(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.AngularJSGrid = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, basedir, module) {
		return module = {
			path: basedir,
			exports: {},
			require: function (path, base) {
				return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
			}
		}, fn(module, module.exports), module.exports;
	}

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	var agGridCommunity_cjs = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, '__esModule', { value: true });

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/**
	 * If value is undefined, null or blank, returns null, otherwise returns the value
	 * @param {T} value
	 * @returns {T | null}
	 */
	function makeNull(value) {
	    if (value == null || value === '') {
	        return null;
	    }
	    return value;
	}
	function exists(value, allowEmptyString) {
	    if (allowEmptyString === void 0) { allowEmptyString = false; }
	    return value != null && (value !== '' || allowEmptyString);
	}
	function missing(value) {
	    return !exists(value);
	}
	function missingOrEmpty(value) {
	    return value == null || value.length === 0;
	}
	function toStringOrNull(value) {
	    return value != null && typeof value.toString === 'function' ? value.toString() : null;
	}
	// for parsing html attributes, where we want empty strings and missing attributes to be undefined
	function attrToNumber(value) {
	    if (value === undefined) {
	        // undefined or empty means ignore the value
	        return;
	    }
	    if (value === null || value === '') {
	        // null or blank means clear
	        return null;
	    }
	    if (typeof value === 'number') {
	        return isNaN(value) ? undefined : value;
	    }
	    var valueParsed = parseInt(value, 10);
	    return isNaN(valueParsed) ? undefined : valueParsed;
	}
	// for parsing html attributes, where we want empty strings and missing attributes to be undefined
	function attrToBoolean(value) {
	    if (value === undefined) {
	        // undefined or empty means ignore the value
	        return;
	    }
	    if (value === null || value === '') {
	        // null means clear
	        return false;
	    }
	    if (typeof value === 'boolean') {
	        // if simple boolean, return the boolean
	        return value;
	    }
	    // if equal to the string 'true' (ignoring case) then return true
	    return (/true/i).test(value);
	}
	// for parsing html attributes, where we want empty strings and missing attributes to be undefined
	function attrToString(value) {
	    if (value == null || value === '') {
	        return;
	    }
	    return value;
	}
	/** @deprecated */
	function referenceCompare(left, right) {
	    if (left == null && right == null) {
	        return true;
	    }
	    if (left == null && right != null) {
	        return false;
	    }
	    if (left != null && right == null) {
	        return false;
	    }
	    return left === right;
	}
	function jsonEquals(val1, val2) {
	    var val1Json = val1 ? JSON.stringify(val1) : null;
	    var val2Json = val2 ? JSON.stringify(val2) : null;
	    return val1Json === val2Json;
	}
	function defaultComparator(valueA, valueB, accentedCompare) {
	    if (accentedCompare === void 0) { accentedCompare = false; }
	    var valueAMissing = valueA == null;
	    var valueBMissing = valueB == null;
	    // this is for aggregations sum and avg, where the result can be a number that is wrapped.
	    // if we didn't do this, then the toString() value would be used, which would result in
	    // the strings getting used instead of the numbers.
	    if (valueA && valueA.toNumber) {
	        valueA = valueA.toNumber();
	    }
	    if (valueB && valueB.toNumber) {
	        valueB = valueB.toNumber();
	    }
	    if (valueAMissing && valueBMissing) {
	        return 0;
	    }
	    if (valueAMissing) {
	        return -1;
	    }
	    if (valueBMissing) {
	        return 1;
	    }
	    function doQuickCompare(a, b) {
	        return (a > b ? 1 : (a < b ? -1 : 0));
	    }
	    if (typeof valueA !== 'string') {
	        return doQuickCompare(valueA, valueB);
	    }
	    if (!accentedCompare) {
	        return doQuickCompare(valueA, valueB);
	    }
	    try {
	        // using local compare also allows chinese comparisons
	        return valueA.localeCompare(valueB);
	    }
	    catch (e) {
	        // if something wrong with localeCompare, eg not supported
	        // by browser, then just continue with the quick one
	        return doQuickCompare(valueA, valueB);
	    }
	}
	function find(collection, predicate, value) {
	    if (collection === null || collection === undefined) {
	        return null;
	    }
	    if (!Array.isArray(collection)) {
	        var objToArray = values(collection);
	        return find(objToArray, predicate, value);
	    }
	    var collectionAsArray = collection;
	    var firstMatchingItem = null;
	    for (var i = 0; i < collectionAsArray.length; i++) {
	        var item = collectionAsArray[i];
	        if (typeof predicate === 'string') {
	            if (item[predicate] === value) {
	                firstMatchingItem = item;
	                break;
	            }
	        }
	        else {
	            var callback = predicate;
	            if (callback(item)) {
	                firstMatchingItem = item;
	                break;
	            }
	        }
	    }
	    return firstMatchingItem;
	}
	function values(object) {
	    if (object instanceof Set || object instanceof Map) {
	        var arr_1 = [];
	        object.forEach(function (value) { return arr_1.push(value); });
	        return arr_1;
	    }
	    return Object.keys(object).map(function (key) { return object[key]; });
	}

	var GenericUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    makeNull: makeNull,
	    exists: exists,
	    missing: missing,
	    missingOrEmpty: missingOrEmpty,
	    toStringOrNull: toStringOrNull,
	    attrToNumber: attrToNumber,
	    attrToBoolean: attrToBoolean,
	    attrToString: attrToString,
	    referenceCompare: referenceCompare,
	    jsonEquals: jsonEquals,
	    defaultComparator: defaultComparator,
	    find: find,
	    values: values
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var ColumnKeyCreator = /** @class */ (function () {
	    function ColumnKeyCreator() {
	        this.existingKeys = {};
	    }
	    ColumnKeyCreator.prototype.addExistingKeys = function (keys) {
	        for (var i = 0; i < keys.length; i++) {
	            this.existingKeys[keys[i]] = true;
	        }
	    };
	    ColumnKeyCreator.prototype.getUniqueKey = function (colId, colField) {
	        // in case user passed in number for colId, convert to string
	        colId = toStringOrNull(colId);
	        var count = 0;
	        while (true) {
	            var idToTry = void 0;
	            if (colId) {
	                idToTry = colId;
	                if (count !== 0) {
	                    idToTry += '_' + count;
	                }
	            }
	            else if (colField) {
	                idToTry = colField;
	                if (count !== 0) {
	                    idToTry += '_' + count;
	                }
	            }
	            else {
	                idToTry = '' + count;
	            }
	            if (!this.existingKeys[idToTry]) {
	                this.existingKeys[idToTry] = true;
	                return idToTry;
	            }
	            count++;
	        }
	    };
	    return ColumnKeyCreator;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function firstExistingValue() {
	    var values = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        values[_i] = arguments[_i];
	    }
	    for (var i = 0; i < values.length; i++) {
	        var value = values[i];
	        if (exists(value)) {
	            return value;
	        }
	    }
	    return null;
	}
	/** @deprecated */
	function anyExists(values) {
	    return values && firstExistingValue(values) != null;
	}
	function existsAndNotEmpty(value) {
	    return value != null && value.length > 0;
	}
	function last(arr) {
	    if (!arr || !arr.length) {
	        return;
	    }
	    return arr[arr.length - 1];
	}
	function areEqual(a, b, comparator) {
	    if (a == null && b == null) {
	        return true;
	    }
	    return a != null &&
	        b != null &&
	        a.length === b.length &&
	        every(a, function (value, index) { return comparator ? comparator(value, b[index]) : b[index] === value; });
	}
	/** @deprecated */
	function compareArrays(array1, array2) {
	    return areEqual(array1, array2);
	}
	/** @deprecated */
	function shallowCompare(arr1, arr2) {
	    return areEqual(arr1, arr2);
	}
	function sortNumerically(array) {
	    return array.sort(function (a, b) { return a - b; });
	}
	function removeRepeatsFromArray(array, object) {
	    if (!array) {
	        return;
	    }
	    for (var index = array.length - 2; index >= 0; index--) {
	        var thisOneMatches = array[index] === object;
	        var nextOneMatches = array[index + 1] === object;
	        if (thisOneMatches && nextOneMatches) {
	            array.splice(index + 1, 1);
	        }
	    }
	}
	function removeFromArray(array, object) {
	    var index = array.indexOf(object);
	    if (index >= 0) {
	        array.splice(index, 1);
	    }
	}
	function removeAllFromArray(array, toRemove) {
	    forEach(toRemove, function (item) { return removeFromArray(array, item); });
	}
	function insertIntoArray(array, object, toIndex) {
	    array.splice(toIndex, 0, object);
	}
	function insertArrayIntoArray(dest, src, toIndex) {
	    if (dest == null || src == null) {
	        return;
	    }
	    // put items in backwards, otherwise inserted items end up in reverse order
	    for (var i = src.length - 1; i >= 0; i--) {
	        var item = src[i];
	        insertIntoArray(dest, item, toIndex);
	    }
	}
	function moveInArray(array, objectsToMove, toIndex) {
	    // first take out items from the array
	    removeAllFromArray(array, objectsToMove);
	    // now add the objects, in same order as provided to us, that means we start at the end
	    // as the objects will be pushed to the right as they are inserted
	    forEach(objectsToMove.slice().reverse(), function (obj) { return insertIntoArray(array, obj, toIndex); });
	}
	function includes(array, value) {
	    return array.indexOf(value) > -1;
	}
	function flatten(arrayOfArrays) {
	    return [].concat.apply([], arrayOfArrays);
	}
	function pushAll(target, source) {
	    if (source == null || target == null) {
	        return;
	    }
	    forEach(source, function (value) { return target.push(value); });
	}
	function toStrings(array) {
	    return map(array, toStringOrNull);
	}
	function findIndex(collection, predicate) {
	    for (var i = 0; i < collection.length; i++) {
	        if (predicate(collection[i], i, collection)) {
	            return i;
	        }
	    }
	    return -1;
	}
	function fill(collection, value, start, end) {
	    if (value === void 0) { value = null; }
	    if (start === void 0) { start = 0; }
	    if (end === void 0) { end = collection.length; }
	    for (var i = start; i < end; i++) {
	        collection[i] = value;
	    }
	    return collection;
	}
	/**
	 * The implementation of Array.prototype.every in browsers is always slower than just using a simple for loop, so
	 * use this for improved performance.
	 * https://jsbench.me/bek91dtit8/
	 */
	function every(list, predicate) {
	    if (list == null) {
	        return true;
	    }
	    for (var i = 0; i < list.length; i++) {
	        if (!predicate(list[i], i)) {
	            return false;
	        }
	    }
	    return true;
	}
	/**
	 * The implementation of Array.prototype.some in browsers is always slower than just using a simple for loop, so
	 * use this for improved performance.
	 * https://jsbench.me/5dk91e4tmt/
	 */
	function some(list, predicate) {
	    if (list == null) {
	        return false;
	    }
	    for (var i = 0; i < list.length; i++) {
	        if (predicate(list[i], i)) {
	            return true;
	        }
	    }
	    return false;
	}
	/**
	 * The implementation of Array.prototype.forEach in browsers is often slower than just using a simple for loop, so
	 * use this for improved performance.
	 * https://jsbench.me/apk91elt8a/
	 */
	function forEach(list, action) {
	    if (list == null) {
	        return;
	    }
	    for (var i = 0; i < list.length; i++) {
	        action(list[i], i);
	    }
	}
	function forEachReverse(list, action) {
	    if (list == null) {
	        return;
	    }
	    for (var i = list.length - 1; i >= 0; i--) {
	        action(list[i], i);
	    }
	}
	/**
	 * The implementation of Array.prototype.map in browsers is generally the same as just using a simple for loop. However,
	 * Firefox does exhibit some difference, and this performs no worse in other browsers, so use this if you want improved
	 * performance.
	 * https://jsbench.me/njk91ez8pc/
	 */
	function map(list, process) {
	    if (list == null) {
	        return null;
	    }
	    var mapped = [];
	    for (var i = 0; i < list.length; i++) {
	        mapped.push(process(list[i], i));
	    }
	    return mapped;
	}
	/**
	 * The implementation of Array.prototype.filter in browsers is always slower than just using a simple for loop, so
	 * use this for improved performance.
	 * https://jsbench.me/7bk91fk08c/
	 */
	function filter(list, predicate) {
	    if (list == null) {
	        return null;
	    }
	    var filtered = [];
	    for (var i = 0; i < list.length; i++) {
	        if (predicate(list[i], i)) {
	            filtered.push(list[i]);
	        }
	    }
	    return filtered;
	}
	/**
	 * The implementation of Array.prototype.reduce in browsers is generally the same as just using a simple for loop. However,
	 * Chrome does exhibit some difference, and this performs no worse in other browsers, so use this if you want improved
	 * performance.
	 * https://jsbench.me/7vk92n6u1f/
	 */
	function reduce(list, step, initial) {
	    if (list == null || initial == null) {
	        return null;
	    }
	    var result = initial;
	    for (var i = 0; i < list.length; i++) {
	        result = step(result, list[i], i);
	    }
	    return result;
	}
	/** @deprecated */
	function forEachSnapshotFirst(list, callback) {
	    if (!list) {
	        return;
	    }
	    var arrayCopy = list.slice(0);
	    arrayCopy.forEach(callback);
	}

	var ArrayUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    firstExistingValue: firstExistingValue,
	    anyExists: anyExists,
	    existsAndNotEmpty: existsAndNotEmpty,
	    last: last,
	    areEqual: areEqual,
	    compareArrays: compareArrays,
	    shallowCompare: shallowCompare,
	    sortNumerically: sortNumerically,
	    removeRepeatsFromArray: removeRepeatsFromArray,
	    removeFromArray: removeFromArray,
	    removeAllFromArray: removeAllFromArray,
	    insertIntoArray: insertIntoArray,
	    insertArrayIntoArray: insertArrayIntoArray,
	    moveInArray: moveInArray,
	    includes: includes,
	    flatten: flatten,
	    pushAll: pushAll,
	    toStrings: toStrings,
	    findIndex: findIndex,
	    fill: fill,
	    every: every,
	    some: some,
	    forEach: forEach,
	    forEachReverse: forEachReverse,
	    map: map,
	    filter: filter,
	    reduce: reduce,
	    forEachSnapshotFirst: forEachSnapshotFirst
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function iterateObject(object, callback) {
	    if (object == null) {
	        return;
	    }
	    if (Array.isArray(object)) {
	        forEach(object, function (value, index) { return callback("" + index, value); });
	    }
	    else {
	        forEach(Object.keys(object), function (key) { return callback(key, object[key]); });
	    }
	}
	function cloneObject(object) {
	    var copy = {};
	    var keys = Object.keys(object);
	    for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var value = object[key];
	        copy[key] = value;
	    }
	    return copy;
	}
	function deepCloneObject(object) {
	    return JSON.parse(JSON.stringify(object));
	}
	// returns copy of an object, doing a deep clone of any objects with that object.
	// this is used for eg creating copies of Column Definitions, where we want to
	// deep copy all objects, but do not want to deep copy functions (eg when user provides
	// a function or class for colDef.cellRenderer)
	function deepCloneDefinition(object, keysToSkip) {
	    if (!object) {
	        return;
	    }
	    var obj = object;
	    var res = {};
	    Object.keys(obj).forEach(function (key) {
	        if (keysToSkip && keysToSkip.indexOf(key) >= 0) {
	            return;
	        }
	        var value = obj[key];
	        // 'simple object' means a bunch of key/value pairs, eg {filter: 'myFilter'}. it does
	        // NOT include the following:
	        // 1) arrays
	        // 2) functions or classes (eg ColumnAPI instance)
	        var sourceIsSimpleObject = isNonNullObject(value) && value.constructor === Object;
	        if (sourceIsSimpleObject) {
	            res[key] = deepCloneDefinition(value);
	        }
	        else {
	            res[key] = value;
	        }
	    });
	    return res;
	}
	function getProperty(object, key) {
	    return object[key];
	}
	function setProperty(object, key, value) {
	    object[key] = value;
	}
	/**
	 * Will copy the specified properties from `source` into the equivalent properties on `target`, ignoring properties with
	 * a value of `undefined`.
	 */
	function copyPropertiesIfPresent(source, target) {
	    var properties = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        properties[_i - 2] = arguments[_i];
	    }
	    forEach(properties, function (p) { return copyPropertyIfPresent(source, target, p); });
	}
	/**
	 * Will copy the specified property from `source` into the equivalent property on `target`, unless the property has a
	 * value of `undefined`. If a transformation is provided, it will be applied to the value before being set on `target`.
	 */
	function copyPropertyIfPresent(source, target, property, transform) {
	    var value = getProperty(source, property);
	    if (value !== undefined) {
	        setProperty(target, property, transform ? transform(value) : value);
	    }
	}
	function getAllKeysInObjects(objects) {
	    var allValues = {};
	    objects.filter(function (obj) { return obj != null; }).forEach(function (obj) {
	        forEach(Object.keys(obj), function (key) { return allValues[key] = null; });
	    });
	    return Object.keys(allValues);
	}
	function getAllValuesInObject(obj) {
	    if (!obj) {
	        return [];
	    }
	    var anyObject = Object;
	    if (typeof anyObject.values === 'function') {
	        return anyObject.values(obj);
	    }
	    var ret = [];
	    for (var key in obj) {
	        if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) {
	            ret.push(obj[key]);
	        }
	    }
	    return ret;
	}
	function mergeDeep(dest, source, copyUndefined, makeCopyOfSimpleObjects) {
	    if (copyUndefined === void 0) { copyUndefined = true; }
	    if (makeCopyOfSimpleObjects === void 0) { makeCopyOfSimpleObjects = false; }
	    if (!exists(source)) {
	        return;
	    }
	    iterateObject(source, function (key, sourceValue) {
	        var destValue = dest[key];
	        if (destValue === sourceValue) {
	            return;
	        }
	        // when creating params, we don't want to just copy objects over. otherwise merging ColDefs (eg DefaultColDef
	        // and Column Types) would result in params getting shared between objects.
	        // by putting an empty value into destValue first, it means we end up copying over values from
	        // the source object, rather than just copying in the source object in it's entirety.
	        if (makeCopyOfSimpleObjects) {
	            var objectIsDueToBeCopied = destValue == null && sourceValue != null;
	            if (objectIsDueToBeCopied) {
	                // 'simple object' means a bunch of key/value pairs, eg {filter: 'myFilter'}, as opposed
	                // to a Class instance (such as ColumnAPI instance).
	                var sourceIsSimpleObject = typeof sourceValue === 'object' && sourceValue.constructor === Object;
	                var dontCopy = sourceIsSimpleObject;
	                if (dontCopy) {
	                    destValue = {};
	                    dest[key] = destValue;
	                }
	            }
	        }
	        if (isNonNullObject(sourceValue) && isNonNullObject(destValue) && !Array.isArray(destValue)) {
	            mergeDeep(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
	        }
	        else if (copyUndefined || sourceValue !== undefined) {
	            dest[key] = sourceValue;
	        }
	    });
	}
	function assign(object) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    forEach(sources, function (source) { return iterateObject(source, function (key, value) { return object[key] = value; }); });
	    return object;
	}
	function missingOrEmptyObject(value) {
	    return missing(value) || Object.keys(value).length === 0;
	}
	function get(source, expression, defaultValue) {
	    if (source == null) {
	        return defaultValue;
	    }
	    var keys = expression.split('.');
	    var objectToRead = source;
	    while (keys.length > 1) {
	        objectToRead = objectToRead[keys.shift()];
	        if (objectToRead == null) {
	            return defaultValue;
	        }
	    }
	    var value = objectToRead[keys[0]];
	    return value != null ? value : defaultValue;
	}
	function set(target, expression, value) {
	    if (target == null) {
	        return;
	    }
	    var keys = expression.split('.');
	    var objectToUpdate = target;
	    while (keys.length > 1) {
	        objectToUpdate = objectToUpdate[keys.shift()];
	        if (objectToUpdate == null) {
	            return;
	        }
	    }
	    objectToUpdate[keys[0]] = value;
	}
	function deepFreeze(object) {
	    Object.freeze(object);
	    forEach(values(object), function (v) {
	        if (isNonNullObject(v) || typeof v === 'function') {
	            deepFreeze(v);
	        }
	    });
	    return object;
	}
	function getValueUsingField(data, field, fieldContainsDots) {
	    if (!field || !data) {
	        return;
	    }
	    // if no '.', then it's not a deep value
	    if (!fieldContainsDots) {
	        return data[field];
	    }
	    // otherwise it is a deep value, so need to dig for it
	    var fields = field.split('.');
	    var currentObject = data;
	    for (var i = 0; i < fields.length; i++) {
	        if (currentObject == null) {
	            return undefined;
	        }
	        currentObject = currentObject[fields[i]];
	    }
	    return currentObject;
	}
	// used by ColumnAPI and GridAPI to remove all references, so keeping grid in memory resulting in a
	// memory leak if user is not disposing of the GridAPI or ColumnApi references
	function removeAllReferences(obj, objectName) {
	    Object.keys(obj).forEach(function (key) {
	        var value = obj[key];
	        // we want to replace all the @autowired services, which are objects. any simple types (boolean, string etc)
	        // we don't care about
	        if (typeof value === 'object') {
	            obj[key] = undefined;
	        }
	    });
	    var proto = Object.getPrototypeOf(obj);
	    var properties = {};
	    Object.keys(proto).forEach(function (key) {
	        var value = proto[key];
	        // leave all basic types - this is needed for GridAPI to leave the "destroyed: boolean" attribute alone
	        if (typeof value === 'function') {
	            var func = function () {
	                console.warn("AG Grid: " + objectName + " function " + key + "() cannot be called as the grid has been destroyed.\n                     Please don't call grid API functions on destroyed grids - as a matter of fact you shouldn't\n                     be keeping the API reference, your application has a memory leak! Remove the API reference\n                     when the grid is destroyed.");
	            };
	            properties[key] = { value: func, writable: true };
	        }
	    });
	    Object.defineProperties(obj, properties);
	}
	function isNonNullObject(value) {
	    return typeof value === 'object' && value !== null;
	}

	var ObjectUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    iterateObject: iterateObject,
	    cloneObject: cloneObject,
	    deepCloneObject: deepCloneObject,
	    deepCloneDefinition: deepCloneDefinition,
	    getProperty: getProperty,
	    setProperty: setProperty,
	    copyPropertiesIfPresent: copyPropertiesIfPresent,
	    copyPropertyIfPresent: copyPropertyIfPresent,
	    getAllKeysInObjects: getAllKeysInObjects,
	    getAllValuesInObject: getAllValuesInObject,
	    mergeDeep: mergeDeep,
	    assign: assign,
	    missingOrEmptyObject: missingOrEmptyObject,
	    get: get,
	    set: set,
	    deepFreeze: deepFreeze,
	    getValueUsingField: getValueUsingField,
	    removeAllReferences: removeAllReferences,
	    isNonNullObject: isNonNullObject
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var FUNCTION_STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var FUNCTION_ARGUMENT_NAMES = /([^\s,]+)/g;
	var doOnceFlags = {};
	/**
	 * If the key was passed before, then doesn't execute the func
	 * @param {Function} func
	 * @param {string} key
	 */
	function doOnce(func, key) {
	    if (doOnceFlags[key]) {
	        return;
	    }
	    func();
	    doOnceFlags[key] = true;
	}
	function getFunctionName(funcConstructor) {
	    // for every other browser in the world
	    if (funcConstructor.name) {
	        return funcConstructor.name;
	    }
	    // for the pestilence that is ie11
	    var matches = /function\s+([^\(]+)/.exec(funcConstructor.toString());
	    return matches && matches.length === 2 ? matches[1].trim() : null;
	}
	/** @deprecated */
	function getFunctionParameters(func) {
	    var fnStr = func.toString().replace(FUNCTION_STRIP_COMMENTS, '');
	    return fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(FUNCTION_ARGUMENT_NAMES) || [];
	}
	function isFunction(val) {
	    return !!(val && val.constructor && val.call && val.apply);
	}
	function executeInAWhile(funcs) {
	    executeAfter(funcs, 400);
	}
	var executeNextVMTurnFuncs = [];
	var executeNextVMTurnPending = false;
	function executeNextVMTurn(func) {
	    executeNextVMTurnFuncs.push(func);
	    if (executeNextVMTurnPending) {
	        return;
	    }
	    executeNextVMTurnPending = true;
	    window.setTimeout(function () {
	        var funcsCopy = executeNextVMTurnFuncs.slice();
	        executeNextVMTurnFuncs.length = 0;
	        executeNextVMTurnPending = false;
	        funcsCopy.forEach(function (func) { return func(); });
	    }, 0);
	}
	function executeAfter(funcs, milliseconds) {
	    if (milliseconds === void 0) { milliseconds = 0; }
	    if (funcs.length > 0) {
	        window.setTimeout(function () { return funcs.forEach(function (func) { return func(); }); }, milliseconds);
	    }
	}
	/**
	 * from https://stackoverflow.com/questions/24004791/can-someone-explain-the-debounce-function-in-javascript
	 * @param {Function} func The function to be debounced
	 * @param {number} wait The time in ms to debounce
	 * @param {boolean} immediate If it should run immediately or wait for the initial debounce delay
	 * @return {Function} The debounced function
	 */
	function debounce(func, wait, immediate) {
	    if (immediate === void 0) { immediate = false; }
	    // 'private' variable for instance
	    // The returned function will be able to reference this due to closure.
	    // Each call to the returned function will share this common timer.
	    var timeout;
	    // Calling debounce returns a new anonymous function
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        // reference the context and args for the setTimeout function
	        var context = this;
	        // Should the function be called now? If immediate is true
	        //   and not already in a timeout then the answer is: Yes
	        var callNow = immediate && !timeout;
	        // This is the basic debounce behaviour where you can call this
	        //   function several times, but it will only execute once
	        //   [before or after imposing a delay].
	        //   Each time the returned function is called, the timer starts over.
	        window.clearTimeout(timeout);
	        // Set the new timeout
	        timeout = window.setTimeout(function () {
	            // Inside the timeout function, clear the timeout variable
	            // which will let the next execution run when in 'immediate' mode
	            timeout = null;
	            // Check if the function already ran with the immediate flag
	            if (!immediate) {
	                // Call the original function with apply
	                // apply lets you define the 'this' object as well as the arguments
	                //    (both captured before setTimeout)
	                func.apply(context, args);
	            }
	        }, wait);
	        // Immediate mode and no wait timer? Execute the function..
	        if (callNow) {
	            func.apply(context, args);
	        }
	    };
	}
	function waitUntil(condition, callback, timeout, timeoutMessage) {
	    if (timeout === void 0) { timeout = 100; }
	    var timeStamp = new Date().getTime();
	    var interval = null;
	    var executed = false;
	    var internalCallback = function () {
	        var reachedTimeout = ((new Date().getTime()) - timeStamp) > timeout;
	        if (condition() || reachedTimeout) {
	            callback();
	            executed = true;
	            if (interval != null) {
	                window.clearInterval(interval);
	                interval = null;
	            }
	            if (reachedTimeout && timeoutMessage) {
	                console.warn(timeoutMessage);
	            }
	        }
	    };
	    internalCallback();
	    if (!executed) {
	        interval = window.setInterval(internalCallback, 10);
	    }
	}
	function compose() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i] = arguments[_i];
	    }
	    return function (arg) { return fns.reduce(function (composed, f) { return f(composed); }, arg); };
	}
	function callIfPresent(func) {
	    if (func) {
	        func();
	    }
	}

	var FunctionUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    doOnce: doOnce,
	    getFunctionName: getFunctionName,
	    getFunctionParameters: getFunctionParameters,
	    isFunction: isFunction,
	    executeInAWhile: executeInAWhile,
	    executeNextVMTurn: executeNextVMTurn,
	    executeAfter: executeAfter,
	    debounce: debounce,
	    waitUntil: waitUntil,
	    compose: compose,
	    callIfPresent: callIfPresent
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var Context = /** @class */ (function () {
	    function Context(params, logger) {
	        this.beanWrappers = {};
	        this.destroyed = false;
	        if (!params || !params.beanClasses) {
	            return;
	        }
	        this.contextParams = params;
	        this.logger = logger;
	        this.logger.log(">> creating ag-Application Context");
	        this.createBeans();
	        var beanInstances = this.getBeanInstances();
	        this.wireBeans(beanInstances);
	        this.logger.log(">> ag-Application Context ready - component is alive");
	    }
	    Context.prototype.getBeanInstances = function () {
	        return values(this.beanWrappers).map(function (beanEntry) { return beanEntry.beanInstance; });
	    };
	    Context.prototype.createBean = function (bean, afterPreCreateCallback) {
	        if (!bean) {
	            throw Error("Can't wire to bean since it is null");
	        }
	        this.wireBeans([bean], afterPreCreateCallback);
	        return bean;
	    };
	    Context.prototype.wireBeans = function (beanInstances, afterPreCreateCallback) {
	        this.autoWireBeans(beanInstances);
	        this.methodWireBeans(beanInstances);
	        this.callLifeCycleMethods(beanInstances, 'preConstructMethods');
	        // the callback sets the attributes, so the component has access to attributes
	        // before postConstruct methods in the component are executed
	        if (exists(afterPreCreateCallback)) {
	            beanInstances.forEach(afterPreCreateCallback);
	        }
	        this.callLifeCycleMethods(beanInstances, 'postConstructMethods');
	    };
	    Context.prototype.createBeans = function () {
	        var _this = this;
	        // register all normal beans
	        this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this));
	        // register override beans, these will overwrite beans above of same name
	        // instantiate all beans - overridden beans will be left out
	        iterateObject(this.beanWrappers, function (key, beanEntry) {
	            var constructorParamsMeta;
	            if (beanEntry.bean.__agBeanMetaData && beanEntry.bean.__agBeanMetaData.autowireMethods && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) {
	                constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
	            }
	            var constructorParams = _this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);
	            var newInstance = applyToConstructor(beanEntry.bean, constructorParams);
	            beanEntry.beanInstance = newInstance;
	        });
	        var createdBeanNames = Object.keys(this.beanWrappers).join(', ');
	        this.logger.log("created beans: " + createdBeanNames);
	    };
	    // tslint:disable-next-line
	    Context.prototype.createBeanWrapper = function (BeanClass) {
	        var metaData = BeanClass.__agBeanMetaData;
	        if (!metaData) {
	            var beanName = void 0;
	            if (BeanClass.prototype.constructor) {
	                beanName = getFunctionName(BeanClass.prototype.constructor);
	            }
	            else {
	                beanName = "" + BeanClass;
	            }
	            console.error("Context item " + beanName + " is not a bean");
	            return;
	        }
	        var beanEntry = {
	            bean: BeanClass,
	            beanInstance: null,
	            beanName: metaData.beanName
	        };
	        this.beanWrappers[metaData.beanName] = beanEntry;
	    };
	    Context.prototype.autoWireBeans = function (beanInstances) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
	                var attributes = metaData.agClassAttributes;
	                if (!attributes) {
	                    return;
	                }
	                attributes.forEach(function (attribute) {
	                    var otherBean = _this.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);
	                    beanInstance[attribute.attributeName] = otherBean;
	                });
	            });
	        });
	    };
	    Context.prototype.methodWireBeans = function (beanInstances) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
	                iterateObject(metaData.autowireMethods, function (methodName, wireParams) {
	                    // skip constructor, as this is dealt with elsewhere
	                    if (methodName === "agConstructor") {
	                        return;
	                    }
	                    var initParams = _this.getBeansForParameters(wireParams, beanName);
	                    beanInstance[methodName].apply(beanInstance, initParams);
	                });
	            });
	        });
	    };
	    Context.prototype.forEachMetaDataInHierarchy = function (beanInstance, callback) {
	        var prototype = Object.getPrototypeOf(beanInstance);
	        while (prototype != null) {
	            var constructor = prototype.constructor;
	            if (constructor.hasOwnProperty('__agBeanMetaData')) {
	                var metaData = constructor.__agBeanMetaData;
	                var beanName = this.getBeanName(constructor);
	                callback(metaData, beanName);
	            }
	            prototype = Object.getPrototypeOf(prototype);
	        }
	    };
	    Context.prototype.getBeanName = function (constructor) {
	        if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) {
	            return constructor.__agBeanMetaData.beanName;
	        }
	        var constructorString = constructor.toString();
	        var beanName = constructorString.substring(9, constructorString.indexOf("("));
	        return beanName;
	    };
	    Context.prototype.getBeansForParameters = function (parameters, beanName) {
	        var _this = this;
	        var beansList = [];
	        if (parameters) {
	            iterateObject(parameters, function (paramIndex, otherBeanName) {
	                var otherBean = _this.lookupBeanInstance(beanName, otherBeanName);
	                beansList[Number(paramIndex)] = otherBean;
	            });
	        }
	        return beansList;
	    };
	    Context.prototype.lookupBeanInstance = function (wiringBean, beanName, optional) {
	        if (optional === void 0) { optional = false; }
	        if (beanName === "context") {
	            return this;
	        }
	        if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(beanName)) {
	            return this.contextParams.providedBeanInstances[beanName];
	        }
	        var beanEntry = this.beanWrappers[beanName];
	        if (beanEntry) {
	            return beanEntry.beanInstance;
	        }
	        if (!optional) {
	            console.error("AG Grid: unable to find bean reference " + beanName + " while initialising " + wiringBean);
	        }
	        return null;
	    };
	    Context.prototype.callLifeCycleMethods = function (beanInstances, lifeCycleMethod) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) { return _this.callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod); });
	    };
	    Context.prototype.callLifeCycleMethodsOnBean = function (beanInstance, lifeCycleMethod, methodToIgnore) {
	        // putting all methods into a map removes duplicates
	        var allMethods = {};
	        // dump methods from each level of the metadata hierarchy
	        this.forEachMetaDataInHierarchy(beanInstance, function (metaData) {
	            var methods = metaData[lifeCycleMethod];
	            if (methods) {
	                methods.forEach(function (methodName) {
	                    if (methodName != methodToIgnore) {
	                        allMethods[methodName] = true;
	                    }
	                });
	            }
	        });
	        var allMethodsList = Object.keys(allMethods);
	        allMethodsList.forEach(function (methodName) { return beanInstance[methodName](); });
	    };
	    Context.prototype.getBean = function (name) {
	        return this.lookupBeanInstance("getBean", name, true);
	    };
	    Context.prototype.destroy = function () {
	        if (this.destroyed) {
	            return;
	        }
	        this.logger.log(">> Shutting down ag-Application Context");
	        var beanInstances = this.getBeanInstances();
	        this.destroyBeans(beanInstances);
	        this.contextParams.providedBeanInstances = null;
	        this.destroyed = true;
	        this.logger.log(">> ag-Application Context shut down - component is dead");
	    };
	    Context.prototype.destroyBean = function (bean) {
	        if (!bean) {
	            return;
	        }
	        this.destroyBeans([bean]);
	    };
	    Context.prototype.destroyBeans = function (beans) {
	        var _this = this;
	        if (!beans) {
	            return [];
	        }
	        beans.forEach(function (bean) {
	            _this.callLifeCycleMethodsOnBean(bean, 'preDestroyMethods', 'destroy');
	            // call destroy() explicitly if it exists
	            var beanAny = bean;
	            if (typeof beanAny.destroy === 'function') {
	                beanAny.destroy();
	            }
	        });
	        return [];
	    };
	    return Context;
	}());
	// taken from: http://stackoverflow.com/questions/3362471/how-can-i-call-a-javascript-constructor-using-call-or-apply
	// allows calling 'apply' on a constructor
	function applyToConstructor(constructor, argArray) {
	    var args = [null].concat(argArray);
	    var factoryFunction = constructor.bind.apply(constructor, args);
	    return new factoryFunction();
	}
	function PreConstruct(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.preConstructMethods) {
	        props.preConstructMethods = [];
	    }
	    props.preConstructMethods.push(methodName);
	}
	function PostConstruct(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.postConstructMethods) {
	        props.postConstructMethods = [];
	    }
	    props.postConstructMethods.push(methodName);
	}
	function PreDestroy(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.preDestroyMethods) {
	        props.preDestroyMethods = [];
	    }
	    props.preDestroyMethods.push(methodName);
	}
	function Bean(beanName) {
	    return function (classConstructor) {
	        var props = getOrCreateProps(classConstructor);
	        props.beanName = beanName;
	    };
	}
	function Autowired(name) {
	    return function (target, propertyKey, descriptor) {
	        autowiredFunc(target, name, false, target, propertyKey, null);
	    };
	}
	function Optional(name) {
	    return function (target, propertyKey, descriptor) {
	        autowiredFunc(target, name, true, target, propertyKey, null);
	    };
	}
	function autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
	    if (name === null) {
	        console.error("AG Grid: Autowired name should not be null");
	        return;
	    }
	    if (typeof index === "number") {
	        console.error("AG Grid: Autowired should be on an attribute");
	        return;
	    }
	    // it's an attribute on the class
	    var props = getOrCreateProps(target.constructor);
	    if (!props.agClassAttributes) {
	        props.agClassAttributes = [];
	    }
	    props.agClassAttributes.push({
	        attributeName: methodOrAttributeName,
	        beanName: name,
	        optional: optional
	    });
	}
	function Qualifier(name) {
	    return function (classPrototype, methodOrAttributeName, index) {
	        var constructor = typeof classPrototype == "function" ? classPrototype : classPrototype.constructor;
	        var props;
	        if (typeof index === "number") {
	            // it's a parameter on a method
	            var methodName = void 0;
	            if (methodOrAttributeName) {
	                props = getOrCreateProps(constructor);
	                methodName = methodOrAttributeName;
	            }
	            else {
	                props = getOrCreateProps(constructor);
	                methodName = "agConstructor";
	            }
	            if (!props.autowireMethods) {
	                props.autowireMethods = {};
	            }
	            if (!props.autowireMethods[methodName]) {
	                props.autowireMethods[methodName] = {};
	            }
	            props.autowireMethods[methodName][index] = name;
	        }
	    };
	}
	function getOrCreateProps(target) {
	    if (!target.hasOwnProperty("__agBeanMetaData")) {
	        target.__agBeanMetaData = {};
	    }
	    return target.__agBeanMetaData;
	}

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var EventService = /** @class */ (function () {
	    function EventService() {
	        this.allSyncListeners = new Map();
	        this.allAsyncListeners = new Map();
	        this.globalSyncListeners = new Set();
	        this.globalAsyncListeners = new Set();
	        this.asyncFunctionsQueue = [];
	        this.scheduled = false;
	        // using an object performs better than a Set for the number of different events we have
	        this.firedEvents = {};
	    }
	    // because this class is used both inside the context and outside the context, we do not
	    // use autowired attributes, as that would be confusing, as sometimes the attributes
	    // would be wired, and sometimes not.
	    //
	    // the global event servers used by AG Grid is autowired by the context once, and this
	    // setBeans method gets called once.
	    //
	    // the times when this class is used outside of the context (eg RowNode has an instance of this
	    // class) then it is not a bean, and this setBeans method is not called.
	    EventService.prototype.setBeans = function (loggerFactory, gridOptionsWrapper, frameworkOverrides, globalEventListener) {
	        if (globalEventListener === void 0) { globalEventListener = null; }
	        this.logger = loggerFactory.create('EventService');
	        this.frameworkOverrides = frameworkOverrides;
	        if (globalEventListener) {
	            var async = gridOptionsWrapper.useAsyncEvents();
	            this.addGlobalListener(globalEventListener, async);
	        }
	    };
	    EventService.prototype.getListeners = function (eventType, async, autoCreateListenerCollection) {
	        var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
	        var listeners = listenerMap.get(eventType);
	        // Note: 'autoCreateListenerCollection' should only be 'true' if a listener is about to be added. For instance
	        // getListeners() is also called during event dispatch even though no listeners are added. This measure protects
	        // against 'memory bloat' as empty collections will prevent the RowNode's event service from being removed after
	        // the RowComp is destroyed, see noRegisteredListenersExist() below.
	        if (!listeners && autoCreateListenerCollection) {
	            listeners = new Set();
	            listenerMap.set(eventType, listeners);
	        }
	        return listeners;
	    };
	    EventService.prototype.noRegisteredListenersExist = function () {
	        return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 &&
	            this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
	    };
	    EventService.prototype.addEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        this.getListeners(eventType, async, true).add(listener);
	    };
	    EventService.prototype.removeEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        var listeners = this.getListeners(eventType, async, false);
	        if (!listeners) {
	            return;
	        }
	        listeners.delete(listener);
	        if (listeners.size === 0) {
	            var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
	            listenerMap.delete(eventType);
	        }
	    };
	    EventService.prototype.addGlobalListener = function (listener, async) {
	        if (async === void 0) { async = false; }
	        (async ? this.globalAsyncListeners : this.globalSyncListeners).add(listener);
	    };
	    EventService.prototype.removeGlobalListener = function (listener, async) {
	        if (async === void 0) { async = false; }
	        (async ? this.globalAsyncListeners : this.globalSyncListeners).delete(listener);
	    };
	    EventService.prototype.dispatchEvent = function (event) {
	        this.dispatchToListeners(event, true);
	        this.dispatchToListeners(event, false);
	        this.firedEvents[event.type] = true;
	    };
	    EventService.prototype.dispatchEventOnce = function (event) {
	        if (!this.firedEvents[event.type]) {
	            this.dispatchEvent(event);
	        }
	    };
	    EventService.prototype.dispatchToListeners = function (event, async) {
	        var _this = this;
	        var eventType = event.type;
	        var processEventListeners = function (listeners) { return listeners.forEach(function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return listener(event); });
	            }
	            else {
	                listener(event);
	            }
	        }); };
	        var listeners = this.getListeners(eventType, async, false);
	        if (listeners) {
	            processEventListeners(listeners);
	        }
	        var globalListeners = async ? this.globalAsyncListeners : this.globalSyncListeners;
	        globalListeners.forEach(function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return _this.frameworkOverrides.dispatchEvent(eventType, function () { return listener(eventType, event); }); });
	            }
	            else {
	                _this.frameworkOverrides.dispatchEvent(eventType, function () { return listener(eventType, event); });
	            }
	        });
	    };
	    // this gets called inside the grid's thread, for each event that it
	    // wants to set async. the grid then batches the events into one setTimeout()
	    // because setTimeout() is an expensive operation. ideally we would have
	    // each event in it's own setTimeout(), but we batch for performance.
	    EventService.prototype.dispatchAsync = function (func) {
	        // add to the queue for executing later in the next VM turn
	        this.asyncFunctionsQueue.push(func);
	        // check if timeout is already scheduled. the first time the grid calls
	        // this within it's thread turn, this should be false, so it will schedule
	        // the 'flush queue' method the first time it comes here. then the flag is
	        // set to 'true' so it will know it's already scheduled for subsequent calls.
	        if (!this.scheduled) {
	            // if not scheduled, schedule one
	            window.setTimeout(this.flushAsyncQueue.bind(this), 0);
	            // mark that it is scheduled
	            this.scheduled = true;
	        }
	    };
	    // this happens in the next VM turn only, and empties the queue of events
	    EventService.prototype.flushAsyncQueue = function () {
	        this.scheduled = false;
	        // we take a copy, because the event listener could be using
	        // the grid, which would cause more events, which would be potentially
	        // added to the queue, so safe to take a copy, the new events will
	        // get executed in a later VM turn rather than risk updating the
	        // queue as we are flushing it.
	        var queueCopy = this.asyncFunctionsQueue.slice();
	        this.asyncFunctionsQueue = [];
	        // execute the queue
	        queueCopy.forEach(function (func) { return func(); });
	    };
	    __decorate([
	        __param(0, Qualifier('loggerFactory')),
	        __param(1, Qualifier('gridOptionsWrapper')),
	        __param(2, Qualifier('frameworkOverrides')),
	        __param(3, Qualifier('globalEventListener'))
	    ], EventService.prototype, "setBeans", null);
	    EventService = __decorate([
	        Bean('eventService')
	    ], EventService);
	    return EventService;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var Constants = /** @class */ (function () {
	    function Constants() {
	    }
	    Constants.ROW_BUFFER_SIZE = 10;
	    Constants.LAYOUT_INTERVAL = 500;
	    Constants.BATCH_WAIT_MILLIS = 50;
	    Constants.EXPORT_TYPE_DRAG_COPY = 'dragCopy';
	    Constants.EXPORT_TYPE_CLIPBOARD = 'clipboard';
	    Constants.EXPORT_TYPE_EXCEL = 'excel';
	    Constants.EXPORT_TYPE_CSV = 'csv';
	    Constants.ROW_MODEL_TYPE_INFINITE = 'infinite';
	    Constants.ROW_MODEL_TYPE_VIEWPORT = 'viewport';
	    Constants.ROW_MODEL_TYPE_CLIENT_SIDE = 'clientSide';
	    Constants.ROW_MODEL_TYPE_SERVER_SIDE = 'serverSide';
	    Constants.ALWAYS = 'always';
	    Constants.ONLY_WHEN_GROUPING = 'onlyWhenGrouping';
	    Constants.PINNED_TOP = 'top';
	    Constants.PINNED_BOTTOM = 'bottom';
	    Constants.DOM_LAYOUT_NORMAL = 'normal';
	    Constants.DOM_LAYOUT_PRINT = 'print';
	    Constants.DOM_LAYOUT_AUTO_HEIGHT = 'autoHeight';
	    Constants.GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';
	    Constants.SOURCE_PASTE = 'paste';
	    Constants.PINNED_RIGHT = 'right';
	    Constants.PINNED_LEFT = 'left';
	    Constants.SORT_ASC = 'asc';
	    Constants.SORT_DESC = 'desc';
	    Constants.INPUT_SELECTOR = 'input, select, button, textarea';
	    Constants.FOCUSABLE_SELECTOR = '[tabindex], input, select, button, textarea';
	    Constants.FOCUSABLE_EXCLUDE = '.ag-hidden, .ag-hidden *, [disabled], .ag-disabled, .ag-disabled *';
	    return Constants;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (ModuleNames) {
	    // when using modules, user references this
	    ModuleNames["CommunityCoreModule"] = "@ag-grid-community/core";
	    // when not using modules, user references this
	    ModuleNames["CommunityAllModules"] = "@ag-grid-community/all";
	    // community modules
	    ModuleNames["InfiniteRowModelModule"] = "@ag-grid-community/infinite-row-model";
	    ModuleNames["ClientSideRowModelModule"] = "@ag-grid-community/client-side-row-model";
	    ModuleNames["CsvExportModule"] = "@ag-grid-community/csv-export";
	    // enterprise core - users never import on this, but other enterprise modules do
	    ModuleNames["EnterpriseCoreModule"] = "@ag-grid-enterprise/core";
	    // when not using modules, user references this
	    ModuleNames["EnterpriseAllModules"] = "@ag-grid-enterprise/all";
	    // enterprise modules
	    ModuleNames["RowGroupingModule"] = "@ag-grid-enterprise/row-grouping";
	    ModuleNames["ColumnToolPanelModule"] = "@ag-grid-enterprise/column-tool-panel";
	    ModuleNames["FiltersToolPanelModule"] = "@ag-grid-enterprise/filter-tool-panel";
	    ModuleNames["MenuModule"] = "@ag-grid-enterprise/menu";
	    ModuleNames["SetFilterModule"] = "@ag-grid-enterprise/set-filter";
	    ModuleNames["MultiFilterModule"] = "@ag-grid-enterprise/multi-filter";
	    ModuleNames["StatusBarModule"] = "@ag-grid-enterprise/status-bar";
	    ModuleNames["SideBarModule"] = "@ag-grid-enterprise/side-bar";
	    ModuleNames["RangeSelectionModule"] = "@ag-grid-enterprise/range-selection";
	    ModuleNames["MasterDetailModule"] = "@ag-grid-enterprise/master-detail";
	    ModuleNames["RichSelectModule"] = "@ag-grid-enterprise/rich-select";
	    ModuleNames["GridChartsModule"] = "@ag-grid-enterprise/charts";
	    ModuleNames["ViewportRowModelModule"] = "@ag-grid-enterprise/viewport-row-model";
	    ModuleNames["ServerSideRowModelModule"] = "@ag-grid-enterprise/server-side-row-model";
	    ModuleNames["ExcelExportModule"] = "@ag-grid-enterprise/excel-export";
	    ModuleNames["ClipboardModule"] = "@ag-grid-enterprise/clipboard";
	    ModuleNames["DateTimeCellEditorModule"] = "@ag-grid-enterprise/date-time-cell-editor";
	    // framework wrappers currently don't provide beans, comps etc, so no need to be modules,
	    // however i argue they should be as in theory they 'could' provide beans etc
	    ModuleNames["AngularModule"] = "@ag-grid-community/angular";
	    ModuleNames["ReactModule"] = "@ag-grid-community/react";
	    ModuleNames["VueModule"] = "@ag-grid-community/vue";
	    ModuleNames["PolymerModule"] = "@ag-grid-community/polymer";
	    // and then this, which is definitely not a grid module, as it should not have any dependency
	    // on the grid (ie shouldn't even reference the Module interface)
	    // ChartsModule = "@ag-grid-community/charts-core",
	})(exports.ModuleNames || (exports.ModuleNames = {}));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var ModuleRegistry = /** @class */ (function () {
	    function ModuleRegistry() {
	    }
	    ModuleRegistry.register = function (module, moduleBased) {
	        if (moduleBased === void 0) { moduleBased = true; }
	        ModuleRegistry.modulesMap[module.moduleName] = module;
	        if (ModuleRegistry.moduleBased === undefined) {
	            ModuleRegistry.moduleBased = moduleBased;
	        }
	        else {
	            if (ModuleRegistry.moduleBased !== moduleBased) {
	                doOnce(function () {
	                    console.warn("AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms.");
	                    console.warn('Please see https://www.ag-grid.com/javascript-table/packages-modules/ for more information.');
	                }, 'ModulePackageCheck');
	            }
	        }
	    };
	    // noinspection JSUnusedGlobalSymbols
	    ModuleRegistry.registerModules = function (modules, moduleBased) {
	        if (moduleBased === void 0) { moduleBased = true; }
	        if (!modules) {
	            return;
	        }
	        modules.forEach(function (module) { return ModuleRegistry.register(module, moduleBased); });
	    };
	    ModuleRegistry.assertRegistered = function (moduleName, reason) {
	        if (this.isRegistered(moduleName)) {
	            return true;
	        }
	        var warningKey = reason + moduleName;
	        var warningMessage = "AG Grid: unable to use " + reason + " as module " + moduleName + " is not present. Please see: https://www.ag-grid.com/javascript-table/modules/";
	        doOnce(function () {
	            console.warn(warningMessage);
	        }, warningKey);
	        return false;
	    };
	    ModuleRegistry.isRegistered = function (moduleName) {
	        return !!ModuleRegistry.modulesMap[moduleName];
	    };
	    ModuleRegistry.getRegisteredModules = function () {
	        return values(ModuleRegistry.modulesMap);
	    };
	    ModuleRegistry.isPackageBased = function () {
	        return !ModuleRegistry.moduleBased;
	    };
	    // having in a map a) removes duplicates and b) allows fast lookup
	    ModuleRegistry.modulesMap = {};
	    return ModuleRegistry;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$1 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// Wrapper around a user provide column definition. The grid treats the column definition as ready only.
	// This class contains all the runtime information about a column, plus some logic (the definition has no logic).
	// This class implements both interfaces ColumnGroupChild and OriginalColumnGroupChild as the class can
	// appear as a child of either the original tree or the displayed tree. However the relevant group classes
	// for each type only implements one, as each group can only appear in it's associated tree (eg OriginalColumnGroup
	// can only appear in OriginalColumn tree).
	var Column = /** @class */ (function () {
	    function Column(colDef, userProvidedColDef, colId, primary) {
	        this.moving = false;
	        this.menuVisible = false;
	        this.filterActive = false;
	        this.eventService = new EventService();
	        this.rowGroupActive = false;
	        this.pivotActive = false;
	        this.aggregationActive = false;
	        this.colDef = colDef;
	        this.userProvidedColDef = userProvidedColDef;
	        this.colId = colId;
	        this.primary = primary;
	        this.setState(colDef);
	    }
	    Column.prototype.setState = function (colDef) {
	        // sort
	        if (colDef.sort !== undefined) {
	            if (colDef.sort === Constants.SORT_ASC || colDef.sort === Constants.SORT_DESC) {
	                this.sort = colDef.sort;
	            }
	        }
	        else {
	            if (colDef.initialSort === Constants.SORT_ASC || colDef.initialSort === Constants.SORT_DESC) {
	                this.sort = colDef.initialSort;
	            }
	        }
	        // sortIndex
	        var sortIndex = attrToNumber(colDef.sortIndex);
	        var initialSortIndex = attrToNumber(colDef.initialSortIndex);
	        if (sortIndex !== undefined) {
	            if (sortIndex !== null) {
	                this.sortIndex = sortIndex;
	            }
	        }
	        else {
	            if (initialSortIndex !== null) {
	                this.sortIndex = initialSortIndex;
	            }
	        }
	        // hide
	        var hide = attrToBoolean(colDef.hide);
	        var initialHide = attrToBoolean(colDef.initialHide);
	        if (hide !== undefined) {
	            this.visible = !hide;
	        }
	        else {
	            this.visible = !initialHide;
	        }
	        // pinned
	        if (colDef.pinned !== undefined) {
	            this.setPinned(colDef.pinned);
	        }
	        else {
	            this.setPinned(colDef.initialPinned);
	        }
	        // flex
	        var flex = attrToNumber(colDef.flex);
	        var initialFlex = attrToNumber(colDef.initialFlex);
	        if (flex !== undefined) {
	            this.flex = flex;
	        }
	        else if (initialFlex !== undefined) {
	            this.flex = initialFlex;
	        }
	    };
	    // gets called when user provides an alternative colDef, eg
	    Column.prototype.setColDef = function (colDef, userProvidedColDef) {
	        this.colDef = colDef;
	        this.userProvidedColDef = userProvidedColDef;
	        this.initMinAndMaxWidths();
	        this.initDotNotation();
	    };
	    Column.prototype.getUserProvidedColDef = function () {
	        return this.userProvidedColDef;
	    };
	    Column.prototype.setParent = function (parent) {
	        this.parent = parent;
	    };
	    Column.prototype.getParent = function () {
	        return this.parent;
	    };
	    Column.prototype.setOriginalParent = function (originalParent) {
	        this.originalParent = originalParent;
	    };
	    Column.prototype.getOriginalParent = function () {
	        return this.originalParent;
	    };
	    // this is done after constructor as it uses gridOptionsWrapper
	    Column.prototype.initialise = function () {
	        this.initMinAndMaxWidths();
	        this.resetActualWidth('gridInitializing');
	        this.initDotNotation();
	        this.validate();
	    };
	    Column.prototype.initDotNotation = function () {
	        var suppressDotNotation = this.gridOptionsWrapper.isSuppressFieldDotNotation();
	        this.fieldContainsDots = exists(this.colDef.field) && this.colDef.field.indexOf('.') >= 0 && !suppressDotNotation;
	        this.tooltipFieldContainsDots = exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf('.') >= 0 && !suppressDotNotation;
	    };
	    Column.prototype.initMinAndMaxWidths = function () {
	        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
	        var maxColWidth = this.gridOptionsWrapper.getMaxColWidth();
	        if (this.colDef.minWidth != null) {
	            // we force min width to be at least one pixel, otherwise column will disappear
	            this.minWidth = Math.max(this.colDef.minWidth, 1);
	        }
	        else {
	            this.minWidth = minColWidth;
	        }
	        if (this.colDef.maxWidth != null) {
	            this.maxWidth = this.colDef.maxWidth;
	        }
	        else {
	            this.maxWidth = maxColWidth;
	        }
	    };
	    Column.prototype.resetActualWidth = function (source) {
	        if (source === void 0) { source = 'api'; }
	        var initialWidth = this.columnUtils.calculateColInitialWidth(this.colDef);
	        this.setActualWidth(initialWidth, source, true);
	    };
	    Column.prototype.isEmptyGroup = function () {
	        return false;
	    };
	    Column.prototype.isRowGroupDisplayed = function (colId) {
	        if (missing(this.colDef) || missing(this.colDef.showRowGroup)) {
	            return false;
	        }
	        var showingAllGroups = this.colDef.showRowGroup === true;
	        var showingThisGroup = this.colDef.showRowGroup === colId;
	        return showingAllGroups || showingThisGroup;
	    };
	    Column.prototype.getUniqueId = function () {
	        return this.getId();
	    };
	    Column.prototype.isPrimary = function () {
	        return this.primary;
	    };
	    Column.prototype.isFilterAllowed = function () {
	        // filter defined means it's a string, class or true.
	        // if its false, null or undefined then it's false.
	        var filterDefined = !!this.colDef.filter || !!this.colDef.filterFramework;
	        return this.primary && filterDefined;
	    };
	    Column.prototype.isFieldContainsDots = function () {
	        return this.fieldContainsDots;
	    };
	    Column.prototype.isTooltipFieldContainsDots = function () {
	        return this.tooltipFieldContainsDots;
	    };
	    Column.prototype.validate = function () {
	        var colDefAny = this.colDef;
	        function warnOnce(msg, key, obj) {
	            doOnce(function () {
	                if (obj) {
	                    console.warn(msg, obj);
	                }
	                else {
	                    doOnce(function () { return console.warn(msg); }, key);
	                }
	            }, key);
	        }
	        var usingCSRM = this.gridOptionsWrapper.isRowModelDefault();
	        if (usingCSRM && !ModuleRegistry.isRegistered(exports.ModuleNames.RowGroupingModule)) {
	            var rowGroupingItems = ['enableRowGroup', 'rowGroup', 'rowGroupIndex', 'enablePivot', 'enableValue', 'pivot', 'pivotIndex', 'aggFunc'];
	            rowGroupingItems.forEach(function (item) {
	                if (exists(colDefAny[item])) {
	                    if (ModuleRegistry.isPackageBased()) {
	                        warnOnce("AG Grid: " + item + " is only valid in ag-grid-enterprise, your column definition should not have " + item, 'ColumnRowGroupingMissing' + item);
	                    }
	                    else {
	                        warnOnce("AG Grid: " + item + " is only valid with AG Grid Enterprise Module " + exports.ModuleNames.RowGroupingModule + " - your column definition should not have " + item, 'ColumnRowGroupingMissing' + item);
	                    }
	                }
	            });
	        }
	        if (!ModuleRegistry.isRegistered(exports.ModuleNames.RichSelectModule)) {
	            if (this.colDef.cellEditor === 'agRichSelect' || this.colDef.cellEditor === 'agRichSelectCellEditor') {
	                if (ModuleRegistry.isPackageBased()) {
	                    warnOnce("AG Grid: " + this.colDef.cellEditor + " can only be used with ag-grid-enterprise", 'ColumnRichSelectMissing');
	                }
	                else {
	                    warnOnce("AG Grid: " + this.colDef.cellEditor + " can only be used with AG Grid Enterprise Module " + exports.ModuleNames.RichSelectModule, 'ColumnRichSelectMissing');
	                }
	            }
	        }
	        if (!ModuleRegistry.isRegistered(exports.ModuleNames.DateTimeCellEditorModule)) {
	            if (this.colDef.cellEditor === 'agRichSelect' || this.colDef.cellEditor === 'agDateTimeCellEditor') {
	                if (ModuleRegistry.isPackageBased()) {
	                    warnOnce("AG Grid: " + this.colDef.cellEditor + " can only be used with ag-grid-enterprise", 'ColumnDateTimeMissing');
	                }
	                else {
	                    warnOnce("AG Grid: " + this.colDef.cellEditor + " can only be used with AG Grid Enterprise Module " + exports.ModuleNames.DateTimeCellEditorModule, 'ColumnDateTimeMissing');
	                }
	            }
	        }
	        if (this.gridOptionsWrapper.isTreeData()) {
	            var itemsNotAllowedWithTreeData = ['rowGroup', 'rowGroupIndex', 'pivot', 'pivotIndex'];
	            itemsNotAllowedWithTreeData.forEach(function (item) {
	                if (exists(colDefAny[item])) {
	                    warnOnce("AG Grid: " + item + " is not possible when doing tree data, your column definition should not have " + item, 'TreeDataCannotRowGroup');
	                }
	            });
	        }
	        if (exists(this.colDef.width) && typeof this.colDef.width !== 'number') {
	            warnOnce('AG Grid: colDef.width should be a number, not ' + typeof this.colDef.width, 'ColumnCheck_asdfawef');
	        }
	    };
	    Column.prototype.addEventListener = function (eventType, listener) {
	        this.eventService.addEventListener(eventType, listener);
	    };
	    Column.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    Column.prototype.createColumnFunctionCallbackParams = function (rowNode) {
	        return {
	            node: rowNode,
	            data: rowNode.data,
	            column: this,
	            colDef: this.colDef,
	            context: this.gridOptionsWrapper.getContext(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	    };
	    Column.prototype.isSuppressNavigable = function (rowNode) {
	        // if boolean set, then just use it
	        if (typeof this.colDef.suppressNavigable === 'boolean') {
	            return this.colDef.suppressNavigable;
	        }
	        // if function, then call the function to find out
	        if (typeof this.colDef.suppressNavigable === 'function') {
	            var params = this.createColumnFunctionCallbackParams(rowNode);
	            var userFunc = this.colDef.suppressNavigable;
	            return userFunc(params);
	        }
	        return false;
	    };
	    Column.prototype.isCellEditable = function (rowNode) {
	        // only allow editing of groups if the user has this option enabled
	        if (rowNode.group && !this.gridOptionsWrapper.isEnableGroupEdit()) {
	            return false;
	        }
	        return this.isColumnFunc(rowNode, this.colDef.editable);
	    };
	    Column.prototype.isRowDrag = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
	    };
	    Column.prototype.isDndSource = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.dndSource);
	    };
	    Column.prototype.isCellCheckboxSelection = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
	    };
	    Column.prototype.isSuppressPaste = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
	    };
	    Column.prototype.isResizable = function () {
	        return this.colDef.resizable === true;
	    };
	    Column.prototype.isColumnFunc = function (rowNode, value) {
	        // if boolean set, then just use it
	        if (typeof value === 'boolean') {
	            return value;
	        }
	        // if function, then call the function to find out
	        if (typeof value === 'function') {
	            var params = this.createColumnFunctionCallbackParams(rowNode);
	            var editableFunc = value;
	            return editableFunc(params);
	        }
	        return false;
	    };
	    Column.prototype.setMoving = function (moving, source) {
	        if (source === void 0) { source = "api"; }
	        this.moving = moving;
	        this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MOVING_CHANGED, source));
	    };
	    Column.prototype.createColumnEvent = function (type, source) {
	        return {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            type: type,
	            column: this,
	            columns: [this],
	            source: source
	        };
	    };
	    Column.prototype.isMoving = function () {
	        return this.moving;
	    };
	    Column.prototype.getSort = function () {
	        return this.sort;
	    };
	    Column.prototype.setSort = function (sort, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.sort !== sort) {
	            this.sort = sort;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_SORT_CHANGED, source));
	        }
	    };
	    Column.prototype.setMenuVisible = function (visible, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.menuVisible !== visible) {
	            this.menuVisible = visible;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MENU_VISIBLE_CHANGED, source));
	        }
	    };
	    Column.prototype.isMenuVisible = function () {
	        return this.menuVisible;
	    };
	    Column.prototype.isSortAscending = function () {
	        return this.sort === Constants.SORT_ASC;
	    };
	    Column.prototype.isSortDescending = function () {
	        return this.sort === Constants.SORT_DESC;
	    };
	    Column.prototype.isSortNone = function () {
	        return missing(this.sort);
	    };
	    Column.prototype.isSorting = function () {
	        return exists(this.sort);
	    };
	    Column.prototype.getSortIndex = function () {
	        return this.sortIndex;
	    };
	    Column.prototype.setSortIndex = function (sortOrder) {
	        this.sortIndex = sortOrder;
	    };
	    Column.prototype.setAggFunc = function (aggFunc) {
	        this.aggFunc = aggFunc;
	    };
	    Column.prototype.getAggFunc = function () {
	        return this.aggFunc;
	    };
	    Column.prototype.getLeft = function () {
	        return this.left;
	    };
	    Column.prototype.getOldLeft = function () {
	        return this.oldLeft;
	    };
	    Column.prototype.getRight = function () {
	        return this.left + this.actualWidth;
	    };
	    Column.prototype.setLeft = function (left, source) {
	        if (source === void 0) { source = "api"; }
	        this.oldLeft = this.left;
	        if (this.left !== left) {
	            this.left = left;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LEFT_CHANGED, source));
	        }
	    };
	    Column.prototype.isFilterActive = function () {
	        return this.filterActive;
	    };
	    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
	    Column.prototype.setFilterActive = function (active, source, additionalEventAttributes) {
	        if (source === void 0) { source = "api"; }
	        if (this.filterActive !== active) {
	            this.filterActive = active;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FILTER_ACTIVE_CHANGED, source));
	        }
	        var filterChangedEvent = this.createColumnEvent(Column.EVENT_FILTER_CHANGED, source);
	        if (additionalEventAttributes) {
	            mergeDeep(filterChangedEvent, additionalEventAttributes);
	        }
	        this.eventService.dispatchEvent(filterChangedEvent);
	    };
	    Column.prototype.setPinned = function (pinned) {
	        if (pinned === true || pinned === Constants.PINNED_LEFT) {
	            this.pinned = Constants.PINNED_LEFT;
	        }
	        else if (pinned === Constants.PINNED_RIGHT) {
	            this.pinned = Constants.PINNED_RIGHT;
	        }
	        else {
	            this.pinned = null;
	        }
	    };
	    Column.prototype.setFirstRightPinned = function (firstRightPinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.firstRightPinned !== firstRightPinned) {
	            this.firstRightPinned = firstRightPinned;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, source));
	        }
	    };
	    Column.prototype.setLastLeftPinned = function (lastLeftPinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.lastLeftPinned !== lastLeftPinned) {
	            this.lastLeftPinned = lastLeftPinned;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LAST_LEFT_PINNED_CHANGED, source));
	        }
	    };
	    Column.prototype.isFirstRightPinned = function () {
	        return this.firstRightPinned;
	    };
	    Column.prototype.isLastLeftPinned = function () {
	        return this.lastLeftPinned;
	    };
	    Column.prototype.isPinned = function () {
	        return this.pinned === Constants.PINNED_LEFT || this.pinned === Constants.PINNED_RIGHT;
	    };
	    Column.prototype.isPinnedLeft = function () {
	        return this.pinned === Constants.PINNED_LEFT;
	    };
	    Column.prototype.isPinnedRight = function () {
	        return this.pinned === Constants.PINNED_RIGHT;
	    };
	    Column.prototype.getPinned = function () {
	        return this.pinned;
	    };
	    Column.prototype.setVisible = function (visible, source) {
	        if (source === void 0) { source = "api"; }
	        var newValue = visible === true;
	        if (this.visible !== newValue) {
	            this.visible = newValue;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VISIBLE_CHANGED, source));
	        }
	    };
	    Column.prototype.isVisible = function () {
	        return this.visible;
	    };
	    Column.prototype.getColDef = function () {
	        return this.colDef;
	    };
	    Column.prototype.getColumnGroupShow = function () {
	        return this.colDef.columnGroupShow;
	    };
	    Column.prototype.getColId = function () {
	        return this.colId;
	    };
	    Column.prototype.getId = function () {
	        return this.getColId();
	    };
	    Column.prototype.getDefinition = function () {
	        return this.colDef;
	    };
	    Column.prototype.getActualWidth = function () {
	        return this.actualWidth;
	    };
	    Column.prototype.createBaseColDefParams = function (rowNode) {
	        var params = {
	            node: rowNode,
	            data: rowNode.data,
	            colDef: this.colDef,
	            column: this,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext()
	        };
	        return params;
	    };
	    Column.prototype.getColSpan = function (rowNode) {
	        if (missing(this.colDef.colSpan)) {
	            return 1;
	        }
	        var params = this.createBaseColDefParams(rowNode);
	        var colSpan = this.colDef.colSpan(params);
	        // colSpan must be number equal to or greater than 1
	        return Math.max(colSpan, 1);
	    };
	    Column.prototype.getRowSpan = function (rowNode) {
	        if (missing(this.colDef.rowSpan)) {
	            return 1;
	        }
	        var params = this.createBaseColDefParams(rowNode);
	        var rowSpan = this.colDef.rowSpan(params);
	        // rowSpan must be number equal to or greater than 1
	        return Math.max(rowSpan, 1);
	    };
	    Column.prototype.setActualWidth = function (actualWidth, source, silent) {
	        if (source === void 0) { source = "api"; }
	        if (silent === void 0) { silent = false; }
	        if (this.minWidth != null) {
	            actualWidth = Math.max(actualWidth, this.minWidth);
	        }
	        if (this.maxWidth != null) {
	            actualWidth = Math.min(actualWidth, this.maxWidth);
	        }
	        if (this.actualWidth !== actualWidth) {
	            // disable flex for this column if it was manually resized.
	            this.actualWidth = actualWidth;
	            if (this.flex && source !== 'flex' && source !== 'gridInitializing') {
	                this.flex = null;
	            }
	            if (!silent) {
	                this.fireColumnWidthChangedEvent(source);
	            }
	        }
	    };
	    Column.prototype.fireColumnWidthChangedEvent = function (source) {
	        this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_WIDTH_CHANGED, source));
	    };
	    Column.prototype.isGreaterThanMax = function (width) {
	        if (this.maxWidth != null) {
	            return width > this.maxWidth;
	        }
	        return false;
	    };
	    Column.prototype.getMinWidth = function () {
	        return this.minWidth;
	    };
	    Column.prototype.getMaxWidth = function () {
	        return this.maxWidth;
	    };
	    Column.prototype.getFlex = function () {
	        return this.flex || 0;
	    };
	    // this method should only be used by the columnController to
	    // change flex when required by the setColumnState method.
	    Column.prototype.setFlex = function (flex) {
	        if (this.flex !== flex) {
	            this.flex = flex;
	        }
	    };
	    Column.prototype.setMinimum = function (source) {
	        if (source === void 0) { source = "api"; }
	        if (exists(this.minWidth)) {
	            this.setActualWidth(this.minWidth, source);
	        }
	    };
	    Column.prototype.setRowGroupActive = function (rowGroup, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.rowGroupActive !== rowGroup) {
	            this.rowGroupActive = rowGroup;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_ROW_GROUP_CHANGED, source));
	        }
	    };
	    Column.prototype.isRowGroupActive = function () {
	        return this.rowGroupActive;
	    };
	    Column.prototype.setPivotActive = function (pivot, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.pivotActive !== pivot) {
	            this.pivotActive = pivot;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_PIVOT_CHANGED, source));
	        }
	    };
	    Column.prototype.isPivotActive = function () {
	        return this.pivotActive;
	    };
	    Column.prototype.isAnyFunctionActive = function () {
	        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
	    };
	    Column.prototype.isAnyFunctionAllowed = function () {
	        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
	    };
	    Column.prototype.setValueActive = function (value, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.aggregationActive !== value) {
	            this.aggregationActive = value;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VALUE_CHANGED, source));
	        }
	    };
	    Column.prototype.isValueActive = function () {
	        return this.aggregationActive;
	    };
	    Column.prototype.isAllowPivot = function () {
	        return this.colDef.enablePivot === true;
	    };
	    Column.prototype.isAllowValue = function () {
	        return this.colDef.enableValue === true;
	    };
	    Column.prototype.isAllowRowGroup = function () {
	        return this.colDef.enableRowGroup === true;
	    };
	    Column.prototype.getMenuTabs = function (defaultValues) {
	        var menuTabs = this.getColDef().menuTabs;
	        if (menuTabs == null) {
	            menuTabs = defaultValues;
	        }
	        return menuTabs;
	    };
	    // this used to be needed, as previous version of ag-grid had lockPosition as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockPosition = function () {
	        console.warn('AG Grid: since v21, col.isLockPosition() should not be used, please use col.getColDef().lockPosition instead.');
	        return this.colDef ? !!this.colDef.lockPosition : false;
	    };
	    // this used to be needed, as previous version of ag-grid had lockVisible as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockVisible = function () {
	        console.warn('AG Grid: since v21, col.isLockVisible() should not be used, please use col.getColDef().lockVisible instead.');
	        return this.colDef ? !!this.colDef.lockVisible : false;
	    };
	    // this used to be needed, as previous version of ag-grid had lockPinned as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockPinned = function () {
	        console.warn('AG Grid: since v21, col.isLockPinned() should not be used, please use col.getColDef().lockPinned instead.');
	        return this.colDef ? !!this.colDef.lockPinned : false;
	    };
	    // + renderedHeaderCell - for making header cell transparent when moving
	    Column.EVENT_MOVING_CHANGED = 'movingChanged';
	    // + renderedCell - changing left position
	    Column.EVENT_LEFT_CHANGED = 'leftChanged';
	    // + renderedCell - changing width
	    Column.EVENT_WIDTH_CHANGED = 'widthChanged';
	    // + renderedCell - for changing pinned classes
	    Column.EVENT_LAST_LEFT_PINNED_CHANGED = 'lastLeftPinnedChanged';
	    Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = 'firstRightPinnedChanged';
	    // + renderedColumn - for changing visibility icon
	    Column.EVENT_VISIBLE_CHANGED = 'visibleChanged';
	    // + every time the filter changes, used in the floating filters
	    Column.EVENT_FILTER_CHANGED = 'filterChanged';
	    // + renderedHeaderCell - marks the header with filter icon
	    Column.EVENT_FILTER_ACTIVE_CHANGED = 'filterActiveChanged';
	    // + renderedHeaderCell - marks the header with sort icon
	    Column.EVENT_SORT_CHANGED = 'sortChanged';
	    Column.EVENT_MENU_VISIBLE_CHANGED = 'menuVisibleChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_PIVOT_CHANGED = 'columnPivotChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_VALUE_CHANGED = 'columnValueChanged';
	    __decorate$1([
	        Autowired('gridOptionsWrapper')
	    ], Column.prototype, "gridOptionsWrapper", void 0);
	    __decorate$1([
	        Autowired('columnUtils')
	    ], Column.prototype, "columnUtils", void 0);
	    __decorate$1([
	        Autowired('columnApi')
	    ], Column.prototype, "columnApi", void 0);
	    __decorate$1([
	        Autowired('gridApi')
	    ], Column.prototype, "gridApi", void 0);
	    __decorate$1([
	        Autowired('context')
	    ], Column.prototype, "context", void 0);
	    __decorate$1([
	        PostConstruct
	    ], Column.prototype, "initialise", null);
	    return Column;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$2 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ColumnGroup = /** @class */ (function () {
	    function ColumnGroup(originalColumnGroup, groupId, instanceId, pinned) {
	        // depends on the open/closed state of the group, only displaying columns are stored here
	        this.displayedChildren = [];
	        this.localEventService = new EventService();
	        this.groupId = groupId;
	        this.instanceId = instanceId;
	        this.originalColumnGroup = originalColumnGroup;
	        this.pinned = pinned;
	    }
	    // this is static, a it is used outside of this class
	    ColumnGroup.createUniqueId = function (groupId, instanceId) {
	        return groupId + '_' + instanceId;
	    };
	    // as the user is adding and removing columns, the groups are recalculated.
	    // this reset clears out all children, ready for children to be added again
	    ColumnGroup.prototype.reset = function () {
	        this.parent = null;
	        this.children = null;
	        this.displayedChildren = null;
	    };
	    ColumnGroup.prototype.getParent = function () {
	        return this.parent;
	    };
	    ColumnGroup.prototype.setParent = function (parent) {
	        this.parent = parent;
	    };
	    ColumnGroup.prototype.getUniqueId = function () {
	        return ColumnGroup.createUniqueId(this.groupId, this.instanceId);
	    };
	    ColumnGroup.prototype.isEmptyGroup = function () {
	        return this.displayedChildren.length === 0;
	    };
	    ColumnGroup.prototype.isMoving = function () {
	        var allLeafColumns = this.getOriginalColumnGroup().getLeafColumns();
	        if (!allLeafColumns || allLeafColumns.length === 0) {
	            return false;
	        }
	        return allLeafColumns.every(function (col) { return col.isMoving(); });
	    };
	    ColumnGroup.prototype.checkLeft = function () {
	        // first get all children to setLeft, as it impacts our decision below
	        this.displayedChildren.forEach(function (child) {
	            if (child instanceof ColumnGroup) {
	                child.checkLeft();
	            }
	        });
	        // set our left based on first displayed column
	        if (this.displayedChildren.length > 0) {
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                var lastChild = last(this.displayedChildren);
	                var lastChildLeft = lastChild.getLeft();
	                this.setLeft(lastChildLeft);
	            }
	            else {
	                var firstChildLeft = this.displayedChildren[0].getLeft();
	                this.setLeft(firstChildLeft);
	            }
	        }
	        else {
	            // this should never happen, as if we have no displayed columns, then
	            // this groups should not even exist.
	            this.setLeft(null);
	        }
	    };
	    ColumnGroup.prototype.getLeft = function () {
	        return this.left;
	    };
	    ColumnGroup.prototype.getOldLeft = function () {
	        return this.oldLeft;
	    };
	    ColumnGroup.prototype.setLeft = function (left) {
	        this.oldLeft = left;
	        if (this.left !== left) {
	            this.left = left;
	            this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_LEFT_CHANGED));
	        }
	    };
	    ColumnGroup.prototype.getPinned = function () {
	        return this.pinned;
	    };
	    ColumnGroup.prototype.createAgEvent = function (type) {
	        return { type: type };
	    };
	    ColumnGroup.prototype.addEventListener = function (eventType, listener) {
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    ColumnGroup.prototype.removeEventListener = function (eventType, listener) {
	        this.localEventService.removeEventListener(eventType, listener);
	    };
	    ColumnGroup.prototype.getGroupId = function () {
	        return this.groupId;
	    };
	    ColumnGroup.prototype.getInstanceId = function () {
	        return this.instanceId;
	    };
	    ColumnGroup.prototype.isChildInThisGroupDeepSearch = function (wantedChild) {
	        var result = false;
	        this.children.forEach(function (foundChild) {
	            if (wantedChild === foundChild) {
	                result = true;
	            }
	            if (foundChild instanceof ColumnGroup) {
	                if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) {
	                    result = true;
	                }
	            }
	        });
	        return result;
	    };
	    ColumnGroup.prototype.getActualWidth = function () {
	        var groupActualWidth = 0;
	        if (this.displayedChildren) {
	            this.displayedChildren.forEach(function (child) {
	                groupActualWidth += child.getActualWidth();
	            });
	        }
	        return groupActualWidth;
	    };
	    ColumnGroup.prototype.isResizable = function () {
	        if (!this.displayedChildren) {
	            return false;
	        }
	        // if at least one child is resizable, then the group is resizable
	        var result = false;
	        this.displayedChildren.forEach(function (child) {
	            if (child.isResizable()) {
	                result = true;
	            }
	        });
	        return result;
	    };
	    ColumnGroup.prototype.getMinWidth = function () {
	        var result = 0;
	        this.displayedChildren.forEach(function (groupChild) {
	            result += groupChild.getMinWidth() || 0;
	        });
	        return result;
	    };
	    ColumnGroup.prototype.addChild = function (child) {
	        if (!this.children) {
	            this.children = [];
	        }
	        this.children.push(child);
	    };
	    ColumnGroup.prototype.getDisplayedChildren = function () {
	        return this.displayedChildren;
	    };
	    ColumnGroup.prototype.getLeafColumns = function () {
	        var result = [];
	        this.addLeafColumns(result);
	        return result;
	    };
	    ColumnGroup.prototype.getDisplayedLeafColumns = function () {
	        var result = [];
	        this.addDisplayedLeafColumns(result);
	        return result;
	    };
	    // why two methods here doing the same thing?
	    ColumnGroup.prototype.getDefinition = function () {
	        return this.originalColumnGroup.getColGroupDef();
	    };
	    ColumnGroup.prototype.getColGroupDef = function () {
	        return this.originalColumnGroup.getColGroupDef();
	    };
	    ColumnGroup.prototype.isPadding = function () {
	        return this.originalColumnGroup.isPadding();
	    };
	    ColumnGroup.prototype.isExpandable = function () {
	        return this.originalColumnGroup.isExpandable();
	    };
	    ColumnGroup.prototype.isExpanded = function () {
	        return this.originalColumnGroup.isExpanded();
	    };
	    ColumnGroup.prototype.setExpanded = function (expanded) {
	        this.originalColumnGroup.setExpanded(expanded);
	    };
	    ColumnGroup.prototype.addDisplayedLeafColumns = function (leafColumns) {
	        this.displayedChildren.forEach(function (child) {
	            if (child instanceof Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof ColumnGroup) {
	                child.addDisplayedLeafColumns(leafColumns);
	            }
	        });
	    };
	    ColumnGroup.prototype.addLeafColumns = function (leafColumns) {
	        this.children.forEach(function (child) {
	            if (child instanceof Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof ColumnGroup) {
	                child.addLeafColumns(leafColumns);
	            }
	        });
	    };
	    ColumnGroup.prototype.getChildren = function () {
	        return this.children;
	    };
	    ColumnGroup.prototype.getColumnGroupShow = function () {
	        return this.originalColumnGroup.getColumnGroupShow();
	    };
	    ColumnGroup.prototype.getOriginalColumnGroup = function () {
	        return this.originalColumnGroup;
	    };
	    ColumnGroup.prototype.getPaddingLevel = function () {
	        var parent = this.getParent();
	        if (!this.isPadding() || !parent || !parent.isPadding()) {
	            return 0;
	        }
	        return 1 + parent.getPaddingLevel();
	    };
	    ColumnGroup.prototype.calculateDisplayedColumns = function () {
	        var _this = this;
	        // clear out last time we calculated
	        this.displayedChildren = [];
	        // find the column group that is controlling expandable. this is relevant when we have padding (empty)
	        // groups, where the expandable is actually the first parent that is not a padding group.
	        var parentWithExpansion = this;
	        while (parentWithExpansion != null && parentWithExpansion.isPadding()) {
	            parentWithExpansion = parentWithExpansion.getParent();
	        }
	        var isExpandable = parentWithExpansion ? parentWithExpansion.originalColumnGroup.isExpandable() : false;
	        // it not expandable, everything is visible
	        if (!isExpandable) {
	            this.displayedChildren = this.children;
	            this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
	            return;
	        }
	        // Add cols based on columnGroupShow
	        // Note - the below also adds padding groups, these are always added because they never have
	        // colDef.columnGroupShow set.
	        this.children.forEach(function (child) {
	            // never add empty groups
	            var emptyGroup = child instanceof ColumnGroup && (!child.displayedChildren || !child.displayedChildren.length);
	            if (emptyGroup) {
	                return;
	            }
	            var headerGroupShow = child.getColumnGroupShow();
	            switch (headerGroupShow) {
	                case ColumnGroup.HEADER_GROUP_SHOW_OPEN:
	                    // when set to open, only show col if group is open
	                    if (parentWithExpansion.originalColumnGroup.isExpanded()) {
	                        _this.displayedChildren.push(child);
	                    }
	                    break;
	                case ColumnGroup.HEADER_GROUP_SHOW_CLOSED:
	                    // when set to open, only show col if group is open
	                    if (!parentWithExpansion.originalColumnGroup.isExpanded()) {
	                        _this.displayedChildren.push(child);
	                    }
	                    break;
	                default:
	                    _this.displayedChildren.push(child);
	                    break;
	            }
	        });
	        this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
	    };
	    ColumnGroup.HEADER_GROUP_SHOW_OPEN = 'open';
	    ColumnGroup.HEADER_GROUP_SHOW_CLOSED = 'closed';
	    ColumnGroup.EVENT_LEFT_CHANGED = 'leftChanged';
	    ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = 'displayedChildrenChanged';
	    __decorate$2([
	        Autowired('gridOptionsWrapper')
	    ], ColumnGroup.prototype, "gridOptionsWrapper", void 0);
	    return ColumnGroup;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var OriginalColumnGroup = /** @class */ (function () {
	    function OriginalColumnGroup(colGroupDef, groupId, padding, level) {
	        this.localEventService = new EventService();
	        this.expandable = false;
	        this.colGroupDef = colGroupDef;
	        this.groupId = groupId;
	        this.expanded = !!colGroupDef && !!colGroupDef.openByDefault;
	        this.padding = padding;
	        this.level = level;
	    }
	    OriginalColumnGroup.prototype.setOriginalParent = function (originalParent) {
	        this.originalParent = originalParent;
	    };
	    OriginalColumnGroup.prototype.getOriginalParent = function () {
	        return this.originalParent;
	    };
	    OriginalColumnGroup.prototype.getLevel = function () {
	        return this.level;
	    };
	    OriginalColumnGroup.prototype.isVisible = function () {
	        // return true if at least one child is visible
	        if (this.children) {
	            return this.children.some(function (child) { return child.isVisible(); });
	        }
	        return false;
	    };
	    OriginalColumnGroup.prototype.isPadding = function () {
	        return this.padding;
	    };
	    OriginalColumnGroup.prototype.setExpanded = function (expanded) {
	        this.expanded = expanded === undefined ? false : expanded;
	        var event = {
	            type: OriginalColumnGroup.EVENT_EXPANDED_CHANGED
	        };
	        this.localEventService.dispatchEvent(event);
	    };
	    OriginalColumnGroup.prototype.isExpandable = function () {
	        return this.expandable;
	    };
	    OriginalColumnGroup.prototype.isExpanded = function () {
	        return this.expanded;
	    };
	    OriginalColumnGroup.prototype.getGroupId = function () {
	        return this.groupId;
	    };
	    OriginalColumnGroup.prototype.getId = function () {
	        return this.getGroupId();
	    };
	    OriginalColumnGroup.prototype.setChildren = function (children) {
	        this.children = children;
	    };
	    OriginalColumnGroup.prototype.getChildren = function () {
	        return this.children;
	    };
	    OriginalColumnGroup.prototype.getColGroupDef = function () {
	        return this.colGroupDef;
	    };
	    OriginalColumnGroup.prototype.getLeafColumns = function () {
	        var result = [];
	        this.addLeafColumns(result);
	        return result;
	    };
	    OriginalColumnGroup.prototype.addLeafColumns = function (leafColumns) {
	        if (!this.children) {
	            return;
	        }
	        this.children.forEach(function (child) {
	            if (child instanceof Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof OriginalColumnGroup) {
	                child.addLeafColumns(leafColumns);
	            }
	        });
	    };
	    OriginalColumnGroup.prototype.getColumnGroupShow = function () {
	        var colGroupDef = this.colGroupDef;
	        if (!colGroupDef) {
	            return;
	        }
	        return colGroupDef.columnGroupShow;
	    };
	    // need to check that this group has at least one col showing when both expanded and contracted.
	    // if not, then we don't allow expanding and contracting on this group
	    OriginalColumnGroup.prototype.setupExpandable = function () {
	        var _this = this;
	        this.setExpandable();
	        // note - we should be removing this event listener
	        this.getLeafColumns().forEach(function (col) { return col.addEventListener(Column.EVENT_VISIBLE_CHANGED, _this.onColumnVisibilityChanged.bind(_this)); });
	    };
	    OriginalColumnGroup.prototype.setExpandable = function () {
	        if (this.isPadding()) {
	            return;
	        }
	        // want to make sure the group doesn't disappear when it's open
	        var atLeastOneShowingWhenOpen = false;
	        // want to make sure the group doesn't disappear when it's closed
	        var atLeastOneShowingWhenClosed = false;
	        // want to make sure the group has something to show / hide
	        var atLeastOneChangeable = false;
	        var children = this.findChildrenRemovingPadding();
	        for (var i = 0, j = children.length; i < j; i++) {
	            var abstractColumn = children[i];
	            if (!abstractColumn.isVisible()) {
	                continue;
	            }
	            // if the abstractColumn is a grid generated group, there will be no colDef
	            var headerGroupShow = abstractColumn.getColumnGroupShow();
	            if (headerGroupShow === ColumnGroup.HEADER_GROUP_SHOW_OPEN) {
	                atLeastOneShowingWhenOpen = true;
	                atLeastOneChangeable = true;
	            }
	            else if (headerGroupShow === ColumnGroup.HEADER_GROUP_SHOW_CLOSED) {
	                atLeastOneShowingWhenClosed = true;
	                atLeastOneChangeable = true;
	            }
	            else {
	                atLeastOneShowingWhenOpen = true;
	                atLeastOneShowingWhenClosed = true;
	            }
	        }
	        var expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
	        if (this.expandable !== expandable) {
	            this.expandable = expandable;
	            var event_1 = {
	                type: OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED
	            };
	            this.localEventService.dispatchEvent(event_1);
	        }
	    };
	    OriginalColumnGroup.prototype.findChildrenRemovingPadding = function () {
	        var res = [];
	        var process = function (items) {
	            items.forEach(function (item) {
	                // if padding, we add this children instead of the padding
	                var skipBecausePadding = item instanceof OriginalColumnGroup && item.isPadding();
	                if (skipBecausePadding) {
	                    process(item.children);
	                }
	                else {
	                    res.push(item);
	                }
	            });
	        };
	        process(this.children);
	        return res;
	    };
	    OriginalColumnGroup.prototype.onColumnVisibilityChanged = function () {
	        this.setExpandable();
	    };
	    OriginalColumnGroup.prototype.addEventListener = function (eventType, listener) {
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    OriginalColumnGroup.prototype.removeEventListener = function (eventType, listener) {
	        this.localEventService.removeEventListener(eventType, listener);
	    };
	    OriginalColumnGroup.EVENT_EXPANDED_CHANGED = 'expandedChanged';
	    OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED = 'expandableChanged';
	    return OriginalColumnGroup;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var DefaultColumnTypes = {
	    numericColumn: {
	        headerClass: 'ag-right-aligned-header',
	        cellClass: 'ag-right-aligned-cell'
	    },
	    rightAligned: {
	        headerClass: 'ag-right-aligned-header',
	        cellClass: 'ag-right-aligned-cell'
	    }
	};

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var AG_GRID_STOP_PROPAGATION = '__ag_Grid_Stop_Propagation';
	var PASSIVE_EVENTS = ['touchstart', 'touchend', 'touchmove', 'touchcancel'];
	var supports = {};
	/**
	 * a user once raised an issue - they said that when you opened a popup (eg context menu)
	 * and then clicked on a selection checkbox, the popup wasn't closed. this is because the
	 * popup listens for clicks on the body, however ag-grid WAS stopping propagation on the
	 * checkbox clicks (so the rows didn't pick them up as row selection selection clicks).
	 * to get around this, we have a pattern to stop propagation for the purposes of AG Grid,
	 * but we still let the event pass back to the body.
	 * @param {Event} event
	 */
	function stopPropagationForAgGrid(event) {
	    event[AG_GRID_STOP_PROPAGATION] = true;
	}
	function isStopPropagationForAgGrid(event) {
	    return event[AG_GRID_STOP_PROPAGATION] === true;
	}
	var isEventSupported = (function () {
	    var tags = {
	        select: 'input',
	        change: 'input',
	        submit: 'form',
	        reset: 'form',
	        error: 'img',
	        load: 'img',
	        abort: 'img'
	    };
	    var eventChecker = function (eventName) {
	        if (typeof supports[eventName] === 'boolean') {
	            return supports[eventName];
	        }
	        var el = document.createElement(tags[eventName] || 'div');
	        eventName = 'on' + eventName;
	        var isSupported = (eventName in el);
	        if (!isSupported) {
	            el.setAttribute(eventName, 'return;');
	            isSupported = typeof el[eventName] == 'function';
	        }
	        return supports[eventName] = isSupported;
	    };
	    return eventChecker;
	})();
	function getComponentForEvent(gridOptionsWrapper, event, type) {
	    var sourceElement = getTarget(event);
	    while (sourceElement) {
	        var renderedComp = gridOptionsWrapper.getDomData(sourceElement, type);
	        if (renderedComp) {
	            return renderedComp;
	        }
	        sourceElement = sourceElement.parentElement;
	    }
	    return null;
	}
	/**
	 * @deprecated
	 * Adds all type of change listeners to an element, intended to be a text field
	 * @param {HTMLElement} element
	 * @param {EventListener} listener
	 */
	function addChangeListener(element, listener) {
	    element.addEventListener('changed', listener);
	    element.addEventListener('paste', listener);
	    element.addEventListener('input', listener);
	    // IE doesn't fire changed for special keys (eg delete, backspace), so need to
	    // listen for this further ones
	    element.addEventListener('keydown', listener);
	    element.addEventListener('keyup', listener);
	}
	/**
	 * srcElement is only available in IE. In all other browsers it is target
	 * http://stackoverflow.com/questions/5301643/how-can-i-make-event-srcelement-work-in-firefox-and-what-does-it-mean
	 * @param {Event} event
	 * @returns {Element}
	 */
	function getTarget(event) {
	    var eventNoType = event;
	    return eventNoType.target || eventNoType.srcElement;
	}
	function isElementInEventPath(element, event) {
	    if (!event || !element) {
	        return false;
	    }
	    return getEventPath(event).indexOf(element) >= 0;
	}
	function createEventPath(event) {
	    var res = [];
	    var pointer = getTarget(event);
	    while (pointer) {
	        res.push(pointer);
	        pointer = pointer.parentElement;
	    }
	    return res;
	}
	/**
	 * firefox doesn't have event.path set, or any alternative to it, so we hack
	 * it in. this is needed as it's to late to work out the path when the item is
	 * removed from the dom. used by MouseEventService, where it works out if a click
	 * was from the current grid, or a detail grid (master / detail).
	 * @param {Event} event
	 */
	function addAgGridEventPath(event) {
	    event.__agGridEventPath = getEventPath(event);
	}
	/**
	 * Gets the path for an Event.
	 * https://stackoverflow.com/questions/39245488/event-path-undefined-with-firefox-and-vue-js
	 * https://developer.mozilla.org/en-US/docs/Web/API/Event
	 * @param {Event} event
	 * @returns {EventTarget[]}
	 */
	function getEventPath(event) {
	    var eventNoType = event;
	    if (eventNoType.deepPath) {
	        // IE supports deep path
	        return eventNoType.deepPath();
	    }
	    if (eventNoType.path) {
	        // Chrome supports path
	        return eventNoType.path;
	    }
	    if (eventNoType.composedPath) {
	        // Firefox supports composePath
	        return eventNoType.composedPath();
	    }
	    if (eventNoType.__agGridEventPath) {
	        // Firefox supports composePath
	        return eventNoType.__agGridEventPath;
	    }
	    // and finally, if none of the above worked,
	    // we create the path ourselves
	    return createEventPath(event);
	}
	function addSafePassiveEventListener(frameworkOverrides, eElement, event, listener) {
	    var isPassive = includes(PASSIVE_EVENTS, event);
	    var options = isPassive ? { passive: true } : undefined;
	    // this check is here for certain scenarios where I believe the user must be destroying
	    // the grid somehow but continuing for it to be used
	    if (frameworkOverrides && frameworkOverrides.addEventListener) {
	        frameworkOverrides.addEventListener(eElement, event, listener, options);
	    }
	}

	var EventUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    stopPropagationForAgGrid: stopPropagationForAgGrid,
	    isStopPropagationForAgGrid: isStopPropagationForAgGrid,
	    isEventSupported: isEventSupported,
	    getComponentForEvent: getComponentForEvent,
	    addChangeListener: addChangeListener,
	    getTarget: getTarget,
	    isElementInEventPath: isElementInEventPath,
	    createEventPath: createEventPath,
	    addAgGridEventPath: addAgGridEventPath,
	    getEventPath: getEventPath,
	    addSafePassiveEventListener: addSafePassiveEventListener
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$3 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var BeanStub = /** @class */ (function () {
	    function BeanStub() {
	        var _this = this;
	        this.destroyFunctions = [];
	        this.destroyed = false;
	        // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
	        // prevents vue from creating proxies for created objects and prevents identity related issues
	        this.__v_skip = true;
	        this.getContext = function () { return _this.context; };
	        this.isAlive = function () { return !_this.destroyed; };
	    }
	    // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
	    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
	    // points to a bean or component that was not properly disposed of.
	    // constructor() {
	    //     setTimeout(()=> {
	    //         if (this.isAlive()) {
	    //             let prototype: any = Object.getPrototypeOf(this);
	    //             const constructor: any = prototype.constructor;
	    //             const constructorString = constructor.toString();
	    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
	    //             console.log('is alive ' + beanName);
	    //         }
	    //     }, 5000);
	    // }
	    // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean
	    BeanStub.prototype.getFrameworkOverrides = function () {
	        return this.frameworkOverrides;
	    };
	    BeanStub.prototype.destroy = function () {
	        // let prototype: any = Object.getPrototypeOf(this);
	        // const constructor: any = prototype.constructor;
	        // const constructorString = constructor.toString();
	        // const beanName = constructorString.substring(9, constructorString.indexOf("("));
	        this.destroyFunctions.forEach(function (func) { return func(); });
	        this.destroyFunctions.length = 0;
	        this.destroyed = true;
	        this.dispatchEvent({ type: BeanStub.EVENT_DESTROYED });
	    };
	    BeanStub.prototype.addEventListener = function (eventType, listener) {
	        if (!this.localEventService) {
	            this.localEventService = new EventService();
	        }
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    BeanStub.prototype.removeEventListener = function (eventType, listener) {
	        if (this.localEventService) {
	            this.localEventService.removeEventListener(eventType, listener);
	        }
	    };
	    BeanStub.prototype.dispatchEventAsync = function (event) {
	        var _this = this;
	        window.setTimeout(function () { return _this.dispatchEvent(event); }, 0);
	    };
	    BeanStub.prototype.dispatchEvent = function (event) {
	        if (this.localEventService) {
	            this.localEventService.dispatchEvent(event);
	        }
	    };
	    BeanStub.prototype.addManagedListener = function (object, event, listener) {
	        var _this = this;
	        if (this.destroyed) {
	            return;
	        }
	        if (object instanceof HTMLElement) {
	            addSafePassiveEventListener(this.getFrameworkOverrides(), object, event, listener);
	        }
	        else {
	            object.addEventListener(event, listener);
	        }
	        var destroyFunc = function () {
	            object.removeEventListener(event, listener);
	            _this.destroyFunctions = _this.destroyFunctions.filter(function (fn) { return fn !== destroyFunc; });
	            return null;
	        };
	        this.destroyFunctions.push(destroyFunc);
	        return destroyFunc;
	    };
	    BeanStub.prototype.addDestroyFunc = function (func) {
	        // if we are already destroyed, we execute the func now
	        if (this.isAlive()) {
	            this.destroyFunctions.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    BeanStub.prototype.createManagedBean = function (bean, context) {
	        var res = this.createBean(bean, context);
	        this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
	        return res;
	    };
	    BeanStub.prototype.createBean = function (bean, context, afterPreCreateCallback) {
	        return (context || this.getContext()).createBean(bean, afterPreCreateCallback);
	    };
	    BeanStub.prototype.destroyBean = function (bean, context) {
	        return (context || this.getContext()).destroyBean(bean);
	    };
	    BeanStub.prototype.destroyBeans = function (beans, context) {
	        var _this = this;
	        if (beans) {
	            forEach(beans, function (bean) { return _this.destroyBean(bean, context); });
	        }
	        return [];
	    };
	    BeanStub.EVENT_DESTROYED = 'destroyed';
	    __decorate$3([
	        Autowired('frameworkOverrides')
	    ], BeanStub.prototype, "frameworkOverrides", void 0);
	    __decorate$3([
	        Autowired('context')
	    ], BeanStub.prototype, "context", void 0);
	    __decorate$3([
	        Autowired('eventService')
	    ], BeanStub.prototype, "eventService", void 0);
	    __decorate$3([
	        Autowired('gridOptionsWrapper')
	    ], BeanStub.prototype, "gridOptionsWrapper", void 0);
	    __decorate$3([
	        PreDestroy
	    ], BeanStub.prototype, "destroy", null);
	    return BeanStub;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$4 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$1 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	// takes ColDefs and ColGroupDefs and turns them into Columns and OriginalGroups
	var ColumnFactory = /** @class */ (function (_super) {
	    __extends(ColumnFactory, _super);
	    function ColumnFactory() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ColumnFactory.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ColumnFactory');
	    };
	    ColumnFactory.prototype.createColumnTree = function (defs, primaryColumns, existingTree) {
	        // column key creator dishes out unique column id's in a deterministic way,
	        // so if we have two grids (that could be master/slave) with same column definitions,
	        // then this ensures the two grids use identical id's.
	        var columnKeyCreator = new ColumnKeyCreator();
	        var _a = this.extractExistingTreeData(existingTree), existingCols = _a.existingCols, existingGroups = _a.existingGroups, existingColKeys = _a.existingColKeys;
	        columnKeyCreator.addExistingKeys(existingColKeys);
	        // create am unbalanced tree that maps the provided definitions
	        var unbalancedTree = this.recursivelyCreateColumns(defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups);
	        var treeDept = this.findMaxDept(unbalancedTree, 0);
	        this.logger.log('Number of levels for grouped columns is ' + treeDept);
	        var columnTree = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
	        var deptFirstCallback = function (child, parent) {
	            if (child instanceof OriginalColumnGroup) {
	                child.setupExpandable();
	            }
	            // we set the original parents at the end, rather than when we go along, as balancing the tree
	            // adds extra levels into the tree. so we can only set parents when balancing is done.
	            child.setOriginalParent(parent);
	        };
	        this.columnUtils.depthFirstOriginalTreeSearch(null, columnTree, deptFirstCallback);
	        return {
	            columnTree: columnTree,
	            treeDept: treeDept
	        };
	    };
	    ColumnFactory.prototype.extractExistingTreeData = function (existingTree) {
	        var existingCols = [];
	        var existingGroups = [];
	        var existingColKeys = [];
	        if (existingTree) {
	            this.columnUtils.depthFirstOriginalTreeSearch(null, existingTree, function (item) {
	                if (item instanceof OriginalColumnGroup) {
	                    var group = item;
	                    existingGroups.push(group);
	                }
	                else {
	                    var col = item;
	                    existingColKeys.push(col.getId());
	                    existingCols.push(col);
	                }
	            });
	        }
	        return { existingCols: existingCols, existingGroups: existingGroups, existingColKeys: existingColKeys };
	    };
	    ColumnFactory.prototype.createForAutoGroups = function (autoGroupCols, gridBalancedTree) {
	        var _this = this;
	        var autoColBalancedTree = [];
	        autoGroupCols.forEach(function (col) {
	            var fakeTreeItem = _this.createAutoGroupTreeItem(gridBalancedTree, col);
	            autoColBalancedTree.push(fakeTreeItem);
	        });
	        return autoColBalancedTree;
	    };
	    ColumnFactory.prototype.createAutoGroupTreeItem = function (balancedColumnTree, column) {
	        var dept = this.findDepth(balancedColumnTree);
	        // at the end, this will be the top of the tree item.
	        var nextChild = column;
	        for (var i = dept - 1; i >= 0; i--) {
	            var autoGroup = new OriginalColumnGroup(null, "FAKE_PATH_" + column.getId() + "}_" + i, true, i);
	            this.context.createBean(autoGroup);
	            autoGroup.setChildren([nextChild]);
	            nextChild.setOriginalParent(autoGroup);
	            nextChild = autoGroup;
	        }
	        // at this point, the nextChild is the top most item in the tree
	        return nextChild;
	    };
	    ColumnFactory.prototype.findDepth = function (balancedColumnTree) {
	        var dept = 0;
	        var pointer = balancedColumnTree;
	        while (pointer && pointer[0] && pointer[0] instanceof OriginalColumnGroup) {
	            dept++;
	            pointer = pointer[0].getChildren();
	        }
	        return dept;
	    };
	    ColumnFactory.prototype.balanceColumnTree = function (unbalancedTree, currentDept, columnDept, columnKeyCreator) {
	        var result = [];
	        // go through each child, for groups, recurse a level deeper,
	        // for columns we need to pad
	        for (var i = 0; i < unbalancedTree.length; i++) {
	            var child = unbalancedTree[i];
	            if (child instanceof OriginalColumnGroup) {
	                // child is a group, all we do is go to the next level of recursion
	                var originalGroup = child;
	                var newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
	                originalGroup.setChildren(newChildren);
	                result.push(originalGroup);
	            }
	            else {
	                // child is a column - so here we add in the padded column groups if needed
	                var firstPaddedGroup = void 0;
	                var currentPaddedGroup = void 0;
	                // this for loop will NOT run any loops if no padded column groups are needed
	                for (var j = columnDept - 1; j >= currentDept; j--) {
	                    var newColId = columnKeyCreator.getUniqueKey(null, null);
	                    var colGroupDefMerged = this.createMergedColGroupDef(null);
	                    var paddedGroup = new OriginalColumnGroup(colGroupDefMerged, newColId, true, currentDept);
	                    this.context.createBean(paddedGroup);
	                    if (currentPaddedGroup) {
	                        currentPaddedGroup.setChildren([paddedGroup]);
	                    }
	                    currentPaddedGroup = paddedGroup;
	                    if (!firstPaddedGroup) {
	                        firstPaddedGroup = currentPaddedGroup;
	                    }
	                }
	                // likewise this if statement will not run if no padded groups
	                if (firstPaddedGroup && currentPaddedGroup) {
	                    result.push(firstPaddedGroup);
	                    var hasGroups = unbalancedTree.some(function (leaf) { return leaf instanceof OriginalColumnGroup; });
	                    if (hasGroups) {
	                        currentPaddedGroup.setChildren([child]);
	                        continue;
	                    }
	                    else {
	                        currentPaddedGroup.setChildren(unbalancedTree);
	                        break;
	                    }
	                }
	                result.push(child);
	            }
	        }
	        return result;
	    };
	    ColumnFactory.prototype.findMaxDept = function (treeChildren, dept) {
	        var maxDeptThisLevel = dept;
	        for (var i = 0; i < treeChildren.length; i++) {
	            var abstractColumn = treeChildren[i];
	            if (abstractColumn instanceof OriginalColumnGroup) {
	                var originalGroup = abstractColumn;
	                var newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
	                if (maxDeptThisLevel < newDept) {
	                    maxDeptThisLevel = newDept;
	                }
	            }
	        }
	        return maxDeptThisLevel;
	    };
	    ColumnFactory.prototype.recursivelyCreateColumns = function (defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups) {
	        var _this = this;
	        var result = [];
	        if (!defs) {
	            return result;
	        }
	        defs.forEach(function (def) {
	            var newGroupOrColumn;
	            if (_this.isColumnGroup(def)) {
	                newGroupOrColumn = _this.createColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups);
	            }
	            else {
	                newGroupOrColumn = _this.createColumn(primaryColumns, def, existingColsCopy, columnKeyCreator);
	            }
	            result.push(newGroupOrColumn);
	        });
	        return result;
	    };
	    ColumnFactory.prototype.createColumnGroup = function (primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups) {
	        var colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
	        var groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId || null, null);
	        var originalGroup = new OriginalColumnGroup(colGroupDefMerged, groupId, false, level);
	        this.context.createBean(originalGroup);
	        var existingGroup = this.findExistingGroup(colGroupDef, existingGroups);
	        if (existingGroup && existingGroup.isExpanded()) {
	            originalGroup.setExpanded(true);
	        }
	        var children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups);
	        originalGroup.setChildren(children);
	        return originalGroup;
	    };
	    ColumnFactory.prototype.createMergedColGroupDef = function (colGroupDef) {
	        var colGroupDefMerged = {};
	        assign(colGroupDefMerged, this.gridOptionsWrapper.getDefaultColGroupDef());
	        assign(colGroupDefMerged, colGroupDef);
	        this.checkForDeprecatedItems(colGroupDefMerged);
	        return colGroupDefMerged;
	    };
	    ColumnFactory.prototype.createColumn = function (primaryColumns, colDef, existingColsCopy, columnKeyCreator) {
	        var colDefMerged = this.mergeColDefs(colDef);
	        this.checkForDeprecatedItems(colDefMerged);
	        // see if column already exists
	        var column = this.findExistingColumn(colDef, existingColsCopy);
	        if (!column) {
	            // no existing column, need to create one
	            var colId = columnKeyCreator.getUniqueKey(colDefMerged.colId, colDefMerged.field);
	            column = new Column(colDefMerged, colDef, colId, primaryColumns);
	            this.context.createBean(column);
	        }
	        else {
	            column.setColDef(colDefMerged, colDef);
	            this.applyColumnState(column, colDefMerged);
	        }
	        return column;
	    };
	    ColumnFactory.prototype.applyColumnState = function (column, colDef) {
	        // flex
	        var flex = attrToNumber(colDef.flex);
	        if (flex !== undefined) {
	            column.setFlex(flex);
	        }
	        // width - we only set width if column is not flexing
	        var noFlexThisCol = column.getFlex() <= 0;
	        if (noFlexThisCol) {
	            // both null and undefined means we skip, as it's not possible to 'clear' width (a column must have a width)
	            var width = attrToNumber(colDef.width);
	            if (width != null) {
	                column.setActualWidth(width);
	            }
	            else {
	                // otherwise set the width again, in case min or max width has changed,
	                // and width needs to be adjusted.
	                var widthBeforeUpdate = column.getActualWidth();
	                column.setActualWidth(widthBeforeUpdate);
	            }
	        }
	        // sort - anything but undefined will set sort, thus null or empty string will clear the sort
	        if (colDef.sort !== undefined) {
	            if (colDef.sort == Constants.SORT_ASC || colDef.sort == Constants.SORT_DESC) {
	                column.setSort(colDef.sort);
	            }
	            else {
	                column.setSort(undefined);
	            }
	        }
	        // sorted at - anything but undefined, thus null will clear the sortIndex
	        var sortIndex = attrToNumber(colDef.sortIndex);
	        if (sortIndex !== undefined) {
	            column.setSortIndex(sortIndex);
	        }
	        // hide - anything but undefined, thus null will clear the hide
	        var hide = attrToBoolean(colDef.hide);
	        if (hide !== undefined) {
	            column.setVisible(!hide);
	        }
	        // pinned - anything but undefined, thus null or empty string will remove pinned
	        if (colDef.pinned !== undefined) {
	            column.setPinned(colDef.pinned);
	        }
	    };
	    ColumnFactory.prototype.findExistingColumn = function (newColDef, existingColsCopy) {
	        var res = find(existingColsCopy, function (existingCol) {
	            var existingColDef = existingCol.getUserProvidedColDef();
	            if (!existingColDef) {
	                return false;
	            }
	            var newHasId = newColDef.colId != null;
	            var newHasField = newColDef.field != null;
	            if (newHasId) {
	                return existingCol.getId() === newColDef.colId;
	            }
	            if (newHasField) {
	                return existingColDef.field === newColDef.field;
	            }
	            // if no id or field present, then try object equivalence.
	            if (existingColDef === newColDef) {
	                return true;
	            }
	            return false;
	        });
	        // make sure we remove, so if user provided duplicate id, then we don't have more than
	        // one column instance for colDef with common id
	        if (existingColsCopy && res) {
	            removeFromArray(existingColsCopy, res);
	        }
	        return res;
	    };
	    ColumnFactory.prototype.findExistingGroup = function (newGroupDef, existingGroups) {
	        var res = find(existingGroups, function (existingGroup) {
	            var existingDef = existingGroup.getColGroupDef();
	            if (!existingDef) {
	                return false;
	            }
	            var newHasId = newGroupDef.groupId != null;
	            if (newHasId) {
	                return existingGroup.getId() === newGroupDef.groupId;
	            }
	            return false;
	        });
	        // make sure we remove, so if user provided duplicate id, then we don't have more than
	        // one column instance for colDef with common id
	        if (res) {
	            removeFromArray(existingGroups, res);
	        }
	        return res;
	    };
	    ColumnFactory.prototype.mergeColDefs = function (colDef) {
	        // start with empty merged definition
	        var colDefMerged = {};
	        // merge properties from default column definitions
	        var defaultColDef = this.gridOptionsWrapper.getDefaultColDef();
	        mergeDeep(colDefMerged, defaultColDef, true, true);
	        // merge properties from column type properties
	        var columnType = colDef.type;
	        if (!columnType) {
	            columnType = defaultColDef && defaultColDef.type;
	        }
	        // if type of both colDef and defaultColDef, then colDef gets preference
	        if (columnType) {
	            this.assignColumnTypes(columnType, colDefMerged);
	        }
	        // merge properties from column definitions
	        mergeDeep(colDefMerged, colDef, true, true);
	        return colDefMerged;
	    };
	    ColumnFactory.prototype.assignColumnTypes = function (type, colDefMerged) {
	        var typeKeys = [];
	        if (type instanceof Array) {
	            var invalidArray = type.some(function (a) { return typeof a !== 'string'; });
	            if (invalidArray) {
	                console.warn("ag-grid: if colDef.type is supplied an array it should be of type 'string[]'");
	            }
	            else {
	                typeKeys = type;
	            }
	        }
	        else if (typeof type === 'string') {
	            typeKeys = type.split(',');
	        }
	        else {
	            console.warn("ag-grid: colDef.type should be of type 'string' | 'string[]'");
	            return;
	        }
	        // merge user defined with default column types
	        var allColumnTypes = assign({}, DefaultColumnTypes);
	        var userTypes = this.gridOptionsWrapper.getColumnTypes() || {};
	        iterateObject(userTypes, function (key, value) {
	            if (key in allColumnTypes) {
	                console.warn("AG Grid: the column type '" + key + "' is a default column type and cannot be overridden.");
	            }
	            else {
	                allColumnTypes[key] = value;
	            }
	        });
	        typeKeys.forEach(function (t) {
	            var typeColDef = allColumnTypes[t.trim()];
	            if (typeColDef) {
	                mergeDeep(colDefMerged, typeColDef, true, true);
	            }
	            else {
	                console.warn("ag-grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
	            }
	        });
	    };
	    ColumnFactory.prototype.checkForDeprecatedItems = function (colDef) {
	        if (colDef) {
	            var colDefNoType = colDef; // take out the type, so we can access attributes not defined in the type
	            if (colDefNoType.group !== undefined) {
	                console.warn('ag-grid: colDef.group is invalid, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.headerGroup !== undefined) {
	                console.warn('ag-grid: colDef.headerGroup is invalid, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.headerGroupShow !== undefined) {
	                console.warn('ag-grid: colDef.headerGroupShow is invalid, should be columnGroupShow, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.suppressRowGroup !== undefined) {
	                console.warn('ag-grid: colDef.suppressRowGroup is deprecated, please use colDef.type instead');
	            }
	            if (colDefNoType.suppressAggregation !== undefined) {
	                console.warn('ag-grid: colDef.suppressAggregation is deprecated, please use colDef.type instead');
	            }
	            if (colDefNoType.suppressRowGroup || colDefNoType.suppressAggregation) {
	                console.warn('ag-grid: colDef.suppressAggregation and colDef.suppressRowGroup are deprecated, use allowRowGroup, allowPivot and allowValue instead');
	            }
	            if (colDefNoType.displayName) {
	                console.warn("ag-grid: Found displayName " + colDefNoType.displayName + ", please use headerName instead, displayName is deprecated.");
	                colDefNoType.headerName = colDefNoType.displayName;
	            }
	        }
	    };
	    // if object has children, we assume it's a group
	    ColumnFactory.prototype.isColumnGroup = function (abstractColDef) {
	        return abstractColDef.children !== undefined;
	    };
	    __decorate$4([
	        Autowired('columnUtils')
	    ], ColumnFactory.prototype, "columnUtils", void 0);
	    __decorate$4([
	        __param$1(0, Qualifier('loggerFactory'))
	    ], ColumnFactory.prototype, "setBeans", null);
	    ColumnFactory = __decorate$4([
	        Bean('columnFactory')
	    ], ColumnFactory);
	    return ColumnFactory;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var Events = /** @class */ (function () {
	    function Events() {
	    }
	    /** Everything has changed with the columns. Either complete new set of columns set, or user called setState() */
	    /** @deprecated - grid no longer uses this, and setSate() also fires individual events */
	    Events.EVENT_COLUMN_EVERYTHING_CHANGED = 'columnEverythingChanged';
	    /** User has set in new columns. */
	    Events.EVENT_NEW_COLUMNS_LOADED = 'newColumnsLoaded';
	    /** The pivot mode flag was changed */
	    Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = 'columnPivotModeChanged';
	    /** A row group column was added, removed or order changed. */
	    Events.EVENT_COLUMN_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
	    /** expandAll / collapseAll was called from the api. */
	    Events.EVENT_EXPAND_COLLAPSE_ALL = 'expandOrCollapseAll';
	    /** A pivot column was added, removed or order changed. */
	    Events.EVENT_COLUMN_PIVOT_CHANGED = 'columnPivotChanged';
	    /** The list of grid columns has changed. */
	    Events.EVENT_GRID_COLUMNS_CHANGED = 'gridColumnsChanged';
	    /** A value column was added, removed or agg function was changed. */
	    Events.EVENT_COLUMN_VALUE_CHANGED = 'columnValueChanged';
	    /** A column was moved */
	    Events.EVENT_COLUMN_MOVED = 'columnMoved';
	    /** One or more columns was shown / hidden */
	    Events.EVENT_COLUMN_VISIBLE = 'columnVisible';
	    /** One or more columns was pinned / unpinned*/
	    Events.EVENT_COLUMN_PINNED = 'columnPinned';
	    /** A column group was opened / closed */
	    Events.EVENT_COLUMN_GROUP_OPENED = 'columnGroupOpened';
	    /** One or more columns was resized. If just one, the column in the event is set. */
	    Events.EVENT_COLUMN_RESIZED = 'columnResized';
	    /** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */
	    Events.EVENT_DISPLAYED_COLUMNS_CHANGED = 'displayedColumnsChanged';
	    /** The list of virtual columns has changed, results from viewport changing */
	    Events.EVENT_VIRTUAL_COLUMNS_CHANGED = 'virtualColumnsChanged';
	    /** Async Transactions Executed */
	    Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED = 'asyncTransactionsFlushed';
	    /** A row group was opened / closed */
	    Events.EVENT_ROW_GROUP_OPENED = 'rowGroupOpened';
	    /** The client has set new data into the grid */
	    Events.EVENT_ROW_DATA_CHANGED = 'rowDataChanged';
	    /** The client has updated data for the grid */
	    Events.EVENT_ROW_DATA_UPDATED = 'rowDataUpdated';
	    /** The client has set new floating data into the grid */
	    Events.EVENT_PINNED_ROW_DATA_CHANGED = 'pinnedRowDataChanged';
	    /** Range selection has changed */
	    Events.EVENT_RANGE_SELECTION_CHANGED = 'rangeSelectionChanged';
	    /** Chart was created */
	    Events.EVENT_CHART_CREATED = 'chartCreated';
	    /** Chart Range selection has changed */
	    Events.EVENT_CHART_RANGE_SELECTION_CHANGED = 'chartRangeSelectionChanged';
	    /** Chart Options have changed */
	    Events.EVENT_CHART_OPTIONS_CHANGED = 'chartOptionsChanged';
	    /** Chart was destroyed */
	    Events.EVENT_CHART_DESTROYED = 'chartDestroyed';
	    /** For when the tool panel is shown / hidden */
	    Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED = 'toolPanelVisibleChanged';
	    /** Model was updated - grid updates the drawn rows when this happens */
	    Events.EVENT_MODEL_UPDATED = 'modelUpdated';
	    Events.EVENT_PASTE_START = 'pasteStart';
	    Events.EVENT_PASTE_END = 'pasteEnd';
	    Events.EVENT_FILL_START = 'fillStart';
	    Events.EVENT_FILL_END = 'fillEnd';
	    Events.EVENT_CELL_CLICKED = 'cellClicked';
	    Events.EVENT_CELL_DOUBLE_CLICKED = 'cellDoubleClicked';
	    Events.EVENT_CELL_MOUSE_DOWN = 'cellMouseDown';
	    Events.EVENT_CELL_CONTEXT_MENU = 'cellContextMenu';
	    Events.EVENT_CELL_VALUE_CHANGED = 'cellValueChanged';
	    Events.EVENT_ROW_VALUE_CHANGED = 'rowValueChanged';
	    Events.EVENT_CELL_FOCUSED = 'cellFocused';
	    Events.EVENT_ROW_SELECTED = 'rowSelected';
	    Events.EVENT_SELECTION_CHANGED = 'selectionChanged';
	    Events.EVENT_CELL_KEY_DOWN = 'cellKeyDown';
	    Events.EVENT_CELL_KEY_PRESS = 'cellKeyPress';
	    Events.EVENT_CELL_MOUSE_OVER = 'cellMouseOver';
	    Events.EVENT_CELL_MOUSE_OUT = 'cellMouseOut';
	    /** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */
	    Events.EVENT_FILTER_CHANGED = 'filterChanged';
	    /** Filter was change but not applied. Only useful if apply buttons are used in filters. */
	    Events.EVENT_FILTER_MODIFIED = 'filterModified';
	    Events.EVENT_FILTER_OPENED = 'filterOpened';
	    Events.EVENT_SORT_CHANGED = 'sortChanged';
	    /** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */
	    Events.EVENT_VIRTUAL_ROW_REMOVED = 'virtualRowRemoved';
	    Events.EVENT_ROW_CLICKED = 'rowClicked';
	    Events.EVENT_ROW_DOUBLE_CLICKED = 'rowDoubleClicked';
	    /** Gets called once after the grid has finished initialising. */
	    Events.EVENT_GRID_READY = 'gridReady';
	    /** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
	     * changed, so always filling the space it was given. */
	    Events.EVENT_GRID_SIZE_CHANGED = 'gridSizeChanged';
	    /** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */
	    Events.EVENT_VIEWPORT_CHANGED = 'viewportChanged';
	    /* The width of the scrollbar has been calculated */
	    Events.EVENT_SCROLLBAR_WIDTH_CHANGED = 'scrollbarWidthChanged';
	    /** Rows were rendered for the first time (ie on async data load). */
	    Events.EVENT_FIRST_DATA_RENDERED = 'firstDataRendered';
	    /** A column drag has started, either resizing a column or moving a column. */
	    Events.EVENT_DRAG_STARTED = 'dragStarted';
	    /** A column drag has stopped */
	    Events.EVENT_DRAG_STOPPED = 'dragStopped';
	    Events.EVENT_CHECKBOX_CHANGED = 'checkboxChanged';
	    Events.EVENT_ROW_EDITING_STARTED = 'rowEditingStarted';
	    Events.EVENT_ROW_EDITING_STOPPED = 'rowEditingStopped';
	    Events.EVENT_CELL_EDITING_STARTED = 'cellEditingStarted';
	    Events.EVENT_CELL_EDITING_STOPPED = 'cellEditingStopped';
	    /** Main body of grid has scrolled, either horizontally or vertically */
	    Events.EVENT_BODY_SCROLL = 'bodyScroll';
	    Events.EVENT_ANIMATION_QUEUE_EMPTY = 'animationQueueEmpty';
	    Events.EVENT_HEIGHT_SCALE_CHANGED = 'heightScaleChanged';
	    /** The displayed page for pagination has changed. For example the data was filtered or sorted,
	     * or the user has moved to a different page. */
	    Events.EVENT_PAGINATION_CHANGED = 'paginationChanged';
	    /** Only used by React, Angular 2+, Web Components and VueJS AG Grid components
	     * (not used if doing plain JavaScript or Angular 1.x). If the grid receives changes due
	     * to bound properties, this event fires after the grid has finished processing the change. */
	    Events.EVENT_COMPONENT_STATE_CHANGED = 'componentStateChanged';
	    /** All items from here down are used internally by the grid, not intended for external use. */
	    // not documented, either experimental, or we just don't want users using an depending on them
	    Events.EVENT_BODY_HEIGHT_CHANGED = 'bodyHeightChanged';
	    Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = 'displayedColumnsWidthChanged';
	    Events.EVENT_SCROLL_VISIBILITY_CHANGED = 'scrollVisibilityChanged';
	    Events.EVENT_COLUMN_HOVER_CHANGED = 'columnHoverChanged';
	    Events.EVENT_FLASH_CELLS = 'flashCells';
	    Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = 'paginationPixelOffsetChanged';
	    Events.EVENT_DISPLAYED_ROWS_CHANGED = 'displayedRowsChanged';
	    Events.EVENT_LEFT_PINNED_WIDTH_CHANGED = 'leftPinnedWidthChanged';
	    Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED = 'rightPinnedWidthChanged';
	    Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = 'rowContainerHeightChanged';
	    Events.EVENT_ROW_DRAG_ENTER = 'rowDragEnter';
	    Events.EVENT_ROW_DRAG_MOVE = 'rowDragMove';
	    Events.EVENT_ROW_DRAG_LEAVE = 'rowDragLeave';
	    Events.EVENT_ROW_DRAG_END = 'rowDragEnd';
	    // primarily for charts
	    Events.EVENT_POPUP_TO_FRONT = 'popupToFront';
	    // these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
	    // to design these better around server side functions and then release to general public when fully working with
	    // all the row models.
	    Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = 'columnRowGroupChangeRequest';
	    Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = 'columnPivotChangeRequest';
	    Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = 'columnValueChangeRequest';
	    Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = 'columnAggFuncChangeRequest';
	    Events.EVENT_KEYBOARD_FOCUS = 'keyboardFocus';
	    Events.EVENT_MOUSE_FOCUS = 'mouseFocus';
	    Events.EVENT_STORE_UPDATED = 'storeUpdated';
	    return Events;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	// class returns unique instance id's for columns.
	// eg, the following calls (in this order) will result in:
	//
	// getInstanceIdForKey('country') => 0
	// getInstanceIdForKey('country') => 1
	// getInstanceIdForKey('country') => 2
	// getInstanceIdForKey('country') => 3
	// getInstanceIdForKey('age') => 0
	// getInstanceIdForKey('age') => 1
	// getInstanceIdForKey('country') => 4
	var GroupInstanceIdCreator = /** @class */ (function () {
	    function GroupInstanceIdCreator() {
	        // this map contains keys to numbers, so we remember what the last call was
	        this.existingIds = {};
	    }
	    GroupInstanceIdCreator.prototype.getInstanceIdForKey = function (key) {
	        var lastResult = this.existingIds[key];
	        var result;
	        if (typeof lastResult !== 'number') {
	            // first time this key
	            result = 0;
	        }
	        else {
	            result = lastResult + 1;
	        }
	        this.existingIds[key] = result;
	        return result;
	    };
	    return GroupInstanceIdCreator;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var reUnescapedHtml = /[&<>"']/g;
	/**
	 * HTML Escapes.
	 */
	var HTML_ESCAPES = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	};
	/**
	 * It encodes any string in UTF-8 format
	 * taken from https://github.com/mathiasbynens/utf8.js
	 * @param {string} s
	 * @returns {string}
	 */
	function utf8_encode(s) {
	    var stringFromCharCode = String.fromCharCode;
	    function ucs2decode(string) {
	        var output = [];
	        if (!string) {
	            return [];
	        }
	        var len = string.length;
	        var counter = 0;
	        var value;
	        var extra;
	        while (counter < len) {
	            value = string.charCodeAt(counter++);
	            if (value >= 0xD800 && value <= 0xDBFF && counter < len) {
	                // high surrogate, and there is a next character
	                extra = string.charCodeAt(counter++);
	                if ((extra & 0xFC00) == 0xDC00) { // low surrogate
	                    output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	                }
	                else {
	                    // unmatched surrogate; only append this code unit, in case the next
	                    // code unit is the high surrogate of a surrogate pair
	                    output.push(value);
	                    counter--;
	                }
	            }
	            else {
	                output.push(value);
	            }
	        }
	        return output;
	    }
	    function checkScalarValue(point) {
	        if (point >= 0xD800 && point <= 0xDFFF) {
	            throw Error('Lone surrogate U+' + point.toString(16).toUpperCase() +
	                ' is not a scalar value');
	        }
	    }
	    function createByte(point, shift) {
	        return stringFromCharCode(((point >> shift) & 0x3F) | 0x80);
	    }
	    function encodeCodePoint(point) {
	        if ((point >= 0 && point <= 7) || (point >= 14 && point <= 31)) {
	            return padStart("_x" + point.toString(16).toUpperCase() + "_", 4, '0');
	        }
	        if ((point & 0xFFFFFF80) == 0) { // 1-byte sequence
	            return stringFromCharCode(point);
	        }
	        var symbol = '';
	        if ((point & 0xFFFFF800) == 0) { // 2-byte sequence
	            symbol = stringFromCharCode(((point >> 6) & 0x1F) | 0xC0);
	        }
	        else if ((point & 0xFFFF0000) == 0) { // 3-byte sequence
	            checkScalarValue(point);
	            symbol = stringFromCharCode(((point >> 12) & 0x0F) | 0xE0);
	            symbol += createByte(point, 6);
	        }
	        else if ((point & 0xFFE00000) == 0) { // 4-byte sequence
	            symbol = stringFromCharCode(((point >> 18) & 0x07) | 0xF0);
	            symbol += createByte(point, 12);
	            symbol += createByte(point, 6);
	        }
	        symbol += stringFromCharCode((point & 0x3F) | 0x80);
	        return symbol;
	    }
	    var codePoints = ucs2decode(s);
	    var length = codePoints.length;
	    var index = -1;
	    var codePoint;
	    var byteString = '';
	    while (++index < length) {
	        codePoint = codePoints[index];
	        byteString += encodeCodePoint(codePoint);
	    }
	    return byteString;
	}
	/**
	 * @param str The string to be repeated
	 * @param len The size of the output string
	 * @returns A string with size len created from repeated `str`.
	 */
	function stringRepeat(str, len) {
	    len = Math.floor(len);
	    if (str.length === 0 || len === 0) {
	        return '';
	    }
	    var maxCount = str.length * len;
	    len = Math.floor(Math.log(len) / Math.log(2));
	    while (len) {
	        str += str;
	        len--;
	    }
	    str += str.substring(0, maxCount - str.length);
	    return str;
	}
	/**
	 * @param str The string to be padded
	 * @param totalLength The final length needed
	 * @param padStr The string to generate the padding
	 * @returns The padded string
	 */
	function padStart(str, totalLength, padStr) {
	    if (str.length > totalLength) {
	        return str;
	    }
	    totalLength -= str.length;
	    if (totalLength > padStr.length) {
	        padStr += stringRepeat(padStr, totalLength / padStr.length);
	    }
	    return padStr.slice(0, totalLength) + str;
	}
	/**
	 * Converts a camelCase string into hyphenated string
	 * from https://gist.github.com/youssman/745578062609e8acac9f
	 * @param {string} str
	 * @return {string}
	 */
	function camelCaseToHyphen(str) {
	    if (str === null || str === undefined) {
	        return null;
	    }
	    return str.replace(/([A-Z])/g, function (g) { return '-' + g[0].toLowerCase(); });
	}
	/**
	 * Converts a hyphenated string into camelCase string
	 * from https://stackoverflow.com/questions/6660977/convert-hyphens-to-camel-case-camelcase
	 * @param {string} str
	 * @return {string}
	 */
	function hyphenToCamelCase(str) {
	    if (str === null || str === undefined) {
	        return null;
	    }
	    return str.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
	}
	function capitalise(str) {
	    return str[0].toUpperCase() + str.substr(1).toLowerCase();
	}
	function escapeString(toEscape) {
	    // we call toString() twice, in case value is an object, where user provides
	    // a toString() method, and first call to toString() returns back something other
	    // than a string (eg a number to render)
	    return toEscape == null ? null : toEscape.toString().toString().replace(reUnescapedHtml, function (chr) { return HTML_ESCAPES[chr]; });
	}
	/**
	 * Converts a camelCase string into regular text
	 * from: https://stackoverflow.com/questions/15369566/putting-space-in-camel-case-string-using-regular-expression
	 * @param {string} camelCase
	 * @return {string}
	 */
	function camelCaseToHumanText(camelCase) {
	    if (!camelCase || camelCase == null) {
	        return null;
	    }
	    var rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
	    var words = camelCase.replace(rex, '$1$4 $2$3$5').replace('.', ' ').split(' ');
	    return words.map(function (word) { return word.substring(0, 1).toUpperCase() + ((word.length > 1) ? word.substring(1, word.length) : ''); }).join(' ');
	}
	function startsWith(str, matchStart) {
	    if (str === matchStart) {
	        return true;
	    }
	    return str != null && str.slice(0, matchStart.length) === matchStart;
	}

	var StringUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    utf8_encode: utf8_encode,
	    stringRepeat: stringRepeat,
	    padStart: padStart,
	    camelCaseToHyphen: camelCaseToHyphen,
	    hyphenToCamelCase: hyphenToCamelCase,
	    capitalise: capitalise,
	    escapeString: escapeString,
	    camelCaseToHumanText: camelCaseToHumanText,
	    startsWith: startsWith
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function convertToMap(arr) {
	    var map = new Map();
	    arr.forEach(function (pair) { return map.set(pair[0], pair[1]); });
	    return map;
	}
	function keys(map) {
	    var arr = [];
	    map.forEach(function (_, key) { return arr.push(key); });
	    return arr;
	}

	var MapUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    convertToMap: convertToMap,
	    keys: keys
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$5 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$2 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var ColumnController = /** @class */ (function (_super) {
	    __extends$1(ColumnController, _super);
	    function ColumnController() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // header row count, based on user provided columns
	        _this.primaryHeaderRowCount = 0;
	        _this.secondaryHeaderRowCount = 0;
	        _this.secondaryColumnsPresent = false;
	        // header row count, either above, or based on pivoting if we are pivoting
	        _this.gridHeaderRowCount = 0;
	        // leave level columns of the displayed trees
	        _this.displayedColumnsLeft = [];
	        _this.displayedColumnsRight = [];
	        _this.displayedColumnsCenter = [];
	        // all three lists above combined
	        _this.displayedColumns = [];
	        // for fast lookup, to see if a column or group is still displayed
	        _this.displayedColumnsAndGroupsMap = {};
	        // all columns to be rendered
	        _this.viewportColumns = [];
	        // all columns to be rendered in the centre
	        _this.viewportColumnsCenter = [];
	        _this.rowGroupColumns = [];
	        _this.valueColumns = [];
	        _this.pivotColumns = [];
	        _this.ready = false;
	        _this.autoGroupsNeedBuilding = false;
	        _this.forceRecreateAutoGroups = false;
	        _this.pivotMode = false;
	        _this.bodyWidth = 0;
	        _this.leftWidth = 0;
	        _this.rightWidth = 0;
	        _this.bodyWidthDirty = true;
	        _this.colDefVersion = 0;
	        _this.flexColsCalculatedAtLestOnce = false;
	        return _this;
	    }
	    ColumnController.prototype.init = function () {
	        this.suppressColumnVirtualisation = this.gridOptionsWrapper.isSuppressColumnVirtualisation();
	        var pivotMode = this.gridOptionsWrapper.isPivotMode();
	        if (this.isPivotSettingAllowed(pivotMode)) {
	            this.pivotMode = pivotMode;
	        }
	        this.usingTreeData = this.gridOptionsWrapper.isTreeData();
	        this.addManagedListener(this.gridOptionsWrapper, 'autoGroupColumnDef', this.onAutoGroupColumnDefChanged.bind(this));
	    };
	    ColumnController.prototype.onAutoGroupColumnDefChanged = function () {
	        this.autoGroupsNeedBuilding = true;
	        this.forceRecreateAutoGroups = true;
	        this.updateGridColumns();
	        this.updateDisplayedColumns('gridOptionsChanged');
	    };
	    ColumnController.prototype.getColDefVersion = function () {
	        return this.colDefVersion;
	    };
	    ColumnController.prototype.setColumnDefs = function (columnDefs, source) {
	        var _this = this;
	        if (source === void 0) { source = 'api'; }
	        var colsPreviouslyExisted = !!this.columnDefs;
	        this.colDefVersion++;
	        var raiseEventsFunc = this.compareColumnStatesAndRaiseEvents(source);
	        this.columnDefs = columnDefs;
	        // always invalidate cache on changing columns, as the column id's for the new columns
	        // could overlap with the old id's, so the cache would return old values for new columns.
	        this.valueCache.expire();
	        // NOTE ==================
	        // we should be destroying the existing columns and groups if they exist, for example, the original column
	        // group adds a listener to the columns, it should be also removing the listeners
	        this.autoGroupsNeedBuilding = true;
	        var oldPrimaryColumns = this.primaryColumns;
	        var oldPrimaryTree = this.primaryColumnTree;
	        var balancedTreeResult = this.columnFactory.createColumnTree(columnDefs, true, oldPrimaryTree);
	        this.primaryColumnTree = balancedTreeResult.columnTree;
	        this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
	        this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
	        this.primaryColumnsMap = {};
	        this.primaryColumns.forEach(function (col) { return _this.primaryColumnsMap[col.getId()] = col; });
	        this.extractRowGroupColumns(source, oldPrimaryColumns);
	        this.extractPivotColumns(source, oldPrimaryColumns);
	        this.extractValueColumns(source, oldPrimaryColumns);
	        this.ready = true;
	        this.updateGridColumns();
	        if (colsPreviouslyExisted && this.gridColsArePrimary && this.gridOptionsWrapper.isApplyColumnDefOrder()) {
	            this.orderGridColumnsLikePrimary();
	        }
	        this.updateDisplayedColumns(source);
	        this.checkViewportColumns();
	        // this event is not used by AG Grid, but left here for backwards compatibility,
	        // in case applications use it
	        this.dispatchEverythingChanged(source);
	        raiseEventsFunc();
	        this.dispatchNewColumnsLoaded();
	    };
	    ColumnController.prototype.dispatchNewColumnsLoaded = function () {
	        var newColumnsLoadedEvent = {
	            type: Events.EVENT_NEW_COLUMNS_LOADED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(newColumnsLoadedEvent);
	    };
	    // this event is legacy, no grid code listens to it. instead the grid listens to New Columns Loaded
	    ColumnController.prototype.dispatchEverythingChanged = function (source) {
	        if (source === void 0) { source = 'api'; }
	        var eventEverythingChanged = {
	            type: Events.EVENT_COLUMN_EVERYTHING_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(eventEverythingChanged);
	    };
	    ColumnController.prototype.orderGridColumnsLikePrimary = function () {
	        var _this = this;
	        this.gridColumns.sort(function (colA, colB) {
	            var primaryIndexA = _this.primaryColumns.indexOf(colA);
	            var primaryIndexB = _this.primaryColumns.indexOf(colB);
	            // if both cols are present in primary, then we just return the position,
	            // so position is maintained.
	            var indexAPresent = primaryIndexA >= 0;
	            var indexBPresent = primaryIndexB >= 0;
	            if (indexAPresent && indexBPresent) {
	                return primaryIndexA - primaryIndexB;
	            }
	            if (indexAPresent) {
	                // B is auto group column, so put B first
	                return 1;
	            }
	            if (indexBPresent) {
	                // A is auto group column, so put A first
	                return -1;
	            }
	            // otherwise both A and B are auto-group columns. so we just keep the order
	            // as they were already in.
	            var gridIndexA = _this.gridColumns.indexOf(colA);
	            var gridIndexB = _this.gridColumns.indexOf(colB);
	            return gridIndexA - gridIndexB;
	        });
	    };
	    ColumnController.prototype.isAutoRowHeightActive = function () {
	        return this.autoRowHeightColumns && this.autoRowHeightColumns.length > 0;
	    };
	    ColumnController.prototype.getAllAutoRowHeightCols = function () {
	        return this.autoRowHeightColumns;
	    };
	    ColumnController.prototype.setViewport = function () {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
	            this.viewportRight = this.bodyWidth - this.scrollPosition;
	        }
	        else {
	            this.viewportLeft = this.scrollPosition;
	            this.viewportRight = this.scrollWidth + this.scrollPosition;
	        }
	    };
	    // used by clipboard service, to know what columns to paste into
	    ColumnController.prototype.getDisplayedColumnsStartingAt = function (column) {
	        var currentColumn = column;
	        var columns = [];
	        while (currentColumn != null) {
	            columns.push(currentColumn);
	            currentColumn = this.getDisplayedColAfter(currentColumn);
	        }
	        return columns;
	    };
	    // checks what columns are currently displayed due to column virtualisation. fires an event
	    // if the list of columns has changed.
	    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
	    ColumnController.prototype.checkViewportColumns = function () {
	        // check displayCenterColumnTree exists first, as it won't exist when grid is initialising
	        if (this.displayedColumnsCenter == null) {
	            return;
	        }
	        var hashBefore = this.viewportColumns.map(function (column) { return column.getId(); }).join('#');
	        this.extractViewport();
	        var hashAfter = this.viewportColumns.map(function (column) { return column.getId(); }).join('#');
	        if (hashBefore !== hashAfter) {
	            var event_1 = {
	                type: Events.EVENT_VIRTUAL_COLUMNS_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    ColumnController.prototype.setViewportPosition = function (scrollWidth, scrollPosition) {
	        if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
	            this.scrollWidth = scrollWidth;
	            this.scrollPosition = scrollPosition;
	            // we need to call setVirtualViewportLeftAndRight() at least once after the body width changes,
	            // as the viewport can stay the same, but in RTL, if body width changes, we need to work out the
	            // virtual columns again
	            this.bodyWidthDirty = true;
	            this.setViewport();
	            if (this.ready) {
	                this.checkViewportColumns();
	            }
	        }
	    };
	    ColumnController.prototype.isPivotMode = function () {
	        return this.pivotMode;
	    };
	    ColumnController.prototype.isPivotSettingAllowed = function (pivot) {
	        if (pivot && this.gridOptionsWrapper.isTreeData()) {
	            console.warn("AG Grid: Pivot mode not available in conjunction Tree Data i.e. 'gridOptions.treeData: true'");
	            return false;
	        }
	        return true;
	    };
	    ColumnController.prototype.setPivotMode = function (pivotMode, source) {
	        if (source === void 0) { source = 'api'; }
	        if (pivotMode === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode)) {
	            return;
	        }
	        this.pivotMode = pivotMode;
	        // we need to update grid columns to cover the scenario where user has groupSuppressAutoColumn=true, as
	        // this means we don't use auto group column UNLESS we are in pivot mode (it's mandatory in pivot mode),
	        // so need to updateGridColumn() to check it autoGroupCol needs to be added / removed
	        this.autoGroupsNeedBuilding = true;
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) {
	        if (!this.secondaryColumnsPresent || !this.secondaryColumns) {
	            return null;
	        }
	        var valueColumnToFind = this.getPrimaryColumn(valueColKey);
	        var foundColumn = null;
	        this.secondaryColumns.forEach(function (column) {
	            var thisPivotKeys = column.getColDef().pivotKeys;
	            var pivotValueColumn = column.getColDef().pivotValueColumn;
	            var pivotKeyMatches = areEqual(thisPivotKeys, pivotKeys);
	            var pivotValueMatches = pivotValueColumn === valueColumnToFind;
	            if (pivotKeyMatches && pivotValueMatches) {
	                foundColumn = column;
	            }
	        });
	        return foundColumn;
	    };
	    ColumnController.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ColumnController');
	    };
	    ColumnController.prototype.setFirstRightAndLastLeftPinned = function (source) {
	        var lastLeft;
	        var firstRight;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            lastLeft = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null;
	            firstRight = this.displayedColumnsRight ? last(this.displayedColumnsRight) : null;
	        }
	        else {
	            lastLeft = this.displayedColumnsLeft ? last(this.displayedColumnsLeft) : null;
	            firstRight = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null;
	        }
	        this.gridColumns.forEach(function (column) {
	            column.setLastLeftPinned(column === lastLeft, source);
	            column.setFirstRightPinned(column === firstRight, source);
	        });
	    };
	    ColumnController.prototype.autoSizeColumns = function (keys, skipHeader, source) {
	        // because of column virtualisation, we can only do this function on columns that are
	        // actually rendered, as non-rendered columns (outside the viewport and not rendered
	        // due to column virtualisation) are not present. this can result in all rendered columns
	        // getting narrowed, which in turn introduces more rendered columns on the RHS which
	        // did not get autosized in the original run, leaving the visible grid with columns on
	        // the LHS sized, but RHS no. so we keep looping through the visible columns until
	        // no more cols are available (rendered) to be resized
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        // we autosize after animation frames finish in case any cell renderers need to complete first. this can
	        // happen eg if client code is calling api.autoSizeAllColumns() straight after grid is initialised, but grid
	        // hasn't fully drawn out all the cells yet (due to cell renderers in animation frames).
	        this.animationFrameService.flushAllFrames();
	        // keep track of which cols we have resized in here
	        var columnsAutosized = [];
	        // initialise with anything except 0 so that while loop executes at least once
	        var changesThisTimeAround = -1;
	        if (skipHeader == null) {
	            skipHeader = this.gridOptionsWrapper.isSkipHeaderOnAutoSize();
	        }
	        while (changesThisTimeAround !== 0) {
	            changesThisTimeAround = 0;
	            this.actionOnGridColumns(keys, function (column) {
	                // if already autosized, skip it
	                if (columnsAutosized.indexOf(column) >= 0) {
	                    return false;
	                }
	                // get how wide this col should be
	                var preferredWidth = _this.autoWidthCalculator.getPreferredWidthForColumn(column, skipHeader);
	                // preferredWidth = -1 if this col is not on the screen
	                if (preferredWidth > 0) {
	                    var newWidth = _this.normaliseColumnWidth(column, preferredWidth);
	                    column.setActualWidth(newWidth, source);
	                    columnsAutosized.push(column);
	                    changesThisTimeAround++;
	                }
	                return true;
	            }, source);
	        }
	        this.fireColumnResizedEvent(columnsAutosized, true, 'autosizeColumns');
	    };
	    ColumnController.prototype.fireColumnResizedEvent = function (columns, finished, source, flexColumns) {
	        if (flexColumns === void 0) { flexColumns = null; }
	        if (columns && columns.length) {
	            var event_2 = {
	                type: Events.EVENT_COLUMN_RESIZED,
	                columns: columns,
	                column: columns.length === 1 ? columns[0] : null,
	                flexColumns: flexColumns,
	                finished: finished,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_2);
	        }
	    };
	    ColumnController.prototype.autoSizeColumn = function (key, skipHeader, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.autoSizeColumns([key], skipHeader, source);
	        }
	    };
	    ColumnController.prototype.autoSizeAllColumns = function (skipHeader, source) {
	        if (source === void 0) { source = "api"; }
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        this.autoSizeColumns(allDisplayedColumns, skipHeader, source);
	    };
	    ColumnController.prototype.getColumnsFromTree = function (rootColumns) {
	        var result = [];
	        var recursiveFindColumns = function (childColumns) {
	            for (var i = 0; i < childColumns.length; i++) {
	                var child = childColumns[i];
	                if (child instanceof Column) {
	                    result.push(child);
	                }
	                else if (child instanceof OriginalColumnGroup) {
	                    recursiveFindColumns(child.getChildren());
	                }
	            }
	        };
	        recursiveFindColumns(rootColumns);
	        return result;
	    };
	    ColumnController.prototype.getAllDisplayedTrees = function () {
	        if (this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre) {
	            return this.displayedTreeLeft
	                .concat(this.displayedTreeCentre)
	                .concat(this.displayedTreeRight);
	        }
	        return null;
	    };
	    // + columnSelectPanel
	    ColumnController.prototype.getPrimaryColumnTree = function () {
	        return this.primaryColumnTree;
	    };
	    // + gridPanel -> for resizing the body and setting top margin
	    ColumnController.prototype.getHeaderRowCount = function () {
	        return this.gridHeaderRowCount;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getDisplayedTreeLeft = function () {
	        return this.displayedTreeLeft;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getDisplayedTreeRight = function () {
	        return this.displayedTreeRight;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getDisplayedTreeCentre = function () {
	        return this.displayedTreeCentre;
	    };
	    // gridPanel -> ensureColumnVisible
	    ColumnController.prototype.isColumnDisplayed = function (column) {
	        return this.getAllDisplayedColumns().indexOf(column) >= 0;
	    };
	    // + csvCreator
	    ColumnController.prototype.getAllDisplayedColumns = function () {
	        return this.displayedColumns;
	    };
	    ColumnController.prototype.getViewportColumns = function () {
	        return this.viewportColumns;
	    };
	    ColumnController.prototype.getDisplayedLeftColumnsForRow = function (rowNode) {
	        if (!this.colSpanActive) {
	            return this.displayedColumnsLeft;
	        }
	        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsLeft);
	    };
	    ColumnController.prototype.getDisplayedRightColumnsForRow = function (rowNode) {
	        if (!this.colSpanActive) {
	            return this.displayedColumnsRight;
	        }
	        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsRight);
	    };
	    ColumnController.prototype.getDisplayedColumnsForRow = function (rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
	        var result = [];
	        var lastConsideredCol = null;
	        var _loop_1 = function (i) {
	            var col = displayedColumns[i];
	            var maxAllowedColSpan = displayedColumns.length - i;
	            var colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
	            var columnsToCheckFilter = [col];
	            if (colSpan > 1) {
	                var colsToRemove = colSpan - 1;
	                for (var j = 1; j <= colsToRemove; j++) {
	                    columnsToCheckFilter.push(displayedColumns[i + j]);
	                }
	                i += colsToRemove;
	            }
	            // see which cols we should take out for column virtualisation
	            var filterPasses;
	            if (filterCallback) {
	                // if user provided a callback, means some columns may not be in the viewport.
	                // the user will NOT provide a callback if we are talking about pinned areas,
	                // as pinned areas have no horizontal scroll and do not virtualise the columns.
	                // if lots of columns, that means column spanning, and we set filterPasses = true
	                // if one or more of the columns spanned pass the filter.
	                filterPasses = false;
	                columnsToCheckFilter.forEach(function (colForFilter) {
	                    if (filterCallback(colForFilter)) {
	                        filterPasses = true;
	                    }
	                });
	            }
	            else {
	                filterPasses = true;
	            }
	            if (filterPasses) {
	                if (result.length === 0 && lastConsideredCol) {
	                    var gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
	                    if (gapBeforeColumn) {
	                        result.push(lastConsideredCol);
	                    }
	                }
	                result.push(col);
	            }
	            lastConsideredCol = col;
	            out_i_1 = i;
	        };
	        var out_i_1;
	        for (var i = 0; i < displayedColumns.length; i++) {
	            _loop_1(i);
	            i = out_i_1;
	        }
	        return result;
	    };
	    // + rowRenderer
	    // if we are not column spanning, this just returns back the virtual centre columns,
	    // however if we are column spanning, then different rows can have different virtual
	    // columns, so we have to work out the list for each individual row.
	    ColumnController.prototype.getViewportCenterColumnsForRow = function (rowNode) {
	        var _this = this;
	        if (!this.colSpanActive) {
	            return this.viewportColumnsCenter;
	        }
	        var emptySpaceBeforeColumn = function (col) {
	            var left = col.getLeft();
	            return exists(left) && left > _this.viewportLeft;
	        };
	        // if doing column virtualisation, then we filter based on the viewport.
	        var filterCallback = this.suppressColumnVirtualisation ? null : this.isColumnInViewport.bind(this);
	        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsCenter, filterCallback, emptySpaceBeforeColumn);
	    };
	    ColumnController.prototype.getAriaColumnIndex = function (col) {
	        return this.getAllGridColumns().indexOf(col) + 1;
	    };
	    ColumnController.prototype.isColumnInViewport = function (col) {
	        var columnLeft = col.getLeft() || 0;
	        var columnRight = columnLeft + col.getActualWidth();
	        // adding 200 for buffer size, so some cols off viewport are rendered.
	        // this helps horizontal scrolling so user rarely sees white space (unless
	        // they scroll horizontally fast). however we are conservative, as the more
	        // buffer the slower the vertical redraw speed
	        var leftBounds = this.viewportLeft - 200;
	        var rightBounds = this.viewportRight + 200;
	        var columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
	        var columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
	        return !columnToMuchLeft && !columnToMuchRight;
	    };
	    // used by:
	    // + angularGrid -> setting pinned body width
	    // note: this should be cached
	    ColumnController.prototype.getDisplayedColumnsLeftWidth = function () {
	        return this.getWidthOfColsInList(this.displayedColumnsLeft);
	    };
	    // note: this should be cached
	    ColumnController.prototype.getDisplayedColumnsRightWidth = function () {
	        return this.getWidthOfColsInList(this.displayedColumnsRight);
	    };
	    ColumnController.prototype.updatePrimaryColumnList = function (keys, masterList, actionIsAdd, columnCallback, eventType, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        if (!keys || missingOrEmpty(keys)) {
	            return;
	        }
	        var atLeastOne = false;
	        keys.forEach(function (key) {
	            var columnToAdd = _this.getPrimaryColumn(key);
	            if (!columnToAdd) {
	                return;
	            }
	            if (actionIsAdd) {
	                if (masterList.indexOf(columnToAdd) >= 0) {
	                    return;
	                }
	                masterList.push(columnToAdd);
	            }
	            else {
	                if (masterList.indexOf(columnToAdd) < 0) {
	                    return;
	                }
	                removeFromArray(masterList, columnToAdd);
	            }
	            columnCallback(columnToAdd);
	            atLeastOne = true;
	        });
	        if (!atLeastOne) {
	            return;
	        }
	        if (this.autoGroupsNeedBuilding) {
	            this.updateGridColumns();
	        }
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: eventType,
	            columns: masterList,
	            column: masterList.length === 1 ? masterList[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.setRowGroupColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.setPrimaryColumnList(colKeys, this.rowGroupColumns, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.setRowGroupActive.bind(this), source);
	    };
	    ColumnController.prototype.setRowGroupActive = function (active, column, source) {
	        if (active === column.isRowGroupActive()) {
	            return;
	        }
	        column.setRowGroupActive(active, source);
	        if (!active && !this.gridOptionsWrapper.isSuppressMakeColumnVisibleAfterUnGroup()) {
	            column.setVisible(true, source);
	        }
	    };
	    ColumnController.prototype.addRowGroupColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.addRowGroupColumns([key], source);
	        }
	    };
	    ColumnController.prototype.addRowGroupColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.updatePrimaryColumnList(keys, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
	    };
	    ColumnController.prototype.removeRowGroupColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.updatePrimaryColumnList(keys, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
	    };
	    ColumnController.prototype.removeRowGroupColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.removeRowGroupColumns([key], source);
	        }
	    };
	    ColumnController.prototype.addPivotColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.pivotColumns, true, function (column) { return column.setPivotActive(true, source); }, Events.EVENT_COLUMN_PIVOT_CHANGED, source);
	    };
	    ColumnController.prototype.setPivotColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.setPrimaryColumnList(colKeys, this.pivotColumns, Events.EVENT_COLUMN_PIVOT_CHANGED, function (added, column) {
	            column.setPivotActive(added, source);
	        }, source);
	    };
	    ColumnController.prototype.addPivotColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        this.addPivotColumns([key], source);
	    };
	    ColumnController.prototype.removePivotColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.pivotColumns, false, function (column) { return column.setPivotActive(false, source); }, Events.EVENT_COLUMN_PIVOT_CHANGED, source);
	    };
	    ColumnController.prototype.removePivotColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        this.removePivotColumns([key], source);
	    };
	    ColumnController.prototype.setPrimaryColumnList = function (colKeys, masterList, eventName, columnCallback, source) {
	        var _this = this;
	        masterList.length = 0;
	        if (exists(colKeys)) {
	            colKeys.forEach(function (key) {
	                var column = _this.getPrimaryColumn(key);
	                if (column) {
	                    masterList.push(column);
	                }
	            });
	        }
	        this.primaryColumns.forEach(function (column) {
	            var added = masterList.indexOf(column) >= 0;
	            columnCallback(added, column);
	        });
	        if (this.autoGroupsNeedBuilding) {
	            this.updateGridColumns();
	        }
	        this.updateDisplayedColumns(source);
	        this.fireColumnEvent(eventName, masterList, source);
	    };
	    ColumnController.prototype.setValueColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.setPrimaryColumnList(colKeys, this.valueColumns, Events.EVENT_COLUMN_VALUE_CHANGED, this.setValueActive.bind(this), source);
	    };
	    ColumnController.prototype.setValueActive = function (active, column, source) {
	        if (active === column.isValueActive()) {
	            return;
	        }
	        column.setValueActive(active, source);
	        if (active && !column.getAggFunc()) {
	            var initialAggFunc = this.aggFuncService.getDefaultAggFunc(column);
	            column.setAggFunc(initialAggFunc);
	        }
	    };
	    ColumnController.prototype.addValueColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.valueColumns, true, this.setValueActive.bind(this, true), Events.EVENT_COLUMN_VALUE_CHANGED, source);
	    };
	    ColumnController.prototype.addValueColumn = function (colKey, source) {
	        if (source === void 0) { source = "api"; }
	        if (colKey) {
	            this.addValueColumns([colKey], source);
	        }
	    };
	    ColumnController.prototype.removeValueColumn = function (colKey, source) {
	        if (source === void 0) { source = "api"; }
	        this.removeValueColumns([colKey], source);
	    };
	    ColumnController.prototype.removeValueColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.valueColumns, false, this.setValueActive.bind(this, false), Events.EVENT_COLUMN_VALUE_CHANGED, source);
	    };
	    // returns the width we can set to this col, taking into consideration min and max widths
	    ColumnController.prototype.normaliseColumnWidth = function (column, newWidth) {
	        var minWidth = column.getMinWidth();
	        if (exists(minWidth) && newWidth < minWidth) {
	            newWidth = minWidth;
	        }
	        var maxWidth = column.getMaxWidth();
	        if (exists(maxWidth) && column.isGreaterThanMax(newWidth)) {
	            newWidth = maxWidth;
	        }
	        return newWidth;
	    };
	    ColumnController.prototype.getPrimaryOrGridColumn = function (key) {
	        var column = this.getPrimaryColumn(key);
	        return column || this.getGridColumn(key);
	    };
	    ColumnController.prototype.setColumnWidths = function (columnWidths, shiftKey, // @takeFromAdjacent - if user has 'shift' pressed, then pixels are taken from adjacent column
	    finished, // @finished - ends up in the event, tells the user if more events are to come
	    source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        var sets = [];
	        columnWidths.forEach(function (columnWidth) {
	            var col = _this.getPrimaryOrGridColumn(columnWidth.key);
	            if (!col) {
	                return;
	            }
	            sets.push({
	                width: columnWidth.newWidth,
	                ratios: [1],
	                columns: [col]
	            });
	            // if user wants to do shift resize by default, then we invert the shift operation
	            var defaultIsShift = _this.gridOptionsWrapper.getColResizeDefault() === 'shift';
	            if (defaultIsShift) {
	                shiftKey = !shiftKey;
	            }
	            if (shiftKey) {
	                var otherCol = _this.getDisplayedColAfter(col);
	                if (!otherCol) {
	                    return;
	                }
	                var widthDiff = col.getActualWidth() - columnWidth.newWidth;
	                var otherColWidth = otherCol.getActualWidth() + widthDiff;
	                sets.push({
	                    width: otherColWidth,
	                    ratios: [1],
	                    columns: [otherCol]
	                });
	            }
	        });
	        if (sets.length === 0) {
	            return;
	        }
	        this.resizeColumnSets(sets, finished, source);
	    };
	    ColumnController.prototype.checkMinAndMaxWidthsForSet = function (columnResizeSet) {
	        var columns = columnResizeSet.columns, width = columnResizeSet.width;
	        // every col has a min width, so sum them all up and see if we have enough room
	        // for all the min widths
	        var minWidthAccumulated = 0;
	        var maxWidthAccumulated = 0;
	        var maxWidthActive = true;
	        columns.forEach(function (col) {
	            var minWidth = col.getMinWidth();
	            minWidthAccumulated += minWidth || 0;
	            var maxWidth = col.getMaxWidth();
	            if (exists(maxWidth) && maxWidth > 0) {
	                maxWidthAccumulated += maxWidth;
	            }
	            else {
	                // if at least one columns has no max width, it means the group of columns
	                // then has no max width, as at least one column can take as much width as possible
	                maxWidthActive = false;
	            }
	        });
	        var minWidthPasses = width >= minWidthAccumulated;
	        var maxWidthPasses = !maxWidthActive || (width <= maxWidthAccumulated);
	        return minWidthPasses && maxWidthPasses;
	    };
	    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
	    // be resized. this is used for example when user tries to resize a group and holds shift key,
	    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
	    // so that's two sets for this method.
	    ColumnController.prototype.resizeColumnSets = function (resizeSets, finished, source) {
	        var passMinMaxCheck = !resizeSets || resizeSets.every(this.checkMinAndMaxWidthsForSet.bind(this));
	        if (!passMinMaxCheck) {
	            // even though we are not going to resize beyond min/max size, we still need to raise event when finished
	            if (finished) {
	                var columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
	                this.fireColumnResizedEvent(columns, finished, source);
	            }
	            return; // don't resize!
	        }
	        var changedCols = [];
	        var allResizedCols = [];
	        resizeSets.forEach(function (set) {
	            var width = set.width, columns = set.columns, ratios = set.ratios;
	            // keep track of pixels used, and last column gets the remaining,
	            // to cater for rounding errors, and min width adjustments
	            var newWidths = {};
	            var finishedCols = {};
	            columns.forEach(function (col) { return allResizedCols.push(col); });
	            // the loop below goes through each col. if a col exceeds it's min/max width,
	            // it then gets set to its min/max width and the column is removed marked as 'finished'
	            // and the calculation is done again leaving this column out. take for example columns
	            // {A, width: 50, maxWidth: 100}
	            // {B, width: 50}
	            // {C, width: 50}
	            // and then the set is set to width 600 - on the first pass the grid tries to set each column
	            // to 200. it checks A and sees 200 > 100 and so sets the width to 100. col A is then marked
	            // as 'finished' and the calculation is done again with the remaining cols B and C, which end up
	            // splitting the remaining 500 pixels.
	            var finishedColsGrew = true;
	            var loopCount = 0;
	            var _loop_2 = function () {
	                loopCount++;
	                if (loopCount > 1000) {
	                    // this should never happen, but in the future, someone might introduce a bug here,
	                    // so we stop the browser from hanging and report bug properly
	                    console.error('AG Grid: infinite loop in resizeColumnSets');
	                    return "break";
	                }
	                finishedColsGrew = false;
	                var subsetCols = [];
	                var subsetRatioTotal = 0;
	                var pixelsToDistribute = width;
	                columns.forEach(function (col, index) {
	                    var thisColFinished = finishedCols[col.getId()];
	                    if (thisColFinished) {
	                        pixelsToDistribute -= newWidths[col.getId()];
	                    }
	                    else {
	                        subsetCols.push(col);
	                        var ratioThisCol = ratios[index];
	                        subsetRatioTotal += ratioThisCol;
	                    }
	                });
	                // because we are not using all of the ratios (cols can be missing),
	                // we scale the ratio. if all columns are included, then subsetRatioTotal=1,
	                // and so the ratioScale will be 1.
	                var ratioScale = 1 / subsetRatioTotal;
	                subsetCols.forEach(function (col, index) {
	                    var lastCol = index === (subsetCols.length - 1);
	                    var colNewWidth;
	                    if (lastCol) {
	                        colNewWidth = pixelsToDistribute;
	                    }
	                    else {
	                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
	                        pixelsToDistribute -= colNewWidth;
	                    }
	                    var minWidth = col.getMinWidth();
	                    var maxWidth = col.getMaxWidth();
	                    if (exists(minWidth) && colNewWidth < minWidth) {
	                        colNewWidth = minWidth;
	                        finishedCols[col.getId()] = true;
	                        finishedColsGrew = true;
	                    }
	                    else if (exists(maxWidth) && maxWidth > 0 && colNewWidth > maxWidth) {
	                        colNewWidth = maxWidth;
	                        finishedCols[col.getId()] = true;
	                        finishedColsGrew = true;
	                    }
	                    newWidths[col.getId()] = colNewWidth;
	                });
	            };
	            while (finishedColsGrew) {
	                var state_1 = _loop_2();
	                if (state_1 === "break")
	                    break;
	            }
	            columns.forEach(function (col) {
	                var newWidth = newWidths[col.getId()];
	                if (col.getActualWidth() !== newWidth) {
	                    col.setActualWidth(newWidth, source);
	                    changedCols.push(col);
	                }
	            });
	        });
	        // if no cols changed, then no need to update more or send event.
	        var atLeastOneColChanged = changedCols.length > 0;
	        var flexedCols = this.refreshFlexedColumns({ resizingCols: allResizedCols, skipSetLeft: true });
	        if (atLeastOneColChanged) {
	            this.setLeftValues(source);
	            this.updateBodyWidths();
	            this.checkViewportColumns();
	        }
	        // check for change first, to avoid unnecessary firing of events
	        // however we always fire 'finished' events. this is important
	        // when groups are resized, as if the group is changing slowly,
	        // eg 1 pixel at a time, then each change will fire change events
	        // in all the columns in the group, but only one with get the pixel.
	        var colsForEvent = allResizedCols.concat(flexedCols);
	        if (atLeastOneColChanged || finished) {
	            this.fireColumnResizedEvent(colsForEvent, finished, source, flexedCols);
	        }
	    };
	    ColumnController.prototype.setColumnAggFunc = function (key, aggFunc, source) {
	        if (source === void 0) { source = "api"; }
	        if (!key) {
	            return;
	        }
	        var column = this.getPrimaryColumn(key);
	        if (!column) {
	            return;
	        }
	        column.setAggFunc(aggFunc);
	        this.fireColumnEvent(Events.EVENT_COLUMN_VALUE_CHANGED, [column], source);
	    };
	    ColumnController.prototype.fireColumnEvent = function (type, columns, source) {
	        var event = {
	            type: type,
	            columns: columns,
	            column: (columns && columns.length == 1) ? columns[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.moveRowGroupColumn = function (fromIndex, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        var column = this.rowGroupColumns[fromIndex];
	        this.rowGroupColumns.splice(fromIndex, 1);
	        this.rowGroupColumns.splice(toIndex, 0, column);
	        var event = {
	            type: Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
	            columns: this.rowGroupColumns,
	            column: this.rowGroupColumns.length === 1 ? this.rowGroupColumns[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.moveColumns = function (columnsToMoveKeys, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
	            console.warn('AG Grid: tried to insert columns in invalid location, toIndex = ' + toIndex);
	            console.warn('AG Grid: remember that you should not count the moving columns when calculating the new index');
	            return;
	        }
	        // we want to pull all the columns out first and put them into an ordered list
	        var columnsToMove = this.getGridColumns(columnsToMoveKeys);
	        var failedRules = !this.doesMovePassRules(columnsToMove, toIndex);
	        if (failedRules) {
	            return;
	        }
	        moveInArray(this.gridColumns, columnsToMove, toIndex);
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: Events.EVENT_COLUMN_MOVED,
	            columns: columnsToMove,
	            column: columnsToMove.length === 1 ? columnsToMove[0] : null,
	            toIndex: toIndex,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	        this.columnAnimationService.finish();
	    };
	    ColumnController.prototype.doesMovePassRules = function (columnsToMove, toIndex) {
	        // make a copy of what the grid columns would look like after the move
	        var proposedColumnOrder = this.gridColumns.slice();
	        moveInArray(proposedColumnOrder, columnsToMove, toIndex);
	        // then check that the new proposed order of the columns passes all rules
	        if (!this.doesMovePassMarryChildren(proposedColumnOrder)) {
	            return false;
	        }
	        if (!this.doesMovePassLockedPositions(proposedColumnOrder)) {
	            return false;
	        }
	        return true;
	    };
	    // returns the provided cols sorted in same order as they appear in grid columns. eg if grid columns
	    // contains [a,b,c,d,e] and col passed is [e,a] then the passed cols are sorted into [a,e]
	    ColumnController.prototype.sortColumnsLikeGridColumns = function (cols) {
	        var _this = this;
	        if (!cols || cols.length <= 1) {
	            return;
	        }
	        var notAllColsInGridColumns = cols.filter(function (c) { return _this.gridColumns.indexOf(c) < 0; }).length > 0;
	        if (notAllColsInGridColumns) {
	            return;
	        }
	        cols.sort(function (a, b) {
	            var indexA = _this.gridColumns.indexOf(a);
	            var indexB = _this.gridColumns.indexOf(b);
	            return indexA - indexB;
	        });
	    };
	    ColumnController.prototype.doesMovePassLockedPositions = function (proposedColumnOrder) {
	        var foundNonLocked = false;
	        var rulePassed = true;
	        // go though the cols, see if any non-locked appear before any locked
	        proposedColumnOrder.forEach(function (col) {
	            if (col.getColDef().lockPosition) {
	                if (foundNonLocked) {
	                    rulePassed = false;
	                }
	            }
	            else {
	                foundNonLocked = true;
	            }
	        });
	        return rulePassed;
	    };
	    ColumnController.prototype.doesMovePassMarryChildren = function (allColumnsCopy) {
	        var rulePassed = true;
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (child) {
	            if (!(child instanceof OriginalColumnGroup)) {
	                return;
	            }
	            var columnGroup = child;
	            var colGroupDef = columnGroup.getColGroupDef();
	            var marryChildren = colGroupDef && colGroupDef.marryChildren;
	            if (!marryChildren) {
	                return;
	            }
	            var newIndexes = [];
	            columnGroup.getLeafColumns().forEach(function (col) {
	                var newColIndex = allColumnsCopy.indexOf(col);
	                newIndexes.push(newColIndex);
	            });
	            var maxIndex = Math.max.apply(Math, newIndexes);
	            var minIndex = Math.min.apply(Math, newIndexes);
	            // spread is how far the first column in this group is away from the last column
	            var spread = maxIndex - minIndex;
	            var maxSpread = columnGroup.getLeafColumns().length - 1;
	            // if the columns
	            if (spread > maxSpread) {
	                rulePassed = false;
	            }
	            // console.log(`maxIndex = ${maxIndex}, minIndex = ${minIndex}, spread = ${spread}, maxSpread = ${maxSpread}, fail = ${spread > (count-1)}`)
	            // console.log(allColumnsCopy.map( col => col.getColDef().field).join(','));
	        });
	        return rulePassed;
	    };
	    ColumnController.prototype.moveColumn = function (key, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        this.moveColumns([key], toIndex, source);
	    };
	    ColumnController.prototype.moveColumnByIndex = function (fromIndex, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        var column = this.gridColumns[fromIndex];
	        this.moveColumn(column, toIndex, source);
	    };
	    ColumnController.prototype.getColumnDefs = function () {
	        var _this = this;
	        var cols = this.primaryColumns.slice();
	        if (this.gridColsArePrimary) {
	            cols.sort(function (a, b) { return _this.gridColumns.indexOf(a) - _this.gridColumns.indexOf(b); });
	        }
	        else if (this.lastPrimaryOrder) {
	            cols.sort(function (a, b) { return _this.lastPrimaryOrder.indexOf(a) - _this.lastPrimaryOrder.indexOf(b); });
	        }
	        return this.columnDefFactory.buildColumnDefs(cols, this.rowGroupColumns, this.pivotColumns);
	    };
	    // used by:
	    // + angularGrid -> for setting body width
	    // + rowController -> setting main row widths (when inserting and resizing)
	    // need to cache this
	    ColumnController.prototype.getBodyContainerWidth = function () {
	        return this.bodyWidth;
	    };
	    ColumnController.prototype.getContainerWidth = function (pinned) {
	        switch (pinned) {
	            case Constants.PINNED_LEFT:
	                return this.leftWidth;
	            case Constants.PINNED_RIGHT:
	                return this.rightWidth;
	            default:
	                return this.bodyWidth;
	        }
	    };
	    // after setColumnWidth or updateGroupsAndDisplayedColumns
	    ColumnController.prototype.updateBodyWidths = function () {
	        var newBodyWidth = this.getWidthOfColsInList(this.displayedColumnsCenter);
	        var newLeftWidth = this.getWidthOfColsInList(this.displayedColumnsLeft);
	        var newRightWidth = this.getWidthOfColsInList(this.displayedColumnsRight);
	        // this is used by virtual col calculation, for RTL only, as a change to body width can impact displayed
	        // columns, due to RTL inverting the y coordinates
	        this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
	        var atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
	        if (atLeastOneChanged) {
	            this.bodyWidth = newBodyWidth;
	            this.leftWidth = newLeftWidth;
	            this.rightWidth = newRightWidth;
	            // when this fires, it is picked up by the gridPanel, which ends up in
	            // gridPanel calling setWidthAndScrollPosition(), which in turn calls setViewportPosition()
	            var event_3 = {
	                type: Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_3);
	        }
	    };
	    // + rowController
	    ColumnController.prototype.getValueColumns = function () {
	        return this.valueColumns ? this.valueColumns : [];
	    };
	    // + rowController
	    ColumnController.prototype.getPivotColumns = function () {
	        return this.pivotColumns ? this.pivotColumns : [];
	    };
	    // + clientSideRowModel
	    ColumnController.prototype.isPivotActive = function () {
	        return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
	    };
	    // + toolPanel
	    ColumnController.prototype.getRowGroupColumns = function () {
	        return this.rowGroupColumns ? this.rowGroupColumns : [];
	    };
	    // + rowController -> while inserting rows
	    ColumnController.prototype.getDisplayedCenterColumns = function () {
	        return this.displayedColumnsCenter;
	    };
	    // + rowController -> while inserting rows
	    ColumnController.prototype.getDisplayedLeftColumns = function () {
	        return this.displayedColumnsLeft;
	    };
	    ColumnController.prototype.getDisplayedRightColumns = function () {
	        return this.displayedColumnsRight;
	    };
	    ColumnController.prototype.getDisplayedColumns = function (type) {
	        switch (type) {
	            case Constants.PINNED_LEFT:
	                return this.getDisplayedLeftColumns();
	            case Constants.PINNED_RIGHT:
	                return this.getDisplayedRightColumns();
	            default:
	                return this.getDisplayedCenterColumns();
	        }
	    };
	    // used by:
	    // + clientSideRowController -> sorting, building quick filter text
	    // + headerRenderer -> sorting (clearing icon)
	    ColumnController.prototype.getAllPrimaryColumns = function () {
	        return this.primaryColumns ? this.primaryColumns.slice() : null;
	    };
	    ColumnController.prototype.getSecondaryColumns = function () {
	        return this.secondaryColumns ? this.secondaryColumns.slice() : null;
	    };
	    ColumnController.prototype.getAllColumnsForQuickFilter = function () {
	        return this.columnsForQuickFilter;
	    };
	    // + moveColumnController
	    ColumnController.prototype.getAllGridColumns = function () {
	        return this.gridColumns;
	    };
	    ColumnController.prototype.isEmpty = function () {
	        return missingOrEmpty(this.gridColumns);
	    };
	    ColumnController.prototype.isRowGroupEmpty = function () {
	        return missingOrEmpty(this.rowGroupColumns);
	    };
	    ColumnController.prototype.setColumnVisible = function (key, visible, source) {
	        if (source === void 0) { source = "api"; }
	        this.setColumnsVisible([key], visible, source);
	    };
	    ColumnController.prototype.setColumnsVisible = function (keys, visible, source) {
	        var _this = this;
	        if (visible === void 0) { visible = false; }
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        this.actionOnGridColumns(keys, function (column) {
	            if (column.isVisible() !== visible) {
	                column.setVisible(visible, source);
	                return true;
	            }
	            return false;
	        }, source, function () {
	            var event = {
	                type: Events.EVENT_COLUMN_VISIBLE,
	                visible: visible,
	                column: null,
	                columns: null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            return event;
	        });
	        this.columnAnimationService.finish();
	    };
	    ColumnController.prototype.setColumnPinned = function (key, pinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.setColumnsPinned([key], pinned, source);
	        }
	    };
	    ColumnController.prototype.setColumnsPinned = function (keys, pinned, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        if (this.gridOptionsWrapper.getDomLayout() === 'print') {
	            console.warn("Changing the column pinning status is not allowed with domLayout='print'");
	            return;
	        }
	        this.columnAnimationService.start();
	        var actualPinned;
	        if (pinned === true || pinned === Constants.PINNED_LEFT) {
	            actualPinned = Constants.PINNED_LEFT;
	        }
	        else if (pinned === Constants.PINNED_RIGHT) {
	            actualPinned = Constants.PINNED_RIGHT;
	        }
	        else {
	            actualPinned = null;
	        }
	        this.actionOnGridColumns(keys, function (col) {
	            if (col.getPinned() !== actualPinned) {
	                col.setPinned(actualPinned);
	                return true;
	            }
	            return false;
	        }, source, function () {
	            var event = {
	                type: Events.EVENT_COLUMN_PINNED,
	                pinned: actualPinned,
	                column: null,
	                columns: null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            return event;
	        });
	        this.columnAnimationService.finish();
	    };
	    // does an action on a set of columns. provides common functionality for looking up the
	    // columns based on key, getting a list of effected columns, and then updated the event
	    // with either one column (if it was just one col) or a list of columns
	    // used by: autoResize, setVisible, setPinned
	    ColumnController.prototype.actionOnGridColumns = function (// the column keys this action will be on
	    keys, 
	    // the action to do - if this returns false, the column was skipped
	    // and won't be included in the event
	    action, 
	    // should return back a column event of the right type
	    source, createEvent) {
	        var _this = this;
	        if (missingOrEmpty(keys)) {
	            return;
	        }
	        var updatedColumns = [];
	        keys.forEach(function (key) {
	            var column = _this.getGridColumn(key);
	            if (!column) {
	                return;
	            }
	            // need to check for false with type (ie !== instead of !=)
	            // as not returning anything (undefined) would also be false
	            var resultOfAction = action(column);
	            if (resultOfAction !== false) {
	                updatedColumns.push(column);
	            }
	        });
	        if (!updatedColumns.length) {
	            return;
	        }
	        this.updateDisplayedColumns(source);
	        if (exists(createEvent) && createEvent) {
	            var event_4 = createEvent();
	            event_4.columns = updatedColumns;
	            event_4.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
	            this.eventService.dispatchEvent(event_4);
	        }
	    };
	    ColumnController.prototype.getDisplayedColBefore = function (col) {
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        var oldIndex = allDisplayedColumns.indexOf(col);
	        if (oldIndex > 0) {
	            return allDisplayedColumns[oldIndex - 1];
	        }
	        return null;
	    };
	    // used by:
	    // + rowRenderer -> for navigation
	    ColumnController.prototype.getDisplayedColAfter = function (col) {
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        var oldIndex = allDisplayedColumns.indexOf(col);
	        if (oldIndex < (allDisplayedColumns.length - 1)) {
	            return allDisplayedColumns[oldIndex + 1];
	        }
	        return null;
	    };
	    ColumnController.prototype.getDisplayedGroupAfter = function (columnGroup) {
	        return this.getDisplayedGroupAtDirection(columnGroup, 'After');
	    };
	    ColumnController.prototype.getDisplayedGroupBefore = function (columnGroup) {
	        return this.getDisplayedGroupAtDirection(columnGroup, 'Before');
	    };
	    ColumnController.prototype.getDisplayedGroupAtDirection = function (columnGroup, direction) {
	        // pick the last displayed column in this group
	        var requiredLevel = columnGroup.getOriginalColumnGroup().getLevel() + columnGroup.getPaddingLevel();
	        var colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
	        var col = direction === 'After' ? last(colGroupLeafColumns) : colGroupLeafColumns[0];
	        var getDisplayColMethod = "getDisplayedCol" + direction;
	        while (true) {
	            // keep moving to the next col, until we get to another group
	            var column = this[getDisplayColMethod](col);
	            if (!column) {
	                return null;
	            }
	            var groupPointer = this.getColumnGroupAtLevel(column, requiredLevel);
	            if (groupPointer !== columnGroup) {
	                return groupPointer;
	            }
	        }
	    };
	    ColumnController.prototype.getColumnGroupAtLevel = function (column, level) {
	        // get group at same level as the one we are looking for
	        var groupPointer = column.getParent();
	        var originalGroupLevel;
	        var groupPointerLevel;
	        while (true) {
	            var groupPointerOriginalColumnGroup = groupPointer.getOriginalColumnGroup();
	            originalGroupLevel = groupPointerOriginalColumnGroup.getLevel();
	            groupPointerLevel = groupPointer.getPaddingLevel();
	            if (originalGroupLevel + groupPointerLevel <= level) {
	                break;
	            }
	            groupPointer = groupPointer.getParent();
	        }
	        return groupPointer;
	    };
	    ColumnController.prototype.isPinningLeft = function () {
	        return this.displayedColumnsLeft.length > 0;
	    };
	    ColumnController.prototype.isPinningRight = function () {
	        return this.displayedColumnsRight.length > 0;
	    };
	    ColumnController.prototype.getPrimaryAndSecondaryAndAutoColumns = function () {
	        var result = this.primaryColumns ? this.primaryColumns.slice(0) : [];
	        if (this.groupAutoColumns && exists(this.groupAutoColumns)) {
	            this.groupAutoColumns.forEach(function (col) { return result.push(col); });
	        }
	        if (this.secondaryColumnsPresent && this.secondaryColumns) {
	            this.secondaryColumns.forEach(function (column) { return result.push(column); });
	        }
	        return result;
	    };
	    ColumnController.prototype.createStateItemFromColumn = function (column) {
	        var rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
	        var pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
	        var aggFunc = column.isValueActive() ? column.getAggFunc() : null;
	        var sort = column.getSort() != null ? column.getSort() : null;
	        var sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
	        var flex = column.getFlex() != null && column.getFlex() > 0 ? column.getFlex() : null;
	        var res = {
	            colId: column.getColId(),
	            width: column.getActualWidth(),
	            hide: !column.isVisible(),
	            pinned: column.getPinned(),
	            sort: sort,
	            sortIndex: sortIndex,
	            aggFunc: aggFunc,
	            rowGroup: column.isRowGroupActive(),
	            rowGroupIndex: rowGroupIndex,
	            pivot: column.isPivotActive(),
	            pivotIndex: pivotIndex,
	            flex: flex
	        };
	        return res;
	    };
	    ColumnController.prototype.getColumnState = function () {
	        if (missing(this.primaryColumns) || !this.isAlive()) {
	            return [];
	        }
	        var primaryColumnState = this.primaryColumns.map(this.createStateItemFromColumn.bind(this));
	        var groupAutoColumnState = this.groupAutoColumns
	            // if groupAutoCols, then include them
	            ? this.groupAutoColumns.map(this.createStateItemFromColumn.bind(this))
	            // otherwise no
	            : [];
	        var columnStateList = groupAutoColumnState.concat(primaryColumnState);
	        if (!this.pivotMode) {
	            this.orderColumnStateList(columnStateList);
	        }
	        return columnStateList;
	    };
	    ColumnController.prototype.orderColumnStateList = function (columnStateList) {
	        // for fast looking, store the index of each column
	        var gridColumnIdMap = convertToMap(this.gridColumns.map(function (col, index) { return [col.getColId(), index]; }));
	        columnStateList.sort(function (itemA, itemB) {
	            var posA = gridColumnIdMap.has(itemA.colId) ? gridColumnIdMap.get(itemA.colId) : -1;
	            var posB = gridColumnIdMap.has(itemB.colId) ? gridColumnIdMap.get(itemB.colId) : -1;
	            return posA - posB;
	        });
	    };
	    ColumnController.prototype.resetColumnState = function (source) {
	        // NOTE = there is one bug here that no customer has noticed - if a column has colDef.lockPosition,
	        // this is ignored  below when ordering the cols. to work, we should always put lockPosition cols first.
	        // As a work around, developers should just put lockPosition columns first in their colDef list.
	        if (source === void 0) { source = "api"; }
	        // we can't use 'allColumns' as the order might of messed up, so get the primary ordered list
	        var primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
	        var columnStates = [];
	        // we start at 1000, so if user has mix of rowGroup and group specified, it will work with both.
	        // eg IF user has ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=true,
	        // THEN result will be ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=1000
	        var letRowGroupIndex = 1000;
	        var letPivotIndex = 1000;
	        var colsToProcess = [];
	        if (this.groupAutoColumns) {
	            colsToProcess = colsToProcess.concat(this.groupAutoColumns);
	        }
	        if (primaryColumns) {
	            colsToProcess = colsToProcess.concat(primaryColumns);
	        }
	        colsToProcess.forEach(function (column) {
	            var colDef = column.getColDef();
	            var sort = colDef.sort != null ? colDef.sort : null;
	            var sortIndex = colDef.sortIndex;
	            var hide = colDef.hide ? true : false;
	            var pinned = colDef.pinned ? colDef.pinned : null;
	            var width = colDef.width;
	            var flex = colDef.flex != null ? colDef.flex : null;
	            var rowGroupIndex = colDef.rowGroupIndex;
	            var rowGroup = colDef.rowGroup;
	            if (rowGroupIndex == null && (rowGroup == null || rowGroup == false)) {
	                rowGroupIndex = null;
	                rowGroup = null;
	            }
	            var pivotIndex = colDef.pivotIndex;
	            var pivot = colDef.pivot;
	            if (pivotIndex == null && (pivot == null || pivot == false)) {
	                pivotIndex = null;
	                pivot = null;
	            }
	            var aggFunc = colDef.aggFunc != null ? colDef.aggFunc : null;
	            var stateItem = {
	                colId: column.getColId(),
	                sort: sort,
	                sortIndex: sortIndex,
	                hide: hide,
	                pinned: pinned,
	                width: width,
	                flex: flex,
	                rowGroup: rowGroup,
	                rowGroupIndex: rowGroupIndex,
	                pivot: pivot,
	                pivotIndex: pivotIndex,
	                aggFunc: aggFunc,
	            };
	            if (missing(rowGroupIndex) && rowGroup) {
	                stateItem.rowGroupIndex = letRowGroupIndex++;
	            }
	            if (missing(pivotIndex) && pivot) {
	                stateItem.pivotIndex = letPivotIndex++;
	            }
	            columnStates.push(stateItem);
	        });
	        this.applyColumnState({ state: columnStates, applyOrder: true }, source);
	    };
	    ColumnController.prototype.applyColumnState = function (params, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        if (missingOrEmpty(this.primaryColumns)) {
	            return false;
	        }
	        if (params && params.state && !params.state.forEach) {
	            console.warn('AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.');
	            return false;
	        }
	        this.columnAnimationService.start();
	        var raiseEventsFunc = this.compareColumnStatesAndRaiseEvents(source);
	        this.autoGroupsNeedBuilding = true;
	        // at the end below, this list will have all columns we got no state for
	        var columnsWithNoState = this.primaryColumns.slice();
	        var success = true;
	        var rowGroupIndexes = {};
	        var pivotIndexes = {};
	        var autoGroupColumnStates = [];
	        var previousRowGroupCols = this.rowGroupColumns.slice();
	        var previousPivotCols = this.pivotColumns.slice();
	        if (params.state) {
	            params.state.forEach(function (state) {
	                var groupAutoColumnId = Constants.GROUP_AUTO_COLUMN_ID;
	                var colId = state.colId || '';
	                // auto group columns are re-created so deferring syncing with ColumnState
	                var isAutoGroupColumn = startsWith(colId, groupAutoColumnId);
	                if (isAutoGroupColumn) {
	                    autoGroupColumnStates.push(state);
	                    return;
	                }
	                var column = _this.getPrimaryColumn(colId);
	                if (!column) {
	                    // we don't log the failure, as it's possible the user is applying that has extra
	                    // cols in it. for example they could of save while row-grouping (so state includes
	                    // auto-group column) and then applied state when not grouping (so the auto-group
	                    // column would be in the state but no used).
	                    success = false;
	                }
	                else {
	                    _this.syncColumnWithStateItem(column, state, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
	                    removeFromArray(columnsWithNoState, column);
	                }
	            });
	        }
	        // anything left over, we got no data for, so add in the column as non-value, non-rowGroup and hidden
	        var applyDefaultsFunc = function (col) {
	            return _this.syncColumnWithStateItem(col, null, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
	        };
	        columnsWithNoState.forEach(applyDefaultsFunc);
	        // sort the lists according to the indexes that were provided
	        var comparator = function (indexes, oldList, colA, colB) {
	            var indexA = indexes[colA.getId()];
	            var indexB = indexes[colB.getId()];
	            var aHasIndex = indexA != null;
	            var bHasIndex = indexB != null;
	            if (aHasIndex && bHasIndex) {
	                // both a and b are new cols with index, so sort on index
	                return indexA - indexB;
	            }
	            if (aHasIndex) {
	                // a has an index, so it should be before a
	                return -1;
	            }
	            if (bHasIndex) {
	                // b has an index, so it should be before a
	                return 1;
	            }
	            var oldIndexA = oldList.indexOf(colA);
	            var oldIndexB = oldList.indexOf(colB);
	            var aHasOldIndex = oldIndexA >= 0;
	            var bHasOldIndex = oldIndexB >= 0;
	            if (aHasOldIndex && bHasOldIndex) {
	                // both a and b are old cols, so sort based on last order
	                return oldIndexA - oldIndexB;
	            }
	            if (aHasOldIndex) {
	                // a is old, b is new, so b is first
	                return -1;
	            }
	            // this bit does matter, means both are new cols
	            // but without index or that b is old and a is new
	            return 1;
	        };
	        this.rowGroupColumns.sort(comparator.bind(this, rowGroupIndexes, previousRowGroupCols));
	        this.pivotColumns.sort(comparator.bind(this, pivotIndexes, previousPivotCols));
	        this.updateGridColumns();
	        // sync newly created auto group columns with ColumnState
	        var autoGroupColsCopy = this.groupAutoColumns ? this.groupAutoColumns.slice() : [];
	        autoGroupColumnStates.forEach(function (stateItem) {
	            var autoCol = _this.getAutoColumn(stateItem.colId);
	            removeFromArray(autoGroupColsCopy, autoCol);
	            _this.syncColumnWithStateItem(autoCol, stateItem, params.defaultState, null, null, true, source);
	        });
	        // autogroup cols with nothing else, apply the default
	        autoGroupColsCopy.forEach(applyDefaultsFunc);
	        this.applyOrderAfterApplyState(params);
	        this.updateDisplayedColumns(source);
	        this.dispatchEverythingChanged(source);
	        raiseEventsFunc();
	        this.columnAnimationService.finish();
	        return success;
	    };
	    ColumnController.prototype.applyOrderAfterApplyState = function (params) {
	        if (!this.gridColsArePrimary || !params.applyOrder || !params.state) {
	            return;
	        }
	        var newOrder = [];
	        var processedColIds = {};
	        var gridColumnsMap = {};
	        this.gridColumns.forEach(function (col) { return gridColumnsMap[col.getId()] = col; });
	        params.state.forEach(function (item) {
	            if (!item.colId || processedColIds[item.colId]) {
	                return;
	            }
	            var col = gridColumnsMap[item.colId];
	            if (col) {
	                newOrder.push(col);
	                processedColIds[item.colId] = true;
	            }
	        });
	        // add in all other columns
	        this.gridColumns.forEach(function (col) {
	            if (!processedColIds[col.getColId()]) {
	                newOrder.push(col);
	            }
	        });
	        // this is already done in updateGridColumns, however we changed the order above (to match the order of the state
	        // columns) so we need to do it again. we could of put logic into the order above to take into account fixed
	        // columns, however if we did then we would have logic for updating fixed columns twice. reusing the logic here
	        // is less sexy for the code here, but it keeps consistency.
	        newOrder = this.putFixedColumnsFirst(newOrder);
	        if (!this.doesMovePassMarryChildren(newOrder)) {
	            console.warn('AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.');
	            return;
	        }
	        this.gridColumns = newOrder;
	    };
	    ColumnController.prototype.compareColumnStatesAndRaiseEvents = function (source) {
	        var _this = this;
	        // if no columns to begin with, then it means we are setting columns for the first time, so
	        // there should be no events fired to show differences in columns.
	        var colsPreviouslyExisted = !!this.columnDefs;
	        if (!colsPreviouslyExisted) {
	            return function () { };
	        }
	        var startState = {
	            rowGroupColumns: this.rowGroupColumns.slice(),
	            pivotColumns: this.pivotColumns.slice(),
	            valueColumns: this.valueColumns.slice()
	        };
	        var columnStateBefore = this.getColumnState();
	        var columnStateBeforeMap = {};
	        columnStateBefore.forEach(function (col) {
	            columnStateBeforeMap[col.colId] = col;
	        });
	        return function () {
	            if (_this.gridOptionsWrapper.isSuppressColumnStateEvents()) {
	                return;
	            }
	            // raises generic ColumnEvents where all columns are returned rather than what has changed
	            var raiseWhenListsDifferent = function (eventType, colsBefore, colsAfter, idMapper) {
	                var beforeList = colsBefore.map(idMapper).sort();
	                var afterList = colsAfter.map(idMapper).sort();
	                var unchanged = areEqual(beforeList, afterList);
	                if (unchanged) {
	                    return;
	                }
	                // returning all columns rather than what has changed!
	                var event = {
	                    type: eventType,
	                    columns: colsAfter,
	                    column: colsAfter.length === 1 ? colsAfter[0] : null,
	                    api: _this.gridApi,
	                    columnApi: _this.columnApi,
	                    source: source
	                };
	                _this.eventService.dispatchEvent(event);
	            };
	            // determines which columns have changed according to supplied predicate
	            var getChangedColumns = function (changedPredicate) {
	                var changedColumns = [];
	                _this.gridColumns.forEach(function (column) {
	                    var colStateBefore = columnStateBeforeMap[column.getColId()];
	                    if (colStateBefore && changedPredicate(colStateBefore, column)) {
	                        changedColumns.push(column);
	                    }
	                });
	                return changedColumns;
	            };
	            var columnIdMapper = function (c) { return c.getColId(); };
	            raiseWhenListsDifferent(Events.EVENT_COLUMN_ROW_GROUP_CHANGED, startState.rowGroupColumns, _this.rowGroupColumns, columnIdMapper);
	            raiseWhenListsDifferent(Events.EVENT_COLUMN_PIVOT_CHANGED, startState.pivotColumns, _this.pivotColumns, columnIdMapper);
	            var valueChangePredicate = function (cs, c) {
	                var oldActive = cs.aggFunc != null;
	                var activeChanged = oldActive != c.isValueActive();
	                // we only check aggFunc if the agg is active
	                var aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
	                return activeChanged || aggFuncChanged;
	            };
	            var changedValues = getChangedColumns(valueChangePredicate);
	            if (changedValues.length > 0) {
	                // we pass all value columns, now the ones that changed. this is the same
	                // as pivot and rowGroup cols, but different to all other properties below.
	                // this is more for backwards compatibility, as it's always been this way.
	                // really it should be the other way, as the order of the cols makes no difference
	                // for valueColumns (apart from displaying them in the tool panel).
	                _this.fireColumnEvent(Events.EVENT_COLUMN_VALUE_CHANGED, _this.valueColumns, source);
	            }
	            var resizeChangePredicate = function (cs, c) { return cs.width != c.getActualWidth(); };
	            _this.fireColumnResizedEvent(getChangedColumns(resizeChangePredicate), true, source);
	            var pinnedChangePredicate = function (cs, c) { return cs.pinned != c.getPinned(); };
	            _this.raiseColumnPinnedEvent(getChangedColumns(pinnedChangePredicate), source);
	            var visibilityChangePredicate = function (cs, c) { return cs.hide == c.isVisible(); };
	            _this.raiseColumnVisibleEvent(getChangedColumns(visibilityChangePredicate), source);
	            var sortChangePredicate = function (cs, c) { return cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex(); };
	            if (getChangedColumns(sortChangePredicate).length > 0) {
	                _this.sortController.dispatchSortChangedEvents();
	            }
	            // special handling for moved column events
	            _this.raiseColumnMovedEvent(columnStateBefore, source);
	        };
	    };
	    ColumnController.prototype.raiseColumnPinnedEvent = function (changedColumns, source) {
	        if (!changedColumns.length) {
	            return;
	        }
	        // if just one column, we use this, otherwise we don't include the col
	        var column = changedColumns.length === 1 ? changedColumns[0] : null;
	        // only include visible if it's common in all columns
	        var pinned = this.getCommonValue(changedColumns, function (col) { return col.getPinned(); });
	        var event = {
	            type: Events.EVENT_COLUMN_PINNED,
	            // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
	            pinned: pinned != null ? pinned : null,
	            columns: changedColumns,
	            column: column,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.getCommonValue = function (cols, valueGetter) {
	        if (!cols || cols.length == 0) {
	            return undefined;
	        }
	        // compare each value to the first value. if nothing differs, then value is common so return it.
	        var firstValue = valueGetter(cols[0]);
	        for (var i = 1; i < cols.length; i++) {
	            if (firstValue !== valueGetter(cols[i])) {
	                // values differ, no common value
	                return undefined;
	            }
	        }
	        return firstValue;
	    };
	    ColumnController.prototype.raiseColumnVisibleEvent = function (changedColumns, source) {
	        if (!changedColumns.length) {
	            return;
	        }
	        // if just one column, we use this, otherwise we don't include the col
	        var column = changedColumns.length === 1 ? changedColumns[0] : null;
	        // only include visible if it's common in all columns
	        var visible = this.getCommonValue(changedColumns, function (col) { return col.isVisible(); });
	        var event = {
	            type: Events.EVENT_COLUMN_VISIBLE,
	            visible: visible,
	            columns: changedColumns,
	            column: column,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.raiseColumnMovedEvent = function (colStateBefore, source) {
	        // we are only interested in columns that were both present and visible before and after
	        var _this = this;
	        var colStateAfter = this.getColumnState();
	        var colStateAfterMapped = {};
	        colStateAfter.forEach(function (s) { return colStateAfterMapped[s.colId] = s; });
	        // get id's of cols in both before and after lists
	        var colsIntersectIds = {};
	        colStateBefore.forEach(function (s) {
	            if (colStateAfterMapped[s.colId]) {
	                colsIntersectIds[s.colId] = true;
	            }
	        });
	        // filter state lists, so we only have cols that were present before and after
	        var beforeFiltered = filter(colStateBefore, function (c) { return colsIntersectIds[c.colId]; });
	        var afterFiltered = filter(colStateAfter, function (c) { return colsIntersectIds[c.colId]; });
	        // see if any cols are in a different location
	        var movedColumns = [];
	        afterFiltered.forEach(function (csAfter, index) {
	            var csBefore = beforeFiltered && beforeFiltered[index];
	            if (csBefore && csBefore.colId !== csAfter.colId) {
	                var gridCol = _this.getGridColumn(csBefore.colId);
	                if (gridCol) {
	                    movedColumns.push(gridCol);
	                }
	            }
	        });
	        if (!movedColumns.length) {
	            return;
	        }
	        var event = {
	            type: Events.EVENT_COLUMN_MOVED,
	            columns: movedColumns,
	            column: null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.syncColumnWithStateItem = function (column, stateItem, defaultState, rowGroupIndexes, pivotIndexes, autoCol, source) {
	        if (!column) {
	            return;
	        }
	        var getValue = function (key1, key2) {
	            var stateAny = stateItem;
	            var defaultAny = defaultState;
	            var obj = { value1: undefined, value2: undefined };
	            var calculated = false;
	            if (stateAny) {
	                if (stateAny[key1] !== undefined) {
	                    obj.value1 = stateAny[key1];
	                    calculated = true;
	                }
	                if (exists(key2) && stateAny[key2] !== undefined) {
	                    obj.value2 = stateAny[key2];
	                    calculated = true;
	                }
	            }
	            if (!calculated && defaultAny) {
	                if (defaultAny[key1] !== undefined) {
	                    obj.value1 = defaultAny[key1];
	                }
	                if (exists(key2) && defaultAny[key2] !== undefined) {
	                    obj.value2 = defaultAny[key2];
	                }
	            }
	            return obj;
	        };
	        // following ensures we are left with boolean true or false, eg converts (null, undefined, 0) all to true
	        var hide = getValue('hide').value1;
	        if (hide !== undefined) {
	            column.setVisible(!hide, source);
	        }
	        // sets pinned to 'left' or 'right'
	        var pinned = getValue('pinned').value1;
	        if (pinned !== undefined) {
	            column.setPinned(pinned);
	        }
	        // if width provided and valid, use it, otherwise stick with the old width
	        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
	        // flex
	        var flex = getValue('flex').value1;
	        if (flex !== undefined) {
	            column.setFlex(flex);
	        }
	        // width - we only set width if column is not flexing
	        var noFlexThisCol = column.getFlex() <= 0;
	        if (noFlexThisCol) {
	            // both null and undefined means we skip, as it's not possible to 'clear' width (a column must have a width)
	            var width = getValue('width').value1;
	            if (width != null) {
	                if (minColWidth &&
	                    (width >= minColWidth)) {
	                    column.setActualWidth(width, source);
	                }
	            }
	        }
	        var sort = getValue('sort').value1;
	        if (sort !== undefined) {
	            if (sort === Constants.SORT_DESC || sort === Constants.SORT_ASC) {
	                column.setSort(sort);
	            }
	            else {
	                column.setSort(undefined);
	            }
	        }
	        var sortIndex = getValue('sortIndex').value1;
	        if (sortIndex !== undefined) {
	            column.setSortIndex(sortIndex);
	        }
	        // we do not do aggFunc, rowGroup or pivot for auto cols, as you can't do these with auto col
	        if (autoCol) {
	            return;
	        }
	        var aggFunc = getValue('aggFunc').value1;
	        if (aggFunc !== undefined) {
	            if (typeof aggFunc === 'string') {
	                column.setAggFunc(aggFunc);
	                if (!column.isValueActive()) {
	                    column.setValueActive(true, source);
	                    this.valueColumns.push(column);
	                }
	            }
	            else {
	                if (exists(aggFunc)) {
	                    console.warn('AG Grid: stateItem.aggFunc must be a string. if using your own aggregation ' +
	                        'functions, register the functions first before using them in get/set state. This is because it is ' +
	                        'intended for the column state to be stored and retrieved as simple JSON.');
	                }
	                column.setAggFunc(null);
	                if (column.isValueActive()) {
	                    column.setValueActive(false, source);
	                    removeFromArray(this.valueColumns, column);
	                }
	            }
	        }
	        var _a = getValue('rowGroup', 'rowGroupIndex'), rowGroup = _a.value1, rowGroupIndex = _a.value2;
	        if (rowGroup !== undefined || rowGroupIndex !== undefined) {
	            if (typeof rowGroupIndex === 'number' || rowGroup) {
	                if (!column.isRowGroupActive()) {
	                    column.setRowGroupActive(true, source);
	                    this.rowGroupColumns.push(column);
	                }
	                if (rowGroupIndexes && typeof rowGroupIndex === 'number') {
	                    rowGroupIndexes[column.getId()] = rowGroupIndex;
	                }
	            }
	            else {
	                if (column.isRowGroupActive()) {
	                    column.setRowGroupActive(false, source);
	                    removeFromArray(this.rowGroupColumns, column);
	                }
	            }
	        }
	        var _b = getValue('pivot', 'pivotIndex'), pivot = _b.value1, pivotIndex = _b.value2;
	        if (pivot !== undefined || pivotIndex !== undefined) {
	            if (typeof pivotIndex === 'number' || pivot) {
	                if (!column.isPivotActive()) {
	                    column.setPivotActive(true, source);
	                    this.pivotColumns.push(column);
	                }
	                if (pivotIndexes && typeof pivotIndex === 'number') {
	                    pivotIndexes[column.getId()] = pivotIndex;
	                }
	            }
	            else {
	                if (column.isPivotActive()) {
	                    column.setPivotActive(false, source);
	                    removeFromArray(this.pivotColumns, column);
	                }
	            }
	        }
	    };
	    ColumnController.prototype.getGridColumns = function (keys) {
	        return this.getColumns(keys, this.getGridColumn.bind(this));
	    };
	    ColumnController.prototype.getColumns = function (keys, columnLookupCallback) {
	        var foundColumns = [];
	        if (keys) {
	            keys.forEach(function (key) {
	                var column = columnLookupCallback(key);
	                if (column) {
	                    foundColumns.push(column);
	                }
	            });
	        }
	        return foundColumns;
	    };
	    // used by growGroupPanel
	    ColumnController.prototype.getColumnWithValidation = function (key) {
	        if (key == null) {
	            return null;
	        }
	        var column = this.getGridColumn(key);
	        if (!column) {
	            console.warn('AG Grid: could not find column ' + key);
	        }
	        return column;
	    };
	    ColumnController.prototype.getPrimaryColumn = function (key) {
	        return this.getColumn(key, this.primaryColumns, this.primaryColumnsMap);
	    };
	    ColumnController.prototype.getGridColumn = function (key) {
	        return this.getColumn(key, this.gridColumns, this.gridColumnsMap);
	    };
	    ColumnController.prototype.getColumn = function (key, columnList, columnMap) {
	        if (!key) {
	            return null;
	        }
	        // most of the time this method gets called the key is a string, so we put this shortcut in
	        // for performance reasons, to see if we can match for ID (it doesn't do auto columns, that's done below)
	        if (typeof key == 'string' && columnMap[key]) {
	            return columnMap[key];
	        }
	        for (var i = 0; i < columnList.length; i++) {
	            if (this.columnsMatch(columnList[i], key)) {
	                return columnList[i];
	            }
	        }
	        return this.getAutoColumn(key);
	    };
	    ColumnController.prototype.getAutoColumn = function (key) {
	        var _this = this;
	        if (!this.groupAutoColumns ||
	            !exists(this.groupAutoColumns) ||
	            missing(this.groupAutoColumns)) {
	            return null;
	        }
	        return find(this.groupAutoColumns, function (groupCol) { return _this.columnsMatch(groupCol, key); });
	    };
	    ColumnController.prototype.columnsMatch = function (column, key) {
	        var columnMatches = column === key;
	        var colDefMatches = column.getColDef() === key;
	        var idMatches = column.getColId() == key;
	        return columnMatches || colDefMatches || idMatches;
	    };
	    ColumnController.prototype.getDisplayNameForColumn = function (column, location, includeAggFunc) {
	        if (includeAggFunc === void 0) { includeAggFunc = false; }
	        if (!column) {
	            return null;
	        }
	        var headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
	        if (includeAggFunc) {
	            return this.wrapHeaderNameWithAggFunc(column, headerName);
	        }
	        return headerName;
	    };
	    ColumnController.prototype.getDisplayNameForOriginalColumnGroup = function (columnGroup, originalColumnGroup, location) {
	        var colGroupDef = originalColumnGroup ? originalColumnGroup.getColGroupDef() : null;
	        if (colGroupDef) {
	            return this.getHeaderName(colGroupDef, null, columnGroup, originalColumnGroup, location);
	        }
	        return null;
	    };
	    ColumnController.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) {
	        return this.getDisplayNameForOriginalColumnGroup(columnGroup, columnGroup.getOriginalColumnGroup(), location);
	    };
	    // location is where the column is going to appear, ie who is calling us
	    ColumnController.prototype.getHeaderName = function (colDef, column, columnGroup, originalColumnGroup, location) {
	        var headerValueGetter = colDef.headerValueGetter;
	        if (headerValueGetter) {
	            var params = {
	                colDef: colDef,
	                column: column,
	                columnGroup: columnGroup,
	                originalColumnGroup: originalColumnGroup,
	                location: location,
	                api: this.gridOptionsWrapper.getApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            if (typeof headerValueGetter === 'function') {
	                // valueGetter is a function, so just call it
	                return headerValueGetter(params);
	            }
	            else if (typeof headerValueGetter === 'string') {
	                // valueGetter is an expression, so execute the expression
	                return this.expressionService.evaluate(headerValueGetter, params);
	            }
	            console.warn('ag-grid: headerValueGetter must be a function or a string');
	            return '';
	        }
	        else if (colDef.headerName != null) {
	            return colDef.headerName;
	        }
	        else if (colDef.field) {
	            return camelCaseToHumanText(colDef.field);
	        }
	        return '';
	    };
	    /*
	        private getHeaderGroupName(columnGroup: ColumnGroup): string {
	            let colGroupDef = columnGroup.getOriginalColumnGroup().getColGroupDef();
	            let headerValueGetter = colGroupDef.headerValueGetter;

	            if (headerValueGetter) {
	                let params = {
	                    columnGroup: columnGroup,
	                    colDef: colGroupDef,
	                    api: this.gridOptionsWrapper.getApi(),
	                    context: this.gridOptionsWrapper.getContext()
	                };

	                if (typeof headerValueGetter === 'function') {
	                    // valueGetter is a function, so just call it
	                    return headerValueGetter(params);
	                } else if (typeof headerValueGetter === 'string') {
	                    // valueGetter is an expression, so execute the expression
	                    return this.expressionService.evaluate(headerValueGetter, params);
	                } else {
	                    console.warn('ag-grid: headerValueGetter must be a function or a string');
	                    return '';
	                }
	            } else {
	                return colGroupDef.headerName;
	            }
	        }
	    */
	    ColumnController.prototype.wrapHeaderNameWithAggFunc = function (column, headerName) {
	        if (this.gridOptionsWrapper.isSuppressAggFuncInHeader()) {
	            return headerName;
	        }
	        // only columns with aggregation active can have aggregations
	        var pivotValueColumn = column.getColDef().pivotValueColumn;
	        var pivotActiveOnThisColumn = exists(pivotValueColumn);
	        var aggFunc = null;
	        var aggFuncFound;
	        // otherwise we have a measure that is active, and we are doing aggregation on it
	        if (pivotActiveOnThisColumn) {
	            aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
	            aggFuncFound = true;
	        }
	        else {
	            var measureActive = column.isValueActive();
	            var aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
	            if (measureActive && aggregationPresent) {
	                aggFunc = column.getAggFunc();
	                aggFuncFound = true;
	            }
	            else {
	                aggFuncFound = false;
	            }
	        }
	        if (aggFuncFound) {
	            var aggFuncString = (typeof aggFunc === 'string') ? aggFunc : 'func';
	            var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	            var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
	            return aggFuncStringTranslated + "(" + headerName + ")";
	        }
	        return headerName;
	    };
	    // returns the group with matching colId and instanceId. If instanceId is missing,
	    // matches only on the colId.
	    ColumnController.prototype.getColumnGroup = function (colId, instanceId) {
	        if (!colId) {
	            return null;
	        }
	        if (colId instanceof ColumnGroup) {
	            return colId;
	        }
	        var allColumnGroups = this.getAllDisplayedTrees();
	        var checkInstanceId = typeof instanceId === 'number';
	        var result = null;
	        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
	            if (child instanceof ColumnGroup) {
	                var columnGroup = child;
	                var matched = void 0;
	                if (checkInstanceId) {
	                    matched = colId === columnGroup.getGroupId() && instanceId === columnGroup.getInstanceId();
	                }
	                else {
	                    matched = colId === columnGroup.getGroupId();
	                }
	                if (matched) {
	                    result = columnGroup;
	                }
	            }
	        });
	        return result;
	    };
	    ColumnController.prototype.isReady = function () {
	        return this.ready;
	    };
	    ColumnController.prototype.extractValueColumns = function (source, oldPrimaryColumns) {
	        this.valueColumns = this.extractColumns(oldPrimaryColumns, this.valueColumns, function (col, flag) { return col.setValueActive(flag, source); }, 
	        // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
	        function () { return undefined; }, function () { return undefined; }, 
	        // aggFunc is a string, so return it's existence
	        function (colDef) {
	            var aggFunc = colDef.aggFunc;
	            // null or empty string means clear
	            if (aggFunc === null || aggFunc === '') {
	                return null;
	            }
	            if (aggFunc === undefined) {
	                return;
	            }
	            return !!aggFunc;
	        }, function (colDef) {
	            // return false if any of the following: null, undefined, empty string
	            return colDef.initialAggFunc != null && colDef.initialAggFunc != '';
	        });
	        // all new columns added will have aggFunc missing, so set it to what is in the colDef
	        this.valueColumns.forEach(function (col) {
	            var colDef = col.getColDef();
	            // if aggFunc provided, we always override, as reactive property
	            if (colDef.aggFunc != null && colDef.aggFunc != '') {
	                col.setAggFunc(colDef.aggFunc);
	            }
	            else {
	                // otherwise we use initialAggFunc only if no agg func set - which happens when new column only
	                if (!col.getAggFunc()) {
	                    col.setAggFunc(colDef.initialAggFunc);
	                }
	            }
	        });
	    };
	    ColumnController.prototype.extractRowGroupColumns = function (source, oldPrimaryColumns) {
	        this.rowGroupColumns = this.extractColumns(oldPrimaryColumns, this.rowGroupColumns, function (col, flag) { return col.setRowGroupActive(flag, source); }, function (colDef) { return colDef.rowGroupIndex; }, function (colDef) { return colDef.initialRowGroupIndex; }, function (colDef) { return colDef.rowGroup; }, function (colDef) { return colDef.initialRowGroup; });
	    };
	    ColumnController.prototype.extractColumns = function (oldPrimaryColumns, previousCols, setFlagFunc, getIndexFunc, getInitialIndexFunc, getValueFunc, getInitialValueFunc) {
	        if (oldPrimaryColumns === void 0) { oldPrimaryColumns = []; }
	        if (previousCols === void 0) { previousCols = []; }
	        var colsWithIndex = [];
	        var colsWithValue = [];
	        // go though all cols.
	        // if value, change
	        // if default only, change only if new
	        this.primaryColumns.forEach(function (col) {
	            var colIsNew = oldPrimaryColumns.indexOf(col) < 0;
	            var colDef = col.getColDef();
	            var value = attrToBoolean(getValueFunc(colDef));
	            var initialValue = attrToBoolean(getInitialValueFunc(colDef));
	            var index = attrToNumber(getIndexFunc(colDef));
	            var initialIndex = attrToNumber(getInitialIndexFunc(colDef));
	            var include;
	            if (colIsNew) {
	                // col is new, use values if present, otherwise use default values if present
	                var valuePresent = value !== undefined || index !== undefined;
	                if (valuePresent) {
	                    if (value !== undefined) {
	                        // if boolean value present, we take it's value, even if 'false'
	                        include = value;
	                    }
	                    else {
	                        // otherwise we based on number value. note that 'null' resets, however 'undefined' doesn't
	                        // go through this code path (undefined means 'ignore').
	                        include = index >= 0;
	                    }
	                }
	                else {
	                    include = initialValue || initialIndex >= 0;
	                }
	            }
	            else {
	                // col is not new, we ignore the default values, just use the values if provided
	                if (value !== undefined) { // value is never null, as attrToBoolean converts null to false
	                    include = value;
	                }
	                else if (index !== undefined) {
	                    if (index === null) {
	                        include = false;
	                    }
	                    else {
	                        include = index >= 0;
	                    }
	                }
	                else {
	                    // no values provided, we include if it was included last time
	                    include = previousCols.indexOf(col) >= 0;
	                }
	            }
	            if (include) {
	                var useIndex = colIsNew ? (index != null || initialIndex != null) : index != null;
	                if (useIndex) {
	                    colsWithIndex.push(col);
	                }
	                else {
	                    colsWithValue.push(col);
	                }
	            }
	        });
	        var getIndexForCol = function (col) {
	            var index = getIndexFunc(col.getColDef());
	            var defaultIndex = getInitialIndexFunc(col.getColDef());
	            return index != null ? index : defaultIndex;
	        };
	        // sort cols with index, and add these first
	        colsWithIndex.sort(function (colA, colB) {
	            var indexA = getIndexForCol(colA);
	            var indexB = getIndexForCol(colB);
	            if (indexA === indexB) {
	                return 0;
	            }
	            if (indexA < indexB) {
	                return -1;
	            }
	            return 1;
	        });
	        var res = [].concat(colsWithIndex);
	        // second add columns that were there before and in the same order as they were before,
	        // so we are preserving order of current grouping of columns that simply have rowGroup=true
	        previousCols.forEach(function (col) {
	            if (colsWithValue.indexOf(col) >= 0) {
	                res.push(col);
	            }
	        });
	        // lastly put in all remaining cols
	        colsWithValue.forEach(function (col) {
	            if (res.indexOf(col) < 0) {
	                res.push(col);
	            }
	        });
	        // set flag=false for removed cols
	        previousCols.forEach(function (col) {
	            if (res.indexOf(col) < 0) {
	                setFlagFunc(col, false);
	            }
	        });
	        // set flag=true for newly added cols
	        res.forEach(function (col) {
	            if (previousCols.indexOf(col) < 0) {
	                setFlagFunc(col, true);
	            }
	        });
	        return res;
	    };
	    ColumnController.prototype.extractPivotColumns = function (source, oldPrimaryColumns) {
	        this.pivotColumns = this.extractColumns(oldPrimaryColumns, this.pivotColumns, function (col, flag) { return col.setPivotActive(flag, source); }, function (colDef) { return colDef.pivotIndex; }, function (colDef) { return colDef.initialPivotIndex; }, function (colDef) { return colDef.pivot; }, function (colDef) { return colDef.initialPivot; });
	    };
	    ColumnController.prototype.resetColumnGroupState = function (source) {
	        if (source === void 0) { source = "api"; }
	        var stateItems = [];
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.primaryColumnTree, function (child) {
	            if (child instanceof OriginalColumnGroup) {
	                var colGroupDef = child.getColGroupDef();
	                var groupState = {
	                    groupId: child.getGroupId(),
	                    open: !colGroupDef ? undefined : colGroupDef.openByDefault
	                };
	                stateItems.push(groupState);
	            }
	        });
	        this.setColumnGroupState(stateItems, source);
	    };
	    ColumnController.prototype.getColumnGroupState = function () {
	        var columnGroupState = [];
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
	            if (node instanceof OriginalColumnGroup) {
	                var originalColumnGroup = node;
	                columnGroupState.push({
	                    groupId: originalColumnGroup.getGroupId(),
	                    open: originalColumnGroup.isExpanded()
	                });
	            }
	        });
	        return columnGroupState;
	    };
	    ColumnController.prototype.setColumnGroupState = function (stateItems, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        var impactedGroups = [];
	        stateItems.forEach(function (stateItem) {
	            var groupKey = stateItem.groupId;
	            var newValue = stateItem.open;
	            var originalColumnGroup = _this.getOriginalColumnGroup(groupKey);
	            if (!originalColumnGroup) {
	                return;
	            }
	            if (originalColumnGroup.isExpanded() === newValue) {
	                return;
	            }
	            _this.logger.log('columnGroupOpened(' + originalColumnGroup.getGroupId() + ',' + newValue + ')');
	            originalColumnGroup.setExpanded(newValue);
	            impactedGroups.push(originalColumnGroup);
	        });
	        this.updateGroupsAndDisplayedColumns(source);
	        this.setFirstRightAndLastLeftPinned(source);
	        impactedGroups.forEach(function (originalColumnGroup) {
	            var event = {
	                type: Events.EVENT_COLUMN_GROUP_OPENED,
	                columnGroup: originalColumnGroup,
	                api: _this.gridApi,
	                columnApi: _this.columnApi
	            };
	            _this.eventService.dispatchEvent(event);
	        });
	        this.columnAnimationService.finish();
	    };
	    // called by headerRenderer - when a header is opened or closed
	    ColumnController.prototype.setColumnGroupOpened = function (key, newValue, source) {
	        if (source === void 0) { source = "api"; }
	        var keyAsString;
	        if (key instanceof OriginalColumnGroup) {
	            keyAsString = key.getId();
	        }
	        else {
	            keyAsString = key || '';
	        }
	        this.setColumnGroupState([{ groupId: keyAsString, open: newValue }], source);
	    };
	    ColumnController.prototype.getOriginalColumnGroup = function (key) {
	        if (key instanceof OriginalColumnGroup) {
	            return key;
	        }
	        if (typeof key !== 'string') {
	            console.error('AG Grid: group key must be a string');
	        }
	        // otherwise, search for the column group by id
	        var res = null;
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
	            if (node instanceof OriginalColumnGroup) {
	                var originalColumnGroup = node;
	                if (originalColumnGroup.getId() === key) {
	                    res = originalColumnGroup;
	                }
	            }
	        });
	        return res;
	    };
	    ColumnController.prototype.calculateColumnsForDisplay = function () {
	        var _this = this;
	        var columnsForDisplay;
	        if (this.pivotMode && !this.secondaryColumnsPresent) {
	            // pivot mode is on, but we are not pivoting, so we only
	            // show columns we are aggregating on
	            columnsForDisplay = this.gridColumns.filter(function (column) {
	                var isAutoGroupCol = _this.groupAutoColumns && includes(_this.groupAutoColumns, column);
	                var isValueCol = _this.valueColumns && includes(_this.valueColumns, column);
	                return isAutoGroupCol || isValueCol;
	            });
	        }
	        else {
	            // otherwise continue as normal. this can be working on the primary
	            // or secondary columns, whatever the gridColumns are set to
	            columnsForDisplay = this.gridColumns.filter(function (column) {
	                // keep col if a) it's auto-group or b) it's visible
	                var isAutoGroupCol = _this.groupAutoColumns && includes(_this.groupAutoColumns, column);
	                return isAutoGroupCol || column.isVisible();
	            });
	        }
	        return columnsForDisplay;
	    };
	    ColumnController.prototype.checkColSpanActiveInCols = function (columns) {
	        var result = false;
	        columns.forEach(function (col) {
	            if (exists(col.getColDef().colSpan)) {
	                result = true;
	            }
	        });
	        return result;
	    };
	    ColumnController.prototype.calculateColumnsForGroupDisplay = function () {
	        var _this = this;
	        this.groupDisplayColumns = [];
	        var checkFunc = function (col) {
	            var colDef = col.getColDef();
	            if (colDef && exists(colDef.showRowGroup)) {
	                _this.groupDisplayColumns.push(col);
	            }
	        };
	        this.gridColumns.forEach(checkFunc);
	        if (this.groupAutoColumns) {
	            this.groupAutoColumns.forEach(checkFunc);
	        }
	    };
	    ColumnController.prototype.getGroupDisplayColumns = function () {
	        return this.groupDisplayColumns;
	    };
	    ColumnController.prototype.updateDisplayedColumns = function (source) {
	        var columnsForDisplay = this.calculateColumnsForDisplay();
	        this.buildDisplayedTrees(columnsForDisplay);
	        this.calculateColumnsForGroupDisplay();
	        // also called when group opened/closed
	        this.updateGroupsAndDisplayedColumns(source);
	        // also called when group opened/closed
	        this.setFirstRightAndLastLeftPinned(source);
	    };
	    ColumnController.prototype.isSecondaryColumnsPresent = function () {
	        return this.secondaryColumnsPresent;
	    };
	    ColumnController.prototype.setSecondaryColumns = function (colDefs, source) {
	        if (source === void 0) { source = "api"; }
	        var newColsPresent = colDefs && colDefs.length > 0;
	        // if not cols passed, and we had to cols anyway, then do nothing
	        if (!newColsPresent && !this.secondaryColumnsPresent) {
	            return;
	        }
	        if (newColsPresent) {
	            this.processSecondaryColumnDefinitions(colDefs);
	            var balancedTreeResult = this.columnFactory.createColumnTree(colDefs, false);
	            this.secondaryBalancedTree = balancedTreeResult.columnTree;
	            this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
	            this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
	            this.secondaryColumnsPresent = true;
	        }
	        else {
	            this.secondaryBalancedTree = null;
	            this.secondaryHeaderRowCount = -1;
	            this.secondaryColumns = null;
	            this.secondaryColumnsPresent = false;
	        }
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	    };
	    ColumnController.prototype.processSecondaryColumnDefinitions = function (colDefs) {
	        var columnCallback = this.gridOptionsWrapper.getProcessSecondaryColDefFunc();
	        var groupCallback = this.gridOptionsWrapper.getProcessSecondaryColGroupDefFunc();
	        if (!columnCallback && !groupCallback) {
	            return undefined;
	        }
	        var searchForColDefs = function (colDefs2) {
	            colDefs2.forEach(function (abstractColDef) {
	                var isGroup = exists(abstractColDef.children);
	                if (isGroup) {
	                    var colGroupDef = abstractColDef;
	                    if (groupCallback) {
	                        groupCallback(colGroupDef);
	                    }
	                    searchForColDefs(colGroupDef.children);
	                }
	                else {
	                    var colDef = abstractColDef;
	                    if (columnCallback) {
	                        columnCallback(colDef);
	                    }
	                }
	            });
	        };
	        if (colDefs) {
	            searchForColDefs(colDefs);
	        }
	    };
	    // called from: setColumnState, setColumnDefs, setSecondaryColumns
	    ColumnController.prototype.updateGridColumns = function () {
	        var _this = this;
	        if (this.gridColsArePrimary) {
	            this.lastPrimaryOrder = this.gridColumns;
	        }
	        if (this.secondaryColumns && this.secondaryBalancedTree) {
	            this.gridBalancedTree = this.secondaryBalancedTree.slice();
	            this.gridHeaderRowCount = this.secondaryHeaderRowCount;
	            this.gridColumns = this.secondaryColumns.slice();
	            this.gridColsArePrimary = false;
	        }
	        else {
	            this.gridBalancedTree = this.primaryColumnTree.slice();
	            this.gridHeaderRowCount = this.primaryHeaderRowCount;
	            this.gridColumns = this.primaryColumns.slice();
	            this.gridColsArePrimary = true;
	            // updateGridColumns gets called after user adds a row group. we want to maintain the order of the columns
	            // when this happens (eg if user moved a column) rather than revert back to the original column order.
	            // likewise if changing in/out of pivot mode, we want to maintain the order of the primary cols
	            this.orderGridColsLikeLastPrimary();
	        }
	        this.addAutoGroupToGridColumns();
	        this.autoRowHeightColumns = this.gridColumns.filter(function (col) { return col.getColDef().autoHeight; });
	        this.gridColumns = this.putFixedColumnsFirst(this.gridColumns);
	        this.setupQuickFilterColumns();
	        this.clearDisplayedAndViewportColumns();
	        this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
	        this.gridColumnsMap = {};
	        this.gridColumns.forEach(function (col) { return _this.gridColumnsMap[col.getId()] = col; });
	        var event = {
	            type: Events.EVENT_GRID_COLUMNS_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.orderGridColsLikeLastPrimary = function () {
	        if (missing(this.lastPrimaryOrder)) {
	            return;
	        }
	        var lastPrimaryOrderMapped = convertToMap(this.lastPrimaryOrder.map(function (col, index) { return [col, index]; }));
	        // only do the sort if at least one column is accounted for. columns will be not accounted for
	        // if changing from secondary to primary columns
	        var noColsFound = true;
	        this.gridColumns.forEach(function (col) {
	            if (lastPrimaryOrderMapped.has(col)) {
	                noColsFound = false;
	            }
	        });
	        if (noColsFound) {
	            return;
	        }
	        // order cols in the same order as before. we need to make sure that all
	        // cols still exists, so filter out any that no longer exist.
	        var gridColsMap = convertToMap(this.gridColumns.map(function (col) { return [col, true]; }));
	        var oldColsOrdered = this.lastPrimaryOrder.filter(function (col) { return gridColsMap.has(col); });
	        var oldColsMap = convertToMap(oldColsOrdered.map(function (col) { return [col, true]; }));
	        var newColsOrdered = this.gridColumns.filter(function (col) { return !oldColsMap.has(col); });
	        // add in the new columns, at the end (if no group), or at the end of the group (if a group)
	        var newGridColumns = oldColsOrdered.slice();
	        newColsOrdered.forEach(function (newCol) {
	            var parent = newCol.getOriginalParent();
	            // if no parent, means we are not grouping, so just add the column to the end
	            if (!parent) {
	                newGridColumns.push(newCol);
	                return;
	            }
	            // find the group the column belongs to. if no siblings at the current level (eg col in group on it's
	            // own) then go up one level and look for siblings there.
	            var siblings = [];
	            while (!siblings.length && parent) {
	                var leafCols = parent.getLeafColumns();
	                leafCols.forEach(function (leafCol) {
	                    var presentInNewGriColumns = newGridColumns.indexOf(leafCol) >= 0;
	                    var noYetInSiblings = siblings.indexOf(leafCol) < 0;
	                    if (presentInNewGriColumns && noYetInSiblings) {
	                        siblings.push(leafCol);
	                    }
	                });
	                parent = parent.getOriginalParent();
	            }
	            // if no siblings exist at any level, this means the col is in a group (or parent groups) on it's own
	            if (!siblings.length) {
	                newGridColumns.push(newCol);
	                return;
	            }
	            // find index of last column in the group
	            var indexes = siblings.map(function (col) { return newGridColumns.indexOf(col); });
	            var lastIndex = Math.max.apply(Math, indexes);
	            insertIntoArray(newGridColumns, newCol, lastIndex + 1);
	        });
	        this.gridColumns = newGridColumns;
	    };
	    ColumnController.prototype.isPrimaryColumnGroupsPresent = function () {
	        return this.primaryHeaderRowCount > 1;
	    };
	    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
	    // following scenarios:
	    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
	    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
	    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
	    ColumnController.prototype.setupQuickFilterColumns = function () {
	        if (this.groupAutoColumns) {
	            this.columnsForQuickFilter = this.primaryColumns.concat(this.groupAutoColumns);
	        }
	        else {
	            this.columnsForQuickFilter = this.primaryColumns;
	        }
	    };
	    ColumnController.prototype.putFixedColumnsFirst = function (cols) {
	        var locked = cols.filter(function (c) { return c.getColDef().lockPosition; });
	        var unlocked = cols.filter(function (c) { return !c.getColDef().lockPosition; });
	        return locked.concat(unlocked);
	    };
	    ColumnController.prototype.addAutoGroupToGridColumns = function () {
	        // add in auto-group here
	        this.createGroupAutoColumnsIfNeeded();
	        if (missing(this.groupAutoColumns)) {
	            return;
	        }
	        this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
	        var autoColBalancedTree = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
	        this.gridBalancedTree = autoColBalancedTree.concat(this.gridBalancedTree);
	    };
	    // gets called after we copy down grid columns, to make sure any part of the gui
	    // that tries to draw, eg the header, it will get empty lists of columns rather
	    // than stale columns. for example, the header will received gridColumnsChanged
	    // event, so will try and draw, but it will draw successfully when it acts on the
	    // virtualColumnsChanged event
	    ColumnController.prototype.clearDisplayedAndViewportColumns = function () {
	        this.displayedTreeLeft = [];
	        this.displayedTreeRight = [];
	        this.displayedTreeCentre = [];
	        this.viewportRowLeft = {};
	        this.viewportRowRight = {};
	        this.viewportRowCenter = {};
	        this.displayedColumnsLeft = [];
	        this.displayedColumnsRight = [];
	        this.displayedColumnsCenter = [];
	        this.displayedColumns = [];
	        this.viewportColumns = [];
	    };
	    ColumnController.prototype.updateGroupsAndDisplayedColumns = function (source) {
	        this.updateOpenClosedVisibilityInColumnGroups();
	        this.deriveDisplayedColumns(source);
	        this.refreshFlexedColumns();
	        this.extractViewport();
	        this.updateBodyWidths();
	        // this event is picked up by the gui, headerRenderer and rowRenderer, to recalculate what columns to display
	        var event = {
	            type: Events.EVENT_DISPLAYED_COLUMNS_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.deriveDisplayedColumns = function (source) {
	        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft);
	        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter);
	        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight);
	        this.joinDisplayedColumns();
	        this.setLeftValues(source);
	    };
	    ColumnController.prototype.joinDisplayedColumns = function () {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            this.displayedColumns = this.displayedColumnsRight
	                .concat(this.displayedColumnsCenter)
	                .concat(this.displayedColumnsLeft);
	        }
	        else {
	            this.displayedColumns = this.displayedColumnsLeft
	                .concat(this.displayedColumnsCenter)
	                .concat(this.displayedColumnsRight);
	        }
	    };
	    // sets the left pixel position of each column
	    ColumnController.prototype.setLeftValues = function (source) {
	        this.setLeftValuesOfColumns(source);
	        this.setLeftValuesOfGroups();
	    };
	    ColumnController.prototype.setLeftValuesOfColumns = function (source) {
	        var _this = this;
	        // go through each list of displayed columns
	        var allColumns = this.primaryColumns.slice(0);
	        // let totalColumnWidth = this.getWidthOfColsInList()
	        var doingRtl = this.gridOptionsWrapper.isEnableRtl();
	        [
	            this.displayedColumnsLeft,
	            this.displayedColumnsRight,
	            this.displayedColumnsCenter
	        ].forEach(function (columns) {
	            if (doingRtl) {
	                // when doing RTL, we start at the top most pixel (ie RHS) and work backwards
	                var left_1 = _this.getWidthOfColsInList(columns);
	                columns.forEach(function (column) {
	                    left_1 -= column.getActualWidth();
	                    column.setLeft(left_1, source);
	                });
	            }
	            else {
	                // otherwise normal LTR, we start at zero
	                var left_2 = 0;
	                columns.forEach(function (column) {
	                    column.setLeft(left_2, source);
	                    left_2 += column.getActualWidth();
	                });
	            }
	            removeAllFromArray(allColumns, columns);
	        });
	        // items left in allColumns are columns not displayed, so remove the left position. this is
	        // important for the rows, as if a col is made visible, then taken out, then made visible again,
	        // we don't want the animation of the cell floating in from the old position, whatever that was.
	        allColumns.forEach(function (column) {
	            column.setLeft(null, source);
	        });
	    };
	    ColumnController.prototype.setLeftValuesOfGroups = function () {
	        // a groups left value is the lest left value of it's children
	        [
	            this.displayedTreeLeft,
	            this.displayedTreeRight,
	            this.displayedTreeCentre
	        ].forEach(function (columns) {
	            columns.forEach(function (column) {
	                if (column instanceof ColumnGroup) {
	                    var columnGroup = column;
	                    columnGroup.checkLeft();
	                }
	            });
	        });
	    };
	    ColumnController.prototype.derivedDisplayedColumnsFromDisplayedTree = function (tree, columns) {
	        columns.length = 0;
	        this.columnUtils.depthFirstDisplayedColumnTreeSearch(tree, function (child) {
	            if (child instanceof Column) {
	                columns.push(child);
	            }
	        });
	    };
	    ColumnController.prototype.extractViewportColumns = function () {
	        if (this.suppressColumnVirtualisation) {
	            // no virtualisation, so don't filter
	            this.viewportColumnsCenter = this.displayedColumnsCenter;
	        }
	        else {
	            // filter out what should be visible
	            this.viewportColumnsCenter = this.filterOutColumnsWithinViewport();
	        }
	        this.viewportColumns = this.viewportColumnsCenter
	            .concat(this.displayedColumnsLeft)
	            .concat(this.displayedColumnsRight);
	    };
	    ColumnController.prototype.getVirtualHeaderGroupRow = function (type, dept) {
	        var result;
	        switch (type) {
	            case Constants.PINNED_LEFT:
	                result = this.viewportRowLeft[dept];
	                break;
	            case Constants.PINNED_RIGHT:
	                result = this.viewportRowRight[dept];
	                break;
	            default:
	                result = this.viewportRowCenter[dept];
	                break;
	        }
	        if (missing(result)) {
	            result = [];
	        }
	        return result;
	    };
	    ColumnController.prototype.extractViewportRows = function () {
	        // go through each group, see if any of it's cols are displayed, and if yes,
	        // then this group is included
	        this.viewportRowLeft = {};
	        this.viewportRowRight = {};
	        this.viewportRowCenter = {};
	        // for easy lookup when building the groups.
	        var virtualColIds = {};
	        this.viewportColumns.forEach(function (col) { return virtualColIds[col.getId()] = true; });
	        var testGroup = function (children, result, dept) {
	            var returnValue = false;
	            for (var i = 0; i < children.length; i++) {
	                // see if this item is within viewport
	                var child = children[i];
	                var addThisItem = false;
	                if (child instanceof Column) {
	                    // for column, test if column is included
	                    addThisItem = virtualColIds[child.getId()] === true;
	                }
	                else {
	                    // if group, base decision on children
	                    var columnGroup = child;
	                    var displayedChildren = columnGroup.getDisplayedChildren();
	                    if (displayedChildren) {
	                        addThisItem = testGroup(displayedChildren, result, dept + 1);
	                    }
	                }
	                if (addThisItem) {
	                    returnValue = true;
	                    if (!result[dept]) {
	                        result[dept] = [];
	                    }
	                    result[dept].push(child);
	                }
	            }
	            return returnValue;
	        };
	        testGroup(this.displayedTreeLeft, this.viewportRowLeft, 0);
	        testGroup(this.displayedTreeRight, this.viewportRowRight, 0);
	        testGroup(this.displayedTreeCentre, this.viewportRowCenter, 0);
	    };
	    ColumnController.prototype.extractViewport = function () {
	        this.extractViewportColumns();
	        this.extractViewportRows();
	    };
	    ColumnController.prototype.filterOutColumnsWithinViewport = function () {
	        return this.displayedColumnsCenter.filter(this.isColumnInViewport.bind(this));
	    };
	    ColumnController.prototype.refreshFlexedColumns = function (params) {
	        var _this = this;
	        if (params === void 0) { params = {}; }
	        var source = params.source ? params.source : 'flex';
	        if (params.viewportWidth != null) {
	            this.flexViewportWidth = params.viewportWidth;
	        }
	        if (!this.flexViewportWidth) {
	            return [];
	        }
	        // If the grid has left-over space, divide it between flexing columns in proportion to their flex value.
	        // A "flexing column" is one that has a 'flex' value set and is not currently being constrained by its
	        // minWidth or maxWidth rules.
	        var flexAfterDisplayIndex = -1;
	        if (params.resizingCols) {
	            params.resizingCols.forEach(function (col) {
	                var indexOfCol = _this.displayedColumnsCenter.indexOf(col);
	                if (flexAfterDisplayIndex < indexOfCol) {
	                    flexAfterDisplayIndex = indexOfCol;
	                }
	            });
	        }
	        var isColFlex = function (col) {
	            var afterResizingCols = _this.displayedColumnsCenter.indexOf(col) > flexAfterDisplayIndex;
	            return col.getFlex() && afterResizingCols;
	        };
	        var knownWidthColumns = this.displayedColumnsCenter.filter(function (col) { return !isColFlex(col); });
	        var flexingColumns = this.displayedColumnsCenter.filter(function (col) { return isColFlex(col); });
	        var changedColumns = [];
	        if (!flexingColumns.length) {
	            return [];
	        }
	        var flexingColumnSizes = [];
	        var spaceForFlexingColumns;
	        outer: while (true) {
	            var totalFlex = flexingColumns.reduce(function (count, col) { return count + col.getFlex(); }, 0);
	            spaceForFlexingColumns = this.flexViewportWidth - this.getWidthOfColsInList(knownWidthColumns);
	            for (var i = 0; i < flexingColumns.length; i++) {
	                var col = flexingColumns[i];
	                var widthByFlexRule = spaceForFlexingColumns * col.getFlex() / totalFlex;
	                var constrainedWidth = 0;
	                var minWidth = col.getMinWidth();
	                var maxWidth = col.getMaxWidth();
	                if (exists(minWidth) && widthByFlexRule < minWidth) {
	                    constrainedWidth = minWidth;
	                }
	                else if (exists(maxWidth) && widthByFlexRule > maxWidth) {
	                    constrainedWidth = maxWidth;
	                }
	                if (constrainedWidth) {
	                    // This column is not in fact flexing as it is being constrained to a specific size
	                    // so remove it from the list of flexing columns and start again
	                    col.setActualWidth(constrainedWidth, source);
	                    removeFromArray(flexingColumns, col);
	                    changedColumns.push(col);
	                    knownWidthColumns.push(col);
	                    continue outer;
	                }
	                flexingColumnSizes[i] = Math.round(widthByFlexRule);
	            }
	            break;
	        }
	        var remainingSpace = spaceForFlexingColumns;
	        flexingColumns.forEach(function (col, i) {
	            col.setActualWidth(Math.min(flexingColumnSizes[i], remainingSpace), source);
	            changedColumns.push(col);
	            remainingSpace -= flexingColumnSizes[i];
	        });
	        if (!params.skipSetLeft) {
	            this.setLeftValues(source);
	        }
	        if (params.updateBodyWidths) {
	            this.updateBodyWidths();
	        }
	        if (params.fireResizedEvent) {
	            this.fireColumnResizedEvent(changedColumns, true, source, flexingColumns);
	        }
	        // if the user sets rowData directly into GridOptions, then the row data is set before
	        // grid is attached to the DOM. this means the columns are not flexed, and then the rows
	        // have the wrong height (as they depend on column widths). so once the columns have
	        // been flexed for the first time (only happens once grid is attached to DOM, as dependency
	        // on getting the grid width, which only happens after attached after ResizeObserver fires)
	        // we get get rows to re-calc their heights.
	        if (!this.flexColsCalculatedAtLestOnce) {
	            if (this.gridOptionsWrapper.isRowModelDefault()) {
	                this.rowModel.resetRowHeights();
	            }
	            this.flexColsCalculatedAtLestOnce = true;
	        }
	        return flexingColumns;
	    };
	    // called from api
	    ColumnController.prototype.sizeColumnsToFit = function (gridWidth, source, silent) {
	        if (source === void 0) { source = "sizeColumnsToFit"; }
	        // avoid divide by zero
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        if (gridWidth <= 0 || !allDisplayedColumns.length) {
	            return;
	        }
	        var colsToSpread = [];
	        var colsToNotSpread = [];
	        allDisplayedColumns.forEach(function (column) {
	            if (column.getColDef().suppressSizeToFit === true) {
	                colsToNotSpread.push(column);
	            }
	            else {
	                colsToSpread.push(column);
	            }
	        });
	        // make a copy of the cols that are going to be resized
	        var colsToFireEventFor = colsToSpread.slice(0);
	        var finishedResizing = false;
	        var moveToNotSpread = function (column) {
	            removeFromArray(colsToSpread, column);
	            colsToNotSpread.push(column);
	        };
	        // resetting cols to their original width makes the sizeColumnsToFit more deterministic,
	        // rather than depending on the current size of the columns. most users call sizeColumnsToFit
	        // immediately after grid is created, so will make no difference. however if application is calling
	        // sizeColumnsToFit repeatedly (eg after column group is opened / closed repeatedly) we don't want
	        // the columns to start shrinking / growing over time.
	        //
	        // NOTE: the process below will assign values to `this.actualWidth` of each column without firing events
	        // for this reason we need to manually fire resize events after the resize has been done for each column.
	        colsToSpread.forEach(function (column) { return column.resetActualWidth(source); });
	        while (!finishedResizing) {
	            finishedResizing = true;
	            var availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
	            if (availablePixels <= 0) {
	                // no width, set everything to minimum
	                colsToSpread.forEach(function (column) {
	                    column.setMinimum(source);
	                });
	            }
	            else {
	                var scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
	                // we set the pixels for the last col based on what's left, as otherwise
	                // we could be a pixel or two short or extra because of rounding errors.
	                var pixelsForLastCol = availablePixels;
	                // backwards through loop, as we are removing items as we go
	                for (var i = colsToSpread.length - 1; i >= 0; i--) {
	                    var column = colsToSpread[i];
	                    var minWidth = column.getMinWidth();
	                    var maxWidth = column.getMaxWidth();
	                    var newWidth = Math.round(column.getActualWidth() * scale);
	                    if (exists(minWidth) && newWidth < minWidth) {
	                        newWidth = minWidth;
	                        moveToNotSpread(column);
	                        finishedResizing = false;
	                    }
	                    else if (exists(maxWidth) && column.isGreaterThanMax(newWidth)) {
	                        newWidth = maxWidth;
	                        moveToNotSpread(column);
	                        finishedResizing = false;
	                    }
	                    else if (i === 0) { // if this is the last column
	                        newWidth = pixelsForLastCol;
	                    }
	                    column.setActualWidth(newWidth, source, true);
	                    pixelsForLastCol -= newWidth;
	                }
	            }
	        }
	        // see notes above
	        colsToFireEventFor.forEach(function (col) {
	            col.fireColumnWidthChangedEvent(source);
	        });
	        this.setLeftValues(source);
	        this.updateBodyWidths();
	        if (silent) {
	            return;
	        }
	        this.fireColumnResizedEvent(colsToFireEventFor, true, source);
	    };
	    ColumnController.prototype.buildDisplayedTrees = function (visibleColumns) {
	        var leftVisibleColumns = [];
	        var rightVisibleColumns = [];
	        var centerVisibleColumns = [];
	        visibleColumns.forEach(function (column) {
	            switch (column.getPinned()) {
	                case "left":
	                    leftVisibleColumns.push(column);
	                    break;
	                case "right":
	                    rightVisibleColumns.push(column);
	                    break;
	                default:
	                    centerVisibleColumns.push(column);
	                    break;
	            }
	        });
	        var groupInstanceIdCreator = new GroupInstanceIdCreator();
	        this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, Constants.PINNED_LEFT, this.displayedTreeLeft);
	        this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, Constants.PINNED_RIGHT, this.displayedTreeRight);
	        this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, null, this.displayedTreeCentre);
	        this.updateDisplayedMap();
	    };
	    ColumnController.prototype.updateDisplayedMap = function () {
	        var _this = this;
	        this.displayedColumnsAndGroupsMap = {};
	        var func = function (child) {
	            _this.displayedColumnsAndGroupsMap[child.getUniqueId()] = child;
	        };
	        this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeCentre, func);
	        this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeLeft, func);
	        this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeRight, func);
	    };
	    ColumnController.prototype.isDisplayed = function (item) {
	        var fromMap = this.displayedColumnsAndGroupsMap[item.getUniqueId()];
	        // check for reference, in case new column / group with same id is now present
	        return fromMap === item;
	    };
	    ColumnController.prototype.updateOpenClosedVisibilityInColumnGroups = function () {
	        var allColumnGroups = this.getAllDisplayedTrees();
	        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
	            if (child instanceof ColumnGroup) {
	                var columnGroup = child;
	                columnGroup.calculateDisplayedColumns();
	            }
	        });
	    };
	    ColumnController.prototype.getGroupAutoColumns = function () {
	        return this.groupAutoColumns;
	    };
	    ColumnController.prototype.createGroupAutoColumnsIfNeeded = function () {
	        if (!this.autoGroupsNeedBuilding) {
	            return;
	        }
	        this.autoGroupsNeedBuilding = false;
	        var groupFullWidthRow = this.gridOptionsWrapper.isGroupUseEntireRow(this.pivotMode);
	        // we need to allow suppressing auto-column separately for group and pivot as the normal situation
	        // is CSRM and user provides group column themselves for normal view, but when they go into pivot the
	        // columns are generated by the grid so no opportunity for user to provide group column. so need a way
	        // to suppress auto-col for grouping only, and not pivot.
	        // however if using Viewport RM or SSRM and user is providing the columns, the user may wish full control
	        // of the group column in this instance.
	        var suppressAutoColumn = this.pivotMode ?
	            this.gridOptionsWrapper.isPivotSuppressAutoColumn() : this.gridOptionsWrapper.isGroupSuppressAutoColumn();
	        var groupingActive = this.rowGroupColumns.length > 0 || this.usingTreeData;
	        var needAutoColumns = groupingActive && !suppressAutoColumn && !groupFullWidthRow;
	        if (needAutoColumns) {
	            var newAutoGroupCols = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
	            var autoColsDifferent = !this.autoColsEqual(newAutoGroupCols, this.groupAutoColumns);
	            // we force recreate when suppressColumnStateEvents changes, so new group cols pick up the new
	            // definitions. otherwise we could ignore the new cols because they appear to be the same.
	            if (autoColsDifferent || this.forceRecreateAutoGroups) {
	                this.groupAutoColumns = newAutoGroupCols;
	            }
	        }
	        else {
	            this.groupAutoColumns = null;
	        }
	    };
	    ColumnController.prototype.autoColsEqual = function (colsA, colsB) {
	        return areEqual(colsA, colsB, function (a, b) { return a.getColId() === b.getColId(); });
	    };
	    ColumnController.prototype.getWidthOfColsInList = function (columnList) {
	        return columnList.reduce(function (width, col) { return width + col.getActualWidth(); }, 0);
	    };
	    ColumnController.prototype.getGridBalancedTree = function () {
	        return this.gridBalancedTree;
	    };
	    ColumnController.prototype.hasFloatingFilters = function () {
	        if (!this.gridColumns) {
	            return false;
	        }
	        var res = this.gridColumns.some(function (col) { return col.getColDef().floatingFilter; });
	        return res;
	    };
	    ColumnController.prototype.getFirstDisplayedColumn = function () {
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        var queryOrder = [
	            'getDisplayedLeftColumns',
	            'getDisplayedCenterColumns',
	            'getDisplayedRightColumns'
	        ];
	        if (isRtl) {
	            queryOrder.reverse();
	        }
	        for (var i = 0; i < queryOrder.length; i++) {
	            var container = this[queryOrder[i]]();
	            if (container.length) {
	                return isRtl ? last(container) : container[0];
	            }
	        }
	        return null;
	    };
	    __decorate$5([
	        Autowired('expressionService')
	    ], ColumnController.prototype, "expressionService", void 0);
	    __decorate$5([
	        Autowired('columnFactory')
	    ], ColumnController.prototype, "columnFactory", void 0);
	    __decorate$5([
	        Autowired('displayedGroupCreator')
	    ], ColumnController.prototype, "displayedGroupCreator", void 0);
	    __decorate$5([
	        Autowired('autoWidthCalculator')
	    ], ColumnController.prototype, "autoWidthCalculator", void 0);
	    __decorate$5([
	        Autowired('columnUtils')
	    ], ColumnController.prototype, "columnUtils", void 0);
	    __decorate$5([
	        Autowired('columnAnimationService')
	    ], ColumnController.prototype, "columnAnimationService", void 0);
	    __decorate$5([
	        Autowired('autoGroupColService')
	    ], ColumnController.prototype, "autoGroupColService", void 0);
	    __decorate$5([
	        Optional('aggFuncService')
	    ], ColumnController.prototype, "aggFuncService", void 0);
	    __decorate$5([
	        Optional('valueCache')
	    ], ColumnController.prototype, "valueCache", void 0);
	    __decorate$5([
	        Optional('animationFrameService')
	    ], ColumnController.prototype, "animationFrameService", void 0);
	    __decorate$5([
	        Autowired('rowModel')
	    ], ColumnController.prototype, "rowModel", void 0);
	    __decorate$5([
	        Autowired('columnApi')
	    ], ColumnController.prototype, "columnApi", void 0);
	    __decorate$5([
	        Autowired('gridApi')
	    ], ColumnController.prototype, "gridApi", void 0);
	    __decorate$5([
	        Autowired('sortController')
	    ], ColumnController.prototype, "sortController", void 0);
	    __decorate$5([
	        Autowired('columnDefFactory')
	    ], ColumnController.prototype, "columnDefFactory", void 0);
	    __decorate$5([
	        PostConstruct
	    ], ColumnController.prototype, "init", null);
	    __decorate$5([
	        __param$2(0, Qualifier('loggerFactory'))
	    ], ColumnController.prototype, "setBeans", null);
	    ColumnController = __decorate$5([
	        Bean('columnController')
	    ], ColumnController);
	    return ColumnController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function padStartWidthZeros(value, totalStringSize) {
	    return padStart(value.toString(), totalStringSize, '0');
	}
	function createArrayOfNumbers(first, last) {
	    var result = [];
	    for (var i = first; i <= last; i++) {
	        result.push(i);
	    }
	    return result;
	}
	/**
	 * Check if a value is numeric
	 * from http://stackoverflow.com/questions/9716468/is-there-any-function-like-isnumeric-in-javascript-to-validate-numbers
	 * @param {any} value
	 * @return {boolean}
	 */
	function isNumeric(value) {
	    return value !== '' && !isNaN(parseFloat(value)) && isFinite(value);
	}
	function getMaxSafeInteger() {
	    // @ts-ignore
	    return Number.MAX_SAFE_INTEGER || 9007199254740991;
	}
	function cleanNumber(value) {
	    if (typeof value === 'string') {
	        value = parseInt(value, 10);
	    }
	    if (typeof value === 'number') {
	        return Math.floor(value);
	    }
	    return null;
	}
	function decToHex(number, bytes) {
	    var hex = '';
	    for (var i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(number & 0xff);
	        number >>>= 8;
	    }
	    return hex;
	}
	function formatNumberTwoDecimalPlacesAndCommas(value) {
	    if (typeof value !== 'number') {
	        return '';
	    }
	    return formatNumberCommas(Math.round(value * 100) / 100);
	}
	/**
	 * the native method number.toLocaleString(undefined, {minimumFractionDigits: 0})
	 * puts in decimal places in IE, so we use this method instead
	 * from: http://blog.tompawlak.org/number-currency-formatting-javascript
	 * @param {number} value
	 * @returns {string}
	 */
	function formatNumberCommas(value) {
	    if (typeof value !== 'number') {
	        return '';
	    }
	    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	function sum(values) {
	    return values == null ? null : values.reduce(function (total, value) { return total + value; }, 0);
	}

	var NumberUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    padStartWidthZeros: padStartWidthZeros,
	    createArrayOfNumbers: createArrayOfNumbers,
	    isNumeric: isNumeric,
	    getMaxSafeInteger: getMaxSafeInteger,
	    cleanNumber: cleanNumber,
	    decToHex: decToHex,
	    formatNumberTwoDecimalPlacesAndCommas: formatNumberTwoDecimalPlacesAndCommas,
	    formatNumberCommas: formatNumberCommas,
	    sum: sum
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$6 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// takes in a list of columns, as specified by the column definitions, and returns column groups
	var ColumnUtils = /** @class */ (function (_super) {
	    __extends$2(ColumnUtils, _super);
	    function ColumnUtils() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ColumnUtils.prototype.calculateColInitialWidth = function (colDef) {
	        var optionsWrapper = this.gridOptionsWrapper;
	        var minColWidth = colDef.minWidth != null ? colDef.minWidth : optionsWrapper.getMinColWidth();
	        var maxColWidth = colDef.maxWidth != null ? colDef.maxWidth : (optionsWrapper.getMaxColWidth() || getMaxSafeInteger());
	        var width;
	        var colDefWidth = attrToNumber(colDef.width);
	        var colDefInitialWidth = attrToNumber(colDef.initialWidth);
	        if (colDefWidth != null) {
	            width = colDefWidth;
	        }
	        else if (colDefInitialWidth != null) {
	            width = colDefInitialWidth;
	        }
	        else {
	            width = optionsWrapper.getColWidth();
	        }
	        return Math.max(Math.min(width, maxColWidth), minColWidth);
	    };
	    ColumnUtils.prototype.getOriginalPathForColumn = function (column, originalBalancedTree) {
	        var result = [];
	        var found = false;
	        var recursePath = function (balancedColumnTree, dept) {
	            for (var i = 0; i < balancedColumnTree.length; i++) {
	                if (found) {
	                    return;
	                }
	                // quit the search, so 'result' is kept with the found result
	                var node = balancedColumnTree[i];
	                if (node instanceof OriginalColumnGroup) {
	                    var nextNode = node;
	                    recursePath(nextNode.getChildren(), dept + 1);
	                    result[dept] = node;
	                }
	                else if (node === column) {
	                    found = true;
	                }
	            }
	        };
	        recursePath(originalBalancedTree, 0);
	        // we should always find the path, but in case there is a bug somewhere, returning null
	        // will make it fail rather than provide a 'hard to track down' bug
	        return found ? result : null;
	    };
	    ColumnUtils.prototype.depthFirstOriginalTreeSearch = function (parent, tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof OriginalColumnGroup) {
	                _this.depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
	            }
	            callback(child, parent);
	        });
	    };
	    ColumnUtils.prototype.depthFirstAllColumnTreeSearch = function (tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof ColumnGroup) {
	                _this.depthFirstAllColumnTreeSearch(child.getChildren(), callback);
	            }
	            callback(child);
	        });
	    };
	    ColumnUtils.prototype.depthFirstDisplayedColumnTreeSearch = function (tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof ColumnGroup) {
	                _this.depthFirstDisplayedColumnTreeSearch(child.getDisplayedChildren(), callback);
	            }
	            callback(child);
	        });
	    };
	    ColumnUtils = __decorate$6([
	        Bean('columnUtils')
	    ], ColumnUtils);
	    return ColumnUtils;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$3 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$7 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// takes in a list of columns, as specified by the column definitions, and returns column groups
	var DisplayedGroupCreator = /** @class */ (function (_super) {
	    __extends$3(DisplayedGroupCreator, _super);
	    function DisplayedGroupCreator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DisplayedGroupCreator.prototype.createDisplayedGroups = function (
	    // all displayed columns sorted - this is the columns the grid should show
	    sortedVisibleColumns, 
	    // the tree of columns, as provided by the users, used to know what groups columns roll up into
	    balancedColumnTree, 
	    // creates unique id's for the group
	    groupInstanceIdCreator, 
	    // whether it's left, right or center col
	    pinned, 
	    // we try to reuse old groups if we can, to allow gui to do animation
	    oldDisplayedGroups) {
	        var _this = this;
	        var result = [];
	        var previousRealPath;
	        var previousOriginalPath;
	        var oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
	        // go through each column, then do a bottom up comparison to the previous column, and start
	        // to share groups if they converge at any point.
	        sortedVisibleColumns.forEach(function (currentColumn) {
	            var currentOriginalPath = _this.getOriginalPathForColumn(balancedColumnTree, currentColumn);
	            var currentRealPath = [];
	            var firstColumn = !previousOriginalPath;
	            for (var i = 0; i < currentOriginalPath.length; i++) {
	                if (firstColumn || currentOriginalPath[i] !== previousOriginalPath[i]) {
	                    // new group needed
	                    var newGroup = _this.createColumnGroup(currentOriginalPath[i], groupInstanceIdCreator, oldColumnsMapped, pinned);
	                    currentRealPath[i] = newGroup;
	                    // if top level, add to result, otherwise add to parent
	                    if (i == 0) {
	                        result.push(newGroup);
	                    }
	                    else {
	                        currentRealPath[i - 1].addChild(newGroup);
	                    }
	                }
	                else {
	                    // reuse old group
	                    currentRealPath[i] = previousRealPath[i];
	                }
	            }
	            var noColumnGroups = currentRealPath.length === 0;
	            if (noColumnGroups) {
	                // if we are not grouping, then the result of the above is an empty
	                // path (no groups), and we just add the column to the root list.
	                result.push(currentColumn);
	            }
	            else {
	                var leafGroup = last(currentRealPath);
	                leafGroup.addChild(currentColumn);
	            }
	            previousRealPath = currentRealPath;
	            previousOriginalPath = currentOriginalPath;
	        });
	        this.setupParentsIntoColumns(result, null);
	        return result;
	    };
	    DisplayedGroupCreator.prototype.createColumnGroup = function (originalGroup, groupInstanceIdCreator, oldColumnsMapped, pinned) {
	        var groupId = originalGroup.getGroupId();
	        var instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
	        var uniqueId = ColumnGroup.createUniqueId(groupId, instanceId);
	        var columnGroup = oldColumnsMapped[uniqueId];
	        // if the user is setting new colDefs, it is possible that the id's overlap, and we
	        // would have a false match from above. so we double check we are talking about the
	        // same original column group.
	        if (columnGroup && columnGroup.getOriginalColumnGroup() !== originalGroup) {
	            columnGroup = null;
	        }
	        if (exists(columnGroup)) {
	            // clean out the old column group here, as we will be adding children into it again
	            columnGroup.reset();
	        }
	        else {
	            columnGroup = new ColumnGroup(originalGroup, groupId, instanceId, pinned);
	            this.context.createBean(columnGroup);
	        }
	        return columnGroup;
	    };
	    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
	    DisplayedGroupCreator.prototype.mapOldGroupsById = function (displayedGroups) {
	        var result = {};
	        var recursive = function (columnsOrGroups) {
	            columnsOrGroups.forEach(function (columnOrGroup) {
	                if (columnOrGroup instanceof ColumnGroup) {
	                    var columnGroup = columnOrGroup;
	                    result[columnOrGroup.getUniqueId()] = columnGroup;
	                    recursive(columnGroup.getChildren());
	                }
	            });
	        };
	        if (displayedGroups) {
	            recursive(displayedGroups);
	        }
	        return result;
	    };
	    DisplayedGroupCreator.prototype.setupParentsIntoColumns = function (columnsOrGroups, parent) {
	        var _this = this;
	        columnsOrGroups.forEach(function (columnsOrGroup) {
	            columnsOrGroup.setParent(parent);
	            if (columnsOrGroup instanceof ColumnGroup) {
	                var columnGroup = columnsOrGroup;
	                _this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
	            }
	        });
	    };
	    DisplayedGroupCreator.prototype.getOriginalPathForColumn = function (balancedColumnTree, column) {
	        var result = [];
	        var found = false;
	        var recursePath = function (columnTree, dept) {
	            for (var i = 0; i < columnTree.length; i++) {
	                // quit the search, so 'result' is kept with the found result
	                if (found) {
	                    return;
	                }
	                var node = columnTree[i];
	                if (node instanceof OriginalColumnGroup) {
	                    var nextNode = node;
	                    recursePath(nextNode.getChildren(), dept + 1);
	                    result[dept] = node;
	                }
	                else if (node === column) {
	                    found = true;
	                }
	            }
	        };
	        recursePath(balancedColumnTree, 0);
	        // it's possible we didn't find a path. this happens if the column is generated
	        // by the grid (auto-group), in that the definition didn't come from the client. in this case,
	        // we create a fake original path.
	        if (found) {
	            return result;
	        }
	        console.warn('could not get path');
	        return null;
	    };
	    DisplayedGroupCreator = __decorate$7([
	        Bean('displayedGroupCreator')
	    ], DisplayedGroupCreator);
	    return DisplayedGroupCreator;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$4 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$8 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeadlessService = /** @class */ (function (_super) {
	    __extends$4(HeadlessService, _super);
	    function HeadlessService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HeadlessService_1 = HeadlessService;
	    HeadlessService.prototype.getHeaderRows = function () {
	        return this.headerRows;
	    };
	    HeadlessService.prototype.getRows = function () {
	        return this.rows;
	    };
	    HeadlessService.prototype.getCenterRowContainer = function () {
	        return this.centerRowContainer;
	    };
	    HeadlessService.prototype.postConstruct = function () {
	        var _this = this;
	        this.createHeaderRows();
	        this.onPageLoaded();
	        this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, function () {
	            _this.createHeaderRows();
	            _this.onPageLoaded();
	        });
	    };
	    HeadlessService.prototype.createHeaderRows = function () {
	        this.headerRows = [];
	        var headerRowCount = this.columnController.getHeaderRowCount();
	        for (var i = 0; i < headerRowCount; i++) {
	            var groupLevel = i === (headerRowCount - 1);
	            this.headerRows.push(this.createHeaderRow(i, groupLevel));
	        }
	        this.dispatchEvent({ type: HeadlessService_1.EVENT_HEADERS_UPDATED });
	    };
	    HeadlessService.prototype.onPageLoaded = function () {
	        var _this = this;
	        this.rows = [];
	        var firstRow = this.paginationProxy.getPageFirstRow();
	        var lastRow = this.paginationProxy.getPageLastRow();
	        // first and last rows are -1 if no rows to display
	        if (firstRow < 0 || lastRow < 0) {
	            return;
	        }
	        var displayedColumns = this.columnController.getDisplayedColumns(null);
	        var _loop_1 = function (rowIndex) {
	            var rowNode = this_1.paginationProxy.getRow(rowIndex);
	            if (!rowNode) {
	                return "continue";
	            }
	            var cells = [];
	            var rowVo = {
	                cells: cells,
	                index: rowIndex,
	                id: rowNode.id,
	                height: rowNode.rowHeight,
	                top: rowNode.rowTop
	            };
	            displayedColumns.forEach(function (col) {
	                cells.push({
	                    value: _this.valueService.getValue(col, rowNode),
	                    colId: col.getId(),
	                    width: col.getActualWidth(),
	                    left: col.getLeft()
	                });
	            });
	            this_1.rows.push(rowVo);
	        };
	        var this_1 = this;
	        for (var rowIndex = firstRow; rowIndex <= lastRow; rowIndex++) {
	            _loop_1(rowIndex);
	        }
	        this.dispatchEvent({ type: HeadlessService_1.EVENT_ROWS_UPDATED });
	        this.centerRowContainer = {
	            height: Math.max(this.paginationProxy.getCurrentPageHeight(), 1),
	            width: this.columnController.getBodyContainerWidth()
	        };
	        this.dispatchEvent({ type: HeadlessService_1.EVENT_ROW_CONTAINER_UPDATED });
	    };
	    HeadlessService.prototype.createHeaderRow = function (depth, groupLevel) {
	        var _this = this;
	        var items = this.columnController.getVirtualHeaderGroupRow(null, depth);
	        var mapColumn = function (item) {
	            var isCol = item instanceof Column;
	            var name = isCol
	                ? _this.columnController.getDisplayNameForColumn(item, 'header')
	                : _this.columnController.getDisplayNameForColumnGroup(item, 'header');
	            var res = {
	                name: name,
	                id: item.getUniqueId()
	            };
	            return res;
	        };
	        var res = {
	            headerRowIndex: depth,
	            groupLevel: groupLevel,
	            columns: items.map(mapColumn)
	        };
	        return res;
	    };
	    var HeadlessService_1;
	    HeadlessService.EVENT_ROWS_UPDATED = 'rowsUpdated';
	    HeadlessService.EVENT_HEADERS_UPDATED = 'headersUpdated';
	    HeadlessService.EVENT_ROW_CONTAINER_UPDATED = 'rowContainerUpdated';
	    __decorate$8([
	        Autowired('columnController')
	    ], HeadlessService.prototype, "columnController", void 0);
	    __decorate$8([
	        Autowired('paginationProxy')
	    ], HeadlessService.prototype, "paginationProxy", void 0);
	    __decorate$8([
	        Autowired('valueService')
	    ], HeadlessService.prototype, "valueService", void 0);
	    __decorate$8([
	        PostConstruct
	    ], HeadlessService.prototype, "postConstruct", null);
	    HeadlessService = HeadlessService_1 = __decorate$8([
	        Bean('headlessService')
	    ], HeadlessService);
	    return HeadlessService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/**
	 * These variables are lazy loaded, as otherwise they try and get initialised when we are loading
	 * unit tests and we don't have references to window or document in the unit tests
	 * from http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
	 */
	var isSafari;
	var isIE;
	var isEdge;
	var isChrome;
	var isFirefox;
	var isIOS;
	var invisibleScrollbar;
	var browserScrollbarWidth;
	function isBrowserIE() {
	    if (isIE === undefined) {
	        isIE = /*@cc_on!@*/  !!document.documentMode; // At least IE6
	    }
	    return isIE;
	}
	function isBrowserEdge() {
	    if (isEdge === undefined) {
	        isEdge = !isBrowserIE() && !!window.StyleMedia;
	    }
	    return isEdge;
	}
	function isBrowserSafari() {
	    if (isSafari === undefined) {
	        // taken from https://stackoverflow.com/a/23522755/1388233
	        isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	    }
	    return isSafari;
	}
	function isBrowserChrome() {
	    if (isChrome === undefined) {
	        var win = window;
	        isChrome = (!!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime)) ||
	            (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
	    }
	    return isChrome;
	}
	function isBrowserFirefox() {
	    if (isFirefox === undefined) {
	        var win = window;
	        isFirefox = typeof win.InstallTrigger !== 'undefined';
	    }
	    return isFirefox;
	}
	function isIOSUserAgent() {
	    if (isIOS === undefined) {
	        // taken from https://stackoverflow.com/a/58064481/1388233
	        isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
	            // eslint-disable-next-line
	            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
	            !window.MSStream;
	    }
	    return isIOS;
	}
	function getTabIndex(el) {
	    if (!el) {
	        return null;
	    }
	    var numberTabIndex = el.tabIndex;
	    var tabIndex = el.getAttribute('tabIndex');
	    if (isBrowserIE() && numberTabIndex === 0 && tabIndex === null) {
	        var map = {
	            a: true,
	            body: true,
	            button: true,
	            frame: true,
	            iframe: true,
	            img: true,
	            input: true,
	            isindex: true,
	            object: true,
	            select: true,
	            textarea: true
	        };
	        return map[el.nodeName.toLowerCase()] === true ? '0' : null;
	    }
	    if (numberTabIndex === -1 && (tabIndex === null || (tabIndex === '' && !isBrowserFirefox()))) {
	        return null;
	    }
	    return numberTabIndex.toString();
	}
	function getMaxDivHeight() {
	    if (!document.body) {
	        return -1;
	    }
	    var res = 1000000;
	    // FF reports the height back but still renders blank after ~6M px
	    var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6000000 : 1000000000;
	    var div = document.createElement('div');
	    document.body.appendChild(div);
	    while (true) {
	        var test = res * 2;
	        div.style.height = test + 'px';
	        if (test > testUpTo || div.clientHeight !== test) {
	            break;
	        }
	        else {
	            res = test;
	        }
	    }
	    document.body.removeChild(div);
	    return res;
	}
	function getScrollbarWidth() {
	    if (browserScrollbarWidth == null) {
	        initScrollbarWidthAndVisibility();
	    }
	    return browserScrollbarWidth;
	}
	function initScrollbarWidthAndVisibility() {
	    var body = document.body;
	    var div = document.createElement('div');
	    div.style.width = div.style.height = '100px';
	    div.style.opacity = '0';
	    div.style.overflow = 'scroll';
	    div.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	    div.style.position = 'absolute';
	    body.appendChild(div);
	    var width = div.offsetWidth - div.clientWidth;
	    // if width is 0 and client width is 0, means the DOM isn't ready
	    if (width === 0 && div.clientWidth === 0) {
	        width = null;
	    }
	    // remove div
	    if (div.parentNode) {
	        div.parentNode.removeChild(div);
	    }
	    if (width != null) {
	        browserScrollbarWidth = width;
	        invisibleScrollbar = width === 0;
	    }
	}
	function isInvisibleScrollbar() {
	    if (invisibleScrollbar == null) {
	        initScrollbarWidthAndVisibility();
	    }
	    return invisibleScrollbar;
	}
	/** @deprecated */
	function hasOverflowScrolling() {
	    var prefixes = ['webkit', 'moz', 'o', 'ms'];
	    var div = document.createElement('div');
	    var body = document.getElementsByTagName('body')[0];
	    var found = false;
	    var p;
	    body.appendChild(div);
	    div.setAttribute('style', prefixes.map(function (prefix) { return "-" + prefix + "-overflow-scrolling: touch"; }).concat('overflow-scrolling: touch').join(';'));
	    var computedStyle = window.getComputedStyle(div);
	    if (computedStyle.overflowScrolling === 'touch') {
	        found = true;
	    }
	    if (!found) {
	        for (var _i = 0, prefixes_1 = prefixes; _i < prefixes_1.length; _i++) {
	            p = prefixes_1[_i];
	            if (computedStyle[p + "OverflowScrolling"] === 'touch') {
	                found = true;
	                break;
	            }
	        }
	    }
	    if (div.parentNode) {
	        div.parentNode.removeChild(div);
	    }
	    return found;
	}
	/**
	 * Gets the document body width
	 * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
	 * @returns {number}
	 */
	function getBodyWidth() {
	    if (document.body) {
	        return document.body.clientWidth;
	    }
	    if (window.innerHeight) {
	        return window.innerWidth;
	    }
	    if (document.documentElement && document.documentElement.clientWidth) {
	        return document.documentElement.clientWidth;
	    }
	    return -1;
	}
	/**
	 * Gets the body height
	 * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
	 * @returns {number}
	 */
	function getBodyHeight() {
	    if (document.body) {
	        return document.body.clientHeight;
	    }
	    if (window.innerHeight) {
	        return window.innerHeight;
	    }
	    if (document.documentElement && document.documentElement.clientHeight) {
	        return document.documentElement.clientHeight;
	    }
	    return -1;
	}

	var BrowserUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    isBrowserIE: isBrowserIE,
	    isBrowserEdge: isBrowserEdge,
	    isBrowserSafari: isBrowserSafari,
	    isBrowserChrome: isBrowserChrome,
	    isBrowserFirefox: isBrowserFirefox,
	    isIOSUserAgent: isIOSUserAgent,
	    getTabIndex: getTabIndex,
	    getMaxDivHeight: getMaxDivHeight,
	    getScrollbarWidth: getScrollbarWidth,
	    isInvisibleScrollbar: isInvisibleScrollbar,
	    hasOverflowScrolling: hasOverflowScrolling,
	    getBodyWidth: getBodyWidth,
	    getBodyHeight: getBodyHeight
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var rtlNegativeScroll;
	function addCssClass(element, className) {
	    if (!element || !className || className.length === 0) {
	        return;
	    }
	    if (className.indexOf(' ') >= 0) {
	        className.split(' ').forEach(function (value) { return addCssClass(element, value); });
	        return;
	    }
	    if (element.classList) {
	        element.classList.add(className);
	    }
	    else if (element.className && element.className.length > 0) {
	        var cssClasses = element.className.split(' ');
	        if (cssClasses.indexOf(className) < 0) {
	            cssClasses.push(className);
	            element.setAttribute('class', cssClasses.join(' '));
	        }
	    }
	    else {
	        // do not use element.classList = className here, it will cause
	        // a read-only assignment error on some browsers (IE/Edge).
	        element.setAttribute('class', className);
	    }
	    return element;
	}
	function removeCssClass(element, className) {
	    if (!element || !className || className.length === 0) {
	        return;
	    }
	    if (className.indexOf(' ') >= 0) {
	        className.split(' ').forEach(function (value) { return removeCssClass(element, value); });
	        return;
	    }
	    if (element.classList) {
	        element.classList.remove(className);
	    }
	    else if (element.className && element.className.length > 0) {
	        var newClassName = element.className.split(' ').filter(function (c) { return c !== className; }).join(' ');
	        element.setAttribute('class', newClassName);
	    }
	}
	function addOrRemoveCssClass(element, className, addOrRemove) {
	    if (addOrRemove) {
	        addCssClass(element, className);
	    }
	    else {
	        removeCssClass(element, className);
	    }
	}
	/**
	 * This method adds a class to an element and remove that class from all siblings.
	 * Useful for toggling state.
	 * @param {HTMLElement} element The element to receive the class
	 * @param {string} elementClass The class to be assigned to the element
	 * @param {boolean} otherElementClass The class to be assigned to siblings of the element, but not the element itself
	 */
	function radioCssClass(element, elementClass, otherElementClass) {
	    var parent = element.parentElement;
	    var sibling = parent && parent.firstChild;
	    while (sibling) {
	        if (elementClass) {
	            addOrRemoveCssClass(sibling, elementClass, sibling === element);
	        }
	        if (otherElementClass) {
	            addOrRemoveCssClass(sibling, otherElementClass, sibling !== element);
	        }
	        sibling = sibling.nextSibling;
	    }
	}
	function containsClass(element, className) {
	    if (element.classList) {
	        // for modern browsers
	        return element.classList.contains(className);
	    }
	    if (element.className) {
	        // for older browsers, check against the string of class names
	        // if only one class, can check for exact match
	        var onlyClass = element.className === className;
	        // if many classes, check for class name, we have to pad with ' ' to stop other
	        // class names that are a substring of this class
	        var contains = element.className.indexOf(' ' + className + ' ') >= 0;
	        // the padding above then breaks when it's the first or last class names
	        var startsWithClass = element.className.indexOf(className + ' ') === 0;
	        var endsWithClass = element.className.lastIndexOf(' ' + className) === (element.className.length - className.length - 1);
	        return onlyClass || contains || startsWithClass || endsWithClass;
	    }
	    // if item is not a node
	    return false;
	}
	function isFocusableFormField(element) {
	    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
	    var isFocusable = matches.call(element, Constants.INPUT_SELECTOR);
	    var isNotFocusable = matches.call(element, Constants.FOCUSABLE_EXCLUDE);
	    var isElementVisible = isVisible(element);
	    var focusable = isFocusable && !isNotFocusable && isElementVisible;
	    return focusable;
	}
	function setDisplayed(element, displayed) {
	    addOrRemoveCssClass(element, 'ag-hidden', !displayed);
	}
	function setVisible(element, visible) {
	    addOrRemoveCssClass(element, 'ag-invisible', !visible);
	}
	function setDisabled(element, disabled) {
	    var attributeName = 'disabled';
	    var addOrRemoveDisabledAttribute = disabled ?
	        function (e) { return e.setAttribute(attributeName, ''); } :
	        function (e) { return e.removeAttribute(attributeName); };
	    addOrRemoveDisabledAttribute(element);
	    nodeListForEach(element.querySelectorAll('input'), function (input) { return addOrRemoveDisabledAttribute(input); });
	}
	function isElementChildOfClass(element, cls, maxNest) {
	    var counter = 0;
	    while (element) {
	        if (containsClass(element, cls)) {
	            return true;
	        }
	        element = element.parentElement;
	        if (maxNest && ++counter > maxNest) {
	            break;
	        }
	    }
	    return false;
	}
	// returns back sizes as doubles instead of strings. similar to
	// getBoundingClientRect, however getBoundingClientRect does not:
	// a) work with fractions (eg browser is zooming)
	// b) has CSS transitions applied (eg CSS scale, browser zoom), which we don't want, we want the un-transitioned values
	function getElementSize(el) {
	    var _a = window.getComputedStyle(el), height = _a.height, width = _a.width, paddingTop = _a.paddingTop, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom, paddingLeft = _a.paddingLeft, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, boxSizing = _a.boxSizing;
	    return {
	        height: parseFloat(height),
	        width: parseFloat(width),
	        paddingTop: parseFloat(paddingTop),
	        paddingRight: parseFloat(paddingRight),
	        paddingBottom: parseFloat(paddingBottom),
	        paddingLeft: parseFloat(paddingLeft),
	        marginTop: parseFloat(marginTop),
	        marginRight: parseFloat(marginRight),
	        marginBottom: parseFloat(marginBottom),
	        marginLeft: parseFloat(marginLeft),
	        boxSizing: boxSizing
	    };
	}
	function getInnerHeight(el) {
	    var size = getElementSize(el);
	    if (size.boxSizing === 'border-box') {
	        return size.height - size.paddingTop - size.paddingBottom;
	    }
	    return size.height;
	}
	function getInnerWidth(el) {
	    var size = getElementSize(el);
	    if (size.boxSizing === 'border-box') {
	        return size.width - size.paddingLeft - size.paddingRight;
	    }
	    return size.width;
	}
	function getAbsoluteHeight(el) {
	    var size = getElementSize(el);
	    var marginRight = size.marginBottom + size.marginTop;
	    return Math.ceil(el.offsetHeight + marginRight);
	}
	function getAbsoluteWidth(el) {
	    var size = getElementSize(el);
	    var marginWidth = size.marginLeft + size.marginRight;
	    return Math.ceil(el.offsetWidth + marginWidth);
	}
	function isRtlNegativeScroll() {
	    if (typeof rtlNegativeScroll === "boolean") {
	        return rtlNegativeScroll;
	    }
	    var template = document.createElement('div');
	    template.style.direction = 'rtl';
	    template.style.width = '1px';
	    template.style.height = '1px';
	    template.style.position = 'fixed';
	    template.style.top = '0px';
	    template.style.overflow = 'hidden';
	    template.dir = 'rtl';
	    template.innerHTML = /* html */
	        "<div style=\"width: 2px\">\n            <span style=\"display: inline-block; width: 1px\"></span>\n            <span style=\"display: inline-block; width: 1px\"></span>\n        </div>";
	    document.body.appendChild(template);
	    template.scrollLeft = 1;
	    rtlNegativeScroll = Math.floor(template.scrollLeft) === 0;
	    document.body.removeChild(template);
	    return rtlNegativeScroll;
	}
	function getScrollLeft(element, rtl) {
	    var scrollLeft = element.scrollLeft;
	    if (rtl) {
	        // Absolute value - for FF that reports RTL scrolls in negative numbers
	        scrollLeft = Math.abs(scrollLeft);
	        if (isBrowserChrome() && !isRtlNegativeScroll()) {
	            scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
	        }
	    }
	    return scrollLeft;
	}
	function setScrollLeft(element, value, rtl) {
	    if (rtl) {
	        // Chrome and Safari when doing RTL have the END position of the scroll as zero, not the start
	        if (isRtlNegativeScroll()) {
	            value *= -1;
	        }
	        else if (isBrowserSafari() || isBrowserChrome()) {
	            value = element.scrollWidth - element.clientWidth - value;
	        }
	    }
	    element.scrollLeft = value;
	}
	function clearElement(el) {
	    while (el && el.firstChild) {
	        el.removeChild(el.firstChild);
	    }
	}
	/** @deprecated */
	function removeElement(parent, cssSelector) {
	    removeFromParent(parent.querySelector(cssSelector));
	}
	function removeFromParent(node) {
	    if (node && node.parentNode) {
	        node.parentNode.removeChild(node);
	    }
	}
	function isVisible(element) {
	    return element.offsetParent !== null;
	}
	/**
	 * Loads the template and returns it as an element. makes up for no simple way in
	 * the dom api to load html directly, eg we cannot do this: document.createElement(template)
	 * @param {string} template
	 * @returns {HTMLElement}
	 */
	function loadTemplate(template) {
	    var tempDiv = document.createElement('div');
	    tempDiv.innerHTML = (template || '').trim();
	    return tempDiv.firstChild;
	}
	function appendHtml(eContainer, htmlTemplate) {
	    if (eContainer.lastChild) {
	        // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
	        // we put the items at the start, so new items appear underneath old items,
	        // so when expanding/collapsing groups, the new rows don't go on top of the
	        // rows below that are moving our of the way
	        eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
	    }
	    else {
	        eContainer.innerHTML = htmlTemplate;
	    }
	}
	/** @deprecated */
	function getElementAttribute(element, attributeName) {
	    if (element.attributes && element.attributes[attributeName]) {
	        var attribute = element.attributes[attributeName];
	        return attribute.value;
	    }
	    return null;
	}
	function offsetHeight(element) {
	    return element && element.clientHeight ? element.clientHeight : 0;
	}
	function offsetWidth(element) {
	    return element && element.clientWidth ? element.clientWidth : 0;
	}
	function ensureDomOrder(eContainer, eChild, eChildBefore) {
	    // if already in right order, do nothing
	    if (eChildBefore && eChildBefore.nextSibling === eChild) {
	        return;
	    }
	    if (eChildBefore) {
	        if (eChildBefore.nextSibling) {
	            // insert between the eRowBefore and the row after it
	            eContainer.insertBefore(eChild, eChildBefore.nextSibling);
	        }
	        else {
	            // if nextSibling is missing, means other row is at end, so just append new row at the end
	            eContainer.appendChild(eChild);
	        }
	    }
	    else {
	        // otherwise put at start
	        if (eContainer.firstChild && eContainer.firstChild !== eChild) {
	            // insert it at the first location
	            eContainer.insertAdjacentElement('afterbegin', eChild);
	        }
	    }
	}
	function setDomChildOrder(eContainer, orderedChildren) {
	    for (var i = 0; i < orderedChildren.length; i++) {
	        var correctCellAtIndex = orderedChildren[i];
	        var actualCellAtIndex = eContainer.children[i];
	        if (actualCellAtIndex !== correctCellAtIndex) {
	            eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
	        }
	    }
	}
	function insertWithDomOrder(eContainer, eToInsert, eChildBefore) {
	    if (eChildBefore) {
	        // if previous element exists, just slot in after the previous element
	        eChildBefore.insertAdjacentElement('afterend', eToInsert);
	    }
	    else {
	        if (eContainer.firstChild) {
	            // insert it at the first location
	            eContainer.insertAdjacentElement('afterbegin', eToInsert);
	        }
	        else {
	            // otherwise eContainer is empty, so just append it
	            eContainer.appendChild(eToInsert);
	        }
	    }
	}
	/** @deprecated */
	function prependDC(parent, documentFragment) {
	    if (exists(parent.firstChild)) {
	        parent.insertBefore(documentFragment, parent.firstChild);
	    }
	    else {
	        parent.appendChild(documentFragment);
	    }
	}
	function addStylesToElement(eElement, styles) {
	    if (!styles) {
	        return;
	    }
	    Object.keys(styles).forEach(function (key) {
	        var keyCamelCase = hyphenToCamelCase(key);
	        if (keyCamelCase) {
	            eElement.style[keyCamelCase] = styles[key];
	        }
	    });
	}
	function isHorizontalScrollShowing(element) {
	    return element.clientWidth < element.scrollWidth;
	}
	function isVerticalScrollShowing(element) {
	    return element.clientHeight < element.scrollHeight;
	}
	function setElementWidth(element, width) {
	    if (width === 'flex') {
	        element.style.removeProperty('width');
	        element.style.removeProperty('minWidth');
	        element.style.removeProperty('maxWidth');
	        element.style.flex = '1 1 auto';
	    }
	    else {
	        setFixedWidth(element, width);
	    }
	}
	function setFixedWidth(element, width) {
	    width = formatSize(width);
	    element.style.width = width.toString();
	    element.style.maxWidth = width.toString();
	    element.style.minWidth = width.toString();
	}
	function setElementHeight(element, height) {
	    if (height === 'flex') {
	        element.style.removeProperty('height');
	        element.style.removeProperty('minHeight');
	        element.style.removeProperty('maxHeight');
	        element.style.flex = '1 1 auto';
	    }
	    else {
	        setFixedHeight(element, height);
	    }
	}
	function setFixedHeight(element, height) {
	    height = formatSize(height);
	    element.style.height = height.toString();
	    element.style.maxHeight = height.toString();
	    element.style.minHeight = height.toString();
	}
	function formatSize(size) {
	    if (typeof size === 'number') {
	        return size + "px";
	    }
	    return size;
	}
	/**
	 * Returns true if it is a DOM node
	 * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
	 * @param {any} o
	 * @return {boolean}
	 */
	function isNode(o) {
	    return (typeof Node === 'function'
	        ? o instanceof Node
	        : o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string');
	}
	//
	/**
	 * Returns true if it is a DOM element
	 * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
	 * @param {any} o
	 * @returns {boolean}
	 */
	function isElement(o) {
	    return (typeof HTMLElement === 'function'
	        ? o instanceof HTMLElement //DOM2
	        : o && isNonNullObject(o) && o.nodeType === 1 && typeof o.nodeName === 'string');
	}
	function isNodeOrElement(o) {
	    return isNode(o) || isElement(o);
	}
	/**
	 * Makes a copy of a node list into a list
	 * @param {NodeList} nodeList
	 * @returns {Node[]}
	 */
	function copyNodeList(nodeList) {
	    if (nodeList == null) {
	        return [];
	    }
	    var result = [];
	    nodeListForEach(nodeList, function (node) { return result.push(node); });
	    return result;
	}
	function iterateNamedNodeMap(map, callback) {
	    if (!map) {
	        return;
	    }
	    for (var i = 0; i < map.length; i++) {
	        var attr = map[i];
	        callback(attr.name, attr.value);
	    }
	}
	/** @deprecated */
	function setCheckboxState(eCheckbox, state) {
	    if (typeof state === 'boolean') {
	        eCheckbox.checked = state;
	        eCheckbox.indeterminate = false;
	    }
	    else {
	        // isNodeSelected returns back undefined if it's a group and the children
	        // are a mix of selected and unselected
	        eCheckbox.indeterminate = true;
	    }
	}
	function addOrRemoveAttribute(element, name, value) {
	    if (value == null) {
	        element.removeAttribute(name);
	    }
	    else {
	        element.setAttribute(name, value.toString());
	    }
	}
	function nodeListForEach(nodeList, action) {
	    if (nodeList == null) {
	        return;
	    }
	    for (var i = 0; i < nodeList.length; i++) {
	        action(nodeList[i]);
	    }
	}

	var DomUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    addCssClass: addCssClass,
	    removeCssClass: removeCssClass,
	    addOrRemoveCssClass: addOrRemoveCssClass,
	    radioCssClass: radioCssClass,
	    containsClass: containsClass,
	    isFocusableFormField: isFocusableFormField,
	    setDisplayed: setDisplayed,
	    setVisible: setVisible,
	    setDisabled: setDisabled,
	    isElementChildOfClass: isElementChildOfClass,
	    getElementSize: getElementSize,
	    getInnerHeight: getInnerHeight,
	    getInnerWidth: getInnerWidth,
	    getAbsoluteHeight: getAbsoluteHeight,
	    getAbsoluteWidth: getAbsoluteWidth,
	    isRtlNegativeScroll: isRtlNegativeScroll,
	    getScrollLeft: getScrollLeft,
	    setScrollLeft: setScrollLeft,
	    clearElement: clearElement,
	    removeElement: removeElement,
	    removeFromParent: removeFromParent,
	    isVisible: isVisible,
	    loadTemplate: loadTemplate,
	    appendHtml: appendHtml,
	    getElementAttribute: getElementAttribute,
	    offsetHeight: offsetHeight,
	    offsetWidth: offsetWidth,
	    ensureDomOrder: ensureDomOrder,
	    setDomChildOrder: setDomChildOrder,
	    insertWithDomOrder: insertWithDomOrder,
	    prependDC: prependDC,
	    addStylesToElement: addStylesToElement,
	    isHorizontalScrollShowing: isHorizontalScrollShowing,
	    isVerticalScrollShowing: isVerticalScrollShowing,
	    setElementWidth: setElementWidth,
	    setFixedWidth: setFixedWidth,
	    setElementHeight: setElementHeight,
	    setFixedHeight: setFixedHeight,
	    formatSize: formatSize,
	    isNode: isNode,
	    isElement: isElement,
	    isNodeOrElement: isNodeOrElement,
	    copyNodeList: copyNodeList,
	    iterateNamedNodeMap: iterateNamedNodeMap,
	    setCheckboxState: setCheckboxState,
	    addOrRemoveAttribute: addOrRemoveAttribute,
	    nodeListForEach: nodeListForEach
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var TestHeadless = /** @class */ (function () {
	    function TestHeadless() {
	    }
	    TestHeadless.prototype.doSomething = function (eDiv, gridOptions) {
	        var headlessService = gridOptions.api.headlessService;
	        var headerRows = headlessService.getHeaderRows();
	        var rows = headlessService.getRows();
	        clearElement(eDiv);
	        var eTable = document.createElement('table');
	        headerRows.forEach(function (headerRow) {
	            var eTr = document.createElement('tr');
	            eTable.appendChild(eTr);
	            headerRow.columns.forEach(function (col) {
	                var eTh = document.createElement('th');
	                eTr.appendChild(eTh);
	                if (col.name != null) {
	                    eTh.innerText = col.name;
	                }
	            });
	        });
	        rows.forEach(function (row) {
	            var eTr = document.createElement('tr');
	            eTable.appendChild(eTr);
	            row.cells.forEach(function (cell) {
	                var eTd = document.createElement('td');
	                eTr.appendChild(eTd);
	                if (cell.value != null) {
	                    eTd.innerText = cell.value.toString();
	                }
	            });
	        });
	        eDiv.append(eTable);
	        console.warn('TestHeadless.doSomething');
	    };
	    return TestHeadless;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __spreadArrays = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	/**
	 * These keys are used for validating properties supplied on a gridOptions object, and for code generation.
	 * If you change the properties on the gridOptions interface, you *must* update this file as well to be consistent.
	 */
	var PropertyKeys = /** @class */ (function () {
	    function PropertyKeys() {
	    }
	    PropertyKeys.STRING_PROPERTIES = [
	        'sortingOrder', 'rowClass', 'rowSelection', 'overlayLoadingTemplate', 'overlayNoRowsTemplate',
	        'quickFilterText', 'rowModelType', 'editType', 'domLayout', 'clipboardDeliminator', 'rowGroupPanelShow',
	        'multiSortKey', 'pivotColumnGroupTotals', 'pivotRowTotals', 'pivotPanelShow', 'fillHandleDirection',
	        'serverSideStoreType'
	    ];
	    PropertyKeys.OBJECT_PROPERTIES = [
	        'components', 'frameworkComponents', 'rowStyle', 'context', 'autoGroupColumnDef', 'localeText', 'icons',
	        'datasource', 'serverSideDatasource', 'viewportDatasource', 'groupRowRendererParams', 'aggFuncs', 'fullWidthCellRendererParams',
	        'defaultColGroupDef', 'defaultColDef', 'defaultExportParams', 'defaultCsvExportParams', 'defaultExcelExportParams', 'columnTypes',
	        'rowClassRules', 'detailGridOptions', 'detailCellRendererParams', 'loadingCellRendererParams', 'loadingOverlayComponentParams',
	        'noRowsOverlayComponentParams', 'popupParent', 'colResizeDefault', 'reduxStore', 'statusBar', 'sideBar', 'chartThemeOverrides',
	        'customChartThemes'
	    ];
	    PropertyKeys.ARRAY_PROPERTIES = [
	        'alignedGrids', 'rowData', 'columnDefs', 'excelStyles', 'pinnedTopRowData', 'pinnedBottomRowData', 'chartThemes'
	    ];
	    PropertyKeys.NUMBER_PROPERTIES = [
	        'rowHeight', 'detailRowHeight', 'rowBuffer', 'colWidth', 'headerHeight', 'groupHeaderHeight', 'floatingFiltersHeight',
	        'pivotHeaderHeight', 'pivotGroupHeaderHeight', 'groupDefaultExpanded', 'minColWidth', 'maxColWidth', 'viewportRowModelPageSize',
	        'viewportRowModelBufferSize', 'autoSizePadding', 'maxBlocksInCache', 'maxConcurrentDatasourceRequests', 'tooltipShowDelay',
	        'cacheOverflowSize', 'paginationPageSize', 'cacheBlockSize', 'infiniteInitialRowCount', 'scrollbarWidth',
	        'batchUpdateWaitMillis', 'asyncTransactionWaitMillis', 'blockLoadDebounceMillis', 'keepDetailRowsCount',
	        'undoRedoCellEditingLimit', 'cellFlashDelay', 'cellFadeDelay', 'tabIndex'
	    ];
	    PropertyKeys.BOOLEAN_PROPERTIES = [
	        'suppressMakeColumnVisibleAfterUnGroup', 'suppressRowClickSelection', 'suppressCellSelection', 'suppressHorizontalScroll',
	        'alwaysShowHorizontalScroll', 'alwaysShowVerticalScroll', 'debug', 'enableBrowserTooltips', 'enableCellExpressions',
	        'angularCompileRows', 'angularCompileFilters', 'groupSuppressAutoColumn', 'groupSelectsChildren', 'groupIncludeFooter',
	        'groupIncludeTotalFooter', 'groupUseEntireRow', 'groupSuppressBlankHeader', 'suppressMenuHide', 'suppressRowDeselection',
	        'unSortIcon', 'suppressMultiSort', 'singleClickEdit', 'suppressLoadingOverlay', 'suppressNoRowsOverlay', 'suppressAutoSize',
	        'skipHeaderOnAutoSize', 'suppressParentsInRowNodes', 'suppressColumnMoveAnimation', 'suppressMovableColumns',
	        'suppressFieldDotNotation', 'enableRangeSelection', 'enableRangeHandle', 'enableFillHandle', 'suppressClearOnFillReduction',
	        'deltaSort', 'suppressTouch', 'suppressAsyncEvents', 'allowContextMenuWithControlKey', 'suppressContextMenu',
	        'rememberGroupStateWhenNewData', 'enableCellChangeFlash', 'suppressDragLeaveHidesColumns', 'suppressMiddleClickScrolls',
	        'suppressPreventDefaultOnMouseWheel', 'suppressCopyRowsToClipboard', 'copyHeadersToClipboard', 'pivotMode',
	        'suppressAggFuncInHeader', 'suppressColumnVirtualisation', 'suppressAggAtRootLevel', 'suppressFocusAfterRefresh',
	        'functionsPassive', 'functionsReadOnly', 'animateRows', 'groupSelectsFiltered', 'groupRemoveSingleChildren',
	        'groupRemoveLowestSingleChildren', 'enableRtl', 'suppressClickEdit', 'rowDragManaged', 'suppressRowDrag',
	        'suppressMoveWhenRowDragging', 'enableMultiRowDragging', 'enableGroupEdit', 'embedFullWidthRows', 'deprecatedEmbedFullWidthRows',
	        'suppressPaginationPanel', 'floatingFilter', 'groupHideOpenParents', 'groupMultiAutoColumn', 'pagination',
	        'stopEditingWhenGridLosesFocus', 'paginationAutoPageSize', 'suppressScrollOnNewData', 'purgeClosedRowNodes', 'cacheQuickFilter',
	        'deltaRowDataMode', 'ensureDomOrder', 'accentedSort', 'suppressChangeDetection', 'valueCache', 'valueCacheNeverExpires',
	        'aggregateOnlyChangedColumns', 'suppressAnimationFrame', 'suppressExcelExport', 'suppressCsvExport', 'treeData',
	        'masterDetail', 'suppressMultiRangeSelection', 'enterMovesDownAfterEdit', 'enterMovesDown', 'suppressPropertyNamesCheck',
	        'rowMultiSelectWithClick', 'suppressEnterpriseResetOnNewColumns', 'enableOldSetFilterModel', 'suppressRowHoverHighlight',
	        'suppressRowTransform', 'suppressClipboardPaste', 'suppressLastEmptyLineOnPaste', 'serverSideSortingAlwaysResets',
	        'reactNext', 'suppressSetColumnStateEvents', 'suppressColumnStateEvents', 'enableCharts', 'deltaColumnMode', 'suppressMaintainUnsortedOrder',
	        'enableCellTextSelection', 'suppressBrowserResizeObserver', 'suppressMaxRenderedRowRestriction',
	        'excludeChildrenWhenTreeDataFiltering', 'tooltipMouseTrack', 'keepDetailRows', 'paginateChildRows', 'preventDefaultOnContextMenu',
	        'undoRedoCellEditing', 'allowDragFromColumnsToolPanel', 'immutableData', 'immutableColumns', 'pivotSuppressAutoColumn',
	        'suppressExpandablePivotGroups', 'applyColumnDefOrder', 'debounceVerticalScrollbar', 'detailRowAutoHeight',
	        'serverSideFilteringAlwaysResets', 'suppressAggFilteredOnly', 'showOpenedGroup', 'suppressClipboardApi',
	        'suppressModelUpdateAfterUpdateTransaction', 'stopEditingWhenCellsLoseFocus'
	    ];
	    /** You do not need to include event callbacks in this list, as they are generated automatically. */
	    PropertyKeys.FUNCTION_PROPERTIES = [
	        'localeTextFunc', 'groupRowInnerRenderer', 'groupRowInnerRendererFramework', 'dateComponent', 'dateComponentFramework', 'groupRowRenderer',
	        'groupRowRendererFramework', 'isExternalFilterPresent', 'getRowHeight', 'doesExternalFilterPass', 'getRowClass', 'getRowStyle',
	        'getRowClassRules', 'traverseNode', 'getContextMenuItems', 'getMainMenuItems', 'processRowPostCreate', 'processCellForClipboard',
	        'groupRowAggNodes', 'getRowNodeId', 'isFullWidthCell', 'fullWidthCellRenderer', 'fullWidthCellRendererFramework', 'processSecondaryColDef',
	        'processSecondaryColGroupDef', 'getBusinessKeyForNode', 'sendToClipboard', 'navigateToNextHeader', 'tabToNextHeader', 'navigateToNextCell',
	        'tabToNextCell', 'getDetailRowData', 'processCellFromClipboard', 'getDocument', 'postProcessPopup', 'getChildCount', 'getDataPath',
	        'loadingCellRenderer', 'loadingCellRendererFramework', 'loadingOverlayComponent', 'loadingOverlayComponentFramework', 'noRowsOverlayComponent',
	        'noRowsOverlayComponentFramework', 'detailCellRenderer', 'detailCellRendererFramework', 'defaultGroupSortComparator', 'isRowMaster',
	        'isRowSelectable', 'postSort', 'processHeaderForClipboard', 'paginationNumberFormatter', 'processDataFromClipboard', 'getServerSideGroupKey',
	        'isServerSideGroup', 'suppressKeyboardEvent', 'createChartContainer', 'processChartOptions', 'getChartToolbarItems', 'fillOperation',
	        'isApplyServerSideTransaction', 'getServerSideStoreParams', 'isServerSideGroupOpenByDefault', 'isGroupOpenByDefault'
	    ];
	    PropertyKeys.ALL_PROPERTIES = __spreadArrays(PropertyKeys.ARRAY_PROPERTIES, PropertyKeys.OBJECT_PROPERTIES, PropertyKeys.STRING_PROPERTIES, PropertyKeys.NUMBER_PROPERTIES, PropertyKeys.FUNCTION_PROPERTIES, PropertyKeys.BOOLEAN_PROPERTIES);
	    /**
	     * Used when performing property checks. This avoids noise caused when using frameworks, which can add their own
	     * framework-specific properties to colDefs, gridOptions etc.
	     */
	    PropertyKeys.FRAMEWORK_PROPERTIES = [
	        '__ob__', '__v_skip', '__metadata__', 'mappedColumnProperties', 'hasChildColumns', 'toColDef', 'createColDefFromGridColumn'
	    ];
	    return PropertyKeys;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __spreadArrays$1 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var ComponentUtil = /** @class */ (function () {
	    function ComponentUtil() {
	    }
	    ComponentUtil.getEventCallbacks = function () {
	        if (!ComponentUtil.EVENT_CALLBACKS) {
	            ComponentUtil.EVENT_CALLBACKS = ComponentUtil.EVENTS.map(function (event) { return ComponentUtil.getCallbackForEvent(event); });
	        }
	        return ComponentUtil.EVENT_CALLBACKS;
	    };
	    ComponentUtil.copyAttributesToGridOptions = function (gridOptions, component, skipEventDeprecationCheck) {
	        // create empty grid options if none were passed
	        if (typeof gridOptions !== 'object') {
	            gridOptions = {};
	        }
	        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
	        var pGridOptions = gridOptions;
	        var keyExists = function (key) { return typeof component[key] !== 'undefined'; };
	        // add in all the simple properties
	        __spreadArrays$1(ComponentUtil.ARRAY_PROPERTIES, ComponentUtil.STRING_PROPERTIES, ComponentUtil.OBJECT_PROPERTIES, ComponentUtil.FUNCTION_PROPERTIES, ComponentUtil.getEventCallbacks()).filter(keyExists)
	            .forEach(function (key) { return pGridOptions[key] = component[key]; });
	        ComponentUtil.BOOLEAN_PROPERTIES
	            .filter(keyExists)
	            .forEach(function (key) { return pGridOptions[key] = ComponentUtil.toBoolean(component[key]); });
	        ComponentUtil.NUMBER_PROPERTIES
	            .filter(keyExists)
	            .forEach(function (key) { return pGridOptions[key] = ComponentUtil.toNumber(component[key]); });
	        return gridOptions;
	    };
	    ComponentUtil.getCallbackForEvent = function (eventName) {
	        if (!eventName || eventName.length < 2) {
	            return eventName;
	        }
	        return 'on' + eventName[0].toUpperCase() + eventName.substr(1);
	    };
	    ComponentUtil.processOnChange = function (changes, gridOptions, api, columnApi) {
	        if (!changes) {
	            return;
	        }
	        var changesToApply = __assign({}, changes);
	        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
	        var pGridOptions = gridOptions;
	        var keyExists = function (key) { return changesToApply[key]; };
	        // check if any change for the simple types, and if so, then just copy in the new value
	        __spreadArrays$1(ComponentUtil.ARRAY_PROPERTIES, ComponentUtil.OBJECT_PROPERTIES, ComponentUtil.STRING_PROPERTIES, ComponentUtil.getEventCallbacks()).filter(keyExists)
	            .forEach(function (key) { return pGridOptions[key] = changesToApply[key].currentValue; });
	        ComponentUtil.BOOLEAN_PROPERTIES
	            .filter(keyExists)
	            .forEach(function (key) { return pGridOptions[key] = ComponentUtil.toBoolean(changesToApply[key].currentValue); });
	        ComponentUtil.NUMBER_PROPERTIES
	            .filter(keyExists)
	            .forEach(function (key) { return pGridOptions[key] = ComponentUtil.toNumber(changesToApply[key].currentValue); });
	        if (changesToApply.enableCellTextSelection) {
	            api.setEnableCellTextSelection(ComponentUtil.toBoolean(changesToApply.enableCellTextSelection.currentValue));
	            delete changesToApply.enableCellTextSelection;
	        }
	        if (changesToApply.quickFilterText) {
	            api.setQuickFilter(changesToApply.quickFilterText.currentValue);
	            delete changesToApply.quickFilterText;
	        }
	        if (changesToApply.autoGroupColumnDef) {
	            api.setAutoGroupColumnDef(changesToApply.autoGroupColumnDef.currentValue, "gridOptionsChanged");
	            delete changesToApply.autoGroupColumnDef;
	        }
	        if (changesToApply.columnDefs) {
	            api.setColumnDefs(changesToApply.columnDefs.currentValue, "gridOptionsChanged");
	            delete changesToApply.columnDefs;
	        }
	        if (changesToApply.paginationPageSize) {
	            api.paginationSetPageSize(ComponentUtil.toNumber(changesToApply.paginationPageSize.currentValue));
	            delete changesToApply.paginationPageSize;
	        }
	        if (changesToApply.pivotMode) {
	            columnApi.setPivotMode(ComponentUtil.toBoolean(changesToApply.pivotMode.currentValue));
	            delete changesToApply.pivotMode;
	        }
	        if (changesToApply.groupRemoveSingleChildren) {
	            api.setGroupRemoveSingleChildren(ComponentUtil.toBoolean(changesToApply.groupRemoveSingleChildren.currentValue));
	            delete changesToApply.groupRemoveSingleChildren;
	        }
	        if (changesToApply.suppressRowDrag) {
	            api.setSuppressRowDrag(ComponentUtil.toBoolean(changesToApply.suppressRowDrag.currentValue));
	            delete changesToApply.suppressRowDrag;
	        }
	        if (changesToApply.suppressMoveWhenRowDragging) {
	            api.setSuppressMoveWhenRowDragging(ComponentUtil.toBoolean(changesToApply.suppressMoveWhenRowDragging.currentValue));
	            delete changesToApply.suppressMoveWhenRowDragging;
	        }
	        if (changesToApply.suppressRowClickSelection) {
	            api.setSuppressRowClickSelection(ComponentUtil.toBoolean(changesToApply.suppressRowClickSelection.currentValue));
	            delete changesToApply.suppressRowClickSelection;
	        }
	        if (changesToApply.suppressClipboardPaste) {
	            api.setSuppressClipboardPaste(ComponentUtil.toBoolean(changesToApply.suppressClipboardPaste.currentValue));
	            delete changesToApply.suppressClipboardPaste;
	        }
	        if (changesToApply.headerHeight) {
	            api.setHeaderHeight(ComponentUtil.toNumber(changesToApply.headerHeight.currentValue));
	            delete changesToApply.headerHeight;
	        }
	        // any remaining properties can be set in a generic way
	        // ie the setter takes the form of setXXX and the argument requires no formatting/translation first
	        var dynamicApi = api;
	        Object.keys(changesToApply)
	            .forEach(function (property) {
	            var setterName = "set" + property.charAt(0).toUpperCase() + property.substring(1);
	            if (dynamicApi[setterName]) {
	                dynamicApi[setterName](changes[property].currentValue);
	            }
	        });
	        // copy changes into an event for dispatch
	        var event = {
	            type: Events.EVENT_COMPONENT_STATE_CHANGED,
	            api: gridOptions.api,
	            columnApi: gridOptions.columnApi
	        };
	        iterateObject(changes, function (key, value) {
	            event[key] = value;
	        });
	        api.dispatchEvent(event);
	    };
	    ComponentUtil.toBoolean = function (value) {
	        if (typeof value === 'boolean') {
	            return value;
	        }
	        if (typeof value === 'string') {
	            // for boolean, compare to empty String to allow attributes appearing with
	            // no value to be treated as 'true'
	            return value.toUpperCase() === 'TRUE' || value == '';
	        }
	        return false;
	    };
	    ComponentUtil.toNumber = function (value) {
	        if (typeof value === 'number') {
	            return value;
	        }
	        if (typeof value === 'string') {
	            return Number(value);
	        }
	    };
	    // all the events are populated in here AFTER this class (at the bottom of the file).
	    ComponentUtil.EVENTS = [];
	    ComponentUtil.STRING_PROPERTIES = PropertyKeys.STRING_PROPERTIES;
	    ComponentUtil.OBJECT_PROPERTIES = PropertyKeys.OBJECT_PROPERTIES;
	    ComponentUtil.ARRAY_PROPERTIES = PropertyKeys.ARRAY_PROPERTIES;
	    ComponentUtil.NUMBER_PROPERTIES = PropertyKeys.NUMBER_PROPERTIES;
	    ComponentUtil.BOOLEAN_PROPERTIES = PropertyKeys.BOOLEAN_PROPERTIES;
	    ComponentUtil.FUNCTION_PROPERTIES = PropertyKeys.FUNCTION_PROPERTIES;
	    ComponentUtil.ALL_PROPERTIES = PropertyKeys.ALL_PROPERTIES;
	    return ComponentUtil;
	}());
	ComponentUtil.EVENTS = values(Events);

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __spreadArrays$2 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var ColDefUtil = /** @class */ (function () {
	    function ColDefUtil() {
	    }
	    ColDefUtil.STRING_PROPERTIES = [
	        'headerName',
	        'columnGroupShow',
	        'headerClass',
	        'toolPanelClass',
	        'headerValueGetter',
	        'pivotKeys',
	        'groupId',
	        'colId',
	        'sort',
	        'initialSort',
	        'field',
	        'type',
	        'tooltipComponent',
	        'tooltipField',
	        'headerTooltip',
	        'cellClass',
	        'showRowGroup',
	        'template',
	        'templateUrl',
	        'filter',
	        'initialAggFunc',
	        'aggFunc',
	        'cellRenderer',
	        'cellEditor',
	        'pinned',
	        'initialPinned',
	        'chartDataType'
	    ];
	    ColDefUtil.OBJECT_PROPERTIES = [
	        'headerGroupComponent',
	        'headerGroupComponentFramework',
	        'headerGroupComponentParams',
	        'cellStyle',
	        'cellRendererParams',
	        'cellEditorFramework',
	        'cellEditorParams',
	        'pinnedRowCellRendererFramework',
	        'pinnedRowCellRendererParams',
	        'filterFramework',
	        'filterParams',
	        'pivotValueColumn',
	        'headerComponent',
	        'headerComponentFramework',
	        'headerComponentParams',
	        'floatingFilterComponent',
	        'floatingFilterComponentParams',
	        'floatingFilterComponentFramework',
	        'tooltipComponent',
	        'tooltipComponentParams',
	        'tooltipComponentFramework',
	        'refData',
	        'columnsMenuParams'
	    ];
	    ColDefUtil.ARRAY_PROPERTIES = [
	        'children',
	        'sortingOrder',
	        'allowedAggFuncs',
	        'menuTabs',
	        'pivotTotalColumnIds',
	        'cellClassRules',
	        'icons'
	    ];
	    ColDefUtil.NUMBER_PROPERTIES = [
	        'sortedAt',
	        'sortIndex',
	        'initialSortIndex',
	        'flex',
	        'initialFlex',
	        'width',
	        'initialWidth',
	        'minWidth',
	        'maxWidth',
	        'rowGroupIndex',
	        'initialRowGroupIndex',
	        'pivotIndex',
	        'initialPivotIndex'
	    ];
	    ColDefUtil.BOOLEAN_PROPERTIES = [
	        'suppressCellFlash',
	        'suppressColumnsToolPanel',
	        'suppressFiltersToolPanel',
	        'openByDefault',
	        'marryChildren',
	        'hide',
	        'initialHide',
	        'rowGroup',
	        'initialRowGroup',
	        'pivot',
	        'initialPivot',
	        'checkboxSelection',
	        'headerCheckboxSelection',
	        'headerCheckboxSelectionFilteredOnly',
	        'suppressMenu',
	        'suppressMovable',
	        'lockPosition',
	        'lockVisible',
	        'lockPinned',
	        'unSortIcon',
	        'suppressSizeToFit',
	        'suppressAutoSize',
	        'enableRowGroup',
	        'enablePivot',
	        'enableValue',
	        'editable',
	        'suppressPaste',
	        'suppressNavigable',
	        'enableCellChangeFlash',
	        'rowDrag',
	        'dndSource',
	        'autoHeight',
	        'wrapText',
	        'sortable',
	        'resizable',
	        'singleClickEdit',
	        'floatingFilter',
	    ];
	    ColDefUtil.FUNCTION_PROPERTIES = [
	        'dndSourceOnRowDrag',
	        'valueGetter',
	        'valueSetter',
	        'filterValueGetter',
	        'keyCreator',
	        'cellRenderer',
	        'cellRendererFramework',
	        'pinnedRowCellRenderer',
	        'valueFormatter',
	        'pinnedRowValueFormatter',
	        'valueParser',
	        'comparator',
	        'equals',
	        'pivotComparator',
	        'suppressKeyboardEvent',
	        'suppressHeaderKeyboardEvent',
	        'colSpan',
	        'rowSpan',
	        'getQuickFilterText',
	        'newValueHandler',
	        'onCellValueChanged',
	        'onCellClicked',
	        'onCellDoubleClicked',
	        'onCellContextMenu',
	        'rowDragText',
	        'tooltipValueGetter',
	        'tooltipComponent',
	        'tooltipComponentFramework',
	        'cellRendererSelector',
	        'cellEditorSelector'
	    ];
	    ColDefUtil.ALL_PROPERTIES = __spreadArrays$2(ColDefUtil.ARRAY_PROPERTIES, ColDefUtil.OBJECT_PROPERTIES, ColDefUtil.STRING_PROPERTIES, ColDefUtil.NUMBER_PROPERTIES, ColDefUtil.FUNCTION_PROPERTIES, ColDefUtil.BOOLEAN_PROPERTIES);
	    // used when doing property checks - this causes noise when using frameworks which can add their own fw specific
	    // properties to colDefs, gridOptions etc
	    ColDefUtil.FRAMEWORK_PROPERTIES = ['__ob__', '__v_skip', '__metadata__', 'mappedColumnProperties', 'hasChildColumns',
	        'toColDef', 'createColDefFromGridColumn'];
	    return ColDefUtil;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var Color = /** @class */ (function () {
	    /**
	     * Every color component should be in the [0, 1] range.
	     * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
	     * So, when animating colors, if the source or target color components are already near
	     * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
	     * component value to end up outside of that range mid-animation. For this reason the constructor
	     * performs range checking/constraining.
	     * @param r Red component.
	     * @param g Green component.
	     * @param b Blue component.
	     * @param a Alpha (opacity) component.
	     */
	    function Color(r, g, b, a) {
	        if (a === void 0) { a = 1; }
	        // NaN is treated as 0.
	        this.r = Math.min(1, Math.max(0, r || 0));
	        this.g = Math.min(1, Math.max(0, g || 0));
	        this.b = Math.min(1, Math.max(0, b || 0));
	        this.a = Math.min(1, Math.max(0, a || 0));
	    }
	    /**
	     * The given string can be in one of the following formats:
	     * - #rgb
	     * - #rrggbb
	     * - rgb(r, g, b)
	     * - rgba(r, g, b, a)
	     * - CSS color name such as 'white', 'orange', 'cyan', etc.
	     * @param str
	     */
	    Color.fromString = function (str) {
	        // hexadecimal notation
	        if (str.indexOf('#') >= 0) { // there can be some leading whitespace
	            return Color.fromHexString(str);
	        }
	        // color name
	        var hex = Color.nameToHex[str];
	        if (hex) {
	            return Color.fromHexString(hex);
	        }
	        // rgb(a) notation
	        if (str.indexOf('rgb') >= 0) {
	            return Color.fromRgbaString(str);
	        }
	        throw new Error("Invalid color string: '" + str + "'");
	    };
	    // Using separate RegExp for the short hex notation because strings like `#abcd`
	    // are matched as ['#abcd', 'ab', 'c', 'd', undefined] when the `{1,2}` quantifier is used.
	    Color.fromHexString = function (str) {
	        var values = str.match(Color.hexRe);
	        if (values) {
	            var r = parseInt(values[1], 16);
	            var g = parseInt(values[2], 16);
	            var b = parseInt(values[3], 16);
	            var a = values[4] !== undefined ? parseInt(values[4], 16) : 255;
	            return new Color(r / 255, g / 255, b / 255, a / 255);
	        }
	        values = str.match(Color.shortHexRe);
	        if (values) {
	            var r = parseInt(values[1], 16);
	            var g = parseInt(values[2], 16);
	            var b = parseInt(values[3], 16);
	            var a = values[4] !== undefined ? parseInt(values[4], 16) : 15;
	            r += r * 16;
	            g += g * 16;
	            b += b * 16;
	            a += a * 16;
	            return new Color(r / 255, g / 255, b / 255, a / 255);
	        }
	        throw new Error("Malformed hexadecimal color string: '" + str + "'");
	    };
	    Color.fromRgbaString = function (str) {
	        var values = str.match(Color.rgbRe);
	        if (values) {
	            return new Color(+values[1] / 255, +values[2] / 255, +values[3] / 255);
	        }
	        values = str.match(Color.rgbaRe);
	        if (values) {
	            return new Color(+values[1] / 255, +values[2] / 255, +values[3] / 255, +values[4]);
	        }
	        throw new Error("Malformed rgb/rgba color string: '" + str + "'");
	    };
	    Color.fromArray = function (arr) {
	        if (arr.length === 4) {
	            return new Color(arr[0], arr[1], arr[2], arr[3]);
	        }
	        if (arr.length === 3) {
	            return new Color(arr[0], arr[1], arr[2]);
	        }
	        throw new Error('The given array should contain 3 or 4 color components (numbers).');
	    };
	    /**
	     * Creates an instance of the Color class from the given HSB(A) components.
	     * @param h Hue in the [0, 360) range.
	     * @param s Saturation in the [0, 1] range.
	     * @param b Brightness in the [0, 1] range.
	     * @param alpha Opacity in the [0, 1] range. Defaults to 1 (completely opaque).
	     */
	    Color.fromHSB = function (h, s, b, alpha) {
	        if (alpha === void 0) { alpha = 1; }
	        var rgb = Color.HSBtoRGB(h, s, b);
	        return new Color(rgb[0], rgb[1], rgb[2], alpha);
	    };
	    Color.padHex = function (str) {
	        // Can't use `padStart(2, '0')` here because of IE.
	        return str.length === 1 ? '0' + str : str;
	    };
	    Color.prototype.toHexString = function () {
	        var hex = '#'
	            + Color.padHex(Math.round(this.r * 255).toString(16))
	            + Color.padHex(Math.round(this.g * 255).toString(16))
	            + Color.padHex(Math.round(this.b * 255).toString(16));
	        if (this.a < 1) {
	            hex += Color.padHex(Math.round(this.a * 255).toString(16));
	        }
	        return hex;
	    };
	    Color.prototype.toRgbaString = function (fractionDigits) {
	        if (fractionDigits === void 0) { fractionDigits = 3; }
	        var components = [
	            Math.round(this.r * 255),
	            Math.round(this.g * 255),
	            Math.round(this.b * 255)
	        ];
	        var k = Math.pow(10, fractionDigits);
	        if (this.a !== 1) {
	            components.push(Math.round(this.a * k) / k);
	            return "rgba(" + components.join(', ') + ")";
	        }
	        return "rgb(" + components.join(', ') + ")";
	    };
	    Color.prototype.toString = function () {
	        if (this.a === 1) {
	            return this.toHexString();
	        }
	        return this.toRgbaString();
	    };
	    Color.prototype.toHSB = function () {
	        return Color.RGBtoHSB(this.r, this.g, this.b);
	    };
	    /**
	     * Converts the given RGB triple to an array of HSB (HSV) components.
	     * The hue component will be `NaN` for achromatic colors.
	     */
	    Color.RGBtoHSB = function (r, g, b) {
	        var min = Math.min(r, g, b);
	        var max = Math.max(r, g, b);
	        var S = max !== 0 ? (max - min) / max : 0;
	        var H = NaN;
	        // min == max, means all components are the same
	        // and the color is a shade of gray with no hue (H is NaN)
	        if (min !== max) {
	            var delta = max - min;
	            var rc = (max - r) / delta;
	            var gc = (max - g) / delta;
	            var bc = (max - b) / delta;
	            if (r === max) {
	                H = bc - gc;
	            }
	            else if (g === max) {
	                H = 2.0 + rc - bc;
	            }
	            else {
	                H = 4.0 + gc - rc;
	            }
	            H /= 6.0;
	            if (H < 0) {
	                H = H + 1.0;
	            }
	        }
	        return [H * 360, S, max];
	    };
	    /**
	     * Converts the given HSB (HSV) triple to an array of RGB components.
	     */
	    Color.HSBtoRGB = function (H, S, B) {
	        if (isNaN(H)) {
	            H = 0;
	        }
	        H = (((H % 360) + 360) % 360) / 360; // normalize hue to [0, 360] interval, then scale to [0, 1]
	        var r = 0;
	        var g = 0;
	        var b = 0;
	        if (S === 0) {
	            r = g = b = B;
	        }
	        else {
	            var h = (H - Math.floor(H)) * 6;
	            var f = h - Math.floor(h);
	            var p = B * (1 - S);
	            var q = B * (1 - S * f);
	            var t = B * (1 - (S * (1 - f)));
	            switch (h >> 0) { // discard the floating point part of the number
	                case 0:
	                    r = B;
	                    g = t;
	                    b = p;
	                    break;
	                case 1:
	                    r = q;
	                    g = B;
	                    b = p;
	                    break;
	                case 2:
	                    r = p;
	                    g = B;
	                    b = t;
	                    break;
	                case 3:
	                    r = p;
	                    g = q;
	                    b = B;
	                    break;
	                case 4:
	                    r = t;
	                    g = p;
	                    b = B;
	                    break;
	                case 5:
	                    r = B;
	                    g = p;
	                    b = q;
	                    break;
	            }
	        }
	        return [r, g, b];
	    };
	    Color.prototype.derive = function (hueShift, saturationFactor, brightnessFactor, opacityFactor) {
	        var hsb = Color.RGBtoHSB(this.r, this.g, this.b);
	        var b = hsb[2];
	        if (b == 0 && brightnessFactor > 1.0) {
	            b = 0.05;
	        }
	        var h = (((hsb[0] + hueShift) % 360) + 360) % 360;
	        var s = Math.max(Math.min(hsb[1] * saturationFactor, 1.0), 0.0);
	        b = Math.max(Math.min(b * brightnessFactor, 1.0), 0.0);
	        var a = Math.max(Math.min(this.a * opacityFactor, 1.0), 0.0);
	        var rgba = Color.HSBtoRGB(h, s, b);
	        rgba.push(a);
	        return Color.fromArray(rgba);
	    };
	    Color.prototype.brighter = function () {
	        return this.derive(0, 1.0, 1.0 / 0.7, 1.0);
	    };
	    Color.prototype.darker = function () {
	        return this.derive(0, 1.0, 0.7, 1.0);
	    };
	    // See https://drafts.csswg.org/css-color/#hex-notation
	    Color.hexRe = /\s*#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?\s*$/;
	    Color.shortHexRe = /\s*#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])?\s*$/;
	    Color.rgbRe = /\s*rgb\((\d+),\s*(\d+),\s*(\d+)\)\s*/;
	    Color.rgbaRe = /\s*rgba\((\d+),\s*(\d+),\s*(\d+),\s*([.\d]+)\)\s*/;
	    /**
	     * CSS Color Module Level 4:
	     * https://drafts.csswg.org/css-color/#named-colors
	     */
	    Color.nameToHex = Object.freeze({
	        aliceblue: '#F0F8FF',
	        antiquewhite: '#FAEBD7',
	        aqua: '#00FFFF',
	        aquamarine: '#7FFFD4',
	        azure: '#F0FFFF',
	        beige: '#F5F5DC',
	        bisque: '#FFE4C4',
	        black: '#000000',
	        blanchedalmond: '#FFEBCD',
	        blue: '#0000FF',
	        blueviolet: '#8A2BE2',
	        brown: '#A52A2A',
	        burlywood: '#DEB887',
	        cadetblue: '#5F9EA0',
	        chartreuse: '#7FFF00',
	        chocolate: '#D2691E',
	        coral: '#FF7F50',
	        cornflowerblue: '#6495ED',
	        cornsilk: '#FFF8DC',
	        crimson: '#DC143C',
	        cyan: '#00FFFF',
	        darkblue: '#00008B',
	        darkcyan: '#008B8B',
	        darkgoldenrod: '#B8860B',
	        darkgray: '#A9A9A9',
	        darkgreen: '#006400',
	        darkgrey: '#A9A9A9',
	        darkkhaki: '#BDB76B',
	        darkmagenta: '#8B008B',
	        darkolivegreen: '#556B2F',
	        darkorange: '#FF8C00',
	        darkorchid: '#9932CC',
	        darkred: '#8B0000',
	        darksalmon: '#E9967A',
	        darkseagreen: '#8FBC8F',
	        darkslateblue: '#483D8B',
	        darkslategray: '#2F4F4F',
	        darkslategrey: '#2F4F4F',
	        darkturquoise: '#00CED1',
	        darkviolet: '#9400D3',
	        deeppink: '#FF1493',
	        deepskyblue: '#00BFFF',
	        dimgray: '#696969',
	        dimgrey: '#696969',
	        dodgerblue: '#1E90FF',
	        firebrick: '#B22222',
	        floralwhite: '#FFFAF0',
	        forestgreen: '#228B22',
	        fuchsia: '#FF00FF',
	        gainsboro: '#DCDCDC',
	        ghostwhite: '#F8F8FF',
	        gold: '#FFD700',
	        goldenrod: '#DAA520',
	        gray: '#808080',
	        green: '#008000',
	        greenyellow: '#ADFF2F',
	        grey: '#808080',
	        honeydew: '#F0FFF0',
	        hotpink: '#FF69B4',
	        indianred: '#CD5C5C',
	        indigo: '#4B0082',
	        ivory: '#FFFFF0',
	        khaki: '#F0E68C',
	        lavender: '#E6E6FA',
	        lavenderblush: '#FFF0F5',
	        lawngreen: '#7CFC00',
	        lemonchiffon: '#FFFACD',
	        lightblue: '#ADD8E6',
	        lightcoral: '#F08080',
	        lightcyan: '#E0FFFF',
	        lightgoldenrodyellow: '#FAFAD2',
	        lightgray: '#D3D3D3',
	        lightgreen: '#90EE90',
	        lightgrey: '#D3D3D3',
	        lightpink: '#FFB6C1',
	        lightsalmon: '#FFA07A',
	        lightseagreen: '#20B2AA',
	        lightskyblue: '#87CEFA',
	        lightslategray: '#778899',
	        lightslategrey: '#778899',
	        lightsteelblue: '#B0C4DE',
	        lightyellow: '#FFFFE0',
	        lime: '#00FF00',
	        limegreen: '#32CD32',
	        linen: '#FAF0E6',
	        magenta: '#FF00FF',
	        maroon: '#800000',
	        mediumaquamarine: '#66CDAA',
	        mediumblue: '#0000CD',
	        mediumorchid: '#BA55D3',
	        mediumpurple: '#9370DB',
	        mediumseagreen: '#3CB371',
	        mediumslateblue: '#7B68EE',
	        mediumspringgreen: '#00FA9A',
	        mediumturquoise: '#48D1CC',
	        mediumvioletred: '#C71585',
	        midnightblue: '#191970',
	        mintcream: '#F5FFFA',
	        mistyrose: '#FFE4E1',
	        moccasin: '#FFE4B5',
	        navajowhite: '#FFDEAD',
	        navy: '#000080',
	        oldlace: '#FDF5E6',
	        olive: '#808000',
	        olivedrab: '#6B8E23',
	        orange: '#FFA500',
	        orangered: '#FF4500',
	        orchid: '#DA70D6',
	        palegoldenrod: '#EEE8AA',
	        palegreen: '#98FB98',
	        paleturquoise: '#AFEEEE',
	        palevioletred: '#DB7093',
	        papayawhip: '#FFEFD5',
	        peachpuff: '#FFDAB9',
	        peru: '#CD853F',
	        pink: '#FFC0CB',
	        plum: '#DDA0DD',
	        powderblue: '#B0E0E6',
	        purple: '#800080',
	        rebeccapurple: '#663399',
	        red: '#FF0000',
	        rosybrown: '#BC8F8F',
	        royalblue: '#4169E1',
	        saddlebrown: '#8B4513',
	        salmon: '#FA8072',
	        sandybrown: '#F4A460',
	        seagreen: '#2E8B57',
	        seashell: '#FFF5EE',
	        sienna: '#A0522D',
	        silver: '#C0C0C0',
	        skyblue: '#87CEEB',
	        slateblue: '#6A5ACD',
	        slategray: '#708090',
	        slategrey: '#708090',
	        snow: '#FFFAFA',
	        springgreen: '#00FF7F',
	        steelblue: '#4682B4',
	        tan: '#D2B48C',
	        teal: '#008080',
	        thistle: '#D8BFD8',
	        tomato: '#FF6347',
	        turquoise: '#40E0D0',
	        violet: '#EE82EE',
	        wheat: '#F5DEB3',
	        white: '#FFFFFF',
	        whitesmoke: '#F5F5F5',
	        yellow: '#FFFF00',
	        yellowgreen: '#9ACD32'
	    });
	    return Color;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	// Based on https://stackoverflow.com/a/14991797
	// This will parse a delimited string into an array of arrays.
	function stringToArray(strData, delimiter) {
	    if (delimiter === void 0) { delimiter = ','; }
	    var data = [];
	    var isNewline = function (char) { return char === '\r' || char === '\n'; };
	    var insideQuotedField = false;
	    if (strData === '') {
	        return [['']];
	    }
	    var _loop_1 = function (row, column, position) {
	        var previousChar = strData[position - 1];
	        var currentChar = strData[position];
	        var nextChar = strData[position + 1];
	        var ensureDataExists = function () {
	            if (!data[row]) {
	                // create row if it doesn't exist
	                data[row] = [];
	            }
	            if (!data[row][column]) {
	                // create column if it doesn't exist
	                data[row][column] = '';
	            }
	        };
	        ensureDataExists();
	        if (currentChar === '"') {
	            if (insideQuotedField) {
	                if (nextChar === '"') {
	                    // unescape double quote
	                    data[row][column] += '"';
	                    position++;
	                }
	                else {
	                    // exit quoted field
	                    insideQuotedField = false;
	                }
	                return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
	            }
	            else if (previousChar === undefined || previousChar === delimiter || isNewline(previousChar)) {
	                // enter quoted field
	                insideQuotedField = true;
	                return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
	            }
	        }
	        if (!insideQuotedField) {
	            if (currentChar === delimiter) {
	                // move to next column
	                column++;
	                ensureDataExists();
	                return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
	            }
	            else if (isNewline(currentChar)) {
	                // move to next row
	                column = 0;
	                row++;
	                ensureDataExists();
	                if (currentChar === '\r' && nextChar === '\n') {
	                    // skip over second newline character if it exists
	                    position++;
	                }
	                return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
	            }
	        }
	        // add current character to current column
	        data[row][column] += currentChar;
	        out_row_1 = row;
	        out_column_1 = column;
	        out_position_1 = position;
	    };
	    var out_row_1, out_column_1, out_position_1;
	    // iterate over each character, keep track of current row and column (of the returned array)
	    for (var row = 0, column = 0, position = 0; position < strData.length; position++) {
	        _loop_1(row, column, position);
	        row = out_row_1;
	        column = out_column_1;
	        position = out_position_1;
	    }
	    return data;
	}

	var CsvUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    stringToArray: stringToArray
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/** @deprecated */
	function getNameOfClass(theClass) {
	    var funcNameRegex = /function (.{1,})\(/;
	    var funcAsString = theClass.toString();
	    var results = funcNameRegex.exec(funcAsString);
	    return results && results.length > 1 ? results[1] : "";
	}
	function findLineByLeastSquares(values) {
	    var len = values.length;
	    var maxDecimals = 0;
	    if (len <= 1) {
	        return values;
	    }
	    for (var i = 0; i < values.length; i++) {
	        var value = values[i];
	        if (Math.floor(value) === value) {
	            continue;
	        }
	        maxDecimals = Math.max(maxDecimals, value.toString().split('.')[1].length);
	    }
	    var sum_x = 0;
	    var sum_y = 0;
	    var sum_xy = 0;
	    var sum_xx = 0;
	    var y = 0;
	    for (var x = 0; x < len; x++) {
	        y = values[x];
	        sum_x += x;
	        sum_y += y;
	        sum_xx += x * x;
	        sum_xy += x * y;
	    }
	    var m = (len * sum_xy - sum_x * sum_y) / (len * sum_xx - sum_x * sum_x);
	    var b = (sum_y / len) - (m * sum_x) / len;
	    var result = [];
	    for (var x = 0; x <= len; x++) {
	        result.push(parseFloat((x * m + b).toFixed(maxDecimals)));
	    }
	    return result;
	}
	/**
	 * Converts a CSS object into string
	 * @param {Object} stylesToUse an object eg: {color: 'black', top: '25px'}
	 * @return {string} A string like "color: black; top: 25px;" for html
	 */
	function cssStyleObjectToMarkup(stylesToUse) {
	    if (!stylesToUse) {
	        return '';
	    }
	    var resParts = [];
	    iterateObject(stylesToUse, function (styleKey, styleValue) {
	        var styleKeyDashed = camelCaseToHyphen(styleKey);
	        resParts.push(styleKeyDashed + ": " + styleValue + ";");
	    });
	    return resParts.join(' ');
	}
	/**
	 * Displays a message to the browser. this is useful in iPad, where you can't easily see the console.
	 * so the javascript code can use this to give feedback. this is NOT intended to be called in production.
	 * it is intended the AG Grid developer calls this to troubleshoot, but then takes out the calls before
	 * checking in.
	 * @param {string} msg
	 */
	function message(msg) {
	    var eMessage = document.createElement('div');
	    var eBox = document.querySelector('#__ag__message');
	    eMessage.innerHTML = msg;
	    if (!eBox) {
	        var template = "<div id=\"__ag__message\" style=\"display: inline-block; position: absolute; top: 0px; left: 0px; color: white; background-color: black; z-index: 20; padding: 2px; border: 1px solid darkred; height: 200px; overflow-y: auto;\"></div>";
	        eBox = loadTemplate(template);
	        if (document.body) {
	            document.body.appendChild(eBox);
	        }
	    }
	    eBox.insertBefore(eMessage, eBox.children[0]);
	}
	/**
	 * cell renderers are used in a few places. they bind to dom slightly differently to other cell renderes as they
	 * can return back strings (instead of html elemnt) in the getGui() method. common code placed here to handle that.
	 * @param {AgPromise<ICellRendererComp>} cellRendererPromise
	 * @param {HTMLElement} eTarget
	 */
	function bindCellRendererToHtmlElement(cellRendererPromise, eTarget) {
	    cellRendererPromise.then(function (cellRenderer) {
	        var gui = cellRenderer.getGui();
	        if (gui != null) {
	            if (typeof gui === 'object') {
	                eTarget.appendChild(gui);
	            }
	            else {
	                eTarget.innerHTML = gui;
	            }
	        }
	    });
	}

	var GeneralUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    getNameOfClass: getNameOfClass,
	    findLineByLeastSquares: findLineByLeastSquares,
	    cssStyleObjectToMarkup: cssStyleObjectToMarkup,
	    message: message,
	    bindCellRendererToHtmlElement: bindCellRendererToHtmlElement
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	// ARIA HELPER FUNCTIONS
	function setAriaAttribute(element, attribute, value) {
	    element.setAttribute(ariaAttributeName(attribute), value.toString());
	}
	function removeAriaAttribute(element, attribute) {
	    element.removeAttribute(ariaAttributeName(attribute));
	}
	function ariaAttributeName(attribute) {
	    return "aria-" + attribute;
	}
	function getAriaSortState(column) {
	    var sort;
	    if (column.isSortAscending()) {
	        sort = 'ascending';
	    }
	    else if (column.isSortDescending()) {
	        sort = 'descending';
	    }
	    else {
	        sort = 'none';
	    }
	    return sort;
	}
	// ARIA ATTRIBUTE GETTERS
	function getAriaLevel(element) {
	    return parseInt(element.getAttribute('aria-level'), 10);
	}
	function getAriaPosInSet(element) {
	    return parseInt(element.getAttribute('aria-posinset'), 10);
	}
	function getAriaDescribedBy(element) {
	    return element.getAttribute('aria-describedby') || '';
	}
	// ARIA ATTRIBUTE SETTERS
	function setAriaLabel(element, label) {
	    setAriaAttribute(element, 'label', label);
	}
	function setAriaLabelledBy(element, labelledBy) {
	    setAriaAttribute(element, 'labelledby', labelledBy);
	}
	function setAriaDescribedBy(element, describedby) {
	    setAriaAttribute(element, 'describedby', describedby);
	}
	function setAriaLevel(element, level) {
	    setAriaAttribute(element, 'level', level);
	}
	function setAriaDisabled(element, disabled) {
	    setAriaAttribute(element, 'disabled', disabled);
	}
	function setAriaExpanded(element, expanded) {
	    setAriaAttribute(element, 'expanded', expanded);
	}
	function removeAriaExpanded(element) {
	    removeAriaAttribute(element, 'expanded');
	}
	function setAriaSetSize(element, setsize) {
	    setAriaAttribute(element, 'setsize', setsize);
	}
	function setAriaPosInSet(element, position) {
	    setAriaAttribute(element, 'posinset', position);
	}
	function setAriaMultiSelectable(element, multiSelectable) {
	    setAriaAttribute(element, 'multiselectable', multiSelectable);
	}
	function setAriaRowCount(element, rowCount) {
	    setAriaAttribute(element, 'rowcount', rowCount);
	}
	function setAriaRowIndex(element, rowIndex) {
	    setAriaAttribute(element, 'rowindex', rowIndex);
	}
	function setAriaColCount(element, colCount) {
	    setAriaAttribute(element, 'colcount', colCount);
	}
	function setAriaColIndex(element, colIndex) {
	    setAriaAttribute(element, 'colindex', colIndex);
	}
	function setAriaColSpan(element, colSpan) {
	    setAriaAttribute(element, 'colspan', colSpan);
	}
	function setAriaSort(element, sort) {
	    setAriaAttribute(element, 'sort', sort);
	}
	function removeAriaSort(element) {
	    removeAriaAttribute(element, 'sort');
	}
	function setAriaSelected(element, selected) {
	    var attributeName = 'selected';
	    if (selected) {
	        setAriaAttribute(element, attributeName, selected);
	    }
	    else {
	        removeAriaAttribute(element, attributeName);
	    }
	}
	function setAriaChecked(element, checked) {
	    setAriaAttribute(element, 'checked', checked === undefined ? 'mixed' : checked);
	}

	var AriaUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    getAriaSortState: getAriaSortState,
	    getAriaLevel: getAriaLevel,
	    getAriaPosInSet: getAriaPosInSet,
	    getAriaDescribedBy: getAriaDescribedBy,
	    setAriaLabel: setAriaLabel,
	    setAriaLabelledBy: setAriaLabelledBy,
	    setAriaDescribedBy: setAriaDescribedBy,
	    setAriaLevel: setAriaLevel,
	    setAriaDisabled: setAriaDisabled,
	    setAriaExpanded: setAriaExpanded,
	    removeAriaExpanded: removeAriaExpanded,
	    setAriaSetSize: setAriaSetSize,
	    setAriaPosInSet: setAriaPosInSet,
	    setAriaMultiSelectable: setAriaMultiSelectable,
	    setAriaRowCount: setAriaRowCount,
	    setAriaRowIndex: setAriaRowIndex,
	    setAriaColCount: setAriaColCount,
	    setAriaColIndex: setAriaColIndex,
	    setAriaColSpan: setAriaColSpan,
	    setAriaSort: setAriaSort,
	    removeAriaSort: removeAriaSort,
	    setAriaSelected: setAriaSelected,
	    setAriaChecked: setAriaChecked
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/**
	 * Serialises a Date to a string of format `yyyy-MM-dd HH:mm:ss`.
	 * An alternative separator can be provided to be used instead of hyphens.
	 * @param date The date to serialise
	 * @param includeTime Whether to include the time in the serialised string
	 * @param separator The separator to use between date parts
	 */
	function serialiseDate(date, includeTime, separator) {
	    if (includeTime === void 0) { includeTime = true; }
	    if (separator === void 0) { separator = '-'; }
	    if (!date) {
	        return null;
	    }
	    var serialised = [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(function (part) { return padStartWidthZeros(part, 2); }).join(separator);
	    if (includeTime) {
	        serialised += ' ' + [date.getHours(), date.getMinutes(), date.getSeconds()].map(function (part) { return padStartWidthZeros(part, 2); }).join(':');
	    }
	    return serialised;
	}
	/**
	 * Parses a date and time from a string in the format `yyyy-MM-dd HH:mm:ss`
	 */
	function parseDateTimeFromString(value) {
	    if (!value) {
	        return null;
	    }
	    var _a = value.split(' '), dateStr = _a[0], timeStr = _a[1];
	    if (!dateStr) {
	        return null;
	    }
	    var fields = dateStr.split('-').map(function (f) { return parseInt(f, 10); });
	    if (fields.filter(function (f) { return !isNaN(f); }).length !== 3) {
	        return null;
	    }
	    var year = fields[0], month = fields[1], day = fields[2];
	    var date = new Date(year, month - 1, day);
	    if (date.getFullYear() !== year ||
	        date.getMonth() !== month - 1 ||
	        date.getDate() !== day) {
	        // date was not parsed as expected so must have been invalid
	        return null;
	    }
	    if (!timeStr || timeStr === '00:00:00') {
	        return date;
	    }
	    var _b = timeStr.split(':').map(function (part) { return parseInt(part, 10); }), hours = _b[0], minutes = _b[1], seconds = _b[2];
	    if (hours >= 0 && hours < 24) {
	        date.setHours(hours);
	    }
	    if (minutes >= 0 && minutes < 60) {
	        date.setMinutes(minutes);
	    }
	    if (seconds >= 0 && seconds < 60) {
	        date.setSeconds(seconds);
	    }
	    return date;
	}

	var DateUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    serialiseDate: serialiseDate,
	    parseDateTimeFromString: parseDateTimeFromString
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
	    var fuzzyMatches = {};
	    var invalidInputs = inputValues.filter(function (inputValue) {
	        return !validValues.some(function (validValue) { return validValue === inputValue; });
	    });
	    if (invalidInputs.length > 0) {
	        invalidInputs.forEach(function (invalidInput) {
	            return fuzzyMatches[invalidInput] = fuzzySuggestions(invalidInput, allSuggestions);
	        });
	    }
	    return fuzzyMatches;
	}
	/**
	 *
	 * @param {String} inputValue The value to be compared against a list of strings
	 * @param allSuggestions The list of strings to be compared against
	 * @param hideIrrelevant By default, fuzzy suggestions will just sort the allSuggestions list, set this to true
	 *        to filter out the irrelevant values
	 * @param weighted Set this to true, to make letters matched in the order they were typed have priority in the results.
	 */
	function fuzzySuggestions(inputValue, allSuggestions, hideIrrelevant, weighted) {
	    var search = weighted ? string_weighted_distances : string_distances;
	    var thisSuggestions = allSuggestions.map(function (text) { return ({
	        value: text,
	        relevance: search(inputValue.toLowerCase(), text.toLocaleLowerCase())
	    }); });
	    thisSuggestions.sort(function (a, b) { return b.relevance - a.relevance; });
	    if (hideIrrelevant) {
	        thisSuggestions = thisSuggestions.filter(function (suggestion) { return suggestion.relevance !== 0; });
	    }
	    return thisSuggestions.map(function (suggestion) { return suggestion.value; });
	}
	/**
	 * Algorithm to do fuzzy search
	 * from https://stackoverflow.com/questions/23305000/javascript-fuzzy-search-that-makes-sense
	 * @param {string} from
	 * @return {[]}
	 */
	function get_bigrams(from) {
	    var s = from.toLowerCase();
	    var v = new Array(s.length - 1);
	    var i;
	    var j;
	    var ref;
	    for (i = j = 0, ref = v.length; j <= ref; i = j += 1) {
	        v[i] = s.slice(i, i + 2);
	    }
	    return v;
	}
	function string_distances(str1, str2) {
	    if (str1.length === 0 && str2.length === 0) {
	        return 0;
	    }
	    var pairs1 = get_bigrams(str1);
	    var pairs2 = get_bigrams(str2);
	    var union = pairs1.length + pairs2.length;
	    var hit_count = 0;
	    var j;
	    var len;
	    for (j = 0, len = pairs1.length; j < len; j++) {
	        var x = pairs1[j];
	        var k = void 0;
	        var len1 = void 0;
	        for (k = 0, len1 = pairs2.length; k < len1; k++) {
	            var y = pairs2[k];
	            if (x === y) {
	                hit_count++;
	            }
	        }
	    }
	    return hit_count > 0 ? (2 * hit_count) / union : 0;
	}
	function string_weighted_distances(str1, str2) {
	    var a = str1.replace(/\s/g, '');
	    var b = str2.replace(/\s/g, '');
	    var weight = 0;
	    var lastIndex = 0;
	    for (var i = 0; i < a.length; i++) {
	        var idx = b.indexOf(a[i], lastIndex);
	        if (idx === -1) {
	            continue;
	        }
	        lastIndex = idx;
	        weight += (100 - (lastIndex * 100 / 10000) * 100);
	    }
	    return weight;
	}

	var FuzzyMatchUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    fuzzyCheckStrings: fuzzyCheckStrings,
	    fuzzySuggestions: fuzzySuggestions,
	    get_bigrams: get_bigrams,
	    string_distances: string_distances,
	    string_weighted_distances: string_weighted_distances
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	//
	// IMPORTANT NOTE!
	//
	// If you change the list below, copy/paste the new content into the docs page javascript-grid-icons
	//
	var iconNameClassMap = {
	    // header column group shown when expanded (click to contract)
	    columnGroupOpened: 'expanded',
	    // header column group shown when contracted (click to expand)
	    columnGroupClosed: 'contracted',
	    // tool panel column group contracted (click to expand)
	    columnSelectClosed: 'tree-closed',
	    // tool panel column group expanded (click to contract)
	    columnSelectOpen: 'tree-open',
	    // column tool panel header expand/collapse all button, shown when some children are expanded and
	    //     others are collapsed
	    columnSelectIndeterminate: 'tree-indeterminate',
	    // shown on ghost icon while dragging column to the side of the grid to pin
	    columnMovePin: 'pin',
	    // shown on ghost icon while dragging over part of the page that is not a drop zone
	    columnMoveHide: 'eye-slash',
	    // shown on ghost icon while dragging columns to reorder
	    columnMoveMove: 'arrows',
	    // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
	    columnMoveLeft: 'left',
	    // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
	    columnMoveRight: 'right',
	    // shown on ghost icon while dragging over Row Groups drop zone
	    columnMoveGroup: 'group',
	    // shown on ghost icon while dragging over Values drop zone
	    columnMoveValue: 'aggregation',
	    // shown on ghost icon while dragging over pivot drop zone
	    columnMovePivot: 'pivot',
	    // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
	    //     string column over aggregation drop zone
	    dropNotAllowed: 'not-allowed',
	    // shown on row group when contracted (click to expand)
	    groupContracted: 'tree-closed',
	    // shown on row group when expanded (click to contract)
	    groupExpanded: 'tree-open',
	    // context menu chart item
	    chart: 'chart',
	    // chart window title bar
	    close: 'cross',
	    // X (remove) on column 'pill' after adding it to a drop zone list
	    cancel: 'cancel',
	    // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
	    check: 'tick',
	    // "go to first" button in pagination controls
	    first: 'first',
	    // "go to previous" button in pagination controls
	    previous: 'previous',
	    // "go to next" button in pagination controls
	    next: 'next',
	    // "go to last" button in pagination controls
	    last: 'last',
	    // shown on top right of chart when chart is linked to range data (click to unlink)
	    linked: 'linked',
	    // shown on top right of chart when chart is not linked to range data (click to link)
	    unlinked: 'unlinked',
	    // "Choose colour" button on chart settings tab
	    colorPicker: 'color-picker',
	    // rotating spinner shown by the loading cell renderer
	    groupLoading: 'loading',
	    // button to launch enterprise column menu
	    menu: 'menu',
	    // filter tool panel tab
	    filter: 'filter',
	    // column tool panel tab
	    columns: 'columns',
	    // button in chart regular size window title bar (click to maximise)
	    maximize: 'maximize',
	    // button in chart maximised window title bar (click to make regular size)
	    minimize: 'minimize',
	    // "Pin column" item in column header menu
	    menuPin: 'pin',
	    // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
	    menuValue: 'aggregation',
	    // "Group by {column-name}" item in column header menu
	    menuAddRowGroup: 'group',
	    // "Un-Group by {column-name}" item in column header menu
	    menuRemoveRowGroup: 'group',
	    // context menu copy item
	    clipboardCopy: 'copy',
	    // context menu paste item
	    clipboardPaste: 'paste',
	    // identifies the pivot drop zone
	    pivotPanel: 'pivot',
	    // "Row groups" drop zone in column tool panel
	    rowGroupPanel: 'group',
	    // columns tool panel Values drop zone
	    valuePanel: 'aggregation',
	    // drag handle used to pick up draggable columns
	    columnDrag: 'grip',
	    // drag handle used to pick up draggable rows
	    rowDrag: 'grip',
	    // context menu export item
	    save: 'save',
	    // csv export
	    csvExport: 'csv',
	    // excel export,
	    excelExport: 'excel',
	    // icon on dropdown editors
	    smallDown: 'small-down',
	    // version of small-right used in RTL mode
	    smallLeft: 'small-left',
	    // separater between column 'pills' when you add multiple columns to the header drop zone
	    smallRight: 'small-right',
	    smallUp: 'small-up',
	    // show on column header when column is sorted ascending
	    sortAscending: 'asc',
	    // show on column header when column is sorted descending
	    sortDescending: 'desc',
	    // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
	    sortUnSort: 'none'
	};
	/**
	 * If icon provided, use this (either a string, or a function callback).
	 * if not, then use the default icon from the theme
	 * @param {string} iconName
	 * @param {GridOptionsWrapper} gridOptionsWrapper
	 * @param {Column | null} [column]
	 * @returns {HTMLElement}
	 */
	function createIcon(iconName, gridOptionsWrapper, column) {
	    var iconContents = createIconNoSpan(iconName, gridOptionsWrapper, column);
	    if (iconContents && iconContents.className.indexOf('ag-icon') > -1) {
	        return iconContents;
	    }
	    var eResult = document.createElement('span');
	    eResult.appendChild(iconContents);
	    return eResult;
	}
	function createIconNoSpan(iconName, gridOptionsWrapper, column, forceCreate) {
	    var userProvidedIcon = null;
	    // check col for icon first
	    var icons = column && column.getColDef().icons;
	    if (icons) {
	        userProvidedIcon = icons[iconName];
	    }
	    // if not in col, try grid options
	    if (gridOptionsWrapper && !userProvidedIcon) {
	        var optionsIcons = gridOptionsWrapper.getIcons();
	        if (optionsIcons) {
	            userProvidedIcon = optionsIcons[iconName];
	        }
	    }
	    // now if user provided, use it
	    if (userProvidedIcon) {
	        var rendererResult = void 0;
	        if (typeof userProvidedIcon === 'function') {
	            rendererResult = userProvidedIcon();
	        }
	        else if (typeof userProvidedIcon === 'string') {
	            rendererResult = userProvidedIcon;
	        }
	        else {
	            throw new Error('icon from grid options needs to be a string or a function');
	        }
	        if (typeof rendererResult === 'string') {
	            return loadTemplate(rendererResult);
	        }
	        if (isNodeOrElement(rendererResult)) {
	            return rendererResult;
	        }
	        console.warn('AG Grid: iconRenderer should return back a string or a dom object');
	    }
	    else {
	        var span = document.createElement('span');
	        var cssClass = iconNameClassMap[iconName];
	        if (!cssClass) {
	            if (!forceCreate) {
	                console.warn("AG Grid: Did not find icon " + iconName);
	                cssClass = '';
	            }
	            else {
	                cssClass = iconName;
	            }
	        }
	        span.setAttribute('class', "ag-icon ag-icon-" + cssClass);
	        span.setAttribute('unselectable', 'on');
	        span.setAttribute('role', 'presentation');
	        return span;
	    }
	}

	var IconUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    iconNameClassMap: iconNameClassMap,
	    createIcon: createIcon,
	    createIconNoSpan: createIconNoSpan
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var NUMPAD_DEL_NUMLOCK_ON_KEY = 'Del';
	var NUMPAD_DEL_NUMLOCK_ON_CHARCODE = 46;
	function isKeyPressed(event, keyToCheck) {
	    return (event.which || event.keyCode) === keyToCheck;
	}
	function isEventFromPrintableCharacter(event) {
	    // no allowed printable chars have alt or ctrl key combinations
	    if (event.altKey || event.ctrlKey || event.metaKey) {
	        return false;
	    }
	    // if key is length 1, eg if it is 'a' for the a key, or '2' for the '2' key.
	    // non-printable characters have names, eg 'Enter' or 'Backspace'.
	    var printableCharacter = event.key.length === 1;
	    // IE11 & Edge treat the numpad del key differently - with numlock on we get "Del" for key,
	    // so this addition checks if its IE11/Edge and handles that specific case the same was as all other browsers
	    var numpadDelWithNumlockOnForEdgeOrIe = isNumpadDelWithNumlockOnForEdgeOrIe(event);
	    return printableCharacter || numpadDelWithNumlockOnForEdgeOrIe;
	}
	/**
	 * Allows user to tell the grid to skip specific keyboard events
	 * @param {GridOptionsWrapper} gridOptionsWrapper
	 * @param {KeyboardEvent} keyboardEvent
	 * @param {RowNode} rowNode
	 * @param {Column} column
	 * @param {boolean} editing
	 * @returns {boolean}
	 */
	function isUserSuppressingKeyboardEvent(gridOptionsWrapper, keyboardEvent, rowNode, column, editing) {
	    var gridOptionsFunc = gridOptionsWrapper.getSuppressKeyboardEventFunc();
	    var colDefFunc = column ? column.getColDef().suppressKeyboardEvent : undefined;
	    // if no callbacks provided by user, then do nothing
	    if (!gridOptionsFunc && !colDefFunc) {
	        return false;
	    }
	    var params = {
	        event: keyboardEvent,
	        editing: editing,
	        column: column,
	        api: gridOptionsWrapper.getApi(),
	        node: rowNode,
	        data: rowNode.data,
	        colDef: column.getColDef(),
	        context: gridOptionsWrapper.getContext(),
	        columnApi: gridOptionsWrapper.getColumnApi()
	    };
	    // colDef get first preference on suppressing events
	    if (colDefFunc) {
	        var colDefFuncResult = colDefFunc(params);
	        // if colDef func suppressed, then return now, no need to call gridOption func
	        if (colDefFuncResult) {
	            return true;
	        }
	    }
	    if (gridOptionsFunc) {
	        // if gridOption func, return the result
	        return gridOptionsFunc(params);
	    }
	    // otherwise return false, don't suppress, as colDef didn't suppress and no func on gridOptions
	    return false;
	}
	function isUserSuppressingHeaderKeyboardEvent(gridOptionsWrapper, keyboardEvent, headerRowIndex, column) {
	    var colDef = column.getDefinition();
	    var colDefFunc = colDef && colDef.suppressHeaderKeyboardEvent;
	    if (!exists(colDefFunc)) {
	        return false;
	    }
	    var params = {
	        api: gridOptionsWrapper.getApi(),
	        columnApi: gridOptionsWrapper.getColumnApi(),
	        context: gridOptionsWrapper.getContext(),
	        colDef: colDef,
	        column: column,
	        headerRowIndex: headerRowIndex,
	        event: keyboardEvent
	    };
	    return !!colDefFunc(params);
	}
	function isNumpadDelWithNumlockOnForEdgeOrIe(event) {
	    return (isBrowserEdge() || isBrowserIE()) &&
	        event.key === NUMPAD_DEL_NUMLOCK_ON_KEY &&
	        event.charCode === NUMPAD_DEL_NUMLOCK_ON_CHARCODE;
	}

	var KeyboardUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    isKeyPressed: isKeyPressed,
	    isEventFromPrintableCharacter: isEventFromPrintableCharacter,
	    isUserSuppressingKeyboardEvent: isUserSuppressingKeyboardEvent,
	    isUserSuppressingHeaderKeyboardEvent: isUserSuppressingHeaderKeyboardEvent
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/**
	 * @deprecated
	 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	 * complicated, thus this doc is long and (hopefully) detailed enough to answer
	 * your questions.
	 *
	 * If you need to react to the mouse wheel in a predictable way, this code is
	 * like your bestest friend. * hugs *
	 *
	 * As of today, there are 4 DOM event types you can listen to:
	 *
	 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	 *
	 * So what to do?  The is the best:
	 *
	 *   normalizeWheel.getEventType();
	 *
	 * In your event callback, use this code to get sane interpretation of the
	 * deltas.  This code will return an object with properties:
	 *
	 *   spinX   -- normalized spin speed (use for zoom) - x plane
	 *   spinY   -- " - y plane
	 *   pixelX  -- normalized distance (to pixels) - x plane
	 *   pixelY  -- " - y plane
	 *
	 * Wheel values are provided by the browser assuming you are using the wheel to
	 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	 * significantly on different platforms and browsers, forgetting that you can
	 * scroll at different speeds.  Some devices (like trackpads) emit more events
	 * at smaller increments with fine granularity, and some emit massive jumps with
	 * linear speed or acceleration.
	 *
	 * This code does its best to normalize the deltas for you:
	 *
	 *   - spin is trying to normalize how far the wheel was spun (or trackpad
	 *     dragged).  This is super useful for zoom support where you want to
	 *     throw away the chunky scroll steps on the PC and make those equal to
	 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	 *     resolve a single slow step on a wheel to 1.
	 *
	 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	 *     get the crazy differences between browsers, but at least it'll be in
	 *     pixels!
	 *
	 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	 *     should translate to positive value zooming IN, negative zooming OUT.
	 *     This matches the newer 'wheel' event.
	 *
	 * Why are there spinX, spinY (or pixels)?
	 *
	 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	 *     with a mouse.  It results in side-scrolling in the browser by default.
	 *
	 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	 *
	 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	 *     probably is by browsers in conjunction with fancy 3D controllers .. but
	 *     you know.
	 *
	 * Implementation info:
	 *
	 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	 * average mouse:
	 *
	 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	 *
	 * On the trackpad:
	 *
	 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	 *
	 * On other/older browsers.. it's more complicated as there can be multiple and
	 * also missing delta values.
	 *
	 * The 'wheel' event is more standard:
	 *
	 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	 *
	 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	 * backward compatibility with older events.  Those other values help us
	 * better normalize spin speed.  Example of what the browsers provide:
	 *
	 *                          | event.wheelDelta | event.detail
	 *        ------------------+------------------+--------------
	 *          Safari v5/OS X  |       -120       |       0
	 *          Safari v5/Win7  |       -120       |       0
	 *         Chrome v17/OS X  |       -120       |       0
	 *         Chrome v17/Win7  |       -120       |       0
	 *                IE9/Win7  |       -120       |   undefined
	 *         Firefox v4/OS X  |     undefined    |       1
	 *         Firefox v4/Win7  |     undefined    |       3
	 *
	 * from: https://github.com/facebook/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
	 * @param {any} event
	 * @return {any}
	 */
	function normalizeWheel(event) {
	    var PIXEL_STEP = 10;
	    var LINE_HEIGHT = 40;
	    var PAGE_HEIGHT = 800;
	    // spinX, spinY
	    var sX = 0;
	    var sY = 0;
	    // pixelX, pixelY
	    var pX = 0;
	    var pY = 0;
	    // Legacy
	    if ('detail' in event) {
	        sY = event.detail;
	    }
	    if ('wheelDelta' in event) {
	        sY = -event.wheelDelta / 120;
	    }
	    if ('wheelDeltaY' in event) {
	        sY = -event.wheelDeltaY / 120;
	    }
	    if ('wheelDeltaX' in event) {
	        sX = -event.wheelDeltaX / 120;
	    }
	    // side scrolling on FF with DOMMouseScroll
	    if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
	        sX = sY;
	        sY = 0;
	    }
	    pX = sX * PIXEL_STEP;
	    pY = sY * PIXEL_STEP;
	    if ('deltaY' in event) {
	        pY = event.deltaY;
	    }
	    if ('deltaX' in event) {
	        pX = event.deltaX;
	    }
	    if ((pX || pY) && event.deltaMode) {
	        if (event.deltaMode == 1) { // delta in LINE units
	            pX *= LINE_HEIGHT;
	            pY *= LINE_HEIGHT;
	        }
	        else { // delta in PAGE units
	            pX *= PAGE_HEIGHT;
	            pY *= PAGE_HEIGHT;
	        }
	    }
	    // Fall-back if spin cannot be determined
	    if (pX && !sX) {
	        sX = (pX < 1) ? -1 : 1;
	    }
	    if (pY && !sY) {
	        sY = (pY < 1) ? -1 : 1;
	    }
	    return {
	        spinX: sX,
	        spinY: sY,
	        pixelX: pX,
	        pixelY: pY
	    };
	}
	/**
	 * @deprecated
	 * Checks if event was issued by a left click
	 * from https://stackoverflow.com/questions/3944122/detect-left-mouse-button-press
	 * @param {MouseEvent} mouseEvent
	 * @returns {boolean}
	 */
	function isLeftClick(mouseEvent) {
	    if ('buttons' in mouseEvent) {
	        return mouseEvent.buttons == 1;
	    }
	    var button = mouseEvent.which || mouseEvent.button;
	    return button == 1;
	}
	/**
	 * `True` if the event is close to the original event by X pixels either vertically or horizontally.
	 * we only start dragging after X pixels so this allows us to know if we should start dragging yet.
	 * @param {MouseEvent | TouchEvent} e1
	 * @param {MouseEvent | TouchEvent} e2
	 * @param {number} pixelCount
	 * @returns {boolean}
	 */
	function areEventsNear(e1, e2, pixelCount) {
	    // by default, we wait 4 pixels before starting the drag
	    if (pixelCount === 0) {
	        return false;
	    }
	    var diffX = Math.abs(e1.clientX - e2.clientX);
	    var diffY = Math.abs(e1.clientY - e2.clientY);
	    return Math.max(diffX, diffY) <= pixelCount;
	}

	var MouseUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    normalizeWheel: normalizeWheel,
	    isLeftClick: isLeftClick,
	    areEventsNear: areEventsNear
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/**
	 * Gets called by: a) ClientSideNodeManager and b) GroupStage to do sorting.
	 * when in ClientSideNodeManager we always have indexes (as this sorts the items the
	 * user provided) but when in GroupStage, the nodes can contain filler nodes that
	 * don't have order id's
	 * @param {RowNode[]} rowNodes
	 * @param {Object} rowNodeOrder
	 */
	function sortRowNodesByOrder(rowNodes, rowNodeOrder) {
	    if (!rowNodes) {
	        return;
	    }
	    var comparator = function (nodeA, nodeB) {
	        var positionA = rowNodeOrder[nodeA.id];
	        var positionB = rowNodeOrder[nodeB.id];
	        var aHasIndex = positionA !== undefined;
	        var bHasIndex = positionB !== undefined;
	        var bothNodesAreUserNodes = aHasIndex && bHasIndex;
	        var bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
	        if (bothNodesAreUserNodes) {
	            // when comparing two nodes the user has provided, they always
	            // have indexes
	            return positionA - positionB;
	        }
	        if (bothNodesAreFillerNodes) {
	            // when comparing two filler nodes, we have no index to compare them
	            // against, however we want this sorting to be deterministic, so that
	            // the rows don't jump around as the user does delta updates. so we
	            // want the same sort result. so we use the __objectId - which doesn't make sense
	            // from a sorting point of view, but does give consistent behaviour between
	            // calls. otherwise groups jump around as delta updates are done.
	            // note: previously here we used nodeId, however this gave a strange order
	            // as string ordering of numbers is wrong, so using id based on creation order
	            // as least gives better looking order.
	            return nodeA.__objectId - nodeB.__objectId;
	        }
	        if (aHasIndex) {
	            return 1;
	        }
	        return -1;
	    };
	    // check if the list first needs sorting
	    var rowNodeA;
	    var rowNodeB;
	    var atLeastOneOutOfOrder = false;
	    for (var i = 0; i < rowNodes.length - 1; i++) {
	        rowNodeA = rowNodes[i];
	        rowNodeB = rowNodes[i + 1];
	        if (comparator(rowNodeA, rowNodeB) > 0) {
	            atLeastOneOutOfOrder = true;
	            break;
	        }
	    }
	    if (atLeastOneOutOfOrder) {
	        rowNodes.sort(comparator);
	    }
	}
	function traverseNodesWithKey(nodes, callback) {
	    var keyParts = [];
	    recursiveSearchNodes(nodes);
	    function recursiveSearchNodes(currentNodes) {
	        if (!currentNodes) {
	            return;
	        }
	        currentNodes.forEach(function (node) {
	            // also checking for children for tree data
	            if (node.group || node.hasChildren()) {
	                keyParts.push(node.key);
	                var key = keyParts.join('|');
	                callback(node, key);
	                recursiveSearchNodes(node.childrenAfterGroup);
	                keyParts.pop();
	            }
	        });
	    }
	}

	var RowNodeUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    sortRowNodesByOrder: sortRowNodesByOrder,
	    traverseNodesWithKey: traverseNodesWithKey
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function convertToSet(list) {
	    var set = new Set();
	    list.forEach(function (x) { return set.add(x); });
	    return set;
	}

	var SetUtils = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    convertToSet: convertToSet
	});

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __assign$1 = function () {
	    __assign$1 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$1.apply(this, arguments);
	};
	var utils = __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, GeneralUtils), AriaUtils), ArrayUtils), BrowserUtils), CsvUtils), DateUtils), DomUtils), EventUtils), FunctionUtils), FuzzyMatchUtils), GenericUtils), IconUtils), KeyboardUtils), MapUtils), MouseUtils), NumberUtils), ObjectUtils), RowNodeUtils), SetUtils), StringUtils);
	var _ = utils;

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var NumberSequence = /** @class */ (function () {
	    function NumberSequence(initValue, step) {
	        if (initValue === void 0) { initValue = 0; }
	        if (step === void 0) { step = 1; }
	        this.nextValue = initValue;
	        this.step = step;
	    }
	    NumberSequence.prototype.next = function () {
	        var valToReturn = this.nextValue;
	        this.nextValue += this.step;
	        return valToReturn;
	    };
	    NumberSequence.prototype.peek = function () {
	        return this.nextValue;
	    };
	    NumberSequence.prototype.skip = function (count) {
	        this.nextValue += count;
	    };
	    return NumberSequence;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (AgPromiseStatus) {
	    AgPromiseStatus[AgPromiseStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
	    AgPromiseStatus[AgPromiseStatus["RESOLVED"] = 1] = "RESOLVED";
	})(exports.AgPromiseStatus || (exports.AgPromiseStatus = {}));
	var AgPromise = /** @class */ (function () {
	    function AgPromise(callback) {
	        var _this = this;
	        this.status = exports.AgPromiseStatus.IN_PROGRESS;
	        this.resolution = null;
	        this.waiters = [];
	        callback(function (value) { return _this.onDone(value); }, function (params) { return _this.onReject(params); });
	    }
	    AgPromise.all = function (promises) {
	        return new AgPromise(function (resolve) {
	            var remainingToResolve = promises.length;
	            var combinedValues = new Array(remainingToResolve);
	            forEach(promises, function (promise, index) {
	                promise.then(function (value) {
	                    combinedValues[index] = value;
	                    remainingToResolve--;
	                    if (remainingToResolve === 0) {
	                        resolve(combinedValues);
	                    }
	                });
	            });
	        });
	    };
	    AgPromise.resolve = function (value) {
	        if (value === void 0) { value = null; }
	        return new AgPromise(function (resolve) { return resolve(value); });
	    };
	    AgPromise.prototype.then = function (func) {
	        var _this = this;
	        return new AgPromise(function (resolve) {
	            if (_this.status === exports.AgPromiseStatus.RESOLVED) {
	                resolve(func(_this.resolution));
	            }
	            else {
	                _this.waiters.push(function (value) { return resolve(func(value)); });
	            }
	        });
	    };
	    AgPromise.prototype.resolveNow = function (ifNotResolvedValue, ifResolved) {
	        return this.status === exports.AgPromiseStatus.RESOLVED ? ifResolved(this.resolution) : ifNotResolvedValue;
	    };
	    AgPromise.prototype.onDone = function (value) {
	        this.status = exports.AgPromiseStatus.RESOLVED;
	        this.resolution = value;
	        forEach(this.waiters, function (waiter) { return waiter(value); });
	    };
	    AgPromise.prototype.onReject = function (params) {
	        console.warn('TBI');
	    };
	    return AgPromise;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/**
	 * A Util Class only used when debugging for printing time to console
	 */
	var Timer = /** @class */ (function () {
	    function Timer() {
	        this.timestamp = new Date().getTime();
	    }
	    Timer.prototype.print = function (msg) {
	        var duration = (new Date().getTime()) - this.timestamp;
	        console.info(msg + " = " + duration);
	        this.timestamp = new Date().getTime();
	    };
	    return Timer;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$5 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign$2 = function () {
	    __assign$2 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$2.apply(this, arguments);
	};
	var __decorate$9 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TooltipStates;
	(function (TooltipStates) {
	    TooltipStates[TooltipStates["NOTHING"] = 0] = "NOTHING";
	    TooltipStates[TooltipStates["WAITING_TO_SHOW"] = 1] = "WAITING_TO_SHOW";
	    TooltipStates[TooltipStates["SHOWING"] = 2] = "SHOWING";
	})(TooltipStates || (TooltipStates = {}));
	var TooltipFeature = /** @class */ (function (_super) {
	    __extends$5(TooltipFeature, _super);
	    function TooltipFeature(parentComp) {
	        var _this = _super.call(this) || this;
	        _this.DEFAULT_HIDE_TOOLTIP_TIMEOUT = 10000;
	        _this.SHOW_QUICK_TOOLTIP_DIFF = 1000;
	        _this.FADE_OUT_TOOLTIP_TIMEOUT = 1000;
	        _this.state = TooltipStates.NOTHING;
	        // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
	        // async we could request two tooltips before the first instance returns, in which case we should
	        // disregard the second instance.
	        _this.tooltipInstanceCount = 0;
	        _this.tooltipMouseTrack = false;
	        _this.parentComp = parentComp;
	        return _this;
	    }
	    TooltipFeature.prototype.postConstruct = function () {
	        this.tooltipShowDelay = this.gridOptionsWrapper.getTooltipShowDelay() || 2000;
	        this.tooltipMouseTrack = this.gridOptionsWrapper.isTooltipMouseTrack();
	        var el = this.parentComp.getGui();
	        this.addManagedListener(el, 'mouseenter', this.onMouseEnter.bind(this));
	        this.addManagedListener(el, 'mouseleave', this.onMouseLeave.bind(this));
	        this.addManagedListener(el, 'mousemove', this.onMouseMove.bind(this));
	        this.addManagedListener(el, 'mousedown', this.onMouseDown.bind(this));
	        this.addManagedListener(el, 'keydown', this.onKeyDown.bind(this));
	    };
	    TooltipFeature.prototype.destroy = function () {
	        // if this component gets destroyed while tooltip is showing, need to make sure
	        // we don't end with no mouseLeave event resulting in zombie tooltip
	        this.setToDoNothing();
	        _super.prototype.destroy.call(this);
	    };
	    TooltipFeature.prototype.onMouseEnter = function (e) {
	        // every mouseenter should be following by a mouseleave, however for some unkonwn, it's possible for
	        // mouseenter to be called twice in a row, which can happen if editing the cell. this was reported
	        // in https://ag-grid.atlassian.net/browse/AG-4422. to get around this, we check the state, and if
	        // state is !=nothing, then we know mouseenter was already received.
	        if (this.state != TooltipStates.NOTHING) {
	            return;
	        }
	        // if another tooltip was hidden very recently, we only wait 200ms to show, not the normal waiting time
	        var delay = this.isLastTooltipHiddenRecently() ? 200 : this.tooltipShowDelay;
	        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
	        this.lastMouseEvent = e;
	        this.state = TooltipStates.WAITING_TO_SHOW;
	    };
	    TooltipFeature.prototype.onMouseLeave = function () {
	        this.setToDoNothing();
	    };
	    TooltipFeature.prototype.onKeyDown = function () {
	        this.setToDoNothing();
	    };
	    TooltipFeature.prototype.setToDoNothing = function () {
	        if (this.state === TooltipStates.SHOWING) {
	            this.hideTooltip();
	        }
	        this.clearTimeouts();
	        this.state = TooltipStates.NOTHING;
	    };
	    TooltipFeature.prototype.onMouseMove = function (e) {
	        // there is a delay from the time we mouseOver a component and the time the
	        // tooltip is displayed, so we need to track mousemove to be able to correctly
	        // position the tooltip when showTooltip is called.
	        this.lastMouseEvent = e;
	        if (this.tooltipMouseTrack &&
	            this.state === TooltipStates.SHOWING &&
	            this.tooltipComp) {
	            this.positionTooltipUnderLastMouseEvent();
	        }
	    };
	    TooltipFeature.prototype.onMouseDown = function () {
	        this.setToDoNothing();
	    };
	    TooltipFeature.prototype.hideTooltip = function () {
	        // check if comp exists - due to async, although we asked for
	        // one, the instance may not be back yet
	        if (this.tooltipComp) {
	            this.destroyTooltipComp();
	            TooltipFeature.lastTooltipHideTime = new Date().getTime();
	        }
	        this.state = TooltipStates.NOTHING;
	    };
	    TooltipFeature.prototype.destroyTooltipComp = function () {
	        var _this = this;
	        // add class to fade out the tooltip
	        addCssClass(this.tooltipComp.getGui(), 'ag-tooltip-hiding');
	        // make local copies of these variables, as we use them in the async function below,
	        // and we clear then to 'undefined' later, so need to take a copy before they are undefined.
	        var tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
	        var tooltipComp = this.tooltipComp;
	        window.setTimeout(function () {
	            tooltipPopupDestroyFunc();
	            _this.getContext().destroyBean(tooltipComp);
	        }, this.FADE_OUT_TOOLTIP_TIMEOUT);
	        this.tooltipPopupDestroyFunc = undefined;
	        this.tooltipComp = undefined;
	    };
	    TooltipFeature.prototype.isLastTooltipHiddenRecently = function () {
	        // return true if <1000ms since last time we hid a tooltip
	        var now = new Date().getTime();
	        var then = TooltipFeature.lastTooltipHideTime;
	        return (now - then) < this.SHOW_QUICK_TOOLTIP_DIFF;
	    };
	    TooltipFeature.prototype.showTooltip = function () {
	        var params = __assign$2({ api: this.gridApi, columnApi: this.columnApi, context: this.gridOptionsWrapper.getContext() }, this.parentComp.getTooltipParams());
	        if (!exists(params.value)) {
	            this.setToDoNothing();
	            return;
	        }
	        this.state = TooltipStates.SHOWING;
	        this.tooltipInstanceCount++;
	        // we pass in tooltipInstanceCount so the callback knows what the count was when
	        // we requested the tooltip, so if another tooltip was requested in the mean time
	        // we disregard it
	        var callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
	        this.userComponentFactory.newTooltipComponent(params).then(callback);
	    };
	    TooltipFeature.prototype.newTooltipComponentCallback = function (tooltipInstanceCopy, tooltipComp) {
	        var compNoLongerNeeded = this.state !== TooltipStates.SHOWING || this.tooltipInstanceCount !== tooltipInstanceCopy;
	        if (compNoLongerNeeded) {
	            this.getContext().destroyBean(tooltipComp);
	            return;
	        }
	        var eGui = tooltipComp.getGui();
	        this.tooltipComp = tooltipComp;
	        if (!containsClass(eGui, 'ag-tooltip')) {
	            addCssClass(eGui, 'ag-tooltip-custom');
	        }
	        var addPopupRes = this.popupService.addPopup({
	            eChild: eGui
	        });
	        if (addPopupRes) {
	            this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
	        }
	        // this.tooltipPopupDestroyFunc = this.popupService.addPopup(false, eGui, false);
	        this.positionTooltipUnderLastMouseEvent();
	        this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.DEFAULT_HIDE_TOOLTIP_TIMEOUT);
	    };
	    TooltipFeature.prototype.positionTooltipUnderLastMouseEvent = function () {
	        this.popupService.positionPopupUnderMouseEvent({
	            type: 'tooltip',
	            mouseEvent: this.lastMouseEvent,
	            ePopup: this.tooltipComp.getGui(),
	            nudgeY: 18
	        });
	    };
	    TooltipFeature.prototype.clearTimeouts = function () {
	        if (this.showTooltipTimeoutId) {
	            window.clearTimeout(this.showTooltipTimeoutId);
	            this.showTooltipTimeoutId = undefined;
	        }
	        if (this.hideTooltipTimeoutId) {
	            window.clearTimeout(this.hideTooltipTimeoutId);
	            this.hideTooltipTimeoutId = undefined;
	        }
	    };
	    __decorate$9([
	        Autowired('popupService')
	    ], TooltipFeature.prototype, "popupService", void 0);
	    __decorate$9([
	        Autowired('userComponentFactory')
	    ], TooltipFeature.prototype, "userComponentFactory", void 0);
	    __decorate$9([
	        Autowired('columnApi')
	    ], TooltipFeature.prototype, "columnApi", void 0);
	    __decorate$9([
	        Autowired('gridApi')
	    ], TooltipFeature.prototype, "gridApi", void 0);
	    __decorate$9([
	        PostConstruct
	    ], TooltipFeature.prototype, "postConstruct", null);
	    return TooltipFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$6 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$a = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var compIdSequence = new NumberSequence();
	var elementGettingCreated;
	var Component = /** @class */ (function (_super) {
	    __extends$6(Component, _super);
	    function Component(template) {
	        var _this = _super.call(this) || this;
	        _this.annotatedGuiListeners = [];
	        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
	        _this.displayed = true;
	        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
	        _this.visible = true;
	        // unique id for this row component. this is used for getting a reference to the HTML dom.
	        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
	        // around as we create a new rowComp instance for the same row node).
	        _this.compId = compIdSequence.next();
	        // to minimise DOM hits, we only apply CSS classes if they have changed. as addding a CSS class that is already
	        // there, or removing one that wasn't present, all takes CPU.
	        _this.cssClassStates = {};
	        if (template) {
	            _this.setTemplate(template);
	        }
	        return _this;
	    }
	    Component.prototype.preConstructOnComponent = function () {
	        this.usingBrowserTooltips = this.gridOptionsWrapper.isEnableBrowserTooltips();
	    };
	    Component.prototype.getCompId = function () {
	        return this.compId;
	    };
	    Component.prototype.getTooltipParams = function () {
	        return {
	            value: this.tooltipText,
	            location: 'UNKNOWN'
	        };
	    };
	    Component.prototype.setTooltip = function (newTooltipText) {
	        var _this = this;
	        var removeTooltip = function () {
	            if (_this.usingBrowserTooltips) {
	                _this.getGui().removeAttribute('title');
	            }
	            else {
	                _this.tooltipFeature = _this.destroyBean(_this.tooltipFeature);
	            }
	        };
	        var addTooltip = function () {
	            if (_this.usingBrowserTooltips) {
	                _this.getGui().setAttribute('title', _this.tooltipText);
	            }
	            else {
	                _this.tooltipFeature = _this.createBean(new TooltipFeature(_this));
	            }
	        };
	        if (this.tooltipText != newTooltipText) {
	            if (this.tooltipText) {
	                removeTooltip();
	            }
	            if (newTooltipText != null) {
	                this.tooltipText = newTooltipText;
	                if (this.tooltipText) {
	                    addTooltip();
	                }
	            }
	        }
	    };
	    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
	    Component.prototype.createChildComponentsFromTags = function (parentNode, paramsMap) {
	        var _this = this;
	        // we MUST take a copy of the list first, as the 'swapComponentForNode' adds comments into the DOM
	        // which messes up the traversal order of the children.
	        var childNodeList = copyNodeList(parentNode.childNodes);
	        forEach(childNodeList, function (childNode) {
	            if (!(childNode instanceof HTMLElement)) {
	                return;
	            }
	            var childComp = _this.createComponentFromElement(childNode, function (comp) {
	                // copy over all attributes, including css classes, so any attributes user put on the tag
	                // wll be carried across
	                _this.copyAttributesFromNode(childNode, comp.getGui());
	            }, paramsMap);
	            if (childComp) {
	                if (childComp.addItems && childNode.children.length) {
	                    _this.createChildComponentsFromTags(childNode, paramsMap);
	                    // converting from HTMLCollection to Array
	                    var items = Array.prototype.slice.call(childNode.children);
	                    childComp.addItems(items);
	                }
	                // replace the tag (eg ag-checkbox) with the proper HTMLElement (eg 'div') in the dom
	                _this.swapComponentForNode(childComp, parentNode, childNode);
	            }
	            else if (childNode.childNodes) {
	                _this.createChildComponentsFromTags(childNode, paramsMap);
	            }
	        });
	    };
	    Component.prototype.createComponentFromElement = function (element, afterPreCreateCallback, paramsMap) {
	        var key = element.nodeName;
	        var componentParams = paramsMap ? paramsMap[element.getAttribute('ref')] : undefined;
	        var ComponentClass = this.agStackComponentsRegistry.getComponentClass(key);
	        if (ComponentClass) {
	            elementGettingCreated = element;
	            var newComponent = new ComponentClass(componentParams);
	            newComponent.setParentComponent(this);
	            this.createBean(newComponent, null, afterPreCreateCallback);
	            return newComponent;
	        }
	        return null;
	    };
	    Component.prototype.copyAttributesFromNode = function (source, dest) {
	        iterateNamedNodeMap(source.attributes, function (name, value) { return dest.setAttribute(name, value); });
	    };
	    Component.prototype.swapComponentForNode = function (newComponent, parentNode, childNode) {
	        var eComponent = newComponent.getGui();
	        parentNode.replaceChild(eComponent, childNode);
	        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
	        this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
	        this.swapInComponentForQuerySelectors(newComponent, childNode);
	    };
	    Component.prototype.swapInComponentForQuerySelectors = function (newComponent, childNode) {
	        var thisNoType = this;
	        this.iterateOverQuerySelectors(function (querySelector) {
	            if (thisNoType[querySelector.attributeName] === childNode) {
	                thisNoType[querySelector.attributeName] = newComponent;
	            }
	        });
	    };
	    Component.prototype.iterateOverQuerySelectors = function (action) {
	        var thisPrototype = Object.getPrototypeOf(this);
	        while (thisPrototype != null) {
	            var metaData = thisPrototype.__agComponentMetaData;
	            var currentProtoName = getFunctionName(thisPrototype.constructor);
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
	                forEach(metaData[currentProtoName].querySelectors, function (querySelector) { return action(querySelector); });
	            }
	            thisPrototype = Object.getPrototypeOf(thisPrototype);
	        }
	    };
	    Component.prototype.setTemplate = function (template, paramsMap) {
	        var eGui = loadTemplate(template);
	        this.setTemplateFromElement(eGui, paramsMap);
	    };
	    Component.prototype.setTemplateFromElement = function (element, paramsMap) {
	        this.eGui = element;
	        this.eGui.__agComponent = this;
	        this.addAnnotatedGuiEventListeners();
	        this.wireQuerySelectors();
	        // context will not be available when user sets template in constructor
	        if (!!this.getContext()) {
	            this.createChildComponentsFromTags(this.getGui(), paramsMap);
	        }
	    };
	    Component.prototype.createChildComponentsPreConstruct = function () {
	        // ui exists if user sets template in constructor. when this happens, we have to wait for the context
	        // to be autoWired first before we can create child components.
	        if (!!this.getGui()) {
	            this.createChildComponentsFromTags(this.getGui());
	        }
	    };
	    Component.prototype.wireQuerySelectors = function () {
	        var _this = this;
	        if (!this.eGui) {
	            return;
	        }
	        var thisNoType = this;
	        this.iterateOverQuerySelectors(function (querySelector) {
	            var setResult = function (result) { return thisNoType[querySelector.attributeName] = result; };
	            // if it's a ref selector, and match is on top level component, we return
	            // the element. otherwise no way of components putting ref=xxx on the top
	            // level element as querySelector only looks at children.
	            var topLevelRefMatch = querySelector.refSelector
	                && _this.eGui.getAttribute('ref') === querySelector.refSelector;
	            if (topLevelRefMatch) {
	                setResult(_this.eGui);
	            }
	            else {
	                // otherwise use querySelector, which looks at children
	                var resultOfQuery = _this.eGui.querySelector(querySelector.querySelector);
	                if (resultOfQuery) {
	                    setResult(resultOfQuery.__agComponent || resultOfQuery);
	                }
	            }
	        });
	    };
	    Component.prototype.addAnnotatedGuiEventListeners = function () {
	        var _this = this;
	        this.removeAnnotatedGuiEventListeners();
	        if (!this.eGui) {
	            return;
	        }
	        var listenerMethods = this.getAgComponentMetaData('guiListenerMethods');
	        if (!listenerMethods) {
	            return;
	        }
	        if (!this.annotatedGuiListeners) {
	            this.annotatedGuiListeners = [];
	        }
	        listenerMethods.forEach(function (meta) {
	            var element = _this.getRefElement(meta.ref);
	            if (!element) {
	                return;
	            }
	            var listener = _this[meta.methodName].bind(_this);
	            element.addEventListener(meta.eventName, listener);
	            _this.annotatedGuiListeners.push({ eventName: meta.eventName, listener: listener, element: element });
	        });
	    };
	    Component.prototype.addAnnotatedGridEventListeners = function () {
	        var _this = this;
	        var listenerMetas = this.getAgComponentMetaData('gridListenerMethods');
	        if (!listenerMetas) {
	            return;
	        }
	        listenerMetas.forEach(function (meta) {
	            var listener = _this[meta.methodName].bind(_this);
	            _this.addManagedListener(_this.eventService, meta.eventName, listener);
	        });
	    };
	    Component.prototype.getAgComponentMetaData = function (key) {
	        var res = [];
	        var thisProto = Object.getPrototypeOf(this);
	        while (thisProto != null) {
	            var metaData = thisProto.__agComponentMetaData;
	            var currentProtoName = getFunctionName(thisProto.constructor);
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName][key]) {
	                res = res.concat(metaData[currentProtoName][key]);
	            }
	            thisProto = Object.getPrototypeOf(thisProto);
	        }
	        return res;
	    };
	    Component.prototype.removeAnnotatedGuiEventListeners = function () {
	        if (!this.annotatedGuiListeners) {
	            return;
	        }
	        forEach(this.annotatedGuiListeners, function (e) {
	            e.element.removeEventListener(e.eventName, e.listener);
	        });
	        this.annotatedGuiListeners = [];
	    };
	    Component.prototype.getGui = function () {
	        return this.eGui;
	    };
	    Component.prototype.getFocusableElement = function () {
	        return this.eGui;
	    };
	    Component.prototype.setParentComponent = function (component) {
	        this.parentComponent = component;
	    };
	    Component.prototype.getParentComponent = function () {
	        return this.parentComponent;
	    };
	    // this method is for older code, that wants to provide the gui element,
	    // it is not intended for this to be in ag-Stack
	    Component.prototype.setGui = function (eGui) {
	        this.eGui = eGui;
	    };
	    Component.prototype.queryForHtmlElement = function (cssSelector) {
	        return this.eGui.querySelector(cssSelector);
	    };
	    Component.prototype.queryForHtmlInputElement = function (cssSelector) {
	        return this.eGui.querySelector(cssSelector);
	    };
	    Component.prototype.appendChild = function (newChild, container) {
	        if (!container) {
	            container = this.eGui;
	        }
	        if (newChild == null) {
	            return;
	        }
	        if (isNodeOrElement(newChild)) {
	            container.appendChild(newChild);
	        }
	        else {
	            var childComponent = newChild;
	            container.appendChild(childComponent.getGui());
	            this.addDestroyFunc(this.destroyBean.bind(this, childComponent));
	        }
	    };
	    Component.prototype.isDisplayed = function () {
	        return this.displayed;
	    };
	    Component.prototype.setVisible = function (visible) {
	        if (visible !== this.visible) {
	            this.visible = visible;
	            setVisible(this.eGui, visible);
	        }
	    };
	    Component.prototype.setDisplayed = function (displayed) {
	        if (displayed !== this.displayed) {
	            this.displayed = displayed;
	            setDisplayed(this.eGui, displayed);
	            var event_1 = {
	                type: Component.EVENT_DISPLAYED_CHANGED,
	                visible: this.displayed
	            };
	            this.dispatchEvent(event_1);
	        }
	    };
	    Component.prototype.destroy = function () {
	        this.removeAnnotatedGuiEventListeners();
	        if (this.tooltipFeature) {
	            this.tooltipFeature = this.destroyBean(this.tooltipFeature);
	        }
	        _super.prototype.destroy.call(this);
	    };
	    Component.prototype.addGuiEventListener = function (event, listener) {
	        var _this = this;
	        this.eGui.addEventListener(event, listener);
	        this.addDestroyFunc(function () { return _this.eGui.removeEventListener(event, listener); });
	    };
	    Component.prototype.addCssClass = function (className) {
	        var updateNeeded = this.cssClassStates[className] !== true;
	        if (updateNeeded) {
	            addCssClass(this.eGui, className);
	            this.cssClassStates[className] = true;
	        }
	    };
	    Component.prototype.removeCssClass = function (className) {
	        var updateNeeded = this.cssClassStates[className] !== false;
	        if (updateNeeded) {
	            removeCssClass(this.eGui, className);
	            this.cssClassStates[className] = false;
	        }
	    };
	    Component.prototype.addOrRemoveCssClass = function (className, addOrRemove) {
	        var updateNeeded = this.cssClassStates[className] !== addOrRemove;
	        if (updateNeeded) {
	            addOrRemoveCssClass(this.eGui, className, addOrRemove);
	            this.cssClassStates[className] = addOrRemove;
	        }
	    };
	    Component.prototype.getAttribute = function (key) {
	        var eGui = this.eGui;
	        return eGui ? eGui.getAttribute(key) : null;
	    };
	    Component.prototype.getRefElement = function (refName) {
	        return this.queryForHtmlElement("[ref=\"" + refName + "\"]");
	    };
	    Component.EVENT_DISPLAYED_CHANGED = 'displayedChanged';
	    __decorate$a([
	        Autowired('agStackComponentsRegistry')
	    ], Component.prototype, "agStackComponentsRegistry", void 0);
	    __decorate$a([
	        PreConstruct
	    ], Component.prototype, "preConstructOnComponent", null);
	    __decorate$a([
	        PreConstruct
	    ], Component.prototype, "createChildComponentsPreConstruct", null);
	    __decorate$a([
	        PostConstruct
	    ], Component.prototype, "addAnnotatedGridEventListeners", null);
	    return Component;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$7 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var PopupComponent = /** @class */ (function (_super) {
	    __extends$7(PopupComponent, _super);
	    function PopupComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupComponent.prototype.isPopup = function () {
	        return true;
	    };
	    PopupComponent.prototype.setParentComponent = function (container) {
	        addCssClass(container.getGui(), 'ag-has-popup');
	        _super.prototype.setParentComponent.call(this, container);
	    };
	    PopupComponent.prototype.destroy = function () {
	        var parentComp = this.parentComponent;
	        var hasParent = parentComp && parentComp.isAlive();
	        if (hasParent) {
	            removeCssClass(parentComp.getGui(), 'ag-has-popup');
	        }
	        _super.prototype.destroy.call(this);
	    };
	    return PopupComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function QuerySelector(selector) {
	    return querySelectorFunc.bind(this, selector, undefined);
	}
	function RefSelector(ref) {
	    return querySelectorFunc.bind(this, "[ref=" + ref + "]", ref);
	}
	function querySelectorFunc(selector, refSelector, classPrototype, methodOrAttributeName, index) {
	    if (selector === null) {
	        console.error('AG Grid: QuerySelector selector should not be null');
	        return;
	    }
	    if (typeof index === 'number') {
	        console.error('AG Grid: QuerySelector should be on an attribute');
	        return;
	    }
	    addToObjectProps(classPrototype, 'querySelectors', {
	        attributeName: methodOrAttributeName,
	        querySelector: selector,
	        refSelector: refSelector
	    });
	}
	// think we should take this out, put property bindings on the
	function GridListener(eventName) {
	    return gridListenerFunc.bind(this, eventName);
	}
	function gridListenerFunc(eventName, target, methodName) {
	    if (eventName == null) {
	        console.error('AG Grid: GridListener eventName is missing');
	        return;
	    }
	    addToObjectProps(target, 'gridListenerMethods', {
	        methodName: methodName,
	        eventName: eventName
	    });
	}
	// think we should take this out, put property bindings on the
	function GuiListener(ref, eventName) {
	    return guiListenerFunc.bind(this, ref, eventName);
	}
	function guiListenerFunc(ref, eventName, target, methodName) {
	    if (eventName == null) {
	        console.error('AG Grid: GuiListener eventName is missing');
	        return;
	    }
	    addToObjectProps(target, 'guiListenerMethods', {
	        methodName: methodName,
	        eventName: eventName,
	        ref: ref
	    });
	}
	// // think we should take this out, put property bindings on the
	// export function Method(eventName?: string): Function {
	//     return methodFunc.bind(this, eventName);
	// }
	//
	// function methodFunc(alias: string, target: Object, methodName: string) {
	//     if (alias === null) {
	//         console.error("AG Grid: EventListener eventName should not be null");
	//         return;
	//     }
	//
	//     addToObjectProps(target, 'methods', {
	//         methodName: methodName,
	//         alias: alias
	//     });
	// }
	function addToObjectProps(target, key, value) {
	    // it's an attribute on the class
	    var props = getOrCreateProps$1(target, getFunctionName(target.constructor));
	    if (!props[key]) {
	        props[key] = [];
	    }
	    props[key].push(value);
	}
	function getOrCreateProps$1(target, instanceName) {
	    if (!target.__agComponentMetaData) {
	        target.__agComponentMetaData = {};
	    }
	    if (!target.__agComponentMetaData[instanceName]) {
	        target.__agComponentMetaData[instanceName] = {};
	    }
	    return target.__agComponentMetaData[instanceName];
	}

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var KeyCode = /** @class */ (function () {
	    function KeyCode() {
	    }
	    KeyCode.BACKSPACE = 8;
	    KeyCode.TAB = 9;
	    KeyCode.ENTER = 13;
	    KeyCode.SHIFT = 16;
	    KeyCode.ESCAPE = 27;
	    KeyCode.SPACE = 32;
	    KeyCode.LEFT = 37;
	    KeyCode.UP = 38;
	    KeyCode.RIGHT = 39;
	    KeyCode.DOWN = 40;
	    KeyCode.DELETE = 46;
	    KeyCode.A = 65;
	    KeyCode.C = 67;
	    KeyCode.V = 86;
	    KeyCode.D = 68;
	    KeyCode.Z = 90;
	    KeyCode.Y = 89;
	    KeyCode.F2 = 113;
	    KeyCode.PAGE_UP = 33;
	    KeyCode.PAGE_DOWN = 34;
	    KeyCode.PAGE_HOME = 36;
	    KeyCode.PAGE_END = 35;
	    return KeyCode;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$8 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$b = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TextCellEditor = /** @class */ (function (_super) {
	    __extends$8(TextCellEditor, _super);
	    function TextCellEditor() {
	        return _super.call(this, TextCellEditor.TEMPLATE) || this;
	    }
	    TextCellEditor.prototype.init = function (params) {
	        this.params = params;
	        var eInput = this.eInput;
	        var startValue;
	        // cellStartedEdit is only false if we are doing fullRow editing
	        if (params.cellStartedEdit) {
	            this.focusAfterAttached = true;
	            if (params.keyPress === KeyCode.BACKSPACE || params.keyPress === KeyCode.DELETE) {
	                startValue = '';
	            }
	            else if (params.charPress) {
	                startValue = params.charPress;
	            }
	            else {
	                startValue = this.getStartValue(params);
	                if (params.keyPress !== KeyCode.F2) {
	                    this.highlightAllOnFocus = true;
	                }
	            }
	        }
	        else {
	            this.focusAfterAttached = false;
	            startValue = this.getStartValue(params);
	        }
	        if (startValue != null) {
	            eInput.setValue(startValue, true);
	        }
	        this.addManagedListener(eInput.getGui(), 'keydown', function (event) {
	            var keyCode = event.keyCode;
	            if (keyCode === KeyCode.PAGE_UP || keyCode === KeyCode.PAGE_DOWN) {
	                event.preventDefault();
	            }
	        });
	    };
	    TextCellEditor.prototype.afterGuiAttached = function () {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var eInput = this.eInput;
	        eInput.setInputAriaLabel(translate('ariaInputEditor', 'Input Editor'));
	        if (!this.focusAfterAttached) {
	            return;
	        }
	        // Added for AG-3238. We can't remove this explicit focus() because Chrome requires an input
	        // to be focused before setSelectionRange will work. But it triggers a bug in Safari where
	        // explicitly focusing then blurring an empty field will cause the parent container to scroll.
	        if (!isBrowserSafari()) {
	            eInput.getFocusableElement().focus();
	        }
	        var inputEl = eInput.getInputElement();
	        if (this.highlightAllOnFocus) {
	            inputEl.select();
	        }
	        else {
	            // when we started editing, we want the caret at the end, not the start.
	            // this comes into play in two scenarios: a) when user hits F2 and b)
	            // when user hits a printable character, then on IE (and only IE) the caret
	            // was placed after the first character, thus 'apply' would end up as 'pplea'
	            var value = eInput.getValue();
	            var len = (exists(value) && value.length) || 0;
	            if (len) {
	                inputEl.setSelectionRange(len, len);
	            }
	        }
	    };
	    // gets called when tabbing trough cells and in full row edit mode
	    TextCellEditor.prototype.focusIn = function () {
	        var eInput = this.eInput;
	        var focusEl = eInput.getFocusableElement();
	        var inputEl = eInput.getInputElement();
	        focusEl.focus();
	        inputEl.select();
	    };
	    TextCellEditor.prototype.focusOut = function () {
	        var inputEl = this.eInput.getInputElement();
	        if (isBrowserIE()) {
	            inputEl.setSelectionRange(0, 0);
	        }
	    };
	    TextCellEditor.prototype.getValue = function () {
	        var eInput = this.eInput;
	        return this.params.parseValue(eInput.getValue());
	    };
	    TextCellEditor.prototype.getStartValue = function (params) {
	        var formatValue = params.useFormatter || params.column.getColDef().refData;
	        return formatValue ? params.formatValue(params.value) : params.value;
	    };
	    TextCellEditor.prototype.isPopup = function () {
	        return false;
	    };
	    TextCellEditor.TEMPLATE = '<div class="ag-cell-edit-wrapper"><ag-input-text-field class="ag-cell-editor" ref="eInput"></ag-input-text-field></div>';
	    __decorate$b([
	        RefSelector('eInput')
	    ], TextCellEditor.prototype, "eInput", void 0);
	    return TextCellEditor;
	}(PopupComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/** Provides sync access to async component. Date component can be lazy created - this class encapsulates
	 * this by keeping value locally until DateComp has loaded, then passing DateComp the value. */
	var DateCompWrapper = /** @class */ (function () {
	    function DateCompWrapper(context, userComponentFactory, dateComponentParams, eParent) {
	        var _this = this;
	        this.alive = true;
	        this.context = context;
	        userComponentFactory.newDateComponent(dateComponentParams).then(function (dateComp) {
	            // because async, check the filter still exists after component comes back
	            if (!_this.alive) {
	                context.destroyBean(dateComp);
	                return;
	            }
	            _this.dateComp = dateComp;
	            if (!dateComp) {
	                return;
	            }
	            eParent.appendChild(dateComp.getGui());
	            if (dateComp.afterGuiAttached) {
	                dateComp.afterGuiAttached();
	            }
	            if (_this.tempValue) {
	                dateComp.setDate(_this.tempValue);
	            }
	        });
	    }
	    DateCompWrapper.prototype.destroy = function () {
	        this.alive = false;
	        this.dateComp = this.context.destroyBean(this.dateComp);
	    };
	    DateCompWrapper.prototype.getDate = function () {
	        return this.dateComp ? this.dateComp.getDate() : this.tempValue;
	    };
	    DateCompWrapper.prototype.setDate = function (value) {
	        if (this.dateComp) {
	            this.dateComp.setDate(value);
	        }
	        else {
	            this.tempValue = value;
	        }
	    };
	    DateCompWrapper.prototype.setInputPlaceholder = function (placeholder) {
	        if (this.dateComp && this.dateComp.setInputPlaceholder) {
	            this.dateComp.setInputPlaceholder(placeholder);
	        }
	    };
	    DateCompWrapper.prototype.setInputAriaLabel = function (label) {
	        if (this.dateComp && this.dateComp.setInputAriaLabel) {
	            this.dateComp.setInputAriaLabel(label);
	        }
	    };
	    DateCompWrapper.prototype.afterGuiAttached = function (params) {
	        if (this.dateComp && typeof this.dateComp.afterGuiAttached === 'function') {
	            this.dateComp.afterGuiAttached(params);
	        }
	    };
	    return DateCompWrapper;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	/* Common logic for options, used by both filters and floating filters. */
	var OptionsFactory = /** @class */ (function () {
	    function OptionsFactory() {
	        this.customFilterOptions = {};
	    }
	    OptionsFactory.prototype.init = function (params, defaultOptions) {
	        this.filterOptions = params.filterOptions || defaultOptions;
	        this.mapCustomOptions();
	        this.selectDefaultItem(params);
	    };
	    OptionsFactory.prototype.getFilterOptions = function () {
	        return this.filterOptions;
	    };
	    OptionsFactory.prototype.mapCustomOptions = function () {
	        var _this = this;
	        if (!this.filterOptions) {
	            return;
	        }
	        this.filterOptions.forEach(function (filterOption) {
	            if (typeof filterOption === 'string') {
	                return;
	            }
	            var requiredProperties = ['displayKey', 'displayName', 'test'];
	            if (every(requiredProperties, function (key) {
	                if (!filterOption[key]) {
	                    console.warn("AG Grid: ignoring FilterOptionDef as it doesn't contain a '" + key + "'");
	                    return false;
	                }
	                return true;
	            })) {
	                _this.customFilterOptions[filterOption.displayKey] = filterOption;
	            }
	        });
	    };
	    OptionsFactory.prototype.selectDefaultItem = function (params) {
	        if (params.defaultOption) {
	            this.defaultOption = params.defaultOption;
	        }
	        else if (this.filterOptions.length >= 1) {
	            var firstFilterOption = this.filterOptions[0];
	            if (typeof firstFilterOption === 'string') {
	                this.defaultOption = firstFilterOption;
	            }
	            else if (firstFilterOption.displayKey) {
	                this.defaultOption = firstFilterOption.displayKey;
	            }
	            else {
	                console.warn("AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
	            }
	        }
	        else {
	            console.warn('AG Grid: no filter options for filter');
	        }
	    };
	    OptionsFactory.prototype.getDefaultOption = function () {
	        return this.defaultOption;
	    };
	    OptionsFactory.prototype.getCustomOption = function (name) {
	        return this.customFilterOptions[name];
	    };
	    return OptionsFactory;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var DEFAULT_FILTER_LOCALE_TEXT = {
	    applyFilter: 'Apply',
	    clearFilter: 'Clear',
	    resetFilter: 'Reset',
	    cancelFilter: 'Cancel',
	    textFilter: 'Text Filter',
	    numberFilter: 'Number Filter',
	    dateFilter: 'Date Filter',
	    setFilter: 'Set Filter',
	    filterOoo: 'Filter...',
	    empty: 'Choose One',
	    equals: 'Equals',
	    notEqual: 'Not equal',
	    lessThan: 'Less than',
	    greaterThan: 'Greater than',
	    inRange: 'In range',
	    inRangeStart: 'From',
	    inRangeEnd: 'To',
	    lessThanOrEqual: 'Less than or equals',
	    greaterThanOrEqual: 'Greater than or equals',
	    contains: 'Contains',
	    notContains: 'Not contains',
	    startsWith: 'Starts with',
	    endsWith: 'Ends with',
	    andCondition: 'AND',
	    orCondition: 'OR',
	    dateFormatOoo: 'yyyy-mm-dd',
	};

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$9 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$c = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	/**
	 * This provides logic to override the default browser focus logic.
	 *
	 * When the component gets focus, it uses the grid logic to find out what should be focused,
	 * and then focuses that instead.
	 *
	 * This is how we ensure when user tabs into the relevant section, we focus the correct item.
	 * For example GridCore extends ManagedFocusComponent, and it ensures when it receives focus
	 * that focus goes to the first cell of the first header row.
	 */
	var ManagedFocusComponent = /** @class */ (function (_super) {
	    __extends$9(ManagedFocusComponent, _super);
	    /*
	     * Set isFocusableContainer to true if this component will contain multiple focus-managed
	     * elements within. When set to true, this component will add tabGuards that will be responsible
	     * for receiving focus from outside and focusing an internal element using the focusInnerElementMethod
	     */
	    function ManagedFocusComponent(template, isFocusableContainer) {
	        if (isFocusableContainer === void 0) { isFocusableContainer = false; }
	        var _this = _super.call(this, template) || this;
	        _this.isFocusableContainer = isFocusableContainer;
	        _this.skipTabGuardFocus = false;
	        return _this;
	    }
	    ManagedFocusComponent.prototype.postConstruct = function () {
	        var _this = this;
	        var focusableElement = this.getFocusableElement();
	        if (!focusableElement) {
	            return;
	        }
	        addCssClass(focusableElement, ManagedFocusComponent.FOCUS_MANAGED_CLASS);
	        if (this.isFocusableContainer) {
	            this.topTabGuard = this.createTabGuard('top');
	            this.bottomTabGuard = this.createTabGuard('bottom');
	            this.addTabGuards();
	            this.activateTabGuards();
	            this.forEachTabGuard(function (guard) { return _this.addManagedListener(guard, 'focus', _this.onFocus.bind(_this)); });
	        }
	        this.addKeyDownListeners(focusableElement);
	        this.addManagedListener(focusableElement, 'focusin', this.onFocusIn.bind(this));
	        this.addManagedListener(focusableElement, 'focusout', this.onFocusOut.bind(this));
	    };
	    /*
	     * Override this method if focusing the default element requires special logic.
	     */
	    ManagedFocusComponent.prototype.focusInnerElement = function (fromBottom) {
	        if (fromBottom === void 0) { fromBottom = false; }
	        var focusable = this.focusController.findFocusableElements(this.getFocusableElement());
	        if (this.isFocusableContainer && this.tabGuardsAreActive()) {
	            // remove tab guards from this component from list of focusable elements
	            focusable.splice(0, 1);
	            focusable.splice(focusable.length - 1, 1);
	        }
	        if (!focusable.length) {
	            return;
	        }
	        focusable[fromBottom ? focusable.length - 1 : 0].focus();
	    };
	    /**
	     * By default this will tab though the elements in the default order. Override if you require special logic.
	     */
	    ManagedFocusComponent.prototype.onTabKeyDown = function (e) {
	        var _this = this;
	        if (e.defaultPrevented) {
	            return;
	        }
	        var tabGuardsAreActive = this.tabGuardsAreActive();
	        if (this.isFocusableContainer && tabGuardsAreActive) {
	            this.deactivateTabGuards();
	        }
	        var nextRoot = this.focusController.findNextFocusableElement(this.getFocusableElement(), false, e.shiftKey);
	        if (this.isFocusableContainer && tabGuardsAreActive) {
	            // ensure the tab guards are only re-instated once the event has finished processing, to avoid the browser
	            // tabbing to the tab guard from inside the component
	            setTimeout(function () { return _this.activateTabGuards(); }, 0);
	        }
	        if (!nextRoot) {
	            return;
	        }
	        nextRoot.focus();
	        e.preventDefault();
	    };
	    ManagedFocusComponent.prototype.onFocusIn = function (e) {
	        if (this.isFocusableContainer) {
	            this.deactivateTabGuards();
	        }
	    };
	    ManagedFocusComponent.prototype.onFocusOut = function (e) {
	        if (this.isFocusableContainer && !this.getFocusableElement().contains(e.relatedTarget)) {
	            this.activateTabGuards();
	        }
	    };
	    ManagedFocusComponent.prototype.forceFocusOutOfContainer = function (up) {
	        if (up === void 0) { up = false; }
	        if (!this.isFocusableContainer) {
	            return;
	        }
	        this.activateTabGuards();
	        this.skipTabGuardFocus = true;
	        var tabGuardToFocus = up ? this.topTabGuard : this.bottomTabGuard;
	        if (tabGuardToFocus) {
	            tabGuardToFocus.focus();
	        }
	    };
	    ManagedFocusComponent.prototype.appendChild = function (newChild, container) {
	        if (this.isFocusableContainer) {
	            if (!isNodeOrElement(newChild)) {
	                newChild = newChild.getGui();
	            }
	            var bottomTabGuard = this.bottomTabGuard;
	            if (bottomTabGuard) {
	                bottomTabGuard.insertAdjacentElement('beforebegin', newChild);
	            }
	            else {
	                _super.prototype.appendChild.call(this, newChild, container);
	            }
	        }
	        else {
	            _super.prototype.appendChild.call(this, newChild, container);
	        }
	    };
	    ManagedFocusComponent.prototype.createTabGuard = function (side) {
	        var tabGuard = document.createElement('div');
	        tabGuard.classList.add('ag-tab-guard');
	        tabGuard.classList.add("ag-tab-guard-" + side);
	        tabGuard.setAttribute('role', 'presentation');
	        return tabGuard;
	    };
	    ManagedFocusComponent.prototype.addTabGuards = function () {
	        var focusableEl = this.getFocusableElement();
	        focusableEl.insertAdjacentElement('afterbegin', this.topTabGuard);
	        focusableEl.insertAdjacentElement('beforeend', this.bottomTabGuard);
	    };
	    ManagedFocusComponent.prototype.forEachTabGuard = function (callback) {
	        if (this.topTabGuard) {
	            callback(this.topTabGuard);
	        }
	        if (this.bottomTabGuard) {
	            callback(this.bottomTabGuard);
	        }
	    };
	    ManagedFocusComponent.prototype.addKeyDownListeners = function (eGui) {
	        var _this = this;
	        this.addManagedListener(eGui, 'keydown', function (e) {
	            if (e.defaultPrevented || isStopPropagationForAgGrid(e)) {
	                return;
	            }
	            if (_this.shouldStopEventPropagation(e)) {
	                stopPropagationForAgGrid(e);
	                return;
	            }
	            if (e.keyCode === KeyCode.TAB) {
	                _this.onTabKeyDown(e);
	            }
	            else if (_this.handleKeyDown) {
	                _this.handleKeyDown(e);
	            }
	        });
	    };
	    ManagedFocusComponent.prototype.shouldStopEventPropagation = function (e) {
	        return false;
	    };
	    ManagedFocusComponent.prototype.onFocus = function (e) {
	        if (this.skipTabGuardFocus) {
	            this.skipTabGuardFocus = false;
	            return;
	        }
	        this.focusInnerElement(e.target === this.bottomTabGuard);
	    };
	    ManagedFocusComponent.prototype.activateTabGuards = function () {
	        var _this = this;
	        this.forEachTabGuard(function (guard) { return guard.setAttribute('tabIndex', _this.gridOptionsWrapper.getGridTabIndex()); });
	    };
	    ManagedFocusComponent.prototype.deactivateTabGuards = function () {
	        this.forEachTabGuard(function (guard) { return guard.removeAttribute('tabIndex'); });
	    };
	    ManagedFocusComponent.prototype.tabGuardsAreActive = function () {
	        return !!this.topTabGuard && this.topTabGuard.hasAttribute('tabIndex');
	    };
	    ManagedFocusComponent.prototype.clearGui = function () {
	        var tabGuardsAreActive = this.tabGuardsAreActive();
	        clearElement(this.getFocusableElement());
	        if (this.isFocusableContainer) {
	            this.addTabGuards();
	            if (tabGuardsAreActive) {
	                this.activateTabGuards();
	            }
	        }
	    };
	    ManagedFocusComponent.FOCUS_MANAGED_CLASS = 'ag-focus-managed';
	    __decorate$c([
	        Autowired('focusController')
	    ], ManagedFocusComponent.prototype, "focusController", void 0);
	    __decorate$c([
	        PostConstruct
	    ], ManagedFocusComponent.prototype, "postConstruct", null);
	    return ManagedFocusComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$a = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$d = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	/**
	 * Contains common logic to all provided filters (apply button, clear button, etc).
	 * All the filters that come with AG Grid extend this class. User filters do not
	 * extend this class.
	 */
	var ProvidedFilter = /** @class */ (function (_super) {
	    __extends$a(ProvidedFilter, _super);
	    function ProvidedFilter(filterNameKey) {
	        var _this = _super.call(this) || this;
	        _this.filterNameKey = filterNameKey;
	        _this.applyActive = false;
	        _this.hidePopup = null;
	        // after the user hits 'apply' the model gets copied to here. this is then the model that we use for
	        // all filtering. so if user changes UI but doesn't hit apply, then the UI will be out of sync with this model.
	        // this is what we want, as the UI should only become the 'active' filter once it's applied. when apply is
	        // inactive, this model will be in sync (following the debounce ms). if the UI is not a valid filter
	        // (eg the value is missing so nothing to filter on, or for set filter all checkboxes are checked so filter
	        // not active) then this appliedModel will be null/undefined.
	        _this.appliedModel = null;
	        return _this;
	    }
	    ProvidedFilter.prototype.getFilterTitle = function () {
	        return this.translate(this.filterNameKey);
	    };
	    /** @deprecated */
	    ProvidedFilter.prototype.onFilterChanged = function () {
	        console.warn("AG Grid: you should not call onFilterChanged() directly on the filter, please call\n        gridApi.onFilterChanged() instead. onFilterChanged is not part of the exposed filter interface (it was\n        a method that existed on an old version of the filters that was not intended for public use.");
	        this.providedFilterParams.filterChangedCallback();
	    };
	    ProvidedFilter.prototype.isFilterActive = function () {
	        // filter is active if we have a valid applied model
	        return !!this.appliedModel;
	    };
	    ProvidedFilter.prototype.postConstruct = function () {
	        this.resetTemplate(); // do this first to create the DOM
	        _super.prototype.postConstruct.call(this);
	    };
	    ProvidedFilter.prototype.resetTemplate = function (paramsMap) {
	        var templateString = /* html */ "\n            <div class=\"ag-filter-wrapper\">\n                <div class=\"ag-filter-body-wrapper ag-" + this.getCssIdentifier() + "-body-wrapper\">\n                    " + this.createBodyTemplate() + "\n                </div>\n            </div>";
	        this.setTemplate(templateString, paramsMap);
	    };
	    ProvidedFilter.prototype.init = function (params) {
	        var _this = this;
	        this.setParams(params);
	        this.resetUiToDefaults(true).then(function () {
	            _this.updateUiVisibility();
	            _this.setupOnBtApplyDebounce();
	        });
	    };
	    ProvidedFilter.prototype.setParams = function (params) {
	        ProvidedFilter.checkForDeprecatedParams(params);
	        this.providedFilterParams = params;
	        if (params.newRowsAction === 'keep') {
	            this.newRowsActionKeep = true;
	        }
	        else if (params.newRowsAction === 'clear') {
	            this.newRowsActionKeep = false;
	        }
	        else {
	            // the default for SSRM and IRM is 'keep', for CSRM and VRM the default is 'clear'
	            var modelsForKeep = [Constants.ROW_MODEL_TYPE_SERVER_SIDE, Constants.ROW_MODEL_TYPE_INFINITE];
	            this.newRowsActionKeep = modelsForKeep.indexOf(this.rowModel.getType()) >= 0;
	        }
	        this.applyActive = ProvidedFilter.isUseApplyButton(params);
	        this.createButtonPanel();
	    };
	    ProvidedFilter.prototype.createButtonPanel = function () {
	        var _this = this;
	        var buttons = this.providedFilterParams.buttons;
	        if (!buttons || buttons.length < 1) {
	            return;
	        }
	        var eButtonsPanel = document.createElement('div');
	        addCssClass(eButtonsPanel, 'ag-filter-apply-panel');
	        var addButton = function (type) {
	            var text;
	            var clickListener;
	            switch (type) {
	                case 'apply':
	                    text = _this.translate('applyFilter');
	                    clickListener = function (e) { return _this.onBtApply(false, false, e); };
	                    break;
	                case 'clear':
	                    text = _this.translate('clearFilter');
	                    clickListener = function () { return _this.onBtClear(); };
	                    break;
	                case 'reset':
	                    text = _this.translate('resetFilter');
	                    clickListener = function () { return _this.onBtReset(); };
	                    break;
	                case 'cancel':
	                    text = _this.translate('cancelFilter');
	                    clickListener = function (e) { _this.onBtCancel(e); };
	                    break;
	                default:
	                    console.warn('Unknown button type specified');
	                    return;
	            }
	            var button = loadTemplate(
	            /* html */
	            "<button\n                    type=\"button\"\n                    ref=\"" + type + "FilterButton\"\n                    class=\"ag-standard-button ag-filter-apply-panel-button\"\n                >" + text + "\n                </button>");
	            eButtonsPanel.appendChild(button);
	            _this.addManagedListener(button, 'click', clickListener);
	        };
	        convertToSet(buttons).forEach(function (type) { return addButton(type); });
	        this.getGui().appendChild(eButtonsPanel);
	    };
	    ProvidedFilter.checkForDeprecatedParams = function (params) {
	        var buttons = params.buttons || [];
	        if (buttons.length > 0) {
	            return;
	        }
	        var applyButton = params.applyButton, resetButton = params.resetButton, clearButton = params.clearButton;
	        if (clearButton) {
	            console.warn('AG Grid: as of AG Grid v23.2, filterParams.clearButton is deprecated. Please use filterParams.buttons instead');
	            buttons.push('clear');
	        }
	        if (resetButton) {
	            console.warn('AG Grid: as of AG Grid v23.2, filterParams.resetButton is deprecated. Please use filterParams.buttons instead');
	            buttons.push('reset');
	        }
	        if (applyButton) {
	            console.warn('AG Grid: as of AG Grid v23.2, filterParams.applyButton is deprecated. Please use filterParams.buttons instead');
	            buttons.push('apply');
	        }
	        if (params.apply) {
	            console.warn('AG Grid: as of AG Grid v21, filterParams.apply is deprecated. Please use filterParams.buttons instead');
	            buttons.push('apply');
	        }
	        params.buttons = buttons;
	    };
	    // subclasses can override this to provide alternative debounce defaults
	    ProvidedFilter.prototype.getDefaultDebounceMs = function () {
	        return 0;
	    };
	    ProvidedFilter.prototype.setupOnBtApplyDebounce = function () {
	        var debounceMs = ProvidedFilter.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs());
	        this.onBtApplyDebounce = debounce(this.onBtApply.bind(this), debounceMs);
	    };
	    ProvidedFilter.prototype.getModel = function () {
	        return this.appliedModel;
	    };
	    ProvidedFilter.prototype.setModel = function (model) {
	        var _this = this;
	        var promise = model ? this.setModelIntoUi(model) : this.resetUiToDefaults();
	        return promise.then(function () {
	            _this.updateUiVisibility();
	            // we set the model from the GUI, rather than the provided model,
	            // so the model is consistent, e.g. handling of null/undefined will be the same,
	            // or if model is case insensitive, then casing is removed.
	            _this.applyModel();
	        });
	    };
	    ProvidedFilter.prototype.onBtCancel = function (e) {
	        var _this = this;
	        var currentModel = this.getModel();
	        var afterAppliedFunc = function () {
	            _this.onUiChanged(false, 'prevent');
	            if (_this.providedFilterParams.closeOnApply) {
	                _this.close(e);
	            }
	        };
	        if (currentModel != null) {
	            this.setModelIntoUi(currentModel).then(afterAppliedFunc);
	        }
	        else {
	            this.resetUiToDefaults().then(afterAppliedFunc);
	        }
	    };
	    ProvidedFilter.prototype.onBtClear = function () {
	        var _this = this;
	        this.resetUiToDefaults().then(function () { return _this.onUiChanged(); });
	    };
	    ProvidedFilter.prototype.onBtReset = function () {
	        this.onBtClear();
	        this.onBtApply();
	    };
	    /**
	     * Applies changes made in the UI to the filter, and returns true if the model has changed.
	     */
	    ProvidedFilter.prototype.applyModel = function () {
	        var newModel = this.getModelFromUi();
	        if (!this.isModelValid(newModel)) {
	            return false;
	        }
	        var previousModel = this.appliedModel;
	        this.appliedModel = newModel;
	        // models can be same if user pasted same content into text field, or maybe just changed the case
	        // and it's a case insensitive filter
	        return !this.areModelsEqual(previousModel, newModel);
	    };
	    ProvidedFilter.prototype.isModelValid = function (model) {
	        return true;
	    };
	    ProvidedFilter.prototype.onBtApply = function (afterFloatingFilter, afterDataChange, e) {
	        if (afterFloatingFilter === void 0) { afterFloatingFilter = false; }
	        if (afterDataChange === void 0) { afterDataChange = false; }
	        if (this.applyModel()) {
	            // the floating filter uses 'afterFloatingFilter' info, so it doesn't refresh after filter changed if change
	            // came from floating filter
	            this.providedFilterParams.filterChangedCallback({ afterFloatingFilter: afterFloatingFilter, afterDataChange: afterDataChange });
	        }
	        var closeOnApply = this.providedFilterParams.closeOnApply;
	        // only close if an apply button is visible, otherwise we'd be closing every time a change was made!
	        if (closeOnApply && this.applyActive && !afterFloatingFilter && !afterDataChange) {
	            this.close(e);
	        }
	    };
	    ProvidedFilter.prototype.onNewRowsLoaded = function () {
	        var _this = this;
	        if (!this.newRowsActionKeep) {
	            this.resetUiToDefaults().then(function () { return _this.appliedModel = null; });
	        }
	    };
	    ProvidedFilter.prototype.close = function (e) {
	        if (!this.hidePopup) {
	            return;
	        }
	        var keyboardEvent = e;
	        var key = keyboardEvent && keyboardEvent.key;
	        var params;
	        if (key === 'Enter' || key === 'Space') {
	            params = { keyboardEvent: keyboardEvent };
	        }
	        this.hidePopup(params);
	        this.hidePopup = null;
	    };
	    // called by set filter
	    ProvidedFilter.prototype.isNewRowsActionKeep = function () {
	        return this.newRowsActionKeep;
	    };
	    /**
	     * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
	     * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
	     * be adjusted by using the apply parameter.
	     */
	    ProvidedFilter.prototype.onUiChanged = function (fromFloatingFilter, apply) {
	        if (fromFloatingFilter === void 0) { fromFloatingFilter = false; }
	        this.updateUiVisibility();
	        this.providedFilterParams.filterModifiedCallback();
	        if (this.applyActive) {
	            var isValid = this.isModelValid(this.getModelFromUi());
	            setDisabled(this.getRefElement('applyFilterButton'), !isValid);
	        }
	        if ((fromFloatingFilter && !apply) || apply === 'immediately') {
	            this.onBtApply(fromFloatingFilter);
	        }
	        else if ((!this.applyActive && !apply) || apply === 'debounce') {
	            this.onBtApplyDebounce();
	        }
	    };
	    ProvidedFilter.prototype.afterGuiAttached = function (params) {
	        if (params == null) {
	            return;
	        }
	        this.hidePopup = params.hidePopup;
	    };
	    // static, as used by floating filter also
	    ProvidedFilter.getDebounceMs = function (params, debounceDefault) {
	        if (ProvidedFilter.isUseApplyButton(params)) {
	            if (params.debounceMs != null) {
	                console.warn('AG Grid: debounceMs is ignored when apply button is present');
	            }
	            return 0;
	        }
	        return params.debounceMs != null ? params.debounceMs : debounceDefault;
	    };
	    // static, as used by floating filter also
	    ProvidedFilter.isUseApplyButton = function (params) {
	        ProvidedFilter.checkForDeprecatedParams(params);
	        return !!params.buttons && params.buttons.indexOf('apply') >= 0;
	    };
	    ProvidedFilter.prototype.destroy = function () {
	        this.hidePopup = null;
	        _super.prototype.destroy.call(this);
	    };
	    ProvidedFilter.prototype.translate = function (key) {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        return translate(key, DEFAULT_FILTER_LOCALE_TEXT[key]);
	    };
	    __decorate$d([
	        Autowired('rowModel')
	    ], ProvidedFilter.prototype, "rowModel", void 0);
	    __decorate$d([
	        PostConstruct
	    ], ProvidedFilter.prototype, "postConstruct", null);
	    return ProvidedFilter;
	}(ManagedFocusComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$b = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$e = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ConditionPosition;
	(function (ConditionPosition) {
	    ConditionPosition[ConditionPosition["One"] = 0] = "One";
	    ConditionPosition[ConditionPosition["Two"] = 1] = "Two";
	})(ConditionPosition || (ConditionPosition = {}));
	/**
	 * Every filter with a dropdown where the user can specify a comparing type against the filter values
	 */
	var SimpleFilter = /** @class */ (function (_super) {
	    __extends$b(SimpleFilter, _super);
	    function SimpleFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // returns true if this type requires a 'from' field, eg any filter that requires at least one text value
	    SimpleFilter.prototype.showValueFrom = function (type) {
	        return !this.doesFilterHaveHiddenInput(type) && type !== SimpleFilter.EMPTY;
	    };
	    // returns true if this type requires a 'to' field, currently only 'range' returns true
	    SimpleFilter.prototype.showValueTo = function (type) {
	        return type === SimpleFilter.IN_RANGE;
	    };
	    // floating filter calls this when user applies filter from floating filter
	    SimpleFilter.prototype.onFloatingFilterChanged = function (type, value) {
	        this.setTypeFromFloatingFilter(type);
	        this.setValueFromFloatingFilter(value);
	        this.onUiChanged(true);
	    };
	    SimpleFilter.prototype.setTypeFromFloatingFilter = function (type) {
	        this.eType1.setValue(type);
	        this.eType2.setValue(this.optionsFactory.getDefaultOption());
	        (this.isDefaultOperator('AND') ? this.eJoinOperatorAnd : this.eJoinOperatorOr).setValue(true);
	    };
	    SimpleFilter.prototype.getModelFromUi = function () {
	        if (!this.isConditionUiComplete(ConditionPosition.One)) {
	            return null;
	        }
	        if (this.isAllowTwoConditions() && this.isConditionUiComplete(ConditionPosition.Two)) {
	            return {
	                filterType: this.getFilterType(),
	                operator: this.getJoinOperator(),
	                condition1: this.createCondition(ConditionPosition.One),
	                condition2: this.createCondition(ConditionPosition.Two)
	            };
	        }
	        return this.createCondition(ConditionPosition.One);
	    };
	    SimpleFilter.prototype.getCondition1Type = function () {
	        return this.eType1.getValue();
	    };
	    SimpleFilter.prototype.getCondition2Type = function () {
	        return this.eType2.getValue();
	    };
	    SimpleFilter.prototype.getJoinOperator = function () {
	        return this.eJoinOperatorOr.getValue() === true ? 'OR' : 'AND';
	    };
	    SimpleFilter.prototype.areModelsEqual = function (a, b) {
	        // both are missing
	        if (!a && !b) {
	            return true;
	        }
	        // one is missing, other present
	        if ((!a && b) || (a && !b)) {
	            return false;
	        }
	        // one is combined, the other is not
	        var aIsSimple = !a.operator;
	        var bIsSimple = !b.operator;
	        var oneSimpleOneCombined = (!aIsSimple && bIsSimple) || (aIsSimple && !bIsSimple);
	        if (oneSimpleOneCombined) {
	            return false;
	        }
	        var res;
	        // otherwise both present, so compare
	        if (aIsSimple) {
	            var aSimple = a;
	            var bSimple = b;
	            res = this.areSimpleModelsEqual(aSimple, bSimple);
	        }
	        else {
	            var aCombined = a;
	            var bCombined = b;
	            res = aCombined.operator === bCombined.operator
	                && this.areSimpleModelsEqual(aCombined.condition1, bCombined.condition1)
	                && this.areSimpleModelsEqual(aCombined.condition2, bCombined.condition2);
	        }
	        return res;
	    };
	    SimpleFilter.prototype.setModelIntoUi = function (model) {
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var orChecked = combinedModel.operator === 'OR';
	            this.eJoinOperatorAnd.setValue(!orChecked);
	            this.eJoinOperatorOr.setValue(orChecked);
	            this.eType1.setValue(combinedModel.condition1.type);
	            this.eType2.setValue(combinedModel.condition2.type);
	            this.setConditionIntoUi(combinedModel.condition1, ConditionPosition.One);
	            this.setConditionIntoUi(combinedModel.condition2, ConditionPosition.Two);
	        }
	        else {
	            var simpleModel = model;
	            this.eJoinOperatorAnd.setValue(this.isDefaultOperator('AND'));
	            this.eJoinOperatorOr.setValue(this.isDefaultOperator('OR'));
	            this.eType1.setValue(simpleModel.type);
	            this.eType2.setValue(this.optionsFactory.getDefaultOption());
	            this.setConditionIntoUi(simpleModel, ConditionPosition.One);
	            this.setConditionIntoUi(null, ConditionPosition.Two);
	        }
	        return AgPromise.resolve();
	    };
	    SimpleFilter.prototype.doesFilterPass = function (params) {
	        var _this = this;
	        var model = this.getModel();
	        if (model == null) {
	            return true;
	        }
	        var operator = model.operator;
	        var models = [];
	        if (operator) {
	            var combinedModel = model;
	            models.push(combinedModel.condition1, combinedModel.condition2);
	        }
	        else {
	            models.push(model);
	        }
	        var combineFunction = operator && operator === 'OR' ? some : every;
	        return combineFunction(models, function (m) { return _this.individualConditionPasses(params, m); });
	    };
	    SimpleFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.optionsFactory = new OptionsFactory();
	        this.optionsFactory.init(params, this.getDefaultFilterOptions());
	        this.allowTwoConditions = !params.suppressAndOrCondition;
	        this.alwaysShowBothConditions = !!params.alwaysShowBothConditions;
	        this.defaultJoinOperator = this.getDefaultJoinOperator(params.defaultJoinOperator);
	        this.putOptionsIntoDropdown();
	        this.addChangedListeners();
	    };
	    SimpleFilter.prototype.getDefaultJoinOperator = function (defaultJoinOperator) {
	        return includes(['AND', 'OR'], defaultJoinOperator) ? defaultJoinOperator : 'AND';
	    };
	    SimpleFilter.prototype.putOptionsIntoDropdown = function () {
	        var _this = this;
	        var filterOptions = this.optionsFactory.getFilterOptions();
	        forEach(filterOptions, function (option) {
	            var value;
	            var text;
	            if (typeof option === 'string') {
	                value = option;
	                text = _this.translate(value);
	            }
	            else {
	                value = option.displayKey;
	                var customOption = _this.optionsFactory.getCustomOption(value);
	                text = customOption ?
	                    _this.gridOptionsWrapper.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) :
	                    _this.translate(value);
	            }
	            var createOption = function () { return ({ value: value, text: text }); };
	            _this.eType1.addOption(createOption());
	            _this.eType2.addOption(createOption());
	        });
	        var readOnly = filterOptions.length <= 1;
	        this.eType1.setDisabled(readOnly);
	        this.eType2.setDisabled(readOnly);
	    };
	    SimpleFilter.prototype.isAllowTwoConditions = function () {
	        return this.allowTwoConditions;
	    };
	    SimpleFilter.prototype.createBodyTemplate = function () {
	        return /* html */ "\n            <ag-select class=\"ag-filter-select\" ref=\"eOptions1\"></ag-select>\n            " + this.createValueTemplate(ConditionPosition.One) + "\n            <div class=\"ag-filter-condition\" ref=\"eJoinOperatorPanel\">\n               <ag-radio-button ref=\"eJoinOperatorAnd\" class=\"ag-filter-condition-operator ag-filter-condition-operator-and\"></ag-radio-button>\n               <ag-radio-button ref=\"eJoinOperatorOr\" class=\"ag-filter-condition-operator ag-filter-condition-operator-or\"></ag-radio-button>\n            </div>\n            <ag-select class=\"ag-filter-select\" ref=\"eOptions2\"></ag-select>\n            " + this.createValueTemplate(ConditionPosition.Two);
	    };
	    SimpleFilter.prototype.getCssIdentifier = function () {
	        return 'simple-filter';
	    };
	    SimpleFilter.prototype.updateUiVisibility = function () {
	        var isCondition2Enabled = this.isCondition2Enabled();
	        if (this.alwaysShowBothConditions) {
	            this.eJoinOperatorAnd.setDisabled(!isCondition2Enabled);
	            this.eJoinOperatorOr.setDisabled(!isCondition2Enabled);
	            this.eType2.setDisabled(!isCondition2Enabled);
	            setDisabled(this.eCondition2Body, !isCondition2Enabled);
	        }
	        else {
	            setDisplayed(this.eJoinOperatorPanel, isCondition2Enabled);
	            setDisplayed(this.eType2.getGui(), isCondition2Enabled);
	            setDisplayed(this.eCondition2Body, isCondition2Enabled);
	        }
	    };
	    SimpleFilter.prototype.isCondition2Enabled = function () {
	        return this.allowTwoConditions && this.isConditionUiComplete(ConditionPosition.One);
	    };
	    SimpleFilter.prototype.resetUiToDefaults = function (silent) {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var filteringLabel = translate('ariaFilteringOperator', 'Filtering operator');
	        var uniqueGroupId = 'ag-simple-filter-and-or-' + this.getCompId();
	        var defaultOption = this.optionsFactory.getDefaultOption();
	        this.eType1.setValue(defaultOption, silent).setAriaLabel(filteringLabel);
	        this.eType2.setValue(defaultOption, silent).setAriaLabel(filteringLabel);
	        this.eJoinOperatorAnd
	            .setValue(this.isDefaultOperator('AND'), silent)
	            .setName(uniqueGroupId)
	            .setLabel(this.translate('andCondition'));
	        this.eJoinOperatorOr
	            .setValue(this.isDefaultOperator('OR'), silent)
	            .setName(uniqueGroupId)
	            .setLabel(this.translate('orCondition'));
	        return AgPromise.resolve();
	    };
	    SimpleFilter.prototype.isDefaultOperator = function (operator) {
	        return operator === this.defaultJoinOperator;
	    };
	    SimpleFilter.prototype.addChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.eType1.onValueChange(listener);
	        this.eType2.onValueChange(listener);
	        this.eJoinOperatorOr.onValueChange(listener);
	        this.eJoinOperatorAnd.onValueChange(listener);
	    };
	    SimpleFilter.prototype.doesFilterHaveHiddenInput = function (filterType) {
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        return customFilterOption && customFilterOption.hideFilterInput;
	    };
	    SimpleFilter.EMPTY = 'empty';
	    SimpleFilter.EQUALS = 'equals';
	    SimpleFilter.NOT_EQUAL = 'notEqual';
	    SimpleFilter.LESS_THAN = 'lessThan';
	    SimpleFilter.LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
	    SimpleFilter.GREATER_THAN = 'greaterThan';
	    SimpleFilter.GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
	    SimpleFilter.IN_RANGE = 'inRange';
	    SimpleFilter.CONTAINS = 'contains';
	    SimpleFilter.NOT_CONTAINS = 'notContains';
	    SimpleFilter.STARTS_WITH = 'startsWith';
	    SimpleFilter.ENDS_WITH = 'endsWith';
	    __decorate$e([
	        RefSelector('eOptions1')
	    ], SimpleFilter.prototype, "eType1", void 0);
	    __decorate$e([
	        RefSelector('eOptions2')
	    ], SimpleFilter.prototype, "eType2", void 0);
	    __decorate$e([
	        RefSelector('eJoinOperatorPanel')
	    ], SimpleFilter.prototype, "eJoinOperatorPanel", void 0);
	    __decorate$e([
	        RefSelector('eJoinOperatorAnd')
	    ], SimpleFilter.prototype, "eJoinOperatorAnd", void 0);
	    __decorate$e([
	        RefSelector('eJoinOperatorOr')
	    ], SimpleFilter.prototype, "eJoinOperatorOr", void 0);
	    __decorate$e([
	        RefSelector('eCondition1Body')
	    ], SimpleFilter.prototype, "eCondition1Body", void 0);
	    __decorate$e([
	        RefSelector('eCondition2Body')
	    ], SimpleFilter.prototype, "eCondition2Body", void 0);
	    return SimpleFilter;
	}(ProvidedFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$c = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var ScalarFilter = /** @class */ (function (_super) {
	    __extends$c(ScalarFilter, _super);
	    function ScalarFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ScalarFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.scalarFilterParams = params;
	        this.checkDeprecatedParams();
	    };
	    ScalarFilter.prototype.checkDeprecatedParams = function () {
	        if (this.scalarFilterParams.nullComparator) {
	            console.warn('AG Grid: Since v21.0, the property filterParams.nullComparator is deprecated. ' +
	                'Please use filterParams.includeBlanksInEquals, filterParams.includeBlanksInLessThan and ' +
	                'filterParams.includeBlanksInGreaterThan instead.');
	            this.scalarFilterParams.includeBlanksInEquals = this.scalarFilterParams.nullComparator.equals;
	            this.scalarFilterParams.includeBlanksInLessThan = this.scalarFilterParams.nullComparator.lessThan;
	            this.scalarFilterParams.includeBlanksInGreaterThan = this.scalarFilterParams.nullComparator.greaterThan;
	        }
	    };
	    ScalarFilter.prototype.individualConditionPasses = function (params, filterModel) {
	        var cellValue = this.scalarFilterParams.valueGetter(params.node);
	        var range = this.mapRangeFromModel(filterModel);
	        var filterValue = range.from;
	        var filterValueTo = range.to;
	        var filterType = filterModel.type;
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        if (customFilterOption) {
	            // only execute the custom filter if a value exists or a value isn't required, i.e. input is hidden
	            if (filterValue != null || customFilterOption.hideFilterInput) {
	                return customFilterOption.test(filterValue, cellValue);
	            }
	        }
	        if (cellValue == null) {
	            switch (filterType) {
	                case ScalarFilter.EQUALS:
	                case ScalarFilter.NOT_EQUAL:
	                    if (this.scalarFilterParams.includeBlanksInEquals) {
	                        return true;
	                    }
	                    break;
	                case ScalarFilter.GREATER_THAN:
	                case ScalarFilter.GREATER_THAN_OR_EQUAL:
	                    if (this.scalarFilterParams.includeBlanksInGreaterThan) {
	                        return true;
	                    }
	                    break;
	                case ScalarFilter.LESS_THAN:
	                case ScalarFilter.LESS_THAN_OR_EQUAL:
	                    if (this.scalarFilterParams.includeBlanksInLessThan) {
	                        return true;
	                    }
	                    break;
	                case ScalarFilter.IN_RANGE:
	                    if (this.scalarFilterParams.includeBlanksInRange) {
	                        return true;
	                    }
	                    break;
	            }
	            return false;
	        }
	        var comparator = this.comparator();
	        var compareResult = comparator(filterValue, cellValue);
	        switch (filterType) {
	            case ScalarFilter.EQUALS:
	                return compareResult === 0;
	            case ScalarFilter.NOT_EQUAL:
	                return compareResult !== 0;
	            case ScalarFilter.GREATER_THAN:
	                return compareResult > 0;
	            case ScalarFilter.GREATER_THAN_OR_EQUAL:
	                return compareResult >= 0;
	            case ScalarFilter.LESS_THAN:
	                return compareResult < 0;
	            case ScalarFilter.LESS_THAN_OR_EQUAL:
	                return compareResult <= 0;
	            case ScalarFilter.IN_RANGE: {
	                var compareToResult = comparator(filterValueTo, cellValue);
	                return this.scalarFilterParams.inRangeInclusive ?
	                    compareResult >= 0 && compareToResult <= 0 :
	                    compareResult > 0 && compareToResult < 0;
	            }
	            default:
	                console.warn('AG Grid: Unexpected type of filter "' + filterType + '", it looks like the filter was configured with incorrect Filter Options');
	                return true;
	        }
	    };
	    return ScalarFilter;
	}(SimpleFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$d = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$f = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var DateFilter = /** @class */ (function (_super) {
	    __extends$d(DateFilter, _super);
	    function DateFilter() {
	        return _super.call(this, 'dateFilter') || this;
	    }
	    DateFilter.prototype.afterGuiAttached = function (params) {
	        _super.prototype.afterGuiAttached.call(this, params);
	        this.dateCondition1FromComp.afterGuiAttached(params);
	    };
	    DateFilter.prototype.mapRangeFromModel = function (filterModel) {
	        // unlike the other filters, we do two things here:
	        // 1) allow for different attribute names (same as done for other filters) (eg the 'from' and 'to'
	        //    are in different locations in Date and Number filter models)
	        // 2) convert the type (because Date filter uses Dates, however model is 'string')
	        //
	        // NOTE: The conversion of string to date also removes the timezone - i.e. when user picks
	        //       a date from the UI, it will have timezone info in it. This is lost when creating
	        //       the model. When we recreate the date again here, it's without a timezone.
	        return {
	            from: parseDateTimeFromString(filterModel.dateFrom),
	            to: parseDateTimeFromString(filterModel.dateTo)
	        };
	    };
	    DateFilter.prototype.setValueFromFloatingFilter = function (value) {
	        this.dateCondition1FromComp.setDate(value == null ? null : parseDateTimeFromString(value));
	        this.dateCondition1ToComp.setDate(null);
	        this.dateCondition2FromComp.setDate(null);
	        this.dateCondition2ToComp.setDate(null);
	    };
	    DateFilter.prototype.setConditionIntoUi = function (model, position) {
	        var _a = model ?
	            [parseDateTimeFromString(model.dateFrom), parseDateTimeFromString(model.dateTo)] :
	            [null, null], dateFrom = _a[0], dateTo = _a[1];
	        var _b = this.getFromToComponents(position), compFrom = _b[0], compTo = _b[1];
	        compFrom.setDate(dateFrom);
	        compTo.setDate(dateTo);
	    };
	    DateFilter.prototype.resetUiToDefaults = function (silent) {
	        var _this = this;
	        return _super.prototype.resetUiToDefaults.call(this, silent).then(function () {
	            _this.dateCondition1FromComp.setDate(null);
	            _this.dateCondition1ToComp.setDate(null);
	            _this.dateCondition2FromComp.setDate(null);
	            _this.dateCondition2ToComp.setDate(null);
	        });
	    };
	    DateFilter.prototype.comparator = function () {
	        return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
	    };
	    DateFilter.prototype.defaultComparator = function (filterDate, cellValue) {
	        // The default comparator assumes that the cellValue is a date
	        var cellAsDate = cellValue;
	        if (cellValue == null || cellAsDate < filterDate) {
	            return -1;
	        }
	        if (cellAsDate > filterDate) {
	            return 1;
	        }
	        return 0;
	    };
	    DateFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.dateFilterParams = params;
	        this.createDateComponents();
	    };
	    DateFilter.prototype.createDateComponents = function () {
	        var _this = this;
	        var createDateCompWrapper = function (element) {
	            return new DateCompWrapper(_this.getContext(), _this.userComponentFactory, {
	                onDateChanged: function () { return _this.onUiChanged(); },
	                filterParams: _this.dateFilterParams
	            }, element);
	        };
	        this.dateCondition1FromComp = createDateCompWrapper(this.eCondition1PanelFrom);
	        this.dateCondition1ToComp = createDateCompWrapper(this.eCondition1PanelTo);
	        this.dateCondition2FromComp = createDateCompWrapper(this.eCondition2PanelFrom);
	        this.dateCondition2ToComp = createDateCompWrapper(this.eCondition2PanelTo);
	        this.addDestroyFunc(function () {
	            _this.dateCondition1FromComp.destroy();
	            _this.dateCondition1ToComp.destroy();
	            _this.dateCondition2FromComp.destroy();
	            _this.dateCondition2ToComp.destroy();
	        });
	    };
	    DateFilter.prototype.getDefaultFilterOptions = function () {
	        return DateFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    DateFilter.prototype.createValueTemplate = function (position) {
	        var pos = position === ConditionPosition.One ? '1' : '2';
	        return /* html */ "\n            <div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\">\n                <div class=\"ag-filter-from ag-filter-date-from\" ref=\"eCondition" + pos + "PanelFrom\"></div>\n                <div class=\"ag-filter-to ag-filter-date-to\" ref=\"eCondition" + pos + "PanelTo\"></div>\n            </div>";
	    };
	    DateFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        if (option === SimpleFilter.EMPTY) {
	            return false;
	        }
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        var _a = this.getFromToComponents(position), compFrom = _a[0], compTo = _a[1];
	        var minValidYear = this.dateFilterParams.minValidYear == null ? 1000 : this.dateFilterParams.minValidYear;
	        var isValidDate = function (value) { return value != null && value.getUTCFullYear() > minValidYear; };
	        return isValidDate(compFrom.getDate()) && (!this.showValueTo(option) || isValidDate(compTo.getDate()));
	    };
	    DateFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.dateFrom === bSimple.dateFrom
	            && aSimple.dateTo === bSimple.dateTo
	            && aSimple.type === bSimple.type;
	    };
	    DateFilter.prototype.getFilterType = function () {
	        return 'date';
	    };
	    DateFilter.prototype.createCondition = function (position) {
	        var positionOne = position === ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var _a = this.getFromToComponents(position), compFrom = _a[0], compTo = _a[1];
	        return {
	            dateFrom: serialiseDate(compFrom.getDate()),
	            dateTo: serialiseDate(compTo.getDate()),
	            type: type,
	            filterType: this.getFilterType()
	        };
	    };
	    DateFilter.prototype.resetPlaceholder = function () {
	        var globalTranslate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var placeholder = this.translate('dateFormatOoo');
	        var ariaLabel = globalTranslate('ariaFilterValue', 'Filter Value');
	        this.dateCondition1FromComp.setInputPlaceholder(placeholder);
	        this.dateCondition1FromComp.setInputAriaLabel(ariaLabel);
	        this.dateCondition1ToComp.setInputPlaceholder(placeholder);
	        this.dateCondition1ToComp.setInputAriaLabel(ariaLabel);
	        this.dateCondition2FromComp.setInputPlaceholder(placeholder);
	        this.dateCondition2FromComp.setInputAriaLabel(ariaLabel);
	        this.dateCondition2ToComp.setInputPlaceholder(placeholder);
	        this.dateCondition2ToComp.setInputAriaLabel(ariaLabel);
	    };
	    DateFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        this.resetPlaceholder();
	        var condition1Type = this.getCondition1Type();
	        setDisplayed(this.eCondition1PanelFrom, this.showValueFrom(condition1Type));
	        setDisplayed(this.eCondition1PanelTo, this.showValueTo(condition1Type));
	        var condition2Type = this.getCondition2Type();
	        setDisplayed(this.eCondition2PanelFrom, this.showValueFrom(condition2Type));
	        setDisplayed(this.eCondition2PanelTo, this.showValueTo(condition2Type));
	    };
	    DateFilter.prototype.getFromToComponents = function (position) {
	        return position === ConditionPosition.One ?
	            [this.dateCondition1FromComp, this.dateCondition1ToComp] :
	            [this.dateCondition2FromComp, this.dateCondition2ToComp];
	    };
	    DateFilter.DEFAULT_FILTER_OPTIONS = [
	        ScalarFilter.EQUALS,
	        ScalarFilter.GREATER_THAN,
	        ScalarFilter.LESS_THAN,
	        ScalarFilter.NOT_EQUAL,
	        ScalarFilter.IN_RANGE
	    ];
	    __decorate$f([
	        RefSelector('eCondition1PanelFrom')
	    ], DateFilter.prototype, "eCondition1PanelFrom", void 0);
	    __decorate$f([
	        RefSelector('eCondition1PanelTo')
	    ], DateFilter.prototype, "eCondition1PanelTo", void 0);
	    __decorate$f([
	        RefSelector('eCondition2PanelFrom')
	    ], DateFilter.prototype, "eCondition2PanelFrom", void 0);
	    __decorate$f([
	        RefSelector('eCondition2PanelTo')
	    ], DateFilter.prototype, "eCondition2PanelTo", void 0);
	    __decorate$f([
	        Autowired('userComponentFactory')
	    ], DateFilter.prototype, "userComponentFactory", void 0);
	    return DateFilter;
	}(ScalarFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var TouchListener = /** @class */ (function () {
	    function TouchListener(eElement, preventMouseClick) {
	        var _this = this;
	        if (preventMouseClick === void 0) { preventMouseClick = false; }
	        this.destroyFuncs = [];
	        this.touching = false;
	        this.eventService = new EventService();
	        this.eElement = eElement;
	        this.preventMouseClick = preventMouseClick;
	        var startListener = this.onTouchStart.bind(this);
	        var moveListener = this.onTouchMove.bind(this);
	        var endListener = this.onTouchEnd.bind(this);
	        this.eElement.addEventListener("touchstart", startListener, { passive: true });
	        this.eElement.addEventListener("touchmove", moveListener, { passive: true });
	        // we set passive=false, as we want to prevent default on this event
	        this.eElement.addEventListener("touchend", endListener, { passive: false });
	        this.destroyFuncs.push(function () {
	            _this.eElement.removeEventListener("touchstart", startListener, { passive: true });
	            _this.eElement.removeEventListener("touchmove", moveListener, { passive: true });
	            _this.eElement.removeEventListener("touchend", endListener, { passive: false });
	        });
	    }
	    TouchListener.prototype.getActiveTouch = function (touchList) {
	        for (var i = 0; i < touchList.length; i++) {
	            var matches = touchList[i].identifier === this.touchStart.identifier;
	            if (matches) {
	                return touchList[i];
	            }
	        }
	        return null;
	    };
	    TouchListener.prototype.addEventListener = function (eventType, listener) {
	        this.eventService.addEventListener(eventType, listener);
	    };
	    TouchListener.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    TouchListener.prototype.onTouchStart = function (touchEvent) {
	        var _this = this;
	        // only looking at one touch point at any time
	        if (this.touching) {
	            return;
	        }
	        this.touchStart = touchEvent.touches[0];
	        this.touching = true;
	        this.moved = false;
	        var touchStartCopy = this.touchStart;
	        window.setTimeout(function () {
	            var touchesMatch = _this.touchStart === touchStartCopy;
	            if (_this.touching && touchesMatch && !_this.moved) {
	                _this.moved = true;
	                var event_1 = {
	                    type: TouchListener.EVENT_LONG_TAP,
	                    touchStart: _this.touchStart,
	                    touchEvent: touchEvent
	                };
	                _this.eventService.dispatchEvent(event_1);
	            }
	        }, 500);
	    };
	    TouchListener.prototype.onTouchMove = function (touchEvent) {
	        if (!this.touching) {
	            return;
	        }
	        var touch = this.getActiveTouch(touchEvent.touches);
	        if (!touch) {
	            return;
	        }
	        var eventIsFarAway = !areEventsNear(touch, this.touchStart, 4);
	        if (eventIsFarAway) {
	            this.moved = true;
	        }
	    };
	    TouchListener.prototype.onTouchEnd = function (touchEvent) {
	        if (!this.touching) {
	            return;
	        }
	        if (!this.moved) {
	            var event_2 = {
	                type: TouchListener.EVENT_TAP,
	                touchStart: this.touchStart
	            };
	            this.eventService.dispatchEvent(event_2);
	            this.checkForDoubleTap();
	        }
	        // stops the tap from also been processed as a mouse click
	        if (this.preventMouseClick) {
	            touchEvent.preventDefault();
	        }
	        this.touching = false;
	    };
	    TouchListener.prototype.checkForDoubleTap = function () {
	        var now = new Date().getTime();
	        if (this.lastTapTime && this.lastTapTime > 0) {
	            // if previous tap, see if duration is short enough to be considered double tap
	            var interval = now - this.lastTapTime;
	            if (interval > TouchListener.DOUBLE_TAP_MILLIS) {
	                // dispatch double tap event
	                var event_3 = {
	                    type: TouchListener.EVENT_DOUBLE_TAP,
	                    touchStart: this.touchStart
	                };
	                this.eventService.dispatchEvent(event_3);
	                // this stops a tripple tap ending up as two double taps
	                this.lastTapTime = null;
	            }
	            else {
	                this.lastTapTime = now;
	            }
	        }
	        else {
	            this.lastTapTime = now;
	        }
	    };
	    TouchListener.prototype.destroy = function () {
	        this.destroyFuncs.forEach(function (func) { return func(); });
	    };
	    TouchListener.EVENT_TAP = "tap";
	    TouchListener.EVENT_DOUBLE_TAP = "doubleTap";
	    TouchListener.EVENT_LONG_TAP = "longTap";
	    TouchListener.DOUBLE_TAP_MILLIS = 500;
	    return TouchListener;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$e = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$g = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderComp = /** @class */ (function (_super) {
	    __extends$e(HeaderComp, _super);
	    function HeaderComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.lastMovingChanged = 0;
	        return _this;
	    }
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to override destroy() just to make the method public.
	    HeaderComp.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	    };
	    HeaderComp.prototype.refresh = function (params) {
	        this.params = params;
	        // if template changed, then recreate the whole comp, the code required to manage
	        // a changing template is to difficult for what it's worth.
	        if (this.workOutTemplate() != this.currentTemplate) {
	            return false;
	        }
	        if (this.workOutShowMenu() != this.currentShowMenu) {
	            return false;
	        }
	        if (this.workOutSort() != this.currentSort) {
	            return false;
	        }
	        this.setDisplayName(params);
	        return true;
	    };
	    HeaderComp.prototype.workOutTemplate = function () {
	        var template = firstExistingValue(this.params.template, HeaderComp.TEMPLATE);
	        // take account of any newlines & whitespace before/after the actual template
	        template = template && template.trim ? template.trim() : template;
	        return template;
	    };
	    HeaderComp.prototype.init = function (params) {
	        this.params = params;
	        this.currentTemplate = this.workOutTemplate();
	        this.setTemplate(this.currentTemplate);
	        this.setupTap();
	        this.setupIcons(params.column);
	        this.setMenu();
	        this.setupSort();
	        this.setupFilterIcon();
	        this.setDisplayName(params);
	    };
	    HeaderComp.prototype.setDisplayName = function (params) {
	        if (this.currentDisplayName != params.displayName) {
	            this.currentDisplayName = params.displayName;
	            var displayNameSanitised = escapeString(this.currentDisplayName);
	            if (this.eText) {
	                this.eText.innerHTML = displayNameSanitised;
	            }
	        }
	    };
	    HeaderComp.prototype.setupIcons = function (column) {
	        this.addInIcon('sortAscending', this.eSortAsc, column);
	        this.addInIcon('sortDescending', this.eSortDesc, column);
	        this.addInIcon('sortUnSort', this.eSortNone, column);
	        this.addInIcon('menu', this.eMenu, column);
	        this.addInIcon('filter', this.eFilter, column);
	    };
	    HeaderComp.prototype.addInIcon = function (iconName, eParent, column) {
	        if (eParent == null) {
	            return;
	        }
	        var eIcon = createIconNoSpan(iconName, this.gridOptionsWrapper, column);
	        if (eIcon) {
	            eParent.appendChild(eIcon);
	        }
	    };
	    HeaderComp.prototype.setupTap = function () {
	        var _this = this;
	        var options = this.gridOptionsWrapper;
	        if (options.isSuppressTouch()) {
	            return;
	        }
	        var touchListener = new TouchListener(this.getGui(), true);
	        var suppressMenuHide = options.isSuppressMenuHide();
	        var tapMenuButton = suppressMenuHide && exists(this.eMenu);
	        var menuTouchListener = tapMenuButton ? new TouchListener(this.eMenu, true) : touchListener;
	        if (this.params.enableMenu) {
	            var eventType = tapMenuButton ? 'EVENT_TAP' : 'EVENT_LONG_TAP';
	            var showMenuFn = function (event) {
	                options.getApi().showColumnMenuAfterMouseClick(_this.params.column, event.touchStart);
	            };
	            this.addManagedListener(menuTouchListener, TouchListener[eventType], showMenuFn);
	        }
	        if (this.params.enableSorting) {
	            var tapListener = function (event) {
	                var target = event.touchStart.target;
	                // When suppressMenuHide is true, a tap on the menu icon will bubble up
	                // to the header container, in that case we should not sort
	                if (suppressMenuHide && _this.eMenu.contains(target)) {
	                    return;
	                }
	                _this.sortController.progressSort(_this.params.column, false, "uiColumnSorted");
	            };
	            this.addManagedListener(touchListener, TouchListener.EVENT_TAP, tapListener);
	        }
	        // if tapMenuButton is true `touchListener` and `menuTouchListener` are different
	        // so we need to make sure to destroy both listeners here
	        this.addDestroyFunc(function () { return touchListener.destroy(); });
	        if (tapMenuButton) {
	            this.addDestroyFunc(function () { return menuTouchListener.destroy(); });
	        }
	    };
	    HeaderComp.prototype.workOutShowMenu = function () {
	        // we don't show the menu if on an iPad/iPhone, as the user cannot have a pointer device/
	        // However if suppressMenuHide is set to true the menu will be displayed alwasys, so it's ok
	        // to show it on iPad in this case (as hover isn't needed). If suppressMenuHide
	        // is false (default) user will need to use longpress to display the menu.
	        var menuHides = !this.gridOptionsWrapper.isSuppressMenuHide();
	        var onIpadAndMenuHides = isIOSUserAgent() && menuHides;
	        var showMenu = this.params.enableMenu && !onIpadAndMenuHides;
	        return showMenu;
	    };
	    HeaderComp.prototype.setMenu = function () {
	        var _this = this;
	        // if no menu provided in template, do nothing
	        if (!this.eMenu) {
	            return;
	        }
	        this.currentShowMenu = this.workOutShowMenu();
	        if (!this.currentShowMenu) {
	            removeFromParent(this.eMenu);
	            return;
	        }
	        var suppressMenuHide = this.gridOptionsWrapper.isSuppressMenuHide();
	        this.addManagedListener(this.eMenu, 'click', function () { return _this.showMenu(_this.eMenu); });
	        addOrRemoveCssClass(this.eMenu, 'ag-header-menu-always-show', suppressMenuHide);
	    };
	    HeaderComp.prototype.showMenu = function (eventSource) {
	        if (!eventSource) {
	            eventSource = this.eMenu;
	        }
	        this.menuFactory.showMenuAfterButtonClick(this.params.column, eventSource);
	    };
	    HeaderComp.prototype.removeSortIcons = function () {
	        removeFromParent(this.eSortAsc);
	        removeFromParent(this.eSortDesc);
	        removeFromParent(this.eSortNone);
	        removeFromParent(this.eSortOrder);
	    };
	    HeaderComp.prototype.workOutSort = function () {
	        return this.params.enableSorting;
	    };
	    HeaderComp.prototype.setupSort = function () {
	        var _this = this;
	        this.currentSort = this.params.enableSorting;
	        if (!this.currentSort) {
	            this.removeSortIcons();
	            return;
	        }
	        var sortUsingCtrl = this.gridOptionsWrapper.isMultiSortKeyCtrl();
	        // keep track of last time the moving changed flag was set
	        this.addManagedListener(this.params.column, Column.EVENT_MOVING_CHANGED, function () {
	            _this.lastMovingChanged = new Date().getTime();
	        });
	        // add the event on the header, so when clicked, we do sorting
	        if (this.eLabel) {
	            this.addManagedListener(this.eLabel, 'click', function (event) {
	                // sometimes when moving a column via dragging, this was also firing a clicked event.
	                // here is issue raised by user: https://ag-grid.zendesk.com/agent/tickets/1076
	                // this check stops sort if a) column is moving or b) column moved less than 200ms ago (so caters for race condition)
	                var moving = _this.params.column.isMoving();
	                var nowTime = new Date().getTime();
	                // typically there is <2ms if moving flag was set recently, as it would be done in same VM turn
	                var movedRecently = (nowTime - _this.lastMovingChanged) < 50;
	                var columnMoving = moving || movedRecently;
	                if (!columnMoving) {
	                    var multiSort = sortUsingCtrl ? (event.ctrlKey || event.metaKey) : event.shiftKey;
	                    _this.params.progressSort(multiSort);
	                }
	            });
	        }
	        this.addManagedListener(this.params.column, Column.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.onSortChanged();
	        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.setMultiSortOrder.bind(this));
	        this.setMultiSortOrder();
	    };
	    HeaderComp.prototype.onSortChanged = function () {
	        addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-asc', this.params.column.isSortAscending());
	        addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-desc', this.params.column.isSortDescending());
	        addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-none', this.params.column.isSortNone());
	        if (this.eSortAsc) {
	            addOrRemoveCssClass(this.eSortAsc, 'ag-hidden', !this.params.column.isSortAscending());
	        }
	        if (this.eSortDesc) {
	            addOrRemoveCssClass(this.eSortDesc, 'ag-hidden', !this.params.column.isSortDescending());
	        }
	        if (this.eSortNone) {
	            var alwaysHideNoSort = !this.params.column.getColDef().unSortIcon && !this.gridOptionsWrapper.isUnSortIcon();
	            addOrRemoveCssClass(this.eSortNone, 'ag-hidden', alwaysHideNoSort || !this.params.column.isSortNone());
	        }
	    };
	    // we listen here for global sort events, NOT column sort events, as we want to do this
	    // when sorting has been set on all column (if we listened just for our col (where we
	    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
	    HeaderComp.prototype.setMultiSortOrder = function () {
	        if (!this.eSortOrder) {
	            return;
	        }
	        var col = this.params.column;
	        var allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
	        var indexThisCol = allColumnsWithSorting.indexOf(col);
	        var moreThanOneColSorting = allColumnsWithSorting.length > 1;
	        var showIndex = col.isSorting() && moreThanOneColSorting;
	        setDisplayed(this.eSortOrder, showIndex);
	        if (indexThisCol >= 0) {
	            this.eSortOrder.innerHTML = (indexThisCol + 1).toString();
	        }
	        else {
	            clearElement(this.eSortOrder);
	        }
	    };
	    HeaderComp.prototype.setupFilterIcon = function () {
	        if (!this.eFilter) {
	            return;
	        }
	        this.addManagedListener(this.params.column, Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.onFilterChanged();
	    };
	    HeaderComp.prototype.onFilterChanged = function () {
	        var filterPresent = this.params.column.isFilterActive();
	        addOrRemoveCssClass(this.eFilter, 'ag-hidden', !filterPresent);
	    };
	    HeaderComp.TEMPLATE = "<div class=\"ag-cell-label-container\" role=\"presentation\">\n            <span ref=\"eMenu\" class=\"ag-header-icon ag-header-cell-menu-button\" aria-hidden=\"true\"></span>\n            <div ref=\"eLabel\" class=\"ag-header-cell-label\" role=\"presentation\" unselectable=\"on\">\n                <span ref=\"eText\" class=\"ag-header-cell-text\" unselectable=\"on\"></span>\n                <span ref=\"eFilter\" class=\"ag-header-icon ag-header-label-icon ag-filter-icon\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortOrder\" class=\"ag-header-icon ag-header-label-icon ag-sort-order\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortAsc\" class=\"ag-header-icon ag-header-label-icon ag-sort-ascending-icon\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortDesc\" class=\"ag-header-icon ag-header-label-icon ag-sort-descending-icon\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortNone\" class=\"ag-header-icon ag-header-label-icon ag-sort-none-icon\" aria-hidden=\"true\"></span>\n            </div>\n        </div>";
	    __decorate$g([
	        Autowired('sortController')
	    ], HeaderComp.prototype, "sortController", void 0);
	    __decorate$g([
	        Autowired('menuFactory')
	    ], HeaderComp.prototype, "menuFactory", void 0);
	    __decorate$g([
	        RefSelector('eFilter')
	    ], HeaderComp.prototype, "eFilter", void 0);
	    __decorate$g([
	        RefSelector('eSortAsc')
	    ], HeaderComp.prototype, "eSortAsc", void 0);
	    __decorate$g([
	        RefSelector('eSortDesc')
	    ], HeaderComp.prototype, "eSortDesc", void 0);
	    __decorate$g([
	        RefSelector('eSortNone')
	    ], HeaderComp.prototype, "eSortNone", void 0);
	    __decorate$g([
	        RefSelector('eSortOrder')
	    ], HeaderComp.prototype, "eSortOrder", void 0);
	    __decorate$g([
	        RefSelector('eMenu')
	    ], HeaderComp.prototype, "eMenu", void 0);
	    __decorate$g([
	        RefSelector('eLabel')
	    ], HeaderComp.prototype, "eLabel", void 0);
	    __decorate$g([
	        RefSelector('eText')
	    ], HeaderComp.prototype, "eText", void 0);
	    return HeaderComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$f = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$h = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderGroupComp = /** @class */ (function (_super) {
	    __extends$f(HeaderGroupComp, _super);
	    function HeaderGroupComp() {
	        return _super.call(this, HeaderGroupComp.TEMPLATE) || this;
	    }
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to override destroy() just to make the method public.
	    HeaderGroupComp.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	    };
	    HeaderGroupComp.prototype.init = function (params) {
	        this.params = params;
	        this.checkWarnings();
	        this.setupLabel();
	        this.addGroupExpandIcon();
	        this.setupExpandIcons();
	    };
	    HeaderGroupComp.prototype.checkWarnings = function () {
	        var paramsAny = this.params;
	        if (paramsAny.template) {
	            var message_1 = "A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)";
	            doOnce(function () { return console.warn(message_1); }, 'HeaderGroupComp.templateNotSupported');
	        }
	    };
	    HeaderGroupComp.prototype.setupExpandIcons = function () {
	        var _this = this;
	        this.addInIcon("columnGroupOpened", "agOpened");
	        this.addInIcon("columnGroupClosed", "agClosed");
	        var expandAction = function (event) {
	            if (isStopPropagationForAgGrid(event)) {
	                return;
	            }
	            var newExpandedValue = !_this.params.columnGroup.isExpanded();
	            _this.columnController.setColumnGroupOpened(_this.params.columnGroup.getOriginalColumnGroup(), newExpandedValue, "uiColumnExpanded");
	        };
	        this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
	        this.addTouchAndClickListeners(this.eOpenIcon, expandAction);
	        var stopPropagationAction = function (event) {
	            stopPropagationForAgGrid(event);
	        };
	        // adding stopPropagation to the double click for the icons prevents double click action happening
	        // when the icons are clicked. if the icons are double clicked, then the groups should open and
	        // then close again straight away. if we also listened to double click, then the group would open,
	        // close, then open, which is not what we want. double click should only action if the user double
	        // clicks outside of the icons.
	        this.addManagedListener(this.eCloseIcon, "dblclick", stopPropagationAction);
	        this.addManagedListener(this.eOpenIcon, "dblclick", stopPropagationAction);
	        this.addManagedListener(this.getGui(), "dblclick", expandAction);
	        this.updateIconVisibility();
	        var originalColumnGroup = this.params.columnGroup.getOriginalColumnGroup();
	        this.addManagedListener(originalColumnGroup, OriginalColumnGroup.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
	        this.addManagedListener(originalColumnGroup, OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
	    };
	    HeaderGroupComp.prototype.addTouchAndClickListeners = function (eElement, action) {
	        var touchListener = new TouchListener(eElement, true);
	        this.addManagedListener(touchListener, TouchListener.EVENT_TAP, action);
	        this.addDestroyFunc(function () { return touchListener.destroy(); });
	        this.addManagedListener(eElement, "click", action);
	    };
	    HeaderGroupComp.prototype.updateIconVisibility = function () {
	        var columnGroup = this.params.columnGroup;
	        if (columnGroup.isExpandable()) {
	            var expanded = this.params.columnGroup.isExpanded();
	            setDisplayed(this.eOpenIcon, expanded);
	            setDisplayed(this.eCloseIcon, !expanded);
	        }
	        else {
	            setDisplayed(this.eOpenIcon, false);
	            setDisplayed(this.eCloseIcon, false);
	        }
	    };
	    HeaderGroupComp.prototype.addInIcon = function (iconName, refName) {
	        var eIcon = createIconNoSpan(iconName, this.gridOptionsWrapper, null);
	        if (eIcon) {
	            this.getRefElement(refName).appendChild(eIcon);
	        }
	    };
	    HeaderGroupComp.prototype.addGroupExpandIcon = function () {
	        if (!this.params.columnGroup.isExpandable()) {
	            setDisplayed(this.eOpenIcon, false);
	            setDisplayed(this.eCloseIcon, false);
	            return;
	        }
	    };
	    HeaderGroupComp.prototype.setupLabel = function () {
	        // no renderer, default text render
	        var displayName = this.params.displayName;
	        if (exists(displayName)) {
	            var displayNameSanitised = escapeString(displayName);
	            this.getRefElement('agLabel').innerHTML = displayNameSanitised;
	        }
	    };
	    HeaderGroupComp.TEMPLATE = "<div class=\"ag-header-group-cell-label\" ref=\"agContainer\" role=\"presentation\">\n            <span ref=\"agLabel\" class=\"ag-header-group-text\" role=\"presentation\"></span>\n            <span ref=\"agOpened\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded\"></span>\n            <span ref=\"agClosed\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed\"></span>\n        </div>";
	    __decorate$h([
	        Autowired("columnController")
	    ], HeaderGroupComp.prototype, "columnController", void 0);
	    __decorate$h([
	        RefSelector("agOpened")
	    ], HeaderGroupComp.prototype, "eOpenIcon", void 0);
	    __decorate$h([
	        RefSelector("agClosed")
	    ], HeaderGroupComp.prototype, "eCloseIcon", void 0);
	    return HeaderGroupComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$i = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var RowNode = /** @class */ (function () {
	    function RowNode() {
	        /** The index of this node in the grid, only valid if node is displayed in the grid, otherwise it should be ignored as old index may be present */
	        this.rowIndex = null;
	        /** Groups only - The key for the group eg Ireland, UK, USA */
	        this.key = null;
	        /** Children mapped by the pivot columns */
	        this.childrenMapped = {};
	        /**
	         * True if the RowNode is not filtered, or in a collapsed group.
	         */
	        this.displayed = false;
	        /** The top pixel for this row */
	        this.rowTop = null;
	        /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
	         * it is used so new rows can animate in from their old position. */
	        this.oldRowTop = null;
	        /** True by default - can be overridden via gridOptions.isRowSelectable(rowNode) */
	        this.selectable = true;
	        /** Used by sorting service - to give deterministic sort to groups. Previously we
	         * just id for this, however id is a string and had slower sorting compared to numbers. */
	        this.__objectId = RowNode.OBJECT_ID_SEQUENCE++;
	        /** True when nodes with the same id are being removed and added as part of the same batch transaction */
	        this.alreadyRendered = false;
	        this.highlighted = null;
	        this.selected = false;
	    }
	    RowNode.prototype.setData = function (data) {
	        this.setDataCommon(data, false);
	    };
	    // similar to setRowData, however it is expected that the data is the same data item. this
	    // is intended to be used with Redux type stores, where the whole data can be changed. we are
	    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
	    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
	    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
	    RowNode.prototype.updateData = function (data) {
	        this.setDataCommon(data, true);
	    };
	    RowNode.prototype.setDataCommon = function (data, update) {
	        var oldData = this.data;
	        this.data = data;
	        this.valueCache.onDataChanged();
	        this.updateDataOnDetailNode();
	        this.checkRowSelectable();
	        var event = this.createDataChangedEvent(data, oldData, update);
	        this.dispatchLocalEvent(event);
	    };
	    // when we are doing master / detail, the detail node is lazy created, but then kept around.
	    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
	    // in sync, otherwise expand/collapse of the detail would still show the old values.
	    RowNode.prototype.updateDataOnDetailNode = function () {
	        if (this.detailNode) {
	            this.detailNode.data = this.data;
	        }
	    };
	    RowNode.prototype.createDataChangedEvent = function (newData, oldData, update) {
	        return {
	            type: RowNode.EVENT_DATA_CHANGED,
	            node: this,
	            oldData: oldData,
	            newData: newData,
	            update: update
	        };
	    };
	    RowNode.prototype.createLocalRowEvent = function (type) {
	        return {
	            type: type,
	            node: this
	        };
	    };
	    RowNode.prototype.getRowIndexString = function () {
	        if (this.rowPinned === Constants.PINNED_TOP) {
	            return 't-' + this.rowIndex;
	        }
	        if (this.rowPinned === Constants.PINNED_BOTTOM) {
	            return 'b-' + this.rowIndex;
	        }
	        return this.rowIndex.toString();
	    };
	    RowNode.prototype.createDaemonNode = function () {
	        var oldNode = new RowNode();
	        this.context.createBean(oldNode);
	        // just copy the id and data, this is enough for the node to be used
	        // in the selection controller (the selection controller is the only
	        // place where daemon nodes can live).
	        oldNode.id = this.id;
	        oldNode.data = this.data;
	        oldNode.daemon = true;
	        oldNode.selected = this.selected;
	        oldNode.level = this.level;
	        return oldNode;
	    };
	    RowNode.prototype.setDataAndId = function (data, id) {
	        var oldNode = exists(this.id) ? this.createDaemonNode() : null;
	        var oldData = this.data;
	        this.data = data;
	        this.updateDataOnDetailNode();
	        this.setId(id);
	        this.selectionController.syncInRowNode(this, oldNode);
	        this.checkRowSelectable();
	        var event = this.createDataChangedEvent(data, oldData, false);
	        this.dispatchLocalEvent(event);
	    };
	    RowNode.prototype.checkRowSelectable = function () {
	        var isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	        this.setRowSelectable(isRowSelectableFunc ? isRowSelectableFunc(this) : true);
	    };
	    RowNode.prototype.setRowSelectable = function (newVal) {
	        if (this.selectable !== newVal) {
	            this.selectable = newVal;
	            if (this.eventService) {
	                this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_SELECTABLE_CHANGED));
	            }
	        }
	    };
	    RowNode.prototype.setId = function (id) {
	        // see if user is providing the id's
	        var getRowNodeId = this.gridOptionsWrapper.getRowNodeIdFunc();
	        if (getRowNodeId) {
	            // if user is providing the id's, then we set the id only after the data has been set.
	            // this is important for virtual pagination and viewport, where empty rows exist.
	            if (this.data) {
	                this.id = getRowNodeId(this.data);
	                // make sure id provided doesn't start with 'row-group-' as this is reserved. also check that
	                // it has 'startsWith' in case the user provided a number.
	                if (this.id && typeof this.id === 'string' && startsWith(this.id, RowNode.ID_PREFIX_ROW_GROUP)) {
	                    console.error("AG Grid: Row ID's cannot start with " + RowNode.ID_PREFIX_ROW_GROUP + ", this is a reserved prefix for AG Grid's row grouping feature.");
	                }
	            }
	            else {
	                // this can happen if user has set blank into the rowNode after the row previously
	                // having data. this happens in virtual page row model, when data is delete and
	                // the page is refreshed.
	                this.id = undefined;
	            }
	        }
	        else {
	            this.id = id;
	        }
	    };
	    RowNode.prototype.isPixelInRange = function (pixel) {
	        if (!exists(this.rowTop) || !exists(this.rowHeight)) {
	            return false;
	        }
	        return pixel >= this.rowTop && pixel < (this.rowTop + this.rowHeight);
	    };
	    RowNode.prototype.setFirstChild = function (firstChild) {
	        if (this.firstChild === firstChild) {
	            return;
	        }
	        this.firstChild = firstChild;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_FIRST_CHILD_CHANGED));
	        }
	    };
	    RowNode.prototype.setLastChild = function (lastChild) {
	        if (this.lastChild === lastChild) {
	            return;
	        }
	        this.lastChild = lastChild;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_LAST_CHILD_CHANGED));
	        }
	    };
	    RowNode.prototype.setChildIndex = function (childIndex) {
	        if (this.childIndex === childIndex) {
	            return;
	        }
	        this.childIndex = childIndex;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_CHILD_INDEX_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowTop = function (rowTop) {
	        this.oldRowTop = this.rowTop;
	        if (this.rowTop === rowTop) {
	            return;
	        }
	        this.rowTop = rowTop;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_TOP_CHANGED));
	        }
	        this.setDisplayed(rowTop !== null);
	    };
	    RowNode.prototype.clearRowTopAndRowIndex = function () {
	        this.oldRowTop = null;
	        this.setRowTop(null);
	        this.setRowIndex(null);
	    };
	    RowNode.prototype.setDisplayed = function (displayed) {
	        if (this.displayed === displayed) {
	            return;
	        }
	        this.displayed = displayed;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_DISPLAYED_CHANGED));
	        }
	    };
	    RowNode.prototype.setDragging = function (dragging) {
	        if (this.dragging === dragging) {
	            return;
	        }
	        this.dragging = dragging;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_DRAGGING_CHANGED));
	        }
	    };
	    RowNode.prototype.setHighlighted = function (highlighted) {
	        if (highlighted === this.highlighted) {
	            return;
	        }
	        this.highlighted = highlighted;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HIGHLIGHT_CHANGED));
	        }
	    };
	    RowNode.prototype.setAllChildrenCount = function (allChildrenCount) {
	        if (this.allChildrenCount === allChildrenCount) {
	            return;
	        }
	        this.allChildrenCount = allChildrenCount;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
	        }
	    };
	    RowNode.prototype.setMaster = function (master) {
	        if (this.master === master) {
	            return;
	        }
	        // if changing AWAY from master, then unexpand, otherwise
	        // next time it's shown it is expanded again
	        if (this.master && !master) {
	            this.expanded = false;
	        }
	        this.master = master;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_MASTER_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowHeight = function (rowHeight, estimated) {
	        if (estimated === void 0) { estimated = false; }
	        this.rowHeight = rowHeight;
	        this.rowHeightEstimated = estimated;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HEIGHT_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowIndex = function (rowIndex) {
	        if (this.rowIndex === rowIndex) {
	            return;
	        }
	        this.rowIndex = rowIndex;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_INDEX_CHANGED));
	        }
	    };
	    RowNode.prototype.setUiLevel = function (uiLevel) {
	        if (this.uiLevel === uiLevel) {
	            return;
	        }
	        this.uiLevel = uiLevel;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_UI_LEVEL_CHANGED));
	        }
	    };
	    RowNode.prototype.setExpanded = function (expanded) {
	        if (this.expanded === expanded) {
	            return;
	        }
	        this.expanded = expanded;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_EXPANDED_CHANGED));
	        }
	        var event = assign({}, this.createGlobalRowEvent(Events.EVENT_ROW_GROUP_OPENED), {
	            expanded: expanded
	        });
	        this.mainEventService.dispatchEvent(event);
	        // when using footers we need to refresh the group row, as the aggregation
	        // values jump between group and footer
	        if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
	            this.rowRenderer.refreshCells({ rowNodes: [this] });
	        }
	    };
	    RowNode.prototype.createGlobalRowEvent = function (type) {
	        return {
	            type: type,
	            node: this,
	            data: this.data,
	            rowIndex: this.rowIndex,
	            rowPinned: this.rowPinned,
	            context: this.gridOptionsWrapper.getContext(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	    };
	    RowNode.prototype.dispatchLocalEvent = function (event) {
	        if (this.eventService) {
	            this.eventService.dispatchEvent(event);
	        }
	    };
	    // we also allow editing the value via the editors. when it is done via
	    // the editors, no 'cell changed' event gets fired, as it's assumed that
	    // the cell knows about the change given it's in charge of the editing.
	    // this method is for the client to call, so the cell listens for the change
	    // event, and also flashes the cell when the change occurs.
	    RowNode.prototype.setDataValue = function (colKey, newValue) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        var oldValue = this.valueService.getValue(column, this);
	        this.valueService.setValue(this, column, newValue);
	        this.dispatchCellChangedEvent(column, newValue, oldValue);
	    };
	    RowNode.prototype.setGroupValue = function (colKey, newValue) {
	        var column = this.columnController.getGridColumn(colKey);
	        if (missing(this.groupData)) {
	            this.groupData = {};
	        }
	        var columnId = column.getColId();
	        var oldValue = this.groupData[columnId];
	        if (oldValue === newValue) {
	            return;
	        }
	        this.groupData[columnId] = newValue;
	        this.dispatchCellChangedEvent(column, newValue, oldValue);
	    };
	    // sets the data for an aggregation
	    RowNode.prototype.setAggData = function (newAggData) {
	        var _this = this;
	        // find out all keys that could potentially change
	        var colIds = getAllKeysInObjects([this.aggData, newAggData]);
	        var oldAggData = this.aggData;
	        this.aggData = newAggData;
	        // if no event service, nobody has registered for events, so no need fire event
	        if (this.eventService) {
	            colIds.forEach(function (colId) {
	                var column = _this.columnController.getGridColumn(colId);
	                var value = _this.aggData ? _this.aggData[colId] : undefined;
	                var oldValue = oldAggData ? oldAggData[colId] : undefined;
	                _this.dispatchCellChangedEvent(column, value, oldValue);
	            });
	        }
	    };
	    RowNode.prototype.updateHasChildren = function () {
	        // we need to return true when this.group=true, as this is used by server side row model
	        // (as children are lazy loaded and stored in a cache anyway). otherwise we return true
	        // if children exist.
	        var newValue = (this.group && !this.footer) || (this.childrenAfterGroup && this.childrenAfterGroup.length > 0);
	        if (newValue !== this.__hasChildren) {
	            this.__hasChildren = !!newValue;
	            if (this.eventService) {
	                this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HAS_CHILDREN_CHANGED));
	            }
	        }
	    };
	    RowNode.prototype.hasChildren = function () {
	        if (this.__hasChildren == null) {
	            this.updateHasChildren();
	        }
	        return this.__hasChildren;
	    };
	    RowNode.prototype.isEmptyRowGroupNode = function () {
	        return this.group && missingOrEmpty(this.childrenAfterGroup);
	    };
	    RowNode.prototype.dispatchCellChangedEvent = function (column, newValue, oldValue) {
	        var cellChangedEvent = {
	            type: RowNode.EVENT_CELL_CHANGED,
	            node: this,
	            column: column,
	            newValue: newValue,
	            oldValue: oldValue
	        };
	        this.dispatchLocalEvent(cellChangedEvent);
	    };
	    RowNode.prototype.resetQuickFilterAggregateText = function () {
	        this.quickFilterAggregateText = null;
	    };
	    RowNode.prototype.isExpandable = function () {
	        return this.hasChildren() || this.master ? true : false;
	    };
	    RowNode.prototype.isSelected = function () {
	        // for footers, we just return what our sibling selected state is, as cannot select a footer
	        if (this.footer) {
	            return this.sibling.isSelected();
	        }
	        return this.selected;
	    };
	    RowNode.prototype.depthFirstSearch = function (callback) {
	        if (this.childrenAfterGroup) {
	            this.childrenAfterGroup.forEach(function (child) { return child.depthFirstSearch(callback); });
	        }
	        callback(this);
	    };
	    // + rowController.updateGroupsInSelection()
	    // + selectionController.calculatedSelectedForAllGroupNodes()
	    RowNode.prototype.calculateSelectedFromChildren = function () {
	        var atLeastOneSelected = false;
	        var atLeastOneDeSelected = false;
	        var atLeastOneMixed = false;
	        var newSelectedValue;
	        if (this.childrenAfterGroup) {
	            for (var i = 0; i < this.childrenAfterGroup.length; i++) {
	                var child = this.childrenAfterGroup[i];
	                // skip non-selectable nodes to prevent inconsistent selection values
	                if (!child.selectable) {
	                    continue;
	                }
	                var childState = child.isSelected();
	                switch (childState) {
	                    case true:
	                        atLeastOneSelected = true;
	                        break;
	                    case false:
	                        atLeastOneDeSelected = true;
	                        break;
	                    default:
	                        atLeastOneMixed = true;
	                        break;
	                }
	            }
	        }
	        if (atLeastOneMixed) {
	            newSelectedValue = undefined;
	        }
	        else if (atLeastOneSelected && !atLeastOneDeSelected) {
	            newSelectedValue = true;
	        }
	        else if (!atLeastOneSelected && atLeastOneDeSelected) {
	            newSelectedValue = false;
	        }
	        else {
	            newSelectedValue = undefined;
	        }
	        this.selectThisNode(newSelectedValue);
	    };
	    RowNode.prototype.setSelectedInitialValue = function (selected) {
	        this.selected = selected;
	    };
	    RowNode.prototype.setSelected = function (newValue, clearSelection, suppressFinishActions) {
	        if (clearSelection === void 0) { clearSelection = false; }
	        if (suppressFinishActions === void 0) { suppressFinishActions = false; }
	        this.setSelectedParams({
	            newValue: newValue,
	            clearSelection: clearSelection,
	            suppressFinishActions: suppressFinishActions,
	            rangeSelect: false
	        });
	    };
	    RowNode.prototype.isRowPinned = function () {
	        return this.rowPinned === Constants.PINNED_TOP || this.rowPinned === Constants.PINNED_BOTTOM;
	    };
	    // to make calling code more readable, this is the same method as setSelected except it takes names parameters
	    RowNode.prototype.setSelectedParams = function (params) {
	        var groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        var newValue = params.newValue === true;
	        var clearSelection = params.clearSelection === true;
	        var suppressFinishActions = params.suppressFinishActions === true;
	        var rangeSelect = params.rangeSelect === true;
	        // groupSelectsFiltered only makes sense when group selects children
	        var groupSelectsFiltered = groupSelectsChildren && (params.groupSelectsFiltered === true);
	        if (this.id === undefined) {
	            console.warn('AG Grid: cannot select node until id for node is known');
	            return 0;
	        }
	        if (this.rowPinned) {
	            console.warn('AG Grid: cannot select pinned rows');
	            return 0;
	        }
	        // if we are a footer, we don't do selection, just pass the info
	        // to the sibling (the parent of the group)
	        if (this.footer) {
	            return this.sibling.setSelectedParams(params);
	        }
	        if (rangeSelect && this.selectionController.getLastSelectedNode()) {
	            var newRowClicked = this.selectionController.getLastSelectedNode() !== this;
	            var allowMultiSelect = this.gridOptionsWrapper.isRowSelectionMulti();
	            if (newRowClicked && allowMultiSelect) {
	                var nodesChanged = this.doRowRangeSelection(params.newValue);
	                this.selectionController.setLastSelectedNode(this);
	                return nodesChanged;
	            }
	        }
	        var updatedCount = 0;
	        // when groupSelectsFiltered, then this node may end up intermediate despite
	        // trying to set it to true / false. this group will be calculated further on
	        // down when we call calculatedSelectedForAllGroupNodes(). we need to skip it
	        // here, otherwise the updatedCount would include it.
	        var skipThisNode = groupSelectsFiltered && this.group;
	        if (!skipThisNode) {
	            var thisNodeWasSelected = this.selectThisNode(newValue);
	            if (thisNodeWasSelected) {
	                updatedCount++;
	            }
	        }
	        if (groupSelectsChildren && this.group) {
	            updatedCount += this.selectChildNodes(newValue, groupSelectsFiltered);
	        }
	        // clear other nodes if not doing multi select
	        if (!suppressFinishActions) {
	            var clearOtherNodes = newValue && (clearSelection || !this.gridOptionsWrapper.isRowSelectionMulti());
	            if (clearOtherNodes) {
	                updatedCount += this.selectionController.clearOtherNodes(this);
	            }
	            // only if we selected something, then update groups and fire events
	            if (updatedCount > 0) {
	                this.selectionController.updateGroupsFromChildrenSelections();
	                // this is the very end of the 'action node', so we are finished all the updates,
	                // include any parent / child changes that this method caused
	                var event_1 = {
	                    type: Events.EVENT_SELECTION_CHANGED,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.mainEventService.dispatchEvent(event_1);
	            }
	            // so if user next does shift-select, we know where to start the selection from
	            if (newValue) {
	                this.selectionController.setLastSelectedNode(this);
	            }
	        }
	        return updatedCount;
	    };
	    // selects all rows between this node and the last selected node (or the top if this is the first selection).
	    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
	    // holding down 'shift'.
	    RowNode.prototype.doRowRangeSelection = function (value) {
	        var _this = this;
	        if (value === void 0) { value = true; }
	        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        var lastSelectedNode = this.selectionController.getLastSelectedNode();
	        var nodesToSelect = this.rowModel.getNodesInRangeForSelection(this, lastSelectedNode);
	        var updatedCount = 0;
	        nodesToSelect.forEach(function (rowNode) {
	            if (rowNode.group && groupsSelectChildren || (value === false && _this === rowNode)) {
	                return;
	            }
	            var nodeWasSelected = rowNode.selectThisNode(value);
	            if (nodeWasSelected) {
	                updatedCount++;
	            }
	        });
	        this.selectionController.updateGroupsFromChildrenSelections();
	        var event = {
	            type: Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.mainEventService.dispatchEvent(event);
	        return updatedCount;
	    };
	    RowNode.prototype.isParentOfNode = function (potentialParent) {
	        var parentNode = this.parent;
	        while (parentNode) {
	            if (parentNode === potentialParent) {
	                return true;
	            }
	            parentNode = parentNode.parent;
	        }
	        return false;
	    };
	    RowNode.prototype.selectThisNode = function (newValue) {
	        // we only check selectable when newValue=true (ie selecting) to allow unselecting values,
	        // as selectable is dynamic, need a way to unselect rows when selectable becomes false.
	        var selectionNotAllowed = !this.selectable && newValue;
	        var selectionNotChanged = this.selected === newValue;
	        if (selectionNotAllowed || selectionNotChanged) {
	            return false;
	        }
	        this.selected = newValue;
	        if (this.eventService) {
	            this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_SELECTED));
	        }
	        var event = this.createGlobalRowEvent(Events.EVENT_ROW_SELECTED);
	        this.mainEventService.dispatchEvent(event);
	        return true;
	    };
	    RowNode.prototype.selectChildNodes = function (newValue, groupSelectsFiltered) {
	        var children = groupSelectsFiltered ? this.childrenAfterFilter : this.childrenAfterGroup;
	        if (missing(children)) {
	            return 0;
	        }
	        var updatedCount = 0;
	        for (var i = 0; i < children.length; i++) {
	            updatedCount += children[i].setSelectedParams({
	                newValue: newValue,
	                clearSelection: false,
	                suppressFinishActions: true,
	                groupSelectsFiltered: groupSelectsFiltered
	            });
	        }
	        return updatedCount;
	    };
	    RowNode.prototype.addEventListener = function (eventType, listener) {
	        if (!this.eventService) {
	            this.eventService = new EventService();
	        }
	        this.eventService.addEventListener(eventType, listener);
	    };
	    RowNode.prototype.removeEventListener = function (eventType, listener) {
	        if (!this.eventService) {
	            return;
	        }
	        this.eventService.removeEventListener(eventType, listener);
	        if (this.eventService.noRegisteredListenersExist()) {
	            this.eventService = null;
	        }
	    };
	    RowNode.prototype.onMouseEnter = function () {
	        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_ENTER));
	    };
	    RowNode.prototype.onMouseLeave = function () {
	        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_LEAVE));
	    };
	    RowNode.prototype.getFirstChildOfFirstChild = function (rowGroupColumn) {
	        var currentRowNode = this;
	        var isCandidate = true;
	        var foundFirstChildPath = false;
	        var nodeToSwapIn = null;
	        // if we are hiding groups, then if we are the first child, of the first child,
	        // all the way up to the column we are interested in, then we show the group cell.
	        while (isCandidate && !foundFirstChildPath) {
	            var parentRowNode = currentRowNode.parent;
	            var firstChild = exists(parentRowNode) && currentRowNode.firstChild;
	            if (firstChild) {
	                if (parentRowNode.rowGroupColumn === rowGroupColumn) {
	                    foundFirstChildPath = true;
	                    nodeToSwapIn = parentRowNode;
	                }
	            }
	            else {
	                isCandidate = false;
	            }
	            currentRowNode = parentRowNode;
	        }
	        return foundFirstChildPath ? nodeToSwapIn : null;
	    };
	    RowNode.prototype.isFullWidthCell = function () {
	        var isFullWidthCellFunc = this.gridOptionsWrapper.getIsFullWidthCellFunc();
	        return isFullWidthCellFunc ? isFullWidthCellFunc(this) : false;
	    };
	    RowNode.prototype.getRoute = function () {
	        if (this.key == null) {
	            return;
	        }
	        var res = [];
	        var pointer = this;
	        while (pointer.key != null) {
	            res.push(pointer.key);
	            pointer = pointer.parent;
	        }
	        return res.reverse();
	    };
	    RowNode.ID_PREFIX_ROW_GROUP = 'row-group-';
	    RowNode.ID_PREFIX_TOP_PINNED = 't-';
	    RowNode.ID_PREFIX_BOTTOM_PINNED = 'b-';
	    RowNode.OBJECT_ID_SEQUENCE = 0;
	    RowNode.EVENT_ROW_SELECTED = 'rowSelected';
	    RowNode.EVENT_DATA_CHANGED = 'dataChanged';
	    RowNode.EVENT_CELL_CHANGED = 'cellChanged';
	    RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = 'allChildrenCountChanged';
	    RowNode.EVENT_MASTER_CHANGED = 'masterChanged';
	    RowNode.EVENT_MOUSE_ENTER = 'mouseEnter';
	    RowNode.EVENT_MOUSE_LEAVE = 'mouseLeave';
	    RowNode.EVENT_HEIGHT_CHANGED = 'heightChanged';
	    RowNode.EVENT_TOP_CHANGED = 'topChanged';
	    RowNode.EVENT_DISPLAYED_CHANGED = 'displayedChanged';
	    RowNode.EVENT_FIRST_CHILD_CHANGED = 'firstChildChanged';
	    RowNode.EVENT_LAST_CHILD_CHANGED = 'lastChildChanged';
	    RowNode.EVENT_CHILD_INDEX_CHANGED = 'childIndexChanged';
	    RowNode.EVENT_ROW_INDEX_CHANGED = 'rowIndexChanged';
	    RowNode.EVENT_EXPANDED_CHANGED = 'expandedChanged';
	    RowNode.EVENT_HAS_CHILDREN_CHANGED = 'hasChildrenChanged';
	    RowNode.EVENT_SELECTABLE_CHANGED = 'selectableChanged';
	    RowNode.EVENT_UI_LEVEL_CHANGED = 'uiLevelChanged';
	    RowNode.EVENT_HIGHLIGHT_CHANGED = 'rowHighlightChanged';
	    RowNode.EVENT_DRAGGING_CHANGED = 'draggingChanged';
	    __decorate$i([
	        Autowired('eventService')
	    ], RowNode.prototype, "mainEventService", void 0);
	    __decorate$i([
	        Autowired('rowRenderer')
	    ], RowNode.prototype, "rowRenderer", void 0);
	    __decorate$i([
	        Autowired('gridOptionsWrapper')
	    ], RowNode.prototype, "gridOptionsWrapper", void 0);
	    __decorate$i([
	        Autowired('selectionController')
	    ], RowNode.prototype, "selectionController", void 0);
	    __decorate$i([
	        Autowired('columnController')
	    ], RowNode.prototype, "columnController", void 0);
	    __decorate$i([
	        Autowired('valueService')
	    ], RowNode.prototype, "valueService", void 0);
	    __decorate$i([
	        Autowired('rowModel')
	    ], RowNode.prototype, "rowModel", void 0);
	    __decorate$i([
	        Autowired('context')
	    ], RowNode.prototype, "context", void 0);
	    __decorate$i([
	        Autowired('valueCache')
	    ], RowNode.prototype, "valueCache", void 0);
	    __decorate$i([
	        Autowired('columnApi')
	    ], RowNode.prototype, "columnApi", void 0);
	    __decorate$i([
	        Autowired('gridApi')
	    ], RowNode.prototype, "gridApi", void 0);
	    return RowNode;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$g = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$j = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var CheckboxSelectionComponent = /** @class */ (function (_super) {
	    __extends$g(CheckboxSelectionComponent, _super);
	    function CheckboxSelectionComponent() {
	        return _super.call(this, /* html*/ "\n            <div class=\"ag-selection-checkbox\" role=\"presentation\">\n                <ag-checkbox role=\"presentation\" ref=\"eCheckbox\"></ag-checkbox>\n            </div>") || this;
	    }
	    CheckboxSelectionComponent.prototype.postConstruct = function () {
	        this.eCheckbox.setPassive(true);
	    };
	    CheckboxSelectionComponent.prototype.getCheckboxId = function () {
	        return this.eCheckbox.getInputElement().id;
	    };
	    CheckboxSelectionComponent.prototype.onDataChanged = function () {
	        // when rows are loaded for the second time, this can impact the selection, as a row
	        // could be loaded as already selected (if user scrolls down, and then up again).
	        this.onSelectionChanged();
	    };
	    CheckboxSelectionComponent.prototype.onSelectableChanged = function () {
	        this.showOrHideSelect();
	    };
	    CheckboxSelectionComponent.prototype.onSelectionChanged = function () {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var state = this.rowNode.isSelected();
	        var stateName = state === undefined
	            ? translate('ariaIndeterminate', 'indeterminate')
	            : (state === true
	                ? translate('ariaChecked', 'checked')
	                : translate('ariaUnchecked', 'unchecked'));
	        var ariaLabel = translate('ariaRowToggleSelection', 'Press Space to toggle row selection');
	        this.eCheckbox.setValue(state, true);
	        this.eCheckbox.setInputAriaLabel(ariaLabel + " (" + stateName + ")");
	    };
	    CheckboxSelectionComponent.prototype.onCheckedClicked = function (event) {
	        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
	        var updatedCount = this.rowNode.setSelectedParams({ newValue: false, rangeSelect: event.shiftKey, groupSelectsFiltered: groupSelectsFiltered });
	        return updatedCount;
	    };
	    CheckboxSelectionComponent.prototype.onUncheckedClicked = function (event) {
	        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
	        var updatedCount = this.rowNode.setSelectedParams({ newValue: true, rangeSelect: event.shiftKey, groupSelectsFiltered: groupSelectsFiltered });
	        return updatedCount;
	    };
	    CheckboxSelectionComponent.prototype.init = function (params) {
	        var _this = this;
	        this.rowNode = params.rowNode;
	        this.column = params.column;
	        this.onSelectionChanged();
	        // we don't want the row clicked event to fire when selecting the checkbox, otherwise the row
	        // would possibly get selected twice
	        this.addGuiEventListener('click', function (event) { return stopPropagationForAgGrid(event); });
	        // likewise we don't want double click on this icon to open a group
	        this.addGuiEventListener('dblclick', function (event) { return stopPropagationForAgGrid(event); });
	        this.addManagedListener(this.eCheckbox.getInputElement(), 'click', function (event) {
	            var isSelected = _this.eCheckbox.getValue();
	            var previousValue = _this.eCheckbox.getPreviousValue();
	            if (previousValue === undefined) { // indeterminate
	                var result = _this.onUncheckedClicked(event || {});
	                if (result === 0) {
	                    _this.onCheckedClicked(event);
	                }
	            }
	            else if (isSelected) {
	                _this.onCheckedClicked(event);
	            }
	            else {
	                _this.onUncheckedClicked(event || {});
	            }
	        });
	        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
	        var isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	        var checkboxVisibleIsDynamic = isRowSelectableFunc || this.checkboxCallbackExists();
	        if (checkboxVisibleIsDynamic) {
	            var showOrHideSelectListener = this.showOrHideSelect.bind(this);
	            this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, showOrHideSelectListener);
	            this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, showOrHideSelectListener);
	            this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, showOrHideSelectListener);
	            this.showOrHideSelect();
	        }
	        this.eCheckbox.getInputElement().setAttribute('tabindex', '-1');
	    };
	    CheckboxSelectionComponent.prototype.showOrHideSelect = function () {
	        // if the isRowSelectable() is not provided the row node is selectable by default
	        var selectable = this.rowNode.selectable;
	        // checkboxSelection callback is deemed a legacy solution however we will still consider it's result.
	        // If selectable, then also check the colDef callback. if not selectable, this it short circuits - no need
	        // to call the colDef callback.
	        if (selectable && this.checkboxCallbackExists()) {
	            selectable = this.column.isCellCheckboxSelection(this.rowNode);
	        }
	        // show checkbox if both conditions are true
	        this.setVisible(selectable);
	    };
	    CheckboxSelectionComponent.prototype.checkboxCallbackExists = function () {
	        // column will be missing if groupUseEntireRow=true
	        var colDef = this.column ? this.column.getColDef() : null;
	        return !!colDef && typeof colDef.checkboxSelection === 'function';
	    };
	    __decorate$j([
	        RefSelector('eCheckbox')
	    ], CheckboxSelectionComponent.prototype, "eCheckbox", void 0);
	    __decorate$j([
	        PostConstruct
	    ], CheckboxSelectionComponent.prototype, "postConstruct", null);
	    return CheckboxSelectionComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var DateComponent = {
	    propertyName: 'dateComponent',
	    isCellRenderer: function () { return false; }
	};
	var HeaderComponent = {
	    propertyName: 'headerComponent',
	    isCellRenderer: function () { return false; },
	};
	var HeaderGroupComponent = {
	    propertyName: 'headerGroupComponent',
	    isCellRenderer: function () { return false; },
	};
	var CellRendererComponent = {
	    propertyName: 'cellRenderer',
	    isCellRenderer: function () { return true; },
	};
	var PinnedRowCellRendererComponent = {
	    propertyName: 'pinnedRowCellRenderer',
	    isCellRenderer: function () { return true; },
	};
	var CellEditorComponent = {
	    propertyName: 'cellEditor',
	    isCellRenderer: function () { return false; },
	};
	var InnerRendererComponent = {
	    propertyName: 'innerRenderer',
	    isCellRenderer: function () { return true; },
	};
	var LoadingOverlayComponent = {
	    propertyName: 'loadingOverlayComponent',
	    isCellRenderer: function () { return false; },
	};
	var NoRowsOverlayComponent = {
	    propertyName: 'noRowsOverlayComponent',
	    isCellRenderer: function () { return false; },
	};
	var TooltipComponent = {
	    propertyName: 'tooltipComponent',
	    isCellRenderer: function () { return false; },
	};
	var FilterComponent = {
	    propertyName: 'filter',
	    isCellRenderer: function () { return false; },
	};
	var FloatingFilterComponent = {
	    propertyName: 'floatingFilterComponent',
	    isCellRenderer: function () { return false; },
	};
	var ToolPanelComponent = {
	    propertyName: 'toolPanel',
	    isCellRenderer: function () { return false; },
	};
	var StatusPanelComponent = {
	    propertyName: 'statusPanel',
	    isCellRenderer: function () { return false; },
	};

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$h = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$k = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ComponentSource;
	(function (ComponentSource) {
	    ComponentSource[ComponentSource["DEFAULT"] = 0] = "DEFAULT";
	    ComponentSource[ComponentSource["REGISTERED_BY_NAME"] = 1] = "REGISTERED_BY_NAME";
	    ComponentSource[ComponentSource["HARDCODED"] = 2] = "HARDCODED";
	})(ComponentSource || (ComponentSource = {}));
	var UserComponentFactory = /** @class */ (function (_super) {
	    __extends$h(UserComponentFactory, _super);
	    function UserComponentFactory() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    UserComponentFactory.prototype.newDateComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, DateComponent, 'agDateInput');
	    };
	    UserComponentFactory.prototype.newHeaderComponent = function (params) {
	        return this.createAndInitUserComponent(params.column.getColDef(), params, HeaderComponent, 'agColumnHeader');
	    };
	    UserComponentFactory.prototype.newHeaderGroupComponent = function (params) {
	        return this.createAndInitUserComponent(params.columnGroup.getColGroupDef(), params, HeaderGroupComponent, 'agColumnGroupHeader');
	    };
	    UserComponentFactory.prototype.newFullWidthGroupRowInnerCellRenderer = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions.groupRowRendererParams, params, InnerRendererComponent, null, true);
	    };
	    // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
	    // so we have to pass the type in.
	    UserComponentFactory.prototype.newFullWidthCellRenderer = function (params, cellRendererType, cellRendererName) {
	        return this.createAndInitUserComponent(null, params, { propertyName: cellRendererType, isCellRenderer: function () { return true; } }, cellRendererName);
	    };
	    UserComponentFactory.prototype.newCellRenderer = function (target, params, isPinned) {
	        if (isPinned === void 0) { isPinned = false; }
	        return this.createAndInitUserComponent(target, params, isPinned ? PinnedRowCellRendererComponent : CellRendererComponent, null, true);
	    };
	    UserComponentFactory.prototype.newCellEditor = function (colDef, params) {
	        return this.createAndInitUserComponent(colDef, params, CellEditorComponent, 'agCellEditor');
	    };
	    UserComponentFactory.prototype.newInnerCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, InnerRendererComponent, null);
	    };
	    UserComponentFactory.prototype.newLoadingOverlayComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, LoadingOverlayComponent, 'agLoadingOverlay');
	    };
	    UserComponentFactory.prototype.newNoRowsOverlayComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, NoRowsOverlayComponent, 'agNoRowsOverlay');
	    };
	    UserComponentFactory.prototype.newTooltipComponent = function (params) {
	        return this.createAndInitUserComponent(params.colDef, params, TooltipComponent, 'agTooltipComponent');
	    };
	    UserComponentFactory.prototype.newFilterComponent = function (def, params, defaultFilter) {
	        return this.createAndInitUserComponent(def, params, FilterComponent, defaultFilter, false);
	    };
	    UserComponentFactory.prototype.newSetFilterCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, CellRendererComponent, null, true);
	    };
	    UserComponentFactory.prototype.newFloatingFilterComponent = function (def, params, defaultFloatingFilter) {
	        return this.createAndInitUserComponent(def, params, FloatingFilterComponent, defaultFloatingFilter, true);
	    };
	    UserComponentFactory.prototype.newToolPanelComponent = function (toolPanelDef, params) {
	        return this.createAndInitUserComponent(toolPanelDef, params, ToolPanelComponent);
	    };
	    UserComponentFactory.prototype.newStatusPanelComponent = function (def, params) {
	        return this.createAndInitUserComponent(def, params, StatusPanelComponent);
	    };
	    /**
	     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
	     * It takes
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param paramsFromGrid: Params to be passed to the component and passed by AG Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param defaultComponentName: The actual name of the component to instantiate, this is usually the same as propertyName, but in
	     *      some cases is not, like floatingFilter, if it is the same is not necessary to specify
	     *  @param optional: Handy method to tell if this should return a component ALWAYS. if that is the case, but there is no
	     *      component found, it throws an error, by default all components are MANDATORY
	     */
	    UserComponentFactory.prototype.createAndInitUserComponent = function (definitionObject, paramsFromGrid, componentType, defaultComponentName, 
	    // optional items are: FloatingFilter, CellComp (for cellRenderer)
	    optional) {
	        if (optional === void 0) { optional = false; }
	        if (!definitionObject) {
	            definitionObject = this.gridOptions;
	        }
	        // Create the component instance
	        var componentAndParams = this.createComponentInstance(definitionObject, componentType, paramsFromGrid, defaultComponentName, optional);
	        if (!componentAndParams) {
	            return null;
	        }
	        var componentInstance = componentAndParams.componentInstance;
	        // Wire the component and call the init method with the correct params
	        var params = this.createFinalParams(definitionObject, componentType.propertyName, paramsFromGrid, componentAndParams.paramsFromSelector);
	        this.addReactHacks(params);
	        var deferredInit = this.initComponent(componentInstance, params);
	        if (deferredInit == null) {
	            return AgPromise.resolve(componentInstance);
	        }
	        return deferredInit.then(function () { return componentInstance; });
	    };
	    UserComponentFactory.prototype.addReactHacks = function (params) {
	        // a temporary fix for AG-1574
	        // AG-1715 raised to do a wider ranging refactor to improve this
	        var agGridReact = this.context.getBean('agGridReact');
	        if (agGridReact) {
	            params.agGridReact = cloneObject(agGridReact);
	        }
	        // AG-1716 - directly related to AG-1574 and AG-1715
	        var frameworkComponentWrapper = this.context.getBean('frameworkComponentWrapper');
	        if (frameworkComponentWrapper) {
	            params.frameworkComponentWrapper = frameworkComponentWrapper;
	        }
	    };
	    /**
	     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
	     * It takes
	     *  @param clazz: The class to instantiate,
	     *  @param agGridParams: Params to be passed to the component and passed by AG Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     *  @param modifyParamsCallback: A chance to customise the params passed to the init method. It receives what the current
	     *  params are and the component that init is about to get called for
	     */
	    UserComponentFactory.prototype.createUserComponentFromConcreteClass = function (clazz, agGridParams) {
	        var internalComponent = new clazz();
	        this.initComponent(internalComponent, agGridParams);
	        return internalComponent;
	    };
	    /**
	     * This method returns the underlying representation of the component to be created. ie for Javascript the
	     * underlying function where we should be calling new into. In case of the frameworks, the framework class
	     * object that represents the component to be created.
	     *
	     * This method is handy for different reasons, for example if you want to check if a component has a particular
	     * method implemented without having to create the component, just by inspecting the source component
	     *
	     * It takes
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param params: Params to be passed to the dynamic component function in case it needs to be
	     *      invoked
	     *  @param defaultComponentName: The name of the component to load if there is no component specified
	     */
	    UserComponentFactory.prototype.lookupComponentClassDef = function (definitionObject, propertyName, params, defaultComponentName) {
	        if (params === void 0) { params = null; }
	        /**
	         * There are five things that can happen when resolving a component.
	         *  a) HardcodedFwComponent: That holder[propertyName]Framework has associated a Framework native component
	         *  b) HardcodedJsComponent: That holder[propertyName] has associate a JS component
	         *  c) hardcodedJsFunction: That holder[propertyName] has associate a JS function
	         *  d) hardcodedNameComponent: That holder[propertyName] has associate a string that represents a component to load
	         *  e) That none of the three previous are specified, then we need to use the DefaultRegisteredComponent
	         */
	        var hardcodedNameComponent = null;
	        var HardcodedJsComponent = null;
	        var hardcodedJsFunction = null;
	        var HardcodedFwComponent = null;
	        var componentSelectorFunc = null;
	        if (definitionObject != null) {
	            var componentPropertyValue = definitionObject[propertyName];
	            // for filters only, we allow 'true' for the component, which means default filter to be used
	            var usingDefaultComponent = componentPropertyValue === true;
	            if (componentPropertyValue != null && !usingDefaultComponent) {
	                if (typeof componentPropertyValue === 'string') {
	                    hardcodedNameComponent = componentPropertyValue;
	                }
	                else if (typeof componentPropertyValue === 'boolean') ;
	                else if (this.agComponentUtils.doesImplementIComponent(componentPropertyValue)) {
	                    HardcodedJsComponent = componentPropertyValue;
	                }
	                else {
	                    hardcodedJsFunction = componentPropertyValue;
	                }
	            }
	            HardcodedFwComponent = definitionObject[propertyName + "Framework"];
	            componentSelectorFunc = definitionObject[propertyName + "Selector"];
	        }
	        /**
	         * Since we allow many types of flavors for specifying the components, let's make sure this is not an illegal
	         * combination
	         */
	        if ((HardcodedJsComponent && HardcodedFwComponent) ||
	            (hardcodedNameComponent && HardcodedFwComponent) ||
	            (hardcodedJsFunction && HardcodedFwComponent)) {
	            throw Error("ag-grid: you are trying to specify: " + propertyName + " twice as a component.");
	        }
	        if (HardcodedFwComponent && !this.frameworkComponentWrapper) {
	            throw Error("ag-grid: you are specifying a framework component but you are not using a framework version of ag-grid for : " + propertyName);
	        }
	        if (componentSelectorFunc && (hardcodedNameComponent || HardcodedJsComponent || hardcodedJsFunction || HardcodedFwComponent)) {
	            throw Error("ag-grid: you can't specify both, the selector and the component of ag-grid for : " + propertyName);
	        }
	        /**
	         * At this stage we are guaranteed to either have,
	         * DEPRECATED
	         * - A unique HardcodedFwComponent
	         * - A unique HardcodedJsComponent
	         * - A unique hardcodedJsFunction
	         * BY NAME- FAVOURED APPROACH
	         * - A unique hardcodedNameComponent
	         * - None of the previous, hence we revert to: RegisteredComponent
	         */
	        if (HardcodedFwComponent) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
	            // console.warn(`${HardcodedFwComponent}`);
	            return {
	                componentFromFramework: true,
	                component: HardcodedFwComponent,
	                source: ComponentSource.HARDCODED,
	                paramsFromSelector: null
	            };
	        }
	        if (HardcodedJsComponent) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
	            // console.warn(`${HardcodedJsComponent}`);
	            return {
	                componentFromFramework: false,
	                component: HardcodedJsComponent,
	                source: ComponentSource.HARDCODED,
	                paramsFromSelector: null
	            };
	        }
	        if (hardcodedJsFunction) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a function directly is deprecated, you should register the component by name`);
	            // console.warn(`${hardcodedJsFunction}`);
	            return this.agComponentUtils.adaptFunction(propertyName, hardcodedJsFunction, false, ComponentSource.HARDCODED);
	        }
	        var selectorResult = componentSelectorFunc ? componentSelectorFunc(params) : null;
	        var componentNameToUse;
	        if (selectorResult && selectorResult.component) {
	            componentNameToUse = selectorResult.component;
	        }
	        else if (hardcodedNameComponent) {
	            componentNameToUse = hardcodedNameComponent;
	        }
	        else {
	            componentNameToUse = defaultComponentName;
	        }
	        if (!componentNameToUse) {
	            return null;
	        }
	        var registeredCompClassDef = this.lookupFromRegisteredComponents(propertyName, componentNameToUse);
	        if (!registeredCompClassDef) {
	            return null;
	        }
	        return {
	            componentFromFramework: registeredCompClassDef.componentFromFramework,
	            component: registeredCompClassDef.component,
	            source: registeredCompClassDef.source,
	            paramsFromSelector: selectorResult ? selectorResult.params : null
	        };
	    };
	    UserComponentFactory.prototype.lookupFromRegisteredComponents = function (propertyName, componentNameOpt) {
	        var componentName = componentNameOpt != null ? componentNameOpt : propertyName;
	        var registeredComponent = this.userComponentRegistry.retrieve(componentName);
	        if (registeredComponent == null) {
	            return null;
	        }
	        //If it is a FW it has to be registered as a component
	        if (registeredComponent.componentFromFramework) {
	            return {
	                component: registeredComponent.component,
	                componentFromFramework: true,
	                source: ComponentSource.REGISTERED_BY_NAME,
	                paramsFromSelector: null
	            };
	        }
	        //If it is JS it may be a function or a component
	        if (this.agComponentUtils.doesImplementIComponent(registeredComponent.component)) {
	            return {
	                component: registeredComponent.component,
	                componentFromFramework: false,
	                source: (registeredComponent.source == RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT,
	                paramsFromSelector: null
	            };
	        }
	        // This is a function
	        return this.agComponentUtils.adaptFunction(propertyName, registeredComponent.component, registeredComponent.componentFromFramework, (registeredComponent.source == RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT);
	    };
	    /**
	     * Useful to check what would be the resultant params for a given object
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param paramsFromGrid: Params to be passed to the component and passed by AG Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     * @returns {TParams} It merges the user agGridParams with the actual params specified by the user.
	     */
	    UserComponentFactory.prototype.createFinalParams = function (definitionObject, propertyName, paramsFromGrid, paramsFromSelector) {
	        if (paramsFromSelector === void 0) { paramsFromSelector = null; }
	        var params = {};
	        mergeDeep(params, paramsFromGrid);
	        var userParams = definitionObject ? definitionObject[propertyName + "Params"] : null;
	        if (userParams != null) {
	            if (typeof userParams === 'function') {
	                var userParamsFromFunc = userParams(paramsFromGrid);
	                mergeDeep(params, userParamsFromFunc);
	            }
	            else if (typeof userParams === 'object') {
	                mergeDeep(params, userParams);
	            }
	        }
	        mergeDeep(params, paramsFromSelector);
	        return params;
	    };
	    UserComponentFactory.prototype.createComponentInstance = function (holder, componentType, paramsForSelector, defaultComponentName, optional) {
	        var propertyName = componentType.propertyName;
	        var componentToUse = this.lookupComponentClassDef(holder, propertyName, paramsForSelector, defaultComponentName);
	        var missing = !componentToUse || !componentToUse.component;
	        if (missing) {
	            // to help the user, we print out the name they are looking for, rather than the default name.
	            // i don't know why the default name was originally printed out (that doesn't help the user)
	            var overrideName = holder ? holder[propertyName] : defaultComponentName;
	            var nameToReport = overrideName ? overrideName : defaultComponentName;
	            if (!optional) {
	                console.error("Could not find component " + nameToReport + ", did you forget to configure this component?");
	            }
	            return null;
	        }
	        var componentInstance;
	        if (componentToUse.componentFromFramework) {
	            // Using framework component
	            var FrameworkComponentRaw = componentToUse.component;
	            var thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
	            componentInstance = this.frameworkComponentWrapper.wrap(FrameworkComponentRaw, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, componentType, defaultComponentName);
	        }
	        else {
	            // Using plain JavaScript component
	            componentInstance = new componentToUse.component();
	        }
	        return { componentInstance: componentInstance, paramsFromSelector: componentToUse.paramsFromSelector };
	    };
	    UserComponentFactory.prototype.initComponent = function (component, params) {
	        this.context.createBean(component);
	        if (component.init == null) {
	            return;
	        }
	        return component.init(params);
	    };
	    __decorate$k([
	        Autowired('gridOptions')
	    ], UserComponentFactory.prototype, "gridOptions", void 0);
	    __decorate$k([
	        Autowired('agComponentUtils')
	    ], UserComponentFactory.prototype, "agComponentUtils", void 0);
	    __decorate$k([
	        Autowired('componentMetadataProvider')
	    ], UserComponentFactory.prototype, "componentMetadataProvider", void 0);
	    __decorate$k([
	        Autowired('userComponentRegistry')
	    ], UserComponentFactory.prototype, "userComponentRegistry", void 0);
	    __decorate$k([
	        Optional('frameworkComponentWrapper')
	    ], UserComponentFactory.prototype, "frameworkComponentWrapper", void 0);
	    UserComponentFactory = __decorate$k([
	        Bean('userComponentFactory')
	    ], UserComponentFactory);
	    return UserComponentFactory;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$i = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$l = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	(function (DragSourceType) {
	    DragSourceType[DragSourceType["ToolPanel"] = 0] = "ToolPanel";
	    DragSourceType[DragSourceType["HeaderCell"] = 1] = "HeaderCell";
	    DragSourceType[DragSourceType["RowDrag"] = 2] = "RowDrag";
	    DragSourceType[DragSourceType["ChartPanel"] = 3] = "ChartPanel";
	})(exports.DragSourceType || (exports.DragSourceType = {}));
	(function (VerticalDirection) {
	    VerticalDirection[VerticalDirection["Up"] = 0] = "Up";
	    VerticalDirection[VerticalDirection["Down"] = 1] = "Down";
	})(exports.VerticalDirection || (exports.VerticalDirection = {}));
	(function (HorizontalDirection) {
	    HorizontalDirection[HorizontalDirection["Left"] = 0] = "Left";
	    HorizontalDirection[HorizontalDirection["Right"] = 1] = "Right";
	})(exports.HorizontalDirection || (exports.HorizontalDirection = {}));
	var DragAndDropService = /** @class */ (function (_super) {
	    __extends$i(DragAndDropService, _super);
	    function DragAndDropService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.dragSourceAndParamsList = [];
	        _this.dropTargets = [];
	        return _this;
	    }
	    DragAndDropService_1 = DragAndDropService;
	    DragAndDropService.prototype.init = function () {
	        this.ePinnedIcon = createIcon('columnMovePin', this.gridOptionsWrapper, null);
	        this.eHideIcon = createIcon('columnMoveHide', this.gridOptionsWrapper, null);
	        this.eMoveIcon = createIcon('columnMoveMove', this.gridOptionsWrapper, null);
	        this.eLeftIcon = createIcon('columnMoveLeft', this.gridOptionsWrapper, null);
	        this.eRightIcon = createIcon('columnMoveRight', this.gridOptionsWrapper, null);
	        this.eGroupIcon = createIcon('columnMoveGroup', this.gridOptionsWrapper, null);
	        this.eAggregateIcon = createIcon('columnMoveValue', this.gridOptionsWrapper, null);
	        this.ePivotIcon = createIcon('columnMovePivot', this.gridOptionsWrapper, null);
	        this.eDropNotAllowedIcon = createIcon('dropNotAllowed', this.gridOptionsWrapper, null);
	    };
	    DragAndDropService.prototype.addDragSource = function (dragSource, allowTouch) {
	        if (allowTouch === void 0) { allowTouch = false; }
	        var params = {
	            eElement: dragSource.eElement,
	            dragStartPixels: dragSource.dragStartPixels,
	            onDragStart: this.onDragStart.bind(this, dragSource),
	            onDragStop: this.onDragStop.bind(this),
	            onDragging: this.onDragging.bind(this)
	        };
	        this.dragSourceAndParamsList.push({ params: params, dragSource: dragSource });
	        this.dragService.addDragSource(params, allowTouch);
	    };
	    DragAndDropService.prototype.removeDragSource = function (dragSource) {
	        var sourceAndParams = find(this.dragSourceAndParamsList, function (item) { return item.dragSource === dragSource; });
	        if (sourceAndParams) {
	            this.dragService.removeDragSource(sourceAndParams.params);
	            removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
	        }
	    };
	    DragAndDropService.prototype.clearDragSourceParamsList = function () {
	        var _this = this;
	        this.dragSourceAndParamsList.forEach(function (sourceAndParams) { return _this.dragService.removeDragSource(sourceAndParams.params); });
	        this.dragSourceAndParamsList.length = 0;
	    };
	    DragAndDropService.prototype.nudge = function () {
	        if (this.dragging) {
	            this.onDragging(this.eventLastTime, true);
	        }
	    };
	    DragAndDropService.prototype.onDragStart = function (dragSource, mouseEvent) {
	        this.dragging = true;
	        this.dragSource = dragSource;
	        this.eventLastTime = mouseEvent;
	        this.dragItem = this.dragSource.getDragItem();
	        this.lastDropTarget = this.dragSource.dragSourceDropTarget;
	        if (this.dragSource.onDragStarted) {
	            this.dragSource.onDragStarted();
	        }
	        this.createGhost();
	    };
	    DragAndDropService.prototype.onDragStop = function (mouseEvent) {
	        this.eventLastTime = null;
	        this.dragging = false;
	        if (this.dragSource.onDragStopped) {
	            this.dragSource.onDragStopped();
	        }
	        if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
	            var draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
	            this.lastDropTarget.onDragStop(draggingEvent);
	        }
	        this.lastDropTarget = null;
	        this.dragItem = null;
	        this.removeGhost();
	    };
	    DragAndDropService.prototype.onDragging = function (mouseEvent, fromNudge) {
	        var _this = this;
	        var hDirection = this.getHorizontalDirection(mouseEvent);
	        var vDirection = this.getVerticalDirection(mouseEvent);
	        this.eventLastTime = mouseEvent;
	        this.positionGhost(mouseEvent);
	        // check if mouseEvent intersects with any of the drop targets
	        var validDropTargets = this.dropTargets.filter(function (target) { return _this.isMouseOnDropTarget(mouseEvent, target); });
	        var len = validDropTargets.length;
	        var dropTarget = null;
	        if (len > 0) {
	            dropTarget = len === 1
	                ? validDropTargets[0]
	                // the current mouse position could intersect with more than 1 element
	                // if they are nested. In that case we need to get the most specific
	                // container, which is the one that does not contain any other targets.
	                : validDropTargets.reduce(function (prevTarget, currTarget) {
	                    if (!prevTarget) {
	                        return currTarget;
	                    }
	                    var prevContainer = prevTarget.getContainer();
	                    var currContainer = currTarget.getContainer();
	                    if (prevContainer.contains(currContainer)) {
	                        return currTarget;
	                    }
	                    return prevTarget;
	                });
	        }
	        if (dropTarget !== this.lastDropTarget) {
	            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
	            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            this.lastDropTarget = dropTarget;
	        }
	        else if (dropTarget && dropTarget.onDragging) {
	            var draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            dropTarget.onDragging(draggingEvent);
	        }
	    };
	    DragAndDropService.prototype.enterDragTargetIfExists = function (dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
	        if (!dropTarget) {
	            return;
	        }
	        if (dropTarget.onDragEnter) {
	            var dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            dropTarget.onDragEnter(dragEnterEvent);
	        }
	        this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
	    };
	    DragAndDropService.prototype.leaveLastTargetIfExists = function (mouseEvent, hDirection, vDirection, fromNudge) {
	        if (!this.lastDropTarget) {
	            return;
	        }
	        if (this.lastDropTarget.onDragLeave) {
	            var dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            this.lastDropTarget.onDragLeave(dragLeaveEvent);
	        }
	        this.setGhostIcon(null);
	    };
	    DragAndDropService.prototype.getAllContainersFromDropTarget = function (dropTarget) {
	        var containers = [dropTarget.getContainer()];
	        var secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
	        if (secondaryContainers) {
	            containers = containers.concat(secondaryContainers);
	        }
	        return containers;
	    };
	    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
	    DragAndDropService.prototype.isMouseOnDropTarget = function (mouseEvent, dropTarget) {
	        var mouseOverTarget = false;
	        this.getAllContainersFromDropTarget(dropTarget)
	            .filter(function (eContainer) { return eContainer; }) // secondary can be missing
	            .forEach(function (eContainer) {
	            var rect = eContainer.getBoundingClientRect();
	            // if element is not visible, then width and height are zero
	            if (rect.width === 0 || rect.height === 0) {
	                return;
	            }
	            var horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX < rect.right;
	            var verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY < rect.bottom;
	            if (horizontalFit && verticalFit) {
	                mouseOverTarget = true;
	            }
	        });
	        return mouseOverTarget && dropTarget.isInterestedIn(this.dragSource.type);
	    };
	    DragAndDropService.prototype.addDropTarget = function (dropTarget) {
	        this.dropTargets.push(dropTarget);
	    };
	    DragAndDropService.prototype.removeDropTarget = function (dropTarget) {
	        this.dropTargets = this.dropTargets.filter(function (target) { return target.getContainer() !== dropTarget.getContainer(); });
	    };
	    DragAndDropService.prototype.hasExternalDropZones = function () {
	        return this.dropTargets.some(function (zones) { return zones.external; });
	    };
	    DragAndDropService.prototype.findExternalZone = function (params) {
	        var externalTargets = this.dropTargets.filter(function (target) { return target.external; });
	        return find(externalTargets, function (zone) { return zone.getContainer() === params.getContainer(); });
	    };
	    DragAndDropService.prototype.getHorizontalDirection = function (event) {
	        var clientX = this.eventLastTime && this.eventLastTime.clientX;
	        var eClientX = event.clientX;
	        if (clientX === eClientX) {
	            return null;
	        }
	        return clientX > eClientX ? exports.HorizontalDirection.Left : exports.HorizontalDirection.Right;
	    };
	    DragAndDropService.prototype.getVerticalDirection = function (event) {
	        var clientY = this.eventLastTime && this.eventLastTime.clientY;
	        var eClientY = event.clientY;
	        if (clientY === eClientY) {
	            return null;
	        }
	        return clientY > eClientY ? exports.VerticalDirection.Up : exports.VerticalDirection.Down;
	    };
	    DragAndDropService.prototype.createDropTargetEvent = function (dropTarget, event, hDirection, vDirection, fromNudge) {
	        // localise x and y to the target
	        var dropZoneTarget = dropTarget.getContainer();
	        var rect = dropZoneTarget.getBoundingClientRect();
	        var _a = this, api = _a.gridApi, columnApi = _a.columnApi, dragItem = _a.dragItem, dragSource = _a.dragSource;
	        var x = event.clientX - rect.left;
	        var y = event.clientY - rect.top;
	        return { event: event, x: x, y: y, vDirection: vDirection, hDirection: hDirection, dragSource: dragSource, fromNudge: fromNudge, dragItem: dragItem, api: api, columnApi: columnApi, dropZoneTarget: dropZoneTarget };
	    };
	    DragAndDropService.prototype.positionGhost = function (event) {
	        var ghost = this.eGhost;
	        if (!ghost) {
	            return;
	        }
	        var ghostRect = ghost.getBoundingClientRect();
	        var ghostHeight = ghostRect.height;
	        // for some reason, without the '-2', it still overlapped by 1 or 2 pixels, which
	        // then brought in scrollbars to the browser. no idea why, but putting in -2 here
	        // works around it which is good enough for me.
	        var browserWidth = getBodyWidth() - 2;
	        var browserHeight = getBodyHeight() - 2;
	        var top = event.pageY - (ghostHeight / 2);
	        var left = event.pageX - 10;
	        var usrDocument = this.gridOptionsWrapper.getDocument();
	        var windowScrollY = window.pageYOffset || usrDocument.documentElement.scrollTop;
	        var windowScrollX = window.pageXOffset || usrDocument.documentElement.scrollLeft;
	        // check ghost is not positioned outside of the browser
	        if (browserWidth > 0 && ((left + ghost.clientWidth) > (browserWidth + windowScrollX))) {
	            left = browserWidth + windowScrollX - ghost.clientWidth;
	        }
	        if (left < 0) {
	            left = 0;
	        }
	        if (browserHeight > 0 && ((top + ghost.clientHeight) > (browserHeight + windowScrollY))) {
	            top = browserHeight + windowScrollY - ghost.clientHeight;
	        }
	        if (top < 0) {
	            top = 0;
	        }
	        ghost.style.left = left + "px";
	        ghost.style.top = top + "px";
	    };
	    DragAndDropService.prototype.removeGhost = function () {
	        if (this.eGhost && this.eGhostParent) {
	            this.eGhostParent.removeChild(this.eGhost);
	        }
	        this.eGhost = null;
	    };
	    DragAndDropService.prototype.createGhost = function () {
	        this.eGhost = loadTemplate(DragAndDropService_1.GHOST_TEMPLATE);
	        var theme = this.environment.getTheme().theme;
	        if (theme) {
	            addCssClass(this.eGhost, theme);
	        }
	        this.eGhostIcon = this.eGhost.querySelector('.ag-dnd-ghost-icon');
	        this.setGhostIcon(null);
	        var eText = this.eGhost.querySelector('.ag-dnd-ghost-label');
	        var dragItemName = this.dragSource.dragItemName;
	        if (isFunction(dragItemName)) {
	            dragItemName = dragItemName();
	        }
	        eText.innerHTML = escapeString(dragItemName) || '';
	        this.eGhost.style.height = '25px';
	        this.eGhost.style.top = '20px';
	        this.eGhost.style.left = '20px';
	        var usrDocument = this.gridOptionsWrapper.getDocument();
	        var targetEl = usrDocument.fullscreenElement || usrDocument.querySelector('body');
	        this.eGhostParent = targetEl;
	        if (!this.eGhostParent) {
	            console.warn('AG Grid: could not find document body, it is needed for dragging columns');
	        }
	        else {
	            this.eGhostParent.appendChild(this.eGhost);
	        }
	    };
	    DragAndDropService.prototype.setGhostIcon = function (iconName, shake) {
	        if (shake === void 0) { shake = false; }
	        clearElement(this.eGhostIcon);
	        var eIcon = null;
	        if (!iconName) {
	            iconName = this.dragSource.defaultIconName || DragAndDropService_1.ICON_NOT_ALLOWED;
	        }
	        switch (iconName) {
	            case DragAndDropService_1.ICON_PINNED:
	                eIcon = this.ePinnedIcon;
	                break;
	            case DragAndDropService_1.ICON_MOVE:
	                eIcon = this.eMoveIcon;
	                break;
	            case DragAndDropService_1.ICON_LEFT:
	                eIcon = this.eLeftIcon;
	                break;
	            case DragAndDropService_1.ICON_RIGHT:
	                eIcon = this.eRightIcon;
	                break;
	            case DragAndDropService_1.ICON_GROUP:
	                eIcon = this.eGroupIcon;
	                break;
	            case DragAndDropService_1.ICON_AGGREGATE:
	                eIcon = this.eAggregateIcon;
	                break;
	            case DragAndDropService_1.ICON_PIVOT:
	                eIcon = this.ePivotIcon;
	                break;
	            case DragAndDropService_1.ICON_NOT_ALLOWED:
	                eIcon = this.eDropNotAllowedIcon;
	                break;
	            case DragAndDropService_1.ICON_HIDE:
	                eIcon = this.eHideIcon;
	                break;
	        }
	        addOrRemoveCssClass(this.eGhostIcon, 'ag-shake-left-to-right', shake);
	        if (eIcon === this.eHideIcon && this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns()) {
	            return;
	        }
	        if (eIcon) {
	            this.eGhostIcon.appendChild(eIcon);
	        }
	    };
	    var DragAndDropService_1;
	    DragAndDropService.ICON_PINNED = 'pinned';
	    DragAndDropService.ICON_MOVE = 'move';
	    DragAndDropService.ICON_LEFT = 'left';
	    DragAndDropService.ICON_RIGHT = 'right';
	    DragAndDropService.ICON_GROUP = 'group';
	    DragAndDropService.ICON_AGGREGATE = 'aggregate';
	    DragAndDropService.ICON_PIVOT = 'pivot';
	    DragAndDropService.ICON_NOT_ALLOWED = 'notAllowed';
	    DragAndDropService.ICON_HIDE = 'hide';
	    DragAndDropService.GHOST_TEMPLATE = "<div class=\"ag-dnd-ghost ag-unselectable\">\n            <span class=\"ag-dnd-ghost-icon ag-shake-left-to-right\"></span>\n            <div class=\"ag-dnd-ghost-label\"></div>\n        </div>";
	    __decorate$l([
	        Autowired('dragService')
	    ], DragAndDropService.prototype, "dragService", void 0);
	    __decorate$l([
	        Autowired('environment')
	    ], DragAndDropService.prototype, "environment", void 0);
	    __decorate$l([
	        Autowired('columnApi')
	    ], DragAndDropService.prototype, "columnApi", void 0);
	    __decorate$l([
	        Autowired('gridApi')
	    ], DragAndDropService.prototype, "gridApi", void 0);
	    __decorate$l([
	        PostConstruct
	    ], DragAndDropService.prototype, "init", null);
	    __decorate$l([
	        PreDestroy
	    ], DragAndDropService.prototype, "clearDragSourceParamsList", null);
	    DragAndDropService = DragAndDropService_1 = __decorate$l([
	        Bean('dragAndDropService')
	    ], DragAndDropService);
	    return DragAndDropService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$j = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$m = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var RowDragComp = /** @class */ (function (_super) {
	    __extends$j(RowDragComp, _super);
	    function RowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels) {
	        var _this = _super.call(this) || this;
	        _this.cellValueFn = cellValueFn;
	        _this.rowNode = rowNode;
	        _this.column = column;
	        _this.customGui = customGui;
	        _this.dragStartPixels = dragStartPixels;
	        _this.isCustomGui = false;
	        _this.dragSource = null;
	        return _this;
	    }
	    RowDragComp.prototype.postConstruct = function () {
	        if (!this.customGui) {
	            this.setTemplate(/* html */ "<div class=\"ag-drag-handle ag-row-drag\" aria-hidden=\"true\"></div>");
	            var eGui = this.getGui();
	            eGui.appendChild(createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
	            this.addDragSource();
	        }
	        else {
	            this.isCustomGui = true;
	            this.setDragElement(this.customGui, this.dragStartPixels);
	        }
	        this.checkCompatibility();
	        var strategy = this.beans.gridOptionsWrapper.isRowDragManaged() ?
	            new ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column) :
	            new NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column);
	        this.createManagedBean(strategy, this.beans.context);
	    };
	    RowDragComp.prototype.setDragElement = function (dragElement, dragStartPixels) {
	        this.setTemplateFromElement(dragElement);
	        this.addDragSource(dragStartPixels);
	    };
	    RowDragComp.prototype.getSelectedCount = function () {
	        var multiRowEnabled = this.beans.gridOptionsWrapper.isEnableMultiRowDragging();
	        if (!multiRowEnabled) {
	            return 1;
	        }
	        var selection = this.beans.selectionController.getSelectedNodes();
	        return selection.indexOf(this.rowNode) !== -1 ? selection.length : 1;
	    };
	    // returns true if all compatibility items work out
	    RowDragComp.prototype.checkCompatibility = function () {
	        var managed = this.beans.gridOptionsWrapper.isRowDragManaged();
	        var treeData = this.beans.gridOptionsWrapper.isTreeData();
	        if (treeData && managed) {
	            doOnce(function () {
	                return console.warn('AG Grid: If using row drag with tree data, you cannot have rowDragManaged=true');
	            }, 'RowDragComp.managedAndTreeData');
	        }
	    };
	    RowDragComp.prototype.addDragSource = function (dragStartPixels) {
	        var _this = this;
	        if (dragStartPixels === void 0) { dragStartPixels = 4; }
	        // if this is changing the drag element, delete the previous dragSource
	        if (this.dragSource) {
	            this.removeDragSource();
	        }
	        var dragItem = {
	            rowNode: this.rowNode,
	            columns: this.column ? [this.column] : undefined,
	            defaultTextValue: this.cellValueFn(),
	        };
	        var rowDragText = this.column && this.column.getColDef().rowDragText;
	        this.dragSource = {
	            type: exports.DragSourceType.RowDrag,
	            eElement: this.getGui(),
	            dragItemName: function () {
	                var dragItemCount = _this.getSelectedCount();
	                if (rowDragText) {
	                    return rowDragText(dragItem, dragItemCount);
	                }
	                return dragItemCount === 1 ? _this.cellValueFn() : dragItemCount + " rows";
	            },
	            getDragItem: function () { return dragItem; },
	            dragStartPixels: dragStartPixels,
	            dragSourceDomDataKey: this.beans.gridOptionsWrapper.getDomDataKey()
	        };
	        this.beans.dragAndDropService.addDragSource(this.dragSource, true);
	    };
	    RowDragComp.prototype.removeDragSource = function () {
	        if (this.dragSource) {
	            this.beans.dragAndDropService.removeDragSource(this.dragSource);
	        }
	        this.dragSource = null;
	    };
	    __decorate$m([
	        Autowired('beans')
	    ], RowDragComp.prototype, "beans", void 0);
	    __decorate$m([
	        PostConstruct
	    ], RowDragComp.prototype, "postConstruct", null);
	    __decorate$m([
	        PreDestroy
	    ], RowDragComp.prototype, "removeDragSource", null);
	    return RowDragComp;
	}(Component));
	var VisibilityStrategy = /** @class */ (function (_super) {
	    __extends$j(VisibilityStrategy, _super);
	    function VisibilityStrategy(parent, rowNode, column) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.column = column;
	        _this.rowNode = rowNode;
	        return _this;
	    }
	    VisibilityStrategy.prototype.setDisplayedOrVisible = function (neverDisplayed) {
	        if (neverDisplayed) {
	            this.parent.setDisplayed(false);
	        }
	        else {
	            var shown = true;
	            var isShownSometimes = false;
	            if (this.column) {
	                shown = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui;
	                isShownSometimes = isFunction(this.column.getColDef().rowDrag);
	            }
	            // if shown sometimes, them some rows can have drag handle while other don't,
	            // so we use setVisible to keep the handles horizontally aligned (as setVisible
	            // keeps the empty space, whereas setDisplayed looses the space)
	            if (isShownSometimes) {
	                this.parent.setDisplayed(true);
	                this.parent.setVisible(shown);
	            }
	            else {
	                this.parent.setDisplayed(shown);
	            }
	        }
	    };
	    return VisibilityStrategy;
	}(BeanStub));
	// when non managed, the visibility depends on suppressRowDrag property only
	var NonManagedVisibilityStrategy = /** @class */ (function (_super) {
	    __extends$j(NonManagedVisibilityStrategy, _super);
	    function NonManagedVisibilityStrategy(parent, beans, rowNode, column) {
	        var _this = _super.call(this, parent, rowNode, column) || this;
	        _this.beans = beans;
	        return _this;
	    }
	    NonManagedVisibilityStrategy.prototype.postConstruct = function () {
	        this.addManagedListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
	        // in case data changes, then we need to update visibility of drag item
	        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
	        this.workOutVisibility();
	    };
	    NonManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
	        this.workOutVisibility();
	    };
	    NonManagedVisibilityStrategy.prototype.workOutVisibility = function () {
	        // only show the drag if both sort and filter are not present
	        var neverDisplayed = this.beans.gridOptionsWrapper.isSuppressRowDrag();
	        this.setDisplayedOrVisible(neverDisplayed);
	    };
	    __decorate$m([
	        PostConstruct
	    ], NonManagedVisibilityStrategy.prototype, "postConstruct", null);
	    return NonManagedVisibilityStrategy;
	}(VisibilityStrategy));
	// when managed, the visibility depends on sort, filter and row group, as well as suppressRowDrag property
	var ManagedVisibilityStrategy = /** @class */ (function (_super) {
	    __extends$j(ManagedVisibilityStrategy, _super);
	    function ManagedVisibilityStrategy(parent, beans, rowNode, column) {
	        var _this = _super.call(this, parent, rowNode, column) || this;
	        _this.beans = beans;
	        return _this;
	    }
	    ManagedVisibilityStrategy.prototype.postConstruct = function () {
	        // we do not show the component if sort, filter or grouping is active
	        this.addManagedListener(this.beans.eventService, Events.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this));
	        this.addManagedListener(this.beans.eventService, Events.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this));
	        this.addManagedListener(this.beans.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this));
	        // in case data changes, then we need to update visibility of drag item
	        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
	        this.addManagedListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.workOutVisibility = function () {
	        // only show the drag if both sort and filter are not present
	        var gridBodyCon = this.beans.controllersService.getGridBodyController();
	        var rowDragFeature = gridBodyCon.getRowDragFeature();
	        var shouldPreventRowMove = rowDragFeature && rowDragFeature.shouldPreventRowMove();
	        var suppressRowDrag = this.beans.gridOptionsWrapper.isSuppressRowDrag();
	        var hasExternalDropZones = this.beans.dragAndDropService.hasExternalDropZones();
	        var neverDisplayed = (shouldPreventRowMove && !hasExternalDropZones) || suppressRowDrag;
	        this.setDisplayedOrVisible(neverDisplayed);
	    };
	    __decorate$m([
	        PostConstruct
	    ], ManagedVisibilityStrategy.prototype, "postConstruct", null);
	    return ManagedVisibilityStrategy;
	}(VisibilityStrategy));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$k = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$n = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var GroupCellRenderer = /** @class */ (function (_super) {
	    __extends$k(GroupCellRenderer, _super);
	    function GroupCellRenderer() {
	        return _super.call(this, GroupCellRenderer.TEMPLATE) || this;
	    }
	    GroupCellRenderer.prototype.isTopLevelFooter = function () {
	        if (!this.gridOptionsWrapper.isGroupIncludeTotalFooter()) {
	            return false;
	        }
	        if (this.params.value != null || this.params.node.level != -1) {
	            return false;
	        }
	        // at this point, we know it's the root node and there is no value present, so it's a footer cell.
	        // the only thing to work out is if we are displaying groups  across multiple
	        // columns (groupMultiAutoColumn=true), we only want 'total' to appear in the first column.
	        var colDef = this.params.colDef;
	        var doingFullWidth = colDef == null;
	        if (doingFullWidth) {
	            return true;
	        }
	        if (colDef.showRowGroup === true) {
	            return true;
	        }
	        var rowGroupCols = this.columnController.getRowGroupColumns();
	        // this is a sanity check, rowGroupCols should always be present
	        if (!rowGroupCols || rowGroupCols.length === 0) {
	            return true;
	        }
	        var firstRowGroupCol = rowGroupCols[0];
	        return firstRowGroupCol.getId() === colDef.showRowGroup;
	    };
	    GroupCellRenderer.prototype.init = function (params) {
	        this.params = params;
	        var topLevelFooter = this.isTopLevelFooter();
	        var embeddedRowMismatch = this.isEmbeddedRowMismatch();
	        // This allows for empty strings to appear as groups since
	        // it will only return for null or undefined.
	        var nullValue = params.value == null;
	        var skipCell = false;
	        // if the groupCellRenderer is inside of a footer and groupHideOpenParents is true
	        // we should only display the groupCellRenderer if the current column is the rowGroupedColumn
	        if (this.gridOptionsWrapper.isGroupIncludeFooter() && this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            var node = params.node;
	            if (node.footer) {
	                var showRowGroup = params.colDef && params.colDef.showRowGroup;
	                var rowGroupColumnId = node.rowGroupColumn && node.rowGroupColumn.getColId();
	                skipCell = showRowGroup !== rowGroupColumnId;
	            }
	        }
	        this.cellIsBlank = topLevelFooter ? false : (embeddedRowMismatch || nullValue || skipCell);
	        if (this.cellIsBlank) {
	            return;
	        }
	        this.setupDragOpenParents();
	        this.addFullWidthRowDraggerIfNeeded();
	        this.addExpandAndContract();
	        this.addCheckboxIfNeeded();
	        this.addValueElement();
	        this.setupIndent();
	    };
	    // if we are doing embedded full width rows, we only show the renderer when
	    // in the body, or if pinning in the pinned section, or if pinning and RTL,
	    // in the right section. otherwise we would have the cell repeated in each section.
	    GroupCellRenderer.prototype.isEmbeddedRowMismatch = function () {
	        if (!this.params.fullWidth || !this.gridOptionsWrapper.isEmbedFullWidthRows()) {
	            return false;
	        }
	        var pinnedLeftCell = this.params.pinned === Constants.PINNED_LEFT;
	        var pinnedRightCell = this.params.pinned === Constants.PINNED_RIGHT;
	        var bodyCell = !pinnedLeftCell && !pinnedRightCell;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            if (this.columnController.isPinningLeft()) {
	                return !pinnedRightCell;
	            }
	            return !bodyCell;
	        }
	        if (this.columnController.isPinningLeft()) {
	            return !pinnedLeftCell;
	        }
	        return !bodyCell;
	    };
	    GroupCellRenderer.prototype.setIndent = function () {
	        if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        var params = this.params;
	        var rowNode = params.node;
	        // if we are only showing one group column, we don't want to be indenting based on level
	        var fullWithRow = !!params.colDef;
	        var manyDimensionThisColumn = !fullWithRow || params.colDef.showRowGroup === true;
	        var paddingCount = manyDimensionThisColumn ? rowNode.uiLevel : 0;
	        var userProvidedPaddingPixelsTheDeprecatedWay = params.padding >= 0;
	        if (userProvidedPaddingPixelsTheDeprecatedWay) {
	            this.setPaddingDeprecatedWay(paddingCount, params.padding);
	            return;
	        }
	        if (this.indentClass) {
	            this.removeCssClass(this.indentClass);
	        }
	        this.indentClass = 'ag-row-group-indent-' + paddingCount;
	        this.addCssClass(this.indentClass);
	    };
	    GroupCellRenderer.prototype.setPaddingDeprecatedWay = function (paddingCount, padding) {
	        doOnce(function () { return console.warn('AG Grid: since v14.2, configuring padding for groupCellRenderer should be done with Sass variables and themes. Please see the AG Grid documentation page for Themes, in particular the property $row-group-indent-size.'); }, 'groupCellRenderer->doDeprecatedWay');
	        var paddingPx = paddingCount * padding;
	        var eGui = this.getGui();
	        var paddingSide = this.gridOptionsWrapper.isEnableRtl() ? 'paddingRight' : 'paddingLeft';
	        eGui.style[paddingSide] = paddingPx + "px";
	    };
	    GroupCellRenderer.prototype.setupIndent = function () {
	        // only do this if an indent - as this overwrites the padding that
	        // the theme set, which will make things look 'not aligned' for the
	        // first group level.
	        var node = this.params.node;
	        var suppressPadding = this.params.suppressPadding;
	        if (!suppressPadding) {
	            this.addManagedListener(node, RowNode.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
	            this.setIndent();
	        }
	    };
	    GroupCellRenderer.prototype.addValueElement = function () {
	        if (this.displayedGroup.footer) {
	            this.addFooterValue();
	        }
	        else {
	            this.addGroupValue();
	            this.addChildCount();
	        }
	    };
	    GroupCellRenderer.prototype.addFooterValue = function () {
	        var footerValueGetter = this.params.footerValueGetter;
	        var footerValue;
	        if (footerValueGetter) {
	            // params is same as we were given, except we set the value as the item to display
	            var paramsClone = cloneObject(this.params);
	            paramsClone.value = this.params.value;
	            if (typeof footerValueGetter === 'function') {
	                footerValue = footerValueGetter(paramsClone);
	            }
	            else if (typeof footerValueGetter === 'string') {
	                footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
	            }
	            else {
	                console.warn('AG Grid: footerValueGetter should be either a function or a string (expression)');
	            }
	        }
	        else {
	            footerValue = 'Total ' + (this.params.value != null ? this.params.value : '');
	        }
	        this.eValue.innerHTML = footerValue;
	    };
	    GroupCellRenderer.prototype.addGroupValue = function () {
	        var _this = this;
	        var params = this.params;
	        var rowGroupColumn = this.displayedGroup.rowGroupColumn;
	        // we try and use the cellRenderer of the column used for the grouping if we can
	        var columnToUse = rowGroupColumn ? rowGroupColumn : params.column;
	        var groupName = this.params.value;
	        var valueFormatted = columnToUse ?
	            this.valueFormatterService.formatValue(columnToUse, params.node, params.scope, groupName) : null;
	        params.valueFormatted = valueFormatted;
	        var rendererPromise;
	        rendererPromise = params.fullWidth
	            ? this.useFullWidth(params)
	            : this.useInnerRenderer(this.params.colDef.cellRendererParams, columnToUse.getColDef(), params);
	        // retain a reference to the created renderer - we'll use this later for cleanup (in destroy)
	        if (rendererPromise) {
	            rendererPromise.then(function (value) {
	                _this.innerCellRenderer = value;
	            });
	        }
	    };
	    GroupCellRenderer.prototype.useInnerRenderer = function (groupCellRendererParams, groupedColumnDef, // the column this group row is for, eg 'Country'
	    params) {
	        var _this = this;
	        // when grouping, the normal case is we use the cell renderer of the grouped column. eg if grouping by country
	        // and then rating, we will use the country cell renderer for each country group row and likewise the rating
	        // cell renderer for each rating group row.
	        //
	        // however if the user has innerCellRenderer defined, this gets preference and we don't use cell renderers
	        // of the grouped columns.
	        //
	        // so we check and use in the following order:
	        //
	        // 1) thisColDef.cellRendererParams.innerRenderer of the column showing the groups (eg auto group column)
	        // 2) groupedColDef.cellRenderer of the grouped column
	        // 3) groupedColDef.cellRendererParams.innerRenderer
	        var cellRendererPromise = null;
	        // we check if cell renderer provided for the group cell renderer, eg colDef.cellRendererParams.innerRenderer
	        var groupInnerRendererClass = this.userComponentFactory
	            .lookupComponentClassDef(groupCellRendererParams, "innerRenderer");
	        if (groupInnerRendererClass && groupInnerRendererClass.component != null
	            && groupInnerRendererClass.source != ComponentSource.DEFAULT) {
	            // use the renderer defined in cellRendererParams.innerRenderer
	            cellRendererPromise = this.userComponentFactory.newInnerCellRenderer(groupCellRendererParams, params);
	        }
	        else {
	            // otherwise see if we can use the cellRenderer of the column we are grouping by
	            var groupColumnRendererClass = this.userComponentFactory
	                .lookupComponentClassDef(groupedColumnDef, "cellRenderer");
	            if (groupColumnRendererClass &&
	                groupColumnRendererClass.source != ComponentSource.DEFAULT) {
	                // Only if the original column is using a specific renderer, it it is a using a DEFAULT one ignore it
	                cellRendererPromise = this.userComponentFactory.newCellRenderer(groupedColumnDef, params);
	            }
	            else if (groupColumnRendererClass &&
	                groupColumnRendererClass.source == ComponentSource.DEFAULT &&
	                (get(groupedColumnDef, 'cellRendererParams.innerRenderer', null))) {
	                // EDGE CASE - THIS COMES FROM A COLUMN WHICH HAS BEEN GROUPED DYNAMICALLY, THAT HAS AS RENDERER 'group'
	                // AND HAS A INNER CELL RENDERER
	                cellRendererPromise = this.userComponentFactory.newInnerCellRenderer(groupedColumnDef.cellRendererParams, params);
	            }
	            else {
	                // This forces the retrieval of the default plain cellRenderer that just renders the values.
	                cellRendererPromise = this.userComponentFactory.newCellRenderer({}, params);
	            }
	        }
	        if (cellRendererPromise != null) {
	            cellRendererPromise.then(function (rendererToUse) {
	                if (rendererToUse == null) {
	                    _this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	                    return;
	                }
	                bindCellRendererToHtmlElement(cellRendererPromise, _this.eValue);
	            });
	        }
	        else {
	            this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        return cellRendererPromise;
	    };
	    GroupCellRenderer.prototype.useFullWidth = function (params) {
	        var cellRendererPromise = this.userComponentFactory.newFullWidthGroupRowInnerCellRenderer(params);
	        if (cellRendererPromise != null) {
	            bindCellRendererToHtmlElement(cellRendererPromise, this.eValue);
	        }
	        else {
	            this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        return cellRendererPromise;
	    };
	    GroupCellRenderer.prototype.addFullWidthRowDraggerIfNeeded = function () {
	        var _this = this;
	        if (!this.params.fullWidth || !this.params.rowDrag) {
	            return;
	        }
	        var rowDragComp = new RowDragComp(function () { return _this.params.value; }, this.params.node);
	        this.createManagedBean(rowDragComp, this.context);
	        this.getGui().insertAdjacentElement('afterbegin', rowDragComp.getGui());
	    };
	    GroupCellRenderer.prototype.addChildCount = function () {
	        // only include the child count if it's included, eg if user doing custom aggregation,
	        // then this could be left out, or set to -1, ie no child count
	        if (this.params.suppressCount) {
	            return;
	        }
	        this.addManagedListener(this.displayedGroup, RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
	        // filtering changes the child count, so need to cater for it
	        this.updateChildCount();
	    };
	    GroupCellRenderer.prototype.updateChildCount = function () {
	        var allChildrenCount = this.displayedGroup.allChildrenCount;
	        var showingGroupForThisNode = this.isShowRowGroupForThisRow();
	        var showCount = showingGroupForThisNode && allChildrenCount != null && allChildrenCount >= 0;
	        var countString = showCount ? "(" + allChildrenCount + ")" : "";
	        this.eChildCount.innerHTML = countString;
	    };
	    GroupCellRenderer.prototype.isUserWantsSelected = function () {
	        var paramsCheckbox = this.params.checkbox;
	        if (typeof paramsCheckbox === 'function') {
	            return paramsCheckbox(this.params);
	        }
	        return paramsCheckbox === true;
	    };
	    GroupCellRenderer.prototype.addCheckboxIfNeeded = function () {
	        var _this = this;
	        var rowNode = this.displayedGroup;
	        var checkboxNeeded = this.isUserWantsSelected() &&
	            // footers cannot be selected
	            !rowNode.footer &&
	            // pinned rows cannot be selected
	            !rowNode.rowPinned &&
	            // details cannot be selected
	            !rowNode.detail;
	        if (checkboxNeeded) {
	            var cbSelectionComponent_1 = new CheckboxSelectionComponent();
	            this.getContext().createBean(cbSelectionComponent_1);
	            cbSelectionComponent_1.init({ rowNode: rowNode, column: this.params.column });
	            this.eCheckbox.appendChild(cbSelectionComponent_1.getGui());
	            this.addDestroyFunc(function () { return _this.getContext().destroyBean(cbSelectionComponent_1); });
	        }
	        addOrRemoveCssClass(this.eCheckbox, 'ag-invisible', !checkboxNeeded);
	    };
	    GroupCellRenderer.prototype.addExpandAndContract = function () {
	        var params = this.params;
	        var eGroupCell = params.eGridCell;
	        var eExpandedIcon = createIconNoSpan('groupExpanded', this.gridOptionsWrapper, null);
	        var eContractedIcon = createIconNoSpan('groupContracted', this.gridOptionsWrapper, null);
	        setAriaExpanded(eGroupCell, !!params.node.expanded);
	        if (eExpandedIcon) {
	            this.eExpanded.appendChild(eExpandedIcon);
	        }
	        if (eContractedIcon) {
	            this.eContracted.appendChild(eContractedIcon);
	        }
	        this.addManagedListener(this.eExpanded, 'click', this.onExpandClicked.bind(this));
	        this.addManagedListener(this.eContracted, 'click', this.onExpandClicked.bind(this));
	        // expand / contract as the user hits enter
	        this.addManagedListener(eGroupCell, 'keydown', this.onKeyDown.bind(this));
	        this.addManagedListener(params.node, RowNode.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
	        this.showExpandAndContractIcons();
	        // because we don't show the expand / contract when there are no children, we need to check every time
	        // the number of children change.
	        var expandableChangedListener = this.onRowNodeIsExpandableChanged.bind(this);
	        this.addManagedListener(this.displayedGroup, RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, expandableChangedListener);
	        this.addManagedListener(this.displayedGroup, RowNode.EVENT_MASTER_CHANGED, expandableChangedListener);
	        this.addManagedListener(this.displayedGroup, RowNode.EVENT_HAS_CHILDREN_CHANGED, expandableChangedListener);
	        // if editing groups, then double click is to start editing
	        if (!this.gridOptionsWrapper.isEnableGroupEdit() && this.isExpandable() && !params.suppressDoubleClickExpand) {
	            this.addManagedListener(eGroupCell, 'dblclick', this.onCellDblClicked.bind(this));
	        }
	    };
	    GroupCellRenderer.prototype.onRowNodeIsExpandableChanged = function () {
	        // maybe if no children now, we should hide the expand / contract icons
	        this.showExpandAndContractIcons();
	        // if we have no children, this impacts the indent
	        this.setIndent();
	    };
	    GroupCellRenderer.prototype.onKeyDown = function (event) {
	        var enterKeyPressed = isKeyPressed(event, KeyCode.ENTER);
	        if (!enterKeyPressed || this.params.suppressEnterExpand) {
	            return;
	        }
	        var cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);
	        if (cellEditable) {
	            return;
	        }
	        this.onExpandOrContract();
	    };
	    GroupCellRenderer.prototype.setupDragOpenParents = function () {
	        var column = this.params.column;
	        var rowNode = this.params.node;
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            this.draggedFromHideOpenParents = false;
	        }
	        else if (!rowNode.hasChildren()) {
	            // if we are here, and we are not a group, then we must of been dragged down,
	            // as otherwise the cell would be blank, and if cell is blank, this method is never called.
	            this.draggedFromHideOpenParents = true;
	        }
	        else {
	            var rowGroupColumn = rowNode.rowGroupColumn;
	            if (rowGroupColumn) {
	                // if the displayGroup column for this col matches the rowGroupColumn we grouped by for this node,
	                // then nothing was dragged down
	                this.draggedFromHideOpenParents = !column.isRowGroupDisplayed(rowGroupColumn.getId());
	            }
	            else {
	                // the only way we can end up here (no column, but a group) is if we are at the root node,
	                // which only happens when 'groupIncludeTotalFooter' is true. here, we are never dragging
	                this.draggedFromHideOpenParents = false;
	            }
	        }
	        if (this.draggedFromHideOpenParents) {
	            var pointer = rowNode.parent;
	            while (true) {
	                if (missing(pointer)) {
	                    break;
	                }
	                if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
	                    this.displayedGroup = pointer;
	                    break;
	                }
	                pointer = pointer.parent;
	            }
	        }
	        // if we didn't find a displayed group, set it to the row node
	        if (missing(this.displayedGroup)) {
	            this.displayedGroup = rowNode;
	        }
	    };
	    GroupCellRenderer.prototype.onExpandClicked = function (mouseEvent) {
	        if (isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        // so if we expand a node, it does not also get selected.
	        stopPropagationForAgGrid(mouseEvent);
	        this.onExpandOrContract();
	    };
	    GroupCellRenderer.prototype.onCellDblClicked = function (mouseEvent) {
	        if (isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        // we want to avoid acting on double click events on the expand / contract icon,
	        // as that icons already has expand / collapse functionality on it. otherwise if
	        // the icon was double clicked, we would get 'click', 'click', 'dblclick' which
	        // is open->close->open, however double click should be open->close only.
	        var targetIsExpandIcon = isElementInEventPath(this.eExpanded, mouseEvent)
	            || isElementInEventPath(this.eContracted, mouseEvent);
	        if (!targetIsExpandIcon) {
	            this.onExpandOrContract();
	        }
	    };
	    GroupCellRenderer.prototype.onExpandOrContract = function () {
	        // must use the displayedGroup, so if data was dragged down, we expand the parent, not this row
	        var rowNode = this.displayedGroup;
	        var params = this.params;
	        var nextExpandState = !rowNode.expanded;
	        rowNode.setExpanded(nextExpandState);
	        setAriaExpanded(params.eGridCell, nextExpandState);
	    };
	    GroupCellRenderer.prototype.isShowRowGroupForThisRow = function () {
	        if (this.gridOptionsWrapper.isTreeData()) {
	            return true;
	        }
	        var rowGroupColumn = this.displayedGroup.rowGroupColumn;
	        if (!rowGroupColumn) {
	            return false;
	        }
	        // column is null for fullWidthRows
	        var column = this.params.column;
	        var thisColumnIsInterested = column == null || column.isRowGroupDisplayed(rowGroupColumn.getId());
	        return thisColumnIsInterested;
	    };
	    GroupCellRenderer.prototype.isExpandable = function () {
	        if (this.draggedFromHideOpenParents) {
	            return true;
	        }
	        var rowNode = this.displayedGroup;
	        var reducedLeafNode = this.columnController.isPivotMode() && rowNode.leafGroup;
	        var expandableGroup = rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode;
	        if (!expandableGroup) {
	            return false;
	        }
	        // column is null for fullWidthRows
	        var column = this.params.column;
	        var displayingForOneColumnOnly = column != null && typeof column.getColDef().showRowGroup === 'string';
	        if (displayingForOneColumnOnly) {
	            var showing = this.isShowRowGroupForThisRow();
	            return showing;
	        }
	        return true;
	    };
	    GroupCellRenderer.prototype.showExpandAndContractIcons = function () {
	        var _a = this, eContracted = _a.eContracted, eExpanded = _a.eExpanded, params = _a.params, displayedGroup = _a.displayedGroup, columnController = _a.columnController;
	        var eGridCell = params.eGridCell, node = params.node;
	        var isExpandable = this.isExpandable();
	        if (isExpandable) {
	            // if expandable, show one based on expand state.
	            // if we were dragged down, means our parent is always expanded
	            var expanded = this.draggedFromHideOpenParents ? true : node.expanded;
	            setDisplayed(eContracted, !expanded);
	            setDisplayed(eExpanded, expanded);
	        }
	        else {
	            // it not expandable, show neither
	            removeAriaExpanded(eGridCell);
	            setDisplayed(eExpanded, false);
	            setDisplayed(eContracted, false);
	        }
	        // compensation padding for leaf nodes, so there is blank space instead of the expand icon
	        var pivotMode = columnController.isPivotMode();
	        var pivotModeAndLeafGroup = pivotMode && displayedGroup.leafGroup;
	        var addExpandableCss = isExpandable && !pivotModeAndLeafGroup;
	        var isTotalFooterNode = node.footer && node.level === -1;
	        this.addOrRemoveCssClass('ag-cell-expandable', addExpandableCss);
	        this.addOrRemoveCssClass('ag-row-group', addExpandableCss);
	        if (pivotMode) {
	            this.addOrRemoveCssClass('ag-pivot-leaf-group', pivotModeAndLeafGroup);
	        }
	        else if (!isTotalFooterNode) {
	            this.addOrRemoveCssClass('ag-row-group-leaf-indent', !addExpandableCss);
	        }
	    };
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to have public here instead of private or protected
	    GroupCellRenderer.prototype.destroy = function () {
	        this.getContext().destroyBean(this.innerCellRenderer);
	        _super.prototype.destroy.call(this);
	    };
	    GroupCellRenderer.prototype.refresh = function () {
	        return false;
	    };
	    GroupCellRenderer.TEMPLATE = "<span class=\"ag-cell-wrapper\">\n            <span class=\"ag-group-expanded\" ref=\"eExpanded\"></span>\n            <span class=\"ag-group-contracted\" ref=\"eContracted\"></span>\n            <span class=\"ag-group-checkbox ag-invisible\" ref=\"eCheckbox\"></span>\n            <span class=\"ag-group-value\" ref=\"eValue\"></span>\n            <span class=\"ag-group-child-count\" ref=\"eChildCount\"></span>\n        </span>";
	    __decorate$n([
	        Autowired('rowRenderer')
	    ], GroupCellRenderer.prototype, "rowRenderer", void 0);
	    __decorate$n([
	        Autowired('expressionService')
	    ], GroupCellRenderer.prototype, "expressionService", void 0);
	    __decorate$n([
	        Autowired('valueFormatterService')
	    ], GroupCellRenderer.prototype, "valueFormatterService", void 0);
	    __decorate$n([
	        Autowired('columnController')
	    ], GroupCellRenderer.prototype, "columnController", void 0);
	    __decorate$n([
	        Autowired('userComponentFactory')
	    ], GroupCellRenderer.prototype, "userComponentFactory", void 0);
	    __decorate$n([
	        RefSelector('eExpanded')
	    ], GroupCellRenderer.prototype, "eExpanded", void 0);
	    __decorate$n([
	        RefSelector('eContracted')
	    ], GroupCellRenderer.prototype, "eContracted", void 0);
	    __decorate$n([
	        RefSelector('eCheckbox')
	    ], GroupCellRenderer.prototype, "eCheckbox", void 0);
	    __decorate$n([
	        RefSelector('eValue')
	    ], GroupCellRenderer.prototype, "eValue", void 0);
	    __decorate$n([
	        RefSelector('eChildCount')
	    ], GroupCellRenderer.prototype, "eChildCount", void 0);
	    return GroupCellRenderer;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$l = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$o = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ARROW_UP = '\u2191';
	var ARROW_DOWN = '\u2193';
	var AnimateShowChangeCellRenderer = /** @class */ (function (_super) {
	    __extends$l(AnimateShowChangeCellRenderer, _super);
	    function AnimateShowChangeCellRenderer() {
	        var _this = _super.call(this, AnimateShowChangeCellRenderer.TEMPLATE) || this;
	        _this.refreshCount = 0;
	        return _this;
	    }
	    AnimateShowChangeCellRenderer.prototype.init = function (params) {
	        // this.params = params;
	        this.eValue = this.queryForHtmlElement('.ag-value-change-value');
	        this.eDelta = this.queryForHtmlElement('.ag-value-change-delta');
	        this.refresh(params);
	    };
	    AnimateShowChangeCellRenderer.prototype.showDelta = function (params, delta) {
	        var absDelta = Math.abs(delta);
	        var valueFormatted = params.formatValue(absDelta);
	        var valueToUse = exists(valueFormatted) ? valueFormatted : absDelta;
	        var deltaUp = (delta >= 0);
	        if (deltaUp) {
	            this.eDelta.innerHTML = ARROW_UP + valueToUse;
	        }
	        else {
	            // because negative, use ABS to remove sign
	            this.eDelta.innerHTML = ARROW_DOWN + valueToUse;
	        }
	        addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-up', deltaUp);
	        addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-down', !deltaUp);
	    };
	    AnimateShowChangeCellRenderer.prototype.setTimerToRemoveDelta = function () {
	        var _this = this;
	        // the refreshCount makes sure that if the value updates again while
	        // the below timer is waiting, then the below timer will realise it
	        // is not the most recent and will not try to remove the delta value.
	        this.refreshCount++;
	        var refreshCountCopy = this.refreshCount;
	        window.setTimeout(function () {
	            if (refreshCountCopy === _this.refreshCount) {
	                _this.hideDeltaValue();
	            }
	        }, 2000);
	    };
	    AnimateShowChangeCellRenderer.prototype.hideDeltaValue = function () {
	        removeCssClass(this.eValue, 'ag-value-change-value-highlight');
	        clearElement(this.eDelta);
	    };
	    AnimateShowChangeCellRenderer.prototype.refresh = function (params) {
	        var value = params.value;
	        if (value === this.lastValue) {
	            return false;
	        }
	        if (exists(params.valueFormatted)) {
	            this.eValue.innerHTML = params.valueFormatted;
	        }
	        else if (exists(params.value)) {
	            this.eValue.innerHTML = value;
	        }
	        else {
	            clearElement(this.eValue);
	        }
	        // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
	        // with regards processingFilterChange
	        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
	            return false;
	        }
	        if (typeof value === 'number' && typeof this.lastValue === 'number') {
	            var delta = value - this.lastValue;
	            this.showDelta(params, delta);
	        }
	        // highlight the current value, but only if it's not new, otherwise it
	        // would get highlighted first time the value is shown
	        if (this.lastValue) {
	            addCssClass(this.eValue, 'ag-value-change-value-highlight');
	        }
	        this.setTimerToRemoveDelta();
	        this.lastValue = value;
	        return true;
	    };
	    AnimateShowChangeCellRenderer.TEMPLATE = '<span>' +
	        '<span class="ag-value-change-delta"></span>' +
	        '<span class="ag-value-change-value"></span>' +
	        '</span>';
	    __decorate$o([
	        Autowired('filterManager')
	    ], AnimateShowChangeCellRenderer.prototype, "filterManager", void 0);
	    return AnimateShowChangeCellRenderer;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$m = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$p = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AnimateSlideCellRenderer = /** @class */ (function (_super) {
	    __extends$m(AnimateSlideCellRenderer, _super);
	    function AnimateSlideCellRenderer() {
	        var _this = _super.call(this, AnimateSlideCellRenderer.TEMPLATE) || this;
	        _this.refreshCount = 0;
	        _this.eCurrent = _this.queryForHtmlElement('.ag-value-slide-current');
	        return _this;
	    }
	    AnimateSlideCellRenderer.prototype.init = function (params) {
	        this.refresh(params);
	    };
	    AnimateSlideCellRenderer.prototype.addSlideAnimation = function () {
	        var _this = this;
	        this.refreshCount++;
	        // below we keep checking this, and stop working on the animation
	        // if it no longer matches - this means another animation has started
	        // and this one is stale.
	        var refreshCountCopy = this.refreshCount;
	        // if old animation, remove it
	        if (this.ePrevious) {
	            this.getGui().removeChild(this.ePrevious);
	        }
	        this.ePrevious = loadTemplate('<span class="ag-value-slide-previous ag-value-slide-out"></span>');
	        this.ePrevious.innerHTML = this.eCurrent.innerHTML;
	        this.getGui().insertBefore(this.ePrevious, this.eCurrent);
	        // having timeout of 0 allows use to skip to the next css turn,
	        // so we know the previous css classes have been applied. so the
	        // complex set of setTimeout below creates the animation
	        window.setTimeout(function () {
	            if (refreshCountCopy !== _this.refreshCount) {
	                return;
	            }
	            addCssClass(_this.ePrevious, 'ag-value-slide-out-end');
	        }, 50);
	        window.setTimeout(function () {
	            if (refreshCountCopy !== _this.refreshCount) {
	                return;
	            }
	            _this.getGui().removeChild(_this.ePrevious);
	            _this.ePrevious = null;
	        }, 3000);
	    };
	    AnimateSlideCellRenderer.prototype.refresh = function (params) {
	        var value = params.value;
	        if (missing(value)) {
	            value = '';
	        }
	        if (value === this.lastValue) {
	            return false;
	        }
	        // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
	        // with regards processingFilterChange
	        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
	            return false;
	        }
	        this.addSlideAnimation();
	        this.lastValue = value;
	        if (exists(params.valueFormatted)) {
	            this.eCurrent.innerHTML = params.valueFormatted;
	        }
	        else if (exists(params.value)) {
	            this.eCurrent.innerHTML = value;
	        }
	        else {
	            clearElement(this.eCurrent);
	        }
	        return true;
	    };
	    AnimateSlideCellRenderer.TEMPLATE = "<span>\n            <span class=\"ag-value-slide-current\"></span>\n        </span>";
	    __decorate$p([
	        Autowired('filterManager')
	    ], AnimateSlideCellRenderer.prototype, "filterManager", void 0);
	    return AnimateSlideCellRenderer;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$n = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$q = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var LoadingCellRenderer = /** @class */ (function (_super) {
	    __extends$n(LoadingCellRenderer, _super);
	    function LoadingCellRenderer() {
	        return _super.call(this, LoadingCellRenderer.TEMPLATE) || this;
	    }
	    LoadingCellRenderer.prototype.init = function (params) {
	        params.node.failedLoad ? this.setupFailed() : this.setupLoading();
	    };
	    LoadingCellRenderer.prototype.setupFailed = function () {
	        this.eLoadingText.innerText = 'ERR';
	    };
	    LoadingCellRenderer.prototype.setupLoading = function () {
	        var eLoadingIcon = createIconNoSpan('groupLoading', this.gridOptionsWrapper, null);
	        if (eLoadingIcon) {
	            this.eLoadingIcon.appendChild(eLoadingIcon);
	        }
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eLoadingText.innerText = localeTextFunc('loadingOoo', 'Loading');
	    };
	    LoadingCellRenderer.prototype.refresh = function (params) {
	        return false;
	    };
	    LoadingCellRenderer.TEMPLATE = "<div class=\"ag-loading\">\n            <span class=\"ag-loading-icon\" ref=\"eLoadingIcon\"></span>\n            <span class=\"ag-loading-text\" ref=\"eLoadingText\"></span>\n        </div>";
	    __decorate$q([
	        RefSelector('eLoadingIcon')
	    ], LoadingCellRenderer.prototype, "eLoadingIcon", void 0);
	    __decorate$q([
	        RefSelector('eLoadingText')
	    ], LoadingCellRenderer.prototype, "eLoadingText", void 0);
	    return LoadingCellRenderer;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$o = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$r = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SelectCellEditor = /** @class */ (function (_super) {
	    __extends$o(SelectCellEditor, _super);
	    function SelectCellEditor() {
	        var _this = _super.call(this, '<div class="ag-cell-edit-wrapper"><ag-select class="ag-cell-editor" ref="eSelect"></ag-select></div>') || this;
	        _this.startedByEnter = false;
	        return _this;
	    }
	    SelectCellEditor.prototype.init = function (params) {
	        var _this = this;
	        this.focusAfterAttached = params.cellStartedEdit;
	        if (missing(params.values)) {
	            console.warn('AG Grid: no values found for select cellEditor');
	            return;
	        }
	        this.startedByEnter = params.keyPress === KeyCode.ENTER;
	        var hasValue = false;
	        params.values.forEach(function (value) {
	            var option = { value: value };
	            var valueFormatted = _this.valueFormatterService.formatValue(params.column, null, null, value);
	            var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
	            option.text = valueFormattedExits ? valueFormatted : value;
	            _this.eSelect.addOption(option);
	            hasValue = hasValue || params.value === value;
	        });
	        if (hasValue) {
	            this.eSelect.setValue(params.value, true);
	        }
	        else if (params.values.length) {
	            this.eSelect.setValue(params.values[0], true);
	        }
	        // we don't want to add this if full row editing, otherwise selecting will stop the
	        // full row editing.
	        if (!this.gridOptionsWrapper.isFullRowEdit()) {
	            this.eSelect.onValueChange(function () { return params.stopEditing(); });
	        }
	    };
	    SelectCellEditor.prototype.afterGuiAttached = function () {
	        if (this.focusAfterAttached) {
	            this.eSelect.getFocusableElement().focus();
	        }
	        if (this.startedByEnter) {
	            this.eSelect.showPicker();
	        }
	    };
	    SelectCellEditor.prototype.focusIn = function () {
	        this.eSelect.getFocusableElement().focus();
	    };
	    SelectCellEditor.prototype.getValue = function () {
	        return this.eSelect.getValue();
	    };
	    SelectCellEditor.prototype.isPopup = function () {
	        return false;
	    };
	    __decorate$r([
	        Autowired('valueFormatterService')
	    ], SelectCellEditor.prototype, "valueFormatterService", void 0);
	    __decorate$r([
	        RefSelector('eSelect')
	    ], SelectCellEditor.prototype, "eSelect", void 0);
	    return SelectCellEditor;
	}(PopupComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$p = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var PopupTextCellEditor = /** @class */ (function (_super) {
	    __extends$p(PopupTextCellEditor, _super);
	    function PopupTextCellEditor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupTextCellEditor.prototype.isPopup = function () {
	        return true;
	    };
	    return PopupTextCellEditor;
	}(TextCellEditor));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$q = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var PopupSelectCellEditor = /** @class */ (function (_super) {
	    __extends$q(PopupSelectCellEditor, _super);
	    function PopupSelectCellEditor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupSelectCellEditor.prototype.isPopup = function () {
	        return true;
	    };
	    return PopupSelectCellEditor;
	}(SelectCellEditor));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$r = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$s = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var LargeTextCellEditor = /** @class */ (function (_super) {
	    __extends$r(LargeTextCellEditor, _super);
	    function LargeTextCellEditor() {
	        return _super.call(this, LargeTextCellEditor.TEMPLATE) || this;
	    }
	    LargeTextCellEditor.prototype.init = function (params) {
	        this.params = params;
	        this.focusAfterAttached = params.cellStartedEdit;
	        this.eTextArea
	            .setMaxLength(params.maxLength || 200)
	            .setCols(params.cols || 60)
	            .setRows(params.rows || 10);
	        if (exists(params.value)) {
	            this.eTextArea.setValue(params.value.toString(), true);
	        }
	        this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
	    };
	    LargeTextCellEditor.prototype.onKeyDown = function (event) {
	        var key = event.which || event.keyCode;
	        if (key === KeyCode.LEFT ||
	            key === KeyCode.UP ||
	            key === KeyCode.RIGHT ||
	            key === KeyCode.DOWN ||
	            (event.shiftKey && key === KeyCode.ENTER)) { // shift+enter allows for newlines
	            event.stopPropagation();
	        }
	    };
	    LargeTextCellEditor.prototype.afterGuiAttached = function () {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eTextArea.setInputAriaLabel(translate('ariaInputEditor', 'Input Editor'));
	        if (this.focusAfterAttached) {
	            this.eTextArea.getFocusableElement().focus();
	        }
	    };
	    LargeTextCellEditor.prototype.getValue = function () {
	        return this.params.parseValue(this.eTextArea.getValue());
	    };
	    LargeTextCellEditor.TEMPLATE = "<div class=\"ag-large-text\" tabindex=\"0\">\n            <ag-input-text-area ref=\"eTextArea\" class=\"ag-large-text-input\"></ag-input-text-area>\n        </div>";
	    __decorate$s([
	        RefSelector("eTextArea")
	    ], LargeTextCellEditor.prototype, "eTextArea", void 0);
	    return LargeTextCellEditor;
	}(PopupComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$s = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$t = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var NumberFilter = /** @class */ (function (_super) {
	    __extends$s(NumberFilter, _super);
	    function NumberFilter() {
	        return _super.call(this, 'numberFilter') || this;
	    }
	    NumberFilter.prototype.mapRangeFromModel = function (filterModel) {
	        return {
	            from: filterModel.filter,
	            to: filterModel.filterTo
	        };
	    };
	    NumberFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    NumberFilter.prototype.resetUiToDefaults = function (silent) {
	        var _this = this;
	        return _super.prototype.resetUiToDefaults.call(this, silent).then(function () {
	            var fields = [_this.eValueFrom1, _this.eValueFrom2, _this.eValueTo1, _this.eValueTo2];
	            fields.forEach(function (field) { return field.setValue(null, silent); });
	            _this.resetPlaceholder();
	        });
	    };
	    NumberFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === ConditionPosition.One;
	        var eValueFrom = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        eValueFrom.setValue(model ? ('' + model.filter) : null);
	        eValueTo.setValue(model ? ('' + model.filterTo) : null);
	    };
	    NumberFilter.prototype.setValueFromFloatingFilter = function (value) {
	        this.eValueFrom1.setValue(value);
	        this.eValueTo1.setValue(null);
	        this.eValueFrom2.setValue(null);
	        this.eValueTo2.setValue(null);
	    };
	    NumberFilter.prototype.comparator = function () {
	        return function (left, right) {
	            if (left === right) {
	                return 0;
	            }
	            return left < right ? 1 : -1;
	        };
	    };
	    NumberFilter.prototype.setParams = function (params) {
	        this.numberFilterParams = params;
	        var allowedCharPattern = this.getAllowedCharPattern();
	        if (allowedCharPattern) {
	            var config = { allowedCharPattern: allowedCharPattern };
	            this.resetTemplate({
	                eValueFrom1: config,
	                eValueTo1: config,
	                eValueFrom2: config,
	                eValueTo2: config,
	            });
	        }
	        _super.prototype.setParams.call(this, params);
	        this.addValueChangedListeners();
	    };
	    NumberFilter.prototype.addValueChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.eValueFrom1.onValueChange(listener);
	        this.eValueTo1.onValueChange(listener);
	        this.eValueFrom2.onValueChange(listener);
	        this.eValueTo2.onValueChange(listener);
	    };
	    NumberFilter.prototype.resetPlaceholder = function () {
	        var globalTranslate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var isRange1 = this.showValueTo(this.getCondition1Type());
	        var isRange2 = this.showValueTo(this.getCondition2Type());
	        this.eValueFrom1.setInputPlaceholder(this.translate(isRange1 ? 'inRangeStart' : 'filterOoo'));
	        this.eValueFrom1.setInputAriaLabel(isRange1
	            ? globalTranslate('ariaFilterFromValue', 'Filter from value')
	            : globalTranslate('ariaFilterValue', 'Filter Value'));
	        this.eValueTo1.setInputPlaceholder(this.translate('inRangeEnd'));
	        this.eValueTo1.setInputAriaLabel(globalTranslate('ariaFilterToValue', 'Filter to Value'));
	        this.eValueFrom2.setInputPlaceholder(this.translate(isRange2 ? 'inRangeStart' : 'filterOoo'));
	        this.eValueFrom2.setInputAriaLabel(isRange2
	            ? globalTranslate('ariaFilterFromValue', 'Filter from value')
	            : globalTranslate('ariaFilterValue', 'Filter Value'));
	        this.eValueTo2.setInputPlaceholder(this.translate('inRangeEnd'));
	        this.eValueTo2.setInputAriaLabel(globalTranslate('ariaFilterToValue', 'Filter to Value'));
	    };
	    NumberFilter.prototype.afterGuiAttached = function (params) {
	        _super.prototype.afterGuiAttached.call(this, params);
	        this.resetPlaceholder();
	        if (!params || !params.suppressFocus) {
	            this.eValueFrom1.getInputElement().focus();
	        }
	    };
	    NumberFilter.prototype.getDefaultFilterOptions = function () {
	        return NumberFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    NumberFilter.prototype.createValueTemplate = function (position) {
	        var pos = position === ConditionPosition.One ? '1' : '2';
	        var allowedCharPattern = this.getAllowedCharPattern();
	        var agElementTag = allowedCharPattern ? 'ag-input-text-field' : 'ag-input-number-field';
	        return /* html */ "\n            <div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n                <" + agElementTag + " class=\"ag-filter-from ag-filter-filter\" ref=\"eValueFrom" + pos + "\"></" + agElementTag + ">\n                <" + agElementTag + " class=\"ag-filter-to ag-filter-filter\" ref=\"eValueTo" + pos + "\"></" + agElementTag + ">\n            </div>";
	    };
	    NumberFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        if (option === SimpleFilter.EMPTY) {
	            return false;
	        }
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        var eValue = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        var value = this.stringToFloat(eValue.getValue());
	        return value != null && (!this.showValueTo(option) || this.stringToFloat(eValueTo.getValue()) != null);
	    };
	    NumberFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.filter === bSimple.filter
	            && aSimple.filterTo === bSimple.filterTo
	            && aSimple.type === bSimple.type;
	    };
	    NumberFilter.prototype.getFilterType = function () {
	        return 'number';
	    };
	    NumberFilter.prototype.stringToFloat = function (value) {
	        if (typeof value === 'number') {
	            return value;
	        }
	        var filterText = makeNull(value);
	        if (filterText != null && filterText.trim() === '') {
	            filterText = null;
	        }
	        if (this.numberFilterParams.numberParser) {
	            return this.numberFilterParams.numberParser(filterText);
	        }
	        return filterText == null || filterText.trim() === '-' ? null : parseFloat(filterText);
	    };
	    NumberFilter.prototype.createCondition = function (position) {
	        var positionOne = position === ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var value = this.stringToFloat(eValue.getValue());
	        var model = {
	            filterType: this.getFilterType(),
	            type: type
	        };
	        if (!this.doesFilterHaveHiddenInput(type)) {
	            model.filter = value;
	            if (this.showValueTo(type)) {
	                var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	                var valueTo = this.stringToFloat(eValueTo.getValue());
	                model.filterTo = valueTo;
	            }
	        }
	        return model;
	    };
	    NumberFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        this.resetPlaceholder();
	        var condition1Type = this.getCondition1Type();
	        var condition2Type = this.getCondition2Type();
	        setDisplayed(this.eValueFrom1.getGui(), this.showValueFrom(condition1Type));
	        setDisplayed(this.eValueTo1.getGui(), this.showValueTo(condition1Type));
	        setDisplayed(this.eValueFrom2.getGui(), this.showValueFrom(condition2Type));
	        setDisplayed(this.eValueTo2.getGui(), this.showValueTo(condition2Type));
	    };
	    NumberFilter.prototype.getAllowedCharPattern = function () {
	        var allowedCharPattern = (this.numberFilterParams || {}).allowedCharPattern;
	        if (allowedCharPattern) {
	            return allowedCharPattern;
	        }
	        if (!isBrowserChrome() && !isBrowserEdge()) {
	            // only Chrome and Edge support the HTML5 number field, so for other browsers we provide an equivalent
	            // constraint instead
	            return '\\d\\-\\.';
	        }
	        return null;
	    };
	    NumberFilter.DEFAULT_FILTER_OPTIONS = [
	        ScalarFilter.EQUALS,
	        ScalarFilter.NOT_EQUAL,
	        ScalarFilter.LESS_THAN,
	        ScalarFilter.LESS_THAN_OR_EQUAL,
	        ScalarFilter.GREATER_THAN,
	        ScalarFilter.GREATER_THAN_OR_EQUAL,
	        ScalarFilter.IN_RANGE
	    ];
	    __decorate$t([
	        RefSelector('eValueFrom1')
	    ], NumberFilter.prototype, "eValueFrom1", void 0);
	    __decorate$t([
	        RefSelector('eValueTo1')
	    ], NumberFilter.prototype, "eValueTo1", void 0);
	    __decorate$t([
	        RefSelector('eValueFrom2')
	    ], NumberFilter.prototype, "eValueFrom2", void 0);
	    __decorate$t([
	        RefSelector('eValueTo2')
	    ], NumberFilter.prototype, "eValueTo2", void 0);
	    return NumberFilter;
	}(ScalarFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$t = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var LoadingOverlayComponent$1 = /** @class */ (function (_super) {
	    __extends$t(LoadingOverlayComponent, _super);
	    function LoadingOverlayComponent() {
	        return _super.call(this) || this;
	    }
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to override destroy() just to make the method public.
	    LoadingOverlayComponent.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	    };
	    LoadingOverlayComponent.prototype.init = function (params) {
	        var template = this.gridOptionsWrapper.getOverlayLoadingTemplate() ?
	            this.gridOptionsWrapper.getOverlayLoadingTemplate() : LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var localisedTemplate = template.replace('[LOADING...]', localeTextFunc('loadingOoo', 'Loading...'));
	        this.setTemplate(localisedTemplate);
	    };
	    LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE = '<span class="ag-overlay-loading-center">[LOADING...]</span>';
	    return LoadingOverlayComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$u = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var NoRowsOverlayComponent$1 = /** @class */ (function (_super) {
	    __extends$u(NoRowsOverlayComponent, _super);
	    function NoRowsOverlayComponent() {
	        return _super.call(this) || this;
	    }
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to override destroy() just to make the method public.
	    NoRowsOverlayComponent.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	    };
	    NoRowsOverlayComponent.prototype.init = function (params) {
	        var template = this.gridOptionsWrapper.getOverlayNoRowsTemplate() ?
	            this.gridOptionsWrapper.getOverlayNoRowsTemplate() : NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var localisedTemplate = template.replace('[NO_ROWS_TO_SHOW]', localeTextFunc('noRowsToShow', 'No Rows To Show'));
	        this.setTemplate(localisedTemplate);
	    };
	    NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE = '<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>';
	    return NoRowsOverlayComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$v = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var TooltipComponent$1 = /** @class */ (function (_super) {
	    __extends$v(TooltipComponent, _super);
	    function TooltipComponent() {
	        return _super.call(this, /* html */ "<div class=\"ag-tooltip\"></div>") || this;
	    }
	    // will need to type params
	    TooltipComponent.prototype.init = function (params) {
	        var value = params.value;
	        this.getGui().innerHTML = value;
	    };
	    return TooltipComponent;
	}(PopupComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$w = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$u = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var DefaultDateComponent = /** @class */ (function (_super) {
	    __extends$w(DefaultDateComponent, _super);
	    function DefaultDateComponent() {
	        return _super.call(this, /* html */ "\n            <div class=\"ag-filter-filter\">\n                <ag-input-text-field class=\"ag-date-filter\" ref=\"eDateInput\"></ag-input-text-field>\n            </div>") || this;
	    }
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to override destroy() just to make the method public.
	    DefaultDateComponent.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	    };
	    DefaultDateComponent.prototype.init = function (params) {
	        var inputElement = this.eDateInput.getInputElement();
	        if (this.shouldUseBrowserDatePicker(params)) {
	            if (isBrowserIE()) {
	                console.warn('ag-grid: browserDatePicker is specified to true, but it is not supported in IE 11; reverting to text date picker');
	            }
	            else {
	                inputElement.type = 'date';
	            }
	        }
	        // ensures that the input element is focussed when a clear button is clicked
	        this.addManagedListener(inputElement, 'mousedown', function () { return inputElement.focus(); });
	        this.addManagedListener(this.eDateInput.getInputElement(), 'input', function (e) {
	            if (e.target !== document.activeElement) {
	                return;
	            }
	            params.onDateChanged();
	        });
	    };
	    DefaultDateComponent.prototype.getDate = function () {
	        return parseDateTimeFromString(this.eDateInput.getValue());
	    };
	    DefaultDateComponent.prototype.setDate = function (date) {
	        this.eDateInput.setValue(serialiseDate(date, false));
	    };
	    DefaultDateComponent.prototype.setInputPlaceholder = function (placeholder) {
	        this.eDateInput.setInputPlaceholder(placeholder);
	    };
	    DefaultDateComponent.prototype.afterGuiAttached = function (params) {
	        if (!params || !params.suppressFocus) {
	            this.eDateInput.getInputElement().focus();
	        }
	    };
	    DefaultDateComponent.prototype.shouldUseBrowserDatePicker = function (params) {
	        if (params.filterParams && params.filterParams.browserDatePicker != null) {
	            return params.filterParams.browserDatePicker;
	        }
	        return isBrowserChrome() || isBrowserFirefox();
	    };
	    __decorate$u([
	        RefSelector('eDateInput')
	    ], DefaultDateComponent.prototype, "eDateInput", void 0);
	    return DefaultDateComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$x = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var SimpleFloatingFilter = /** @class */ (function (_super) {
	    __extends$x(SimpleFloatingFilter, _super);
	    function SimpleFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SimpleFloatingFilter.prototype.getDefaultDebounceMs = function () {
	        return 0;
	    };
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to override destroy() just to make the method public.
	    SimpleFloatingFilter.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	    };
	    // used by:
	    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
	    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
	    SimpleFloatingFilter.prototype.getTextFromModel = function (model) {
	        if (!model) {
	            return null;
	        }
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var con1Str = this.conditionToString(combinedModel.condition1);
	            var con2Str = this.conditionToString(combinedModel.condition2);
	            return con1Str + " " + combinedModel.operator + " " + con2Str;
	        }
	        else {
	            var condition = model;
	            var customOption = this.optionsFactory.getCustomOption(condition.type);
	            // For custom filter options we display the Name of the filter instead
	            // of displaying the `from` value, as it wouldn't be relevant
	            if (customOption && customOption.hideFilterInput) {
	                this.gridOptionsWrapper.getLocaleTextFunc()(customOption.displayKey, customOption.displayName);
	                return customOption.displayName;
	            }
	            return this.conditionToString(condition);
	        }
	    };
	    SimpleFloatingFilter.prototype.isEventFromFloatingFilter = function (event) {
	        return event && event.afterFloatingFilter;
	    };
	    SimpleFloatingFilter.prototype.getLastType = function () {
	        return this.lastType;
	    };
	    SimpleFloatingFilter.prototype.setLastTypeFromModel = function (model) {
	        // if no model provided by the parent filter use default
	        if (!model) {
	            this.lastType = this.optionsFactory.getDefaultOption();
	            return;
	        }
	        var isCombined = model.operator;
	        var condition;
	        if (isCombined) {
	            var combinedModel = model;
	            condition = combinedModel.condition1;
	        }
	        else {
	            condition = model;
	        }
	        this.lastType = condition.type;
	    };
	    SimpleFloatingFilter.prototype.canWeEditAfterModelFromParentFilter = function (model) {
	        if (!model) {
	            // if no model, then we can edit as long as the lastType is something we can edit, as this
	            // is the type we will provide to the parent filter if the user decides to use the floating filter.
	            return this.isTypeEditable(this.lastType);
	        }
	        // never allow editing if the filter is combined (ie has two parts)
	        var isCombined = model.operator;
	        if (isCombined) {
	            return false;
	        }
	        var simpleModel = model;
	        return this.isTypeEditable(simpleModel.type);
	    };
	    SimpleFloatingFilter.prototype.init = function (params) {
	        this.optionsFactory = new OptionsFactory();
	        this.optionsFactory.init(params.filterParams, this.getDefaultFilterOptions());
	        this.lastType = this.optionsFactory.getDefaultOption();
	        // we are editable if:
	        // 1) there is a type (user has configured filter wrong if not type)
	        //  AND
	        // 2) the default type is not 'in range'
	        var editable = this.isTypeEditable(this.lastType);
	        this.setEditable(editable);
	    };
	    SimpleFloatingFilter.prototype.doesFilterHaveHiddenInput = function (filterType) {
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        return customFilterOption && customFilterOption.hideFilterInput;
	    };
	    SimpleFloatingFilter.prototype.isTypeEditable = function (type) {
	        return !!type && !this.doesFilterHaveHiddenInput(type) &&
	            type !== SimpleFilter.IN_RANGE
	            && type !== SimpleFilter.EMPTY;
	    };
	    return SimpleFloatingFilter;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$y = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$v = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var DateFloatingFilter = /** @class */ (function (_super) {
	    __extends$y(DateFloatingFilter, _super);
	    function DateFloatingFilter() {
	        return _super.call(this, /* html */ "\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eReadOnlyText\"></ag-input-text-field>\n                <div ref=\"eDateWrapper\" style=\"display: flex;\"></div>\n            </div>") || this;
	    }
	    DateFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return DateFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    DateFloatingFilter.prototype.conditionToString = function (condition) {
	        var type = condition.type;
	        var dateFrom = parseDateTimeFromString(condition.dateFrom);
	        if (type === SimpleFilter.IN_RANGE) {
	            var dateTo = parseDateTimeFromString(condition.dateTo);
	            return serialiseDate(dateFrom, false) + "-" + serialiseDate(dateTo, false);
	        }
	        // cater for when the type doesn't need a value
	        return dateFrom == null ? "" + type : "" + serialiseDate(dateFrom, false);
	    };
	    DateFloatingFilter.prototype.init = function (params) {
	        _super.prototype.init.call(this, params);
	        this.params = params;
	        this.createDateComponent();
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eReadOnlyText
	            .setDisabled(true)
	            .setInputAriaLabel(translate('ariaDateFilterInput', 'Date Filter Input'));
	    };
	    DateFloatingFilter.prototype.setEditable = function (editable) {
	        setDisplayed(this.eDateWrapper, editable);
	        setDisplayed(this.eReadOnlyText.getGui(), !editable);
	    };
	    DateFloatingFilter.prototype.onParentModelChanged = function (model, event) {
	        // We don't want to update the floating filter if the floating filter caused the change,
	        // because the UI is already in sync. if we didn't do this, the UI would behave strangely
	        // as it would be updating as the user is typing
	        if (this.isEventFromFloatingFilter(event)) {
	            return;
	        }
	        _super.prototype.setLastTypeFromModel.call(this, model);
	        var allowEditing = this.canWeEditAfterModelFromParentFilter(model);
	        this.setEditable(allowEditing);
	        if (allowEditing) {
	            if (model) {
	                var dateModel = model;
	                this.dateComp.setDate(parseDateTimeFromString(dateModel.dateFrom));
	            }
	            else {
	                this.dateComp.setDate(null);
	            }
	            this.eReadOnlyText.setValue('');
	        }
	        else {
	            this.eReadOnlyText.setValue(this.getTextFromModel(model));
	            this.dateComp.setDate(null);
	        }
	    };
	    DateFloatingFilter.prototype.onDateChanged = function () {
	        var _this = this;
	        var filterValueDate = this.dateComp.getDate();
	        var filterValueText = serialiseDate(filterValueDate);
	        this.params.parentFilterInstance(function (filterInstance) {
	            if (filterInstance) {
	                var simpleFilter = filterInstance;
	                simpleFilter.onFloatingFilterChanged(_this.getLastType(), filterValueText);
	            }
	        });
	    };
	    DateFloatingFilter.prototype.createDateComponent = function () {
	        var _this = this;
	        var debounceMs = ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
	        var dateComponentParams = {
	            onDateChanged: debounce(this.onDateChanged.bind(this), debounceMs),
	            filterParams: this.params.column.getColDef().filterParams
	        };
	        this.dateComp = new DateCompWrapper(this.getContext(), this.userComponentFactory, dateComponentParams, this.eDateWrapper);
	        this.addDestroyFunc(function () { return _this.dateComp.destroy(); });
	    };
	    __decorate$v([
	        Autowired('userComponentFactory')
	    ], DateFloatingFilter.prototype, "userComponentFactory", void 0);
	    __decorate$v([
	        RefSelector('eReadOnlyText')
	    ], DateFloatingFilter.prototype, "eReadOnlyText", void 0);
	    __decorate$v([
	        RefSelector('eDateWrapper')
	    ], DateFloatingFilter.prototype, "eDateWrapper", void 0);
	    return DateFloatingFilter;
	}(SimpleFloatingFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$z = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$w = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TextFilter = /** @class */ (function (_super) {
	    __extends$z(TextFilter, _super);
	    function TextFilter() {
	        return _super.call(this, 'textFilter') || this;
	    }
	    TextFilter.trimInput = function (value) {
	        var trimmedInput = value && value.trim();
	        // trim the input, unless it is all whitespace (this is consistent with Excel behaviour)
	        return trimmedInput === '' ? value : trimmedInput;
	    };
	    TextFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    TextFilter.prototype.getCleanValue = function (inputField) {
	        var value = makeNull(inputField.getValue());
	        return this.textFilterParams.trimInput ? TextFilter.trimInput(value) : value;
	    };
	    TextFilter.prototype.addValueChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.eValue1.onValueChange(listener);
	        this.eValue2.onValueChange(listener);
	    };
	    TextFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.textFilterParams = params;
	        this.comparator = this.textFilterParams.textCustomComparator || TextFilter.DEFAULT_COMPARATOR;
	        this.formatter = this.textFilterParams.textFormatter ||
	            (this.textFilterParams.caseSensitive ? TextFilter.DEFAULT_FORMATTER : TextFilter.DEFAULT_LOWERCASE_FORMATTER);
	        this.addValueChangedListeners();
	    };
	    TextFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === ConditionPosition.One;
	        var eValue = positionOne ? this.eValue1 : this.eValue2;
	        eValue.setValue(model ? model.filter : null);
	    };
	    TextFilter.prototype.createCondition = function (position) {
	        var positionOne = position === ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValue1 : this.eValue2;
	        var value = this.getCleanValue(eValue);
	        eValue.setValue(value, true); // ensure clean value is visible
	        var model = {
	            filterType: this.getFilterType(),
	            type: type
	        };
	        if (!this.doesFilterHaveHiddenInput(type)) {
	            model.filter = value;
	        }
	        return model;
	    };
	    TextFilter.prototype.getFilterType = function () {
	        return 'text';
	    };
	    TextFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.filter === bSimple.filter && aSimple.type === bSimple.type;
	    };
	    TextFilter.prototype.resetUiToDefaults = function (silent) {
	        var _this = this;
	        return _super.prototype.resetUiToDefaults.call(this, silent).then(function () {
	            _this.forEachInput(function (field) { return field.setValue(null, silent); });
	            _this.resetPlaceholder();
	        });
	    };
	    TextFilter.prototype.resetPlaceholder = function () {
	        var globalTranslate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var placeholder = this.translate('filterOoo');
	        this.forEachInput(function (field) {
	            field.setInputPlaceholder(placeholder);
	            field.setInputAriaLabel(globalTranslate('ariaFilterValue', 'Filter Value'));
	        });
	    };
	    TextFilter.prototype.forEachInput = function (action) {
	        forEach([this.eValue1, this.eValue2], action);
	    };
	    TextFilter.prototype.setValueFromFloatingFilter = function (value) {
	        this.eValue1.setValue(value);
	        this.eValue2.setValue(null);
	    };
	    TextFilter.prototype.getDefaultFilterOptions = function () {
	        return TextFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    TextFilter.prototype.createValueTemplate = function (position) {
	        var pos = position === ConditionPosition.One ? '1' : '2';
	        return /* html */ "\n            <div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n                <ag-input-text-field class=\"ag-filter-filter\" ref=\"eValue" + pos + "\"></ag-input-text-field>\n            </div>";
	    };
	    TextFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        setDisplayed(this.eCondition1Body, this.showValueFrom(this.getCondition1Type()));
	        setDisplayed(this.eCondition2Body, this.isCondition2Enabled() && this.showValueFrom(this.getCondition2Type()));
	    };
	    TextFilter.prototype.afterGuiAttached = function (params) {
	        _super.prototype.afterGuiAttached.call(this, params);
	        this.resetPlaceholder();
	        if (!params || !params.suppressFocus) {
	            this.eValue1.getInputElement().focus();
	        }
	    };
	    TextFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        if (option === SimpleFilter.EMPTY) {
	            return false;
	        }
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        return this.getCleanValue(positionOne ? this.eValue1 : this.eValue2) != null;
	    };
	    TextFilter.prototype.individualConditionPasses = function (params, filterModel) {
	        var filterText = filterModel.filter;
	        var filterOption = filterModel.type;
	        var cellValue = this.textFilterParams.valueGetter(params.node);
	        var cellValueFormatted = this.formatter(cellValue);
	        var customFilterOption = this.optionsFactory.getCustomOption(filterOption);
	        if (customFilterOption) {
	            // only execute the custom filter if a value exists or a value isn't required, i.e. input is hidden
	            if (filterText != null || customFilterOption.hideFilterInput) {
	                return customFilterOption.test(filterText, cellValueFormatted);
	            }
	        }
	        if (cellValue == null) {
	            return filterOption === SimpleFilter.NOT_EQUAL || filterOption === SimpleFilter.NOT_CONTAINS;
	        }
	        var filterTextFormatted = this.formatter(filterText);
	        return this.comparator(filterOption, cellValueFormatted, filterTextFormatted);
	    };
	    TextFilter.DEFAULT_FILTER_OPTIONS = [
	        SimpleFilter.CONTAINS,
	        SimpleFilter.NOT_CONTAINS,
	        SimpleFilter.EQUALS,
	        SimpleFilter.NOT_EQUAL,
	        SimpleFilter.STARTS_WITH,
	        SimpleFilter.ENDS_WITH
	    ];
	    TextFilter.DEFAULT_FORMATTER = function (from) { return from; };
	    TextFilter.DEFAULT_LOWERCASE_FORMATTER = function (from) { return from == null ? null : from.toString().toLowerCase(); };
	    TextFilter.DEFAULT_COMPARATOR = function (filter, value, filterText) {
	        switch (filter) {
	            case TextFilter.CONTAINS:
	                return value.indexOf(filterText) >= 0;
	            case TextFilter.NOT_CONTAINS:
	                return value.indexOf(filterText) < 0;
	            case TextFilter.EQUALS:
	                return value === filterText;
	            case TextFilter.NOT_EQUAL:
	                return value != filterText;
	            case TextFilter.STARTS_WITH:
	                return value.indexOf(filterText) === 0;
	            case TextFilter.ENDS_WITH:
	                var index = value.lastIndexOf(filterText);
	                return index >= 0 && index === (value.length - filterText.length);
	            default:
	                // should never happen
	                console.warn('AG Grid: Unexpected type of filter "' + filter + '", it looks like the filter was configured with incorrect Filter Options');
	                return false;
	        }
	    };
	    __decorate$w([
	        RefSelector('eValue1')
	    ], TextFilter.prototype, "eValue1", void 0);
	    __decorate$w([
	        RefSelector('eValue2')
	    ], TextFilter.prototype, "eValue2", void 0);
	    return TextFilter;
	}(SimpleFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$A = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$x = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TextInputFloatingFilter = /** @class */ (function (_super) {
	    __extends$A(TextInputFloatingFilter, _super);
	    function TextInputFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextInputFloatingFilter.prototype.postConstruct = function () {
	        this.setTemplate(/* html */ "\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eFloatingFilterInput\"></ag-input-text-field>\n            </div>");
	    };
	    TextInputFloatingFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    TextInputFloatingFilter.prototype.onParentModelChanged = function (model, event) {
	        if (this.isEventFromFloatingFilter(event)) {
	            // if the floating filter triggered the change, it is already in sync
	            return;
	        }
	        this.setLastTypeFromModel(model);
	        this.eFloatingFilterInput.setValue(this.getTextFromModel(model));
	        this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
	    };
	    TextInputFloatingFilter.prototype.init = function (params) {
	        _super.prototype.init.call(this, params);
	        this.params = params;
	        this.applyActive = ProvidedFilter.isUseApplyButton(this.params.filterParams);
	        var debounceMs = ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
	        var toDebounce = debounce(this.syncUpWithParentFilter.bind(this), debounceMs);
	        var filterGui = this.eFloatingFilterInput.getGui();
	        this.addManagedListener(filterGui, 'input', toDebounce);
	        this.addManagedListener(filterGui, 'keypress', toDebounce);
	        this.addManagedListener(filterGui, 'keydown', toDebounce);
	        var columnDef = params.column.getDefinition();
	        if (columnDef.filterParams &&
	            columnDef.filterParams.filterOptions &&
	            columnDef.filterParams.filterOptions.length === 1 &&
	            columnDef.filterParams.filterOptions[0] === 'inRange') {
	            this.eFloatingFilterInput.setDisabled(true);
	        }
	        var displayName = this.columnController.getDisplayNameForColumn(params.column, 'header', true);
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eFloatingFilterInput.setInputAriaLabel(displayName + " " + translate('ariaFilterInput', 'Filter Input'));
	    };
	    TextInputFloatingFilter.prototype.syncUpWithParentFilter = function (e) {
	        var _this = this;
	        var enterKeyPressed = isKeyPressed(e, KeyCode.ENTER);
	        if (this.applyActive && !enterKeyPressed) {
	            return;
	        }
	        var value = this.eFloatingFilterInput.getValue();
	        if (this.params.filterParams.trimInput) {
	            value = TextFilter.trimInput(value);
	            this.eFloatingFilterInput.setValue(value, true); // ensure visible value is trimmed
	        }
	        this.params.parentFilterInstance(function (filterInstance) {
	            if (filterInstance) {
	                var simpleFilter = filterInstance;
	                simpleFilter.onFloatingFilterChanged(_this.getLastType(), value);
	            }
	        });
	    };
	    TextInputFloatingFilter.prototype.setEditable = function (editable) {
	        this.eFloatingFilterInput.setDisabled(!editable);
	    };
	    __decorate$x([
	        Autowired('columnController')
	    ], TextInputFloatingFilter.prototype, "columnController", void 0);
	    __decorate$x([
	        RefSelector('eFloatingFilterInput')
	    ], TextInputFloatingFilter.prototype, "eFloatingFilterInput", void 0);
	    __decorate$x([
	        PostConstruct
	    ], TextInputFloatingFilter.prototype, "postConstruct", null);
	    return TextInputFloatingFilter;
	}(SimpleFloatingFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$B = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var NumberFloatingFilter = /** @class */ (function (_super) {
	    __extends$B(NumberFloatingFilter, _super);
	    function NumberFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NumberFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return NumberFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    NumberFloatingFilter.prototype.conditionToString = function (condition) {
	        var isRange = condition.type == SimpleFilter.IN_RANGE;
	        if (isRange) {
	            return condition.filter + "-" + condition.filterTo;
	        }
	        // cater for when the type doesn't need a value
	        if (condition.filter != null) {
	            return "" + condition.filter;
	        }
	        return "" + condition.type;
	    };
	    return NumberFloatingFilter;
	}(TextInputFloatingFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$C = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var TextFloatingFilter = /** @class */ (function (_super) {
	    __extends$C(TextFloatingFilter, _super);
	    function TextFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextFloatingFilter.prototype.conditionToString = function (condition) {
	        // it's not possible to have 'in range' for string, so no need to check for it.
	        // also cater for when the type doesn't need a value
	        if (condition.filter != null) {
	            return "" + condition.filter;
	        }
	        else {
	            return "" + condition.type;
	        }
	    };
	    TextFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return TextFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    return TextFloatingFilter;
	}(TextInputFloatingFilter));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$D = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$y = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var RegisteredComponentSource;
	(function (RegisteredComponentSource) {
	    RegisteredComponentSource[RegisteredComponentSource["DEFAULT"] = 0] = "DEFAULT";
	    RegisteredComponentSource[RegisteredComponentSource["REGISTERED"] = 1] = "REGISTERED";
	})(RegisteredComponentSource || (RegisteredComponentSource = {}));
	var UserComponentRegistry = /** @class */ (function (_super) {
	    __extends$D(UserComponentRegistry, _super);
	    function UserComponentRegistry() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.agGridDefaults = {
	            //date
	            agDateInput: DefaultDateComponent,
	            //header
	            agColumnHeader: HeaderComp,
	            agColumnGroupHeader: HeaderGroupComp,
	            //floating filters
	            agTextColumnFloatingFilter: TextFloatingFilter,
	            agNumberColumnFloatingFilter: NumberFloatingFilter,
	            agDateColumnFloatingFilter: DateFloatingFilter,
	            // renderers
	            agAnimateShowChangeCellRenderer: AnimateShowChangeCellRenderer,
	            agAnimateSlideCellRenderer: AnimateSlideCellRenderer,
	            agGroupCellRenderer: GroupCellRenderer,
	            agGroupRowRenderer: GroupCellRenderer,
	            agLoadingCellRenderer: LoadingCellRenderer,
	            //editors
	            agCellEditor: TextCellEditor,
	            agTextCellEditor: TextCellEditor,
	            agSelectCellEditor: SelectCellEditor,
	            agPopupTextCellEditor: PopupTextCellEditor,
	            agPopupSelectCellEditor: PopupSelectCellEditor,
	            agLargeTextCellEditor: LargeTextCellEditor,
	            //filter
	            agTextColumnFilter: TextFilter,
	            agNumberColumnFilter: NumberFilter,
	            agDateColumnFilter: DateFilter,
	            //overlays
	            agLoadingOverlay: LoadingOverlayComponent$1,
	            agNoRowsOverlay: NoRowsOverlayComponent$1,
	            // tooltips
	            agTooltipComponent: TooltipComponent$1
	        };
	        _this.agDeprecatedNames = {
	            set: {
	                newComponentName: 'agSetColumnFilter',
	                propertyHolder: 'filter'
	            },
	            text: {
	                newComponentName: 'agTextColumnFilter',
	                propertyHolder: 'filter'
	            },
	            number: {
	                newComponentName: 'agNumberColumnFilter',
	                propertyHolder: 'filter'
	            },
	            date: {
	                newComponentName: 'agDateColumnFilter',
	                propertyHolder: 'filter'
	            },
	            group: {
	                newComponentName: 'agGroupCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            animateShowChange: {
	                newComponentName: 'agAnimateShowChangeCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            animateSlide: {
	                newComponentName: 'agAnimateSlideCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            select: {
	                newComponentName: 'agSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            largeText: {
	                newComponentName: 'agLargeTextCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            popupSelect: {
	                newComponentName: 'agPopupSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            popupText: {
	                newComponentName: 'agPopupTextCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            richSelect: {
	                newComponentName: 'agRichSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            headerComponent: {
	                newComponentName: 'agColumnHeader',
	                propertyHolder: 'headerComponent'
	            }
	        };
	        _this.jsComponents = {};
	        _this.frameworkComponents = {};
	        return _this;
	    }
	    UserComponentRegistry.prototype.init = function () {
	        var _this = this;
	        if (this.gridOptions.components != null) {
	            iterateObject(this.gridOptions.components, function (key, component) { return _this.registerComponent(key, component); });
	        }
	        if (this.gridOptions.frameworkComponents != null) {
	            iterateObject(this.gridOptions.frameworkComponents, function (key, component) { return _this.registerFwComponent(key, component); });
	        }
	    };
	    UserComponentRegistry.prototype.registerDefaultComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.agGridDefaults[name]) {
	            console.error("Trying to overwrite a default component. You should call registerComponent");
	            return;
	        }
	        this.agGridDefaults[name] = component;
	    };
	    UserComponentRegistry.prototype.registerComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.frameworkComponents[name]) {
	            console.error("Trying to register a component that you have already registered for frameworks: " + name);
	            return;
	        }
	        this.jsComponents[name] = component;
	    };
	    /**
	     * B the business interface (ie IHeader)
	     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
	     */
	    UserComponentRegistry.prototype.registerFwComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.jsComponents[name]) {
	            console.error("Trying to register a component that you have already registered for plain javascript: " + name);
	            return;
	        }
	        this.frameworkComponents[name] = component;
	    };
	    /**
	     * B the business interface (ie IHeader)
	     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
	     */
	    UserComponentRegistry.prototype.retrieve = function (rawName) {
	        var name = this.translateIfDeprecated(rawName);
	        var frameworkComponent = this.frameworkComponents[name];
	        if (frameworkComponent) {
	            return {
	                componentFromFramework: true,
	                component: frameworkComponent,
	                source: RegisteredComponentSource.REGISTERED
	            };
	        }
	        var jsComponent = this.jsComponents[name];
	        if (jsComponent) {
	            return {
	                componentFromFramework: false,
	                component: jsComponent,
	                source: RegisteredComponentSource.REGISTERED
	            };
	        }
	        var defaultComponent = this.agGridDefaults[name];
	        if (defaultComponent) {
	            return {
	                componentFromFramework: false,
	                component: defaultComponent,
	                source: RegisteredComponentSource.DEFAULT
	            };
	        }
	        if (Object.keys(this.agGridDefaults).indexOf(name) < 0) {
	            console.warn("AG Grid: Looking for component [" + name + "] but it wasn't found.");
	        }
	        return null;
	    };
	    UserComponentRegistry.prototype.translateIfDeprecated = function (raw) {
	        var deprecatedInfo = this.agDeprecatedNames[raw];
	        if (deprecatedInfo != null) {
	            doOnce(function () {
	                console.warn("ag-grid. Since v15.0 component names have been renamed to be namespaced. You should rename " + deprecatedInfo.propertyHolder + ":" + raw + " to " + deprecatedInfo.propertyHolder + ":" + deprecatedInfo.newComponentName);
	            }, 'DEPRECATE_COMPONENT_' + raw);
	            return deprecatedInfo.newComponentName;
	        }
	        return raw;
	    };
	    __decorate$y([
	        Autowired('gridOptions')
	    ], UserComponentRegistry.prototype, "gridOptions", void 0);
	    __decorate$y([
	        PostConstruct
	    ], UserComponentRegistry.prototype, "init", null);
	    UserComponentRegistry = __decorate$y([
	        Bean('userComponentRegistry')
	    ], UserComponentRegistry);
	    return UserComponentRegistry;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var SideBarDefParser = /** @class */ (function () {
	    function SideBarDefParser() {
	    }
	    SideBarDefParser.parse = function (toParse) {
	        if (!toParse) {
	            return null;
	        }
	        if (toParse === true) {
	            return {
	                toolPanels: [
	                    SideBarDefParser.DEFAULT_COLUMN_COMP,
	                    SideBarDefParser.DEFAULT_FILTER_COMP,
	                ],
	                defaultToolPanel: 'columns'
	            };
	        }
	        if (typeof toParse === 'string') {
	            return SideBarDefParser.parse([toParse]);
	        }
	        if (Array.isArray(toParse)) {
	            var comps_1 = [];
	            toParse.forEach(function (key) {
	                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[key];
	                if (!lookupResult) {
	                    console.warn("ag-grid: the key " + key + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
	                    return;
	                }
	                comps_1.push(lookupResult);
	            });
	            if (comps_1.length === 0) {
	                return null;
	            }
	            return {
	                toolPanels: comps_1,
	                defaultToolPanel: comps_1[0].id
	            };
	        }
	        var result = {
	            toolPanels: SideBarDefParser.parseComponents(toParse.toolPanels),
	            defaultToolPanel: toParse.defaultToolPanel,
	            hiddenByDefault: toParse.hiddenByDefault,
	            position: toParse.position
	        };
	        return result;
	    };
	    SideBarDefParser.parseComponents = function (from) {
	        var result = [];
	        if (!from) {
	            return result;
	        }
	        from.forEach(function (it) {
	            var toAdd = null;
	            if (typeof it === 'string') {
	                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[it];
	                if (!lookupResult) {
	                    console.warn("ag-grid: the key " + it + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
	                    return;
	                }
	                toAdd = lookupResult;
	            }
	            else {
	                toAdd = it;
	            }
	            result.push(toAdd);
	        });
	        return result;
	    };
	    SideBarDefParser.DEFAULT_COLUMN_COMP = {
	        id: 'columns',
	        labelDefault: 'Columns',
	        labelKey: 'columns',
	        iconKey: 'columns',
	        toolPanel: 'agColumnsToolPanel',
	    };
	    SideBarDefParser.DEFAULT_FILTER_COMP = {
	        id: 'filters',
	        labelDefault: 'Filters',
	        labelKey: 'filters',
	        iconKey: 'filter',
	        toolPanel: 'agFiltersToolPanel',
	    };
	    SideBarDefParser.DEFAULT_BY_KEY = {
	        columns: SideBarDefParser.DEFAULT_COLUMN_COMP,
	        filters: SideBarDefParser.DEFAULT_FILTER_COMP
	    };
	    return SideBarDefParser;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$z = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$3 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var __spreadArrays$3 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var DEFAULT_ROW_HEIGHT = 25;
	var DEFAULT_DETAIL_ROW_HEIGHT = 300;
	var DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE = 5;
	var DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE = 5;
	var DEFAULT_KEEP_DETAIL_ROW_COUNT = 10;
	function isTrue(value) {
	    return value === true || value === 'true';
	}
	function toNumber(value) {
	    if (typeof value == 'number') {
	        return value;
	    }
	    if (typeof value == 'string') {
	        return parseInt(value, 10);
	    }
	}
	function zeroOrGreater(value, defaultValue) {
	    if (value >= 0) {
	        return value;
	    }
	    // zero gets returned if number is missing or the wrong type
	    return defaultValue;
	}
	function oneOrGreater(value, defaultValue) {
	    var valueNumber = parseInt(value, 10);
	    if (isNumeric(valueNumber) && valueNumber > 0) {
	        return valueNumber;
	    }
	    return defaultValue;
	}
	var GridOptionsWrapper = /** @class */ (function () {
	    function GridOptionsWrapper() {
	        this.propertyEventService = new EventService();
	        this.domDataKey = '__AG_' + Math.random().toString();
	        this.destroyed = false;
	    }
	    GridOptionsWrapper_1 = GridOptionsWrapper;
	    GridOptionsWrapper.prototype.agWire = function (gridApi, columnApi) {
	        this.gridOptions.api = gridApi;
	        this.gridOptions.columnApi = columnApi;
	        this.checkForDeprecated();
	        this.checkForViolations();
	    };
	    GridOptionsWrapper.prototype.destroy = function () {
	        // need to remove these, as we don't own the lifecycle of the gridOptions, we need to
	        // remove the references in case the user keeps the grid options, we want the rest
	        // of the grid to be picked up by the garbage collector
	        this.gridOptions.api = null;
	        this.gridOptions.columnApi = null;
	        this.removeEventListener(GridOptionsWrapper_1.PROP_DOM_LAYOUT, this.updateLayoutClassesListener);
	        this.destroyed = true;
	    };
	    GridOptionsWrapper.prototype.init = function () {
	        var _this = this;
	        if (this.gridOptions.suppressPropertyNamesCheck !== true) {
	            this.checkGridOptionsProperties();
	            this.checkColumnDefProperties();
	        }
	        // parse side bar options into correct format
	        if (this.gridOptions.sideBar != null) {
	            this.gridOptions.sideBar = SideBarDefParser.parse(this.gridOptions.sideBar);
	        }
	        var async = this.useAsyncEvents();
	        this.eventService.addGlobalListener(this.globalEventHandler.bind(this), async);
	        if (this.isGroupSelectsChildren() && this.isSuppressParentsInRowNodes()) {
	            console.warn("AG Grid: 'groupSelectsChildren' does not work with 'suppressParentsInRowNodes', this selection method needs the part in rowNode to work");
	        }
	        if (this.isGroupSelectsChildren()) {
	            if (!this.isRowSelectionMulti()) {
	                console.warn("AG Grid: rowSelection must be 'multiple' for groupSelectsChildren to make sense");
	            }
	            if (this.isRowModelServerSide()) {
	                console.warn('AG Grid: group selects children is NOT support for Server Side Row Model. ' +
	                    'This is because the rows are lazy loaded, so selecting a group is not possible as' +
	                    'the grid has no way of knowing what the children are.');
	            }
	        }
	        if (this.isGroupRemoveSingleChildren() && this.isGroupHideOpenParents()) {
	            console.warn("AG Grid: groupRemoveSingleChildren and groupHideOpenParents do not work with each other, you need to pick one. And don't ask us how to us these together on our support forum either you will get the same answer!");
	        }
	        if (this.isRowModelServerSide()) {
	            var msg = function (prop) { return "AG Grid: '" + prop + "' is not supported on the Server-Side Row Model"; };
	            if (exists(this.gridOptions.groupDefaultExpanded)) {
	                console.warn(msg('groupDefaultExpanded'));
	            }
	            if (exists(this.gridOptions.groupDefaultExpanded)) {
	                console.warn(msg('groupIncludeFooter'));
	            }
	            if (exists(this.gridOptions.groupDefaultExpanded)) {
	                console.warn(msg('groupIncludeTotalFooter'));
	            }
	        }
	        if (this.isEnableRangeSelection()) {
	            ModuleRegistry.assertRegistered(exports.ModuleNames.RangeSelectionModule, 'enableRangeSelection');
	        }
	        if (!this.isEnableRangeSelection() && (this.isEnableRangeHandle() || this.isEnableFillHandle())) {
	            console.warn("AG Grid: 'enableRangeHandle' and 'enableFillHandle' will not work unless 'enableRangeSelection' is set to true");
	        }
	        var warnOfDeprecaredIcon = function (name) {
	            if (_this.gridOptions.icons && _this.gridOptions.icons[name]) {
	                console.warn("gridOptions.icons." + name + " is no longer supported. For information on how to style checkboxes and radio buttons, see https://www.ag-grid.com/javascript-grid-icons/");
	            }
	        };
	        warnOfDeprecaredIcon('radioButtonOff');
	        warnOfDeprecaredIcon('radioButtonOn');
	        warnOfDeprecaredIcon('checkboxChecked');
	        warnOfDeprecaredIcon('checkboxUnchecked');
	        warnOfDeprecaredIcon('checkboxIndeterminate');
	        // sets an initial calculation for the scrollbar width
	        this.getScrollbarWidth();
	    };
	    GridOptionsWrapper.prototype.checkColumnDefProperties = function () {
	        var _this = this;
	        if (this.gridOptions.columnDefs == null) {
	            return;
	        }
	        this.gridOptions.columnDefs.forEach(function (colDef) {
	            var userProperties = Object.getOwnPropertyNames(colDef);
	            var validProperties = __spreadArrays$3(ColDefUtil.ALL_PROPERTIES, ColDefUtil.FRAMEWORK_PROPERTIES);
	            _this.checkProperties(userProperties, validProperties, validProperties, 'colDef', 'https://www.ag-grid.com/javascript-grid-column-properties/');
	        });
	    };
	    GridOptionsWrapper.prototype.checkGridOptionsProperties = function () {
	        var userProperties = Object.getOwnPropertyNames(this.gridOptions);
	        var validProperties = __spreadArrays$3(PropertyKeys.ALL_PROPERTIES, PropertyKeys.FRAMEWORK_PROPERTIES, values(Events).map(function (event) { return ComponentUtil.getCallbackForEvent(event); }));
	        var validPropertiesAndExceptions = __spreadArrays$3(validProperties, ['api', 'columnApi']);
	        this.checkProperties(userProperties, validPropertiesAndExceptions, validProperties, 'gridOptions', 'https://www.ag-grid.com/javascript-grid-properties/');
	    };
	    GridOptionsWrapper.prototype.checkProperties = function (userProperties, validPropertiesAndExceptions, validProperties, containerName, docsUrl) {
	        var invalidProperties = fuzzyCheckStrings(userProperties, validPropertiesAndExceptions, validProperties);
	        iterateObject(invalidProperties, function (key, value) {
	            console.warn("ag-grid: invalid " + containerName + " property '" + key + "' did you mean any of these: " + value.slice(0, 8).join(", "));
	        });
	        if (Object.keys(invalidProperties).length > 0) {
	            console.warn("ag-grid: to see all the valid " + containerName + " properties please check: " + docsUrl);
	        }
	    };
	    GridOptionsWrapper.prototype.getDomDataKey = function () {
	        return this.domDataKey;
	    };
	    // returns the dom data, or undefined if not found
	    GridOptionsWrapper.prototype.getDomData = function (element, key) {
	        var domData = element[this.getDomDataKey()];
	        return domData ? domData[key] : undefined;
	    };
	    GridOptionsWrapper.prototype.setDomData = function (element, key, value) {
	        var domDataKey = this.getDomDataKey();
	        var domData = element[domDataKey];
	        if (missing(domData)) {
	            domData = {};
	            element[domDataKey] = domData;
	        }
	        domData[key] = value;
	    };
	    GridOptionsWrapper.prototype.isRowSelection = function () {
	        return this.gridOptions.rowSelection === 'single' || this.gridOptions.rowSelection === 'multiple';
	    };
	    GridOptionsWrapper.prototype.isSuppressRowDeselection = function () {
	        return isTrue(this.gridOptions.suppressRowDeselection);
	    };
	    GridOptionsWrapper.prototype.isRowSelectionMulti = function () {
	        return this.gridOptions.rowSelection === 'multiple';
	    };
	    GridOptionsWrapper.prototype.isRowMultiSelectWithClick = function () {
	        return isTrue(this.gridOptions.rowMultiSelectWithClick);
	    };
	    GridOptionsWrapper.prototype.getContext = function () {
	        return this.gridOptions.context;
	    };
	    GridOptionsWrapper.prototype.isPivotMode = function () {
	        return isTrue(this.gridOptions.pivotMode);
	    };
	    GridOptionsWrapper.prototype.isSuppressExpandablePivotGroups = function () {
	        return isTrue(this.gridOptions.suppressExpandablePivotGroups);
	    };
	    GridOptionsWrapper.prototype.getPivotColumnGroupTotals = function () {
	        return this.gridOptions.pivotColumnGroupTotals;
	    };
	    GridOptionsWrapper.prototype.getPivotRowTotals = function () {
	        return this.gridOptions.pivotRowTotals;
	    };
	    GridOptionsWrapper.prototype.isRowModelInfinite = function () {
	        return this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_INFINITE;
	    };
	    GridOptionsWrapper.prototype.isRowModelViewport = function () {
	        return this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_VIEWPORT;
	    };
	    GridOptionsWrapper.prototype.isRowModelServerSide = function () {
	        return this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_SERVER_SIDE;
	    };
	    GridOptionsWrapper.prototype.isRowModelDefault = function () {
	        return (missing(this.gridOptions.rowModelType) ||
	            this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE);
	    };
	    GridOptionsWrapper.prototype.isFullRowEdit = function () {
	        return this.gridOptions.editType === 'fullRow';
	    };
	    GridOptionsWrapper.prototype.isSuppressFocusAfterRefresh = function () {
	        return isTrue(this.gridOptions.suppressFocusAfterRefresh);
	    };
	    GridOptionsWrapper.prototype.isSuppressBrowserResizeObserver = function () {
	        return isTrue(this.gridOptions.suppressBrowserResizeObserver);
	    };
	    GridOptionsWrapper.prototype.isSuppressMaintainUnsortedOrder = function () {
	        return isTrue(this.gridOptions.suppressMaintainUnsortedOrder);
	    };
	    GridOptionsWrapper.prototype.isSuppressClearOnFillReduction = function () {
	        return isTrue(this.gridOptions.suppressClearOnFillReduction);
	    };
	    GridOptionsWrapper.prototype.isShowToolPanel = function () {
	        return isTrue(this.gridOptions.sideBar && Array.isArray(this.getSideBar().toolPanels));
	    };
	    GridOptionsWrapper.prototype.getSideBar = function () {
	        return this.gridOptions.sideBar;
	    };
	    GridOptionsWrapper.prototype.isSuppressTouch = function () {
	        return isTrue(this.gridOptions.suppressTouch);
	    };
	    GridOptionsWrapper.prototype.isApplyColumnDefOrder = function () {
	        return isTrue(this.gridOptions.applyColumnDefOrder);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowTransform = function () {
	        return isTrue(this.gridOptions.suppressRowTransform);
	    };
	    GridOptionsWrapper.prototype.isSuppressColumnStateEvents = function () {
	        return isTrue(this.gridOptions.suppressColumnStateEvents);
	    };
	    GridOptionsWrapper.prototype.isAllowDragFromColumnsToolPanel = function () {
	        return isTrue(this.gridOptions.allowDragFromColumnsToolPanel);
	    };
	    GridOptionsWrapper.prototype.useAsyncEvents = function () {
	        return !isTrue(this.gridOptions.suppressAsyncEvents);
	    };
	    GridOptionsWrapper.prototype.isEnableCellChangeFlash = function () {
	        return isTrue(this.gridOptions.enableCellChangeFlash);
	    };
	    GridOptionsWrapper.prototype.getCellFlashDelay = function () {
	        return this.gridOptions.cellFlashDelay || 500;
	    };
	    GridOptionsWrapper.prototype.getCellFadeDelay = function () {
	        return this.gridOptions.cellFadeDelay || 1000;
	    };
	    GridOptionsWrapper.prototype.isGroupSelectsChildren = function () {
	        var result = isTrue(this.gridOptions.groupSelectsChildren);
	        if (result && this.isTreeData()) {
	            console.warn('AG Grid: groupSelectsChildren does not work with tree data');
	            return false;
	        }
	        return result;
	    };
	    GridOptionsWrapper.prototype.isSuppressRowHoverHighlight = function () {
	        return isTrue(this.gridOptions.suppressRowHoverHighlight);
	    };
	    GridOptionsWrapper.prototype.isGroupSelectsFiltered = function () {
	        return isTrue(this.gridOptions.groupSelectsFiltered);
	    };
	    GridOptionsWrapper.prototype.isGroupHideOpenParents = function () {
	        return isTrue(this.gridOptions.groupHideOpenParents);
	    };
	    // if we are doing hideOpenParents, then we always have groupMultiAutoColumn, otherwise hideOpenParents would not work
	    GridOptionsWrapper.prototype.isGroupMultiAutoColumn = function () {
	        return isTrue(this.gridOptions.groupMultiAutoColumn) || isTrue(this.gridOptions.groupHideOpenParents);
	    };
	    GridOptionsWrapper.prototype.isGroupRemoveSingleChildren = function () {
	        return isTrue(this.gridOptions.groupRemoveSingleChildren);
	    };
	    GridOptionsWrapper.prototype.isGroupRemoveLowestSingleChildren = function () {
	        return isTrue(this.gridOptions.groupRemoveLowestSingleChildren);
	    };
	    GridOptionsWrapper.prototype.isGroupIncludeFooter = function () {
	        return isTrue(this.gridOptions.groupIncludeFooter);
	    };
	    GridOptionsWrapper.prototype.isGroupIncludeTotalFooter = function () {
	        return isTrue(this.gridOptions.groupIncludeTotalFooter);
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressBlankHeader = function () {
	        return isTrue(this.gridOptions.groupSuppressBlankHeader);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowClickSelection = function () {
	        return isTrue(this.gridOptions.suppressRowClickSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressCellSelection = function () {
	        return isTrue(this.gridOptions.suppressCellSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressMultiSort = function () {
	        return isTrue(this.gridOptions.suppressMultiSort);
	    };
	    GridOptionsWrapper.prototype.isMultiSortKeyCtrl = function () {
	        return this.gridOptions.multiSortKey === 'ctrl';
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressAutoColumn = function () {
	        return isTrue(this.gridOptions.groupSuppressAutoColumn);
	    };
	    GridOptionsWrapper.prototype.isPivotSuppressAutoColumn = function () {
	        return isTrue(this.gridOptions.pivotSuppressAutoColumn);
	    };
	    GridOptionsWrapper.prototype.isSuppressDragLeaveHidesColumns = function () {
	        return isTrue(this.gridOptions.suppressDragLeaveHidesColumns);
	    };
	    GridOptionsWrapper.prototype.isSuppressScrollOnNewData = function () {
	        return isTrue(this.gridOptions.suppressScrollOnNewData);
	    };
	    GridOptionsWrapper.prototype.isRowDragManaged = function () {
	        return isTrue(this.gridOptions.rowDragManaged);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowDrag = function () {
	        return isTrue(this.gridOptions.suppressRowDrag);
	    };
	    GridOptionsWrapper.prototype.isSuppressMoveWhenRowDragging = function () {
	        return isTrue(this.gridOptions.suppressMoveWhenRowDragging);
	    };
	    GridOptionsWrapper.prototype.isEnableMultiRowDragging = function () {
	        return isTrue(this.gridOptions.enableMultiRowDragging);
	    };
	    // returns either 'print', 'autoHeight' or 'normal' (normal is the default)
	    GridOptionsWrapper.prototype.getDomLayout = function () {
	        var domLayout = this.gridOptions.domLayout || Constants.DOM_LAYOUT_NORMAL;
	        var validLayouts = [
	            Constants.DOM_LAYOUT_PRINT,
	            Constants.DOM_LAYOUT_AUTO_HEIGHT,
	            Constants.DOM_LAYOUT_NORMAL
	        ];
	        if (validLayouts.indexOf(domLayout) === -1) {
	            doOnce(function () {
	                return console.warn("AG Grid: " + domLayout + " is not valid for DOM Layout, valid values are " + Constants.DOM_LAYOUT_NORMAL + ", " + Constants.DOM_LAYOUT_AUTO_HEIGHT + " and " + Constants.DOM_LAYOUT_PRINT);
	            }, 'warn about dom layout values');
	            return Constants.DOM_LAYOUT_NORMAL;
	        }
	        return domLayout;
	    };
	    GridOptionsWrapper.prototype.isSuppressHorizontalScroll = function () {
	        return isTrue(this.gridOptions.suppressHorizontalScroll);
	    };
	    GridOptionsWrapper.prototype.isSuppressMaxRenderedRowRestriction = function () {
	        return isTrue(this.gridOptions.suppressMaxRenderedRowRestriction);
	    };
	    GridOptionsWrapper.prototype.isExcludeChildrenWhenTreeDataFiltering = function () {
	        return isTrue(this.gridOptions.excludeChildrenWhenTreeDataFiltering);
	    };
	    GridOptionsWrapper.prototype.isAlwaysShowHorizontalScroll = function () {
	        return isTrue(this.gridOptions.alwaysShowHorizontalScroll);
	    };
	    GridOptionsWrapper.prototype.isAlwaysShowVerticalScroll = function () {
	        return isTrue(this.gridOptions.alwaysShowVerticalScroll);
	    };
	    GridOptionsWrapper.prototype.isDebounceVerticalScrollbar = function () {
	        return isTrue(this.gridOptions.debounceVerticalScrollbar);
	    };
	    GridOptionsWrapper.prototype.isSuppressLoadingOverlay = function () {
	        return isTrue(this.gridOptions.suppressLoadingOverlay);
	    };
	    GridOptionsWrapper.prototype.isSuppressNoRowsOverlay = function () {
	        return isTrue(this.gridOptions.suppressNoRowsOverlay);
	    };
	    GridOptionsWrapper.prototype.isSuppressFieldDotNotation = function () {
	        return isTrue(this.gridOptions.suppressFieldDotNotation);
	    };
	    GridOptionsWrapper.prototype.getPinnedTopRowData = function () {
	        return this.gridOptions.pinnedTopRowData;
	    };
	    GridOptionsWrapper.prototype.getPinnedBottomRowData = function () {
	        return this.gridOptions.pinnedBottomRowData;
	    };
	    GridOptionsWrapper.prototype.isFunctionsPassive = function () {
	        return isTrue(this.gridOptions.functionsPassive);
	    };
	    GridOptionsWrapper.prototype.isSuppressChangeDetection = function () {
	        return isTrue(this.gridOptions.suppressChangeDetection);
	    };
	    GridOptionsWrapper.prototype.isSuppressAnimationFrame = function () {
	        return isTrue(this.gridOptions.suppressAnimationFrame);
	    };
	    GridOptionsWrapper.prototype.getQuickFilterText = function () {
	        return this.gridOptions.quickFilterText;
	    };
	    GridOptionsWrapper.prototype.isCacheQuickFilter = function () {
	        return isTrue(this.gridOptions.cacheQuickFilter);
	    };
	    GridOptionsWrapper.prototype.isUnSortIcon = function () {
	        return isTrue(this.gridOptions.unSortIcon);
	    };
	    GridOptionsWrapper.prototype.isSuppressMenuHide = function () {
	        return isTrue(this.gridOptions.suppressMenuHide);
	    };
	    GridOptionsWrapper.prototype.isEnterMovesDownAfterEdit = function () {
	        return isTrue(this.gridOptions.enterMovesDownAfterEdit);
	    };
	    GridOptionsWrapper.prototype.isEnterMovesDown = function () {
	        return isTrue(this.gridOptions.enterMovesDown);
	    };
	    GridOptionsWrapper.prototype.isUndoRedoCellEditing = function () {
	        return isTrue(this.gridOptions.undoRedoCellEditing);
	    };
	    GridOptionsWrapper.prototype.getUndoRedoCellEditingLimit = function () {
	        return this.gridOptions.undoRedoCellEditingLimit;
	    };
	    GridOptionsWrapper.prototype.getRowStyle = function () {
	        return this.gridOptions.rowStyle;
	    };
	    GridOptionsWrapper.prototype.getRowClass = function () {
	        return this.gridOptions.rowClass;
	    };
	    GridOptionsWrapper.prototype.getRowStyleFunc = function () {
	        return this.gridOptions.getRowStyle;
	    };
	    GridOptionsWrapper.prototype.getRowClassFunc = function () {
	        return this.gridOptions.getRowClass;
	    };
	    GridOptionsWrapper.prototype.rowClassRules = function () {
	        return this.gridOptions.rowClassRules;
	    };
	    GridOptionsWrapper.prototype.getServerSideStoreType = function () {
	        return this.gridOptions.serverSideStoreType;
	    };
	    GridOptionsWrapper.prototype.getServerSideStoreParamsFunc = function () {
	        return this.gridOptions.getServerSideStoreParams;
	    };
	    GridOptionsWrapper.prototype.getCreateChartContainerFunc = function () {
	        return this.gridOptions.createChartContainer;
	    };
	    GridOptionsWrapper.prototype.getPopupParent = function () {
	        return this.gridOptions.popupParent;
	    };
	    GridOptionsWrapper.prototype.getBlockLoadDebounceMillis = function () {
	        return this.gridOptions.blockLoadDebounceMillis;
	    };
	    GridOptionsWrapper.prototype.getPostProcessPopupFunc = function () {
	        return this.gridOptions.postProcessPopup;
	    };
	    GridOptionsWrapper.prototype.getPaginationNumberFormatterFunc = function () {
	        return this.gridOptions.paginationNumberFormatter;
	    };
	    GridOptionsWrapper.prototype.getChildCountFunc = function () {
	        return this.gridOptions.getChildCount;
	    };
	    GridOptionsWrapper.prototype.getIsApplyServerSideTransactionFunc = function () {
	        return this.gridOptions.isApplyServerSideTransaction;
	    };
	    GridOptionsWrapper.prototype.getDefaultGroupSortComparator = function () {
	        return this.gridOptions.defaultGroupSortComparator;
	    };
	    GridOptionsWrapper.prototype.getIsFullWidthCellFunc = function () {
	        return this.gridOptions.isFullWidthCell;
	    };
	    GridOptionsWrapper.prototype.getFullWidthCellRendererParams = function () {
	        return this.gridOptions.fullWidthCellRendererParams;
	    };
	    GridOptionsWrapper.prototype.isEmbedFullWidthRows = function () {
	        return isTrue(this.gridOptions.embedFullWidthRows) || isTrue(this.gridOptions.deprecatedEmbedFullWidthRows);
	    };
	    GridOptionsWrapper.prototype.isDetailRowAutoHeight = function () {
	        return isTrue(this.gridOptions.detailRowAutoHeight);
	    };
	    GridOptionsWrapper.prototype.getSuppressKeyboardEventFunc = function () {
	        return this.gridOptions.suppressKeyboardEvent;
	    };
	    GridOptionsWrapper.prototype.getBusinessKeyForNodeFunc = function () {
	        return this.gridOptions.getBusinessKeyForNode;
	    };
	    GridOptionsWrapper.prototype.getApi = function () {
	        return this.gridOptions.api;
	    };
	    GridOptionsWrapper.prototype.getColumnApi = function () {
	        return this.gridOptions.columnApi;
	    };
	    GridOptionsWrapper.prototype.isImmutableData = function () {
	        return isTrue(this.gridOptions.immutableData);
	    };
	    GridOptionsWrapper.prototype.isEnsureDomOrder = function () {
	        return isTrue(this.gridOptions.ensureDomOrder);
	    };
	    GridOptionsWrapper.prototype.isEnableCharts = function () {
	        if (isTrue(this.gridOptions.enableCharts)) {
	            return ModuleRegistry.assertRegistered(exports.ModuleNames.GridChartsModule, 'enableCharts');
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.getColResizeDefault = function () {
	        return this.gridOptions.colResizeDefault;
	    };
	    GridOptionsWrapper.prototype.isSingleClickEdit = function () {
	        return isTrue(this.gridOptions.singleClickEdit);
	    };
	    GridOptionsWrapper.prototype.isSuppressClickEdit = function () {
	        return isTrue(this.gridOptions.suppressClickEdit);
	    };
	    GridOptionsWrapper.prototype.isStopEditingWhenCellsLoseFocus = function () {
	        return isTrue(this.gridOptions.stopEditingWhenCellsLoseFocus);
	    };
	    GridOptionsWrapper.prototype.getGroupDefaultExpanded = function () {
	        return this.gridOptions.groupDefaultExpanded;
	    };
	    GridOptionsWrapper.prototype.getMaxConcurrentDatasourceRequests = function () {
	        return this.gridOptions.maxConcurrentDatasourceRequests;
	    };
	    GridOptionsWrapper.prototype.getMaxBlocksInCache = function () {
	        return this.gridOptions.maxBlocksInCache;
	    };
	    GridOptionsWrapper.prototype.getCacheOverflowSize = function () {
	        return this.gridOptions.cacheOverflowSize;
	    };
	    GridOptionsWrapper.prototype.getPaginationPageSize = function () {
	        return toNumber(this.gridOptions.paginationPageSize);
	    };
	    GridOptionsWrapper.prototype.isPaginateChildRows = function () {
	        var shouldPaginate = this.isGroupRemoveSingleChildren() || this.isGroupRemoveLowestSingleChildren();
	        if (shouldPaginate) {
	            return true;
	        }
	        return isTrue(this.gridOptions.paginateChildRows);
	    };
	    GridOptionsWrapper.prototype.getCacheBlockSize = function () {
	        return oneOrGreater(this.gridOptions.cacheBlockSize);
	    };
	    GridOptionsWrapper.prototype.getInfiniteInitialRowCount = function () {
	        return this.gridOptions.infiniteInitialRowCount;
	    };
	    GridOptionsWrapper.prototype.isPurgeClosedRowNodes = function () {
	        return isTrue(this.gridOptions.purgeClosedRowNodes);
	    };
	    GridOptionsWrapper.prototype.isSuppressPaginationPanel = function () {
	        return isTrue(this.gridOptions.suppressPaginationPanel);
	    };
	    GridOptionsWrapper.prototype.getRowData = function () {
	        return this.gridOptions.rowData;
	    };
	    // this property is different - we never allow groupUseEntireRow if in pivot mode,
	    // as otherwise we don't see the pivot values.
	    GridOptionsWrapper.prototype.isGroupUseEntireRow = function (pivotMode) {
	        return pivotMode ? false : isTrue(this.gridOptions.groupUseEntireRow);
	    };
	    GridOptionsWrapper.prototype.isEnableRtl = function () {
	        return isTrue(this.gridOptions.enableRtl);
	    };
	    GridOptionsWrapper.prototype.getAutoGroupColumnDef = function () {
	        return this.gridOptions.autoGroupColumnDef;
	    };
	    GridOptionsWrapper.prototype.getRowGroupPanelShow = function () {
	        return this.gridOptions.rowGroupPanelShow;
	    };
	    GridOptionsWrapper.prototype.getPivotPanelShow = function () {
	        return this.gridOptions.pivotPanelShow;
	    };
	    GridOptionsWrapper.prototype.isAngularCompileRows = function () {
	        return isTrue(this.gridOptions.angularCompileRows);
	    };
	    GridOptionsWrapper.prototype.isAngularCompileFilters = function () {
	        return isTrue(this.gridOptions.angularCompileFilters);
	    };
	    GridOptionsWrapper.prototype.isDebug = function () {
	        return isTrue(this.gridOptions.debug);
	    };
	    GridOptionsWrapper.prototype.getColumnDefs = function () {
	        return this.gridOptions.columnDefs;
	    };
	    GridOptionsWrapper.prototype.getColumnTypes = function () {
	        return this.gridOptions.columnTypes;
	    };
	    GridOptionsWrapper.prototype.getDatasource = function () {
	        return this.gridOptions.datasource;
	    };
	    GridOptionsWrapper.prototype.getViewportDatasource = function () {
	        return this.gridOptions.viewportDatasource;
	    };
	    GridOptionsWrapper.prototype.getServerSideDatasource = function () {
	        return this.gridOptions.serverSideDatasource;
	    };
	    GridOptionsWrapper.prototype.isAccentedSort = function () {
	        return isTrue(this.gridOptions.accentedSort);
	    };
	    GridOptionsWrapper.prototype.isEnableBrowserTooltips = function () {
	        return isTrue(this.gridOptions.enableBrowserTooltips);
	    };
	    GridOptionsWrapper.prototype.isEnableCellExpressions = function () {
	        return isTrue(this.gridOptions.enableCellExpressions);
	    };
	    GridOptionsWrapper.prototype.isEnableGroupEdit = function () {
	        return isTrue(this.gridOptions.enableGroupEdit);
	    };
	    GridOptionsWrapper.prototype.isSuppressMiddleClickScrolls = function () {
	        return isTrue(this.gridOptions.suppressMiddleClickScrolls);
	    };
	    GridOptionsWrapper.prototype.isPreventDefaultOnContextMenu = function () {
	        return isTrue(this.gridOptions.preventDefaultOnContextMenu);
	    };
	    GridOptionsWrapper.prototype.isSuppressPreventDefaultOnMouseWheel = function () {
	        return isTrue(this.gridOptions.suppressPreventDefaultOnMouseWheel);
	    };
	    GridOptionsWrapper.prototype.isSuppressColumnVirtualisation = function () {
	        return isTrue(this.gridOptions.suppressColumnVirtualisation);
	    };
	    GridOptionsWrapper.prototype.isSuppressContextMenu = function () {
	        return isTrue(this.gridOptions.suppressContextMenu);
	    };
	    GridOptionsWrapper.prototype.isAllowContextMenuWithControlKey = function () {
	        return isTrue(this.gridOptions.allowContextMenuWithControlKey);
	    };
	    GridOptionsWrapper.prototype.isSuppressCopyRowsToClipboard = function () {
	        return isTrue(this.gridOptions.suppressCopyRowsToClipboard);
	    };
	    GridOptionsWrapper.prototype.isCopyHeadersToClipboard = function () {
	        return isTrue(this.gridOptions.copyHeadersToClipboard);
	    };
	    GridOptionsWrapper.prototype.isSuppressClipboardPaste = function () {
	        return isTrue(this.gridOptions.suppressClipboardPaste);
	    };
	    GridOptionsWrapper.prototype.isSuppressLastEmptyLineOnPaste = function () {
	        return isTrue(this.gridOptions.suppressLastEmptyLineOnPaste);
	    };
	    GridOptionsWrapper.prototype.isPagination = function () {
	        return isTrue(this.gridOptions.pagination);
	    };
	    GridOptionsWrapper.prototype.isSuppressEnterpriseResetOnNewColumns = function () {
	        return isTrue(this.gridOptions.suppressEnterpriseResetOnNewColumns);
	    };
	    GridOptionsWrapper.prototype.getProcessDataFromClipboardFunc = function () {
	        return this.gridOptions.processDataFromClipboard;
	    };
	    GridOptionsWrapper.prototype.getAsyncTransactionWaitMillis = function () {
	        return exists(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : Constants.BATCH_WAIT_MILLIS;
	    };
	    GridOptionsWrapper.prototype.isSuppressMovableColumns = function () {
	        return isTrue(this.gridOptions.suppressMovableColumns);
	    };
	    GridOptionsWrapper.prototype.isAnimateRows = function () {
	        // never allow animating if enforcing the row order
	        if (this.isEnsureDomOrder()) {
	            return false;
	        }
	        return isTrue(this.gridOptions.animateRows);
	    };
	    GridOptionsWrapper.prototype.isSuppressColumnMoveAnimation = function () {
	        return isTrue(this.gridOptions.suppressColumnMoveAnimation);
	    };
	    GridOptionsWrapper.prototype.isSuppressAggFuncInHeader = function () {
	        return isTrue(this.gridOptions.suppressAggFuncInHeader);
	    };
	    GridOptionsWrapper.prototype.isSuppressAggAtRootLevel = function () {
	        return isTrue(this.gridOptions.suppressAggAtRootLevel);
	    };
	    GridOptionsWrapper.prototype.isSuppressAggFilteredOnly = function () {
	        return isTrue(this.gridOptions.suppressAggFilteredOnly);
	    };
	    GridOptionsWrapper.prototype.isShowOpenedGroup = function () {
	        return isTrue(this.gridOptions.showOpenedGroup);
	    };
	    GridOptionsWrapper.prototype.isEnableRangeSelection = function () {
	        return ModuleRegistry.isRegistered(exports.ModuleNames.RangeSelectionModule) && isTrue(this.gridOptions.enableRangeSelection);
	    };
	    GridOptionsWrapper.prototype.isEnableRangeHandle = function () {
	        return isTrue(this.gridOptions.enableRangeHandle);
	    };
	    GridOptionsWrapper.prototype.isEnableFillHandle = function () {
	        return isTrue(this.gridOptions.enableFillHandle);
	    };
	    GridOptionsWrapper.prototype.getFillHandleDirection = function () {
	        var direction = this.gridOptions.fillHandleDirection;
	        if (!direction) {
	            return 'xy';
	        }
	        if (direction !== 'x' && direction !== 'y' && direction !== 'xy') {
	            doOnce(function () { return console.warn("AG Grid: valid values for fillHandleDirection are 'x', 'y' and 'xy'. Default to 'xy'."); }, 'warn invalid fill direction');
	            return 'xy';
	        }
	        return direction;
	    };
	    GridOptionsWrapper.prototype.getFillOperation = function () {
	        return this.gridOptions.fillOperation;
	    };
	    GridOptionsWrapper.prototype.isSuppressMultiRangeSelection = function () {
	        return isTrue(this.gridOptions.suppressMultiRangeSelection);
	    };
	    GridOptionsWrapper.prototype.isPaginationAutoPageSize = function () {
	        return isTrue(this.gridOptions.paginationAutoPageSize);
	    };
	    GridOptionsWrapper.prototype.isRememberGroupStateWhenNewData = function () {
	        return isTrue(this.gridOptions.rememberGroupStateWhenNewData);
	    };
	    GridOptionsWrapper.prototype.getIcons = function () {
	        return this.gridOptions.icons;
	    };
	    GridOptionsWrapper.prototype.getAggFuncs = function () {
	        return this.gridOptions.aggFuncs;
	    };
	    GridOptionsWrapper.prototype.getSortingOrder = function () {
	        return this.gridOptions.sortingOrder;
	    };
	    GridOptionsWrapper.prototype.getAlignedGrids = function () {
	        return this.gridOptions.alignedGrids;
	    };
	    GridOptionsWrapper.prototype.isMasterDetail = function () {
	        var masterDetail = isTrue(this.gridOptions.masterDetail);
	        if (masterDetail) {
	            return ModuleRegistry.assertRegistered(exports.ModuleNames.MasterDetailModule, 'masterDetail');
	        }
	        else {
	            return false;
	        }
	    };
	    GridOptionsWrapper.prototype.isKeepDetailRows = function () {
	        return isTrue(this.gridOptions.keepDetailRows);
	    };
	    GridOptionsWrapper.prototype.getKeepDetailRowsCount = function () {
	        var keepDetailRowsCount = this.gridOptions.keepDetailRowsCount;
	        if (exists(keepDetailRowsCount) && keepDetailRowsCount > 0) {
	            return this.gridOptions.keepDetailRowsCount;
	        }
	        return DEFAULT_KEEP_DETAIL_ROW_COUNT;
	    };
	    GridOptionsWrapper.prototype.getIsRowMasterFunc = function () {
	        return this.gridOptions.isRowMaster;
	    };
	    GridOptionsWrapper.prototype.getIsRowSelectableFunc = function () {
	        return this.gridOptions.isRowSelectable;
	    };
	    GridOptionsWrapper.prototype.getGroupRowRendererParams = function () {
	        return this.gridOptions.groupRowRendererParams;
	    };
	    GridOptionsWrapper.prototype.getOverlayLoadingTemplate = function () {
	        return this.gridOptions.overlayLoadingTemplate;
	    };
	    GridOptionsWrapper.prototype.getOverlayNoRowsTemplate = function () {
	        return this.gridOptions.overlayNoRowsTemplate;
	    };
	    GridOptionsWrapper.prototype.isSuppressAutoSize = function () {
	        return isTrue(this.gridOptions.suppressAutoSize);
	    };
	    GridOptionsWrapper.prototype.isEnableCellTextSelection = function () {
	        return isTrue(this.gridOptions.enableCellTextSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressParentsInRowNodes = function () {
	        return isTrue(this.gridOptions.suppressParentsInRowNodes);
	    };
	    GridOptionsWrapper.prototype.isSuppressClipboardApi = function () {
	        return isTrue(this.gridOptions.suppressClipboardApi);
	    };
	    GridOptionsWrapper.prototype.isFunctionsReadOnly = function () {
	        return isTrue(this.gridOptions.functionsReadOnly);
	    };
	    GridOptionsWrapper.prototype.isFloatingFilter = function () {
	        return this.gridOptions.floatingFilter;
	    };
	    GridOptionsWrapper.prototype.isEnableCellTextSelect = function () {
	        return isTrue(this.gridOptions.enableCellTextSelection);
	    };
	    GridOptionsWrapper.prototype.isEnableOldSetFilterModel = function () {
	        return isTrue(this.gridOptions.enableOldSetFilterModel);
	    };
	    GridOptionsWrapper.prototype.getDefaultColDef = function () {
	        return this.gridOptions.defaultColDef;
	    };
	    GridOptionsWrapper.prototype.getDefaultColGroupDef = function () {
	        return this.gridOptions.defaultColGroupDef;
	    };
	    GridOptionsWrapper.prototype.getDefaultExportParams = function (type) {
	        if (this.gridOptions.defaultExportParams) {
	            console.warn("AG Grid: Since v25.2 `defaultExportParams`  has been replaced by `default" + capitalise(type) + "ExportParams`'");
	            if (type === 'csv') {
	                return this.gridOptions.defaultExportParams;
	            }
	            return this.gridOptions.defaultExportParams;
	        }
	        if (type === 'csv' && this.gridOptions.defaultCsvExportParams) {
	            return this.gridOptions.defaultCsvExportParams;
	        }
	        if (type === 'excel' && this.gridOptions.defaultExcelExportParams) {
	            return this.gridOptions.defaultExcelExportParams;
	        }
	    };
	    GridOptionsWrapper.prototype.isSuppressCsvExport = function () {
	        return isTrue(this.gridOptions.suppressCsvExport);
	    };
	    GridOptionsWrapper.prototype.isAllowShowChangeAfterFilter = function () {
	        return isTrue(this.gridOptions.allowShowChangeAfterFilter);
	    };
	    GridOptionsWrapper.prototype.isSuppressExcelExport = function () {
	        return isTrue(this.gridOptions.suppressExcelExport);
	    };
	    GridOptionsWrapper.prototype.isSuppressMakeColumnVisibleAfterUnGroup = function () {
	        return isTrue(this.gridOptions.suppressMakeColumnVisibleAfterUnGroup);
	    };
	    GridOptionsWrapper.prototype.getDataPathFunc = function () {
	        return this.gridOptions.getDataPath;
	    };
	    GridOptionsWrapper.prototype.getIsServerSideGroupFunc = function () {
	        return this.gridOptions.isServerSideGroup;
	    };
	    GridOptionsWrapper.prototype.getIsServerSideGroupOpenByDefaultFunc = function () {
	        return this.gridOptions.isServerSideGroupOpenByDefault;
	    };
	    GridOptionsWrapper.prototype.getIsGroupOpenByDefaultFunc = function () {
	        return this.gridOptions.isGroupOpenByDefault;
	    };
	    GridOptionsWrapper.prototype.getServerSideGroupKeyFunc = function () {
	        return this.gridOptions.getServerSideGroupKey;
	    };
	    GridOptionsWrapper.prototype.getGroupRowAggNodesFunc = function () {
	        return this.gridOptions.groupRowAggNodes;
	    };
	    GridOptionsWrapper.prototype.getContextMenuItemsFunc = function () {
	        return this.gridOptions.getContextMenuItems;
	    };
	    GridOptionsWrapper.prototype.getMainMenuItemsFunc = function () {
	        return this.gridOptions.getMainMenuItems;
	    };
	    GridOptionsWrapper.prototype.getRowNodeIdFunc = function () {
	        return this.gridOptions.getRowNodeId;
	    };
	    GridOptionsWrapper.prototype.getNavigateToNextHeaderFunc = function () {
	        return this.gridOptions.navigateToNextHeader;
	    };
	    GridOptionsWrapper.prototype.getTabToNextHeaderFunc = function () {
	        return this.gridOptions.tabToNextHeader;
	    };
	    GridOptionsWrapper.prototype.getNavigateToNextCellFunc = function () {
	        return this.gridOptions.navigateToNextCell;
	    };
	    GridOptionsWrapper.prototype.getTabToNextCellFunc = function () {
	        return this.gridOptions.tabToNextCell;
	    };
	    GridOptionsWrapper.prototype.getGridTabIndex = function () {
	        return (this.gridOptions.tabIndex || 0).toString();
	    };
	    GridOptionsWrapper.prototype.isTreeData = function () {
	        var usingTreeData = isTrue(this.gridOptions.treeData);
	        if (usingTreeData) {
	            return ModuleRegistry.assertRegistered(exports.ModuleNames.RowGroupingModule, 'Tree Data');
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.isValueCache = function () {
	        return isTrue(this.gridOptions.valueCache);
	    };
	    GridOptionsWrapper.prototype.isValueCacheNeverExpires = function () {
	        return isTrue(this.gridOptions.valueCacheNeverExpires);
	    };
	    GridOptionsWrapper.prototype.isDeltaSort = function () {
	        return isTrue(this.gridOptions.deltaSort);
	    };
	    GridOptionsWrapper.prototype.isAggregateOnlyChangedColumns = function () {
	        return isTrue(this.gridOptions.aggregateOnlyChangedColumns);
	    };
	    GridOptionsWrapper.prototype.getProcessSecondaryColDefFunc = function () {
	        return this.gridOptions.processSecondaryColDef;
	    };
	    GridOptionsWrapper.prototype.getProcessSecondaryColGroupDefFunc = function () {
	        return this.gridOptions.processSecondaryColGroupDef;
	    };
	    GridOptionsWrapper.prototype.getSendToClipboardFunc = function () {
	        return this.gridOptions.sendToClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessRowPostCreateFunc = function () {
	        return this.gridOptions.processRowPostCreate;
	    };
	    GridOptionsWrapper.prototype.getProcessCellForClipboardFunc = function () {
	        return this.gridOptions.processCellForClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessHeaderForClipboardFunc = function () {
	        return this.gridOptions.processHeaderForClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessCellFromClipboardFunc = function () {
	        return this.gridOptions.processCellFromClipboard;
	    };
	    GridOptionsWrapper.prototype.getViewportRowModelPageSize = function () {
	        return oneOrGreater(this.gridOptions.viewportRowModelPageSize, DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE);
	    };
	    GridOptionsWrapper.prototype.getViewportRowModelBufferSize = function () {
	        return zeroOrGreater(this.gridOptions.viewportRowModelBufferSize, DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE);
	    };
	    GridOptionsWrapper.prototype.isServerSideSortingAlwaysResets = function () {
	        return isTrue(this.gridOptions.serverSideSortingAlwaysResets);
	    };
	    GridOptionsWrapper.prototype.isServerSideFilteringAlwaysResets = function () {
	        return isTrue(this.gridOptions.serverSideFilteringAlwaysResets);
	    };
	    GridOptionsWrapper.prototype.getPostSortFunc = function () {
	        return this.gridOptions.postSort;
	    };
	    GridOptionsWrapper.prototype.getChartToolbarItemsFunc = function () {
	        return this.gridOptions.getChartToolbarItems;
	    };
	    GridOptionsWrapper.prototype.getChartThemeOverrides = function () {
	        return this.gridOptions.chartThemeOverrides;
	    };
	    GridOptionsWrapper.prototype.getCustomChartThemes = function () {
	        return this.gridOptions.customChartThemes;
	    };
	    GridOptionsWrapper.prototype.getChartThemes = function () {
	        // return default themes if user hasn't supplied any
	        return this.gridOptions.chartThemes || ['ag-default', 'ag-material', 'ag-pastel', 'ag-vivid', 'ag-solar'];
	    };
	    GridOptionsWrapper.prototype.getProcessChartOptionsFunc = function () {
	        return this.gridOptions.processChartOptions;
	    };
	    GridOptionsWrapper.prototype.getClipboardDeliminator = function () {
	        return exists(this.gridOptions.clipboardDeliminator) ? this.gridOptions.clipboardDeliminator : '\t';
	    };
	    GridOptionsWrapper.prototype.setProperty = function (key, value, force) {
	        if (force === void 0) { force = false; }
	        var gridOptionsNoType = this.gridOptions;
	        var previousValue = gridOptionsNoType[key];
	        if (force || previousValue !== value) {
	            gridOptionsNoType[key] = value;
	            var event_1 = {
	                type: key,
	                currentValue: value,
	                previousValue: previousValue
	            };
	            this.propertyEventService.dispatchEvent(event_1);
	        }
	    };
	    GridOptionsWrapper.prototype.addEventListener = function (key, listener) {
	        this.propertyEventService.addEventListener(key, listener);
	    };
	    GridOptionsWrapper.prototype.removeEventListener = function (key, listener) {
	        this.propertyEventService.removeEventListener(key, listener);
	    };
	    GridOptionsWrapper.prototype.isSkipHeaderOnAutoSize = function () {
	        return !!this.gridOptions.skipHeaderOnAutoSize;
	    };
	    GridOptionsWrapper.prototype.getAutoSizePadding = function () {
	        var value = this.gridOptions.autoSizePadding;
	        return value != null && value >= 0 ? value : 20;
	    };
	    // properties
	    GridOptionsWrapper.prototype.getHeaderHeight = function () {
	        if (typeof this.gridOptions.headerHeight === 'number') {
	            return this.gridOptions.headerHeight;
	        }
	        return this.getFromTheme(25, 'headerHeight');
	    };
	    GridOptionsWrapper.prototype.getFloatingFiltersHeight = function () {
	        if (typeof this.gridOptions.floatingFiltersHeight === 'number') {
	            return this.gridOptions.floatingFiltersHeight;
	        }
	        return this.getFromTheme(25, 'headerHeight');
	    };
	    GridOptionsWrapper.prototype.getGroupHeaderHeight = function () {
	        if (typeof this.gridOptions.groupHeaderHeight === 'number') {
	            return this.gridOptions.groupHeaderHeight;
	        }
	        return this.getHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.getPivotHeaderHeight = function () {
	        if (typeof this.gridOptions.pivotHeaderHeight === 'number') {
	            return this.gridOptions.pivotHeaderHeight;
	        }
	        return this.getHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.getPivotGroupHeaderHeight = function () {
	        if (typeof this.gridOptions.pivotGroupHeaderHeight === 'number') {
	            return this.gridOptions.pivotGroupHeaderHeight;
	        }
	        return this.getGroupHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.isExternalFilterPresent = function () {
	        if (typeof this.gridOptions.isExternalFilterPresent === 'function') {
	            return this.gridOptions.isExternalFilterPresent();
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.doesExternalFilterPass = function (node) {
	        if (typeof this.gridOptions.doesExternalFilterPass === 'function') {
	            return this.gridOptions.doesExternalFilterPass(node);
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.getTooltipShowDelay = function () {
	        var tooltipShowDelay = this.gridOptions.tooltipShowDelay;
	        if (exists(tooltipShowDelay)) {
	            if (tooltipShowDelay < 0) {
	                console.warn('ag-grid: tooltipShowDelay should not be lower than 0');
	            }
	            return Math.max(200, tooltipShowDelay);
	        }
	        return null;
	    };
	    GridOptionsWrapper.prototype.isTooltipMouseTrack = function () {
	        return isTrue(this.gridOptions.tooltipMouseTrack);
	    };
	    GridOptionsWrapper.prototype.isSuppressModelUpdateAfterUpdateTransaction = function () {
	        return isTrue(this.gridOptions.suppressModelUpdateAfterUpdateTransaction);
	    };
	    GridOptionsWrapper.prototype.getDocument = function () {
	        // if user is providing document, we use the users one,
	        // otherwise we use the document on the global namespace.
	        var result = null;
	        if (this.gridOptions.getDocument && exists(this.gridOptions.getDocument)) {
	            result = this.gridOptions.getDocument();
	        }
	        if (result && exists(result)) {
	            return result;
	        }
	        return document;
	    };
	    GridOptionsWrapper.prototype.getMinColWidth = function () {
	        var minColWidth = this.gridOptions.minColWidth;
	        if (exists(minColWidth) && minColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH) {
	            return this.gridOptions.minColWidth;
	        }
	        var measuredMin = this.getFromTheme(null, 'headerCellMinWidth');
	        return exists(measuredMin) ? Math.max(measuredMin, GridOptionsWrapper_1.MIN_COL_WIDTH) : GridOptionsWrapper_1.MIN_COL_WIDTH;
	    };
	    GridOptionsWrapper.prototype.getMaxColWidth = function () {
	        if (this.gridOptions.maxColWidth && this.gridOptions.maxColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH) {
	            return this.gridOptions.maxColWidth;
	        }
	        return null;
	    };
	    GridOptionsWrapper.prototype.getColWidth = function () {
	        if (typeof this.gridOptions.colWidth !== 'number' || this.gridOptions.colWidth < GridOptionsWrapper_1.MIN_COL_WIDTH) {
	            return 200;
	        }
	        return this.gridOptions.colWidth;
	    };
	    GridOptionsWrapper.prototype.getRowBuffer = function () {
	        var rowBuffer = this.gridOptions.rowBuffer;
	        if (typeof rowBuffer === 'number') {
	            if (rowBuffer < 0) {
	                doOnce(function () { return console.warn("AG Grid: rowBuffer should not be negative"); }, 'warn rowBuffer negative');
	                this.gridOptions.rowBuffer = rowBuffer = 0;
	            }
	        }
	        else {
	            rowBuffer = Constants.ROW_BUFFER_SIZE;
	        }
	        return rowBuffer;
	    };
	    GridOptionsWrapper.prototype.getRowBufferInPixels = function () {
	        var rowsToBuffer = this.getRowBuffer();
	        var defaultRowHeight = this.getRowHeightAsNumber();
	        return rowsToBuffer * defaultRowHeight;
	    };
	    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
	    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
	    // allow the user to provide the scroll width before we work it out.
	    GridOptionsWrapper.prototype.getScrollbarWidth = function () {
	        if (this.scrollbarWidth == null) {
	            var useGridOptions = typeof this.gridOptions.scrollbarWidth === 'number' && this.gridOptions.scrollbarWidth >= 0;
	            var scrollbarWidth = useGridOptions ? this.gridOptions.scrollbarWidth : getScrollbarWidth();
	            if (scrollbarWidth != null) {
	                this.scrollbarWidth = scrollbarWidth;
	                this.eventService.dispatchEvent({
	                    type: Events.EVENT_SCROLLBAR_WIDTH_CHANGED
	                });
	            }
	        }
	        return this.scrollbarWidth;
	    };
	    GridOptionsWrapper.prototype.checkForDeprecated = function () {
	        // casting to generic object, so typescript compiles even though
	        // we are looking for attributes that don't exist
	        var options = this.gridOptions;
	        if (options.deprecatedEmbedFullWidthRows) {
	            console.warn("AG Grid: since v21.2, deprecatedEmbedFullWidthRows has been replaced with embedFullWidthRows.");
	        }
	        if (options.enableOldSetFilterModel) {
	            console.warn('AG Grid: since v22.x, enableOldSetFilterModel is deprecated. Please move to the new Set Filter Model as the old one may not be supported in v23 onwards.');
	        }
	        if (options.floatingFilter) {
	            console.warn('AG Grid: since v23.1, floatingFilter on the gridOptions is deprecated. Please use floatingFilter on the colDef instead.');
	            if (!options.defaultColDef) {
	                options.defaultColDef = {};
	            }
	            if (options.defaultColDef.floatingFilter == null) {
	                options.defaultColDef.floatingFilter = true;
	            }
	        }
	        if (options.rowDeselection) {
	            console.warn('AG Grid: since v24.x, rowDeselection is deprecated and the behaviour is true by default. Please use `suppressRowDeselection` to prevent rows from being deselected.');
	        }
	        var checkRenamedProperty = function (oldProp, newProp, version) {
	            if (options[oldProp] != null) {
	                console.warn("ag-grid: since version " + version + ", '" + oldProp + "' is deprecated / renamed, please use the new property name '" + newProp + "' instead.");
	                if (options[newProp] == null) {
	                    options[newProp] = options[oldProp];
	                }
	            }
	        };
	        checkRenamedProperty('batchUpdateWaitMillis', 'asyncTransactionWaitMillis', '23.1.x');
	        checkRenamedProperty('deltaRowDataMode', 'immutableData', '23.1.x');
	        if (options.immutableColumns || options.deltaColumnMode) {
	            console.warn('AG Grid: since v24.0, immutableColumns and deltaColumnMode properties are gone. The grid now works like this as default. To keep column order maintained, set grid property applyColumnDefOrder=true');
	        }
	        checkRenamedProperty('suppressSetColumnStateEvents', 'suppressColumnStateEvents', '24.0.x');
	        if (options.groupRowInnerRenderer || options.groupRowInnerRendererParams || options.groupRowInnerRendererFramework) {
	            console.warn('AG Grid: since v24.0, grid properties groupRowInnerRenderer, groupRowInnerRendererFramework and groupRowInnerRendererParams are no longer used.');
	            console.warn('  Instead use the grid properties groupRowRendererParams.innerRenderer, groupRowRendererParams.innerRendererFramework and groupRowRendererParams.innerRendererParams.');
	            console.warn('  For example instead of this:');
	            console.warn('    groupRowInnerRenderer: "myRenderer"');
	            console.warn('    groupRowInnerRendererParams: {x: a}');
	            console.warn('  Replace with this:');
	            console.warn('    groupRowRendererParams: {');
	            console.warn('      innerRenderer: "myRenderer",');
	            console.warn('      innerRendererParams: {x: a}');
	            console.warn('    }');
	            console.warn('  We have copied the properties over for you. However to stop this error message, please change your application code.');
	            if (!options.groupRowRendererParams) {
	                options.groupRowRendererParams = {};
	            }
	            var params = options.groupRowRendererParams;
	            if (options.groupRowInnerRenderer) {
	                params.innerRenderer = options.groupRowInnerRenderer;
	            }
	            if (options.groupRowInnerRendererParams) {
	                params.innerRendererParams = options.groupRowInnerRendererParams;
	            }
	            if (options.groupRowInnerRendererFramework) {
	                params.innerRendererFramework = options.groupRowInnerRendererFramework;
	            }
	        }
	        if (options.rememberGroupStateWhenNewData) {
	            console.warn('AG Grid: since v24.0, grid property rememberGroupStateWhenNewData is deprecated. This feature was provided before Transaction Updates worked (which keep group state). Now that transaction updates are possible and they keep group state, this feature is no longer needed.');
	        }
	        if (options.detailCellRendererParams && options.detailCellRendererParams.autoHeight) {
	            console.warn('AG Grid: since v24.1, grid property detailCellRendererParams.autoHeight is replaced with grid property detailRowAutoHeight. This allows this feature to work when you provide a custom DetailCellRenderer');
	            options.detailRowAutoHeight = true;
	        }
	        if (options.suppressKeyboardEvent) {
	            console.warn("AG Grid: since v24.1 suppressKeyboardEvent in the gridOptions has been deprecated and will be removed in\n                 future versions of AG Grid. If you need this to be set for every column use the defaultColDef property.");
	        }
	        if (options.suppressEnterpriseResetOnNewColumns) {
	            console.warn('AG Grid: since v25, grid property suppressEnterpriseResetOnNewColumns is deprecated. This was a temporary property to allow changing columns in Server Side Row Model without triggering a reload. Now that it is possible to dynamically change columns in the grid, this is no longer needed.');
	            options.detailRowAutoHeight = true;
	        }
	        if (options.suppressColumnStateEvents) {
	            console.warn('AG Grid: since v25, grid property suppressColumnStateEvents no longer works due to a refactor that we did. It should be possible to achieve similar using event.source, which would be "api" if the event was due to setting column state via the API');
	            options.detailRowAutoHeight = true;
	        }
	        if (options.defaultExportParams) {
	            console.warn('AG Grid: since v25.2, the grid property `defaultExportParams` has been replaced by `defaultCsvExportParams` and `defaultExcelExportParams`.');
	        }
	        if (options.stopEditingWhenGridLosesFocus) {
	            console.warn('AG Grid: since v25.2.2, the grid property `stopEditingWhenGridLosesFocus`.');
	            options.stopEditingWhenCellsLoseFocus = true;
	        }
	    };
	    GridOptionsWrapper.prototype.checkForViolations = function () {
	        if (this.isTreeData()) {
	            this.treeDataViolations();
	        }
	    };
	    GridOptionsWrapper.prototype.treeDataViolations = function () {
	        if (this.isRowModelDefault()) {
	            if (missing(this.getDataPathFunc())) {
	                console.warn('AG Grid: property usingTreeData=true with rowModel=clientSide, but you did not ' +
	                    'provide getDataPath function, please provide getDataPath function if using tree data.');
	            }
	        }
	        if (this.isRowModelServerSide()) {
	            if (missing(this.getIsServerSideGroupFunc())) {
	                console.warn('AG Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' +
	                    'provide isServerSideGroup function, please provide isServerSideGroup function if using tree data.');
	            }
	            if (missing(this.getServerSideGroupKeyFunc())) {
	                console.warn('AG Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' +
	                    'provide getServerSideGroupKey function, please provide getServerSideGroupKey function if using tree data.');
	            }
	        }
	    };
	    GridOptionsWrapper.prototype.getLocaleTextFunc = function () {
	        if (this.gridOptions.localeTextFunc) {
	            return this.gridOptions.localeTextFunc;
	        }
	        var localeText = this.gridOptions.localeText;
	        return function (key, defaultValue) {
	            return localeText && localeText[key] ? localeText[key] : defaultValue;
	        };
	    };
	    // responsible for calling the onXXX functions on gridOptions
	    GridOptionsWrapper.prototype.globalEventHandler = function (eventName, event) {
	        // prevent events from being fired _after_ the grid has been destroyed
	        if (this.destroyed) {
	            return;
	        }
	        var callbackMethodName = ComponentUtil.getCallbackForEvent(eventName);
	        if (typeof this.gridOptions[callbackMethodName] === 'function') {
	            this.gridOptions[callbackMethodName](event);
	        }
	    };
	    // we don't allow dynamic row height for virtual paging
	    GridOptionsWrapper.prototype.getRowHeightAsNumber = function () {
	        if (!this.gridOptions.rowHeight || missing(this.gridOptions.rowHeight)) {
	            return this.getDefaultRowHeight();
	        }
	        if (this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight)) {
	            return this.gridOptions.rowHeight;
	        }
	        console.warn('AG Grid row height must be a number if not using standard row model');
	        return this.getDefaultRowHeight();
	    };
	    GridOptionsWrapper.prototype.getRowHeightForNode = function (rowNode, allowEstimate) {
	        // check the function first, in case use set both function and
	        // number, when using virtual pagination then function can be
	        // used for pinned rows and the number for the body rows.
	        if (allowEstimate === void 0) { allowEstimate = false; }
	        if (typeof this.gridOptions.getRowHeight === 'function') {
	            if (allowEstimate) {
	                return { height: this.getDefaultRowHeight(), estimated: true };
	            }
	            var params = {
	                node: rowNode,
	                data: rowNode.data,
	                api: this.gridOptions.api,
	                context: this.gridOptions.context
	            };
	            var height = this.gridOptions.getRowHeight(params);
	            if (this.isNumeric(height)) {
	                if (height === 0) {
	                    doOnce(function () { return console.warn('AG Grid: The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.'); }, 'invalidRowHeight');
	                }
	                return { height: Math.max(1, height), estimated: false };
	            }
	        }
	        if (rowNode.detail && this.isMasterDetail()) {
	            if (this.isNumeric(this.gridOptions.detailRowHeight)) {
	                return { height: this.gridOptions.detailRowHeight, estimated: false };
	            }
	            return { height: DEFAULT_DETAIL_ROW_HEIGHT, estimated: false };
	        }
	        var defaultRowHeight = this.getDefaultRowHeight();
	        var rowHeight = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : defaultRowHeight;
	        var minRowHeight = exists(rowHeight) ? Math.min(defaultRowHeight, rowHeight) : defaultRowHeight;
	        if (this.columnController.isAutoRowHeightActive()) {
	            if (allowEstimate) {
	                return { height: rowHeight, estimated: true };
	            }
	            var autoHeight = this.autoHeightCalculator.getPreferredHeightForRow(rowNode);
	            // never return less than the default row height - covers when auto height
	            // cells are blank.
	            return { height: Math.max(autoHeight, minRowHeight), estimated: false };
	        }
	        return { height: rowHeight, estimated: false };
	    };
	    GridOptionsWrapper.prototype.isDynamicRowHeight = function () {
	        return typeof this.gridOptions.getRowHeight === 'function';
	    };
	    GridOptionsWrapper.prototype.getListItemHeight = function () {
	        return this.getFromTheme(20, 'listItemHeight');
	    };
	    GridOptionsWrapper.prototype.chartMenuPanelWidth = function () {
	        return this.environment.chartMenuPanelWidth();
	    };
	    GridOptionsWrapper.prototype.isNumeric = function (value) {
	        return !isNaN(value) && typeof value === 'number' && isFinite(value);
	    };
	    GridOptionsWrapper.prototype.getFromTheme = function (defaultValue, sassVariableName) {
	        var theme = this.environment.getTheme().theme;
	        if (theme && theme.indexOf('ag-theme') === 0) {
	            return this.environment.getSassVariable(theme, sassVariableName);
	        }
	        return defaultValue;
	    };
	    GridOptionsWrapper.prototype.getDefaultRowHeight = function () {
	        return this.getFromTheme(DEFAULT_ROW_HEIGHT, 'rowHeight');
	    };
	    var GridOptionsWrapper_1;
	    GridOptionsWrapper.MIN_COL_WIDTH = 10;
	    GridOptionsWrapper.PROP_HEADER_HEIGHT = 'headerHeight';
	    GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN = 'groupRemoveSingleChildren';
	    GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN = 'groupRemoveLowestSingleChildren';
	    GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT = 'pivotHeaderHeight';
	    GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE = 'suppressClipboardPaste';
	    GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT = 'groupHeaderHeight';
	    GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT = 'pivotGroupHeaderHeight';
	    GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_CELL = 'navigateToNextCell';
	    GridOptionsWrapper.PROP_TAB_TO_NEXT_CELL = 'tabToNextCell';
	    GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_HEADER = 'navigateToNextHeader';
	    GridOptionsWrapper.PROP_TAB_TO_NEXT_HEADER = 'tabToNextHeader';
	    GridOptionsWrapper.PROP_IS_EXTERNAL_FILTER_PRESENT = 'isExternalFilterPresentFunc';
	    GridOptionsWrapper.PROP_DOES_EXTERNAL_FILTER_PASS = 'doesExternalFilterPass';
	    GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT = 'floatingFiltersHeight';
	    GridOptionsWrapper.PROP_SUPPRESS_ROW_CLICK_SELECTION = 'suppressRowClickSelection';
	    GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG = 'suppressRowDrag';
	    GridOptionsWrapper.PROP_SUPPRESS_MOVE_WHEN_ROW_DRAG = 'suppressMoveWhenRowDragging';
	    GridOptionsWrapper.PROP_GET_ROW_CLASS = 'getRowClass';
	    GridOptionsWrapper.PROP_GET_ROW_STYLE = 'getRowStyle';
	    GridOptionsWrapper.PROP_GET_ROW_HEIGHT = 'getRowHeight';
	    GridOptionsWrapper.PROP_POPUP_PARENT = 'popupParent';
	    GridOptionsWrapper.PROP_DOM_LAYOUT = 'domLayout';
	    GridOptionsWrapper.PROP_FILL_HANDLE_DIRECTION = 'fillHandleDirection';
	    GridOptionsWrapper.PROP_GROUP_ROW_AGG_NODES = 'groupRowAggNodes';
	    GridOptionsWrapper.PROP_GET_BUSINESS_KEY_FOR_NODE = 'getBusinessKeyForNode';
	    GridOptionsWrapper.PROP_GET_CHILD_COUNT = 'getChildCount';
	    GridOptionsWrapper.PROP_PROCESS_ROW_POST_CREATE = 'processRowPostCreate';
	    GridOptionsWrapper.PROP_GET_ROW_NODE_ID = 'getRowNodeId';
	    GridOptionsWrapper.PROP_IS_FULL_WIDTH_CELL = 'isFullWidthCell';
	    GridOptionsWrapper.PROP_IS_ROW_SELECTABLE = 'isRowSelectable';
	    GridOptionsWrapper.PROP_IS_ROW_MASTER = 'isRowMaster';
	    GridOptionsWrapper.PROP_POST_SORT = 'postSort';
	    GridOptionsWrapper.PROP_GET_DOCUMENT = 'getDocument';
	    GridOptionsWrapper.PROP_POST_PROCESS_POPUP = 'postProcessPopup';
	    GridOptionsWrapper.PROP_DEFAULT_GROUP_SORT_COMPARATOR = 'defaultGroupSortComparator';
	    GridOptionsWrapper.PROP_PAGINATION_NUMBER_FORMATTER = 'paginationNumberFormatter';
	    GridOptionsWrapper.PROP_GET_CONTEXT_MENU_ITEMS = 'getContextMenuItems';
	    GridOptionsWrapper.PROP_GET_MAIN_MENU_ITEMS = 'getMainMenuItems';
	    GridOptionsWrapper.PROP_PROCESS_CELL_FOR_CLIPBOARD = 'processCellForClipboard';
	    GridOptionsWrapper.PROP_PROCESS_CELL_FROM_CLIPBOARD = 'processCellFromClipboard';
	    GridOptionsWrapper.PROP_SEND_TO_CLIPBOARD = 'sendToClipboard';
	    GridOptionsWrapper.PROP_PROCESS_TO_SECONDARY_COLDEF = 'processSecondaryColDef';
	    GridOptionsWrapper.PROP_PROCESS_SECONDARY_COL_GROUP_DEF = 'processSecondaryColGroupDef';
	    GridOptionsWrapper.PROP_PROCESS_CHART_OPTIONS = 'processChartOptions';
	    GridOptionsWrapper.PROP_GET_CHART_TOOLBAR_ITEMS = 'getChartToolbarItems';
	    GridOptionsWrapper.PROP_GET_SERVER_SIDE_STORE_PARAMS = 'getServerSideStoreParams';
	    GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUPS_OPEN_BY_DEFAULT = 'isServerSideGroupOpenByDefault';
	    GridOptionsWrapper.PROP_IS_APPLY_SERVER_SIDE_TRANSACTION = 'isApplyServerSideTransaction';
	    GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUP = 'isServerSideGroup';
	    GridOptionsWrapper.PROP_GET_SERVER_SIDE_GROUP_KEY = 'getServerSideGroupKey';
	    __decorate$z([
	        Autowired('gridOptions')
	    ], GridOptionsWrapper.prototype, "gridOptions", void 0);
	    __decorate$z([
	        Autowired('columnController')
	    ], GridOptionsWrapper.prototype, "columnController", void 0);
	    __decorate$z([
	        Autowired('eventService')
	    ], GridOptionsWrapper.prototype, "eventService", void 0);
	    __decorate$z([
	        Autowired('environment')
	    ], GridOptionsWrapper.prototype, "environment", void 0);
	    __decorate$z([
	        Autowired('autoHeightCalculator')
	    ], GridOptionsWrapper.prototype, "autoHeightCalculator", void 0);
	    __decorate$z([
	        __param$3(0, Qualifier('gridApi')), __param$3(1, Qualifier('columnApi'))
	    ], GridOptionsWrapper.prototype, "agWire", null);
	    __decorate$z([
	        PreDestroy
	    ], GridOptionsWrapper.prototype, "destroy", null);
	    __decorate$z([
	        PostConstruct
	    ], GridOptionsWrapper.prototype, "init", null);
	    GridOptionsWrapper = GridOptionsWrapper_1 = __decorate$z([
	        Bean('gridOptionsWrapper')
	    ], GridOptionsWrapper);
	    return GridOptionsWrapper;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	// when doing transactions, or change detection, and grouping is present
	// in the data, there is no need for the ClientSideRowModel to update each
	// group after an update, ony parts that were impacted by the change.
	// this class keeps track of all groups that were impacted by a transaction.
	// the the different CSRM operations (filter, sort etc) use the forEach method
	// to visit each group that was changed.
	var ChangedPath = /** @class */ (function () {
	    function ChangedPath(keepingColumns, rootNode) {
	        // whether changed path is active of not. it is active when a) doing
	        // a transaction update or b) doing change detection. if we are doing
	        // a CSRM refresh for other reasons (after sort or filter, or user calling
	        // setRowData() without delta mode) then we are not active. we are also
	        // marked as not active if secondary columns change in pivot (as this impacts
	        // aggregations)
	        this.active = true;
	        // for each node in the change path, we also store which columns need
	        // to be re-aggregated.
	        this.nodeIdsToColumns = {};
	        // for quick lookup, all items in the change path are mapped by nodeId
	        this.mapToItems = {};
	        this.keepingColumns = keepingColumns;
	        this.pathRoot = {
	            rowNode: rootNode,
	            children: null
	        };
	        this.mapToItems[rootNode.id] = this.pathRoot;
	    }
	    // can be set inactive by:
	    // a) ClientSideRowModel, if no transactions or
	    // b) PivotService, if secondary columns changed
	    ChangedPath.prototype.setInactive = function () {
	        this.active = false;
	    };
	    ChangedPath.prototype.isActive = function () {
	        return this.active;
	    };
	    ChangedPath.prototype.depthFirstSearchChangedPath = function (pathItem, callback) {
	        if (pathItem.children) {
	            for (var i = 0; i < pathItem.children.length; i++) {
	                this.depthFirstSearchChangedPath(pathItem.children[i], callback);
	            }
	        }
	        callback(pathItem.rowNode);
	    };
	    ChangedPath.prototype.depthFirstSearchEverything = function (rowNode, callback, traverseEverything) {
	        if (rowNode.childrenAfterGroup) {
	            for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                var childNode = rowNode.childrenAfterGroup[i];
	                if (childNode.childrenAfterGroup) {
	                    this.depthFirstSearchEverything(rowNode.childrenAfterGroup[i], callback, traverseEverything);
	                }
	                else if (traverseEverything) {
	                    callback(childNode);
	                }
	            }
	        }
	        callback(rowNode);
	    };
	    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
	    // will be called for child nodes in addition to parent nodes.
	    ChangedPath.prototype.forEachChangedNodeDepthFirst = function (callback, traverseLeafNodes) {
	        if (traverseLeafNodes === void 0) { traverseLeafNodes = false; }
	        if (this.active) {
	            // if we are active, then use the change path to callback
	            // only for updated groups
	            this.depthFirstSearchChangedPath(this.pathRoot, callback);
	        }
	        else {
	            // we are not active, so callback for everything, walk the entire path
	            this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
	        }
	    };
	    ChangedPath.prototype.executeFromRootNode = function (callback) {
	        callback(this.pathRoot.rowNode);
	    };
	    ChangedPath.prototype.createPathItems = function (rowNode) {
	        var pointer = rowNode;
	        var newEntryCount = 0;
	        while (!this.mapToItems[pointer.id]) {
	            var newEntry = {
	                rowNode: pointer,
	                children: null
	            };
	            this.mapToItems[pointer.id] = newEntry;
	            newEntryCount++;
	            pointer = pointer.parent;
	        }
	        return newEntryCount;
	    };
	    ChangedPath.prototype.populateColumnsMap = function (rowNode, columns) {
	        var _this = this;
	        if (!this.keepingColumns || !columns) {
	            return;
	        }
	        var pointer = rowNode;
	        while (pointer) {
	            // if columns, add the columns in all the way to parent, merging
	            // in any other columns that might be there already
	            if (!this.nodeIdsToColumns[pointer.id]) {
	                this.nodeIdsToColumns[pointer.id] = {};
	            }
	            columns.forEach(function (col) { return _this.nodeIdsToColumns[pointer.id][col.getId()] = true; });
	            pointer = pointer.parent;
	        }
	    };
	    ChangedPath.prototype.linkPathItems = function (rowNode, newEntryCount) {
	        var pointer = rowNode;
	        for (var i = 0; i < newEntryCount; i++) {
	            var thisItem = this.mapToItems[pointer.id];
	            var parentItem = this.mapToItems[pointer.parent.id];
	            if (!parentItem.children) {
	                parentItem.children = [];
	            }
	            parentItem.children.push(thisItem);
	            pointer = pointer.parent;
	        }
	    };
	    // called by
	    // 1) change detection (provides cols) and
	    // 2) groupStage if doing transaction update (doesn't provide cols)
	    ChangedPath.prototype.addParentNode = function (rowNode, columns) {
	        if (!rowNode || rowNode.isRowPinned()) {
	            return;
	        }
	        // we cannot do  both steps below in the same loop as
	        // the second loop has a dependency on the first loop.
	        // ie the hierarchy cannot be stitched up yet because
	        // we don't have it built yet
	        // create the new PathItem objects.
	        var newEntryCount = this.createPathItems(rowNode);
	        // link in the node items
	        this.linkPathItems(rowNode, newEntryCount);
	        // update columns
	        this.populateColumnsMap(rowNode, columns);
	    };
	    ChangedPath.prototype.canSkip = function (rowNode) {
	        return this.active && !this.mapToItems[rowNode.id];
	    };
	    ChangedPath.prototype.getValueColumnsForNode = function (rowNode, valueColumns) {
	        if (!this.keepingColumns) {
	            return valueColumns;
	        }
	        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
	        var result = valueColumns.filter(function (col) { return colsForThisNode[col.getId()]; });
	        return result;
	    };
	    ChangedPath.prototype.getNotValueColumnsForNode = function (rowNode, valueColumns) {
	        if (!this.keepingColumns) {
	            return null;
	        }
	        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
	        var result = valueColumns.filter(function (col) { return !colsForThisNode[col.getId()]; });
	        return result;
	    };
	    return ChangedPath;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$E = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$A = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$4 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var SelectionController = /** @class */ (function (_super) {
	    __extends$E(SelectionController, _super);
	    function SelectionController() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SelectionController.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('SelectionController');
	        this.reset();
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_CHANGED, this.reset.bind(this));
	        }
	    };
	    SelectionController.prototype.init = function () {
	        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
	    };
	    SelectionController.prototype.setLastSelectedNode = function (rowNode) {
	        this.lastSelectedNode = rowNode;
	    };
	    SelectionController.prototype.getLastSelectedNode = function () {
	        return this.lastSelectedNode;
	    };
	    SelectionController.prototype.getSelectedNodes = function () {
	        var selectedNodes = [];
	        iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode) {
	                selectedNodes.push(rowNode);
	            }
	        });
	        return selectedNodes;
	    };
	    SelectionController.prototype.getSelectedRows = function () {
	        var selectedRows = [];
	        iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode && rowNode.data) {
	                selectedRows.push(rowNode.data);
	            }
	        });
	        return selectedRows;
	    };
	    SelectionController.prototype.removeGroupsFromSelection = function () {
	        var _this = this;
	        iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode && rowNode.group) {
	                _this.selectedNodes[rowNode.id] = undefined;
	            }
	        });
	    };
	    // should only be called if groupSelectsChildren=true
	    SelectionController.prototype.updateGroupsFromChildrenSelections = function (changedPath) {
	        // we only do this when group selection state depends on selected children
	        if (!this.gridOptionsWrapper.isGroupSelectsChildren()) {
	            return;
	        }
	        // also only do it if CSRM (code should never allow this anyway)
	        if (this.rowModel.getType() !== Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            return;
	        }
	        var clientSideRowModel = this.rowModel;
	        var rootNode = clientSideRowModel.getRootNode();
	        if (!changedPath) {
	            changedPath = new ChangedPath(true, rootNode);
	            changedPath.setInactive();
	        }
	        changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
	            if (rowNode !== rootNode) {
	                rowNode.calculateSelectedFromChildren();
	            }
	        });
	        // clientSideRowModel.getTopLevelNodes()!.forEach((rowNode: RowNode) => {
	        //     rowNode.depthFirstSearch((node) => {
	        //         if (node.group) {
	        //         }
	        //     });
	        // });
	    };
	    SelectionController.prototype.getNodeForIdIfSelected = function (id) {
	        return this.selectedNodes[id];
	    };
	    SelectionController.prototype.clearOtherNodes = function (rowNodeToKeepSelected) {
	        var _this = this;
	        var groupsToRefresh = {};
	        var updatedCount = 0;
	        iterateObject(this.selectedNodes, function (key, otherRowNode) {
	            if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
	                var rowNode = _this.selectedNodes[otherRowNode.id];
	                updatedCount += rowNode.setSelectedParams({
	                    newValue: false,
	                    clearSelection: false,
	                    suppressFinishActions: true
	                });
	                if (_this.groupSelectsChildren && otherRowNode.parent) {
	                    groupsToRefresh[otherRowNode.parent.id] = otherRowNode.parent;
	                }
	            }
	        });
	        iterateObject(groupsToRefresh, function (key, group) {
	            group.calculateSelectedFromChildren();
	        });
	        return updatedCount;
	    };
	    SelectionController.prototype.onRowSelected = function (event) {
	        var rowNode = event.node;
	        // we do not store the group rows when the groups select children
	        if (this.groupSelectsChildren && rowNode.group) {
	            return;
	        }
	        if (rowNode.isSelected()) {
	            this.selectedNodes[rowNode.id] = rowNode;
	        }
	        else {
	            this.selectedNodes[rowNode.id] = undefined;
	        }
	    };
	    SelectionController.prototype.syncInRowNode = function (rowNode, oldNode) {
	        this.syncInOldRowNode(rowNode, oldNode);
	        this.syncInNewRowNode(rowNode);
	    };
	    // if the id has changed for the node, then this means the rowNode
	    // is getting used for a different data item, which breaks
	    // our selectedNodes, as the node now is mapped by the old id
	    // which is inconsistent. so to keep the old node as selected,
	    // we swap in the clone (with the old id and old data). this means
	    // the oldNode is effectively a daemon we keep a reference to,
	    // so if client calls api.getSelectedNodes(), it gets the daemon
	    // in the result. when the client un-selects, the reference to the
	    // daemon is removed. the daemon, because it's an oldNode, is not
	    // used by the grid for rendering, it's a copy of what the node used
	    // to be like before the id was changed.
	    SelectionController.prototype.syncInOldRowNode = function (rowNode, oldNode) {
	        var oldNodeHasDifferentId = exists(oldNode) && (rowNode.id !== oldNode.id);
	        if (oldNodeHasDifferentId && oldNode) {
	            var oldNodeSelected = exists(this.selectedNodes[oldNode.id]);
	            if (oldNodeSelected) {
	                this.selectedNodes[oldNode.id] = oldNode;
	            }
	        }
	    };
	    SelectionController.prototype.syncInNewRowNode = function (rowNode) {
	        if (exists(this.selectedNodes[rowNode.id])) {
	            rowNode.setSelectedInitialValue(true);
	            this.selectedNodes[rowNode.id] = rowNode;
	        }
	        else {
	            rowNode.setSelectedInitialValue(false);
	        }
	    };
	    SelectionController.prototype.reset = function () {
	        this.logger.log('reset');
	        this.selectedNodes = {};
	        this.lastSelectedNode = null;
	    };
	    // returns a list of all nodes at 'best cost' - a feature to be used
	    // with groups / trees. if a group has all it's children selected,
	    // then the group appears in the result, but not the children.
	    // Designed for use with 'children' as the group selection type,
	    // where groups don't actually appear in the selection normally.
	    SelectionController.prototype.getBestCostNodeSelection = function () {
	        if (this.rowModel.getType() !== Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            console.warn('getBestCostNodeSelection is only available when using normal row model');
	            return;
	        }
	        var clientSideRowModel = this.rowModel;
	        var topLevelNodes = clientSideRowModel.getTopLevelNodes();
	        if (topLevelNodes === null) {
	            console.warn('selectAll not available doing rowModel=virtual');
	            return;
	        }
	        var result = [];
	        // recursive function, to find the selected nodes
	        function traverse(nodes) {
	            for (var i = 0, l = nodes.length; i < l; i++) {
	                var node = nodes[i];
	                if (node.isSelected()) {
	                    result.push(node);
	                }
	                else {
	                    // if not selected, then if it's a group, and the group
	                    // has children, continue to search for selections
	                    if (node.group && node.children) {
	                        traverse(node.children);
	                    }
	                }
	            }
	        }
	        traverse(topLevelNodes);
	        return result;
	    };
	    SelectionController.prototype.setRowModel = function (rowModel) {
	        this.rowModel = rowModel;
	    };
	    SelectionController.prototype.isEmpty = function () {
	        var count = 0;
	        iterateObject(this.selectedNodes, function (nodeId, rowNode) {
	            if (rowNode) {
	                count++;
	            }
	        });
	        return count === 0;
	    };
	    SelectionController.prototype.deselectAllRowNodes = function (justFiltered) {
	        if (justFiltered === void 0) { justFiltered = false; }
	        var callback = function (rowNode) { return rowNode.selectThisNode(false); };
	        var rowModelClientSide = this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        if (justFiltered) {
	            if (!rowModelClientSide) {
	                console.error('AG Grid: selecting just filtered only works with In Memory Row Model');
	                return;
	            }
	            var clientSideRowModel = this.rowModel;
	            clientSideRowModel.forEachNodeAfterFilter(callback);
	        }
	        else {
	            iterateObject(this.selectedNodes, function (id, rowNode) {
	                // remember the reference can be to null, as we never 'delete' from the map
	                if (rowNode) {
	                    callback(rowNode);
	                }
	            });
	            // this clears down the map (whereas above only sets the items in map to 'undefined')
	            this.reset();
	        }
	        // the above does not clean up the parent rows if they are selected
	        if (rowModelClientSide && this.groupSelectsChildren) {
	            this.updateGroupsFromChildrenSelections();
	        }
	        var event = {
	            type: Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    SelectionController.prototype.selectAllRowNodes = function (justFiltered) {
	        if (justFiltered === void 0) { justFiltered = false; }
	        if (this.rowModel.getType() !== Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            throw new Error("selectAll only available with normal row model, ie not " + this.rowModel.getType());
	        }
	        var clientSideRowModel = this.rowModel;
	        var callback = function (rowNode) { return rowNode.selectThisNode(true); };
	        if (justFiltered) {
	            clientSideRowModel.forEachNodeAfterFilter(callback);
	        }
	        else {
	            clientSideRowModel.forEachNode(callback);
	        }
	        // the above does not clean up the parent rows if they are selected
	        if (this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE && this.groupSelectsChildren) {
	            this.updateGroupsFromChildrenSelections();
	        }
	        var event = {
	            type: Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.selectNode = function (rowNode, tryMulti) {
	        if (rowNode) {
	            rowNode.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
	        }
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.deselectIndex = function (rowIndex) {
	        var node = this.rowModel.getRow(rowIndex);
	        this.deselectNode(node);
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.deselectNode = function (rowNode) {
	        if (rowNode) {
	            rowNode.setSelectedParams({ newValue: false, clearSelection: false });
	        }
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.selectIndex = function (index, tryMulti) {
	        var node = this.rowModel.getRow(index);
	        this.selectNode(node, tryMulti);
	    };
	    __decorate$A([
	        Autowired('rowModel')
	    ], SelectionController.prototype, "rowModel", void 0);
	    __decorate$A([
	        Autowired('columnApi')
	    ], SelectionController.prototype, "columnApi", void 0);
	    __decorate$A([
	        Autowired('gridApi')
	    ], SelectionController.prototype, "gridApi", void 0);
	    __decorate$A([
	        __param$4(0, Qualifier('loggerFactory'))
	    ], SelectionController.prototype, "setBeans", null);
	    __decorate$A([
	        PostConstruct
	    ], SelectionController.prototype, "init", null);
	    SelectionController = __decorate$A([
	        Bean('selectionController')
	    ], SelectionController);
	    return SelectionController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$B = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ColumnApi = /** @class */ (function () {
	    function ColumnApi() {
	    }
	    ColumnApi.prototype.sizeColumnsToFit = function (gridWidth) {
	        // AG-3403 validate that gridWidth is provided because this method has the same name as
	        // a method on the grid API that takes no arguments, and it's easy to confuse the two
	        if (typeof gridWidth === "undefined") {
	            console.error('AG Grid: missing parameter to columnApi.sizeColumnsToFit(gridWidth)');
	        }
	        this.columnController.sizeColumnsToFit(gridWidth, 'api');
	    };
	    ColumnApi.prototype.setColumnGroupOpened = function (group, newValue) { this.columnController.setColumnGroupOpened(group, newValue, 'api'); };
	    ColumnApi.prototype.getColumnGroup = function (name, instanceId) { return this.columnController.getColumnGroup(name, instanceId); };
	    ColumnApi.prototype.getOriginalColumnGroup = function (name) { return this.columnController.getOriginalColumnGroup(name); };
	    ColumnApi.prototype.getDisplayNameForColumn = function (column, location) { return this.columnController.getDisplayNameForColumn(column, location) || ''; };
	    ColumnApi.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) { return this.columnController.getDisplayNameForColumnGroup(columnGroup, location) || ''; };
	    ColumnApi.prototype.getColumn = function (key) { return this.columnController.getPrimaryColumn(key); };
	    ColumnApi.prototype.applyColumnState = function (params) { return this.columnController.applyColumnState(params, 'api'); };
	    ColumnApi.prototype.getColumnState = function () { return this.columnController.getColumnState(); };
	    ColumnApi.prototype.resetColumnState = function () { this.columnController.resetColumnState('api'); };
	    ColumnApi.prototype.getColumnGroupState = function () { return this.columnController.getColumnGroupState(); };
	    ColumnApi.prototype.setColumnGroupState = function (stateItems) { this.columnController.setColumnGroupState(stateItems, 'api'); };
	    ColumnApi.prototype.resetColumnGroupState = function () { this.columnController.resetColumnGroupState('api'); };
	    ColumnApi.prototype.isPinning = function () { return this.columnController.isPinningLeft() || this.columnController.isPinningRight(); };
	    ColumnApi.prototype.isPinningLeft = function () { return this.columnController.isPinningLeft(); };
	    ColumnApi.prototype.isPinningRight = function () { return this.columnController.isPinningRight(); };
	    ColumnApi.prototype.getDisplayedColAfter = function (col) { return this.columnController.getDisplayedColAfter(col); };
	    ColumnApi.prototype.getDisplayedColBefore = function (col) { return this.columnController.getDisplayedColBefore(col); };
	    ColumnApi.prototype.setColumnVisible = function (key, visible) { this.columnController.setColumnVisible(key, visible, 'api'); };
	    ColumnApi.prototype.setColumnsVisible = function (keys, visible) { this.columnController.setColumnsVisible(keys, visible, 'api'); };
	    ColumnApi.prototype.setColumnPinned = function (key, pinned) { this.columnController.setColumnPinned(key, pinned, 'api'); };
	    ColumnApi.prototype.setColumnsPinned = function (keys, pinned) { this.columnController.setColumnsPinned(keys, pinned, 'api'); };
	    ColumnApi.prototype.getAllColumns = function () { return this.columnController.getAllPrimaryColumns(); };
	    ColumnApi.prototype.getAllGridColumns = function () { return this.columnController.getAllGridColumns(); };
	    ColumnApi.prototype.getDisplayedLeftColumns = function () { return this.columnController.getDisplayedLeftColumns(); };
	    ColumnApi.prototype.getDisplayedCenterColumns = function () { return this.columnController.getDisplayedCenterColumns(); };
	    ColumnApi.prototype.getDisplayedRightColumns = function () { return this.columnController.getDisplayedRightColumns(); };
	    ColumnApi.prototype.getAllDisplayedColumns = function () { return this.columnController.getAllDisplayedColumns(); };
	    ColumnApi.prototype.getAllDisplayedVirtualColumns = function () { return this.columnController.getViewportColumns(); };
	    ColumnApi.prototype.moveColumn = function (key, toIndex) {
	        if (typeof key === 'number') {
	            // moveColumn used to take indexes, so this is advising user who hasn't moved to new method name
	            console.warn('AG Grid: you are using moveColumn(fromIndex, toIndex) - moveColumn takes a column key and a destination index, not two indexes, to move with indexes use moveColumnByIndex(from,to) instead');
	            this.columnController.moveColumnByIndex(key, toIndex, 'api');
	        }
	        else {
	            this.columnController.moveColumn(key, toIndex, 'api');
	        }
	    };
	    ColumnApi.prototype.moveColumnByIndex = function (fromIndex, toIndex) { this.columnController.moveColumnByIndex(fromIndex, toIndex, 'api'); };
	    ColumnApi.prototype.moveColumns = function (columnsToMoveKeys, toIndex) { this.columnController.moveColumns(columnsToMoveKeys, toIndex, 'api'); };
	    ColumnApi.prototype.moveRowGroupColumn = function (fromIndex, toIndex) { this.columnController.moveRowGroupColumn(fromIndex, toIndex); };
	    ColumnApi.prototype.setColumnAggFunc = function (key, aggFunc) { this.columnController.setColumnAggFunc(key, aggFunc); };
	    ColumnApi.prototype.setColumnWidth = function (key, newWidth, finished) {
	        if (finished === void 0) { finished = true; }
	        this.columnController.setColumnWidths([{ key: key, newWidth: newWidth }], false, finished);
	    };
	    ColumnApi.prototype.setColumnWidths = function (columnWidths, finished) {
	        if (finished === void 0) { finished = true; }
	        this.columnController.setColumnWidths(columnWidths, false, finished);
	    };
	    ColumnApi.prototype.setPivotMode = function (pivotMode) { this.columnController.setPivotMode(pivotMode); };
	    ColumnApi.prototype.isPivotMode = function () { return this.columnController.isPivotMode(); };
	    ColumnApi.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) { return this.columnController.getSecondaryPivotColumn(pivotKeys, valueColKey); };
	    ColumnApi.prototype.setValueColumns = function (colKeys) { this.columnController.setValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getValueColumns = function () { return this.columnController.getValueColumns(); };
	    ColumnApi.prototype.removeValueColumn = function (colKey) { this.columnController.removeValueColumn(colKey, 'api'); };
	    ColumnApi.prototype.removeValueColumns = function (colKeys) { this.columnController.removeValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addValueColumn = function (colKey) { this.columnController.addValueColumn(colKey, 'api'); };
	    ColumnApi.prototype.addValueColumns = function (colKeys) { this.columnController.addValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.setRowGroupColumns = function (colKeys) { this.columnController.setRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.removeRowGroupColumn = function (colKey) { this.columnController.removeRowGroupColumn(colKey, 'api'); };
	    ColumnApi.prototype.removeRowGroupColumns = function (colKeys) { this.columnController.removeRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addRowGroupColumn = function (colKey) { this.columnController.addRowGroupColumn(colKey, 'api'); };
	    ColumnApi.prototype.addRowGroupColumns = function (colKeys) { this.columnController.addRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getRowGroupColumns = function () { return this.columnController.getRowGroupColumns(); };
	    ColumnApi.prototype.setPivotColumns = function (colKeys) { this.columnController.setPivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.removePivotColumn = function (colKey) { this.columnController.removePivotColumn(colKey, 'api'); };
	    ColumnApi.prototype.removePivotColumns = function (colKeys) { this.columnController.removePivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addPivotColumn = function (colKey) { this.columnController.addPivotColumn(colKey, 'api'); };
	    ColumnApi.prototype.addPivotColumns = function (colKeys) { this.columnController.addPivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getPivotColumns = function () { return this.columnController.getPivotColumns(); };
	    ColumnApi.prototype.getLeftDisplayedColumnGroups = function () { return this.columnController.getDisplayedTreeLeft(); };
	    ColumnApi.prototype.getCenterDisplayedColumnGroups = function () { return this.columnController.getDisplayedTreeCentre(); };
	    ColumnApi.prototype.getRightDisplayedColumnGroups = function () { return this.columnController.getDisplayedTreeRight(); };
	    ColumnApi.prototype.getAllDisplayedColumnGroups = function () { return this.columnController.getAllDisplayedTrees(); };
	    ColumnApi.prototype.autoSizeColumn = function (key, skipHeader) { return this.columnController.autoSizeColumn(key, skipHeader, 'api'); };
	    ColumnApi.prototype.autoSizeColumns = function (keys, skipHeader) { return this.columnController.autoSizeColumns(keys, skipHeader, 'api'); };
	    ColumnApi.prototype.autoSizeAllColumns = function (skipHeader) { this.columnController.autoSizeAllColumns(skipHeader, 'api'); };
	    ColumnApi.prototype.setSecondaryColumns = function (colDefs) { this.columnController.setSecondaryColumns(colDefs, 'api'); };
	    ColumnApi.prototype.getSecondaryColumns = function () { return this.columnController.getSecondaryColumns(); };
	    ColumnApi.prototype.getPrimaryColumns = function () { return this.columnController.getAllPrimaryColumns(); };
	    ColumnApi.prototype.cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid = function () {
	        // some users were raising support issues with regards memory leaks. the problem was the customers applications
	        // were keeping references to the API. trying to educate them all would be difficult, easier to just remove
	        // all references in teh API so at least the core grid can be garbage collected.
	        //
	        // wait about 100ms before clearing down the references, in case user has some cleanup to do,
	        // and needs to deference the API first
	        setTimeout(_.removeAllReferences.bind(window, this, 'Column API'), 100);
	    };
	    // below goes through deprecated items, prints message to user, then calls the new version of the same method
	    // public getColumnDefs(): (ColDef | ColGroupDef)[] {
	    //     this.setColumnGroupOpened(group, newValue);
	    //     return null;
	    // }
	    ColumnApi.prototype.columnGroupOpened = function (group, newValue) {
	        console.error('AG Grid: columnGroupOpened no longer exists, use setColumnGroupOpened');
	        this.setColumnGroupOpened(group, newValue);
	    };
	    ColumnApi.prototype.hideColumns = function (colIds, hide) {
	        console.error('AG Grid: hideColumns is deprecated, use setColumnsVisible');
	        this.columnController.setColumnsVisible(colIds, !hide, 'api');
	    };
	    ColumnApi.prototype.hideColumn = function (colId, hide) {
	        console.error('AG Grid: hideColumn is deprecated, use setColumnVisible');
	        this.columnController.setColumnVisible(colId, !hide, 'api');
	    };
	    ColumnApi.prototype.setState = function (columnState) {
	        console.error('AG Grid: setState is deprecated, use setColumnState');
	        return this.setColumnState(columnState);
	    };
	    ColumnApi.prototype.getState = function () {
	        console.error('AG Grid: getState is deprecated, use getColumnState');
	        return this.getColumnState();
	    };
	    ColumnApi.prototype.resetState = function () {
	        console.error('AG Grid: resetState is deprecated, use resetColumnState');
	        this.resetColumnState();
	    };
	    ColumnApi.prototype.getAggregationColumns = function () {
	        console.error('AG Grid: getAggregationColumns is deprecated, use getValueColumns');
	        return this.columnController.getValueColumns();
	    };
	    ColumnApi.prototype.removeAggregationColumn = function (colKey) {
	        console.error('AG Grid: removeAggregationColumn is deprecated, use removeValueColumn');
	        this.columnController.removeValueColumn(colKey, 'api');
	    };
	    ColumnApi.prototype.removeAggregationColumns = function (colKeys) {
	        console.error('AG Grid: removeAggregationColumns is deprecated, use removeValueColumns');
	        this.columnController.removeValueColumns(colKeys, 'api');
	    };
	    ColumnApi.prototype.addAggregationColumn = function (colKey) {
	        console.error('AG Grid: addAggregationColumn is deprecated, use addValueColumn');
	        this.columnController.addValueColumn(colKey, 'api');
	    };
	    ColumnApi.prototype.addAggregationColumns = function (colKeys) {
	        console.error('AG Grid: addAggregationColumns is deprecated, use addValueColumns');
	        this.columnController.addValueColumns(colKeys, 'api');
	    };
	    ColumnApi.prototype.setColumnAggFunction = function (column, aggFunc) {
	        console.error('AG Grid: setColumnAggFunction is deprecated, use setColumnAggFunc');
	        this.columnController.setColumnAggFunc(column, aggFunc, 'api');
	    };
	    ColumnApi.prototype.getDisplayNameForCol = function (column) {
	        console.error('AG Grid: getDisplayNameForCol is deprecated, use getDisplayNameForColumn');
	        return this.getDisplayNameForColumn(column, null);
	    };
	    ColumnApi.prototype.setColumnState = function (columnState) {
	        return this.columnController.applyColumnState({ state: columnState, applyOrder: true }, 'api');
	    };
	    __decorate$B([
	        Autowired('columnController')
	    ], ColumnApi.prototype, "columnController", void 0);
	    __decorate$B([
	        PreDestroy
	    ], ColumnApi.prototype, "cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid", null);
	    ColumnApi = __decorate$B([
	        Bean('columnApi')
	    ], ColumnApi);
	    return ColumnApi;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __assign$3 = function () {
	    __assign$3 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$3.apply(this, arguments);
	};
	var AngularRowUtils = /** @class */ (function () {
	    function AngularRowUtils() {
	    }
	    AngularRowUtils.createChildScopeOrNull = function (rowNode, parentScope, gridOptionsWrapper) {
	        var isAngularCompileRows = gridOptionsWrapper.isAngularCompileRows();
	        if (!isAngularCompileRows) {
	            return null;
	        }
	        var newChildScope = parentScope.$new();
	        newChildScope.data = __assign$3({}, rowNode.data);
	        newChildScope.rowNode = rowNode;
	        newChildScope.context = gridOptionsWrapper.getContext();
	        var destroyFunc = function () {
	            newChildScope.$destroy();
	            newChildScope.data = null;
	            newChildScope.rowNode = null;
	            newChildScope.context = null;
	        };
	        return {
	            scope: newChildScope,
	            scopeDestroyFunc: destroyFunc
	        };
	    };
	    return AngularRowUtils;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$F = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var RowType;
	(function (RowType) {
	    RowType["Normal"] = "Normal";
	    RowType["FullWidth"] = "FullWidth";
	    RowType["FullWidthLoading"] = "FullWidthLoading";
	    RowType["FullWidthGroup"] = "FullWidthGroup";
	    RowType["FullWidthDetail"] = "FullWidthDetail";
	})(RowType || (RowType = {}));
	var FullWidthRenderers = convertToMap([
	    [RowType.FullWidthLoading, 'agLoadingCellRenderer'],
	    [RowType.FullWidthGroup, 'agGroupRowRenderer'],
	    [RowType.FullWidthDetail, 'agDetailCellRenderer']
	]);
	var FullWidthKeys = convertToMap([
	    [RowType.FullWidth, 'fullWidthCellRenderer'],
	    [RowType.FullWidthLoading, 'loadingCellRenderer'],
	    [RowType.FullWidthGroup, 'groupRowRenderer'],
	    [RowType.FullWidthDetail, 'detailCellRenderer']
	]);
	var instanceIdSequence = 0;
	var RowController = /** @class */ (function (_super) {
	    __extends$F(RowController, _super);
	    function RowController(parentScope, rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout) {
	        var _this = _super.call(this) || this;
	        _this.instanceId = instanceIdSequence++;
	        _this.allRowComps = [];
	        _this.active = true;
	        _this.centerCols = [];
	        _this.leftCols = [];
	        _this.rightCols = [];
	        _this.lastMouseDownOnDragger = false;
	        _this.updateColumnListsPending = false;
	        _this.parentScope = parentScope;
	        _this.beans = beans;
	        _this.rowNode = rowNode;
	        _this.rowIsEven = _this.rowNode.rowIndex % 2 === 0;
	        _this.paginationPage = _this.beans.paginationProxy.getCurrentPage();
	        _this.useAnimationFrameForCreate = useAnimationFrameForCreate;
	        _this.printLayout = printLayout;
	        _this.setAnimateFlags(animateIn);
	        _this.rowFocused = _this.beans.focusController.isRowFocused(_this.rowNode.rowIndex, _this.rowNode.rowPinned);
	        _this.setupAngular1Scope();
	        _this.rowLevel = _this.beans.rowCssClassCalculator.calculateRowLevel(_this.rowNode);
	        _this.setRowType();
	        _this.updateColumnLists(!_this.useAnimationFrameForCreate);
	        _this.addListeners();
	        if (_this.slideRowIn) {
	            executeNextVMTurn(_this.onTopChanged.bind(_this));
	        }
	        if (_this.fadeRowIn) {
	            executeNextVMTurn(function () {
	                _this.allRowComps.forEach(function (rowComp) { return removeCssClass(rowComp.getGui(), 'ag-opacity-zero'); });
	            });
	        }
	        return _this;
	    }
	    RowController.prototype.getInstanceId = function () {
	        return this.instanceId;
	    };
	    RowController.prototype.setLeftRowComp = function (rowComp) {
	        if (this.leftRowComp) {
	            console.error('AG Grid - should not set leftRowComp twice');
	        }
	        this.leftRowComp = rowComp;
	        this.allRowComps.push(rowComp);
	    };
	    RowController.prototype.setRightRowComp = function (rowComp) {
	        if (this.rightRowComp) {
	            console.error('AG Grid - should not set rightRowComp twice');
	        }
	        this.rightRowComp = rowComp;
	        this.allRowComps.push(rowComp);
	    };
	    RowController.prototype.setCenterRowComp = function (rowComp) {
	        if (this.centerRowComp) {
	            console.error('AG Grid - should not set centerRowComp twice');
	        }
	        this.centerRowComp = rowComp;
	        this.allRowComps.push(rowComp);
	    };
	    RowController.prototype.setFullWidthRowComp = function (rowComp) {
	        if (this.fullWidthRowComp) {
	            console.error('AG Grid - should not set fullWidthRowComp twice');
	        }
	        this.fullWidthRowComp = rowComp;
	        this.allRowComps.push(rowComp);
	    };
	    RowController.prototype.getColsForRowComp = function (pinned) {
	        switch (pinned) {
	            case Constants.PINNED_RIGHT: return this.rightCols;
	            case Constants.PINNED_LEFT: return this.leftCols;
	            default: return this.centerCols;
	        }
	    };
	    RowController.prototype.getScope = function () {
	        return this.scope;
	    };
	    RowController.prototype.isPrintLayout = function () {
	        return this.printLayout;
	    };
	    RowController.prototype.setupAngular1Scope = function () {
	        var scopeResult = AngularRowUtils.createChildScopeOrNull(this.rowNode, this.parentScope, this.beans.gridOptionsWrapper);
	        if (scopeResult) {
	            this.scope = scopeResult.scope;
	            this.addDestroyFunc(scopeResult.scopeDestroyFunc);
	        }
	    };
	    RowController.prototype.getCellForCol = function (column) {
	        var cellComp = this.getRenderedCellForColumn(column);
	        return cellComp ? cellComp.getGui() : null;
	    };
	    RowController.prototype.executeProcessRowPostCreateFunc = function () {
	        var func = this.beans.gridOptionsWrapper.getProcessRowPostCreateFunc();
	        if (!func) {
	            return;
	        }
	        var params = {
	            eRow: this.centerRowComp ? this.centerRowComp.getGui() : undefined,
	            ePinnedLeftRow: this.leftRowComp ? this.leftRowComp.getGui() : undefined,
	            ePinnedRightRow: this.rightRowComp ? this.rightRowComp.getGui() : undefined,
	            node: this.rowNode,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            rowIndex: this.rowNode.rowIndex,
	            addRenderedRowListener: this.addEventListener.bind(this),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        func(params);
	    };
	    RowController.prototype.setRowType = function () {
	        var isStub = this.rowNode.stub;
	        var isFullWidthCell = this.rowNode.isFullWidthCell();
	        var isDetailCell = this.beans.doingMasterDetail && this.rowNode.detail;
	        var pivotMode = this.beans.columnController.isPivotMode();
	        // we only use full width for groups, not footers. it wouldn't make sense to include footers if not looking
	        // for totals. if users complain about this, then we should introduce a new property 'footerUseEntireRow'
	        // so each can be set independently (as a customer complained about footers getting full width, hence
	        // introducing this logic)
	        var isGroupRow = !!this.rowNode.group && !this.rowNode.footer;
	        var isFullWidthGroup = isGroupRow && this.beans.gridOptionsWrapper.isGroupUseEntireRow(pivotMode);
	        if (isStub) {
	            this.rowType = RowType.FullWidthLoading;
	        }
	        else if (isDetailCell) {
	            this.rowType = RowType.FullWidthDetail;
	        }
	        else if (isFullWidthCell) {
	            this.rowType = RowType.FullWidth;
	        }
	        else if (isFullWidthGroup) {
	            this.rowType = RowType.FullWidthGroup;
	        }
	        else {
	            this.rowType = RowType.Normal;
	        }
	    };
	    RowController.prototype.updateColumnLists = function (suppressAnimationFrame) {
	        var _this = this;
	        if (suppressAnimationFrame === void 0) { suppressAnimationFrame = false; }
	        if (this.isFullWidth()) {
	            return;
	        }
	        var noAnimation = suppressAnimationFrame
	            || this.beans.gridOptionsWrapper.isSuppressAnimationFrame()
	            || this.printLayout;
	        if (noAnimation) {
	            this.updateColumnListsImpl();
	            return;
	        }
	        if (this.updateColumnListsPending) {
	            return;
	        }
	        this.beans.taskQueue.createTask(function () {
	            if (!_this.active) {
	                return;
	            }
	            _this.updateColumnListsImpl();
	        }, this.rowNode.rowIndex, 'createTasksP1');
	        this.updateColumnListsPending = true;
	    };
	    RowController.prototype.updateColumnListsImpl = function () {
	        this.updateColumnListsPending = false;
	        if (this.printLayout) {
	            this.centerCols = this.beans.columnController.getAllDisplayedColumns();
	            this.leftCols = [];
	            this.rightCols = [];
	        }
	        else {
	            this.centerCols = this.beans.columnController.getViewportCenterColumnsForRow(this.rowNode);
	            this.leftCols = this.beans.columnController.getDisplayedLeftColumnsForRow(this.rowNode);
	            this.rightCols = this.beans.columnController.getDisplayedRightColumnsForRow(this.rowNode);
	        }
	        this.allRowComps.forEach(function (rc) { return rc.onColumnChanged(); });
	    };
	    RowController.prototype.setAnimateFlags = function (animateIn) {
	        if (animateIn) {
	            var oldRowTopExists = exists(this.rowNode.oldRowTop);
	            // if the row had a previous position, we slide it in (animate row top)
	            this.slideRowIn = oldRowTopExists;
	            // if the row had no previous position, we fade it in (animate
	            this.fadeRowIn = !oldRowTopExists;
	        }
	        else {
	            this.slideRowIn = false;
	            this.fadeRowIn = false;
	        }
	    };
	    RowController.prototype.isEditing = function () {
	        return this.editingRow;
	    };
	    RowController.prototype.stopRowEditing = function (cancel) {
	        this.stopEditing(cancel);
	    };
	    RowController.prototype.isFullWidth = function () {
	        return this.rowType !== RowType.Normal;
	    };
	    RowController.prototype.getRowType = function () {
	        return this.rowType;
	    };
	    RowController.prototype.refreshFullWidth = function () {
	        var _this = this;
	        // returns 'true' if refresh succeeded
	        var tryRefresh = function (rowComp, pinned) {
	            if (!rowComp) {
	                return true;
	            } // no refresh needed
	            var cellComp = rowComp.getFullWidthRowComp();
	            if (!cellComp) {
	                return true;
	            } // no refresh needed
	            // no refresh method present, so can't refresh, hard refresh needed
	            if (!cellComp.refresh) {
	                return false;
	            }
	            var params = _this.createFullWidthParams(rowComp.getGui(), pinned);
	            var refreshSucceeded = cellComp.refresh(params);
	            return refreshSucceeded;
	        };
	        var normalSuccess = tryRefresh(this.fullWidthRowComp, null);
	        var bodySuccess = tryRefresh(this.centerRowComp, null);
	        var leftSuccess = tryRefresh(this.leftRowComp, Constants.PINNED_LEFT);
	        var rightSuccess = tryRefresh(this.rightRowComp, Constants.PINNED_RIGHT);
	        var allFullWidthRowsRefreshed = normalSuccess && bodySuccess && leftSuccess && rightSuccess;
	        return allFullWidthRowsRefreshed;
	    };
	    RowController.prototype.addListeners = function () {
	        this.addManagedListener(this.rowNode, RowNode.EVENT_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.onRowNodeCellChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_DRAGGING_CHANGED, this.onRowNodeDraggingChanged.bind(this));
	        this.addManagedListener(this.rowNode, RowNode.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
	        var eventService = this.beans.eventService;
	        this.addManagedListener(eventService, Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this));
	        this.addManagedListener(eventService, Events.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this));
	        this.addManagedListener(eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addManagedListener(eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
	        this.addManagedListener(eventService, Events.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
	        this.addManagedListener(eventService, Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
	        this.addManagedListener(eventService, Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
	        this.addManagedListener(eventService, Events.EVENT_COLUMN_MOVED, this.onColumnMoved.bind(this));
	        this.addListenersForCellComps();
	    };
	    RowController.prototype.onColumnMoved = function () {
	        this.updateColumnLists();
	    };
	    RowController.prototype.addListenersForCellComps = function () {
	        var _this = this;
	        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_INDEX_CHANGED, function () {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onRowIndexChanged(); });
	        });
	        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onCellChanged(event); });
	        });
	    };
	    RowController.prototype.onRowNodeDataChanged = function (event) {
	        // if this is an update, we want to refresh, as this will allow the user to put in a transition
	        // into the cellRenderer refresh method. otherwise this might be completely new data, in which case
	        // we will want to completely replace the cells
	        this.forEachCellComp(function (cellComp) {
	            return cellComp.refreshCell({
	                suppressFlash: !event.update,
	                newData: !event.update
	            });
	        });
	        // check for selected also, as this could be after lazy loading of the row data, in which case
	        // the id might of just gotten set inside the row and the row selected state may of changed
	        // as a result. this is what happens when selected rows are loaded in virtual pagination.
	        // - niall note - since moving to the stub component, this may no longer be true, as replacing
	        // the stub component now replaces the entire row
	        this.onRowSelected();
	        // as data has changed, then the style and class needs to be recomputed
	        this.postProcessCss();
	    };
	    RowController.prototype.onRowNodeCellChanged = function () {
	        // as data has changed, then the style and class needs to be recomputed
	        this.postProcessCss();
	    };
	    RowController.prototype.postProcessCss = function () {
	        this.postProcessStylesFromGridOptions();
	        this.postProcessClassesFromGridOptions();
	        this.postProcessRowClassRules();
	        this.postProcessRowDragging();
	    };
	    RowController.prototype.onRowNodeHighlightChanged = function () {
	        var highlighted = this.rowNode.highlighted;
	        this.allRowComps.forEach(function (rowComp) {
	            var eGui = rowComp.getGui();
	            removeCssClass(eGui, 'ag-row-highlight-above');
	            removeCssClass(eGui, 'ag-row-highlight-below');
	            if (highlighted) {
	                addCssClass(eGui, 'ag-row-highlight-' + highlighted);
	            }
	        });
	    };
	    RowController.prototype.onRowNodeDraggingChanged = function () {
	        this.postProcessRowDragging();
	    };
	    RowController.prototype.postProcessRowDragging = function () {
	        var dragging = this.rowNode.dragging;
	        this.allRowComps.forEach(function (rowComp) { return addOrRemoveCssClass(rowComp.getGui(), 'ag-row-dragging', dragging); });
	    };
	    RowController.prototype.updateExpandedCss = function () {
	        var expandable = this.rowNode.isExpandable();
	        var expanded = this.rowNode.expanded == true;
	        this.allRowComps.forEach(function (rowComp) {
	            var eRow = rowComp.getGui();
	            addOrRemoveCssClass(eRow, 'ag-row-group', expandable);
	            addOrRemoveCssClass(eRow, 'ag-row-group-expanded', expandable && expanded);
	            addOrRemoveCssClass(eRow, 'ag-row-group-contracted', expandable && !expanded);
	            setAriaExpanded(eRow, expandable && expanded);
	        });
	    };
	    RowController.prototype.onDisplayedColumnsChanged = function () {
	        // we skip animations for onDisplayedColumnChanged, as otherwise the client could remove columns and
	        // then set data, and any old valueGetter's (ie from cols that were removed) would still get called.
	        this.updateColumnLists(true);
	    };
	    RowController.prototype.onVirtualColumnsChanged = function () {
	        this.updateColumnLists();
	    };
	    RowController.prototype.getRowPosition = function () {
	        return {
	            rowPinned: this.rowNode.rowPinned,
	            rowIndex: this.rowNode.rowIndex
	        };
	    };
	    RowController.prototype.onKeyboardNavigate = function (keyboardEvent) {
	        var currentFullWidthComp = find(this.allRowComps, function (rowComp) { return rowComp.getGui().contains(keyboardEvent.target); });
	        var currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.getGui() : null;
	        var isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
	        if (!isFullWidthContainerFocused) {
	            return;
	        }
	        var node = this.rowNode;
	        var lastFocusedCell = this.beans.focusController.getFocusedCell();
	        var cellPosition = {
	            rowIndex: node.rowIndex,
	            rowPinned: node.rowPinned,
	            column: (lastFocusedCell && lastFocusedCell.column)
	        };
	        this.beans.rowRenderer.navigateToNextCell(keyboardEvent, keyboardEvent.keyCode, cellPosition, true);
	        keyboardEvent.preventDefault();
	    };
	    RowController.prototype.onTabKeyDown = function (keyboardEvent) {
	        if (keyboardEvent.defaultPrevented || isStopPropagationForAgGrid(keyboardEvent)) {
	            return;
	        }
	        var currentFullWidthComp = find(this.allRowComps, function (rowComp) { return rowComp.getGui().contains(keyboardEvent.target); });
	        var currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.getGui() : null;
	        var isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
	        var nextEl = null;
	        if (!isFullWidthContainerFocused) {
	            nextEl = this.beans.focusController.findNextFocusableElement(currentFullWidthContainer, false, keyboardEvent.shiftKey);
	        }
	        if ((this.isFullWidth() && isFullWidthContainerFocused) || !nextEl) {
	            this.beans.rowRenderer.onTabKeyDown(this, keyboardEvent);
	        }
	    };
	    RowController.prototype.onFullWidthRowFocused = function (event) {
	        var node = this.rowNode;
	        var isFocused = this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
	        var element = this.fullWidthRowComp ? this.fullWidthRowComp.getGui() : this.centerRowComp.getGui();
	        addOrRemoveCssClass(element, 'ag-full-width-focus', isFocused);
	        if (isFocused) {
	            // we don't scroll normal rows into view when we focus them, so we don't want
	            // to scroll Full Width rows either.
	            element.focus({ preventScroll: true });
	        }
	    };
	    RowController.prototype.refreshCell = function (cellComp) {
	        this.allRowComps.forEach(function (rc) { return rc.destroyCells([cellComp]); });
	        this.updateColumnLists();
	    };
	    RowController.prototype.onMouseEvent = function (eventName, mouseEvent) {
	        switch (eventName) {
	            case 'dblclick':
	                this.onRowDblClick(mouseEvent);
	                break;
	            case 'click':
	                this.onRowClick(mouseEvent);
	                break;
	            case 'mousedown':
	                this.onRowMouseDown(mouseEvent);
	                break;
	        }
	    };
	    RowController.prototype.createRowEvent = function (type, domEvent) {
	        return {
	            type: type,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            rowIndex: this.rowNode.rowIndex,
	            rowPinned: this.rowNode.rowPinned,
	            context: this.beans.gridOptionsWrapper.getContext(),
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            event: domEvent
	        };
	    };
	    RowController.prototype.createRowEventWithSource = function (type, domEvent) {
	        var event = this.createRowEvent(type, domEvent);
	        // when first developing this, we included the rowComp in the event.
	        // this seems very weird. so when introducing the event types, i left the 'source'
	        // out of the type, and just include the source in the two places where this event
	        // was fired (rowClicked and rowDoubleClicked). it doesn't make sense for any
	        // users to be using this, as the rowComp isn't an object we expose, so would be
	        // very surprising if a user was using it.
	        event.source = this;
	        return event;
	    };
	    RowController.prototype.onRowDblClick = function (mouseEvent) {
	        if (isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        var agEvent = this.createRowEventWithSource(Events.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
	        this.beans.eventService.dispatchEvent(agEvent);
	    };
	    RowController.prototype.onRowMouseDown = function (mouseEvent) {
	        this.lastMouseDownOnDragger = isElementChildOfClass(mouseEvent.target, 'ag-row-drag', 3);
	        if (!this.isFullWidth()) {
	            return;
	        }
	        var node = this.rowNode;
	        var columnController = this.beans.columnController;
	        this.beans.focusController.setFocusedCell(node.rowIndex, columnController.getAllDisplayedColumns()[0], node.rowPinned, true);
	    };
	    RowController.prototype.onRowClick = function (mouseEvent) {
	        var stop = isStopPropagationForAgGrid(mouseEvent) || this.lastMouseDownOnDragger;
	        if (stop) {
	            return;
	        }
	        var agEvent = this.createRowEventWithSource(Events.EVENT_ROW_CLICKED, mouseEvent);
	        this.beans.eventService.dispatchEvent(agEvent);
	        // ctrlKey for windows, metaKey for Apple
	        var multiSelectKeyPressed = mouseEvent.ctrlKey || mouseEvent.metaKey;
	        var shiftKeyPressed = mouseEvent.shiftKey;
	        // we do not allow selecting the group by clicking, when groupSelectChildren, as the logic to
	        // handle this is broken. to observe, change the logic below and allow groups to be selected.
	        // you will see the group gets selected, then all children get selected, then the grid unselects
	        // the children (as the default behaviour when clicking is to unselect other rows) which results
	        // in the group getting unselected (as all children are unselected). the correct thing would be
	        // to change this, so that children of the selected group are not then subsequenly un-selected.
	        var groupSelectsChildren = this.beans.gridOptionsWrapper.isGroupSelectsChildren();
	        if (
	        // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
	        // so return if it's a group row
	        (groupSelectsChildren && this.rowNode.group) ||
	            // this is needed so we don't unselect other rows when we click this row, eg if this row is not selectable,
	            // and we click it, the selection should not change (ie any currently selected row should stay selected)
	            !this.rowNode.selectable ||
	            // we also don't allow selection of pinned rows
	            this.rowNode.rowPinned ||
	            // if no selection method enabled, do nothing
	            !this.beans.gridOptionsWrapper.isRowSelection() ||
	            // if click selection suppressed, do nothing
	            this.beans.gridOptionsWrapper.isSuppressRowClickSelection()) {
	            return;
	        }
	        var multiSelectOnClick = this.beans.gridOptionsWrapper.isRowMultiSelectWithClick();
	        var rowDeselectionWithCtrl = !this.beans.gridOptionsWrapper.isSuppressRowDeselection();
	        if (this.rowNode.isSelected()) {
	            if (multiSelectOnClick) {
	                this.rowNode.setSelectedParams({ newValue: false });
	            }
	            else if (multiSelectKeyPressed) {
	                if (rowDeselectionWithCtrl) {
	                    this.rowNode.setSelectedParams({ newValue: false });
	                }
	            }
	            else {
	                // selected with no multi key, must make sure anything else is unselected
	                this.rowNode.setSelectedParams({ newValue: !shiftKeyPressed, clearSelection: !shiftKeyPressed, rangeSelect: shiftKeyPressed });
	            }
	        }
	        else {
	            var clearSelection = multiSelectOnClick ? false : !multiSelectKeyPressed;
	            this.rowNode.setSelectedParams({ newValue: true, clearSelection: clearSelection, rangeSelect: shiftKeyPressed });
	        }
	    };
	    RowController.prototype.setupDetailRowAutoHeight = function (eDetailGui) {
	        var _this = this;
	        if (!this.beans.gridOptionsWrapper.isDetailRowAutoHeight()) {
	            return;
	        }
	        var checkRowSizeFunc = function () {
	            var clientHeight = eDetailGui.clientHeight;
	            // if the UI is not ready, the height can be 0, which we ignore, as otherwise a flicker will occur
	            // as UI goes from the default height, to 0, then to the real height as UI becomes ready. this means
	            // it's not possible for have 0 as auto-height, however this is an improbable use case, as even an
	            // empty detail grid would still have some styling around it giving at least a few pixels.
	            if (clientHeight != null && clientHeight > 0) {
	                // we do the update in a timeout, to make sure we are not calling from inside the grid
	                // doing another update
	                var updateRowHeightFunc = function () {
	                    _this.rowNode.setRowHeight(clientHeight);
	                    if (_this.beans.clientSideRowModel) {
	                        _this.beans.clientSideRowModel.onRowHeightChanged();
	                    }
	                    else if (_this.beans.serverSideRowModel) {
	                        _this.beans.serverSideRowModel.onRowHeightChanged();
	                    }
	                };
	                _this.beans.frameworkOverrides.setTimeout(updateRowHeightFunc, 0);
	            }
	        };
	        var resizeObserverDestroyFunc = this.beans.resizeObserverService.observeResize(eDetailGui, checkRowSizeFunc);
	        this.addDestroyFunc(resizeObserverDestroyFunc);
	        checkRowSizeFunc();
	    };
	    RowController.prototype.createFullWidthParams = function (eRow, pinned) {
	        var _this = this;
	        var params = {
	            fullWidth: true,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            value: this.rowNode.key,
	            valueFormatted: this.rowNode.key,
	            $scope: this.scope ? this.scope : this.parentScope,
	            $compile: this.beans.$compile,
	            rowIndex: this.rowNode.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            // these need to be taken out, as part of 'afterAttached' now
	            eGridCell: eRow,
	            eParentOfValue: eRow,
	            pinned: pinned,
	            addRenderedRowListener: this.addEventListener.bind(this),
	            registerRowDragger: function (rowDraggerElement, dragStartPixels, value) { return _this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value); }
	        };
	        return params;
	    };
	    RowController.prototype.addFullWidthRowDragging = function (rowDraggerElement, dragStartPixels, value) {
	        if (value === void 0) { value = ''; }
	        if (!this.isFullWidth()) {
	            return;
	        }
	        var rowDragComp = new RowDragComp(function () { return value; }, this.rowNode, undefined, rowDraggerElement, dragStartPixels);
	        this.createManagedBean(rowDragComp, this.beans.context);
	    };
	    RowController.prototype.onUiLevelChanged = function () {
	        var newLevel = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
	        if (this.rowLevel != newLevel) {
	            var classToAdd_1 = 'ag-row-level-' + newLevel;
	            var classToRemove_1 = 'ag-row-level-' + this.rowLevel;
	            this.allRowComps.forEach(function (rowComp) {
	                var eGui = rowComp.getGui();
	                addCssClass(eGui, classToAdd_1);
	                removeCssClass(eGui, classToRemove_1);
	            });
	        }
	        this.rowLevel = newLevel;
	    };
	    RowController.prototype.isFirstRowOnPage = function () {
	        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
	    };
	    RowController.prototype.isLastRowOnPage = function () {
	        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
	    };
	    RowController.prototype.onModelUpdated = function () {
	        var newFirst = this.isFirstRowOnPage();
	        var newLast = this.isLastRowOnPage();
	        if (this.firstRowOnPage !== newFirst) {
	            this.firstRowOnPage = newFirst;
	            this.allRowComps.forEach(function (rowComp) { return addOrRemoveCssClass(rowComp.getGui(), 'ag-row-first', newFirst); });
	        }
	        if (this.lastRowOnPage !== newLast) {
	            this.lastRowOnPage = newLast;
	            this.allRowComps.forEach(function (rowComp) { return addOrRemoveCssClass(rowComp.getGui(), 'ag-row-last', newLast); });
	        }
	    };
	    RowController.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.forEachCellComp(function (renderedCell) {
	            renderedCell.stopEditing(cancel);
	        });
	        if (!this.editingRow) {
	            return;
	        }
	        if (!cancel) {
	            var event_1 = this.createRowEvent(Events.EVENT_ROW_VALUE_CHANGED);
	            this.beans.eventService.dispatchEvent(event_1);
	        }
	        this.setEditingRow(false);
	    };
	    RowController.prototype.setEditingRow = function (value) {
	        this.editingRow = value;
	        this.allRowComps.forEach(function (rowComp) { return addOrRemoveCssClass(rowComp.getGui(), 'ag-row-editing', value); });
	        var event = value ?
	            this.createRowEvent(Events.EVENT_ROW_EDITING_STARTED)
	            : this.createRowEvent(Events.EVENT_ROW_EDITING_STOPPED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    RowController.prototype.startRowEditing = function (keyPress, charPress, sourceRenderedCell) {
	        if (keyPress === void 0) { keyPress = null; }
	        if (charPress === void 0) { charPress = null; }
	        if (sourceRenderedCell === void 0) { sourceRenderedCell = null; }
	        // don't do it if already editing
	        if (this.editingRow) {
	            return;
	        }
	        this.forEachCellComp(function (renderedCell) {
	            var cellStartedEdit = renderedCell === sourceRenderedCell;
	            if (cellStartedEdit) {
	                renderedCell.startEditingIfEnabled(keyPress, charPress, cellStartedEdit);
	            }
	            else {
	                renderedCell.startEditingIfEnabled(null, null, cellStartedEdit);
	            }
	        });
	        this.setEditingRow(true);
	    };
	    RowController.prototype.forEachCellComp = function (callback) {
	        this.allRowComps.forEach(function (rc) { return rc.forEachCellComp(callback); });
	    };
	    RowController.prototype.postProcessClassesFromGridOptions = function () {
	        var _this = this;
	        var cssClasses = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode, this.scope);
	        if (!cssClasses || !cssClasses.length) {
	            return;
	        }
	        cssClasses.forEach(function (classStr) {
	            _this.allRowComps.forEach(function (rowComp) { return addCssClass(rowComp.getGui(), classStr); });
	        });
	    };
	    RowController.prototype.postProcessRowClassRules = function () {
	        var _this = this;
	        this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, this.scope, function (className) {
	            _this.allRowComps.forEach(function (rowComp) { return addCssClass(rowComp.getGui(), className); });
	        }, function (className) {
	            _this.allRowComps.forEach(function (rowComp) { return removeCssClass(rowComp.getGui(), className); });
	        });
	    };
	    RowController.prototype.postProcessStylesFromGridOptions = function () {
	        var rowStyles = this.processStylesFromGridOptions();
	        this.allRowComps.forEach(function (rowComp) { return addStylesToElement(rowComp.getGui(), rowStyles); });
	    };
	    RowController.prototype.getInitialRowTopStyle = function () {
	        // print layout uses normal flow layout for row positioning
	        if (this.printLayout) {
	            return '';
	        }
	        // if sliding in, we take the old row top. otherwise we just set the current row top.
	        var pixels = this.slideRowIn ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
	        var afterPaginationPixels = this.applyPaginationOffset(pixels);
	        // we don't apply scaling if row is pinned
	        var afterScalingPixels = this.rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
	        var isSuppressRowTransform = this.beans.gridOptionsWrapper.isSuppressRowTransform();
	        return isSuppressRowTransform ? "top: " + afterScalingPixels + "px; " : "transform: translateY(" + afterScalingPixels + "px);";
	    };
	    RowController.prototype.getRowBusinessKey = function () {
	        var businessKeyForNodeFunc = this.beans.gridOptionsWrapper.getBusinessKeyForNodeFunc();
	        if (typeof businessKeyForNodeFunc !== 'function') {
	            return;
	        }
	        return businessKeyForNodeFunc(this.rowNode);
	    };
	    RowController.prototype.getInitialRowClasses = function (pinned) {
	        var params = {
	            rowNode: this.rowNode,
	            rowFocused: this.rowFocused,
	            fadeRowIn: this.fadeRowIn,
	            rowIsEven: this.rowIsEven,
	            rowLevel: this.rowLevel,
	            fullWidthRow: this.isFullWidth(),
	            firstRowOnPage: this.isFirstRowOnPage(),
	            lastRowOnPage: this.isLastRowOnPage(),
	            printLayout: this.printLayout,
	            expandable: this.rowNode.isExpandable(),
	            scope: this.scope,
	            pinned: pinned
	        };
	        return this.beans.rowCssClassCalculator.getInitialRowClasses(params);
	    };
	    RowController.prototype.preProcessStylesFromGridOptions = function () {
	        var rowStyles = this.processStylesFromGridOptions();
	        return cssStyleObjectToMarkup(rowStyles);
	    };
	    RowController.prototype.processStylesFromGridOptions = function () {
	        // part 1 - rowStyle
	        var rowStyle = this.beans.gridOptionsWrapper.getRowStyle();
	        if (rowStyle && typeof rowStyle === 'function') {
	            console.warn('AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead');
	            return;
	        }
	        // part 1 - rowStyleFunc
	        var rowStyleFunc = this.beans.gridOptionsWrapper.getRowStyleFunc();
	        var rowStyleFuncResult;
	        if (rowStyleFunc) {
	            var params = {
	                data: this.rowNode.data,
	                node: this.rowNode,
	                rowIndex: this.rowNode.rowIndex,
	                $scope: this.scope,
	                api: this.beans.gridOptionsWrapper.getApi(),
	                columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	                context: this.beans.gridOptionsWrapper.getContext()
	            };
	            rowStyleFuncResult = rowStyleFunc(params);
	        }
	        return assign({}, rowStyle, rowStyleFuncResult);
	    };
	    RowController.prototype.onRowSelected = function () {
	        var _this = this;
	        var selected = this.rowNode.isSelected();
	        this.allRowComps.forEach(function (rowComp) {
	            var eGui = rowComp.getGui();
	            setAriaSelected(eGui, selected);
	            addOrRemoveCssClass(eGui, 'ag-row-selected', selected);
	            _this.refreshAriaLabel(eGui, selected);
	        });
	    };
	    RowController.prototype.refreshAriaLabel = function (node, selected) {
	        if (selected && this.beans.gridOptionsWrapper.isSuppressRowDeselection()) {
	            node.removeAttribute('aria-label');
	            return;
	        }
	        var translate = this.beans.gridOptionsWrapper.getLocaleTextFunc();
	        var label = translate(selected ? 'ariaRowDeselect' : 'ariaRowSelect', "Press SPACE to " + (selected ? 'deselect' : 'select') + " this row.");
	        setAriaLabel(node, label);
	    };
	    RowController.prototype.isUseAnimationFrameForCreate = function () {
	        return this.useAnimationFrameForCreate;
	    };
	    RowController.prototype.addHoverFunctionality = function (eRow) {
	        var _this = this;
	        // because we use animation frames to do this, it's possible the row no longer exists
	        // by the time we get to add it
	        if (!this.active) {
	            return;
	        }
	        // because mouseenter and mouseleave do not propagate, we cannot listen on the gridPanel
	        // like we do for all the other mouse events.
	        // because of the pinning, we cannot simply add / remove the class based on the eRow. we
	        // have to check all eRow's (body & pinned). so the trick is if any of the rows gets a
	        // mouse hover, it sets such in the rowNode, and then all three reflect the change as
	        // all are listening for event on the row node.
	        // step 1 - add listener, to set flag on row node
	        this.addManagedListener(eRow, 'mouseenter', function () { return _this.rowNode.onMouseEnter(); });
	        this.addManagedListener(eRow, 'mouseleave', function () { return _this.rowNode.onMouseLeave(); });
	        // step 2 - listen for changes on row node (which any eRow can trigger)
	        this.addManagedListener(this.rowNode, RowNode.EVENT_MOUSE_ENTER, function () {
	            // if hover turned off, we don't add the class. we do this here so that if the application
	            // toggles this property mid way, we remove the hover form the last row, but we stop
	            // adding hovers from that point onwards.
	            if (!_this.beans.gridOptionsWrapper.isSuppressRowHoverHighlight()) {
	                addCssClass(eRow, 'ag-row-hover');
	            }
	        });
	        this.addManagedListener(this.rowNode, RowNode.EVENT_MOUSE_LEAVE, function () {
	            removeCssClass(eRow, 'ag-row-hover');
	        });
	    };
	    // for animation, we don't want to animate entry or exit to a very far away pixel,
	    // otherwise the row would move so fast, it would appear to disappear. so this method
	    // moves the row closer to the viewport if it is far away, so the row slide in / out
	    // at a speed the user can see.
	    RowController.prototype.roundRowTopToBounds = function (rowTop) {
	        var gridBodyCon = this.beans.controllersService.getGridBodyController();
	        var range = gridBodyCon.getScrollFeature().getVScrollPosition();
	        var minPixel = this.applyPaginationOffset(range.top, true) - 100;
	        var maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
	        return Math.min(Math.max(minPixel, rowTop), maxPixel);
	    };
	    RowController.prototype.getFrameworkOverrides = function () {
	        return this.beans.frameworkOverrides;
	    };
	    RowController.prototype.onRowHeightChanged = function () {
	        // check for exists first - if the user is resetting the row height, then
	        // it will be null (or undefined) momentarily until the next time the flatten
	        // stage is called where the row will then update again with a new height
	        if (exists(this.rowNode.rowHeight)) {
	            var heightPx_1 = this.rowNode.rowHeight + "px";
	            this.allRowComps.forEach(function (rowComp) { return rowComp.getGui().style.height = heightPx_1; });
	        }
	    };
	    RowController.prototype.addEventListener = function (eventType, listener) {
	        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
	            eventType = Events.EVENT_VIRTUAL_ROW_REMOVED;
	            console.warn('AG Grid: Since version 11, event renderedRowRemoved is now called ' + Events.EVENT_VIRTUAL_ROW_REMOVED);
	        }
	        _super.prototype.addEventListener.call(this, eventType, listener);
	    };
	    RowController.prototype.removeEventListener = function (eventType, listener) {
	        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
	            eventType = Events.EVENT_VIRTUAL_ROW_REMOVED;
	            console.warn('AG Grid: Since version 11, event renderedRowRemoved and rowRemoved is now called ' + Events.EVENT_VIRTUAL_ROW_REMOVED);
	        }
	        _super.prototype.removeEventListener.call(this, eventType, listener);
	    };
	    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
	    RowController.prototype.destroyFirstPass = function () {
	        this.active = false;
	        // why do we have this method? shouldn't everything below be added as a destroy func beside
	        // the corresponding create logic?
	        this.setupRemoveAnimation();
	        var event = this.createRowEvent(Events.EVENT_VIRTUAL_ROW_REMOVED);
	        this.dispatchEvent(event);
	        this.beans.eventService.dispatchEvent(event);
	        _super.prototype.destroy.call(this);
	    };
	    RowController.prototype.setupRemoveAnimation = function () {
	        var rowStillVisibleJustNotInViewport = this.rowNode.rowTop != null;
	        if (rowStillVisibleJustNotInViewport) {
	            // if the row is not rendered, but in viewport, it means it has moved,
	            // so we animate the row out. if the new location is very far away,
	            // the animation will be so fast the row will look like it's just disappeared,
	            // so instead we animate to a position just outside the viewport.
	            var rowTop = this.roundRowTopToBounds(this.rowNode.rowTop);
	            this.setRowTop(rowTop);
	        }
	        else {
	            this.allRowComps.forEach(function (rowComp) {
	                addCssClass(rowComp.getGui(), 'ag-opacity-zero');
	            });
	        }
	    };
	    RowController.prototype.destroySecondPass = function () {
	        this.allRowComps.forEach(function (c) { return c.destroy(); });
	        this.allRowComps.length = 0;
	    };
	    RowController.prototype.onCellFocusChanged = function () {
	        var rowFocused = this.beans.focusController.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
	        if (rowFocused !== this.rowFocused) {
	            this.allRowComps.forEach(function (rowComp) {
	                var eRow = rowComp.getGui();
	                addOrRemoveCssClass(eRow, 'ag-row-focus', rowFocused);
	                addOrRemoveCssClass(eRow, 'ag-row-no-focus', !rowFocused);
	            });
	            this.rowFocused = rowFocused;
	        }
	        // if we are editing, then moving the focus out of a row will stop editing
	        if (!rowFocused && this.editingRow) {
	            this.stopEditing(false);
	        }
	    };
	    RowController.prototype.onPaginationChanged = function () {
	        var currentPage = this.beans.paginationProxy.getCurrentPage();
	        // it is possible this row is in the new page, but the page number has changed, which means
	        // it needs to reposition itself relative to the new page
	        if (this.paginationPage !== currentPage) {
	            this.paginationPage = currentPage;
	            this.onTopChanged();
	        }
	    };
	    RowController.prototype.onTopChanged = function () {
	        this.setRowTop(this.rowNode.rowTop);
	    };
	    RowController.prototype.onPaginationPixelOffsetChanged = function () {
	        // the pixel offset is used when calculating rowTop to set on the row DIV
	        this.onTopChanged();
	    };
	    // applies pagination offset, eg if on second page, and page height is 500px, then removes
	    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
	    // reverse will take the offset away rather than add.
	    RowController.prototype.applyPaginationOffset = function (topPx, reverse) {
	        if (reverse === void 0) { reverse = false; }
	        if (this.rowNode.isRowPinned()) {
	            return topPx;
	        }
	        var pixelOffset = this.beans.paginationProxy.getPixelOffset();
	        var multiplier = reverse ? 1 : -1;
	        return topPx + (pixelOffset * multiplier);
	    };
	    RowController.prototype.setRowTop = function (pixels) {
	        // print layout uses normal flow layout for row positioning
	        if (this.printLayout) {
	            return;
	        }
	        // need to make sure rowTop is not null, as this can happen if the node was once
	        // visible (ie parent group was expanded) but is now not visible
	        if (exists(pixels)) {
	            var afterPaginationPixels = this.applyPaginationOffset(pixels);
	            var afterScalingPixels = this.rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
	            var topPx_1 = afterScalingPixels + "px";
	            var suppressRowTransform_1 = this.beans.gridOptionsWrapper.isSuppressRowTransform();
	            this.allRowComps.forEach(function (rowComp) {
	                var eGui = rowComp.getGui();
	                if (suppressRowTransform_1) {
	                    eGui.style.top = topPx_1;
	                }
	                else {
	                    eGui.style.transform = "translateY(" + topPx_1 + ")";
	                }
	            });
	        }
	    };
	    RowController.prototype.getRowNode = function () {
	        return this.rowNode;
	    };
	    RowController.prototype.getRenderedCellForColumn = function (column) {
	        var cellComps = this.allRowComps.map(function (rc) { return rc.getCellComp(column.getColId()); });
	        var cellComp = find(cellComps, function (c) { return !!c; });
	        if (cellComp) {
	            return cellComp;
	        }
	        var spannedCellComps = this.allRowComps.map(function (rc) { return rc.getCellCompSpanned(column); });
	        cellComp = find(spannedCellComps, function (c) { return !!c; });
	        return cellComp || null;
	    };
	    RowController.prototype.onRowIndexChanged = function () {
	        // we only bother updating if the rowIndex is present. if it is not present, it means this row
	        // is child of a group node, and the group node was closed, it's the only way to have no row index.
	        // when this happens, row is about to be de-rendered, so we don't care, rowComp is about to die!
	        if (this.rowNode.rowIndex != null) {
	            this.onCellFocusChanged();
	            this.updateRowIndexes();
	        }
	    };
	    RowController.prototype.updateRowIndexes = function () {
	        var _this = this;
	        var rowIndexStr = this.rowNode.getRowIndexString();
	        var rowIsEven = this.rowNode.rowIndex % 2 === 0;
	        var rowIsEvenChanged = this.rowIsEven !== rowIsEven;
	        var headerRowCount = this.beans.headerNavigationService.getHeaderRowCount();
	        if (rowIsEvenChanged) {
	            this.rowIsEven = rowIsEven;
	        }
	        this.allRowComps.forEach(function (rowComp) {
	            var eRow = rowComp.getGui();
	            eRow.setAttribute('row-index', rowIndexStr);
	            setAriaRowIndex(eRow, headerRowCount + _this.rowNode.rowIndex + 1);
	            if (!rowIsEvenChanged) {
	                return;
	            }
	            addOrRemoveCssClass(eRow, 'ag-row-even', rowIsEven);
	            addOrRemoveCssClass(eRow, 'ag-row-odd', !rowIsEven);
	        });
	    };
	    // returns the pinned left container, either the normal one, or the embedded full with one if exists
	    RowController.prototype.getPinnedLeftRowElement = function () {
	        return this.leftRowComp ? this.leftRowComp.getGui() : undefined;
	    };
	    // returns the pinned right container, either the normal one, or the embedded full with one if exists
	    RowController.prototype.getPinnedRightRowElement = function () {
	        return this.rightRowComp ? this.rightRowComp.getGui() : undefined;
	    };
	    // returns the body container, either the normal one, or the embedded full with one if exists
	    RowController.prototype.getBodyRowElement = function () {
	        return this.centerRowComp ? this.centerRowComp.getGui() : undefined;
	    };
	    // returns the full width container
	    RowController.prototype.getFullWidthRowElement = function () {
	        return this.fullWidthRowComp ? this.fullWidthRowComp.getGui() : undefined;
	    };
	    RowController.DOM_DATA_KEY_RENDERED_ROW = 'renderedRow';
	    return RowController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (SelectionHandleType) {
	    SelectionHandleType[SelectionHandleType["FILL"] = 0] = "FILL";
	    SelectionHandleType[SelectionHandleType["RANGE"] = 1] = "RANGE";
	})(exports.SelectionHandleType || (exports.SelectionHandleType = {}));
	(function (CellRangeType) {
	    CellRangeType[CellRangeType["VALUE"] = 0] = "VALUE";
	    CellRangeType[CellRangeType["DIMENSION"] = 1] = "DIMENSION";
	})(exports.CellRangeType || (exports.CellRangeType = {}));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$G = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var PopupEditorWrapper = /** @class */ (function (_super) {
	    __extends$G(PopupEditorWrapper, _super);
	    function PopupEditorWrapper(cellEditor) {
	        var _this = _super.call(this, "<div class=\"ag-popup-editor\" tabindex=\"-1\"/>") || this;
	        _this.getGuiCalledOnChild = false;
	        _this.cellEditor = cellEditor;
	        return _this;
	    }
	    PopupEditorWrapper.prototype.onKeyDown = function (event) {
	        if (!isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, event, this.params.node, this.params.column, true)) {
	            this.params.onKeyDown(event);
	        }
	    };
	    PopupEditorWrapper.prototype.getGui = function () {
	        // we call getGui() on child here (rather than in the constructor)
	        // as we should wait for 'init' to be called on child first.
	        if (!this.getGuiCalledOnChild) {
	            this.appendChild(this.cellEditor.getGui());
	            this.getGuiCalledOnChild = true;
	        }
	        return _super.prototype.getGui.call(this);
	    };
	    PopupEditorWrapper.prototype.init = function (params) {
	        var _this = this;
	        this.params = params;
	        this.gridOptionsWrapper.setDomData(this.getGui(), PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
	        this.addDestroyFunc(function () { return _this.destroyBean(_this.cellEditor); });
	        this.addManagedListener(
	        // this needs to be 'super' and not 'this' as if we call 'this',
	        // it ends up called 'getGui()' on the child before 'init' was called,
	        // which is not good
	        _super.prototype.getGui.call(this), 'keydown', this.onKeyDown.bind(this));
	    };
	    PopupEditorWrapper.prototype.afterGuiAttached = function () {
	        if (this.cellEditor.afterGuiAttached) {
	            this.cellEditor.afterGuiAttached();
	        }
	    };
	    PopupEditorWrapper.prototype.getValue = function () {
	        return this.cellEditor.getValue();
	    };
	    PopupEditorWrapper.prototype.isCancelBeforeStart = function () {
	        if (this.cellEditor.isCancelBeforeStart) {
	            return this.cellEditor.isCancelBeforeStart();
	        }
	        return false;
	    };
	    PopupEditorWrapper.prototype.isCancelAfterEnd = function () {
	        if (this.cellEditor.isCancelAfterEnd) {
	            return this.cellEditor.isCancelAfterEnd();
	        }
	        return false;
	    };
	    PopupEditorWrapper.prototype.getPopupPosition = function () {
	        if (this.cellEditor.getPopupPosition) {
	            return this.cellEditor.getPopupPosition();
	        }
	    };
	    PopupEditorWrapper.prototype.focusIn = function () {
	        if (this.cellEditor.focusIn) {
	            this.cellEditor.focusIn();
	        }
	    };
	    PopupEditorWrapper.prototype.focusOut = function () {
	        if (this.cellEditor.focusOut) {
	            this.cellEditor.focusOut();
	        }
	    };
	    PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = 'popupEditorWrapper';
	    return PopupEditorWrapper;
	}(PopupComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$H = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$C = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var DndSourceComp = /** @class */ (function (_super) {
	    __extends$H(DndSourceComp, _super);
	    function DndSourceComp(rowNode, column, beans, eCell) {
	        var _this = _super.call(this, "<div class=\"ag-drag-handle ag-row-drag\" draggable=\"true\"></div>") || this;
	        _this.rowNode = rowNode;
	        _this.column = column;
	        _this.beans = beans;
	        _this.eCell = eCell;
	        return _this;
	    }
	    DndSourceComp.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        eGui.appendChild(createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
	        // we need to stop the event propagation here to avoid starting a range selection while dragging
	        this.addGuiEventListener('mousedown', function (e) {
	            e.stopPropagation();
	        });
	        this.addDragSource();
	        this.checkVisibility();
	    };
	    DndSourceComp.prototype.addDragSource = function () {
	        this.addGuiEventListener('dragstart', this.onDragStart.bind(this));
	    };
	    DndSourceComp.prototype.onDragStart = function (dragEvent) {
	        var _this = this;
	        var providedOnRowDrag = this.column.getColDef().dndSourceOnRowDrag;
	        var isIE = isBrowserIE();
	        if (!isIE) {
	            dragEvent.dataTransfer.setDragImage(this.eCell, 0, 0);
	        }
	        // default behaviour is to convert data to json and set into drag component
	        var defaultOnRowDrag = function () {
	            try {
	                var jsonData = JSON.stringify(_this.rowNode.data);
	                if (isIE) {
	                    dragEvent.dataTransfer.setData('text', jsonData);
	                }
	                else {
	                    dragEvent.dataTransfer.setData('application/json', jsonData);
	                    dragEvent.dataTransfer.setData('text/plain', jsonData);
	                }
	            }
	            catch (e) {
	                // if we cannot convert the data to json, then we do not set the type
	            }
	        };
	        if (providedOnRowDrag) {
	            providedOnRowDrag({ rowNode: this.rowNode, dragEvent: dragEvent });
	        }
	        else {
	            defaultOnRowDrag();
	        }
	    };
	    DndSourceComp.prototype.checkVisibility = function () {
	        var visible = this.column.isDndSource(this.rowNode);
	        this.setDisplayed(visible);
	    };
	    __decorate$C([
	        PostConstruct
	    ], DndSourceComp.prototype, "postConstruct", null);
	    return DndSourceComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$I = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign$4 = function () {
	    __assign$4 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$4.apply(this, arguments);
	};
	var CSS_CELL = 'ag-cell';
	var CSS_CELL_VALUE = 'ag-cell-value';
	var CSS_AUTO_HEIGHT = 'ag-cell-auto-height';
	var CSS_RANGE_TOP = 'ag-cell-range-top';
	var CSS_RANGE_RIGHT = 'ag-cell-range-right';
	var CSS_RANGE_BOTTOM = 'ag-cell-range-bottom';
	var CSS_RANGE_LEFT = 'ag-cell-range-left';
	var CSS_CELL_FOCUS = 'ag-cell-focus';
	var CSS_FIRST_RIGHT_PINNED = 'ag-cell-first-right-pinned';
	var CSS_LAST_LEFT_PINNED = 'ag-cell-last-left-pinned';
	var CSS_NOT_INLINE_EDITING = 'ag-cell-not-inline-editing';
	var CSS_INLINE_EDITING = 'ag-cell-inline-editing';
	var CSS_POPUP_EDITING = 'ag-cell-popup-editing';
	var CSS_RANGE_SELECTED = 'ag-cell-range-selected';
	var CSS_COLUMN_HOVER = 'ag-column-hover';
	var CSS_CELL_WRAP_TEXT = 'ag-cell-wrap-text';
	var CSS_RANGE_CHART = 'ag-cell-range-chart';
	var CSS_RANGE_SINGLE_CELL = 'ag-cell-range-single-cell';
	var CSS_RANGE_CHART_CATEGORY = 'ag-cell-range-chart-category';
	var CSS_RANGE_HANDLE = 'ag-cell-range-handle';
	var CellComp = /** @class */ (function (_super) {
	    __extends$I(CellComp, _super);
	    function CellComp(scope, beans, column, rowNode, rowComp, autoHeightCell, printLayout, eRow, editingRow) {
	        var _this = _super.call(this) || this;
	        _this.hasChartRange = false;
	        _this.editingCell = false;
	        _this.suppressRefreshCell = false;
	        _this.tooltipFeatureEnabled = false;
	        _this.scope = null;
	        // every time we go into edit mode, or back again, this gets incremented.
	        // it's the components way of dealing with the async nature of framework components,
	        // so if a framework component takes a while to be created, we know if the object
	        // is still relevant when creating is finished. eg we could click edit / un-edit 20
	        // times before the first React edit component comes back - we should discard
	        // the first 19.
	        _this.cellEditorVersion = 0;
	        _this.cellRendererVersion = 0;
	        _this.scope = scope;
	        _this.beans = beans;
	        _this.column = column;
	        _this.rowNode = rowNode;
	        _this.rowComp = rowComp;
	        _this.autoHeightCell = autoHeightCell;
	        _this.printLayout = printLayout;
	        _this.eRow = eRow;
	        _this.createGridCellVo();
	        _this.rangeSelectionEnabled = _this.beans.rangeController && beans.gridOptionsWrapper.isEnableRangeSelection();
	        _this.cellFocused = _this.beans.focusController.isCellFocused(_this.cellPosition);
	        _this.firstRightPinned = _this.column.isFirstRightPinned();
	        _this.lastLeftPinned = _this.column.isLastLeftPinned();
	        if (_this.rangeSelectionEnabled && _this.beans.rangeController) {
	            var rangeController = _this.beans.rangeController;
	            _this.rangeCount = rangeController.getCellRangeCount(_this.cellPosition);
	            _this.hasChartRange = _this.getHasChartRange();
	        }
	        _this.getValueAndFormat();
	        _this.setUsingWrapper();
	        _this.chooseCellRenderer();
	        _this.setupColSpan();
	        _this.rowSpan = _this.column.getRowSpan(_this.rowNode);
	        _this.setTemplate(_this.getCreateTemplate());
	        _this.afterAttached();
	        // if we are editing the row, then the cell needs to turn
	        // into edit mode
	        if (editingRow) {
	            _this.startEditingIfEnabled();
	        }
	        return _this;
	    }
	    CellComp.prototype.getCreateTemplate = function () {
	        var unselectable = !this.beans.gridOptionsWrapper.isEnableCellTextSelection() ? ' unselectable="on"' : '';
	        var templateParts = [];
	        var col = this.column;
	        var width = this.getCellWidth();
	        var left = this.modifyLeftForPrintLayout(this.getCellLeft());
	        var valueToRender = this.getInitialValueToRender();
	        var valueSanitised = get(this.column, 'colDef.template', null) ? valueToRender : escapeString(valueToRender);
	        this.tooltip = this.getToolTip();
	        var tooltipSanitised = escapeString(this.tooltip);
	        var colIdSanitised = escapeString(col.getId());
	        var stylesFromColDef = this.preProcessStylesFromColDef();
	        var cssClasses = this.getInitialCssClasses();
	        var stylesForRowSpanning = this.getStylesForRowSpanning();
	        var colIdxSanitised = escapeString(this.beans.columnController.getAriaColumnIndex(this.column).toString());
	        templateParts.push("<div");
	        templateParts.push(" tabindex=\"-1\"");
	        templateParts.push("" + unselectable); // THIS IS FOR IE ONLY so text selection doesn't bubble outside of the grid
	        templateParts.push(" role=\"gridcell\"");
	        templateParts.push(" aria-colindex=\"" + colIdxSanitised + "\"");
	        templateParts.push(" comp-id=\"" + this.getCompId() + "\" ");
	        templateParts.push(" col-id=\"" + colIdSanitised + "\"");
	        templateParts.push(" class=\"" + escapeString(cssClasses.join(' ')) + "\"");
	        if (this.beans.gridOptionsWrapper.isEnableBrowserTooltips() && exists(tooltipSanitised)) {
	            templateParts.push(" title=\"" + tooltipSanitised + "\"");
	        }
	        if (this.rangeSelectionEnabled) {
	            templateParts.push(" aria-selected=\"" + (this.rangeCount ? 'true' : 'false') + "\"");
	        }
	        templateParts.push(" style=\"width: " + Number(width) + "px; left: " + Number(left) + "px; " + escapeString(stylesFromColDef) + " " + escapeString(stylesForRowSpanning) + "\">");
	        if (this.usingWrapper) {
	            templateParts.push(this.getCellWrapperString(valueSanitised));
	        }
	        else if (valueSanitised != null) {
	            templateParts.push(valueSanitised);
	        }
	        templateParts.push("</div>");
	        return templateParts.join('');
	    };
	    CellComp.prototype.getCellWrapperString = function (value) {
	        if (value === void 0) { value = ''; }
	        var unselectable = !this.beans.gridOptionsWrapper.isEnableCellTextSelection() ? ' unselectable="on"' : '';
	        var wrapper = /* html */ "<div ref=\"eCellWrapper\" class=\"ag-cell-wrapper\" role=\"presentation\">\n            <span ref=\"eCellValue\" role=\"presentation\" class=\"" + CSS_CELL_VALUE + "\"" + unselectable + ">\n                " + (value != null ? value : '') + "\n            </span>\n        </div>";
	        return wrapper;
	    };
	    CellComp.prototype.getStylesForRowSpanning = function () {
	        if (this.rowSpan === 1) {
	            return '';
	        }
	        var singleRowHeight = this.beans.gridOptionsWrapper.getRowHeightAsNumber();
	        var totalRowHeight = singleRowHeight * this.rowSpan;
	        return "height: " + totalRowHeight + "px; z-index: 1;";
	    };
	    CellComp.prototype.afterAttached = function () {
	        // all of these have dependencies on the eGui, so only do them after eGui is set
	        this.addDomData();
	        this.populateTemplate();
	        this.createCellRendererInstance(true);
	        this.angular1Compile();
	        this.refreshHandle();
	        if (exists(this.tooltip)) {
	            this.createTooltipFeatureIfNeeded();
	        }
	    };
	    CellComp.prototype.createTooltipFeatureIfNeeded = function () {
	        if (this.beans.gridOptionsWrapper.isEnableBrowserTooltips() ||
	            this.tooltipFeatureEnabled) {
	            return;
	        }
	        this.createManagedBean(new TooltipFeature(this), this.beans.context);
	        this.tooltipFeatureEnabled = true;
	    };
	    CellComp.prototype.onColumnHover = function () {
	        var isHovered = this.beans.columnHoverService.isHovered(this.column);
	        this.addOrRemoveCssClass(CSS_COLUMN_HOVER, isHovered);
	    };
	    CellComp.prototype.onCellChanged = function (event) {
	        var eventImpactsThisCell = event.column === this.column;
	        if (eventImpactsThisCell) {
	            this.refreshCell({});
	        }
	    };
	    CellComp.prototype.getCellLeft = function () {
	        var mostLeftCol;
	        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
	            mostLeftCol = last(this.colsSpanning);
	        }
	        else {
	            mostLeftCol = this.column;
	        }
	        return mostLeftCol.getLeft();
	    };
	    CellComp.prototype.getCellWidth = function () {
	        if (!this.colsSpanning) {
	            return this.column.getActualWidth();
	        }
	        return this.colsSpanning.reduce(function (width, col) { return width + col.getActualWidth(); }, 0);
	    };
	    CellComp.prototype.onFlashCells = function (event) {
	        var cellId = this.beans.cellPositionUtils.createId(this.cellPosition);
	        var shouldFlash = event.cells[cellId];
	        if (shouldFlash) {
	            this.animateCell('highlight');
	        }
	    };
	    CellComp.prototype.setupColSpan = function () {
	        // if no col span is active, then we don't set it up, as it would be wasteful of CPU
	        if (missing(this.getComponentHolder().colSpan)) {
	            return;
	        }
	        // because we are col spanning, a reorder of the cols can change what cols we are spanning over
	        this.addManagedListener(this.beans.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
	        // because we are spanning over multiple cols, we check for width any time any cols width changes.
	        // this is expensive - really we should be explicitly checking only the cols we are spanning over
	        // instead of every col, however it would be tricky code to track the cols we are spanning over, so
	        // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
	        this.addManagedListener(this.beans.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
	        this.colsSpanning = this.getColSpanningList();
	    };
	    CellComp.prototype.getColSpanningList = function () {
	        var colSpan = this.column.getColSpan(this.rowNode);
	        var colsSpanning = [];
	        // if just one col, the col span is just the column we are in
	        if (colSpan === 1) {
	            colsSpanning.push(this.column);
	        }
	        else {
	            var pointer = this.column;
	            var pinned = this.column.getPinned();
	            for (var i = 0; pointer && i < colSpan; i++) {
	                colsSpanning.push(pointer);
	                pointer = this.beans.columnController.getDisplayedColAfter(pointer);
	                if (!pointer || missing(pointer)) {
	                    break;
	                }
	                // we do not allow col spanning to span outside of pinned areas
	                if (pinned !== pointer.getPinned()) {
	                    break;
	                }
	            }
	        }
	        return colsSpanning;
	    };
	    CellComp.prototype.onDisplayColumnsChanged = function () {
	        var colsSpanning = this.getColSpanningList();
	        if (!areEqual(this.colsSpanning, colsSpanning)) {
	            this.colsSpanning = colsSpanning;
	            this.onWidthChanged();
	            this.onLeftChanged(); // left changes when doing RTL
	        }
	    };
	    CellComp.prototype.refreshAriaIndex = function () {
	        var colIdx = this.beans.columnController.getAriaColumnIndex(this.column);
	        setAriaColIndex(this.getGui(), colIdx);
	    };
	    CellComp.prototype.getInitialCssClasses = function () {
	        var cssClasses = [CSS_CELL, CSS_NOT_INLINE_EDITING];
	        // if we are putting the cell into a dummy container, to work out it's height,
	        // then we don't put the height css in, as we want cell to fit height in that case.
	        if (!this.autoHeightCell) {
	            cssClasses.push(CSS_AUTO_HEIGHT);
	        }
	        var doingFocusCss = !this.beans.gridOptionsWrapper.isSuppressCellSelection();
	        if (doingFocusCss && this.cellFocused) {
	            // otherwise the class depends on the focus state
	            cssClasses.push(CSS_CELL_FOCUS);
	        }
	        if (this.firstRightPinned) {
	            cssClasses.push(CSS_FIRST_RIGHT_PINNED);
	        }
	        if (this.lastLeftPinned) {
	            cssClasses.push(CSS_LAST_LEFT_PINNED);
	        }
	        if (this.beans.columnHoverService.isHovered(this.column)) {
	            cssClasses.push(CSS_COLUMN_HOVER);
	        }
	        pushAll(cssClasses, this.preProcessClassesFromColDef());
	        pushAll(cssClasses, this.preProcessCellClassRules());
	        pushAll(cssClasses, this.getInitialRangeClasses());
	        // if using the wrapper, this class goes on the wrapper instead
	        if (!this.usingWrapper) {
	            cssClasses.push(CSS_CELL_VALUE);
	        }
	        this.wrapText = this.column.getColDef().wrapText == true;
	        if (this.wrapText) {
	            cssClasses.push(CSS_CELL_WRAP_TEXT);
	        }
	        return cssClasses;
	    };
	    CellComp.prototype.getInitialValueToRender = function () {
	        // if using a cellRenderer, then render the html from the cell renderer if it exists
	        if (this.usingCellRenderer) {
	            if (typeof this.cellRendererGui === 'string') {
	                return this.cellRendererGui;
	            }
	            return '';
	        }
	        var colDef = this.getComponentHolder();
	        if (colDef.template) {
	            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
	            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
	            return colDef.template;
	        }
	        if (colDef.templateUrl) {
	            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
	            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
	            // not do these, but would follow a pattern that was friendly towards components, not templates.
	            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
	            return template || '';
	        }
	        return this.getValueToUse();
	    };
	    CellComp.prototype.getRenderedRow = function () {
	        return this.rowComp;
	    };
	    CellComp.prototype.isSuppressNavigable = function () {
	        return this.column.isSuppressNavigable(this.rowNode);
	    };
	    CellComp.prototype.getCellRenderer = function () {
	        return this.cellRenderer;
	    };
	    CellComp.prototype.getCellEditor = function () {
	        return this.cellEditor;
	    };
	    CellComp.prototype.onNewColumnsLoaded = function () {
	        this.postProcessWrapText();
	        this.postProcessCellClassRules();
	    };
	    CellComp.prototype.postProcessWrapText = function () {
	        var newValue = this.column.getColDef().wrapText == true;
	        if (newValue !== this.wrapText) {
	            this.wrapText = newValue;
	            this.addOrRemoveCssClass(CSS_CELL_WRAP_TEXT, this.wrapText);
	        }
	    };
	    // + stop editing {forceRefresh: true, suppressFlash: true}
	    // + event cellChanged {}
	    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
	    // + rowComp: event dataChanged {animate: update, newData: !update}
	    // + rowComp: api refreshCells() {animate: true/false}
	    // + rowRenderer: api softRefreshView() {}
	    CellComp.prototype.refreshCell = function (params) {
	        // if we are in the middle of 'stopEditing', then we don't refresh here, as refresh gets called explicitly
	        if (this.suppressRefreshCell || this.editingCell) {
	            return;
	        }
	        var colDef = this.getComponentHolder();
	        var newData = params && params.newData;
	        var suppressFlash = (params && params.suppressFlash) || colDef.suppressCellFlash;
	        // we always refresh if cell has no value - this can happen when user provides Cell Renderer and the
	        // cell renderer doesn't rely on a value, instead it could be looking directly at the data, or maybe
	        // printing the current time (which would be silly)???. Generally speaking
	        // non of {field, valueGetter, showRowGroup} is bad in the users application, however for this edge case, it's
	        // best always refresh and take the performance hit rather than never refresh and users complaining in support
	        // that cells are not updating.
	        var noValueProvided = colDef.field == null && colDef.valueGetter == null && colDef.showRowGroup == null;
	        var forceRefresh = (params && params.forceRefresh) || noValueProvided || newData;
	        var oldValue = this.value;
	        // get latest value without invoking the value formatter as we may not be updating the cell
	        this.value = this.getValue();
	        // for simple values only (not objects), see if the value is the same, and if it is, skip the refresh.
	        // when never allow skipping after an edit, as after editing, we need to put the GUI back to the way
	        // if was before the edit.
	        var valuesDifferent = !this.valuesAreEqual(oldValue, this.value);
	        var dataNeedsUpdating = forceRefresh || valuesDifferent;
	        if (dataNeedsUpdating) {
	            // now invoke the value formatter as we are going to update cell
	            this.valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, this.value);
	            // if it's 'new data', then we don't refresh the cellRenderer, even if refresh method is available.
	            // this is because if the whole data is new (ie we are showing stock price 'BBA' now and not 'SSD')
	            // then we are not showing a movement in the stock price, rather we are showing different stock.
	            var cellRendererRefreshed = newData ? false : this.attemptCellRendererRefresh();
	            // we do the replace if not doing refresh, or if refresh was unsuccessful.
	            // the refresh can be unsuccessful if we are using a framework (eg ng2 or react) and the framework
	            // wrapper has the refresh method, but the underlying component doesn't
	            if (!cellRendererRefreshed) {
	                this.replaceContentsAfterRefresh();
	            }
	            // we don't want to flash the cells when processing a filter change, as otherwise the UI would
	            // be to busy. see comment in FilterManager with regards processingFilterChange
	            var processingFilterChange = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
	            var flashCell = !suppressFlash && !processingFilterChange &&
	                (this.beans.gridOptionsWrapper.isEnableCellChangeFlash() || colDef.enableCellChangeFlash);
	            if (flashCell) {
	                this.flashCell();
	            }
	            // need to check rules. note, we ignore colDef classes and styles, these are assumed to be static
	            this.postProcessStylesFromColDef();
	            this.postProcessClassesFromColDef();
	        }
	        // we can't readily determine if the data in an angularjs template has changed, so here we just update
	        // and recompile (if applicable)
	        this.updateAngular1ScopeAndCompile();
	        this.refreshToolTip();
	        // we do cellClassRules even if the value has not changed, so that users who have rules that
	        // look at other parts of the row (where the other part of the row might of changed) will work.
	        this.postProcessCellClassRules();
	    };
	    // user can also call this via API
	    CellComp.prototype.flashCell = function (delays) {
	        var flashDelay = delays && delays.flashDelay;
	        var fadeDelay = delays && delays.fadeDelay;
	        this.animateCell('data-changed', flashDelay, fadeDelay);
	    };
	    CellComp.prototype.animateCell = function (cssName, flashDelay, fadeDelay) {
	        var _this = this;
	        var fullName = "ag-cell-" + cssName;
	        var animationFullName = "ag-cell-" + cssName + "-animation";
	        var element = this.getGui();
	        var gridOptionsWrapper = this.beans.gridOptionsWrapper;
	        if (!flashDelay) {
	            flashDelay = gridOptionsWrapper.getCellFlashDelay();
	        }
	        if (!exists(fadeDelay)) {
	            fadeDelay = gridOptionsWrapper.getCellFadeDelay();
	        }
	        // we want to highlight the cells, without any animation
	        this.addCssClass(fullName);
	        this.removeCssClass(animationFullName);
	        // then once that is applied, we remove the highlight with animation
	        window.setTimeout(function () {
	            _this.removeCssClass(fullName);
	            _this.addCssClass(animationFullName);
	            element.style.transition = "background-color " + fadeDelay + "ms";
	            window.setTimeout(function () {
	                // and then to leave things as we got them, we remove the animation
	                _this.removeCssClass(animationFullName);
	                element.style.removeProperty('transition');
	            }, fadeDelay);
	        }, flashDelay);
	    };
	    CellComp.prototype.replaceContentsAfterRefresh = function () {
	        this.setUsingWrapper();
	        clearElement(this.eCellValue);
	        // remove old renderer component if it exists
	        this.cellRenderer = this.beans.context.destroyBean(this.cellRenderer);
	        this.cellRendererGui = null;
	        // populate
	        this.putDataIntoCellAfterRefresh();
	        this.updateAngular1ScopeAndCompile();
	    };
	    CellComp.prototype.updateAngular1ScopeAndCompile = function () {
	        if (this.beans.gridOptionsWrapper.isAngularCompileRows() && this.scope) {
	            this.scope.data = __assign$4({}, this.rowNode.data);
	            this.angular1Compile();
	        }
	    };
	    CellComp.prototype.angular1Compile = function () {
	        // if angular compiling, then need to also compile the cell again (angular compiling sucks, please wait...)
	        if (this.beans.gridOptionsWrapper.isAngularCompileRows()) {
	            var eGui = this.getGui();
	            // only compile the node if it hasn't already been done
	            // this prevents "orphaned" node leaks
	            if (!eGui.classList.contains('ng-scope') || eGui.childElementCount === 0) {
	                var compiledElement_1 = this.beans.$compile(eGui)(this.scope);
	                this.addDestroyFunc(function () { return compiledElement_1.remove(); });
	            }
	        }
	    };
	    CellComp.prototype.postProcessStylesFromColDef = function () {
	        var stylesToUse = this.processStylesFromColDef();
	        if (stylesToUse) {
	            addStylesToElement(this.getGui(), stylesToUse);
	        }
	    };
	    CellComp.prototype.preProcessStylesFromColDef = function () {
	        return cssStyleObjectToMarkup(this.processStylesFromColDef());
	    };
	    CellComp.prototype.processStylesFromColDef = function () {
	        var colDef = this.getComponentHolder();
	        if (colDef.cellStyle) {
	            var cssToUse = void 0;
	            if (typeof colDef.cellStyle === 'function') {
	                var cellStyleParams = {
	                    column: this.column,
	                    value: this.value,
	                    colDef: colDef,
	                    data: this.rowNode.data,
	                    node: this.rowNode,
	                    rowIndex: this.rowNode.rowIndex,
	                    $scope: this.scope,
	                    api: this.beans.gridOptionsWrapper.getApi(),
	                    columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	                    context: this.beans.gridOptionsWrapper.getContext(),
	                };
	                var cellStyleFunc = colDef.cellStyle;
	                cssToUse = cellStyleFunc(cellStyleParams);
	            }
	            else {
	                cssToUse = colDef.cellStyle;
	            }
	            return cssToUse;
	        }
	    };
	    CellComp.prototype.postProcessClassesFromColDef = function () {
	        var _this = this;
	        this.processClassesFromColDef(function (className) { return _this.addCssClass(className); });
	    };
	    CellComp.prototype.preProcessClassesFromColDef = function () {
	        var res = [];
	        this.processClassesFromColDef(function (className) { return res.push(className); });
	        return res;
	    };
	    CellComp.prototype.processClassesFromColDef = function (onApplicableClass) {
	        var colDef = this.getComponentHolder();
	        var cellClassParams = {
	            value: this.value,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: colDef,
	            rowIndex: this.rowNode.rowIndex,
	            $scope: this.scope,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        this.beans.stylingService.processStaticCellClasses(colDef, cellClassParams, onApplicableClass);
	    };
	    CellComp.prototype.putDataIntoCellAfterRefresh = function () {
	        // template gets preference, then cellRenderer, then do it ourselves
	        var colDef = this.getComponentHolder();
	        if (colDef.template) {
	            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
	            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
	            this.eCellValue.innerHTML = colDef.template;
	        }
	        else if (colDef.templateUrl) {
	            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
	            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
	            // not do these, but would follow a pattern that was friendly towards components, not templates.
	            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
	            if (template) {
	                this.eCellValue.innerHTML = template;
	            }
	        }
	        else {
	            // we can switch from using a cell renderer back to the default if a user
	            // is using cellRendererSelect
	            this.chooseCellRenderer();
	            if (this.usingCellRenderer) {
	                this.createCellRendererInstance();
	            }
	            else {
	                var valueToUse = this.getValueToUse();
	                if (valueToUse != null) {
	                    this.eCellValue.innerHTML = escapeString(valueToUse) || '';
	                }
	            }
	        }
	    };
	    CellComp.prototype.attemptCellRendererRefresh = function () {
	        if (missing(this.cellRenderer) || !this.cellRenderer || missing(this.cellRenderer.refresh)) {
	            return false;
	        }
	        // if the cell renderer has a refresh method, we call this instead of doing a refresh
	        var params = this.createCellRendererParams();
	        // take any custom params off of the user
	        var finalParams = this.beans.userComponentFactory.createFinalParams(this.getComponentHolder(), this.cellRendererType, params);
	        var result = this.cellRenderer.refresh(finalParams);
	        // NOTE on undefined: previous version of the cellRenderer.refresh() interface
	        // returned nothing, if the method existed, we assumed it refreshed. so for
	        // backwards compatibility, we assume if method exists and returns nothing,
	        // that it was successful.
	        return result === true || result === undefined;
	    };
	    CellComp.prototype.refreshToolTip = function () {
	        var newTooltip = this.getToolTip();
	        if (this.tooltip === newTooltip) {
	            return;
	        }
	        this.createTooltipFeatureIfNeeded();
	        var hasNewTooltip = exists(newTooltip);
	        if (hasNewTooltip && this.tooltip === newTooltip.toString()) {
	            return;
	        }
	        this.tooltip = newTooltip;
	        if (this.beans.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            if (hasNewTooltip) {
	                this.eCellValue.setAttribute('title', this.tooltip);
	            }
	            else {
	                this.eCellValue.removeAttribute('title');
	            }
	        }
	    };
	    CellComp.prototype.valuesAreEqual = function (val1, val2) {
	        // if the user provided an equals method, use that, otherwise do simple comparison
	        var colDef = this.getComponentHolder();
	        var equalsMethod = colDef ? colDef.equals : null;
	        return equalsMethod ? equalsMethod(val1, val2) : val1 === val2;
	    };
	    CellComp.prototype.getToolTip = function () {
	        var colDef = this.getComponentHolder();
	        var data = this.rowNode.data;
	        if (colDef.tooltipField && exists(data)) {
	            return getValueUsingField(data, colDef.tooltipField, this.column.isTooltipFieldContainsDots());
	        }
	        var valueGetter = colDef.tooltipValueGetter;
	        if (valueGetter) {
	            return valueGetter(__assign$4(__assign$4({ api: this.beans.gridOptionsWrapper.getApi(), columnApi: this.beans.gridOptionsWrapper.getColumnApi(), context: this.beans.gridOptionsWrapper.getContext() }, this.getTooltipParams()), { value: this.value }));
	        }
	        return null;
	    };
	    CellComp.prototype.getTooltipParams = function () {
	        return {
	            location: 'cell',
	            colDef: this.getComponentHolder(),
	            column: this.getColumn(),
	            rowIndex: this.cellPosition.rowIndex,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            value: this.getTooltipText(),
	            valueFormatted: this.valueFormatted,
	        };
	    };
	    CellComp.prototype.getTooltipText = function (escape) {
	        if (escape === void 0) { escape = true; }
	        return escape ? escapeString(this.tooltip) : this.tooltip;
	    };
	    CellComp.prototype.processCellClassRules = function (onApplicableClass, onNotApplicableClass) {
	        var colDef = this.getComponentHolder();
	        var cellClassParams = {
	            value: this.value,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: colDef,
	            rowIndex: this.cellPosition.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            $scope: this.scope,
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        this.beans.stylingService.processClassRules(colDef.cellClassRules, cellClassParams, onApplicableClass, onNotApplicableClass);
	    };
	    CellComp.prototype.postProcessCellClassRules = function () {
	        var _this = this;
	        this.processCellClassRules(function (className) { return _this.addCssClass(className); }, function (className) { return _this.removeCssClass(className); });
	    };
	    CellComp.prototype.preProcessCellClassRules = function () {
	        var res = [];
	        this.processCellClassRules(function (className) { return res.push(className); }, function (_) {
	            // not catered for, if creating, no need
	            // to remove class as it was never there
	        });
	        return res;
	    };
	    // a wrapper is used when we are putting a selection checkbox in the cell with the value
	    CellComp.prototype.setUsingWrapper = function () {
	        var colDef = this.getComponentHolder();
	        // never allow selection or dragging on pinned rows
	        if (this.rowNode.rowPinned) {
	            this.usingWrapper = false;
	            this.includeSelectionComponent = false;
	            this.includeRowDraggingComponent = false;
	            this.includeDndSourceComponent = false;
	            return;
	        }
	        var cbSelectionIsFunc = typeof colDef.checkboxSelection === 'function';
	        var rowDraggableIsFunc = typeof colDef.rowDrag === 'function';
	        var dndSourceIsFunc = typeof colDef.dndSource === 'function';
	        this.includeSelectionComponent = cbSelectionIsFunc || colDef.checkboxSelection === true;
	        this.includeRowDraggingComponent = rowDraggableIsFunc || colDef.rowDrag === true;
	        this.includeDndSourceComponent = dndSourceIsFunc || colDef.dndSource === true;
	        var enableTextSelection = this.beans.gridOptionsWrapper.isEnableCellTextSelection();
	        this.usingWrapper = enableTextSelection || this.includeRowDraggingComponent || this.includeSelectionComponent || this.includeDndSourceComponent;
	    };
	    CellComp.prototype.chooseCellRenderer = function () {
	        // template gets preference, then cellRenderer, then do it ourselves
	        var colDef = this.getComponentHolder();
	        // templates are for ng1, ideally we wouldn't have these, they are ng1 support
	        // inside the core which is bad
	        if (colDef.template || colDef.templateUrl) {
	            this.usingCellRenderer = false;
	            return;
	        }
	        var params = this.createCellRendererParams();
	        if (this.rowNode.rowPinned &&
	            this.beans.userComponentFactory.lookupComponentClassDef(colDef, 'pinnedRowCellRenderer', params)) {
	            this.cellRendererType = CellComp.CELL_RENDERER_TYPE_PINNED;
	            this.usingCellRenderer = true;
	        }
	        else if (this.beans.userComponentFactory.lookupComponentClassDef(colDef, 'cellRenderer', params)) {
	            this.cellRendererType = CellComp.CELL_RENDERER_TYPE_NORMAL;
	            this.usingCellRenderer = true;
	        }
	        else {
	            this.usingCellRenderer = false;
	        }
	    };
	    CellComp.prototype.createCellRendererInstance = function (useTaskService) {
	        var _this = this;
	        if (useTaskService === void 0) { useTaskService = false; }
	        if (!this.usingCellRenderer) {
	            return;
	        }
	        // never use task service if angularCompileRows=true, as that assume the cell renderers
	        // are finished when the row is created. also we never use it if animation frame service
	        // is turned off.
	        // and lastly we never use it if doing auto-height, as the auto-height service checks the
	        // row height directly after the cell is created, it doesn't wait around for the tasks to complete
	        var angularCompileRows = this.beans.gridOptionsWrapper.isAngularCompileRows();
	        var suppressAnimationFrame = this.beans.gridOptionsWrapper.isSuppressAnimationFrame();
	        if (angularCompileRows || suppressAnimationFrame || this.autoHeightCell) {
	            useTaskService = false;
	        }
	        var params = this.createCellRendererParams();
	        this.cellRendererVersion++;
	        var callback = this.afterCellRendererCreated.bind(this, this.cellRendererVersion);
	        var cellRendererTypeNormal = this.cellRendererType === CellComp.CELL_RENDERER_TYPE_NORMAL;
	        this.createCellRendererFunc = function () {
	            _this.createCellRendererFunc = null;
	            // this can return null in the event that the user has switched from a renderer component to nothing, for example
	            // when using a cellRendererSelect to return a component or null depending on row data etc
	            var componentPromise = _this.beans.userComponentFactory.newCellRenderer(_this.getComponentHolder(), params, !cellRendererTypeNormal);
	            if (componentPromise) {
	                componentPromise.then(callback);
	            }
	        };
	        if (useTaskService) {
	            this.beans.taskQueue.createTask(this.createCellRendererFunc, this.rowNode.rowIndex, 'createTasksP2');
	        }
	        else {
	            this.createCellRendererFunc();
	        }
	    };
	    CellComp.prototype.afterCellRendererCreated = function (cellRendererVersion, cellRenderer) {
	        var cellRendererNotRequired = !this.isAlive() || cellRendererVersion !== this.cellRendererVersion;
	        if (cellRendererNotRequired) {
	            this.beans.context.destroyBean(cellRenderer);
	            return;
	        }
	        this.cellRenderer = cellRenderer;
	        this.cellRendererGui = this.cellRenderer.getGui();
	        if (missing(this.cellRendererGui)) {
	            return;
	        }
	        // if async components, then it's possible the user started editing since this call was made
	        if (!this.editingCell) {
	            this.eCellValue.appendChild(this.cellRendererGui);
	        }
	    };
	    CellComp.prototype.createCellRendererParams = function () {
	        var _this = this;
	        return {
	            value: this.value,
	            valueFormatted: this.valueFormatted,
	            getValue: this.getValue.bind(this),
	            setValue: function (value) { return _this.beans.valueService.setValue(_this.rowNode, _this.column, value); },
	            formatValue: this.formatValue.bind(this),
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: this.getComponentHolder(),
	            column: this.column,
	            $scope: this.scope,
	            rowIndex: this.cellPosition.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            refreshCell: this.refreshCell.bind(this),
	            eGridCell: this.getGui(),
	            eParentOfValue: this.eCellValue,
	            registerRowDragger: function (rowDraggerElement, dragStartPixels) { return _this.addRowDragging(rowDraggerElement, dragStartPixels); },
	            // these bits are not documented anywhere, so we could drop them?
	            // it was in the olden days to allow user to register for when rendered
	            // row was removed (the row comp was removed), however now that the user
	            // can provide components for cells, the destroy method gets call when this
	            // happens so no longer need to fire event.
	            addRowCompListener: this.rowComp ? this.rowComp.addEventListener.bind(this.rowComp) : null,
	            addRenderedRowListener: function (eventType, listener) {
	                console.warn('AG Grid: since AG Grid .v11, params.addRenderedRowListener() is now params.addRowCompListener()');
	                if (_this.rowComp) {
	                    _this.rowComp.addEventListener(eventType, listener);
	                }
	            }
	        };
	    };
	    CellComp.prototype.formatValue = function (value) {
	        var valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, value);
	        return valueFormatted != null ? valueFormatted : value;
	    };
	    CellComp.prototype.getValueToUse = function () {
	        return this.valueFormatted != null ? this.valueFormatted : this.value;
	    };
	    CellComp.prototype.getValueAndFormat = function () {
	        this.value = this.getValue();
	        this.valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, this.value);
	    };
	    CellComp.prototype.getValue = function () {
	        // if we don't check this, then the grid will render leaf groups as open even if we are not
	        // allowing the user to open leaf groups. confused? remember for pivot mode we don't allow
	        // opening leaf groups, so we have to force leafGroups to be closed in case the user expanded
	        // them via the API, or user user expanded them in the UI before turning on pivot mode
	        var lockedClosedGroup = this.rowNode.leafGroup && this.beans.columnController.isPivotMode();
	        var isOpenGroup = this.rowNode.group && this.rowNode.expanded && !this.rowNode.footer && !lockedClosedGroup;
	        // are we showing group footers
	        var groupFootersEnabled = this.beans.gridOptionsWrapper.isGroupIncludeFooter();
	        // if doing footers, we normally don't show agg data at group level when group is open
	        var groupAlwaysShowAggData = this.beans.gridOptionsWrapper.isGroupSuppressBlankHeader();
	        // if doing grouping and footers, we don't want to include the agg value
	        // in the header when the group is open
	        var ignoreAggData = (isOpenGroup && groupFootersEnabled) && !groupAlwaysShowAggData;
	        var value = this.beans.valueService.getValue(this.column, this.rowNode, false, ignoreAggData);
	        return value;
	    };
	    CellComp.prototype.onMouseEvent = function (eventName, mouseEvent) {
	        if (isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        switch (eventName) {
	            case 'click':
	                this.onCellClicked(mouseEvent);
	                break;
	            case 'mousedown':
	                this.onMouseDown(mouseEvent);
	                break;
	            case 'dblclick':
	                this.onCellDoubleClicked(mouseEvent);
	                break;
	            case 'mouseout':
	                this.onMouseOut(mouseEvent);
	                break;
	            case 'mouseover':
	                this.onMouseOver(mouseEvent);
	                break;
	        }
	    };
	    CellComp.prototype.dispatchCellContextMenuEvent = function (event) {
	        var colDef = this.getComponentHolder();
	        var cellContextMenuEvent = this.createEvent(event, Events.EVENT_CELL_CONTEXT_MENU);
	        this.beans.eventService.dispatchEvent(cellContextMenuEvent);
	        if (colDef.onCellContextMenu) {
	            // to make the callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellContextMenu(cellContextMenuEvent); }, 0);
	        }
	    };
	    CellComp.prototype.createEvent = function (domEvent, eventType) {
	        var event = {
	            type: eventType,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            value: this.value,
	            column: this.column,
	            colDef: this.getComponentHolder(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            api: this.beans.gridApi,
	            columnApi: this.beans.columnApi,
	            rowPinned: this.rowNode.rowPinned,
	            event: domEvent,
	            rowIndex: this.rowNode.rowIndex
	        };
	        // because we are hacking in $scope for angular 1, we have to de-reference
	        if (this.scope) {
	            event.$scope = this.scope;
	        }
	        return event;
	    };
	    CellComp.prototype.onMouseOut = function (mouseEvent) {
	        var cellMouseOutEvent = this.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_OUT);
	        this.beans.eventService.dispatchEvent(cellMouseOutEvent);
	        this.beans.columnHoverService.clearMouseOver();
	    };
	    CellComp.prototype.onMouseOver = function (mouseEvent) {
	        var cellMouseOverEvent = this.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_OVER);
	        this.beans.eventService.dispatchEvent(cellMouseOverEvent);
	        this.beans.columnHoverService.setMouseOver([this.column]);
	    };
	    CellComp.prototype.onCellDoubleClicked = function (mouseEvent) {
	        var colDef = this.getComponentHolder();
	        // always dispatch event to eventService
	        var cellDoubleClickedEvent = this.createEvent(mouseEvent, Events.EVENT_CELL_DOUBLE_CLICKED);
	        this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);
	        // check if colDef also wants to handle event
	        if (typeof colDef.onCellDoubleClicked === 'function') {
	            // to make the callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellDoubleClicked(cellDoubleClickedEvent); }, 0);
	        }
	        var editOnDoubleClick = !this.beans.gridOptionsWrapper.isSingleClickEdit()
	            && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
	        if (editOnDoubleClick) {
	            this.startRowOrCellEdit();
	        }
	    };
	    // called by rowRenderer when user navigates via tab key
	    CellComp.prototype.startRowOrCellEdit = function (keyPress, charPress) {
	        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
	            this.rowComp.startRowEditing(keyPress, charPress, this);
	        }
	        else {
	            this.startEditingIfEnabled(keyPress, charPress, true);
	        }
	    };
	    CellComp.prototype.isCellEditable = function () {
	        return this.column.isCellEditable(this.rowNode);
	    };
	    // either called internally if single cell editing, or called by rowRenderer if row editing
	    CellComp.prototype.startEditingIfEnabled = function (keyPress, charPress, cellStartedEdit) {
	        if (keyPress === void 0) { keyPress = null; }
	        if (charPress === void 0) { charPress = null; }
	        if (cellStartedEdit === void 0) { cellStartedEdit = false; }
	        // don't do it if not editable
	        if (!this.isCellEditable()) {
	            return;
	        }
	        // don't do it if already editing
	        if (this.editingCell) {
	            return;
	        }
	        this.editingCell = true;
	        this.cellEditorVersion++;
	        var callback = this.afterCellEditorCreated.bind(this, this.cellEditorVersion);
	        var params = this.createCellEditorParams(keyPress, charPress, cellStartedEdit);
	        this.createCellEditor(params).then(callback);
	        // if we don't do this, and editor component is async, then there will be a period
	        // when the component isn't present and keyboard navigation won't work - so example
	        // of user hitting tab quickly (more quickly than renderers getting created) won't work
	        var cellEditorAsync = missing(this.cellEditor);
	        if (cellEditorAsync && cellStartedEdit) {
	            this.focusCell(true);
	        }
	    };
	    CellComp.prototype.createCellEditor = function (params) {
	        var _this = this;
	        var cellEditorPromise = this.beans.userComponentFactory.newCellEditor(this.column.getColDef(), params);
	        return cellEditorPromise.then(function (cellEditor) {
	            var cellEditorComp = cellEditor;
	            var isPopup = cellEditorComp.isPopup && cellEditorComp.isPopup();
	            if (!isPopup) {
	                return cellEditorComp;
	            }
	            if (_this.beans.gridOptionsWrapper.isFullRowEdit()) {
	                console.warn('AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both ' +
	                    '- either turn off fullRowEdit, or stop using popup editors.');
	            }
	            // if a popup, then we wrap in a popup editor and return the popup
	            var popupEditorWrapper = new PopupEditorWrapper(cellEditorComp);
	            _this.beans.context.createBean(popupEditorWrapper);
	            popupEditorWrapper.init(params);
	            return popupEditorWrapper;
	        });
	    };
	    CellComp.prototype.afterCellEditorCreated = function (cellEditorVersion, cellEditor) {
	        // if editingCell=false, means user cancelled the editor before component was ready.
	        // if versionMismatch, then user cancelled the edit, then started the edit again, and this
	        //   is the first editor which is now stale.
	        var versionMismatch = cellEditorVersion !== this.cellEditorVersion;
	        var cellEditorNotNeeded = versionMismatch || !this.editingCell;
	        if (cellEditorNotNeeded) {
	            this.beans.context.destroyBean(cellEditor);
	            return;
	        }
	        var editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
	        if (editingCancelledByUserComp) {
	            this.beans.context.destroyBean(cellEditor);
	            this.editingCell = false;
	            return;
	        }
	        if (!cellEditor.getGui) {
	            console.warn("AG Grid: cellEditor for column " + this.column.getId() + " is missing getGui() method");
	            // no getGui, for React guys, see if they attached a react component directly
	            if (cellEditor.render) {
	                console.warn("AG Grid: we found 'render' on the component, are you trying to set a React renderer but added it as colDef.cellEditor instead of colDef.cellEditorFmk?");
	            }
	            this.beans.context.destroyBean(cellEditor);
	            this.editingCell = false;
	            return;
	        }
	        this.cellEditor = cellEditor;
	        this.cellEditorInPopup = cellEditor.isPopup !== undefined && cellEditor.isPopup();
	        this.setInlineEditingClass();
	        if (this.cellEditorInPopup) {
	            this.addPopupCellEditor();
	        }
	        else {
	            this.addInCellEditor();
	        }
	        if (cellEditor.afterGuiAttached) {
	            cellEditor.afterGuiAttached();
	        }
	        var event = this.createEvent(null, Events.EVENT_CELL_EDITING_STARTED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    CellComp.prototype.addInCellEditor = function () {
	        var eGui = this.getGui();
	        // if focus is inside the cell, we move focus to the cell itself
	        // before removing it's contents, otherwise errors could be thrown.
	        if (eGui.contains(document.activeElement)) {
	            eGui.focus();
	        }
	        this.clearCellElement();
	        if (this.cellEditor) {
	            eGui.appendChild(this.cellEditor.getGui());
	        }
	        this.angular1Compile();
	    };
	    CellComp.prototype.addPopupCellEditor = function () {
	        var _this = this;
	        var ePopupGui = this.cellEditor && this.cellEditor.getGui();
	        if (!ePopupGui) {
	            return;
	        }
	        var popupService = this.beans.popupService;
	        var useModelPopup = this.beans.gridOptionsWrapper.isStopEditingWhenCellsLoseFocus();
	        var position = this.cellEditor && this.cellEditor.getPopupPosition ? this.cellEditor.getPopupPosition() : 'over';
	        var params = {
	            column: this.column,
	            rowNode: this.rowNode,
	            type: 'popupCellEditor',
	            eventSource: this.getGui(),
	            ePopup: ePopupGui,
	            keepWithinBounds: true
	        };
	        var positionCallback = position === 'under' ?
	            popupService.positionPopupUnderComponent.bind(popupService, params)
	            : popupService.positionPopupOverComponent.bind(popupService, params);
	        var addPopupRes = popupService.addPopup({
	            modal: useModelPopup,
	            eChild: ePopupGui,
	            closeOnEsc: true,
	            closedCallback: function () { _this.onPopupEditorClosed(); },
	            anchorToElement: this.getGui(),
	            positionCallback: positionCallback
	        });
	        if (addPopupRes) {
	            this.hideEditorPopup = addPopupRes.hideFunc;
	        }
	        this.angular1Compile();
	    };
	    CellComp.prototype.onPopupEditorClosed = function () {
	        // we only call stopEditing if we are editing, as
	        // it's possible the popup called 'stop editing'
	        // before this, eg if 'enter key' was pressed on
	        // the editor.
	        if (!this.editingCell) {
	            return;
	        }
	        // note: this only happens when use clicks outside of the grid. if use clicks on another
	        // cell, then the editing will have already stopped on this cell
	        this.stopRowOrCellEdit();
	    };
	    // if we are editing inline, then we don't have the padding in the cell (set in the themes)
	    // to allow the text editor full access to the entire cell
	    CellComp.prototype.setInlineEditingClass = function () {
	        if (!this.isAlive()) {
	            return;
	        }
	        // ag-cell-inline-editing - appears when user is inline editing
	        // ag-cell-not-inline-editing - appears when user is no inline editing
	        // ag-cell-popup-editing - appears when user is editing cell in popup (appears on the cell, not on the popup)
	        // note: one of {ag-cell-inline-editing, ag-cell-not-inline-editing} is always present, they toggle.
	        //       however {ag-cell-popup-editing} shows when popup, so you have both {ag-cell-popup-editing}
	        //       and {ag-cell-not-inline-editing} showing at the same time.
	        var editingInline = this.editingCell && !this.cellEditorInPopup;
	        var popupEditorShowing = this.editingCell && this.cellEditorInPopup;
	        this.addOrRemoveCssClass(CSS_INLINE_EDITING, editingInline);
	        this.addOrRemoveCssClass(CSS_NOT_INLINE_EDITING, !editingInline);
	        this.addOrRemoveCssClass(CSS_POPUP_EDITING, popupEditorShowing);
	        addOrRemoveCssClass(this.getGui().parentNode, "ag-row-inline-editing", editingInline);
	        addOrRemoveCssClass(this.getGui().parentNode, "ag-row-not-inline-editing", !editingInline);
	    };
	    CellComp.prototype.createCellEditorParams = function (keyPress, charPress, cellStartedEdit) {
	        return {
	            value: this.getValue(),
	            keyPress: keyPress,
	            charPress: charPress,
	            column: this.column,
	            colDef: this.column.getColDef(),
	            rowIndex: this.cellPosition.rowIndex,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            cellStartedEdit: cellStartedEdit,
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            $scope: this.scope,
	            onKeyDown: this.onKeyDown.bind(this),
	            stopEditing: this.stopEditingAndFocus.bind(this),
	            eGridCell: this.getGui(),
	            parseValue: this.parseValue.bind(this),
	            formatValue: this.formatValue.bind(this)
	        };
	    };
	    // cell editors call this, when they want to stop for reasons other
	    // than what we pick up on. eg selecting from a dropdown ends editing.
	    CellComp.prototype.stopEditingAndFocus = function (suppressNavigateAfterEdit) {
	        if (suppressNavigateAfterEdit === void 0) { suppressNavigateAfterEdit = false; }
	        this.stopRowOrCellEdit();
	        this.focusCell(true);
	        if (!suppressNavigateAfterEdit) {
	            this.navigateAfterEdit();
	        }
	    };
	    CellComp.prototype.parseValue = function (newValue) {
	        var colDef = this.getComponentHolder();
	        var params = {
	            node: this.rowNode,
	            data: this.rowNode.data,
	            oldValue: this.value,
	            newValue: newValue,
	            colDef: colDef,
	            column: this.column,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        var valueParser = colDef.valueParser;
	        return exists(valueParser) ? this.beans.expressionService.evaluate(valueParser, params) : newValue;
	    };
	    CellComp.prototype.focusCell = function (forceBrowserFocus) {
	        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
	        this.beans.focusController.setFocusedCell(this.cellPosition.rowIndex, this.column, this.rowNode.rowPinned, forceBrowserFocus);
	    };
	    CellComp.prototype.setFocusInOnEditor = function () {
	        if (this.editingCell) {
	            if (this.cellEditor && this.cellEditor.focusIn) {
	                // if the editor is present, then we just focus it
	                this.cellEditor.focusIn();
	            }
	            else {
	                // if the editor is not present, it means async cell editor (eg React fibre)
	                // and we are trying to set focus before the cell editor is present, so we
	                // focus the cell instead
	                this.focusCell(true);
	            }
	        }
	    };
	    CellComp.prototype.isEditing = function () {
	        return this.editingCell;
	    };
	    CellComp.prototype.onKeyDown = function (event) {
	        var key = event.which || event.keyCode;
	        switch (key) {
	            case KeyCode.ENTER:
	                this.onEnterKeyDown(event);
	                break;
	            case KeyCode.F2:
	                this.onF2KeyDown();
	                break;
	            case KeyCode.ESCAPE:
	                this.onEscapeKeyDown();
	                break;
	            case KeyCode.TAB:
	                this.onTabKeyDown(event);
	                break;
	            case KeyCode.BACKSPACE:
	            case KeyCode.DELETE:
	                this.onBackspaceOrDeleteKeyPressed(key);
	                break;
	            case KeyCode.DOWN:
	            case KeyCode.UP:
	            case KeyCode.RIGHT:
	            case KeyCode.LEFT:
	                this.onNavigationKeyPressed(event, key);
	                break;
	        }
	    };
	    CellComp.prototype.setFocusOutOnEditor = function () {
	        if (this.editingCell && this.cellEditor && this.cellEditor.focusOut) {
	            this.cellEditor.focusOut();
	        }
	    };
	    CellComp.prototype.onNavigationKeyPressed = function (event, key) {
	        if (this.editingCell) {
	            return;
	        }
	        if (event.shiftKey && this.rangeSelectionEnabled) {
	            this.onShiftRangeSelect(key);
	        }
	        else {
	            this.beans.rowRenderer.navigateToNextCell(event, key, this.cellPosition, true);
	        }
	        // if we don't prevent default, the grid will scroll with the navigation keys
	        event.preventDefault();
	    };
	    CellComp.prototype.onShiftRangeSelect = function (key) {
	        if (!this.beans.rangeController) {
	            return;
	        }
	        var endCell = this.beans.rangeController.extendLatestRangeInDirection(key);
	        if (endCell) {
	            this.beans.rowRenderer.ensureCellVisible(endCell);
	        }
	    };
	    CellComp.prototype.onTabKeyDown = function (event) {
	        this.beans.rowRenderer.onTabKeyDown(this, event);
	    };
	    CellComp.prototype.onBackspaceOrDeleteKeyPressed = function (key) {
	        if (!this.editingCell) {
	            this.startRowOrCellEdit(key);
	        }
	    };
	    CellComp.prototype.onEnterKeyDown = function (e) {
	        if (this.editingCell || this.rowComp.isEditing()) {
	            this.stopEditingAndFocus();
	        }
	        else {
	            if (this.beans.gridOptionsWrapper.isEnterMovesDown()) {
	                this.beans.rowRenderer.navigateToNextCell(null, KeyCode.DOWN, this.cellPosition, false);
	            }
	            else {
	                this.startRowOrCellEdit(KeyCode.ENTER);
	                if (this.editingCell) {
	                    // if we started editing, then we need to prevent default, otherwise the Enter action can get
	                    // applied to the cell editor. this happened, for example, with largeTextCellEditor where not
	                    // preventing default results in a 'new line' character getting inserted in the text area
	                    // when the editing was started
	                    e.preventDefault();
	                }
	            }
	        }
	    };
	    CellComp.prototype.navigateAfterEdit = function () {
	        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
	        if (fullRowEdit) {
	            return;
	        }
	        var enterMovesDownAfterEdit = this.beans.gridOptionsWrapper.isEnterMovesDownAfterEdit();
	        if (enterMovesDownAfterEdit) {
	            this.beans.rowRenderer.navigateToNextCell(null, KeyCode.DOWN, this.cellPosition, false);
	        }
	    };
	    CellComp.prototype.onF2KeyDown = function () {
	        if (!this.editingCell) {
	            this.startRowOrCellEdit(KeyCode.F2);
	        }
	    };
	    CellComp.prototype.onEscapeKeyDown = function () {
	        if (this.editingCell) {
	            this.stopRowOrCellEdit(true);
	            this.focusCell(true);
	        }
	    };
	    CellComp.prototype.onKeyPress = function (event) {
	        // check this, in case focus is on a (for example) a text field inside the cell,
	        // in which cse we should not be listening for these key pressed
	        var eventTarget = getTarget(event);
	        var eventOnChildComponent = eventTarget !== this.getGui();
	        if (eventOnChildComponent || this.editingCell) {
	            return;
	        }
	        var pressedChar = String.fromCharCode(event.charCode);
	        if (pressedChar === ' ') {
	            this.onSpaceKeyPressed(event);
	        }
	        else if (isEventFromPrintableCharacter(event)) {
	            this.startRowOrCellEdit(null, pressedChar);
	            // if we don't prevent default, then the keypress also gets applied to the text field
	            // (at least when doing the default editor), but we need to allow the editor to decide
	            // what it wants to do. we only do this IF editing was started - otherwise it messes
	            // up when the use is not doing editing, but using rendering with text fields in cellRenderer
	            // (as it would block the the user from typing into text fields).
	            event.preventDefault();
	        }
	    };
	    CellComp.prototype.onSpaceKeyPressed = function (event) {
	        var gridOptionsWrapper = this.beans.gridOptionsWrapper;
	        if (!this.editingCell && gridOptionsWrapper.isRowSelection()) {
	            var currentSelection = this.rowNode.isSelected();
	            var newSelection = !currentSelection;
	            if (newSelection || !gridOptionsWrapper.isSuppressRowDeselection()) {
	                var groupSelectsFiltered = this.beans.gridOptionsWrapper.isGroupSelectsFiltered();
	                var updatedCount = this.rowNode.setSelectedParams({
	                    newValue: newSelection,
	                    rangeSelect: event.shiftKey,
	                    groupSelectsFiltered: groupSelectsFiltered
	                });
	                if (currentSelection === undefined && updatedCount === 0) {
	                    this.rowNode.setSelectedParams({
	                        newValue: false,
	                        rangeSelect: event.shiftKey,
	                        groupSelectsFiltered: groupSelectsFiltered
	                    });
	                }
	            }
	        }
	        // prevent default as space key, by default, moves browser scroll down
	        event.preventDefault();
	    };
	    CellComp.prototype.onMouseDown = function (mouseEvent) {
	        var ctrlKey = mouseEvent.ctrlKey, metaKey = mouseEvent.metaKey, shiftKey = mouseEvent.shiftKey;
	        var target = mouseEvent.target;
	        var _a = this.beans, eventService = _a.eventService, rangeController = _a.rangeController;
	        // do not change the range for right-clicks inside an existing range
	        if (this.isRightClickInExistingRange(mouseEvent)) {
	            return;
	        }
	        if (!shiftKey || (rangeController && !rangeController.getCellRanges().length)) {
	            // We only need to pass true to focusCell when the browser is IE/Edge and we are trying
	            // to focus the cell itself. This should never be true if the mousedown was triggered
	            // due to a click on a cell editor for example.
	            var forceBrowserFocus = (isBrowserIE() || isBrowserEdge()) && !this.editingCell && !isFocusableFormField(target);
	            this.focusCell(forceBrowserFocus);
	        }
	        else if (rangeController) {
	            // if a range is being changed, we need to make sure the focused cell does not change.
	            mouseEvent.preventDefault();
	        }
	        // if we are clicking on a checkbox, we need to make sure the cell wrapping that checkbox
	        // is focused but we don't want to change the range selection, so return here.
	        if (this.containsWidget(target)) {
	            return;
	        }
	        if (rangeController) {
	            var thisCell = this.cellPosition;
	            if (shiftKey) {
	                rangeController.extendLatestRangeToCell(thisCell);
	            }
	            else {
	                var ctrlKeyPressed = ctrlKey || metaKey;
	                rangeController.setRangeToCell(thisCell, ctrlKeyPressed);
	            }
	        }
	        eventService.dispatchEvent(this.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_DOWN));
	    };
	    CellComp.prototype.isRightClickInExistingRange = function (mouseEvent) {
	        var rangeController = this.beans.rangeController;
	        if (rangeController) {
	            var cellInRange = rangeController.isCellInAnyRange(this.getCellPosition());
	            if (cellInRange && mouseEvent.button === 2) {
	                return true;
	            }
	        }
	        return false;
	    };
	    CellComp.prototype.containsWidget = function (target) {
	        return isElementChildOfClass(target, 'ag-selection-checkbox', 3);
	    };
	    // returns true if on iPad and this is second 'click' event in 200ms
	    CellComp.prototype.isDoubleClickOnIPad = function () {
	        if (!isIOSUserAgent() || isEventSupported('dblclick')) {
	            return false;
	        }
	        var nowMillis = new Date().getTime();
	        var res = nowMillis - this.lastIPadMouseClickEvent < 200;
	        this.lastIPadMouseClickEvent = nowMillis;
	        return res;
	    };
	    CellComp.prototype.onCellClicked = function (mouseEvent) {
	        // iPad doesn't have double click - so we need to mimic it to enable editing for iPad.
	        if (this.isDoubleClickOnIPad()) {
	            this.onCellDoubleClicked(mouseEvent);
	            mouseEvent.preventDefault(); // if we don't do this, then iPad zooms in
	            return;
	        }
	        var _a = this.beans, eventService = _a.eventService, gridOptionsWrapper = _a.gridOptionsWrapper;
	        var cellClickedEvent = this.createEvent(mouseEvent, Events.EVENT_CELL_CLICKED);
	        eventService.dispatchEvent(cellClickedEvent);
	        var colDef = this.getComponentHolder();
	        if (colDef.onCellClicked) {
	            // to make callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellClicked(cellClickedEvent); }, 0);
	        }
	        var editOnSingleClick = (gridOptionsWrapper.isSingleClickEdit() || colDef.singleClickEdit)
	            && !gridOptionsWrapper.isSuppressClickEdit();
	        if (editOnSingleClick) {
	            this.startRowOrCellEdit();
	        }
	    };
	    CellComp.prototype.createGridCellVo = function () {
	        this.cellPosition = {
	            rowIndex: this.rowNode.rowIndex,
	            rowPinned: this.rowNode.rowPinned,
	            column: this.column
	        };
	    };
	    CellComp.prototype.getRowPosition = function () {
	        return {
	            rowIndex: this.cellPosition.rowIndex,
	            rowPinned: this.cellPosition.rowPinned
	        };
	    };
	    CellComp.prototype.getCellPosition = function () {
	        return this.cellPosition;
	    };
	    CellComp.prototype.getParentRow = function () {
	        return this.eRow;
	    };
	    CellComp.prototype.setParentRow = function (eParentRow) {
	        this.eRow = eParentRow;
	    };
	    CellComp.prototype.getColumn = function () {
	        return this.column;
	    };
	    CellComp.prototype.getComponentHolder = function () {
	        return this.column.getColDef();
	    };
	    CellComp.prototype.detach = function () {
	        this.eRow.removeChild(this.getGui());
	    };
	    // if the row is also getting destroyed, then we don't need to remove from dom,
	    // as the row will also get removed, so no need to take out the cells from the row
	    // if the row is going (removing is an expensive operation, so only need to remove
	    // the top part)
	    //
	    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
	    CellComp.prototype.destroy = function () {
	        if (this.createCellRendererFunc) {
	            this.beans.taskQueue.cancelTask(this.createCellRendererFunc);
	        }
	        this.stopEditing();
	        this.cellRenderer = this.beans.context.destroyBean(this.cellRenderer);
	        this.beans.context.destroyBean(this.selectionHandle);
	        _super.prototype.destroy.call(this);
	    };
	    CellComp.prototype.onLeftChanged = function () {
	        var left = this.modifyLeftForPrintLayout(this.getCellLeft());
	        this.getGui().style.left = left + 'px';
	        this.refreshAriaIndex();
	    };
	    CellComp.prototype.modifyLeftForPrintLayout = function (leftPosition) {
	        if (!this.printLayout || this.column.getPinned() === Constants.PINNED_LEFT) {
	            return leftPosition;
	        }
	        var leftWidth = this.beans.columnController.getDisplayedColumnsLeftWidth();
	        if (this.column.getPinned() === Constants.PINNED_RIGHT) {
	            var bodyWidth = this.beans.columnController.getBodyContainerWidth();
	            return leftWidth + bodyWidth + (leftPosition || 0);
	        }
	        // is in body
	        return leftWidth + (leftPosition || 0);
	    };
	    CellComp.prototype.onWidthChanged = function () {
	        var width = this.getCellWidth();
	        this.getGui().style.width = width + "px";
	    };
	    CellComp.prototype.getRangeBorders = function () {
	        var _this = this;
	        var isRtl = this.beans.gridOptionsWrapper.isEnableRtl();
	        var top = false;
	        var right = false;
	        var bottom = false;
	        var left = false;
	        var thisCol = this.cellPosition.column;
	        var _a = this.beans, rangeController = _a.rangeController, columnController = _a.columnController;
	        var leftCol;
	        var rightCol;
	        if (isRtl) {
	            leftCol = columnController.getDisplayedColAfter(thisCol);
	            rightCol = columnController.getDisplayedColBefore(thisCol);
	        }
	        else {
	            leftCol = columnController.getDisplayedColBefore(thisCol);
	            rightCol = columnController.getDisplayedColAfter(thisCol);
	        }
	        var ranges = rangeController.getCellRanges().filter(function (range) { return rangeController.isCellInSpecificRange(_this.cellPosition, range); });
	        // this means we are the first column in the grid
	        if (!leftCol) {
	            left = true;
	        }
	        // this means we are the last column in the grid
	        if (!rightCol) {
	            right = true;
	        }
	        for (var i = 0; i < ranges.length; i++) {
	            if (top && right && bottom && left) {
	                break;
	            }
	            var range = ranges[i];
	            var startRow = rangeController.getRangeStartRow(range);
	            var endRow = rangeController.getRangeEndRow(range);
	            if (!top && this.beans.rowPositionUtils.sameRow(startRow, this.cellPosition)) {
	                top = true;
	            }
	            if (!bottom && this.beans.rowPositionUtils.sameRow(endRow, this.cellPosition)) {
	                bottom = true;
	            }
	            if (!left && leftCol && range.columns.indexOf(leftCol) < 0) {
	                left = true;
	            }
	            if (!right && rightCol && range.columns.indexOf(rightCol) < 0) {
	                right = true;
	            }
	        }
	        return { top: top, right: right, bottom: bottom, left: left };
	    };
	    CellComp.prototype.getInitialRangeClasses = function () {
	        var classes = [];
	        if (!this.rangeSelectionEnabled || !this.rangeCount) {
	            return classes;
	        }
	        classes.push(CSS_RANGE_SELECTED);
	        if (this.hasChartRange) {
	            classes.push(CSS_RANGE_CHART);
	        }
	        var count = Math.min(this.rangeCount, 4);
	        classes.push(CSS_RANGE_SELECTED + "-" + count);
	        if (this.isSingleCell()) {
	            classes.push(CSS_RANGE_SINGLE_CELL);
	        }
	        if (this.rangeCount > 0) {
	            var borders = this.getRangeBorders();
	            if (borders.top) {
	                classes.push(CSS_RANGE_TOP);
	            }
	            if (borders.right) {
	                classes.push(CSS_RANGE_RIGHT);
	            }
	            if (borders.bottom) {
	                classes.push(CSS_RANGE_BOTTOM);
	            }
	            if (borders.left) {
	                classes.push(CSS_RANGE_LEFT);
	            }
	        }
	        if (!!this.selectionHandle) {
	            classes.push(CSS_RANGE_HANDLE);
	        }
	        return classes;
	    };
	    CellComp.prototype.onRowIndexChanged = function () {
	        // when index changes, this influences items that need the index, so we update the
	        // grid cell so they are working off the new index.
	        this.createGridCellVo();
	        // when the index of the row changes, ie means the cell may have lost or gained focus
	        this.onCellFocused();
	        // check range selection
	        this.onRangeSelectionChanged();
	    };
	    CellComp.prototype.onRangeSelectionChanged = function () {
	        var rangeController = this.beans.rangeController;
	        if (!rangeController) {
	            return;
	        }
	        var _a = this, cellPosition = _a.cellPosition, rangeCount = _a.rangeCount;
	        var newRangeCount = rangeController.getCellRangeCount(cellPosition);
	        var element = this.getGui();
	        if (rangeCount !== newRangeCount) {
	            this.addOrRemoveCssClass(CSS_RANGE_SELECTED, newRangeCount !== 0);
	            this.addOrRemoveCssClass(CSS_RANGE_SELECTED + "-1", newRangeCount === 1);
	            this.addOrRemoveCssClass(CSS_RANGE_SELECTED + "-2", newRangeCount === 2);
	            this.addOrRemoveCssClass(CSS_RANGE_SELECTED + "-3", newRangeCount === 3);
	            this.addOrRemoveCssClass(CSS_RANGE_SELECTED + "-4", newRangeCount >= 4);
	            this.rangeCount = newRangeCount;
	        }
	        setAriaSelected(element, this.rangeCount > 0);
	        var hasChartRange = this.getHasChartRange();
	        if (hasChartRange !== this.hasChartRange) {
	            this.hasChartRange = hasChartRange;
	            this.addOrRemoveCssClass(CSS_RANGE_CHART, this.hasChartRange);
	        }
	        this.updateRangeBorders();
	        this.addOrRemoveCssClass(CSS_RANGE_SINGLE_CELL, this.isSingleCell());
	        this.refreshHandle();
	    };
	    CellComp.prototype.getHasChartRange = function () {
	        var rangeController = this.beans.rangeController;
	        if (!this.rangeCount || !rangeController) {
	            return false;
	        }
	        var cellRanges = rangeController.getCellRanges();
	        return cellRanges.length > 0 && cellRanges.every(function (range) { return includes([exports.CellRangeType.DIMENSION, exports.CellRangeType.VALUE], range.type); });
	    };
	    CellComp.prototype.shouldHaveSelectionHandle = function () {
	        var _a = this.beans, gridOptionsWrapper = _a.gridOptionsWrapper, rangeController = _a.rangeController;
	        var cellRanges = rangeController.getCellRanges();
	        var rangesLen = cellRanges.length;
	        if (this.rangeCount < 1 || rangesLen < 1) {
	            return false;
	        }
	        var cellRange = last(cellRanges);
	        var cellPosition = this.getCellPosition();
	        var fillHandleIsAvailable = rangesLen === 1 &&
	            (gridOptionsWrapper.isEnableFillHandle() || gridOptionsWrapper.isEnableRangeHandle()) &&
	            !this.editingCell;
	        if (this.hasChartRange) {
	            var hasCategoryRange = cellRanges[0].type === exports.CellRangeType.DIMENSION;
	            var isCategoryCell = hasCategoryRange && rangeController.isCellInSpecificRange(cellPosition, cellRanges[0]);
	            this.addOrRemoveCssClass(CSS_RANGE_CHART_CATEGORY, isCategoryCell);
	            fillHandleIsAvailable = cellRange.type === exports.CellRangeType.VALUE;
	        }
	        return fillHandleIsAvailable &&
	            cellRange.endRow != null &&
	            rangeController.isContiguousRange(cellRange) &&
	            rangeController.isBottomRightCell(cellRange, cellPosition);
	    };
	    CellComp.prototype.addSelectionHandle = function () {
	        var _a = this.beans, gridOptionsWrapper = _a.gridOptionsWrapper, rangeController = _a.rangeController;
	        var cellRangeType = last(rangeController.getCellRanges()).type;
	        var selectionHandleFill = gridOptionsWrapper.isEnableFillHandle() && missing(cellRangeType);
	        var type = selectionHandleFill ? exports.SelectionHandleType.FILL : exports.SelectionHandleType.RANGE;
	        if (this.selectionHandle && this.selectionHandle.getType() !== type) {
	            this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
	        }
	        if (!this.selectionHandle) {
	            this.selectionHandle = this.beans.selectionHandleFactory.createSelectionHandle(type);
	        }
	        this.selectionHandle.refresh(this);
	    };
	    CellComp.prototype.updateRangeBordersIfRangeCount = function () {
	        // we only need to update range borders if we are in a range
	        if (this.rangeCount > 0) {
	            this.updateRangeBorders();
	            this.refreshHandle();
	        }
	    };
	    CellComp.prototype.refreshHandle = function () {
	        if (!this.beans.rangeController) {
	            return;
	        }
	        var shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
	        if (this.selectionHandle && !shouldHaveSelectionHandle) {
	            this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
	        }
	        if (shouldHaveSelectionHandle) {
	            this.addSelectionHandle();
	        }
	        this.addOrRemoveCssClass(CSS_RANGE_HANDLE, !!this.selectionHandle);
	    };
	    CellComp.prototype.updateRangeBorders = function () {
	        var rangeBorders = this.getRangeBorders();
	        var isSingleCell = this.isSingleCell();
	        var isTop = !isSingleCell && rangeBorders.top;
	        var isRight = !isSingleCell && rangeBorders.right;
	        var isBottom = !isSingleCell && rangeBorders.bottom;
	        var isLeft = !isSingleCell && rangeBorders.left;
	        this.addOrRemoveCssClass(CSS_RANGE_TOP, isTop);
	        this.addOrRemoveCssClass(CSS_RANGE_RIGHT, isRight);
	        this.addOrRemoveCssClass(CSS_RANGE_BOTTOM, isBottom);
	        this.addOrRemoveCssClass(CSS_RANGE_LEFT, isLeft);
	    };
	    CellComp.prototype.onFirstRightPinnedChanged = function () {
	        var firstRightPinned = this.column.isFirstRightPinned();
	        if (this.firstRightPinned !== firstRightPinned) {
	            this.firstRightPinned = firstRightPinned;
	            this.addOrRemoveCssClass(CSS_FIRST_RIGHT_PINNED, firstRightPinned);
	        }
	    };
	    CellComp.prototype.onLastLeftPinnedChanged = function () {
	        var lastLeftPinned = this.column.isLastLeftPinned();
	        if (this.lastLeftPinned !== lastLeftPinned) {
	            this.lastLeftPinned = lastLeftPinned;
	            this.addOrRemoveCssClass(CSS_LAST_LEFT_PINNED, lastLeftPinned);
	        }
	    };
	    CellComp.prototype.refreshShouldDestroy = function () {
	        var isUsingWrapper = this.usingWrapper;
	        var isIncludingRowDragging = this.includeRowDraggingComponent;
	        var isIncludingDndSource = this.includeDndSourceComponent;
	        var isIncludingSelection = this.includeSelectionComponent;
	        this.setUsingWrapper();
	        return isUsingWrapper !== this.usingWrapper ||
	            isIncludingRowDragging !== this.includeRowDraggingComponent ||
	            isIncludingDndSource !== this.includeDndSourceComponent ||
	            isIncludingSelection !== this.includeSelectionComponent;
	    };
	    CellComp.prototype.populateTemplate = function () {
	        if (this.usingWrapper) {
	            this.eCellValue = this.getRefElement('eCellValue');
	            this.eCellWrapper = this.getRefElement('eCellWrapper');
	            this.eCellValue.id = "cell-" + this.getCompId();
	            var describedByIds = '';
	            if (this.includeRowDraggingComponent) {
	                this.addRowDragging();
	            }
	            if (this.includeDndSourceComponent) {
	                this.addDndSource();
	            }
	            if (this.includeSelectionComponent) {
	                describedByIds += this.addSelectionCheckbox().getCheckboxId();
	            }
	            setAriaDescribedBy(this.getGui(), (describedByIds + " " + this.eCellValue.id).trim());
	        }
	        else {
	            this.eCellValue = this.getGui();
	            this.eCellWrapper = this.eCellValue;
	        }
	    };
	    CellComp.prototype.getFrameworkOverrides = function () {
	        return this.beans.frameworkOverrides;
	    };
	    CellComp.prototype.addRowDragging = function (customElement, dragStartPixels) {
	        var _this = this;
	        var pagination = this.beans.gridOptionsWrapper.isPagination();
	        var rowDragManaged = this.beans.gridOptionsWrapper.isRowDragManaged();
	        var clientSideRowModelActive = this.beans.gridOptionsWrapper.isRowModelDefault();
	        if (rowDragManaged) {
	            // row dragging only available in default row model
	            if (!clientSideRowModelActive) {
	                doOnce(function () { return console.warn('AG Grid: managed row dragging is only allowed in the Client Side Row Model'); }, 'CellComp.addRowDragging');
	                return;
	            }
	            if (pagination) {
	                doOnce(function () { return console.warn('AG Grid: managed row dragging is not possible when doing pagination'); }, 'CellComp.addRowDragging');
	                return;
	            }
	        }
	        if (!this.rowDraggingComp) {
	            this.rowDraggingComp = new RowDragComp(function () { return _this.value; }, this.rowNode, this.column, customElement, dragStartPixels);
	            this.createManagedBean(this.rowDraggingComp, this.beans.context);
	        }
	        else if (customElement) {
	            // if the rowDraggingComp is already present, means we should only set the drag element
	            this.rowDraggingComp.setDragElement(customElement, dragStartPixels);
	        }
	        // If there is a custom element, the Cell Renderer is responsible for displaying it.
	        if (!customElement) {
	            // put the checkbox in before the value
	            this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue);
	        }
	    };
	    CellComp.prototype.addDndSource = function () {
	        var dndSourceComp = new DndSourceComp(this.rowNode, this.column, this.beans, this.getGui());
	        this.createManagedBean(dndSourceComp, this.beans.context);
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(dndSourceComp.getGui(), this.eCellValue);
	    };
	    CellComp.prototype.addSelectionCheckbox = function () {
	        var _this = this;
	        var cbSelectionComponent = new CheckboxSelectionComponent();
	        this.beans.context.createBean(cbSelectionComponent);
	        this.getComponentHolder().checkboxSelection;
	        cbSelectionComponent.init({ rowNode: this.rowNode, column: this.column });
	        this.addDestroyFunc(function () { return _this.beans.context.destroyBean(cbSelectionComponent); });
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(cbSelectionComponent.getGui(), this.eCellValue);
	        return cbSelectionComponent;
	    };
	    CellComp.prototype.addDomData = function () {
	        var _this = this;
	        var element = this.getGui();
	        this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, this);
	        this.addDestroyFunc(function () { return _this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, null); });
	    };
	    CellComp.prototype.isSingleCell = function () {
	        var rangeController = this.beans.rangeController;
	        return this.rangeCount === 1 && rangeController && !rangeController.isMoreThanOneCell();
	    };
	    CellComp.prototype.onCellFocused = function (event) {
	        var cellFocused = this.beans.focusController.isCellFocused(this.cellPosition);
	        // see if we need to change the classes on this cell
	        if (cellFocused !== this.cellFocused) {
	            // if we are not doing cell selection, then the focus class does not change
	            var doingFocusCss = !this.beans.gridOptionsWrapper.isSuppressCellSelection();
	            if (doingFocusCss) {
	                this.addOrRemoveCssClass(CSS_CELL_FOCUS, cellFocused);
	            }
	            this.cellFocused = cellFocused;
	        }
	        // see if we need to force browser focus - this can happen if focus is programmatically set
	        if (cellFocused && event && event.forceBrowserFocus) {
	            var focusEl = this.getFocusableElement();
	            focusEl.focus();
	            // Fix for AG-3465 "IE11 - After editing cell's content, selection doesn't go one cell below on enter"
	            // IE can fail to focus the cell after the first call to focus(), and needs a second call
	            if (!document.activeElement || document.activeElement === document.body) {
	                focusEl.focus();
	            }
	        }
	        // if another cell was focused, and we are editing, then stop editing
	        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
	        if (!cellFocused && !fullRowEdit && this.editingCell) {
	            this.stopRowOrCellEdit();
	        }
	    };
	    // pass in 'true' to cancel the editing.
	    CellComp.prototype.stopRowOrCellEdit = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
	            this.rowComp.stopRowEditing(cancel);
	        }
	        else {
	            this.stopEditing(cancel);
	        }
	    };
	    CellComp.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        if (!this.editingCell) {
	            return;
	        }
	        // if no cell editor, this means due to async, that the cell editor never got initialised,
	        // so we just carry on regardless as if the editing was never started.
	        if (!this.cellEditor) {
	            this.editingCell = false;
	            return;
	        }
	        var oldValue = this.getValue();
	        var newValueExists = false;
	        var newValue;
	        if (!cancel) {
	            // also have another option here to cancel after editing, so for example user could have a popup editor and
	            // it is closed by user clicking outside the editor. then the editor will close automatically (with false
	            // passed above) and we need to see if the editor wants to accept the new value.
	            var userWantsToCancel = this.cellEditor.isCancelAfterEnd && this.cellEditor.isCancelAfterEnd();
	            if (!userWantsToCancel) {
	                newValue = this.cellEditor.getValue();
	                newValueExists = true;
	            }
	        }
	        // it is important we set this after setValue() above, as otherwise the cell will flash
	        // when editing stops. the 'refresh' method checks editing, and doesn't refresh editing cells.
	        // thus it will skip the refresh on this cell until the end of this method where we call
	        // refresh directly and we suppress the flash.
	        this.editingCell = false;
	        // important to clear this out - as parts of the code will check for
	        // this to see if an async cellEditor has yet to be created
	        this.beans.context.destroyBean(this.cellEditor);
	        this.cellEditor = null;
	        if (this.cellEditorInPopup && this.hideEditorPopup) {
	            this.hideEditorPopup();
	            this.hideEditorPopup = null;
	        }
	        else {
	            this.clearCellElement();
	            var eGui = this.getGui();
	            // put the cell back the way it was before editing
	            if (this.usingWrapper) {
	                // if wrapper, then put the wrapper back
	                eGui.appendChild(this.eCellWrapper);
	            }
	            else if (this.cellRenderer) {
	                // if cellRenderer, then put the gui back in. if the renderer has
	                // a refresh, it will be called. however if it doesn't, then later
	                // the renderer will be destroyed and a new one will be created.
	                // we know it's a dom element (not a string) because we converted
	                // it after the gui was attached if it was a string.
	                var eCell = this.cellRendererGui;
	                // can be null if cell was previously null / contained empty string,
	                // this will result in new value not being rendered.
	                if (eCell) {
	                    eGui.appendChild(eCell);
	                }
	            }
	        }
	        this.setInlineEditingClass();
	        this.refreshHandle();
	        if (newValueExists && newValue !== oldValue) {
	            // we suppressRefreshCell because the call to rowNode.setDataValue() results in change detection
	            // getting triggered, which results in all cells getting refreshed. we do not want this refresh
	            // to happen on this call as we want to call it explicitly below. otherwise refresh gets called twice.
	            // if we only did this refresh (and not the one below) then the cell would flash and not be forced.
	            this.suppressRefreshCell = true;
	            this.rowNode.setDataValue(this.column, newValue);
	            this.suppressRefreshCell = false;
	        }
	        // we suppress the flash, as it is not correct to flash the cell the user has finished editing,
	        // the user doesn't need to flash as they were the one who did the edit, the flash is pointless
	        // (as the flash is meant to draw the user to a change that they didn't manually do themselves).
	        this.refreshCell({ forceRefresh: true, suppressFlash: true });
	        var editingStoppedEvent = __assign$4(__assign$4({}, this.createEvent(null, Events.EVENT_CELL_EDITING_STOPPED)), { oldValue: oldValue,
	            newValue: newValue });
	        this.beans.eventService.dispatchEvent(editingStoppedEvent);
	    };
	    CellComp.prototype.clearCellElement = function () {
	        var eGui = this.getGui();
	        // if focus is inside the cell, we move focus to the cell itself
	        // before removing it's contents, otherwise errors could be thrown.
	        if (eGui.contains(document.activeElement) && !isBrowserIE()) {
	            eGui.focus({
	                preventScroll: true
	            });
	        }
	        clearElement(eGui);
	    };
	    CellComp.DOM_DATA_KEY_CELL_COMP = 'cellComp';
	    CellComp.CELL_RENDERER_TYPE_NORMAL = 'cellRenderer';
	    CellComp.CELL_RENDERER_TYPE_PINNED = 'pinnedRowCellRenderer';
	    return CellComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$J = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign$5 = function () {
	    __assign$5 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$5.apply(this, arguments);
	};
	var __decorate$D = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$5 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var __spreadArrays$4 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var RowRenderer = /** @class */ (function (_super) {
	    __extends$J(RowRenderer, _super);
	    function RowRenderer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.destroyFuncsForColumnListeners = [];
	        // map of row ids to row objects. keeps track of which elements
	        // are rendered for which rows in the dom.
	        _this.rowConsByRowIndex = {};
	        _this.zombieRowCons = {};
	        _this.allRowCons = [];
	        _this.topRowCons = [];
	        _this.bottomRowCons = [];
	        // we only allow one refresh at a time, otherwise the internal memory structure here
	        // will get messed up. this can happen if the user has a cellRenderer, and inside the
	        // renderer they call an API method that results in another pass of the refresh,
	        // then it will be trying to draw rows in the middle of a refresh.
	        _this.refreshInProgress = false;
	        return _this;
	    }
	    RowRenderer.prototype.agWire = function (loggerFactory) {
	        this.logger = loggerFactory.create("RowRenderer");
	    };
	    RowRenderer.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function () {
	            _this.gridBodyCon = _this.controllersService.getGridBodyController();
	            _this.initialise();
	        });
	    };
	    RowRenderer.prototype.initialise = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, this.redrawAfterScroll.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, this.redrawAfterScroll.bind(this));
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        this.registerCellEventListeners();
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        this.embedFullWidthRows = this.printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
	        this.redrawAfterModelUpdate();
	    };
	    RowRenderer.prototype.getRowCons = function () {
	        return this.allRowCons;
	    };
	    RowRenderer.prototype.updateAllRowCons = function () {
	        this.allRowCons = __spreadArrays$4(getAllValuesInObject(this.rowConsByRowIndex), getAllValuesInObject(this.zombieRowCons));
	    };
	    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
	    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
	    // all active cells.
	    RowRenderer.prototype.registerCellEventListeners = function () {
	        var _this = this;
	        this.addManagedListener(this.eventService, Events.EVENT_CELL_FOCUSED, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onCellFocused(event); });
	            _this.forEachRowComp(function (key, rowComp) {
	                if (rowComp.isFullWidth()) {
	                    rowComp.onFullWidthRowFocused(event);
	                }
	            });
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_FLASH_CELLS, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onFlashCells(event); });
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, function () {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onColumnHover(); });
	        });
	        // only for printLayout - because we are rendering all the cells in the same row, regardless of pinned state,
	        // then changing the width of the containers will impact left position. eg the center cols all have their
	        // left position adjusted by the width of the left pinned column, so if the pinned left column width changes,
	        // all the center cols need to be shifted to accommodate this. when in normal layout, the pinned cols are
	        // in different containers so doesn't impact.
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function () {
	            if (_this.printLayout) {
	                _this.forEachCellComp(function (cellComp) { return cellComp.onLeftChanged(); });
	            }
	        });
	        var rangeSelectionEnabled = this.gridOptionsWrapper.isEnableRangeSelection();
	        if (rangeSelectionEnabled) {
	            this.addManagedListener(this.eventService, Events.EVENT_RANGE_SELECTION_CHANGED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.onRangeSelectionChanged(); });
	            });
	            this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	            this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	            this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	        }
	        // add listeners to the grid columns
	        this.refreshListenersToColumnsForCellComps();
	        // if the grid columns change, then refresh the listeners again
	        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this));
	        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
	    };
	    // executes all functions in destroyFuncsForColumnListeners and then clears the list
	    RowRenderer.prototype.removeGridColumnListeners = function () {
	        this.destroyFuncsForColumnListeners.forEach(function (func) { return func(); });
	        this.destroyFuncsForColumnListeners.length = 0;
	    };
	    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
	    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
	    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
	    // once instead.
	    RowRenderer.prototype.refreshListenersToColumnsForCellComps = function () {
	        var _this = this;
	        this.removeGridColumnListeners();
	        var cols = this.columnController.getAllGridColumns();
	        if (!cols) {
	            return;
	        }
	        cols.forEach(function (col) {
	            var forEachCellWithThisCol = function (callback) {
	                _this.forEachCellComp(function (cellComp) {
	                    if (cellComp.getColumn() === col) {
	                        callback(cellComp);
	                    }
	                });
	            };
	            var leftChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onLeftChanged(); });
	            };
	            var widthChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onWidthChanged(); });
	            };
	            var firstRightPinnedChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onFirstRightPinnedChanged(); });
	            };
	            var lastLeftPinnedChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onLastLeftPinnedChanged(); });
	            };
	            col.addEventListener(Column.EVENT_LEFT_CHANGED, leftChangedListener);
	            col.addEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	            col.addEventListener(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
	            col.addEventListener(Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
	            _this.destroyFuncsForColumnListeners.push(function () {
	                col.removeEventListener(Column.EVENT_LEFT_CHANGED, leftChangedListener);
	                col.removeEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	                col.removeEventListener(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
	                col.removeEventListener(Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
	            });
	        });
	    };
	    RowRenderer.prototype.onDomLayoutChanged = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        var embedFullWidthRows = printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
	        // if moving towards or away from print layout, means we need to destroy all rows, as rows are not laid
	        // out using absolute positioning when doing print layout
	        var destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
	        this.printLayout = printLayout;
	        this.embedFullWidthRows = embedFullWidthRows;
	        if (destroyRows) {
	            this.redrawAfterModelUpdate();
	        }
	    };
	    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
	    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
	    RowRenderer.prototype.datasourceChanged = function () {
	        this.firstRenderedRow = 0;
	        this.lastRenderedRow = -1;
	        var rowIndexesToRemove = Object.keys(this.rowConsByRowIndex);
	        this.removeRowComps(rowIndexesToRemove);
	    };
	    RowRenderer.prototype.onPageLoaded = function (event) {
	        var params = {
	            recycleRows: event.keepRenderedRows,
	            animate: event.animate,
	            newData: event.newData,
	            newPage: event.newPage,
	            // because this is a model updated event (not pinned rows), we
	            // can skip updating the pinned rows. this is needed so that if user
	            // is doing transaction updates, the pinned rows are not getting constantly
	            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
	            onlyBody: true
	        };
	        this.redrawAfterModelUpdate(params);
	    };
	    RowRenderer.prototype.getAllCellsForColumn = function (column) {
	        var eCells = [];
	        function callback(key, rowComp) {
	            var eCell = rowComp.getCellForCol(column);
	            if (eCell) {
	                eCells.push(eCell);
	            }
	        }
	        iterateObject(this.rowConsByRowIndex, callback);
	        iterateObject(this.bottomRowCons, callback);
	        iterateObject(this.topRowCons, callback);
	        return eCells;
	    };
	    RowRenderer.prototype.refreshFloatingRowComps = function () {
	        this.refreshFloatingRows(this.topRowCons, this.pinnedRowModel.getPinnedTopRowData());
	        this.refreshFloatingRows(this.bottomRowCons, this.pinnedRowModel.getPinnedBottomRowData());
	    };
	    RowRenderer.prototype.getTopRowCons = function () {
	        return this.topRowCons;
	    };
	    RowRenderer.prototype.getBottomRowCons = function () {
	        return this.bottomRowCons;
	    };
	    RowRenderer.prototype.refreshFloatingRows = function (rowComps, rowNodes) {
	        var _this = this;
	        rowComps.forEach(function (row) {
	            row.destroyFirstPass();
	            row.destroySecondPass();
	        });
	        rowComps.length = 0;
	        if (!rowNodes) {
	            return;
	        }
	        rowNodes.forEach(function (rowNode) {
	            var rowCon = new RowController(_this.$scope, rowNode, _this.beans, false, false, _this.printLayout);
	            rowComps.push(rowCon);
	        });
	    };
	    RowRenderer.prototype.onPinnedRowDataChanged = function () {
	        // recycling rows in order to ensure cell editing is not cancelled
	        var params = {
	            recycleRows: true
	        };
	        this.redrawAfterModelUpdate(params);
	    };
	    // if the row nodes are not rendered, no index is returned
	    RowRenderer.prototype.getRenderedIndexesForRowNodes = function (rowNodes) {
	        var result = [];
	        if (missing(rowNodes)) {
	            return result;
	        }
	        iterateObject(this.rowConsByRowIndex, function (index, renderedRow) {
	            var rowNode = renderedRow.getRowNode();
	            if (rowNodes.indexOf(rowNode) >= 0) {
	                result.push(index);
	            }
	        });
	        return result;
	    };
	    RowRenderer.prototype.redrawRows = function (rowNodes) {
	        // if no row nodes provided, then refresh everything
	        var partialRefresh = rowNodes != null && rowNodes.length > 0;
	        if (partialRefresh) {
	            var indexesToRemove = this.getRenderedIndexesForRowNodes(rowNodes);
	            // remove the rows
	            this.removeRowComps(indexesToRemove);
	        }
	        // add draw them again
	        this.redrawAfterModelUpdate({
	            recycleRows: partialRefresh
	        });
	    };
	    RowRenderer.prototype.getCellToRestoreFocusToAfterRefresh = function (params) {
	        var focusedCell = params.suppressKeepFocus ? null : this.focusController.getFocusCellToUseAfterRefresh();
	        if (missing(focusedCell)) {
	            return null;
	        }
	        // if the dom is not actually focused on a cell, then we don't try to refocus. the problem this
	        // solves is with editing - if the user is editing, eg focus is on a text field, and not on the
	        // cell itself, then the cell can be registered as having focus, however it's the text field that
	        // has the focus and not the cell div. therefore, when the refresh is finished, the grid will focus
	        // the cell, and not the textfield. that means if the user is in a text field, and the grid refreshes,
	        // the focus is lost from the text field. we do not want this.
	        var activeElement = document.activeElement;
	        var domData = this.gridOptionsWrapper.getDomData(activeElement, CellComp.DOM_DATA_KEY_CELL_COMP);
	        var elementIsNotACellDev = missing(domData);
	        return elementIsNotACellDev ? null : focusedCell;
	    };
	    // gets called from:
	    // +) initialisation (in registerGridComp) params = null
	    // +) onDomLayoutChanged, params = null
	    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
	    // +) onPinnedRowDataChanged, recycleRows = true
	    // +) redrawRows (from Grid API), recycleRows = true/false
	    RowRenderer.prototype.redrawAfterModelUpdate = function (params) {
	        if (params === void 0) { params = {}; }
	        this.getLockOnRefresh();
	        var focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
	        this.updateContainerHeights();
	        this.scrollToTopIfNewData(params);
	        // never recycle rows when print layout, we draw each row again from scratch. this is because print layout
	        // uses normal dom layout to put cells into dom - it doesn't allow reordering rows.
	        var recycleRows = !this.printLayout && !!params.recycleRows;
	        var animate = params.animate && this.gridOptionsWrapper.isAnimateRows();
	        // after modelUpdate, row indexes can change, so we clear out the rowsByIndex map,
	        // however we can reuse the rows, so we keep them but index by rowNode.id
	        var rowsToRecycle = recycleRows ? this.recycleRows() : null;
	        if (!recycleRows) {
	            this.removeAllRowComps();
	        }
	        var isFocusedCellGettingRecycled = function () {
	            if (focusedCell == null || rowsToRecycle == null) {
	                return false;
	            }
	            var res = false;
	            iterateObject(rowsToRecycle, function (key, rowComp) {
	                var rowNode = rowComp.getRowNode();
	                var rowIndexEqual = rowNode.rowIndex == focusedCell.rowIndex;
	                var pinnedEqual = rowNode.rowPinned == focusedCell.rowPinned;
	                if (rowIndexEqual && pinnedEqual) {
	                    res = true;
	                }
	            });
	            return res;
	        };
	        var focusedCellRecycled = isFocusedCellGettingRecycled();
	        this.redraw(rowsToRecycle, animate);
	        if (!params.onlyBody) {
	            this.refreshFloatingRowComps();
	        }
	        this.dispatchDisplayedRowsChanged();
	        // if we focus a cell that's already focused, then we get an unnecessary 'cellFocused' event fired.
	        // this was happening when user clicked 'expand' on a rowGroup, then cellFocused was getting fired twice.
	        if (!focusedCellRecycled) {
	            this.restoreFocusedCell(focusedCell);
	        }
	        this.releaseLockOnRefresh();
	    };
	    RowRenderer.prototype.scrollToTopIfNewData = function (params) {
	        var scrollToTop = params.newData || params.newPage;
	        var suppressScrollToTop = this.gridOptionsWrapper.isSuppressScrollOnNewData();
	        if (scrollToTop && !suppressScrollToTop) {
	            this.gridBodyCon.getScrollFeature().scrollToTop();
	        }
	    };
	    RowRenderer.prototype.updateContainerHeights = function () {
	        // when doing print layout, we don't explicitly set height on the containers
	        if (this.printLayout) {
	            this.rowContainerHeightService.setModelHeight(null);
	            return;
	        }
	        var containerHeight = this.paginationProxy.getCurrentPageHeight();
	        // we need at least 1 pixel for the horizontal scroll to work. so if there are now rows,
	        // we still want the scroll to be present, otherwise there would be no way to scroll the header
	        // which might be needed us user wants to access columns
	        // on the RHS - and if that was where the filter was that cause no rows to be presented, there
	        // is no way to remove the filter.
	        if (containerHeight === 0) {
	            containerHeight = 1;
	        }
	        this.rowContainerHeightService.setModelHeight(containerHeight);
	    };
	    RowRenderer.prototype.getLockOnRefresh = function () {
	        if (this.refreshInProgress) {
	            throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. " +
	                "Your code probably called a grid API method while the grid was in the render stage. To overcome " +
	                "this, put the API call into a timeout, e.g. instead of api.refreshView(), " +
	                "call setTimeout(function() { api.refreshView(); }, 0). To see what part of your code " +
	                "that caused the refresh check this stacktrace.");
	        }
	        this.refreshInProgress = true;
	    };
	    RowRenderer.prototype.releaseLockOnRefresh = function () {
	        this.refreshInProgress = false;
	    };
	    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
	    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
	    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
	    // edited cell).
	    RowRenderer.prototype.restoreFocusedCell = function (cellPosition) {
	        if (cellPosition) {
	            this.focusController.setFocusedCell(cellPosition.rowIndex, cellPosition.column, cellPosition.rowPinned, true);
	        }
	    };
	    RowRenderer.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.forEachRowComp(function (key, rowComp) {
	            rowComp.stopEditing(cancel);
	        });
	    };
	    RowRenderer.prototype.onNewColumnsLoaded = function () {
	        // we don't want each cellComp to register for events, as would increase rendering time.
	        // so for newColumnsLoaded, we register once here (in rowRenderer) and then inform
	        // each cell if / when event was fired.
	        this.forEachCellComp(function (cellComp) { return cellComp.onNewColumnsLoaded(); });
	    };
	    RowRenderer.prototype.forEachCellComp = function (callback) {
	        this.forEachRowComp(function (key, rowComp) { return rowComp.forEachCellComp(callback); });
	    };
	    RowRenderer.prototype.forEachRowComp = function (callback) {
	        iterateObject(this.rowConsByRowIndex, callback);
	        iterateObject(this.topRowCons, callback);
	        iterateObject(this.bottomRowCons, callback);
	    };
	    RowRenderer.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
	        var rowComp = this.rowConsByRowIndex[rowIndex];
	        if (rowComp) {
	            rowComp.addEventListener(eventName, callback);
	        }
	    };
	    RowRenderer.prototype.flashCells = function (params) {
	        if (params === void 0) { params = {}; }
	        var flashDelay = params.flashDelay, fadeDelay = params.fadeDelay;
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) { return cellComp.flashCell({ flashDelay: flashDelay, fadeDelay: fadeDelay }); });
	    };
	    RowRenderer.prototype.refreshCells = function (params) {
	        if (params === void 0) { params = {}; }
	        var refreshCellParams = {
	            forceRefresh: params.force,
	            newData: false,
	            suppressFlash: params.suppressFlash
	        };
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) {
	            if (cellComp.refreshShouldDestroy()) {
	                var rowComp = cellComp.getRenderedRow();
	                if (rowComp) {
	                    rowComp.refreshCell(cellComp);
	                }
	            }
	            else {
	                cellComp.refreshCell(refreshCellParams);
	            }
	        });
	    };
	    RowRenderer.prototype.getCellRendererInstances = function (params) {
	        var res = [];
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) {
	            var cellRenderer = cellComp.getCellRenderer();
	            if (cellRenderer) {
	                res.push(cellRenderer);
	            }
	        });
	        return res;
	    };
	    RowRenderer.prototype.getCellEditorInstances = function (params) {
	        var res = [];
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) {
	            var cellEditor = cellComp.getCellEditor();
	            if (cellEditor) {
	                res.push(cellEditor);
	            }
	        });
	        return res;
	    };
	    RowRenderer.prototype.getEditingCells = function () {
	        var res = [];
	        this.forEachCellComp(function (cellComp) {
	            if (cellComp.isEditing()) {
	                var cellPosition = cellComp.getCellPosition();
	                res.push(cellPosition);
	            }
	        });
	        return res;
	    };
	    // calls the callback for each cellComp that match the provided rowNodes and columns. eg if one row node
	    // and two columns provided, that identifies 4 cells, so callback gets called 4 times, once for each cell.
	    RowRenderer.prototype.forEachCellCompFiltered = function (rowNodes, columns, callback) {
	        var _this = this;
	        var rowIdsMap;
	        if (exists(rowNodes)) {
	            rowIdsMap = {
	                top: {},
	                bottom: {},
	                normal: {}
	            };
	            rowNodes.forEach(function (rowNode) {
	                var id = rowNode.id;
	                if (rowNode.rowPinned === Constants.PINNED_TOP) {
	                    rowIdsMap.top[id] = true;
	                }
	                else if (rowNode.rowPinned === Constants.PINNED_BOTTOM) {
	                    rowIdsMap.bottom[id] = true;
	                }
	                else {
	                    rowIdsMap.normal[id] = true;
	                }
	            });
	        }
	        var colIdsMap;
	        if (exists(columns)) {
	            colIdsMap = {};
	            columns.forEach(function (colKey) {
	                var column = _this.columnController.getGridColumn(colKey);
	                if (exists(column)) {
	                    colIdsMap[column.getId()] = true;
	                }
	            });
	        }
	        var processRow = function (rowComp) {
	            var rowNode = rowComp.getRowNode();
	            var id = rowNode.id;
	            var floating = rowNode.rowPinned;
	            // skip this row if it is missing from the provided list
	            if (exists(rowIdsMap)) {
	                if (floating === Constants.PINNED_BOTTOM) {
	                    if (!rowIdsMap.bottom[id]) {
	                        return;
	                    }
	                }
	                else if (floating === Constants.PINNED_TOP) {
	                    if (!rowIdsMap.top[id]) {
	                        return;
	                    }
	                }
	                else {
	                    if (!rowIdsMap.normal[id]) {
	                        return;
	                    }
	                }
	            }
	            rowComp.forEachCellComp(function (cellComp) {
	                var colId = cellComp.getColumn().getId();
	                var excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
	                if (excludeColFromRefresh) {
	                    return;
	                }
	                if (callback) {
	                    callback(cellComp);
	                }
	            });
	        };
	        iterateObject(this.rowConsByRowIndex, function (index, rowComp) {
	            processRow(rowComp);
	        });
	        if (this.topRowCons) {
	            this.topRowCons.forEach(processRow);
	        }
	        if (this.bottomRowCons) {
	            this.bottomRowCons.forEach(processRow);
	        }
	    };
	    RowRenderer.prototype.destroy = function () {
	        this.removeAllRowComps();
	        _super.prototype.destroy.call(this);
	    };
	    RowRenderer.prototype.removeAllRowComps = function () {
	        var rowIndexesToRemove = Object.keys(this.rowConsByRowIndex);
	        this.removeRowComps(rowIndexesToRemove);
	    };
	    RowRenderer.prototype.recycleRows = function () {
	        // remove all stub nodes, they can't be reused, as no rowNode id
	        var stubNodeIndexes = [];
	        iterateObject(this.rowConsByRowIndex, function (index, rowComp) {
	            var stubNode = rowComp.getRowNode().id == null;
	            if (stubNode) {
	                stubNodeIndexes.push(index);
	            }
	        });
	        this.removeRowComps(stubNodeIndexes);
	        // then clear out rowCompsByIndex, but before that take a copy, but index by id, not rowIndex
	        var nodesByIdMap = {};
	        iterateObject(this.rowConsByRowIndex, function (index, rowComp) {
	            var rowNode = rowComp.getRowNode();
	            nodesByIdMap[rowNode.id] = rowComp;
	        });
	        this.rowConsByRowIndex = {};
	        return nodesByIdMap;
	    };
	    // takes array of row indexes
	    RowRenderer.prototype.removeRowComps = function (rowsToRemove) {
	        var _this = this;
	        // if no fromIndex then set to -1, which will refresh everything
	        // let realFromIndex = -1;
	        rowsToRemove.forEach(function (indexToRemove) {
	            var rowComp = _this.rowConsByRowIndex[indexToRemove];
	            if (rowComp) {
	                rowComp.destroyFirstPass();
	                rowComp.destroySecondPass();
	            }
	            delete _this.rowConsByRowIndex[indexToRemove];
	        });
	    };
	    // gets called when rows don't change, but viewport does, so after:
	    // 1) height of grid body changes, ie number of displayed rows has changed
	    // 2) grid scrolled to new position
	    // 3) ensure index visible (which is a scroll)
	    RowRenderer.prototype.redrawAfterScroll = function () {
	        this.getLockOnRefresh();
	        this.redraw(null, false, true);
	        this.releaseLockOnRefresh();
	        this.dispatchDisplayedRowsChanged();
	    };
	    RowRenderer.prototype.removeRowCompsNotToDraw = function (indexesToDraw) {
	        // for speedy lookup, dump into map
	        var indexesToDrawMap = {};
	        indexesToDraw.forEach(function (index) { return (indexesToDrawMap[index] = true); });
	        var existingIndexes = Object.keys(this.rowConsByRowIndex);
	        var indexesNotToDraw = existingIndexes.filter(function (index) { return !indexesToDrawMap[index]; });
	        this.removeRowComps(indexesNotToDraw);
	    };
	    RowRenderer.prototype.calculateIndexesToDraw = function (rowsToRecycle) {
	        var _this = this;
	        // all in all indexes in the viewport
	        var indexesToDraw = createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);
	        var checkRowToDraw = function (indexStr, rowComp) {
	            var index = rowComp.getRowNode().rowIndex;
	            if (index == null) {
	                return;
	            }
	            if (index < _this.firstRenderedRow || index > _this.lastRenderedRow) {
	                if (_this.doNotUnVirtualiseRow(rowComp)) {
	                    indexesToDraw.push(index);
	                }
	            }
	        };
	        // if we are redrawing due to scrolling change, then old rows are in this.rowCompsByIndex
	        iterateObject(this.rowConsByRowIndex, checkRowToDraw);
	        // if we are redrawing due to model update, then old rows are in rowsToRecycle
	        iterateObject(rowsToRecycle, checkRowToDraw);
	        indexesToDraw.sort(function (a, b) { return a - b; });
	        return indexesToDraw;
	    };
	    RowRenderer.prototype.redraw = function (rowsToRecycle, animate, afterScroll) {
	        var _this = this;
	        if (animate === void 0) { animate = false; }
	        if (afterScroll === void 0) { afterScroll = false; }
	        this.rowContainerHeightService.updateOffset();
	        this.workOutFirstAndLastRowsToRender();
	        // the row can already exist and be in the following:
	        // rowsToRecycle -> if model change, then the index may be different, however row may
	        //                         exist here from previous time (mapped by id).
	        // this.rowCompsByIndex -> if just a scroll, then this will contain what is currently in the viewport
	        // this is all the indexes we want, including those that already exist, so this method
	        // will end up going through each index and drawing only if the row doesn't already exist
	        var indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
	        this.removeRowCompsNotToDraw(indexesToDraw);
	        // never animate when doing print layout - as we want to get things ready to print as quickly as possible,
	        // otherwise we risk the printer printing a row that's half faded (half way through fading in)
	        if (this.printLayout) {
	            animate = false;
	        }
	        indexesToDraw.forEach(function (rowIndex) {
	            var rowComp = _this.createOrUpdateRowCon(rowIndex, rowsToRecycle, animate, afterScroll);
	            if (exists(rowComp)) ;
	        });
	        if (rowsToRecycle) {
	            var useAnimationFrame = afterScroll && !this.gridOptionsWrapper.isSuppressAnimationFrame() && !this.printLayout;
	            if (useAnimationFrame) {
	                this.beans.taskQueue.addDestroyTask(function () {
	                    _this.destroyRowCons(rowsToRecycle, animate);
	                    _this.updateAllRowCons();
	                    _this.dispatchDisplayedRowsChanged();
	                });
	            }
	            else {
	                this.destroyRowCons(rowsToRecycle, animate);
	            }
	        }
	        this.updateAllRowCons();
	        this.checkAngularCompile();
	        this.gridBodyCon.updateRowCount();
	    };
	    RowRenderer.prototype.dispatchDisplayedRowsChanged = function () {
	        var event = { type: Events.EVENT_DISPLAYED_ROWS_CHANGED };
	        this.eventService.dispatchEvent(event);
	    };
	    RowRenderer.prototype.onDisplayedColumnsChanged = function () {
	        var pinningLeft = this.columnController.isPinningLeft();
	        var pinningRight = this.columnController.isPinningRight();
	        var atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
	        if (atLeastOneChanged) {
	            this.pinningLeft = pinningLeft;
	            this.pinningRight = pinningRight;
	            if (this.embedFullWidthRows) {
	                this.redrawFullWidthEmbeddedRows();
	            }
	        }
	    };
	    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
	    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
	    RowRenderer.prototype.redrawFullWidthEmbeddedRows = function () {
	        // if either of the pinned panels has shown / hidden, then need to redraw the fullWidth bits when
	        // embedded, as what appears in each section depends on whether we are pinned or not
	        var rowsToRemove = [];
	        iterateObject(this.rowConsByRowIndex, function (id, rowComp) {
	            if (rowComp.isFullWidth()) {
	                var rowIndex = rowComp.getRowNode().rowIndex;
	                rowsToRemove.push(rowIndex.toString());
	            }
	        });
	        this.refreshFloatingRowComps();
	        this.removeRowComps(rowsToRemove);
	        this.redrawAfterScroll();
	    };
	    RowRenderer.prototype.refreshFullWidthRows = function (rowNodesToRefresh) {
	        var rowsToRemove = [];
	        var selectivelyRefreshing = !!rowNodesToRefresh;
	        var idsToRefresh = selectivelyRefreshing ? {} : undefined;
	        if (selectivelyRefreshing && idsToRefresh) {
	            rowNodesToRefresh.forEach(function (r) { return idsToRefresh[r.id] = true; });
	        }
	        iterateObject(this.rowConsByRowIndex, function (id, rowComp) {
	            if (!rowComp.isFullWidth()) {
	                return;
	            }
	            var rowNode = rowComp.getRowNode();
	            if (selectivelyRefreshing && idsToRefresh) {
	                // we refresh if a) this node is present or b) this parents nodes is present. checking parent
	                // node is important for master/detail, as we want detail to refresh on changes to parent node.
	                // it's also possible, if user is provider their own fullWidth, that details panels contain
	                // some info on the parent, eg if in tree data and child row shows some data from parent row also.
	                var parentId = (rowNode.level > 0 && rowNode.parent) ? rowNode.parent.id : undefined;
	                var skipThisNode = !idsToRefresh[rowNode.id] && !idsToRefresh[parentId];
	                if (skipThisNode) {
	                    return;
	                }
	            }
	            var fullWidthRowsRefreshed = rowComp.refreshFullWidth();
	            if (!fullWidthRowsRefreshed) {
	                var rowIndex = rowComp.getRowNode().rowIndex;
	                rowsToRemove.push(rowIndex.toString());
	            }
	        });
	        this.removeRowComps(rowsToRemove);
	        this.redrawAfterScroll();
	    };
	    RowRenderer.prototype.createOrUpdateRowCon = function (rowIndex, rowsToRecycle, animate, afterScroll) {
	        var rowNode = null;
	        var rowCon = this.rowConsByRowIndex[rowIndex];
	        // if no row comp, see if we can get it from the previous rowComps
	        if (!rowCon) {
	            rowNode = this.paginationProxy.getRow(rowIndex);
	            if (exists(rowNode) && exists(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
	                rowCon = rowsToRecycle[rowNode.id];
	                rowsToRecycle[rowNode.id] = null;
	            }
	        }
	        var creatingNewRowCon = !rowCon;
	        if (creatingNewRowCon) {
	            // create a new one
	            if (!rowNode) {
	                rowNode = this.paginationProxy.getRow(rowIndex);
	            }
	            if (exists(rowNode)) {
	                rowCon = this.createRowCon(rowNode, animate, afterScroll);
	            }
	            else {
	                // this should never happen - if somehow we are trying to create
	                // a row for a rowNode that does not exist.
	                return;
	            }
	        }
	        if (rowNode) {
	            // set node as 'alreadyRendered' to ensure we only recycle rowComps that have been rendered, this ensures
	            // we don't reuse rowComps that have been removed and then re-added in the same batch transaction.
	            rowNode.alreadyRendered = true;
	        }
	        this.rowConsByRowIndex[rowIndex] = rowCon;
	        return rowCon;
	    };
	    RowRenderer.prototype.destroyRowCons = function (rowConsMap, animate) {
	        var _this = this;
	        var executeInAWhileFuncs = [];
	        iterateObject(rowConsMap, function (nodeId, rowCon) {
	            // if row was used, then it's null
	            if (!rowCon) {
	                return;
	            }
	            rowCon.destroyFirstPass();
	            if (animate) {
	                _this.zombieRowCons[rowCon.getInstanceId()] = rowCon;
	                executeInAWhileFuncs.push(function () {
	                    rowCon.destroySecondPass();
	                    delete _this.zombieRowCons[rowCon.getInstanceId()];
	                });
	            }
	            else {
	                rowCon.destroySecondPass();
	            }
	        });
	        if (animate) {
	            // this ensures we fire displayedRowsChanged AFTER all the 'executeInAWhileFuncs' get
	            // executed, as we added it to the end of the list.
	            executeInAWhileFuncs.push(function () {
	                _this.updateAllRowCons();
	                _this.dispatchDisplayedRowsChanged();
	            });
	            executeInAWhile(executeInAWhileFuncs);
	        }
	    };
	    RowRenderer.prototype.checkAngularCompile = function () {
	        var _this = this;
	        // if we are doing angular compiling, then do digest the scope here
	        if (this.gridOptionsWrapper.isAngularCompileRows()) {
	            // we do it in a timeout, in case we are already in an apply
	            window.setTimeout(function () {
	                _this.$scope.$apply();
	            }, 0);
	        }
	    };
	    RowRenderer.prototype.workOutFirstAndLastRowsToRender = function () {
	        var _this = this;
	        var newFirst;
	        var newLast;
	        if (!this.paginationProxy.isRowsToRender()) {
	            newFirst = 0;
	            newLast = -1; // setting to -1 means nothing in range
	        }
	        else if (this.printLayout) {
	            newFirst = this.paginationProxy.getPageFirstRow();
	            newLast = this.paginationProxy.getPageLastRow();
	        }
	        else {
	            var bufferPixels = this.gridOptionsWrapper.getRowBufferInPixels();
	            var gridBodyCon = this.controllersService.getGridBodyController();
	            var rowHeightsChanged = false;
	            var firstPixel = void 0;
	            var lastPixel = void 0;
	            do {
	                var paginationOffset = this.paginationProxy.getPixelOffset();
	                var _a = this.paginationProxy.getCurrentPagePixelRange(), pageFirstPixel = _a.pageFirstPixel, pageLastPixel = _a.pageLastPixel;
	                var divStretchOffset = this.rowContainerHeightService.getDivStretchOffset();
	                var bodyVRange = gridBodyCon.getScrollFeature().getVScrollPosition();
	                var bodyTopPixel = bodyVRange.top;
	                var bodyBottomPixel = bodyVRange.bottom;
	                firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
	                lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
	                // if the rows we are about to display get their heights changed, then that upsets the calcs from above.
	                rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
	            } while (rowHeightsChanged);
	            var firstRowIndex = this.paginationProxy.getRowIndexAtPixel(firstPixel);
	            var lastRowIndex = this.paginationProxy.getRowIndexAtPixel(lastPixel);
	            var pageFirstRow = this.paginationProxy.getPageFirstRow();
	            var pageLastRow = this.paginationProxy.getPageLastRow();
	            // adjust, in case buffer extended actual size
	            if (firstRowIndex < pageFirstRow) {
	                firstRowIndex = pageFirstRow;
	            }
	            if (lastRowIndex > pageLastRow) {
	                lastRowIndex = pageLastRow;
	            }
	            newFirst = firstRowIndex;
	            newLast = lastRowIndex;
	        }
	        // sometimes user doesn't set CSS right and ends up with grid with no height and grid ends up
	        // trying to render all the rows, eg 10,000+ rows. this will kill the browser. so instead of
	        // killing the browser, we limit the number of rows. just in case some use case we didn't think
	        // of, we also have a property to not do this operation.
	        var rowLayoutNormal = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_NORMAL;
	        var suppressRowCountRestriction = this.gridOptionsWrapper.isSuppressMaxRenderedRowRestriction();
	        var rowBufferMaxSize = Math.max(this.gridOptionsWrapper.getRowBuffer(), 500);
	        if (rowLayoutNormal && !suppressRowCountRestriction) {
	            if (newLast - newFirst > rowBufferMaxSize) {
	                newLast = newFirst + rowBufferMaxSize;
	            }
	        }
	        var firstDiffers = newFirst !== this.firstRenderedRow;
	        var lastDiffers = newLast !== this.lastRenderedRow;
	        if (firstDiffers || lastDiffers) {
	            this.firstRenderedRow = newFirst;
	            this.lastRenderedRow = newLast;
	            var event_1 = {
	                type: Events.EVENT_VIEWPORT_CHANGED,
	                firstRow: newFirst,
	                lastRow: newLast,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	        // only dispatch firstDataRendered if we have actually rendered some data
	        if (this.paginationProxy.isRowsToRender()) {
	            var event_2 = {
	                type: Events.EVENT_FIRST_DATA_RENDERED,
	                firstRow: newFirst,
	                lastRow: newLast,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            // added a small delay here because in some scenarios this can be fired
	            // before the grid is actually rendered, causing component creation
	            // on EVENT_FIRST_DATA_RENDERED to fail.
	            window.setTimeout(function () { return _this.eventService.dispatchEventOnce(event_2); }, 50);
	        }
	    };
	    RowRenderer.prototype.ensureAllRowsInRangeHaveHeightsCalculated = function (topPixel, bottomPixel) {
	        // ensureRowHeightsVisible only works with CSRM, as it's the only row model that allows lazy row height calcs.
	        // all the other row models just hard code so the method just returns back false
	        var res = this.paginationProxy.ensureRowHeightsValid(topPixel, bottomPixel, -1, -1);
	        if (res) {
	            this.updateContainerHeights();
	        }
	        return res;
	    };
	    RowRenderer.prototype.getFirstVirtualRenderedRow = function () {
	        return this.firstRenderedRow;
	    };
	    RowRenderer.prototype.getLastVirtualRenderedRow = function () {
	        return this.lastRenderedRow;
	    };
	    // check that none of the rows to remove are editing or focused as:
	    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
	    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
	    //    the edit is reset - so we want to keep it rendered.
	    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
	    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
	    //    and then ctrl+c, nothing will happen if cell is removed from dom.
	    // c) if detail record of master detail, as users complained that the context of detail rows
	    //    was getting lost when detail row out of view. eg user expands to show detail row,
	    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
	    //    after detail panel is scrolled out of / into view.
	    RowRenderer.prototype.doNotUnVirtualiseRow = function (rowComp) {
	        var REMOVE_ROW = false;
	        var KEEP_ROW = true;
	        var rowNode = rowComp.getRowNode();
	        var rowHasFocus = this.focusController.isRowNodeFocused(rowNode);
	        var rowIsEditing = rowComp.isEditing();
	        var rowIsDetail = rowNode.detail;
	        var mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
	        // if we deffo don't want to keep it,
	        if (!mightWantToKeepRow) {
	            return REMOVE_ROW;
	        }
	        // editing row, only remove if it is no longer rendered, eg filtered out or new data set.
	        // the reason we want to keep is if user is scrolling up and down, we don't want to loose
	        // the context of the editing in process.
	        var rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
	        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
	    };
	    RowRenderer.prototype.createRowCon = function (rowNode, animate, afterScroll) {
	        var suppressAnimationFrame = this.gridOptionsWrapper.isSuppressAnimationFrame();
	        // we don't use animations frames for printing, so the user can put the grid into print mode
	        // and immediately print - otherwise the user would have to wait for the rows to draw in the background
	        // (via the animation frames) which is awkward to do from code.
	        // we only do the animation frames after scrolling, as this is where we want the smooth user experience.
	        // having animation frames for other times makes the grid look 'jumpy'.
	        var useAnimationFrameForCreate = afterScroll && !suppressAnimationFrame && !this.printLayout;
	        var res = new RowController(this.$scope, rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
	        return res;
	    };
	    RowRenderer.prototype.getRenderedNodes = function () {
	        var renderedRows = this.rowConsByRowIndex;
	        return Object.keys(renderedRows).map(function (key) { return renderedRows[key].getRowNode(); });
	    };
	    // we use index for rows, but column object for columns, as the next column (by index) might not
	    // be visible (header grouping) so it's not reliable, so using the column object instead.
	    RowRenderer.prototype.navigateToNextCell = function (event, key, currentCell, allowUserOverride) {
	        // we keep searching for a next cell until we find one. this is how the group rows get skipped
	        var nextCell = currentCell;
	        var hitEdgeOfGrid = false;
	        while (nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))) {
	            // if the current cell is spanning across multiple columns, we need to move
	            // our current position to be the last cell on the right before finding the
	            // the next target.
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                if (key === KeyCode.LEFT) {
	                    nextCell = this.getLastCellOfColSpan(nextCell);
	                }
	            }
	            else if (key === KeyCode.RIGHT) {
	                nextCell = this.getLastCellOfColSpan(nextCell);
	            }
	            nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
	            // eg if going down, and nextCell=undefined, means we are gone past the last row
	            hitEdgeOfGrid = missing(nextCell);
	        }
	        if (hitEdgeOfGrid && event && event.keyCode === KeyCode.UP) {
	            nextCell = {
	                rowIndex: -1,
	                rowPinned: null,
	                column: currentCell.column
	            };
	        }
	        // allow user to override what cell to go to next. when doing normal cell navigation (with keys)
	        // we allow this, however if processing 'enter after edit' we don't allow override
	        if (allowUserOverride) {
	            var userFunc = this.gridOptionsWrapper.getNavigateToNextCellFunc();
	            if (exists(userFunc)) {
	                var params = {
	                    key: key,
	                    previousCellPosition: currentCell,
	                    nextCellPosition: nextCell ? nextCell : null,
	                    event: event
	                };
	                var userCell = userFunc(params);
	                if (exists(userCell)) {
	                    if (userCell.floating) {
	                        doOnce(function () { console.warn("AG Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"); }, 'no floating in userCell');
	                        userCell.rowPinned = userCell.floating;
	                    }
	                    nextCell = {
	                        rowPinned: userCell.rowPinned,
	                        rowIndex: userCell.rowIndex,
	                        column: userCell.column
	                    };
	                }
	                else {
	                    nextCell = null;
	                }
	            }
	        }
	        // no next cell means we have reached a grid boundary, eg left, right, top or bottom of grid
	        if (!nextCell) {
	            return;
	        }
	        if (nextCell.rowIndex < 0) {
	            var headerLen = this.beans.headerNavigationService.getHeaderRowCount();
	            this.focusController.focusHeaderPosition({ headerRowIndex: headerLen + (nextCell.rowIndex), column: currentCell.column });
	            return;
	        }
	        // in case we have col spanning we get the cellComp and use it to get the
	        // position. This was we always focus the first cell inside the spanning.
	        var normalisedPosition = this.getNormalisedPosition(nextCell);
	        if (normalisedPosition) {
	            this.focusPosition(normalisedPosition);
	        }
	        else {
	            this.tryToFocusFullWidthRow(nextCell);
	        }
	    };
	    RowRenderer.prototype.getNormalisedPosition = function (cellPosition) {
	        // ensureCellVisible first, to make sure cell at position is rendered.
	        this.ensureCellVisible(cellPosition);
	        var cellComp = this.getComponentForCell(cellPosition);
	        // not guaranteed to have a cellComp when using the SSRM as blocks are loading.
	        if (!cellComp) {
	            return null;
	        }
	        cellPosition = cellComp.getCellPosition();
	        // we call this again, as nextCell can be different to it's previous value due to Column Spanning
	        // (ie if cursor moving from right to left, and cell is spanning columns, then nextCell was the
	        // last column in the group, however now it's the first column in the group). if we didn't do
	        // ensureCellVisible again, then we could only be showing the last portion (last column) of the
	        // merged cells.
	        this.ensureCellVisible(cellPosition);
	        return cellPosition;
	    };
	    RowRenderer.prototype.tryToFocusFullWidthRow = function (position, backwards) {
	        if (backwards === void 0) { backwards = false; }
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var rowComp = this.getRowConByPosition(position);
	        if (!rowComp || !rowComp.isFullWidth()) {
	            return false;
	        }
	        var cellPosition = {
	            rowIndex: position.rowIndex,
	            rowPinned: position.rowPinned,
	            column: position.column || (backwards ? last(displayedColumns) : displayedColumns[0])
	        };
	        this.focusPosition(cellPosition);
	        return true;
	    };
	    RowRenderer.prototype.focusPosition = function (cellPosition) {
	        this.focusController.setFocusedCell(cellPosition.rowIndex, cellPosition.column, cellPosition.rowPinned, true);
	        if (this.rangeController) {
	            this.rangeController.setRangeToCell(cellPosition);
	        }
	    };
	    RowRenderer.prototype.isValidNavigateCell = function (cell) {
	        var rowNode = this.rowPositionUtils.getRowNode(cell);
	        // we do not allow focusing on detail rows and full width rows
	        return !!rowNode;
	    };
	    RowRenderer.prototype.getLastCellOfColSpan = function (cell) {
	        var cellComp = this.getComponentForCell(cell);
	        if (!cellComp) {
	            return cell;
	        }
	        var colSpanningList = cellComp.getColSpanningList();
	        if (colSpanningList.length === 1) {
	            return cell;
	        }
	        return {
	            rowIndex: cell.rowIndex,
	            column: last(colSpanningList),
	            rowPinned: cell.rowPinned
	        };
	    };
	    RowRenderer.prototype.ensureCellVisible = function (gridCell) {
	        // this scrolls the row into view
	        if (missing(gridCell.rowPinned)) {
	            this.gridBodyCon.getScrollFeature().ensureIndexVisible(gridCell.rowIndex);
	        }
	        if (!gridCell.column.isPinned()) {
	            this.gridBodyCon.getScrollFeature().ensureColumnVisible(gridCell.column);
	        }
	        // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
	        // floating cell, the scrolls get out of sync
	        this.gridBodyCon.getScrollFeature().horizontallyScrollHeaderCenterAndFloatingCenter();
	        // need to flush frames, to make sure the correct cells are rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    RowRenderer.prototype.startEditingCell = function (gridCell, keyPress, charPress) {
	        var cell = this.getComponentForCell(gridCell);
	        if (cell) {
	            cell.startRowOrCellEdit(keyPress, charPress);
	        }
	    };
	    RowRenderer.prototype.getRowConByPosition = function (rowPosition) {
	        var rowComponent;
	        switch (rowPosition.rowPinned) {
	            case Constants.PINNED_TOP:
	                rowComponent = this.topRowCons[rowPosition.rowIndex];
	                break;
	            case Constants.PINNED_BOTTOM:
	                rowComponent = this.bottomRowCons[rowPosition.rowIndex];
	                break;
	            default:
	                rowComponent = this.rowConsByRowIndex[rowPosition.rowIndex];
	                break;
	        }
	        return rowComponent;
	    };
	    RowRenderer.prototype.getComponentForCell = function (cellPosition) {
	        var rowComp = this.getRowConByPosition(cellPosition);
	        if (!rowComp) {
	            return null;
	        }
	        var cellComponent = rowComp.getRenderedCellForColumn(cellPosition.column);
	        return cellComponent;
	    };
	    RowRenderer.prototype.getRowNode = function (gridRow) {
	        switch (gridRow.rowPinned) {
	            case Constants.PINNED_TOP:
	                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
	            case Constants.PINNED_BOTTOM:
	                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
	            default:
	                return this.rowModel.getRow(gridRow.rowIndex);
	        }
	    };
	    // result of keyboard event
	    RowRenderer.prototype.onTabKeyDown = function (previousRenderedCell, keyboardEvent) {
	        var backwards = keyboardEvent.shiftKey;
	        var movedToNextCell = this.tabToNextCellCommon(previousRenderedCell, backwards);
	        if (movedToNextCell) {
	            // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	            // to the normal tabbing so user can exit the grid.
	            keyboardEvent.preventDefault();
	            return;
	        }
	        // if we didn't move to next cell, then need to tab out of the cells, ie to the header (if going
	        // backwards)
	        if (backwards) {
	            var _a = previousRenderedCell.getRowPosition(), rowIndex = _a.rowIndex, rowPinned = _a.rowPinned;
	            var firstRow = rowPinned ? rowIndex === 0 : rowIndex === this.paginationProxy.getPageFirstRow();
	            if (firstRow) {
	                keyboardEvent.preventDefault();
	                var headerRowIndex = this.beans.headerNavigationService.getHeaderRowCount() - 1;
	                var column = last(this.columnController.getAllDisplayedColumns());
	                this.focusController.focusHeaderPosition({ headerRowIndex: headerRowIndex, column: column });
	            }
	        }
	        else {
	            // if the case it's a popup editor, the focus is on the editor and not the previous cell.
	            // in order for the tab navigation to work, we need to focus the browser back onto the
	            // previous cell.
	            if (previousRenderedCell instanceof CellComp) {
	                previousRenderedCell.focusCell(true);
	            }
	            if (this.focusController.focusNextGridCoreContainer(false)) {
	                keyboardEvent.preventDefault();
	            }
	        }
	    };
	    // comes from API
	    RowRenderer.prototype.tabToNextCell = function (backwards) {
	        var focusedCell = this.focusController.getFocusedCell();
	        // if no focus, then cannot navigate
	        if (!focusedCell) {
	            return false;
	        }
	        var cellOrRowComp = this.getComponentForCell(focusedCell);
	        // if cell is not rendered, means user has scrolled away from the cell
	        // or that the focusedCell is a Full Width Row
	        if (!cellOrRowComp) {
	            cellOrRowComp = this.getRowConByPosition(focusedCell);
	            if (!cellOrRowComp || !cellOrRowComp.isFullWidth()) {
	                return false;
	            }
	        }
	        return this.tabToNextCellCommon(cellOrRowComp, backwards);
	    };
	    RowRenderer.prototype.tabToNextCellCommon = function (previousCellOrRow, backwards) {
	        var editing = previousCellOrRow.isEditing();
	        // if cell is not editing, there is still chance row is editing if it's Full Row Editing
	        if (!editing && previousCellOrRow instanceof CellComp) {
	            var cellComp = previousCellOrRow;
	            var rowCon = cellComp.getRenderedRow();
	            if (rowCon) {
	                editing = rowCon.isEditing();
	            }
	        }
	        var res;
	        if (editing) {
	            // if we are editing, we know it's not a Full Width Row (RowComp)
	            if (this.gridOptionsWrapper.isFullRowEdit()) {
	                res = this.moveToNextEditingRow(previousCellOrRow, backwards);
	            }
	            else {
	                res = this.moveToNextEditingCell(previousCellOrRow, backwards);
	            }
	        }
	        else {
	            res = this.moveToNextCellNotEditing(previousCellOrRow, backwards);
	        }
	        // if a cell wasn't found, it's possible that focus was moved to the header
	        return res || !!this.focusController.getFocusedHeader();
	    };
	    RowRenderer.prototype.moveToNextEditingCell = function (previousRenderedCell, backwards) {
	        var gridCell = previousRenderedCell.getCellPosition();
	        // need to do this before getting next cell to edit, in case the next cell
	        // has editable function (eg colDef.editable=func() ) and it depends on the
	        // result of this cell, so need to save updates from the first edit, in case
	        // the value is referenced in the function.
	        previousRenderedCell.stopEditing();
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, true);
	        var foundCell = nextRenderedCell != null;
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (foundCell) {
	            nextRenderedCell.startEditingIfEnabled(null, null, true);
	            nextRenderedCell.focusCell(false);
	        }
	        return foundCell;
	    };
	    RowRenderer.prototype.moveToNextEditingRow = function (previousCellComp, backwards) {
	        var cellPos = previousCellComp.getCellPosition();
	        // find the next cell to start editing
	        var nextCellComp = this.findNextCellToFocusOn(cellPos, backwards, true);
	        if (nextCellComp == null) {
	            return false;
	        }
	        var previousPos = previousCellComp.getCellPosition();
	        var nextPos = nextCellComp.getCellPosition();
	        var previousEditable = this.isCellEditable(previousPos);
	        var nextEditable = this.isCellEditable(nextPos);
	        var rowsMatch = nextPos && previousPos.rowIndex === nextPos.rowIndex && previousPos.rowPinned === nextPos.rowPinned;
	        if (previousEditable) {
	            previousCellComp.setFocusOutOnEditor();
	        }
	        if (!rowsMatch) {
	            var pRow = previousCellComp.getRenderedRow();
	            pRow.stopEditing();
	            var nRow = nextCellComp.getRenderedRow();
	            nRow.startRowEditing();
	        }
	        if (nextEditable) {
	            nextCellComp.setFocusInOnEditor();
	            nextCellComp.focusCell();
	        }
	        else {
	            nextCellComp.focusCell(true);
	        }
	        return true;
	    };
	    RowRenderer.prototype.moveToNextCellNotEditing = function (previousRenderedCell, backwards) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var gridCell;
	        if (previousRenderedCell instanceof RowController) {
	            gridCell = __assign$5(__assign$5({}, previousRenderedCell.getRowPosition()), { column: backwards ? displayedColumns[0] : last(displayedColumns) });
	        }
	        else {
	            gridCell = previousRenderedCell.getCellPosition();
	        }
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, false);
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (nextRenderedCell instanceof CellComp) {
	            nextRenderedCell.focusCell(true);
	        }
	        else if (nextRenderedCell) {
	            return this.tryToFocusFullWidthRow(nextRenderedCell.getRowPosition(), backwards);
	        }
	        return exists(nextRenderedCell);
	    };
	    // called by the cell, when tab is pressed while editing.
	    // @return: RenderedCell when navigation successful, otherwise null
	    RowRenderer.prototype.findNextCellToFocusOn = function (gridCell, backwards, startEditing) {
	        var nextCell = gridCell;
	        while (true) {
	            if (!backwards) {
	                nextCell = this.getLastCellOfColSpan(nextCell);
	            }
	            nextCell = this.cellNavigationService.getNextTabbedCell(nextCell, backwards);
	            // allow user to override what cell to go to next
	            var userFunc = this.gridOptionsWrapper.getTabToNextCellFunc();
	            if (exists(userFunc)) {
	                var params = {
	                    backwards: backwards,
	                    editing: startEditing,
	                    previousCellPosition: gridCell,
	                    nextCellPosition: nextCell ? nextCell : null
	                };
	                var userCell = userFunc(params);
	                if (exists(userCell)) {
	                    if (userCell.floating) {
	                        doOnce(function () { console.warn("AG Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"); }, 'no floating in userCell');
	                        userCell.rowPinned = userCell.floating;
	                    }
	                    nextCell = {
	                        rowIndex: userCell.rowIndex,
	                        column: userCell.column,
	                        rowPinned: userCell.rowPinned
	                    };
	                }
	                else {
	                    nextCell = null;
	                }
	            }
	            // if no 'next cell', means we have got to last cell of grid, so nothing to move to,
	            // so bottom right cell going forwards, or top left going backwards
	            if (!nextCell) {
	                return null;
	            }
	            if (nextCell.rowIndex < 0) {
	                var headerLen = this.beans.headerNavigationService.getHeaderRowCount();
	                this.focusController.focusHeaderPosition({ headerRowIndex: headerLen + (nextCell.rowIndex), column: nextCell.column });
	                return null;
	            }
	            // if editing, but cell not editable, skip cell. we do this before we do all of
	            // the 'ensure index visible' and 'flush all frames', otherwise if we are skipping
	            // a bunch of cells (eg 10 rows) then all the work on ensuring cell visible is useless
	            // (except for the last one) which causes grid to stall for a while.
	            // note - for full row edit, we do focus non-editable cells, as the row stays in edit mode.
	            var fullRowEdit = this.gridOptionsWrapper.isFullRowEdit();
	            if (startEditing && !fullRowEdit) {
	                var cellIsEditable = this.isCellEditable(nextCell);
	                if (!cellIsEditable) {
	                    continue;
	                }
	            }
	            this.ensureCellVisible(nextCell);
	            // we have to call this after ensureColumnVisible - otherwise it could be a virtual column
	            // or row that is not currently in view, hence the renderedCell would not exist
	            var nextCellComp = this.getComponentForCell(nextCell);
	            // if next cell is fullWidth row, then no rendered cell,
	            // as fullWidth rows have no cells, so we skip it
	            if (!nextCellComp) {
	                var rowComp = this.getRowConByPosition(nextCell);
	                if (!rowComp || !rowComp.isFullWidth()) {
	                    continue;
	                }
	                else {
	                    return rowComp;
	                }
	            }
	            if (nextCellComp.isSuppressNavigable()) {
	                continue;
	            }
	            // by default, when we click a cell, it gets selected into a range, so to keep keyboard navigation
	            // consistent, we set into range here also.
	            if (this.rangeController) {
	                this.rangeController.setRangeToCell(nextCell);
	            }
	            // we successfully tabbed onto a grid cell, so return true
	            return nextCellComp;
	        }
	    };
	    RowRenderer.prototype.isCellEditable = function (cell) {
	        var rowNode = this.lookupRowNodeForCell(cell);
	        if (rowNode) {
	            return cell.column.isCellEditable(rowNode);
	        }
	        return false;
	    };
	    RowRenderer.prototype.lookupRowNodeForCell = function (cell) {
	        if (cell.rowPinned === Constants.PINNED_TOP) {
	            return this.pinnedRowModel.getPinnedTopRow(cell.rowIndex);
	        }
	        if (cell.rowPinned === Constants.PINNED_BOTTOM) {
	            return this.pinnedRowModel.getPinnedBottomRow(cell.rowIndex);
	        }
	        return this.paginationProxy.getRow(cell.rowIndex);
	    };
	    // returns true if any row between startIndex and endIndex is rendered. used by
	    // SSRM or IRM, as they don't want to purge visible blocks from cache.
	    RowRenderer.prototype.isRangeInRenderedViewport = function (startIndex, endIndex) {
	        // parent closed means the parent node is not expanded, thus these blocks are not visible
	        var parentClosed = startIndex == null || endIndex == null;
	        if (parentClosed) {
	            return false;
	        }
	        var blockAfterViewport = startIndex > this.lastRenderedRow;
	        var blockBeforeViewport = endIndex < this.firstRenderedRow;
	        var blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
	        return blockInsideViewport;
	    };
	    __decorate$D([
	        Autowired("paginationProxy")
	    ], RowRenderer.prototype, "paginationProxy", void 0);
	    __decorate$D([
	        Autowired("columnController")
	    ], RowRenderer.prototype, "columnController", void 0);
	    __decorate$D([
	        Autowired("$scope")
	    ], RowRenderer.prototype, "$scope", void 0);
	    __decorate$D([
	        Autowired("pinnedRowModel")
	    ], RowRenderer.prototype, "pinnedRowModel", void 0);
	    __decorate$D([
	        Autowired("rowModel")
	    ], RowRenderer.prototype, "rowModel", void 0);
	    __decorate$D([
	        Autowired("focusController")
	    ], RowRenderer.prototype, "focusController", void 0);
	    __decorate$D([
	        Autowired("cellNavigationService")
	    ], RowRenderer.prototype, "cellNavigationService", void 0);
	    __decorate$D([
	        Autowired("columnApi")
	    ], RowRenderer.prototype, "columnApi", void 0);
	    __decorate$D([
	        Autowired("gridApi")
	    ], RowRenderer.prototype, "gridApi", void 0);
	    __decorate$D([
	        Autowired("beans")
	    ], RowRenderer.prototype, "beans", void 0);
	    __decorate$D([
	        Autowired("rowContainerHeightService")
	    ], RowRenderer.prototype, "rowContainerHeightService", void 0);
	    __decorate$D([
	        Autowired("animationFrameService")
	    ], RowRenderer.prototype, "animationFrameService", void 0);
	    __decorate$D([
	        Autowired("rowPositionUtils")
	    ], RowRenderer.prototype, "rowPositionUtils", void 0);
	    __decorate$D([
	        Optional("rangeController")
	    ], RowRenderer.prototype, "rangeController", void 0);
	    __decorate$D([
	        Optional("controllersService")
	    ], RowRenderer.prototype, "controllersService", void 0);
	    __decorate$D([
	        __param$5(0, Qualifier("loggerFactory"))
	    ], RowRenderer.prototype, "agWire", null);
	    __decorate$D([
	        PostConstruct
	    ], RowRenderer.prototype, "postConstruct", null);
	    RowRenderer = __decorate$D([
	        Bean("rowRenderer")
	    ], RowRenderer);
	    return RowRenderer;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var CssClassApplier = /** @class */ (function () {
	    function CssClassApplier() {
	    }
	    CssClassApplier.addHeaderClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (missing(abstractColDef)) {
	            return;
	        }
	        this.addColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
	    };
	    CssClassApplier.addToolPanelClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (missing(abstractColDef)) {
	            return;
	        }
	        this.addColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
	    };
	    CssClassApplier.addColumnClassesFromCollDef = function (classesOrFunc, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (missing(classesOrFunc)) {
	            return;
	        }
	        var classToUse;
	        if (typeof classesOrFunc === 'function') {
	            var params = {
	                // bad naming, as colDef here can be a group or a column,
	                // however most people won't appreciate the difference,
	                // so keeping it as colDef to avoid confusion.
	                colDef: abstractColDef,
	                column: column,
	                columnGroup: columnGroup,
	                context: gridOptionsWrapper.getContext(),
	                api: gridOptionsWrapper.getApi()
	            };
	            var headerClassFunc = classesOrFunc;
	            classToUse = headerClassFunc(params);
	        }
	        else {
	            classToUse = classesOrFunc;
	        }
	        if (typeof classToUse === 'string') {
	            addCssClass(eHeaderCell, classToUse);
	        }
	        else if (Array.isArray(classToUse)) {
	            classToUse.forEach(function (cssClassItem) {
	                addCssClass(eHeaderCell, cssClassItem);
	            });
	        }
	    };
	    return CssClassApplier;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$K = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$E = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HoverFeature = /** @class */ (function (_super) {
	    __extends$K(HoverFeature, _super);
	    function HoverFeature(columns, element) {
	        var _this = _super.call(this) || this;
	        _this.columns = columns;
	        _this.element = element;
	        return _this;
	    }
	    HoverFeature.prototype.postConstruct = function () {
	        this.addMouseHoverListeners();
	    };
	    HoverFeature.prototype.addMouseHoverListeners = function () {
	        this.addManagedListener(this.element, 'mouseout', this.onMouseOut.bind(this));
	        this.addManagedListener(this.element, 'mouseover', this.onMouseOver.bind(this));
	    };
	    HoverFeature.prototype.onMouseOut = function () {
	        this.columnHoverService.clearMouseOver();
	    };
	    HoverFeature.prototype.onMouseOver = function () {
	        this.columnHoverService.setMouseOver(this.columns);
	    };
	    __decorate$E([
	        Autowired('columnHoverService')
	    ], HoverFeature.prototype, "columnHoverService", void 0);
	    __decorate$E([
	        PostConstruct
	    ], HoverFeature.prototype, "postConstruct", null);
	    return HoverFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$L = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$F = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SetLeftFeature = /** @class */ (function (_super) {
	    __extends$L(SetLeftFeature, _super);
	    function SetLeftFeature(columnOrGroup, eCell, beans, colsSpanning) {
	        var _this = _super.call(this) || this;
	        _this.columnOrGroup = columnOrGroup;
	        _this.eCell = eCell;
	        _this.ariaEl = _this.eCell.querySelector('[role=columnheader]') || _this.eCell;
	        _this.colsSpanning = colsSpanning;
	        _this.beans = beans;
	        _this.printLayout = beans.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        return _this;
	    }
	    SetLeftFeature.prototype.setColsSpanning = function (colsSpanning) {
	        this.colsSpanning = colsSpanning;
	        this.onLeftChanged();
	    };
	    SetLeftFeature.prototype.getColumnOrGroup = function () {
	        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
	            return last(this.colsSpanning);
	        }
	        return this.columnOrGroup;
	    };
	    SetLeftFeature.prototype.postConstruct = function () {
	        this.addManagedListener(this.columnOrGroup, Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
	        this.setLeftFirstTime();
	        // when in print layout, the left position is also dependent on the width of the pinned sections.
	        // so additionally update left if any column width changes.
	        if (this.printLayout) {
	            this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this));
	        }
	    };
	    SetLeftFeature.prototype.setLeftFirstTime = function () {
	        var suppressMoveAnimation = this.beans.gridOptionsWrapper.isSuppressColumnMoveAnimation();
	        var oldLeftExists = exists(this.columnOrGroup.getOldLeft());
	        var animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;
	        if (animateColumnMove) {
	            this.animateInLeft();
	        }
	        else {
	            this.onLeftChanged();
	        }
	    };
	    SetLeftFeature.prototype.animateInLeft = function () {
	        var _this = this;
	        var colOrGroup = this.getColumnOrGroup();
	        var left = colOrGroup.getLeft();
	        var oldLeft = colOrGroup.getOldLeft();
	        var oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, oldLeft);
	        var actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
	        this.setLeft(oldActualLeft);
	        // we must keep track of the left we want to set to, as this would otherwise lead to a race
	        // condition, if the user changed the left value many times in one VM turn, then we want to make
	        // make sure the actualLeft we set in the timeout below (in the next VM turn) is the correct left
	        // position. eg if user changes column position twice, then setLeft() below executes twice in next
	        // VM turn, but only one (the correct one) should get applied.
	        this.actualLeft = actualLeft;
	        this.beans.columnAnimationService.executeNextVMTurn(function () {
	            // test this left value is the latest one to be applied, and if not, do nothing
	            if (_this.actualLeft === actualLeft) {
	                _this.setLeft(actualLeft);
	            }
	        });
	    };
	    SetLeftFeature.prototype.onLeftChanged = function () {
	        var colOrGroup = this.getColumnOrGroup();
	        var left = colOrGroup.getLeft();
	        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
	        this.setLeft(this.actualLeft);
	    };
	    SetLeftFeature.prototype.modifyLeftForPrintLayout = function (colOrGroup, leftPosition) {
	        if (!this.printLayout) {
	            return leftPosition;
	        }
	        if (colOrGroup.getPinned() === Constants.PINNED_LEFT) {
	            return leftPosition;
	        }
	        var leftWidth = this.beans.columnController.getDisplayedColumnsLeftWidth();
	        if (colOrGroup.getPinned() === Constants.PINNED_RIGHT) {
	            var bodyWidth = this.beans.columnController.getBodyContainerWidth();
	            return leftWidth + bodyWidth + leftPosition;
	        }
	        // is in body
	        return leftWidth + leftPosition;
	    };
	    SetLeftFeature.prototype.setLeft = function (value) {
	        // if the value is null, then that means the column is no longer
	        // displayed. there is logic in the rendering to fade these columns
	        // out, so we don't try and change their left positions.
	        if (exists(value)) {
	            this.eCell.style.left = value + "px";
	        }
	        var indexColumn;
	        if (this.columnOrGroup instanceof Column) {
	            indexColumn = this.columnOrGroup;
	        }
	        else {
	            var columnGroup = this.columnOrGroup;
	            var children = columnGroup.getLeafColumns();
	            if (!children.length) {
	                return;
	            }
	            if (children.length > 1) {
	                setAriaColSpan(this.ariaEl, children.length);
	            }
	            indexColumn = children[0];
	        }
	        var index = this.beans.columnController.getAriaColumnIndex(indexColumn);
	        setAriaColIndex(this.ariaEl, index);
	    };
	    __decorate$F([
	        PostConstruct
	    ], SetLeftFeature.prototype, "postConstruct", null);
	    return SetLeftFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$M = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$G = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgAbstractLabel = /** @class */ (function (_super) {
	    __extends$M(AgAbstractLabel, _super);
	    function AgAbstractLabel(config, template) {
	        var _this = _super.call(this, template) || this;
	        _this.labelSeparator = '';
	        _this.labelAlignment = 'left';
	        _this.label = '';
	        _this.config = config || {};
	        return _this;
	    }
	    AgAbstractLabel.prototype.postConstruct = function () {
	        addCssClass(this.getGui(), 'ag-labeled');
	        addCssClass(this.eLabel, 'ag-label');
	        var _a = this.config, labelSeparator = _a.labelSeparator, label = _a.label, labelWidth = _a.labelWidth, labelAlignment = _a.labelAlignment;
	        if (labelSeparator != null) {
	            this.setLabelSeparator(labelSeparator);
	        }
	        if (label != null) {
	            this.setLabel(label);
	        }
	        if (labelWidth != null) {
	            this.setLabelWidth(labelWidth);
	        }
	        this.setLabelAlignment(labelAlignment || this.labelAlignment);
	        this.refreshLabel();
	    };
	    AgAbstractLabel.prototype.refreshLabel = function () {
	        clearElement(this.eLabel);
	        if (typeof this.label === 'string') {
	            this.eLabel.innerText = this.label + this.labelSeparator;
	        }
	        else if (this.label) {
	            this.eLabel.appendChild(this.label);
	        }
	        if (this.label === '') {
	            addCssClass(this.eLabel, 'ag-hidden');
	            this.eLabel.setAttribute('role', 'presentation');
	        }
	        else {
	            removeCssClass(this.eLabel, 'ag-hidden');
	            this.eLabel.removeAttribute('role');
	        }
	    };
	    AgAbstractLabel.prototype.setLabelSeparator = function (labelSeparator) {
	        if (this.labelSeparator === labelSeparator) {
	            return this;
	        }
	        this.labelSeparator = labelSeparator;
	        if (this.label != null) {
	            this.refreshLabel();
	        }
	        return this;
	    };
	    AgAbstractLabel.prototype.getLabelId = function () {
	        this.eLabel.id = this.eLabel.id || "ag-" + this.getCompId() + "-label";
	        return this.eLabel.id;
	    };
	    AgAbstractLabel.prototype.getLabel = function () {
	        return this.label;
	    };
	    AgAbstractLabel.prototype.setLabel = function (label) {
	        if (this.label === label) {
	            return this;
	        }
	        this.label = label;
	        this.refreshLabel();
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabelAlignment = function (alignment) {
	        var eGui = this.getGui();
	        addOrRemoveCssClass(eGui, 'ag-label-align-left', alignment === 'left');
	        addOrRemoveCssClass(eGui, 'ag-label-align-right', alignment === 'right');
	        addOrRemoveCssClass(eGui, 'ag-label-align-top', alignment === 'top');
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabelWidth = function (width) {
	        if (this.label == null) {
	            return this;
	        }
	        setElementWidth(this.eLabel, width);
	        return this;
	    };
	    __decorate$G([
	        PostConstruct
	    ], AgAbstractLabel.prototype, "postConstruct", null);
	    return AgAbstractLabel;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$N = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgAbstractField = /** @class */ (function (_super) {
	    __extends$N(AgAbstractField, _super);
	    function AgAbstractField(config, template, className) {
	        var _this = _super.call(this, config, template) || this;
	        _this.className = className;
	        _this.disabled = false;
	        return _this;
	    }
	    AgAbstractField.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        if (this.className) {
	            addCssClass(this.getGui(), this.className);
	        }
	    };
	    AgAbstractField.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        this.addManagedListener(this, AgAbstractField.EVENT_CHANGED, function () { return callbackFn(_this.getValue()); });
	        return this;
	    };
	    AgAbstractField.prototype.getWidth = function () {
	        return this.getGui().clientWidth;
	    };
	    AgAbstractField.prototype.setWidth = function (width) {
	        setFixedWidth(this.getGui(), width);
	        return this;
	    };
	    AgAbstractField.prototype.getPreviousValue = function () {
	        return this.previousValue;
	    };
	    AgAbstractField.prototype.getValue = function () {
	        return this.value;
	    };
	    AgAbstractField.prototype.setValue = function (value, silent) {
	        if (this.value === value) {
	            return this;
	        }
	        this.previousValue = this.value;
	        this.value = value;
	        if (!silent) {
	            this.dispatchEvent({ type: AgAbstractField.EVENT_CHANGED });
	        }
	        return this;
	    };
	    AgAbstractField.prototype.setDisabled = function (disabled) {
	        disabled = !!disabled;
	        var element = this.getGui();
	        setDisabled(element, disabled);
	        addOrRemoveCssClass(element, 'ag-disabled', disabled);
	        this.disabled = disabled;
	        return this;
	    };
	    AgAbstractField.prototype.isDisabled = function () {
	        return !!this.disabled;
	    };
	    AgAbstractField.EVENT_CHANGED = 'valueChange';
	    return AgAbstractField;
	}(AgAbstractLabel));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$O = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$H = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgAbstractInputField = /** @class */ (function (_super) {
	    __extends$O(AgAbstractInputField, _super);
	    function AgAbstractInputField(config, className, inputType, displayFieldTag) {
	        if (inputType === void 0) { inputType = 'text'; }
	        if (displayFieldTag === void 0) { displayFieldTag = 'input'; }
	        var _this = _super.call(this, config, /* html */ "\n            <div role=\"presentation\">\n                <div ref=\"eLabel\" class=\"ag-input-field-label\"></div>\n                <div ref=\"eWrapper\" class=\"ag-wrapper ag-input-wrapper\" role=\"presentation\">\n                    <" + displayFieldTag + " ref=\"eInput\" class=\"ag-input-field-input\"></" + displayFieldTag + ">\n                </div>\n            </div>", className) || this;
	        _this.inputType = inputType;
	        _this.displayFieldTag = displayFieldTag;
	        return _this;
	    }
	    AgAbstractInputField.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        this.setInputType();
	        addCssClass(this.eLabel, this.className + "-label");
	        addCssClass(this.eWrapper, this.className + "-input-wrapper");
	        addCssClass(this.eInput, this.className + "-input");
	        addCssClass(this.getGui(), 'ag-input-field');
	        this.eInput.id = this.eInput.id || "ag-" + this.getCompId() + "-input";
	        var _a = this.config, width = _a.width, value = _a.value;
	        if (width != null) {
	            this.setWidth(width);
	        }
	        if (value != null) {
	            this.setValue(value);
	        }
	        this.addInputListeners();
	    };
	    AgAbstractInputField.prototype.refreshLabel = function () {
	        if (exists(this.getLabel())) {
	            setAriaLabelledBy(this.eInput, this.getLabelId());
	        }
	        else {
	            this.eInput.removeAttribute('aria-labelledby');
	        }
	        _super.prototype.refreshLabel.call(this);
	    };
	    AgAbstractInputField.prototype.addInputListeners = function () {
	        var _this = this;
	        this.addManagedListener(this.eInput, 'input', function (e) { return _this.setValue(e.target.value); });
	    };
	    AgAbstractInputField.prototype.setInputType = function () {
	        if (this.displayFieldTag === 'input') {
	            this.eInput.setAttribute('type', this.inputType);
	        }
	    };
	    AgAbstractInputField.prototype.getInputElement = function () {
	        return this.eInput;
	    };
	    AgAbstractInputField.prototype.setInputWidth = function (width) {
	        setElementWidth(this.eWrapper, width);
	        return this;
	    };
	    AgAbstractInputField.prototype.setInputName = function (name) {
	        this.getInputElement().setAttribute('name', name);
	        return this;
	    };
	    AgAbstractInputField.prototype.getFocusableElement = function () {
	        return this.eInput;
	    };
	    AgAbstractInputField.prototype.setMaxLength = function (length) {
	        var eInput = this.eInput;
	        eInput.maxLength = length;
	        return this;
	    };
	    AgAbstractInputField.prototype.setInputPlaceholder = function (placeholder) {
	        addOrRemoveAttribute(this.eInput, 'placeholder', placeholder);
	        return this;
	    };
	    AgAbstractInputField.prototype.setInputAriaLabel = function (label) {
	        setAriaLabel(this.eInput, label);
	        return this;
	    };
	    AgAbstractInputField.prototype.setDisabled = function (disabled) {
	        setDisabled(this.eInput, disabled);
	        return _super.prototype.setDisabled.call(this, disabled);
	    };
	    __decorate$H([
	        RefSelector('eLabel')
	    ], AgAbstractInputField.prototype, "eLabel", void 0);
	    __decorate$H([
	        RefSelector('eWrapper')
	    ], AgAbstractInputField.prototype, "eWrapper", void 0);
	    __decorate$H([
	        RefSelector('eInput')
	    ], AgAbstractInputField.prototype, "eInput", void 0);
	    return AgAbstractInputField;
	}(AgAbstractField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$P = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgCheckbox = /** @class */ (function (_super) {
	    __extends$P(AgCheckbox, _super);
	    function AgCheckbox(config, className, inputType) {
	        if (className === void 0) { className = 'ag-checkbox'; }
	        if (inputType === void 0) { inputType = 'checkbox'; }
	        var _this = _super.call(this, config, className, inputType) || this;
	        _this.labelAlignment = 'right';
	        _this.selected = false;
	        _this.readOnly = false;
	        _this.passive = false;
	        return _this;
	    }
	    AgCheckbox.prototype.addInputListeners = function () {
	        this.addManagedListener(this.eInput, 'click', this.onCheckboxClick.bind(this));
	        this.addManagedListener(this.eLabel, 'click', this.toggle.bind(this));
	    };
	    AgCheckbox.prototype.getNextValue = function () {
	        return this.selected === undefined ? true : !this.selected;
	    };
	    AgCheckbox.prototype.setPassive = function (passive) {
	        this.passive = passive;
	    };
	    AgCheckbox.prototype.isReadOnly = function () {
	        return this.readOnly;
	    };
	    AgCheckbox.prototype.setReadOnly = function (readOnly) {
	        addOrRemoveCssClass(this.eWrapper, 'ag-disabled', readOnly);
	        this.eInput.disabled = readOnly;
	        this.readOnly = readOnly;
	    };
	    AgCheckbox.prototype.setDisabled = function (disabled) {
	        addOrRemoveCssClass(this.eWrapper, 'ag-disabled', disabled);
	        return _super.prototype.setDisabled.call(this, disabled);
	    };
	    AgCheckbox.prototype.toggle = function () {
	        var previousValue = this.isSelected();
	        var nextValue = this.getNextValue();
	        if (this.passive) {
	            this.dispatchChange(nextValue, previousValue);
	        }
	        else {
	            this.setValue(nextValue);
	        }
	    };
	    AgCheckbox.prototype.getValue = function () {
	        return this.isSelected();
	    };
	    AgCheckbox.prototype.setValue = function (value, silent) {
	        this.refreshSelectedClass(value);
	        this.setSelected(value, silent);
	        return this;
	    };
	    AgCheckbox.prototype.setName = function (name) {
	        var input = this.getInputElement();
	        input.name = name;
	        return this;
	    };
	    AgCheckbox.prototype.isSelected = function () {
	        return this.selected;
	    };
	    AgCheckbox.prototype.setSelected = function (selected, silent) {
	        if (this.isSelected() === selected) {
	            return;
	        }
	        this.previousValue = this.isSelected();
	        selected = this.selected = typeof selected === 'boolean' ? selected : undefined;
	        this.eInput.checked = selected;
	        this.eInput.indeterminate = selected === undefined;
	        if (!silent) {
	            this.dispatchChange(this.selected, this.previousValue);
	        }
	    };
	    AgCheckbox.prototype.dispatchChange = function (selected, previousValue, event) {
	        this.dispatchEvent({ type: AgCheckbox.EVENT_CHANGED, selected: selected, previousValue: previousValue, event: event });
	        var input = this.getInputElement();
	        var checkboxChangedEvent = {
	            type: Events.EVENT_CHECKBOX_CHANGED,
	            id: input.id,
	            name: input.name,
	            selected: selected,
	            previousValue: previousValue
	        };
	        this.eventService.dispatchEvent(checkboxChangedEvent);
	    };
	    AgCheckbox.prototype.onCheckboxClick = function (e) {
	        if (this.passive) {
	            return;
	        }
	        var previousValue = this.isSelected();
	        var selected = this.selected = e.target.checked;
	        this.refreshSelectedClass(selected);
	        this.dispatchChange(selected, previousValue, e);
	    };
	    AgCheckbox.prototype.refreshSelectedClass = function (value) {
	        addOrRemoveCssClass(this.eWrapper, 'ag-checked', value === true);
	        addOrRemoveCssClass(this.eWrapper, 'ag-indeterminate', value == null);
	    };
	    return AgCheckbox;
	}(AgAbstractInputField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$Q = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$I = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SelectAllFeature = /** @class */ (function (_super) {
	    __extends$Q(SelectAllFeature, _super);
	    function SelectAllFeature(cbSelectAll, column) {
	        var _this = _super.call(this) || this;
	        _this.cbSelectAllVisible = false;
	        _this.processingEventFromCheckbox = false;
	        _this.cbSelectAll = cbSelectAll;
	        _this.column = column;
	        var colDef = column.getColDef();
	        _this.filteredOnly = colDef ? !!colDef.headerCheckboxSelectionFilteredOnly : false;
	        return _this;
	    }
	    SelectAllFeature.prototype.postConstruct = function () {
	        this.showOrHideSelectAll();
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.showOrHideSelectAll.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelectAll.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
	        this.addManagedListener(this.cbSelectAll, AgCheckbox.EVENT_CHANGED, this.onCbSelectAll.bind(this));
	        this.cbSelectAll.getInputElement().setAttribute('tabindex', '-1');
	        this.refreshSelectAllLabel();
	    };
	    SelectAllFeature.prototype.showOrHideSelectAll = function () {
	        this.cbSelectAllVisible = this.isCheckboxSelection();
	        this.cbSelectAll.setDisplayed(this.cbSelectAllVisible);
	        if (this.cbSelectAllVisible) {
	            // in case user is trying this feature with the wrong model type
	            this.checkRightRowModelType();
	            // make sure checkbox is showing the right state
	            this.updateStateOfCheckbox();
	        }
	        this.refreshHeaderAriaDescribedBy(this.cbSelectAllVisible);
	    };
	    SelectAllFeature.prototype.refreshHeaderAriaDescribedBy = function (isSelectAllVisible) {
	        var parentHeader = this.cbSelectAll.getParentComponent();
	        var parentHeaderGui = parentHeader && parentHeader.getGui();
	        if (!parentHeaderGui || !isVisible(parentHeaderGui)) {
	            return;
	        }
	        var describedByIds = '';
	        if (parentHeaderGui) {
	            describedByIds = getAriaDescribedBy(parentHeaderGui);
	        }
	        var cbSelectAllId = this.cbSelectAll.getInputElement().id;
	        var describedByIdsHasSelectAllFeature = describedByIds.indexOf(cbSelectAllId) !== -1;
	        if (isSelectAllVisible) {
	            if (!describedByIdsHasSelectAllFeature) {
	                setAriaDescribedBy(parentHeaderGui, cbSelectAllId + " " + describedByIds.trim());
	            }
	        }
	        else if (describedByIdsHasSelectAllFeature) {
	            setAriaDescribedBy(parentHeaderGui, describedByIds.trim().split(' ').filter(function (id) { return id === cbSelectAllId; }).join(' '));
	        }
	    };
	    SelectAllFeature.prototype.onModelChanged = function () {
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        this.updateStateOfCheckbox();
	    };
	    SelectAllFeature.prototype.onSelectionChanged = function () {
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        this.updateStateOfCheckbox();
	    };
	    SelectAllFeature.prototype.getNextCheckboxState = function (selectionCount) {
	        // if no rows, always have it unselected
	        if (selectionCount.selected === 0 && selectionCount.notSelected === 0) {
	            return false;
	        }
	        // if mix of selected and unselected, this is the tri-state
	        if (selectionCount.selected > 0 && selectionCount.notSelected > 0) {
	            return null;
	        }
	        // only selected
	        if (selectionCount.selected > 0) {
	            return true;
	        }
	        // nothing selected
	        return false;
	    };
	    SelectAllFeature.prototype.updateStateOfCheckbox = function () {
	        if (this.processingEventFromCheckbox) {
	            return;
	        }
	        this.processingEventFromCheckbox = true;
	        var selectionCount = this.getSelectionCount();
	        var allSelected = this.getNextCheckboxState(selectionCount);
	        this.cbSelectAll.setValue(allSelected);
	        this.refreshSelectAllLabel();
	        this.processingEventFromCheckbox = false;
	    };
	    SelectAllFeature.prototype.refreshSelectAllLabel = function () {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var checked = this.cbSelectAll.getValue();
	        var ariaStatus = checked ? translate('ariaChecked', 'checked') : translate('ariaUnchecked', 'unchecked');
	        var ariaLabel = translate('ariaRowSelectAll', 'Press Space to toggle all rows selection');
	        this.cbSelectAll.setInputAriaLabel(ariaLabel + " (" + ariaStatus + ")");
	    };
	    SelectAllFeature.prototype.getSelectionCount = function () {
	        var _this = this;
	        var selectedCount = 0;
	        var notSelectedCount = 0;
	        var callback = function (node) {
	            if (_this.gridOptionsWrapper.isGroupSelectsChildren() && node.group) {
	                return;
	            }
	            if (node.isSelected()) {
	                selectedCount++;
	            }
	            else if (!node.selectable) ;
	            else {
	                notSelectedCount++;
	            }
	        };
	        if (this.filteredOnly) {
	            this.gridApi.forEachNodeAfterFilter(callback);
	        }
	        else {
	            this.gridApi.forEachNode(callback);
	        }
	        return {
	            notSelected: notSelectedCount,
	            selected: selectedCount
	        };
	    };
	    SelectAllFeature.prototype.checkRightRowModelType = function () {
	        var rowModelType = this.rowModel.getType();
	        var rowModelMatches = rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        if (!rowModelMatches) {
	            console.warn("AG Grid: selectAllCheckbox is only available if using normal row model, you are using " + rowModelType);
	        }
	    };
	    SelectAllFeature.prototype.onCbSelectAll = function () {
	        if (this.processingEventFromCheckbox) {
	            return;
	        }
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        var value = this.cbSelectAll.getValue();
	        if (value) {
	            this.selectionController.selectAllRowNodes(this.filteredOnly);
	        }
	        else {
	            this.selectionController.deselectAllRowNodes(this.filteredOnly);
	        }
	    };
	    SelectAllFeature.prototype.isCheckboxSelection = function () {
	        var result = this.column.getColDef().headerCheckboxSelection;
	        if (typeof result === 'function') {
	            var func = result;
	            result = func({
	                column: this.column,
	                colDef: this.column.getColDef(),
	                columnApi: this.columnApi,
	                api: this.gridApi
	            });
	        }
	        if (result) {
	            if (this.gridOptionsWrapper.isRowModelServerSide()) {
	                console.warn('headerCheckboxSelection is not supported for Server Side Row Model');
	                return false;
	            }
	            if (this.gridOptionsWrapper.isRowModelInfinite()) {
	                console.warn('headerCheckboxSelection is not supported for Infinite Row Model');
	                return false;
	            }
	            if (this.gridOptionsWrapper.isRowModelViewport()) {
	                console.warn('headerCheckboxSelection is not supported for Viewport Row Model');
	                return false;
	            }
	            // otherwise the row model is compatible, so return true
	            return true;
	        }
	        return false;
	    };
	    __decorate$I([
	        Autowired('gridApi')
	    ], SelectAllFeature.prototype, "gridApi", void 0);
	    __decorate$I([
	        Autowired('columnApi')
	    ], SelectAllFeature.prototype, "columnApi", void 0);
	    __decorate$I([
	        Autowired('rowModel')
	    ], SelectAllFeature.prototype, "rowModel", void 0);
	    __decorate$I([
	        Autowired('selectionController')
	    ], SelectAllFeature.prototype, "selectionController", void 0);
	    __decorate$I([
	        PostConstruct
	    ], SelectAllFeature.prototype, "postConstruct", null);
	    return SelectAllFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$R = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AbstractHeaderWrapper = /** @class */ (function (_super) {
	    __extends$R(AbstractHeaderWrapper, _super);
	    function AbstractHeaderWrapper() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AbstractHeaderWrapper.prototype.shouldStopEventPropagation = function (e) {
	        var _a = this.focusController.getFocusedHeader(), headerRowIndex = _a.headerRowIndex, column = _a.column;
	        return isUserSuppressingHeaderKeyboardEvent(this.gridOptionsWrapper, e, headerRowIndex, column);
	    };
	    AbstractHeaderWrapper.prototype.getColumn = function () {
	        return this.column;
	    };
	    AbstractHeaderWrapper.prototype.getPinned = function () {
	        return this.pinned;
	    };
	    return AbstractHeaderWrapper;
	}(ManagedFocusComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$S = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$J = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderWrapperComp = /** @class */ (function (_super) {
	    __extends$S(HeaderWrapperComp, _super);
	    function HeaderWrapperComp(column, pinned) {
	        var _this = _super.call(this, HeaderWrapperComp.TEMPLATE) || this;
	        _this.headerCompVersion = 0;
	        _this.refreshFunctions = [];
	        _this.column = column;
	        _this.pinned = pinned;
	        return _this;
	    }
	    HeaderWrapperComp.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        this.colDefVersion = this.columnController.getColDefVersion();
	        this.updateState();
	        this.setupWidth();
	        this.setupMovingCss();
	        this.setupTooltip();
	        this.setupResize();
	        this.setupMenuClass();
	        this.setupSortableClass();
	        this.addColumnHoverListener();
	        this.addActiveHeaderMouseListeners();
	        this.createManagedBean(new HoverFeature([this.column], this.getGui()));
	        this.addManagedListener(this.column, Column.EVENT_FILTER_ACTIVE_CHANGED, this.onFilterChanged.bind(this));
	        this.onFilterChanged();
	        this.createManagedBean(new SelectAllFeature(this.cbSelectAll, this.column));
	        this.cbSelectAll.setParentComponent(this);
	        this.createManagedBean(new SetLeftFeature(this.column, this.getGui(), this.beans));
	        this.addAttributes();
	        CssClassApplier.addHeaderClassesFromColDef(this.column.getColDef(), this.getGui(), this.gridOptionsWrapper, this.column, null);
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this));
	        this.appendHeaderComp();
	    };
	    HeaderWrapperComp.prototype.onColumnRowGroupChanged = function () {
	        this.checkDisplayName();
	    };
	    HeaderWrapperComp.prototype.onColumnPivotChanged = function () {
	        this.checkDisplayName();
	    };
	    HeaderWrapperComp.prototype.onColumnValueChanged = function () {
	        this.checkDisplayName();
	    };
	    HeaderWrapperComp.prototype.checkDisplayName = function () {
	        // display name can change if aggFunc different, eg sum(Gold) is now max(Gold)
	        if (this.displayName !== this.calculateDisplayName()) {
	            this.refresh();
	        }
	    };
	    HeaderWrapperComp.prototype.updateState = function () {
	        var colDef = this.column.getColDef();
	        this.sortable = colDef.sortable;
	        this.displayName = this.calculateDisplayName();
	        this.draggable = this.workOutDraggable();
	    };
	    HeaderWrapperComp.prototype.calculateDisplayName = function () {
	        return this.columnController.getDisplayNameForColumn(this.column, 'header', true);
	    };
	    HeaderWrapperComp.prototype.onNewColumnsLoaded = function () {
	        var colDefVersionNow = this.columnController.getColDefVersion();
	        if (colDefVersionNow != this.colDefVersion) {
	            this.colDefVersion = colDefVersionNow;
	            this.refresh();
	        }
	    };
	    HeaderWrapperComp.prototype.refresh = function () {
	        this.updateState();
	        this.refreshHeaderComp();
	        this.refreshFunctions.forEach(function (f) { return f(); });
	    };
	    HeaderWrapperComp.prototype.refreshHeaderComp = function () {
	        // if no header comp created yet, it's cos of async creation, so first version is yet
	        // to get here, in which case nothing to refresh
	        if (!this.headerComp) {
	            return;
	        }
	        var colDef = this.column.getColDef();
	        var newHeaderCompConfigured = this.colDefHeaderComponent != colDef.headerComponent
	            || this.colDefHeaderComponentFramework != colDef.headerComponentFramework;
	        var headerCompRefreshed = newHeaderCompConfigured ? false : this.attemptHeaderCompRefresh();
	        if (headerCompRefreshed) {
	            var dragSourceIsMissing = this.draggable && !this.moveDragSource;
	            var dragSourceNeedsRemoving = !this.draggable && this.moveDragSource;
	            if (dragSourceIsMissing || dragSourceNeedsRemoving) {
	                this.attachDraggingToHeaderComp();
	            }
	        }
	        else {
	            this.appendHeaderComp();
	        }
	    };
	    HeaderWrapperComp.prototype.destroyHeaderComp = function () {
	        if (this.headerComp) {
	            this.getGui().removeChild(this.headerCompGui);
	            this.headerComp = this.destroyBean(this.headerComp);
	            this.headerCompGui = undefined;
	        }
	        this.removeMoveDragSource();
	    };
	    HeaderWrapperComp.prototype.removeMoveDragSource = function () {
	        if (this.moveDragSource) {
	            this.dragAndDropService.removeDragSource(this.moveDragSource);
	            this.moveDragSource = undefined;
	        }
	    };
	    HeaderWrapperComp.prototype.attemptHeaderCompRefresh = function () {
	        // if no refresh method, then we want to replace the headerComp
	        if (!this.headerComp.refresh) {
	            return false;
	        }
	        // if the cell renderer has a refresh method, we call this instead of doing a refresh
	        var params = this.createParams();
	        // take any custom params off of the user
	        var finalParams = this.userComponentFactory.createFinalParams(this.getComponentHolder(), 'headerComponent', params);
	        var res = this.headerComp.refresh(finalParams);
	        return res;
	    };
	    HeaderWrapperComp.prototype.addActiveHeaderMouseListeners = function () {
	        var _this = this;
	        var listener = function (e) { return _this.setActiveHeader(e.type === 'mouseenter'); };
	        this.addManagedListener(this.getGui(), 'mouseenter', listener);
	        this.addManagedListener(this.getGui(), 'mouseleave', listener);
	    };
	    HeaderWrapperComp.prototype.setActiveHeader = function (active) {
	        addOrRemoveCssClass(this.getGui(), 'ag-header-active', active);
	    };
	    HeaderWrapperComp.prototype.onFocusIn = function (e) {
	        if (!this.getGui().contains(e.relatedTarget)) {
	            var headerRow = this.getParentComponent();
	            this.focusController.setFocusedHeader(headerRow.getRowIndex(), this.getColumn());
	        }
	        this.setActiveHeader(true);
	    };
	    HeaderWrapperComp.prototype.onFocusOut = function (e) {
	        if (this.getGui().contains(e.relatedTarget)) {
	            return;
	        }
	        this.setActiveHeader(false);
	    };
	    HeaderWrapperComp.prototype.handleKeyDown = function (e) {
	        var headerComp = this.headerComp;
	        if (!headerComp) {
	            return;
	        }
	        if (e.keyCode === KeyCode.SPACE) {
	            var checkbox = this.cbSelectAll;
	            if (checkbox.isDisplayed() && !checkbox.getGui().contains(document.activeElement)) {
	                e.preventDefault();
	                checkbox.setValue(!checkbox.getValue());
	            }
	        }
	        if (e.keyCode === KeyCode.ENTER) {
	            if (e.ctrlKey || e.metaKey) {
	                if (this.menuEnabled && headerComp.showMenu) {
	                    e.preventDefault();
	                    headerComp.showMenu();
	                }
	            }
	            else if (this.sortable) {
	                var multiSort = e.shiftKey;
	                this.sortController.progressSort(this.column, multiSort, "uiColumnSorted");
	            }
	        }
	    };
	    HeaderWrapperComp.prototype.onTabKeyDown = function () { };
	    HeaderWrapperComp.prototype.getComponentHolder = function () {
	        return this.column.getColDef();
	    };
	    HeaderWrapperComp.prototype.addColumnHoverListener = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
	        this.onColumnHover();
	    };
	    HeaderWrapperComp.prototype.onColumnHover = function () {
	        var isHovered = this.columnHoverService.isHovered(this.column);
	        addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
	    };
	    HeaderWrapperComp.prototype.setupSortableClass = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        var updateSortableCssClass = function () {
	            addOrRemoveCssClass(eGui, 'ag-header-cell-sortable', !!_this.sortable);
	        };
	        var updateAriaSort = function () {
	            if (_this.sortable) {
	                setAriaSort(eGui, getAriaSortState(_this.column));
	            }
	            else {
	                removeAriaSort(eGui);
	            }
	        };
	        updateSortableCssClass();
	        updateAriaSort();
	        this.refreshFunctions.push(updateSortableCssClass);
	        this.refreshFunctions.push(updateAriaSort);
	        this.addManagedListener(this.column, Column.EVENT_SORT_CHANGED, updateAriaSort.bind(this));
	    };
	    HeaderWrapperComp.prototype.onFilterChanged = function () {
	        var filterPresent = this.column.isFilterActive();
	        addOrRemoveCssClass(this.getGui(), 'ag-header-cell-filtered', filterPresent);
	    };
	    HeaderWrapperComp.prototype.appendHeaderComp = function () {
	        this.headerCompVersion++;
	        var colDef = this.column.getColDef();
	        this.colDefHeaderComponent = colDef.headerComponent;
	        this.colDefHeaderComponentFramework = colDef.headerComponentFramework;
	        var params = this.createParams();
	        var callback = this.afterHeaderCompCreated.bind(this, this.headerCompVersion);
	        this.userComponentFactory.newHeaderComponent(params).then(callback);
	    };
	    HeaderWrapperComp.prototype.createParams = function () {
	        var _this = this;
	        var colDef = this.column.getColDef();
	        this.menuEnabled = this.menuFactory.isMenuEnabled(this.column) && !colDef.suppressMenu;
	        var params = {
	            column: this.column,
	            displayName: this.displayName,
	            enableSorting: colDef.sortable,
	            enableMenu: this.menuEnabled,
	            showColumnMenu: function (source) {
	                _this.gridApi.showColumnMenuAfterButtonClick(_this.column, source);
	            },
	            progressSort: function (multiSort) {
	                _this.sortController.progressSort(_this.column, !!multiSort, "uiColumnSorted");
	            },
	            setSort: function (sort, multiSort) {
	                _this.sortController.setSortForColumn(_this.column, sort, !!multiSort, "uiColumnSorted");
	            },
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            context: this.gridOptionsWrapper.getContext(),
	            eGridHeader: this.getGui()
	        };
	        return params;
	    };
	    HeaderWrapperComp.prototype.afterHeaderCompCreated = function (version, headerComp) {
	        if (version != this.headerCompVersion || !this.isAlive()) {
	            this.destroyBean(headerComp);
	            return;
	        }
	        this.destroyHeaderComp();
	        this.headerComp = headerComp;
	        this.headerCompGui = headerComp.getGui();
	        this.getGui().appendChild(this.headerCompGui);
	        this.attachDraggingToHeaderComp();
	    };
	    HeaderWrapperComp.prototype.onColumnMovingChanged = function () {
	        // this function adds or removes the moving css, based on if the col is moving.
	        // this is what makes the header go dark when it is been moved (gives impression to
	        // user that the column was picked up).
	        if (this.column.isMoving()) {
	            addCssClass(this.getGui(), 'ag-header-cell-moving');
	        }
	        else {
	            removeCssClass(this.getGui(), 'ag-header-cell-moving');
	        }
	    };
	    HeaderWrapperComp.prototype.workOutDraggable = function () {
	        var colDef = this.column.getColDef();
	        var isSuppressMovableColumns = this.gridOptionsWrapper.isSuppressMovableColumns();
	        var colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
	        // we should still be allowed drag the column, even if it can't be moved, if the column
	        // can be dragged to a rowGroup or pivot drop zone
	        return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
	    };
	    HeaderWrapperComp.prototype.attachDraggingToHeaderComp = function () {
	        var _this = this;
	        this.removeMoveDragSource();
	        if (!this.draggable) {
	            return;
	        }
	        this.moveDragSource = {
	            type: exports.DragSourceType.HeaderCell,
	            eElement: this.headerCompGui,
	            defaultIconName: DragAndDropService.ICON_HIDE,
	            getDragItem: function () { return _this.createDragItem(); },
	            dragItemName: this.displayName,
	            onDragStarted: function () { return _this.column.setMoving(true, "uiColumnMoved"); },
	            onDragStopped: function () { return _this.column.setMoving(false, "uiColumnMoved"); }
	        };
	        this.dragAndDropService.addDragSource(this.moveDragSource, true);
	    };
	    HeaderWrapperComp.prototype.createDragItem = function () {
	        var visibleState = {};
	        visibleState[this.column.getId()] = this.column.isVisible();
	        return {
	            columns: [this.column],
	            visibleState: visibleState
	        };
	    };
	    HeaderWrapperComp.prototype.setupResize = function () {
	        var _this = this;
	        var colDef = this.getComponentHolder();
	        var destroyResizeFuncs = [];
	        var canResize;
	        var canAutosize;
	        var addResize = function () {
	            setDisplayed(_this.eResize, canResize);
	            if (!canResize) {
	                return;
	            }
	            var finishedWithResizeFunc = _this.horizontalResizeService.addResizeBar({
	                eResizeBar: _this.eResize,
	                onResizeStart: _this.onResizeStart.bind(_this),
	                onResizing: _this.onResizing.bind(_this, false),
	                onResizeEnd: _this.onResizing.bind(_this, true)
	            });
	            destroyResizeFuncs.push(finishedWithResizeFunc);
	            if (canAutosize) {
	                var skipHeaderOnAutoSize_1 = _this.gridOptionsWrapper.isSkipHeaderOnAutoSize();
	                var autoSizeColListener_1 = function () {
	                    _this.columnController.autoSizeColumn(_this.column, skipHeaderOnAutoSize_1, "uiColumnResized");
	                };
	                _this.eResize.addEventListener('dblclick', autoSizeColListener_1);
	                var touchListener_1 = new TouchListener(_this.eResize);
	                touchListener_1.addEventListener(TouchListener.EVENT_DOUBLE_TAP, autoSizeColListener_1);
	                _this.addDestroyFunc(function () {
	                    _this.eResize.removeEventListener('dblclick', autoSizeColListener_1);
	                    touchListener_1.removeEventListener(TouchListener.EVENT_DOUBLE_TAP, autoSizeColListener_1);
	                    touchListener_1.destroy();
	                });
	            }
	        };
	        var removeResize = function () {
	            destroyResizeFuncs.forEach(function (f) { return f(); });
	            destroyResizeFuncs.length = 0;
	        };
	        var refresh = function () {
	            var resize = _this.column.isResizable();
	            var autoSize = !_this.gridOptionsWrapper.isSuppressAutoSize() && !colDef.suppressAutoSize;
	            var propertyChange = resize !== canResize || autoSize !== canAutosize;
	            if (propertyChange) {
	                canResize = resize;
	                canAutosize = autoSize;
	                removeResize();
	                addResize();
	            }
	        };
	        refresh();
	        this.addDestroyFunc(removeResize);
	        this.refreshFunctions.push(refresh);
	    };
	    HeaderWrapperComp.prototype.onResizing = function (finished, resizeAmount) {
	        var resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
	        var columnWidths = [{ key: this.column, newWidth: this.resizeStartWidth + resizeAmountNormalised }];
	        this.columnController.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnDragged");
	        if (finished) {
	            removeCssClass(this.getGui(), 'ag-column-resizing');
	        }
	    };
	    HeaderWrapperComp.prototype.onResizeStart = function (shiftKey) {
	        this.resizeStartWidth = this.column.getActualWidth();
	        this.resizeWithShiftKey = shiftKey;
	        addCssClass(this.getGui(), 'ag-column-resizing');
	    };
	    HeaderWrapperComp.prototype.getTooltipParams = function () {
	        var res = _super.prototype.getTooltipParams.call(this);
	        res.location = 'header';
	        res.colDef = this.column.getColDef();
	        return res;
	    };
	    HeaderWrapperComp.prototype.setupTooltip = function () {
	        var _this = this;
	        var refresh = function () {
	            var newTooltipText = _this.column.getColDef().headerTooltip;
	            _this.setTooltip(escapeString(newTooltipText));
	        };
	        refresh();
	        this.refreshFunctions.push(refresh);
	    };
	    HeaderWrapperComp.prototype.setupMovingCss = function () {
	        this.addManagedListener(this.column, Column.EVENT_MOVING_CHANGED, this.onColumnMovingChanged.bind(this));
	        this.onColumnMovingChanged();
	    };
	    HeaderWrapperComp.prototype.addAttributes = function () {
	        this.getGui().setAttribute("col-id", this.column.getColId());
	    };
	    HeaderWrapperComp.prototype.setupWidth = function () {
	        this.addManagedListener(this.column, Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
	        this.onColumnWidthChanged();
	    };
	    HeaderWrapperComp.prototype.setupMenuClass = function () {
	        this.addManagedListener(this.column, Column.EVENT_MENU_VISIBLE_CHANGED, this.onMenuVisible.bind(this));
	    };
	    HeaderWrapperComp.prototype.onMenuVisible = function () {
	        this.addOrRemoveCssClass('ag-column-menu-visible', this.column.isMenuVisible());
	    };
	    HeaderWrapperComp.prototype.onColumnWidthChanged = function () {
	        this.getGui().style.width = this.column.getActualWidth() + 'px';
	    };
	    // optionally inverts the drag, depending on pinned and RTL
	    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
	    HeaderWrapperComp.prototype.normaliseResizeAmount = function (dragChange) {
	        var result = dragChange;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, dragging left makes the col bigger, except when pinning left
	            if (this.pinned !== Constants.PINNED_LEFT) {
	                result *= -1;
	            }
	        }
	        else {
	            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
	            if (this.pinned === Constants.PINNED_RIGHT) {
	                result *= -1;
	            }
	        }
	        return result;
	    };
	    HeaderWrapperComp.TEMPLATE = "<div class=\"ag-header-cell\" role=\"columnheader\" unselectable=\"on\" tabindex=\"-1\">\n            <div ref=\"eResize\" class=\"ag-header-cell-resize\" role=\"presentation\"></div>\n            <ag-checkbox ref=\"cbSelectAll\" class=\"ag-header-select-all\" role=\"presentation\"></ag-checkbox>\n        </div>";
	    __decorate$J([
	        Autowired('dragAndDropService')
	    ], HeaderWrapperComp.prototype, "dragAndDropService", void 0);
	    __decorate$J([
	        Autowired('columnController')
	    ], HeaderWrapperComp.prototype, "columnController", void 0);
	    __decorate$J([
	        Autowired('horizontalResizeService')
	    ], HeaderWrapperComp.prototype, "horizontalResizeService", void 0);
	    __decorate$J([
	        Autowired('menuFactory')
	    ], HeaderWrapperComp.prototype, "menuFactory", void 0);
	    __decorate$J([
	        Autowired('gridApi')
	    ], HeaderWrapperComp.prototype, "gridApi", void 0);
	    __decorate$J([
	        Autowired('columnApi')
	    ], HeaderWrapperComp.prototype, "columnApi", void 0);
	    __decorate$J([
	        Autowired('sortController')
	    ], HeaderWrapperComp.prototype, "sortController", void 0);
	    __decorate$J([
	        Autowired('userComponentFactory')
	    ], HeaderWrapperComp.prototype, "userComponentFactory", void 0);
	    __decorate$J([
	        Autowired('columnHoverService')
	    ], HeaderWrapperComp.prototype, "columnHoverService", void 0);
	    __decorate$J([
	        Autowired('beans')
	    ], HeaderWrapperComp.prototype, "beans", void 0);
	    __decorate$J([
	        RefSelector('eResize')
	    ], HeaderWrapperComp.prototype, "eResize", void 0);
	    __decorate$J([
	        RefSelector('cbSelectAll')
	    ], HeaderWrapperComp.prototype, "cbSelectAll", void 0);
	    __decorate$J([
	        PreDestroy
	    ], HeaderWrapperComp.prototype, "destroyHeaderComp", null);
	    return HeaderWrapperComp;
	}(AbstractHeaderWrapper));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$T = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$K = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderGroupWrapperComp = /** @class */ (function (_super) {
	    __extends$T(HeaderGroupWrapperComp, _super);
	    function HeaderGroupWrapperComp(columnGroup, pinned) {
	        var _this = _super.call(this, HeaderGroupWrapperComp.TEMPLATE) || this;
	        // the children can change, we keep destroy functions related to listening to the children here
	        _this.removeChildListenersFuncs = [];
	        _this.column = columnGroup;
	        _this.pinned = pinned;
	        return _this;
	    }
	    HeaderGroupWrapperComp.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        CssClassApplier.addHeaderClassesFromColDef(this.getComponentHolder(), this.getGui(), this.gridOptionsWrapper, null, this.column);
	        var displayName = this.columnController.getDisplayNameForColumnGroup(this.column, 'header');
	        this.appendHeaderGroupComp(displayName);
	        this.setupResize();
	        this.addClasses();
	        this.setupWidth();
	        this.addAttributes();
	        this.setupMovingCss();
	        this.setupTooltip();
	        this.setupExpandable();
	        this.createManagedBean(new HoverFeature(this.column.getOriginalColumnGroup().getLeafColumns(), this.getGui()));
	        this.createManagedBean(new SetLeftFeature(this.column, this.getGui(), this.beans));
	    };
	    HeaderGroupWrapperComp.prototype.onFocusIn = function (e) {
	        if (!this.getGui().contains(e.relatedTarget)) {
	            var headerRow = this.getParentComponent();
	            this.beans.focusController.setFocusedHeader(headerRow.getRowIndex(), this.getColumn());
	        }
	    };
	    HeaderGroupWrapperComp.prototype.handleKeyDown = function (e) {
	        var activeEl = document.activeElement;
	        var eGui = this.getGui();
	        var wrapperHasFocus = activeEl === eGui;
	        if (!this.expandable || !wrapperHasFocus) {
	            return;
	        }
	        if (e.keyCode === KeyCode.ENTER) {
	            var column = this.getColumn();
	            var newExpandedValue = !column.isExpanded();
	            this.columnController.setColumnGroupOpened(column.getOriginalColumnGroup(), newExpandedValue, "uiColumnExpanded");
	        }
	    };
	    HeaderGroupWrapperComp.prototype.onTabKeyDown = function () { };
	    HeaderGroupWrapperComp.prototype.setupExpandable = function () {
	        var column = this.getColumn();
	        var originalColumnGroup = column.getOriginalColumnGroup();
	        this.refreshExpanded();
	        this.addManagedListener(originalColumnGroup, OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this));
	        this.addManagedListener(originalColumnGroup, OriginalColumnGroup.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
	    };
	    HeaderGroupWrapperComp.prototype.refreshExpanded = function () {
	        var column = this.getColumn();
	        var eGui = this.getGui();
	        var expandable = column.isExpandable();
	        var expanded = column.isExpanded();
	        this.expandable = expandable;
	        if (!expandable) {
	            eGui.removeAttribute('aria-expanded');
	        }
	        else {
	            setAriaExpanded(eGui, expanded);
	        }
	    };
	    HeaderGroupWrapperComp.prototype.setupMovingCss = function () {
	        var _this = this;
	        var originalColumnGroup = this.column.getOriginalColumnGroup();
	        var leafColumns = originalColumnGroup.getLeafColumns();
	        leafColumns.forEach(function (col) {
	            _this.addManagedListener(col, Column.EVENT_MOVING_CHANGED, _this.onColumnMovingChanged.bind(_this));
	        });
	        this.onColumnMovingChanged();
	    };
	    HeaderGroupWrapperComp.prototype.getComponentHolder = function () {
	        return this.column.getColGroupDef();
	    };
	    HeaderGroupWrapperComp.prototype.getTooltipParams = function () {
	        var res = _super.prototype.getTooltipParams.call(this);
	        res.location = 'headerGroup';
	        // this is wrong, but leaving it as i don't want to change code,
	        // but the ColumnGroup does not have a ColDef or a Column (although it does have GroupDef and ColumnGroup)
	        res.colDef = this.getComponentHolder();
	        res.column = this.getColumn();
	        return res;
	    };
	    HeaderGroupWrapperComp.prototype.setupTooltip = function () {
	        var colGroupDef = this.getComponentHolder();
	        var tooltipText = colGroupDef && colGroupDef.headerTooltip;
	        if (tooltipText != null) {
	            this.setTooltip(escapeString(tooltipText));
	        }
	    };
	    HeaderGroupWrapperComp.prototype.onColumnMovingChanged = function () {
	        // this function adds or removes the moving css, based on if the col is moving.
	        // this is what makes the header go dark when it is been moved (gives impression to
	        // user that the column was picked up).
	        addOrRemoveCssClass(this.getGui(), 'ag-header-cell-moving', this.column.isMoving());
	    };
	    HeaderGroupWrapperComp.prototype.addAttributes = function () {
	        this.getGui().setAttribute("col-id", this.column.getUniqueId());
	    };
	    HeaderGroupWrapperComp.prototype.appendHeaderGroupComp = function (displayName) {
	        var _this = this;
	        var params = {
	            displayName: displayName,
	            columnGroup: this.column,
	            setExpanded: function (expanded) {
	                _this.columnController.setColumnGroupOpened(_this.column.getOriginalColumnGroup(), expanded, "gridInitializing");
	            },
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        if (!displayName) {
	            var columnGroup = this.column;
	            var leafCols = columnGroup.getLeafColumns();
	            // find the top most column group that represents the same columns. so if we are dragging a group, we also
	            // want to visually show the parent groups dragging for the same column set. for example imaging 5 levels
	            // of grouping, with each group only containing the next group, and the last group containing three columns,
	            // then when you move any group (even the lowest level group) you are in-fact moving all the groups, as all
	            // the groups represent the same column set.
	            while (columnGroup.getParent() && columnGroup.getParent().getLeafColumns().length === leafCols.length) {
	                columnGroup = columnGroup.getParent();
	            }
	            var colGroupDef = columnGroup.getColGroupDef();
	            if (colGroupDef) {
	                displayName = colGroupDef.headerName;
	            }
	            if (!displayName) {
	                displayName = leafCols ? this.columnController.getDisplayNameForColumn(leafCols[0], 'header', true) : '';
	            }
	        }
	        var callback = this.afterHeaderCompCreated.bind(this, displayName);
	        this.userComponentFactory.newHeaderGroupComponent(params).then(callback);
	    };
	    HeaderGroupWrapperComp.prototype.afterHeaderCompCreated = function (displayName, headerGroupComp) {
	        var _this = this;
	        this.getGui().appendChild(headerGroupComp.getGui());
	        this.addDestroyFunc(function () {
	            _this.getContext().destroyBean(headerGroupComp);
	        });
	        this.setupMove(headerGroupComp.getGui(), displayName);
	    };
	    HeaderGroupWrapperComp.prototype.addClasses = function () {
	        // having different classes below allows the style to not have a bottom border
	        // on the group header, if no group is specified
	        // columnGroup.getColGroupDef
	        var style = this.column.isPadding() ? 'no' : 'with';
	        this.addCssClass("ag-header-group-cell-" + style + "-group");
	    };
	    HeaderGroupWrapperComp.prototype.setupMove = function (eHeaderGroup, displayName) {
	        var _this = this;
	        if (!eHeaderGroup) {
	            return;
	        }
	        if (this.isSuppressMoving()) {
	            return;
	        }
	        var allLeafColumns = this.column.getOriginalColumnGroup().getLeafColumns();
	        var dragSource = {
	            type: exports.DragSourceType.HeaderCell,
	            eElement: eHeaderGroup,
	            defaultIconName: DragAndDropService.ICON_HIDE,
	            dragItemName: displayName,
	            // we add in the original group leaf columns, so we move both visible and non-visible items
	            getDragItem: this.getDragItemForGroup.bind(this),
	            onDragStarted: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(true, "uiColumnDragged"); }); },
	            onDragStopped: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(false, "uiColumnDragged"); }); }
	        };
	        this.dragAndDropService.addDragSource(dragSource, true);
	        this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
	    };
	    // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
	    // and in the order they are currently in the screen.
	    HeaderGroupWrapperComp.prototype.getDragItemForGroup = function () {
	        var allColumnsOriginalOrder = this.column.getOriginalColumnGroup().getLeafColumns();
	        // capture visible state, used when re-entering grid to dictate which columns should be visible
	        var visibleState = {};
	        allColumnsOriginalOrder.forEach(function (column) { return visibleState[column.getId()] = column.isVisible(); });
	        var allColumnsCurrentOrder = [];
	        this.columnController.getAllDisplayedColumns().forEach(function (column) {
	            if (allColumnsOriginalOrder.indexOf(column) >= 0) {
	                allColumnsCurrentOrder.push(column);
	                removeFromArray(allColumnsOriginalOrder, column);
	            }
	        });
	        // we are left with non-visible columns, stick these in at the end
	        allColumnsOriginalOrder.forEach(function (column) { return allColumnsCurrentOrder.push(column); });
	        // create and return dragItem
	        return {
	            columns: allColumnsCurrentOrder,
	            visibleState: visibleState
	        };
	    };
	    HeaderGroupWrapperComp.prototype.isSuppressMoving = function () {
	        // if any child is fixed, then don't allow moving
	        var childSuppressesMoving = false;
	        this.column.getLeafColumns().forEach(function (column) {
	            if (column.getColDef().suppressMovable || column.getColDef().lockPosition) {
	                childSuppressesMoving = true;
	            }
	        });
	        var result = childSuppressesMoving || this.gridOptionsWrapper.isSuppressMovableColumns();
	        return result;
	    };
	    HeaderGroupWrapperComp.prototype.setupWidth = function () {
	        // we need to listen to changes in child columns, as they impact our width
	        this.addListenersToChildrenColumns();
	        // the children belonging to this group can change, so we need to add and remove listeners as they change
	        this.addManagedListener(this.column, ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
	        this.onWidthChanged();
	        // the child listeners are not tied to this components life-cycle, as children can get added and removed
	        // to the group - hence they are on a different life-cycle. so we must make sure the existing children
	        // listeners are removed when we finally get destroyed
	        this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
	    };
	    HeaderGroupWrapperComp.prototype.onDisplayedChildrenChanged = function () {
	        this.addListenersToChildrenColumns();
	        this.onWidthChanged();
	    };
	    HeaderGroupWrapperComp.prototype.addListenersToChildrenColumns = function () {
	        var _this = this;
	        // first destroy any old listeners
	        this.removeListenersOnChildrenColumns();
	        // now add new listeners to the new set of children
	        var widthChangedListener = this.onWidthChanged.bind(this);
	        this.column.getLeafColumns().forEach(function (column) {
	            column.addEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	            column.addEventListener(Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
	            _this.removeChildListenersFuncs.push(function () {
	                column.removeEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	                column.removeEventListener(Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
	            });
	        });
	    };
	    HeaderGroupWrapperComp.prototype.removeListenersOnChildrenColumns = function () {
	        this.removeChildListenersFuncs.forEach(function (func) { return func(); });
	        this.removeChildListenersFuncs = [];
	    };
	    HeaderGroupWrapperComp.prototype.onWidthChanged = function () {
	        this.getGui().style.width = this.column.getActualWidth() + 'px';
	    };
	    HeaderGroupWrapperComp.prototype.setupResize = function () {
	        var _this = this;
	        this.eHeaderCellResize = this.getRefElement('agResize');
	        if (!this.column.isResizable()) {
	            removeFromParent(this.eHeaderCellResize);
	            return;
	        }
	        var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
	            eResizeBar: this.eHeaderCellResize,
	            onResizeStart: this.onResizeStart.bind(this),
	            onResizing: this.onResizing.bind(this, false),
	            onResizeEnd: this.onResizing.bind(this, true)
	        });
	        this.addDestroyFunc(finishedWithResizeFunc);
	        if (!this.gridOptionsWrapper.isSuppressAutoSize()) {
	            var skipHeaderOnAutoSize_1 = this.gridOptionsWrapper.isSkipHeaderOnAutoSize();
	            this.eHeaderCellResize.addEventListener('dblclick', function (event) {
	                // get list of all the column keys we are responsible for
	                var keys = [];
	                _this.column.getDisplayedLeafColumns().forEach(function (column) {
	                    // not all cols in the group may be participating with auto-resize
	                    if (!column.getColDef().suppressAutoSize) {
	                        keys.push(column.getColId());
	                    }
	                });
	                if (keys.length > 0) {
	                    _this.columnController.autoSizeColumns(keys, skipHeaderOnAutoSize_1, "uiColumnResized");
	                }
	            });
	        }
	    };
	    HeaderGroupWrapperComp.prototype.onResizeStart = function (shiftKey) {
	        var _this = this;
	        var leafCols = this.column.getDisplayedLeafColumns();
	        this.resizeCols = leafCols.filter(function (col) { return col.isResizable(); });
	        this.resizeStartWidth = 0;
	        this.resizeCols.forEach(function (col) { return _this.resizeStartWidth += col.getActualWidth(); });
	        this.resizeRatios = [];
	        this.resizeCols.forEach(function (col) { return _this.resizeRatios.push(col.getActualWidth() / _this.resizeStartWidth); });
	        var takeFromGroup = null;
	        if (shiftKey) {
	            takeFromGroup = this.columnController.getDisplayedGroupAfter(this.column);
	        }
	        if (takeFromGroup) {
	            var takeFromLeafCols = takeFromGroup.getDisplayedLeafColumns();
	            this.resizeTakeFromCols = takeFromLeafCols.filter(function (col) { return col.isResizable(); });
	            this.resizeTakeFromStartWidth = 0;
	            this.resizeTakeFromCols.forEach(function (col) { return _this.resizeTakeFromStartWidth += col.getActualWidth(); });
	            this.resizeTakeFromRatios = [];
	            this.resizeTakeFromCols.forEach(function (col) { return _this.resizeTakeFromRatios.push(col.getActualWidth() / _this.resizeTakeFromStartWidth); });
	        }
	        else {
	            this.resizeTakeFromCols = null;
	            this.resizeTakeFromStartWidth = null;
	            this.resizeTakeFromRatios = null;
	        }
	        addCssClass(this.getGui(), 'ag-column-resizing');
	    };
	    HeaderGroupWrapperComp.prototype.onResizing = function (finished, resizeAmount) {
	        var resizeSets = [];
	        var resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
	        resizeSets.push({
	            columns: this.resizeCols,
	            ratios: this.resizeRatios,
	            width: this.resizeStartWidth + resizeAmountNormalised
	        });
	        if (this.resizeTakeFromCols) {
	            resizeSets.push({
	                columns: this.resizeTakeFromCols,
	                ratios: this.resizeTakeFromRatios,
	                width: this.resizeTakeFromStartWidth - resizeAmountNormalised
	            });
	        }
	        this.columnController.resizeColumnSets(resizeSets, finished, 'uiColumnDragged');
	        if (finished) {
	            removeCssClass(this.getGui(), 'ag-column-resizing');
	        }
	    };
	    // optionally inverts the drag, depending on pinned and RTL
	    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
	    HeaderGroupWrapperComp.prototype.normaliseDragChange = function (dragChange) {
	        var result = dragChange;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, dragging left makes the col bigger, except when pinning left
	            if (this.pinned !== Constants.PINNED_LEFT) {
	                result *= -1;
	            }
	        }
	        else if (this.pinned === Constants.PINNED_RIGHT) {
	            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
	            result *= -1;
	        }
	        return result;
	    };
	    HeaderGroupWrapperComp.TEMPLATE = "<div class=\"ag-header-group-cell\" role=\"columnheader\" tabindex=\"-1\">\n            <div ref=\"agResize\" class=\"ag-header-cell-resize\" role=\"presentation\"></div>\n        </div>";
	    __decorate$K([
	        Autowired('columnController')
	    ], HeaderGroupWrapperComp.prototype, "columnController", void 0);
	    __decorate$K([
	        Autowired('horizontalResizeService')
	    ], HeaderGroupWrapperComp.prototype, "horizontalResizeService", void 0);
	    __decorate$K([
	        Autowired('dragAndDropService')
	    ], HeaderGroupWrapperComp.prototype, "dragAndDropService", void 0);
	    __decorate$K([
	        Autowired('userComponentFactory')
	    ], HeaderGroupWrapperComp.prototype, "userComponentFactory", void 0);
	    __decorate$K([
	        Autowired('beans')
	    ], HeaderGroupWrapperComp.prototype, "beans", void 0);
	    __decorate$K([
	        Autowired('gridApi')
	    ], HeaderGroupWrapperComp.prototype, "gridApi", void 0);
	    __decorate$K([
	        Autowired('columnApi')
	    ], HeaderGroupWrapperComp.prototype, "columnApi", void 0);
	    return HeaderGroupWrapperComp;
	}(AbstractHeaderWrapper));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$U = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$L = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// optional floating filter for user provided filters - instead of providing a floating filter,
	// they can provide a getModelAsString() method on the filter instead. this class just displays
	// the string returned from getModelAsString()
	var ReadOnlyFloatingFilter = /** @class */ (function (_super) {
	    __extends$U(ReadOnlyFloatingFilter, _super);
	    function ReadOnlyFloatingFilter() {
	        return _super.call(this, /* html */ "\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eFloatingFilterText\"></ag-input-text-field>\n            </div>") || this;
	    }
	    // this is a user component, and IComponent has "public destroy()" as part of the interface.
	    // so we need to override destroy() just to make the method public.
	    ReadOnlyFloatingFilter.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	    };
	    ReadOnlyFloatingFilter.prototype.init = function (params) {
	        this.params = params;
	        var displayName = this.columnController.getDisplayNameForColumn(params.column, 'header', true);
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eFloatingFilterText
	            .setDisabled(true)
	            .setInputAriaLabel(displayName + " " + translate('ariaFilterInput', 'Filter Input'));
	    };
	    ReadOnlyFloatingFilter.prototype.onParentModelChanged = function (parentModel) {
	        var _this = this;
	        if (!parentModel) {
	            this.eFloatingFilterText.setValue('');
	            return;
	        }
	        this.params.parentFilterInstance(function (filterInstance) {
	            // it would be nice to check if getModelAsString was present before creating this component,
	            // however that is not possible, as React Hooks and VueJS don't attached the methods to the Filter until
	            // AFTER the filter is created, not allowing inspection before this (we create floating filters as columns
	            // are drawn, but the parent filters are only created when needed).
	            if (filterInstance.getModelAsString) {
	                var modelAsString = filterInstance.getModelAsString(parentModel);
	                _this.eFloatingFilterText.setValue(modelAsString);
	            }
	        });
	    };
	    __decorate$L([
	        RefSelector('eFloatingFilterText')
	    ], ReadOnlyFloatingFilter.prototype, "eFloatingFilterText", void 0);
	    __decorate$L([
	        Autowired('columnController')
	    ], ReadOnlyFloatingFilter.prototype, "columnController", void 0);
	    return ReadOnlyFloatingFilter;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var FloatingFilterMapper = /** @class */ (function () {
	    function FloatingFilterMapper() {
	    }
	    FloatingFilterMapper.getFloatingFilterType = function (filterType) {
	        return this.filterToFloatingFilterMapping[filterType];
	    };
	    FloatingFilterMapper.filterToFloatingFilterMapping = {
	        set: 'agSetColumnFloatingFilter',
	        agSetColumnFilter: 'agSetColumnFloatingFilter',
	        multi: 'agMultiColumnFloatingFilter',
	        agMultiColumnFilter: 'agMultiColumnFloatingFilter',
	        number: 'agNumberColumnFloatingFilter',
	        agNumberColumnFilter: 'agNumberColumnFloatingFilter',
	        date: 'agDateColumnFloatingFilter',
	        agDateColumnFilter: 'agDateColumnFloatingFilter',
	        text: 'agTextColumnFloatingFilter',
	        agTextColumnFilter: 'agTextColumnFloatingFilter'
	    };
	    return FloatingFilterMapper;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$V = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$M = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var FloatingFilterWrapper = /** @class */ (function (_super) {
	    __extends$V(FloatingFilterWrapper, _super);
	    function FloatingFilterWrapper(column, pinned) {
	        var _this = _super.call(this, FloatingFilterWrapper.TEMPLATE) || this;
	        _this.column = column;
	        _this.pinned = pinned;
	        return _this;
	    }
	    FloatingFilterWrapper.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        this.setupFloatingFilter();
	        this.setupWidth();
	        this.setupLeftPositioning();
	        this.setupColumnHover();
	        this.createManagedBean(new HoverFeature([this.column], this.getGui()));
	        this.addManagedListener(this.eButtonShowMainFilter, 'click', this.showParentFilter.bind(this));
	    };
	    FloatingFilterWrapper.prototype.onTabKeyDown = function (e) {
	        var activeEl = document.activeElement;
	        var eGui = this.getGui();
	        var wrapperHasFocus = activeEl === eGui;
	        if (wrapperHasFocus) {
	            return;
	        }
	        e.preventDefault();
	        var nextFocusableEl = this.focusController.findNextFocusableElement(eGui, null, e.shiftKey);
	        if (nextFocusableEl) {
	            nextFocusableEl.focus();
	        }
	        else {
	            eGui.focus();
	        }
	    };
	    FloatingFilterWrapper.prototype.handleKeyDown = function (e) {
	        var activeEl = document.activeElement;
	        var eGui = this.getGui();
	        var wrapperHasFocus = activeEl === eGui;
	        switch (e.keyCode) {
	            case KeyCode.UP:
	            case KeyCode.DOWN:
	                if (!wrapperHasFocus) {
	                    e.preventDefault();
	                }
	            case KeyCode.LEFT:
	            case KeyCode.RIGHT:
	                if (wrapperHasFocus) {
	                    return;
	                }
	                e.stopPropagation();
	            case KeyCode.ENTER:
	                if (wrapperHasFocus) {
	                    if (this.focusController.focusInto(eGui)) {
	                        e.preventDefault();
	                    }
	                }
	                break;
	            case KeyCode.ESCAPE:
	                if (!wrapperHasFocus) {
	                    this.getGui().focus();
	                }
	        }
	    };
	    FloatingFilterWrapper.prototype.onFocusIn = function (e) {
	        var eGui = this.getGui();
	        if (!eGui.contains(e.relatedTarget)) {
	            var headerRow = this.getParentComponent();
	            this.beans.focusController.setFocusedHeader(headerRow.getRowIndex(), this.getColumn());
	        }
	    };
	    FloatingFilterWrapper.prototype.setupFloatingFilter = function () {
	        var _this = this;
	        var colDef = this.column.getColDef();
	        if (!colDef.filter || !colDef.floatingFilter) {
	            return;
	        }
	        this.floatingFilterCompPromise = this.getFloatingFilterInstance();
	        if (!this.floatingFilterCompPromise) {
	            return;
	        }
	        this.floatingFilterCompPromise.then(function (compInstance) {
	            if (compInstance) {
	                _this.setupWithFloatingFilter(compInstance);
	                _this.setupSyncWithFilter();
	            }
	        });
	    };
	    FloatingFilterWrapper.prototype.setupLeftPositioning = function () {
	        var setLeftFeature = new SetLeftFeature(this.column, this.getGui(), this.beans);
	        this.createManagedBean(setLeftFeature);
	    };
	    FloatingFilterWrapper.prototype.setupSyncWithFilter = function () {
	        var _this = this;
	        var syncWithFilter = function (filterChangedEvent) {
	            _this.onParentModelChanged(_this.currentParentModel(), filterChangedEvent);
	        };
	        this.addManagedListener(this.column, Column.EVENT_FILTER_CHANGED, syncWithFilter);
	        if (this.filterManager.isFilterActive(this.column)) {
	            syncWithFilter(null);
	        }
	    };
	    // linked to event listener in template
	    FloatingFilterWrapper.prototype.showParentFilter = function () {
	        var eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
	        this.menuFactory.showMenuAfterButtonClick(this.column, eventSource, 'filterMenuTab', ['filterMenuTab']);
	    };
	    FloatingFilterWrapper.prototype.setupColumnHover = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
	        this.onColumnHover();
	    };
	    FloatingFilterWrapper.prototype.onColumnHover = function () {
	        addOrRemoveCssClass(this.getGui(), 'ag-column-hover', this.columnHoverService.isHovered(this.column));
	    };
	    FloatingFilterWrapper.prototype.setupWidth = function () {
	        this.addManagedListener(this.column, Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
	        this.onColumnWidthChanged();
	    };
	    FloatingFilterWrapper.prototype.onColumnWidthChanged = function () {
	        this.getGui().style.width = this.column.getActualWidth() + "px";
	    };
	    FloatingFilterWrapper.prototype.setupWithFloatingFilter = function (floatingFilterComp) {
	        var _this = this;
	        var disposeFunc = function () {
	            _this.getContext().destroyBean(floatingFilterComp);
	        };
	        if (!this.isAlive()) {
	            disposeFunc();
	            return;
	        }
	        this.addDestroyFunc(disposeFunc);
	        var floatingFilterCompUi = floatingFilterComp.getGui();
	        addOrRemoveCssClass(this.eFloatingFilterBody, 'ag-floating-filter-full-body', this.suppressFilterButton);
	        addOrRemoveCssClass(this.eFloatingFilterBody, 'ag-floating-filter-body', !this.suppressFilterButton);
	        setDisplayed(this.eButtonWrapper, !this.suppressFilterButton);
	        var eIcon = createIconNoSpan('filter', this.gridOptionsWrapper, this.column);
	        this.eButtonShowMainFilter.appendChild(eIcon);
	        this.eFloatingFilterBody.appendChild(floatingFilterCompUi);
	        if (floatingFilterComp.afterGuiAttached) {
	            floatingFilterComp.afterGuiAttached();
	        }
	    };
	    FloatingFilterWrapper.prototype.parentFilterInstance = function (callback) {
	        var filterComponent = this.getFilterComponent();
	        if (filterComponent) {
	            filterComponent.then(callback);
	        }
	    };
	    FloatingFilterWrapper.prototype.getFilterComponent = function (createIfDoesNotExist) {
	        if (createIfDoesNotExist === void 0) { createIfDoesNotExist = true; }
	        return this.filterManager.getFilterComponent(this.column, 'NO_UI', createIfDoesNotExist);
	    };
	    FloatingFilterWrapper.getDefaultFloatingFilterType = function (def) {
	        if (def == null) {
	            return null;
	        }
	        var defaultFloatingFilterType = null;
	        if (typeof def.filter === 'string') {
	            // will be undefined if not in the map
	            defaultFloatingFilterType = FloatingFilterMapper.getFloatingFilterType(def.filter);
	        }
	        else if (def.filterFramework) ;
	        else if (def.filter === true) {
	            var setFilterModuleLoaded = ModuleRegistry.isRegistered(exports.ModuleNames.SetFilterModule);
	            defaultFloatingFilterType = setFilterModuleLoaded ? 'agSetColumnFloatingFilter' : 'agTextColumnFloatingFilter';
	        }
	        return defaultFloatingFilterType;
	    };
	    FloatingFilterWrapper.prototype.getFloatingFilterInstance = function () {
	        var colDef = this.column.getColDef();
	        var defaultFloatingFilterType = FloatingFilterWrapper.getDefaultFloatingFilterType(colDef);
	        var filterParams = this.filterManager.createFilterParams(this.column, colDef);
	        var finalFilterParams = this.userComponentFactory.createFinalParams(colDef, 'filter', filterParams);
	        var params = {
	            api: this.gridApi,
	            column: this.column,
	            filterParams: finalFilterParams,
	            currentParentModel: this.currentParentModel.bind(this),
	            parentFilterInstance: this.parentFilterInstance.bind(this),
	            showParentFilter: this.showParentFilter.bind(this),
	            onFloatingFilterChanged: this.onFloatingFilterChanged.bind(this),
	            suppressFilterButton: false // This one might be overridden from the colDef
	        };
	        // this is unusual - we need a params value OUTSIDE the component the params are for.
	        // the params are for the floating filter component, but this property is actually for the wrapper.
	        this.suppressFilterButton = colDef.floatingFilterComponentParams ? !!colDef.floatingFilterComponentParams.suppressFilterButton : false;
	        var promise = this.userComponentFactory.newFloatingFilterComponent(colDef, params, defaultFloatingFilterType);
	        if (!promise) {
	            var compInstance = this.userComponentFactory.createUserComponentFromConcreteClass(ReadOnlyFloatingFilter, params);
	            promise = AgPromise.resolve(compInstance);
	        }
	        return promise;
	    };
	    FloatingFilterWrapper.prototype.currentParentModel = function () {
	        var filterComponent = this.getFilterComponent(false);
	        return filterComponent ? filterComponent.resolveNow(null, function (filter) { return filter && filter.getModel(); }) : null;
	    };
	    FloatingFilterWrapper.prototype.onParentModelChanged = function (model, filterChangedEvent) {
	        if (!this.floatingFilterCompPromise) {
	            return;
	        }
	        this.floatingFilterCompPromise.then(function (comp) { return comp && comp.onParentModelChanged(model, filterChangedEvent); });
	    };
	    FloatingFilterWrapper.prototype.onFloatingFilterChanged = function () {
	        console.warn('AG Grid: since version 21.x, how floating filters are implemented has changed. ' +
	            'Instead of calling params.onFloatingFilterChanged(), get a reference to the main filter via ' +
	            'params.parentFilterInstance() and then set a value on the parent filter directly.');
	    };
	    FloatingFilterWrapper.TEMPLATE = "<div class=\"ag-header-cell\" role=\"gridcell\" tabindex=\"-1\">\n            <div class=\"ag-floating-filter-full-body\" ref=\"eFloatingFilterBody\" role=\"presentation\"></div>\n            <div class=\"ag-floating-filter-button ag-hidden\" ref=\"eButtonWrapper\" role=\"presentation\">\n                <button type=\"button\" aria-label=\"Open Filter Menu\" class=\"ag-floating-filter-button-button\" ref=\"eButtonShowMainFilter\" tabindex=\"-1\"></button>\n            </div>\n        </div>";
	    __decorate$M([
	        Autowired('columnHoverService')
	    ], FloatingFilterWrapper.prototype, "columnHoverService", void 0);
	    __decorate$M([
	        Autowired('userComponentFactory')
	    ], FloatingFilterWrapper.prototype, "userComponentFactory", void 0);
	    __decorate$M([
	        Autowired('gridApi')
	    ], FloatingFilterWrapper.prototype, "gridApi", void 0);
	    __decorate$M([
	        Autowired('columnApi')
	    ], FloatingFilterWrapper.prototype, "columnApi", void 0);
	    __decorate$M([
	        Autowired('filterManager')
	    ], FloatingFilterWrapper.prototype, "filterManager", void 0);
	    __decorate$M([
	        Autowired('menuFactory')
	    ], FloatingFilterWrapper.prototype, "menuFactory", void 0);
	    __decorate$M([
	        Autowired('beans')
	    ], FloatingFilterWrapper.prototype, "beans", void 0);
	    __decorate$M([
	        RefSelector('eFloatingFilterBody')
	    ], FloatingFilterWrapper.prototype, "eFloatingFilterBody", void 0);
	    __decorate$M([
	        RefSelector('eButtonWrapper')
	    ], FloatingFilterWrapper.prototype, "eButtonWrapper", void 0);
	    __decorate$M([
	        RefSelector('eButtonShowMainFilter')
	    ], FloatingFilterWrapper.prototype, "eButtonShowMainFilter", void 0);
	    return FloatingFilterWrapper;
	}(AbstractHeaderWrapper));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$W = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$N = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderRowType;
	(function (HeaderRowType) {
	    HeaderRowType[HeaderRowType["COLUMN_GROUP"] = 0] = "COLUMN_GROUP";
	    HeaderRowType[HeaderRowType["COLUMN"] = 1] = "COLUMN";
	    HeaderRowType[HeaderRowType["FLOATING_FILTER"] = 2] = "FLOATING_FILTER";
	})(HeaderRowType || (HeaderRowType = {}));
	var HeaderRowComp = /** @class */ (function (_super) {
	    __extends$W(HeaderRowComp, _super);
	    function HeaderRowComp(dept, type, pinned) {
	        var _this = _super.call(this, /* html */ "<div class=\"ag-header-row\" role=\"row\"></div>") || this;
	        _this.headerComps = {};
	        _this.setRowIndex(dept);
	        _this.type = type;
	        _this.pinned = pinned;
	        var niceClassName = HeaderRowType[type].toLowerCase().replace(/_/g, '-');
	        _this.addCssClass("ag-header-row-" + niceClassName);
	        if (isBrowserSafari()) {
	            // fix for a Safari rendering bug that caused the header to flicker above chart panels
	            // as you move the mouse over the header
	            _this.getGui().style.transform = 'translateZ(0)';
	        }
	        return _this;
	    }
	    HeaderRowComp.prototype.forEachHeaderElement = function (callback) {
	        var _this = this;
	        Object.keys(this.headerComps).forEach(function (key) {
	            callback(_this.headerComps[key]);
	        });
	    };
	    HeaderRowComp.prototype.setRowIndex = function (rowIndex) {
	        this.dept = rowIndex;
	        setAriaRowIndex(this.getGui(), rowIndex + 1);
	    };
	    HeaderRowComp.prototype.getRowIndex = function () {
	        return this.dept;
	    };
	    HeaderRowComp.prototype.getType = function () {
	        return this.type;
	    };
	    HeaderRowComp.prototype.destroyAllChildComponents = function () {
	        var idsOfAllChildren = Object.keys(this.headerComps);
	        this.destroyChildComponents(idsOfAllChildren);
	    };
	    HeaderRowComp.prototype.destroyChildComponents = function (idsToDestroy) {
	        var _this = this;
	        idsToDestroy.forEach(function (id) {
	            var childHeaderWrapper = _this.headerComps[id];
	            _this.getGui().removeChild(childHeaderWrapper.getGui());
	            _this.destroyBean(childHeaderWrapper);
	            delete _this.headerComps[id];
	        });
	    };
	    HeaderRowComp.prototype.onRowHeightChanged = function () {
	        var headerRowCount = this.columnController.getHeaderRowCount();
	        var sizes = [];
	        var numberOfFloating = 0;
	        var groupHeight;
	        var headerHeight;
	        if (this.columnController.isPivotMode()) {
	            groupHeight = this.gridOptionsWrapper.getPivotGroupHeaderHeight();
	            headerHeight = this.gridOptionsWrapper.getPivotHeaderHeight();
	        }
	        else {
	            if (this.columnController.hasFloatingFilters()) {
	                headerRowCount++;
	                numberOfFloating = 1;
	            }
	            groupHeight = this.gridOptionsWrapper.getGroupHeaderHeight();
	            headerHeight = this.gridOptionsWrapper.getHeaderHeight();
	        }
	        var numberOfNonGroups = 1 + numberOfFloating;
	        var numberOfGroups = headerRowCount - numberOfNonGroups;
	        for (var i = 0; i < numberOfGroups; i++) {
	            sizes.push(groupHeight);
	        }
	        sizes.push(headerHeight);
	        for (var i = 0; i < numberOfFloating; i++) {
	            sizes.push(this.gridOptionsWrapper.getFloatingFiltersHeight());
	        }
	        var rowHeight = 0;
	        for (var i = 0; i < this.dept; i++) {
	            rowHeight += sizes[i];
	        }
	        this.getGui().style.top = rowHeight + 'px';
	        this.getGui().style.height = sizes[this.dept] + 'px';
	    };
	    //noinspection JSUnusedLocalSymbols
	    HeaderRowComp.prototype.init = function () {
	        this.onRowHeightChanged();
	        this.onVirtualColumnsChanged();
	        this.setWidth();
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        // this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	    };
	    HeaderRowComp.prototype.onColumnResized = function () {
	        this.setWidth();
	    };
	    HeaderRowComp.prototype.setWidth = function () {
	        var width = this.getWidthForRow();
	        this.getGui().style.width = width + 'px';
	    };
	    HeaderRowComp.prototype.getWidthForRow = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        if (printLayout) {
	            var centerRow = missing(this.pinned);
	            if (centerRow) {
	                return this.columnController.getContainerWidth(Constants.PINNED_RIGHT)
	                    + this.columnController.getContainerWidth(Constants.PINNED_LEFT)
	                    + this.columnController.getContainerWidth(null);
	            }
	            return 0;
	        }
	        // if not printing, just return the width as normal
	        return this.columnController.getContainerWidth(this.pinned);
	    };
	    HeaderRowComp.prototype.onDisplayedColumnsChanged = function () {
	        this.onVirtualColumnsChanged();
	        this.setWidth();
	    };
	    HeaderRowComp.prototype.getColumnsInViewport = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        return printLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
	    };
	    HeaderRowComp.prototype.getColumnsInViewportPrintLayout = function () {
	        var _this = this;
	        // for print layout, we add all columns into the center
	        if (this.pinned != null) {
	            return [];
	        }
	        var viewportColumns = [];
	        var actualDepth = this.getActualDepth();
	        [Constants.PINNED_LEFT, null, Constants.PINNED_RIGHT].forEach(function (pinned) {
	            var items = _this.columnController.getVirtualHeaderGroupRow(pinned, actualDepth);
	            viewportColumns = viewportColumns.concat(items);
	        });
	        return viewportColumns;
	    };
	    HeaderRowComp.prototype.getActualDepth = function () {
	        return this.type == HeaderRowType.FLOATING_FILTER ? this.dept - 1 : this.dept;
	    };
	    HeaderRowComp.prototype.getColumnsInViewportNormalLayout = function () {
	        // when in normal layout, we add the columns for that container only
	        return this.columnController.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
	    };
	    HeaderRowComp.prototype.onVirtualColumnsChanged = function () {
	        var _this = this;
	        var compIdsToRemove = Object.keys(this.headerComps);
	        var compIdsWanted = [];
	        var columns = this.getColumnsInViewport();
	        columns.forEach(function (child) {
	            // skip groups that have no displayed children. this can happen when the group is broken,
	            // and this section happens to have nothing to display for the open / closed state.
	            // (a broken group is one that is split, ie columns in the group have a non-group column
	            // in between them)
	            if (child.isEmptyGroup()) {
	                return;
	            }
	            var idOfChild = child.getUniqueId();
	            var eParentContainer = _this.getGui();
	            // if we already have this cell rendered, do nothing
	            var previousComp = _this.headerComps[idOfChild];
	            // it's possible there is a new Column with the same ID, but it's for a different Column.
	            // this is common with pivoting, where the pivot cols change, but the id's are still pivot_0,
	            // pivot_1 etc. so if new col but same ID, need to remove the old col here first as we are
	            // about to replace it in the this.headerComps map.
	            var previousCompForOldColumn = previousComp && previousComp.getColumn() != child;
	            if (previousCompForOldColumn) {
	                _this.destroyChildComponents([idOfChild]);
	                removeFromArray(compIdsToRemove, idOfChild);
	                previousComp = undefined;
	            }
	            if (previousComp) {
	                // already have comp for this column, so do nothing
	                removeFromArray(compIdsToRemove, idOfChild);
	            }
	            else {
	                // don't have comp, need to create one
	                var headerComp = _this.createHeaderComp(child);
	                _this.headerComps[idOfChild] = headerComp;
	                eParentContainer.appendChild(headerComp.getGui());
	            }
	            compIdsWanted.push(idOfChild);
	        });
	        // we want to keep columns that are focused, otherwise keyboard navigation breaks
	        var isFocusedAndDisplayed = function (colId) {
	            var wrapper = _this.headerComps[colId];
	            var isFocused = _this.focusController.isHeaderWrapperFocused(wrapper);
	            if (!isFocused) {
	                return false;
	            }
	            var isDisplayed = _this.columnController.isDisplayed(wrapper.getColumn());
	            return isDisplayed;
	        };
	        var focusedAndDisplayedComps = compIdsToRemove.filter(isFocusedAndDisplayed);
	        focusedAndDisplayedComps.forEach(function (colId) {
	            removeFromArray(compIdsToRemove, colId);
	            compIdsWanted.push(colId);
	        });
	        // at this point, anything left in currentChildIds is an element that is no longer in the viewport
	        this.destroyChildComponents(compIdsToRemove);
	        var ensureDomOrder = this.gridOptionsWrapper.isEnsureDomOrder();
	        if (ensureDomOrder) {
	            var correctChildOrder = compIdsWanted.map(function (id) { return _this.headerComps[id].getGui(); });
	            setDomChildOrder(this.getGui(), correctChildOrder);
	        }
	    };
	    HeaderRowComp.prototype.createHeaderComp = function (columnGroupChild) {
	        var result;
	        switch (this.type) {
	            case HeaderRowType.COLUMN_GROUP:
	                result = new HeaderGroupWrapperComp(columnGroupChild, this.pinned);
	                break;
	            case HeaderRowType.FLOATING_FILTER:
	                result = new FloatingFilterWrapper(columnGroupChild, this.pinned);
	                break;
	            default:
	                result = new HeaderWrapperComp(columnGroupChild, this.pinned);
	                break;
	        }
	        this.createBean(result);
	        result.setParentComponent(this);
	        return result;
	    };
	    HeaderRowComp.prototype.getHeaderComps = function () {
	        return this.headerComps;
	    };
	    __decorate$N([
	        Autowired('columnController')
	    ], HeaderRowComp.prototype, "columnController", void 0);
	    __decorate$N([
	        Autowired('focusController')
	    ], HeaderRowComp.prototype, "focusController", void 0);
	    __decorate$N([
	        PreDestroy
	    ], HeaderRowComp.prototype, "destroyAllChildComponents", null);
	    __decorate$N([
	        PostConstruct
	    ], HeaderRowComp.prototype, "init", null);
	    return HeaderRowComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$O = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var MoveColumnController = /** @class */ (function () {
	    function MoveColumnController(pinned, eContainer) {
	        this.needToMoveLeft = false;
	        this.needToMoveRight = false;
	        this.pinned = pinned;
	        this.eContainer = eContainer;
	        this.centerContainer = !exists(pinned);
	    }
	    MoveColumnController.prototype.init = function () {
	        var _this = this;
	        this.logger = this.loggerFactory.create('MoveColumnController');
	        this.controllersService.whenReady(function () {
	            _this.gridBodyCon = _this.controllersService.getGridBodyController();
	        });
	    };
	    MoveColumnController.prototype.getIconName = function () {
	        return this.pinned ? DragAndDropService.ICON_PINNED : DragAndDropService.ICON_MOVE;
	    };
	    MoveColumnController.prototype.onDragEnter = function (draggingEvent) {
	        // we do dummy drag, so make sure column appears in the right location when first placed
	        var columns = draggingEvent.dragItem.columns;
	        var dragCameFromToolPanel = draggingEvent.dragSource.type === exports.DragSourceType.ToolPanel;
	        if (dragCameFromToolPanel) {
	            // the if statement doesn't work if drag leaves grid, then enters again
	            this.setColumnsVisible(columns, true, "uiColumnDragged");
	        }
	        else {
	            // restore previous state of visible columns upon re-entering. this means if the user drags
	            // a group out, and then drags the group back in, only columns that were originally visible
	            // will be visible again. otherwise a group with three columns (but only two visible) could
	            // be dragged out, then when it's dragged in again, all three are visible. this stops that.
	            var visibleState_1 = draggingEvent.dragItem.visibleState;
	            var visibleColumns = (columns || []).filter(function (column) { return visibleState_1[column.getId()]; });
	            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
	        }
	        this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
	        this.onDragging(draggingEvent, true);
	    };
	    MoveColumnController.prototype.onDragLeave = function (draggingEvent) {
	        var hideColumnOnExit = !this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns() && !draggingEvent.fromNudge;
	        if (hideColumnOnExit) {
	            var dragItem = draggingEvent.dragSource.getDragItem();
	            var columns = dragItem.columns;
	            this.setColumnsVisible(columns, false, "uiColumnDragged");
	        }
	        this.ensureIntervalCleared();
	    };
	    MoveColumnController.prototype.setColumnsVisible = function (columns, visible, source) {
	        if (source === void 0) { source = "api"; }
	        if (columns) {
	            var allowedCols = columns.filter(function (c) { return !c.getColDef().lockVisible; });
	            this.columnController.setColumnsVisible(allowedCols, visible, source);
	        }
	    };
	    MoveColumnController.prototype.setColumnsPinned = function (columns, pinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (columns) {
	            var allowedCols = columns.filter(function (c) { return !c.getColDef().lockPinned; });
	            this.columnController.setColumnsPinned(allowedCols, pinned, source);
	        }
	    };
	    MoveColumnController.prototype.onDragStop = function () {
	        this.ensureIntervalCleared();
	    };
	    MoveColumnController.prototype.normaliseX = function (x) {
	        // flip the coordinate if doing RTL
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            var clientWidth = this.eContainer.clientWidth;
	            x = clientWidth - x;
	        }
	        // adjust for scroll only if centre container (the pinned containers don't scroll)
	        if (this.centerContainer) {
	            x += this.controllersService.getCenterRowContainerCon().getCenterViewportScrollLeft();
	        }
	        return x;
	    };
	    MoveColumnController.prototype.checkCenterForScrolling = function (xAdjustedForScroll) {
	        if (this.centerContainer) {
	            // scroll if the mouse has gone outside the grid (or just outside the scrollable part if pinning)
	            // putting in 50 buffer, so even if user gets to edge of grid, a scroll will happen
	            var firstVisiblePixel = this.controllersService.getCenterRowContainerCon().getCenterViewportScrollLeft();
	            var lastVisiblePixel = firstVisiblePixel + this.controllersService.getCenterRowContainerCon().getCenterWidth();
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                this.needToMoveRight = xAdjustedForScroll < (firstVisiblePixel + 50);
	                this.needToMoveLeft = xAdjustedForScroll > (lastVisiblePixel - 50);
	            }
	            else {
	                this.needToMoveLeft = xAdjustedForScroll < (firstVisiblePixel + 50);
	                this.needToMoveRight = xAdjustedForScroll > (lastVisiblePixel - 50);
	            }
	            if (this.needToMoveLeft || this.needToMoveRight) {
	                this.ensureIntervalStarted();
	            }
	            else {
	                this.ensureIntervalCleared();
	            }
	        }
	    };
	    MoveColumnController.prototype.onDragging = function (draggingEvent, fromEnter) {
	        var _this = this;
	        if (fromEnter === void 0) { fromEnter = false; }
	        this.lastDraggingEvent = draggingEvent;
	        // if moving up or down (ie not left or right) then do nothing
	        if (missing(draggingEvent.hDirection)) {
	            return;
	        }
	        var mouseXNormalised = this.normaliseX(draggingEvent.x);
	        // if the user is dragging into the panel, ie coming from the side panel into the main grid,
	        // we don't want to scroll the grid this time, it would appear like the table is jumping
	        // each time a column is dragged in.
	        if (!fromEnter) {
	            this.checkCenterForScrolling(mouseXNormalised);
	        }
	        var hDirectionNormalised = this.normaliseDirection(draggingEvent.hDirection);
	        var dragSourceType = draggingEvent.dragSource.type;
	        var columnsToMove = draggingEvent.dragSource.getDragItem().columns;
	        columnsToMove = columnsToMove.filter(function (col) {
	            if (col.getColDef().lockPinned) {
	                // if locked return true only if both col and container are same pin type.
	                // double equals (==) here on purpose so that null==undefined is true (for not pinned options)
	                return col.getPinned() == _this.pinned;
	            }
	            // if not pin locked, then always allowed to be in this container
	            return true;
	        });
	        this.attemptMoveColumns(dragSourceType, columnsToMove, hDirectionNormalised, mouseXNormalised, fromEnter);
	    };
	    MoveColumnController.prototype.normaliseDirection = function (hDirection) {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            switch (hDirection) {
	                case exports.HorizontalDirection.Left: return exports.HorizontalDirection.Right;
	                case exports.HorizontalDirection.Right: return exports.HorizontalDirection.Left;
	                default: console.error("AG Grid: Unknown direction " + hDirection);
	            }
	        }
	        else {
	            return hDirection;
	        }
	    };
	    // returns the index of the first column in the list ONLY if the cols are all beside
	    // each other. if the cols are not beside each other, then returns null
	    MoveColumnController.prototype.calculateOldIndex = function (movingCols) {
	        var gridCols = this.columnController.getAllGridColumns();
	        var indexes = sortNumerically(movingCols.map(function (col) { return gridCols.indexOf(col); }));
	        var firstIndex = indexes[0];
	        var lastIndex = last(indexes);
	        var spread = lastIndex - firstIndex;
	        var gapsExist = spread !== indexes.length - 1;
	        return gapsExist ? null : firstIndex;
	    };
	    MoveColumnController.prototype.attemptMoveColumns = function (dragSourceType, allMovingColumns, hDirection, mouseX, fromEnter) {
	        var draggingLeft = hDirection === exports.HorizontalDirection.Left;
	        var draggingRight = hDirection === exports.HorizontalDirection.Right;
	        // it is important to sort the moving columns as they are in grid columns, as the list of moving columns
	        // could themselves be part of 'married children' groups, which means we need to maintain the order within
	        // the moving list.
	        var allMovingColumnsOrdered = allMovingColumns.slice();
	        this.columnController.sortColumnsLikeGridColumns(allMovingColumnsOrdered);
	        var validMoves = this.calculateValidMoves(allMovingColumnsOrdered, draggingRight, mouseX);
	        // if cols are not adjacent, then this returns null. when moving, we constrain the direction of the move
	        // (ie left or right) to the mouse direction. however
	        var oldIndex = this.calculateOldIndex(allMovingColumnsOrdered);
	        if (validMoves.length === 0) {
	            return;
	        }
	        var firstValidMove = validMoves[0];
	        // the two check below stop an error when the user grabs a group my a middle column, then
	        // it is possible the mouse pointer is to the right of a column while been dragged left.
	        // so we need to make sure that the mouse pointer is actually left of the left most column
	        // if moving left, and right of the right most column if moving right
	        // we check 'fromEnter' below so we move the column to the new spot if the mouse is coming from
	        // outside the grid, eg if the column is moving from side panel, mouse is moving left, then we should
	        // place the column to the RHS even if the mouse is moving left and the column is already on
	        // the LHS. otherwise we stick to the rule described above.
	        var constrainDirection = oldIndex !== null && !fromEnter;
	        // don't consider 'fromEnter' when dragging header cells, otherwise group can jump to opposite direction of drag
	        if (dragSourceType == exports.DragSourceType.HeaderCell) {
	            constrainDirection = oldIndex !== null;
	        }
	        if (constrainDirection) {
	            // only allow left drag if this column is moving left
	            if (draggingLeft && firstValidMove >= oldIndex) {
	                return;
	            }
	            // only allow right drag if this column is moving right
	            if (draggingRight && firstValidMove <= oldIndex) {
	                return;
	            }
	        }
	        for (var i = 0; i < validMoves.length; i++) {
	            var move = validMoves[i];
	            if (!this.columnController.doesMovePassRules(allMovingColumnsOrdered, move)) {
	                continue;
	            }
	            this.columnController.moveColumns(allMovingColumnsOrdered, move, "uiColumnDragged");
	            // important to return here, so once we do the first valid move, we don't try do any more
	            return;
	        }
	    };
	    MoveColumnController.prototype.calculateValidMoves = function (movingCols, draggingRight, mouseX) {
	        var isMoveBlocked = this.gridOptionsWrapper.isSuppressMovableColumns() || movingCols.some(function (col) { return col.getColDef().suppressMovable; });
	        if (isMoveBlocked) {
	            return [];
	        }
	        // this is the list of cols on the screen, so it's these we use when comparing the x mouse position
	        var allDisplayedCols = this.columnController.getDisplayedColumns(this.pinned);
	        // but this list is the list of all cols, when we move a col it's the index within this list that gets used,
	        // so the result we return has to be and index location for this list
	        var allGridCols = this.columnController.getAllGridColumns();
	        var movingDisplayedCols = allDisplayedCols.filter(function (col) { return includes(movingCols, col); });
	        var otherDisplayedCols = allDisplayedCols.filter(function (col) { return !includes(movingCols, col); });
	        var otherGridCols = allGridCols.filter(function (col) { return !includes(movingCols, col); });
	        // work out how many DISPLAYED columns fit before the 'x' position. this gives us the displayIndex.
	        // for example, if cols are a,b,c,d and we find a,b fit before 'x', then we want to place the moving
	        // col between b and c (so that it is under the mouse position).
	        var displayIndex = 0;
	        var availableWidth = mouseX;
	        // if we are dragging right, then the columns will be to the left of the mouse, so we also want to
	        // include the width of the moving columns
	        if (draggingRight) {
	            var widthOfMovingDisplayedCols_1 = 0;
	            movingDisplayedCols.forEach(function (col) { return widthOfMovingDisplayedCols_1 += col.getActualWidth(); });
	            availableWidth -= widthOfMovingDisplayedCols_1;
	        }
	        if (availableWidth > 0) {
	            // now count how many of the displayed columns will fit to the left
	            for (var i = 0; i < otherDisplayedCols.length; i++) {
	                var col = otherDisplayedCols[i];
	                availableWidth -= col.getActualWidth();
	                if (availableWidth < 0) {
	                    break;
	                }
	                displayIndex++;
	            }
	            // trial and error, if going right, we adjust by one, i didn't manage to quantify why, but it works
	            if (draggingRight) {
	                displayIndex++;
	            }
	        }
	        // the display index is with respect to all the showing columns, however when we move, it's with
	        // respect to all grid columns, so we need to translate from display index to grid index
	        var firstValidMove;
	        if (displayIndex > 0) {
	            var leftColumn = otherDisplayedCols[displayIndex - 1];
	            firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
	        }
	        else {
	            firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
	            if (firstValidMove === -1) {
	                firstValidMove = 0;
	            }
	        }
	        var validMoves = [firstValidMove];
	        var numberComparator = function (a, b) { return a - b; };
	        // add in other valid moves due to hidden columns and married children. for example, a particular
	        // move might break a group that has married children (so move isn't valid), however there could
	        // be hidden columns (not displayed) that we could jump over to make the move valid. because
	        // they are hidden, user doesn't see any different, however it allows moves that would otherwise
	        // not work. for example imagine a group with 9 columns and all columns are hidden except the
	        // middle one (so 4 hidden to left, 4 hidden to right), then when moving 'firstValidMove' will
	        // be relative to the not-shown column, however we need to consider the move jumping over all the
	        // hidden children. if we didn't do this, then if the group just described was at the end (RHS) of the
	        // grid, there would be no way to put a column after it (as the grid would only consider beside the
	        // visible column, which would fail valid move rules).
	        if (draggingRight) {
	            // if dragging right, then we add all the additional moves to the right. so in other words
	            // if the next move is not valid, find the next move to the right that is valid.
	            var pointer = firstValidMove + 1;
	            var lastIndex = allGridCols.length - 1;
	            while (pointer <= lastIndex) {
	                validMoves.push(pointer);
	                pointer++;
	            }
	            // adding columns here means the order is now messed up
	            validMoves.sort(numberComparator);
	        }
	        else {
	            // if dragging left we do the reverse of dragging right, we add in all the valid moves to the
	            // left. however we also have to consider moves to the right for all hidden columns first.
	            // (this logic is hard to reason with, it was worked out with trial and error,
	            // more observation rather than science).
	            // add moves to the right
	            var pointer = firstValidMove;
	            var lastIndex = allGridCols.length - 1;
	            var displacedCol = allGridCols[pointer];
	            while (pointer <= lastIndex && this.isColumnHidden(allDisplayedCols, displacedCol)) {
	                pointer++;
	                validMoves.push(pointer);
	                displacedCol = allGridCols[pointer];
	            }
	            // add moves to the left
	            pointer = firstValidMove - 1;
	            var firstDisplayIndex = 0;
	            while (pointer >= firstDisplayIndex) {
	                validMoves.push(pointer);
	                pointer--;
	            }
	            // adding columns here means the order is now messed up
	            validMoves.sort(numberComparator).reverse();
	        }
	        return validMoves;
	    };
	    // isHidden takes into account visible=false and group=closed, ie it is not displayed
	    MoveColumnController.prototype.isColumnHidden = function (displayedColumns, col) {
	        return displayedColumns.indexOf(col) < 0;
	    };
	    MoveColumnController.prototype.ensureIntervalStarted = function () {
	        if (!this.movingIntervalId) {
	            this.intervalCount = 0;
	            this.failedMoveAttempts = 0;
	            this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
	            if (this.needToMoveLeft) {
	                this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_LEFT, true);
	            }
	            else {
	                this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_RIGHT, true);
	            }
	        }
	    };
	    MoveColumnController.prototype.ensureIntervalCleared = function () {
	        if (this.movingIntervalId) {
	            window.clearInterval(this.movingIntervalId);
	            this.movingIntervalId = null;
	            this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_MOVE);
	        }
	    };
	    MoveColumnController.prototype.moveInterval = function () {
	        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
	        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
	        var pixelsToMove;
	        this.intervalCount++;
	        pixelsToMove = 10 + (this.intervalCount * 5);
	        if (pixelsToMove > 100) {
	            pixelsToMove = 100;
	        }
	        var pixelsMoved = null;
	        var scrollFeature = this.gridBodyCon.getScrollFeature();
	        if (this.needToMoveLeft) {
	            pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
	        }
	        else if (this.needToMoveRight) {
	            pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
	        }
	        if (pixelsMoved !== 0) {
	            this.onDragging(this.lastDraggingEvent);
	            this.failedMoveAttempts = 0;
	        }
	        else {
	            // we count the failed move attempts. if we fail to move 7 times, then we pin the column.
	            // this is how we achieve pining by dragging the column to the edge of the grid.
	            this.failedMoveAttempts++;
	            var columns = this.lastDraggingEvent.dragItem.columns;
	            var columnsThatCanPin = columns.filter(function (c) { return !c.getColDef().lockPinned; });
	            if (columnsThatCanPin.length > 0) {
	                this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_PINNED);
	                if (this.failedMoveAttempts > 7) {
	                    var pinType = this.needToMoveLeft ? Constants.PINNED_LEFT : Constants.PINNED_RIGHT;
	                    this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
	                    this.dragAndDropService.nudge();
	                }
	            }
	        }
	    };
	    __decorate$O([
	        Autowired('loggerFactory')
	    ], MoveColumnController.prototype, "loggerFactory", void 0);
	    __decorate$O([
	        Autowired('columnController')
	    ], MoveColumnController.prototype, "columnController", void 0);
	    __decorate$O([
	        Autowired('dragAndDropService')
	    ], MoveColumnController.prototype, "dragAndDropService", void 0);
	    __decorate$O([
	        Autowired('gridOptionsWrapper')
	    ], MoveColumnController.prototype, "gridOptionsWrapper", void 0);
	    __decorate$O([
	        Autowired('controllersService')
	    ], MoveColumnController.prototype, "controllersService", void 0);
	    __decorate$O([
	        PostConstruct
	    ], MoveColumnController.prototype, "init", null);
	    return MoveColumnController;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$P = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var BodyDropPivotTarget = /** @class */ (function () {
	    function BodyDropPivotTarget(pinned) {
	        this.columnsToAggregate = [];
	        this.columnsToGroup = [];
	        this.columnsToPivot = [];
	        this.pinned = pinned;
	    }
	    /** Callback for when drag enters */
	    BodyDropPivotTarget.prototype.onDragEnter = function (draggingEvent) {
	        var _this = this;
	        this.clearColumnsList();
	        // in pivot mode, we don't accept any drops if functions are read only
	        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            return;
	        }
	        var dragColumns = draggingEvent.dragItem.columns;
	        if (!dragColumns) {
	            return;
	        }
	        dragColumns.forEach(function (column) {
	            // we don't allow adding secondary columns
	            if (!column.isPrimary()) {
	                return;
	            }
	            if (column.isAnyFunctionActive()) {
	                return;
	            }
	            if (column.isAllowValue()) {
	                _this.columnsToAggregate.push(column);
	            }
	            else if (column.isAllowRowGroup()) {
	                _this.columnsToGroup.push(column);
	            }
	            else if (column.isAllowPivot()) {
	                _this.columnsToPivot.push(column);
	            }
	        });
	    };
	    BodyDropPivotTarget.prototype.getIconName = function () {
	        var totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
	        if (totalColumns > 0) {
	            return this.pinned ? DragAndDropService.ICON_PINNED : DragAndDropService.ICON_MOVE;
	        }
	        return null;
	    };
	    /** Callback for when drag leaves */
	    BodyDropPivotTarget.prototype.onDragLeave = function (draggingEvent) {
	        // if we are taking columns out of the center, then we remove them from the report
	        this.clearColumnsList();
	    };
	    BodyDropPivotTarget.prototype.clearColumnsList = function () {
	        this.columnsToAggregate.length = 0;
	        this.columnsToGroup.length = 0;
	        this.columnsToPivot.length = 0;
	    };
	    /** Callback for when dragging */
	    BodyDropPivotTarget.prototype.onDragging = function (draggingEvent) {
	    };
	    /** Callback for when drag stops */
	    BodyDropPivotTarget.prototype.onDragStop = function (draggingEvent) {
	        if (this.columnsToAggregate.length > 0) {
	            this.columnController.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
	        }
	        if (this.columnsToGroup.length > 0) {
	            this.columnController.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
	        }
	        if (this.columnsToPivot.length > 0) {
	            this.columnController.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
	        }
	    };
	    __decorate$P([
	        Autowired('columnController')
	    ], BodyDropPivotTarget.prototype, "columnController", void 0);
	    __decorate$P([
	        Autowired('gridOptionsWrapper')
	    ], BodyDropPivotTarget.prototype, "gridOptionsWrapper", void 0);
	    return BodyDropPivotTarget;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$X = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$Q = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var DropType;
	(function (DropType) {
	    DropType[DropType["ColumnMove"] = 0] = "ColumnMove";
	    DropType[DropType["Pivot"] = 1] = "Pivot";
	})(DropType || (DropType = {}));
	var BodyDropTarget = /** @class */ (function (_super) {
	    __extends$X(BodyDropTarget, _super);
	    function BodyDropTarget(pinned, eContainer) {
	        var _this = _super.call(this) || this;
	        _this.dropListeners = {};
	        _this.pinned = pinned;
	        _this.eContainer = eContainer;
	        return _this;
	    }
	    BodyDropTarget.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function (p) {
	            var containers;
	            switch (_this.pinned) {
	                case Constants.PINNED_LEFT:
	                    containers = [p.leftRowContainerCon, p.bottomLeftRowContainerCon, p.topLeftRowContainerCon];
	                    break;
	                case Constants.PINNED_RIGHT:
	                    containers = [p.rightRowContainerCon, p.bottomRightRowContainerCon, p.topRightRowContainerCon];
	                    break;
	                default:
	                    containers = [p.centerRowContainerCon, p.bottomCenterRowContainerCon, p.topCenterRowContainerCon];
	                    break;
	            }
	            _this.eSecondaryContainers = containers.map(function (c) { return c.getContainerElement(); });
	        });
	    };
	    BodyDropTarget.prototype.isInterestedIn = function (type) {
	        return type === exports.DragSourceType.HeaderCell ||
	            (type === exports.DragSourceType.ToolPanel && this.gridOptionsWrapper.isAllowDragFromColumnsToolPanel());
	    };
	    BodyDropTarget.prototype.getSecondaryContainers = function () {
	        return this.eSecondaryContainers;
	    };
	    BodyDropTarget.prototype.getContainer = function () {
	        return this.eContainer;
	    };
	    BodyDropTarget.prototype.init = function () {
	        this.moveColumnController = this.createBean(new MoveColumnController(this.pinned, this.eContainer));
	        var bodyDropPivotTarget = new BodyDropPivotTarget(this.pinned);
	        this.createBean(bodyDropPivotTarget);
	        this.dropListeners[DropType.ColumnMove] = this.moveColumnController;
	        this.dropListeners[DropType.Pivot] = bodyDropPivotTarget;
	        this.dragAndDropService.addDropTarget(this);
	    };
	    BodyDropTarget.prototype.getIconName = function () {
	        return this.currentDropListener.getIconName();
	    };
	    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
	    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
	    // dropped into the grid's body.
	    BodyDropTarget.prototype.getDropType = function (draggingEvent) {
	        if (this.columnController.isPivotMode()) {
	            // in pivot mode, then if moving a column (ie didn't come from toolpanel) then it's
	            // a standard column move, however if it came from the toolpanel, then we are introducing
	            // dimensions or values to the grid
	            if (draggingEvent.dragSource.type === exports.DragSourceType.ToolPanel) {
	                return DropType.Pivot;
	            }
	            return DropType.ColumnMove;
	        }
	        // it's a column, and not pivot mode, so always moving
	        return DropType.ColumnMove;
	    };
	    BodyDropTarget.prototype.onDragEnter = function (draggingEvent) {
	        // we pick the drop listener depending on whether we are in pivot mode are not. if we are
	        // in pivot mode, then dropping cols changes the row group, pivot, value stats. otherwise
	        // we change visibility state and position.
	        // if (this.columnController.isPivotMode()) {
	        var dropType = this.getDropType(draggingEvent);
	        this.currentDropListener = this.dropListeners[dropType];
	        this.currentDropListener.onDragEnter(draggingEvent);
	    };
	    BodyDropTarget.prototype.onDragLeave = function (params) {
	        this.currentDropListener.onDragLeave(params);
	    };
	    BodyDropTarget.prototype.onDragging = function (params) {
	        this.currentDropListener.onDragging(params);
	    };
	    BodyDropTarget.prototype.onDragStop = function (params) {
	        this.currentDropListener.onDragStop(params);
	    };
	    __decorate$Q([
	        Autowired('dragAndDropService')
	    ], BodyDropTarget.prototype, "dragAndDropService", void 0);
	    __decorate$Q([
	        Autowired('columnController')
	    ], BodyDropTarget.prototype, "columnController", void 0);
	    __decorate$Q([
	        Autowired('controllersService')
	    ], BodyDropTarget.prototype, "controllersService", void 0);
	    __decorate$Q([
	        PostConstruct
	    ], BodyDropTarget.prototype, "postConstruct", null);
	    __decorate$Q([
	        PostConstruct
	    ], BodyDropTarget.prototype, "init", null);
	    return BodyDropTarget;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$Y = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$R = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderContainer = /** @class */ (function (_super) {
	    __extends$Y(HeaderContainer, _super);
	    function HeaderContainer(eContainer, eViewport, pinned) {
	        var _this = _super.call(this) || this;
	        _this.groupsRowComps = [];
	        _this.eContainer = eContainer;
	        _this.pinned = pinned;
	        _this.eViewport = eViewport;
	        return _this;
	    }
	    HeaderContainer.prototype.forEachHeaderElement = function (callback) {
	        if (this.groupsRowComps) {
	            this.groupsRowComps.forEach(function (c) { return c.forEachHeaderElement(callback); });
	        }
	        if (this.columnsRowComp) {
	            this.columnsRowComp.forEachHeaderElement(callback);
	        }
	        if (this.filtersRowComp) {
	            this.filtersRowComp.forEachHeaderElement(callback);
	        }
	    };
	    HeaderContainer.prototype.init = function () {
	        // if value changes, then if not pivoting, we at least need to change the label eg from sum() to avg(),
	        // if pivoting, then the columns have changed
	        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this));
	        this.setupDragAndDrop();
	    };
	    HeaderContainer.prototype.onColumnResized = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.onDisplayedColumnsChanged = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.onScrollVisibilityChanged = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.onScrollbarWidthChanged = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.setWidthOfPinnedContainer = function () {
	        var pinningLeft = this.pinned === Constants.PINNED_LEFT;
	        var pinningRight = this.pinned === Constants.PINNED_RIGHT;
	        var controller = this.columnController;
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        var scrollbarWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        if (pinningLeft || pinningRight) {
	            // size to fit all columns
	            var width = controller[pinningLeft ? 'getDisplayedColumnsLeftWidth' : 'getDisplayedColumnsRightWidth']();
	            // if there is a scroll showing (and taking up space, so Windows, and not iOS)
	            // in the body, then we add extra space to keep header aligned with the body,
	            // as body width fits the cols and the scrollbar
	            var addPaddingForScrollbar = this.scrollVisibleService.isVerticalScrollShowing() && ((isRtl && pinningLeft) || (!isRtl && pinningRight));
	            if (addPaddingForScrollbar) {
	                width += scrollbarWidth;
	            }
	            setFixedWidth(this.eContainer, width);
	        }
	    };
	    HeaderContainer.prototype.getRowComps = function () {
	        var res = [];
	        if (this.groupsRowComps) {
	            res = res.concat(this.groupsRowComps);
	        }
	        if (this.columnsRowComp) {
	            res.push(this.columnsRowComp);
	        }
	        if (this.filtersRowComp) {
	            res.push(this.filtersRowComp);
	        }
	        return res;
	    };
	    // grid cols have changed - this also means the number of rows in the header can have
	    // changed. so we remove all the old rows and insert new ones for a complete refresh
	    HeaderContainer.prototype.onGridColumnsChanged = function () {
	        this.refresh(true);
	    };
	    // we expose this for gridOptions.api.refreshHeader() to call
	    HeaderContainer.prototype.refresh = function (keepColumns) {
	        if (keepColumns === void 0) { keepColumns = false; }
	        this.refreshRowComps(keepColumns);
	    };
	    HeaderContainer.prototype.setupDragAndDrop = function () {
	        // center section has viewport, but pinned sections do not
	        var dropContainer = this.eViewport ? this.eViewport : this.eContainer;
	        var bodyDropTarget = new BodyDropTarget(this.pinned, dropContainer);
	        this.createManagedBean(bodyDropTarget);
	    };
	    HeaderContainer.prototype.destroyRowComps = function (keepColumns) {
	        if (keepColumns === void 0) { keepColumns = false; }
	        this.groupsRowComps.forEach(this.destroyRowComp.bind(this));
	        this.groupsRowComps = [];
	        this.destroyRowComp(this.filtersRowComp);
	        this.filtersRowComp = undefined;
	        if (!keepColumns) {
	            this.destroyRowComp(this.columnsRowComp);
	            this.columnsRowComp = undefined;
	        }
	    };
	    HeaderContainer.prototype.destroyRowComp = function (rowComp) {
	        if (rowComp) {
	            this.destroyBean(rowComp);
	            this.eContainer.removeChild(rowComp.getGui());
	        }
	    };
	    HeaderContainer.prototype.refreshRowComps = function (keepColumns) {
	        var _this = this;
	        if (keepColumns === void 0) { keepColumns = false; }
	        var sequence = new NumberSequence();
	        var refreshColumnGroups = function () {
	            var groupRowCount = _this.columnController.getHeaderRowCount() - 1;
	            _this.groupsRowComps.forEach(_this.destroyRowComp.bind(_this));
	            _this.groupsRowComps = [];
	            for (var i = 0; i < groupRowCount; i++) {
	                var rowComp = _this.createBean(new HeaderRowComp(sequence.next(), HeaderRowType.COLUMN_GROUP, _this.pinned));
	                _this.groupsRowComps.push(rowComp);
	            }
	        };
	        var refreshColumns = function () {
	            var rowIndex = sequence.next();
	            if (_this.columnsRowComp) {
	                var rowIndexMismatch = _this.columnsRowComp.getRowIndex() !== rowIndex;
	                if (!keepColumns || rowIndexMismatch) {
	                    _this.destroyRowComp(_this.columnsRowComp);
	                    _this.columnsRowComp = undefined;
	                }
	            }
	            if (!_this.columnsRowComp) {
	                _this.columnsRowComp = _this.createBean(new HeaderRowComp(rowIndex, HeaderRowType.COLUMN, _this.pinned));
	            }
	        };
	        var refreshFilters = function () {
	            var includeFloatingFilter = !_this.columnController.isPivotMode() && _this.columnController.hasFloatingFilters();
	            var destroyPreviousComp = function () {
	                _this.destroyRowComp(_this.filtersRowComp);
	                _this.filtersRowComp = undefined;
	            };
	            if (!includeFloatingFilter) {
	                destroyPreviousComp();
	                return;
	            }
	            var rowIndex = sequence.next();
	            if (_this.filtersRowComp) {
	                var rowIndexMismatch = _this.filtersRowComp.getRowIndex() !== rowIndex;
	                if (!keepColumns || rowIndexMismatch) {
	                    destroyPreviousComp();
	                }
	            }
	            if (!_this.filtersRowComp) {
	                _this.filtersRowComp = _this.createBean(new HeaderRowComp(rowIndex, HeaderRowType.FLOATING_FILTER, _this.pinned));
	            }
	        };
	        refreshColumnGroups();
	        refreshColumns();
	        refreshFilters();
	        // this re-adds the this.columnsRowComp, which is fine, it just means the DOM will rearrange then,
	        // taking it out of the last position and re-inserting relative to the other rows.
	        this.getRowComps().forEach(function (rowComp) { return _this.eContainer.appendChild(rowComp.getGui()); });
	    };
	    __decorate$R([
	        Autowired('columnController')
	    ], HeaderContainer.prototype, "columnController", void 0);
	    __decorate$R([
	        Autowired('scrollVisibleService')
	    ], HeaderContainer.prototype, "scrollVisibleService", void 0);
	    __decorate$R([
	        PostConstruct
	    ], HeaderContainer.prototype, "init", null);
	    __decorate$R([
	        PreDestroy
	    ], HeaderContainer.prototype, "destroyRowComps", null);
	    return HeaderContainer;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$Z = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$S = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	(function (HeaderNavigationDirection) {
	    HeaderNavigationDirection[HeaderNavigationDirection["UP"] = 0] = "UP";
	    HeaderNavigationDirection[HeaderNavigationDirection["DOWN"] = 1] = "DOWN";
	    HeaderNavigationDirection[HeaderNavigationDirection["LEFT"] = 2] = "LEFT";
	    HeaderNavigationDirection[HeaderNavigationDirection["RIGHT"] = 3] = "RIGHT";
	})(exports.HeaderNavigationDirection || (exports.HeaderNavigationDirection = {}));
	var HeaderNavigationService = /** @class */ (function (_super) {
	    __extends$Z(HeaderNavigationService, _super);
	    function HeaderNavigationService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HeaderNavigationService.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function (p) {
	            _this.gridBodyCon = p.gridBodyCon;
	        });
	    };
	    HeaderNavigationService.prototype.registerHeaderRoot = function (headerRoot) {
	        this.headerRoot = headerRoot;
	    };
	    HeaderNavigationService.prototype.getHeaderRowCount = function () {
	        var headerContainers = this.headerRoot.getHeaderContainers();
	        return headerContainers.size === 0 ? 0 : this.getHeaderContainer().getRowComps().length;
	    };
	    HeaderNavigationService.prototype.getHeaderRowType = function (idx) {
	        if (this.getHeaderRowCount()) {
	            return this.getHeaderContainer().getRowComps()[idx].getType();
	        }
	    };
	    HeaderNavigationService.prototype.getHeaderContainer = function (position) {
	        if (position === void 0) { position = 'center'; }
	        if (position === null) {
	            position = 'center';
	        }
	        return this.headerRoot.getHeaderContainers().get(position);
	    };
	    /*
	     * This method navigates grid header vertically
	     * @return {boolean} true to preventDefault on the event that caused this navigation.
	     */
	    HeaderNavigationService.prototype.navigateVertically = function (direction, fromHeader, event) {
	        if (!fromHeader) {
	            fromHeader = this.focusController.getFocusedHeader();
	        }
	        if (!fromHeader) {
	            return false;
	        }
	        var headerRowIndex = fromHeader.headerRowIndex, column = fromHeader.column;
	        var rowLen = this.getHeaderRowCount();
	        var isUp = direction === exports.HeaderNavigationDirection.UP;
	        var nextRow = isUp ? headerRowIndex - 1 : headerRowIndex + 1;
	        var nextFocusColumn = null;
	        var skipColumn = false;
	        if (nextRow < 0) {
	            nextRow = 0;
	            nextFocusColumn = column;
	            skipColumn = true;
	        }
	        if (nextRow >= rowLen) {
	            nextRow = -1; // -1 indicates the focus should move to grid rows.
	        }
	        var currentRowType = this.getHeaderRowType(headerRowIndex);
	        if (!skipColumn) {
	            if (currentRowType === HeaderRowType.COLUMN_GROUP) {
	                var currentColumn = column;
	                nextFocusColumn = isUp ? column.getParent() : currentColumn.getDisplayedChildren()[0];
	            }
	            else if (currentRowType === HeaderRowType.FLOATING_FILTER) {
	                nextFocusColumn = column;
	            }
	            else {
	                var currentColumn = column;
	                nextFocusColumn = isUp ? currentColumn.getParent() : currentColumn;
	            }
	            if (!nextFocusColumn) {
	                return false;
	            }
	        }
	        return this.focusController.focusHeaderPosition({ headerRowIndex: nextRow, column: nextFocusColumn }, undefined, false, true, event);
	    };
	    /*
	     * This method navigates grid header horizontally
	     * @return {boolean} true to preventDefault on the event that caused this navigation.
	     */
	    HeaderNavigationService.prototype.navigateHorizontally = function (direction, fromTab, event) {
	        if (fromTab === void 0) { fromTab = false; }
	        var focusedHeader = this.focusController.getFocusedHeader();
	        var isLeft = direction === exports.HeaderNavigationDirection.LEFT;
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        var nextHeader;
	        var normalisedDirection;
	        // either navigating to the left or isRtl (cannot be both)
	        if (isLeft !== isRtl) {
	            normalisedDirection = 'Before';
	            nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
	        }
	        else {
	            normalisedDirection = 'After';
	            nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
	        }
	        if (nextHeader) {
	            return this.focusController.focusHeaderPosition(nextHeader, normalisedDirection, fromTab, true, event);
	        }
	        if (!fromTab) {
	            return true;
	        }
	        return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
	    };
	    HeaderNavigationService.prototype.focusNextHeaderRow = function (focusedHeader, direction, event) {
	        var currentIndex = focusedHeader.headerRowIndex;
	        var nextPosition = null;
	        var nextRowIndex;
	        if (direction === 'Before') {
	            if (currentIndex > 0) {
	                nextRowIndex = currentIndex - 1;
	                nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, 'end');
	            }
	        }
	        else {
	            nextRowIndex = currentIndex + 1;
	            nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, 'start');
	        }
	        return this.focusController.focusHeaderPosition(nextPosition, direction, true, true, event);
	    };
	    HeaderNavigationService.prototype.scrollToColumn = function (column, direction) {
	        if (direction === void 0) { direction = 'After'; }
	        if (column.getPinned()) {
	            return;
	        }
	        var columnToScrollTo;
	        if (column instanceof ColumnGroup) {
	            var columns = column.getDisplayedLeafColumns();
	            columnToScrollTo = direction === 'Before' ? last(columns) : columns[0];
	        }
	        else {
	            columnToScrollTo = column;
	        }
	        this.gridBodyCon.getScrollFeature().ensureColumnVisible(columnToScrollTo);
	        // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
	        // floating cell, the scrolls get out of sync
	        this.gridBodyCon.getScrollFeature().horizontallyScrollHeaderCenterAndFloatingCenter();
	        // need to flush frames, to make sure the correct cells are rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    __decorate$S([
	        Autowired('focusController')
	    ], HeaderNavigationService.prototype, "focusController", void 0);
	    __decorate$S([
	        Autowired('headerPositionUtils')
	    ], HeaderNavigationService.prototype, "headerPositionUtils", void 0);
	    __decorate$S([
	        Autowired('animationFrameService')
	    ], HeaderNavigationService.prototype, "animationFrameService", void 0);
	    __decorate$S([
	        Autowired('controllersService')
	    ], HeaderNavigationService.prototype, "controllersService", void 0);
	    __decorate$S([
	        PostConstruct
	    ], HeaderNavigationService.prototype, "postConstruct", null);
	    HeaderNavigationService = __decorate$S([
	        Bean('headerNavigationService')
	    ], HeaderNavigationService);
	    return HeaderNavigationService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var KeyName = /** @class */ (function () {
	    function KeyName() {
	    }
	    KeyName.BACKSPACE = 'Backspace';
	    KeyName.TAB = 'Tab';
	    KeyName.ENTER = 'Enter';
	    KeyName.SHIFT = 'Shift';
	    KeyName.ESCAPE = 'Escape';
	    KeyName.SPACE = ' ';
	    KeyName.LEFT = 'ArrowLeft';
	    KeyName.UP = 'ArrowUp';
	    KeyName.RIGHT = 'ArrowRight';
	    KeyName.DOWN = 'ArrowDown';
	    KeyName.DELETE = 'Delete';
	    // IE11 & Edge treat the numpad del key differently - with numlock on we get "Del" for key
	    KeyName.NUM_PAD_DELETE = 'Del';
	    KeyName.A = 'a';
	    KeyName.C = 'c';
	    KeyName.V = 'v';
	    KeyName.D = 'd';
	    KeyName.Z = 'z';
	    KeyName.Y = 'y';
	    KeyName.F2 = 'F2';
	    KeyName.PAGE_UP = 'PageUp';
	    KeyName.PAGE_DOWN = 'PageDown';
	    KeyName.PAGE_HOME = 'Home';
	    KeyName.PAGE_END = 'End';
	    return KeyName;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$_ = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$T = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var CenterWidthFeature = /** @class */ (function (_super) {
	    __extends$_(CenterWidthFeature, _super);
	    function CenterWidthFeature(callback) {
	        var _this = _super.call(this) || this;
	        _this.callback = callback;
	        return _this;
	    }
	    CenterWidthFeature.prototype.postConstruct = function () {
	        var listener = this.setWidth.bind(this);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, listener);
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, listener);
	        this.setWidth();
	    };
	    CenterWidthFeature.prototype.setWidth = function () {
	        var columnController = this.columnController;
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        var centerWidth = columnController.getBodyContainerWidth();
	        var leftWidth = columnController.getDisplayedColumnsLeftWidth();
	        var rightWidth = columnController.getDisplayedColumnsRightWidth();
	        var totalWidth = printLayout ? centerWidth + leftWidth + rightWidth : centerWidth;
	        this.callback(totalWidth);
	    };
	    __decorate$T([
	        Autowired('columnController')
	    ], CenterWidthFeature.prototype, "columnController", void 0);
	    __decorate$T([
	        PostConstruct
	    ], CenterWidthFeature.prototype, "postConstruct", null);
	    return CenterWidthFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$$ = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$U = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderRootComp = /** @class */ (function (_super) {
	    __extends$$(HeaderRootComp, _super);
	    function HeaderRootComp() {
	        var _this = _super.call(this, HeaderRootComp.TEMPLATE) || this;
	        _this.headerContainers = new Map();
	        return _this;
	    }
	    HeaderRootComp.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        this.gridApi.registerHeaderRootComp(this);
	        this.autoWidthCalculator.registerHeaderRootComp(this);
	        this.registerHeaderContainer(new HeaderContainer(this.eHeaderContainer, this.eHeaderViewport, null), 'center');
	        this.registerHeaderContainer(new HeaderContainer(this.ePinnedLeftHeader, null, Constants.PINNED_LEFT), 'left');
	        this.registerHeaderContainer(new HeaderContainer(this.ePinnedRightHeader, null, Constants.PINNED_RIGHT), 'right');
	        this.headerContainers.forEach(function (container) { return _this.createManagedBean(container); });
	        this.headerNavigationService.registerHeaderRoot(this);
	        // shotgun way to get labels to change, eg from sum(amount) to avg(amount)
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	        // for setting ag-pivot-on / ag-pivot-off CSS classes
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
	        this.onPivotModeChanged();
	        this.addPreventHeaderScroll();
	        this.createManagedBean(new CenterWidthFeature(function (width) { return _this.eHeaderContainer.style.width = width + "px"; }));
	        if (this.columnController.isReady()) {
	            this.refreshHeader();
	        }
	        this.setupHeaderHeight();
	        this.controllersService.registerHeaderRootComp(this);
	    };
	    HeaderRootComp.prototype.setupHeaderHeight = function () {
	        var listener = this.setHeaderHeight.bind(this);
	        listener();
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_HEADER_HEIGHT, listener);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, listener);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, listener);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, listener);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, listener);
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
	    };
	    HeaderRootComp.prototype.registerHeaderContainer = function (headerContainer, type) {
	        this.headerContainers.set(type, headerContainer);
	    };
	    HeaderRootComp.prototype.onTabKeyDown = function (e) {
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        var direction = e.shiftKey !== isRtl
	            ? exports.HeaderNavigationDirection.LEFT
	            : exports.HeaderNavigationDirection.RIGHT;
	        if (this.headerNavigationService.navigateHorizontally(direction, true, e) ||
	            this.focusController.focusNextGridCoreContainer(e.shiftKey)) {
	            e.preventDefault();
	        }
	    };
	    HeaderRootComp.prototype.handleKeyDown = function (e) {
	        var direction = null;
	        switch (e.key) {
	            case KeyName.LEFT:
	                direction = exports.HeaderNavigationDirection.LEFT;
	            case KeyName.RIGHT:
	                if (!exists(direction)) {
	                    direction = exports.HeaderNavigationDirection.RIGHT;
	                }
	                this.headerNavigationService.navigateHorizontally(direction, false, e);
	                break;
	            case KeyName.UP:
	                direction = exports.HeaderNavigationDirection.UP;
	            case KeyName.DOWN:
	                if (!exists(direction)) {
	                    direction = exports.HeaderNavigationDirection.DOWN;
	                }
	                if (this.headerNavigationService.navigateVertically(direction, null, e)) {
	                    e.preventDefault();
	                }
	                break;
	            default:
	                return;
	        }
	    };
	    HeaderRootComp.prototype.onFocusOut = function (e) {
	        var relatedTarget = e.relatedTarget;
	        var eGui = this.getGui();
	        if (!relatedTarget && eGui.contains(document.activeElement)) {
	            return;
	        }
	        if (!eGui.contains(relatedTarget)) {
	            this.focusController.clearFocusedHeader();
	        }
	    };
	    HeaderRootComp.prototype.onDomLayoutChanged = function () {
	        var newValue = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        if (this.printLayout !== newValue) {
	            this.printLayout = newValue;
	            this.refreshHeader();
	        }
	    };
	    HeaderRootComp.prototype.setHorizontalScroll = function (offset) {
	        this.eHeaderContainer.style.transform = "translateX(" + offset + "px)";
	    };
	    HeaderRootComp.prototype.forEachHeaderElement = function (callback) {
	        this.headerContainers.forEach(function (childContainer) { return childContainer.forEachHeaderElement(callback); });
	    };
	    HeaderRootComp.prototype.refreshHeader = function () {
	        this.headerContainers.forEach(function (container) { return container.refresh(); });
	    };
	    HeaderRootComp.prototype.onPivotModeChanged = function () {
	        var pivotMode = this.columnController.isPivotMode();
	        addOrRemoveCssClass(this.getGui(), 'ag-pivot-on', pivotMode);
	        addOrRemoveCssClass(this.getGui(), 'ag-pivot-off', !pivotMode);
	    };
	    HeaderRootComp.prototype.setHeaderHeight = function () {
	        var _a = this, columnController = _a.columnController, gridOptionsWrapper = _a.gridOptionsWrapper;
	        var numberOfFloating = 0;
	        var headerRowCount = columnController.getHeaderRowCount();
	        var totalHeaderHeight;
	        var groupHeight;
	        var headerHeight;
	        if (columnController.isPivotMode()) {
	            groupHeight = gridOptionsWrapper.getPivotGroupHeaderHeight();
	            headerHeight = gridOptionsWrapper.getPivotHeaderHeight();
	        }
	        else {
	            var hasFloatingFilters = columnController.hasFloatingFilters();
	            if (hasFloatingFilters) {
	                headerRowCount++;
	                numberOfFloating = 1;
	            }
	            groupHeight = gridOptionsWrapper.getGroupHeaderHeight();
	            headerHeight = gridOptionsWrapper.getHeaderHeight();
	        }
	        var numberOfNonGroups = 1 + numberOfFloating;
	        var numberOfGroups = headerRowCount - numberOfNonGroups;
	        totalHeaderHeight = numberOfFloating * gridOptionsWrapper.getFloatingFiltersHeight();
	        totalHeaderHeight += numberOfGroups * groupHeight;
	        totalHeaderHeight += headerHeight;
	        // one extra pixel is needed here to account for the
	        // height of the border
	        var px = totalHeaderHeight + 1 + "px";
	        this.getGui().style.height = px;
	        this.getGui().style.minHeight = px;
	    };
	    // if the user is in floating filter and hits tab a few times, the header can
	    // end up scrolling to show items off the screen, leaving the grid and header
	    // and the grid columns no longer in sync.
	    HeaderRootComp.prototype.addPreventHeaderScroll = function () {
	        var _this = this;
	        this.addManagedListener(this.eHeaderViewport, 'scroll', function () {
	            // if the header scrolls, the header will be out of sync. so we reset the
	            // header scroll, and then scroll the body, which will in turn set the offset
	            // on the header, giving the impression that the header scrolled as expected.
	            var scrollLeft = _this.eHeaderViewport.scrollLeft;
	            if (scrollLeft !== 0) {
	                var gridBodyCon = _this.controllersService.getGridBodyController();
	                gridBodyCon.getScrollFeature().scrollHorizontally(scrollLeft);
	                _this.eHeaderViewport.scrollLeft = 0;
	            }
	        });
	    };
	    HeaderRootComp.prototype.getHeaderContainers = function () {
	        return this.headerContainers;
	    };
	    HeaderRootComp.prototype.onPinnedLeftWidthChanged = function () {
	        var displayed = this.pinnedWidthService.getPinnedLeftWidth() > 0;
	        setDisplayed(this.ePinnedLeftHeader, displayed);
	    };
	    HeaderRootComp.prototype.onPinnedRightWidthChanged = function () {
	        var displayed = this.pinnedWidthService.getPinnedRightWidth() > 0;
	        setDisplayed(this.ePinnedRightHeader, displayed);
	    };
	    HeaderRootComp.TEMPLATE = "<div class=\"ag-header\" role=\"presentation\">\n            <div class=\"ag-pinned-left-header\" ref=\"ePinnedLeftHeader\" role=\"presentation\"></div>\n            <div class=\"ag-header-viewport\" ref=\"eHeaderViewport\" role=\"presentation\">\n                <div class=\"ag-header-container\" ref=\"eHeaderContainer\" role=\"rowgroup\"></div>\n            </div>\n            <div class=\"ag-pinned-right-header\" ref=\"ePinnedRightHeader\" role=\"presentation\"></div>\n        </div>";
	    __decorate$U([
	        RefSelector('ePinnedLeftHeader')
	    ], HeaderRootComp.prototype, "ePinnedLeftHeader", void 0);
	    __decorate$U([
	        RefSelector('ePinnedRightHeader')
	    ], HeaderRootComp.prototype, "ePinnedRightHeader", void 0);
	    __decorate$U([
	        RefSelector('eHeaderContainer')
	    ], HeaderRootComp.prototype, "eHeaderContainer", void 0);
	    __decorate$U([
	        RefSelector('eHeaderViewport')
	    ], HeaderRootComp.prototype, "eHeaderViewport", void 0);
	    __decorate$U([
	        Autowired('columnController')
	    ], HeaderRootComp.prototype, "columnController", void 0);
	    __decorate$U([
	        Autowired('gridApi')
	    ], HeaderRootComp.prototype, "gridApi", void 0);
	    __decorate$U([
	        Autowired('autoWidthCalculator')
	    ], HeaderRootComp.prototype, "autoWidthCalculator", void 0);
	    __decorate$U([
	        Autowired('headerNavigationService')
	    ], HeaderRootComp.prototype, "headerNavigationService", void 0);
	    __decorate$U([
	        Autowired('pinnedWidthService')
	    ], HeaderRootComp.prototype, "pinnedWidthService", void 0);
	    __decorate$U([
	        Autowired('controllersService')
	    ], HeaderRootComp.prototype, "controllersService", void 0);
	    return HeaderRootComp;
	}(ManagedFocusComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$10 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign$6 = function () {
	    __assign$6 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$6.apply(this, arguments);
	};
	var __decorate$V = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var FilterManager = /** @class */ (function (_super) {
	    __extends$10(FilterManager, _super);
	    function FilterManager() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.allAdvancedFilters = new Map();
	        _this.activeAdvancedFilters = [];
	        _this.quickFilter = null;
	        _this.quickFilterParts = null;
	        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
	        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
	        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
	        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
	        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
	        _this.processingFilterChange = false;
	        return _this;
	    }
	    FilterManager_1 = FilterManager;
	    FilterManager.prototype.init = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_CHANGED, this.onNewRowsLoaded.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        this.quickFilter = this.parseQuickFilter(this.gridOptionsWrapper.getQuickFilterText());
	        this.setQuickFilterParts();
	        this.allowShowChangeAfterFilter = this.gridOptionsWrapper.isAllowShowChangeAfterFilter();
	    };
	    FilterManager.prototype.setQuickFilterParts = function () {
	        this.quickFilterParts = this.quickFilter ? this.quickFilter.split(' ') : null;
	    };
	    FilterManager.prototype.setFilterModel = function (model) {
	        var _this = this;
	        var allPromises = [];
	        if (model) {
	            // mark the filters as we set them, so any active filters left over we stop
	            var modelKeys_1 = convertToSet(Object.keys(model));
	            this.allAdvancedFilters.forEach(function (filterWrapper, colId) {
	                var newModel = model[colId];
	                allPromises.push(_this.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel));
	                modelKeys_1.delete(colId);
	            });
	            // at this point, processedFields contains data for which we don't have a filter working yet
	            modelKeys_1.forEach(function (colId) {
	                var column = _this.columnController.getPrimaryColumn(colId);
	                if (!column) {
	                    console.warn('Warning ag-grid setFilterModel - no column found for colId ' + colId);
	                    return;
	                }
	                var filterWrapper = _this.getOrCreateFilterWrapper(column, 'NO_UI');
	                allPromises.push(_this.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]));
	            });
	        }
	        else {
	            this.allAdvancedFilters.forEach(function (filterWrapper) {
	                allPromises.push(_this.setModelOnFilterWrapper(filterWrapper.filterPromise, null));
	            });
	        }
	        AgPromise.all(allPromises).then(function () { return _this.onFilterChanged(); });
	    };
	    FilterManager.prototype.setModelOnFilterWrapper = function (filterPromise, newModel) {
	        return new AgPromise(function (resolve) {
	            filterPromise.then(function (filter) {
	                if (typeof filter.setModel !== 'function') {
	                    console.warn('Warning ag-grid - filter missing setModel method, which is needed for setFilterModel');
	                    resolve();
	                }
	                (filter.setModel(newModel) || AgPromise.resolve()).then(function () { return resolve(); });
	            });
	        });
	    };
	    FilterManager.prototype.getFilterModel = function () {
	        var result = {};
	        this.allAdvancedFilters.forEach(function (filterWrapper, key) {
	            // because user can provide filters, we provide useful error checking and messages
	            var filterPromise = filterWrapper.filterPromise;
	            var filter = filterPromise.resolveNow(null, function (promiseFilter) { return promiseFilter; });
	            if (filter == null) {
	                return null;
	            }
	            if (typeof filter.getModel !== 'function') {
	                console.warn('Warning ag-grid - filter API missing getModel method, which is needed for getFilterModel');
	                return;
	            }
	            var model = filter.getModel();
	            if (exists(model)) {
	                result[key] = model;
	            }
	        });
	        return result;
	    };
	    // returns true if any advanced filter (ie not quick filter) active
	    FilterManager.prototype.isAdvancedFilterPresent = function () {
	        return this.activeAdvancedFilters.length > 0;
	    };
	    // called by:
	    // 1) onFilterChanged()
	    // 2) onNewRowsLoaded()
	    FilterManager.prototype.updateActiveFilters = function () {
	        var _this = this;
	        this.activeAdvancedFilters.length = 0;
	        this.allAdvancedFilters.forEach(function (filterWrapper) {
	            if (filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); })) {
	                var resolvedPromise = filterWrapper.filterPromise.resolveNow(null, function (filter) { return filter; });
	                _this.activeAdvancedFilters.push(resolvedPromise);
	            }
	        });
	    };
	    FilterManager.prototype.updateFilterFlagInColumns = function (source, additionalEventAttributes) {
	        this.allAdvancedFilters.forEach(function (filterWrapper) {
	            var isFilterActive = filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); });
	            filterWrapper.column.setFilterActive(isFilterActive, source, additionalEventAttributes);
	        });
	    };
	    FilterManager.prototype.isAnyFilterPresent = function () {
	        return this.isQuickFilterPresent() || this.isAdvancedFilterPresent() || this.gridOptionsWrapper.isExternalFilterPresent();
	    };
	    FilterManager.prototype.doAdvancedFiltersPass = function (node, filterToSkip) {
	        var data = node.data;
	        for (var i = 0; i < this.activeAdvancedFilters.length; i++) {
	            var filter = this.activeAdvancedFilters[i];
	            if (filter == null || filter === filterToSkip) {
	                continue;
	            }
	            if (typeof filter.doesFilterPass !== 'function') {
	                // because users can do custom filters, give nice error message
	                throw new Error('Filter is missing method doesFilterPass');
	            }
	            if (!filter.doesFilterPass({ node: node, data: data })) {
	                return false;
	            }
	        }
	        return true;
	    };
	    FilterManager.prototype.parseQuickFilter = function (newFilter) {
	        if (!exists(newFilter)) {
	            return null;
	        }
	        if (!this.gridOptionsWrapper.isRowModelDefault()) {
	            console.warn('ag-grid: quick filtering only works with the Client-Side Row Model');
	            return null;
	        }
	        return newFilter.toUpperCase();
	    };
	    FilterManager.prototype.setQuickFilter = function (newFilter) {
	        var parsedFilter = this.parseQuickFilter(newFilter);
	        if (this.quickFilter !== parsedFilter) {
	            this.quickFilter = parsedFilter;
	            this.setQuickFilterParts();
	            this.onFilterChanged();
	        }
	    };
	    FilterManager.prototype.onFilterChanged = function (filterInstance, additionalEventAttributes) {
	        this.updateActiveFilters();
	        this.updateFilterFlagInColumns('filterChanged', additionalEventAttributes);
	        this.allAdvancedFilters.forEach(function (filterWrapper) {
	            filterWrapper.filterPromise.then(function (filter) {
	                if (filter !== filterInstance && filter.onAnyFilterChanged) {
	                    filter.onAnyFilterChanged();
	                }
	            });
	        });
	        var filterChangedEvent = {
	            type: Events.EVENT_FILTER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        if (additionalEventAttributes) {
	            mergeDeep(filterChangedEvent, additionalEventAttributes);
	        }
	        // because internal events are not async in ag-grid, when the dispatchEvent
	        // method comes back, we know all listeners have finished executing.
	        this.processingFilterChange = true;
	        this.eventService.dispatchEvent(filterChangedEvent);
	        this.processingFilterChange = false;
	    };
	    FilterManager.prototype.isSuppressFlashingCellsBecauseFiltering = function () {
	        // if user has elected to always flash cell changes, then always return false, otherwise we suppress flashing
	        // changes when filtering
	        return !this.allowShowChangeAfterFilter && this.processingFilterChange;
	    };
	    FilterManager.prototype.isQuickFilterPresent = function () {
	        return this.quickFilter !== null;
	    };
	    FilterManager.prototype.doesRowPassOtherFilters = function (filterToSkip, node) {
	        return this.doesRowPassFilter({ rowNode: node, filterInstanceToSkip: filterToSkip });
	    };
	    FilterManager.prototype.doesRowPassQuickFilterNoCache = function (node, filterPart) {
	        var _this = this;
	        var columns = this.columnController.getAllColumnsForQuickFilter();
	        return some(columns, function (column) {
	            var part = _this.getQuickFilterTextForColumn(column, node);
	            return exists(part) && part.indexOf(filterPart) >= 0;
	        });
	    };
	    FilterManager.prototype.doesRowPassQuickFilterCache = function (node, filterPart) {
	        if (!node.quickFilterAggregateText) {
	            this.aggregateRowForQuickFilter(node);
	        }
	        return node.quickFilterAggregateText.indexOf(filterPart) >= 0;
	    };
	    FilterManager.prototype.doesRowPassQuickFilter = function (node) {
	        var _this = this;
	        var usingCache = this.gridOptionsWrapper.isCacheQuickFilter();
	        // each part must pass, if any fails, then the whole filter fails
	        return every(this.quickFilterParts, function (part) {
	            return usingCache ? _this.doesRowPassQuickFilterCache(node, part) : _this.doesRowPassQuickFilterNoCache(node, part);
	        });
	    };
	    FilterManager.prototype.doesRowPassFilter = function (params) {
	        // the row must pass ALL of the filters, so if any of them fail,
	        // we return true. that means if a row passes the quick filter,
	        // but fails the column filter, it fails overall
	        // first up, check quick filter
	        if (this.isQuickFilterPresent() && !this.doesRowPassQuickFilter(params.rowNode)) {
	            return false;
	        }
	        // secondly, give the client a chance to reject this row
	        if (this.gridOptionsWrapper.isExternalFilterPresent() && !this.gridOptionsWrapper.doesExternalFilterPass(params.rowNode)) {
	            return false;
	        }
	        // lastly, check our internal advanced filter
	        if (this.isAdvancedFilterPresent() && !this.doAdvancedFiltersPass(params.rowNode, params.filterInstanceToSkip)) {
	            return false;
	        }
	        // got this far, all filters pass
	        return true;
	    };
	    FilterManager.prototype.getQuickFilterTextForColumn = function (column, node) {
	        var value = this.valueService.getValue(column, node, true);
	        var colDef = column.getColDef();
	        if (colDef.getQuickFilterText) {
	            var params = {
	                value: value,
	                node: node,
	                data: node.data,
	                column: column,
	                colDef: colDef,
	                context: this.gridOptionsWrapper.getContext()
	            };
	            value = colDef.getQuickFilterText(params);
	        }
	        return exists(value) ? value.toString().toUpperCase() : null;
	    };
	    FilterManager.prototype.aggregateRowForQuickFilter = function (node) {
	        var _this = this;
	        var stringParts = [];
	        var columns = this.columnController.getAllColumnsForQuickFilter();
	        forEach(columns, function (column) {
	            var part = _this.getQuickFilterTextForColumn(column, node);
	            if (exists(part)) {
	                stringParts.push(part);
	            }
	        });
	        node.quickFilterAggregateText = stringParts.join(FilterManager_1.QUICK_FILTER_SEPARATOR);
	    };
	    FilterManager.prototype.onNewRowsLoaded = function (source) {
	        this.allAdvancedFilters.forEach(function (filterWrapper) {
	            filterWrapper.filterPromise.then(function (filter) {
	                if (filter.onNewRowsLoaded) {
	                    filter.onNewRowsLoaded();
	                }
	            });
	        });
	        this.updateFilterFlagInColumns(source);
	        this.updateActiveFilters();
	    };
	    FilterManager.prototype.createValueGetter = function (column) {
	        var _this = this;
	        return function (node) { return _this.valueService.getValue(column, node, true); };
	    };
	    FilterManager.prototype.getFilterComponent = function (column, source, createIfDoesNotExist) {
	        if (createIfDoesNotExist === void 0) { createIfDoesNotExist = true; }
	        if (createIfDoesNotExist) {
	            return this.getOrCreateFilterWrapper(column, source).filterPromise;
	        }
	        var filterWrapper = this.cachedFilter(column);
	        return filterWrapper ? filterWrapper.filterPromise : null;
	    };
	    FilterManager.prototype.isFilterActive = function (column) {
	        var filterWrapper = this.cachedFilter(column);
	        return !!filterWrapper && filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); });
	    };
	    FilterManager.prototype.getOrCreateFilterWrapper = function (column, source) {
	        var filterWrapper = this.cachedFilter(column);
	        if (!filterWrapper) {
	            filterWrapper = this.createFilterWrapper(column, source);
	            this.allAdvancedFilters.set(column.getColId(), filterWrapper);
	        }
	        else if (source !== 'NO_UI') {
	            this.putIntoGui(filterWrapper, source);
	        }
	        return filterWrapper;
	    };
	    FilterManager.prototype.cachedFilter = function (column) {
	        return this.allAdvancedFilters.get(column.getColId());
	    };
	    FilterManager.prototype.createFilterInstance = function (column, $scope) {
	        var _this = this;
	        var defaultFilter = ModuleRegistry.isRegistered(exports.ModuleNames.SetFilterModule) ? 'agSetColumnFilter' : 'agTextColumnFilter';
	        var colDef = column.getColDef();
	        var filterInstance;
	        var params = __assign$6(__assign$6({}, this.createFilterParams(column, colDef, $scope)), { filterModifiedCallback: function () {
	                var event = {
	                    type: Events.EVENT_FILTER_MODIFIED,
	                    api: _this.gridApi,
	                    columnApi: _this.columnApi,
	                    column: column,
	                    filterInstance: filterInstance
	                };
	                _this.eventService.dispatchEvent(event);
	            }, filterChangedCallback: function (additionalEventAttributes) {
	                return _this.onFilterChanged(filterInstance, additionalEventAttributes);
	            }, doesRowPassOtherFilter: function (node) { return _this.doesRowPassOtherFilters(filterInstance, node); } });
	        var res = this.userComponentFactory.newFilterComponent(colDef, params, defaultFilter);
	        if (res) {
	            res.then(function (r) { return filterInstance = r; });
	        }
	        return res;
	    };
	    FilterManager.prototype.createFilterParams = function (column, colDef, $scope) {
	        if ($scope === void 0) { $scope = null; }
	        var params = {
	            api: this.gridOptionsWrapper.getApi(),
	            column: column,
	            colDef: cloneObject(colDef),
	            rowModel: this.rowModel,
	            filterChangedCallback: function () { },
	            filterModifiedCallback: function () { },
	            valueGetter: this.createValueGetter(column),
	            context: this.gridOptionsWrapper.getContext(),
	            doesRowPassOtherFilter: function () { return true; },
	        };
	        // hack in scope if using AngularJS
	        if ($scope) {
	            params.$scope = $scope;
	        }
	        return params;
	    };
	    FilterManager.prototype.createFilterWrapper = function (column, source) {
	        var filterWrapper = {
	            column: column,
	            filterPromise: null,
	            scope: null,
	            compiledElement: null,
	            guiPromise: AgPromise.resolve(null)
	        };
	        filterWrapper.scope = this.gridOptionsWrapper.isAngularCompileFilters() ? this.$scope.$new() : null;
	        filterWrapper.filterPromise = this.createFilterInstance(column, filterWrapper.scope);
	        if (filterWrapper.filterPromise) {
	            this.putIntoGui(filterWrapper, source);
	        }
	        return filterWrapper;
	    };
	    FilterManager.prototype.putIntoGui = function (filterWrapper, source) {
	        var _this = this;
	        var eFilterGui = document.createElement('div');
	        eFilterGui.className = 'ag-filter';
	        filterWrapper.guiPromise = new AgPromise(function (resolve) {
	            filterWrapper.filterPromise.then(function (filter) {
	                var guiFromFilter = filter.getGui();
	                if (!exists(guiFromFilter)) {
	                    console.warn("getGui method from filter returned " + guiFromFilter + ", it should be a DOM element or an HTML template string.");
	                }
	                // for backwards compatibility with Angular 1 - we
	                // used to allow providing back HTML from getGui().
	                // once we move away from supporting Angular 1
	                // directly, we can change this.
	                if (typeof guiFromFilter === 'string') {
	                    guiFromFilter = loadTemplate(guiFromFilter);
	                }
	                eFilterGui.appendChild(guiFromFilter);
	                if (filterWrapper.scope) {
	                    var compiledElement = _this.$compile(eFilterGui)(filterWrapper.scope);
	                    filterWrapper.compiledElement = compiledElement;
	                    window.setTimeout(function () { return filterWrapper.scope.$apply(); }, 0);
	                }
	                resolve(eFilterGui);
	                _this.eventService.dispatchEvent({
	                    type: Events.EVENT_FILTER_OPENED,
	                    column: filterWrapper.column,
	                    source: source,
	                    eGui: eFilterGui,
	                    api: _this.gridApi,
	                    columnApi: _this.columnApi
	                });
	            });
	        });
	    };
	    FilterManager.prototype.onNewColumnsLoaded = function () {
	        var _this = this;
	        var atLeastOneFilterGone = false;
	        this.allAdvancedFilters.forEach(function (filterWrapper) {
	            var oldColumn = !_this.columnController.getPrimaryColumn(filterWrapper.column);
	            if (oldColumn) {
	                atLeastOneFilterGone = true;
	                _this.disposeFilterWrapper(filterWrapper, 'filterDestroyed');
	            }
	        });
	        if (atLeastOneFilterGone) {
	            this.onFilterChanged();
	        }
	    };
	    // destroys the filter, so it not longer takes part
	    FilterManager.prototype.destroyFilter = function (column, source) {
	        if (source === void 0) { source = 'api'; }
	        var filterWrapper = this.allAdvancedFilters.get(column.getColId());
	        if (filterWrapper) {
	            this.disposeFilterWrapper(filterWrapper, source);
	            this.onFilterChanged();
	        }
	    };
	    FilterManager.prototype.disposeFilterWrapper = function (filterWrapper, source) {
	        var _this = this;
	        filterWrapper.filterPromise.then(function (filter) {
	            (filter.setModel(null) || AgPromise.resolve()).then(function () {
	                _this.getContext().destroyBean(filter);
	                filterWrapper.column.setFilterActive(false, source);
	                if (filterWrapper.scope) {
	                    if (filterWrapper.compiledElement) {
	                        filterWrapper.compiledElement.remove();
	                    }
	                    filterWrapper.scope.$destroy();
	                }
	                _this.allAdvancedFilters.delete(filterWrapper.column.getColId());
	            });
	        });
	    };
	    FilterManager.prototype.destroy = function () {
	        var _this = this;
	        _super.prototype.destroy.call(this);
	        this.allAdvancedFilters.forEach(function (filterWrapper) { return _this.disposeFilterWrapper(filterWrapper, 'filterDestroyed'); });
	    };
	    var FilterManager_1;
	    FilterManager.QUICK_FILTER_SEPARATOR = '\n';
	    __decorate$V([
	        Autowired('$compile')
	    ], FilterManager.prototype, "$compile", void 0);
	    __decorate$V([
	        Autowired('$scope')
	    ], FilterManager.prototype, "$scope", void 0);
	    __decorate$V([
	        Autowired('valueService')
	    ], FilterManager.prototype, "valueService", void 0);
	    __decorate$V([
	        Autowired('columnController')
	    ], FilterManager.prototype, "columnController", void 0);
	    __decorate$V([
	        Autowired('rowModel')
	    ], FilterManager.prototype, "rowModel", void 0);
	    __decorate$V([
	        Autowired('columnApi')
	    ], FilterManager.prototype, "columnApi", void 0);
	    __decorate$V([
	        Autowired('gridApi')
	    ], FilterManager.prototype, "gridApi", void 0);
	    __decorate$V([
	        Autowired('userComponentFactory')
	    ], FilterManager.prototype, "userComponentFactory", void 0);
	    __decorate$V([
	        PostConstruct
	    ], FilterManager.prototype, "init", null);
	    __decorate$V([
	        PreDestroy
	    ], FilterManager.prototype, "destroy", null);
	    FilterManager = FilterManager_1 = __decorate$V([
	        Bean('filterManager')
	    ], FilterManager);
	    return FilterManager;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$11 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$W = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ValueService = /** @class */ (function (_super) {
	    __extends$11(ValueService, _super);
	    function ValueService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.initialised = false;
	        return _this;
	    }
	    ValueService.prototype.init = function () {
	        this.cellExpressions = this.gridOptionsWrapper.isEnableCellExpressions();
	        this.initialised = true;
	    };
	    ValueService.prototype.getValue = function (column, rowNode, forFilter, ignoreAggData) {
	        if (forFilter === void 0) { forFilter = false; }
	        if (ignoreAggData === void 0) { ignoreAggData = false; }
	        // hack - the grid is getting refreshed before this bean gets initialised, race condition.
	        // really should have a way so they get initialised in the right order???
	        if (!this.initialised) {
	            this.init();
	        }
	        if (!rowNode) {
	            return;
	        }
	        // pull these out to make code below easier to read
	        var colDef = column.getColDef();
	        var field = colDef.field;
	        var colId = column.getId();
	        var data = rowNode.data;
	        var result;
	        // if there is a value getter, this gets precedence over a field
	        var groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== undefined;
	        var aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== undefined;
	        if (forFilter && colDef.filterValueGetter) {
	            result = this.executeFilterValueGetter(colDef.filterValueGetter, data, column, rowNode);
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && aggDataExists) {
	            result = rowNode.aggData[colId];
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && colDef.valueGetter) {
	            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && (field && data)) {
	            result = getValueUsingField(data, field, column.isFieldContainsDots());
	        }
	        else if (groupDataExists) {
	            result = rowNode.groupData[colId];
	        }
	        else if (aggDataExists) {
	            result = rowNode.aggData[colId];
	        }
	        else if (colDef.valueGetter) {
	            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
	        }
	        else if (field && data) {
	            result = getValueUsingField(data, field, column.isFieldContainsDots());
	        }
	        // the result could be an expression itself, if we are allowing cell values to be expressions
	        if (this.cellExpressions && (typeof result === 'string') && result.indexOf('=') === 0) {
	            var cellValueGetter = result.substring(1);
	            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
	        }
	        if (result == null) {
	            var openedGroup = this.getOpenedGroup(rowNode, column);
	            if (openedGroup != null) {
	                return openedGroup;
	            }
	        }
	        return result;
	    };
	    ValueService.prototype.getOpenedGroup = function (rowNode, column) {
	        if (!this.gridOptionsWrapper.isShowOpenedGroup()) {
	            return;
	        }
	        var colDef = column.getColDef();
	        if (!colDef.showRowGroup) {
	            return;
	        }
	        var showRowGroup = column.getColDef().showRowGroup;
	        var pointer = rowNode.parent;
	        while (pointer != null) {
	            if (pointer.rowGroupColumn && (showRowGroup === true || showRowGroup === pointer.rowGroupColumn.getId())) {
	                return pointer.key;
	            }
	            pointer = pointer.parent;
	        }
	        return undefined;
	    };
	    ValueService.prototype.setValue = function (rowNode, colKey, newValue, eventSource) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        if (!rowNode || !column) {
	            return;
	        }
	        // this will only happen if user is trying to paste into a group row, which doesn't make sense
	        // the user should not be trying to paste into group rows
	        if (missing(rowNode.data)) {
	            rowNode.data = {};
	        }
	        // for backwards compatibility we are also retrieving the newValueHandler as well as the valueSetter
	        var _a = column.getColDef(), field = _a.field, newValueHandler = _a.newValueHandler, valueSetter = _a.valueSetter;
	        // need either a field or a newValueHandler for this to work
	        if (missing(field) && missing(newValueHandler) && missing(valueSetter)) {
	            // we don't tell user about newValueHandler, as that is deprecated
	            console.warn("AG Grid: you need either field or valueSetter set on colDef for editing to work");
	            return;
	        }
	        var params = {
	            node: rowNode,
	            data: rowNode.data,
	            oldValue: this.getValue(column, rowNode),
	            newValue: newValue,
	            colDef: column.getColDef(),
	            column: column,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext()
	        };
	        params.newValue = newValue;
	        var valueWasDifferent;
	        if (newValueHandler && exists(newValueHandler)) {
	            valueWasDifferent = newValueHandler(params);
	        }
	        else if (exists(valueSetter)) {
	            valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
	        }
	        else {
	            valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
	        }
	        // in case user forgot to return something (possible if they are not using TypeScript
	        // and just forgot, or using an old newValueHandler we didn't always expect a return
	        // value here), we default the return value to true, so we always refresh.
	        if (valueWasDifferent === undefined) {
	            valueWasDifferent = true;
	        }
	        // if no change to the value, then no need to do the updating, or notifying via events.
	        // otherwise the user could be tabbing around the grid, and cellValueChange would get called
	        // all the time.
	        if (!valueWasDifferent) {
	            return;
	        }
	        // reset quick filter on this row
	        rowNode.resetQuickFilterAggregateText();
	        this.valueCache.onDataChanged();
	        params.newValue = this.getValue(column, rowNode);
	        var onCellValueChanged = column.getColDef().onCellValueChanged;
	        if (typeof onCellValueChanged === 'function') {
	            // to make callback async, do in a timeout
	            setTimeout(function () { return onCellValueChanged(params); }, 0);
	        }
	        var event = {
	            type: Events.EVENT_CELL_VALUE_CHANGED,
	            event: null,
	            rowIndex: rowNode.rowIndex,
	            rowPinned: rowNode.rowPinned,
	            column: params.column,
	            api: params.api,
	            columnApi: params.columnApi,
	            colDef: params.colDef,
	            context: params.context,
	            data: rowNode.data,
	            node: rowNode,
	            oldValue: params.oldValue,
	            newValue: params.newValue,
	            value: params.newValue,
	            source: eventSource
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ValueService.prototype.setValueUsingField = function (data, field, newValue, isFieldContainsDots) {
	        if (!field) {
	            return false;
	        }
	        // if no '.', then it's not a deep value
	        var valuesAreSame = false;
	        if (!isFieldContainsDots) {
	            data[field] = newValue;
	        }
	        else {
	            // otherwise it is a deep value, so need to dig for it
	            var fieldPieces = field.split('.');
	            var currentObject = data;
	            while (fieldPieces.length > 0 && currentObject) {
	                var fieldPiece = fieldPieces.shift();
	                if (fieldPieces.length === 0) {
	                    currentObject[fieldPiece] = newValue;
	                }
	                else {
	                    currentObject = currentObject[fieldPiece];
	                }
	            }
	        }
	        return !valuesAreSame;
	    };
	    ValueService.prototype.executeFilterValueGetter = function (valueGetter, data, column, rowNode) {
	        var params = {
	            data: data,
	            node: rowNode,
	            column: column,
	            colDef: column.getColDef(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext(),
	            getValue: this.getValueCallback.bind(this, rowNode)
	        };
	        return this.expressionService.evaluate(valueGetter, params);
	    };
	    ValueService.prototype.executeValueGetter = function (valueGetter, data, column, rowNode) {
	        var colId = column.getId();
	        // if inside the same turn, just return back the value we got last time
	        var valueFromCache = this.valueCache.getValue(rowNode, colId);
	        if (valueFromCache !== undefined) {
	            return valueFromCache;
	        }
	        var params = {
	            data: data,
	            node: rowNode,
	            column: column,
	            colDef: column.getColDef(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext(),
	            getValue: this.getValueCallback.bind(this, rowNode)
	        };
	        var result = this.expressionService.evaluate(valueGetter, params);
	        // if a turn is active, store the value in case the grid asks for it again
	        this.valueCache.setValue(rowNode, colId, result);
	        return result;
	    };
	    ValueService.prototype.getValueCallback = function (node, field) {
	        var otherColumn = this.columnController.getPrimaryColumn(field);
	        if (otherColumn) {
	            return this.getValue(otherColumn, node);
	        }
	        return null;
	    };
	    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
	    ValueService.prototype.getKeyForNode = function (col, rowNode) {
	        var value = this.getValue(col, rowNode);
	        var keyCreator = col.getColDef().keyCreator;
	        var result = keyCreator ? keyCreator({ value: value }) : value;
	        // if already a string, or missing, just return it
	        if (typeof result === 'string' || result == null) {
	            return result;
	        }
	        result = String(result);
	        if (result === '[object Object]') {
	            doOnce(function () {
	                console.warn('AG Grid: a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key');
	            }, 'getKeyForNode - warn about [object,object]');
	        }
	        return result;
	    };
	    __decorate$W([
	        Autowired('expressionService')
	    ], ValueService.prototype, "expressionService", void 0);
	    __decorate$W([
	        Autowired('columnController')
	    ], ValueService.prototype, "columnController", void 0);
	    __decorate$W([
	        Autowired('valueCache')
	    ], ValueService.prototype, "valueCache", void 0);
	    __decorate$W([
	        PostConstruct
	    ], ValueService.prototype, "init", null);
	    ValueService = __decorate$W([
	        Bean('valueService')
	    ], ValueService);
	    return ValueService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$12 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$X = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	(function (LayoutCssClasses) {
	    LayoutCssClasses["AUTO_HEIGHT"] = "ag-layout-auto-height";
	    LayoutCssClasses["NORMAL"] = "ag-layout-normal";
	    LayoutCssClasses["PRINT"] = "ag-layout-print";
	})(exports.LayoutCssClasses || (exports.LayoutCssClasses = {}));
	var LayoutFeature = /** @class */ (function (_super) {
	    __extends$12(LayoutFeature, _super);
	    function LayoutFeature(view) {
	        var _this = _super.call(this) || this;
	        _this.view = view;
	        return _this;
	    }
	    LayoutFeature.prototype.postConstruct = function () {
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, this.updateLayoutClasses.bind(this));
	        this.updateLayoutClasses();
	    };
	    LayoutFeature.prototype.updateLayoutClasses = function () {
	        var domLayout = this.gridOptionsWrapper.getDomLayout();
	        this.view.updateLayoutClasses({
	            autoHeight: domLayout === Constants.DOM_LAYOUT_AUTO_HEIGHT,
	            normal: domLayout === Constants.DOM_LAYOUT_NORMAL,
	            print: domLayout === Constants.DOM_LAYOUT_PRINT
	        });
	    };
	    __decorate$X([
	        Autowired('gridOptionsWrapper')
	    ], LayoutFeature.prototype, "gridOptionsWrapper", void 0);
	    __decorate$X([
	        PostConstruct
	    ], LayoutFeature.prototype, "postConstruct", null);
	    return LayoutFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$13 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$Y = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var GridBodyScrollFeature = /** @class */ (function (_super) {
	    __extends$13(GridBodyScrollFeature, _super);
	    function GridBodyScrollFeature(eBodyViewport) {
	        var _this = _super.call(this) || this;
	        _this.scrollLeft = -1;
	        _this.nextScrollTop = -1;
	        _this.scrollTop = -1;
	        _this.eBodyViewport = eBodyViewport;
	        _this.resetLastHorizontalScrollElementDebounced = debounce(_this.resetLastHorizontalScrollElement.bind(_this), 500);
	        return _this;
	    }
	    GridBodyScrollFeature.prototype.postConstruct = function () {
	        var _this = this;
	        this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
	        this.controllersService.whenReady(function (p) {
	            _this.centerRowContainerCon = p.centerRowContainerCon;
	            _this.onDisplayedColumnsWidthChanged();
	            _this.addScrollListener();
	        });
	    };
	    GridBodyScrollFeature.prototype.addScrollListener = function () {
	        var fakeHScroll = this.controllersService.getFakeHScrollCon();
	        this.addManagedListener(this.centerRowContainerCon.getViewportElement(), 'scroll', this.onCenterViewportScroll.bind(this));
	        this.addManagedListener(fakeHScroll.getViewport(), 'scroll', this.onFakeHorizontalScroll.bind(this));
	        var onVerticalScroll = this.gridOptionsWrapper.isDebounceVerticalScrollbar() ?
	            debounce(this.onVerticalScroll.bind(this), 100)
	            : this.onVerticalScroll.bind(this);
	        this.addManagedListener(this.eBodyViewport, 'scroll', onVerticalScroll);
	    };
	    GridBodyScrollFeature.prototype.onDisplayedColumnsWidthChanged = function () {
	        if (this.enableRtl) {
	            // because RTL is all backwards, a change in the width of the row
	            // can cause a change in the scroll position, without a scroll event,
	            // because the scroll position in RTL is a function that depends on
	            // the width. to be convinced of this, take out this line, enable RTL,
	            // scroll all the way to the left and then resize a column
	            this.horizontallyScrollHeaderCenterAndFloatingCenter();
	        }
	    };
	    GridBodyScrollFeature.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function (scrollLeft) {
	        if (scrollLeft === undefined) {
	            scrollLeft = this.centerRowContainerCon.getCenterViewportScrollLeft();
	        }
	        var offset = this.enableRtl ? scrollLeft : -scrollLeft;
	        var topCenterContainer = this.controllersService.getTopCenterRowContainerCon();
	        var bottomCenterContainer = this.controllersService.getBottomCenterRowContainerCon();
	        var headerRootComp = this.controllersService.getHeaderRootComp();
	        var fakeHScroll = this.controllersService.getFakeHScrollCon();
	        headerRootComp.setHorizontalScroll(offset);
	        bottomCenterContainer.setContainerTranslateX(offset);
	        topCenterContainer.setContainerTranslateX(offset);
	        var partner = this.lastHorizontalScrollElement === this.centerRowContainerCon.getViewportElement() ?
	            fakeHScroll.getViewport() : this.centerRowContainerCon.getViewportElement();
	        setScrollLeft(partner, Math.abs(scrollLeft), this.enableRtl);
	    };
	    GridBodyScrollFeature.prototype.isControllingScroll = function (eDiv) {
	        if (!this.lastHorizontalScrollElement) {
	            this.lastHorizontalScrollElement = eDiv;
	            return true;
	        }
	        return eDiv === this.lastHorizontalScrollElement;
	    };
	    GridBodyScrollFeature.prototype.onFakeHorizontalScroll = function () {
	        var fakeHScrollViewport = this.controllersService.getFakeHScrollCon().getViewport();
	        if (!this.isControllingScroll(fakeHScrollViewport)) {
	            return;
	        }
	        this.onBodyHorizontalScroll(fakeHScrollViewport);
	    };
	    GridBodyScrollFeature.prototype.onCenterViewportScroll = function () {
	        var centerContainerViewport = this.centerRowContainerCon.getViewportElement();
	        if (!this.isControllingScroll(centerContainerViewport)) {
	            return;
	        }
	        this.onBodyHorizontalScroll(centerContainerViewport);
	    };
	    GridBodyScrollFeature.prototype.onBodyHorizontalScroll = function (eSource) {
	        var centerContainerViewport = this.centerRowContainerCon.getViewportElement();
	        var scrollLeft = centerContainerViewport.scrollLeft;
	        if (this.shouldBlockScrollUpdate('horizontal', scrollLeft, true)) {
	            return;
	        }
	        // we do Math.round() rather than Math.floor(), to mirror how scroll values are applied.
	        // eg if a scale is applied (ie user has zoomed the browser), then applying scroll=200
	        // could result in 199.88, which then floor(199.88) = 199, however round(199.88) = 200.
	        // initially Math.floor() was used, however this caused (almost) infinite loop with aligned grids,
	        // as the scroll would move 1px at at time bouncing from one grid to the next (eg one grid would cause
	        // scroll to 200px, the next to 199px, then the first back to 198px and so on).
	        this.doHorizontalScroll(Math.round(getScrollLeft(eSource, this.enableRtl)));
	        this.resetLastHorizontalScrollElementDebounced();
	    };
	    GridBodyScrollFeature.prototype.onVerticalScroll = function () {
	        var scrollTop = this.eBodyViewport.scrollTop;
	        if (this.shouldBlockScrollUpdate('vertical', scrollTop, true)) {
	            return;
	        }
	        this.animationFrameService.setScrollTop(scrollTop);
	        this.nextScrollTop = scrollTop;
	        if (this.gridOptionsWrapper.isSuppressAnimationFrame()) {
	            this.scrollTop = this.nextScrollTop;
	            this.redrawRowsAfterScroll();
	        }
	        else {
	            this.animationFrameService.schedule();
	        }
	    };
	    GridBodyScrollFeature.prototype.resetLastHorizontalScrollElement = function () {
	        this.lastHorizontalScrollElement = null;
	    };
	    GridBodyScrollFeature.prototype.doHorizontalScroll = function (scrollLeft) {
	        this.scrollLeft = scrollLeft;
	        var event = {
	            type: Events.EVENT_BODY_SCROLL,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            direction: 'horizontal',
	            left: this.scrollLeft,
	            top: this.scrollTop
	        };
	        this.eventService.dispatchEvent(event);
	        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
	        this.onHorizontalViewportChanged();
	    };
	    GridBodyScrollFeature.prototype.shouldBlockScrollUpdate = function (direction, scrollTo, touchOnly) {
	        // touch devices allow elastic scroll - which temporally scrolls the panel outside of the viewport
	        // (eg user uses touch to go to the left of the grid, but drags past the left, the rows will actually
	        // scroll past the left until the user releases the mouse). when this happens, we want ignore the scroll,
	        // as otherwise it was causing the rows and header to flicker.
	        if (touchOnly === void 0) { touchOnly = false; }
	        // sometimes when scrolling, we got values that extended the maximum scroll allowed. we used to
	        // ignore these scrolls. problem is the max scroll position could be skipped (eg the previous scroll event
	        // could be 10px before the max position, and then current scroll event could be 20px after the max position).
	        // if we just ignored the last event, we would be setting the scroll to 10px before the max position, when in
	        // actual fact the user has exceeded the max scroll and thus scroll should be set to the max.
	        if (touchOnly && !isIOSUserAgent()) {
	            return false;
	        }
	        if (direction === 'vertical') {
	            var clientHeight = getInnerHeight(this.eBodyViewport);
	            var scrollHeight = this.eBodyViewport.scrollHeight;
	            if (scrollTo < 0 || (scrollTo + clientHeight > scrollHeight)) {
	                return true;
	            }
	        }
	        if (direction === 'horizontal') {
	            var clientWidth = this.centerRowContainerCon.getCenterWidth();
	            var scrollWidth = this.centerRowContainerCon.getViewportElement().scrollWidth;
	            if (this.enableRtl && isRtlNegativeScroll()) {
	                if (scrollTo > 0) {
	                    return true;
	                }
	            }
	            else if (scrollTo < 0) {
	                return true;
	            }
	            if (Math.abs(scrollTo) + clientWidth > scrollWidth) {
	                return true;
	            }
	        }
	        return false;
	    };
	    GridBodyScrollFeature.prototype.redrawRowsAfterScroll = function () {
	        var event = {
	            type: Events.EVENT_BODY_SCROLL,
	            direction: 'vertical',
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            left: this.scrollLeft,
	            top: this.scrollTop
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    GridBodyScrollFeature.prototype.onHorizontalViewportChanged = function () {
	        this.centerRowContainerCon.onHorizontalViewportChanged();
	    };
	    // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
	    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
	    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
	    // back to the left to be kept in sync.
	    // adding and removing the grid from the DOM both resets the scroll position and
	    // triggers a resize event, so notify listeners if the scroll position has changed
	    GridBodyScrollFeature.prototype.checkScrollLeft = function () {
	        if (this.scrollLeft !== this.centerRowContainerCon.getCenterViewportScrollLeft()) {
	            this.onBodyHorizontalScroll(this.centerRowContainerCon.getViewportElement());
	        }
	    };
	    GridBodyScrollFeature.prototype.executeAnimationFrameScroll = function () {
	        var frameNeeded = this.scrollTop != this.nextScrollTop;
	        if (frameNeeded) {
	            this.scrollTop = this.nextScrollTop;
	            this.redrawRowsAfterScroll();
	        }
	        return frameNeeded;
	    };
	    // called by scrollHorizontally method and alignedGridsService
	    GridBodyScrollFeature.prototype.setHorizontalScrollPosition = function (hScrollPosition) {
	        var minScrollLeft = 0;
	        var maxScrollLeft = this.centerRowContainerCon.getViewportElement().scrollWidth - this.centerRowContainerCon.getCenterWidth();
	        if (this.shouldBlockScrollUpdate('horizontal', hScrollPosition)) {
	            if (this.enableRtl && isRtlNegativeScroll()) {
	                hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
	            }
	            else {
	                hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
	            }
	        }
	        setScrollLeft(this.centerRowContainerCon.getViewportElement(), Math.abs(hScrollPosition), this.enableRtl);
	        // we need to manually do the event handling (rather than wait for the event)
	        // for the alignedGridsService, as if we don't, the aligned grid service gets
	        // notified async, and then it's 'consuming' flag doesn't get used right, and
	        // we can end up with an infinite loop
	        this.doHorizontalScroll(hScrollPosition);
	    };
	    GridBodyScrollFeature.prototype.setVerticalScrollPosition = function (vScrollPosition) {
	        this.eBodyViewport.scrollTop = vScrollPosition;
	    };
	    GridBodyScrollFeature.prototype.getVScrollPosition = function () {
	        var result = {
	            top: this.eBodyViewport.scrollTop,
	            bottom: this.eBodyViewport.scrollTop + this.eBodyViewport.offsetHeight
	        };
	        return result;
	    };
	    GridBodyScrollFeature.prototype.getHScrollPosition = function () {
	        return this.centerRowContainerCon.getHScrollPosition();
	    };
	    GridBodyScrollFeature.prototype.isHorizontalScrollShowing = function () {
	        return this.centerRowContainerCon.isHorizontalScrollShowing();
	    };
	    // called by the headerRootComp and moveColumnController
	    GridBodyScrollFeature.prototype.scrollHorizontally = function (pixels) {
	        var oldScrollPosition = this.centerRowContainerCon.getViewportElement().scrollLeft;
	        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
	        return this.centerRowContainerCon.getViewportElement().scrollLeft - oldScrollPosition;
	    };
	    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
	    GridBodyScrollFeature.prototype.scrollToTop = function () {
	        this.eBodyViewport.scrollTop = 0;
	    };
	    // Valid values for position are bottom, middle and top
	    GridBodyScrollFeature.prototype.ensureNodeVisible = function (comparator, position) {
	        if (position === void 0) { position = null; }
	        // look for the node index we want to display
	        var rowCount = this.rowModel.getRowCount();
	        var comparatorIsAFunction = typeof comparator === 'function';
	        var indexToSelect = -1;
	        // go through all the nodes, find the one we want to show
	        for (var i = 0; i < rowCount; i++) {
	            var node = this.rowModel.getRow(i);
	            if (comparatorIsAFunction) {
	                if (comparator(node)) {
	                    indexToSelect = i;
	                    break;
	                }
	            }
	            else {
	                // check object equality against node and data
	                if (comparator === node || comparator === node.data) {
	                    indexToSelect = i;
	                    break;
	                }
	            }
	        }
	        if (indexToSelect >= 0) {
	            this.ensureIndexVisible(indexToSelect, position);
	        }
	    };
	    // Valid values for position are bottom, middle and top
	    // position should be {'top','middle','bottom', or undefined/null}.
	    // if undefined/null, then the grid will to the minimal amount of scrolling,
	    // eg if grid needs to scroll up, it scrolls until row is on top,
	    //    if grid needs to scroll down, it scrolls until row is on bottom,
	    //    if row is already in view, grid does not scroll
	    GridBodyScrollFeature.prototype.ensureIndexVisible = function (index, position) {
	        // if for print or auto height, everything is always visible
	        if (this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT) {
	            return;
	        }
	        var rowCount = this.paginationProxy.getRowCount();
	        if (typeof index !== 'number' || index < 0 || index >= rowCount) {
	            console.warn('invalid row index for ensureIndexVisible: ' + index);
	            return;
	        }
	        var isPaging = this.gridOptionsWrapper.isPagination();
	        var paginationPanelEnabled = isPaging && !this.gridOptionsWrapper.isSuppressPaginationPanel();
	        if (!paginationPanelEnabled) {
	            this.paginationProxy.goToPageWithIndex(index);
	        }
	        var rowNode = this.paginationProxy.getRow(index);
	        var rowGotShiftedDuringOperation;
	        do {
	            var startingRowTop = rowNode.rowTop;
	            var startingRowHeight = rowNode.rowHeight;
	            var paginationOffset = this.paginationProxy.getPixelOffset();
	            var rowTopPixel = rowNode.rowTop - paginationOffset;
	            var rowBottomPixel = rowTopPixel + rowNode.rowHeight;
	            var scrollPosition = this.getVScrollPosition();
	            var heightOffset = this.heightScaler.getDivStretchOffset();
	            var vScrollTop = scrollPosition.top + heightOffset;
	            var vScrollBottom = scrollPosition.bottom + heightOffset;
	            var viewportHeight = vScrollBottom - vScrollTop;
	            // work out the pixels for top, middle and bottom up front,
	            // make the if/else below easier to read
	            var pxTop = this.heightScaler.getScrollPositionForPixel(rowTopPixel);
	            var pxBottom = this.heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
	            // make sure if middle, the row is not outside the top of the grid
	            var pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
	            var rowBelowViewport = vScrollTop > rowTopPixel;
	            var rowAboveViewport = vScrollBottom < rowBottomPixel;
	            var newScrollPosition = null;
	            if (position === 'top') {
	                newScrollPosition = pxTop;
	            }
	            else if (position === 'bottom') {
	                newScrollPosition = pxBottom;
	            }
	            else if (position === 'middle') {
	                newScrollPosition = pxMiddle;
	            }
	            else if (rowBelowViewport) {
	                // if row is before, scroll up with row at top
	                newScrollPosition = pxTop;
	            }
	            else if (rowAboveViewport) {
	                // if row is below, scroll down with row at bottom
	                newScrollPosition = pxBottom;
	            }
	            if (newScrollPosition !== null) {
	                this.eBodyViewport.scrollTop = newScrollPosition;
	                this.rowRenderer.redrawAfterScroll();
	            }
	            // the row can get shifted if during the rendering (during rowRenderer.redrawAfterScroll()),
	            // the height of a row changes due to lazy calculation of row heights when using
	            // colDef.autoHeight or gridOptions.getRowHeight.
	            // if row was shifted, then the position we scrolled to is incorrect.
	            rowGotShiftedDuringOperation = (startingRowTop !== rowNode.rowTop)
	                || (startingRowHeight !== rowNode.rowHeight);
	        } while (rowGotShiftedDuringOperation);
	        // so when we return back to user, the cells have rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    GridBodyScrollFeature.prototype.ensureColumnVisible = function (key) {
	        var column = this.columnController.getGridColumn(key);
	        if (!column) {
	            return;
	        }
	        if (column.isPinned()) {
	            console.warn('calling ensureIndexVisible on a ' + column.getPinned() + ' pinned column doesn\'t make sense for column ' + column.getColId());
	            return;
	        }
	        if (!this.columnController.isColumnDisplayed(column)) {
	            console.warn('column is not currently visible');
	            return;
	        }
	        var colLeftPixel = column.getLeft();
	        var colRightPixel = colLeftPixel + column.getActualWidth();
	        var viewportWidth = this.centerRowContainerCon.getCenterWidth();
	        var scrollPosition = this.centerRowContainerCon.getCenterViewportScrollLeft();
	        var bodyWidth = this.columnController.getBodyContainerWidth();
	        var viewportLeftPixel;
	        var viewportRightPixel;
	        // the logic of working out left and right viewport px is both here and in the ColumnController,
	        // need to refactor it out to one place
	        if (this.enableRtl) {
	            viewportLeftPixel = bodyWidth - scrollPosition - viewportWidth;
	            viewportRightPixel = bodyWidth - scrollPosition;
	        }
	        else {
	            viewportLeftPixel = scrollPosition;
	            viewportRightPixel = viewportWidth + scrollPosition;
	        }
	        var viewportScrolledPastCol = viewportLeftPixel > colLeftPixel;
	        var viewportScrolledBeforeCol = viewportRightPixel < colRightPixel;
	        var colToSmallForViewport = viewportWidth < column.getActualWidth();
	        var alignColToLeft = viewportScrolledPastCol || colToSmallForViewport;
	        var alignColToRight = viewportScrolledBeforeCol;
	        if (alignColToLeft || alignColToRight) {
	            var newScrollPosition = void 0;
	            if (this.enableRtl) {
	                newScrollPosition = alignColToLeft ? (bodyWidth - viewportWidth - colLeftPixel) : (bodyWidth - colRightPixel);
	            }
	            else {
	                newScrollPosition = alignColToLeft ? colLeftPixel : (colRightPixel - viewportWidth);
	            }
	            this.centerRowContainerCon.setCenterViewportScrollLeft(newScrollPosition);
	        }
	        // this will happen anyway, as the move will cause a 'scroll' event on the body, however
	        // it is possible that the ensureColumnVisible method is called from within AG Grid and
	        // the caller will need to have the columns rendered to continue, which will be before
	        // the event has been worked on (which is the case for cell navigation).
	        this.centerRowContainerCon.onHorizontalViewportChanged();
	        // so when we return back to user, the cells have rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    __decorate$Y([
	        Autowired('controllersService')
	    ], GridBodyScrollFeature.prototype, "controllersService", void 0);
	    __decorate$Y([
	        Autowired('animationFrameService')
	    ], GridBodyScrollFeature.prototype, "animationFrameService", void 0);
	    __decorate$Y([
	        Autowired('columnApi')
	    ], GridBodyScrollFeature.prototype, "columnApi", void 0);
	    __decorate$Y([
	        Autowired('gridApi')
	    ], GridBodyScrollFeature.prototype, "gridApi", void 0);
	    __decorate$Y([
	        Autowired('paginationProxy')
	    ], GridBodyScrollFeature.prototype, "paginationProxy", void 0);
	    __decorate$Y([
	        Autowired('rowModel')
	    ], GridBodyScrollFeature.prototype, "rowModel", void 0);
	    __decorate$Y([
	        Autowired('rowContainerHeightService')
	    ], GridBodyScrollFeature.prototype, "heightScaler", void 0);
	    __decorate$Y([
	        Autowired('rowRenderer')
	    ], GridBodyScrollFeature.prototype, "rowRenderer", void 0);
	    __decorate$Y([
	        Autowired('columnController')
	    ], GridBodyScrollFeature.prototype, "columnController", void 0);
	    __decorate$Y([
	        PostConstruct
	    ], GridBodyScrollFeature.prototype, "postConstruct", null);
	    return GridBodyScrollFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$14 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign$7 = function () {
	    __assign$7 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$7.apply(this, arguments);
	};
	var __decorate$Z = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __spreadArrays$5 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var RowDragFeature = /** @class */ (function (_super) {
	    __extends$14(RowDragFeature, _super);
	    function RowDragFeature(eContainer) {
	        var _this = _super.call(this) || this;
	        _this.isMultiRowDrag = false;
	        _this.isGridSorted = false;
	        _this.isGridFiltered = false;
	        _this.isRowGroupActive = false;
	        _this.eContainer = eContainer;
	        return _this;
	    }
	    RowDragFeature.prototype.postConstruct = function () {
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            this.clientSideRowModel = this.rowModel;
	        }
	        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
	        this.onSortChanged();
	        this.onFilterChanged();
	        this.onRowGroupChanged();
	    };
	    RowDragFeature.prototype.onSortChanged = function () {
	        this.isGridSorted = this.sortController.isSortActive();
	    };
	    RowDragFeature.prototype.onFilterChanged = function () {
	        this.isGridFiltered = this.filterManager.isAnyFilterPresent();
	    };
	    RowDragFeature.prototype.onRowGroupChanged = function () {
	        var rowGroups = this.columnController.getRowGroupColumns();
	        this.isRowGroupActive = !missingOrEmpty(rowGroups);
	    };
	    RowDragFeature.prototype.getContainer = function () {
	        return this.eContainer;
	    };
	    RowDragFeature.prototype.isInterestedIn = function (type) {
	        return type === exports.DragSourceType.RowDrag;
	    };
	    RowDragFeature.prototype.getIconName = function () {
	        var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
	        if (managedDrag && this.shouldPreventRowMove()) {
	            return DragAndDropService.ICON_NOT_ALLOWED;
	        }
	        return DragAndDropService.ICON_MOVE;
	    };
	    RowDragFeature.prototype.shouldPreventRowMove = function () {
	        return this.isGridSorted || this.isGridFiltered || this.isRowGroupActive;
	    };
	    RowDragFeature.prototype.getRowNodes = function (draggingEvent) {
	        if (!this.isFromThisGrid(draggingEvent)) {
	            return draggingEvent.dragItem.rowNodes || [];
	        }
	        var enableMultiRowDragging = this.gridOptionsWrapper.isEnableMultiRowDragging();
	        var selectedNodes = this.selectionController.getSelectedNodes();
	        var currentNode = draggingEvent.dragItem.rowNode;
	        if (enableMultiRowDragging && selectedNodes.indexOf(currentNode) !== -1) {
	            this.isMultiRowDrag = true;
	            return __spreadArrays$5(selectedNodes);
	        }
	        this.isMultiRowDrag = false;
	        return [currentNode];
	    };
	    RowDragFeature.prototype.onDragEnter = function (draggingEvent) {
	        // when entering, we fire the enter event, then in onEnterOrDragging,
	        // we also fire the move event. so we get both events when entering.
	        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_ENTER, draggingEvent);
	        this.getRowNodes(draggingEvent).forEach(function (rowNode) {
	            rowNode.setDragging(true);
	        });
	        this.onEnterOrDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.onDragging = function (draggingEvent) {
	        this.onEnterOrDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.isFromThisGrid = function (draggingEvent) {
	        var dragSourceDomDataKey = draggingEvent.dragSource.dragSourceDomDataKey;
	        return dragSourceDomDataKey === this.gridOptionsWrapper.getDomDataKey();
	    };
	    RowDragFeature.prototype.isDropZoneWithinThisGrid = function (draggingEvent) {
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var gridGui = gridBodyCon.getGui();
	        var dropZoneTarget = draggingEvent.dropZoneTarget;
	        return !gridGui.contains(dropZoneTarget);
	    };
	    RowDragFeature.prototype.onEnterOrDragging = function (draggingEvent) {
	        // this event is fired for enter and move
	        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_MOVE, draggingEvent);
	        this.lastDraggingEvent = draggingEvent;
	        var pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
	        var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
	        if (managedDrag) {
	            this.doManagedDrag(draggingEvent, pixel);
	        }
	        this.checkCenterForScrolling(pixel);
	    };
	    RowDragFeature.prototype.doManagedDrag = function (draggingEvent, pixel) {
	        var _this = this;
	        var rowNodes;
	        var isFromThisGrid = this.isFromThisGrid(draggingEvent);
	        if (isFromThisGrid) {
	            rowNodes = [draggingEvent.dragItem.rowNode];
	            if (this.isMultiRowDrag) {
	                rowNodes = __spreadArrays$5(this.selectionController.getSelectedNodes()).sort(function (a, b) { return _this.getRowIndexNumber(a) - _this.getRowIndexNumber(b); });
	            }
	            draggingEvent.dragItem.rowNodes = rowNodes;
	        }
	        else {
	            rowNodes = draggingEvent.dragItem.rowNodes;
	        }
	        var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
	        if (managedDrag && this.shouldPreventRowMove()) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isSuppressMoveWhenRowDragging() || !isFromThisGrid) {
	            if (!this.isDropZoneWithinThisGrid(draggingEvent)) {
	                this.clientSideRowModel.highlightRowAtPixel(rowNodes[0], pixel);
	            }
	        }
	        else {
	            this.moveRows(rowNodes, pixel);
	        }
	    };
	    RowDragFeature.prototype.getRowIndexNumber = function (rowNode) {
	        return parseInt(last(rowNode.getRowIndexString().split('-')), 10);
	    };
	    RowDragFeature.prototype.moveRowAndClearHighlight = function (draggingEvent) {
	        var _this = this;
	        var lastHighlightedRowNode = this.clientSideRowModel.getLastHighlightedRowNode();
	        var isBelow = lastHighlightedRowNode && lastHighlightedRowNode.highlighted === 'below';
	        var pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
	        var rowNodes = draggingEvent.dragItem.rowNodes;
	        var increment = isBelow ? 1 : 0;
	        if (this.isFromThisGrid(draggingEvent)) {
	            rowNodes.forEach(function (rowNode) {
	                if (rowNode.rowTop < pixel) {
	                    increment -= 1;
	                }
	            });
	            this.moveRows(rowNodes, pixel, increment);
	        }
	        else {
	            var getRowNodeId_1 = this.gridOptionsWrapper.getRowNodeIdFunc();
	            var addIndex = this.clientSideRowModel.getRowIndexAtPixel(pixel) + 1;
	            if (this.clientSideRowModel.getHighlightPosition(pixel) === 'above') {
	                addIndex--;
	            }
	            this.clientSideRowModel.updateRowData({
	                add: rowNodes
	                    .map(function (node) { return node.data; })
	                    .filter(function (data) { return !_this.clientSideRowModel.getRowNode(getRowNodeId_1 ? getRowNodeId_1(data) : data.id); }),
	                addIndex: addIndex
	            });
	        }
	        this.clearRowHighlight();
	    };
	    RowDragFeature.prototype.clearRowHighlight = function () {
	        this.clientSideRowModel.highlightRowAtPixel(null);
	    };
	    RowDragFeature.prototype.moveRows = function (rowNodes, pixel, increment) {
	        if (increment === void 0) { increment = 0; }
	        var rowWasMoved = this.clientSideRowModel.ensureRowsAtPixel(rowNodes, pixel, increment);
	        if (rowWasMoved) {
	            this.focusController.clearFocusedCell();
	            if (this.rangeController) {
	                this.rangeController.removeAllCellRanges();
	            }
	        }
	    };
	    RowDragFeature.prototype.checkCenterForScrolling = function (pixel) {
	        // scroll if the mouse is within 50px of the grid edge
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var pixelRange = gridBodyCon.getScrollFeature().getVScrollPosition();
	        // console.log(`pixelRange = (${pixelRange.top}, ${pixelRange.bottom})`);
	        this.needToMoveUp = pixel < (pixelRange.top + 50);
	        this.needToMoveDown = pixel > (pixelRange.bottom - 50);
	        // console.log(`needToMoveUp = ${this.needToMoveUp} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
	        // console.log(`needToMoveDown = ${this.needToMoveDown} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
	        if (this.needToMoveUp || this.needToMoveDown) {
	            this.ensureIntervalStarted();
	        }
	        else {
	            this.ensureIntervalCleared();
	        }
	    };
	    RowDragFeature.prototype.ensureIntervalStarted = function () {
	        if (this.movingIntervalId) {
	            return;
	        }
	        this.intervalCount = 0;
	        this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
	    };
	    RowDragFeature.prototype.ensureIntervalCleared = function () {
	        if (!exists(this.movingIntervalId)) {
	            return;
	        }
	        window.clearInterval(this.movingIntervalId);
	        this.movingIntervalId = null;
	    };
	    RowDragFeature.prototype.moveInterval = function () {
	        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
	        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
	        var pixelsToMove;
	        this.intervalCount++;
	        pixelsToMove = 10 + (this.intervalCount * 5);
	        if (pixelsToMove > 100) {
	            pixelsToMove = 100;
	        }
	        var pixelsMoved = null;
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        if (this.needToMoveDown) {
	            pixelsMoved = gridBodyCon.scrollVertically(pixelsToMove);
	        }
	        else if (this.needToMoveUp) {
	            pixelsMoved = gridBodyCon.scrollVertically(-pixelsToMove);
	        }
	        if (pixelsMoved !== 0) {
	            this.onDragging(this.lastDraggingEvent);
	        }
	    };
	    RowDragFeature.prototype.addRowDropZone = function (params) {
	        var _this = this;
	        if (!params.getContainer()) {
	            doOnce(function () { return console.warn('AG Grid: addRowDropZone - A container target needs to be provided'); }, 'add-drop-zone-empty-target');
	            return;
	        }
	        if (this.dragAndDropService.findExternalZone(params)) {
	            console.warn('AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.');
	            return;
	        }
	        var processedParams = {
	            getContainer: params.getContainer
	        };
	        if (params.fromGrid) {
	            params.fromGrid = undefined;
	            processedParams = params;
	        }
	        else {
	            if (params.onDragEnter) {
	                processedParams.onDragEnter = function (e) {
	                    params.onDragEnter(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_ENTER, e));
	                };
	            }
	            if (params.onDragLeave) {
	                processedParams.onDragLeave = function (e) {
	                    params.onDragLeave(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_LEAVE, e));
	                };
	            }
	            if (params.onDragging) {
	                processedParams.onDragging = function (e) {
	                    params.onDragging(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_MOVE, e));
	                };
	            }
	            if (params.onDragStop) {
	                processedParams.onDragStop = function (e) {
	                    params.onDragStop(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_END, e));
	                };
	            }
	        }
	        this.dragAndDropService.addDropTarget(__assign$7({ isInterestedIn: function (type) { return type === exports.DragSourceType.RowDrag; }, getIconName: function () { return DragAndDropService.ICON_MOVE; }, external: true }, processedParams));
	    };
	    RowDragFeature.prototype.getRowDropZone = function (events) {
	        var _this = this;
	        var getContainer = this.getContainer.bind(this);
	        var onDragEnter = this.onDragEnter.bind(this);
	        var onDragLeave = this.onDragLeave.bind(this);
	        var onDragging = this.onDragging.bind(this);
	        var onDragStop = this.onDragStop.bind(this);
	        if (!events) {
	            return { getContainer: getContainer, onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDragging: onDragging, onDragStop: onDragStop, /* @private */ fromGrid: true };
	        }
	        return {
	            getContainer: getContainer,
	            onDragEnter: events.onDragEnter
	                ? (function (e) {
	                    onDragEnter(e);
	                    events.onDragEnter(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_ENTER, e));
	                })
	                : onDragEnter,
	            onDragLeave: events.onDragLeave
	                ? (function (e) {
	                    onDragLeave(e);
	                    events.onDragLeave(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_LEAVE, e));
	                })
	                : onDragLeave,
	            onDragging: events.onDragging
	                ? (function (e) {
	                    onDragging(e);
	                    events.onDragging(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_MOVE, e));
	                })
	                : onDragging,
	            onDragStop: events.onDragStop
	                ? (function (e) {
	                    onDragStop(e);
	                    events.onDragStop(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_END, e));
	                })
	                : onDragStop,
	            fromGrid: true /* @private */
	        };
	    };
	    RowDragFeature.prototype.draggingToRowDragEvent = function (type, draggingEvent) {
	        var yNormalised = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
	        var mouseIsPastLastRow = yNormalised > this.paginationProxy.getCurrentPageHeight();
	        var overIndex = -1;
	        var overNode = null;
	        if (!mouseIsPastLastRow) {
	            overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
	            overNode = this.rowModel.getRow(overIndex);
	        }
	        var vDirectionString;
	        switch (draggingEvent.vDirection) {
	            case exports.VerticalDirection.Down:
	                vDirectionString = 'down';
	                break;
	            case exports.VerticalDirection.Up:
	                vDirectionString = 'up';
	                break;
	            default:
	                vDirectionString = null;
	                break;
	        }
	        var event = {
	            type: type,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            event: draggingEvent.event,
	            node: draggingEvent.dragItem.rowNode,
	            nodes: draggingEvent.dragItem.rowNodes,
	            overIndex: overIndex,
	            overNode: overNode,
	            y: yNormalised,
	            vDirection: vDirectionString
	        };
	        return event;
	    };
	    RowDragFeature.prototype.dispatchGridEvent = function (type, draggingEvent) {
	        var event = this.draggingToRowDragEvent(type, draggingEvent);
	        this.eventService.dispatchEvent(event);
	    };
	    RowDragFeature.prototype.onDragLeave = function (draggingEvent) {
	        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_LEAVE, draggingEvent);
	        this.stopDragging(draggingEvent);
	        if (this.gridOptionsWrapper.isRowDragManaged()) {
	            this.clearRowHighlight();
	        }
	        if (this.isFromThisGrid(draggingEvent)) {
	            this.isMultiRowDrag = false;
	        }
	    };
	    RowDragFeature.prototype.onDragStop = function (draggingEvent) {
	        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_END, draggingEvent);
	        this.stopDragging(draggingEvent);
	        if (this.gridOptionsWrapper.isRowDragManaged() &&
	            (this.gridOptionsWrapper.isSuppressMoveWhenRowDragging() || !this.isFromThisGrid(draggingEvent)) &&
	            !this.isDropZoneWithinThisGrid(draggingEvent)) {
	            this.moveRowAndClearHighlight(draggingEvent);
	        }
	    };
	    RowDragFeature.prototype.stopDragging = function (draggingEvent) {
	        this.ensureIntervalCleared();
	        this.getRowNodes(draggingEvent).forEach(function (rowNode) {
	            rowNode.setDragging(false);
	        });
	    };
	    __decorate$Z([
	        Autowired('dragAndDropService')
	    ], RowDragFeature.prototype, "dragAndDropService", void 0);
	    __decorate$Z([
	        Autowired('rowModel')
	    ], RowDragFeature.prototype, "rowModel", void 0);
	    __decorate$Z([
	        Autowired('paginationProxy')
	    ], RowDragFeature.prototype, "paginationProxy", void 0);
	    __decorate$Z([
	        Autowired('columnController')
	    ], RowDragFeature.prototype, "columnController", void 0);
	    __decorate$Z([
	        Autowired('focusController')
	    ], RowDragFeature.prototype, "focusController", void 0);
	    __decorate$Z([
	        Autowired('sortController')
	    ], RowDragFeature.prototype, "sortController", void 0);
	    __decorate$Z([
	        Autowired('filterManager')
	    ], RowDragFeature.prototype, "filterManager", void 0);
	    __decorate$Z([
	        Autowired('selectionController')
	    ], RowDragFeature.prototype, "selectionController", void 0);
	    __decorate$Z([
	        Optional('rangeController')
	    ], RowDragFeature.prototype, "rangeController", void 0);
	    __decorate$Z([
	        Autowired('mouseEventService')
	    ], RowDragFeature.prototype, "mouseEventService", void 0);
	    __decorate$Z([
	        Autowired('controllersService')
	    ], RowDragFeature.prototype, "controllersService", void 0);
	    __decorate$Z([
	        PostConstruct
	    ], RowDragFeature.prototype, "postConstruct", null);
	    return RowDragFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$15 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$_ = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var RowAnimationCssClasses;
	(function (RowAnimationCssClasses) {
	    RowAnimationCssClasses["ANIMATION_ON"] = "ag-row-animation";
	    RowAnimationCssClasses["ANIMATION_OFF"] = "ag-row-no-animation";
	})(RowAnimationCssClasses || (RowAnimationCssClasses = {}));
	var CSS_CLASS_CELL_SELECTABLE = 'ag-selectable';
	var CSS_CLASS_FORCE_VERTICAL_SCROLL = 'ag-force-vertical-scroll';
	var CSS_CLASS_COLUMN_MOVING = 'ag-column-moving';
	var GridBodyController = /** @class */ (function (_super) {
	    __extends$15(GridBodyController, _super);
	    function GridBodyController() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GridBodyController.prototype.getScrollFeature = function () {
	        return this.bodyScrollFeature;
	    };
	    GridBodyController.prototype.getBodyViewportElement = function () {
	        return this.eBodyViewport;
	    };
	    GridBodyController.prototype.setView = function (view, eGridBody, eBodyViewport, eTop, eBottom) {
	        this.view = view;
	        this.eGridBody = eGridBody;
	        this.eBodyViewport = eBodyViewport;
	        this.eTop = eTop;
	        this.eBottom = eBottom;
	        this.setCellTextSelection(this.gridOptionsWrapper.isEnableCellTextSelect());
	        this.createManagedBean(new LayoutFeature(this.view));
	        this.bodyScrollFeature = this.createManagedBean(new GridBodyScrollFeature(this.eBodyViewport));
	        this.addRowDragListener();
	        this.setupRowAnimationCssClass();
	        this.controllersService.registerGridBodyController(this);
	        this.addEventListeners();
	        this.onGridColumnsChanged();
	        this.addBodyViewportListener();
	        this.setFloatingHeights();
	        this.disableBrowserDragging();
	        this.addStopEditingWhenGridLosesFocus();
	    };
	    GridBodyController.prototype.addEventListeners = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_PINNED_ROW_DATA_CHANGED, this.setFloatingHeights.bind(this));
	    };
	    // used by ColumnAnimationService
	    GridBodyController.prototype.setColumnMovingCss = function (moving) {
	        this.view.setColumnMovingCss(moving);
	    };
	    GridBodyController.prototype.setCellTextSelection = function (selectable) {
	        if (selectable === void 0) { selectable = false; }
	        this.view.setCellSelectableCss(selectable);
	    };
	    GridBodyController.prototype.onScrollVisibilityChanged = function () {
	        var show = this.scrollVisibleService.isVerticalScrollShowing();
	        this.view.setVerticalScrollPaddingVisible(show);
	    };
	    GridBodyController.prototype.onGridColumnsChanged = function () {
	        var columns = this.columnController.getAllGridColumns();
	        this.view.setColumnCount(columns ? columns.length : 0);
	    };
	    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
	    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
	    GridBodyController.prototype.disableBrowserDragging = function () {
	        this.addManagedListener(this.eGridBody, 'dragstart', function (event) {
	            if (event.target instanceof HTMLImageElement) {
	                event.preventDefault();
	                return false;
	            }
	        });
	    };
	    GridBodyController.prototype.addStopEditingWhenGridLosesFocus = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isStopEditingWhenCellsLoseFocus()) {
	            return;
	        }
	        var focusOutListener = function (event) {
	            // this is the element the focus is moving to
	            var elementWithFocus = event.relatedTarget;
	            if (getTabIndex(elementWithFocus) === null) {
	                _this.rowRenderer.stopEditing();
	                return;
	            }
	            var clickInsideGrid = 
	            // see if click came from inside the viewports
	            viewports.some(function (viewport) { return viewport.contains(elementWithFocus); })
	                // and also that it's not from a detail grid
	                && _this.mouseEventService.isElementInThisGrid(elementWithFocus);
	            if (!clickInsideGrid) {
	                var popupService = _this.popupService;
	                clickInsideGrid =
	                    popupService.getActivePopups().some(function (popup) { return popup.contains(elementWithFocus); }) ||
	                        popupService.isElementWithinCustomPopup(elementWithFocus);
	            }
	            if (!clickInsideGrid) {
	                _this.rowRenderer.stopEditing();
	            }
	        };
	        var viewports = [this.eBodyViewport, this.eBottom, this.eTop];
	        viewports.forEach(function (viewport) { return _this.addManagedListener(viewport, 'focusout', focusOutListener); });
	    };
	    GridBodyController.prototype.updateRowCount = function () {
	        var headerCount = this.headerNavigationService.getHeaderRowCount();
	        var modelType = this.paginationProxy.getType();
	        var rowCount = -1;
	        if (modelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            rowCount = 0;
	            this.paginationProxy.forEachNode(function (node) {
	                if (!node.group) {
	                    rowCount++;
	                }
	            });
	        }
	        var total = rowCount === -1 ? -1 : (headerCount + rowCount);
	        this.view.setRowCount(total);
	    };
	    GridBodyController.prototype.registerBodyViewportResizeListener = function (listener) {
	        this.view.registerBodyViewportResizeListener(listener);
	    };
	    GridBodyController.prototype.setVerticalScrollPaddingVisible = function (visible) {
	        this.view.setVerticalScrollPaddingVisible(visible);
	    };
	    GridBodyController.prototype.isVerticalScrollShowing = function () {
	        var isAlwaysShowVerticalScroll = this.gridOptionsWrapper.isAlwaysShowVerticalScroll();
	        this.view.setAlwaysVerticalScrollClass(isAlwaysShowVerticalScroll);
	        return isAlwaysShowVerticalScroll || isVerticalScrollShowing(this.eBodyViewport);
	    };
	    GridBodyController.prototype.setupRowAnimationCssClass = function () {
	        var _this = this;
	        var listener = function () {
	            // we don't want to use row animation if scaling, as rows jump strangely as you scroll,
	            // when scaling and doing row animation.
	            var animateRows = _this.gridOptionsWrapper.isAnimateRows() && !_this.rowContainerHeightService.isStretching();
	            _this.view.setRowAnimationCssOnBodyViewport(animateRows);
	        };
	        listener();
	        this.addManagedListener(this.eventService, Events.EVENT_HEIGHT_SCALE_CHANGED, listener);
	    };
	    GridBodyController.prototype.getGridBodyElement = function () {
	        return this.eGridBody;
	    };
	    GridBodyController.prototype.addBodyViewportListener = function () {
	        var _this = this;
	        // we want to listen for clicks directly on the eBodyViewport, so the user has a way of showing
	        // the context menu if no rows or columns are displayed, or user simply clicks outside of a cell
	        var listener = function (mouseEvent) {
	            var target = getTarget(mouseEvent);
	            if (target === _this.eBodyViewport || target === _this.controllersService.getCenterRowContainerCon().getViewportElement()) {
	                // show it
	                if (_this.contextMenuFactory) {
	                    _this.contextMenuFactory.onContextMenu(mouseEvent, null, null, null, null, _this.eGridBody);
	                }
	            }
	        };
	        this.addManagedListener(this.eBodyViewport, 'contextmenu', listener);
	    };
	    GridBodyController.prototype.getGui = function () {
	        return this.eGridBody;
	    };
	    // called by rowDragFeature
	    GridBodyController.prototype.scrollVertically = function (pixels) {
	        var oldScrollPosition = this.eBodyViewport.scrollTop;
	        this.bodyScrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
	        return this.eBodyViewport.scrollTop - oldScrollPosition;
	    };
	    // + rangeController - used to know when to scroll when user is dragging outside the
	    // main viewport while doing a range selection
	    GridBodyController.prototype.getBodyClientRect = function () {
	        if (!this.eBodyViewport) {
	            return;
	        }
	        return this.eBodyViewport.getBoundingClientRect();
	    };
	    GridBodyController.prototype.addRowDragListener = function () {
	        this.rowDragFeature = this.createManagedBean(new RowDragFeature(this.eBodyViewport));
	        this.dragAndDropService.addDropTarget(this.rowDragFeature);
	    };
	    GridBodyController.prototype.getRowDragFeature = function () {
	        return this.rowDragFeature;
	    };
	    GridBodyController.prototype.setFloatingHeights = function () {
	        var pinnedRowModel = this.pinnedRowModel;
	        var floatingTopHeight = pinnedRowModel.getPinnedTopTotalHeight();
	        if (floatingTopHeight) {
	            // adding 1px for cell bottom border
	            floatingTopHeight += 1;
	        }
	        var floatingBottomHeight = pinnedRowModel.getPinnedBottomTotalHeight();
	        if (floatingBottomHeight) {
	            // adding 1px for cell bottom border
	            floatingBottomHeight += 1;
	        }
	        this.view.setTopHeight(floatingTopHeight);
	        this.view.setBottomHeight(floatingBottomHeight);
	        this.view.setTopDisplay(floatingTopHeight ? 'inherit' : 'none');
	        this.view.setBottomDisplay(floatingBottomHeight ? 'inherit' : 'none');
	    };
	    // method will call itself if no available width. this covers if the grid
	    // isn't visible, but is just about to be visible.
	    GridBodyController.prototype.sizeColumnsToFit = function (nextTimeout) {
	        var _this = this;
	        // IE is different to the other browsers, it already removes the scroll width
	        // while calling window.getComputedStyle() (which is called by getInnerWidth())
	        var removeScrollWidth = this.isVerticalScrollShowing() && !isBrowserIE();
	        var scrollWidthToRemove = removeScrollWidth ? this.gridOptionsWrapper.getScrollbarWidth() : 0;
	        var bodyViewportWidth = getInnerWidth(this.eBodyViewport);
	        var availableWidth = bodyViewportWidth - scrollWidthToRemove;
	        if (availableWidth > 0) {
	            this.columnController.sizeColumnsToFit(availableWidth, "sizeColumnsToFit");
	            return;
	        }
	        if (nextTimeout === undefined) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(100);
	            }, 0);
	        }
	        else if (nextTimeout === 100) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(500);
	            }, 100);
	        }
	        else if (nextTimeout === 500) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(-1);
	            }, 500);
	        }
	        else {
	            console.warn('AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with ' +
	                'zero width, maybe the grid is not visible yet on the screen?');
	        }
	    };
	    __decorate$_([
	        Autowired('rowContainerHeightService')
	    ], GridBodyController.prototype, "rowContainerHeightService", void 0);
	    __decorate$_([
	        Autowired('controllersService')
	    ], GridBodyController.prototype, "controllersService", void 0);
	    __decorate$_([
	        Autowired('columnController')
	    ], GridBodyController.prototype, "columnController", void 0);
	    __decorate$_([
	        Autowired('scrollVisibleService')
	    ], GridBodyController.prototype, "scrollVisibleService", void 0);
	    __decorate$_([
	        Optional('contextMenuFactory')
	    ], GridBodyController.prototype, "contextMenuFactory", void 0);
	    __decorate$_([
	        Autowired('headerNavigationService')
	    ], GridBodyController.prototype, "headerNavigationService", void 0);
	    __decorate$_([
	        Autowired('paginationProxy')
	    ], GridBodyController.prototype, "paginationProxy", void 0);
	    __decorate$_([
	        Autowired('dragAndDropService')
	    ], GridBodyController.prototype, "dragAndDropService", void 0);
	    __decorate$_([
	        Autowired('pinnedRowModel')
	    ], GridBodyController.prototype, "pinnedRowModel", void 0);
	    __decorate$_([
	        Autowired('rowRenderer')
	    ], GridBodyController.prototype, "rowRenderer", void 0);
	    __decorate$_([
	        Autowired('popupService')
	    ], GridBodyController.prototype, "popupService", void 0);
	    __decorate$_([
	        Autowired('mouseEventService')
	    ], GridBodyController.prototype, "mouseEventService", void 0);
	    return GridBodyController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$16 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$$ = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var RowContainerEventsFeature = /** @class */ (function (_super) {
	    __extends$16(RowContainerEventsFeature, _super);
	    function RowContainerEventsFeature(element) {
	        var _this = _super.call(this) || this;
	        _this.element = element;
	        return _this;
	    }
	    RowContainerEventsFeature.prototype.postConstruct = function () {
	        this.addMouseListeners();
	        this.mockContextMenuForIPad();
	        this.addKeyboardEvents();
	    };
	    RowContainerEventsFeature.prototype.addKeyboardEvents = function () {
	        var _this = this;
	        var eventNames = ['keydown', 'keypress'];
	        eventNames.forEach(function (eventName) {
	            var listener = _this.processKeyboardEvent.bind(_this, eventName);
	            _this.addManagedListener(_this.element, eventName, listener);
	        });
	    };
	    RowContainerEventsFeature.prototype.addMouseListeners = function () {
	        var _this = this;
	        var eventNames = ['dblclick', 'contextmenu', 'mouseover', 'mouseout', 'click', 'mousedown'];
	        eventNames.forEach(function (eventName) {
	            var listener = _this.processMouseEvent.bind(_this, eventName);
	            _this.addManagedListener(_this.element, eventName, listener);
	        });
	    };
	    RowContainerEventsFeature.prototype.processMouseEvent = function (eventName, mouseEvent) {
	        if (!this.mouseEventService.isEventFromThisGrid(mouseEvent) ||
	            isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        var rowComp = this.getRowForEvent(mouseEvent);
	        var cellComp = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
	        if (eventName === "contextmenu") {
	            this.handleContextMenuMouseEvent(mouseEvent, null, rowComp, cellComp);
	        }
	        else {
	            if (cellComp) {
	                cellComp.onMouseEvent(eventName, mouseEvent);
	            }
	            if (rowComp) {
	                rowComp.onMouseEvent(eventName, mouseEvent);
	            }
	        }
	    };
	    RowContainerEventsFeature.prototype.mockContextMenuForIPad = function () {
	        var _this = this;
	        // we do NOT want this when not in iPad, otherwise we will be doing
	        if (!isIOSUserAgent()) {
	            return;
	        }
	        var touchListener = new TouchListener(this.element);
	        var longTapListener = function (event) {
	            var rowComp = _this.getRowForEvent(event.touchEvent);
	            var cellComp = _this.mouseEventService.getRenderedCellForEvent(event.touchEvent);
	            _this.handleContextMenuMouseEvent(null, event.touchEvent, rowComp, cellComp);
	        };
	        this.addManagedListener(touchListener, TouchListener.EVENT_LONG_TAP, longTapListener);
	        this.addDestroyFunc(function () { return touchListener.destroy(); });
	    };
	    RowContainerEventsFeature.prototype.getRowForEvent = function (event) {
	        var sourceElement = getTarget(event);
	        while (sourceElement) {
	            var rowCon = this.gridOptionsWrapper.getDomData(sourceElement, RowController.DOM_DATA_KEY_RENDERED_ROW);
	            if (rowCon) {
	                return rowCon;
	            }
	            sourceElement = sourceElement.parentElement;
	        }
	        return null;
	    };
	    RowContainerEventsFeature.prototype.handleContextMenuMouseEvent = function (mouseEvent, touchEvent, rowComp, cellComp) {
	        var rowNode = rowComp ? rowComp.getRowNode() : null;
	        var column = cellComp ? cellComp.getColumn() : null;
	        var value = null;
	        if (column) {
	            var event_1 = mouseEvent ? mouseEvent : touchEvent;
	            cellComp.dispatchCellContextMenuEvent(event_1);
	            value = this.valueService.getValue(column, rowNode);
	        }
	        // if user clicked on a cell, anchor to that cell, otherwise anchor to the grid panel
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var anchorToElement = cellComp ? cellComp.getGui() : gridBodyCon.getGridBodyElement();
	        if (this.contextMenuFactory) {
	            this.contextMenuFactory.onContextMenu(mouseEvent, touchEvent, rowNode, column, value, anchorToElement);
	        }
	    };
	    RowContainerEventsFeature.prototype.processKeyboardEvent = function (eventName, keyboardEvent) {
	        var cellComp = getComponentForEvent(this.gridOptionsWrapper, keyboardEvent, 'cellComp');
	        var rowComp = getComponentForEvent(this.gridOptionsWrapper, keyboardEvent, 'renderedRow');
	        if (keyboardEvent.defaultPrevented) {
	            return;
	        }
	        if (cellComp) {
	            this.processCellKeyboardEvent(cellComp, eventName, keyboardEvent);
	        }
	        else if (rowComp && rowComp.isFullWidth()) {
	            this.processFullWidthRowKeyboardEvent(rowComp, eventName, keyboardEvent);
	        }
	    };
	    RowContainerEventsFeature.prototype.processCellKeyboardEvent = function (cellComp, eventName, keyboardEvent) {
	        var rowNode = cellComp.getRenderedRow().getRowNode();
	        var column = cellComp.getColumn();
	        var editing = cellComp.isEditing();
	        var gridProcessingAllowed = !isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, keyboardEvent, rowNode, column, editing);
	        if (gridProcessingAllowed) {
	            switch (eventName) {
	                case 'keydown':
	                    // first see if it's a scroll key, page up / down, home / end etc
	                    var wasScrollKey = !editing && this.navigationService.handlePageScrollingKey(keyboardEvent);
	                    // if not a scroll key, then we pass onto cell
	                    if (!wasScrollKey) {
	                        cellComp.onKeyDown(keyboardEvent);
	                    }
	                    // perform clipboard and undo / redo operations
	                    this.doGridOperations(keyboardEvent, cellComp);
	                    break;
	                case 'keypress':
	                    cellComp.onKeyPress(keyboardEvent);
	                    break;
	            }
	        }
	        if (eventName === 'keydown') {
	            var cellKeyDownEvent = cellComp.createEvent(keyboardEvent, Events.EVENT_CELL_KEY_DOWN);
	            this.eventService.dispatchEvent(cellKeyDownEvent);
	        }
	        if (eventName === 'keypress') {
	            var cellKeyPressEvent = cellComp.createEvent(keyboardEvent, Events.EVENT_CELL_KEY_PRESS);
	            this.eventService.dispatchEvent(cellKeyPressEvent);
	        }
	    };
	    RowContainerEventsFeature.prototype.processFullWidthRowKeyboardEvent = function (rowComp, eventName, keyboardEvent) {
	        var rowNode = rowComp.getRowNode();
	        var focusedCell = this.focusController.getFocusedCell();
	        var column = (focusedCell && focusedCell.column);
	        var gridProcessingAllowed = !isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, keyboardEvent, rowNode, column, false);
	        if (gridProcessingAllowed) {
	            var key = keyboardEvent.key;
	            if (eventName === 'keydown') {
	                switch (key) {
	                    case KeyName.UP:
	                    case KeyName.DOWN:
	                        rowComp.onKeyboardNavigate(keyboardEvent);
	                        break;
	                    case KeyName.TAB:
	                        rowComp.onTabKeyDown(keyboardEvent);
	                }
	            }
	        }
	        if (eventName === 'keydown') {
	            var cellKeyDownEvent = rowComp.createRowEvent(Events.EVENT_CELL_KEY_DOWN, keyboardEvent);
	            this.eventService.dispatchEvent(cellKeyDownEvent);
	        }
	        if (eventName === 'keypress') {
	            var cellKeyPressEvent = rowComp.createRowEvent(Events.EVENT_CELL_KEY_PRESS, keyboardEvent);
	            this.eventService.dispatchEvent(cellKeyPressEvent);
	        }
	    };
	    RowContainerEventsFeature.prototype.doGridOperations = function (keyboardEvent, cellComp) {
	        // check if ctrl or meta key pressed
	        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) {
	            return;
	        }
	        // if the cell the event came from is editing, then we do not
	        // want to do the default shortcut keys, otherwise the editor
	        // (eg a text field) would not be able to do the normal cut/copy/paste
	        if (cellComp.isEditing()) {
	            return;
	        }
	        // for copy / paste, we don't want to execute when the event
	        // was from a child grid (happens in master detail)
	        if (!this.mouseEventService.isEventFromThisGrid(keyboardEvent)) {
	            return;
	        }
	        switch (keyboardEvent.which) {
	            case KeyCode.A:
	                return this.onCtrlAndA(keyboardEvent);
	            case KeyCode.C:
	                return this.onCtrlAndC(keyboardEvent);
	            case KeyCode.V:
	                return this.onCtrlAndV();
	            case KeyCode.D:
	                return this.onCtrlAndD(keyboardEvent);
	            case KeyCode.Z:
	                return keyboardEvent.shiftKey ? this.undoRedoService.redo() : this.undoRedoService.undo();
	            case KeyCode.Y:
	                return this.undoRedoService.redo();
	        }
	    };
	    RowContainerEventsFeature.prototype.onCtrlAndA = function (event) {
	        var _a = this, pinnedRowModel = _a.pinnedRowModel, paginationProxy = _a.paginationProxy, rangeController = _a.rangeController;
	        var PINNED_BOTTOM = Constants.PINNED_BOTTOM, PINNED_TOP = Constants.PINNED_TOP;
	        if (rangeController && paginationProxy.isRowsToRender()) {
	            var _b = [
	                pinnedRowModel.isEmpty(PINNED_TOP),
	                pinnedRowModel.isEmpty(PINNED_BOTTOM)
	            ], isEmptyPinnedTop = _b[0], isEmptyPinnedBottom = _b[1];
	            var floatingStart = isEmptyPinnedTop ? null : PINNED_TOP;
	            var floatingEnd = void 0;
	            var rowEnd = void 0;
	            if (isEmptyPinnedBottom) {
	                floatingEnd = null;
	                rowEnd = this.paginationProxy.getRowCount() - 1;
	            }
	            else {
	                floatingEnd = PINNED_BOTTOM;
	                rowEnd = pinnedRowModel.getPinnedBottomRowData().length - 1;
	            }
	            var allDisplayedColumns = this.columnController.getAllDisplayedColumns();
	            if (missingOrEmpty(allDisplayedColumns)) {
	                return;
	            }
	            rangeController.setCellRange({
	                rowStartIndex: 0,
	                rowStartPinned: floatingStart,
	                rowEndIndex: rowEnd,
	                rowEndPinned: floatingEnd,
	                columnStart: allDisplayedColumns[0],
	                columnEnd: last(allDisplayedColumns)
	            });
	        }
	        event.preventDefault();
	    };
	    RowContainerEventsFeature.prototype.onCtrlAndC = function (event) {
	        if (!this.clipboardService || this.gridOptionsWrapper.isEnableCellTextSelection()) {
	            return;
	        }
	        this.clipboardService.copyToClipboard();
	        event.preventDefault();
	    };
	    RowContainerEventsFeature.prototype.onCtrlAndV = function () {
	        if (ModuleRegistry.isRegistered(exports.ModuleNames.ClipboardModule) && !this.gridOptionsWrapper.isSuppressClipboardPaste()) {
	            this.clipboardService.pasteFromClipboard();
	        }
	    };
	    RowContainerEventsFeature.prototype.onCtrlAndD = function (event) {
	        if (ModuleRegistry.isRegistered(exports.ModuleNames.ClipboardModule) && !this.gridOptionsWrapper.isSuppressClipboardPaste()) {
	            this.clipboardService.copyRangeDown();
	        }
	        event.preventDefault();
	    };
	    __decorate$$([
	        Autowired('mouseEventService')
	    ], RowContainerEventsFeature.prototype, "mouseEventService", void 0);
	    __decorate$$([
	        Autowired('valueService')
	    ], RowContainerEventsFeature.prototype, "valueService", void 0);
	    __decorate$$([
	        Optional('contextMenuFactory')
	    ], RowContainerEventsFeature.prototype, "contextMenuFactory", void 0);
	    __decorate$$([
	        Autowired('controllersService')
	    ], RowContainerEventsFeature.prototype, "controllersService", void 0);
	    __decorate$$([
	        Autowired('navigationService')
	    ], RowContainerEventsFeature.prototype, "navigationService", void 0);
	    __decorate$$([
	        Autowired('focusController')
	    ], RowContainerEventsFeature.prototype, "focusController", void 0);
	    __decorate$$([
	        Autowired('undoRedoService')
	    ], RowContainerEventsFeature.prototype, "undoRedoService", void 0);
	    __decorate$$([
	        Autowired('columnController')
	    ], RowContainerEventsFeature.prototype, "columnController", void 0);
	    __decorate$$([
	        Autowired('paginationProxy')
	    ], RowContainerEventsFeature.prototype, "paginationProxy", void 0);
	    __decorate$$([
	        Autowired('pinnedRowModel')
	    ], RowContainerEventsFeature.prototype, "pinnedRowModel", void 0);
	    __decorate$$([
	        Optional('rangeController')
	    ], RowContainerEventsFeature.prototype, "rangeController", void 0);
	    __decorate$$([
	        Optional('clipboardService')
	    ], RowContainerEventsFeature.prototype, "clipboardService", void 0);
	    __decorate$$([
	        PostConstruct
	    ], RowContainerEventsFeature.prototype, "postConstruct", null);
	    return RowContainerEventsFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$17 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$10 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// listens to changes in the center viewport size, for column and row virtualisation,
	// and adjusts grid as necessary. there are two viewports, one for horizontal and one for
	// vertical scrolling.
	var ViewportSizeFeature = /** @class */ (function (_super) {
	    __extends$17(ViewportSizeFeature, _super);
	    function ViewportSizeFeature(centerContainer) {
	        var _this = _super.call(this) || this;
	        _this.centerContainerCon = centerContainer;
	        return _this;
	    }
	    ViewportSizeFeature.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function () {
	            _this.gridBodyCon = _this.controllersService.getGridBodyController();
	            _this.listenForResize();
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this));
	    };
	    ViewportSizeFeature.prototype.listenForResize = function () {
	        var listener = this.onCenterViewportResized.bind(this);
	        // centerContainer gets horizontal resizes
	        this.centerContainerCon.registerViewportResizeListener(listener);
	        // eBodyViewport gets vertical resizes
	        this.gridBodyCon.registerBodyViewportResizeListener(listener);
	    };
	    ViewportSizeFeature.prototype.onScrollbarWidthChanged = function () {
	        this.checkViewportAndScrolls();
	    };
	    ViewportSizeFeature.prototype.onCenterViewportResized = function () {
	        if (this.centerContainerCon.isViewportVisible()) {
	            this.checkViewportAndScrolls();
	            var newWidth = this.centerContainerCon.getCenterWidth();
	            if (newWidth !== this.centerWidth) {
	                this.centerWidth = newWidth;
	                this.columnController.refreshFlexedColumns({ viewportWidth: this.centerWidth, updateBodyWidths: true, fireResizedEvent: true });
	            }
	        }
	        else {
	            this.bodyHeight = 0;
	        }
	    };
	    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
	    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
	    ViewportSizeFeature.prototype.checkViewportAndScrolls = function () {
	        // results in updating anything that depends on scroll showing
	        this.updateScrollVisibleService();
	        // fires event if height changes, used by PaginationService, HeightScalerService, RowRenderer
	        this.checkBodyHeight();
	        // check for virtual columns for ColumnController
	        this.onHorizontalViewportChanged();
	        this.gridBodyCon.getScrollFeature().checkScrollLeft();
	    };
	    ViewportSizeFeature.prototype.getBodyHeight = function () {
	        return this.bodyHeight;
	    };
	    ViewportSizeFeature.prototype.checkBodyHeight = function () {
	        var eBodyViewport = this.gridBodyCon.getBodyViewportElement();
	        var bodyHeight = getInnerHeight(eBodyViewport);
	        if (this.bodyHeight !== bodyHeight) {
	            this.bodyHeight = bodyHeight;
	            var event_1 = {
	                type: Events.EVENT_BODY_HEIGHT_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    ViewportSizeFeature.prototype.updateScrollVisibleService = function () {
	        // because of column animation (which takes 200ms), we have to do this twice.
	        // eg if user removes cols anywhere except at the RHS, then the cols on the RHS
	        // will animate to the left to fill the gap. this animation means just after
	        // the cols are removed, the remaining cols are still in the original location
	        // at the start of the animation, so pre animation the H scrollbar is still needed,
	        // but post animation it is not.
	        this.updateScrollVisibleServiceImpl();
	        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
	    };
	    ViewportSizeFeature.prototype.updateScrollVisibleServiceImpl = function () {
	        var params = {
	            horizontalScrollShowing: this.isHorizontalScrollShowing(),
	            verticalScrollShowing: this.gridBodyCon.isVerticalScrollShowing()
	        };
	        this.scrollVisibleService.setScrollsVisible(params);
	        // fix - gridComp should just listen to event from above
	        this.gridBodyCon.setVerticalScrollPaddingVisible(params.verticalScrollShowing);
	    };
	    ViewportSizeFeature.prototype.isHorizontalScrollShowing = function () {
	        var isAlwaysShowHorizontalScroll = this.gridOptionsWrapper.isAlwaysShowHorizontalScroll();
	        return isAlwaysShowHorizontalScroll || this.centerContainerCon.isViewportHScrollShowing();
	    };
	    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
	    // out the virtual columns again. gets called from following locations:
	    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged, API (doLayout)
	    ViewportSizeFeature.prototype.onHorizontalViewportChanged = function () {
	        var scrollWidth = this.centerContainerCon.getCenterWidth();
	        var scrollPosition = this.centerContainerCon.getViewportScrollLeft();
	        this.columnController.setViewportPosition(scrollWidth, scrollPosition);
	    };
	    __decorate$10([
	        Autowired('controllersService')
	    ], ViewportSizeFeature.prototype, "controllersService", void 0);
	    __decorate$10([
	        Autowired('columnController')
	    ], ViewportSizeFeature.prototype, "columnController", void 0);
	    __decorate$10([
	        Autowired('scrollVisibleService')
	    ], ViewportSizeFeature.prototype, "scrollVisibleService", void 0);
	    __decorate$10([
	        Autowired('columnApi')
	    ], ViewportSizeFeature.prototype, "columnApi", void 0);
	    __decorate$10([
	        Autowired('gridApi')
	    ], ViewportSizeFeature.prototype, "gridApi", void 0);
	    __decorate$10([
	        PostConstruct
	    ], ViewportSizeFeature.prototype, "postConstruct", null);
	    return ViewportSizeFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$18 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$11 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SetPinnedLeftWidthFeature = /** @class */ (function (_super) {
	    __extends$18(SetPinnedLeftWidthFeature, _super);
	    function SetPinnedLeftWidthFeature(element) {
	        var _this = _super.call(this) || this;
	        _this.element = element;
	        return _this;
	    }
	    SetPinnedLeftWidthFeature.prototype.postConstruct = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
	    };
	    SetPinnedLeftWidthFeature.prototype.onPinnedLeftWidthChanged = function () {
	        var leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
	        var displayed = leftWidth > 0;
	        setDisplayed(this.element, displayed);
	        if (displayed) {
	            setFixedWidth(this.element, leftWidth);
	        }
	    };
	    __decorate$11([
	        Autowired('pinnedWidthService')
	    ], SetPinnedLeftWidthFeature.prototype, "pinnedWidthService", void 0);
	    __decorate$11([
	        PostConstruct
	    ], SetPinnedLeftWidthFeature.prototype, "postConstruct", null);
	    return SetPinnedLeftWidthFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$19 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$12 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SetPinnedRightWidthFeature = /** @class */ (function (_super) {
	    __extends$19(SetPinnedRightWidthFeature, _super);
	    function SetPinnedRightWidthFeature(element) {
	        var _this = _super.call(this) || this;
	        _this.element = element;
	        return _this;
	    }
	    SetPinnedRightWidthFeature.prototype.postConstruct = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
	    };
	    SetPinnedRightWidthFeature.prototype.onPinnedRightWidthChanged = function () {
	        var rightWidth = this.pinnedWidthService.getPinnedRightWidth();
	        var displayed = rightWidth > 0;
	        setDisplayed(this.element, displayed);
	        if (displayed) {
	            setFixedWidth(this.element, rightWidth);
	        }
	    };
	    __decorate$12([
	        Autowired('pinnedWidthService')
	    ], SetPinnedRightWidthFeature.prototype, "pinnedWidthService", void 0);
	    __decorate$12([
	        PostConstruct
	    ], SetPinnedRightWidthFeature.prototype, "postConstruct", null);
	    return SetPinnedRightWidthFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1a = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$13 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SetHeightFeature = /** @class */ (function (_super) {
	    __extends$1a(SetHeightFeature, _super);
	    function SetHeightFeature(eContainer, eWrapper) {
	        var _this = _super.call(this) || this;
	        _this.eContainer = eContainer;
	        _this.eWrapper = eWrapper;
	        return _this;
	    }
	    SetHeightFeature.prototype.postConstruct = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
	    };
	    SetHeightFeature.prototype.onHeightChanged = function () {
	        var height = this.maxDivHeightScaler.getUiContainerHeight();
	        var heightString = height != null ? height + "px" : "";
	        this.eContainer.style.height = heightString;
	        if (this.eWrapper) {
	            this.eWrapper.style.height = heightString;
	        }
	    };
	    __decorate$13([
	        Autowired("rowContainerHeightService")
	    ], SetHeightFeature.prototype, "maxDivHeightScaler", void 0);
	    __decorate$13([
	        PostConstruct
	    ], SetHeightFeature.prototype, "postConstruct", null);
	    return SetHeightFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1b = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$14 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var DragListenerFeature = /** @class */ (function (_super) {
	    __extends$1b(DragListenerFeature, _super);
	    function DragListenerFeature(eContainer) {
	        var _this = _super.call(this) || this;
	        _this.eContainer = eContainer;
	        return _this;
	    }
	    DragListenerFeature.prototype.postConstruct = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isEnableRangeSelection() || // no range selection if no property
	            missing(this.rangeController) // no range selection if not enterprise version
	        ) {
	            return;
	        }
	        var params = {
	            eElement: this.eContainer,
	            onDragStart: this.rangeController.onDragStart.bind(this.rangeController),
	            onDragStop: this.rangeController.onDragStop.bind(this.rangeController),
	            onDragging: this.rangeController.onDragging.bind(this.rangeController)
	        };
	        this.dragService.addDragSource(params);
	        this.addDestroyFunc(function () { return _this.dragService.removeDragSource(params); });
	    };
	    __decorate$14([
	        Optional('rangeController')
	    ], DragListenerFeature.prototype, "rangeController", void 0);
	    __decorate$14([
	        Autowired('dragService')
	    ], DragListenerFeature.prototype, "dragService", void 0);
	    __decorate$14([
	        PostConstruct
	    ], DragListenerFeature.prototype, "postConstruct", null);
	    return DragListenerFeature;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1c = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$15 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __spreadArrays$6 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var RowContainerNames;
	(function (RowContainerNames) {
	    RowContainerNames["LEFT"] = "left";
	    RowContainerNames["RIGHT"] = "right";
	    RowContainerNames["CENTER"] = "center";
	    RowContainerNames["FULL_WIDTH"] = "fullWidth";
	    RowContainerNames["TOP_LEFT"] = "topLeft";
	    RowContainerNames["TOP_RIGHT"] = "topRight";
	    RowContainerNames["TOP_CENTER"] = "topCenter";
	    RowContainerNames["TOP_FULL_WITH"] = "topFullWidth";
	    RowContainerNames["BOTTOM_LEFT"] = "bottomLeft";
	    RowContainerNames["BOTTOM_RIGHT"] = "bottomRight";
	    RowContainerNames["BOTTOM_CENTER"] = "bottomCenter";
	    RowContainerNames["BOTTOM_FULL_WITH"] = "bottomFullWidth";
	})(RowContainerNames || (RowContainerNames = {}));
	var ContainerCssClasses = convertToMap([
	    [RowContainerNames.CENTER, 'ag-center-cols-container'],
	    [RowContainerNames.LEFT, 'ag-pinned-left-cols-container'],
	    [RowContainerNames.RIGHT, 'ag-pinned-right-cols-container'],
	    [RowContainerNames.FULL_WIDTH, 'ag-full-width-container'],
	    [RowContainerNames.TOP_CENTER, 'ag-floating-top-container'],
	    [RowContainerNames.TOP_LEFT, 'ag-pinned-left-floating-top'],
	    [RowContainerNames.TOP_RIGHT, 'ag-pinned-right-floating-top'],
	    [RowContainerNames.TOP_FULL_WITH, 'ag-floating-top-full-width-container'],
	    [RowContainerNames.BOTTOM_CENTER, 'ag-floating-bottom-container'],
	    [RowContainerNames.BOTTOM_LEFT, 'ag-pinned-left-floating-bottom'],
	    [RowContainerNames.BOTTOM_RIGHT, 'ag-pinned-right-floating-bottom'],
	    [RowContainerNames.BOTTOM_FULL_WITH, 'ag-floating-bottom-full-width-container'],
	]);
	var ViewportCssClasses = convertToMap([
	    [RowContainerNames.CENTER, 'ag-center-cols-viewport'],
	    [RowContainerNames.TOP_CENTER, 'ag-floating-top-viewport'],
	    [RowContainerNames.BOTTOM_CENTER, 'ag-floating-bottom-viewport'],
	]);
	var WrapperCssClasses = convertToMap([
	    [RowContainerNames.CENTER, 'ag-center-cols-clipper'],
	]);
	var RowContainerController = /** @class */ (function (_super) {
	    __extends$1c(RowContainerController, _super);
	    function RowContainerController(name) {
	        var _this = _super.call(this) || this;
	        _this.name = name;
	        return _this;
	    }
	    RowContainerController.prototype.postConstruct = function () {
	        var _this = this;
	        this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
	        this.forContainers([RowContainerNames.CENTER], function () { return _this.viewportSizeFeature = _this.createManagedBean(new ViewportSizeFeature(_this)); });
	        this.registerWithControllersService();
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
	    };
	    RowContainerController.prototype.registerWithControllersService = function () {
	        switch (this.name) {
	            case RowContainerNames.CENTER:
	                this.controllersService.registerCenterRowContainerCon(this);
	                break;
	            case RowContainerNames.LEFT:
	                this.controllersService.registerLeftRowContainerCon(this);
	                break;
	            case RowContainerNames.RIGHT:
	                this.controllersService.registerRightRowContainerCon(this);
	                break;
	            case RowContainerNames.TOP_CENTER:
	                this.controllersService.registerTopCenterRowContainerCon(this);
	                break;
	            case RowContainerNames.TOP_LEFT:
	                this.controllersService.registerTopLeftRowContainerCon(this);
	                break;
	            case RowContainerNames.TOP_RIGHT:
	                this.controllersService.registerTopRightRowContainerCon(this);
	                break;
	            case RowContainerNames.BOTTOM_CENTER:
	                this.controllersService.registerBottomCenterRowContainerCon(this);
	                break;
	            case RowContainerNames.BOTTOM_LEFT:
	                this.controllersService.registerBottomLeftRowContainerCon(this);
	                break;
	            case RowContainerNames.BOTTOM_RIGHT:
	                this.controllersService.registerBottomRightRowContainerCon(this);
	                break;
	        }
	    };
	    RowContainerController.prototype.forContainers = function (names, callback) {
	        if (names.indexOf(this.name) >= 0) {
	            callback();
	        }
	    };
	    RowContainerController.prototype.getContainerElement = function () {
	        return this.eContainer;
	    };
	    RowContainerController.prototype.getViewportSizeFeature = function () {
	        return this.viewportSizeFeature;
	    };
	    RowContainerController.prototype.setView = function (view, eContainer, eViewport, eWrapper) {
	        var _this = this;
	        this.view = view;
	        this.eContainer = eContainer;
	        this.eViewport = eViewport;
	        this.eWrapper = eWrapper;
	        this.createManagedBean(new RowContainerEventsFeature(this.eContainer));
	        this.addPreventScrollWhileDragging();
	        var allTopNoFW = [RowContainerNames.TOP_CENTER, RowContainerNames.TOP_LEFT, RowContainerNames.TOP_RIGHT];
	        var allBottomNoFW = [RowContainerNames.BOTTOM_CENTER, RowContainerNames.BOTTOM_LEFT, RowContainerNames.BOTTOM_RIGHT];
	        var allMiddleNoFW = [RowContainerNames.CENTER, RowContainerNames.LEFT, RowContainerNames.RIGHT];
	        var allNoFW = __spreadArrays$6(allTopNoFW, allBottomNoFW, allMiddleNoFW);
	        var allMiddle = [RowContainerNames.CENTER, RowContainerNames.LEFT, RowContainerNames.RIGHT, RowContainerNames.FULL_WIDTH];
	        var allCenter = [RowContainerNames.CENTER, RowContainerNames.TOP_CENTER, RowContainerNames.BOTTOM_CENTER];
	        var allLeft = [RowContainerNames.LEFT, RowContainerNames.BOTTOM_LEFT, RowContainerNames.TOP_LEFT];
	        var allRight = [RowContainerNames.RIGHT, RowContainerNames.BOTTOM_RIGHT, RowContainerNames.TOP_RIGHT];
	        this.forContainers(allLeft, function () { return _this.createManagedBean(new SetPinnedLeftWidthFeature(_this.eContainer)); });
	        this.forContainers(allRight, function () { return _this.createManagedBean(new SetPinnedRightWidthFeature(_this.eContainer)); });
	        this.forContainers(allMiddle, function () { return _this.createManagedBean(new SetHeightFeature(_this.eContainer, _this.eWrapper)); });
	        this.forContainers(allNoFW, function () { return _this.createManagedBean(new DragListenerFeature(_this.eContainer)); });
	        this.forContainers(allCenter, function () { return _this.createManagedBean(new CenterWidthFeature(function (width) { return _this.eContainer.style.width = width + "px"; })); });
	    };
	    RowContainerController.prototype.onDisplayedColumnsChanged = function () {
	        var _this = this;
	        this.forContainers([RowContainerNames.CENTER], function () { return _this.onHorizontalViewportChanged(); });
	    };
	    RowContainerController.prototype.onDisplayedColumnsWidthChanged = function () {
	        var _this = this;
	        this.forContainers([RowContainerNames.CENTER], function () { return _this.onHorizontalViewportChanged(); });
	    };
	    RowContainerController.prototype.onScrollVisibilityChanged = function () {
	        if (this.name !== RowContainerNames.CENTER) {
	            return;
	        }
	        var visible = this.scrollVisibleService.isHorizontalScrollShowing();
	        var scrollbarWidth = visible ? (this.gridOptionsWrapper.getScrollbarWidth() || 0) : 0;
	        var height = scrollbarWidth == 0 ? '100%' : "calc(100% + " + scrollbarWidth + "px)";
	        this.view.setViewportHeight(height);
	    };
	    // this methods prevents the grid views from being scrolled while the dragService is being used
	    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
	    RowContainerController.prototype.addPreventScrollWhileDragging = function () {
	        var _this = this;
	        var preventScroll = function (e) {
	            if (_this.dragService.isDragging()) {
	                if (e.cancelable) {
	                    e.preventDefault();
	                }
	            }
	        };
	        this.eContainer.addEventListener('touchmove', preventScroll, { passive: false });
	        this.addDestroyFunc(function () { return _this.eContainer.removeEventListener('touchmove', preventScroll); });
	    };
	    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
	    // out the virtual columns again. gets called from following locations:
	    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged, API (doLayout)
	    RowContainerController.prototype.onHorizontalViewportChanged = function () {
	        var scrollWidth = this.getCenterWidth();
	        var scrollPosition = this.getCenterViewportScrollLeft();
	        this.columnController.setViewportPosition(scrollWidth, scrollPosition);
	    };
	    RowContainerController.prototype.getCenterWidth = function () {
	        return getInnerWidth(this.eViewport);
	    };
	    RowContainerController.prototype.getCenterViewportScrollLeft = function () {
	        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
	        return getScrollLeft(this.eViewport, this.enableRtl);
	    };
	    RowContainerController.prototype.registerViewportResizeListener = function (listener) {
	        var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eViewport, listener);
	        this.addDestroyFunc(function () { return unsubscribeFromResize(); });
	    };
	    RowContainerController.prototype.isViewportVisible = function () {
	        return isVisible(this.eViewport);
	    };
	    RowContainerController.prototype.isViewportHScrollShowing = function () {
	        return isHorizontalScrollShowing(this.eViewport);
	    };
	    RowContainerController.prototype.getViewportScrollLeft = function () {
	        return getScrollLeft(this.eViewport, this.enableRtl);
	    };
	    RowContainerController.prototype.isHorizontalScrollShowing = function () {
	        var isAlwaysShowHorizontalScroll = this.gridOptionsWrapper.isAlwaysShowHorizontalScroll();
	        return isAlwaysShowHorizontalScroll || isHorizontalScrollShowing(this.eViewport);
	    };
	    RowContainerController.prototype.getViewportElement = function () {
	        return this.eViewport;
	    };
	    RowContainerController.prototype.setContainerTranslateX = function (amount) {
	        this.eContainer.style.transform = "translateX(" + amount + "px)";
	    };
	    RowContainerController.prototype.getHScrollPosition = function () {
	        var res = {
	            left: this.eViewport.scrollLeft,
	            right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
	        };
	        return res;
	    };
	    RowContainerController.prototype.setCenterViewportScrollLeft = function (value) {
	        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
	        setScrollLeft(this.eViewport, value, this.enableRtl);
	    };
	    __decorate$15([
	        Autowired('scrollVisibleService')
	    ], RowContainerController.prototype, "scrollVisibleService", void 0);
	    __decorate$15([
	        Autowired('dragService')
	    ], RowContainerController.prototype, "dragService", void 0);
	    __decorate$15([
	        Autowired('controllersService')
	    ], RowContainerController.prototype, "controllersService", void 0);
	    __decorate$15([
	        Autowired('columnController')
	    ], RowContainerController.prototype, "columnController", void 0);
	    __decorate$15([
	        Autowired('resizeObserverService')
	    ], RowContainerController.prototype, "resizeObserverService", void 0);
	    __decorate$15([
	        PostConstruct
	    ], RowContainerController.prototype, "postConstruct", null);
	    return RowContainerController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1d = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$16 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var GRID_BODY_TEMPLATE = /* html */ "<div class=\"ag-root ag-unselectable\" role=\"grid\" unselectable=\"on\">\n        <ag-header-root ref=\"headerRoot\" unselectable=\"on\"></ag-header-root>\n        <div class=\"ag-floating-top\" ref=\"eTop\" role=\"presentation\" unselectable=\"on\">\n            <ag-row-container ref=\"topLeftContainer\" name=\"" + RowContainerNames.TOP_LEFT + "\"></ag-row-container>\n            <ag-row-container ref=\"topCenterContainer\" name=\"" + RowContainerNames.TOP_CENTER + "\"></ag-row-container>\n            <ag-row-container ref=\"topRightContainer\" name=\"" + RowContainerNames.TOP_RIGHT + "\"></ag-row-container>\n            <ag-row-container ref=\"topFullWidthContainer\" name=\"" + RowContainerNames.TOP_FULL_WITH + "\"></ag-row-container>\n        </div>\n        <div class=\"ag-body-viewport\" ref=\"eBodyViewport\" role=\"presentation\">\n            <ag-row-container ref=\"leftContainer\" name=\"" + RowContainerNames.LEFT + "\"></ag-row-container>\n            <ag-row-container ref=\"centerContainer\" name=\"" + RowContainerNames.CENTER + "\"></ag-row-container>\n            <ag-row-container ref=\"rightContainer\" name=\"" + RowContainerNames.RIGHT + "\"></ag-row-container>\n            <ag-row-container ref=\"fullWidthContainer\" name=\"" + RowContainerNames.FULL_WIDTH + "\"></ag-row-container>\n        </div>\n        <div class=\"ag-floating-bottom\" ref=\"eBottom\" role=\"presentation\" unselectable=\"on\">\n            <ag-row-container ref=\"bottomLeftContainer\" name=\"" + RowContainerNames.BOTTOM_LEFT + "\"></ag-row-container>\n            <ag-row-container ref=\"bottomCenterContainer\" name=\"" + RowContainerNames.BOTTOM_CENTER + "\"></ag-row-container>\n            <ag-row-container ref=\"bottomRightContainer\" name=\"" + RowContainerNames.BOTTOM_RIGHT + "\"></ag-row-container>\n            <ag-row-container ref=\"bottomFullWidthContainer\" name=\"" + RowContainerNames.BOTTOM_FULL_WITH + "\"></ag-row-container>\n        </div>\n        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>\n        <ag-overlay-wrapper></ag-overlay-wrapper>\n    </div>";
	var GridBodyComp = /** @class */ (function (_super) {
	    __extends$1d(GridBodyComp, _super);
	    function GridBodyComp() {
	        return _super.call(this, GRID_BODY_TEMPLATE) || this;
	    }
	    GridBodyComp.prototype.init = function () {
	        var _this = this;
	        var setHeight = function (height, element) {
	            var heightString = height + "px";
	            element.style.minHeight = heightString;
	            element.style.height = heightString;
	        };
	        var view = {
	            setRowAnimationCssOnBodyViewport: this.setRowAnimationCssOnBodyViewport.bind(this),
	            setColumnCount: function (count) { return setAriaColCount(_this.getGui(), count); },
	            setRowCount: function (count) { return setAriaRowCount(_this.getGui(), count); },
	            setTopHeight: function (height) { return setHeight(height, _this.eTop); },
	            setBottomHeight: function (height) { return setHeight(height, _this.eBottom); },
	            setTopDisplay: function (display) { return _this.eTop.style.display = display; },
	            setBottomDisplay: function (display) { return _this.eBottom.style.display = display; },
	            setColumnMovingCss: function (moving) { return _this.addOrRemoveCssClass(CSS_CLASS_COLUMN_MOVING, moving); },
	            updateLayoutClasses: function (params) {
	                addOrRemoveCssClass(_this.eBodyViewport, exports.LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
	                addOrRemoveCssClass(_this.eBodyViewport, exports.LayoutCssClasses.NORMAL, params.normal);
	                addOrRemoveCssClass(_this.eBodyViewport, exports.LayoutCssClasses.PRINT, params.print);
	                _this.addOrRemoveCssClass(exports.LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
	                _this.addOrRemoveCssClass(exports.LayoutCssClasses.NORMAL, params.normal);
	                _this.addOrRemoveCssClass(exports.LayoutCssClasses.PRINT, params.print);
	            },
	            setAlwaysVerticalScrollClass: function (on) {
	                return addOrRemoveCssClass(_this.eBodyViewport, CSS_CLASS_FORCE_VERTICAL_SCROLL, on);
	            },
	            registerBodyViewportResizeListener: function (listener) {
	                var unsubscribeFromResize = _this.resizeObserverService.observeResize(_this.eBodyViewport, listener);
	                _this.addDestroyFunc(function () { return unsubscribeFromResize(); });
	            },
	            setVerticalScrollPaddingVisible: function (show) {
	                var scroller = show ? 'scroll' : 'hidden';
	                _this.eTop.style.overflowY = _this.eBottom.style.overflowY = scroller;
	            },
	            setCellSelectableCss: function (selectable) {
	                [_this.eTop, _this.eBodyViewport, _this.eBottom]
	                    .forEach(function (ct) { return addOrRemoveCssClass(ct, CSS_CLASS_CELL_SELECTABLE, selectable); });
	            },
	        };
	        this.controller = this.createManagedBean(new GridBodyController());
	        this.controller.setView(view, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom);
	        if (this.$scope) {
	            this.addAngularApplyCheck();
	        }
	        this.gridApi.registerGridComp(this);
	        this.beans.registerGridComp(this);
	        if (this.contextMenuFactory) {
	            this.contextMenuFactory.registerGridComp(this);
	        }
	        if (this.menuFactory) {
	            this.menuFactory.registerGridComp(this);
	        }
	        if (this.rangeController || this.gridOptionsWrapper.isRowSelectionMulti()) {
	            setAriaMultiSelectable(this.getGui(), true);
	            if (this.rangeController) {
	                this.rangeController.registerGridComp(this);
	            }
	        }
	        [this.eTop, this.eBodyViewport, this.eBottom].forEach(function (element) {
	            _this.addManagedListener(element, 'focusin', function () {
	                addCssClass(element, 'ag-has-focus');
	            });
	            _this.addManagedListener(element, 'focusout', function (e) {
	                if (!element.contains(e.relatedTarget)) {
	                    removeCssClass(element, 'ag-has-focus');
	                }
	            });
	        });
	    };
	    GridBodyComp.prototype.setRowAnimationCssOnBodyViewport = function (animateRows) {
	        addOrRemoveCssClass(this.eBodyViewport, RowAnimationCssClasses.ANIMATION_ON, animateRows);
	        addOrRemoveCssClass(this.eBodyViewport, RowAnimationCssClasses.ANIMATION_OFF, !animateRows);
	    };
	    GridBodyComp.prototype.addAngularApplyCheck = function () {
	        var _this = this;
	        // this makes sure if we queue up requests, we only execute oe
	        var applyTriggered = false;
	        var listener = function () {
	            // only need to do one apply at a time
	            if (applyTriggered) {
	                return;
	            }
	            applyTriggered = true; // mark 'need apply' to true
	            window.setTimeout(function () {
	                applyTriggered = false;
	                _this.$scope.$apply();
	            }, 0);
	        };
	        // these are the events we need to do an apply after - these are the ones that can end up
	        // with columns added or removed
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
	        this.addManagedListener(this.eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, listener);
	    };
	    GridBodyComp.prototype.getFloatingTopBottom = function () {
	        return [this.eTop, this.eBottom];
	    };
	    // + rangeController
	    GridBodyComp.prototype.addScrollEventListener = function (listener) {
	        this.eBodyViewport.addEventListener('scroll', listener);
	    };
	    // + rangeController
	    GridBodyComp.prototype.removeScrollEventListener = function (listener) {
	        this.eBodyViewport.removeEventListener('scroll', listener);
	    };
	    __decorate$16([
	        Autowired('beans')
	    ], GridBodyComp.prototype, "beans", void 0);
	    __decorate$16([
	        Autowired('gridApi')
	    ], GridBodyComp.prototype, "gridApi", void 0);
	    __decorate$16([
	        Autowired('$scope')
	    ], GridBodyComp.prototype, "$scope", void 0);
	    __decorate$16([
	        Autowired('resizeObserverService')
	    ], GridBodyComp.prototype, "resizeObserverService", void 0);
	    __decorate$16([
	        Optional('rangeController')
	    ], GridBodyComp.prototype, "rangeController", void 0);
	    __decorate$16([
	        Optional('contextMenuFactory')
	    ], GridBodyComp.prototype, "contextMenuFactory", void 0);
	    __decorate$16([
	        Optional('menuFactory')
	    ], GridBodyComp.prototype, "menuFactory", void 0);
	    __decorate$16([
	        RefSelector('eBodyViewport')
	    ], GridBodyComp.prototype, "eBodyViewport", void 0);
	    __decorate$16([
	        RefSelector('eTop')
	    ], GridBodyComp.prototype, "eTop", void 0);
	    __decorate$16([
	        RefSelector('eBottom')
	    ], GridBodyComp.prototype, "eBottom", void 0);
	    __decorate$16([
	        RefSelector('headerRoot')
	    ], GridBodyComp.prototype, "headerRootComp", void 0);
	    __decorate$16([
	        PostConstruct
	    ], GridBodyComp.prototype, "init", null);
	    return GridBodyComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (ExcelFactoryMode) {
	    ExcelFactoryMode[ExcelFactoryMode["SINGLE_SHEET"] = 0] = "SINGLE_SHEET";
	    ExcelFactoryMode[ExcelFactoryMode["MULTI_SHEET"] = 1] = "MULTI_SHEET";
	})(exports.ExcelFactoryMode || (exports.ExcelFactoryMode = {}));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (ClientSideRowModelSteps) {
	    ClientSideRowModelSteps["EVERYTHING"] = "group";
	    ClientSideRowModelSteps["FILTER"] = "filter";
	    ClientSideRowModelSteps["SORT"] = "sort";
	    ClientSideRowModelSteps["MAP"] = "map";
	    ClientSideRowModelSteps["AGGREGATE"] = "aggregate";
	    ClientSideRowModelSteps["PIVOT"] = "pivot";
	    ClientSideRowModelSteps["NOTHING"] = "nothing";
	})(exports.ClientSideRowModelSteps || (exports.ClientSideRowModelSteps = {}));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$17 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var GridApi = /** @class */ (function () {
	    function GridApi() {
	        this.detailGridInfoMap = {};
	        this.destroyCalled = false;
	    }
	    GridApi.prototype.registerGridComp = function (gridBodyComp) {
	        this.gridBodyComp = gridBodyComp;
	    };
	    GridApi.prototype.registerOverlayWrapperComp = function (overlayWrapperComp) {
	        this.overlayWrapperComp = overlayWrapperComp;
	    };
	    GridApi.prototype.registerGridCompController = function (gridCompController) {
	        this.gridCompController = gridCompController;
	    };
	    GridApi.prototype.registerHeaderRootComp = function (headerRootComp) {
	        this.headerRootComp = headerRootComp;
	    };
	    GridApi.prototype.registerSideBarComp = function (sideBarComp) {
	        this.sideBarComp = sideBarComp;
	    };
	    GridApi.prototype.init = function () {
	        var _this = this;
	        switch (this.rowModel.getType()) {
	            case Constants.ROW_MODEL_TYPE_CLIENT_SIDE:
	                this.clientSideRowModel = this.rowModel;
	                break;
	            case Constants.ROW_MODEL_TYPE_INFINITE:
	                this.infiniteRowModel = this.rowModel;
	                break;
	            case Constants.ROW_MODEL_TYPE_SERVER_SIDE:
	                this.serverSideRowModel = this.rowModel;
	                break;
	        }
	        this.controllersService.whenReady(function () {
	            _this.gridBodyCon = _this.controllersService.getGridBodyController();
	        });
	    };
	    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
	    GridApi.prototype.__getAlignedGridService = function () {
	        return this.alignedGridsService;
	    };
	    GridApi.prototype.addDetailGridInfo = function (id, gridInfo) {
	        this.detailGridInfoMap[id] = gridInfo;
	    };
	    GridApi.prototype.removeDetailGridInfo = function (id) {
	        this.detailGridInfoMap[id] = undefined;
	    };
	    GridApi.prototype.getDetailGridInfo = function (id) {
	        return this.detailGridInfoMap[id];
	    };
	    GridApi.prototype.forEachDetailGridInfo = function (callback) {
	        var index = 0;
	        iterateObject(this.detailGridInfoMap, function (id, gridInfo) {
	            // check for undefined, as old references will still be lying around
	            if (exists(gridInfo)) {
	                callback(gridInfo, index);
	                index++;
	            }
	        });
	    };
	    GridApi.prototype.getDataAsCsv = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.CsvExportModule, 'api.getDataAsCsv')) {
	            return this.csvCreator.getDataAsCsv(params);
	        }
	    };
	    GridApi.prototype.exportDataAsCsv = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.CsvExportModule, 'api.exportDataAsCSv')) {
	            this.csvCreator.exportDataAsCsv(params);
	        }
	    };
	    GridApi.prototype.getDataAsExcel = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.ExcelExportModule, 'api.getDataAsExcel')) {
	            var exportMode = (params && params.exportMode) || 'xlsx';
	            if (this.excelCreator.getFactoryMode(exportMode) === exports.ExcelFactoryMode.MULTI_SHEET) {
	                console.warn('AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling `api.getMultipleSheetAsExcel()` or `api.exportMultipleSheetsAsExcel()`');
	                return;
	            }
	            return this.excelCreator.getDataAsExcel(params);
	        }
	    };
	    GridApi.prototype.exportDataAsExcel = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.ExcelExportModule, 'api.exportDataAsExcel')) {
	            var exportMode = (params && params.exportMode) || 'xlsx';
	            if (this.excelCreator.getFactoryMode(exportMode) === exports.ExcelFactoryMode.MULTI_SHEET) {
	                console.warn('AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling `api.getMultipleSheetAsExcel()` or `api.exportMultipleSheetsAsExcel()`');
	                return;
	            }
	            this.excelCreator.exportDataAsExcel(params);
	        }
	    };
	    GridApi.prototype.getSheetDataForExcel = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.ExcelExportModule, 'api.getSheetDataForExcel')) {
	            var exportMode = (params && params.exportMode) || 'xlsx';
	            this.excelCreator.setFactoryMode(exports.ExcelFactoryMode.MULTI_SHEET, exportMode);
	            return this.excelCreator.getSheetDataForExcel(params);
	        }
	    };
	    GridApi.prototype.getMultipleSheetsAsExcel = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.ExcelExportModule, 'api.getMultipleSheetsAsExcel')) {
	            return this.excelCreator.getMultipleSheetsAsExcel(params);
	        }
	    };
	    GridApi.prototype.exportMultipleSheetsAsExcel = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.ExcelExportModule, 'api.exportMultipleSheetsAsExcel')) {
	            return this.excelCreator.exportMultipleSheetsAsExcel(params);
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.setEnterpriseDatasource = function (datasource) {
	        console.warn("ag-grid: since version 18.x, api.setEnterpriseDatasource() should be replaced with api.setServerSideDatasource()");
	        this.setServerSideDatasource(datasource);
	    };
	    GridApi.prototype.setGridAriaProperty = function (property, value) {
	        if (!property) {
	            return;
	        }
	        var eGrid = this.gridBodyComp.getGui();
	        var ariaProperty = "aria-" + property;
	        if (value === null) {
	            eGrid.removeAttribute(ariaProperty);
	        }
	        else {
	            eGrid.setAttribute(ariaProperty, value);
	        }
	    };
	    GridApi.prototype.setServerSideDatasource = function (datasource) {
	        if (this.serverSideRowModel) {
	            // should really have an IEnterpriseRowModel interface, so we are not casting to any
	            this.serverSideRowModel.setDatasource(datasource);
	        }
	        else {
	            console.warn("AG Grid: you can only use an enterprise datasource when gridOptions.rowModelType is '" + Constants.ROW_MODEL_TYPE_SERVER_SIDE + "'");
	        }
	    };
	    GridApi.prototype.setDatasource = function (datasource) {
	        if (this.gridOptionsWrapper.isRowModelInfinite()) {
	            this.rowModel.setDatasource(datasource);
	        }
	        else {
	            console.warn("AG Grid: you can only use a datasource when gridOptions.rowModelType is '" + Constants.ROW_MODEL_TYPE_INFINITE + "'");
	        }
	    };
	    GridApi.prototype.setViewportDatasource = function (viewportDatasource) {
	        if (this.gridOptionsWrapper.isRowModelViewport()) {
	            // this is bad coding, because it's using an interface that's exposed in the enterprise.
	            // really we should create an interface in the core for viewportDatasource and let
	            // the enterprise implement it, rather than casting to 'any' here
	            this.rowModel.setViewportDatasource(viewportDatasource);
	        }
	        else {
	            console.warn("AG Grid: you can only use a viewport datasource when gridOptions.rowModelType is '" + Constants.ROW_MODEL_TYPE_VIEWPORT + "'");
	        }
	    };
	    GridApi.prototype.setRowData = function (rowData) {
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            if (this.gridOptionsWrapper.isImmutableData()) {
	                var transactionAndMap = this.immutableService.createTransactionForRowData(rowData);
	                if (!transactionAndMap) {
	                    return;
	                }
	                var transaction = transactionAndMap[0], orderIdMap = transactionAndMap[1];
	                var nodeTransaction = this.clientSideRowModel.updateRowData(transaction, orderIdMap);
	                // need to force updating of full width rows - note this wouldn't be necessary the full width cell comp listened
	                // to the data change event on the row node and refreshed itself.
	                if (nodeTransaction) {
	                    this.rowRenderer.refreshFullWidthRows(nodeTransaction.update);
	                }
	            }
	            else {
	                this.selectionController.reset();
	                this.clientSideRowModel.setRowData(rowData);
	            }
	        }
	        else {
	            console.warn('cannot call setRowData unless using normal row model');
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.setFloatingTopRowData = function (rows) {
	        console.warn('AG Grid: since v12, api.setFloatingTopRowData() is now api.setPinnedTopRowData()');
	        this.setPinnedTopRowData(rows);
	    };
	    /** @deprecated */
	    GridApi.prototype.setFloatingBottomRowData = function (rows) {
	        console.warn('AG Grid: since v12, api.setFloatingBottomRowData() is now api.setPinnedBottomRowData()');
	        this.setPinnedBottomRowData(rows);
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingTopRowCount = function () {
	        console.warn('AG Grid: since v12, api.getFloatingTopRowCount() is now api.getPinnedTopRowCount()');
	        return this.getPinnedTopRowCount();
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingBottomRowCount = function () {
	        console.warn('AG Grid: since v12, api.getFloatingBottomRowCount() is now api.getPinnedBottomRowCount()');
	        return this.getPinnedBottomRowCount();
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingTopRow = function (index) {
	        console.warn('AG Grid: since v12, api.getFloatingTopRow() is now api.getPinnedTopRow()');
	        return this.getPinnedTopRow(index);
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingBottomRow = function (index) {
	        console.warn('AG Grid: since v12, api.getFloatingBottomRow() is now api.getPinnedBottomRow()');
	        return this.getPinnedBottomRow(index);
	    };
	    GridApi.prototype.setPinnedTopRowData = function (rows) {
	        this.pinnedRowModel.setPinnedTopRowData(rows);
	    };
	    GridApi.prototype.setPinnedBottomRowData = function (rows) {
	        this.pinnedRowModel.setPinnedBottomRowData(rows);
	    };
	    GridApi.prototype.getPinnedTopRowCount = function () {
	        return this.pinnedRowModel.getPinnedTopRowCount();
	    };
	    GridApi.prototype.getPinnedBottomRowCount = function () {
	        return this.pinnedRowModel.getPinnedBottomRowCount();
	    };
	    GridApi.prototype.getPinnedTopRow = function (index) {
	        return this.pinnedRowModel.getPinnedTopRow(index);
	    };
	    GridApi.prototype.getPinnedBottomRow = function (index) {
	        return this.pinnedRowModel.getPinnedBottomRow(index);
	    };
	    GridApi.prototype.setColumnDefs = function (colDefs, source) {
	        if (source === void 0) { source = "api"; }
	        this.columnController.setColumnDefs(colDefs, source);
	    };
	    GridApi.prototype.setAutoGroupColumnDef = function (colDef, source) {
	        this.gridOptionsWrapper.setProperty('autoGroupColumnDef', colDef, true);
	    };
	    GridApi.prototype.expireValueCache = function () {
	        this.valueCache.expire();
	    };
	    GridApi.prototype.getVerticalPixelRange = function () {
	        return this.gridBodyCon.getScrollFeature().getVScrollPosition();
	    };
	    GridApi.prototype.getHorizontalPixelRange = function () {
	        return this.gridBodyCon.getScrollFeature().getHScrollPosition();
	    };
	    GridApi.prototype.setAlwaysShowHorizontalScroll = function (show) {
	        this.gridOptionsWrapper.setProperty('alwaysShowHorizontalScroll', show);
	    };
	    GridApi.prototype.setAlwaysShowVerticalScroll = function (show) {
	        this.gridOptionsWrapper.setProperty('alwaysShowVerticalScroll', show);
	    };
	    GridApi.prototype.refreshToolPanel = function () {
	        if (!this.sideBarComp) {
	            return;
	        }
	        this.sideBarComp.refresh();
	    };
	    GridApi.prototype.refreshCells = function (params) {
	        if (params === void 0) { params = {}; }
	        if (Array.isArray(params)) {
	            // the old version of refreshCells() took an array of rowNodes for the first argument
	            console.warn('since AG Grid v11.1, refreshCells() now takes parameters, please see the documentation.');
	            return;
	        }
	        this.rowRenderer.refreshCells(params);
	    };
	    GridApi.prototype.flashCells = function (params) {
	        if (params === void 0) { params = {}; }
	        this.rowRenderer.flashCells(params);
	    };
	    GridApi.prototype.redrawRows = function (params) {
	        if (params === void 0) { params = {}; }
	        var rowNodes = params ? params.rowNodes : undefined;
	        this.rowRenderer.redrawRows(rowNodes);
	    };
	    /** @deprecated */
	    GridApi.prototype.refreshView = function () {
	        console.warn('AG Grid: since v11.1, refreshView() is deprecated, please call refreshCells() or redrawRows() instead');
	        this.redrawRows();
	    };
	    /** @deprecated */
	    GridApi.prototype.refreshRows = function (rowNodes) {
	        console.warn('since AG Grid v11.1, refreshRows() is deprecated, please use refreshCells({rowNodes: rows}) or redrawRows({rowNodes: rows}) instead');
	        this.refreshCells({ rowNodes: rowNodes });
	    };
	    /** @deprecated */
	    GridApi.prototype.rowDataChanged = function (rows) {
	        console.warn('AG Grid: rowDataChanged is deprecated, either call refreshView() to refresh everything, or call rowNode.setRowData(newData) to set value on a particular node');
	        this.redrawRows();
	    };
	    /** @deprecated */
	    GridApi.prototype.softRefreshView = function () {
	        console.error('AG Grid: since v16, softRefreshView() is no longer supported. Please check the documentation on how to refresh.');
	    };
	    /** @deprecated */
	    GridApi.prototype.refreshGroupRows = function () {
	        console.warn('AG Grid: since v11.1, refreshGroupRows() is no longer supported, call refreshCells() instead. ' +
	            'Because refreshCells() now does dirty checking, it will only refresh cells that have changed, so it should ' +
	            'not be necessary to only refresh the group rows.');
	        this.refreshCells();
	    };
	    GridApi.prototype.setFunctionsReadOnly = function (readOnly) {
	        this.gridOptionsWrapper.setProperty('functionsReadOnly', readOnly);
	    };
	    GridApi.prototype.refreshHeader = function () {
	        this.headerRootComp.refreshHeader();
	    };
	    GridApi.prototype.isAnyFilterPresent = function () {
	        return this.filterManager.isAnyFilterPresent();
	    };
	    /** @deprecated */
	    GridApi.prototype.isAdvancedFilterPresent = function () {
	        console.warn('AG Grid: isAdvancedFilterPresent() is deprecated, please use isColumnFilterPresent()');
	        return this.isColumnFilterPresent();
	    };
	    GridApi.prototype.isColumnFilterPresent = function () {
	        return this.filterManager.isAdvancedFilterPresent();
	    };
	    GridApi.prototype.isQuickFilterPresent = function () {
	        return this.filterManager.isQuickFilterPresent();
	    };
	    GridApi.prototype.getModel = function () {
	        return this.rowModel;
	    };
	    GridApi.prototype.setRowNodeExpanded = function (rowNode, expanded) {
	        if (rowNode) {
	            rowNode.setExpanded(expanded);
	        }
	    };
	    GridApi.prototype.onGroupExpandedOrCollapsed = function (deprecated_refreshFromIndex) {
	        if (missing(this.clientSideRowModel)) {
	            console.warn('AG Grid: cannot call onGroupExpandedOrCollapsed unless using normal row model');
	        }
	        if (exists(deprecated_refreshFromIndex)) {
	            console.warn('AG Grid: api.onGroupExpandedOrCollapsed - refreshFromIndex parameter is no longer used, the grid will refresh all rows');
	        }
	        // we don't really want the user calling this if only one rowNode was expanded, instead they should be
	        // calling rowNode.setExpanded(boolean) - this way we do a 'keepRenderedRows=false' so that the whole
	        // grid gets refreshed again - otherwise the row with the rowNodes that were changed won't get updated,
	        // and thus the expand icon in the group cell won't get 'opened' or 'closed'.
	        this.clientSideRowModel.refreshModel({ step: exports.ClientSideRowModelSteps.MAP });
	    };
	    GridApi.prototype.refreshInMemoryRowModel = function (step) {
	        console.warn("ag-grid: since version 18.x, api.refreshInMemoryRowModel() should be replaced with api.refreshClientSideRowModel()");
	        this.refreshClientSideRowModel(step);
	    };
	    GridApi.prototype.refreshClientSideRowModel = function (step) {
	        if (missing(this.clientSideRowModel)) {
	            console.warn('cannot call refreshClientSideRowModel unless using normal row model');
	        }
	        var paramsStep = exports.ClientSideRowModelSteps.EVERYTHING;
	        var stepsMapped = {
	            group: exports.ClientSideRowModelSteps.EVERYTHING,
	            filter: exports.ClientSideRowModelSteps.FILTER,
	            map: exports.ClientSideRowModelSteps.MAP,
	            aggregate: exports.ClientSideRowModelSteps.AGGREGATE,
	            sort: exports.ClientSideRowModelSteps.SORT,
	            pivot: exports.ClientSideRowModelSteps.PIVOT
	        };
	        if (exists(step)) {
	            paramsStep = stepsMapped[step];
	        }
	        if (missing(paramsStep)) {
	            console.error("AG Grid: invalid step " + step + ", available steps are " + Object.keys(stepsMapped).join(', '));
	            return;
	        }
	        var modelParams = {
	            step: paramsStep,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        };
	        this.clientSideRowModel.refreshModel(modelParams);
	    };
	    GridApi.prototype.isAnimationFrameQueueEmpty = function () {
	        return this.animationFrameService.isQueueEmpty();
	    };
	    GridApi.prototype.getRowNode = function (id) {
	        return this.rowModel.getRowNode(id);
	    };
	    GridApi.prototype.getSizesForCurrentTheme = function () {
	        return {
	            rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
	            headerHeight: this.gridOptionsWrapper.getHeaderHeight()
	        };
	    };
	    GridApi.prototype.expandAll = function () {
	        if (this.clientSideRowModel) {
	            this.clientSideRowModel.expandOrCollapseAll(true);
	        }
	        else if (this.serverSideRowModel) {
	            this.serverSideRowModel.expandAll(true);
	        }
	        else {
	            console.warn('AG Grid: expandAll only works with Client Side Row Model and Server Side Row Model');
	        }
	    };
	    GridApi.prototype.collapseAll = function () {
	        if (this.clientSideRowModel) {
	            this.clientSideRowModel.expandOrCollapseAll(false);
	        }
	        else if (this.serverSideRowModel) {
	            this.serverSideRowModel.expandAll(false);
	        }
	        else {
	            console.warn('AG Grid: collapseAll only works with Client Side Row Model and Server Side Row Model');
	        }
	    };
	    GridApi.prototype.getToolPanelInstance = function (id) {
	        if (!this.sideBarComp) {
	            console.warn('AG Grid: toolPanel is only available in AG Grid Enterprise');
	            return;
	        }
	        return this.sideBarComp.getToolPanelInstance(id);
	    };
	    GridApi.prototype.addVirtualRowListener = function (eventName, rowIndex, callback) {
	        if (typeof eventName !== 'string') {
	            console.warn('AG Grid: addVirtualRowListener is deprecated, please use addRenderedRowListener.');
	        }
	        this.addRenderedRowListener(eventName, rowIndex, callback);
	    };
	    GridApi.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
	        if (eventName === 'virtualRowSelected') {
	            console.warn("AG Grid: event virtualRowSelected is deprecated, to register for individual row\n                selection events, add a listener directly to the row node.");
	        }
	        this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
	    };
	    GridApi.prototype.setQuickFilter = function (newFilter) {
	        this.filterManager.setQuickFilter(newFilter);
	    };
	    GridApi.prototype.selectIndex = function (index, tryMulti, suppressEvents) {
	        console.warn('AG Grid: do not use api for selection, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        this.selectionController.selectIndex(index, tryMulti);
	    };
	    GridApi.prototype.deselectIndex = function (index, suppressEvents) {
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('AG Grid: do not use api for selection, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        this.selectionController.deselectIndex(index);
	    };
	    GridApi.prototype.selectNode = function (node, tryMulti, suppressEvents) {
	        if (tryMulti === void 0) { tryMulti = false; }
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('AG Grid: API for selection is deprecated, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        node.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
	    };
	    GridApi.prototype.deselectNode = function (node, suppressEvents) {
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('AG Grid: API for selection is deprecated, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        node.setSelectedParams({ newValue: false });
	    };
	    GridApi.prototype.selectAll = function () {
	        this.selectionController.selectAllRowNodes();
	    };
	    GridApi.prototype.deselectAll = function () {
	        this.selectionController.deselectAllRowNodes();
	    };
	    GridApi.prototype.selectAllFiltered = function () {
	        this.selectionController.selectAllRowNodes(true);
	    };
	    GridApi.prototype.deselectAllFiltered = function () {
	        this.selectionController.deselectAllRowNodes(true);
	    };
	    GridApi.prototype.recomputeAggregates = function () {
	        if (missing(this.clientSideRowModel)) {
	            console.warn('cannot call recomputeAggregates unless using normal row model');
	        }
	        console.warn("recomputeAggregates is deprecated, please call api.refreshClientSideRowModel('aggregate') instead");
	        this.clientSideRowModel.refreshModel({ step: exports.ClientSideRowModelSteps.AGGREGATE });
	    };
	    GridApi.prototype.sizeColumnsToFit = function () {
	        this.gridBodyCon.sizeColumnsToFit();
	    };
	    GridApi.prototype.showLoadingOverlay = function () {
	        this.overlayWrapperComp.showLoadingOverlay();
	    };
	    GridApi.prototype.showNoRowsOverlay = function () {
	        this.overlayWrapperComp.showNoRowsOverlay();
	    };
	    GridApi.prototype.hideOverlay = function () {
	        this.overlayWrapperComp.hideOverlay();
	    };
	    GridApi.prototype.isNodeSelected = function (node) {
	        console.warn('AG Grid: no need to call api.isNodeSelected(), just call node.isSelected() instead');
	        return node.isSelected();
	    };
	    GridApi.prototype.getSelectedNodesById = function () {
	        console.error('AG Grid: since version 3.4, getSelectedNodesById no longer exists, use getSelectedNodes() instead');
	        return null;
	    };
	    GridApi.prototype.getSelectedNodes = function () {
	        return this.selectionController.getSelectedNodes();
	    };
	    GridApi.prototype.getSelectedRows = function () {
	        return this.selectionController.getSelectedRows();
	    };
	    GridApi.prototype.getBestCostNodeSelection = function () {
	        return this.selectionController.getBestCostNodeSelection();
	    };
	    GridApi.prototype.getRenderedNodes = function () {
	        return this.rowRenderer.getRenderedNodes();
	    };
	    GridApi.prototype.ensureColIndexVisible = function (index) {
	        console.warn('AG Grid: ensureColIndexVisible(index) no longer supported, use ensureColumnVisible(colKey) instead.');
	    };
	    GridApi.prototype.ensureColumnVisible = function (key) {
	        this.gridBodyCon.getScrollFeature().ensureColumnVisible(key);
	    };
	    // Valid values for position are bottom, middle and top
	    GridApi.prototype.ensureIndexVisible = function (index, position) {
	        this.gridBodyCon.getScrollFeature().ensureIndexVisible(index, position);
	    };
	    // Valid values for position are bottom, middle and top
	    GridApi.prototype.ensureNodeVisible = function (comparator, position) {
	        if (position === void 0) { position = null; }
	        this.gridBodyCon.getScrollFeature().ensureNodeVisible(comparator, position);
	    };
	    GridApi.prototype.forEachLeafNode = function (callback) {
	        if (missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNode unless using normal row model');
	        }
	        this.clientSideRowModel.forEachLeafNode(callback);
	    };
	    GridApi.prototype.forEachNode = function (callback) {
	        this.rowModel.forEachNode(callback);
	    };
	    GridApi.prototype.forEachNodeAfterFilter = function (callback) {
	        if (missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNodeAfterFilter unless using normal row model');
	        }
	        this.clientSideRowModel.forEachNodeAfterFilter(callback);
	    };
	    GridApi.prototype.forEachNodeAfterFilterAndSort = function (callback) {
	        if (missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNodeAfterFilterAndSort unless using normal row model');
	        }
	        this.clientSideRowModel.forEachNodeAfterFilterAndSort(callback);
	    };
	    GridApi.prototype.getFilterApiForColDef = function (colDef) {
	        console.warn('ag-grid API method getFilterApiForColDef deprecated, use getFilterInstance instead');
	        return this.getFilterInstance(colDef);
	    };
	    GridApi.prototype.getFilterInstance = function (key, callback) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            var filterPromise = this.filterManager.getFilterComponent(column, 'NO_UI');
	            var currentValue = filterPromise && filterPromise.resolveNow(null, function (filterComp) { return filterComp; });
	            if (callback) {
	                if (currentValue) {
	                    setTimeout(callback, 0, currentValue);
	                }
	                else if (filterPromise) {
	                    filterPromise.then(callback);
	                }
	            }
	            return currentValue;
	        }
	    };
	    GridApi.prototype.getFilterApi = function (key) {
	        console.warn('AG Grid: getFilterApi is deprecated, use getFilterInstance instead');
	        return this.getFilterInstance(key);
	    };
	    GridApi.prototype.destroyFilter = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return this.filterManager.destroyFilter(column, "filterDestroyed");
	        }
	    };
	    GridApi.prototype.getStatusPanel = function (key) {
	        if (this.statusBarService) {
	            return this.statusBarService.getStatusPanel(key);
	        }
	    };
	    GridApi.prototype.getColumnDef = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return column.getColDef();
	        }
	        return null;
	    };
	    GridApi.prototype.getColumnDefs = function () { return this.columnController.getColumnDefs(); };
	    GridApi.prototype.onFilterChanged = function () {
	        this.filterManager.onFilterChanged();
	    };
	    GridApi.prototype.onSortChanged = function () {
	        this.sortController.onSortChanged();
	    };
	    GridApi.prototype.setSortModel = function (sortModel, source) {
	        console.warn('AG Grid: as of version 24.0.0, setSortModel() is deprecated, sort information is now part of Column State. Please use columnApi.applyColumnState() instead.');
	        var columnState = [];
	        if (sortModel) {
	            sortModel.forEach(function (item, index) {
	                columnState.push({
	                    colId: item.colId,
	                    sort: item.sort,
	                    sortIndex: index
	                });
	            });
	        }
	        this.columnController.applyColumnState({ state: columnState, defaultState: { sort: null } });
	    };
	    GridApi.prototype.getSortModel = function () {
	        console.warn('AG Grid: as of version 24.0.0, getSortModel() is deprecated, sort information is now part of Column State. Please use columnApi.getColumnState() instead.');
	        var columnState = this.columnController.getColumnState();
	        var filteredStates = columnState.filter(function (item) { return item.sort != null; });
	        var indexes = {};
	        filteredStates.forEach(function (state) {
	            var id = state.colId;
	            var sortIndex = state.sortIndex;
	            indexes[id] = sortIndex;
	        });
	        var res = filteredStates.map(function (s) {
	            return { colId: s.colId, sort: s.sort };
	        });
	        res.sort(function (a, b) { return indexes[a.colId] - indexes[b.colId]; });
	        return res;
	    };
	    GridApi.prototype.setFilterModel = function (model) {
	        this.filterManager.setFilterModel(model);
	    };
	    GridApi.prototype.getFilterModel = function () {
	        return this.filterManager.getFilterModel();
	    };
	    GridApi.prototype.getFocusedCell = function () {
	        return this.focusController.getFocusedCell();
	    };
	    GridApi.prototype.clearFocusedCell = function () {
	        return this.focusController.clearFocusedCell();
	    };
	    GridApi.prototype.setFocusedCell = function (rowIndex, colKey, floating) {
	        this.focusController.setFocusedCell(rowIndex, colKey, floating, true);
	    };
	    GridApi.prototype.setSuppressRowDrag = function (value) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG, value);
	    };
	    GridApi.prototype.setSuppressMoveWhenRowDragging = function (value) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_MOVE_WHEN_ROW_DRAG, value);
	    };
	    GridApi.prototype.setSuppressRowClickSelection = function (value) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_ROW_CLICK_SELECTION, value);
	    };
	    GridApi.prototype.addRowDropZone = function (params) {
	        this.gridBodyCon.getRowDragFeature().addRowDropZone(params);
	    };
	    GridApi.prototype.removeRowDropZone = function (params) {
	        var activeDropTarget = this.dragAndDropService.findExternalZone(params);
	        if (activeDropTarget) {
	            this.dragAndDropService.removeDropTarget(activeDropTarget);
	        }
	    };
	    GridApi.prototype.getRowDropZoneParams = function (events) {
	        return this.gridBodyCon.getRowDragFeature().getRowDropZone(events);
	    };
	    GridApi.prototype.setHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_HEADER_HEIGHT, headerHeight);
	    };
	    GridApi.prototype.setDomLayout = function (domLayout) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_DOM_LAYOUT, domLayout);
	    };
	    GridApi.prototype.setEnableCellTextSelection = function (selectable) {
	        this.gridBodyCon.setCellTextSelection(selectable);
	    };
	    GridApi.prototype.setFillHandleDirection = function (direction) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_FILL_HANDLE_DIRECTION, direction);
	    };
	    GridApi.prototype.setGroupHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, headerHeight);
	    };
	    GridApi.prototype.setFloatingFiltersHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, headerHeight);
	    };
	    GridApi.prototype.setPivotGroupHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, headerHeight);
	    };
	    GridApi.prototype.setIsExternalFilterPresent = function (isExternalFilterPresentFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_EXTERNAL_FILTER_PRESENT, isExternalFilterPresentFunc);
	    };
	    GridApi.prototype.setDoesExternalFilterPass = function (doesExternalFilterPassFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_DOES_EXTERNAL_FILTER_PASS, doesExternalFilterPassFunc);
	    };
	    GridApi.prototype.setNavigateToNextCell = function (navigateToNextCellFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_CELL, navigateToNextCellFunc);
	    };
	    GridApi.prototype.setTabToNextCell = function (tabToNextCellFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_TAB_TO_NEXT_CELL, tabToNextCellFunc);
	    };
	    GridApi.prototype.setTabToNextHeader = function (tabToNextHeaderFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_TAB_TO_NEXT_HEADER, tabToNextHeaderFunc);
	    };
	    GridApi.prototype.setNavigateToNextHeader = function (navigateToNextHeaderFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_HEADER, navigateToNextHeaderFunc);
	    };
	    GridApi.prototype.setGroupRowAggNodes = function (groupRowAggNodesFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_ROW_AGG_NODES, groupRowAggNodesFunc);
	    };
	    GridApi.prototype.setGetBusinessKeyForNode = function (getBusinessKeyForNodeFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_BUSINESS_KEY_FOR_NODE, getBusinessKeyForNodeFunc);
	    };
	    GridApi.prototype.setGetChildCount = function (getChildCountFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_CHILD_COUNT, getChildCountFunc);
	    };
	    GridApi.prototype.setProcessRowPostCreate = function (processRowPostCreateFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_ROW_POST_CREATE, processRowPostCreateFunc);
	    };
	    GridApi.prototype.setGetRowNodeId = function (getRowNodeIdFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_NODE_ID, getRowNodeIdFunc);
	    };
	    GridApi.prototype.setGetRowClass = function (rowClassFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_CLASS, rowClassFunc);
	    };
	    GridApi.prototype.setIsFullWidthCell = function (isFullWidthCellFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_FULL_WIDTH_CELL, isFullWidthCellFunc);
	    };
	    GridApi.prototype.setIsRowSelectable = function (isRowSelectableFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_ROW_SELECTABLE, isRowSelectableFunc);
	    };
	    GridApi.prototype.setIsRowMaster = function (isRowMasterFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_ROW_MASTER, isRowMasterFunc);
	    };
	    GridApi.prototype.setPostSort = function (postSortFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_POST_SORT, postSortFunc);
	    };
	    GridApi.prototype.setGetDocument = function (getDocumentFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_DOCUMENT, getDocumentFunc);
	    };
	    GridApi.prototype.setGetContextMenuItems = function (getContextMenuItemsFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_CONTEXT_MENU_ITEMS, getContextMenuItemsFunc);
	    };
	    GridApi.prototype.setGetMainMenuItems = function (getMainMenuItemsFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_MAIN_MENU_ITEMS, getMainMenuItemsFunc);
	    };
	    GridApi.prototype.setProcessCellForClipboard = function (processCellForClipboardFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_CELL_FOR_CLIPBOARD, processCellForClipboardFunc);
	    };
	    GridApi.prototype.setSendToClipboard = function (sendToClipboardFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SEND_TO_CLIPBOARD, sendToClipboardFunc);
	    };
	    GridApi.prototype.setProcessCellFromClipboard = function (processCellFromClipboardFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_CELL_FROM_CLIPBOARD, processCellFromClipboardFunc);
	    };
	    GridApi.prototype.setProcessSecondaryColDef = function (processSecondaryColDefFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_TO_SECONDARY_COLDEF, processSecondaryColDefFunc);
	    };
	    GridApi.prototype.setProcessSecondaryColGroupDef = function (processSecondaryColGroupDefFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_SECONDARY_COL_GROUP_DEF, processSecondaryColGroupDefFunc);
	    };
	    GridApi.prototype.setPostProcessPopup = function (postProcessPopupFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_POST_PROCESS_POPUP, postProcessPopupFunc);
	    };
	    GridApi.prototype.setDefaultGroupSortComparator = function (defaultGroupSortComparatorFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_DEFAULT_GROUP_SORT_COMPARATOR, defaultGroupSortComparatorFunc);
	    };
	    GridApi.prototype.setProcessChartOptions = function (processChartOptionsFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_CHART_OPTIONS, processChartOptionsFunc);
	    };
	    GridApi.prototype.setGetChartToolbarItems = function (getChartToolbarItemsFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_CHART_TOOLBAR_ITEMS, getChartToolbarItemsFunc);
	    };
	    GridApi.prototype.setPaginationNumberFormatter = function (paginationNumberFormatterFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PAGINATION_NUMBER_FORMATTER, paginationNumberFormatterFunc);
	    };
	    GridApi.prototype.setGetServerSideStoreParams = function (getServerSideStoreParamsFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_SERVER_SIDE_STORE_PARAMS, getServerSideStoreParamsFunc);
	    };
	    GridApi.prototype.setIsServerSideGroupOpenByDefault = function (isServerSideGroupOpenByDefaultFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUPS_OPEN_BY_DEFAULT, isServerSideGroupOpenByDefaultFunc);
	    };
	    GridApi.prototype.setIsApplyServerSideTransaction = function (isApplyServerSideTransactionFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_APPLY_SERVER_SIDE_TRANSACTION, isApplyServerSideTransactionFunc);
	    };
	    GridApi.prototype.setIsServerSideGroup = function (isServerSideGroupFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUP, isServerSideGroupFunc);
	    };
	    GridApi.prototype.setGetServerSideGroupKey = function (getServerSideGroupKeyFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_SERVER_SIDE_GROUP_KEY, getServerSideGroupKeyFunc);
	    };
	    GridApi.prototype.setGetRowStyle = function (rowStyleFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_STYLE, rowStyleFunc);
	    };
	    GridApi.prototype.setGetRowHeight = function (rowHeightFunc) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_HEIGHT, rowHeightFunc);
	    };
	    GridApi.prototype.setPivotHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, headerHeight);
	    };
	    GridApi.prototype.isSideBarVisible = function () {
	        return this.sideBarComp ? this.sideBarComp.isDisplayed() : false;
	    };
	    GridApi.prototype.setSideBarVisible = function (show) {
	        if (!this.sideBarComp) {
	            if (show) {
	                console.warn('AG Grid: sideBar is not loaded');
	            }
	            return;
	        }
	        this.sideBarComp.setDisplayed(show);
	    };
	    GridApi.prototype.setSideBarPosition = function (position) {
	        if (!this.sideBarComp) {
	            console.warn('AG Grid: sideBar is not loaded');
	            return;
	        }
	        this.sideBarComp.setSideBarPosition(position);
	    };
	    GridApi.prototype.openToolPanel = function (key) {
	        if (!this.sideBarComp) {
	            console.warn('AG Grid: toolPanel is only available in AG Grid Enterprise');
	            return;
	        }
	        this.sideBarComp.openToolPanel(key);
	    };
	    GridApi.prototype.closeToolPanel = function () {
	        if (!this.sideBarComp) {
	            console.warn('AG Grid: toolPanel is only available in AG Grid Enterprise');
	            return;
	        }
	        this.sideBarComp.close();
	    };
	    GridApi.prototype.getOpenedToolPanel = function () {
	        return this.sideBarComp ? this.sideBarComp.openedItem() : null;
	    };
	    GridApi.prototype.getSideBar = function () {
	        return this.gridOptionsWrapper.getSideBar();
	    };
	    GridApi.prototype.setSideBar = function (def) {
	        this.gridOptionsWrapper.setProperty('sideBar', SideBarDefParser.parse(def));
	    };
	    GridApi.prototype.setSuppressClipboardPaste = function (value) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE, value);
	    };
	    GridApi.prototype.isToolPanelShowing = function () {
	        return this.sideBarComp.isToolPanelShowing();
	    };
	    GridApi.prototype.doLayout = function () {
	        var message = "AG Grid - since version 25.1, doLayout was taken out, as it's not needed. The grid responds to grid size changes automatically";
	        doOnce(function () { return console.warn(message); }, 'doLayoutDeprecated');
	    };
	    GridApi.prototype.resetRowHeights = function () {
	        if (exists(this.clientSideRowModel)) {
	            this.clientSideRowModel.resetRowHeights();
	        }
	    };
	    GridApi.prototype.setGroupRemoveSingleChildren = function (value) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, value);
	    };
	    GridApi.prototype.setGroupRemoveLowestSingleChildren = function (value) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, value);
	    };
	    GridApi.prototype.onRowHeightChanged = function () {
	        if (this.clientSideRowModel) {
	            this.clientSideRowModel.onRowHeightChanged();
	        }
	        else if (this.serverSideRowModel) {
	            this.serverSideRowModel.onRowHeightChanged();
	        }
	    };
	    GridApi.prototype.getValue = function (colKey, rowNode) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        if (missing(column)) {
	            column = this.columnController.getGridColumn(colKey);
	        }
	        if (missing(column)) {
	            return null;
	        }
	        return this.valueService.getValue(column, rowNode);
	    };
	    GridApi.prototype.addEventListener = function (eventType, listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.addEventListener(eventType, listener, async);
	    };
	    GridApi.prototype.addGlobalListener = function (listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.addGlobalListener(listener, async);
	    };
	    GridApi.prototype.removeEventListener = function (eventType, listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.removeEventListener(eventType, listener, async);
	    };
	    GridApi.prototype.removeGlobalListener = function (listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.removeGlobalListener(listener, async);
	    };
	    GridApi.prototype.dispatchEvent = function (event) {
	        this.eventService.dispatchEvent(event);
	    };
	    GridApi.prototype.destroy = function () {
	        // this is needed as GridAPI is a bean, and GridAPI.destroy() is called as part
	        // of context.destroy(). so we need to stop the infinite loop.
	        if (this.destroyCalled) {
	            return;
	        }
	        this.destroyCalled = true;
	        // destroy the UI first (as they use the services)
	        this.gridCompController.destroyGridUi();
	        // destroy the services
	        this.context.destroy();
	    };
	    GridApi.prototype.cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid = function () {
	        // some users were raising support issues with regards memory leaks. the problem was the customers applications
	        // were keeping references to the API. trying to educate them all would be difficult, easier to just remove
	        // all references in teh API so at least the core grid can be garbage collected.
	        //
	        // wait about 100ms before clearing down the references, in case user has some cleanup to do,
	        // and needs to deference the API first
	        setTimeout(removeAllReferences.bind(window, this, 'Grid API'), 100);
	    };
	    GridApi.prototype.warnIfDestroyed = function (methodName) {
	        if (this.destroyCalled) {
	            console.warn("AG Grid: Grid API method " + methodName + " was called on a grid that was destroyed.");
	        }
	        return this.destroyCalled;
	    };
	    GridApi.prototype.resetQuickFilter = function () {
	        if (this.warnIfDestroyed('resetQuickFilter')) {
	            return;
	        }
	        this.rowModel.forEachNode(function (node) { return node.quickFilterAggregateText = null; });
	    };
	    GridApi.prototype.getRangeSelections = function () {
	        console.warn("AG Grid: in v20.1.x, api.getRangeSelections() is gone, please use getCellRanges() instead.\n        We had to change how cell selections works a small bit to allow charting to integrate. The return type of\n        getCellRanges() is a bit different, please check the AG Grid documentation.");
	        return null;
	    };
	    GridApi.prototype.getCellRanges = function () {
	        if (this.rangeController) {
	            return this.rangeController.getCellRanges();
	        }
	        console.warn('AG Grid: cell range selection is only available in AG Grid Enterprise');
	        return null;
	    };
	    GridApi.prototype.camelCaseToHumanReadable = function (camelCase) {
	        return camelCaseToHumanText(camelCase);
	    };
	    GridApi.prototype.addRangeSelection = function (deprecatedNoLongerUsed) {
	        console.warn('AG Grid: As of version 21.x, range selection changed slightly to allow charting integration. Please call api.addCellRange() instead of api.addRangeSelection()');
	    };
	    GridApi.prototype.addCellRange = function (params) {
	        if (!this.rangeController) {
	            console.warn('AG Grid: cell range selection is only available in AG Grid Enterprise');
	        }
	        this.rangeController.addCellRange(params);
	    };
	    GridApi.prototype.clearRangeSelection = function () {
	        if (!this.rangeController) {
	            console.warn('AG Grid: cell range selection is only available in AG Grid Enterprise');
	        }
	        this.rangeController.removeAllCellRanges();
	    };
	    GridApi.prototype.undoCellEditing = function () {
	        this.undoRedoService.undo();
	    };
	    GridApi.prototype.redoCellEditing = function () {
	        this.undoRedoService.redo();
	    };
	    GridApi.prototype.getCurrentUndoSize = function () {
	        return this.undoRedoService.getCurrentUndoStackSize();
	    };
	    GridApi.prototype.getCurrentRedoSize = function () {
	        return this.undoRedoService.getCurrentRedoStackSize();
	    };
	    GridApi.prototype.getChartModels = function () {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.RangeSelectionModule, 'api.getChartModels') &&
	            ModuleRegistry.assertRegistered(exports.ModuleNames.GridChartsModule, 'api.getChartModels')) {
	            return this.chartService.getChartModels();
	        }
	    };
	    GridApi.prototype.createRangeChart = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.RangeSelectionModule, 'api.createRangeChart') &&
	            ModuleRegistry.assertRegistered(exports.ModuleNames.GridChartsModule, 'api.createRangeChart')) {
	            return this.chartService.createRangeChart(params);
	        }
	    };
	    GridApi.prototype.createCrossFilterChart = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.RangeSelectionModule, 'api.createCrossFilterChart') &&
	            ModuleRegistry.assertRegistered(exports.ModuleNames.GridChartsModule, 'api.createCrossFilterChart')) {
	            return this.chartService.createCrossFilterChart(params);
	        }
	    };
	    GridApi.prototype.restoreChart = function (chartModel, chartContainer) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.RangeSelectionModule, 'api.restoreChart') &&
	            ModuleRegistry.assertRegistered(exports.ModuleNames.GridChartsModule, 'api.restoreChart')) {
	            return this.chartService.restoreChart(chartModel, chartContainer);
	        }
	    };
	    GridApi.prototype.createPivotChart = function (params) {
	        if (ModuleRegistry.assertRegistered(exports.ModuleNames.RangeSelectionModule, 'api.createPivotChart') &&
	            ModuleRegistry.assertRegistered(exports.ModuleNames.GridChartsModule, 'api.createPivotChart')) {
	            return this.chartService.createPivotChart(params);
	        }
	    };
	    GridApi.prototype.copySelectedRowsToClipboard = function (includeHeader, columnKeys) {
	        if (!this.clipboardService) {
	            console.warn('AG Grid: clipboard is only available in AG Grid Enterprise');
	        }
	        this.clipboardService.copySelectedRowsToClipboard(includeHeader, columnKeys);
	    };
	    GridApi.prototype.copySelectedRangeToClipboard = function (includeHeader) {
	        if (!this.clipboardService) {
	            console.warn('AG Grid: clipboard is only available in AG Grid Enterprise');
	        }
	        this.clipboardService.copySelectedRangeToClipboard(includeHeader);
	    };
	    GridApi.prototype.copySelectedRangeDown = function () {
	        if (!this.clipboardService) {
	            console.warn('AG Grid: clipboard is only available in AG Grid Enterprise');
	        }
	        this.clipboardService.copyRangeDown();
	    };
	    GridApi.prototype.showColumnMenuAfterButtonClick = function (colKey, buttonElement) {
	        // use grid column so works with pivot mode
	        var column = this.columnController.getGridColumn(colKey);
	        this.menuFactory.showMenuAfterButtonClick(column, buttonElement);
	    };
	    GridApi.prototype.showColumnMenuAfterMouseClick = function (colKey, mouseEvent) {
	        // use grid column so works with pivot mode
	        var column = this.columnController.getGridColumn(colKey);
	        if (!column) {
	            column = this.columnController.getPrimaryColumn(colKey);
	        }
	        if (!column) {
	            console.error("AG Grid: column '" + colKey + "' not found");
	            return;
	        }
	        this.menuFactory.showMenuAfterMouseEvent(column, mouseEvent);
	    };
	    GridApi.prototype.hidePopupMenu = function () {
	        // hide the context menu if in enterprise
	        if (this.contextMenuFactory) {
	            this.contextMenuFactory.hideActiveMenu();
	        }
	        // and hide the column menu always
	        this.menuFactory.hideActiveMenu();
	    };
	    GridApi.prototype.setPopupParent = function (ePopupParent) {
	        this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_POPUP_PARENT, ePopupParent);
	    };
	    GridApi.prototype.tabToNextCell = function () {
	        return this.rowRenderer.tabToNextCell(false);
	    };
	    GridApi.prototype.tabToPreviousCell = function () {
	        return this.rowRenderer.tabToNextCell(true);
	    };
	    GridApi.prototype.getCellRendererInstances = function (params) {
	        if (params === void 0) { params = {}; }
	        return this.rowRenderer.getCellRendererInstances(params);
	    };
	    GridApi.prototype.getCellEditorInstances = function (params) {
	        if (params === void 0) { params = {}; }
	        return this.rowRenderer.getCellEditorInstances(params);
	    };
	    GridApi.prototype.getEditingCells = function () {
	        return this.rowRenderer.getEditingCells();
	    };
	    GridApi.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.rowRenderer.stopEditing(cancel);
	    };
	    GridApi.prototype.startEditingCell = function (params) {
	        var column = this.columnController.getGridColumn(params.colKey);
	        if (!column) {
	            console.warn("AG Grid: no column found for " + params.colKey);
	            return;
	        }
	        var cellPosition = {
	            rowIndex: params.rowIndex,
	            rowPinned: params.rowPinned || null,
	            column: column
	        };
	        var notPinned = missing(params.rowPinned);
	        if (notPinned) {
	            this.gridBodyCon.getScrollFeature().ensureIndexVisible(params.rowIndex);
	        }
	        this.rowRenderer.startEditingCell(cellPosition, params.keyPress, params.charPress);
	    };
	    GridApi.prototype.addAggFunc = function (key, aggFunc) {
	        if (this.aggFuncService) {
	            this.aggFuncService.addAggFunc(key, aggFunc);
	        }
	    };
	    GridApi.prototype.addAggFuncs = function (aggFuncs) {
	        if (this.aggFuncService) {
	            this.aggFuncService.addAggFuncs(aggFuncs);
	        }
	    };
	    GridApi.prototype.clearAggFuncs = function () {
	        if (this.aggFuncService) {
	            this.aggFuncService.clear();
	        }
	    };
	    GridApi.prototype.applyServerSideTransaction = function (transaction) {
	        if (!this.serverSideTransactionManager) {
	            console.warn('AG Grid: Cannot apply Server Side Transaction if not using the Server Side Row Model.');
	            return;
	        }
	        return this.serverSideTransactionManager.applyTransaction(transaction);
	    };
	    GridApi.prototype.applyServerSideTransactionAsync = function (transaction, callback) {
	        if (!this.serverSideTransactionManager) {
	            console.warn('AG Grid: Cannot apply Server Side Transaction if not using the Server Side Row Model.');
	            return;
	        }
	        return this.serverSideTransactionManager.applyTransactionAsync(transaction, callback);
	    };
	    GridApi.prototype.retryServerSideLoads = function () {
	        if (!this.serverSideRowModel) {
	            console.warn('AG Grid: API retryServerSideLoads() can only be used when using Server-Side Row Model.');
	            return;
	        }
	        this.serverSideRowModel.retryLoads();
	    };
	    GridApi.prototype.flushServerSideAsyncTransactions = function () {
	        if (!this.serverSideTransactionManager) {
	            console.warn('AG Grid: Cannot flush Server Side Transaction if not using the Server Side Row Model.');
	            return;
	        }
	        return this.serverSideTransactionManager.flushAsyncTransactions();
	    };
	    GridApi.prototype.applyTransaction = function (rowDataTransaction) {
	        if (!this.clientSideRowModel) {
	            console.error('AG Grid: updateRowData() only works with ClientSideRowModel. Working with InfiniteRowModel was deprecated in v23.1 and removed in v24.1');
	            return;
	        }
	        var res = this.clientSideRowModel.updateRowData(rowDataTransaction);
	        // refresh all the full width rows
	        this.rowRenderer.refreshFullWidthRows(res.update);
	        // do change detection for all present cells
	        if (!this.gridOptionsWrapper.isSuppressChangeDetection()) {
	            this.rowRenderer.refreshCells();
	        }
	        return res;
	    };
	    /** @deprecated */
	    GridApi.prototype.updateRowData = function (rowDataTransaction) {
	        var message = 'AG Grid: as of v23.1, grid API updateRowData(transaction) is now called applyTransaction(transaction). updateRowData is deprecated and will be removed in a future major release.';
	        doOnce(function () { return console.warn(message); }, 'updateRowData deprecated');
	        return this.applyTransaction(rowDataTransaction);
	    };
	    GridApi.prototype.applyTransactionAsync = function (rowDataTransaction, callback) {
	        if (!this.clientSideRowModel) {
	            console.error('AG Grid: api.applyTransactionAsync() only works with ClientSideRowModel.');
	            return;
	        }
	        this.clientSideRowModel.batchUpdateRowData(rowDataTransaction, callback);
	    };
	    GridApi.prototype.flushAsyncTransactions = function () {
	        if (!this.clientSideRowModel) {
	            console.error('AG Grid: api.applyTransactionAsync() only works with ClientSideRowModel.');
	            return;
	        }
	        this.clientSideRowModel.flushAsyncTransactions();
	    };
	    /** @deprecated */
	    GridApi.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
	        var message = 'AG Grid: as of v23.1, grid API batchUpdateRowData(transaction, callback) is now called applyTransactionAsync(transaction, callback). batchUpdateRowData is deprecated and will be removed in a future major release.';
	        doOnce(function () { return console.warn(message); }, 'batchUpdateRowData deprecated');
	        this.applyTransactionAsync(rowDataTransaction, callback);
	    };
	    GridApi.prototype.insertItemsAtIndex = function (index, items, skipRefresh) {
	        console.warn('AG Grid: insertItemsAtIndex() is deprecated, use updateRowData(transaction) instead.');
	        this.updateRowData({ add: items, addIndex: index, update: null, remove: null });
	    };
	    GridApi.prototype.removeItems = function (rowNodes, skipRefresh) {
	        console.warn('AG Grid: removeItems() is deprecated, use updateRowData(transaction) instead.');
	        var dataToRemove = rowNodes.map(function (rowNode) { return rowNode.data; });
	        this.updateRowData({ add: null, addIndex: null, update: null, remove: dataToRemove });
	    };
	    GridApi.prototype.addItems = function (items, skipRefresh) {
	        console.warn('AG Grid: addItems() is deprecated, use updateRowData(transaction) instead.');
	        this.updateRowData({ add: items, addIndex: null, update: null, remove: null });
	    };
	    GridApi.prototype.refreshVirtualPageCache = function () {
	        console.warn('AG Grid: refreshVirtualPageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
	        this.refreshInfiniteCache();
	    };
	    GridApi.prototype.refreshInfinitePageCache = function () {
	        console.warn('AG Grid: refreshInfinitePageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
	        this.refreshInfiniteCache();
	    };
	    GridApi.prototype.refreshInfiniteCache = function () {
	        if (this.infiniteRowModel) {
	            this.infiniteRowModel.refreshCache();
	        }
	        else {
	            console.warn("AG Grid: api.refreshInfiniteCache is only available when rowModelType='infinite'.");
	        }
	    };
	    GridApi.prototype.purgeVirtualPageCache = function () {
	        console.warn('AG Grid: purgeVirtualPageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
	        this.purgeInfinitePageCache();
	    };
	    GridApi.prototype.purgeInfinitePageCache = function () {
	        console.warn('AG Grid: purgeInfinitePageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
	        this.purgeInfiniteCache();
	    };
	    GridApi.prototype.purgeInfiniteCache = function () {
	        if (this.infiniteRowModel) {
	            this.infiniteRowModel.purgeCache();
	        }
	        else {
	            console.warn("AG Grid: api.purgeInfiniteCache is only available when rowModelType='infinite'.");
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.purgeEnterpriseCache = function (route) {
	        console.warn("ag-grid: since version 18.x, api.purgeEnterpriseCache() should be replaced with api.purgeServerSideCache()");
	        this.purgeServerSideCache(route);
	    };
	    /** @deprecated */
	    GridApi.prototype.purgeServerSideCache = function (route) {
	        if (route === void 0) { route = []; }
	        if (this.serverSideRowModel) {
	            console.warn("AG Grid: since v25.0, api.purgeServerSideCache is deprecated. Please use api.refreshServerSideStore({purge: true}) instead.");
	            this.refreshServerSideStore({
	                route: route,
	                purge: true
	            });
	        }
	        else {
	            console.warn("AG Grid: api.purgeServerSideCache is only available when rowModelType='serverSide'.");
	        }
	    };
	    GridApi.prototype.refreshServerSideStore = function (params) {
	        if (this.serverSideRowModel) {
	            this.serverSideRowModel.refreshStore(params);
	        }
	        else {
	            console.warn("AG Grid: api.refreshServerSideStore is only available when rowModelType='serverSide'.");
	        }
	    };
	    GridApi.prototype.getServerSideStoreState = function () {
	        if (this.serverSideRowModel) {
	            return this.serverSideRowModel.getStoreState();
	        }
	        else {
	            console.warn("AG Grid: api.getServerSideStoreState is only available when rowModelType='serverSide'.");
	            return [];
	        }
	    };
	    GridApi.prototype.getVirtualRowCount = function () {
	        console.warn('AG Grid: getVirtualRowCount() is now called getInfiniteRowCount(), please call getInfiniteRowCount() instead');
	        return this.getInfiniteRowCount();
	    };
	    GridApi.prototype.getInfiniteRowCount = function () {
	        if (this.infiniteRowModel) {
	            return this.infiniteRowModel.getRowCount();
	        }
	        else {
	            console.warn("AG Grid: api.getVirtualRowCount is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.isMaxRowFound = function () {
	        console.warn("AG Grid: api.isLastRowIndexKnown is deprecated, please use api.isLastRowIndexKnown()");
	        return this.isLastRowIndexKnown();
	    };
	    GridApi.prototype.isLastRowIndexKnown = function () {
	        if (this.infiniteRowModel) {
	            return this.infiniteRowModel.isLastRowIndexKnown();
	        }
	        else {
	            console.warn("AG Grid: api.isMaxRowFound is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
	        console.warn('AG Grid: setVirtualRowCount() is now called setInfiniteRowCount(), please call setInfiniteRowCount() instead');
	        this.setRowCount(rowCount, maxRowFound);
	    };
	    GridApi.prototype.setInfiniteRowCount = function (rowCount, maxRowFound) {
	        console.warn('AG Grid: setInfiniteRowCount() is now called setRowCount(), please call setRowCount() instead');
	        this.setRowCount(rowCount, maxRowFound);
	    };
	    GridApi.prototype.setRowCount = function (rowCount, maxRowFound) {
	        if (this.infiniteRowModel) {
	            this.infiniteRowModel.setRowCount(rowCount, maxRowFound);
	        }
	        else {
	            console.warn("AG Grid: api.setRowCount is only available for Infinite Row Model.");
	        }
	    };
	    GridApi.prototype.getVirtualPageState = function () {
	        console.warn('AG Grid: getVirtualPageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
	        return this.getCacheBlockState();
	    };
	    GridApi.prototype.getInfinitePageState = function () {
	        console.warn('AG Grid: getInfinitePageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
	        return this.getCacheBlockState();
	    };
	    GridApi.prototype.getCacheBlockState = function () {
	        return this.rowNodeBlockLoader.getBlockState();
	    };
	    GridApi.prototype.checkGridSize = function () {
	        console.warn("in AG Grid v25.2.0, checkGridSize() was removed, as it was legacy and didn't do anything uesful.");
	    };
	    GridApi.prototype.getFirstRenderedRow = function () {
	        console.warn('in AG Grid v12, getFirstRenderedRow() was renamed to getFirstDisplayedRow()');
	        return this.getFirstDisplayedRow();
	    };
	    GridApi.prototype.getFirstDisplayedRow = function () {
	        return this.rowRenderer.getFirstVirtualRenderedRow();
	    };
	    GridApi.prototype.getLastRenderedRow = function () {
	        console.warn('in AG Grid v12, getLastRenderedRow() was renamed to getLastDisplayedRow()');
	        return this.getLastDisplayedRow();
	    };
	    GridApi.prototype.getLastDisplayedRow = function () {
	        return this.rowRenderer.getLastVirtualRenderedRow();
	    };
	    GridApi.prototype.getDisplayedRowAtIndex = function (index) {
	        return this.rowModel.getRow(index);
	    };
	    GridApi.prototype.getDisplayedRowCount = function () {
	        return this.rowModel.getRowCount();
	    };
	    GridApi.prototype.paginationIsLastPageFound = function () {
	        return this.paginationProxy.isLastPageFound();
	    };
	    GridApi.prototype.paginationGetPageSize = function () {
	        return this.paginationProxy.getPageSize();
	    };
	    GridApi.prototype.paginationSetPageSize = function (size) {
	        this.gridOptionsWrapper.setProperty('paginationPageSize', size);
	    };
	    GridApi.prototype.paginationGetCurrentPage = function () {
	        return this.paginationProxy.getCurrentPage();
	    };
	    GridApi.prototype.paginationGetTotalPages = function () {
	        return this.paginationProxy.getTotalPages();
	    };
	    GridApi.prototype.paginationGetRowCount = function () {
	        return this.paginationProxy.getMasterRowCount();
	    };
	    GridApi.prototype.paginationGoToNextPage = function () {
	        this.paginationProxy.goToNextPage();
	    };
	    GridApi.prototype.paginationGoToPreviousPage = function () {
	        this.paginationProxy.goToPreviousPage();
	    };
	    GridApi.prototype.paginationGoToFirstPage = function () {
	        this.paginationProxy.goToFirstPage();
	    };
	    GridApi.prototype.paginationGoToLastPage = function () {
	        this.paginationProxy.goToLastPage();
	    };
	    GridApi.prototype.paginationGoToPage = function (page) {
	        this.paginationProxy.goToPage(page);
	    };
	    __decorate$17([
	        Optional('immutableService')
	    ], GridApi.prototype, "immutableService", void 0);
	    __decorate$17([
	        Optional('csvCreator')
	    ], GridApi.prototype, "csvCreator", void 0);
	    __decorate$17([
	        Optional('excelCreator')
	    ], GridApi.prototype, "excelCreator", void 0);
	    __decorate$17([
	        Autowired('rowRenderer')
	    ], GridApi.prototype, "rowRenderer", void 0);
	    __decorate$17([
	        Autowired('filterManager')
	    ], GridApi.prototype, "filterManager", void 0);
	    __decorate$17([
	        Autowired('columnController')
	    ], GridApi.prototype, "columnController", void 0);
	    __decorate$17([
	        Autowired('selectionController')
	    ], GridApi.prototype, "selectionController", void 0);
	    __decorate$17([
	        Autowired('gridOptionsWrapper')
	    ], GridApi.prototype, "gridOptionsWrapper", void 0);
	    __decorate$17([
	        Autowired('valueService')
	    ], GridApi.prototype, "valueService", void 0);
	    __decorate$17([
	        Autowired('alignedGridsService')
	    ], GridApi.prototype, "alignedGridsService", void 0);
	    __decorate$17([
	        Autowired('eventService')
	    ], GridApi.prototype, "eventService", void 0);
	    __decorate$17([
	        Autowired('pinnedRowModel')
	    ], GridApi.prototype, "pinnedRowModel", void 0);
	    __decorate$17([
	        Autowired('context')
	    ], GridApi.prototype, "context", void 0);
	    __decorate$17([
	        Autowired('rowModel')
	    ], GridApi.prototype, "rowModel", void 0);
	    __decorate$17([
	        Autowired('sortController')
	    ], GridApi.prototype, "sortController", void 0);
	    __decorate$17([
	        Autowired('paginationProxy')
	    ], GridApi.prototype, "paginationProxy", void 0);
	    __decorate$17([
	        Autowired('focusController')
	    ], GridApi.prototype, "focusController", void 0);
	    __decorate$17([
	        Autowired('dragAndDropService')
	    ], GridApi.prototype, "dragAndDropService", void 0);
	    __decorate$17([
	        Optional('rangeController')
	    ], GridApi.prototype, "rangeController", void 0);
	    __decorate$17([
	        Optional('clipboardService')
	    ], GridApi.prototype, "clipboardService", void 0);
	    __decorate$17([
	        Optional('aggFuncService')
	    ], GridApi.prototype, "aggFuncService", void 0);
	    __decorate$17([
	        Autowired('menuFactory')
	    ], GridApi.prototype, "menuFactory", void 0);
	    __decorate$17([
	        Optional('contextMenuFactory')
	    ], GridApi.prototype, "contextMenuFactory", void 0);
	    __decorate$17([
	        Autowired('valueCache')
	    ], GridApi.prototype, "valueCache", void 0);
	    __decorate$17([
	        Autowired('animationFrameService')
	    ], GridApi.prototype, "animationFrameService", void 0);
	    __decorate$17([
	        Optional('statusBarService')
	    ], GridApi.prototype, "statusBarService", void 0);
	    __decorate$17([
	        Optional('chartService')
	    ], GridApi.prototype, "chartService", void 0);
	    __decorate$17([
	        Optional('undoRedoService')
	    ], GridApi.prototype, "undoRedoService", void 0);
	    __decorate$17([
	        Optional('headlessService')
	    ], GridApi.prototype, "headlessService", void 0);
	    __decorate$17([
	        Optional('rowNodeBlockLoader')
	    ], GridApi.prototype, "rowNodeBlockLoader", void 0);
	    __decorate$17([
	        Optional('ssrmTransactionManager')
	    ], GridApi.prototype, "serverSideTransactionManager", void 0);
	    __decorate$17([
	        Optional('controllersService')
	    ], GridApi.prototype, "controllersService", void 0);
	    __decorate$17([
	        PostConstruct
	    ], GridApi.prototype, "init", null);
	    __decorate$17([
	        PreDestroy
	    ], GridApi.prototype, "cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid", null);
	    GridApi = __decorate$17([
	        Bean('gridApi')
	    ], GridApi);
	    return GridApi;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1e = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$18 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$6 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var ExpressionService = /** @class */ (function (_super) {
	    __extends$1e(ExpressionService, _super);
	    function ExpressionService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.expressionToFunctionCache = {};
	        return _this;
	    }
	    ExpressionService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ExpressionService');
	    };
	    ExpressionService.prototype.evaluate = function (expressionOrFunc, params) {
	        if (typeof expressionOrFunc === 'function') {
	            // valueGetter is a function, so just call it
	            var func = expressionOrFunc;
	            return func(params);
	        }
	        else if (typeof expressionOrFunc === 'string') {
	            // valueGetter is an expression, so execute the expression
	            var expression = expressionOrFunc;
	            return this.evaluateExpression(expression, params);
	        }
	        else {
	            console.error('AG Grid: value should be either a string or a function', expressionOrFunc);
	        }
	    };
	    ExpressionService.prototype.evaluateExpression = function (expression, params) {
	        try {
	            var javaScriptFunction = this.createExpressionFunction(expression);
	            // the params don't have all these values, rather we add every possible
	            // value a params can have, which makes whatever is in the params available.
	            var result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
	            return result;
	        }
	        catch (e) {
	            // the expression failed, which can happen, as it's the client that
	            // provides the expression. so print a nice message
	            // tslint:disable-next-line
	            console.log('Processing of the expression failed');
	            // tslint:disable-next-line
	            console.log('Expression = ' + expression);
	            // tslint:disable-next-line
	            console.log('Params =', params);
	            // tslint:disable-next-line
	            console.log('Exception = ' + e);
	            return null;
	        }
	    };
	    ExpressionService.prototype.createExpressionFunction = function (expression) {
	        // check cache first
	        if (this.expressionToFunctionCache[expression]) {
	            return this.expressionToFunctionCache[expression];
	        }
	        // if not found in cache, return the function
	        var functionBody = this.createFunctionBody(expression);
	        var theFunction = new Function('x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup', functionBody);
	        // store in cache
	        this.expressionToFunctionCache[expression] = theFunction;
	        return theFunction;
	    };
	    ExpressionService.prototype.createFunctionBody = function (expression) {
	        // if the expression has the 'return' word in it, then use as is,
	        // if not, then wrap it with return and ';' to make a function
	        if (expression.indexOf('return') >= 0) {
	            return expression;
	        }
	        else {
	            return 'return ' + expression + ';';
	        }
	    };
	    __decorate$18([
	        __param$6(0, Qualifier('loggerFactory'))
	    ], ExpressionService.prototype, "setBeans", null);
	    ExpressionService = __decorate$18([
	        Bean('expressionService')
	    ], ExpressionService);
	    return ExpressionService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1f = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$19 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TemplateService = /** @class */ (function (_super) {
	    __extends$1f(TemplateService, _super);
	    function TemplateService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.templateCache = {};
	        _this.waitingCallbacks = {};
	        return _this;
	    }
	    // returns the template if it is loaded, or null if it is not loaded
	    // but will call the callback when it is loaded
	    TemplateService.prototype.getTemplate = function (url, callback) {
	        var templateFromCache = this.templateCache[url];
	        if (templateFromCache) {
	            return templateFromCache;
	        }
	        var callbackList = this.waitingCallbacks[url];
	        var that = this;
	        if (!callbackList) {
	            // first time this was called, so need a new list for callbacks
	            callbackList = [];
	            this.waitingCallbacks[url] = callbackList;
	            // and also need to do the http request
	            var client = new XMLHttpRequest();
	            client.onload = function () {
	                that.handleHttpResult(this, url);
	            };
	            client.open("GET", url);
	            client.send();
	        }
	        // add this callback
	        if (callback) {
	            callbackList.push(callback);
	        }
	        // caller needs to wait for template to load, so return null
	        return null;
	    };
	    TemplateService.prototype.handleHttpResult = function (httpResult, url) {
	        if (httpResult.status !== 200 || httpResult.response === null) {
	            console.warn("Unable to get template error " + httpResult.status + " - " + url);
	            return;
	        }
	        // response success, so process it
	        // in IE9 the response is in - responseText
	        this.templateCache[url] = httpResult.response || httpResult.responseText;
	        // inform all listeners that this is now in the cache
	        var callbacks = this.waitingCallbacks[url];
	        for (var i = 0; i < callbacks.length; i++) {
	            var callback = callbacks[i];
	            // we could pass the callback the response, however we know the client of this code
	            // is the cell renderer, and it passes the 'cellRefresh' method in as the callback
	            // which doesn't take any parameters.
	            callback();
	        }
	        if (this.$scope) {
	            var that_1 = this;
	            window.setTimeout(function () {
	                that_1.$scope.$apply();
	            }, 0);
	        }
	    };
	    __decorate$19([
	        Autowired('$scope')
	    ], TemplateService.prototype, "$scope", void 0);
	    TemplateService = __decorate$19([
	        Bean('templateService')
	    ], TemplateService);
	    return TemplateService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1g = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1a = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __spreadArrays$7 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var FocusController = /** @class */ (function (_super) {
	    __extends$1g(FocusController, _super);
	    function FocusController() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FocusController_1 = FocusController;
	    /**
	     * Adds a gridCore to the list of the gridCores monitoring Keyboard Mode
	     * in a specific HTMLDocument.
	     *
	     * @param doc {Document} - The Document containing the gridCore.
	     * @param gridCore {GridComp} - The GridCore to be monitored.
	     */
	    FocusController.addKeyboardModeEvents = function (doc, controller) {
	        var docControllers = FocusController_1.instancesMonitored.get(doc);
	        if (docControllers && docControllers.length > 0) {
	            if (docControllers.indexOf(controller) === -1) {
	                docControllers.push(controller);
	            }
	        }
	        else {
	            FocusController_1.instancesMonitored.set(doc, [controller]);
	            doc.addEventListener('keydown', FocusController_1.toggleKeyboardMode);
	            doc.addEventListener('mousedown', FocusController_1.toggleKeyboardMode);
	        }
	    };
	    /**
	     * Removes a gridCore from the list of the gridCores monitoring Keyboard Mode
	     * in a specific HTMLDocument.
	     *
	     * @param doc {Document} - The Document containing the gridCore.
	     * @param gridCore {GridComp} - The GridCore to be removed.
	     */
	    FocusController.removeKeyboardModeEvents = function (doc, controller) {
	        var docControllers = FocusController_1.instancesMonitored.get(doc);
	        var newControllers = [];
	        if (docControllers && docControllers.length) {
	            newControllers = __spreadArrays$7(docControllers).filter(function (currentGridCore) { return currentGridCore !== controller; });
	            FocusController_1.instancesMonitored.set(doc, newControllers);
	        }
	        if (newControllers.length === 0) {
	            doc.removeEventListener('keydown', FocusController_1.toggleKeyboardMode);
	            doc.removeEventListener('mousedown', FocusController_1.toggleKeyboardMode);
	        }
	    };
	    /**
	     * This method will be called by `keydown` and `mousedown` events on all Documents monitoring
	     * KeyboardMode. It will then fire a KEYBOARD_FOCUS, MOUSE_FOCUS on each gridCore present in
	     * the Document allowing each gridCore to maintain a state for KeyboardMode.
	     *
	     * @param event {KeyboardEvent | MouseEvent | TouchEvent} - The event triggered.
	     */
	    FocusController.toggleKeyboardMode = function (event) {
	        var isKeyboardActive = FocusController_1.keyboardModeActive;
	        var isKeyboardEvent = event.type === 'keydown';
	        if (isKeyboardEvent) {
	            // the following keys should not toggle keyboard mode.
	            if (event.ctrlKey || event.metaKey || event.altKey) {
	                return;
	            }
	        }
	        if (isKeyboardActive && isKeyboardEvent || !isKeyboardActive && !isKeyboardEvent) {
	            return;
	        }
	        FocusController_1.keyboardModeActive = isKeyboardEvent;
	        var doc = event.target.ownerDocument;
	        if (!doc) {
	            return;
	        }
	        var controllersForDoc = FocusController_1.instancesMonitored.get(doc);
	        if (controllersForDoc) {
	            controllersForDoc.forEach(function (controller) {
	                controller.dispatchEvent({ type: isKeyboardEvent ? Events.EVENT_KEYBOARD_FOCUS : Events.EVENT_MOUSE_FOCUS });
	            });
	        }
	    };
	    FocusController.prototype.init = function () {
	        var clearFocusedCellListener = this.clearFocusedCell.bind(this);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, clearFocusedCellListener);
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, clearFocusedCellListener);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, clearFocusedCellListener);
	    };
	    FocusController.prototype.registerGridCompController = function (gridCompController) {
	        var _this = this;
	        this.gridCompController = gridCompController;
	        var doc = this.gridOptionsWrapper.getDocument();
	        FocusController_1.addKeyboardModeEvents(doc, gridCompController);
	        this.addDestroyFunc(function () { return _this.unregisterGridCompController(gridCompController); });
	    };
	    FocusController.prototype.unregisterGridCompController = function (gridCompController) {
	        var doc = this.gridOptionsWrapper.getDocument();
	        FocusController_1.removeKeyboardModeEvents(doc, gridCompController);
	    };
	    FocusController.prototype.onColumnEverythingChanged = function () {
	        // if the columns change, check and see if this column still exists. if it does, then
	        // we can keep the focused cell. if it doesn't, then we need to drop the focused cell.
	        if (!this.focusedCellPosition) {
	            return;
	        }
	        var col = this.focusedCellPosition.column;
	        var colFromColumnController = this.columnController.getGridColumn(col.getId());
	        if (col !== colFromColumnController) {
	            this.clearFocusedCell();
	        }
	    };
	    FocusController.prototype.isKeyboardMode = function () {
	        return FocusController_1.keyboardModeActive;
	    };
	    // we check if the browser is focusing something, and if it is, and
	    // it's the cell we think is focused, then return the cell. so this
	    // methods returns the cell if a) we think it has focus and b) the
	    // browser thinks it has focus. this then returns nothing if we
	    // first focus a cell, then second click outside the grid, as then the
	    // grid cell will still be focused as far as the grid is concerned,
	    // however the browser focus will have moved somewhere else.
	    FocusController.prototype.getFocusCellToUseAfterRefresh = function () {
	        if (this.gridOptionsWrapper.isSuppressFocusAfterRefresh() || !this.focusedCellPosition) {
	            return null;
	        }
	        // we check that the browser is actually focusing on the grid, if it is not, then
	        // we have nothing to worry about
	        if (!this.getGridCellForDomElement(document.activeElement)) {
	            return null;
	        }
	        return this.focusedCellPosition;
	    };
	    FocusController.prototype.getGridCellForDomElement = function (eBrowserCell) {
	        var ePointer = eBrowserCell;
	        while (ePointer) {
	            var cellComp = this.gridOptionsWrapper.getDomData(ePointer, CellComp.DOM_DATA_KEY_CELL_COMP);
	            if (cellComp) {
	                return cellComp.getCellPosition();
	            }
	            ePointer = ePointer.parentNode;
	        }
	        return null;
	    };
	    FocusController.prototype.clearFocusedCell = function () {
	        this.focusedCellPosition = null;
	        this.onCellFocused(false);
	    };
	    FocusController.prototype.getFocusedCell = function () {
	        return this.focusedCellPosition;
	    };
	    FocusController.prototype.setFocusedCell = function (rowIndex, colKey, floating, forceBrowserFocus) {
	        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
	        var gridColumn = this.columnController.getGridColumn(colKey);
	        // if column doesn't exist, then blank the focused cell and return. this can happen when user sets new columns,
	        // and the focused cell is in a column that no longer exists. after columns change, the grid refreshes and tries
	        // to re-focus the focused cell.
	        if (!gridColumn) {
	            this.focusedCellPosition = null;
	            return;
	        }
	        this.focusedCellPosition = gridColumn ? { rowIndex: rowIndex, rowPinned: makeNull(floating), column: gridColumn } : null;
	        this.onCellFocused(forceBrowserFocus);
	    };
	    FocusController.prototype.isCellFocused = function (cellPosition) {
	        if (this.focusedCellPosition == null) {
	            return false;
	        }
	        return this.focusedCellPosition.column === cellPosition.column &&
	            this.isRowFocused(cellPosition.rowIndex, cellPosition.rowPinned);
	    };
	    FocusController.prototype.isRowNodeFocused = function (rowNode) {
	        return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
	    };
	    FocusController.prototype.isHeaderWrapperFocused = function (headerWrapper) {
	        if (this.focusedHeaderPosition == null) {
	            return false;
	        }
	        var column = headerWrapper.getColumn();
	        var headerRowIndex = headerWrapper.getParentComponent().getRowIndex();
	        var pinned = headerWrapper.getPinned();
	        var _a = this.focusedHeaderPosition, focusedColumn = _a.column, focusedHeaderRowIndex = _a.headerRowIndex;
	        return column === focusedColumn &&
	            headerRowIndex === focusedHeaderRowIndex &&
	            pinned == focusedColumn.getPinned();
	    };
	    FocusController.prototype.clearFocusedHeader = function () {
	        this.focusedHeaderPosition = null;
	    };
	    FocusController.prototype.getFocusedHeader = function () {
	        return this.focusedHeaderPosition;
	    };
	    FocusController.prototype.setFocusedHeader = function (headerRowIndex, column) {
	        this.focusedHeaderPosition = { headerRowIndex: headerRowIndex, column: column };
	    };
	    FocusController.prototype.focusHeaderPosition = function (headerPosition, direction, fromTab, allowUserOverride, event) {
	        if (direction === void 0) { direction = null; }
	        if (fromTab === void 0) { fromTab = false; }
	        if (allowUserOverride === void 0) { allowUserOverride = false; }
	        if (allowUserOverride) {
	            var gridOptionsWrapper = this.gridOptionsWrapper;
	            var currentPosition = this.getFocusedHeader();
	            var headerRowCount = this.headerNavigationService.getHeaderRowCount();
	            if (fromTab) {
	                var userFunc = gridOptionsWrapper.getTabToNextHeaderFunc();
	                if (userFunc) {
	                    var params = {
	                        backwards: direction === 'Before',
	                        previousHeaderPosition: currentPosition,
	                        nextHeaderPosition: headerPosition,
	                        headerRowCount: headerRowCount
	                    };
	                    headerPosition = userFunc(params);
	                }
	            }
	            else {
	                var userFunc = gridOptionsWrapper.getNavigateToNextHeaderFunc();
	                if (userFunc && event) {
	                    var params = {
	                        key: event.key,
	                        previousHeaderPosition: currentPosition,
	                        nextHeaderPosition: headerPosition,
	                        headerRowCount: headerRowCount,
	                        event: event
	                    };
	                    headerPosition = userFunc(params);
	                }
	            }
	        }
	        if (!headerPosition) {
	            return false;
	        }
	        if (headerPosition.headerRowIndex === -1) {
	            return this.focusGridView(headerPosition.column);
	        }
	        this.headerNavigationService.scrollToColumn(headerPosition.column, direction);
	        var childContainer = this.headerNavigationService.getHeaderContainer(headerPosition.column.getPinned());
	        var rowComps = childContainer.getRowComps();
	        var nextRowComp = rowComps[headerPosition.headerRowIndex];
	        var headerComps = nextRowComp.getHeaderComps();
	        var nextHeader = headerComps[headerPosition.column.getUniqueId()];
	        if (nextHeader) {
	            // this will automatically call the setFocusedHeader method above
	            nextHeader.getFocusableElement().focus();
	            return true;
	        }
	        return false;
	    };
	    FocusController.prototype.isAnyCellFocused = function () {
	        return !!this.focusedCellPosition;
	    };
	    FocusController.prototype.isRowFocused = function (rowIndex, floating) {
	        if (this.focusedCellPosition == null) {
	            return false;
	        }
	        return this.focusedCellPosition.rowIndex === rowIndex && this.focusedCellPosition.rowPinned === makeNull(floating);
	    };
	    FocusController.prototype.findFocusableElements = function (rootNode, exclude, onlyUnmanaged) {
	        if (onlyUnmanaged === void 0) { onlyUnmanaged = false; }
	        var focusableString = Constants.FOCUSABLE_SELECTOR;
	        var excludeString = Constants.FOCUSABLE_EXCLUDE;
	        if (exclude) {
	            excludeString += ', ' + exclude;
	        }
	        if (onlyUnmanaged) {
	            excludeString += ', [tabindex="-1"]';
	        }
	        var nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString));
	        var excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
	        if (!excludeNodes.length) {
	            return nodes;
	        }
	        var diff = function (a, b) { return a.filter(function (element) { return b.indexOf(element) === -1; }); };
	        return diff(nodes, excludeNodes);
	    };
	    FocusController.prototype.focusInto = function (rootNode, up, onlyUnmanaged) {
	        if (up === void 0) { up = false; }
	        if (onlyUnmanaged === void 0) { onlyUnmanaged = false; }
	        var focusableElements = this.findFocusableElements(rootNode, null, onlyUnmanaged);
	        var toFocus = up ? last(focusableElements) : focusableElements[0];
	        if (toFocus) {
	            toFocus.focus();
	            return true;
	        }
	        return false;
	    };
	    FocusController.prototype.findNextFocusableElement = function (rootNode, onlyManaged, backwards) {
	        var focusable = this.findFocusableElements(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
	        var currentIndex;
	        if (onlyManaged) {
	            currentIndex = findIndex(focusable, function (el) { return el.contains(document.activeElement); });
	        }
	        else {
	            currentIndex = focusable.indexOf(document.activeElement);
	        }
	        var nextIndex = currentIndex + (backwards ? -1 : 1);
	        if (nextIndex < 0 || nextIndex >= focusable.length) {
	            return null;
	        }
	        return focusable[nextIndex];
	    };
	    FocusController.prototype.isFocusUnderManagedComponent = function (rootNode) {
	        var managedContainers = rootNode.querySelectorAll("." + ManagedFocusComponent.FOCUS_MANAGED_CLASS);
	        if (!managedContainers.length) {
	            return false;
	        }
	        for (var i = 0; i < managedContainers.length; i++) {
	            if (managedContainers[i].contains(document.activeElement)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    FocusController.prototype.findTabbableParent = function (node, limit) {
	        if (limit === void 0) { limit = 5; }
	        var counter = 0;
	        while (node && getTabIndex(node) === null && ++counter <= limit) {
	            node = node.parentElement;
	        }
	        if (getTabIndex(node) === null) {
	            return null;
	        }
	        return node;
	    };
	    FocusController.prototype.onCellFocused = function (forceBrowserFocus) {
	        var event = {
	            type: Events.EVENT_CELL_FOCUSED,
	            forceBrowserFocus: forceBrowserFocus,
	            rowIndex: null,
	            column: null,
	            floating: null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            rowPinned: null,
	            isFullWidthCell: false
	        };
	        if (this.focusedCellPosition) {
	            var rowIndex = event.rowIndex = this.focusedCellPosition.rowIndex;
	            var rowPinned = event.rowPinned = this.focusedCellPosition.rowPinned;
	            event.column = this.focusedCellPosition.column;
	            var rowCon = this.rowRenderer.getRowConByPosition({ rowIndex: rowIndex, rowPinned: rowPinned });
	            if (rowCon) {
	                event.isFullWidthCell = rowCon.isFullWidth();
	            }
	        }
	        this.eventService.dispatchEvent(event);
	    };
	    FocusController.prototype.focusGridView = function (column, backwards) {
	        var nextRow = backwards
	            ? this.rowPositionUtils.getLastRow()
	            : this.rowPositionUtils.getFirstRow();
	        if (!nextRow) {
	            return false;
	        }
	        var rowIndex = nextRow.rowIndex, rowPinned = nextRow.rowPinned;
	        var focusedHeader = this.getFocusedHeader();
	        if (!column && focusedHeader) {
	            column = focusedHeader.column;
	        }
	        if (rowIndex == null || !column) {
	            return false;
	        }
	        this.rowRenderer.ensureCellVisible({ rowIndex: rowIndex, column: column, rowPinned: rowPinned });
	        this.setFocusedCell(rowIndex, column, makeNull(rowPinned), true);
	        if (this.rangeController) {
	            var cellPosition = { rowIndex: rowIndex, rowPinned: rowPinned, column: column };
	            this.rangeController.setRangeToCell(cellPosition);
	        }
	        return true;
	    };
	    FocusController.prototype.focusNextGridCoreContainer = function (backwards) {
	        if (this.gridCompController.focusNextInnerContainer(backwards)) {
	            return true;
	        }
	        if (!backwards) {
	            this.gridCompController.forceFocusOutOfContainer();
	        }
	        return false;
	    };
	    var FocusController_1;
	    FocusController.AG_KEYBOARD_FOCUS = 'ag-keyboard-focus';
	    FocusController.keyboardModeActive = false;
	    FocusController.instancesMonitored = new Map();
	    __decorate$1a([
	        Autowired('columnController')
	    ], FocusController.prototype, "columnController", void 0);
	    __decorate$1a([
	        Autowired('headerNavigationService')
	    ], FocusController.prototype, "headerNavigationService", void 0);
	    __decorate$1a([
	        Autowired('columnApi')
	    ], FocusController.prototype, "columnApi", void 0);
	    __decorate$1a([
	        Autowired('gridApi')
	    ], FocusController.prototype, "gridApi", void 0);
	    __decorate$1a([
	        Autowired('rowRenderer')
	    ], FocusController.prototype, "rowRenderer", void 0);
	    __decorate$1a([
	        Autowired('rowPositionUtils')
	    ], FocusController.prototype, "rowPositionUtils", void 0);
	    __decorate$1a([
	        Optional('rangeController')
	    ], FocusController.prototype, "rangeController", void 0);
	    __decorate$1a([
	        PostConstruct
	    ], FocusController.prototype, "init", null);
	    FocusController = FocusController_1 = __decorate$1a([
	        Bean('focusController')
	    ], FocusController);
	    return FocusController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1h = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1b = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var PopupService = /** @class */ (function (_super) {
	    __extends$1h(PopupService, _super);
	    function PopupService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.popupList = [];
	        return _this;
	    }
	    PopupService.prototype.registerGridCompController = function (gridCompController) {
	        var _this = this;
	        this.gridCompController = gridCompController;
	        this.addManagedListener(this.gridCompController, Events.EVENT_KEYBOARD_FOCUS, function () {
	            forEach(_this.popupList, function (popup) { return addCssClass(popup.element, FocusController.AG_KEYBOARD_FOCUS); });
	        });
	        this.addManagedListener(this.gridCompController, Events.EVENT_MOUSE_FOCUS, function () {
	            forEach(_this.popupList, function (popup) { return removeCssClass(popup.element, FocusController.AG_KEYBOARD_FOCUS); });
	        });
	    };
	    PopupService.prototype.getPopupParent = function () {
	        var ePopupParent = this.gridOptionsWrapper.getPopupParent();
	        if (ePopupParent) {
	            return ePopupParent;
	        }
	        return this.gridCompController.getGui();
	    };
	    PopupService.prototype.positionPopupForMenu = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var parentRect = this.getParentRect();
	        var y = this.keepYWithinBounds(params, sourceRect.top - parentRect.top);
	        var minWidth = (params.ePopup.clientWidth > 0) ? params.ePopup.clientWidth : 200;
	        params.ePopup.style.minWidth = minWidth + "px";
	        var widthOfParent = parentRect.right - parentRect.left;
	        var maxX = widthOfParent - minWidth;
	        // the x position of the popup depends on RTL or LTR. for normal cases, LTR, we put the child popup
	        // to the right, unless it doesn't fit and we then put it to the left. for RTL it's the other way around,
	        // we try place it first to the left, and then if not to the right.
	        var x;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, try left first
	            x = xLeftPosition();
	            if (x < 0) {
	                x = xRightPosition();
	            }
	            if (x > maxX) {
	                x = 0;
	            }
	        }
	        else {
	            // for LTR, try right first
	            x = xRightPosition();
	            if (x > maxX) {
	                x = xLeftPosition();
	            }
	            if (x < 0) {
	                x = 0;
	            }
	        }
	        params.ePopup.style.left = x + "px";
	        params.ePopup.style.top = y + "px";
	        function xRightPosition() {
	            return sourceRect.right - parentRect.left - 2;
	        }
	        function xLeftPosition() {
	            return sourceRect.left - parentRect.left - minWidth;
	        }
	    };
	    PopupService.prototype.positionPopupUnderMouseEvent = function (params) {
	        var _a = this.calculatePointerAlign(params.mouseEvent), x = _a.x, y = _a.y;
	        var ePopup = params.ePopup, nudgeX = params.nudgeX, nudgeY = params.nudgeY;
	        this.positionPopup({
	            ePopup: ePopup,
	            x: x,
	            y: y,
	            nudgeX: nudgeX,
	            nudgeY: nudgeY,
	            keepWithinBounds: true
	        });
	        this.callPostProcessPopup(params.type, params.ePopup, null, params.mouseEvent, params.column, params.rowNode);
	    };
	    PopupService.prototype.calculatePointerAlign = function (e) {
	        var parentRect = this.getParentRect();
	        return {
	            x: e.clientX - parentRect.left,
	            y: e.clientY - parentRect.top
	        };
	    };
	    PopupService.prototype.positionPopupUnderComponent = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var alignSide = params.alignSide || 'left';
	        var parentRect = this.getParentRect();
	        var x = sourceRect.left - parentRect.left;
	        if (alignSide === 'right') {
	            x -= (params.ePopup.offsetWidth - sourceRect.width);
	        }
	        this.positionPopup({
	            ePopup: params.ePopup,
	            minWidth: params.minWidth,
	            minHeight: params.minHeight,
	            nudgeX: params.nudgeX,
	            nudgeY: params.nudgeY,
	            x: x,
	            y: sourceRect.top - parentRect.top + sourceRect.height,
	            keepWithinBounds: params.keepWithinBounds
	        });
	        this.callPostProcessPopup(params.type, params.ePopup, params.eventSource, null, params.column, params.rowNode);
	    };
	    PopupService.prototype.positionPopupOverComponent = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var parentRect = this.getParentRect();
	        this.positionPopup({
	            ePopup: params.ePopup,
	            minWidth: params.minWidth,
	            nudgeX: params.nudgeX,
	            nudgeY: params.nudgeY,
	            x: sourceRect.left - parentRect.left,
	            y: sourceRect.top - parentRect.top,
	            keepWithinBounds: params.keepWithinBounds
	        });
	        this.callPostProcessPopup(params.type, params.ePopup, params.eventSource, null, params.column, params.rowNode);
	    };
	    PopupService.prototype.callPostProcessPopup = function (type, ePopup, eventSource, mouseEvent, column, rowNode) {
	        var callback = this.gridOptionsWrapper.getPostProcessPopupFunc();
	        if (callback) {
	            var params = {
	                column: column,
	                rowNode: rowNode,
	                ePopup: ePopup,
	                type: type,
	                eventSource: eventSource,
	                mouseEvent: mouseEvent
	            };
	            callback(params);
	        }
	    };
	    PopupService.prototype.positionPopup = function (params) {
	        var x = params.x;
	        var y = params.y;
	        if (params.nudgeX) {
	            x += params.nudgeX;
	        }
	        if (params.nudgeY) {
	            y += params.nudgeY;
	        }
	        // if popup is overflowing to the bottom, move it up
	        if (params.keepWithinBounds) {
	            x = this.keepXWithinBounds(params, x);
	            y = this.keepYWithinBounds(params, y);
	        }
	        params.ePopup.style.left = x + "px";
	        params.ePopup.style.top = y + "px";
	    };
	    PopupService.prototype.getActivePopups = function () {
	        return this.popupList.map(function (popup) { return popup.element; });
	    };
	    PopupService.prototype.getParentRect = function () {
	        // subtract the popup parent borders, because popupParent.getBoundingClientRect
	        // returns the rect outside the borders, but the 0,0 coordinate for absolute
	        // positioning is inside the border, leading the popup to be off by the width
	        // of the border
	        var popupParent = this.getPopupParent();
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        if (popupParent === eDocument.body) {
	            popupParent = eDocument.documentElement;
	        }
	        var style = getComputedStyle(popupParent);
	        var bounds = popupParent.getBoundingClientRect();
	        return {
	            top: bounds.top + parseFloat(style.borderTopWidth) || 0,
	            left: bounds.left + parseFloat(style.borderLeftWidth) || 0,
	            right: bounds.right + parseFloat(style.borderRightWidth) || 0,
	            bottom: bounds.bottom + parseFloat(style.borderBottomWidth) || 0,
	        };
	    };
	    PopupService.prototype.keepYWithinBounds = function (params, y) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var docElement = eDocument.documentElement;
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        var isBody = popupParent === eDocument.body;
	        var minHeight = Math.min(200, parentRect.height);
	        var diff = 0;
	        if (params.minHeight && params.minHeight < minHeight) {
	            minHeight = params.minHeight;
	        }
	        else if (params.ePopup.offsetHeight > 0) {
	            minHeight = params.ePopup.clientHeight;
	            diff = getAbsoluteHeight(params.ePopup) - minHeight;
	        }
	        var heightOfParent = isBody ? (getAbsoluteHeight(docElement) + docElement.scrollTop) : parentRect.height;
	        if (isBody) {
	            heightOfParent -= Math.abs(documentRect.top - parentRect.top);
	        }
	        var maxY = heightOfParent - minHeight - diff;
	        return Math.min(Math.max(y, 0), Math.abs(maxY));
	    };
	    PopupService.prototype.keepXWithinBounds = function (params, x) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var docElement = eDocument.documentElement;
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        var isBody = popupParent === eDocument.body;
	        var ePopup = params.ePopup;
	        var minWidth = Math.min(200, parentRect.width);
	        var diff = 0;
	        if (params.minWidth && params.minWidth < minWidth) {
	            minWidth = params.minWidth;
	        }
	        else if (ePopup.offsetWidth > 0) {
	            minWidth = ePopup.offsetWidth;
	            ePopup.style.minWidth = minWidth + "px";
	            diff = getAbsoluteWidth(ePopup) - minWidth;
	        }
	        var widthOfParent = isBody ? (getAbsoluteWidth(docElement) + docElement.scrollLeft) : parentRect.width;
	        if (isBody) {
	            widthOfParent -= Math.abs(documentRect.left - parentRect.left);
	        }
	        var maxX = widthOfParent - minWidth - diff;
	        return Math.min(Math.max(x, 0), Math.abs(maxX));
	    };
	    PopupService.prototype.keepPopupPositionedRelativeTo = function (params) {
	        var eParent = this.getPopupParent();
	        var parentRect = eParent.getBoundingClientRect();
	        var sourceRect = params.element.getBoundingClientRect();
	        var initialDiffTop = parentRect.top - sourceRect.top;
	        var initialDiffLeft = parentRect.left - sourceRect.left;
	        var lastDiffTop = initialDiffTop;
	        var lastDiffLeft = initialDiffLeft;
	        var topPx = params.ePopup.style.top;
	        var top = parseInt(topPx.substring(0, topPx.length - 1), 10);
	        var leftPx = params.ePopup.style.left;
	        var left = parseInt(leftPx.substring(0, leftPx.length - 1), 10);
	        var intervalId = window.setInterval(function () {
	            var pRect = eParent.getBoundingClientRect();
	            var sRect = params.element.getBoundingClientRect();
	            var elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
	            if (elementNotInDom) {
	                params.hidePopup();
	                return;
	            }
	            var currentDiffTop = pRect.top - sRect.top;
	            if (currentDiffTop != lastDiffTop) {
	                var newTop = top + initialDiffTop - currentDiffTop;
	                params.ePopup.style.top = newTop + "px";
	            }
	            lastDiffTop = currentDiffTop;
	            var currentDiffLeft = pRect.left - sRect.left;
	            if (currentDiffLeft != lastDiffLeft) {
	                var newLeft = left + initialDiffLeft - currentDiffLeft;
	                params.ePopup.style.left = newLeft + "px";
	            }
	            lastDiffLeft = currentDiffLeft;
	        }, 200);
	        var res = function () {
	            if (intervalId != null) {
	                window.clearInterval(intervalId);
	            }
	            intervalId = undefined;
	        };
	        return res;
	    };
	    PopupService.prototype.addPopup = function (params) {
	        var _this = this;
	        var modal = params.modal, eChild = params.eChild, closeOnEsc = params.closeOnEsc, closedCallback = params.closedCallback, click = params.click, alwaysOnTop = params.alwaysOnTop, afterGuiAttached = params.afterGuiAttached, positionCallback = params.positionCallback, anchorToElement = params.anchorToElement;
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        if (!eDocument) {
	            console.warn('ag-grid: could not find the document, document is empty');
	            return;
	        }
	        var pos = findIndex(this.popupList, function (popup) { return popup.element === eChild; });
	        if (pos !== -1) {
	            var popup = this.popupList[pos];
	            return { hideFunc: popup.hideFunc, stopAnchoringFunc: popup.stopAnchoringFunc };
	        }
	        var ePopupParent = this.getPopupParent();
	        // for angular specifically, but shouldn't cause an issue with js or other fw's
	        // https://github.com/angular/angular/issues/8563
	        ePopupParent.appendChild(eChild);
	        if (eChild.style.top == null) {
	            eChild.style.top = '0px';
	        }
	        if (eChild.style.left == null) {
	            eChild.style.left = '0px';
	        }
	        // add env CSS class to child, in case user provided a popup parent, which means
	        // theme class may be missing
	        var eWrapper = document.createElement('div');
	        var theme = this.environment.getTheme().theme;
	        if (theme) {
	            addCssClass(eWrapper, theme);
	        }
	        addCssClass(eWrapper, 'ag-popup');
	        addCssClass(eChild, this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr');
	        addCssClass(eChild, 'ag-popup-child');
	        if (this.focusController.isKeyboardMode()) {
	            addCssClass(eChild, FocusController.AG_KEYBOARD_FOCUS);
	        }
	        eWrapper.appendChild(eChild);
	        ePopupParent.appendChild(eWrapper);
	        if (alwaysOnTop) {
	            this.setAlwaysOnTop(eWrapper, true);
	        }
	        else {
	            this.bringPopupToFront(eWrapper);
	        }
	        var popupHidden = false;
	        var hidePopupOnKeyboardEvent = function (event) {
	            if (!eWrapper.contains(document.activeElement)) {
	                return;
	            }
	            var key = event.which || event.keyCode;
	            if (key === KeyCode.ESCAPE) {
	                hidePopup({ keyboardEvent: event });
	            }
	        };
	        var hidePopupOnMouseEvent = function (event) { return hidePopup({ mouseEvent: event }); };
	        var hidePopupOnTouchEvent = function (event) { return hidePopup({ touchEvent: event }); };
	        var destroyPositionTracker;
	        var hidePopup = function (popupParams) {
	            if (popupParams === void 0) { popupParams = {}; }
	            var mouseEvent = popupParams.mouseEvent, touchEvent = popupParams.touchEvent, keyboardEvent = popupParams.keyboardEvent;
	            if (
	            // we don't hide popup if the event was on the child, or any
	            // children of this child
	            _this.isEventFromCurrentPopup({ mouseEvent: mouseEvent, touchEvent: touchEvent }, eChild) ||
	                // if the event to close is actually the open event, then ignore it
	                _this.isEventSameChainAsOriginalEvent({ originalMouseEvent: click, mouseEvent: mouseEvent, touchEvent: touchEvent }) ||
	                // this method should only be called once. the client can have different
	                // paths, each one wanting to close, so this method may be called multiple times.
	                popupHidden) {
	                return;
	            }
	            popupHidden = true;
	            ePopupParent.removeChild(eWrapper);
	            eDocument.removeEventListener('keydown', hidePopupOnKeyboardEvent);
	            eDocument.removeEventListener('mousedown', hidePopupOnMouseEvent);
	            eDocument.removeEventListener('touchstart', hidePopupOnTouchEvent);
	            eDocument.removeEventListener('contextmenu', hidePopupOnMouseEvent);
	            _this.eventService.removeEventListener(Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
	            if (closedCallback) {
	                closedCallback(mouseEvent || touchEvent || keyboardEvent);
	            }
	            _this.popupList = _this.popupList.filter(function (popup) { return popup.element !== eChild; });
	            if (destroyPositionTracker) {
	                destroyPositionTracker();
	            }
	        };
	        if (afterGuiAttached) {
	            afterGuiAttached({ hidePopup: hidePopup });
	        }
	        // if we add these listeners now, then the current mouse
	        // click will be included, which we don't want
	        window.setTimeout(function () {
	            if (closeOnEsc) {
	                eDocument.addEventListener('keydown', hidePopupOnKeyboardEvent);
	            }
	            if (modal) {
	                eDocument.addEventListener('mousedown', hidePopupOnMouseEvent);
	                _this.eventService.addEventListener(Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
	                eDocument.addEventListener('touchstart', hidePopupOnTouchEvent);
	                eDocument.addEventListener('contextmenu', hidePopupOnMouseEvent);
	            }
	        }, 0);
	        if (positionCallback) {
	            positionCallback();
	        }
	        if (anchorToElement) {
	            // keeps popup positioned under created, eg if context menu, if user scrolls
	            // using touchpad and the cell moves, it moves the popup to keep it with the cell.
	            destroyPositionTracker = this.keepPopupPositionedRelativeTo({
	                element: anchorToElement,
	                ePopup: eChild,
	                hidePopup: hidePopup
	            });
	        }
	        this.popupList.push({
	            element: eChild,
	            hideFunc: hidePopup,
	            stopAnchoringFunc: destroyPositionTracker
	        });
	        return {
	            hideFunc: hidePopup,
	            stopAnchoringFunc: destroyPositionTracker
	        };
	    };
	    PopupService.prototype.isEventFromCurrentPopup = function (params, target) {
	        var mouseEvent = params.mouseEvent, touchEvent = params.touchEvent;
	        var event = mouseEvent ? mouseEvent : touchEvent;
	        if (!event) {
	            return false;
	        }
	        var indexOfThisChild = findIndex(this.popupList, function (popup) { return popup.element === target; });
	        if (indexOfThisChild === -1) {
	            return false;
	        }
	        for (var i = indexOfThisChild; i < this.popupList.length; i++) {
	            var popup = this.popupList[i];
	            if (isElementInEventPath(popup.element, event)) {
	                return true;
	            }
	        }
	        // if the user did not write their own Custom Element to be rendered as popup
	        // and this component has an additional popup element, they should have the
	        // `ag-custom-component-popup` class to be detected as part of the Custom Component
	        return this.isElementWithinCustomPopup(event.target);
	    };
	    PopupService.prototype.isElementWithinCustomPopup = function (el) {
	        if (!this.popupList.length) {
	            return false;
	        }
	        while (el && el !== document.body) {
	            if (el.classList.contains('ag-custom-component-popup') || el.parentElement === null) {
	                return true;
	            }
	            el = el.parentElement;
	        }
	        return false;
	    };
	    // in some browsers, the context menu event can be fired before the click event, which means
	    // the context menu event could open the popup, but then the click event closes it straight away.
	    PopupService.prototype.isEventSameChainAsOriginalEvent = function (params) {
	        var originalMouseEvent = params.originalMouseEvent, mouseEvent = params.mouseEvent, touchEvent = params.touchEvent;
	        // we check the coordinates of the event, to see if it's the same event. there is a 1 / 1000 chance that
	        // the event is a different event, however that is an edge case that is not very relevant (the user clicking
	        // twice on the same location isn't a normal path).
	        // event could be mouse event or touch event.
	        var mouseEventOrTouch = null;
	        if (mouseEvent) {
	            // mouse event can be used direction, it has coordinates
	            mouseEventOrTouch = mouseEvent;
	        }
	        else if (touchEvent) {
	            // touch event doesn't have coordinates, need it's touch object
	            mouseEventOrTouch = touchEvent.touches[0];
	        }
	        if (mouseEventOrTouch && originalMouseEvent) {
	            // for x, allow 4px margin, to cover iPads, where touch (which opens menu) is followed
	            // by browser click (when you finger up, touch is interrupted as click in browser)
	            var screenX_1 = mouseEvent ? mouseEvent.screenX : 0;
	            var screenY_1 = mouseEvent ? mouseEvent.screenY : 0;
	            var xMatch = Math.abs(originalMouseEvent.screenX - screenX_1) < 5;
	            var yMatch = Math.abs(originalMouseEvent.screenY - screenY_1) < 5;
	            if (xMatch && yMatch) {
	                return true;
	            }
	        }
	        return false;
	    };
	    PopupService.prototype.getWrapper = function (ePopup) {
	        while (!containsClass(ePopup, 'ag-popup') && ePopup.parentElement) {
	            ePopup = ePopup.parentElement;
	        }
	        return containsClass(ePopup, 'ag-popup') ? ePopup : null;
	    };
	    PopupService.prototype.setAlwaysOnTop = function (ePopup, alwaysOnTop) {
	        var eWrapper = this.getWrapper(ePopup);
	        if (!eWrapper) {
	            return;
	        }
	        addOrRemoveCssClass(eWrapper, 'ag-always-on-top', !!alwaysOnTop);
	        if (alwaysOnTop) {
	            this.bringPopupToFront(eWrapper);
	        }
	    };
	    PopupService.prototype.bringPopupToFront = function (ePopup) {
	        var parent = this.getPopupParent();
	        var popupList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup'));
	        var popupLen = popupList.length;
	        var alwaysOnTopList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup.ag-always-on-top'));
	        var onTopLength = alwaysOnTopList.length;
	        var eWrapper = this.getWrapper(ePopup);
	        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) {
	            return;
	        }
	        var pos = popupList.indexOf(eWrapper);
	        if (onTopLength) {
	            var isPopupAlwaysOnTop = containsClass(eWrapper, 'ag-always-on-top');
	            if (isPopupAlwaysOnTop) {
	                if (pos !== popupLen - 1) {
	                    last(alwaysOnTopList).insertAdjacentElement('afterend', eWrapper);
	                }
	            }
	            else if (pos !== popupLen - onTopLength - 1) {
	                alwaysOnTopList[0].insertAdjacentElement('beforebegin', eWrapper);
	            }
	        }
	        else if (pos !== popupLen - 1) {
	            last(popupList).insertAdjacentElement('afterend', eWrapper);
	        }
	        var params = {
	            type: 'popupToFront',
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            eWrapper: eWrapper
	        };
	        this.eventService.dispatchEvent(params);
	    };
	    __decorate$1b([
	        Autowired('environment')
	    ], PopupService.prototype, "environment", void 0);
	    __decorate$1b([
	        Autowired('focusController')
	    ], PopupService.prototype, "focusController", void 0);
	    PopupService = __decorate$1b([
	        Bean('popupService')
	    ], PopupService);
	    return PopupService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1i = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1c = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$7 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var LoggerFactory = /** @class */ (function (_super) {
	    __extends$1i(LoggerFactory, _super);
	    function LoggerFactory() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LoggerFactory.prototype.setBeans = function (gridOptionsWrapper) {
	        this.logging = gridOptionsWrapper.isDebug();
	    };
	    LoggerFactory.prototype.create = function (name) {
	        return new Logger(name, this.isLogging.bind(this));
	    };
	    LoggerFactory.prototype.isLogging = function () {
	        return this.logging;
	    };
	    __decorate$1c([
	        __param$7(0, Qualifier('gridOptionsWrapper'))
	    ], LoggerFactory.prototype, "setBeans", null);
	    LoggerFactory = __decorate$1c([
	        Bean('loggerFactory')
	    ], LoggerFactory);
	    return LoggerFactory;
	}(BeanStub));
	var Logger = /** @class */ (function () {
	    function Logger(name, isLoggingFunc) {
	        this.name = name;
	        this.isLoggingFunc = isLoggingFunc;
	    }
	    Logger.prototype.isLogging = function () {
	        return this.isLoggingFunc();
	    };
	    Logger.prototype.log = function (message) {
	        if (this.isLoggingFunc()) {
	            // tslint:disable-next-line
	            console.log('AG Grid.' + this.name + ': ' + message);
	        }
	    };
	    return Logger;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1j = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1d = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AutoWidthCalculator = /** @class */ (function (_super) {
	    __extends$1j(AutoWidthCalculator, _super);
	    function AutoWidthCalculator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AutoWidthCalculator.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function (p) {
	            _this.centerRowContainerCon = p.centerRowContainerCon;
	        });
	    };
	    AutoWidthCalculator.prototype.registerHeaderRootComp = function (headerRootComp) {
	        this.headerRootComp = headerRootComp;
	    };
	    // this is the trick: we create a dummy container and clone all the cells
	    // into the dummy, then check the dummy's width. then destroy the dummy
	    // as we don't need it any more.
	    // drawback: only the cells visible on the screen are considered
	    AutoWidthCalculator.prototype.getPreferredWidthForColumn = function (column, skipHeader) {
	        var eHeaderCell = this.getHeaderCellForColumn(column);
	        // cell isn't visible
	        if (!eHeaderCell) {
	            return -1;
	        }
	        var eDummyContainer = document.createElement('span');
	        // position fixed, so it isn't restricted to the boundaries of the parent
	        eDummyContainer.style.position = 'fixed';
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        var eBodyContainer = this.centerRowContainerCon.getContainerElement();
	        eBodyContainer.appendChild(eDummyContainer);
	        // get all the cells that are currently displayed (this only brings back
	        // rendered cells, rows not rendered due to row visualisation will not be here)
	        this.putRowCellsIntoDummyContainer(column, eDummyContainer);
	        if (!skipHeader) {
	            // we only consider the lowest level cell, not the group cell. in 99% of the time, this
	            // will be enough. if we consider groups, then it gets too complicated for what it's worth,
	            // as the groups can span columns and this class only considers one column at a time.
	            this.cloneItemIntoDummy(eHeaderCell, eDummyContainer);
	        }
	        // at this point, all the clones are lined up vertically with natural widths. the dummy
	        // container will have a width wide enough just to fit the largest.
	        var dummyContainerWidth = eDummyContainer.offsetWidth;
	        // we are finished with the dummy container, so get rid of it
	        eBodyContainer.removeChild(eDummyContainer);
	        // we add padding as I found sometimes the gui still put '...' after some of the texts. so the
	        // user can configure the grid to add a few more pixels after the calculated width
	        var autoSizePadding = this.gridOptionsWrapper.getAutoSizePadding();
	        return dummyContainerWidth + autoSizePadding;
	    };
	    AutoWidthCalculator.prototype.getHeaderCellForColumn = function (column) {
	        var comp = null;
	        // find the rendered header cell
	        this.headerRootComp.forEachHeaderElement(function (headerElement) {
	            if (headerElement instanceof HeaderWrapperComp) {
	                var headerWrapperComp = headerElement;
	                if (headerWrapperComp.getColumn() === column) {
	                    comp = headerWrapperComp;
	                }
	            }
	        });
	        return comp ? comp.getGui() : null;
	    };
	    AutoWidthCalculator.prototype.putRowCellsIntoDummyContainer = function (column, eDummyContainer) {
	        var _this = this;
	        var eCells = this.rowRenderer.getAllCellsForColumn(column);
	        eCells.forEach(function (eCell) { return _this.cloneItemIntoDummy(eCell, eDummyContainer); });
	    };
	    AutoWidthCalculator.prototype.cloneItemIntoDummy = function (eCell, eDummyContainer) {
	        // make a deep clone of the cell
	        var eCellClone = eCell.cloneNode(true);
	        // the original has a fixed width, we remove this to allow the natural width based on content
	        eCellClone.style.width = '';
	        // the original has position = absolute, we need to remove this so it's positioned normally
	        eCellClone.style.position = 'static';
	        eCellClone.style.left = '';
	        // we put the cell into a containing div, as otherwise the cells would just line up
	        // on the same line, standard flow layout, by putting them into divs, they are laid
	        // out one per line
	        var eCloneParent = document.createElement('div');
	        if (containsClass(eCellClone, 'ag-header-cell')) {
	            addCssClass(eCloneParent, 'ag-header');
	            addCssClass(eCloneParent, 'ag-header-row');
	            eCloneParent.style.position = 'static';
	        }
	        else {
	            addCssClass(eCloneParent, 'ag-row');
	        }
	        // table-row, so that each cell is on a row. i also tried display='block', but this
	        // didn't work in IE
	        eCloneParent.style.display = 'table-row';
	        // the twig on the branch, the branch on the tree, the tree in the hole,
	        // the hole in the bog, the bog in the clone, the clone in the parent,
	        // the parent in the dummy, and the dummy down in the vall-e-ooo, OOOOOOOOO! Oh row the rattling bog....
	        eCloneParent.appendChild(eCellClone);
	        eDummyContainer.appendChild(eCloneParent);
	    };
	    __decorate$1d([
	        Autowired('rowRenderer')
	    ], AutoWidthCalculator.prototype, "rowRenderer", void 0);
	    __decorate$1d([
	        Autowired('controllersService')
	    ], AutoWidthCalculator.prototype, "controllersService", void 0);
	    __decorate$1d([
	        PostConstruct
	    ], AutoWidthCalculator.prototype, "postConstruct", null);
	    AutoWidthCalculator = __decorate$1d([
	        Bean('autoWidthCalculator')
	    ], AutoWidthCalculator);
	    return AutoWidthCalculator;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1k = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1e = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HorizontalResizeService = /** @class */ (function (_super) {
	    __extends$1k(HorizontalResizeService, _super);
	    function HorizontalResizeService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HorizontalResizeService.prototype.addResizeBar = function (params) {
	        var _this = this;
	        var dragSource = {
	            dragStartPixels: params.dragStartPixels || 0,
	            eElement: params.eResizeBar,
	            onDragStart: this.onDragStart.bind(this, params),
	            onDragStop: this.onDragStop.bind(this, params),
	            onDragging: this.onDragging.bind(this, params)
	        };
	        this.dragService.addDragSource(dragSource, true);
	        // we pass remove func back to the caller, so call can tell us when they
	        // are finished, and then we remove the listener from the drag source
	        var finishedWithResizeFunc = function () { return _this.dragService.removeDragSource(dragSource); };
	        return finishedWithResizeFunc;
	    };
	    HorizontalResizeService.prototype.onDragStart = function (params, mouseEvent) {
	        this.dragStartX = mouseEvent.clientX;
	        this.setResizeIcons();
	        var shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
	        params.onResizeStart(shiftKey);
	    };
	    HorizontalResizeService.prototype.setResizeIcons = function () {
	        this.oldBodyCursor = this.eGridDiv.style.cursor;
	        this.oldUserSelect = this.eGridDiv.style.userSelect;
	        this.oldWebkitUserSelect = this.eGridDiv.style.webkitUserSelect;
	        // change the body cursor, so when drag moves out of the drag bar, the cursor is still 'resize' (or 'move'
	        this.eGridDiv.style.cursor = 'ew-resize';
	        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
	        this.eGridDiv.style.userSelect = 'none';
	        this.eGridDiv.style.webkitUserSelect = 'none';
	    };
	    HorizontalResizeService.prototype.onDragStop = function (params, mouseEvent) {
	        params.onResizeEnd(this.resizeAmount);
	        this.resetIcons();
	    };
	    HorizontalResizeService.prototype.resetIcons = function () {
	        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
	        this.eGridDiv.style.cursor = this.oldBodyCursor;
	        this.eGridDiv.style.userSelect = this.oldUserSelect;
	        this.eGridDiv.style.webkitUserSelect = this.oldWebkitUserSelect;
	    };
	    HorizontalResizeService.prototype.onDragging = function (params, mouseEvent) {
	        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
	        params.onResizing(this.resizeAmount);
	    };
	    __decorate$1e([
	        Autowired('dragService')
	    ], HorizontalResizeService.prototype, "dragService", void 0);
	    __decorate$1e([
	        Autowired('eGridDiv')
	    ], HorizontalResizeService.prototype, "eGridDiv", void 0);
	    HorizontalResizeService = __decorate$1e([
	        Bean('horizontalResizeService')
	    ], HorizontalResizeService);
	    return HorizontalResizeService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1l = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1f = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var GridCompController = /** @class */ (function (_super) {
	    __extends$1l(GridCompController, _super);
	    function GridCompController() {
	        return _super.call(this) || this;
	    }
	    GridCompController.prototype.postConstruct = function () {
	        var _this = this;
	        this.logger = this.loggerFactory.create('GridCompController');
	        // register with services that need grid core
	        [
	            this.gridApi,
	            this.popupService,
	            this.focusController,
	            this.controllersService
	        ].forEach(function (service) { return service.registerGridCompController(_this); });
	        if (ModuleRegistry.isRegistered(exports.ModuleNames.ClipboardModule)) {
	            this.clipboardService.registerGridCompController(this);
	        }
	    };
	    GridCompController.prototype.setView = function (view, eGridDiv, eGui) {
	        var _this = this;
	        this.view = view;
	        this.eGridHostDiv = eGridDiv;
	        this.eGui = eGui;
	        this.mouseEventService.stampTopLevelGridCompWithGridInstance(eGridDiv);
	        this.createManagedBean(new LayoutFeature(this.view));
	        // important to set rtl before doLayout, as setting the RTL class impacts the scroll position,
	        // which doLayout indirectly depends on
	        this.addRtlSupport();
	        this.addManagedListener(this, Events.EVENT_KEYBOARD_FOCUS, function () {
	            _this.view.addOrRemoveKeyboardFocusClass(true);
	        });
	        this.addManagedListener(this, Events.EVENT_MOUSE_FOCUS, function () {
	            _this.view.addOrRemoveKeyboardFocusClass(false);
	        });
	        var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
	        this.addDestroyFunc(function () { return unsubscribeFromResize(); });
	    };
	    GridCompController.prototype.showDropZones = function () {
	        return ModuleRegistry.isRegistered(exports.ModuleNames.RowGroupingModule);
	    };
	    GridCompController.prototype.showSideBar = function () {
	        return ModuleRegistry.isRegistered(exports.ModuleNames.SideBarModule);
	    };
	    GridCompController.prototype.showStatusBar = function () {
	        return ModuleRegistry.isRegistered(exports.ModuleNames.StatusBarModule);
	    };
	    GridCompController.prototype.showWatermark = function () {
	        return ModuleRegistry.isRegistered(exports.ModuleNames.EnterpriseCoreModule);
	    };
	    GridCompController.prototype.onGridSizeChanged = function () {
	        var event = {
	            type: Events.EVENT_GRID_SIZE_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            clientWidth: this.eGridHostDiv.clientWidth,
	            clientHeight: this.eGridHostDiv.clientHeight
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    GridCompController.prototype.addRtlSupport = function () {
	        var cssClass = this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr';
	        this.view.setRtlClass(cssClass);
	    };
	    GridCompController.prototype.destroyGridUi = function () {
	        this.view.destroyGridUi();
	    };
	    GridCompController.prototype.getGui = function () {
	        return this.eGui;
	    };
	    GridCompController.prototype.focusNextInnerContainer = function (backwards) {
	        var focusableContainers = this.view.getFocusableContainers();
	        var idxWithFocus = findIndex(focusableContainers, function (container) { return container.contains(document.activeElement); });
	        var nextIdx = idxWithFocus + (backwards ? -1 : 1);
	        if (nextIdx < 0 || nextIdx >= focusableContainers.length) {
	            return false;
	        }
	        if (nextIdx === 0) {
	            return this.focusGridHeader();
	        }
	        return this.focusController.focusInto(focusableContainers[nextIdx]);
	    };
	    GridCompController.prototype.focusGridHeader = function () {
	        var firstColumn = this.columnController.getAllDisplayedColumns()[0];
	        if (!firstColumn) {
	            return false;
	        }
	        if (firstColumn.getParent()) {
	            firstColumn = this.columnController.getColumnGroupAtLevel(firstColumn, 0);
	        }
	        this.focusController.focusHeaderPosition({ headerRowIndex: 0, column: firstColumn });
	        return true;
	    };
	    GridCompController.prototype.forceFocusOutOfContainer = function (up) {
	        if (up === void 0) { up = false; }
	        this.view.forceFocusOutOfContainer(up);
	    };
	    __decorate$1f([
	        Autowired('columnApi')
	    ], GridCompController.prototype, "columnApi", void 0);
	    __decorate$1f([
	        Autowired('gridApi')
	    ], GridCompController.prototype, "gridApi", void 0);
	    __decorate$1f([
	        Autowired('popupService')
	    ], GridCompController.prototype, "popupService", void 0);
	    __decorate$1f([
	        Autowired('focusController')
	    ], GridCompController.prototype, "focusController", void 0);
	    __decorate$1f([
	        Optional('clipboardService')
	    ], GridCompController.prototype, "clipboardService", void 0);
	    __decorate$1f([
	        Autowired('loggerFactory')
	    ], GridCompController.prototype, "loggerFactory", void 0);
	    __decorate$1f([
	        Autowired('resizeObserverService')
	    ], GridCompController.prototype, "resizeObserverService", void 0);
	    __decorate$1f([
	        Autowired('columnController')
	    ], GridCompController.prototype, "columnController", void 0);
	    __decorate$1f([
	        Autowired('controllersService')
	    ], GridCompController.prototype, "controllersService", void 0);
	    __decorate$1f([
	        Autowired('mouseEventService')
	    ], GridCompController.prototype, "mouseEventService", void 0);
	    __decorate$1f([
	        PostConstruct
	    ], GridCompController.prototype, "postConstruct", null);
	    return GridCompController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1m = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1g = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var GridComp = /** @class */ (function (_super) {
	    __extends$1m(GridComp, _super);
	    function GridComp(eGridDiv) {
	        var _this = _super.call(this, undefined, true) || this;
	        _this.eGridDiv = eGridDiv;
	        return _this;
	    }
	    GridComp.prototype.postConstruct = function () {
	        var _this = this;
	        this.logger = this.loggerFactory.create('GridComp');
	        var view = {
	            destroyGridUi: function () { return _this.destroyBean(_this); },
	            setRtlClass: function (cssClass) { return addCssClass(_this.getGui(), cssClass); },
	            addOrRemoveKeyboardFocusClass: function (addOrRemove) { return _this.addOrRemoveCssClass(FocusController.AG_KEYBOARD_FOCUS, addOrRemove); },
	            forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
	            updateLayoutClasses: this.updateLayoutClasses.bind(this),
	            getFocusableContainers: this.getFocusableContainers.bind(this)
	        };
	        this.con = this.createManagedBean(new GridCompController());
	        var template = this.createTemplate();
	        this.setTemplate(template);
	        this.con.setView(view, this.eGridDiv, this.getGui());
	        this.insertGridIntoDom();
	        _super.prototype.postConstruct.call(this);
	    };
	    GridComp.prototype.insertGridIntoDom = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        this.eGridDiv.appendChild(eGui);
	        this.addDestroyFunc(function () {
	            _this.eGridDiv.removeChild(eGui);
	            _this.logger.log('Grid removed from DOM');
	        });
	    };
	    GridComp.prototype.updateLayoutClasses = function (params) {
	        addOrRemoveCssClass(this.eRootWrapperBody, exports.LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
	        addOrRemoveCssClass(this.eRootWrapperBody, exports.LayoutCssClasses.NORMAL, params.normal);
	        addOrRemoveCssClass(this.eRootWrapperBody, exports.LayoutCssClasses.PRINT, params.print);
	        this.addOrRemoveCssClass(exports.LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
	        this.addOrRemoveCssClass(exports.LayoutCssClasses.NORMAL, params.normal);
	        this.addOrRemoveCssClass(exports.LayoutCssClasses.PRINT, params.print);
	    };
	    GridComp.prototype.createTemplate = function () {
	        var dropZones = this.con.showDropZones() ? '<ag-grid-header-drop-zones></ag-grid-header-drop-zones>' : '';
	        var sideBar = this.con.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : '';
	        var statusBar = this.con.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : '';
	        var watermark = this.con.showWatermark() ? '<ag-watermark></ag-watermark>' : '';
	        var template = /* html */ "<div ref=\"eRootWrapper\" class=\"ag-root-wrapper\">\n                " + dropZones + "\n                <div class=\"ag-root-wrapper-body\" ref=\"rootWrapperBody\">\n                    <ag-grid-body ref=\"gridBody\"></ag-grid-body>\n                    " + sideBar + "\n                </div>\n                " + statusBar + "\n                <ag-pagination></ag-pagination>\n                " + watermark + "\n            </div>";
	        return template;
	    };
	    GridComp.prototype.getFocusableElement = function () {
	        return this.eRootWrapperBody;
	    };
	    GridComp.prototype.getFocusableContainers = function () {
	        var focusableContainers = [
	            this.gridBodyComp.getGui()
	        ];
	        if (this.sideBarComp) {
	            focusableContainers.push(this.sideBarComp.getGui());
	        }
	        return focusableContainers.filter(function (el) { return isVisible(el); });
	    };
	    GridComp.prototype.focusInnerElement = function (fromBottom) {
	        var focusableContainers = this.getFocusableContainers();
	        if (fromBottom) {
	            if (focusableContainers.length > 1) {
	                return this.focusController.focusInto(last(focusableContainers));
	            }
	            var lastColumn = last(this.columnController.getAllDisplayedColumns());
	            if (this.focusController.focusGridView(lastColumn, true)) {
	                return true;
	            }
	        }
	        return this.con.focusGridHeader();
	    };
	    GridComp.prototype.onTabKeyDown = function () { };
	    __decorate$1g([
	        Autowired('columnController')
	    ], GridComp.prototype, "columnController", void 0);
	    __decorate$1g([
	        Autowired('loggerFactory')
	    ], GridComp.prototype, "loggerFactory", void 0);
	    __decorate$1g([
	        RefSelector('gridBody')
	    ], GridComp.prototype, "gridBodyComp", void 0);
	    __decorate$1g([
	        RefSelector('sideBar')
	    ], GridComp.prototype, "sideBarComp", void 0);
	    __decorate$1g([
	        RefSelector('rootWrapperBody')
	    ], GridComp.prototype, "eRootWrapperBody", void 0);
	    return GridComp;
	}(ManagedFocusComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1n = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1h = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var StandardMenuFactory = /** @class */ (function (_super) {
	    __extends$1n(StandardMenuFactory, _super);
	    function StandardMenuFactory() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StandardMenuFactory.prototype.registerGridComp = function (gridBodyComp) {
	        this.gridBodyComp = gridBodyComp;
	    };
	    StandardMenuFactory.prototype.hideActiveMenu = function () {
	        if (this.hidePopup) {
	            this.hidePopup();
	        }
	    };
	    StandardMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent) {
	        var _this = this;
	        this.showPopup(column, function (eMenu) {
	            _this.popupService.positionPopupUnderMouseEvent({
	                column: column,
	                type: 'columnMenu',
	                mouseEvent: mouseEvent,
	                ePopup: eMenu
	            });
	        }, mouseEvent.target);
	    };
	    StandardMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource) {
	        var _this = this;
	        this.showPopup(column, function (eMenu) {
	            _this.popupService.positionPopupUnderComponent({
	                type: 'columnMenu',
	                eventSource: eventSource,
	                ePopup: eMenu,
	                keepWithinBounds: true,
	                column: column
	            });
	        }, eventSource);
	    };
	    StandardMenuFactory.prototype.showPopup = function (column, positionCallback, eventSource) {
	        var _this = this;
	        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, 'COLUMN_MENU');
	        var eMenu = document.createElement('div');
	        eMenu.setAttribute('role', 'presentation');
	        addCssClass(eMenu, 'ag-menu');
	        this.tabListener = this.addManagedListener(eMenu, 'keydown', function (e) { return _this.trapFocusWithin(e, eMenu); });
	        filterWrapper.guiPromise.then(function (gui) { return eMenu.appendChild(gui); });
	        var hidePopup;
	        var anchorToElement = eventSource || this.gridBodyComp.getGui();
	        var closedCallback = function (e) {
	            column.setMenuVisible(false, 'contextMenu');
	            var isKeyboardEvent = e instanceof KeyboardEvent;
	            if (_this.tabListener) {
	                _this.tabListener = _this.tabListener();
	            }
	            if (isKeyboardEvent && eventSource && isVisible(eventSource)) {
	                var focusableEl = _this.focusController.findTabbableParent(eventSource);
	                if (focusableEl) {
	                    focusableEl.focus();
	                }
	            }
	        };
	        var addPopupRes = this.popupService.addPopup({
	            modal: true,
	            eChild: eMenu,
	            closeOnEsc: true,
	            closedCallback: closedCallback,
	            positionCallback: function () { return positionCallback(eMenu); },
	            anchorToElement: anchorToElement
	        });
	        if (addPopupRes) {
	            this.hidePopup = hidePopup = addPopupRes.hideFunc;
	        }
	        filterWrapper.filterPromise.then(function (filter) {
	            // need to make sure the filter is present before positioning, as only
	            // after filter it is visible can we find out what the width of it is
	            positionCallback(eMenu);
	            if (filter.afterGuiAttached) {
	                filter.afterGuiAttached({ container: 'columnMenu', hidePopup: hidePopup });
	            }
	        });
	        column.setMenuVisible(true, 'contextMenu');
	    };
	    StandardMenuFactory.prototype.trapFocusWithin = function (e, menu) {
	        if (e.keyCode !== KeyCode.TAB ||
	            e.defaultPrevented ||
	            this.focusController.findNextFocusableElement(menu, false, e.shiftKey)) {
	            return;
	        }
	        e.preventDefault();
	        this.focusController.focusInto(menu, e.shiftKey);
	    };
	    StandardMenuFactory.prototype.isMenuEnabled = function (column) {
	        // for standard, we show menu if filter is enabled, and the menu is not suppressed
	        return column.isFilterAllowed();
	    };
	    __decorate$1h([
	        Autowired('filterManager')
	    ], StandardMenuFactory.prototype, "filterManager", void 0);
	    __decorate$1h([
	        Autowired('popupService')
	    ], StandardMenuFactory.prototype, "popupService", void 0);
	    __decorate$1h([
	        Autowired('focusController')
	    ], StandardMenuFactory.prototype, "focusController", void 0);
	    StandardMenuFactory = __decorate$1h([
	        Bean('menuFactory')
	    ], StandardMenuFactory);
	    return StandardMenuFactory;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1o = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1i = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	/** Adds drag listening onto an element. In AG Grid this is used twice, first is resizing columns,
	 * second is moving the columns and column groups around (ie the 'drag' part of Drag and Drop. */
	var DragService = /** @class */ (function (_super) {
	    __extends$1o(DragService, _super);
	    function DragService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.dragEndFunctions = [];
	        _this.dragSources = [];
	        return _this;
	    }
	    DragService.prototype.init = function () {
	        this.logger = this.loggerFactory.create('DragService');
	    };
	    DragService.prototype.removeAllListeners = function () {
	        this.dragSources.forEach(this.removeListener.bind(this));
	        this.dragSources.length = 0;
	    };
	    DragService.prototype.removeListener = function (dragSourceAndListener) {
	        var element = dragSourceAndListener.dragSource.eElement;
	        var mouseDownListener = dragSourceAndListener.mouseDownListener;
	        element.removeEventListener('mousedown', mouseDownListener);
	        // remove touch listener only if it exists
	        if (dragSourceAndListener.touchEnabled) {
	            var touchStartListener = dragSourceAndListener.touchStartListener;
	            element.removeEventListener('touchstart', touchStartListener, { passive: true });
	        }
	    };
	    DragService.prototype.removeDragSource = function (params) {
	        var dragSourceAndListener = find(this.dragSources, function (item) { return item.dragSource === params; });
	        if (!dragSourceAndListener) {
	            return;
	        }
	        this.removeListener(dragSourceAndListener);
	        removeFromArray(this.dragSources, dragSourceAndListener);
	    };
	    DragService.prototype.setNoSelectToBody = function (noSelect) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var eBody = eDocument.querySelector('body');
	        if (exists(eBody)) {
	            // when we drag the mouse in AG Grid, this class gets added / removed from the body, so that
	            // the mouse isn't selecting text when dragging.
	            addOrRemoveCssClass(eBody, 'ag-unselectable', noSelect);
	        }
	    };
	    DragService.prototype.isDragging = function () {
	        return this.dragging;
	    };
	    DragService.prototype.addDragSource = function (params, includeTouch) {
	        if (includeTouch === void 0) { includeTouch = false; }
	        var mouseListener = this.onMouseDown.bind(this, params);
	        params.eElement.addEventListener('mousedown', mouseListener);
	        var touchListener = null;
	        var suppressTouch = this.gridOptionsWrapper.isSuppressTouch();
	        if (includeTouch && !suppressTouch) {
	            touchListener = this.onTouchStart.bind(this, params);
	            params.eElement.addEventListener('touchstart', touchListener, { passive: true });
	        }
	        this.dragSources.push({
	            dragSource: params,
	            mouseDownListener: mouseListener,
	            touchStartListener: touchListener,
	            touchEnabled: includeTouch
	        });
	    };
	    // gets called whenever mouse down on any drag source
	    DragService.prototype.onTouchStart = function (params, touchEvent) {
	        var _this = this;
	        this.currentDragParams = params;
	        this.dragging = false;
	        var touch = touchEvent.touches[0];
	        this.touchLastTime = touch;
	        this.touchStart = touch;
	        var touchMoveEvent = function (e) { return _this.onTouchMove(e, params.eElement); };
	        var touchEndEvent = function (e) { return _this.onTouchUp(e, params.eElement); };
	        var documentTouchMove = function (e) { if (e.cancelable) {
	            e.preventDefault();
	        } };
	        var target = params.eElement;
	        var events = [
	            // Prevents the page document from moving while we are dragging items around.
	            // preventDefault needs to be called in the touchmove listener and never inside the
	            // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
	            { target: document, type: 'touchmove', listener: documentTouchMove, options: { passive: false } },
	            { target: target, type: 'touchmove', listener: touchMoveEvent, options: { passive: true } },
	            { target: target, type: 'touchend', listener: touchEndEvent, options: { passive: true } },
	            { target: target, type: 'touchcancel', listener: touchEndEvent, options: { passive: true } }
	        ];
	        // temporally add these listeners, for the duration of the drag
	        this.addTemporaryEvents(events);
	        // see if we want to start dragging straight away
	        if (params.dragStartPixels === 0) {
	            this.onCommonMove(touch, this.touchStart, params.eElement);
	        }
	    };
	    // gets called whenever mouse down on any drag source
	    DragService.prototype.onMouseDown = function (params, mouseEvent) {
	        var _this = this;
	        var e = mouseEvent;
	        if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent)) {
	            return;
	        }
	        // if there are two elements with parent / child relationship, and both are draggable,
	        // when we drag the child, we should NOT drag the parent. an example of this is row moving
	        // and range selection - row moving should get preference when use drags the rowDrag component.
	        if (e._alreadyProcessedByDragService) {
	            return;
	        }
	        e._alreadyProcessedByDragService = true;
	        // only interested in left button clicks
	        if (mouseEvent.button !== 0) {
	            return;
	        }
	        this.currentDragParams = params;
	        this.dragging = false;
	        this.mouseStartEvent = mouseEvent;
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        this.setNoSelectToBody(true);
	        var mouseMoveEvent = function (event) { return _this.onMouseMove(event, params.eElement); };
	        var mouseUpEvent = function (event) { return _this.onMouseUp(event, params.eElement); };
	        var contextEvent = function (event) { return event.preventDefault(); };
	        var target = eDocument;
	        var events = [
	            { target: target, type: 'mousemove', listener: mouseMoveEvent },
	            { target: target, type: 'mouseup', listener: mouseUpEvent },
	            { target: target, type: 'contextmenu', listener: contextEvent }
	        ];
	        // temporally add these listeners, for the duration of the drag
	        this.addTemporaryEvents(events);
	        //see if we want to start dragging straight away
	        if (params.dragStartPixels === 0) {
	            this.onMouseMove(mouseEvent, params.eElement);
	        }
	    };
	    DragService.prototype.addTemporaryEvents = function (events) {
	        events.forEach(function (currentEvent) {
	            var target = currentEvent.target, type = currentEvent.type, listener = currentEvent.listener, options = currentEvent.options;
	            target.addEventListener(type, listener, options);
	        });
	        this.dragEndFunctions.push(function () {
	            events.forEach(function (currentEvent) {
	                var target = currentEvent.target, type = currentEvent.type, listener = currentEvent.listener, options = currentEvent.options;
	                target.removeEventListener(type, listener, options);
	            });
	        });
	    };
	    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
	    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
	    DragService.prototype.isEventNearStartEvent = function (currentEvent, startEvent) {
	        // by default, we wait 4 pixels before starting the drag
	        var dragStartPixels = this.currentDragParams.dragStartPixels;
	        var requiredPixelDiff = exists(dragStartPixels) ? dragStartPixels : 4;
	        return areEventsNear(currentEvent, startEvent, requiredPixelDiff);
	    };
	    DragService.prototype.getFirstActiveTouch = function (touchList) {
	        for (var i = 0; i < touchList.length; i++) {
	            if (touchList[i].identifier === this.touchStart.identifier) {
	                return touchList[i];
	            }
	        }
	        return null;
	    };
	    DragService.prototype.onCommonMove = function (currentEvent, startEvent, el) {
	        if (!this.dragging) {
	            // if mouse hasn't travelled from the start position enough, do nothing
	            if (!this.dragging && this.isEventNearStartEvent(currentEvent, startEvent)) {
	                return;
	            }
	            this.dragging = true;
	            var event_1 = {
	                type: Events.EVENT_DRAG_STARTED,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                target: el
	            };
	            this.eventService.dispatchEvent(event_1);
	            this.currentDragParams.onDragStart(startEvent);
	            // we need ONE drag action at the startEvent, so that we are guaranteed the drop target
	            // at the start gets notified. this is because the drag can start outside of the element
	            // that started it, as the mouse is allowed drag away from the mouse down before it's
	            // considered a drag (the isEventNearStartEvent() above). if we didn't do this, then
	            // it would be possible to click a column by the edge, then drag outside of the drop zone
	            // in less than 4 pixels and the drag officially starts outside of the header but the header
	            // wouldn't be notified of the dragging.
	            this.currentDragParams.onDragging(startEvent);
	        }
	        this.currentDragParams.onDragging(currentEvent);
	    };
	    DragService.prototype.onTouchMove = function (touchEvent, el) {
	        var touch = this.getFirstActiveTouch(touchEvent.touches);
	        if (!touch) {
	            return;
	        }
	        // this.___statusPanel.setInfoText(Math.random() + ' onTouchMove preventDefault stopPropagation');
	        this.onCommonMove(touch, this.touchStart, el);
	    };
	    // only gets called after a mouse down - as this is only added after mouseDown
	    // and is removed when mouseUp happens
	    DragService.prototype.onMouseMove = function (mouseEvent, el) {
	        this.onCommonMove(mouseEvent, this.mouseStartEvent, el);
	    };
	    DragService.prototype.onTouchUp = function (touchEvent, el) {
	        var touch = this.getFirstActiveTouch(touchEvent.changedTouches);
	        // i haven't worked this out yet, but there is no matching touch
	        // when we get the touch up event. to get around this, we swap in
	        // the last touch. this is a hack to 'get it working' while we
	        // figure out what's going on, why we are not getting a touch in
	        // current event.
	        if (!touch) {
	            touch = this.touchLastTime;
	        }
	        // if mouse was left up before we started to move, then this is a tap.
	        // we check this before onUpCommon as onUpCommon resets the dragging
	        // let tap = !this.dragging;
	        // let tapTarget = this.currentDragParams.eElement;
	        this.onUpCommon(touch, el);
	        // if tap, tell user
	        // console.log(`${Math.random()} tap = ${tap}`);
	        // if (tap) {
	        //     tapTarget.click();
	        // }
	    };
	    DragService.prototype.onMouseUp = function (mouseEvent, el) {
	        this.onUpCommon(mouseEvent, el);
	    };
	    DragService.prototype.onUpCommon = function (eventOrTouch, el) {
	        if (this.dragging) {
	            this.dragging = false;
	            this.currentDragParams.onDragStop(eventOrTouch);
	            var event_2 = {
	                type: Events.EVENT_DRAG_STOPPED,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                target: el
	            };
	            this.eventService.dispatchEvent(event_2);
	        }
	        this.setNoSelectToBody(false);
	        this.mouseStartEvent = null;
	        this.touchStart = null;
	        this.touchLastTime = null;
	        this.currentDragParams = null;
	        this.dragEndFunctions.forEach(function (func) { return func(); });
	        this.dragEndFunctions.length = 0;
	    };
	    __decorate$1i([
	        Autowired('loggerFactory')
	    ], DragService.prototype, "loggerFactory", void 0);
	    __decorate$1i([
	        Autowired('columnApi')
	    ], DragService.prototype, "columnApi", void 0);
	    __decorate$1i([
	        Autowired('gridApi')
	    ], DragService.prototype, "gridApi", void 0);
	    __decorate$1i([
	        PostConstruct
	    ], DragService.prototype, "init", null);
	    __decorate$1i([
	        PreDestroy
	    ], DragService.prototype, "removeAllListeners", null);
	    DragService = __decorate$1i([
	        Bean('dragService')
	    ], DragService);
	    return DragService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1p = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1j = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SortController = /** @class */ (function (_super) {
	    __extends$1p(SortController, _super);
	    function SortController() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SortController_1 = SortController;
	    SortController.prototype.progressSort = function (column, multiSort, source) {
	        if (source === void 0) { source = "api"; }
	        var nextDirection = this.getNextSortDirection(column);
	        this.setSortForColumn(column, nextDirection, multiSort, source);
	    };
	    SortController.prototype.setSortForColumn = function (column, sort, multiSort, source) {
	        if (source === void 0) { source = "api"; }
	        // auto correct - if sort not legal value, then set it to 'no sort' (which is null)
	        if (sort !== Constants.SORT_ASC && sort !== Constants.SORT_DESC) {
	            sort = null;
	        }
	        // update sort on current col
	        column.setSort(sort, source);
	        var doingMultiSort = multiSort && !this.gridOptionsWrapper.isSuppressMultiSort();
	        // clear sort on all columns except this one, and update the icons
	        if (!doingMultiSort) {
	            this.clearSortBarThisColumn(column, source);
	        }
	        // sortIndex used for knowing order of cols when multi-col sort
	        this.updateSortIndex(column);
	        this.dispatchSortChangedEvents();
	    };
	    SortController.prototype.updateSortIndex = function (lastColToChange) {
	        // update sortIndex on all sorting cols
	        var allSortedCols = this.getColumnsWithSortingOrdered();
	        var sortIndex = 0;
	        allSortedCols.forEach(function (col) {
	            if (col !== lastColToChange) {
	                col.setSortIndex(sortIndex);
	                sortIndex++;
	            }
	        });
	        // last col to change always gets the last sort index, it's added to the end
	        if (lastColToChange.getSort()) {
	            lastColToChange.setSortIndex(sortIndex);
	        }
	        // clear sort index on all cols not sorting
	        var allCols = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
	        allCols.filter(function (col) { return col.getSort() == null; }).forEach(function (col) { return col.setSortIndex(); });
	    };
	    // gets called by API, so if data changes, use can call this, which will end up
	    // working out the sort order again of the rows.
	    SortController.prototype.onSortChanged = function () {
	        this.dispatchSortChangedEvents();
	    };
	    SortController.prototype.isSortActive = function () {
	        // pull out all the columns that have sorting set
	        var allCols = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
	        var sortedCols = allCols.filter(function (column) { return !!column.getSort(); });
	        return sortedCols && sortedCols.length > 0;
	    };
	    SortController.prototype.dispatchSortChangedEvents = function () {
	        var event = {
	            type: Events.EVENT_SORT_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    SortController.prototype.clearSortBarThisColumn = function (columnToSkip, source) {
	        this.columnController.getPrimaryAndSecondaryAndAutoColumns().forEach(function (columnToClear) {
	            // Do not clear if either holding shift, or if column in question was clicked
	            if (columnToClear !== columnToSkip) {
	                // setting to 'undefined' as null means 'none' rather than cleared, otherwise issue will arise
	                // if sort order is: ['desc', null , 'asc'], as it will start at null rather than 'desc'.
	                columnToClear.setSort(undefined, source);
	            }
	        });
	    };
	    SortController.prototype.getNextSortDirection = function (column) {
	        var sortingOrder;
	        if (column.getColDef().sortingOrder) {
	            sortingOrder = column.getColDef().sortingOrder;
	        }
	        else if (this.gridOptionsWrapper.getSortingOrder()) {
	            sortingOrder = this.gridOptionsWrapper.getSortingOrder();
	        }
	        else {
	            sortingOrder = SortController_1.DEFAULT_SORTING_ORDER;
	        }
	        if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
	            console.warn("ag-grid: sortingOrder must be an array with at least one element, currently it's " + sortingOrder);
	            return null;
	        }
	        var currentIndex = sortingOrder.indexOf(column.getSort());
	        var notInArray = currentIndex < 0;
	        var lastItemInArray = currentIndex == sortingOrder.length - 1;
	        var result;
	        if (notInArray || lastItemInArray) {
	            result = sortingOrder[0];
	        }
	        else {
	            result = sortingOrder[currentIndex + 1];
	        }
	        // verify the sort type exists, as the user could provide the sortingOrder, need to make sure it's valid
	        if (SortController_1.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
	            console.warn('ag-grid: invalid sort type ' + result);
	            return null;
	        }
	        return result;
	    };
	    SortController.prototype.getColumnsWithSortingOrdered = function () {
	        // pull out all the columns that have sorting set
	        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
	        var columnsWithSorting = allColumnsIncludingAuto.filter(function (column) { return !!column.getSort(); });
	        // when both cols are missing sortIndex, we use the position of the col in all cols list.
	        // this means if colDefs only have sort, but no sortIndex, we deterministically pick which
	        // cols is sorted by first.
	        var allColsIndexes = {};
	        allColumnsIncludingAuto.forEach(function (col, index) { return allColsIndexes[col.getId()] = index; });
	        // put the columns in order of which one got sorted first
	        columnsWithSorting.sort(function (a, b) {
	            var iA = a.getSortIndex();
	            var iB = b.getSortIndex();
	            if (iA != null && iB != null) {
	                return iA - iB; // both present, normal comparison
	            }
	            else if (iA == null && iB == null) {
	                // both missing, compare using column positions
	                var posA = allColsIndexes[a.getId()];
	                var posB = allColsIndexes[b.getId()];
	                return posA > posB ? 1 : -1;
	            }
	            else if (iB == null) {
	                return -1; // iB missing
	            }
	            else {
	                return 1; // iA missing
	            }
	        });
	        return columnsWithSorting;
	    };
	    // used by server side row models, to sent sort to server
	    SortController.prototype.getSortModel = function () {
	        return this.getColumnsWithSortingOrdered().map(function (column) { return ({
	            sort: column.getSort(),
	            colId: column.getId()
	        }); });
	    };
	    SortController.prototype.getSortOptions = function () {
	        return this.getColumnsWithSortingOrdered().map(function (column) { return ({
	            sort: column.getSort(),
	            column: column
	        }); });
	    };
	    var SortController_1;
	    SortController.DEFAULT_SORTING_ORDER = [Constants.SORT_ASC, Constants.SORT_DESC, null];
	    __decorate$1j([
	        Autowired('columnController')
	    ], SortController.prototype, "columnController", void 0);
	    __decorate$1j([
	        Autowired('columnApi')
	    ], SortController.prototype, "columnApi", void 0);
	    __decorate$1j([
	        Autowired('gridApi')
	    ], SortController.prototype, "gridApi", void 0);
	    SortController = SortController_1 = __decorate$1j([
	        Bean('sortController')
	    ], SortController);
	    return SortController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1q = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1k = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var MouseEventService = /** @class */ (function (_super) {
	    __extends$1q(MouseEventService, _super);
	    function MouseEventService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.gridInstanceId = MouseEventService_1.gridInstanceSequence.next();
	        return _this;
	    }
	    MouseEventService_1 = MouseEventService;
	    // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
	    // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
	    // for where this is used.
	    MouseEventService.prototype.stampTopLevelGridCompWithGridInstance = function (eGridDiv) {
	        eGridDiv[MouseEventService_1.GRID_DOM_KEY] = this.gridInstanceId;
	    };
	    MouseEventService.prototype.getRenderedCellForEvent = function (event) {
	        return getComponentForEvent(this.gridOptionsWrapper, event, 'cellComp');
	    };
	    // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
	    // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
	    // getting executed on many grids at the same time.
	    MouseEventService.prototype.isEventFromThisGrid = function (event) {
	        var res = this.isElementInThisGrid(event.target);
	        return res;
	    };
	    MouseEventService.prototype.isElementInThisGrid = function (element) {
	        var pointer = element;
	        while (pointer) {
	            var instanceId = pointer[MouseEventService_1.GRID_DOM_KEY];
	            if (exists(instanceId)) {
	                var eventFromThisGrid = instanceId === this.gridInstanceId;
	                return eventFromThisGrid;
	            }
	            pointer = pointer.parentElement;
	        }
	        return false;
	    };
	    MouseEventService.prototype.getCellPositionForEvent = function (event) {
	        var cellComp = this.getRenderedCellForEvent(event);
	        return cellComp ? cellComp.getCellPosition() : null;
	    };
	    MouseEventService.prototype.getNormalisedPosition = function (event) {
	        var gridPanelHasScrolls = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_NORMAL;
	        var e = event;
	        var x;
	        var y;
	        if (e.clientX != null || e.clientY != null) {
	            x = e.clientX;
	            y = e.clientY;
	        }
	        else {
	            x = e.x;
	            y = e.y;
	        }
	        if (gridPanelHasScrolls) {
	            var gridBodyCon = this.controllersService.getGridBodyController();
	            var vRange = gridBodyCon.getScrollFeature().getVScrollPosition();
	            var hRange = gridBodyCon.getScrollFeature().getHScrollPosition();
	            x += hRange.left;
	            y += vRange.top;
	        }
	        return { x: x, y: y };
	    };
	    var MouseEventService_1;
	    MouseEventService.gridInstanceSequence = new NumberSequence();
	    MouseEventService.GRID_DOM_KEY = '__ag_grid_instance';
	    __decorate$1k([
	        Autowired('controllersService')
	    ], MouseEventService.prototype, "controllersService", void 0);
	    MouseEventService = MouseEventService_1 = __decorate$1k([
	        Bean('mouseEventService')
	    ], MouseEventService);
	    return MouseEventService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1r = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1l = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var CellNavigationService = /** @class */ (function (_super) {
	    __extends$1r(CellNavigationService, _super);
	    function CellNavigationService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // returns null if no cell to focus on, ie at the end of the grid
	    CellNavigationService.prototype.getNextCellToFocus = function (key, lastCellToFocus) {
	        // starting with the provided cell, we keep moving until we find a cell we can
	        // focus on.
	        var pointer = lastCellToFocus;
	        var finished = false;
	        // finished will be true when either:
	        // a) cell found that we can focus on
	        // b) run out of cells (ie the method returns null)
	        while (!finished) {
	            switch (key) {
	                case KeyCode.UP:
	                    pointer = this.getCellAbove(pointer);
	                    break;
	                case KeyCode.DOWN:
	                    pointer = this.getCellBelow(pointer);
	                    break;
	                case KeyCode.RIGHT:
	                    if (this.gridOptionsWrapper.isEnableRtl()) {
	                        pointer = this.getCellToLeft(pointer);
	                    }
	                    else {
	                        pointer = this.getCellToRight(pointer);
	                    }
	                    break;
	                case KeyCode.LEFT:
	                    if (this.gridOptionsWrapper.isEnableRtl()) {
	                        pointer = this.getCellToRight(pointer);
	                    }
	                    else {
	                        pointer = this.getCellToLeft(pointer);
	                    }
	                    break;
	                default:
	                    pointer = null;
	                    console.warn('AG Grid: unknown key for navigation ' + key);
	                    break;
	            }
	            if (pointer) {
	                finished = this.isCellGoodToFocusOn(pointer);
	            }
	            else {
	                finished = true;
	            }
	        }
	        return pointer;
	    };
	    CellNavigationService.prototype.isCellGoodToFocusOn = function (gridCell) {
	        var column = gridCell.column;
	        var rowNode;
	        switch (gridCell.rowPinned) {
	            case Constants.PINNED_TOP:
	                rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
	                break;
	            case Constants.PINNED_BOTTOM:
	                rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
	                break;
	            default:
	                rowNode = this.rowModel.getRow(gridCell.rowIndex);
	                break;
	        }
	        if (!rowNode) {
	            return false;
	        }
	        var suppressNavigable = column.isSuppressNavigable(rowNode);
	        return !suppressNavigable;
	    };
	    CellNavigationService.prototype.getCellToLeft = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var colToLeft = this.columnController.getDisplayedColBefore(lastCell.column);
	        if (!colToLeft) {
	            return null;
	        }
	        return {
	            rowIndex: lastCell.rowIndex,
	            column: colToLeft,
	            rowPinned: lastCell.rowPinned
	        };
	    };
	    CellNavigationService.prototype.getCellToRight = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var colToRight = this.columnController.getDisplayedColAfter(lastCell.column);
	        // if already on right, do nothing
	        if (!colToRight) {
	            return null;
	        }
	        return {
	            rowIndex: lastCell.rowIndex,
	            column: colToRight,
	            rowPinned: lastCell.rowPinned
	        };
	    };
	    CellNavigationService.prototype.getRowBelow = function (rowPosition) {
	        // if already on top row, do nothing
	        var index = rowPosition.rowIndex;
	        var pinned = rowPosition.rowPinned;
	        if (this.isLastRowInContainer(rowPosition)) {
	            switch (pinned) {
	                case Constants.PINNED_BOTTOM:
	                    // never any rows after pinned bottom
	                    return null;
	                case Constants.PINNED_TOP:
	                    // if on last row of pinned top, then next row is main body (if rows exist),
	                    // otherwise it's the pinned bottom
	                    if (this.rowModel.isRowsToRender()) {
	                        return { rowIndex: this.paginationProxy.getPageFirstRow(), rowPinned: null };
	                    }
	                    if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_BOTTOM)) {
	                        return { rowIndex: 0, rowPinned: Constants.PINNED_BOTTOM };
	                    }
	                    return null;
	                default:
	                    // if in the main body, then try pinned bottom, otherwise return nothing
	                    if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_BOTTOM)) {
	                        return { rowIndex: 0, rowPinned: Constants.PINNED_BOTTOM };
	                    }
	                    return null;
	            }
	        }
	        return { rowIndex: index + 1, rowPinned: pinned };
	    };
	    CellNavigationService.prototype.getCellBelow = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var rowBelow = this.getRowBelow(lastCell);
	        if (rowBelow) {
	            return {
	                rowIndex: rowBelow.rowIndex,
	                column: lastCell.column,
	                rowPinned: rowBelow.rowPinned
	            };
	        }
	        return null;
	    };
	    CellNavigationService.prototype.isLastRowInContainer = function (rowPosition) {
	        var pinned = rowPosition.rowPinned;
	        var index = rowPosition.rowIndex;
	        if (pinned === Constants.PINNED_TOP) {
	            var lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
	            return lastTopIndex <= index;
	        }
	        if (pinned === Constants.PINNED_BOTTOM) {
	            var lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
	            return lastBottomIndex <= index;
	        }
	        var lastBodyIndex = this.paginationProxy.getPageLastRow();
	        return lastBodyIndex <= index;
	    };
	    CellNavigationService.prototype.getRowAbove = function (rowPosition) {
	        // if already on top row, do nothing
	        var index = rowPosition.rowIndex;
	        var pinned = rowPosition.rowPinned;
	        var isFirstRow = pinned ? index === 0 : index === this.paginationProxy.getPageFirstRow();
	        // if already on top row, do nothing
	        if (isFirstRow) {
	            if (pinned === Constants.PINNED_TOP) {
	                return null;
	            }
	            if (!pinned) {
	                if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_TOP)) {
	                    return this.getLastFloatingTopRow();
	                }
	                return null;
	            }
	            // last floating bottom
	            if (this.rowModel.isRowsToRender()) {
	                return this.getLastBodyCell();
	            }
	            if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_TOP)) {
	                return this.getLastFloatingTopRow();
	            }
	            return null;
	        }
	        return { rowIndex: index - 1, rowPinned: pinned };
	    };
	    CellNavigationService.prototype.getCellAbove = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var rowAbove = this.getRowAbove({ rowIndex: lastCell.rowIndex, rowPinned: lastCell.rowPinned });
	        if (rowAbove) {
	            return {
	                rowIndex: rowAbove.rowIndex,
	                column: lastCell.column,
	                rowPinned: rowAbove.rowPinned
	            };
	        }
	        return null;
	    };
	    CellNavigationService.prototype.getLastBodyCell = function () {
	        var lastBodyRow = this.paginationProxy.getPageLastRow();
	        return { rowIndex: lastBodyRow, rowPinned: null };
	    };
	    CellNavigationService.prototype.getLastFloatingTopRow = function () {
	        var lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
	        return { rowIndex: lastFloatingRow, rowPinned: Constants.PINNED_TOP };
	    };
	    CellNavigationService.prototype.getNextTabbedCell = function (gridCell, backwards) {
	        if (backwards) {
	            return this.getNextTabbedCellBackwards(gridCell);
	        }
	        return this.getNextTabbedCellForwards(gridCell);
	    };
	    CellNavigationService.prototype.getNextTabbedCellForwards = function (gridCell) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var newRowIndex = gridCell.rowIndex;
	        var newFloating = gridCell.rowPinned;
	        // move along to the next cell
	        var newColumn = this.columnController.getDisplayedColAfter(gridCell.column);
	        // check if end of the row, and if so, go forward a row
	        if (!newColumn) {
	            newColumn = displayedColumns[0];
	            var rowBelow = this.getRowBelow(gridCell);
	            if (missing(rowBelow)) {
	                return null;
	            }
	            // If we are tabbing and there is a paging panel present, tabbing should go
	            // to the paging panel instead of loading the next page.
	            if (!rowBelow.rowPinned && !this.paginationProxy.isRowInPage(rowBelow)) {
	                return null;
	            }
	            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
	            newFloating = rowBelow ? rowBelow.rowPinned : null;
	        }
	        return { rowIndex: newRowIndex, column: newColumn, rowPinned: newFloating };
	    };
	    CellNavigationService.prototype.getNextTabbedCellBackwards = function (gridCell) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var newRowIndex = gridCell.rowIndex;
	        var newFloating = gridCell.rowPinned;
	        // move along to the next cell
	        var newColumn = this.columnController.getDisplayedColBefore(gridCell.column);
	        // check if end of the row, and if so, go forward a row
	        if (!newColumn) {
	            newColumn = last(displayedColumns);
	            var rowAbove = this.getRowAbove({ rowIndex: gridCell.rowIndex, rowPinned: gridCell.rowPinned });
	            if (missing(rowAbove)) {
	                return null;
	            }
	            // If we are tabbing and there is a paging panel present, tabbing should go
	            // to the paging panel instead of loading the next page.
	            if (!rowAbove.rowPinned && !this.paginationProxy.isRowInPage(rowAbove)) {
	                return null;
	            }
	            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
	            newFloating = rowAbove ? rowAbove.rowPinned : null;
	        }
	        return { rowIndex: newRowIndex, column: newColumn, rowPinned: newFloating };
	    };
	    __decorate$1l([
	        Autowired('columnController')
	    ], CellNavigationService.prototype, "columnController", void 0);
	    __decorate$1l([
	        Autowired('rowModel')
	    ], CellNavigationService.prototype, "rowModel", void 0);
	    __decorate$1l([
	        Autowired('pinnedRowModel')
	    ], CellNavigationService.prototype, "pinnedRowModel", void 0);
	    __decorate$1l([
	        Autowired('paginationProxy')
	    ], CellNavigationService.prototype, "paginationProxy", void 0);
	    CellNavigationService = __decorate$1l([
	        Bean('cellNavigationService')
	    ], CellNavigationService);
	    return CellNavigationService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1s = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1m = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ValueFormatterService = /** @class */ (function (_super) {
	    __extends$1s(ValueFormatterService, _super);
	    function ValueFormatterService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ValueFormatterService.prototype.formatValue = function (column, node, $scope, value, suppliedFormatter, useFormatterFromColumn) {
	        if (useFormatterFromColumn === void 0) { useFormatterFromColumn = true; }
	        var result = null;
	        var formatter;
	        var colDef = column.getColDef();
	        if (suppliedFormatter) {
	            // use supplied formatter if provided, e.g. set filter items can have their own value formatters
	            formatter = suppliedFormatter;
	        }
	        else if (useFormatterFromColumn) {
	            // if row is pinned, give preference to the pinned formatter
	            formatter = node && node.rowPinned && colDef.pinnedRowValueFormatter ?
	                colDef.pinnedRowValueFormatter : colDef.valueFormatter;
	        }
	        if (formatter) {
	            var params = {
	                value: value,
	                node: node,
	                data: node ? node.data : null,
	                colDef: colDef,
	                column: column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            // originally we put the angular 1 scope here, but we don't want the scope
	            // in the params interface, as other frameworks will see the interface, and
	            // angular 1 is not cool any more. so we hack the scope in here (we cannot
	            // include it above, as it's not in the interface, so would cause a compile error).
	            // in the future, when we stop supporting angular 1, we can take this out.
	            params.$scope = $scope;
	            result = this.expressionService.evaluate(formatter, params);
	        }
	        else if (colDef.refData) {
	            return colDef.refData[value] || '';
	        }
	        // if we don't do this, then arrays get displayed as 1,2,3, but we want 1, 2, 3 (i.e. with spaces)
	        if (result == null && Array.isArray(value)) {
	            result = value.join(', ');
	        }
	        return result;
	    };
	    __decorate$1m([
	        Autowired('expressionService')
	    ], ValueFormatterService.prototype, "expressionService", void 0);
	    ValueFormatterService = __decorate$1m([
	        Bean('valueFormatterService')
	    ], ValueFormatterService);
	    return ValueFormatterService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1t = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgRadioButton = /** @class */ (function (_super) {
	    __extends$1t(AgRadioButton, _super);
	    function AgRadioButton(config) {
	        return _super.call(this, config, 'ag-radio-button', 'radio') || this;
	    }
	    AgRadioButton.prototype.isSelected = function () {
	        return this.eInput.checked;
	    };
	    AgRadioButton.prototype.toggle = function () {
	        // do not allow an active radio button to be deselected
	        if (!this.isSelected()) {
	            this.setValue(true);
	        }
	    };
	    AgRadioButton.prototype.addInputListeners = function () {
	        _super.prototype.addInputListeners.call(this);
	        this.addManagedListener(this.eventService, Events.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
	    };
	    /**
	     * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
	     * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
	     * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
	     * not deselected, so we need to use our own event.
	     */
	    AgRadioButton.prototype.onChange = function (event) {
	        if (event.selected &&
	            event.name &&
	            this.eInput.name &&
	            this.eInput.name === event.name &&
	            event.id &&
	            this.eInput.id !== event.id) {
	            this.setValue(false, true);
	        }
	    };
	    return AgRadioButton;
	}(AgCheckbox));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var OUTSIDE_ANGULAR_EVENTS = ['mouseover', 'mouseout', 'mouseenter', 'mouseleave'];
	/** The base frameworks, eg React & Angular 2, override this bean with implementations specific to their requirement. */
	var VanillaFrameworkOverrides = /** @class */ (function () {
	    function VanillaFrameworkOverrides() {
	        this.isOutsideAngular = function (eventType) { return includes(OUTSIDE_ANGULAR_EVENTS, eventType); };
	    }
	    // for Vanilla JS, we use simple timeout
	    VanillaFrameworkOverrides.prototype.setTimeout = function (action, timeout) {
	        window.setTimeout(action, timeout);
	    };
	    // for Vanilla JS, we just add the event to the element
	    VanillaFrameworkOverrides.prototype.addEventListener = function (element, type, listener, useCapture) {
	        element.addEventListener(type, listener, useCapture);
	    };
	    // for Vanilla JS, we just execute the listener
	    VanillaFrameworkOverrides.prototype.dispatchEvent = function (eventType, listener) {
	        listener();
	    };
	    return VanillaFrameworkOverrides;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1u = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1n = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ScrollVisibleService = /** @class */ (function (_super) {
	    __extends$1u(ScrollVisibleService, _super);
	    function ScrollVisibleService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ScrollVisibleService.prototype.postConstruct = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
	    };
	    ScrollVisibleService.prototype.onDisplayedColumnsChanged = function () {
	        this.update();
	    };
	    ScrollVisibleService.prototype.onDisplayedColumnsWidthChanged = function () {
	        this.update();
	    };
	    ScrollVisibleService.prototype.update = function () {
	        // because of column animation (which takes 200ms), we have to do this twice.
	        // eg if user removes cols anywhere except at the RHS, then the cols on the RHS
	        // will animate to the left to fill the gap. this animation means just after
	        // the cols are removed, the remaining cols are still in the original location
	        // at the start of the animation, so pre animation the H scrollbar is still needed,
	        // but post animation it is not.
	        this.updateImpl();
	        setTimeout(this.updateImpl.bind(this), 500);
	    };
	    ScrollVisibleService.prototype.updateImpl = function () {
	        var params = {
	            horizontalScrollShowing: this.controllersService.getCenterRowContainerCon().isHorizontalScrollShowing(),
	            verticalScrollShowing: this.isVerticalScrollShowing()
	        };
	        this.setScrollsVisible(params);
	    };
	    ScrollVisibleService.prototype.setScrollsVisible = function (params) {
	        var atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing ||
	            this.verticalScrollShowing !== params.verticalScrollShowing;
	        if (atLeastOneDifferent) {
	            this.horizontalScrollShowing = params.horizontalScrollShowing;
	            this.verticalScrollShowing = params.verticalScrollShowing;
	            var event_1 = {
	                type: Events.EVENT_SCROLL_VISIBILITY_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    // used by pagination service - to know page height
	    ScrollVisibleService.prototype.isHorizontalScrollShowing = function () {
	        return this.horizontalScrollShowing;
	    };
	    // used by header container
	    ScrollVisibleService.prototype.isVerticalScrollShowing = function () {
	        return this.verticalScrollShowing;
	    };
	    __decorate$1n([
	        Autowired('columnApi')
	    ], ScrollVisibleService.prototype, "columnApi", void 0);
	    __decorate$1n([
	        Autowired('gridApi')
	    ], ScrollVisibleService.prototype, "gridApi", void 0);
	    __decorate$1n([
	        Autowired('controllersService')
	    ], ScrollVisibleService.prototype, "controllersService", void 0);
	    __decorate$1n([
	        PostConstruct
	    ], ScrollVisibleService.prototype, "postConstruct", null);
	    ScrollVisibleService = __decorate$1n([
	        Bean('scrollVisibleService')
	    ], ScrollVisibleService);
	    return ScrollVisibleService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1v = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1o = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var StylingService = /** @class */ (function (_super) {
	    __extends$1v(StylingService, _super);
	    function StylingService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StylingService.prototype.processAllCellClasses = function (colDef, params, onApplicableClass, onNotApplicableClass) {
	        this.processClassRules(colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
	        this.processStaticCellClasses(colDef, params, onApplicableClass);
	    };
	    StylingService.prototype.processClassRules = function (classRules, params, onApplicableClass, onNotApplicableClass) {
	        if (isNonNullObject(classRules)) {
	            var classNames = Object.keys(classRules);
	            for (var i = 0; i < classNames.length; i++) {
	                var className = classNames[i];
	                var rule = classRules[className];
	                var resultOfRule = void 0;
	                if (typeof rule === 'string') {
	                    resultOfRule = this.expressionService.evaluate(rule, params);
	                }
	                else if (typeof rule === 'function') {
	                    resultOfRule = rule(params);
	                }
	                if (resultOfRule) {
	                    onApplicableClass(className);
	                }
	                else if (onNotApplicableClass) {
	                    onNotApplicableClass(className);
	                }
	            }
	        }
	    };
	    StylingService.prototype.processStaticCellClasses = function (colDef, params, onApplicableClass) {
	        var cellClass = colDef.cellClass;
	        if (cellClass) {
	            var classOrClasses = void 0;
	            if (typeof colDef.cellClass === 'function') {
	                var cellClassFunc = colDef.cellClass;
	                classOrClasses = cellClassFunc(params);
	            }
	            else {
	                classOrClasses = colDef.cellClass;
	            }
	            if (typeof classOrClasses === 'string') {
	                onApplicableClass(classOrClasses);
	            }
	            else if (Array.isArray(classOrClasses)) {
	                classOrClasses.forEach(function (cssClassItem) {
	                    onApplicableClass(cssClassItem);
	                });
	            }
	        }
	    };
	    __decorate$1o([
	        Autowired('expressionService')
	    ], StylingService.prototype, "expressionService", void 0);
	    StylingService = __decorate$1o([
	        Bean('stylingService')
	    ], StylingService);
	    return StylingService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1w = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1p = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ColumnHoverService = /** @class */ (function (_super) {
	    __extends$1w(ColumnHoverService, _super);
	    function ColumnHoverService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ColumnHoverService.prototype.setMouseOver = function (columns) {
	        this.selectedColumns = columns;
	        var event = {
	            type: Events.EVENT_COLUMN_HOVER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnHoverService.prototype.clearMouseOver = function () {
	        this.selectedColumns = null;
	        var event = {
	            type: Events.EVENT_COLUMN_HOVER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnHoverService.prototype.isHovered = function (column) {
	        return !!this.selectedColumns && this.selectedColumns.indexOf(column) >= 0;
	    };
	    __decorate$1p([
	        Autowired('columnApi')
	    ], ColumnHoverService.prototype, "columnApi", void 0);
	    __decorate$1p([
	        Autowired('gridApi')
	    ], ColumnHoverService.prototype, "gridApi", void 0);
	    ColumnHoverService = __decorate$1p([
	        Bean('columnHoverService')
	    ], ColumnHoverService);
	    return ColumnHoverService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1x = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1q = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ColumnAnimationService = /** @class */ (function (_super) {
	    __extends$1x(ColumnAnimationService, _super);
	    function ColumnAnimationService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.executeNextFuncs = [];
	        _this.executeLaterFuncs = [];
	        _this.active = false;
	        _this.animationThreadCount = 0;
	        return _this;
	    }
	    ColumnAnimationService.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function (p) { return _this.gridBodyCon = p.gridBodyCon; });
	    };
	    ColumnAnimationService.prototype.isActive = function () {
	        return this.active;
	    };
	    ColumnAnimationService.prototype.start = function () {
	        if (this.active) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isSuppressColumnMoveAnimation()) {
	            return;
	        }
	        // if doing RTL, we don't animate open / close as due to how the pixels are inverted,
	        // the animation moves all the row the the right rather than to the left (ie it's the static
	        // columns that actually get their coordinates updated)
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            return;
	        }
	        this.ensureAnimationCssClassPresent();
	        this.active = true;
	    };
	    ColumnAnimationService.prototype.finish = function () {
	        if (!this.active) {
	            return;
	        }
	        this.flush();
	        this.active = false;
	    };
	    ColumnAnimationService.prototype.executeNextVMTurn = function (func) {
	        if (this.active) {
	            this.executeNextFuncs.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    ColumnAnimationService.prototype.executeLaterVMTurn = function (func) {
	        if (this.active) {
	            this.executeLaterFuncs.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    ColumnAnimationService.prototype.ensureAnimationCssClassPresent = function () {
	        var _this = this;
	        // up the count, so we can tell if someone else has updated the count
	        // by the time the 'wait' func executes
	        this.animationThreadCount++;
	        var animationThreadCountCopy = this.animationThreadCount;
	        this.gridBodyCon.setColumnMovingCss(true);
	        this.executeLaterFuncs.push(function () {
	            // only remove the class if this thread was the last one to update it
	            if (_this.animationThreadCount === animationThreadCountCopy) {
	                _this.gridBodyCon.setColumnMovingCss(false);
	            }
	        });
	    };
	    ColumnAnimationService.prototype.flush = function () {
	        var nowFuncs = this.executeNextFuncs;
	        this.executeNextFuncs = [];
	        var waitFuncs = this.executeLaterFuncs;
	        this.executeLaterFuncs = [];
	        if (nowFuncs.length === 0 && waitFuncs.length === 0) {
	            return;
	        }
	        window.setTimeout(function () { return nowFuncs.forEach(function (func) { return func(); }); }, 0);
	        window.setTimeout(function () { return waitFuncs.forEach(function (func) { return func(); }); }, 300);
	    };
	    __decorate$1q([
	        Autowired('controllersService')
	    ], ColumnAnimationService.prototype, "controllersService", void 0);
	    __decorate$1q([
	        PostConstruct
	    ], ColumnAnimationService.prototype, "postConstruct", null);
	    ColumnAnimationService = __decorate$1q([
	        Bean('columnAnimationService')
	    ], ColumnAnimationService);
	    return ColumnAnimationService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1y = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1r = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AutoGroupColService = /** @class */ (function (_super) {
	    __extends$1y(AutoGroupColService, _super);
	    function AutoGroupColService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AutoGroupColService_1 = AutoGroupColService;
	    AutoGroupColService.prototype.createAutoGroupColumns = function (rowGroupColumns) {
	        var _this = this;
	        var groupAutoColumns = [];
	        var doingTreeData = this.gridOptionsWrapper.isTreeData();
	        var doingMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
	        if (doingTreeData && doingMultiAutoColumn) {
	            console.warn('AG Grid: you cannot mix groupMultiAutoColumn with treeData, only one column can be used to display groups when doing tree data');
	            doingMultiAutoColumn = false;
	        }
	        // if doing groupMultiAutoColumn, then we call the method multiple times, once
	        // for each column we are grouping by
	        if (doingMultiAutoColumn) {
	            rowGroupColumns.forEach(function (rowGroupCol, index) {
	                groupAutoColumns.push(_this.createOneAutoGroupColumn(rowGroupCol, index));
	            });
	        }
	        else {
	            groupAutoColumns.push(this.createOneAutoGroupColumn());
	        }
	        return groupAutoColumns;
	    };
	    // rowGroupCol and index are missing if groupMultiAutoColumn=false
	    AutoGroupColService.prototype.createOneAutoGroupColumn = function (rowGroupCol, index) {
	        // if one provided by user, use it, otherwise create one
	        var defaultAutoColDef = this.generateDefaultColDef(rowGroupCol);
	        // if doing multi, set the field
	        var colId;
	        if (rowGroupCol) {
	            colId = Constants.GROUP_AUTO_COLUMN_ID + "-" + rowGroupCol.getId();
	        }
	        else {
	            colId = AutoGroupColService_1.GROUP_AUTO_COLUMN_BUNDLE_ID;
	        }
	        var userAutoColDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
	        mergeDeep(defaultAutoColDef, userAutoColDef);
	        defaultAutoColDef = this.columnFactory.mergeColDefs(defaultAutoColDef);
	        defaultAutoColDef.colId = colId;
	        // For tree data the filter is always allowed
	        if (!this.gridOptionsWrapper.isTreeData()) {
	            // we would only allow filter if the user has provided field or value getter. otherwise the filter
	            // would not be able to work.
	            var noFieldOrValueGetter = missing(defaultAutoColDef.field) && missing(defaultAutoColDef.valueGetter) && missing(defaultAutoColDef.filterValueGetter);
	            if (noFieldOrValueGetter) {
	                defaultAutoColDef.filter = false;
	            }
	        }
	        // if showing many cols, we don't want to show more than one with a checkbox for selection
	        if (index && index > 0) {
	            defaultAutoColDef.headerCheckboxSelection = false;
	        }
	        var newCol = new Column(defaultAutoColDef, null, colId, true);
	        this.context.createBean(newCol);
	        return newCol;
	    };
	    AutoGroupColService.prototype.generateDefaultColDef = function (rowGroupCol) {
	        var userDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var res = {
	            headerName: localeTextFunc('group', 'Group')
	        };
	        var userHasProvidedGroupCellRenderer = userDef &&
	            (userDef.cellRenderer || userDef.cellRendererFramework || userDef.cellRendererSelector);
	        // only add the default group cell renderer if user hasn't provided one
	        if (!userHasProvidedGroupCellRenderer) {
	            res.cellRenderer = 'agGroupCellRenderer';
	        }
	        // we never allow moving the group column
	        // defaultAutoColDef.suppressMovable = true;
	        if (rowGroupCol) {
	            var colDef = rowGroupCol.getColDef();
	            assign(res, {
	                // cellRendererParams.groupKey: colDefToCopy.field;
	                headerName: this.columnController.getDisplayNameForColumn(rowGroupCol, 'header'),
	                headerValueGetter: colDef.headerValueGetter
	            });
	            if (colDef.cellRenderer) {
	                assign(res, {
	                    cellRendererParams: {
	                        innerRenderer: colDef.cellRenderer,
	                        innerRendererParams: colDef.cellRendererParams
	                    }
	                });
	            }
	            res.showRowGroup = rowGroupCol.getColId();
	        }
	        else {
	            res.showRowGroup = true;
	        }
	        return res;
	    };
	    var AutoGroupColService_1;
	    AutoGroupColService.GROUP_AUTO_COLUMN_BUNDLE_ID = Constants.GROUP_AUTO_COLUMN_ID;
	    __decorate$1r([
	        Autowired('columnController')
	    ], AutoGroupColService.prototype, "columnController", void 0);
	    __decorate$1r([
	        Autowired('columnFactory')
	    ], AutoGroupColService.prototype, "columnFactory", void 0);
	    AutoGroupColService = AutoGroupColService_1 = __decorate$1r([
	        Bean('autoGroupColService')
	    ], AutoGroupColService);
	    return AutoGroupColService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1z = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1s = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var PaginationProxy = /** @class */ (function (_super) {
	    __extends$1z(PaginationProxy, _super);
	    function PaginationProxy() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.currentPage = 0;
	        _this.topDisplayedRowIndex = 0;
	        _this.bottomDisplayedRowIndex = 0;
	        _this.pixelOffset = 0;
	        _this.masterRowCount = 0;
	        return _this;
	    }
	    PaginationProxy.prototype.postConstruct = function () {
	        this.active = this.gridOptionsWrapper.isPagination();
	        this.paginateChildRows = this.gridOptionsWrapper.isPaginateChildRows();
	        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
	        this.addManagedListener(this.gridOptionsWrapper, 'paginationPageSize', this.onPaginationPageSizeChanged.bind(this));
	        this.onModelUpdated();
	    };
	    PaginationProxy.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
	        var res = this.rowModel.ensureRowHeightsValid(startPixel, endPixel, this.getPageFirstRow(), this.getPageLastRow());
	        if (res) {
	            this.calculatePages();
	        }
	        return res;
	    };
	    PaginationProxy.prototype.onModelUpdated = function (modelUpdatedEvent) {
	        this.calculatePages();
	        var paginationChangedEvent = {
	            type: Events.EVENT_PAGINATION_CHANGED,
	            animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
	            newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
	            newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
	            keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(paginationChangedEvent);
	    };
	    PaginationProxy.prototype.onPaginationPageSizeChanged = function () {
	        this.calculatePages();
	        var paginationChangedEvent = {
	            type: Events.EVENT_PAGINATION_CHANGED,
	            animate: false,
	            newData: false,
	            newPage: false,
	            // important to keep rendered rows, otherwise every time grid is resized,
	            // we would destroy all the rows.
	            keepRenderedRows: true,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(paginationChangedEvent);
	    };
	    PaginationProxy.prototype.goToPage = function (page) {
	        if (!this.active || this.currentPage === page) {
	            return;
	        }
	        this.currentPage = page;
	        var event = {
	            type: Events.EVENT_MODEL_UPDATED,
	            animate: false,
	            keepRenderedRows: false,
	            newData: false,
	            newPage: true,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.onModelUpdated(event);
	    };
	    PaginationProxy.prototype.getPixelOffset = function () {
	        return this.pixelOffset;
	    };
	    PaginationProxy.prototype.getRow = function (index) {
	        return this.rowModel.getRow(index);
	    };
	    PaginationProxy.prototype.getRowNode = function (id) {
	        return this.rowModel.getRowNode(id);
	    };
	    PaginationProxy.prototype.getRowIndexAtPixel = function (pixel) {
	        return this.rowModel.getRowIndexAtPixel(pixel);
	    };
	    PaginationProxy.prototype.getCurrentPageHeight = function () {
	        if (missing(this.topRowBounds) || missing(this.bottomRowBounds)) {
	            return 0;
	        }
	        return Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
	    };
	    PaginationProxy.prototype.getCurrentPagePixelRange = function () {
	        var pageFirstPixel = this.topRowBounds ? this.topRowBounds.rowTop : 0;
	        var pageLastPixel = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
	        return { pageFirstPixel: pageFirstPixel, pageLastPixel: pageLastPixel };
	    };
	    PaginationProxy.prototype.isRowPresent = function (rowNode) {
	        if (!this.rowModel.isRowPresent(rowNode)) {
	            return false;
	        }
	        var nodeIsInPage = rowNode.rowIndex >= this.topDisplayedRowIndex && rowNode.rowIndex <= this.bottomDisplayedRowIndex;
	        return nodeIsInPage;
	    };
	    PaginationProxy.prototype.isEmpty = function () {
	        return this.rowModel.isEmpty();
	    };
	    PaginationProxy.prototype.isRowsToRender = function () {
	        return this.rowModel.isRowsToRender();
	    };
	    PaginationProxy.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        return this.rowModel.getNodesInRangeForSelection(firstInRange, lastInRange);
	    };
	    PaginationProxy.prototype.forEachNode = function (callback) {
	        return this.rowModel.forEachNode(callback);
	    };
	    PaginationProxy.prototype.getType = function () {
	        return this.rowModel.getType();
	    };
	    PaginationProxy.prototype.getRowBounds = function (index) {
	        var res = this.rowModel.getRowBounds(index);
	        res.rowIndex = index;
	        return res;
	    };
	    PaginationProxy.prototype.getPageFirstRow = function () {
	        return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
	    };
	    PaginationProxy.prototype.getPageLastRow = function () {
	        return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
	    };
	    PaginationProxy.prototype.getRowCount = function () {
	        return this.rowModel.getRowCount();
	    };
	    PaginationProxy.prototype.getPageForIndex = function (index) {
	        return Math.floor(index / this.pageSize);
	    };
	    PaginationProxy.prototype.goToPageWithIndex = function (index) {
	        if (!this.active) {
	            return;
	        }
	        var pageNumber = this.getPageForIndex(index);
	        this.goToPage(pageNumber);
	    };
	    PaginationProxy.prototype.isRowInPage = function (row) {
	        if (!this.active) {
	            return true;
	        }
	        var rowPage = this.getPageForIndex(row.rowIndex);
	        return rowPage === this.currentPage;
	    };
	    PaginationProxy.prototype.isLastPageFound = function () {
	        return this.rowModel.isLastRowIndexKnown();
	    };
	    PaginationProxy.prototype.getCurrentPage = function () {
	        return this.currentPage;
	    };
	    PaginationProxy.prototype.goToNextPage = function () {
	        this.goToPage(this.currentPage + 1);
	    };
	    PaginationProxy.prototype.goToPreviousPage = function () {
	        this.goToPage(this.currentPage - 1);
	    };
	    PaginationProxy.prototype.goToFirstPage = function () {
	        this.goToPage(0);
	    };
	    PaginationProxy.prototype.goToLastPage = function () {
	        var rowCount = this.rowModel.getRowCount();
	        var lastPage = Math.floor(rowCount / this.pageSize);
	        this.goToPage(lastPage);
	    };
	    PaginationProxy.prototype.getPageSize = function () {
	        return this.pageSize;
	    };
	    PaginationProxy.prototype.getTotalPages = function () {
	        return this.totalPages;
	    };
	    PaginationProxy.prototype.setPageSize = function () {
	        // show put this into super class
	        this.pageSize = this.gridOptionsWrapper.getPaginationPageSize();
	        if (this.pageSize == null || this.pageSize < 1) {
	            this.pageSize = 100;
	        }
	    };
	    PaginationProxy.prototype.calculatePages = function () {
	        if (this.active) {
	            this.setPageSize();
	            if (this.paginateChildRows) {
	                this.calculatePagesAllRows();
	            }
	            else {
	                this.calculatePagesMasterRowsOnly();
	            }
	        }
	        else {
	            this.calculatedPagesNotActive();
	        }
	        this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex);
	        if (this.topRowBounds) {
	            this.topRowBounds.rowIndex = this.topDisplayedRowIndex;
	        }
	        this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex);
	        if (this.bottomRowBounds) {
	            this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex;
	        }
	        this.setPixelOffset(exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
	    };
	    PaginationProxy.prototype.setPixelOffset = function (value) {
	        if (this.pixelOffset === value) {
	            return;
	        }
	        this.pixelOffset = value;
	        this.eventService.dispatchEvent({ type: Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED });
	    };
	    PaginationProxy.prototype.setZeroRows = function () {
	        this.masterRowCount = 0;
	        this.topDisplayedRowIndex = 0;
	        this.bottomDisplayedRowIndex = -1;
	        this.currentPage = 0;
	        this.totalPages = 0;
	    };
	    PaginationProxy.prototype.calculatePagesMasterRowsOnly = function () {
	        // const csrm = <ClientSideRowModel> this.rowModel;
	        // const rootNode = csrm.getRootNode();
	        // const masterRows = rootNode.childrenAfterSort;
	        this.masterRowCount = this.rowModel.getTopLevelRowCount();
	        // we say <=0 (rather than =0) as viewport returns -1 when no rows
	        if (this.masterRowCount <= 0) {
	            this.setZeroRows();
	            return;
	        }
	        var masterLastRowIndex = this.masterRowCount - 1;
	        this.totalPages = Math.floor((masterLastRowIndex) / this.pageSize) + 1;
	        if (this.currentPage >= this.totalPages) {
	            this.currentPage = this.totalPages - 1;
	        }
	        if (!isNumeric(this.currentPage) || this.currentPage < 0) {
	            this.currentPage = 0;
	        }
	        var masterPageStartIndex = this.pageSize * this.currentPage;
	        var masterPageEndIndex = (this.pageSize * (this.currentPage + 1)) - 1;
	        if (masterPageEndIndex > masterLastRowIndex) {
	            masterPageEndIndex = masterLastRowIndex;
	        }
	        this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
	        // masterRows[masterPageStartIndex].rowIndex;
	        if (masterPageEndIndex === masterLastRowIndex) {
	            // if showing the last master row, then we want to show the very last row of the model
	            this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
	        }
	        else {
	            var firstIndexNotToShow = this.rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
	            //masterRows[masterPageEndIndex + 1].rowIndex;
	            // this gets the index of the last child - eg current row is open, we want to display all children,
	            // the index of the last child is one less than the index of the next parent row.
	            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
	        }
	    };
	    PaginationProxy.prototype.getMasterRowCount = function () {
	        return this.masterRowCount;
	    };
	    PaginationProxy.prototype.calculatePagesAllRows = function () {
	        this.masterRowCount = this.rowModel.getRowCount();
	        if (this.masterRowCount === 0) {
	            this.setZeroRows();
	            return;
	        }
	        var maxRowIndex = this.masterRowCount - 1;
	        this.totalPages = Math.floor((maxRowIndex) / this.pageSize) + 1;
	        if (this.currentPage >= this.totalPages) {
	            this.currentPage = this.totalPages - 1;
	        }
	        if (!isNumeric(this.currentPage) || this.currentPage < 0) {
	            this.currentPage = 0;
	        }
	        this.topDisplayedRowIndex = this.pageSize * this.currentPage;
	        this.bottomDisplayedRowIndex = (this.pageSize * (this.currentPage + 1)) - 1;
	        if (this.bottomDisplayedRowIndex > maxRowIndex) {
	            this.bottomDisplayedRowIndex = maxRowIndex;
	        }
	    };
	    PaginationProxy.prototype.calculatedPagesNotActive = function () {
	        this.pageSize = this.rowModel.getRowCount();
	        this.totalPages = 1;
	        this.currentPage = 0;
	        this.topDisplayedRowIndex = 0;
	        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
	    };
	    __decorate$1s([
	        Autowired('rowModel')
	    ], PaginationProxy.prototype, "rowModel", void 0);
	    __decorate$1s([
	        Autowired('columnApi')
	    ], PaginationProxy.prototype, "columnApi", void 0);
	    __decorate$1s([
	        Autowired('gridApi')
	    ], PaginationProxy.prototype, "gridApi", void 0);
	    __decorate$1s([
	        PostConstruct
	    ], PaginationProxy.prototype, "postConstruct", null);
	    PaginationProxy = __decorate$1s([
	        Bean('paginationProxy')
	    ], PaginationProxy);
	    return PaginationProxy;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1A = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1t = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var PaginationAutoPageSizeService = /** @class */ (function (_super) {
	    __extends$1A(PaginationAutoPageSizeService, _super);
	    function PaginationAutoPageSizeService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PaginationAutoPageSizeService.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function (p) {
	            _this.centerRowContainerCon = p.centerRowContainerCon;
	            _this.addManagedListener(_this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, _this.onBodyHeightChanged.bind(_this));
	            _this.addManagedListener(_this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, _this.onScrollVisibilityChanged.bind(_this));
	            _this.checkPageSize();
	        });
	    };
	    PaginationAutoPageSizeService.prototype.notActive = function () {
	        return !this.gridOptionsWrapper.isPaginationAutoPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.onScrollVisibilityChanged = function () {
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.onBodyHeightChanged = function () {
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.checkPageSize = function () {
	        if (this.notActive()) {
	            return;
	        }
	        var rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        var bodyHeight = this.centerRowContainerCon.getViewportSizeFeature().getBodyHeight();
	        if (bodyHeight > 0) {
	            var newPageSize = Math.floor(bodyHeight / rowHeight);
	            this.gridOptionsWrapper.setProperty('paginationPageSize', newPageSize);
	        }
	    };
	    __decorate$1t([
	        Autowired('controllersService')
	    ], PaginationAutoPageSizeService.prototype, "controllersService", void 0);
	    __decorate$1t([
	        PostConstruct
	    ], PaginationAutoPageSizeService.prototype, "postConstruct", null);
	    PaginationAutoPageSizeService = __decorate$1t([
	        Bean('paginationAutoPageSizeService')
	    ], PaginationAutoPageSizeService);
	    return PaginationAutoPageSizeService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1B = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1u = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ValueCache = /** @class */ (function (_super) {
	    __extends$1B(ValueCache, _super);
	    function ValueCache() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cacheVersion = 0;
	        return _this;
	    }
	    ValueCache.prototype.init = function () {
	        this.active = this.gridOptionsWrapper.isValueCache();
	        this.neverExpires = this.gridOptionsWrapper.isValueCacheNeverExpires();
	    };
	    ValueCache.prototype.onDataChanged = function () {
	        if (this.neverExpires) {
	            return;
	        }
	        this.expire();
	    };
	    ValueCache.prototype.expire = function () {
	        this.cacheVersion++;
	    };
	    ValueCache.prototype.setValue = function (rowNode, colId, value) {
	        if (this.active) {
	            if (rowNode.__cacheVersion !== this.cacheVersion) {
	                rowNode.__cacheVersion = this.cacheVersion;
	                rowNode.__cacheData = {};
	            }
	            rowNode.__cacheData[colId] = value;
	        }
	    };
	    ValueCache.prototype.getValue = function (rowNode, colId) {
	        if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) {
	            return undefined;
	        }
	        return rowNode.__cacheData[colId];
	    };
	    __decorate$1u([
	        PostConstruct
	    ], ValueCache.prototype, "init", null);
	    ValueCache = __decorate$1u([
	        Bean('valueCache')
	    ], ValueCache);
	    return ValueCache;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1C = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1v = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ChangeDetectionService = /** @class */ (function (_super) {
	    __extends$1C(ChangeDetectionService, _super);
	    function ChangeDetectionService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ChangeDetectionService.prototype.init = function () {
	        if (this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = this.rowModel;
	        }
	        this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
	    };
	    ChangeDetectionService.prototype.onCellValueChanged = function (event) {
	        // Clipboard service manages its own change detection, so no need to do it here.
	        // The clipboard manages its own as otherwise this would happen once for every cell
	        // that got updated as part of a paste operation, so e.g. if 100 cells in a paste operation,
	        // this doChangeDetection would get called 100 times (once for each cell), instead clipboard
	        // service executes the logic we have here once (in essence batching up all cell changes
	        // into one change detection).
	        if (event.source === Constants.SOURCE_PASTE) {
	            return;
	        }
	        this.doChangeDetection(event.node, event.column);
	    };
	    ChangeDetectionService.prototype.doChangeDetection = function (rowNode, column) {
	        if (this.gridOptionsWrapper.isSuppressChangeDetection()) {
	            return;
	        }
	        // step 1 of change detection is to update the aggregated values
	        if (this.clientSideRowModel && !rowNode.isRowPinned()) {
	            var onlyChangedColumns = this.gridOptionsWrapper.isAggregateOnlyChangedColumns();
	            var changedPath = new ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
	            changedPath.addParentNode(rowNode.parent, [column]);
	            this.clientSideRowModel.doAggregate(changedPath);
	        }
	        // step 2 of change detection is to refresh the cells
	        this.rowRenderer.refreshCells();
	    };
	    __decorate$1v([
	        Autowired('rowModel')
	    ], ChangeDetectionService.prototype, "rowModel", void 0);
	    __decorate$1v([
	        Autowired('rowRenderer')
	    ], ChangeDetectionService.prototype, "rowRenderer", void 0);
	    __decorate$1v([
	        PostConstruct
	    ], ChangeDetectionService.prototype, "init", null);
	    ChangeDetectionService = __decorate$1v([
	        Bean('changeDetectionService')
	    ], ChangeDetectionService);
	    return ChangeDetectionService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1D = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1w = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$8 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var AlignedGridsService = /** @class */ (function (_super) {
	    __extends$1D(AlignedGridsService, _super);
	    function AlignedGridsService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
	        // while processing a master event) we mark this if consuming an event, and if we are, then
	        // we don't fire back any events.
	        _this.consuming = false;
	        return _this;
	    }
	    AlignedGridsService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('AlignedGridsService');
	    };
	    AlignedGridsService.prototype.init = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
	    };
	    // common logic across all the fire methods
	    AlignedGridsService.prototype.fireEvent = function (callback) {
	        // if we are already consuming, then we are acting on an event from a master,
	        // so we don't cause a cyclic firing of events
	        if (this.consuming) {
	            return;
	        }
	        // iterate through the aligned grids, and pass each aligned grid service to the callback
	        var otherGrids = this.gridOptionsWrapper.getAlignedGrids();
	        if (otherGrids) {
	            otherGrids.forEach(function (otherGridOptions) {
	                if (otherGridOptions.api) {
	                    var alignedGridService = otherGridOptions.api.__getAlignedGridService();
	                    callback(alignedGridService);
	                }
	            });
	        }
	    };
	    // common logic across all consume methods. very little common logic, however extracting
	    // guarantees consistency across the methods.
	    AlignedGridsService.prototype.onEvent = function (callback) {
	        this.consuming = true;
	        callback();
	        this.consuming = false;
	    };
	    AlignedGridsService.prototype.fireColumnEvent = function (event) {
	        this.fireEvent(function (alignedGridsService) {
	            alignedGridsService.onColumnEvent(event);
	        });
	    };
	    AlignedGridsService.prototype.fireScrollEvent = function (event) {
	        if (event.direction !== 'horizontal') {
	            return;
	        }
	        this.fireEvent(function (alignedGridsService) {
	            alignedGridsService.onScrollEvent(event);
	        });
	    };
	    AlignedGridsService.prototype.onScrollEvent = function (event) {
	        var _this = this;
	        this.onEvent(function () {
	            var gridBodyCon = _this.controllersService.getGridBodyController();
	            gridBodyCon.getScrollFeature().setHorizontalScrollPosition(event.left);
	        });
	    };
	    AlignedGridsService.prototype.getMasterColumns = function (event) {
	        var result = [];
	        if (event.columns) {
	            event.columns.forEach(function (column) {
	                result.push(column);
	            });
	        }
	        else if (event.column) {
	            result.push(event.column);
	        }
	        return result;
	    };
	    AlignedGridsService.prototype.getColumnIds = function (event) {
	        var result = [];
	        if (event.columns) {
	            event.columns.forEach(function (column) {
	                result.push(column.getColId());
	            });
	        }
	        else if (event.column) {
	            result.push(event.column.getColId());
	        }
	        return result;
	    };
	    AlignedGridsService.prototype.onColumnEvent = function (event) {
	        var _this = this;
	        this.onEvent(function () {
	            switch (event.type) {
	                case Events.EVENT_COLUMN_MOVED:
	                case Events.EVENT_COLUMN_VISIBLE:
	                case Events.EVENT_COLUMN_PINNED:
	                case Events.EVENT_COLUMN_RESIZED:
	                    var colEvent = event;
	                    _this.processColumnEvent(colEvent);
	                    break;
	                case Events.EVENT_COLUMN_GROUP_OPENED:
	                    var groupOpenedEvent = event;
	                    _this.processGroupOpenedEvent(groupOpenedEvent);
	                    break;
	                case Events.EVENT_COLUMN_PIVOT_CHANGED:
	                    // we cannot support pivoting with aligned grids as the columns will be out of sync as the
	                    // grids will have columns created based on the row data of the grid.
	                    console.warn('AG Grid: pivoting is not supported with aligned grids. ' +
	                        'You can only use one of these features at a time in a grid.');
	                    break;
	            }
	        });
	    };
	    AlignedGridsService.prototype.processGroupOpenedEvent = function (groupOpenedEvent) {
	        // likewise for column group
	        var masterColumnGroup = groupOpenedEvent.columnGroup;
	        var otherColumnGroup = null;
	        if (masterColumnGroup) {
	            var groupId = masterColumnGroup.getGroupId();
	            otherColumnGroup = this.columnController.getOriginalColumnGroup(groupId);
	        }
	        if (masterColumnGroup && !otherColumnGroup) {
	            return;
	        }
	        this.logger.log('onColumnEvent-> processing ' + groupOpenedEvent + ' expanded = ' + masterColumnGroup.isExpanded());
	        this.columnController.setColumnGroupOpened(otherColumnGroup, masterColumnGroup.isExpanded(), "alignedGridChanged");
	    };
	    AlignedGridsService.prototype.processColumnEvent = function (colEvent) {
	        var _this = this;
	        // the column in the event is from the master grid. need to
	        // look up the equivalent from this (other) grid
	        var masterColumn = colEvent.column;
	        var otherColumn = null;
	        if (masterColumn) {
	            otherColumn = this.columnController.getPrimaryColumn(masterColumn.getColId());
	        }
	        // if event was with respect to a master column, that is not present in this
	        // grid, then we ignore the event
	        if (masterColumn && !otherColumn) {
	            return;
	        }
	        // in time, all the methods below should use the column ids, it's a more generic way
	        // of handling columns, and also allows for single or multi column events
	        var masterColumns = this.getMasterColumns(colEvent);
	        switch (colEvent.type) {
	            case Events.EVENT_COLUMN_MOVED:
	                // when the user moves columns via setColumnState, we can't depend on moving specific columns
	                // to an index, as there maybe be many indexes columns moved to (as wasn't result of a mouse drag).
	                // so only way to be sure is match the order of all columns using Column State.
	                {
	                    var movedEvent = colEvent;
	                    var srcColState = colEvent.columnApi.getColumnState();
	                    var destColState = srcColState.map(function (s) { return ({ colId: s.colId }); });
	                    this.columnController.applyColumnState({ state: destColState, applyOrder: true }, "alignedGridChanged");
	                    this.logger.log("onColumnEvent-> processing " + colEvent.type + " toIndex = " + movedEvent.toIndex);
	                }
	                break;
	            case Events.EVENT_COLUMN_VISIBLE:
	                // when the user changes visibility via setColumnState, we can't depend on visibility flag in event
	                // as there maybe be mix of true/false (as wasn't result of a mouse click to set visiblity).
	                // so only way to be sure is match the visibility of all columns using Column State.
	                {
	                    var visibleEvent = colEvent;
	                    var srcColState = colEvent.columnApi.getColumnState();
	                    var destColState = srcColState.map(function (s) { return ({ colId: s.colId, hide: s.hide }); });
	                    this.columnController.applyColumnState({ state: destColState }, "alignedGridChanged");
	                    this.logger.log("onColumnEvent-> processing " + colEvent.type + " visible = " + visibleEvent.visible);
	                }
	                break;
	            case Events.EVENT_COLUMN_PINNED:
	                {
	                    var pinnedEvent = colEvent;
	                    var srcColState = colEvent.columnApi.getColumnState();
	                    var destColState = srcColState.map(function (s) { return ({ colId: s.colId, pinned: s.pinned }); });
	                    this.columnController.applyColumnState({ state: destColState }, "alignedGridChanged");
	                    this.logger.log("onColumnEvent-> processing " + colEvent.type + " pinned = " + pinnedEvent.pinned);
	                }
	                break;
	            case Events.EVENT_COLUMN_RESIZED:
	                var resizedEvent_1 = colEvent;
	                masterColumns.forEach(function (column) {
	                    _this.logger.log("onColumnEvent-> processing " + colEvent.type + " actualWidth = " + column.getActualWidth());
	                    var columnWidths = [{ key: column.getColId(), newWidth: column.getActualWidth() }];
	                    _this.columnController.setColumnWidths(columnWidths, false, resizedEvent_1.finished, "alignedGridChanged");
	                });
	                break;
	        }
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var isVerticalScrollShowing = gridBodyCon.isVerticalScrollShowing();
	        var alignedGrids = this.gridOptionsWrapper.getAlignedGrids();
	        if (alignedGrids) {
	            alignedGrids.forEach(function (grid) {
	                if (grid.api) {
	                    grid.api.setAlwaysShowVerticalScroll(isVerticalScrollShowing);
	                }
	            });
	        }
	    };
	    __decorate$1w([
	        Autowired('columnController')
	    ], AlignedGridsService.prototype, "columnController", void 0);
	    __decorate$1w([
	        Autowired('controllersService')
	    ], AlignedGridsService.prototype, "controllersService", void 0);
	    __decorate$1w([
	        __param$8(0, Qualifier('loggerFactory'))
	    ], AlignedGridsService.prototype, "setBeans", null);
	    __decorate$1w([
	        PostConstruct
	    ], AlignedGridsService.prototype, "init", null);
	    AlignedGridsService = __decorate$1w([
	        Bean('alignedGridsService')
	    ], AlignedGridsService);
	    return AlignedGridsService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1E = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1x = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgComponentUtils = /** @class */ (function (_super) {
	    __extends$1E(AgComponentUtils, _super);
	    function AgComponentUtils() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AgComponentUtils.prototype.adaptFunction = function (propertyName, hardcodedJsFunction, componentFromFramework, source) {
	        if (hardcodedJsFunction == null) {
	            return {
	                component: null,
	                componentFromFramework: componentFromFramework,
	                source: source,
	                paramsFromSelector: null
	            };
	        }
	        var metadata = this.componentMetadataProvider.retrieve(propertyName);
	        if (metadata && metadata.functionAdapter) {
	            return {
	                componentFromFramework: componentFromFramework,
	                component: metadata.functionAdapter(hardcodedJsFunction),
	                source: source,
	                paramsFromSelector: null
	            };
	        }
	        return null;
	    };
	    AgComponentUtils.prototype.adaptCellRendererFunction = function (callback) {
	        var Adapter = /** @class */ (function () {
	            function Adapter() {
	            }
	            Adapter.prototype.refresh = function (params) {
	                return false;
	            };
	            Adapter.prototype.getGui = function () {
	                var callbackResult = callback(this.params);
	                var type = typeof callbackResult;
	                if (type === 'string' || type === 'number' || type === 'boolean') {
	                    return loadTemplate('<span>' + callbackResult + '</span>');
	                }
	                return callbackResult;
	            };
	            Adapter.prototype.init = function (params) {
	                this.params = params;
	            };
	            return Adapter;
	        }());
	        return Adapter;
	    };
	    AgComponentUtils.prototype.doesImplementIComponent = function (candidate) {
	        if (!candidate) {
	            return false;
	        }
	        return candidate.prototype && 'getGui' in candidate.prototype;
	    };
	    __decorate$1x([
	        Autowired("componentMetadataProvider")
	    ], AgComponentUtils.prototype, "componentMetadataProvider", void 0);
	    AgComponentUtils = __decorate$1x([
	        Bean("agComponentUtils")
	    ], AgComponentUtils);
	    return AgComponentUtils;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1F = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1y = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ComponentMetadataProvider = /** @class */ (function (_super) {
	    __extends$1F(ComponentMetadataProvider, _super);
	    function ComponentMetadataProvider() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ComponentMetadataProvider.prototype.postConstruct = function () {
	        this.componentMetaData = {
	            dateComponent: {
	                mandatoryMethodList: ['getDate', 'setDate'],
	                optionalMethodList: ['afterGuiAttached', 'setInputPlaceholder', 'setInputAriaLabel']
	            },
	            detailCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh']
	            },
	            headerComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh']
	            },
	            headerGroupComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            loadingCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            loadingOverlayComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            noRowsOverlayComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            floatingFilterComponent: {
	                mandatoryMethodList: ['onParentModelChanged'],
	                optionalMethodList: ['afterGuiAttached']
	            },
	            floatingFilterWrapperComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            cellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            cellEditor: {
	                mandatoryMethodList: ['getValue'],
	                optionalMethodList: ['isPopup', 'isCancelBeforeStart', 'isCancelAfterEnd', 'getPopupPosition', 'focusIn', 'focusOut', 'afterGuiAttached']
	            },
	            innerRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            fullWidthCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            pinnedRowCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            groupRowRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            filter: {
	                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
	                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
	            },
	            filterComponent: {
	                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
	                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
	            },
	            statusPanel: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	            },
	            toolPanel: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached']
	            },
	            tooltipComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            }
	        };
	    };
	    ComponentMetadataProvider.prototype.retrieve = function (name) {
	        return this.componentMetaData[name];
	    };
	    __decorate$1y([
	        Autowired("agComponentUtils")
	    ], ComponentMetadataProvider.prototype, "agComponentUtils", void 0);
	    __decorate$1y([
	        PostConstruct
	    ], ComponentMetadataProvider.prototype, "postConstruct", null);
	    ComponentMetadataProvider = __decorate$1y([
	        Bean("componentMetadataProvider")
	    ], ComponentMetadataProvider);
	    return ComponentMetadataProvider;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$1z = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	/** Using the IoC has a slight performance consideration, which is no problem most of the
	 * time, unless we are trashing objects - which is the case when scrolling and rowComp
	 * and cellComp. So for performance reasons, RowComp and CellComp do not get autowired
	 * with the IoC. Instead they get passed this object which is all the beans the RowComp
	 * and CellComp need. Not autowiring all the cells gives performance improvement. */
	var Beans = /** @class */ (function () {
	    function Beans() {
	    }
	    Beans.prototype.registerGridComp = function (gridBodyComp) {
	        this.gridBodyComp = gridBodyComp;
	    };
	    Beans.prototype.postConstruct = function () {
	        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            this.clientSideRowModel = this.rowModel;
	        }
	        if (this.gridOptionsWrapper.isRowModelServerSide()) {
	            this.serverSideRowModel = this.rowModel;
	        }
	    };
	    __decorate$1z([
	        Autowired('resizeObserverService')
	    ], Beans.prototype, "resizeObserverService", void 0);
	    __decorate$1z([
	        Autowired('paginationProxy')
	    ], Beans.prototype, "paginationProxy", void 0);
	    __decorate$1z([
	        Autowired('context')
	    ], Beans.prototype, "context", void 0);
	    __decorate$1z([
	        Autowired('columnApi')
	    ], Beans.prototype, "columnApi", void 0);
	    __decorate$1z([
	        Autowired('gridApi')
	    ], Beans.prototype, "gridApi", void 0);
	    __decorate$1z([
	        Autowired('gridOptionsWrapper')
	    ], Beans.prototype, "gridOptionsWrapper", void 0);
	    __decorate$1z([
	        Autowired('expressionService')
	    ], Beans.prototype, "expressionService", void 0);
	    __decorate$1z([
	        Autowired('rowRenderer')
	    ], Beans.prototype, "rowRenderer", void 0);
	    __decorate$1z([
	        Autowired('$compile')
	    ], Beans.prototype, "$compile", void 0);
	    __decorate$1z([
	        Autowired('templateService')
	    ], Beans.prototype, "templateService", void 0);
	    __decorate$1z([
	        Autowired('valueService')
	    ], Beans.prototype, "valueService", void 0);
	    __decorate$1z([
	        Autowired('eventService')
	    ], Beans.prototype, "eventService", void 0);
	    __decorate$1z([
	        Autowired('columnController')
	    ], Beans.prototype, "columnController", void 0);
	    __decorate$1z([
	        Autowired('headerNavigationService')
	    ], Beans.prototype, "headerNavigationService", void 0);
	    __decorate$1z([
	        Autowired('columnAnimationService')
	    ], Beans.prototype, "columnAnimationService", void 0);
	    __decorate$1z([
	        Optional('rangeController')
	    ], Beans.prototype, "rangeController", void 0);
	    __decorate$1z([
	        Autowired('focusController')
	    ], Beans.prototype, "focusController", void 0);
	    __decorate$1z([
	        Optional('contextMenuFactory')
	    ], Beans.prototype, "contextMenuFactory", void 0);
	    __decorate$1z([
	        Autowired('popupService')
	    ], Beans.prototype, "popupService", void 0);
	    __decorate$1z([
	        Autowired('valueFormatterService')
	    ], Beans.prototype, "valueFormatterService", void 0);
	    __decorate$1z([
	        Autowired('stylingService')
	    ], Beans.prototype, "stylingService", void 0);
	    __decorate$1z([
	        Autowired('columnHoverService')
	    ], Beans.prototype, "columnHoverService", void 0);
	    __decorate$1z([
	        Autowired('userComponentFactory')
	    ], Beans.prototype, "userComponentFactory", void 0);
	    __decorate$1z([
	        Autowired('animationFrameService')
	    ], Beans.prototype, "taskQueue", void 0);
	    __decorate$1z([
	        Autowired('dragAndDropService')
	    ], Beans.prototype, "dragAndDropService", void 0);
	    __decorate$1z([
	        Autowired('sortController')
	    ], Beans.prototype, "sortController", void 0);
	    __decorate$1z([
	        Autowired('filterManager')
	    ], Beans.prototype, "filterManager", void 0);
	    __decorate$1z([
	        Autowired('rowContainerHeightService')
	    ], Beans.prototype, "rowContainerHeightService", void 0);
	    __decorate$1z([
	        Autowired('frameworkOverrides')
	    ], Beans.prototype, "frameworkOverrides", void 0);
	    __decorate$1z([
	        Autowired('detailRowCompCache')
	    ], Beans.prototype, "detailRowCompCache", void 0);
	    __decorate$1z([
	        Autowired('cellPositionUtils')
	    ], Beans.prototype, "cellPositionUtils", void 0);
	    __decorate$1z([
	        Autowired('rowPositionUtils')
	    ], Beans.prototype, "rowPositionUtils", void 0);
	    __decorate$1z([
	        Autowired('selectionController')
	    ], Beans.prototype, "selectionController", void 0);
	    __decorate$1z([
	        Optional('selectionHandleFactory')
	    ], Beans.prototype, "selectionHandleFactory", void 0);
	    __decorate$1z([
	        Autowired('rowCssClassCalculator')
	    ], Beans.prototype, "rowCssClassCalculator", void 0);
	    __decorate$1z([
	        Autowired('rowModel')
	    ], Beans.prototype, "rowModel", void 0);
	    __decorate$1z([
	        Autowired('controllersService')
	    ], Beans.prototype, "controllersService", void 0);
	    __decorate$1z([
	        PostConstruct
	    ], Beans.prototype, "postConstruct", null);
	    Beans = __decorate$1z([
	        Bean('beans')
	    ], Beans);
	    return Beans;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1G = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1A = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var MAT_GRID_SIZE = 8;
	var BASE_GRID_SIZE = 4;
	var BALHAM_GRID_SIZE = 4;
	var ALPINE_GRID_SIZE = 6;
	var HARD_CODED_SIZES = {
	    // this item is required for custom themes
	    'ag-theme-custom': {
	        headerHeight: 25,
	        headerCellMinWidth: 24,
	        listItemHeight: BASE_GRID_SIZE * 5,
	        rowHeight: 25,
	        chartMenuPanelWidth: 220
	    },
	    'ag-theme-material': {
	        headerHeight: MAT_GRID_SIZE * 7,
	        headerCellMinWidth: 48,
	        listItemHeight: MAT_GRID_SIZE * 4,
	        rowHeight: MAT_GRID_SIZE * 6,
	        chartMenuPanelWidth: 240
	    },
	    'ag-theme-balham': {
	        headerHeight: BALHAM_GRID_SIZE * 8,
	        headerCellMinWidth: 24,
	        listItemHeight: BALHAM_GRID_SIZE * 6,
	        rowHeight: BALHAM_GRID_SIZE * 7,
	        chartMenuPanelWidth: 220
	    },
	    'ag-theme-alpine': {
	        headerHeight: ALPINE_GRID_SIZE * 8,
	        headerCellMinWidth: 36,
	        listItemHeight: ALPINE_GRID_SIZE * 4,
	        rowHeight: ALPINE_GRID_SIZE * 7,
	        chartMenuPanelWidth: 240
	    }
	};
	/**
	 * this object contains a list of Sass variables and an array
	 * of CSS styles required to get the correct value.
	 * eg. $virtual-item-height requires a structure, so we can get its height.
	 * <div class="ag-theme-balham">
	 *     <div class="ag-virtual-list-container">
	 *         <div class="ag-virtual-list-item"></div>
	 *     </div>
	 * </div>
	 */
	var SASS_PROPERTY_BUILDER = {
	    headerHeight: ['ag-header-row'],
	    headerCellMinWidth: ['ag-header-cell'],
	    listItemHeight: ['ag-virtual-list-item'],
	    rowHeight: ['ag-row'],
	    chartMenuPanelWidth: ['ag-chart-docked-container']
	};
	var CALCULATED_SIZES = {};
	var Environment = /** @class */ (function (_super) {
	    __extends$1G(Environment, _super);
	    function Environment() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Environment.prototype.getSassVariable = function (theme, key) {
	        var useTheme = 'ag-theme-' + (theme.match('material') ? 'material' : theme.match('balham') ? 'balham' : theme.match('alpine') ? 'alpine' : 'custom');
	        var defaultValue = HARD_CODED_SIZES[useTheme][key];
	        var calculatedValue = 0;
	        if (!CALCULATED_SIZES[theme]) {
	            CALCULATED_SIZES[theme] = {};
	        }
	        var size = CALCULATED_SIZES[theme][key];
	        if (size != null) {
	            return size;
	        }
	        if (SASS_PROPERTY_BUILDER[key]) {
	            var classList = SASS_PROPERTY_BUILDER[key];
	            var div = document.createElement('div');
	            addCssClass(div, theme);
	            div.style.position = 'absolute';
	            var el = classList.reduce(function (prevEl, currentClass) {
	                var currentDiv = document.createElement('div');
	                currentDiv.style.position = 'static';
	                addCssClass(currentDiv, currentClass);
	                prevEl.appendChild(currentDiv);
	                return currentDiv;
	            }, div);
	            if (document.body) {
	                document.body.appendChild(div);
	                var sizeName = key.toLowerCase().indexOf('height') !== -1 ? 'height' : 'width';
	                calculatedValue = parseInt(window.getComputedStyle(el)[sizeName], 10);
	                document.body.removeChild(div);
	            }
	        }
	        CALCULATED_SIZES[theme][key] = calculatedValue || defaultValue;
	        return CALCULATED_SIZES[theme][key];
	    };
	    Environment.prototype.isThemeDark = function () {
	        var theme = this.getTheme().theme;
	        return !!theme && theme.indexOf('dark') >= 0;
	    };
	    Environment.prototype.chartMenuPanelWidth = function () {
	        var theme = this.getTheme().themeFamily;
	        return this.getSassVariable(theme, 'chartMenuPanelWidth');
	    };
	    Environment.prototype.getTheme = function () {
	        var reg = /\bag-(material|(?:theme-([\w\-]*)))\b/;
	        var el = this.eGridDiv;
	        var themeMatch = null;
	        while (el) {
	            themeMatch = reg.exec(el.className);
	            if (!themeMatch) {
	                el = el.parentElement || undefined;
	            }
	            else {
	                break;
	            }
	        }
	        if (!themeMatch) {
	            return {};
	        }
	        var theme = themeMatch[0];
	        var usingOldTheme = themeMatch[2] === undefined;
	        if (usingOldTheme) {
	            var newTheme_1 = theme.replace('ag-', 'ag-theme-');
	            doOnce(function () { return console.warn("AG Grid: As of v19 old theme are no longer provided. Please replace " + theme + " with " + newTheme_1 + "."); }, 'using-old-theme');
	        }
	        return { theme: theme, el: el, themeFamily: theme.replace(/-dark$/, '') };
	    };
	    __decorate$1A([
	        Autowired('eGridDiv')
	    ], Environment.prototype, "eGridDiv", void 0);
	    Environment = __decorate$1A([
	        Bean('environment')
	    ], Environment);
	    return Environment;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1H = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1B = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AnimationFrameService = /** @class */ (function (_super) {
	    __extends$1H(AnimationFrameService, _super);
	    function AnimationFrameService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // p1 and p2 are create tasks are to do with row and cell creation.
	        // for them we want to execute according to row order, so we use
	        // TaskItem so we know what index the item is for.
	        _this.createTasksP1 = { list: [], sorted: false }; // eg drawing back-ground of rows
	        _this.createTasksP2 = { list: [], sorted: false }; // eg cell renderers, adding hover functionality
	        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
	        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
	        // important.
	        _this.destroyTasks = [];
	        _this.ticking = false;
	        // we need to know direction of scroll, to build up rows in the direction of
	        // the scroll. eg if user scrolls down, we extend the rows by building down.
	        _this.scrollGoingDown = true;
	        _this.lastScrollTop = 0;
	        _this.taskCount = 0;
	        _this.cancelledTasks = new Set();
	        return _this;
	    }
	    AnimationFrameService.prototype.setScrollTop = function (scrollTop) {
	        this.scrollGoingDown = scrollTop > this.lastScrollTop;
	        this.lastScrollTop = scrollTop;
	    };
	    AnimationFrameService.prototype.init = function () {
	        this.useAnimationFrame = !this.gridOptionsWrapper.isSuppressAnimationFrame();
	    };
	    // this method is for our AG Grid sanity only - if animation frames are turned off,
	    // then no place in the code should be looking to add any work to be done in animation
	    // frames. this stops bugs - where some code is asking for a frame to be executed
	    // when it should not.
	    AnimationFrameService.prototype.verifyAnimationFrameOn = function (methodName) {
	        if (this.useAnimationFrame === false) {
	            console.warn("AG Grid: AnimationFrameService." + methodName + " called but animation frames are off");
	        }
	    };
	    AnimationFrameService.prototype.createTask = function (task, index, list) {
	        this.verifyAnimationFrameOn(list);
	        var taskItem = { task: task, index: index, createOrder: ++this.taskCount };
	        this.addTaskToList(this[list], taskItem);
	        this.schedule();
	    };
	    AnimationFrameService.prototype.cancelTask = function (task) {
	        this.cancelledTasks.add(task);
	    };
	    AnimationFrameService.prototype.addTaskToList = function (taskList, task) {
	        taskList.list.push(task);
	        taskList.sorted = false;
	    };
	    AnimationFrameService.prototype.sortTaskList = function (taskList) {
	        if (taskList.sorted) {
	            return;
	        }
	        var sortDirection = this.scrollGoingDown ? 1 : -1;
	        // sort first by row index (taking into account scroll direction), then by
	        // order of task creation (always ascending, so cells will render left-to-right)
	        taskList.list.sort(function (a, b) { return a.index !== b.index ? sortDirection * (b.index - a.index) : b.createOrder - a.createOrder; });
	        taskList.sorted = true;
	    };
	    AnimationFrameService.prototype.addDestroyTask = function (task) {
	        this.verifyAnimationFrameOn('createTasksP3');
	        this.destroyTasks.push(task);
	        this.schedule();
	    };
	    AnimationFrameService.prototype.executeFrame = function (millis) {
	        this.verifyAnimationFrameOn('executeFrame');
	        var p1TaskList = this.createTasksP1;
	        var p1Tasks = p1TaskList.list;
	        var p2TaskList = this.createTasksP2;
	        var p2Tasks = p2TaskList.list;
	        var destroyTasks = this.destroyTasks;
	        var frameStart = new Date().getTime();
	        var duration = (new Date().getTime()) - frameStart;
	        // 16ms is 60 fps
	        var noMaxMillis = millis <= 0;
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        while (noMaxMillis || duration < millis) {
	            var gridBodyDidSomething = gridBodyCon.getScrollFeature().executeAnimationFrameScroll();
	            if (!gridBodyDidSomething) {
	                var task = void 0;
	                if (p1Tasks.length) {
	                    this.sortTaskList(p1TaskList);
	                    task = p1Tasks.pop().task;
	                }
	                else if (p2Tasks.length) {
	                    this.sortTaskList(p2TaskList);
	                    task = p2Tasks.pop().task;
	                }
	                else if (destroyTasks.length) {
	                    task = destroyTasks.pop();
	                }
	                else {
	                    this.cancelledTasks.clear();
	                    break;
	                }
	                if (!this.cancelledTasks.has(task)) {
	                    task();
	                }
	            }
	            duration = (new Date().getTime()) - frameStart;
	        }
	        if (p1Tasks.length || p2Tasks.length || destroyTasks.length) {
	            this.requestFrame();
	        }
	        else {
	            this.stopTicking();
	        }
	    };
	    AnimationFrameService.prototype.stopTicking = function () {
	        this.ticking = false;
	        var event = {
	            type: Events.EVENT_ANIMATION_QUEUE_EMPTY,
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            api: this.gridOptionsWrapper.getApi()
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    AnimationFrameService.prototype.flushAllFrames = function () {
	        if (!this.useAnimationFrame) {
	            return;
	        }
	        this.executeFrame(-1);
	    };
	    AnimationFrameService.prototype.schedule = function () {
	        if (!this.useAnimationFrame) {
	            return;
	        }
	        if (!this.ticking) {
	            this.ticking = true;
	            this.requestFrame();
	        }
	    };
	    AnimationFrameService.prototype.requestFrame = function () {
	        // check for the existence of requestAnimationFrame, and if
	        // it's missing, then we polyfill it with setTimeout()
	        var callback = this.executeFrame.bind(this, 60);
	        if (window.requestAnimationFrame) {
	            window.requestAnimationFrame(callback);
	        }
	        else if (window.webkitRequestAnimationFrame) {
	            window.webkitRequestAnimationFrame(callback);
	        }
	        else {
	            window.setTimeout(callback, 0);
	        }
	    };
	    AnimationFrameService.prototype.isQueueEmpty = function () {
	        return !this.ticking;
	    };
	    __decorate$1B([
	        Autowired('controllersService')
	    ], AnimationFrameService.prototype, "controllersService", void 0);
	    __decorate$1B([
	        PostConstruct
	    ], AnimationFrameService.prototype, "init", null);
	    AnimationFrameService = __decorate$1B([
	        Bean('animationFrameService')
	    ], AnimationFrameService);
	    return AnimationFrameService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1I = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1C = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var NavigationService = /** @class */ (function (_super) {
	    __extends$1I(NavigationService, _super);
	    function NavigationService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.timeLastPageEventProcessed = 0;
	        return _this;
	    }
	    NavigationService.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function (p) {
	            _this.gridBodyCon = p.gridBodyCon;
	        });
	    };
	    NavigationService.prototype.handlePageScrollingKey = function (event) {
	        var key = event.which || event.keyCode;
	        var alt = event.altKey;
	        var ctrl = event.ctrlKey || event.metaKey;
	        var currentCell = this.mouseEventService.getCellPositionForEvent(event);
	        if (!currentCell) {
	            return false;
	        }
	        var processed = false;
	        switch (key) {
	            case KeyCode.PAGE_HOME:
	            case KeyCode.PAGE_END:
	                // handle home and end when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onHomeOrEndKey(key);
	                    processed = true;
	                }
	                break;
	            case KeyCode.LEFT:
	            case KeyCode.RIGHT:
	                // handle left and right when ctrl is pressed only
	                if (ctrl && !alt) {
	                    this.onCtrlLeftOrRight(key, currentCell);
	                    processed = true;
	                }
	                break;
	            case KeyCode.UP:
	            case KeyCode.DOWN:
	                // handle up and down when ctrl is pressed only
	                if (ctrl && !alt) {
	                    this.onCtrlUpOrDown(key, currentCell);
	                    processed = true;
	                }
	                break;
	            case KeyCode.PAGE_DOWN:
	                // handle page up and page down when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onPageDown(currentCell);
	                    processed = true;
	                }
	                break;
	            case KeyCode.PAGE_UP:
	                // handle page up and page down when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onPageUp(currentCell);
	                    processed = true;
	                }
	                break;
	        }
	        if (processed) {
	            event.preventDefault();
	        }
	        return processed;
	    };
	    // the page up/down keys caused a problem, in that if the user
	    // held the page up/down key down, lots of events got generated,
	    // which clogged up the event queue (as they take time to process)
	    // which in turn froze the grid. Logic below makes sure we wait 100ms
	    // between processing the page up/down events, so when user has finger
	    // held down on key, we ignore page up/down events until 100ms has passed,
	    // which effectively empties the queue of page up/down events.
	    NavigationService.prototype.isTimeSinceLastPageEventToRecent = function () {
	        var now = new Date().getTime();
	        var diff = now - this.timeLastPageEventProcessed;
	        return (diff < 100);
	    };
	    NavigationService.prototype.setTimeLastPageEventProcessed = function () {
	        this.timeLastPageEventProcessed = new Date().getTime();
	    };
	    NavigationService.prototype.navigateTo = function (navigateParams) {
	        var scrollIndex = navigateParams.scrollIndex, scrollType = navigateParams.scrollType, scrollColumn = navigateParams.scrollColumn, focusIndex = navigateParams.focusIndex, focusColumn = navigateParams.focusColumn;
	        if (exists(scrollColumn)) {
	            this.gridBodyCon.getScrollFeature().ensureColumnVisible(scrollColumn);
	        }
	        if (exists(scrollIndex)) {
	            this.gridBodyCon.getScrollFeature().ensureIndexVisible(scrollIndex, scrollType);
	        }
	        // make sure the cell is rendered, needed if we are to focus
	        this.animationFrameService.flushAllFrames();
	        // if we don't do this, the range will be left on the last cell, which will leave the last focused cell
	        // highlighted.
	        this.focusController.setFocusedCell(focusIndex, focusColumn, null, true);
	        if (this.rangeController) {
	            var cellPosition = { rowIndex: focusIndex, rowPinned: null, column: focusColumn };
	            this.rangeController.setRangeToCell(cellPosition);
	        }
	    };
	    NavigationService.prototype.onPageDown = function (gridCell) {
	        if (this.isTimeSinceLastPageEventToRecent()) {
	            return;
	        }
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
	        var scrollbarWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
	        if (this.controllersService.getCenterRowContainerCon().isHorizontalScrollShowing()) {
	            pixelsInOnePage -= scrollbarWidth;
	        }
	        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
	        var currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
	        var currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
	        var scrollIndex = currentPageBottomRow;
	        var currentCellPixel = this.paginationProxy.getRow(gridCell.rowIndex).rowTop;
	        var nextCellPixel = currentCellPixel + pixelsInOnePage - pagingPixelOffset;
	        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
	        var pageLastRow = this.paginationProxy.getPageLastRow();
	        if (focusIndex > pageLastRow) {
	            focusIndex = pageLastRow;
	        }
	        if (scrollIndex > pageLastRow) {
	            scrollIndex = pageLastRow;
	        }
	        this.navigateTo({
	            scrollIndex: scrollIndex,
	            scrollType: 'top',
	            scrollColumn: null,
	            focusIndex: focusIndex,
	            focusColumn: gridCell.column
	        });
	        this.setTimeLastPageEventProcessed();
	    };
	    NavigationService.prototype.onPageUp = function (gridCell) {
	        if (this.isTimeSinceLastPageEventToRecent()) {
	            return;
	        }
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
	        var scrollbarWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
	        if (this.controllersService.getCenterRowContainerCon().isHorizontalScrollShowing()) {
	            pixelsInOnePage -= scrollbarWidth;
	        }
	        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
	        var currentPageTopPixel = scrollPosition.top;
	        var currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
	        var scrollIndex = currentPageTopRow;
	        var currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
	        var nextCellPixel = currentRowNode.rowTop + currentRowNode.rowHeight - pixelsInOnePage - pagingPixelOffset;
	        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
	        var firstRow = this.paginationProxy.getPageFirstRow();
	        if (focusIndex < firstRow) {
	            focusIndex = firstRow;
	        }
	        if (scrollIndex < firstRow) {
	            scrollIndex = firstRow;
	        }
	        this.navigateTo({
	            scrollIndex: scrollIndex,
	            scrollType: 'bottom',
	            scrollColumn: null,
	            focusIndex: focusIndex,
	            focusColumn: gridCell.column
	        });
	        this.setTimeLastPageEventProcessed();
	    };
	    NavigationService.prototype.getIndexToFocus = function (indexToScrollTo, isDown) {
	        var indexToFocus = indexToScrollTo;
	        // for SSRM, when user hits ctrl+down, we can end up trying to focus the loading row.
	        // instead we focus the last row with data instead.
	        if (isDown) {
	            var node = this.paginationProxy.getRow(indexToScrollTo);
	            if (node && node.stub) {
	                indexToFocus -= 1;
	            }
	        }
	        return indexToFocus;
	    };
	    // ctrl + up/down will bring focus to same column, first/last row. no horizontal scrolling.
	    NavigationService.prototype.onCtrlUpOrDown = function (key, gridCell) {
	        var upKey = key === KeyCode.UP;
	        var rowIndexToScrollTo = upKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
	        this.navigateTo({
	            scrollIndex: rowIndexToScrollTo,
	            scrollType: null,
	            scrollColumn: gridCell.column,
	            focusIndex: this.getIndexToFocus(rowIndexToScrollTo, !upKey),
	            focusColumn: gridCell.column
	        });
	    };
	    // ctrl + left/right will bring focus to same row, first/last cell. no vertical scrolling.
	    NavigationService.prototype.onCtrlLeftOrRight = function (key, gridCell) {
	        var leftKey = key === KeyCode.LEFT;
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var columnToSelect = leftKey ? allColumns[0] : last(allColumns);
	        this.navigateTo({
	            scrollIndex: gridCell.rowIndex,
	            scrollType: null,
	            scrollColumn: columnToSelect,
	            focusIndex: gridCell.rowIndex,
	            focusColumn: columnToSelect
	        });
	    };
	    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
	    // same cell into view (which means either scroll all the way up, or all the way down).
	    NavigationService.prototype.onHomeOrEndKey = function (key) {
	        var homeKey = key === KeyCode.PAGE_HOME;
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var columnToSelect = homeKey ? allColumns[0] : last(allColumns);
	        var scrollIndex = homeKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
	        this.navigateTo({
	            scrollIndex: scrollIndex,
	            scrollType: null,
	            scrollColumn: columnToSelect,
	            focusIndex: this.getIndexToFocus(scrollIndex, !homeKey),
	            focusColumn: columnToSelect
	        });
	    };
	    __decorate$1C([
	        Autowired('mouseEventService')
	    ], NavigationService.prototype, "mouseEventService", void 0);
	    __decorate$1C([
	        Autowired('paginationProxy')
	    ], NavigationService.prototype, "paginationProxy", void 0);
	    __decorate$1C([
	        Autowired('focusController')
	    ], NavigationService.prototype, "focusController", void 0);
	    __decorate$1C([
	        Autowired('animationFrameService')
	    ], NavigationService.prototype, "animationFrameService", void 0);
	    __decorate$1C([
	        Optional('rangeController')
	    ], NavigationService.prototype, "rangeController", void 0);
	    __decorate$1C([
	        Autowired('columnController')
	    ], NavigationService.prototype, "columnController", void 0);
	    __decorate$1C([
	        Autowired('controllersService')
	    ], NavigationService.prototype, "controllersService", void 0);
	    __decorate$1C([
	        PostConstruct
	    ], NavigationService.prototype, "postConstruct", null);
	    NavigationService = __decorate$1C([
	        Bean('navigationService')
	    ], NavigationService);
	    return NavigationService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1J = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1D = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$9 = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	/**
	 * This class solves the 'max height' problem, where the user might want to show more data than
	 * the max div height actually allows.
	 */
	var RowContainerHeightService = /** @class */ (function (_super) {
	    __extends$1J(RowContainerHeightService, _super);
	    function RowContainerHeightService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // the scrollY position
	        _this.scrollY = 0;
	        // how tall the body is
	        _this.uiBodyHeight = 0;
	        return _this;
	    }
	    RowContainerHeightService.prototype.agWire = function (loggerFactory) {
	        this.logger = loggerFactory.create("RowContainerHeightService");
	    };
	    RowContainerHeightService.prototype.postConstruct = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this));
	        this.maxDivHeight = getMaxDivHeight();
	        this.logger.log('maxDivHeight = ' + this.maxDivHeight);
	    };
	    RowContainerHeightService.prototype.isStretching = function () {
	        return this.stretching;
	    };
	    RowContainerHeightService.prototype.getDivStretchOffset = function () {
	        return this.divStretchOffset;
	    };
	    RowContainerHeightService.prototype.updateOffset = function () {
	        if (!this.stretching) {
	            return;
	        }
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var newScrollY = gridBodyCon.getScrollFeature().getVScrollPosition().top;
	        var newBodyHeight = this.getUiBodyHeight();
	        var atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
	        if (atLeastOneChanged) {
	            this.scrollY = newScrollY;
	            this.uiBodyHeight = newBodyHeight;
	            this.calculateOffset();
	        }
	    };
	    RowContainerHeightService.prototype.calculateOffset = function () {
	        this.setUiContainerHeight(this.maxDivHeight);
	        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
	        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
	        var scrollPercent = this.scrollY / this.maxScrollY;
	        var divStretchOffset = scrollPercent * this.pixelsToShave;
	        this.logger.log("Div Stretch Offset = " + divStretchOffset + " (" + this.pixelsToShave + " * " + scrollPercent + ")");
	        this.setDivStretchOffset(divStretchOffset);
	    };
	    RowContainerHeightService.prototype.setUiContainerHeight = function (height) {
	        if (height !== this.uiContainerHeight) {
	            this.uiContainerHeight = height;
	            this.eventService.dispatchEvent({ type: Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED });
	        }
	    };
	    RowContainerHeightService.prototype.clearOffset = function () {
	        this.setUiContainerHeight(this.modelHeight);
	        this.pixelsToShave = 0;
	        this.setDivStretchOffset(0);
	    };
	    RowContainerHeightService.prototype.setDivStretchOffset = function (newOffset) {
	        // because we are talking pixels, no point in confusing things with half numbers
	        var newOffsetFloor = typeof newOffset === 'number' ? Math.floor(newOffset) : null;
	        if (this.divStretchOffset === newOffsetFloor) {
	            return;
	        }
	        this.divStretchOffset = newOffsetFloor;
	        this.eventService.dispatchEvent({ type: Events.EVENT_HEIGHT_SCALE_CHANGED });
	    };
	    RowContainerHeightService.prototype.setModelHeight = function (modelHeight) {
	        this.modelHeight = modelHeight;
	        this.stretching = modelHeight != null // null happens when in print layout
	            && this.maxDivHeight > 0
	            && modelHeight > this.maxDivHeight;
	        if (this.stretching) {
	            this.calculateOffset();
	        }
	        else {
	            this.clearOffset();
	        }
	    };
	    RowContainerHeightService.prototype.getUiContainerHeight = function () {
	        return this.uiContainerHeight;
	    };
	    RowContainerHeightService.prototype.getRealPixelPosition = function (modelPixel) {
	        return modelPixel - this.divStretchOffset;
	    };
	    RowContainerHeightService.prototype.getUiBodyHeight = function () {
	        var gridBodyCon = this.controllersService.getGridBodyController();
	        var pos = gridBodyCon.getScrollFeature().getVScrollPosition();
	        return pos.bottom - pos.top;
	    };
	    RowContainerHeightService.prototype.getScrollPositionForPixel = function (rowTop) {
	        if (this.pixelsToShave <= 0) {
	            return rowTop;
	        }
	        var modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
	        var scrollPercent = rowTop / modelMaxScroll;
	        var scrollPixel = this.maxScrollY * scrollPercent;
	        return scrollPixel;
	    };
	    __decorate$1D([
	        Autowired('controllersService')
	    ], RowContainerHeightService.prototype, "controllersService", void 0);
	    __decorate$1D([
	        __param$9(0, Qualifier("loggerFactory"))
	    ], RowContainerHeightService.prototype, "agWire", null);
	    __decorate$1D([
	        PostConstruct
	    ], RowContainerHeightService.prototype, "postConstruct", null);
	    RowContainerHeightService = __decorate$1D([
	        Bean('rowContainerHeightService')
	    ], RowContainerHeightService);
	    return RowContainerHeightService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1K = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1E = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SelectableService = /** @class */ (function (_super) {
	    __extends$1K(SelectableService, _super);
	    function SelectableService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SelectableService.prototype.init = function () {
	        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	    };
	    SelectableService.prototype.updateSelectableAfterGrouping = function (rowNode) {
	        if (this.isRowSelectableFunc) {
	            var nextChildrenFunc = function (node) { return node.childrenAfterGroup; };
	            this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
	        }
	    };
	    SelectableService.prototype.updateSelectableAfterFiltering = function (rowNode) {
	        if (this.isRowSelectableFunc) {
	            var nextChildrenFunc = function (node) { return node.childrenAfterFilter; };
	            this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
	        }
	    };
	    SelectableService.prototype.recurseDown = function (children, nextChildrenFunc) {
	        var _this = this;
	        if (!children) {
	            return;
	        }
	        children.forEach(function (child) {
	            if (!child.group) {
	                return;
	            } // only interested in groups
	            if (child.hasChildren()) {
	                _this.recurseDown(nextChildrenFunc(child), nextChildrenFunc);
	            }
	            var rowSelectable;
	            if (_this.groupSelectsChildren) {
	                // have this group selectable if at least one direct child is selectable
	                var firstSelectable = find(nextChildrenFunc(child), 'selectable', true);
	                rowSelectable = exists(firstSelectable);
	            }
	            else {
	                // directly retrieve selectable value from user callback
	                rowSelectable = _this.isRowSelectableFunc ? _this.isRowSelectableFunc(child) : false;
	            }
	            child.setRowSelectable(rowSelectable);
	        });
	    };
	    __decorate$1E([
	        PostConstruct
	    ], SelectableService.prototype, "init", null);
	    SelectableService = __decorate$1E([
	        Bean('selectableService')
	    ], SelectableService);
	    return SelectableService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1L = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1F = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AutoHeightCalculator = /** @class */ (function (_super) {
	    __extends$1L(AutoHeightCalculator, _super);
	    function AutoHeightCalculator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AutoHeightCalculator.prototype.postConstruct = function () {
	        var _this = this;
	        this.controllersService.whenReady(function (p) {
	            _this.centerRowContainerCon = p.centerRowContainerCon;
	        });
	    };
	    AutoHeightCalculator.prototype.getPreferredHeightForRow = function (rowNode) {
	        var _this = this;
	        var eDummyContainer = document.createElement('div');
	        this.addInRowCssClasses(rowNode, eDummyContainer);
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        var eBodyContainer = this.centerRowContainerCon.getContainerElement();
	        eBodyContainer.appendChild(eDummyContainer);
	        var scopeResult = AngularRowUtils.createChildScopeOrNull(rowNode, this.$scope, this.beans.gridOptionsWrapper);
	        var scope = scopeResult ? scopeResult.scope : undefined;
	        var scopeDestroyFunc = scopeResult ? scopeResult.scopeDestroyFunc : undefined;
	        var cellComps = [];
	        var autoRowHeightCols = this.columnController.getAllAutoRowHeightCols();
	        var displayedCols = this.columnController.getAllDisplayedColumns();
	        var visibleAutoRowHeightCols = autoRowHeightCols.filter(function (col) { return displayedCols.indexOf(col) >= 0; });
	        visibleAutoRowHeightCols.forEach(function (col) {
	            var cellComp = new CellComp(scope, _this.beans, col, rowNode, null, true, false, eDummyContainer, false);
	            cellComps.push(cellComp);
	        });
	        cellComps.forEach(function (cellComp) { return eDummyContainer.appendChild(cellComp.getGui()); });
	        if (scope) {
	            this.$compile(eDummyContainer)(scope);
	        }
	        // we should be able to just take the height of the row at this point, however
	        // the row isn't expanding to cover the cell heights, i don't know why, i couldn't
	        // figure it out so instead looking at the individual cells instead
	        var maxCellHeight = 0;
	        for (var i = 0; i < eDummyContainer.children.length; i++) {
	            var child = eDummyContainer.children[i];
	            if (child.offsetHeight > maxCellHeight) {
	                maxCellHeight = child.offsetHeight;
	            }
	        }
	        // we are finished with the dummy container, so get rid of it
	        eBodyContainer.removeChild(eDummyContainer);
	        cellComps.forEach(function (cellComp) {
	            // dunno why we need to detach first, doing it here to be consistent with code in RowComp
	            cellComp.detach();
	            cellComp.destroy();
	        });
	        if (scopeDestroyFunc) {
	            scopeDestroyFunc();
	        }
	        return maxCellHeight;
	    };
	    AutoHeightCalculator.prototype.addInRowCssClasses = function (rowNode, eDummyContainer) {
	        // so any styles on row also get applied in dummy, otherwise
	        // the content in dummy may differ to the real
	        var rowIndex = rowNode.rowIndex;
	        var params = {
	            rowNode: rowNode,
	            rowIsEven: rowIndex % 2 === 0,
	            rowLevel: this.rowCssClassCalculator.calculateRowLevel(rowNode),
	            firstRowOnPage: rowIndex === this.beans.paginationProxy.getPageFirstRow(),
	            lastRowOnPage: rowIndex === this.beans.paginationProxy.getPageLastRow(),
	            printLayout: false,
	            expandable: rowNode.isExpandable()
	        };
	        var classes = this.rowCssClassCalculator.getInitialRowClasses(params);
	        addCssClass(eDummyContainer, classes.join(' '));
	    };
	    __decorate$1F([
	        Autowired('beans')
	    ], AutoHeightCalculator.prototype, "beans", void 0);
	    __decorate$1F([
	        Autowired("$scope")
	    ], AutoHeightCalculator.prototype, "$scope", void 0);
	    __decorate$1F([
	        Autowired("columnController")
	    ], AutoHeightCalculator.prototype, "columnController", void 0);
	    __decorate$1F([
	        Autowired("rowCssClassCalculator")
	    ], AutoHeightCalculator.prototype, "rowCssClassCalculator", void 0);
	    __decorate$1F([
	        Autowired('$compile')
	    ], AutoHeightCalculator.prototype, "$compile", void 0);
	    __decorate$1F([
	        Autowired('controllersService')
	    ], AutoHeightCalculator.prototype, "controllersService", void 0);
	    __decorate$1F([
	        PostConstruct
	    ], AutoHeightCalculator.prototype, "postConstruct", null);
	    AutoHeightCalculator = __decorate$1F([
	        Bean('autoHeightCalculator')
	    ], AutoHeightCalculator);
	    return AutoHeightCalculator;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1M = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1G = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var PaginationComp = /** @class */ (function (_super) {
	    __extends$1M(PaginationComp, _super);
	    function PaginationComp() {
	        var _this = _super.call(this) || this;
	        _this.previousAndFirstButtonsDisabled = false;
	        _this.nextButtonDisabled = false;
	        _this.lastButtonDisabled = false;
	        return _this;
	    }
	    PaginationComp.prototype.postConstruct = function () {
	        var _this = this;
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        this.setTemplate(this.getTemplate());
	        this.btFirst.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'last' : 'first', this.gridOptionsWrapper));
	        this.btPrevious.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'next' : 'previous', this.gridOptionsWrapper));
	        this.btNext.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'previous' : 'next', this.gridOptionsWrapper));
	        this.btLast.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'first' : 'last', this.gridOptionsWrapper));
	        var isPaging = this.gridOptionsWrapper.isPagination();
	        var paginationPanelEnabled = isPaging && !this.gridOptionsWrapper.isSuppressPaginationPanel();
	        if (!paginationPanelEnabled) {
	            this.setDisplayed(false);
	            return;
	        }
	        this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
	        [
	            { el: this.btFirst, fn: this.onBtFirst.bind(this) },
	            { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
	            { el: this.btNext, fn: this.onBtNext.bind(this) },
	            { el: this.btLast, fn: this.onBtLast.bind(this) }
	        ].forEach(function (item) {
	            var el = item.el, fn = item.fn;
	            _this.addManagedListener(el, 'click', fn);
	            _this.addManagedListener(el, 'keydown', function (e) {
	                if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
	                    e.preventDefault();
	                    fn();
	                }
	            });
	        });
	        this.onPaginationChanged();
	    };
	    PaginationComp.prototype.onPaginationChanged = function () {
	        this.enableOrDisableButtons();
	        this.updateRowLabels();
	        this.setCurrentPageLabel();
	        this.setTotalLabels();
	    };
	    PaginationComp.prototype.onBtFirst = function () {
	        if (!this.previousAndFirstButtonsDisabled) {
	            this.paginationProxy.goToFirstPage();
	        }
	    };
	    PaginationComp.prototype.setCurrentPageLabel = function () {
	        var pagesExist = this.paginationProxy.getTotalPages() > 0;
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var toDisplay = pagesExist ? currentPage + 1 : 0;
	        this.lbCurrent.innerHTML = this.formatNumber(toDisplay);
	    };
	    PaginationComp.prototype.formatNumber = function (value) {
	        var userFunc = this.gridOptionsWrapper.getPaginationNumberFormatterFunc();
	        if (userFunc) {
	            return userFunc({ value: value });
	        }
	        return formatNumberCommas(value);
	    };
	    PaginationComp.prototype.getTemplate = function () {
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var strPage = localeTextFunc('page', 'Page');
	        var strTo = localeTextFunc('to', 'to');
	        var strOf = localeTextFunc('of', 'of');
	        var strFirst = localeTextFunc('firstPage', 'First Page');
	        var strPrevious = localeTextFunc('previousPage', 'Previous Page');
	        var strNext = localeTextFunc('nextPage', 'Next Page');
	        var strLast = localeTextFunc('lastPage', 'Last Page');
	        var compId = this.getCompId();
	        var summaryDescribedBy = "ag-" + compId + "-first-row ag-" + compId + "-to ag-" + compId + "-last-row ag-" + compId + "-of ag-" + compId + "-row-count";
	        var descriptionDescribedBy = "ag-" + compId + "-start-page ag-" + compId + "-start-page-number ag-" + compId + "-of-page ag-" + compId + "-of-page-number";
	        return /* html */ "<div class=\"ag-paging-panel ag-unselectable\" id=\"ag-" + compId + "\" aria-live=\"polite\" aria-describedby=\"" + descriptionDescribedBy + " " + summaryDescribedBy + "\">\n                <span class=\"ag-paging-row-summary-panel\" aria-hidden=\"true\">\n                    <span id=\"ag-" + compId + "-first-row\" ref=\"lbFirstRowOnPage\" class=\"ag-paging-row-summary-panel-number\"></span>\n                    <span id=\"ag-" + compId + "-to\">" + strTo + "</span>\n                    <span id=\"ag-" + compId + "-last-row\" ref=\"lbLastRowOnPage\" class=\"ag-paging-row-summary-panel-number\"></span>\n                    <span id=\"ag-" + compId + "-of\">" + strOf + "</span>\n                    <span id=\"ag-" + compId + "-row-count\" ref=\"lbRecordCount\" class=\"ag-paging-row-summary-panel-number\"></span>\n                </span>\n                <span class=\"ag-paging-page-summary-panel\" role=\"presentation\">\n                    <div ref=\"btFirst\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strFirst + "\" tabindex=\"0\"></div>\n                    <div ref=\"btPrevious\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strPrevious + "\" tabindex=\"0\"></div>\n                    <span class=\"ag-paging-description\" aria-hidden=\"true\">\n                        <span id=\"ag-" + compId + "-start-page\">" + strPage + "</span>\n                        <span id=\"ag-" + compId + "-start-page-number\" ref=\"lbCurrent\" class=\"ag-paging-number\"></span>\n                        <span id=\"ag-" + compId + "-of-page\">" + strOf + "</span>\n                        <span id=\"ag-" + compId + "-of-page-number\" ref=\"lbTotal\" class=\"ag-paging-number\"></span>\n                    </span>\n                    <div ref=\"btNext\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strNext + "\" tabindex=\"0\"></div>\n                    <div ref=\"btLast\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strLast + "\" tabindex=\"0\"></div>\n                </span>\n            </div>";
	    };
	    PaginationComp.prototype.onBtNext = function () {
	        if (!this.nextButtonDisabled) {
	            this.paginationProxy.goToNextPage();
	        }
	    };
	    PaginationComp.prototype.onBtPrevious = function () {
	        if (!this.previousAndFirstButtonsDisabled) {
	            this.paginationProxy.goToPreviousPage();
	        }
	    };
	    PaginationComp.prototype.onBtLast = function () {
	        if (!this.lastButtonDisabled) {
	            this.paginationProxy.goToLastPage();
	        }
	    };
	    PaginationComp.prototype.enableOrDisableButtons = function () {
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        this.previousAndFirstButtonsDisabled = currentPage === 0;
	        addOrRemoveCssClass(this.btFirst, 'ag-disabled', this.previousAndFirstButtonsDisabled);
	        setAriaDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
	        addOrRemoveCssClass(this.btPrevious, 'ag-disabled', this.previousAndFirstButtonsDisabled);
	        setAriaDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
	        var zeroPagesToDisplay = this.isZeroPagesToDisplay();
	        var onLastPage = maxRowFound && currentPage === (totalPages - 1);
	        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
	        addOrRemoveCssClass(this.btNext, 'ag-disabled', this.nextButtonDisabled);
	        setAriaDisabled(this.btNext, this.nextButtonDisabled);
	        this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === (totalPages - 1);
	        addOrRemoveCssClass(this.btLast, 'ag-disabled', this.lastButtonDisabled);
	        setAriaDisabled(this.btLast, this.lastButtonDisabled);
	    };
	    PaginationComp.prototype.updateRowLabels = function () {
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var pageSize = this.paginationProxy.getPageSize();
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var rowCount = this.paginationProxy.isLastPageFound() ?
	            this.paginationProxy.getMasterRowCount() : null;
	        var startRow;
	        var endRow;
	        if (this.isZeroPagesToDisplay()) {
	            startRow = endRow = 0;
	        }
	        else {
	            startRow = (pageSize * currentPage) + 1;
	            endRow = startRow + pageSize - 1;
	            if (maxRowFound && endRow > rowCount) {
	                endRow = rowCount;
	            }
	        }
	        this.lbFirstRowOnPage.innerHTML = this.formatNumber(startRow);
	        if (this.rowNodeBlockLoader.isLoading()) {
	            this.lbLastRowOnPage.innerHTML = '?';
	        }
	        else {
	            this.lbLastRowOnPage.innerHTML = this.formatNumber(endRow);
	        }
	    };
	    PaginationComp.prototype.isZeroPagesToDisplay = function () {
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        return maxRowFound && totalPages === 0;
	    };
	    PaginationComp.prototype.setTotalLabels = function () {
	        var lastPageFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        var rowCount = lastPageFound ?
	            this.paginationProxy.getMasterRowCount() : null;
	        if (lastPageFound) {
	            this.lbTotal.innerHTML = this.formatNumber(totalPages);
	            this.lbRecordCount.innerHTML = this.formatNumber(rowCount);
	        }
	        else {
	            var moreText = this.gridOptionsWrapper.getLocaleTextFunc()('more', 'more');
	            this.lbTotal.innerHTML = moreText;
	            this.lbRecordCount.innerHTML = moreText;
	        }
	    };
	    __decorate$1G([
	        Autowired('paginationProxy')
	    ], PaginationComp.prototype, "paginationProxy", void 0);
	    __decorate$1G([
	        Autowired('rowNodeBlockLoader')
	    ], PaginationComp.prototype, "rowNodeBlockLoader", void 0);
	    __decorate$1G([
	        RefSelector('btFirst')
	    ], PaginationComp.prototype, "btFirst", void 0);
	    __decorate$1G([
	        RefSelector('btPrevious')
	    ], PaginationComp.prototype, "btPrevious", void 0);
	    __decorate$1G([
	        RefSelector('btNext')
	    ], PaginationComp.prototype, "btNext", void 0);
	    __decorate$1G([
	        RefSelector('btLast')
	    ], PaginationComp.prototype, "btLast", void 0);
	    __decorate$1G([
	        RefSelector('lbRecordCount')
	    ], PaginationComp.prototype, "lbRecordCount", void 0);
	    __decorate$1G([
	        RefSelector('lbFirstRowOnPage')
	    ], PaginationComp.prototype, "lbFirstRowOnPage", void 0);
	    __decorate$1G([
	        RefSelector('lbLastRowOnPage')
	    ], PaginationComp.prototype, "lbLastRowOnPage", void 0);
	    __decorate$1G([
	        RefSelector('lbCurrent')
	    ], PaginationComp.prototype, "lbCurrent", void 0);
	    __decorate$1G([
	        RefSelector('lbTotal')
	    ], PaginationComp.prototype, "lbTotal", void 0);
	    __decorate$1G([
	        PostConstruct
	    ], PaginationComp.prototype, "postConstruct", null);
	    return PaginationComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1N = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1H = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ResizeObserverService = /** @class */ (function (_super) {
	    __extends$1N(ResizeObserverService, _super);
	    function ResizeObserverService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResizeObserverService.prototype.observeResize = function (element, callback, debounceDelay) {
	        if (debounceDelay === void 0) { debounceDelay = 50; }
	        // put in variable, so available to usePolyfill() function below
	        var frameworkFactory = this.getFrameworkOverrides();
	        // this gets fired too often and might cause some relayout issues
	        // so we add a debounce to the callback here to avoid the flashing effect.
	        var debouncedCallback = debounce(callback, debounceDelay);
	        var useBrowserResizeObserver = function () {
	            var resizeObserver = new window.ResizeObserver(debouncedCallback);
	            resizeObserver.observe(element);
	            return function () { return resizeObserver.disconnect(); };
	        };
	        var usePolyfill = function () {
	            // initialise to the current width and height, so first call will have no changes
	            var widthLastTime = offsetWidth(element);
	            var heightLastTime = offsetHeight(element);
	            // when finished, this gets turned to false.
	            var running = true;
	            var periodicallyCheckWidthAndHeight = function () {
	                if (running) {
	                    var newWidth = offsetWidth(element);
	                    var newHeight = offsetHeight(element);
	                    var changed = newWidth !== widthLastTime || newHeight !== heightLastTime;
	                    if (changed) {
	                        widthLastTime = newWidth;
	                        heightLastTime = newHeight;
	                        callback();
	                    }
	                    frameworkFactory.setTimeout(periodicallyCheckWidthAndHeight, debounceDelay);
	                }
	            };
	            periodicallyCheckWidthAndHeight();
	            // the callback function we return sets running to false
	            return function () { return running = false; };
	        };
	        var suppressResize = this.gridOptionsWrapper.isSuppressBrowserResizeObserver();
	        var resizeObserverExists = !!window.ResizeObserver;
	        if (resizeObserverExists && !suppressResize) {
	            return useBrowserResizeObserver();
	        }
	        else {
	            return usePolyfill();
	        }
	    };
	    ResizeObserverService = __decorate$1H([
	        Bean('resizeObserverService')
	    ], ResizeObserverService);
	    return ResizeObserverService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1O = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1I = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var LoadingType;
	(function (LoadingType) {
	    LoadingType[LoadingType["Loading"] = 0] = "Loading";
	    LoadingType[LoadingType["NoRows"] = 1] = "NoRows";
	})(LoadingType || (LoadingType = {}));
	var OverlayWrapperComponent = /** @class */ (function (_super) {
	    __extends$1O(OverlayWrapperComponent, _super);
	    function OverlayWrapperComponent() {
	        var _this = _super.call(this, OverlayWrapperComponent.TEMPLATE) || this;
	        _this.inProgress = false;
	        _this.destroyRequested = false;
	        return _this;
	    }
	    OverlayWrapperComponent.prototype.updateLayoutClasses = function (params) {
	        addOrRemoveCssClass(this.eOverlayWrapper, exports.LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
	        addOrRemoveCssClass(this.eOverlayWrapper, exports.LayoutCssClasses.NORMAL, params.normal);
	        addOrRemoveCssClass(this.eOverlayWrapper, exports.LayoutCssClasses.PRINT, params.print);
	    };
	    OverlayWrapperComponent.prototype.postConstruct = function () {
	        this.createManagedBean(new LayoutFeature(this));
	        this.setDisplayed(false);
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_CHANGED, this.onRowDataChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_UPDATED, this.onRowDataChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        if (this.gridOptionsWrapper.isRowModelDefault() && !this.gridOptionsWrapper.getRowData()) {
	            this.showLoadingOverlay();
	        }
	        this.gridApi.registerOverlayWrapperComp(this);
	    };
	    OverlayWrapperComponent.prototype.setWrapperTypeClass = function (loadingType) {
	        addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-loading-wrapper', loadingType === LoadingType.Loading);
	        addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-no-rows-wrapper', loadingType === LoadingType.NoRows);
	    };
	    OverlayWrapperComponent.prototype.showLoadingOverlay = function () {
	        if (this.gridOptionsWrapper.isSuppressLoadingOverlay()) {
	            return;
	        }
	        var workItem = this.userComponentFactory.newLoadingOverlayComponent({
	            api: this.gridOptionsWrapper.getApi()
	        });
	        this.showOverlay(workItem, LoadingType.Loading);
	    };
	    OverlayWrapperComponent.prototype.showNoRowsOverlay = function () {
	        if (this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
	            return;
	        }
	        var workItem = this.userComponentFactory.newNoRowsOverlayComponent({
	            api: this.gridOptionsWrapper.getApi()
	        });
	        this.showOverlay(workItem, LoadingType.NoRows);
	    };
	    OverlayWrapperComponent.prototype.showOverlay = function (workItem, type) {
	        var _this = this;
	        if (this.inProgress) {
	            return;
	        }
	        this.setWrapperTypeClass(type);
	        this.destroyActiveOverlay();
	        this.inProgress = true;
	        if (workItem) {
	            workItem.then(function (comp) {
	                _this.inProgress = false;
	                _this.eOverlayWrapper.appendChild(comp.getGui());
	                _this.activeOverlay = comp;
	                if (_this.destroyRequested) {
	                    _this.destroyRequested = false;
	                    _this.destroyActiveOverlay();
	                }
	            });
	        }
	        this.setDisplayed(true);
	    };
	    OverlayWrapperComponent.prototype.destroyActiveOverlay = function () {
	        if (this.inProgress) {
	            this.destroyRequested = true;
	            return;
	        }
	        if (!this.activeOverlay) {
	            return;
	        }
	        this.activeOverlay = this.getContext().destroyBean(this.activeOverlay);
	        clearElement(this.eOverlayWrapper);
	    };
	    OverlayWrapperComponent.prototype.hideOverlay = function () {
	        this.destroyActiveOverlay();
	        this.setDisplayed(false);
	    };
	    OverlayWrapperComponent.prototype.destroy = function () {
	        this.destroyActiveOverlay();
	        _super.prototype.destroy.call(this);
	    };
	    OverlayWrapperComponent.prototype.showOrHideOverlay = function () {
	        var isEmpty = this.paginationProxy.isEmpty();
	        var isSuppressNoRowsOverlay = this.gridOptionsWrapper.isSuppressNoRowsOverlay();
	        if (isEmpty && !isSuppressNoRowsOverlay) {
	            this.showNoRowsOverlay();
	        }
	        else {
	            this.hideOverlay();
	        }
	    };
	    OverlayWrapperComponent.prototype.onRowDataChanged = function () {
	        this.showOrHideOverlay();
	    };
	    OverlayWrapperComponent.prototype.onNewColumnsLoaded = function () {
	        // hide overlay if columns and rows exist, this can happen if columns are loaded after data.
	        // this problem exists before of the race condition between the services (column controller in this case)
	        // and the view (grid panel). if the model beans were all initialised first, and then the view beans second,
	        // this race condition would not happen.
	        if (this.columnController.isReady() && !this.paginationProxy.isEmpty()) {
	            this.hideOverlay();
	        }
	    };
	    // wrapping in outer div, and wrapper, is needed to center the loading icon
	    // The idea for centering came from here: http://www.vanseodesign.com/css/vertical-centering/
	    OverlayWrapperComponent.TEMPLATE = "\n        <div class=\"ag-overlay\" aria-hidden=\"true\">\n            <div class=\"ag-overlay-panel\">\n                <div class=\"ag-overlay-wrapper\" ref=\"eOverlayWrapper\"></div>\n            </div>\n        </div>";
	    __decorate$1I([
	        Autowired('userComponentFactory')
	    ], OverlayWrapperComponent.prototype, "userComponentFactory", void 0);
	    __decorate$1I([
	        Autowired('paginationProxy')
	    ], OverlayWrapperComponent.prototype, "paginationProxy", void 0);
	    __decorate$1I([
	        Autowired('gridApi')
	    ], OverlayWrapperComponent.prototype, "gridApi", void 0);
	    __decorate$1I([
	        Autowired('columnController')
	    ], OverlayWrapperComponent.prototype, "columnController", void 0);
	    __decorate$1I([
	        RefSelector('eOverlayWrapper')
	    ], OverlayWrapperComponent.prototype, "eOverlayWrapper", void 0);
	    __decorate$1I([
	        PostConstruct
	    ], OverlayWrapperComponent.prototype, "postConstruct", null);
	    return OverlayWrapperComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1P = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1J = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgGroupComponent = /** @class */ (function (_super) {
	    __extends$1P(AgGroupComponent, _super);
	    function AgGroupComponent(params) {
	        if (params === void 0) { params = {}; }
	        var _this = _super.call(this, AgGroupComponent.getTemplate(params)) || this;
	        _this.suppressEnabledCheckbox = true;
	        _this.suppressOpenCloseIcons = false;
	        var title = params.title, enabled = params.enabled, items = params.items, suppressEnabledCheckbox = params.suppressEnabledCheckbox, suppressOpenCloseIcons = params.suppressOpenCloseIcons;
	        _this.title = title;
	        _this.cssIdentifier = params.cssIdentifier || 'default';
	        _this.enabled = enabled != null ? enabled : true;
	        _this.items = items || [];
	        _this.alignItems = params.alignItems || 'center';
	        if (suppressEnabledCheckbox != null) {
	            _this.suppressEnabledCheckbox = suppressEnabledCheckbox;
	        }
	        if (suppressOpenCloseIcons != null) {
	            _this.suppressOpenCloseIcons = suppressOpenCloseIcons;
	        }
	        return _this;
	    }
	    AgGroupComponent.getTemplate = function (params) {
	        var cssIdentifier = params.cssIdentifier || 'default';
	        var direction = params.direction || 'vertical';
	        return /* html */ "<div class=\"ag-group ag-" + cssIdentifier + "-group\">\n            <div class=\"ag-group-title-bar ag-" + cssIdentifier + "-group-title-bar ag-unselectable\" ref=\"eTitleBar\">\n                <span class=\"ag-group-title-bar-icon ag-" + cssIdentifier + "-group-title-bar-icon\" ref=\"eGroupOpenedIcon\"></span>\n                <span class=\"ag-group-title-bar-icon ag-" + cssIdentifier + "-group-title-bar-icon\" ref=\"eGroupClosedIcon\"></span>\n                <span ref=\"eTitle\" class=\"ag-group-title ag-" + cssIdentifier + "-group-title\"></span>\n            </div>\n            <div ref=\"eToolbar\" class=\"ag-group-toolbar ag-" + cssIdentifier + "-group-toolbar\">\n                <ag-checkbox ref=\"cbGroupEnabled\"></ag-checkbox>\n            </div>\n            <div ref=\"eContainer\" class=\"ag-group-container ag-group-container-" + direction + " ag-" + cssIdentifier + "-group-container\"></div>\n        </div>";
	    };
	    AgGroupComponent.prototype.postConstruct = function () {
	        if (this.items.length) {
	            var initialItems = this.items;
	            this.items = [];
	            this.addItems(initialItems);
	        }
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.cbGroupEnabled.setLabel(localeTextFunc('enabled', 'Enabled'));
	        if (this.title) {
	            this.setTitle(this.title);
	        }
	        if (this.enabled) {
	            this.setEnabled(this.enabled);
	        }
	        this.setAlignItems(this.alignItems);
	        this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
	        this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
	        this.setupExpandContract();
	        this.refreshChildDisplay();
	    };
	    AgGroupComponent.prototype.setupExpandContract = function () {
	        var _this = this;
	        this.eGroupClosedIcon.appendChild(createIcon('columnSelectClosed', this.gridOptionsWrapper, null));
	        this.eGroupOpenedIcon.appendChild(createIcon('columnSelectOpen', this.gridOptionsWrapper, null));
	        this.addManagedListener(this.eTitleBar, 'click', function () { return _this.toggleGroupExpand(); });
	        this.addManagedListener(this.eTitleBar, 'keydown', function (e) {
	            switch (e.keyCode) {
	                case KeyCode.ENTER:
	                    _this.toggleGroupExpand();
	                    break;
	                case KeyCode.RIGHT:
	                    _this.toggleGroupExpand(true);
	                    break;
	                case KeyCode.LEFT:
	                    _this.toggleGroupExpand(false);
	                    break;
	            }
	        });
	    };
	    AgGroupComponent.prototype.refreshChildDisplay = function () {
	        var showIcon = !this.suppressOpenCloseIcons;
	        setDisplayed(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox);
	        setDisplayed(this.eGroupOpenedIcon, showIcon && this.expanded);
	        setDisplayed(this.eGroupClosedIcon, showIcon && !this.expanded);
	    };
	    AgGroupComponent.prototype.isExpanded = function () {
	        return this.expanded;
	    };
	    AgGroupComponent.prototype.setAlignItems = function (alignment) {
	        var eGui = this.getGui();
	        if (this.alignItems !== alignment) {
	            removeCssClass(eGui, "ag-group-item-alignment-" + this.alignItems);
	        }
	        this.alignItems = alignment;
	        var newCls = "ag-group-item-alignment-" + this.alignItems;
	        addCssClass(eGui, newCls);
	        return this;
	    };
	    AgGroupComponent.prototype.toggleGroupExpand = function (expanded) {
	        if (this.suppressOpenCloseIcons) {
	            this.expanded = true;
	            this.refreshChildDisplay();
	            setDisplayed(this.eContainer, true);
	            return this;
	        }
	        expanded = expanded != null ? expanded : !this.expanded;
	        if (this.expanded === expanded) {
	            return this;
	        }
	        this.expanded = expanded;
	        this.refreshChildDisplay();
	        setDisplayed(this.eContainer, expanded);
	        this.dispatchEvent({ type: this.expanded ? AgGroupComponent.EVENT_EXPANDED : AgGroupComponent.EVENT_COLLAPSED });
	        return this;
	    };
	    AgGroupComponent.prototype.addItems = function (items) {
	        var _this = this;
	        items.forEach(function (item) { return _this.addItem(item); });
	    };
	    AgGroupComponent.prototype.addItem = function (item) {
	        var container = this.eContainer;
	        var el = item instanceof Component ? item.getGui() : item;
	        addCssClass(el, 'ag-group-item');
	        addCssClass(el, "ag-" + this.cssIdentifier + "-group-item");
	        container.appendChild(el);
	        this.items.push(el);
	    };
	    AgGroupComponent.prototype.hideItem = function (hide, index) {
	        var itemToHide = this.items[index];
	        addOrRemoveCssClass(itemToHide, 'ag-hidden', hide);
	    };
	    AgGroupComponent.prototype.setTitle = function (title) {
	        this.eTitle.innerText = title;
	        return this;
	    };
	    AgGroupComponent.prototype.addCssClassToTitleBar = function (cssClass) {
	        addCssClass(this.eTitleBar, cssClass);
	    };
	    AgGroupComponent.prototype.setEnabled = function (enabled, skipToggle) {
	        this.enabled = enabled;
	        this.refreshDisabledStyles();
	        this.toggleGroupExpand(enabled);
	        if (!skipToggle) {
	            this.cbGroupEnabled.setValue(enabled);
	        }
	        return this;
	    };
	    AgGroupComponent.prototype.isEnabled = function () {
	        return this.enabled;
	    };
	    AgGroupComponent.prototype.onEnableChange = function (callbackFn) {
	        var _this = this;
	        this.cbGroupEnabled.onValueChange(function (newSelection) {
	            _this.setEnabled(newSelection, true);
	            callbackFn(newSelection);
	        });
	        return this;
	    };
	    AgGroupComponent.prototype.hideEnabledCheckbox = function (hide) {
	        this.suppressEnabledCheckbox = hide;
	        this.refreshChildDisplay();
	        this.refreshDisabledStyles();
	        return this;
	    };
	    AgGroupComponent.prototype.hideOpenCloseIcons = function (hide) {
	        this.suppressOpenCloseIcons = hide;
	        if (hide) {
	            this.toggleGroupExpand(true);
	        }
	        return this;
	    };
	    AgGroupComponent.prototype.refreshDisabledStyles = function () {
	        addOrRemoveCssClass(this.getGui(), 'ag-disabled', !this.enabled);
	        if (this.suppressEnabledCheckbox && !this.enabled) {
	            addCssClass(this.eTitleBar, 'ag-disabled-group-title-bar');
	            this.eTitleBar.removeAttribute('tabindex');
	        }
	        else {
	            removeCssClass(this.eTitleBar, 'ag-disabled-group-title-bar');
	            this.eTitleBar.setAttribute('tabindex', '0');
	        }
	        addOrRemoveCssClass(this.eContainer, 'ag-disabled-group-container', !this.enabled);
	    };
	    AgGroupComponent.EVENT_EXPANDED = 'expanded';
	    AgGroupComponent.EVENT_COLLAPSED = 'collapsed';
	    __decorate$1J([
	        RefSelector('eTitleBar')
	    ], AgGroupComponent.prototype, "eTitleBar", void 0);
	    __decorate$1J([
	        RefSelector('eGroupOpenedIcon')
	    ], AgGroupComponent.prototype, "eGroupOpenedIcon", void 0);
	    __decorate$1J([
	        RefSelector('eGroupClosedIcon')
	    ], AgGroupComponent.prototype, "eGroupClosedIcon", void 0);
	    __decorate$1J([
	        RefSelector('eToolbar')
	    ], AgGroupComponent.prototype, "eToolbar", void 0);
	    __decorate$1J([
	        RefSelector('cbGroupEnabled')
	    ], AgGroupComponent.prototype, "cbGroupEnabled", void 0);
	    __decorate$1J([
	        RefSelector('eTitle')
	    ], AgGroupComponent.prototype, "eTitle", void 0);
	    __decorate$1J([
	        RefSelector('eContainer')
	    ], AgGroupComponent.prototype, "eContainer", void 0);
	    __decorate$1J([
	        PostConstruct
	    ], AgGroupComponent.prototype, "postConstruct", null);
	    return AgGroupComponent;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1Q = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1K = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgPanel = /** @class */ (function (_super) {
	    __extends$1Q(AgPanel, _super);
	    function AgPanel(config) {
	        var _this = _super.call(this, AgPanel.getTemplate(config)) || this;
	        _this.closable = true;
	        _this.positioned = false;
	        _this.dragStartPosition = {
	            x: 0,
	            y: 0
	        };
	        _this.position = {
	            x: 0,
	            y: 0
	        };
	        _this.size = {
	            width: undefined,
	            height: undefined
	        };
	        _this.config = config;
	        return _this;
	    }
	    AgPanel.getTemplate = function (config) {
	        var cssIdentifier = (config && config.cssIdentifier) || 'default';
	        return /* html */ "<div class=\"ag-panel ag-" + cssIdentifier + "-panel\" tabindex=\"-1\">\n            <div ref=\"eTitleBar\" class=\"ag-panel-title-bar ag-" + cssIdentifier + "-panel-title-bar ag-unselectable\">\n                <span ref=\"eTitle\" class=\"ag-panel-title-bar-title ag-" + cssIdentifier + "-panel-title-bar-title\"></span>\n                <div ref=\"eTitleBarButtons\" class=\"ag-panel-title-bar-buttons ag-" + cssIdentifier + "-panel-title-bar-buttons\"></div>\n            </div>\n            <div ref=\"eContentWrapper\" class=\"ag-panel-content-wrapper ag-" + cssIdentifier + "-panel-content-wrapper\"></div>\n        </div>";
	    };
	    AgPanel.prototype.postConstruct = function () {
	        var _this = this;
	        var _a = this.config, component = _a.component, closable = _a.closable, hideTitleBar = _a.hideTitleBar, title = _a.title, minWidth = _a.minWidth, width = _a.width, minHeight = _a.minHeight, height = _a.height, centered = _a.centered, x = _a.x, y = _a.y;
	        var eGui = this.getGui();
	        if (component) {
	            this.setBodyComponent(component);
	        }
	        if (!hideTitleBar) {
	            if (title) {
	                this.setTitle(title);
	            }
	            this.setClosable(closable != null ? closable : this.closable);
	        }
	        else {
	            addCssClass(this.eTitleBar, 'ag-hidden');
	        }
	        this.addManagedListener(this.eTitleBar, 'mousedown', function (e) {
	            if (eGui.contains(e.relatedTarget) ||
	                eGui.contains(document.activeElement) ||
	                _this.eTitleBarButtons.contains(e.target)) {
	                e.preventDefault();
	                return;
	            }
	            var focusEl = _this.eContentWrapper.querySelector('button, [href], input, select, textarea, [tabindex]');
	            if (focusEl) {
	                focusEl.focus();
	            }
	        });
	        if (this.positioned) {
	            return;
	        }
	        this.minHeight = minHeight != null ? minHeight : 250;
	        this.minWidth = minWidth != null ? minWidth : 250;
	        this.popupParent = this.popupService.getPopupParent();
	        if (width) {
	            this.setWidth(width);
	        }
	        if (height) {
	            this.setHeight(height);
	        }
	        if (this.renderComponent) {
	            this.renderComponent();
	        }
	        if (!width || !height) {
	            this.refreshSize();
	        }
	        if (centered) {
	            this.center();
	        }
	        else if (x || y) {
	            this.offsetElement(x, y);
	        }
	        this.positioned = true;
	        this.eContentWrapper.style.height = '0';
	    };
	    AgPanel.prototype.renderComponent = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        eGui.focus();
	        this.close = function () {
	            eGui.parentElement.removeChild(eGui);
	            _this.destroy();
	        };
	    };
	    AgPanel.prototype.updateDragStartPosition = function (x, y) {
	        this.dragStartPosition = { x: x, y: y };
	    };
	    AgPanel.prototype.calculateMouseMovement = function (params) {
	        var parentRect = this.popupParent.getBoundingClientRect();
	        var e = params.e, isLeft = params.isLeft, isTop = params.isTop, anywhereWithin = params.anywhereWithin, topBuffer = params.topBuffer;
	        var movementX = e.clientX - this.dragStartPosition.x;
	        var movementY = e.clientY - this.dragStartPosition.y;
	        var width = this.getWidth();
	        var height = this.getHeight();
	        // skip if cursor is outside of popupParent horizontally
	        var skipX = (parentRect.left >= e.clientX && this.position.x <= 0 ||
	            parentRect.right <= e.clientX && parentRect.right <= this.position.x + parentRect.left + width);
	        if (!skipX) {
	            if (isLeft) {
	                skipX = (
	                // skip if we are moving to the left and the cursor
	                // is positioned to the right of the left side anchor
	                (movementX < 0 && e.clientX > this.position.x + parentRect.left) ||
	                    // skip if we are moving to the right and the cursor
	                    // is positioned to the left of the dialog
	                    (movementX > 0 && e.clientX < this.position.x + parentRect.left));
	            }
	            else {
	                if (anywhereWithin) {
	                    // if anywhereWithin is true, we allow to move
	                    // as long as the cursor is within the dialog
	                    skipX = ((movementX < 0 && e.clientX > this.position.x + parentRect.left + width) ||
	                        (movementX > 0 && e.clientX < this.position.x + parentRect.left));
	                }
	                else {
	                    skipX = (
	                    // if the movement is bound to the right side of the dialog
	                    // we skip if we are moving to the left and the cursor
	                    // is to the right of the dialog
	                    (movementX < 0 && e.clientX > this.position.x + parentRect.left + width) ||
	                        // or skip if we are moving to the right and the cursor
	                        // is to the left of the right side anchor
	                        (movementX > 0 && e.clientX < this.position.x + parentRect.left + width));
	                }
	            }
	        }
	        movementX = skipX ? 0 : movementX;
	        var skipY = (
	        // skip if cursor is outside of popupParent vertically
	        parentRect.top >= e.clientY && this.position.y <= 0 ||
	            parentRect.bottom <= e.clientY && parentRect.bottom <= this.position.y + parentRect.top + height ||
	            isTop && (
	            // skip if we are moving to towards top and the cursor is
	            // below the top anchor + topBuffer
	            // note: topBuffer is used when moving the dialog using the title bar
	            (movementY < 0 && e.clientY > this.position.y + parentRect.top + (topBuffer || 0)) ||
	                // skip if we are moving to the bottom and the cursor is
	                // above the top anchor
	                (movementY > 0 && e.clientY < this.position.y + parentRect.top)) ||
	            // we are anchored to the bottom of the dialog
	            !isTop && (
	            // skip if we are moving towards the top and the cursor
	            // is below the bottom anchor
	            (movementY < 0 && e.clientY > this.position.y + parentRect.top + height) ||
	                // skip if we are moving towards the bottom and the cursor
	                // is above the bottom anchor
	                (movementY > 0 && e.clientY < this.position.y + parentRect.top + height)));
	        movementY = skipY ? 0 : movementY;
	        return { movementX: movementX, movementY: movementY };
	    };
	    AgPanel.prototype.refreshSize = function () {
	        var _a = this.size, width = _a.width, height = _a.height;
	        if (!width) {
	            this.setWidth(this.getGui().offsetWidth);
	        }
	        if (!height) {
	            this.setHeight(this.getGui().offsetHeight);
	        }
	    };
	    AgPanel.prototype.offsetElement = function (x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        var ePopup = this.getGui();
	        this.popupService.positionPopup({
	            ePopup: ePopup,
	            x: x,
	            y: y,
	            minWidth: this.minWidth,
	            minHeight: this.minHeight,
	            keepWithinBounds: true
	        });
	        this.position.x = parseInt(ePopup.style.left, 10);
	        this.position.y = parseInt(ePopup.style.top, 10);
	    };
	    AgPanel.prototype.getHeight = function () {
	        return this.size.height;
	    };
	    AgPanel.prototype.setHeight = function (height) {
	        var eGui = this.getGui();
	        var isPercent = false;
	        if (typeof height === 'string' && height.indexOf('%') !== -1) {
	            setFixedHeight(eGui, height);
	            height = getAbsoluteHeight(eGui);
	            isPercent = true;
	        }
	        else {
	            height = Math.max(this.minHeight, height);
	            var offsetParent = eGui.offsetParent;
	            if (offsetParent && offsetParent.clientHeight && (height + this.position.y > offsetParent.clientHeight)) {
	                height = offsetParent.clientHeight - this.position.y;
	            }
	        }
	        if (this.size.height === height) {
	            return;
	        }
	        this.size.height = height;
	        if (!isPercent) {
	            setFixedHeight(eGui, height);
	        }
	        else {
	            eGui.style.maxHeight = 'unset';
	            eGui.style.minHeight = 'unset';
	        }
	    };
	    AgPanel.prototype.getWidth = function () {
	        return this.size.width;
	    };
	    AgPanel.prototype.setWidth = function (width) {
	        var eGui = this.getGui();
	        var isPercent = false;
	        if (typeof width === 'string' && width.indexOf('%') !== -1) {
	            setFixedWidth(eGui, width);
	            width = getAbsoluteWidth(eGui);
	            isPercent = true;
	        }
	        else {
	            width = Math.max(this.minWidth, width);
	            var offsetParent = eGui.offsetParent;
	            if (offsetParent && offsetParent.clientWidth && (width + this.position.x > offsetParent.clientWidth)) {
	                width = offsetParent.clientWidth - this.position.x;
	            }
	        }
	        if (this.size.width === width) {
	            return;
	        }
	        this.size.width = width;
	        if (!isPercent) {
	            setFixedWidth(eGui, width);
	        }
	        else {
	            eGui.style.maxWidth = 'unset';
	            eGui.style.minWidth = 'unset';
	        }
	    };
	    AgPanel.prototype.center = function () {
	        var eGui = this.getGui();
	        var x = (eGui.offsetParent.clientWidth / 2) - (this.getWidth() / 2);
	        var y = (eGui.offsetParent.clientHeight / 2) - (this.getHeight() / 2);
	        this.offsetElement(x, y);
	    };
	    AgPanel.prototype.setClosable = function (closable) {
	        if (closable !== this.closable) {
	            this.closable = closable;
	        }
	        if (closable) {
	            var closeButtonComp = this.closeButtonComp = new Component(AgPanel.CLOSE_BTN_TEMPLATE);
	            this.getContext().createBean(closeButtonComp);
	            var eGui = closeButtonComp.getGui();
	            eGui.appendChild(addCssClass(createIconNoSpan('close', this.gridOptionsWrapper), 'ag-panel-title-bar-button-icon'));
	            this.addTitleBarButton(closeButtonComp);
	            closeButtonComp.addManagedListener(eGui, 'click', this.onBtClose.bind(this));
	        }
	        else if (this.closeButtonComp) {
	            var eGui = this.closeButtonComp.getGui();
	            eGui.parentElement.removeChild(eGui);
	            this.closeButtonComp = this.destroyBean(this.closeButtonComp);
	        }
	    };
	    AgPanel.prototype.setBodyComponent = function (bodyComponent) {
	        bodyComponent.setParentComponent(this);
	        this.eContentWrapper.appendChild(bodyComponent.getGui());
	    };
	    AgPanel.prototype.addTitleBarButton = function (button, position) {
	        var eTitleBarButtons = this.eTitleBarButtons;
	        var buttons = eTitleBarButtons.children;
	        var len = buttons.length;
	        if (position == null) {
	            position = len;
	        }
	        position = Math.max(0, Math.min(position, len));
	        var eGui = button.getGui();
	        addCssClass(eGui, 'ag-panel-title-bar-button');
	        if (position === 0) {
	            eTitleBarButtons.insertAdjacentElement('afterbegin', eGui);
	        }
	        else if (position === len) {
	            eTitleBarButtons.insertAdjacentElement('beforeend', eGui);
	        }
	        else {
	            buttons[position - 1].insertAdjacentElement('afterend', eGui);
	        }
	        button.setParentComponent(this);
	    };
	    AgPanel.prototype.getBodyHeight = function () {
	        return getInnerHeight(this.eContentWrapper);
	    };
	    AgPanel.prototype.getBodyWidth = function () {
	        return getInnerWidth(this.eContentWrapper);
	    };
	    AgPanel.prototype.setTitle = function (title) {
	        this.eTitle.innerText = title;
	    };
	    // called when user hits the 'x' in the top right
	    AgPanel.prototype.onBtClose = function () {
	        this.close();
	    };
	    AgPanel.prototype.destroy = function () {
	        if (this.closeButtonComp) {
	            this.closeButtonComp = this.destroyBean(this.closeButtonComp);
	        }
	        var eGui = this.getGui();
	        if (eGui && eGui.offsetParent) {
	            this.close();
	        }
	        _super.prototype.destroy.call(this);
	    };
	    AgPanel.CLOSE_BTN_TEMPLATE = "<div class=\"ag-button\"></div>";
	    __decorate$1K([
	        Autowired('popupService')
	    ], AgPanel.prototype, "popupService", void 0);
	    __decorate$1K([
	        RefSelector('eContentWrapper')
	    ], AgPanel.prototype, "eContentWrapper", void 0);
	    __decorate$1K([
	        RefSelector('eTitleBar')
	    ], AgPanel.prototype, "eTitleBar", void 0);
	    __decorate$1K([
	        RefSelector('eTitleBarButtons')
	    ], AgPanel.prototype, "eTitleBarButtons", void 0);
	    __decorate$1K([
	        RefSelector('eTitle')
	    ], AgPanel.prototype, "eTitle", void 0);
	    __decorate$1K([
	        PostConstruct
	    ], AgPanel.prototype, "postConstruct", null);
	    return AgPanel;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1R = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1L = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgDialog = /** @class */ (function (_super) {
	    __extends$1R(AgDialog, _super);
	    function AgDialog(config) {
	        var _this = _super.call(this, config) || this;
	        _this.RESIZE_TEMPLATE = "<div class=\"ag-resizer-wrapper\">\n            <div ref=\"eTopLeftResizer\" class=\"ag-resizer ag-resizer-topLeft\"></div>\n            <div ref=\"eTopResizer\" class=\"ag-resizer ag-resizer-top\"></div>\n            <div ref=\"eTopRightResizer\" class=\"ag-resizer ag-resizer-topRight\"></div>\n            <div ref=\"eRightResizer\" class=\"ag-resizer ag-resizer-right\"></div>\n            <div ref=\"eBottomRightResizer\" class=\"ag-resizer ag-resizer-bottomRight\"></div>\n            <div ref=\"eBottomResizer\" class=\"ag-resizer ag-resizer-bottom\"></div>\n            <div ref=\"eBottomLeftResizer\" class=\"ag-resizer ag-resizer-bottomLeft\"></div>\n            <div ref=\"eLeftResizer\" class=\"ag-resizer ag-resizer-left\"></div>\n        </div>";
	        _this.resizable = {};
	        _this.movable = false;
	        _this.isMoving = false;
	        _this.isMaximizable = false;
	        _this.isMaximized = false;
	        _this.maximizeListeners = [];
	        _this.resizeListenerDestroy = null;
	        _this.isResizing = false;
	        _this.lastPosition = {
	            x: 0,
	            y: 0,
	            width: 0,
	            height: 0
	        };
	        return _this;
	    }
	    AgDialog.prototype.postConstruct = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        var _a = this.config, movable = _a.movable, resizable = _a.resizable, maximizable = _a.maximizable;
	        addCssClass(eGui, 'ag-dialog');
	        this.moveElement = this.eTitleBar;
	        _super.prototype.postConstruct.call(this);
	        this.addManagedListener(eGui, 'focusin', function (e) {
	            if (eGui.contains(e.relatedTarget)) {
	                return;
	            }
	            _this.popupService.bringPopupToFront(eGui);
	        });
	        if (movable) {
	            this.setMovable(movable);
	        }
	        if (maximizable) {
	            this.setMaximizable(maximizable);
	        }
	        this.addResizers();
	        if (resizable) {
	            this.setResizable(resizable);
	        }
	    };
	    AgDialog.prototype.renderComponent = function () {
	        var eGui = this.getGui();
	        var _a = this.config, alwaysOnTop = _a.alwaysOnTop, modal = _a.modal;
	        var addPopupRes = this.popupService.addPopup({
	            modal: modal,
	            eChild: eGui,
	            closeOnEsc: true,
	            closedCallback: this.destroy.bind(this),
	            alwaysOnTop: alwaysOnTop
	        });
	        if (addPopupRes) {
	            this.close = addPopupRes.hideFunc;
	        }
	    };
	    AgDialog.prototype.addResizers = function () {
	        var eGui = this.getGui();
	        if (!eGui) {
	            return;
	        }
	        var parser = new DOMParser();
	        var resizers = parser.parseFromString(this.RESIZE_TEMPLATE, 'text/html').body;
	        eGui.appendChild(resizers.firstChild);
	        this.createMap();
	    };
	    AgDialog.prototype.createMap = function () {
	        var eGui = this.getGui();
	        this.resizerMap = {
	            topLeft: { element: eGui.querySelector('[ref=eTopLeftResizer]') },
	            top: { element: eGui.querySelector('[ref=eTopResizer]') },
	            topRight: { element: eGui.querySelector('[ref=eTopRightResizer]') },
	            right: { element: eGui.querySelector('[ref=eRightResizer]') },
	            bottomRight: { element: eGui.querySelector('[ref=eBottomRightResizer]') },
	            bottom: { element: eGui.querySelector('[ref=eBottomResizer]') },
	            bottomLeft: { element: eGui.querySelector('[ref=eBottomLeftResizer]') },
	            left: { element: eGui.querySelector('[ref=eLeftResizer]') }
	        };
	    };
	    AgDialog.prototype.getResizerElement = function (side) {
	        return this.resizerMap[side].element;
	    };
	    AgDialog.prototype.onResizeStart = function (e) {
	        this.isResizing = true;
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onResize = function (e, side) {
	        if (!this.isResizing) {
	            return;
	        }
	        var isLeft = !!side.match(/left/i);
	        var isRight = !!side.match(/right/i);
	        var isTop = !!side.match(/top/i);
	        var isBottom = !!side.match(/bottom/i);
	        var isHorizontal = isLeft || isRight;
	        var isVertical = isTop || isBottom;
	        var _a = this.calculateMouseMovement({ e: e, isLeft: isLeft, isTop: isTop }), movementX = _a.movementX, movementY = _a.movementY;
	        var offsetLeft = 0;
	        var offsetTop = 0;
	        if (isHorizontal && movementX) {
	            var direction = isLeft ? -1 : 1;
	            var oldWidth = this.getWidth();
	            var newWidth = oldWidth + (movementX * direction);
	            var skipWidth = false;
	            if (isLeft) {
	                offsetLeft = oldWidth - newWidth;
	                if (this.position.x + offsetLeft <= 0 || newWidth <= this.minWidth) {
	                    skipWidth = true;
	                    offsetLeft = 0;
	                }
	            }
	            if (!skipWidth) {
	                this.setWidth(newWidth);
	            }
	        }
	        if (isVertical && movementY) {
	            var direction = isTop ? -1 : 1;
	            var oldHeight = this.getHeight();
	            var newHeight = oldHeight + (movementY * direction);
	            var skipHeight = false;
	            if (isTop) {
	                offsetTop = oldHeight - newHeight;
	                if (this.position.y + offsetTop <= 0 || newHeight <= this.minHeight) {
	                    skipHeight = true;
	                    offsetTop = 0;
	                }
	            }
	            if (!skipHeight) {
	                this.setHeight(newHeight);
	            }
	        }
	        this.updateDragStartPosition(e.clientX, e.clientY);
	        if (offsetLeft || offsetTop) {
	            this.offsetElement(this.position.x + offsetLeft, this.position.y + offsetTop);
	        }
	    };
	    AgDialog.prototype.onResizeEnd = function () {
	        this.isResizing = false;
	        var params = {
	            type: 'resize',
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	        this.dispatchEvent(params);
	    };
	    AgDialog.prototype.onMoveStart = function (e) {
	        this.isMoving = true;
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onMove = function (e) {
	        if (!this.isMoving) {
	            return;
	        }
	        var _a = this.position, x = _a.x, y = _a.y;
	        var _b = this.calculateMouseMovement({
	            e: e,
	            isTop: true,
	            anywhereWithin: true,
	            topBuffer: this.getHeight() - this.getBodyHeight()
	        }), movementX = _b.movementX, movementY = _b.movementY;
	        this.offsetElement(x + movementX, y + movementY);
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onMoveEnd = function () {
	        this.isMoving = false;
	    };
	    AgDialog.prototype.toggleMaximize = function () {
	        if (this.isMaximized) {
	            var _a = this.lastPosition, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	            this.setWidth(width);
	            this.setHeight(height);
	            this.offsetElement(x, y);
	        }
	        else {
	            this.lastPosition.width = this.getWidth();
	            this.lastPosition.height = this.getHeight();
	            this.lastPosition.x = this.position.x;
	            this.lastPosition.y = this.position.y;
	            this.offsetElement(0, 0);
	            this.setHeight('100%');
	            this.setWidth('100%');
	        }
	        this.isMaximized = !this.isMaximized;
	        this.refreshMaximizeIcon();
	    };
	    AgDialog.prototype.refreshMaximizeIcon = function () {
	        setDisplayed(this.maximizeIcon, !this.isMaximized);
	        setDisplayed(this.minimizeIcon, this.isMaximized);
	    };
	    AgDialog.prototype.clearMaximizebleListeners = function () {
	        if (this.maximizeListeners.length) {
	            this.maximizeListeners.forEach(function (destroyListener) { return destroyListener(); });
	            this.maximizeListeners.length = 0;
	        }
	        if (this.resizeListenerDestroy) {
	            this.resizeListenerDestroy();
	            this.resizeListenerDestroy = null;
	        }
	    };
	    AgDialog.prototype.destroy = function () {
	        this.setResizable(false);
	        this.setMovable(false);
	        this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp);
	        this.clearMaximizebleListeners();
	        _super.prototype.destroy.call(this);
	    };
	    AgDialog.prototype.setResizable = function (resizable) {
	        var _this = this;
	        if (typeof resizable === 'boolean') {
	            resizable = {
	                topLeft: resizable,
	                top: resizable,
	                topRight: resizable,
	                right: resizable,
	                bottomRight: resizable,
	                bottom: resizable,
	                bottomLeft: resizable,
	                left: resizable
	            };
	        }
	        Object.keys(resizable).forEach(function (side) {
	            var r = resizable;
	            var s = side;
	            var val = !!r[s];
	            var el = _this.getResizerElement(s);
	            var params = _this.resizerMap[s].dragSource || {
	                eElement: el,
	                onDragStart: _this.onResizeStart.bind(_this),
	                onDragging: function (e) { return _this.onResize(e, s); },
	                onDragStop: _this.onResizeEnd.bind(_this),
	            };
	            if (!!_this.resizable[s] !== val || (!_this.isAlive() && !val)) {
	                if (val) {
	                    _this.dragService.addDragSource(params);
	                    el.style.pointerEvents = 'all';
	                }
	                else {
	                    _this.dragService.removeDragSource(params);
	                    el.style.pointerEvents = 'none';
	                }
	                _this.resizerMap[s].dragSource = val ? params : undefined;
	            }
	        });
	    };
	    AgDialog.prototype.setMovable = function (movable) {
	        if (movable === this.movable) {
	            return;
	        }
	        this.movable = movable;
	        var params = this.moveElementDragListener || {
	            eElement: this.moveElement,
	            onDragStart: this.onMoveStart.bind(this),
	            onDragging: this.onMove.bind(this),
	            onDragStop: this.onMoveEnd.bind(this)
	        };
	        if (movable) {
	            this.dragService.addDragSource(params);
	            this.moveElementDragListener = params;
	        }
	        else {
	            this.dragService.removeDragSource(params);
	            this.moveElementDragListener = undefined;
	        }
	    };
	    AgDialog.prototype.setMaximizable = function (maximizable) {
	        var _this = this;
	        if (!maximizable) {
	            this.clearMaximizebleListeners();
	            if (this.maximizeButtonComp) {
	                this.destroyBean(this.maximizeButtonComp);
	                this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = undefined;
	            }
	            return;
	        }
	        var eTitleBar = this.eTitleBar;
	        if (!eTitleBar || maximizable === this.isMaximizable) {
	            return;
	        }
	        var maximizeButtonComp = this.maximizeButtonComp =
	            this.createBean(new Component(/* html */ "<div class=\"ag-dialog-button\"></span>"));
	        var eGui = maximizeButtonComp.getGui();
	        eGui.appendChild(this.maximizeIcon = createIconNoSpan('maximize', this.gridOptionsWrapper));
	        addCssClass(this.maximizeIcon, 'ag-panel-title-bar-button-icon');
	        eGui.appendChild(this.minimizeIcon = createIconNoSpan('minimize', this.gridOptionsWrapper));
	        addCssClass(this.minimizeIcon, 'ag-panel-title-bar-button-icon');
	        addCssClass(this.minimizeIcon, 'ag-hidden');
	        maximizeButtonComp.addManagedListener(eGui, 'click', this.toggleMaximize.bind(this));
	        this.addTitleBarButton(maximizeButtonComp, 0);
	        this.maximizeListeners.push(this.addManagedListener(eTitleBar, 'dblclick', this.toggleMaximize.bind(this)));
	        this.resizeListenerDestroy = this.addManagedListener(this, 'resize', function () {
	            _this.isMaximized = false;
	            _this.refreshMaximizeIcon();
	        });
	    };
	    __decorate$1L([
	        Autowired('dragService')
	    ], AgDialog.prototype, "dragService", void 0);
	    return AgDialog;
	}(AgPanel));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1S = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgInputTextField = /** @class */ (function (_super) {
	    __extends$1S(AgInputTextField, _super);
	    function AgInputTextField(config, className, inputType) {
	        if (className === void 0) { className = 'ag-text-field'; }
	        if (inputType === void 0) { inputType = 'text'; }
	        return _super.call(this, config, className, inputType) || this;
	    }
	    AgInputTextField.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        if (this.config.allowedCharPattern) {
	            this.preventDisallowedCharacters();
	        }
	    };
	    AgInputTextField.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        if (this.eInput.value !== value) {
	            this.eInput.value = exists(value) ? value : '';
	        }
	        return ret;
	    };
	    AgInputTextField.prototype.preventDisallowedCharacters = function () {
	        var pattern = new RegExp("[" + this.config.allowedCharPattern + "]");
	        var preventDisallowedCharacters = function (event) {
	            if (event.key && !pattern.test(event.key)) {
	                event.preventDefault();
	            }
	        };
	        this.addManagedListener(this.eInput, 'keypress', preventDisallowedCharacters);
	        this.addManagedListener(this.eInput, 'paste', function (e) {
	            var text = e.clipboardData.getData('text');
	            if (some(text, function (c) { return !pattern.test(c); })) {
	                e.preventDefault();
	            }
	        });
	    };
	    return AgInputTextField;
	}(AgAbstractInputField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1T = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgInputTextArea = /** @class */ (function (_super) {
	    __extends$1T(AgInputTextArea, _super);
	    function AgInputTextArea(config) {
	        return _super.call(this, config, 'ag-text-area', null, 'textarea') || this;
	    }
	    AgInputTextArea.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    AgInputTextArea.prototype.setCols = function (cols) {
	        this.eInput.cols = cols;
	        return this;
	    };
	    AgInputTextArea.prototype.setRows = function (rows) {
	        this.eInput.rows = rows;
	        return this;
	    };
	    return AgInputTextArea;
	}(AgAbstractInputField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1U = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1M = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgSlider = /** @class */ (function (_super) {
	    __extends$1U(AgSlider, _super);
	    function AgSlider(config) {
	        var _this = _super.call(this, config, AgSlider.TEMPLATE) || this;
	        _this.labelAlignment = 'top';
	        return _this;
	    }
	    AgSlider.prototype.init = function () {
	        addCssClass(this.eSlider.getGui(), 'ag-slider-field');
	    };
	    AgSlider.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        var eventChanged = AgAbstractField.EVENT_CHANGED;
	        this.addManagedListener(this.eText, eventChanged, function () {
	            var textValue = parseFloat(_this.eText.getValue());
	            _this.eSlider.setValue(textValue.toString(), true);
	            callbackFn(textValue || 0);
	        });
	        this.addManagedListener(this.eSlider, eventChanged, function () {
	            var sliderValue = _this.eSlider.getValue();
	            _this.eText.setValue(sliderValue, true);
	            callbackFn(parseFloat(sliderValue));
	        });
	        return this;
	    };
	    AgSlider.prototype.setSliderWidth = function (width) {
	        this.eSlider.setWidth(width);
	        return this;
	    };
	    AgSlider.prototype.setTextFieldWidth = function (width) {
	        this.eText.setWidth(width);
	        return this;
	    };
	    AgSlider.prototype.setMinValue = function (minValue) {
	        this.eSlider.setMinValue(minValue);
	        this.eText.setMin(minValue);
	        return this;
	    };
	    AgSlider.prototype.setMaxValue = function (maxValue) {
	        this.eSlider.setMaxValue(maxValue);
	        this.eText.setMax(maxValue);
	        return this;
	    };
	    AgSlider.prototype.getValue = function () {
	        return this.eText.getValue();
	    };
	    AgSlider.prototype.setValue = function (value) {
	        if (this.getValue() === value) {
	            return this;
	        }
	        this.eText.setValue(value, true);
	        this.eSlider.setValue(value, true);
	        this.dispatchEvent({ type: AgAbstractField.EVENT_CHANGED });
	        return this;
	    };
	    AgSlider.prototype.setStep = function (step) {
	        this.eSlider.setStep(step);
	        this.eText.setStep(step);
	        return this;
	    };
	    AgSlider.TEMPLATE = "<div class=\"ag-slider\">\n            <label ref=\"eLabel\"></label>\n            <div class=\"ag-wrapper ag-slider-wrapper\">\n                <ag-input-range ref=\"eSlider\"></ag-input-range>\n                <ag-input-number-field ref=\"eText\"></ag-input-number-field>\n            </div>\n        </div>";
	    __decorate$1M([
	        RefSelector('eLabel')
	    ], AgSlider.prototype, "eLabel", void 0);
	    __decorate$1M([
	        RefSelector('eSlider')
	    ], AgSlider.prototype, "eSlider", void 0);
	    __decorate$1M([
	        RefSelector('eText')
	    ], AgSlider.prototype, "eText", void 0);
	    __decorate$1M([
	        PostConstruct
	    ], AgSlider.prototype, "init", null);
	    return AgSlider;
	}(AgAbstractLabel));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1V = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1N = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgColorPanel = /** @class */ (function (_super) {
	    __extends$1V(AgColorPanel, _super);
	    function AgColorPanel(config) {
	        var _this = _super.call(this, AgColorPanel.TEMPLATE) || this;
	        _this.H = 1; // in the [0, 1] range
	        _this.S = 1; // in the [0, 1] range
	        _this.B = 1; // in the [0, 1] range
	        _this.A = 1; // in the [0, 1] range
	        _this.isSpectrumDragging = false;
	        _this.isSpectrumHueDragging = false;
	        _this.isSpectrumAlphaDragging = false;
	        _this.colorChanged = false;
	        _this.picker = config.picker;
	        return _this;
	    }
	    AgColorPanel.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        this.initRecentColors();
	        this.addManagedListener(this.spectrumVal, 'mousedown', this.onSpectrumDraggerDown.bind(this));
	        this.addManagedListener(eGui, 'mousemove', this.onSpectrumDraggerMove.bind(this));
	        this.addManagedListener(this.spectrumHue, 'mousedown', this.onSpectrumHueDown.bind(this));
	        this.addManagedListener(eGui, 'mousemove', this.onSpectrumHueMove.bind(this));
	        this.addManagedListener(this.spectrumAlpha, 'mousedown', this.onSpectrumAlphaDown.bind(this));
	        this.addManagedListener(eGui, 'mousemove', this.onSpectrumAlphaMove.bind(this));
	        // Listening to `mouseup` on the document on purpose. The user might release the mouse button
	        // outside the UI control. When the mouse returns back to the control's area, the dragging
	        // of the thumb is not expected and seen as a bug.
	        this.addManagedListener(document, 'mouseup', this.onMouseUp.bind(this));
	        this.addManagedListener(this.recentColors, 'click', this.onRecentColorClick.bind(this));
	    };
	    AgColorPanel.prototype.refreshSpectrumRect = function () {
	        return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.refreshHueRect = function () {
	        return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.refreshAlphaRect = function () {
	        return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.onSpectrumDraggerDown = function (e) {
	        this.refreshSpectrumRect();
	        this.isSpectrumDragging = true;
	        this.moveDragger(e);
	    };
	    AgColorPanel.prototype.onSpectrumDraggerMove = function (e) {
	        if (this.isSpectrumDragging) {
	            this.moveDragger(e);
	        }
	    };
	    AgColorPanel.prototype.onSpectrumHueDown = function (e) {
	        this.refreshHueRect();
	        this.isSpectrumHueDragging = true;
	        this.moveHueSlider(e);
	    };
	    AgColorPanel.prototype.onSpectrumHueMove = function (e) {
	        if (this.isSpectrumHueDragging) {
	            this.moveHueSlider(e);
	        }
	    };
	    AgColorPanel.prototype.onSpectrumAlphaDown = function (e) {
	        this.refreshAlphaRect();
	        this.isSpectrumAlphaDragging = true;
	        this.moveAlphaSlider(e);
	    };
	    AgColorPanel.prototype.onSpectrumAlphaMove = function (e) {
	        if (this.isSpectrumAlphaDragging) {
	            this.moveAlphaSlider(e);
	        }
	    };
	    AgColorPanel.prototype.onMouseUp = function () {
	        this.isSpectrumDragging = false;
	        this.isSpectrumHueDragging = false;
	        this.isSpectrumAlphaDragging = false;
	    };
	    AgColorPanel.prototype.moveDragger = function (e) {
	        var valRect = this.spectrumValRect;
	        if (valRect) {
	            var x = e.clientX - valRect.left;
	            var y = e.clientY - valRect.top;
	            x = Math.max(x, 0);
	            x = Math.min(x, valRect.width);
	            y = Math.max(y, 0);
	            y = Math.min(y, valRect.height);
	            this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
	        }
	    };
	    AgColorPanel.prototype.moveHueSlider = function (e) {
	        var hueRect = this.spectrumHueRect;
	        if (hueRect) {
	            var slider = this.spectrumHueSlider;
	            var sliderRect = slider.getBoundingClientRect();
	            var x = e.clientX - hueRect.left;
	            x = Math.max(x, 0);
	            x = Math.min(x, hueRect.width);
	            this.H = 1 - x / hueRect.width;
	            slider.style.left = (x + sliderRect.width / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.moveAlphaSlider = function (e) {
	        var alphaRect = this.spectrumAlphaRect;
	        if (alphaRect) {
	            var slider = this.spectrumAlphaSlider;
	            var sliderRect = slider.getBoundingClientRect();
	            var x = e.clientX - alphaRect.left;
	            x = Math.max(x, 0);
	            x = Math.min(x, alphaRect.width);
	            this.A = x / alphaRect.width;
	            slider.style.left = (x + sliderRect.width / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.update = function () {
	        var color = Color.fromHSB(this.H * 360, this.S, this.B, this.A);
	        var spectrumColor = Color.fromHSB(this.H * 360, 1, 1);
	        var rgbaColor = color.toRgbaString();
	        // the recent color list needs to know color has actually changed
	        var colorPicker = this.picker;
	        var existingColor = Color.fromString(colorPicker.getValue());
	        if (existingColor.toRgbaString() !== rgbaColor) {
	            this.colorChanged = true;
	        }
	        colorPicker.setValue(rgbaColor);
	        this.spectrumColor.style.backgroundColor = spectrumColor.toRgbaString();
	        this.spectrumDragger.style.backgroundColor = rgbaColor;
	    };
	    /**
	     * @param saturation In the [0, 1] interval.
	     * @param brightness In the [0, 1] interval.
	     */
	    AgColorPanel.prototype.setSpectrumValue = function (saturation, brightness) {
	        var valRect = this.spectrumValRect || this.refreshSpectrumRect();
	        if (valRect) {
	            var dragger = this.spectrumDragger;
	            var draggerRect = dragger.getBoundingClientRect();
	            saturation = Math.max(0, saturation);
	            saturation = Math.min(1, saturation);
	            brightness = Math.max(0, brightness);
	            brightness = Math.min(1, brightness);
	            this.S = saturation;
	            this.B = brightness;
	            dragger.style.left = (saturation * valRect.width - draggerRect.width / 2) + 'px';
	            dragger.style.top = ((1 - brightness) * valRect.height - draggerRect.height / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.initRecentColors = function () {
	        var recentColors = AgColorPanel.recentColors;
	        var innerHtml = recentColors.map(function (color, index) {
	            return "<div class=\"ag-recent-color\" id=" + index + " style=\"background-color: " + color + "; width: 15px; height: 15px;\" recent-color=\"" + color + "\"></div>";
	        });
	        this.recentColors.innerHTML = innerHtml.join('');
	    };
	    AgColorPanel.prototype.setValue = function (val) {
	        var color = Color.fromString(val);
	        var _a = color.toHSB(), h = _a[0], s = _a[1], b = _a[2];
	        this.H = (isNaN(h) ? 0 : h) / 360;
	        this.A = color.a;
	        var spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
	        var spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
	        this.spectrumHueSlider.style.left = ((this.H - 1) * -spectrumHueRect.width) + "px";
	        this.spectrumAlphaSlider.style.left = (this.A * spectrumAlphaRect.width) + "px";
	        this.setSpectrumValue(s, b);
	    };
	    AgColorPanel.prototype.onRecentColorClick = function (e) {
	        var target = e.target;
	        if (!exists(target.id)) {
	            return;
	        }
	        var id = parseInt(target.id, 10);
	        this.setValue(AgColorPanel.recentColors[id]);
	        this.destroy();
	    };
	    AgColorPanel.prototype.addRecentColor = function () {
	        var color = Color.fromHSB(this.H * 360, this.S, this.B, this.A);
	        var rgbaColor = color.toRgbaString();
	        var recentColors = AgColorPanel.recentColors;
	        if (!this.colorChanged || recentColors[0] === rgbaColor) {
	            return;
	        }
	        // remove duplicate color
	        recentColors = recentColors.filter(function (currentColor) { return currentColor != rgbaColor; });
	        // add color to head
	        recentColors = [rgbaColor].concat(recentColors);
	        // ensure we don't exceed max number of recent colors
	        if (recentColors.length > AgColorPanel.maxRecentColors) {
	            recentColors = recentColors.slice(0, AgColorPanel.maxRecentColors);
	        }
	        AgColorPanel.recentColors = recentColors;
	    };
	    AgColorPanel.prototype.destroy = function () {
	        this.addRecentColor();
	        _super.prototype.destroy.call(this);
	    };
	    AgColorPanel.maxRecentColors = 8;
	    AgColorPanel.recentColors = [];
	    AgColorPanel.TEMPLATE = "<div class=\"ag-color-panel\">\n            <div ref=\"spectrumColor\" class=\"ag-spectrum-color\">\n                <div class=\"ag-spectrum-sat ag-spectrum-fill\">\n                    <div ref=\"spectrumVal\" class=\"ag-spectrum-val ag-spectrum-fill\">\n                        <div ref=\"spectrumDragger\" class=\"ag-spectrum-dragger\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"ag-spectrum-tools\">\n                <div ref=\"spectrumHue\" class=\"ag-spectrum-hue ag-spectrum-tool\">\n                    <div class=\"ag-spectrum-hue-background\"></div>\n                    <div ref=\"spectrumHueSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"spectrumAlpha\" class=\"ag-spectrum-alpha ag-spectrum-tool\">\n                    <div class=\"ag-spectrum-alpha-background\"></div>\n                    <div ref=\"spectrumAlphaSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"recentColors\" class=\"ag-recent-colors\"></div>\n            </div>\n        </div>";
	    __decorate$1N([
	        RefSelector('spectrumColor')
	    ], AgColorPanel.prototype, "spectrumColor", void 0);
	    __decorate$1N([
	        RefSelector('spectrumVal')
	    ], AgColorPanel.prototype, "spectrumVal", void 0);
	    __decorate$1N([
	        RefSelector('spectrumDragger')
	    ], AgColorPanel.prototype, "spectrumDragger", void 0);
	    __decorate$1N([
	        RefSelector('spectrumHue')
	    ], AgColorPanel.prototype, "spectrumHue", void 0);
	    __decorate$1N([
	        RefSelector('spectrumHueSlider')
	    ], AgColorPanel.prototype, "spectrumHueSlider", void 0);
	    __decorate$1N([
	        RefSelector('spectrumAlpha')
	    ], AgColorPanel.prototype, "spectrumAlpha", void 0);
	    __decorate$1N([
	        RefSelector('spectrumAlphaSlider')
	    ], AgColorPanel.prototype, "spectrumAlphaSlider", void 0);
	    __decorate$1N([
	        RefSelector('recentColors')
	    ], AgColorPanel.prototype, "recentColors", void 0);
	    __decorate$1N([
	        PostConstruct
	    ], AgColorPanel.prototype, "postConstruct", null);
	    return AgColorPanel;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1W = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1O = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgPickerField = /** @class */ (function (_super) {
	    __extends$1W(AgPickerField, _super);
	    function AgPickerField(config, className, pickerIcon, popupRole) {
	        var _this = _super.call(this, config, 
	        /* html */ "<div class=\"ag-picker-field\" role=\"presentation\">\n                <div ref=\"eLabel\"></div>\n                <div ref=\"eWrapper\"\n                    class=\"ag-wrapper ag-picker-field-wrapper\"\n                    tabIndex=\"-1\"\n                    " + (popupRole ? "aria-haspopup=\"" + popupRole + "\"" : '') + "\n                >\n                    <div ref=\"eDisplayField\" class=\"ag-picker-field-display\"></div>\n                    <div ref=\"eIcon\" class=\"ag-picker-field-icon\" aria-hidden=\"true\"></div>\n                </div>\n            </div>", className) || this;
	        _this.pickerIcon = pickerIcon;
	        _this.isPickerDisplayed = false;
	        _this.isDestroyingPicker = false;
	        _this.skipClick = false;
	        return _this;
	    }
	    AgPickerField.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        var displayId = this.getCompId() + "-display";
	        this.eDisplayField.setAttribute('id', displayId);
	        setAriaDescribedBy(this.eWrapper, displayId);
	        var clickHandler = function () {
	            if (_this.skipClick) {
	                _this.skipClick = false;
	                return;
	            }
	            if (_this.isDisabled()) {
	                return;
	            }
	            _this.pickerComponent = _this.showPicker();
	        };
	        var eGui = this.getGui();
	        this.addManagedListener(eGui, 'mousedown', function (e) {
	            if (!_this.skipClick &&
	                _this.pickerComponent &&
	                _this.pickerComponent.isAlive() &&
	                isVisible(_this.pickerComponent.getGui()) &&
	                eGui.contains(e.target)) {
	                _this.skipClick = true;
	            }
	        });
	        this.addManagedListener(eGui, 'keydown', function (e) {
	            switch (e.keyCode) {
	                case KeyCode.UP:
	                case KeyCode.DOWN:
	                case KeyCode.ENTER:
	                case KeyCode.SPACE:
	                    clickHandler();
	                case KeyCode.ESCAPE:
	                    if (_this.isPickerDisplayed) {
	                        e.preventDefault();
	                    }
	                    break;
	            }
	        });
	        this.addManagedListener(this.eWrapper, 'click', clickHandler);
	        this.addManagedListener(this.eLabel, 'click', clickHandler);
	        if (this.pickerIcon) {
	            var icon = createIconNoSpan(this.pickerIcon, this.gridOptionsWrapper);
	            if (icon) {
	                this.eIcon.appendChild(icon);
	            }
	        }
	    };
	    AgPickerField.prototype.refreshLabel = function () {
	        if (exists(this.getLabel())) {
	            setAriaLabelledBy(this.eWrapper, this.getLabelId());
	        }
	        else {
	            this.eWrapper.removeAttribute('aria-labelledby');
	        }
	        _super.prototype.refreshLabel.call(this);
	    };
	    AgPickerField.prototype.setAriaLabel = function (label) {
	        setAriaLabel(this.eWrapper, label);
	        return this;
	    };
	    AgPickerField.prototype.setInputWidth = function (width) {
	        setElementWidth(this.eWrapper, width);
	        return this;
	    };
	    AgPickerField.prototype.getFocusableElement = function () {
	        return this.eWrapper;
	    };
	    __decorate$1O([
	        RefSelector('eLabel')
	    ], AgPickerField.prototype, "eLabel", void 0);
	    __decorate$1O([
	        RefSelector('eWrapper')
	    ], AgPickerField.prototype, "eWrapper", void 0);
	    __decorate$1O([
	        RefSelector('eDisplayField')
	    ], AgPickerField.prototype, "eDisplayField", void 0);
	    __decorate$1O([
	        RefSelector('eIcon')
	    ], AgPickerField.prototype, "eIcon", void 0);
	    return AgPickerField;
	}(AgAbstractField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1X = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgColorPicker = /** @class */ (function (_super) {
	    __extends$1X(AgColorPicker, _super);
	    function AgColorPicker(config) {
	        var _this = _super.call(this, config, 'ag-color-picker', 'colorPicker') || this;
	        if (config && config.color) {
	            _this.value = config.color;
	        }
	        return _this;
	    }
	    AgColorPicker.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        if (this.value) {
	            this.setValue(this.value);
	        }
	    };
	    AgColorPicker.prototype.showPicker = function () {
	        var _this = this;
	        var eGuiRect = this.getGui().getBoundingClientRect();
	        var colorDialog = this.createBean(new AgDialog({
	            closable: false,
	            modal: true,
	            hideTitleBar: true,
	            minWidth: 190,
	            width: 190,
	            height: 250,
	            x: eGuiRect.right - 190,
	            y: eGuiRect.top - 250
	        }));
	        this.isPickerDisplayed = true;
	        addCssClass(colorDialog.getGui(), 'ag-color-dialog');
	        var colorPanel = this.createBean(new AgColorPanel({ picker: this }));
	        colorPanel.addDestroyFunc(function () {
	            if (colorDialog.isAlive()) {
	                _this.destroyBean(colorDialog);
	            }
	        });
	        colorDialog.setParentComponent(this);
	        colorDialog.setBodyComponent(colorPanel);
	        colorPanel.setValue(this.getValue());
	        colorDialog.addDestroyFunc(function () {
	            // here we check if the picker was already being
	            // destroyed to avoid a stack overflow
	            if (!_this.isDestroyingPicker) {
	                _this.isDestroyingPicker = true;
	                if (colorPanel.isAlive()) {
	                    _this.destroyBean(colorPanel);
	                }
	            }
	            else {
	                _this.isDestroyingPicker = false;
	            }
	            if (_this.isAlive()) {
	                _this.getFocusableElement().focus();
	            }
	            _this.isPickerDisplayed = false;
	        });
	        return colorDialog;
	    };
	    AgColorPicker.prototype.setValue = function (color) {
	        if (this.value === color) {
	            return this;
	        }
	        this.eDisplayField.style.backgroundColor = color;
	        return _super.prototype.setValue.call(this, color);
	    };
	    AgColorPicker.prototype.getValue = function () {
	        return this.value;
	    };
	    return AgColorPicker;
	}(AgPickerField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1Y = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgInputNumberField = /** @class */ (function (_super) {
	    __extends$1Y(AgInputNumberField, _super);
	    function AgInputNumberField(config) {
	        return _super.call(this, config, 'ag-number-field', 'number') || this;
	    }
	    AgInputNumberField.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.addManagedListener(this.eInput, 'blur', function () {
	            var floatedValue = parseFloat(_this.eInput.value);
	            var value = isNaN(floatedValue) ? '' : _this.normalizeValue(floatedValue.toString());
	            if (_this.value !== value) {
	                _this.setValue(value);
	            }
	        });
	    };
	    AgInputNumberField.prototype.normalizeValue = function (value) {
	        if (value === '') {
	            return '';
	        }
	        if (this.precision) {
	            value = this.adjustPrecision(value);
	        }
	        var val = parseFloat(value);
	        if (this.min != null && val < this.min) {
	            value = this.min.toString();
	        }
	        else if (this.max != null && val > this.max) {
	            value = this.max.toString();
	        }
	        return value;
	    };
	    AgInputNumberField.prototype.adjustPrecision = function (value) {
	        if (this.precision) {
	            var floatString = parseFloat(value).toFixed(this.precision);
	            value = parseFloat(floatString).toString();
	        }
	        return value;
	    };
	    AgInputNumberField.prototype.setMin = function (min) {
	        if (this.min === min) {
	            return this;
	        }
	        this.min = min;
	        addOrRemoveAttribute(this.eInput, 'min', min);
	        return this;
	    };
	    AgInputNumberField.prototype.setMax = function (max) {
	        if (this.max === max) {
	            return this;
	        }
	        this.max = max;
	        addOrRemoveAttribute(this.eInput, 'max', max);
	        return this;
	    };
	    AgInputNumberField.prototype.setPrecision = function (precision) {
	        this.precision = precision;
	        return this;
	    };
	    AgInputNumberField.prototype.setStep = function (step) {
	        if (this.step === step) {
	            return this;
	        }
	        this.step = step;
	        addOrRemoveAttribute(this.eInput, 'step', step);
	        return this;
	    };
	    AgInputNumberField.prototype.setValue = function (value, silent) {
	        value = this.adjustPrecision(value);
	        var normalizedValue = this.normalizeValue(value);
	        if (value != normalizedValue) {
	            return this;
	        }
	        return _super.prototype.setValue.call(this, value, silent);
	    };
	    return AgInputNumberField;
	}(AgInputTextField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1Z = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgInputRange = /** @class */ (function (_super) {
	    __extends$1Z(AgInputRange, _super);
	    function AgInputRange(config) {
	        return _super.call(this, config, 'ag-range-field', 'range') || this;
	    }
	    AgInputRange.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        var _a = this.config, min = _a.min, max = _a.max, step = _a.step;
	        if (min != null) {
	            this.setMinValue(min);
	        }
	        if (max != null) {
	            this.setMaxValue(max);
	        }
	        this.setStep(step || 1);
	    };
	    AgInputRange.prototype.addInputListeners = function () {
	        var _this = this;
	        var isIE = isBrowserIE();
	        var eventName = isIE ? 'change' : 'input';
	        this.addManagedListener(this.eInput, eventName, function (e) {
	            var value = e.target.value;
	            _this.setValue(value);
	        });
	    };
	    AgInputRange.prototype.setMinValue = function (value) {
	        this.min = value;
	        this.eInput.setAttribute('min', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setMaxValue = function (value) {
	        this.max = value;
	        this.eInput.setAttribute('max', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setStep = function (value) {
	        this.eInput.setAttribute('step', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setValue = function (value, silent) {
	        if (this.min != null) {
	            value = Math.max(parseFloat(value), this.min).toString();
	        }
	        if (this.max != null) {
	            value = Math.min(parseFloat(value), this.max).toString();
	        }
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    return AgInputRange;
	}(AgAbstractInputField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1_ = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1P = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgList = /** @class */ (function (_super) {
	    __extends$1_(AgList, _super);
	    function AgList(cssIdentifier) {
	        if (cssIdentifier === void 0) { cssIdentifier = 'default'; }
	        var _this = _super.call(this, /* html */ "<div class=\"ag-list ag-" + cssIdentifier + "-list\" role=\"listbox\"></div>") || this;
	        _this.cssIdentifier = cssIdentifier;
	        _this.options = [];
	        _this.itemEls = [];
	        return _this;
	    }
	    AgList.prototype.init = function () {
	        this.addManagedListener(this.getGui(), 'keydown', this.handleKeyDown.bind(this));
	    };
	    AgList.prototype.handleKeyDown = function (e) {
	        var key = e.keyCode;
	        switch (key) {
	            case KeyCode.ENTER:
	                if (!this.highlightedEl) {
	                    this.setValue(this.getValue());
	                }
	                else {
	                    var pos = this.itemEls.indexOf(this.highlightedEl);
	                    this.setValueByIndex(pos);
	                }
	                break;
	            case KeyCode.DOWN:
	            case KeyCode.UP:
	                var isDown = key === KeyCode.DOWN;
	                var itemToHighlight = void 0;
	                e.preventDefault();
	                if (!this.highlightedEl) {
	                    itemToHighlight = this.itemEls[isDown ? 0 : this.itemEls.length - 1];
	                }
	                else {
	                    var currentIdx = this.itemEls.indexOf(this.highlightedEl);
	                    var nextPos = currentIdx + (isDown ? 1 : -1);
	                    nextPos = Math.min(Math.max(nextPos, 0), this.itemEls.length - 1);
	                    itemToHighlight = this.itemEls[nextPos];
	                }
	                this.highlightItem(itemToHighlight);
	                break;
	        }
	    };
	    AgList.prototype.addOptions = function (listOptions) {
	        var _this = this;
	        listOptions.forEach(function (listOption) { return _this.addOption(listOption); });
	        return this;
	    };
	    AgList.prototype.addOption = function (listOption) {
	        var value = listOption.value, text = listOption.text;
	        var sanitisedText = escapeString(text || value);
	        this.options.push({ value: value, text: sanitisedText });
	        this.renderOption(value, sanitisedText);
	        return this;
	    };
	    AgList.prototype.renderOption = function (value, text) {
	        var _this = this;
	        var itemEl = document.createElement('div');
	        itemEl.setAttribute('role', 'option');
	        addCssClass(itemEl, 'ag-list-item');
	        addCssClass(itemEl, "ag-" + this.cssIdentifier + "-list-item");
	        itemEl.innerHTML = "<span>" + text + "</span>";
	        itemEl.tabIndex = -1;
	        this.itemEls.push(itemEl);
	        this.addManagedListener(itemEl, 'mouseover', function () { return _this.highlightItem(itemEl); });
	        this.addManagedListener(itemEl, 'mouseleave', function () { return _this.clearHighlighted(); });
	        this.addManagedListener(itemEl, 'click', function () { return _this.setValue(value); });
	        this.getGui().appendChild(itemEl);
	    };
	    AgList.prototype.setValue = function (value, silent) {
	        if (this.value === value) {
	            this.fireItemSelected();
	            return this;
	        }
	        if (value == null) {
	            this.reset();
	            return this;
	        }
	        var idx = findIndex(this.options, function (option) { return option.value === value; });
	        if (idx !== -1) {
	            var option = this.options[idx];
	            this.value = option.value;
	            this.displayValue = option.text != null ? option.text : option.value;
	            this.highlightItem(this.itemEls[idx]);
	            if (!silent) {
	                this.fireChangeEvent();
	            }
	        }
	        return this;
	    };
	    AgList.prototype.setValueByIndex = function (idx) {
	        return this.setValue(this.options[idx].value);
	    };
	    AgList.prototype.getValue = function () {
	        return this.value;
	    };
	    AgList.prototype.getDisplayValue = function () {
	        return this.displayValue;
	    };
	    AgList.prototype.refreshHighlighted = function () {
	        var _this = this;
	        this.clearHighlighted();
	        var idx = findIndex(this.options, function (option) { return option.value === _this.value; });
	        if (idx !== -1) {
	            this.highlightItem(this.itemEls[idx]);
	        }
	    };
	    AgList.prototype.reset = function () {
	        this.value = null;
	        this.displayValue = null;
	        this.clearHighlighted();
	        this.fireChangeEvent();
	    };
	    AgList.prototype.highlightItem = function (el) {
	        if (!el.offsetParent) {
	            return;
	        }
	        this.clearHighlighted();
	        this.highlightedEl = el;
	        addCssClass(this.highlightedEl, AgList.ACTIVE_CLASS);
	        setAriaSelected(this.highlightedEl, true);
	        this.highlightedEl.focus();
	    };
	    AgList.prototype.clearHighlighted = function () {
	        if (!this.highlightedEl || !this.highlightedEl.offsetParent) {
	            return;
	        }
	        removeCssClass(this.highlightedEl, AgList.ACTIVE_CLASS);
	        setAriaSelected(this.highlightedEl, false);
	        this.highlightedEl = null;
	    };
	    AgList.prototype.fireChangeEvent = function () {
	        this.dispatchEvent({ type: AgAbstractField.EVENT_CHANGED });
	        this.fireItemSelected();
	    };
	    AgList.prototype.fireItemSelected = function () {
	        this.dispatchEvent({ type: AgList.EVENT_ITEM_SELECTED });
	    };
	    AgList.EVENT_ITEM_SELECTED = 'selectedItem';
	    AgList.ACTIVE_CLASS = 'ag-active-item';
	    __decorate$1P([
	        PostConstruct
	    ], AgList.prototype, "init", null);
	    return AgList;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$1$ = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1Q = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgSelect = /** @class */ (function (_super) {
	    __extends$1$(AgSelect, _super);
	    function AgSelect(config) {
	        return _super.call(this, config, 'ag-select', 'smallDown', 'listbox') || this;
	    }
	    AgSelect.prototype.init = function () {
	        var _this = this;
	        this.listComponent = this.createBean(new AgList('select'));
	        this.listComponent.setParentComponent(this);
	        this.eWrapper.tabIndex = 0;
	        this.listComponent.addManagedListener(this.listComponent, AgList.EVENT_ITEM_SELECTED, function () { if (_this.hideList) {
	            _this.hideList();
	        } });
	        this.listComponent.addManagedListener(this.listComponent, AgAbstractField.EVENT_CHANGED, function () {
	            _this.setValue(_this.listComponent.getValue(), false, true);
	            if (_this.hideList) {
	                _this.hideList();
	            }
	        });
	    };
	    AgSelect.prototype.showPicker = function () {
	        var _this = this;
	        var listGui = this.listComponent.getGui();
	        var destroyMouseWheelFunc = this.addManagedListener(document.body, 'wheel', function (e) {
	            if (!listGui.contains(e.target) && _this.hideList) {
	                _this.hideList();
	            }
	        });
	        var destroyFocusOutFunc = this.addManagedListener(listGui, 'focusout', function (e) {
	            if (!listGui.contains(e.relatedTarget) && _this.hideList) {
	                _this.hideList();
	            }
	        });
	        var addPopupRes = this.popupService.addPopup({
	            modal: true,
	            eChild: listGui,
	            closeOnEsc: true,
	            closedCallback: function () {
	                _this.hideList = null;
	                _this.isPickerDisplayed = false;
	                destroyFocusOutFunc();
	                destroyMouseWheelFunc();
	                if (_this.isAlive()) {
	                    _this.getFocusableElement().focus();
	                }
	            }
	        });
	        if (addPopupRes) {
	            this.hideList = addPopupRes.hideFunc;
	        }
	        this.isPickerDisplayed = true;
	        setElementWidth(listGui, getAbsoluteWidth(this.eWrapper));
	        listGui.style.maxHeight = getInnerHeight(this.popupService.getPopupParent()) + 'px';
	        listGui.style.position = 'absolute';
	        this.popupService.positionPopupUnderComponent({
	            type: 'ag-list',
	            eventSource: this.eWrapper,
	            ePopup: listGui,
	            keepWithinBounds: true
	        });
	        this.listComponent.refreshHighlighted();
	        return this.listComponent;
	    };
	    AgSelect.prototype.addOptions = function (options) {
	        var _this = this;
	        options.forEach(function (option) { return _this.addOption(option); });
	        return this;
	    };
	    AgSelect.prototype.addOption = function (option) {
	        this.listComponent.addOption(option);
	        return this;
	    };
	    AgSelect.prototype.setValue = function (value, silent, fromPicker) {
	        if (this.value === value) {
	            return this;
	        }
	        if (!fromPicker) {
	            this.listComponent.setValue(value, true);
	        }
	        var newValue = this.listComponent.getValue();
	        if (newValue === this.getValue()) {
	            return this;
	        }
	        this.eDisplayField.innerHTML = this.listComponent.getDisplayValue();
	        return _super.prototype.setValue.call(this, value, silent);
	    };
	    AgSelect.prototype.destroy = function () {
	        if (this.hideList) {
	            this.hideList();
	        }
	        this.destroyBean(this.listComponent);
	        _super.prototype.destroy.call(this);
	    };
	    __decorate$1Q([
	        Autowired('popupService')
	    ], AgSelect.prototype, "popupService", void 0);
	    __decorate$1Q([
	        PostConstruct
	    ], AgSelect.prototype, "init", null);
	    return AgSelect;
	}(AgPickerField));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$20 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1R = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgAngleSelect = /** @class */ (function (_super) {
	    __extends$20(AgAngleSelect, _super);
	    function AgAngleSelect(config) {
	        var _this = _super.call(this, config, AgAngleSelect.TEMPLATE) || this;
	        _this.radius = 0;
	        _this.offsetX = 0;
	        _this.offsetY = 0;
	        return _this;
	    }
	    AgAngleSelect.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.dragListener = {
	            eElement: this.eParentCircle,
	            dragStartPixels: 0,
	            onDragStart: function (e) {
	                _this.parentCircleRect = _this.eParentCircle.getBoundingClientRect();
	            },
	            onDragging: function (e) { return _this.calculateAngleDrag(e); },
	            onDragStop: function () { }
	        };
	        this.dragService.addDragSource(this.dragListener);
	        this.eAngleValue
	            .setLabel('')
	            .setLabelWidth(5)
	            .setInputWidth(45)
	            .setMin(0)
	            .setMax(360)
	            .setValue("" + this.degrees)
	            .onValueChange(function (value) {
	            if (value == null || value === '') {
	                value = '0';
	            }
	            value = _this.eAngleValue.normalizeValue(value);
	            var floatValue = parseFloat(value);
	            if (floatValue > 180) {
	                floatValue = floatValue - 360;
	            }
	            _this.setValue(floatValue);
	        });
	        this.updateNumberInput();
	        if (exists(this.getValue())) {
	            this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
	        }
	        this.addManagedListener(this, AgAbstractField.EVENT_CHANGED, function () {
	            if (_this.eAngleValue.getInputElement().contains(document.activeElement)) {
	                return;
	            }
	            _this.updateNumberInput();
	        });
	    };
	    AgAngleSelect.prototype.updateNumberInput = function () {
	        var normalizedValue = this.normalizeNegativeValue(this.getValue());
	        this.eAngleValue.setValue(normalizedValue.toString());
	    };
	    AgAngleSelect.prototype.positionChildCircle = function (radians) {
	        var rect = this.parentCircleRect || { width: 24, height: 24 };
	        var eChildCircle = this.eChildCircle;
	        var centerX = rect.width / 2;
	        var centerY = rect.height / 2;
	        eChildCircle.style.left = centerX + Math.cos(radians) * 8 + "px";
	        eChildCircle.style.top = centerY + Math.sin(radians) * 8 + "px";
	    };
	    AgAngleSelect.prototype.calculatePolar = function () {
	        var x = this.offsetX;
	        var y = this.offsetY;
	        var radians = Math.atan2(y, x);
	        this.degrees = this.toDegrees(radians);
	        this.radius = Math.sqrt((x * x) + (y * y));
	        this.positionChildCircle(radians);
	    };
	    AgAngleSelect.prototype.calculateCartesian = function () {
	        var radians = this.toRadians(this.getValue());
	        var radius = this.getRadius();
	        this
	            .setOffsetX(Math.cos(radians) * radius)
	            .setOffsetY(Math.sin(radians) * radius);
	    };
	    AgAngleSelect.prototype.setOffsetX = function (offset) {
	        if (this.offsetX !== offset) {
	            this.offsetX = offset;
	            this.calculatePolar();
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.setOffsetY = function (offset) {
	        if (this.offsetY !== offset) {
	            this.offsetY = offset;
	            this.calculatePolar();
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.calculateAngleDrag = function (e) {
	        var rect = this.parentCircleRect;
	        var centerX = rect.width / 2;
	        var centerY = rect.height / 2;
	        var x = e.clientX - rect.left;
	        var y = e.clientY - rect.top;
	        var dx = x - centerX;
	        var dy = y - centerY;
	        var radians = Math.atan2(dy, dx);
	        this.setValue(radians, true);
	    };
	    AgAngleSelect.prototype.toDegrees = function (radians) {
	        return radians / Math.PI * 180;
	    };
	    AgAngleSelect.prototype.toRadians = function (degrees) {
	        return degrees / 180 * Math.PI;
	    };
	    AgAngleSelect.prototype.normalizeNegativeValue = function (degrees) {
	        return degrees < 0 ? 360 + degrees : degrees;
	    };
	    AgAngleSelect.prototype.normalizeAngle180 = function (radians) {
	        radians %= Math.PI * 2;
	        if (radians < -Math.PI) {
	            radians += Math.PI * 2;
	        }
	        else if (radians >= Math.PI) {
	            radians -= Math.PI * 2;
	        }
	        return radians;
	    };
	    AgAngleSelect.prototype.getRadius = function () {
	        return this.radius;
	    };
	    AgAngleSelect.prototype.setRadius = function (r) {
	        if (this.radius === r) {
	            return this;
	        }
	        this.radius = r;
	        this.calculateCartesian();
	        return this;
	    };
	    AgAngleSelect.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        this.addManagedListener(this, AgAbstractField.EVENT_CHANGED, function () {
	            callbackFn(_this.degrees);
	        });
	        return this;
	    };
	    AgAngleSelect.prototype.getValue = function (radians) {
	        return radians ? this.toRadians(this.degrees) : this.degrees;
	    };
	    AgAngleSelect.prototype.setValue = function (degrees, radians) {
	        var radiansValue;
	        if (!radians) {
	            radiansValue = this.normalizeAngle180(this.toRadians(degrees));
	        }
	        else {
	            radiansValue = degrees;
	        }
	        degrees = this.toDegrees(radiansValue);
	        if (this.degrees !== degrees) {
	            this.degrees = Math.floor(degrees);
	            this.calculateCartesian();
	            this.positionChildCircle(radiansValue);
	            this.dispatchEvent({ type: AgAbstractField.EVENT_CHANGED });
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.setWidth = function (width) {
	        setFixedWidth(this.getGui(), width);
	        return this;
	    };
	    AgAngleSelect.prototype.destroy = function () {
	        this.dragService.removeDragSource(this.dragListener);
	        _super.prototype.destroy.call(this);
	    };
	    AgAngleSelect.TEMPLATE = "<div class=\"ag-angle-select\">\n            <div ref=\"eLabel\"></div>\n            <div class=\"ag-wrapper ag-angle-select-wrapper\">\n                <div ref=\"eAngleSelectField\" class=\"ag-angle-select-field\">\n                    <div ref=\"eParentCircle\" class=\"ag-angle-select-parent-circle\">\n                        <div ref=\"eChildCircle\" class=\"ag-angle-select-child-circle\"></div>\n                    </div>\n                </div>\n                <ag-input-number-field ref=\"eAngleValue\"></ag-input-number-field>\n            </div>\n        </div>";
	    __decorate$1R([
	        RefSelector('eLabel')
	    ], AgAngleSelect.prototype, "eLabel", void 0);
	    __decorate$1R([
	        RefSelector('eParentCircle')
	    ], AgAngleSelect.prototype, "eParentCircle", void 0);
	    __decorate$1R([
	        RefSelector('eChildCircle')
	    ], AgAngleSelect.prototype, "eChildCircle", void 0);
	    __decorate$1R([
	        RefSelector('eAngleValue')
	    ], AgAngleSelect.prototype, "eAngleValue", void 0);
	    __decorate$1R([
	        Autowired('dragService')
	    ], AgAngleSelect.prototype, "dragService", void 0);
	    return AgAngleSelect;
	}(AgAbstractLabel));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$21 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var AgToggleButton = /** @class */ (function (_super) {
	    __extends$21(AgToggleButton, _super);
	    function AgToggleButton(config) {
	        return _super.call(this, config, 'ag-toggle-button') || this;
	    }
	    AgToggleButton.prototype.setValue = function (value, silent) {
	        _super.prototype.setValue.call(this, value, silent);
	        addOrRemoveCssClass(this.getGui(), 'ag-selected', this.getValue());
	        return this;
	    };
	    return AgToggleButton;
	}(AgCheckbox));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$22 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1S = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	/**
	 * For Master Detail, it is required to keep components between expanding & collapsing parents.
	 * For example a user expands row A (and shows a detail grid for this row), then when row A
	 * is closed, we want to keep the detail grid, so next time row A is expanded the detail grid
	 * is showed with it's context intact, eg if user sorted in the detail grid, that sort should
	 * still be applied after the detail grid is shown for the second time.
	 */
	var DetailRowCompCache = /** @class */ (function (_super) {
	    __extends$22(DetailRowCompCache, _super);
	    function DetailRowCompCache() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cacheItems = [];
	        return _this;
	    }
	    DetailRowCompCache.prototype.postConstruct = function () {
	        this.active = this.gridOptionsWrapper.isKeepDetailRows();
	        this.maxCacheSize = this.gridOptionsWrapper.getKeepDetailRowsCount();
	    };
	    DetailRowCompCache.prototype.addOrDestroy = function (rowNode, pinned, comp) {
	        // only accept detail rows
	        var doNotUseCache = !this.active || !rowNode.detail;
	        if (doNotUseCache) {
	            this.destroyFullWidthRow(comp);
	            return;
	        }
	        var item = this.getCacheItem(rowNode, true);
	        // put the comp in the right location of the item.
	        // we also destroy any previous comp - this should never happen
	        // as the logic outside of this class shouldn't be adding same item to the
	        // cache twice, however we cater for it in case in future releases code
	        // outside of this class is changed and this could happen.
	        switch (pinned) {
	            case Constants.PINNED_LEFT:
	                this.destroyFullWidthRow(item.left);
	                item.left = comp;
	                break;
	            case Constants.PINNED_RIGHT:
	                this.destroyFullWidthRow(item.right);
	                item.right = comp;
	                break;
	            default:
	                this.destroyFullWidthRow(item.center);
	                item.center = comp;
	                break;
	        }
	        this.cacheItems.sort(function (a, b) {
	            return b.lastAccessedTime - a.lastAccessedTime;
	        });
	        this.purgeCache(this.maxCacheSize);
	    };
	    DetailRowCompCache.prototype.getCacheItem = function (rowNode, autoCreate) {
	        if (autoCreate === void 0) { autoCreate = false; }
	        var res = null;
	        for (var i = 0; i < this.cacheItems.length; i++) {
	            var item = this.cacheItems[i];
	            if (item.rowNode === rowNode) {
	                res = item;
	                break;
	            }
	        }
	        if (!res && autoCreate) {
	            res = {
	                rowNode: rowNode
	            };
	            this.cacheItems.push(res);
	        }
	        if (res) {
	            this.stampCacheItem(res);
	        }
	        return res;
	    };
	    DetailRowCompCache.prototype.stampCacheItem = function (item) {
	        item.lastAccessedTime = new Date().getTime();
	    };
	    DetailRowCompCache.prototype.destroyFullWidthRow = function (comp) {
	        this.getContext().destroyBean(comp);
	    };
	    DetailRowCompCache.prototype.purgeCache = function (startIndex) {
	        // delete all rows past the index of interest
	        for (var i = startIndex; i < this.cacheItems.length; i++) {
	            var item = this.cacheItems[i];
	            this.destroyFullWidthRow(item.center);
	            this.destroyFullWidthRow(item.left);
	            this.destroyFullWidthRow(item.right);
	        }
	        // change the length of the array so it no longer contains the deleted items
	        if (this.cacheItems.length > startIndex) {
	            this.cacheItems.length = startIndex;
	        }
	    };
	    DetailRowCompCache.prototype.get = function (rowNode, pinned) {
	        if (!rowNode.detail) {
	            return;
	        }
	        var item = this.getCacheItem(rowNode);
	        var res;
	        if (item) {
	            switch (pinned) {
	                case Constants.PINNED_LEFT:
	                    if (item.left) {
	                        res = item.left;
	                        item.left = undefined;
	                    }
	                    break;
	                case Constants.PINNED_RIGHT:
	                    if (item.right) {
	                        res = item.right;
	                        item.right = undefined;
	                    }
	                    break;
	                default:
	                    if (item.center) {
	                        res = item.center;
	                        item.center = undefined;
	                    }
	                    break;
	            }
	        }
	        return res;
	    };
	    DetailRowCompCache.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.purgeCache(0);
	    };
	    __decorate$1S([
	        PostConstruct
	    ], DetailRowCompCache.prototype, "postConstruct", null);
	    __decorate$1S([
	        PreDestroy
	    ], DetailRowCompCache.prototype, "destroy", null);
	    DetailRowCompCache = __decorate$1S([
	        Bean('detailRowCompCache')
	    ], DetailRowCompCache);
	    return DetailRowCompCache;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$23 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1T = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var RowPositionUtils = /** @class */ (function (_super) {
	    __extends$23(RowPositionUtils, _super);
	    function RowPositionUtils() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    RowPositionUtils.prototype.getFirstRow = function () {
	        var rowIndex = 0;
	        var rowPinned;
	        if (this.pinnedRowModel.getPinnedTopRowCount()) {
	            rowPinned = Constants.PINNED_TOP;
	        }
	        else if (this.rowModel.getRowCount()) {
	            rowPinned = null;
	            rowIndex = this.paginationProxy.getPageFirstRow();
	        }
	        else if (this.pinnedRowModel.getPinnedBottomRowCount()) {
	            rowPinned = Constants.PINNED_BOTTOM;
	        }
	        return rowPinned === undefined ? null : { rowIndex: rowIndex, rowPinned: rowPinned };
	    };
	    RowPositionUtils.prototype.getLastRow = function () {
	        var rowIndex;
	        var rowPinned = null;
	        var pinnedBottomCount = this.pinnedRowModel.getPinnedBottomRowCount();
	        var pinnedTopCount = this.pinnedRowModel.getPinnedTopRowCount();
	        if (pinnedBottomCount) {
	            rowPinned = Constants.PINNED_BOTTOM;
	            rowIndex = pinnedBottomCount - 1;
	        }
	        else if (this.rowModel.getRowCount()) {
	            rowPinned = null;
	            rowIndex = this.paginationProxy.getPageLastRow();
	        }
	        else if (pinnedTopCount) {
	            rowPinned = Constants.PINNED_TOP;
	            rowIndex = pinnedTopCount - 1;
	        }
	        return rowIndex === undefined ? null : { rowIndex: rowIndex, rowPinned: rowPinned };
	    };
	    RowPositionUtils.prototype.getRowNode = function (gridRow) {
	        switch (gridRow.rowPinned) {
	            case Constants.PINNED_TOP:
	                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
	            case Constants.PINNED_BOTTOM:
	                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
	            default:
	                return this.rowModel.getRow(gridRow.rowIndex);
	        }
	    };
	    RowPositionUtils.prototype.sameRow = function (rowA, rowB) {
	        // if both missing
	        if (!rowA && !rowB) {
	            return true;
	        }
	        // if only one missing
	        if ((rowA && !rowB) || (!rowA && rowB)) {
	            return false;
	        }
	        // otherwise compare (use == to compare rowPinned because it can be null or undefined)
	        return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
	    };
	    // tests if this row selection is before the other row selection
	    RowPositionUtils.prototype.before = function (rowA, rowB) {
	        switch (rowA.rowPinned) {
	            case Constants.PINNED_TOP:
	                // we we are floating top, and other isn't, then we are always before
	                if (rowB.rowPinned !== Constants.PINNED_TOP) {
	                    return true;
	                }
	                break;
	            case Constants.PINNED_BOTTOM:
	                // if we are floating bottom, and the other isn't, then we are never before
	                if (rowB.rowPinned !== Constants.PINNED_BOTTOM) {
	                    return false;
	                }
	                break;
	            default:
	                // if we are not floating, but the other one is floating...
	                if (exists(rowB.rowPinned)) {
	                    return rowB.rowPinned !== Constants.PINNED_TOP;
	                }
	                break;
	        }
	        return rowA.rowIndex < rowB.rowIndex;
	    };
	    __decorate$1T([
	        Autowired('rowModel')
	    ], RowPositionUtils.prototype, "rowModel", void 0);
	    __decorate$1T([
	        Autowired('pinnedRowModel')
	    ], RowPositionUtils.prototype, "pinnedRowModel", void 0);
	    __decorate$1T([
	        Autowired('paginationProxy')
	    ], RowPositionUtils.prototype, "paginationProxy", void 0);
	    RowPositionUtils = __decorate$1T([
	        Bean('rowPositionUtils')
	    ], RowPositionUtils);
	    return RowPositionUtils;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$24 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1U = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var CellPositionUtils = /** @class */ (function (_super) {
	    __extends$24(CellPositionUtils, _super);
	    function CellPositionUtils() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CellPositionUtils.prototype.createId = function (cellPosition) {
	        var rowIndex = cellPosition.rowIndex, rowPinned = cellPosition.rowPinned, column = cellPosition.column;
	        return this.createIdFromValues(rowIndex, column, rowPinned);
	    };
	    CellPositionUtils.prototype.createIdFromValues = function (rowIndex, column, rowPinned) {
	        return rowIndex + "." + (rowPinned == null ? 'null' : rowPinned) + "." + column.getId();
	    };
	    CellPositionUtils.prototype.equals = function (cellA, cellB) {
	        var colsMatch = cellA.column === cellB.column;
	        var floatingMatch = cellA.rowPinned === cellB.rowPinned;
	        var indexMatch = cellA.rowIndex === cellB.rowIndex;
	        return colsMatch && floatingMatch && indexMatch;
	    };
	    CellPositionUtils = __decorate$1U([
	        Bean('cellPositionUtils')
	    ], CellPositionUtils);
	    return CellPositionUtils;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$25 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1V = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var PinnedRowModel = /** @class */ (function (_super) {
	    __extends$25(PinnedRowModel, _super);
	    function PinnedRowModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PinnedRowModel.prototype.init = function () {
	        this.setPinnedTopRowData(this.gridOptionsWrapper.getPinnedTopRowData());
	        this.setPinnedBottomRowData(this.gridOptionsWrapper.getPinnedBottomRowData());
	    };
	    PinnedRowModel.prototype.isEmpty = function (floating) {
	        var rows = floating === Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
	        return missingOrEmpty(rows);
	    };
	    PinnedRowModel.prototype.isRowsToRender = function (floating) {
	        return !this.isEmpty(floating);
	    };
	    PinnedRowModel.prototype.getRowAtPixel = function (pixel, floating) {
	        var rows = floating === Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
	        if (missingOrEmpty(rows)) {
	            return 0; // this should never happen, just in case, 0 is graceful failure
	        }
	        for (var i = 0; i < rows.length; i++) {
	            var rowNode = rows[i];
	            var rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
	            // only need to range check against the top pixel, as we are going through the list
	            // in order, first row to hit the pixel wins
	            if (rowTopPixel >= pixel) {
	                return i;
	            }
	        }
	        return rows.length - 1;
	    };
	    PinnedRowModel.prototype.setPinnedTopRowData = function (rowData) {
	        this.pinnedTopRows = this.createNodesFromData(rowData, true);
	        var event = {
	            type: Events.EVENT_PINNED_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    PinnedRowModel.prototype.setPinnedBottomRowData = function (rowData) {
	        this.pinnedBottomRows = this.createNodesFromData(rowData, false);
	        var event = {
	            type: Events.EVENT_PINNED_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    PinnedRowModel.prototype.createNodesFromData = function (allData, isTop) {
	        var _this = this;
	        var rowNodes = [];
	        if (allData) {
	            var nextRowTop_1 = 0;
	            allData.forEach(function (dataItem, index) {
	                var rowNode = new RowNode();
	                _this.context.createBean(rowNode);
	                rowNode.data = dataItem;
	                var idPrefix = isTop ? RowNode.ID_PREFIX_TOP_PINNED : RowNode.ID_PREFIX_BOTTOM_PINNED;
	                rowNode.id = idPrefix + index;
	                rowNode.rowPinned = isTop ? Constants.PINNED_TOP : Constants.PINNED_BOTTOM;
	                rowNode.setRowTop(nextRowTop_1);
	                rowNode.setRowHeight(_this.gridOptionsWrapper.getRowHeightForNode(rowNode).height);
	                rowNode.setRowIndex(index);
	                nextRowTop_1 += rowNode.rowHeight;
	                rowNodes.push(rowNode);
	            });
	        }
	        return rowNodes;
	    };
	    PinnedRowModel.prototype.getPinnedTopRowData = function () {
	        return this.pinnedTopRows;
	    };
	    PinnedRowModel.prototype.getPinnedBottomRowData = function () {
	        return this.pinnedBottomRows;
	    };
	    PinnedRowModel.prototype.getPinnedTopTotalHeight = function () {
	        return this.getTotalHeight(this.pinnedTopRows);
	    };
	    PinnedRowModel.prototype.getPinnedTopRowCount = function () {
	        return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
	    };
	    PinnedRowModel.prototype.getPinnedBottomRowCount = function () {
	        return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
	    };
	    PinnedRowModel.prototype.getPinnedTopRow = function (index) {
	        return this.pinnedTopRows[index];
	    };
	    PinnedRowModel.prototype.getPinnedBottomRow = function (index) {
	        return this.pinnedBottomRows[index];
	    };
	    PinnedRowModel.prototype.forEachPinnedTopRow = function (callback) {
	        if (missingOrEmpty(this.pinnedTopRows)) {
	            return;
	        }
	        this.pinnedTopRows.forEach(callback);
	    };
	    PinnedRowModel.prototype.forEachPinnedBottomRow = function (callback) {
	        if (missingOrEmpty(this.pinnedBottomRows)) {
	            return;
	        }
	        this.pinnedBottomRows.forEach(callback);
	    };
	    PinnedRowModel.prototype.getPinnedBottomTotalHeight = function () {
	        return this.getTotalHeight(this.pinnedBottomRows);
	    };
	    PinnedRowModel.prototype.getTotalHeight = function (rowNodes) {
	        if (!rowNodes || rowNodes.length === 0) {
	            return 0;
	        }
	        var lastNode = last(rowNodes);
	        return lastNode.rowTop + lastNode.rowHeight;
	    };
	    __decorate$1V([
	        Autowired('columnApi')
	    ], PinnedRowModel.prototype, "columnApi", void 0);
	    __decorate$1V([
	        Autowired('gridApi')
	    ], PinnedRowModel.prototype, "gridApi", void 0);
	    __decorate$1V([
	        PostConstruct
	    ], PinnedRowModel.prototype, "init", null);
	    PinnedRowModel = __decorate$1V([
	        Bean('pinnedRowModel')
	    ], PinnedRowModel);
	    return PinnedRowModel;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$26 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var UndoRedoAction = /** @class */ (function () {
	    function UndoRedoAction(cellValueChanges) {
	        this.cellValueChanges = cellValueChanges;
	    }
	    return UndoRedoAction;
	}());
	var FillUndoRedoAction = /** @class */ (function (_super) {
	    __extends$26(FillUndoRedoAction, _super);
	    function FillUndoRedoAction(cellValueChanges, initialRange, finalRange) {
	        var _this = _super.call(this, cellValueChanges) || this;
	        _this.initialRange = initialRange;
	        _this.finalRange = finalRange;
	        return _this;
	    }
	    return FillUndoRedoAction;
	}(UndoRedoAction));
	var UndoRedoStack = /** @class */ (function () {
	    function UndoRedoStack(maxStackSize) {
	        this.actionStack = [];
	        this.maxStackSize = maxStackSize ? maxStackSize : UndoRedoStack.DEFAULT_STACK_SIZE;
	        this.actionStack = new Array(this.maxStackSize);
	    }
	    UndoRedoStack.prototype.pop = function () {
	        return this.actionStack.pop();
	    };
	    UndoRedoStack.prototype.push = function (item) {
	        var shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
	        if (!shouldAddActions) {
	            return;
	        }
	        if (this.actionStack.length === this.maxStackSize) {
	            this.actionStack.shift();
	        }
	        this.actionStack.push(item);
	    };
	    UndoRedoStack.prototype.clear = function () {
	        this.actionStack = [];
	    };
	    UndoRedoStack.prototype.getCurrentStackSize = function () {
	        return this.actionStack.length;
	    };
	    UndoRedoStack.DEFAULT_STACK_SIZE = 10;
	    return UndoRedoStack;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$27 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1W = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var UndoRedoService = /** @class */ (function (_super) {
	    __extends$27(UndoRedoService, _super);
	    function UndoRedoService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cellValueChanges = [];
	        _this.isCellEditing = false;
	        _this.isRowEditing = false;
	        _this.isPasting = false;
	        _this.isFilling = false;
	        _this.onCellValueChanged = function (event) {
	            var shouldCaptureAction = _this.isCellEditing || _this.isRowEditing || _this.isPasting || _this.isFilling;
	            if (!shouldCaptureAction) {
	                return;
	            }
	            var rowPinned = event.rowPinned, rowIndex = event.rowIndex, column = event.column, oldValue = event.oldValue, value = event.value;
	            var cellValueChange = {
	                rowPinned: rowPinned,
	                rowIndex: rowIndex,
	                columnId: column.getColId(),
	                newValue: value,
	                oldValue: oldValue
	            };
	            _this.cellValueChanges.push(cellValueChange);
	        };
	        _this.clearStacks = function () {
	            _this.undoStack.clear();
	            _this.redoStack.clear();
	        };
	        return _this;
	    }
	    UndoRedoService.prototype.init = function () {
	        if (!this.gridOptionsWrapper.isUndoRedoCellEditing()) {
	            return;
	        }
	        var undoRedoLimit = this.gridOptionsWrapper.getUndoRedoCellEditingLimit();
	        if (undoRedoLimit <= 0) {
	            return;
	        }
	        this.undoStack = new UndoRedoStack(undoRedoLimit);
	        this.redoStack = new UndoRedoStack(undoRedoLimit);
	        this.addRowEditingListeners();
	        this.addCellEditingListeners();
	        this.addPasteListeners();
	        this.addFillListeners();
	        this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged);
	        // undo / redo is restricted to actual editing so we clear the stacks when other operations are
	        // performed that change the order of the row / cols.
	        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.clearStacks);
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_DRAG_END, this.clearStacks);
	    };
	    UndoRedoService.prototype.getCurrentUndoStackSize = function () {
	        return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
	    };
	    UndoRedoService.prototype.getCurrentRedoStackSize = function () {
	        return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
	    };
	    UndoRedoService.prototype.undo = function () {
	        if (!this.undoStack) {
	            return;
	        }
	        var undoAction = this.undoStack.pop();
	        if (!undoAction || !undoAction.cellValueChanges) {
	            return;
	        }
	        this.processAction(undoAction, function (cellValueChange) { return cellValueChange.oldValue; });
	        if (undoAction instanceof FillUndoRedoAction) {
	            this.processRangeAndCellFocus(undoAction.cellValueChanges, undoAction.initialRange);
	        }
	        else {
	            this.processRangeAndCellFocus(undoAction.cellValueChanges);
	        }
	        this.redoStack.push(undoAction);
	    };
	    UndoRedoService.prototype.redo = function () {
	        if (!this.redoStack) {
	            return;
	        }
	        var redoAction = this.redoStack.pop();
	        if (!redoAction || !redoAction.cellValueChanges) {
	            return;
	        }
	        this.processAction(redoAction, function (cellValueChange) { return cellValueChange.newValue; });
	        if (redoAction instanceof FillUndoRedoAction) {
	            this.processRangeAndCellFocus(redoAction.cellValueChanges, redoAction.finalRange);
	        }
	        else {
	            this.processRangeAndCellFocus(redoAction.cellValueChanges);
	        }
	        this.undoStack.push(redoAction);
	    };
	    UndoRedoService.prototype.processAction = function (action, valueExtractor) {
	        var _this = this;
	        action.cellValueChanges.forEach(function (cellValueChange) {
	            var rowIndex = cellValueChange.rowIndex, rowPinned = cellValueChange.rowPinned, columnId = cellValueChange.columnId;
	            var rowPosition = { rowIndex: rowIndex, rowPinned: rowPinned };
	            var currentRow = _this.getRowNode(rowPosition);
	            // checks if the row has been filtered out
	            if (!currentRow.displayed) {
	                return;
	            }
	            currentRow.setDataValue(columnId, valueExtractor(cellValueChange));
	        });
	    };
	    UndoRedoService.prototype.processRangeAndCellFocus = function (cellValueChanges, range) {
	        var lastFocusedCell;
	        if (range) {
	            var startRow = range.startRow;
	            var endRow = range.endRow;
	            lastFocusedCell = {
	                rowPinned: startRow.rowPinned,
	                rowIndex: startRow.rowIndex,
	                columnId: range.startColumn.getColId()
	            };
	            this.setLastFocusedCell(lastFocusedCell);
	            var cellRangeParams = {
	                rowStartIndex: startRow.rowIndex,
	                rowStartPinned: startRow.rowPinned,
	                rowEndIndex: endRow.rowIndex,
	                rowEndPinned: endRow.rowPinned,
	                columnStart: range.startColumn,
	                columns: range.columns
	            };
	            this.gridApi.addCellRange(cellRangeParams);
	            return;
	        }
	        var cellValueChange = cellValueChanges[0];
	        var rowIndex = cellValueChange.rowIndex, rowPinned = cellValueChange.rowPinned;
	        var rowPosition = { rowIndex: rowIndex, rowPinned: rowPinned };
	        var row = this.getRowNode(rowPosition);
	        lastFocusedCell = {
	            rowPinned: cellValueChange.rowPinned,
	            rowIndex: row.rowIndex,
	            columnId: cellValueChange.columnId
	        };
	        this.setLastFocusedCell(lastFocusedCell);
	    };
	    UndoRedoService.prototype.setLastFocusedCell = function (lastFocusedCell) {
	        var rowIndex = lastFocusedCell.rowIndex, columnId = lastFocusedCell.columnId, rowPinned = lastFocusedCell.rowPinned;
	        this.gridApi.ensureIndexVisible(rowIndex);
	        this.gridApi.ensureColumnVisible(columnId);
	        if (ModuleRegistry.isRegistered(exports.ModuleNames.RangeSelectionModule)) {
	            this.gridApi.clearRangeSelection();
	        }
	        this.focusController.setFocusedCell(rowIndex, columnId, rowPinned, true);
	    };
	    UndoRedoService.prototype.addRowEditingListeners = function () {
	        var _this = this;
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_EDITING_STARTED, function () {
	            _this.isRowEditing = true;
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_EDITING_STOPPED, function () {
	            var action = new UndoRedoAction(_this.cellValueChanges);
	            _this.pushActionsToUndoStack(action);
	            _this.isRowEditing = false;
	        });
	    };
	    UndoRedoService.prototype.addCellEditingListeners = function () {
	        var _this = this;
	        this.addManagedListener(this.eventService, Events.EVENT_CELL_EDITING_STARTED, function () {
	            _this.isCellEditing = true;
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_CELL_EDITING_STOPPED, function () {
	            _this.isCellEditing = false;
	            var shouldPushAction = !_this.isRowEditing && !_this.isPasting && !_this.isFilling;
	            if (shouldPushAction) {
	                var action = new UndoRedoAction(_this.cellValueChanges);
	                _this.pushActionsToUndoStack(action);
	            }
	        });
	    };
	    UndoRedoService.prototype.addPasteListeners = function () {
	        var _this = this;
	        this.addManagedListener(this.eventService, Events.EVENT_PASTE_START, function () {
	            _this.isPasting = true;
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_PASTE_END, function () {
	            var action = new UndoRedoAction(_this.cellValueChanges);
	            _this.pushActionsToUndoStack(action);
	            _this.isPasting = false;
	        });
	    };
	    UndoRedoService.prototype.addFillListeners = function () {
	        var _this = this;
	        this.addManagedListener(this.eventService, Events.EVENT_FILL_START, function () {
	            _this.isFilling = true;
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_FILL_END, function (event) {
	            var action = new FillUndoRedoAction(_this.cellValueChanges, event.initialRange, event.finalRange);
	            _this.pushActionsToUndoStack(action);
	            _this.isFilling = false;
	        });
	    };
	    UndoRedoService.prototype.pushActionsToUndoStack = function (action) {
	        this.undoStack.push(action);
	        this.cellValueChanges = [];
	        this.redoStack.clear();
	    };
	    UndoRedoService.prototype.getRowNode = function (gridRow) {
	        switch (gridRow.rowPinned) {
	            case Constants.PINNED_TOP:
	                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
	            case Constants.PINNED_BOTTOM:
	                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
	            default:
	                return this.rowModel.getRow(gridRow.rowIndex);
	        }
	    };
	    __decorate$1W([
	        Autowired('focusController')
	    ], UndoRedoService.prototype, "focusController", void 0);
	    __decorate$1W([
	        Autowired('gridApi')
	    ], UndoRedoService.prototype, "gridApi", void 0);
	    __decorate$1W([
	        Autowired('rowModel')
	    ], UndoRedoService.prototype, "rowModel", void 0);
	    __decorate$1W([
	        Autowired('pinnedRowModel')
	    ], UndoRedoService.prototype, "pinnedRowModel", void 0);
	    __decorate$1W([
	        PostConstruct
	    ], UndoRedoService.prototype, "init", null);
	    UndoRedoService = __decorate$1W([
	        Bean('undoRedoService')
	    ], UndoRedoService);
	    return UndoRedoService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$28 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1X = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var AgStackComponentsRegistry = /** @class */ (function (_super) {
	    __extends$28(AgStackComponentsRegistry, _super);
	    function AgStackComponentsRegistry() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.componentsMappedByName = {};
	        return _this;
	    }
	    AgStackComponentsRegistry.prototype.setupComponents = function (components) {
	        var _this = this;
	        if (components) {
	            components.forEach(function (componentMeta) { return _this.addComponent(componentMeta); });
	        }
	    };
	    AgStackComponentsRegistry.prototype.addComponent = function (componentMeta) {
	        // get name of the class as a string
	        // let className = getNameOfClass(ComponentClass);
	        // insert a dash after every capital letter
	        // let classEscaped = className.replace(/([A-Z])/g, "-$1").toLowerCase();
	        var classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
	        // put all to upper case
	        var classUpperCase = classEscaped.toUpperCase();
	        // finally store
	        this.componentsMappedByName[classUpperCase] = componentMeta.componentClass;
	    };
	    AgStackComponentsRegistry.prototype.getComponentClass = function (htmlTag) {
	        return this.componentsMappedByName[htmlTag];
	    };
	    AgStackComponentsRegistry = __decorate$1X([
	        Bean('agStackComponentsRegistry')
	    ], AgStackComponentsRegistry);
	    return AgStackComponentsRegistry;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$29 = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1Y = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HeaderPositionUtils = /** @class */ (function (_super) {
	    __extends$29(HeaderPositionUtils, _super);
	    function HeaderPositionUtils() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HeaderPositionUtils.prototype.findHeader = function (focusedHeader, direction) {
	        var nextColumn;
	        var getGroupMethod;
	        var getColMethod;
	        if (focusedHeader.column instanceof ColumnGroup) {
	            getGroupMethod = "getDisplayedGroup" + direction;
	            nextColumn = this.columnController[getGroupMethod](focusedHeader.column);
	        }
	        else {
	            getColMethod = "getDisplayedCol" + direction;
	            nextColumn = this.columnController[getColMethod](focusedHeader.column);
	        }
	        if (nextColumn) {
	            return {
	                column: nextColumn,
	                headerRowIndex: focusedHeader.headerRowIndex
	            };
	        }
	    };
	    HeaderPositionUtils.prototype.findColAtEdgeForHeaderRow = function (level, position) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var column = displayedColumns[position === 'start' ? 0 : displayedColumns.length - 1];
	        if (!column) {
	            return;
	        }
	        var childContainer = this.headerNavigationService.getHeaderContainer(column.getPinned());
	        var headerRowComp = childContainer.getRowComps()[level];
	        var type = headerRowComp && headerRowComp.getType();
	        if (type == HeaderRowType.COLUMN_GROUP) {
	            var columnGroup = this.columnController.getColumnGroupAtLevel(column, level);
	            return {
	                headerRowIndex: level,
	                column: columnGroup
	            };
	        }
	        return {
	            headerRowIndex: !headerRowComp ? -1 : level,
	            column: column
	        };
	    };
	    __decorate$1Y([
	        Autowired('columnController')
	    ], HeaderPositionUtils.prototype, "columnController", void 0);
	    __decorate$1Y([
	        Autowired('headerNavigationService')
	    ], HeaderPositionUtils.prototype, "headerNavigationService", void 0);
	    HeaderPositionUtils = __decorate$1Y([
	        Bean('headerPositionUtils')
	    ], HeaderPositionUtils);
	    return HeaderPositionUtils;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$1Z = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ColumnDefFactory = /** @class */ (function () {
	    function ColumnDefFactory() {
	    }
	    ColumnDefFactory.prototype.buildColumnDefs = function (cols, rowGroupColumns, pivotColumns) {
	        var _this = this;
	        var res = [];
	        var colGroupDefs = {};
	        cols.forEach(function (col) {
	            var colDef = _this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
	            var addToResult = true;
	            var childDef = colDef;
	            var pointer = col.getOriginalParent();
	            while (pointer) {
	                var parentDef = null;
	                // we don't include padding groups, as the column groups provided
	                // by application didn't have these. the whole point of padding groups
	                // is to balance the column tree that the user provided.
	                if (pointer.isPadding()) {
	                    pointer = pointer.getOriginalParent();
	                    continue;
	                }
	                // if colDef for this group already exists, use it
	                var existingParentDef = colGroupDefs[pointer.getGroupId()];
	                if (existingParentDef) {
	                    existingParentDef.children.push(childDef);
	                    // if we added to result, it would be the second time we did it
	                    addToResult = false;
	                    // we don't want to continue up the tree, as it has already been
	                    // done for this group
	                    break;
	                }
	                parentDef = _this.createDefFromGroup(pointer);
	                if (parentDef) {
	                    parentDef.children = [childDef];
	                    colGroupDefs[parentDef.groupId] = parentDef;
	                    childDef = parentDef;
	                    pointer = pointer.getOriginalParent();
	                }
	            }
	            if (addToResult) {
	                res.push(childDef);
	            }
	        });
	        return res;
	    };
	    ColumnDefFactory.prototype.createDefFromGroup = function (group) {
	        var defCloned = deepCloneDefinition(group.getColGroupDef(), ['children']);
	        if (defCloned) {
	            defCloned.groupId = group.getGroupId();
	        }
	        return defCloned;
	    };
	    ColumnDefFactory.prototype.createDefFromColumn = function (col, rowGroupColumns, pivotColumns) {
	        var colDefCloned = deepCloneDefinition(col.getColDef());
	        colDefCloned.colId = col.getColId();
	        colDefCloned.width = col.getActualWidth();
	        colDefCloned.rowGroup = col.isRowGroupActive();
	        colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
	        colDefCloned.pivot = col.isPivotActive();
	        colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
	        colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
	        colDefCloned.hide = col.isVisible() ? undefined : true;
	        colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
	        colDefCloned.sort = col.getSort() ? col.getSort() : null;
	        colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
	        return colDefCloned;
	    };
	    ColumnDefFactory = __decorate$1Z([
	        Bean('columnDefFactory')
	    ], ColumnDefFactory);
	    return ColumnDefFactory;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$1_ = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	/**
	 * Common logic for RowComp and AutoHeightCalculator
	 */
	var RowCssClassCalculator = /** @class */ (function () {
	    function RowCssClassCalculator() {
	    }
	    RowCssClassCalculator.prototype.getInitialRowClasses = function (params) {
	        var classes = [];
	        if (exists(params.extraCssClass)) {
	            classes.push(params.extraCssClass);
	        }
	        classes.push('ag-row');
	        classes.push(params.rowFocused ? 'ag-row-focus' : 'ag-row-no-focus');
	        if (params.fadeRowIn) {
	            classes.push('ag-opacity-zero');
	        }
	        classes.push(params.rowIsEven ? 'ag-row-even' : 'ag-row-odd');
	        if (params.rowNode.isRowPinned()) {
	            classes.push('ag-row-pinned');
	        }
	        if (params.rowNode.isSelected()) {
	            classes.push('ag-row-selected');
	        }
	        if (params.rowNode.footer) {
	            classes.push('ag-row-footer');
	        }
	        classes.push('ag-row-level-' + params.rowLevel);
	        if (params.rowNode.stub) {
	            classes.push('ag-row-loading');
	        }
	        if (params.fullWidthRow) {
	            classes.push('ag-full-width-row');
	        }
	        if (params.expandable) {
	            classes.push('ag-row-group');
	            classes.push(params.rowNode.expanded ? 'ag-row-group-expanded' : 'ag-row-group-contracted');
	        }
	        if (params.rowNode.dragging) {
	            classes.push('ag-row-dragging');
	        }
	        pushAll(classes, this.processClassesFromGridOptions(params.rowNode, params.scope));
	        pushAll(classes, this.preProcessRowClassRules(params.rowNode, params.scope));
	        // we use absolute position unless we are doing print layout
	        classes.push(params.printLayout ? 'ag-row-position-relative' : 'ag-row-position-absolute');
	        if (params.firstRowOnPage) {
	            classes.push('ag-row-first');
	        }
	        if (params.lastRowOnPage) {
	            classes.push('ag-row-last');
	        }
	        if (params.fullWidthRow) {
	            if (params.pinned === Constants.PINNED_LEFT) {
	                classes.push('ag-cell-last-left-pinned');
	            }
	            if (params.pinned === Constants.PINNED_RIGHT) {
	                classes.push('ag-cell-first-right-pinned');
	            }
	        }
	        return classes;
	    };
	    RowCssClassCalculator.prototype.processClassesFromGridOptions = function (rowNode, scope) {
	        var res = [];
	        var process = function (rowCls) {
	            if (typeof rowCls === 'string') {
	                res.push(rowCls);
	            }
	            else if (Array.isArray(rowCls)) {
	                rowCls.forEach(function (e) { return res.push(e); });
	            }
	        };
	        // part 1 - rowClass
	        var rowClass = this.gridOptionsWrapper.getRowClass();
	        if (rowClass) {
	            if (typeof rowClass === 'function') {
	                console.warn('AG Grid: rowClass should not be a function, please use getRowClass instead');
	                return [];
	            }
	            process(rowClass);
	        }
	        // part 2 - rowClassFunc
	        var rowClassFunc = this.gridOptionsWrapper.getRowClassFunc();
	        if (rowClassFunc) {
	            var params = {
	                data: rowNode.data,
	                node: rowNode,
	                rowIndex: rowNode.rowIndex,
	                $scope: scope,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            var rowClassFuncResult = rowClassFunc(params);
	            process(rowClassFuncResult);
	        }
	        return res;
	    };
	    RowCssClassCalculator.prototype.preProcessRowClassRules = function (rowNode, scope) {
	        var res = [];
	        this.processRowClassRules(rowNode, scope, function (className) {
	            res.push(className);
	        }, function (className) {
	            // not catered for, if creating, no need
	            // to remove class as it was never there
	        });
	        return res;
	    };
	    RowCssClassCalculator.prototype.processRowClassRules = function (rowNode, scope, onApplicableClass, onNotApplicableClass) {
	        var rowClassParams = {
	            data: rowNode.data,
	            node: rowNode,
	            rowIndex: rowNode.rowIndex,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            $scope: scope,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        this.stylingService.processClassRules(this.gridOptionsWrapper.rowClassRules(), rowClassParams, onApplicableClass, onNotApplicableClass);
	    };
	    RowCssClassCalculator.prototype.calculateRowLevel = function (rowNode) {
	        if (rowNode.group) {
	            return rowNode.level;
	        }
	        // if a leaf, and a parent exists, put a level of the parent, else put level of 0 for top level item
	        return rowNode.parent ? (rowNode.parent.level + 1) : 0;
	    };
	    __decorate$1_([
	        Autowired('stylingService')
	    ], RowCssClassCalculator.prototype, "stylingService", void 0);
	    __decorate$1_([
	        Autowired('gridOptionsWrapper')
	    ], RowCssClassCalculator.prototype, "gridOptionsWrapper", void 0);
	    RowCssClassCalculator = __decorate$1_([
	        Bean('rowCssClassCalculator')
	    ], RowCssClassCalculator);
	    return RowCssClassCalculator;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2a = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var RowNodeBlock = /** @class */ (function (_super) {
	    __extends$2a(RowNodeBlock, _super);
	    function RowNodeBlock(id) {
	        var _this = _super.call(this) || this;
	        _this.state = RowNodeBlock.STATE_WAITING_TO_LOAD;
	        _this.version = 0;
	        _this.id = id;
	        return _this;
	    }
	    RowNodeBlock.prototype.getId = function () {
	        return this.id;
	    };
	    RowNodeBlock.prototype.load = function () {
	        this.state = RowNodeBlock.STATE_LOADING;
	        this.loadFromDatasource();
	    };
	    RowNodeBlock.prototype.getVersion = function () {
	        return this.version;
	    };
	    RowNodeBlock.prototype.setStateWaitingToLoad = function () {
	        // in case any current loads in progress, this will have their results ignored
	        this.version++;
	        this.state = RowNodeBlock.STATE_WAITING_TO_LOAD;
	    };
	    RowNodeBlock.prototype.getState = function () {
	        return this.state;
	    };
	    RowNodeBlock.prototype.pageLoadFailed = function (version) {
	        var requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
	        if (requestMostRecentAndLive) {
	            this.state = RowNodeBlock.STATE_FAILED;
	            this.processServerFail();
	        }
	        this.dispatchLoadCompleted(false);
	    };
	    RowNodeBlock.prototype.success = function (version, params) {
	        this.successCommon(version, params);
	    };
	    RowNodeBlock.prototype.pageLoaded = function (version, rows, lastRow) {
	        this.successCommon(version, { rowData: rows, rowCount: lastRow });
	    };
	    RowNodeBlock.prototype.isRequestMostRecentAndLive = function (version) {
	        // thisIsMostRecentRequest - if block was refreshed, then another request
	        // could of been sent after this one.
	        var thisIsMostRecentRequest = version === this.version;
	        // weAreNotDestroyed - if InfiniteStore is purged, then blocks are destroyed
	        // and new blocks created. so data loads of old blocks are discarded.
	        var weAreNotDestroyed = this.isAlive();
	        return thisIsMostRecentRequest && weAreNotDestroyed;
	    };
	    RowNodeBlock.prototype.successCommon = function (version, params) {
	        // need to dispatch load complete before processing the data, as PaginationComp checks
	        // RowNodeBlockLoader to see if it is still loading, so the RowNodeBlockLoader needs to
	        // be updated first (via LoadComplete event) before PaginationComp updates (via processServerResult method)
	        this.dispatchLoadCompleted();
	        var requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
	        if (requestMostRecentAndLive) {
	            this.state = RowNodeBlock.STATE_LOADED;
	            this.processServerResult(params);
	        }
	    };
	    RowNodeBlock.prototype.dispatchLoadCompleted = function (success) {
	        if (success === void 0) { success = true; }
	        // we fire event regardless of processing data or now, as we want
	        // the concurrentLoadRequests count to be reduced in BlockLoader
	        var event = {
	            type: RowNodeBlock.EVENT_LOAD_COMPLETE,
	            success: success,
	            block: this
	        };
	        this.dispatchEvent(event);
	    };
	    RowNodeBlock.EVENT_LOAD_COMPLETE = 'loadComplete';
	    RowNodeBlock.STATE_WAITING_TO_LOAD = 'needsLoading';
	    RowNodeBlock.STATE_LOADING = 'loading';
	    RowNodeBlock.STATE_LOADED = 'loaded';
	    RowNodeBlock.STATE_FAILED = 'failed';
	    return RowNodeBlock;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2b = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1$ = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$a = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var RowNodeBlockLoader = /** @class */ (function (_super) {
	    __extends$2b(RowNodeBlockLoader, _super);
	    function RowNodeBlockLoader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.activeBlockLoadsCount = 0;
	        _this.blocks = [];
	        _this.active = true;
	        return _this;
	    }
	    RowNodeBlockLoader_1 = RowNodeBlockLoader;
	    RowNodeBlockLoader.prototype.postConstruct = function () {
	        this.maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
	        var blockLoadDebounceMillis = this.gridOptionsWrapper.getBlockLoadDebounceMillis();
	        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) {
	            this.checkBlockToLoadDebounce = _.debounce(this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
	        }
	    };
	    RowNodeBlockLoader.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('RowNodeBlockLoader');
	    };
	    RowNodeBlockLoader.prototype.addBlock = function (block) {
	        this.blocks.push(block);
	        // note that we do not remove this listener when removing the block. this is because the
	        // cache can get destroyed (and containing blocks) when a block is loading. however the loading block
	        // is still counted as an active loading block and we must decrement activeBlockLoadsCount when it finishes.
	        block.addEventListener(RowNodeBlock.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this));
	        this.checkBlockToLoad();
	    };
	    RowNodeBlockLoader.prototype.removeBlock = function (block) {
	        _.removeFromArray(this.blocks, block);
	    };
	    RowNodeBlockLoader.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.active = false;
	    };
	    RowNodeBlockLoader.prototype.loadComplete = function () {
	        this.activeBlockLoadsCount--;
	        this.checkBlockToLoad();
	        if (this.activeBlockLoadsCount == 0) {
	            this.dispatchEvent({ type: RowNodeBlockLoader_1.BLOCK_LOADER_FINISHED_EVENT });
	        }
	    };
	    RowNodeBlockLoader.prototype.checkBlockToLoad = function () {
	        if (this.checkBlockToLoadDebounce) {
	            this.checkBlockToLoadDebounce();
	        }
	        else {
	            this.performCheckBlocksToLoad();
	        }
	    };
	    RowNodeBlockLoader.prototype.performCheckBlocksToLoad = function () {
	        if (!this.active) {
	            return;
	        }
	        this.printCacheStatus();
	        if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
	            this.logger.log("checkBlockToLoad: max loads exceeded");
	            return;
	        }
	        var blockToLoad = null;
	        this.blocks.forEach(function (block) {
	            if (block.getState() === RowNodeBlock.STATE_WAITING_TO_LOAD) {
	                blockToLoad = block;
	            }
	        });
	        if (blockToLoad) {
	            blockToLoad.load();
	            this.activeBlockLoadsCount++;
	            this.printCacheStatus();
	        }
	    };
	    RowNodeBlockLoader.prototype.getBlockState = function () {
	        var result = {};
	        this.blocks.forEach(function (block) {
	            var _a = block.getBlockStateJson(), id = _a.id, state = _a.state;
	            result[id] = state;
	        });
	        return result;
	    };
	    RowNodeBlockLoader.prototype.printCacheStatus = function () {
	        if (this.logger.isLogging()) {
	            this.logger.log("printCacheStatus: activePageLoadsCount = " + this.activeBlockLoadsCount + ","
	                + (" blocks = " + JSON.stringify(this.getBlockState())));
	        }
	    };
	    RowNodeBlockLoader.prototype.isLoading = function () {
	        return this.activeBlockLoadsCount > 0;
	    };
	    var RowNodeBlockLoader_1;
	    RowNodeBlockLoader.BLOCK_LOADER_FINISHED_EVENT = 'blockLoaderFinished';
	    __decorate$1$([
	        PostConstruct
	    ], RowNodeBlockLoader.prototype, "postConstruct", null);
	    __decorate$1$([
	        __param$a(0, Qualifier('loggerFactory'))
	    ], RowNodeBlockLoader.prototype, "setBeans", null);
	    RowNodeBlockLoader = RowNodeBlockLoader_1 = __decorate$1$([
	        Bean('rowNodeBlockLoader')
	    ], RowNodeBlockLoader);
	    return RowNodeBlockLoader;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __decorate$20 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// this logic is used by both SSRM and CSRM
	var RowNodeSorter = /** @class */ (function () {
	    function RowNodeSorter() {
	    }
	    RowNodeSorter.prototype.doFullSort = function (rowNodes, sortOptions) {
	        var mapper = function (rowNode, pos) { return ({ currentPos: pos, rowNode: rowNode }); };
	        var sortedRowNodes = rowNodes.map(mapper);
	        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
	        return sortedRowNodes.map(function (item) { return item.rowNode; });
	    };
	    RowNodeSorter.prototype.compareRowNodes = function (sortOptions, sortedNodeA, sortedNodeB) {
	        var nodeA = sortedNodeA.rowNode;
	        var nodeB = sortedNodeB.rowNode;
	        // Iterate columns, return the first that doesn't match
	        for (var i = 0, len = sortOptions.length; i < len; i++) {
	            var sortOption = sortOptions[i];
	            // let compared = compare(nodeA, nodeB, sortOption.column, sortOption.inverter === -1);
	            var isInverted = sortOption.sort === Constants.SORT_DESC;
	            var valueA = this.getValue(nodeA, sortOption.column);
	            var valueB = this.getValue(nodeB, sortOption.column);
	            var comparatorResult = void 0;
	            var providedComparator = sortOption.column.getColDef().comparator;
	            if (providedComparator) {
	                //if comparator provided, use it
	                comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isInverted);
	            }
	            else {
	                //otherwise do our own comparison
	                comparatorResult = _.defaultComparator(valueA, valueB, this.gridOptionsWrapper.isAccentedSort());
	            }
	            if (comparatorResult !== 0) {
	                return sortOption.sort === Constants.SORT_ASC ? comparatorResult : comparatorResult * -1;
	            }
	        }
	        // All matched, we make is so that the original sort order is kept:
	        return sortedNodeA.currentPos - sortedNodeB.currentPos;
	    };
	    RowNodeSorter.prototype.getValue = function (nodeA, column) {
	        return this.valueService.getValue(column, nodeA);
	    };
	    __decorate$20([
	        Autowired('gridOptionsWrapper')
	    ], RowNodeSorter.prototype, "gridOptionsWrapper", void 0);
	    __decorate$20([
	        Autowired('valueService')
	    ], RowNodeSorter.prototype, "valueService", void 0);
	    RowNodeSorter = __decorate$20([
	        Bean('rowNodeSorter')
	    ], RowNodeSorter);
	    return RowNodeSorter;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2c = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$21 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ControllersService = /** @class */ (function (_super) {
	    __extends$2c(ControllersService, _super);
	    function ControllersService() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ready = false;
	        _this.readyCallbacks = [];
	        return _this;
	    }
	    ControllersService.prototype.checkReady = function () {
	        this.ready =
	            this.gridCompCon != null
	                && this.gridBodyCon != null
	                && this.centerRowContainerCon != null
	                && this.leftRowContainerCon != null
	                && this.rightRowContainerCon != null
	                && this.bottomCenterRowContainerCon != null
	                && this.bottomLeftRowContainerCon != null
	                && this.bottomRightRowContainerCon != null
	                && this.topCenterRowContainerCon != null
	                && this.topLeftRowContainerCon != null
	                && this.topRightRowContainerCon != null
	                && this.fakeHScrollCon != null
	                && this.headerRootComp != null;
	        if (this.ready) {
	            var p_1 = this.createReadyParams();
	            this.readyCallbacks.forEach(function (c) { return c(p_1); });
	            this.readyCallbacks.length = 0;
	        }
	    };
	    ControllersService.prototype.whenReady = function (callback) {
	        if (this.ready) {
	            callback(this.createReadyParams());
	        }
	        else {
	            this.readyCallbacks.push(callback);
	        }
	    };
	    ControllersService.prototype.createReadyParams = function () {
	        return {
	            centerRowContainerCon: this.centerRowContainerCon,
	            leftRowContainerCon: this.leftRowContainerCon,
	            rightRowContainerCon: this.rightRowContainerCon,
	            bottomCenterRowContainerCon: this.bottomCenterRowContainerCon,
	            bottomLeftRowContainerCon: this.bottomLeftRowContainerCon,
	            bottomRightRowContainerCon: this.bottomRightRowContainerCon,
	            topCenterRowContainerCon: this.topCenterRowContainerCon,
	            topLeftRowContainerCon: this.topLeftRowContainerCon,
	            topRightRowContainerCon: this.topRightRowContainerCon,
	            fakeHScrollCon: this.fakeHScrollCon,
	            gridBodyCon: this.gridBodyCon,
	            gridCompCon: this.gridCompCon,
	            headerRootComp: this.headerRootComp,
	        };
	    };
	    ControllersService.prototype.registerFakeHScrollCon = function (con) {
	        this.fakeHScrollCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerHeaderRootComp = function (headerRootComp) {
	        this.headerRootComp = headerRootComp;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerCenterRowContainerCon = function (con) {
	        this.centerRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerLeftRowContainerCon = function (con) {
	        this.leftRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerRightRowContainerCon = function (con) {
	        this.rightRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerTopCenterRowContainerCon = function (con) {
	        this.topCenterRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerTopLeftRowContainerCon = function (con) {
	        this.topLeftRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerTopRightRowContainerCon = function (con) {
	        this.topRightRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerBottomCenterRowContainerCon = function (con) {
	        this.bottomCenterRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerBottomLeftRowContainerCon = function (con) {
	        this.bottomLeftRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerBottomRightRowContainerCon = function (con) {
	        this.bottomRightRowContainerCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerGridBodyController = function (con) {
	        this.gridBodyCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.registerGridCompController = function (con) {
	        this.gridCompCon = con;
	        this.checkReady();
	    };
	    ControllersService.prototype.getFakeHScrollCon = function () {
	        return this.fakeHScrollCon;
	    };
	    ControllersService.prototype.getHeaderRootComp = function () {
	        return this.headerRootComp;
	    };
	    ControllersService.prototype.getGridCompController = function () {
	        return this.gridCompCon;
	    };
	    ControllersService.prototype.getCenterRowContainerCon = function () {
	        return this.centerRowContainerCon;
	    };
	    ControllersService.prototype.getTopCenterRowContainerCon = function () {
	        return this.topCenterRowContainerCon;
	    };
	    ControllersService.prototype.getBottomCenterRowContainerCon = function () {
	        return this.bottomCenterRowContainerCon;
	    };
	    ControllersService.prototype.getGridBodyController = function () {
	        return this.gridBodyCon;
	    };
	    ControllersService = __decorate$21([
	        Bean('controllersService')
	    ], ControllersService);
	    return ControllersService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2d = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$22 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var FakeHorizontalScrollController = /** @class */ (function (_super) {
	    __extends$2d(FakeHorizontalScrollController, _super);
	    function FakeHorizontalScrollController() {
	        return _super.call(this) || this;
	    }
	    FakeHorizontalScrollController.prototype.setView = function (view, eViewport, eContainer) {
	        this.view = view;
	        this.eViewport = eViewport;
	        this.eContainer = eContainer;
	        this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.onScrollVisibilityChanged();
	        // When doing printing, this changes whether cols are pinned or not
	        var spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, spacerWidthsListener);
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, spacerWidthsListener);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, spacerWidthsListener);
	        this.setFakeHScrollSpacerWidths();
	        this.controllersService.registerFakeHScrollCon(this);
	    };
	    FakeHorizontalScrollController.prototype.postConstruct = function () {
	        this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
	    };
	    FakeHorizontalScrollController.prototype.onScrollVisibilityChanged = function () {
	        this.setScrollVisible();
	        this.setFakeHScrollSpacerWidths();
	    };
	    FakeHorizontalScrollController.prototype.setFakeHScrollSpacerWidths = function () {
	        var vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
	        // we pad the right based on a) if cols are pinned to the right and
	        // b) if v scroll is showing on the right (normal position of scroll)
	        var rightSpacing = this.columnController.getDisplayedColumnsRightWidth();
	        var scrollOnRight = !this.enableRtl && vScrollShowing;
	        var scrollbarWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        if (scrollOnRight) {
	            rightSpacing += scrollbarWidth;
	        }
	        this.view.setRightSpacerFixedWidth(rightSpacing);
	        this.view.includeRightSpacerScrollerCss('ag-scroller-corner', rightSpacing <= scrollbarWidth);
	        // we pad the left based on a) if cols are pinned to the left and
	        // b) if v scroll is showing on the left (happens in LTR layout only)
	        var leftSpacing = this.columnController.getDisplayedColumnsLeftWidth();
	        var scrollOnLeft = this.enableRtl && vScrollShowing;
	        if (scrollOnLeft) {
	            leftSpacing += scrollbarWidth;
	        }
	        this.view.setLeftSpacerFixedWidth(leftSpacing);
	        this.view.includeLeftSpacerScrollerCss('ag-scroller-corner', leftSpacing <= scrollbarWidth);
	    };
	    FakeHorizontalScrollController.prototype.setScrollVisible = function () {
	        var hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
	        var scrollbarInvisible = isInvisibleScrollbar();
	        var isSuppressHorizontalScroll = this.gridOptionsWrapper.isSuppressHorizontalScroll();
	        var scrollbarWidth = hScrollShowing ? (this.gridOptionsWrapper.getScrollbarWidth() || 0) : 0;
	        var adjustedScrollbarWidth = (scrollbarWidth === 0 && scrollbarInvisible) ? 15 : scrollbarWidth;
	        var scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
	        var addIEPadding = isBrowserIE() && hScrollShowing;
	        this.view.setInvisibleStyles(scrollbarInvisible);
	        this.view.setHeight(scrollContainerSize);
	        // we have to add an extra pixel to the scroller viewport on IE because
	        // if the container has the same size as the scrollbar, the scroll button won't work
	        this.view.setViewportHeight(scrollContainerSize + (addIEPadding ? 1 : 0));
	        this.view.setContainerHeight(scrollContainerSize);
	    };
	    FakeHorizontalScrollController.prototype.getViewport = function () {
	        return this.eViewport;
	    };
	    FakeHorizontalScrollController.prototype.getContainer = function () {
	        return this.eContainer;
	    };
	    __decorate$22([
	        Autowired('scrollVisibleService')
	    ], FakeHorizontalScrollController.prototype, "scrollVisibleService", void 0);
	    __decorate$22([
	        Autowired('columnController')
	    ], FakeHorizontalScrollController.prototype, "columnController", void 0);
	    __decorate$22([
	        Autowired('controllersService')
	    ], FakeHorizontalScrollController.prototype, "controllersService", void 0);
	    __decorate$22([
	        PostConstruct
	    ], FakeHorizontalScrollController.prototype, "postConstruct", null);
	    return FakeHorizontalScrollController;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2e = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$23 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var FakeHorizontalScrollComp = /** @class */ (function (_super) {
	    __extends$2e(FakeHorizontalScrollComp, _super);
	    function FakeHorizontalScrollComp() {
	        return _super.call(this, FakeHorizontalScrollComp.TEMPLATE) || this;
	    }
	    FakeHorizontalScrollComp.prototype.postConstruct = function () {
	        var _this = this;
	        var view = {
	            setHeight: function (height) { return setFixedHeight(_this.getGui(), height); },
	            setContainerHeight: function (height) { return setFixedHeight(_this.eContainer, height); },
	            setViewportHeight: function (height) { return setFixedHeight(_this.eViewport, height); },
	            setRightSpacerFixedWidth: function (width) { return setFixedWidth(_this.eRightSpacer, width); },
	            setLeftSpacerFixedWidth: function (width) { return setFixedWidth(_this.eLeftSpacer, width); },
	            setInvisibleStyles: function (isInvisible) { return addOrRemoveCssClass(_this.getGui(), 'ag-invisible-scrollbar', isInvisible); },
	            includeLeftSpacerScrollerCss: function (cssClass, include) {
	                return addOrRemoveCssClass(_this.eLeftSpacer, cssClass, include);
	            },
	            includeRightSpacerScrollerCss: function (cssClass, include) {
	                return addOrRemoveCssClass(_this.eRightSpacer, cssClass, include);
	            },
	        };
	        this.controller = this.createManagedBean(new FakeHorizontalScrollController());
	        this.controller.setView(view, this.eViewport, this.eContainer);
	        this.createManagedBean(new CenterWidthFeature(function (width) { return _this.eContainer.style.width = width + "px"; }));
	    };
	    FakeHorizontalScrollComp.TEMPLATE = "<div class=\"ag-body-horizontal-scroll\" aria-hidden=\"true\">\n            <div class=\"ag-horizontal-left-spacer\" ref=\"eLeftSpacer\"></div>\n            <div class=\"ag-body-horizontal-scroll-viewport\" ref=\"eViewport\">\n                <div class=\"ag-body-horizontal-scroll-container\" ref=\"eContainer\"></div>\n            </div>\n            <div class=\"ag-horizontal-right-spacer\" ref=\"eRightSpacer\"></div>\n        </div>";
	    __decorate$23([
	        RefSelector('eLeftSpacer')
	    ], FakeHorizontalScrollComp.prototype, "eLeftSpacer", void 0);
	    __decorate$23([
	        RefSelector('eRightSpacer')
	    ], FakeHorizontalScrollComp.prototype, "eRightSpacer", void 0);
	    __decorate$23([
	        RefSelector('eViewport')
	    ], FakeHorizontalScrollComp.prototype, "eViewport", void 0);
	    __decorate$23([
	        RefSelector('eContainer')
	    ], FakeHorizontalScrollComp.prototype, "eContainer", void 0);
	    __decorate$23([
	        PostConstruct
	    ], FakeHorizontalScrollComp.prototype, "postConstruct", null);
	    return FakeHorizontalScrollComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2f = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$24 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var PinnedWidthService = /** @class */ (function (_super) {
	    __extends$2f(PinnedWidthService, _super);
	    function PinnedWidthService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PinnedWidthService.prototype.postConstruct = function () {
	        var listener = this.checkContainerWidths.bind(this);
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, listener);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, listener);
	    };
	    PinnedWidthService.prototype.checkContainerWidths = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	        var newLeftWidth = printLayout ? 0 : this.columnController.getDisplayedColumnsLeftWidth();
	        var newRightWidth = printLayout ? 0 : this.columnController.getDisplayedColumnsRightWidth();
	        if (newLeftWidth != this.leftWidth) {
	            this.leftWidth = newLeftWidth;
	            this.eventService.dispatchEvent({ type: Events.EVENT_LEFT_PINNED_WIDTH_CHANGED });
	        }
	        if (newRightWidth != this.rightWidth) {
	            this.rightWidth = newRightWidth;
	            this.eventService.dispatchEvent({ type: Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED });
	        }
	    };
	    PinnedWidthService.prototype.getPinnedRightWidth = function () {
	        return this.rightWidth;
	    };
	    PinnedWidthService.prototype.getPinnedLeftWidth = function () {
	        return this.leftWidth;
	    };
	    __decorate$24([
	        Autowired('columnController')
	    ], PinnedWidthService.prototype, "columnController", void 0);
	    __decorate$24([
	        PostConstruct
	    ], PinnedWidthService.prototype, "postConstruct", null);
	    PinnedWidthService = __decorate$24([
	        Bean('pinnedWidthService')
	    ], PinnedWidthService);
	    return PinnedWidthService;
	}(BeanStub));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2g = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var RowComp = /** @class */ (function (_super) {
	    __extends$2g(RowComp, _super);
	    function RowComp(controller, container, beans, pinned) {
	        var _this = _super.call(this) || this;
	        _this.cellComps = {};
	        _this.container = container;
	        _this.beans = beans;
	        _this.rowNode = controller.getRowNode();
	        _this.pinned = pinned;
	        _this.controller = controller;
	        var template = _this.createTemplate();
	        _this.setTemplate(template);
	        _this.afterRowAttached();
	        switch (pinned) {
	            case Constants.PINNED_LEFT:
	                controller.setLeftRowComp(_this);
	                break;
	            case Constants.PINNED_RIGHT:
	                controller.setRightRowComp(_this);
	                break;
	            default:
	                if (controller.isFullWidth() && !beans.gridOptionsWrapper.isEmbedFullWidthRows()) {
	                    controller.setFullWidthRowComp(_this);
	                }
	                else {
	                    controller.setCenterRowComp(_this);
	                }
	                break;
	        }
	        if (controller.isFullWidth()) {
	            _this.createFullWidthRowCell();
	        }
	        else {
	            _this.onColumnChanged();
	            _this.controller.refreshAriaLabel(_this.getGui(), !!_this.rowNode.isSelected());
	        }
	        return _this;
	    }
	    RowComp.prototype.createFullWidthRowCell = function () {
	        var _this = this;
	        var params = this.controller.createFullWidthParams(this.getGui(), this.pinned);
	        var callback = function (cellRenderer) {
	            if (_this.isAlive()) {
	                var eGui = cellRenderer.getGui();
	                _this.getGui().appendChild(eGui);
	                if (_this.controller.getRowType() === RowType.FullWidthDetail) {
	                    _this.controller.setupDetailRowAutoHeight(eGui);
	                }
	                _this.setFullWidthRowComp(cellRenderer);
	            }
	            else {
	                _this.beans.context.destroyBean(cellRenderer);
	            }
	        };
	        // if doing master detail, it's possible we have a cached row comp from last time detail was displayed
	        var cachedDetailComp = this.beans.detailRowCompCache.get(this.rowNode, this.pinned);
	        if (cachedDetailComp) {
	            callback(cachedDetailComp);
	        }
	        else {
	            var cellRendererType = FullWidthKeys.get(this.controller.getRowType());
	            var cellRendererName = FullWidthRenderers.get(this.controller.getRowType());
	            var res = this.beans.userComponentFactory.newFullWidthCellRenderer(params, cellRendererType, cellRendererName);
	            if (res) {
	                res.then(callback);
	            }
	            else {
	                var masterDetailModuleLoaded = ModuleRegistry.isRegistered(exports.ModuleNames.MasterDetailModule);
	                if (cellRendererName === 'agDetailCellRenderer' && !masterDetailModuleLoaded) {
	                    console.warn("AG Grid: cell renderer agDetailCellRenderer (for master detail) not found. Did you forget to include the master detail module?");
	                }
	                else {
	                    console.error("AG Grid: fullWidthCellRenderer " + cellRendererName + " not found");
	                }
	            }
	        }
	        // fixme - what to do here?
	        // this.angular1Compile(eRow);
	    };
	    RowComp.prototype.onColumnChanged = function () {
	        var _this = this;
	        var cols = this.controller.getColsForRowComp(this.pinned);
	        var cellsToRemove = assign({}, this.cellComps);
	        cols.forEach(function (col) {
	            var colId = col.getId();
	            var existingCellComp = _this.cellComps[colId];
	            // it's possible there is a Cell Comp with correct Id, but it's referring to
	            // a different column instance. Happens a lot with pivot, as pivot col id's are
	            // reused eg  pivot_0, pivot_1 etc
	            if (existingCellComp && existingCellComp.getColumn() !== col) {
	                _this.destroyCells([existingCellComp]);
	                existingCellComp = null;
	            }
	            if (existingCellComp == null) {
	                _this.newCellComp(col);
	            }
	            else {
	                cellsToRemove[colId] = null;
	            }
	        });
	        var cellCompsToRemove = getAllValuesInObject(cellsToRemove)
	            .filter(function (cellComp) { return cellComp ? _this.isCellEligibleToBeRemoved(cellComp) : false; });
	        this.destroyCells(cellCompsToRemove);
	        this.ensureDomOrder(cols);
	    };
	    RowComp.prototype.ensureDomOrder = function (cols) {
	        var _this = this;
	        if (!this.beans.gridOptionsWrapper.isEnsureDomOrder()) {
	            return;
	        }
	        var elementsInOrder = [];
	        cols.forEach(function (col) {
	            var cellComp = _this.cellComps[col.getColId()];
	            if (cellComp) {
	                elementsInOrder.push(cellComp.getGui());
	            }
	        });
	        setDomChildOrder(this.getGui(), elementsInOrder);
	    };
	    RowComp.prototype.isCellEligibleToBeRemoved = function (cellComp) {
	        var REMOVE_CELL = true;
	        var KEEP_CELL = false;
	        // always remove the cell if it's not rendered or if it's in the wrong pinned location
	        var column = cellComp.getColumn();
	        if (column.getPinned() != this.pinned) {
	            return REMOVE_CELL;
	        }
	        // we want to try and keep editing and focused cells
	        var editing = cellComp.isEditing();
	        var focused = this.beans.focusController.isCellFocused(cellComp.getCellPosition());
	        var mightWantToKeepCell = editing || focused;
	        if (mightWantToKeepCell) {
	            var column_1 = cellComp.getColumn();
	            var displayedColumns = this.beans.columnController.getAllDisplayedColumns();
	            var cellStillDisplayed = displayedColumns.indexOf(column_1) >= 0;
	            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
	        }
	        return REMOVE_CELL;
	    };
	    RowComp.prototype.newCellComp = function (col) {
	        var cellComp = new CellComp(this.controller.getScope(), this.beans, col, this.rowNode, this.controller, false, this.controller.isPrintLayout(), this.getGui(), this.controller.isEditing());
	        this.cellComps[col.getId()] = cellComp;
	        this.getGui().appendChild(cellComp.getGui());
	    };
	    RowComp.prototype.getCellComp = function (id) {
	        return this.cellComps[id];
	    };
	    RowComp.prototype.getCellCompSpanned = function (column) {
	        var _this = this;
	        var spanList = Object.keys(this.cellComps)
	            .map(function (name) { return _this.cellComps[name]; })
	            .filter(function (cmp) { return cmp && cmp.getColSpanningList().indexOf(column) !== -1; });
	        return spanList.length ? spanList[0] : null;
	    };
	    RowComp.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.destroyAllCells();
	    };
	    RowComp.prototype.destroyAllCells = function () {
	        var cellsToDestroy = getAllValuesInObject(this.cellComps).filter(function (cp) { return cp != null; });
	        this.destroyCells(cellsToDestroy);
	    };
	    RowComp.prototype.getContainer = function () {
	        return this.container;
	    };
	    RowComp.prototype.setFullWidthRowComp = function (fullWidthRowComponent) {
	        var _this = this;
	        if (this.fullWidthRowComponent) {
	            console.error('AG Grid - should not be setting fullWidthRowComponent twice');
	        }
	        this.fullWidthRowComponent = fullWidthRowComponent;
	        this.addDestroyFunc(function () {
	            _this.beans.detailRowCompCache.addOrDestroy(_this.rowNode, _this.pinned, fullWidthRowComponent);
	            _this.fullWidthRowComponent = null;
	        });
	    };
	    RowComp.prototype.getFullWidthRowComp = function () {
	        return this.fullWidthRowComponent;
	    };
	    RowComp.prototype.createTemplate = function () {
	        var con = this.controller;
	        var templateParts = [];
	        var rowHeight = this.rowNode.rowHeight;
	        var rowClasses = con.getInitialRowClasses(this.pinned).join(' ');
	        var rowIdSanitised = escapeString(this.rowNode.id);
	        var userRowStyles = con.preProcessStylesFromGridOptions();
	        var businessKey = con.getRowBusinessKey();
	        var businessKeySanitised = escapeString(businessKey);
	        var rowTopStyle = con.getInitialRowTopStyle();
	        var rowIdx = this.rowNode.getRowIndexString();
	        var headerRowCount = this.beans.headerNavigationService.getHeaderRowCount();
	        templateParts.push("<div");
	        templateParts.push(" role=\"row\"");
	        templateParts.push(" row-index=\"" + rowIdx + "\" aria-rowindex=\"" + (headerRowCount + this.rowNode.rowIndex + 1) + "\"");
	        templateParts.push(rowIdSanitised ? " row-id=\"" + rowIdSanitised + "\"" : "");
	        templateParts.push(businessKey ? " row-business-key=\"" + businessKeySanitised + "\"" : "");
	        templateParts.push(" comp-id=\"" + this.getCompId() + "\"");
	        templateParts.push(" class=\"" + rowClasses + "\"");
	        if (con.isFullWidth()) {
	            templateParts.push(" tabindex=\"-1\"");
	        }
	        if (this.beans.gridOptionsWrapper.isRowSelection()) {
	            templateParts.push(" aria-selected=\"" + (this.rowNode.isSelected() ? 'true' : 'false') + "\"");
	        }
	        if (this.rowNode.group) {
	            templateParts.push(" aria-expanded=" + (this.rowNode.expanded ? 'true' : 'false'));
	        }
	        templateParts.push(" style=\"height: " + rowHeight + "px; " + rowTopStyle + " " + userRowStyles + "\">");
	        // add in the template for the cells
	        templateParts.push("</div>");
	        return templateParts.join('');
	    };
	    RowComp.prototype.afterRowAttached = function () {
	        this.addDomData();
	        var eRow = this.getGui();
	        // adding hover functionality adds listener to this row, so we
	        // do it lazily in an animation frame
	        if (this.controller.isUseAnimationFrameForCreate()) {
	            this.beans.taskQueue.createTask(this.controller.addHoverFunctionality.bind(this.controller, eRow), this.rowNode.rowIndex, 'createTasksP2');
	        }
	        else {
	            this.controller.addHoverFunctionality(eRow);
	        }
	        this.controller.executeProcessRowPostCreateFunc();
	    };
	    RowComp.prototype.addDomData = function () {
	        var _this = this;
	        var gow = this.beans.gridOptionsWrapper;
	        gow.setDomData(this.getGui(), RowController.DOM_DATA_KEY_RENDERED_ROW, this.controller);
	        this.addDestroyFunc(function () { return gow.setDomData(_this.getGui(), RowController.DOM_DATA_KEY_RENDERED_ROW, null); });
	    };
	    RowComp.prototype.destroyCells = function (cellComps) {
	        var _this = this;
	        cellComps.forEach(function (cellComp) {
	            // could be old reference, ie removed cell
	            if (!cellComp) {
	                return;
	            }
	            // check cellComp belongs in this container
	            var id = cellComp.getColumn().getId();
	            if (_this.cellComps[id] !== cellComp) {
	                return;
	            }
	            cellComp.detach();
	            cellComp.destroy();
	            _this.cellComps[id] = null;
	        });
	    };
	    RowComp.prototype.forEachCellComp = function (callback) {
	        iterateObject(this.cellComps, function (key, cellComp) {
	            if (!cellComp) {
	                return;
	            }
	            callback(cellComp);
	        });
	    };
	    return RowComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2h = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign$8 = function () {
	    __assign$8 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$8.apply(this, arguments);
	};
	var __decorate$25 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	function templateFactory() {
	    var name = elementGettingCreated.getAttribute('name');
	    var containerClass = ContainerCssClasses.get(name);
	    var viewportClass = ViewportCssClasses.get(name);
	    var wrapperClass = WrapperCssClasses.get(name);
	    var res;
	    switch (name) {
	        case RowContainerNames.LEFT:
	        case RowContainerNames.RIGHT:
	        case RowContainerNames.FULL_WIDTH:
	        case RowContainerNames.TOP_LEFT:
	        case RowContainerNames.TOP_RIGHT:
	        case RowContainerNames.TOP_FULL_WITH:
	        case RowContainerNames.BOTTOM_LEFT:
	        case RowContainerNames.BOTTOM_RIGHT:
	        case RowContainerNames.BOTTOM_FULL_WITH:
	            res = /* html */
	                "<div class=\"" + containerClass + "\" ref=\"eContainer\" role=\"presentation\" unselectable=\"on\"></div>";
	            break;
	        case RowContainerNames.CENTER:
	            res = /* html */
	                "<div class=\"" + wrapperClass + "\" ref=\"eWrapper\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"" + viewportClass + "\" ref=\"eViewport\" role=\"presentation\">\n                    <div class=\"" + containerClass + "\" ref=\"eContainer\" role=\"rowgroup\" unselectable=\"on\"></div>\n                </div>\n            </div>";
	            break;
	        case RowContainerNames.TOP_CENTER:
	        case RowContainerNames.BOTTOM_CENTER:
	            res = /* html */
	                "<div class=\"" + viewportClass + "\" ref=\"eViewport\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"" + containerClass + "\" ref=\"eContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            </div>";
	            break;
	        default: return '';
	    }
	    return res;
	}
	var RowContainerComp = /** @class */ (function (_super) {
	    __extends$2h(RowContainerComp, _super);
	    function RowContainerComp() {
	        var _this = _super.call(this, templateFactory()) || this;
	        _this.renderedRows = {};
	        _this.name = elementGettingCreated.getAttribute('name');
	        return _this;
	    }
	    RowContainerComp.prototype.postConstruct = function () {
	        var _this = this;
	        this.embedFullWidthRows = this.gridOptionsWrapper.isEmbedFullWidthRows();
	        var view = {
	            setViewportHeight: function (height) { return _this.eViewport.style.height = height; },
	        };
	        var con = this.createManagedBean(new RowContainerController(this.name));
	        con.setView(view, this.eContainer, this.eViewport, this.eWrapper);
	        this.listenOnDomOrder();
	        this.stopHScrollOnPinnedRows();
	        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_ROWS_CHANGED, this.onDisplayedRowsChanged.bind(this));
	    };
	    RowContainerComp.prototype.forContainers = function (names, callback) {
	        if (names.indexOf(this.name) >= 0) {
	            callback();
	        }
	    };
	    // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
	    // scroll the column into view. we do not want this, the pinned sections should never scroll.
	    // so we listen to scrolls on these containers and reset the scroll if we find one.
	    RowContainerComp.prototype.stopHScrollOnPinnedRows = function () {
	        var _this = this;
	        this.forContainers([RowContainerNames.TOP_CENTER, RowContainerNames.BOTTOM_CENTER], function () {
	            var resetScrollLeft = function () { return _this.eViewport.scrollLeft = 0; };
	            _this.addManagedListener(_this.eViewport, 'scroll', resetScrollLeft);
	        });
	    };
	    RowContainerComp.prototype.listenOnDomOrder = function () {
	        var _this = this;
	        var listener = function () { return _this.domOrder = _this.gridOptionsWrapper.isEnsureDomOrder(); };
	        this.gridOptionsWrapper.addEventListener(GridOptionsWrapper.PROP_DOM_LAYOUT, listener);
	        listener();
	    };
	    // this is repeated inside the controller, need to remove where this one is called from
	    RowContainerComp.prototype.getViewportElement = function () {
	        return this.eViewport;
	    };
	    RowContainerComp.prototype.clearLastPlacedElement = function () {
	        this.lastPlacedElement = null;
	    };
	    RowContainerComp.prototype.appendRow = function (element) {
	        if (this.domOrder) {
	            insertWithDomOrder(this.eContainer, element, this.lastPlacedElement);
	        }
	        else {
	            this.eContainer.appendChild(element);
	        }
	        this.lastPlacedElement = element;
	    };
	    RowContainerComp.prototype.ensureDomOrder = function (eRow) {
	        if (this.domOrder) {
	            ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);
	            this.lastPlacedElement = eRow;
	        }
	    };
	    RowContainerComp.prototype.removeRow = function (eRow) {
	        this.eContainer.removeChild(eRow);
	    };
	    RowContainerComp.prototype.onDisplayedRowsChanged = function () {
	        var _this = this;
	        var fullWithContainer = this.name === RowContainerNames.TOP_FULL_WITH
	            || this.name === RowContainerNames.BOTTOM_FULL_WITH
	            || this.name === RowContainerNames.FULL_WIDTH;
	        var oldRows = __assign$8({}, this.renderedRows);
	        this.renderedRows = {};
	        this.clearLastPlacedElement();
	        var processRow = function (rowCon) {
	            var instanceId = rowCon.getInstanceId();
	            var existingRowComp = oldRows[instanceId];
	            if (existingRowComp) {
	                _this.renderedRows[instanceId] = existingRowComp;
	                delete oldRows[instanceId];
	                _this.ensureDomOrder(existingRowComp.getGui());
	            }
	            else {
	                var rowComp = _this.newRowComp(rowCon);
	                _this.renderedRows[instanceId] = rowComp;
	                _this.appendRow(rowComp.getGui());
	            }
	        };
	        var doesRowMatch = function (rowCon) {
	            var fullWidthController = rowCon.isFullWidth();
	            var printLayout = _this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
	            var embedFW = _this.embedFullWidthRows || printLayout;
	            var match = fullWithContainer ?
	                !embedFW && fullWidthController
	                : embedFW || !fullWidthController;
	            return match;
	        };
	        var rowConsToRender = this.getRowCons();
	        rowConsToRender.filter(doesRowMatch).forEach(processRow);
	        getAllValuesInObject(oldRows).forEach(function (rowComp) { return _this.removeRow(rowComp.getGui()); });
	    };
	    RowContainerComp.prototype.getRowCons = function () {
	        switch (this.name) {
	            case RowContainerNames.TOP_CENTER:
	            case RowContainerNames.TOP_LEFT:
	            case RowContainerNames.TOP_RIGHT:
	            case RowContainerNames.TOP_FULL_WITH:
	                return this.rowRenderer.getTopRowCons();
	            case RowContainerNames.BOTTOM_CENTER:
	            case RowContainerNames.BOTTOM_LEFT:
	            case RowContainerNames.BOTTOM_RIGHT:
	            case RowContainerNames.BOTTOM_FULL_WITH:
	                return this.rowRenderer.getBottomRowCons();
	            default:
	                return this.rowRenderer.getRowCons();
	        }
	    };
	    RowContainerComp.prototype.newRowComp = function (rowCon) {
	        var pinned;
	        switch (this.name) {
	            case RowContainerNames.BOTTOM_LEFT:
	            case RowContainerNames.TOP_LEFT:
	            case RowContainerNames.LEFT:
	                pinned = Constants.PINNED_LEFT;
	                break;
	            case RowContainerNames.BOTTOM_RIGHT:
	            case RowContainerNames.TOP_RIGHT:
	            case RowContainerNames.RIGHT:
	                pinned = Constants.PINNED_RIGHT;
	                break;
	            default:
	                pinned = null;
	                break;
	        }
	        var res = new RowComp(rowCon, this, this.beans, pinned);
	        return res;
	    };
	    __decorate$25([
	        Autowired('rowRenderer')
	    ], RowContainerComp.prototype, "rowRenderer", void 0);
	    __decorate$25([
	        Autowired("beans")
	    ], RowContainerComp.prototype, "beans", void 0);
	    __decorate$25([
	        RefSelector('eViewport')
	    ], RowContainerComp.prototype, "eViewport", void 0);
	    __decorate$25([
	        RefSelector('eContainer')
	    ], RowContainerComp.prototype, "eContainer", void 0);
	    __decorate$25([
	        RefSelector('eWrapper')
	    ], RowContainerComp.prototype, "eWrapper", void 0);
	    __decorate$25([
	        PostConstruct
	    ], RowContainerComp.prototype, "postConstruct", null);
	    return RowContainerComp;
	}(Component));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	// creates JavaScript vanilla Grid, including JavaScript (ag-stack) components, which can
	// be wrapped by the framework wrappers
	var Grid = /** @class */ (function () {
	    function Grid(eGridDiv, gridOptions, params) {
	        if (!gridOptions) {
	            console.error('AG Grid: no gridOptions provided to the grid');
	            return;
	        }
	        this.gridOptions = gridOptions;
	        new GridCoreCreator().create(eGridDiv, gridOptions, function (context) {
	            var gridComp = new GridComp(eGridDiv);
	            context.createBean(gridComp);
	        }, params);
	    }
	    Grid.prototype.destroy = function () {
	        if (this.gridOptions && this.gridOptions.api) {
	            this.gridOptions.api.destroy();
	        }
	    };
	    return Grid;
	}());
	// created services of grid only, no UI, so frameworks can use this if providing
	// their own UI
	var GridCoreCreator = /** @class */ (function () {
	    function GridCoreCreator() {
	    }
	    GridCoreCreator.prototype.create = function (eGridDiv, gridOptions, uiCallback, params) {
	        var debug = !!gridOptions.debug;
	        var registeredModules = this.getRegisteredModules(params);
	        var beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules);
	        var providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
	        if (!beanClasses) {
	            return;
	        } // happens when no row model found
	        var contextParams = {
	            providedBeanInstances: providedBeanInstances,
	            beanClasses: beanClasses,
	            debug: debug
	        };
	        var logger = new Logger('AG Grid', function () { return gridOptions.debug; });
	        var contextLogger = new Logger('Context', function () { return contextParams.debug; });
	        var context = new Context(contextParams, contextLogger);
	        this.registerModuleUserComponents(context, registeredModules);
	        this.registerStackComponents(context, registeredModules);
	        uiCallback(context);
	        this.setColumnsAndData(context);
	        this.dispatchGridReadyEvent(context, gridOptions);
	        var isEnterprise = ModuleRegistry.isRegistered(exports.ModuleNames.EnterpriseCoreModule);
	        logger.log("initialised successfully, enterprise = " + isEnterprise);
	    };
	    GridCoreCreator.prototype.registerStackComponents = function (context, registeredModules) {
	        var agStackComponents = this.createAgStackComponentsList(registeredModules);
	        var agStackComponentsRegistry = context.getBean('agStackComponentsRegistry');
	        agStackComponentsRegistry.setupComponents(agStackComponents);
	    };
	    GridCoreCreator.prototype.getRegisteredModules = function (params) {
	        var passedViaConstructor = params ? params.modules : null;
	        var registered = ModuleRegistry.getRegisteredModules();
	        var allModules = [];
	        var mapNames = {};
	        // adds to list and removes duplicates
	        function addModule(moduleBased, mod) {
	            function addIndividualModule(currentModule) {
	                if (!mapNames[currentModule.moduleName]) {
	                    mapNames[currentModule.moduleName] = true;
	                    allModules.push(currentModule);
	                    ModuleRegistry.register(currentModule, moduleBased);
	                }
	            }
	            addIndividualModule(mod);
	            if (mod.dependantModules) {
	                mod.dependantModules.forEach(addModule.bind(null, moduleBased));
	            }
	        }
	        if (passedViaConstructor) {
	            passedViaConstructor.forEach(addModule.bind(null, true));
	        }
	        if (registered) {
	            registered.forEach(addModule.bind(null, !ModuleRegistry.isPackageBased()));
	        }
	        return allModules;
	    };
	    GridCoreCreator.prototype.registerModuleUserComponents = function (context, registeredModules) {
	        var userComponentRegistry = context.getBean('userComponentRegistry');
	        var moduleUserComps = this.extractModuleEntity(registeredModules, function (module) { return module.userComponents ? module.userComponents : []; });
	        moduleUserComps.forEach(function (compMeta) {
	            userComponentRegistry.registerDefaultComponent(compMeta.componentName, compMeta.componentClass);
	        });
	    };
	    GridCoreCreator.prototype.createProvidedBeans = function (eGridDiv, gridOptions, params) {
	        var frameworkOverrides = params ? params.frameworkOverrides : null;
	        if (missing(frameworkOverrides)) {
	            frameworkOverrides = new VanillaFrameworkOverrides();
	        }
	        var seed = {
	            gridOptions: gridOptions,
	            eGridDiv: eGridDiv,
	            $scope: params ? params.$scope : null,
	            $compile: params ? params.$compile : null,
	            globalEventListener: params ? params.globalEventListener : null,
	            frameworkOverrides: frameworkOverrides
	        };
	        if (params && params.providedBeanInstances) {
	            assign(seed, params.providedBeanInstances);
	        }
	        return seed;
	    };
	    GridCoreCreator.prototype.createAgStackComponentsList = function (registeredModules) {
	        var components = [
	            { componentName: 'AgCheckbox', componentClass: AgCheckbox },
	            { componentName: 'AgRadioButton', componentClass: AgRadioButton },
	            { componentName: 'AgToggleButton', componentClass: AgToggleButton },
	            { componentName: 'AgInputTextField', componentClass: AgInputTextField },
	            { componentName: 'AgInputTextArea', componentClass: AgInputTextArea },
	            { componentName: 'AgInputNumberField', componentClass: AgInputNumberField },
	            { componentName: 'AgInputRange', componentClass: AgInputRange },
	            { componentName: 'AgSelect', componentClass: AgSelect },
	            { componentName: 'AgSlider', componentClass: AgSlider },
	            { componentName: 'AgAngleSelect', componentClass: AgAngleSelect },
	            { componentName: 'AgColorPicker', componentClass: AgColorPicker },
	            { componentName: 'AgGridBody', componentClass: GridBodyComp },
	            { componentName: 'AgHeaderRoot', componentClass: HeaderRootComp },
	            { componentName: 'AgPagination', componentClass: PaginationComp },
	            { componentName: 'AgOverlayWrapper', componentClass: OverlayWrapperComponent },
	            { componentName: 'AgGroupComponent', componentClass: AgGroupComponent },
	            { componentName: 'AgPanel', componentClass: AgPanel },
	            { componentName: 'AgDialog', componentClass: AgDialog },
	            { componentName: 'AgRowContainer', componentClass: RowContainerComp },
	            { componentName: 'AgFakeHorizontalScroll', componentClass: FakeHorizontalScrollComp }
	        ];
	        var moduleAgStackComps = this.extractModuleEntity(registeredModules, function (module) { return module.agStackComponents ? module.agStackComponents : []; });
	        components = components.concat(moduleAgStackComps);
	        return components;
	    };
	    GridCoreCreator.prototype.createBeansList = function (rowModelType, registeredModules) {
	        var rowModelClass = this.getRowModelClass(rowModelType, registeredModules);
	        if (!rowModelClass) {
	            return;
	        }
	        // beans should only contain SERVICES, it should NEVER contain COMPONENTS
	        var beans = [
	            rowModelClass, Beans, RowPositionUtils, CellPositionUtils, HeaderPositionUtils,
	            PaginationAutoPageSizeService, GridApi, UserComponentRegistry, AgComponentUtils,
	            ComponentMetadataProvider, ResizeObserverService, UserComponentFactory,
	            RowContainerHeightService, AutoHeightCalculator, HorizontalResizeService,
	            PinnedRowModel, DragService, DisplayedGroupCreator, EventService, GridOptionsWrapper,
	            PopupService, SelectionController, FilterManager, ColumnController, HeaderNavigationService,
	            PaginationProxy, RowRenderer, ExpressionService, ColumnFactory, TemplateService,
	            AlignedGridsService, NavigationService, ValueCache, ValueService, LoggerFactory,
	            ColumnUtils, AutoWidthCalculator, StandardMenuFactory, DragAndDropService, ColumnApi,
	            FocusController, MouseEventService, Environment, CellNavigationService, ValueFormatterService,
	            StylingService, ScrollVisibleService, SortController, ColumnHoverService, ColumnAnimationService,
	            SelectableService, AutoGroupColService, ChangeDetectionService, AnimationFrameService,
	            DetailRowCompCache, UndoRedoService, AgStackComponentsRegistry, ColumnDefFactory,
	            RowCssClassCalculator, RowNodeBlockLoader, RowNodeSorter, ControllersService,
	            PinnedWidthService
	        ];
	        var moduleBeans = this.extractModuleEntity(registeredModules, function (module) { return module.beans ? module.beans : []; });
	        beans.push.apply(beans, moduleBeans);
	        // check for duplicates, as different modules could include the same beans that
	        // they depend on, eg ClientSideRowModel in enterprise, and ClientSideRowModel in community
	        var beansNoDuplicates = [];
	        beans.forEach(function (bean) {
	            if (beansNoDuplicates.indexOf(bean) < 0) {
	                beansNoDuplicates.push(bean);
	            }
	        });
	        return beansNoDuplicates;
	    };
	    GridCoreCreator.prototype.extractModuleEntity = function (moduleEntities, extractor) {
	        return [].concat.apply([], moduleEntities.map(extractor));
	    };
	    GridCoreCreator.prototype.setColumnsAndData = function (context) {
	        var gridOptionsWrapper = context.getBean('gridOptionsWrapper');
	        var columnController = context.getBean('columnController');
	        var columnDefs = gridOptionsWrapper.getColumnDefs();
	        columnController.setColumnDefs(columnDefs || [], "gridInitializing");
	        var rowModel = context.getBean('rowModel');
	        rowModel.start();
	    };
	    GridCoreCreator.prototype.dispatchGridReadyEvent = function (context, gridOptions) {
	        var eventService = context.getBean('eventService');
	        var readyEvent = {
	            type: Events.EVENT_GRID_READY,
	            api: gridOptions.api,
	            columnApi: gridOptions.columnApi
	        };
	        eventService.dispatchEvent(readyEvent);
	    };
	    GridCoreCreator.prototype.getRowModelClass = function (rowModelType, registeredModules) {
	        // default to client side
	        if (!rowModelType) {
	            rowModelType = Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        }
	        var rowModelClasses = {};
	        registeredModules.forEach(function (module) {
	            iterateObject(module.rowModels, function (key, value) {
	                rowModelClasses[key] = value;
	            });
	        });
	        var rowModelClass = rowModelClasses[rowModelType];
	        if (exists(rowModelClass)) {
	            return rowModelClass;
	        }
	        if (rowModelType === Constants.ROW_MODEL_TYPE_INFINITE) {
	            console.error("AG Grid: Row Model \"Infinite\" not found. Please ensure the " + exports.ModuleNames.InfiniteRowModelModule + " is registered.';");
	        }
	        console.error('AG Grid: could not find matching row model for rowModelType ' + rowModelType);
	        if (rowModelType === Constants.ROW_MODEL_TYPE_VIEWPORT) {
	            console.error("AG Grid: Row Model \"Viewport\" not found. Please ensure the AG Grid Enterprise Module " + exports.ModuleNames.ViewportRowModelModule + " is registered.';");
	        }
	        if (rowModelType === Constants.ROW_MODEL_TYPE_SERVER_SIDE) {
	            console.error("AG Grid: Row Model \"Server Side\" not found. Please ensure the AG Grid Enterprise Module " + exports.ModuleNames.ServerSideRowModelModule + " is registered.';");
	        }
	        if (rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            console.error("AG Grid: Row Model \"Client Side\" not found. Please ensure the " + exports.ModuleNames.ClientSideRowModelModule + " is registered.';");
	        }
	    };
	    return GridCoreCreator;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function initialiseAgGridWithAngular1(angular) {
	    var angularModule = angular.module("agGrid", []);
	    angularModule.directive("agGrid", function () {
	        return {
	            restrict: "A",
	            controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
	            scope: true
	        };
	    });
	}
	function AngularDirectiveController($element, $scope, $compile, $attrs) {
	    var gridOptions;
	    var keyOfGridInScope = $attrs.agGrid;
	    gridOptions = $scope.$eval(keyOfGridInScope);
	    if (!gridOptions) {
	        console.warn("WARNING - grid options for AG Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");
	        return;
	    }
	    var eGridDiv = $element[0];
	    var gridParams = {
	        $scope: $scope,
	        $compile: $compile
	    };
	    var grid = new Grid(eGridDiv, gridOptions, gridParams);
	    var quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
	    var quickFilterUnregisterFn = $scope.$watch(quickFilterOnScope, function (newFilter) {
	        gridOptions.api.setQuickFilter(newFilter);
	    });
	    $scope.$on("$destroy", function () {
	        quickFilterUnregisterFn();
	        if (grid) {
	            grid.destroy();
	        }
	        grid = null;
	    });
	}

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var registered = false;
	function initialiseAgGridWithWebComponents() {
	    console.warn('ag-grid: initialiseAgGridWithWebComponents is deprecated. Please use the ag-grid-webcomponent dependency instead. ');
	    // only register to WebComponents once
	    if (registered) {
	        return;
	    }
	    registered = true;
	    if (typeof document === 'undefined' || !document.registerElement) {
	        console.error('AG Grid: unable to find document.registerElement() function, unable to initialise AG Grid as a Web Component');
	    }
	    // i don't think this type of extension is possible in TypeScript, so back to
	    // plain Javascript to create this object
	    var AgileGridProto = Object.create(HTMLElement.prototype);
	    // wrap each property with a get and set method, so we can track when changes are done
	    ComponentUtil.ALL_PROPERTIES.forEach(function (key) {
	        Object.defineProperty(AgileGridProto, key, {
	            set: function (v) {
	                this.__agGridSetProperty(key, v);
	            },
	            get: function () {
	                return this.__agGridGetProperty(key);
	            },
	            enumerable: true,
	            configurable: true
	        });
	    });
	    var agGridProtoNoType = AgileGridProto;
	    agGridProtoNoType.__agGridSetProperty = function (key, value) {
	        if (!this.__attributes) {
	            this.__attributes = {};
	        }
	        this.__attributes[key] = value;
	        // keeping this consistent with the ng2 onChange, so I can reuse the handling code
	        var changeObject = {};
	        changeObject[key] = { currentValue: value };
	        this.onChange(changeObject);
	    };
	    agGridProtoNoType.onChange = function (changes) {
	        if (this._initialised) {
	            ComponentUtil.processOnChange(changes, this._gridOptions, this.api, this.columnApi);
	        }
	    };
	    agGridProtoNoType.__agGridGetProperty = function (key) {
	        if (!this.__attributes) {
	            this.__attributes = {};
	        }
	        return this.__attributes[key];
	    };
	    agGridProtoNoType.setGridOptions = function (options) {
	        var globalEventListener = this.globalEventListener.bind(this);
	        this._gridOptions = ComponentUtil.copyAttributesToGridOptions(options, this);
	        var gridParams = {
	            globalEventListener: globalEventListener
	        };
	        this._agGrid = new Grid(this, this._gridOptions, gridParams);
	        this.api = options.api;
	        this.columnApi = options.columnApi;
	        this._initialised = true;
	    };
	    // copies all the attributes into this object
	    agGridProtoNoType.createdCallback = function () {
	        for (var i = 0; i < this.attributes.length; i++) {
	            var attribute = this.attributes[i];
	            this.setPropertyFromAttribute(attribute);
	        }
	    };
	    agGridProtoNoType.setPropertyFromAttribute = function (attribute) {
	        var name = toCamelCase(attribute.nodeName);
	        var value = attribute.nodeValue;
	        if (ComponentUtil.ALL_PROPERTIES.indexOf(name) >= 0) {
	            this[name] = value;
	        }
	    };
	    agGridProtoNoType.attachedCallback = function (params) { };
	    agGridProtoNoType.detachedCallback = function (params) { };
	    agGridProtoNoType.attributeChangedCallback = function (attributeName) {
	        var attribute = this.attributes[attributeName];
	        this.setPropertyFromAttribute(attribute);
	    };
	    agGridProtoNoType.globalEventListener = function (eventType, event) {
	        var eventLowerCase = eventType.toLowerCase();
	        var browserEvent = new Event(eventLowerCase);
	        var browserEventNoType = browserEvent;
	        browserEventNoType.agGridDetails = event;
	        this.dispatchEvent(browserEvent);
	        var callbackMethod = 'on' + eventLowerCase;
	        if (typeof this[callbackMethod] === 'function') {
	            this[callbackMethod](browserEvent);
	        }
	    };
	    // finally, register
	    document.registerElement('ag-grid', { prototype: AgileGridProto });
	}
	function toCamelCase(myString) {
	    if (typeof myString === 'string') {
	        var result = myString.replace(/-([a-z])/g, function (g) {
	            return g[1].toUpperCase();
	        });
	        return result;
	    }
	    else {
	        return myString;
	    }
	}

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2i = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$26 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TabbedLayout = /** @class */ (function (_super) {
	    __extends$2i(TabbedLayout, _super);
	    function TabbedLayout(params) {
	        var _this = _super.call(this, TabbedLayout.getTemplate(params.cssClass)) || this;
	        _this.items = [];
	        _this.params = params;
	        if (params.items) {
	            params.items.forEach(function (item) { return _this.addItem(item); });
	        }
	        return _this;
	    }
	    TabbedLayout.getTemplate = function (cssClass) {
	        return /* html */ "<div class=\"ag-tabs " + cssClass + "\">\n            <div ref=\"eHeader\" role=\"menu\" class=\"ag-tabs-header " + (cssClass ? cssClass + "-header" : '') + "\"></div>\n            <div ref=\"eBody\" role=\"presentation\" class=\"ag-tabs-body " + (cssClass ? cssClass + "-body" : '') + "\"></div>\n        </div>";
	    };
	    TabbedLayout.prototype.handleKeyDown = function (e) {
	        switch (e.keyCode) {
	            case KeyCode.RIGHT:
	            case KeyCode.LEFT:
	                if (!this.eHeader.contains(document.activeElement)) {
	                    return;
	                }
	                var currentPosition = this.items.indexOf(this.activeItem);
	                var nextPosition = e.keyCode === KeyCode.RIGHT ? Math.min(currentPosition + 1, this.items.length - 1) : Math.max(currentPosition - 1, 0);
	                if (currentPosition === nextPosition) {
	                    return;
	                }
	                e.preventDefault();
	                var nextItem = this.items[nextPosition];
	                this.showItemWrapper(nextItem);
	                nextItem.eHeaderButton.focus();
	                break;
	            case KeyCode.UP:
	            case KeyCode.DOWN:
	                e.stopPropagation();
	                break;
	        }
	    };
	    TabbedLayout.prototype.onTabKeyDown = function (e) {
	        if (e.defaultPrevented) {
	            return;
	        }
	        var _a = this, focusController = _a.focusController, eHeader = _a.eHeader, eBody = _a.eBody, activeItem = _a.activeItem;
	        var activeElement = document.activeElement;
	        e.preventDefault();
	        if (eHeader.contains(activeElement)) {
	            // focus is in header, move into body of popup
	            focusController.focusInto(eBody, e.shiftKey);
	        }
	        else {
	            // focus is in body, establish if it should return to header
	            if (focusController.isFocusUnderManagedComponent(eBody)) {
	                // focus was in a managed focus component and has now left, so we can return to the header
	                activeItem.eHeaderButton.focus();
	            }
	            else {
	                var nextEl = focusController.findNextFocusableElement(eBody, false, e.shiftKey);
	                if (nextEl) {
	                    // if another element exists in the body that can be focussed, go to that
	                    nextEl.focus();
	                }
	                else {
	                    // otherwise return to the header
	                    activeItem.eHeaderButton.focus();
	                }
	            }
	        }
	    };
	    TabbedLayout.prototype.setAfterAttachedParams = function (params) {
	        this.afterAttachedParams = params;
	    };
	    TabbedLayout.prototype.getMinDimensions = function () {
	        var eDummyContainer = this.getGui().cloneNode(true);
	        var eDummyBody = eDummyContainer.querySelector('[ref="eBody"]');
	        // position fixed, so it isn't restricted to the boundaries of the parent
	        eDummyContainer.style.position = 'fixed';
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        this.getGui().appendChild(eDummyContainer);
	        var minWidth = 0;
	        var minHeight = 0;
	        this.items.forEach(function (itemWrapper) {
	            clearElement(eDummyBody);
	            var eClone = itemWrapper.tabbedItem.bodyPromise.resolveNow(null, function (body) { return body.cloneNode(true); });
	            if (eClone == null) {
	                return;
	            }
	            eDummyBody.appendChild(eClone);
	            if (minWidth < eDummyContainer.offsetWidth) {
	                minWidth = eDummyContainer.offsetWidth;
	            }
	            if (minHeight < eDummyContainer.offsetHeight) {
	                minHeight = eDummyContainer.offsetHeight;
	            }
	        });
	        this.getGui().removeChild(eDummyContainer);
	        return { height: minHeight, width: minWidth };
	    };
	    TabbedLayout.prototype.showFirstItem = function () {
	        if (this.items.length > 0) {
	            this.showItemWrapper(this.items[0]);
	        }
	    };
	    TabbedLayout.prototype.addItem = function (item) {
	        var eHeaderButton = document.createElement('span');
	        eHeaderButton.setAttribute('tabIndex', '-1');
	        eHeaderButton.setAttribute('role', 'menuitem');
	        eHeaderButton.appendChild(item.title);
	        addCssClass(eHeaderButton, 'ag-tab');
	        this.eHeader.appendChild(eHeaderButton);
	        setAriaLabel(eHeaderButton, item.titleLabel);
	        var wrapper = {
	            tabbedItem: item,
	            eHeaderButton: eHeaderButton
	        };
	        this.items.push(wrapper);
	        eHeaderButton.addEventListener('click', this.showItemWrapper.bind(this, wrapper));
	    };
	    TabbedLayout.prototype.showItem = function (tabbedItem) {
	        var itemWrapper = find(this.items, function (wrapper) { return wrapper.tabbedItem === tabbedItem; });
	        if (itemWrapper) {
	            this.showItemWrapper(itemWrapper);
	        }
	    };
	    TabbedLayout.prototype.showItemWrapper = function (wrapper) {
	        var _this = this;
	        if (this.params.onItemClicked) {
	            this.params.onItemClicked({ item: wrapper.tabbedItem });
	        }
	        if (this.activeItem === wrapper) {
	            callIfPresent(this.params.onActiveItemClicked);
	            return;
	        }
	        clearElement(this.eBody);
	        wrapper.tabbedItem.bodyPromise.then(function (body) {
	            _this.eBody.appendChild(body);
	            var onlyUnmanaged = !_this.focusController.isKeyboardMode();
	            _this.focusController.focusInto(_this.eBody, false, onlyUnmanaged);
	            if (wrapper.tabbedItem.afterAttachedCallback) {
	                wrapper.tabbedItem.afterAttachedCallback(_this.afterAttachedParams);
	            }
	        });
	        if (this.activeItem) {
	            removeCssClass(this.activeItem.eHeaderButton, 'ag-tab-selected');
	        }
	        addCssClass(wrapper.eHeaderButton, 'ag-tab-selected');
	        this.activeItem = wrapper;
	    };
	    __decorate$26([
	        RefSelector('eHeader')
	    ], TabbedLayout.prototype, "eHeader", void 0);
	    __decorate$26([
	        RefSelector('eBody')
	    ], TabbedLayout.prototype, "eBody", void 0);
	    return TabbedLayout;
	}(ManagedFocusComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function simpleHttpRequest(params) {
	    return new AgPromise(function (resolve) {
	        var httpRequest = new XMLHttpRequest();
	        httpRequest.open('GET', params.url);
	        httpRequest.send();
	        httpRequest.onreadystatechange = function () {
	            if (httpRequest.readyState === 4 && httpRequest.status === 200) {
	                resolve(JSON.parse(httpRequest.responseText));
	            }
	        };
	    });
	}

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (ServerSideTransactionResultStatus) {
	    ServerSideTransactionResultStatus["StoreNotFound"] = "StoreNotFound";
	    ServerSideTransactionResultStatus["StoreLoading"] = "StoreLoading";
	    ServerSideTransactionResultStatus["StoreWaitingToLoad"] = "StoreWaitingToLoad";
	    ServerSideTransactionResultStatus["StoreLoadingFailed"] = "StoreLoadingFailed";
	    ServerSideTransactionResultStatus["StoreWrongType"] = "StoreWrongType";
	    ServerSideTransactionResultStatus["Applied"] = "Applied";
	    ServerSideTransactionResultStatus["Cancelled"] = "Cancelled";
	})(exports.ServerSideTransactionResultStatus || (exports.ServerSideTransactionResultStatus = {}));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var __extends$2j = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$27 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var VirtualList = /** @class */ (function (_super) {
	    __extends$2j(VirtualList, _super);
	    function VirtualList(cssIdentifier, ariaRole) {
	        if (cssIdentifier === void 0) { cssIdentifier = 'default'; }
	        if (ariaRole === void 0) { ariaRole = 'listbox'; }
	        var _this = _super.call(this, VirtualList.getTemplate(cssIdentifier), true) || this;
	        _this.cssIdentifier = cssIdentifier;
	        _this.ariaRole = ariaRole;
	        _this.renderedRows = new Map();
	        _this.rowHeight = 20;
	        _this.isDestroyed = false;
	        return _this;
	    }
	    VirtualList.prototype.postConstruct = function () {
	        this.addScrollListener();
	        this.rowHeight = this.getItemHeight();
	        this.addResizeObserver();
	        _super.prototype.postConstruct.call(this);
	    };
	    VirtualList.prototype.addResizeObserver = function () {
	        var listener = this.drawVirtualRows.bind(this);
	        var destroyObserver = this.resizeObserverService.observeResize(this.getGui(), listener);
	        this.addDestroyFunc(destroyObserver);
	    };
	    VirtualList.prototype.focusInnerElement = function (fromBottom) {
	        this.focusRow(fromBottom ? this.model.getRowCount() - 1 : 0);
	    };
	    VirtualList.prototype.onFocusIn = function (e) {
	        _super.prototype.onFocusIn.call(this, e);
	        var target = e.target;
	        if (containsClass(target, 'ag-virtual-list-item')) {
	            this.lastFocusedRowIndex = getAriaPosInSet(target) - 1;
	        }
	    };
	    VirtualList.prototype.onFocusOut = function (e) {
	        _super.prototype.onFocusOut.call(this, e);
	        if (!this.getFocusableElement().contains(e.relatedTarget)) {
	            this.lastFocusedRowIndex = null;
	        }
	    };
	    VirtualList.prototype.handleKeyDown = function (e) {
	        switch (e.keyCode) {
	            case KeyCode.UP:
	            case KeyCode.DOWN:
	                if (this.navigate(e.keyCode === KeyCode.UP)) {
	                    e.preventDefault();
	                }
	                break;
	        }
	    };
	    VirtualList.prototype.onTabKeyDown = function (e) {
	        if (this.navigate(e.shiftKey)) {
	            e.preventDefault();
	        }
	        else {
	            // focus on the first or last focusable element to ensure that any other handlers start from there
	            this.focusController.focusInto(this.getGui(), !e.shiftKey);
	        }
	    };
	    VirtualList.prototype.navigate = function (up) {
	        if (this.lastFocusedRowIndex == null) {
	            return false;
	        }
	        var nextRow = this.lastFocusedRowIndex + (up ? -1 : 1);
	        if (nextRow < 0 || nextRow >= this.model.getRowCount()) {
	            return false;
	        }
	        this.focusRow(nextRow);
	        return true;
	    };
	    VirtualList.prototype.getLastFocusedRow = function () {
	        return this.lastFocusedRowIndex;
	    };
	    VirtualList.prototype.focusRow = function (rowNumber) {
	        var _this = this;
	        this.ensureIndexVisible(rowNumber);
	        window.setTimeout(function () {
	            var renderedRow = _this.renderedRows.get(rowNumber);
	            if (renderedRow) {
	                renderedRow.eDiv.focus();
	            }
	        }, 10);
	    };
	    VirtualList.prototype.getComponentAt = function (rowIndex) {
	        var comp = this.renderedRows.get(rowIndex);
	        return comp && comp.rowComponent;
	    };
	    VirtualList.getTemplate = function (cssIdentifier) {
	        return /* html */ "\n            <div class=\"ag-virtual-list-viewport ag-" + cssIdentifier + "-virtual-list-viewport\" role=\"listbox\">\n                <div class=\"ag-virtual-list-container ag-" + cssIdentifier + "-virtual-list-container\" ref=\"eContainer\"></div>\n            </div>";
	    };
	    VirtualList.prototype.getItemHeight = function () {
	        return this.gridOptionsWrapper.getListItemHeight();
	    };
	    VirtualList.prototype.ensureIndexVisible = function (index) {
	        var lastRow = this.model.getRowCount();
	        if (typeof index !== 'number' || index < 0 || index >= lastRow) {
	            console.warn('invalid row index for ensureIndexVisible: ' + index);
	            return;
	        }
	        var rowTopPixel = index * this.rowHeight;
	        var rowBottomPixel = rowTopPixel + this.rowHeight;
	        var eGui = this.getGui();
	        var viewportTopPixel = eGui.scrollTop;
	        var viewportHeight = eGui.offsetHeight;
	        var viewportBottomPixel = viewportTopPixel + viewportHeight;
	        var viewportScrolledPastRow = viewportTopPixel > rowTopPixel;
	        var viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel;
	        if (viewportScrolledPastRow) {
	            // if row is before, scroll up with row at top
	            eGui.scrollTop = rowTopPixel;
	        }
	        else if (viewportScrolledBeforeRow) {
	            // if row is below, scroll down with row at bottom
	            var newScrollPosition = rowBottomPixel - viewportHeight;
	            eGui.scrollTop = newScrollPosition;
	        }
	    };
	    VirtualList.prototype.setComponentCreator = function (componentCreator) {
	        this.componentCreator = componentCreator;
	    };
	    VirtualList.prototype.getRowHeight = function () {
	        return this.rowHeight;
	    };
	    VirtualList.prototype.getScrollTop = function () {
	        return this.getGui().scrollTop;
	    };
	    VirtualList.prototype.setRowHeight = function (rowHeight) {
	        this.rowHeight = rowHeight;
	        this.refresh();
	    };
	    VirtualList.prototype.refresh = function () {
	        var _this = this;
	        if (this.model == null || this.isDestroyed) {
	            return;
	        }
	        var rowCount = this.model.getRowCount();
	        this.eContainer.style.height = rowCount * this.rowHeight + "px";
	        // ensure height is applied before attempting to redraw rows
	        waitUntil(function () { return _this.eContainer.clientHeight >= rowCount * _this.rowHeight; }, function () {
	            if (_this.isDestroyed) {
	                return;
	            }
	            _this.clearVirtualRows();
	            _this.drawVirtualRows();
	        });
	    };
	    VirtualList.prototype.clearVirtualRows = function () {
	        var _this = this;
	        this.renderedRows.forEach(function (_, rowIndex) { return _this.removeRow(rowIndex); });
	    };
	    VirtualList.prototype.drawVirtualRows = function () {
	        var gui = this.getGui();
	        var topPixel = gui.scrollTop;
	        var bottomPixel = topPixel + gui.offsetHeight;
	        var firstRow = Math.floor(topPixel / this.rowHeight);
	        var lastRow = Math.floor(bottomPixel / this.rowHeight);
	        this.ensureRowsRendered(firstRow, lastRow);
	    };
	    VirtualList.prototype.ensureRowsRendered = function (start, finish) {
	        var _this = this;
	        // remove any rows that are no longer required
	        this.renderedRows.forEach(function (_, rowIndex) {
	            if ((rowIndex < start || rowIndex > finish) && rowIndex !== _this.lastFocusedRowIndex) {
	                _this.removeRow(rowIndex);
	            }
	        });
	        // insert any required new rows
	        for (var rowIndex = start; rowIndex <= finish; rowIndex++) {
	            if (this.renderedRows.has(rowIndex)) {
	                continue;
	            }
	            // check this row actually exists (in case overflow buffer window exceeds real data)
	            if (rowIndex < this.model.getRowCount()) {
	                this.insertRow(rowIndex);
	            }
	        }
	    };
	    VirtualList.prototype.insertRow = function (rowIndex) {
	        var _this = this;
	        var value = this.model.getRow(rowIndex);
	        var eDiv = document.createElement('div');
	        addCssClass(eDiv, 'ag-virtual-list-item');
	        addCssClass(eDiv, "ag-" + this.cssIdentifier + "-virtual-list-item");
	        eDiv.setAttribute('role', this.ariaRole === 'tree' ? 'treeitem' : 'option');
	        setAriaSetSize(eDiv, this.model.getRowCount());
	        setAriaPosInSet(eDiv, rowIndex + 1);
	        eDiv.setAttribute('tabindex', '-1');
	        if (typeof this.model.isRowSelected === 'function') {
	            var isSelected = this.model.isRowSelected(rowIndex);
	            setAriaSelected(eDiv, !!isSelected);
	            setAriaChecked(eDiv, isSelected);
	        }
	        eDiv.style.height = this.rowHeight + "px";
	        eDiv.style.top = this.rowHeight * rowIndex + "px";
	        var rowComponent = this.componentCreator(value, eDiv);
	        rowComponent.addGuiEventListener('focusin', function () { return _this.lastFocusedRowIndex = rowIndex; });
	        eDiv.appendChild(rowComponent.getGui());
	        // keep the DOM order consistent with the order of the rows
	        if (this.renderedRows.has(rowIndex - 1)) {
	            this.renderedRows.get(rowIndex - 1).eDiv.insertAdjacentElement('afterend', eDiv);
	        }
	        else if (this.renderedRows.has(rowIndex + 1)) {
	            this.renderedRows.get(rowIndex + 1).eDiv.insertAdjacentElement('beforebegin', eDiv);
	        }
	        else {
	            this.eContainer.appendChild(eDiv);
	        }
	        this.renderedRows.set(rowIndex, { rowComponent: rowComponent, eDiv: eDiv });
	    };
	    VirtualList.prototype.removeRow = function (rowIndex) {
	        var component = this.renderedRows.get(rowIndex);
	        this.eContainer.removeChild(component.eDiv);
	        this.destroyBean(component.rowComponent);
	        this.renderedRows.delete(rowIndex);
	    };
	    VirtualList.prototype.addScrollListener = function () {
	        var _this = this;
	        this.addGuiEventListener('scroll', function () { return _this.drawVirtualRows(); });
	    };
	    VirtualList.prototype.setModel = function (model) {
	        this.model = model;
	    };
	    VirtualList.prototype.destroy = function () {
	        if (this.isDestroyed) {
	            return;
	        }
	        this.clearVirtualRows();
	        this.isDestroyed = true;
	        _super.prototype.destroy.call(this);
	    };
	    __decorate$27([
	        Autowired('resizeObserverService')
	    ], VirtualList.prototype, "resizeObserverService", void 0);
	    __decorate$27([
	        RefSelector('eContainer')
	    ], VirtualList.prototype, "eContainer", void 0);
	    return VirtualList;
	}(ManagedFocusComponent));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	function defaultGroupComparator(valueA, valueB, nodeA, nodeB, accentedCompare) {
	    if (accentedCompare === void 0) { accentedCompare = false; }
	    console.warn('AG Grid: Since ag-grid 11.0.0 defaultGroupComparator is not necessary. You can remove this from your colDef');
	    var nodeAIsGroup = exists(nodeA) && nodeA.group;
	    var nodeBIsGroup = exists(nodeB) && nodeB.group;
	    var bothAreGroups = nodeAIsGroup && nodeBIsGroup;
	    var bothAreNormal = !nodeAIsGroup && !nodeBIsGroup;
	    if (bothAreGroups) {
	        return defaultComparator(nodeA.key, nodeB.key, accentedCompare);
	    }
	    if (bothAreNormal) {
	        return defaultComparator(valueA, valueB, accentedCompare);
	    }
	    if (nodeAIsGroup) {
	        return 1;
	    }
	    return -1;
	}

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (ServerSideStoreType) {
	    ServerSideStoreType["Full"] = "full";
	    ServerSideStoreType["Partial"] = "partial";
	})(exports.ServerSideStoreType || (exports.ServerSideStoreType = {}));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var BaseComponentWrapper = /** @class */ (function () {
	    function BaseComponentWrapper() {
	    }
	    BaseComponentWrapper.prototype.wrap = function (OriginalConstructor, mandatoryMethodList, optionalMethodList, componentType, componentName) {
	        var _this = this;
	        if (optionalMethodList === void 0) { optionalMethodList = []; }
	        var wrapper = this.createWrapper(OriginalConstructor, componentType, componentName);
	        mandatoryMethodList.forEach((function (methodName) {
	            _this.createMethod(wrapper, methodName, true);
	        }));
	        optionalMethodList.forEach((function (methodName) {
	            _this.createMethod(wrapper, methodName, false);
	        }));
	        return wrapper;
	    };
	    BaseComponentWrapper.prototype.createMethod = function (wrapper, methodName, mandatory) {
	        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
	    };
	    BaseComponentWrapper.prototype.createMethodProxy = function (wrapper, methodName, mandatory) {
	        return function () {
	            if (wrapper.hasMethod(methodName)) {
	                return wrapper.callMethod(methodName, arguments);
	            }
	            if (mandatory) {
	                console.warn('AG Grid: Framework component is missing the method ' + methodName + '()');
	            }
	            return null;
	        };
	    };
	    return BaseComponentWrapper;
	}());

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	(function (ChartType) {
	    ChartType["Column"] = "column";
	    ChartType["GroupedColumn"] = "groupedColumn";
	    ChartType["StackedColumn"] = "stackedColumn";
	    ChartType["NormalizedColumn"] = "normalizedColumn";
	    ChartType["Bar"] = "bar";
	    ChartType["GroupedBar"] = "groupedBar";
	    ChartType["StackedBar"] = "stackedBar";
	    ChartType["NormalizedBar"] = "normalizedBar";
	    ChartType["Line"] = "line";
	    ChartType["Scatter"] = "scatter";
	    ChartType["Bubble"] = "bubble";
	    ChartType["Pie"] = "pie";
	    ChartType["Doughnut"] = "doughnut";
	    ChartType["Area"] = "area";
	    ChartType["StackedArea"] = "stackedArea";
	    ChartType["NormalizedArea"] = "normalizedArea";
	    ChartType["Histogram"] = "histogram";
	})(exports.ChartType || (exports.ChartType = {}));
	(function (LegendPosition) {
	    LegendPosition["Top"] = "top";
	    LegendPosition["Right"] = "right";
	    LegendPosition["Bottom"] = "bottom";
	    LegendPosition["Left"] = "left";
	})(exports.LegendPosition || (exports.LegendPosition = {}));

	/**
	 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v25.3.0
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	var globalObj = typeof commonjsGlobal === 'undefined' ? {} : commonjsGlobal;
	globalObj.HTMLElement = typeof HTMLElement === 'undefined' ? {} : HTMLElement;
	globalObj.HTMLButtonElement = typeof HTMLButtonElement === 'undefined' ? {} : HTMLButtonElement;
	globalObj.HTMLSelectElement = typeof HTMLSelectElement === 'undefined' ? {} : HTMLSelectElement;
	globalObj.HTMLInputElement = typeof HTMLInputElement === 'undefined' ? {} : HTMLInputElement;
	globalObj.Node = typeof Node === 'undefined' ? {} : Node;
	globalObj.MouseEvent = typeof MouseEvent === 'undefined' ? {} : MouseEvent;

	var __spreadArrays$8 = function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var ClientSideNodeManager = /** @class */ (function () {
	    function ClientSideNodeManager(rootNode, gridOptionsWrapper, context, eventService, columnController, gridApi, columnApi, selectionController) {
	        this.nextId = 0;
	        // when user is provide the id's, we also keep a map of ids to row nodes for convenience
	        this.allNodesMap = {};
	        this.rootNode = rootNode;
	        this.gridOptionsWrapper = gridOptionsWrapper;
	        this.context = context;
	        this.eventService = eventService;
	        this.columnController = columnController;
	        this.gridApi = gridApi;
	        this.columnApi = columnApi;
	        this.selectionController = selectionController;
	        this.rootNode.group = true;
	        this.rootNode.level = -1;
	        this.rootNode.id = ClientSideNodeManager.ROOT_NODE_ID;
	        this.rootNode.allLeafChildren = [];
	        this.rootNode.childrenAfterGroup = [];
	        this.rootNode.childrenAfterSort = [];
	        this.rootNode.childrenAfterFilter = [];
	        // if we make this class a bean, then can annotate postConstruct
	        this.postConstruct();
	    }
	    // @PostConstruct - this is not a bean, so postConstruct called by constructor
	    ClientSideNodeManager.prototype.postConstruct = function () {
	        // func below doesn't have 'this' pointer, so need to pull out these bits
	        this.suppressParentsInRowNodes = this.gridOptionsWrapper.isSuppressParentsInRowNodes();
	        this.isRowMasterFunc = this.gridOptionsWrapper.getIsRowMasterFunc();
	        this.doingTreeData = this.gridOptionsWrapper.isTreeData();
	        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
	    };
	    ClientSideNodeManager.prototype.getCopyOfNodesMap = function () {
	        return _.cloneObject(this.allNodesMap);
	    };
	    ClientSideNodeManager.prototype.getRowNode = function (id) {
	        return this.allNodesMap[id];
	    };
	    ClientSideNodeManager.prototype.setRowData = function (rowData) {
	        this.rootNode.childrenAfterFilter = null;
	        this.rootNode.childrenAfterGroup = null;
	        this.rootNode.childrenAfterSort = null;
	        this.rootNode.childrenMapped = null;
	        this.rootNode.updateHasChildren();
	        this.nextId = 0;
	        this.allNodesMap = {};
	        if (!rowData) {
	            this.rootNode.allLeafChildren = [];
	            this.rootNode.childrenAfterGroup = [];
	            return;
	        }
	        // kick off recursion
	        // we add rootNode as the parent, however if using ag-grid-enterprise, the grouping stage
	        // sets the parent node on each row (even if we are not grouping). so setting parent node
	        // here is for benefit of ag-grid-community users
	        this.rootNode.allLeafChildren = this.recursiveFunction(rowData, this.rootNode, ClientSideNodeManager.TOP_LEVEL);
	    };
	    ClientSideNodeManager.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
	        var rowNodeTransaction = {
	            remove: [],
	            update: [],
	            add: []
	        };
	        var nodesToUnselect = [];
	        this.executeRemove(rowDataTran, rowNodeTransaction, nodesToUnselect);
	        this.executeUpdate(rowDataTran, rowNodeTransaction, nodesToUnselect);
	        this.executeAdd(rowDataTran, rowNodeTransaction);
	        this.updateSelection(nodesToUnselect);
	        if (rowNodeOrder) {
	            _.sortRowNodesByOrder(this.rootNode.allLeafChildren, rowNodeOrder);
	        }
	        return rowNodeTransaction;
	    };
	    ClientSideNodeManager.prototype.updateSelection = function (nodesToUnselect) {
	        var selectionChanged = nodesToUnselect.length > 0;
	        if (selectionChanged) {
	            nodesToUnselect.forEach(function (rowNode) {
	                rowNode.setSelected(false, false, true);
	            });
	        }
	        // we do this regardless of nodes to unselect or not, as it's possible
	        // a new node was inserted, so a parent that was previously selected (as all
	        // children were selected) should not be tri-state (as new one unselected against
	        // all other selected children).
	        this.selectionController.updateGroupsFromChildrenSelections();
	        if (selectionChanged) {
	            var event_1 = {
	                type: Events.EVENT_SELECTION_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    ClientSideNodeManager.prototype.executeAdd = function (rowDataTran, rowNodeTransaction) {
	        var _this = this;
	        var add = rowDataTran.add, addIndex = rowDataTran.addIndex;
	        if (_.missingOrEmpty(add)) {
	            return;
	        }
	        // create new row nodes for each data item
	        var newNodes = add.map(function (item) { return _this.createNode(item, _this.rootNode, ClientSideNodeManager.TOP_LEVEL); });
	        // add new row nodes to the root nodes 'allLeafChildren'
	        var useIndex = typeof addIndex === 'number' && addIndex >= 0;
	        if (useIndex) {
	            // new rows are inserted in one go by concatenating them in between the existing rows at the desired index.
	            // this is much faster than splicing them individually into 'allLeafChildren' when there are large inserts.
	            var existingLeafChildren = this.rootNode.allLeafChildren;
	            var nodesBeforeIndex = existingLeafChildren.slice(0, addIndex);
	            var nodesAfterIndex = existingLeafChildren.slice(addIndex, existingLeafChildren.length);
	            this.rootNode.allLeafChildren = __spreadArrays$8(nodesBeforeIndex, newNodes, nodesAfterIndex);
	        }
	        else {
	            this.rootNode.allLeafChildren = __spreadArrays$8(this.rootNode.allLeafChildren, newNodes);
	        }
	        // add new row nodes to the transaction add items
	        rowNodeTransaction.add = newNodes;
	    };
	    ClientSideNodeManager.prototype.executeRemove = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
	        var _this = this;
	        var remove = rowDataTran.remove;
	        if (_.missingOrEmpty(remove)) {
	            return;
	        }
	        var rowIdsRemoved = {};
	        remove.forEach(function (item) {
	            var rowNode = _this.lookupRowNode(item);
	            if (!rowNode) {
	                return;
	            }
	            // do delete - setting 'suppressFinishActions = true' to ensure EVENT_SELECTION_CHANGED is not raised for
	            // each row node updated, instead it is raised once by the calling code if any selected nodes exist.
	            if (rowNode.isSelected()) {
	                nodesToUnselect.push(rowNode);
	            }
	            // so row renderer knows to fade row out (and not reposition it)
	            rowNode.clearRowTopAndRowIndex();
	            // NOTE: were we could remove from allLeaveChildren, however _.removeFromArray() is expensive, especially
	            // if called multiple times (eg deleting lots of rows) and if allLeafChildren is a large list
	            rowIdsRemoved[rowNode.id] = true;
	            // _.removeFromArray(this.rootNode.allLeafChildren, rowNode);
	            delete _this.allNodesMap[rowNode.id];
	            rowNodeTransaction.remove.push(rowNode);
	        });
	        this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter(function (rowNode) { return !rowIdsRemoved[rowNode.id]; });
	    };
	    ClientSideNodeManager.prototype.executeUpdate = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
	        var _this = this;
	        var update = rowDataTran.update;
	        if (_.missingOrEmpty(update)) {
	            return;
	        }
	        update.forEach(function (item) {
	            var rowNode = _this.lookupRowNode(item);
	            if (!rowNode) {
	                return;
	            }
	            rowNode.updateData(item);
	            if (!rowNode.selectable && rowNode.isSelected()) {
	                nodesToUnselect.push(rowNode);
	            }
	            _this.setMasterForRow(rowNode, item, ClientSideNodeManager.TOP_LEVEL, false);
	            rowNodeTransaction.update.push(rowNode);
	        });
	    };
	    ClientSideNodeManager.prototype.lookupRowNode = function (data) {
	        var rowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
	        var rowNode;
	        if (_.exists(rowNodeIdFunc)) {
	            // find rowNode using id
	            var id = rowNodeIdFunc(data);
	            rowNode = this.allNodesMap[id];
	            if (!rowNode) {
	                console.error("AG Grid: could not find row id=" + id + ", data item was not found for this id");
	                return null;
	            }
	        }
	        else {
	            // find rowNode using object references
	            rowNode = _.find(this.rootNode.allLeafChildren, function (node) { return node.data === data; });
	            if (!rowNode) {
	                console.error("AG Grid: could not find data item as object was not found", data);
	                return null;
	            }
	        }
	        return rowNode;
	    };
	    ClientSideNodeManager.prototype.recursiveFunction = function (rowData, parent, level) {
	        var _this = this;
	        // make sure the rowData is an array and not a string of json - this was a commonly reported problem on the forum
	        if (typeof rowData === 'string') {
	            console.warn('AG Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first');
	            return;
	        }
	        var rowNodes = [];
	        rowData.forEach(function (dataItem) {
	            var node = _this.createNode(dataItem, parent, level);
	            rowNodes.push(node);
	        });
	        return rowNodes;
	    };
	    ClientSideNodeManager.prototype.createNode = function (dataItem, parent, level) {
	        var node = new RowNode();
	        this.context.createBean(node);
	        node.group = false;
	        this.setMasterForRow(node, dataItem, level, true);
	        if (parent && !this.suppressParentsInRowNodes) {
	            node.parent = parent;
	        }
	        node.level = level;
	        node.setDataAndId(dataItem, this.nextId.toString());
	        if (this.allNodesMap[node.id]) {
	            console.warn("ag-grid: duplicate node id '" + node.id + "' detected from getRowNodeId callback, this could cause issues in your grid.");
	        }
	        this.allNodesMap[node.id] = node;
	        this.nextId++;
	        return node;
	    };
	    ClientSideNodeManager.prototype.setMasterForRow = function (rowNode, data, level, setExpanded) {
	        if (this.doingTreeData) {
	            rowNode.setMaster(false);
	            if (setExpanded) {
	                rowNode.expanded = false;
	            }
	        }
	        else {
	            // this is the default, for when doing grid data
	            if (this.doingMasterDetail) {
	                // if we are doing master detail, then the
	                // default is that everything can be a Master Row.
	                if (this.isRowMasterFunc) {
	                    rowNode.setMaster(this.isRowMasterFunc(data));
	                }
	                else {
	                    rowNode.setMaster(true);
	                }
	            }
	            else {
	                rowNode.setMaster(false);
	            }
	            if (setExpanded) {
	                var rowGroupColumns = this.columnController.getRowGroupColumns();
	                var numRowGroupColumns = rowGroupColumns ? rowGroupColumns.length : 0;
	                // need to take row group into account when determining level
	                var masterRowLevel = level + numRowGroupColumns;
	                rowNode.expanded = rowNode.master ? this.isExpanded(masterRowLevel) : false;
	            }
	        }
	    };
	    ClientSideNodeManager.prototype.isExpanded = function (level) {
	        var expandByDefault = this.gridOptionsWrapper.getGroupDefaultExpanded();
	        if (expandByDefault === -1) {
	            return true;
	        }
	        return level < expandByDefault;
	    };
	    ClientSideNodeManager.TOP_LEVEL = 0;
	    ClientSideNodeManager.ROOT_NODE_ID = 'ROOT_NODE_ID';
	    return ClientSideNodeManager;
	}());

	var __extends$2k = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$28 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var RecursionType;
	(function (RecursionType) {
	    RecursionType[RecursionType["Normal"] = 0] = "Normal";
	    RecursionType[RecursionType["AfterFilter"] = 1] = "AfterFilter";
	    RecursionType[RecursionType["AfterFilterAndSort"] = 2] = "AfterFilterAndSort";
	    RecursionType[RecursionType["PivotNodes"] = 3] = "PivotNodes";
	})(RecursionType || (RecursionType = {}));
	var ClientSideRowModel = /** @class */ (function (_super) {
	    __extends$2k(ClientSideRowModel, _super);
	    function ClientSideRowModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onRowGroupOpenedPending = false;
	        return _this;
	    }
	    ClientSideRowModel.prototype.init = function () {
	        var refreshEverythingFunc = this.refreshModel.bind(this, { step: exports.ClientSideRowModelSteps.EVERYTHING });
	        var refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, {
	            step: exports.ClientSideRowModelSteps.EVERYTHING,
	            afterColumnsChanged: true,
	            keepRenderedRows: true,
	            animate: true
	        });
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refreshEverythingAfterColsChangedFunc);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, refreshEverythingFunc);
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, { step: exports.ClientSideRowModelSteps.PIVOT }));
	        this.addManagedListener(this.eventService, Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, refreshEverythingFunc);
	        var refreshMapListener = this.refreshModel.bind(this, {
	            step: exports.ClientSideRowModelSteps.MAP,
	            keepRenderedRows: true,
	            animate: true
	        });
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, refreshMapListener);
	        this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, refreshMapListener);
	        this.rootNode = new RowNode();
	        this.nodeManager = new ClientSideNodeManager(this.rootNode, this.gridOptionsWrapper, this.getContext(), this.eventService, this.columnController, this.gridApi, this.columnApi, this.selectionController);
	        this.createBean(this.rootNode);
	    };
	    ClientSideRowModel.prototype.start = function () {
	        var rowData = this.gridOptionsWrapper.getRowData();
	        if (rowData) {
	            this.setRowData(rowData);
	        }
	    };
	    ClientSideRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
	        var atLeastOneChange;
	        var res = false;
	        // we do this multiple times as changing the row heights can also change the first and last rows,
	        // so the first pass can make lots of rows smaller, which means the second pass we end up changing
	        // more rows.
	        do {
	            atLeastOneChange = false;
	            var rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
	            var rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
	            // keep check to current page if doing pagination
	            var firstRow = Math.max(rowAtStartPixel, startLimitIndex);
	            var lastRow = Math.min(rowAtEndPixel, endLimitIndex);
	            for (var rowIndex = firstRow; rowIndex <= lastRow; rowIndex++) {
	                var rowNode = this.getRow(rowIndex);
	                if (rowNode.rowHeightEstimated) {
	                    var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode);
	                    rowNode.setRowHeight(rowHeight.height);
	                    atLeastOneChange = true;
	                    res = true;
	                }
	            }
	            if (atLeastOneChange) {
	                this.setRowTops();
	            }
	        } while (atLeastOneChange);
	        return res;
	    };
	    ClientSideRowModel.prototype.setRowTops = function () {
	        var nextRowTop = 0;
	        for (var i = 0; i < this.rowsToDisplay.length; i++) {
	            // we don't estimate if doing fullHeight or autoHeight, as all rows get rendered all the time
	            // with these two layouts.
	            var allowEstimate = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_NORMAL;
	            var rowNode = this.rowsToDisplay[i];
	            if (_.missing(rowNode.rowHeight)) {
	                var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode, allowEstimate);
	                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
	            }
	            rowNode.setRowTop(nextRowTop);
	            rowNode.setRowIndex(i);
	            nextRowTop += rowNode.rowHeight;
	        }
	    };
	    ClientSideRowModel.prototype.resetRowTops = function (changedPath) {
	        var displayedRowsMapped = {};
	        this.rowsToDisplay.forEach(function (rowNode) {
	            if (rowNode.id != null) {
	                displayedRowsMapped[rowNode.id] = rowNode;
	            }
	        });
	        var clearIfNotDisplayed = function (rowNode) {
	            if (rowNode && rowNode.id != null && displayedRowsMapped[rowNode.id] == null) {
	                rowNode.clearRowTopAndRowIndex();
	            }
	        };
	        var recurse = function (rowNode) {
	            clearIfNotDisplayed(rowNode);
	            clearIfNotDisplayed(rowNode.detailNode);
	            clearIfNotDisplayed(rowNode.sibling);
	            if (rowNode.hasChildren()) {
	                if (rowNode.childrenAfterGroup) {
	                    // if a changedPath is active, it means we are here because of a transaction update or
	                    // a change detection. neither of these impacts the open/closed state of groups. so if
	                    // a group is not open this time, it was not open last time. so we know all closed groups
	                    // already have their top positions cleared. so there is no need to traverse all the way
	                    // when changedPath is active and the rowNode is not expanded.
	                    var isRootNode = rowNode.level == -1; // we need to give special consideration for root node,
	                    // as expanded=undefined for root node
	                    var skipChildren = changedPath.isActive() && !isRootNode && !rowNode.expanded;
	                    if (!skipChildren) {
	                        rowNode.childrenAfterGroup.forEach(recurse);
	                    }
	                }
	            }
	        };
	        recurse(this.rootNode);
	    };
	    // returns false if row was moved, otherwise true
	    ClientSideRowModel.prototype.ensureRowsAtPixel = function (rowNodes, pixel, increment) {
	        var _this = this;
	        if (increment === void 0) { increment = 0; }
	        var indexAtPixelNow = this.getRowIndexAtPixel(pixel);
	        var rowNodeAtPixelNow = this.getRow(indexAtPixelNow);
	        if (rowNodeAtPixelNow === rowNodes[0]) {
	            return false;
	        }
	        rowNodes.forEach(function (rowNode) {
	            _.removeFromArray(_this.rootNode.allLeafChildren, rowNode);
	        });
	        rowNodes.forEach(function (rowNode, idx) {
	            _.insertIntoArray(_this.rootNode.allLeafChildren, rowNode, Math.max(indexAtPixelNow + increment, 0) + idx);
	        });
	        this.refreshModel({
	            step: exports.ClientSideRowModelSteps.EVERYTHING,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        });
	        return true;
	    };
	    ClientSideRowModel.prototype.highlightRowAtPixel = function (rowNode, pixel) {
	        var indexAtPixelNow = pixel != null ? this.getRowIndexAtPixel(pixel) : null;
	        var rowNodeAtPixelNow = indexAtPixelNow != null ? this.getRow(indexAtPixelNow) : null;
	        if (!rowNodeAtPixelNow || !rowNode || rowNodeAtPixelNow === rowNode || pixel == null) {
	            if (this.lastHighlightedRow) {
	                this.lastHighlightedRow.setHighlighted(null);
	                this.lastHighlightedRow = null;
	            }
	            return;
	        }
	        var highlight = this.getHighlightPosition(pixel, rowNodeAtPixelNow);
	        if (this.lastHighlightedRow && this.lastHighlightedRow !== rowNodeAtPixelNow) {
	            this.lastHighlightedRow.setHighlighted(null);
	            this.lastHighlightedRow = null;
	        }
	        rowNodeAtPixelNow.setHighlighted(highlight);
	        this.lastHighlightedRow = rowNodeAtPixelNow;
	    };
	    ClientSideRowModel.prototype.getHighlightPosition = function (pixel, rowNode) {
	        if (!rowNode) {
	            var index = this.getRowIndexAtPixel(pixel);
	            rowNode = this.getRow(index || 0);
	            if (!rowNode) {
	                return 'below';
	            }
	        }
	        var rowTop = rowNode.rowTop, rowHeight = rowNode.rowHeight;
	        return pixel - rowTop < rowHeight / 2 ? 'above' : 'below';
	    };
	    ClientSideRowModel.prototype.getLastHighlightedRowNode = function () {
	        return this.lastHighlightedRow;
	    };
	    ClientSideRowModel.prototype.isLastRowIndexKnown = function () {
	        return true;
	    };
	    ClientSideRowModel.prototype.getRowCount = function () {
	        if (this.rowsToDisplay) {
	            return this.rowsToDisplay.length;
	        }
	        return 0;
	    };
	    ClientSideRowModel.prototype.getTopLevelRowCount = function () {
	        var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
	        if (showingRootNode) {
	            return 1;
	        }
	        return this.rootNode.childrenAfterFilter ? this.rootNode.childrenAfterFilter.length : 0;
	    };
	    ClientSideRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
	        if (showingRootNode) {
	            return topLevelIndex;
	        }
	        var rowNode = this.rootNode.childrenAfterSort[topLevelIndex];
	        if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            // if hideOpenParents, and this row open, then this row is now displayed at this index, first child is
	            while (rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0) {
	                rowNode = rowNode.childrenAfterSort[0];
	            }
	        }
	        return rowNode.rowIndex;
	    };
	    ClientSideRowModel.prototype.getRowBounds = function (index) {
	        if (_.missing(this.rowsToDisplay)) {
	            return null;
	        }
	        var rowNode = this.rowsToDisplay[index];
	        if (rowNode) {
	            return {
	                rowTop: rowNode.rowTop,
	                rowHeight: rowNode.rowHeight
	            };
	        }
	        return null;
	    };
	    ClientSideRowModel.prototype.onRowGroupOpened = function () {
	        // because the user can call rowNode.setExpanded() many times in on VM turn,
	        // we debounce the call using animationFrameService. we use animationFrameService
	        // rather than _.debounce() so this will get done if anyone flushes the animationFrameService
	        // (eg user calls api.ensureRowVisible(), which in turn flushes ).
	        var _this = this;
	        if (this.onRowGroupOpenedPending) {
	            return;
	        }
	        this.onRowGroupOpenedPending = true;
	        var action = function () {
	            _this.onRowGroupOpenedPending = false;
	            var animate = _this.gridOptionsWrapper.isAnimateRows();
	            _this.refreshModel({ step: exports.ClientSideRowModelSteps.MAP, keepRenderedRows: true, animate: animate });
	        };
	        if (this.gridOptionsWrapper.isSuppressAnimationFrame()) {
	            action();
	        }
	        else {
	            this.animationFrameService.addDestroyTask(action);
	        }
	    };
	    ClientSideRowModel.prototype.onFilterChanged = function (event) {
	        if (event.afterDataChange) {
	            return;
	        }
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: exports.ClientSideRowModelSteps.FILTER, keepRenderedRows: true, animate: animate });
	    };
	    ClientSideRowModel.prototype.onSortChanged = function () {
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: exports.ClientSideRowModelSteps.SORT, keepRenderedRows: true, animate: animate, keepEditingRows: true });
	    };
	    ClientSideRowModel.prototype.getType = function () {
	        return Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	    };
	    ClientSideRowModel.prototype.onValueChanged = function () {
	        if (this.columnController.isPivotActive()) {
	            this.refreshModel({ step: exports.ClientSideRowModelSteps.PIVOT });
	        }
	        else {
	            this.refreshModel({ step: exports.ClientSideRowModelSteps.AGGREGATE });
	        }
	    };
	    ClientSideRowModel.prototype.createChangePath = function (rowNodeTransactions) {
	        // for updates, if the row is updated at all, then we re-calc all the values
	        // in that row. we could compare each value to each old value, however if we
	        // did this, we would be calling the valueService twice, once on the old value
	        // and once on the new value. so it's less valueGetter calls if we just assume
	        // each column is different. that way the changedPath is used so that only
	        // the impacted parent rows are recalculated, parents who's children have
	        // not changed are not impacted.
	        var noTransactions = _.missingOrEmpty(rowNodeTransactions);
	        var changedPath = new ChangedPath(false, this.rootNode);
	        if (noTransactions || this.gridOptionsWrapper.isTreeData()) {
	            changedPath.setInactive();
	        }
	        return changedPath;
	    };
	    ClientSideRowModel.prototype.isSuppressModelUpdateAfterUpdateTransaction = function (params) {
	        if (!this.gridOptionsWrapper.isSuppressModelUpdateAfterUpdateTransaction()) {
	            return false;
	        }
	        // return true if we are only doing update transactions
	        if (params.rowNodeTransactions == null) {
	            return false;
	        }
	        var transWithAddsOrDeletes = _.filter(params.rowNodeTransactions, function (tx) {
	            return (tx.add != null && tx.add.length > 0) || (tx.remove != null && tx.remove.length > 0);
	        });
	        var transactionsContainUpdatesOnly = transWithAddsOrDeletes == null || transWithAddsOrDeletes.length == 0;
	        return transactionsContainUpdatesOnly;
	    };
	    ClientSideRowModel.prototype.refreshModel = function (params) {
	        var _this = this;
	        if (this.isSuppressModelUpdateAfterUpdateTransaction(params)) {
	            return;
	        }
	        // this goes through the pipeline of stages. what's in my head is similar
	        // to the diagram on this page:
	        // http://commons.apache.org/sandbox/commons-pipeline/pipeline_basics.html
	        // however we want to keep the results of each stage, hence we manually call
	        // each step rather than have them chain each other.
	        // fallthrough in below switch is on purpose,
	        // eg if STEP_FILTER, then all steps below this
	        // step get done
	        // let start: number;
	        // console.log('======= start =======');
	        var changedPath = this.createChangePath(params.rowNodeTransactions);
	        switch (params.step) {
	            case exports.ClientSideRowModelSteps.EVERYTHING:
	                // start = new Date().getTime();
	                this.doRowGrouping(params.groupState, params.rowNodeTransactions, params.rowNodeOrder, changedPath, !!params.afterColumnsChanged);
	            // console.log('rowGrouping = ' + (new Date().getTime() - start));
	            case exports.ClientSideRowModelSteps.FILTER:
	                // start = new Date().getTime();
	                this.doFilter(changedPath);
	            // console.log('filter = ' + (new Date().getTime() - start));
	            case exports.ClientSideRowModelSteps.PIVOT:
	                this.doPivot(changedPath);
	            case exports.ClientSideRowModelSteps.AGGREGATE: // depends on agg fields
	                // start = new Date().getTime();
	                this.doAggregate(changedPath);
	            // console.log('aggregation = ' + (new Date().getTime() - start));
	            case exports.ClientSideRowModelSteps.SORT:
	                // start = new Date().getTime();
	                this.doSort(params.rowNodeTransactions, changedPath);
	            // console.log('sort = ' + (new Date().getTime() - start));
	            case exports.ClientSideRowModelSteps.MAP:
	                // start = new Date().getTime();
	                this.doRowsToDisplay();
	            // console.log('rowsToDisplay = ' + (new Date().getTime() - start));
	        }
	        // set all row tops to null, then set row tops on all visible rows. if we don't
	        // do this, then the algorithm below only sets row tops, old row tops from old rows
	        // will still lie around
	        this.setRowTops();
	        this.resetRowTops(changedPath);
	        var event = {
	            type: Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            animate: params.animate,
	            keepRenderedRows: params.keepRenderedRows,
	            newData: params.newData,
	            newPage: false
	        };
	        this.eventService.dispatchEvent(event);
	        if (this.$scope) {
	            window.setTimeout(function () {
	                _this.$scope.$apply();
	            }, 0);
	        }
	    };
	    ClientSideRowModel.prototype.isEmpty = function () {
	        var rowsMissing = _.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
	        return _.missing(this.rootNode) || rowsMissing || !this.columnController.isReady();
	    };
	    ClientSideRowModel.prototype.isRowsToRender = function () {
	        return _.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
	    };
	    ClientSideRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        // if lastSelectedNode is missing, we start at the first row
	        var firstRowHit = !lastInRange;
	        var lastRowHit = false;
	        var lastRow;
	        var result = [];
	        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.forEachNodeAfterFilterAndSort(function (rowNode) {
	            var lookingForLastRow = firstRowHit && !lastRowHit;
	            // check if we need to flip the select switch
	            if (!firstRowHit) {
	                if (rowNode === lastInRange || rowNode === firstInRange) {
	                    firstRowHit = true;
	                }
	            }
	            var skipThisGroupNode = rowNode.group && groupsSelectChildren;
	            if (!skipThisGroupNode) {
	                var inRange = firstRowHit && !lastRowHit;
	                var childOfLastRow = rowNode.isParentOfNode(lastRow);
	                if (inRange || childOfLastRow) {
	                    result.push(rowNode);
	                }
	            }
	            if (lookingForLastRow) {
	                if (rowNode === lastInRange || rowNode === firstInRange) {
	                    lastRowHit = true;
	                    if (rowNode === lastInRange) {
	                        lastRow = lastInRange;
	                    }
	                    else {
	                        lastRow = firstInRange;
	                    }
	                }
	            }
	        });
	        return result;
	    };
	    ClientSideRowModel.prototype.setDatasource = function (datasource) {
	        console.error('AG Grid: should never call setDatasource on clientSideRowController');
	    };
	    ClientSideRowModel.prototype.getTopLevelNodes = function () {
	        return this.rootNode ? this.rootNode.childrenAfterGroup : null;
	    };
	    ClientSideRowModel.prototype.getRootNode = function () {
	        return this.rootNode;
	    };
	    ClientSideRowModel.prototype.getRow = function (index) {
	        return this.rowsToDisplay[index];
	    };
	    ClientSideRowModel.prototype.isRowPresent = function (rowNode) {
	        return this.rowsToDisplay.indexOf(rowNode) >= 0;
	    };
	    ClientSideRowModel.prototype.getRowIndexAtPixel = function (pixelToMatch) {
	        if (this.isEmpty()) {
	            return -1;
	        }
	        // do binary search of tree
	        // http://oli.me.uk/2013/06/08/searching-javascript-arrays-with-a-binary-search/
	        var bottomPointer = 0;
	        var topPointer = this.rowsToDisplay.length - 1;
	        // quick check, if the pixel is out of bounds, then return last row
	        if (pixelToMatch <= 0) {
	            // if pixel is less than or equal zero, it's always the first row
	            return 0;
	        }
	        var lastNode = _.last(this.rowsToDisplay);
	        if (lastNode.rowTop <= pixelToMatch) {
	            return this.rowsToDisplay.length - 1;
	        }
	        while (true) {
	            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
	            var currentRowNode = this.rowsToDisplay[midPointer];
	            if (this.isRowInPixel(currentRowNode, pixelToMatch)) {
	                return midPointer;
	            }
	            if (currentRowNode.rowTop < pixelToMatch) {
	                bottomPointer = midPointer + 1;
	            }
	            else if (currentRowNode.rowTop > pixelToMatch) {
	                topPointer = midPointer - 1;
	            }
	        }
	    };
	    ClientSideRowModel.prototype.isRowInPixel = function (rowNode, pixelToMatch) {
	        var topPixel = rowNode.rowTop;
	        var bottomPixel = rowNode.rowTop + rowNode.rowHeight;
	        var pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
	        return pixelInRow;
	    };
	    ClientSideRowModel.prototype.forEachLeafNode = function (callback) {
	        if (this.rootNode.allLeafChildren) {
	            this.rootNode.allLeafChildren.forEach(function (rowNode, index) { return callback(rowNode, index); });
	        }
	    };
	    ClientSideRowModel.prototype.forEachNode = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterGroup, callback, RecursionType.Normal, 0);
	    };
	    ClientSideRowModel.prototype.forEachNodeAfterFilter = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterFilter, callback, RecursionType.AfterFilter, 0);
	    };
	    ClientSideRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterSort, callback, RecursionType.AfterFilterAndSort, 0);
	    };
	    ClientSideRowModel.prototype.forEachPivotNode = function (callback) {
	        this.recursivelyWalkNodesAndCallback([this.rootNode], callback, RecursionType.PivotNodes, 0);
	    };
	    // iterates through each item in memory, and calls the callback function
	    // nodes - the rowNodes to traverse
	    // callback - the user provided callback
	    // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
	    // index - works similar to the index in forEach in javascript's array function
	    ClientSideRowModel.prototype.recursivelyWalkNodesAndCallback = function (nodes, callback, recursionType, index) {
	        if (!nodes) {
	            return index;
	        }
	        for (var i = 0; i < nodes.length; i++) {
	            var node = nodes[i];
	            callback(node, index++);
	            // go to the next level if it is a group
	            if (node.hasChildren()) {
	                // depending on the recursion type, we pick a difference set of children
	                var nodeChildren = null;
	                switch (recursionType) {
	                    case RecursionType.Normal:
	                        nodeChildren = node.childrenAfterGroup;
	                        break;
	                    case RecursionType.AfterFilter:
	                        nodeChildren = node.childrenAfterFilter;
	                        break;
	                    case RecursionType.AfterFilterAndSort:
	                        nodeChildren = node.childrenAfterSort;
	                        break;
	                    case RecursionType.PivotNodes:
	                        // for pivot, we don't go below leafGroup levels
	                        nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
	                        break;
	                }
	                if (nodeChildren) {
	                    index = this.recursivelyWalkNodesAndCallback(nodeChildren, callback, recursionType, index);
	                }
	            }
	        }
	        return index;
	    };
	    // it's possible to recompute the aggregate without doing the other parts
	    // + gridApi.recomputeAggregates()
	    ClientSideRowModel.prototype.doAggregate = function (changedPath) {
	        if (this.aggregationStage) {
	            this.aggregationStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	        }
	    };
	    // + gridApi.expandAll()
	    // + gridApi.collapseAll()
	    ClientSideRowModel.prototype.expandOrCollapseAll = function (expand) {
	        var usingTreeData = this.gridOptionsWrapper.isTreeData();
	        if (this.rootNode) {
	            recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
	        }
	        function recursiveExpandOrCollapse(rowNodes) {
	            if (!rowNodes) {
	                return;
	            }
	            rowNodes.forEach(function (rowNode) {
	                var shouldExpandOrCollapse = usingTreeData ? _.exists(rowNode.childrenAfterGroup) : rowNode.group;
	                if (shouldExpandOrCollapse) {
	                    rowNode.expanded = expand;
	                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
	                }
	            });
	        }
	        this.refreshModel({ step: exports.ClientSideRowModelSteps.MAP });
	        var eventSource = expand ? 'expandAll' : 'collapseAll';
	        var event = {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            type: Events.EVENT_EXPAND_COLLAPSE_ALL,
	            source: eventSource
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ClientSideRowModel.prototype.doSort = function (rowNodeTransactions, changedPath) {
	        this.sortStage.execute({
	            rowNode: this.rootNode,
	            rowNodeTransactions: rowNodeTransactions,
	            changedPath: changedPath
	        });
	    };
	    ClientSideRowModel.prototype.doRowGrouping = function (groupState, rowNodeTransactions, rowNodeOrder, changedPath, afterColumnsChanged) {
	        if (this.groupStage) {
	            if (rowNodeTransactions) {
	                this.groupStage.execute({
	                    rowNode: this.rootNode,
	                    rowNodeTransactions: rowNodeTransactions,
	                    rowNodeOrder: rowNodeOrder,
	                    changedPath: changedPath
	                });
	            }
	            else {
	                // groups are about to get disposed, so need to deselect any that are selected
	                this.selectionController.removeGroupsFromSelection();
	                this.groupStage.execute({
	                    rowNode: this.rootNode,
	                    changedPath: changedPath,
	                    afterColumnsChanged: afterColumnsChanged
	                });
	                // set open/closed state on groups
	                this.restoreGroupState(groupState);
	            }
	            if (this.gridOptionsWrapper.isGroupSelectsChildren()) {
	                this.selectionController.updateGroupsFromChildrenSelections(changedPath);
	            }
	        }
	        else {
	            this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
	            this.rootNode.updateHasChildren();
	        }
	    };
	    ClientSideRowModel.prototype.restoreGroupState = function (groupState) {
	        if (!groupState) {
	            return;
	        }
	        _.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) {
	            // if the group was open last time, then open it this time. however
	            // if was not open last time, then don't touch the group, so the 'groupDefaultExpanded'
	            // setting will take effect.
	            if (typeof groupState[key] === 'boolean') {
	                node.expanded = groupState[key];
	            }
	        });
	    };
	    ClientSideRowModel.prototype.doFilter = function (changedPath) {
	        this.filterStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	    };
	    ClientSideRowModel.prototype.doPivot = function (changedPath) {
	        if (this.pivotStage) {
	            this.pivotStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	        }
	    };
	    ClientSideRowModel.prototype.getGroupState = function () {
	        if (!this.rootNode.childrenAfterGroup || !this.gridOptionsWrapper.isRememberGroupStateWhenNewData()) {
	            return null;
	        }
	        var result = {};
	        _.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) { return result[key] = node.expanded; });
	        return result;
	    };
	    ClientSideRowModel.prototype.getCopyOfNodesMap = function () {
	        return this.nodeManager.getCopyOfNodesMap();
	    };
	    ClientSideRowModel.prototype.getRowNode = function (id) {
	        // although id is typed a string, this could be called by the user, and they could have passed a number
	        var idIsGroup = typeof id == 'string' && id.indexOf(RowNode.ID_PREFIX_ROW_GROUP) == 0;
	        if (idIsGroup) {
	            // only one users complained about getRowNode not working for groups, after years of
	            // this working for normal rows. so have done quick implementation. if users complain
	            // about performance, then GroupStage should store / manage created groups in a map,
	            // which is a chunk of work.
	            var res_1 = null;
	            this.forEachNode(function (node) {
	                if (node.id === id) {
	                    res_1 = node;
	                }
	            });
	            return res_1;
	        }
	        else {
	            return this.nodeManager.getRowNode(id);
	        }
	    };
	    // rows: the rows to put into the model
	    ClientSideRowModel.prototype.setRowData = function (rowData) {
	        // no need to invalidate cache, as the cache is stored on the rowNode,
	        // so new rowNodes means the cache is wiped anyway.
	        // remember group state, so we can expand groups that should be expanded
	        var groupState = this.getGroupState();
	        this.nodeManager.setRowData(rowData);
	        // this event kicks off:
	        // - clears selection
	        // - updates filters
	        // - shows 'no rows' overlay if needed
	        var rowDataChangedEvent = {
	            type: Events.EVENT_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(rowDataChangedEvent);
	        this.refreshModel({
	            step: exports.ClientSideRowModelSteps.EVERYTHING,
	            groupState: groupState,
	            newData: true
	        });
	    };
	    ClientSideRowModel.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
	        var _this = this;
	        if (this.applyAsyncTransactionsTimeout == null) {
	            this.rowDataTransactionBatch = [];
	            var waitMillis = this.gridOptionsWrapper.getAsyncTransactionWaitMillis();
	            this.applyAsyncTransactionsTimeout = window.setTimeout(function () {
	                _this.executeBatchUpdateRowData();
	            }, waitMillis);
	        }
	        this.rowDataTransactionBatch.push({ rowDataTransaction: rowDataTransaction, callback: callback });
	    };
	    ClientSideRowModel.prototype.flushAsyncTransactions = function () {
	        if (this.applyAsyncTransactionsTimeout != null) {
	            clearTimeout(this.applyAsyncTransactionsTimeout);
	            this.executeBatchUpdateRowData();
	        }
	    };
	    ClientSideRowModel.prototype.executeBatchUpdateRowData = function () {
	        var _this = this;
	        this.valueCache.onDataChanged();
	        var callbackFuncsBound = [];
	        var rowNodeTrans = [];
	        // The rowGroup stage uses rowNodeOrder if order was provided. if we didn't pass 'true' to
	        // commonUpdateRowData, using addIndex would have no effect when grouping.
	        var forceRowNodeOrder = false;
	        if (this.rowDataTransactionBatch) {
	            this.rowDataTransactionBatch.forEach(function (tranItem) {
	                var rowNodeTran = _this.nodeManager.updateRowData(tranItem.rowDataTransaction, undefined);
	                rowNodeTrans.push(rowNodeTran);
	                if (tranItem.callback) {
	                    callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTran));
	                }
	                if (typeof tranItem.rowDataTransaction.addIndex === 'number') {
	                    forceRowNodeOrder = true;
	                }
	            });
	        }
	        this.commonUpdateRowData(rowNodeTrans, undefined, forceRowNodeOrder);
	        // do callbacks in next VM turn so it's async
	        if (callbackFuncsBound.length > 0) {
	            window.setTimeout(function () {
	                callbackFuncsBound.forEach(function (func) { return func(); });
	            }, 0);
	        }
	        if (rowNodeTrans.length > 0) {
	            var event_1 = {
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                type: Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
	                results: rowNodeTrans
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	        this.rowDataTransactionBatch = null;
	        this.applyAsyncTransactionsTimeout = undefined;
	    };
	    ClientSideRowModel.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
	        this.valueCache.onDataChanged();
	        var rowNodeTran = this.nodeManager.updateRowData(rowDataTran, rowNodeOrder);
	        // if doing immutableData, addIndex is never present. however if doing standard transaction, and user
	        // provided addIndex, then this is used in updateRowData. However if doing Enterprise, then the rowGroup
	        // stage also uses the
	        var forceRowNodeOrder = typeof rowDataTran.addIndex === 'number';
	        this.commonUpdateRowData([rowNodeTran], rowNodeOrder, forceRowNodeOrder);
	        return rowNodeTran;
	    };
	    ClientSideRowModel.prototype.createRowNodeOrder = function () {
	        var suppressSortOrder = this.gridOptionsWrapper.isSuppressMaintainUnsortedOrder();
	        if (suppressSortOrder) {
	            return;
	        }
	        var orderMap = {};
	        if (this.rootNode && this.rootNode.allLeafChildren) {
	            for (var index = 0; index < this.rootNode.allLeafChildren.length; index++) {
	                var node = this.rootNode.allLeafChildren[index];
	                orderMap[node.id] = index;
	            }
	        }
	        return orderMap;
	    };
	    // common to updateRowData and batchUpdateRowData
	    ClientSideRowModel.prototype.commonUpdateRowData = function (rowNodeTrans, rowNodeOrder, forceRowNodeOrder) {
	        if (forceRowNodeOrder) {
	            rowNodeOrder = this.createRowNodeOrder();
	        }
	        this.refreshModel({
	            step: exports.ClientSideRowModelSteps.EVERYTHING,
	            rowNodeTransactions: rowNodeTrans,
	            rowNodeOrder: rowNodeOrder,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        });
	        var event = {
	            type: Events.EVENT_ROW_DATA_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ClientSideRowModel.prototype.doRowsToDisplay = function () {
	        this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
	    };
	    ClientSideRowModel.prototype.onRowHeightChanged = function () {
	        this.refreshModel({ step: exports.ClientSideRowModelSteps.MAP, keepRenderedRows: true, keepEditingRows: true });
	    };
	    ClientSideRowModel.prototype.resetRowHeights = function () {
	        var atLeastOne = false;
	        this.forEachNode(function (rowNode) {
	            rowNode.setRowHeight(rowNode.rowHeight, true);
	            // we keep the height each row is at, however we set estimated=true rather than clear the height.
	            // this means the grid will not reset the row heights back to defaults, rather it will re-calc
	            // the height for each row as the row is displayed. otherwise the scroll will jump when heights are reset.
	            var detailNode = rowNode.detailNode;
	            if (detailNode) {
	                detailNode.setRowHeight(detailNode.rowHeight, true);
	            }
	            atLeastOne = true;
	        });
	        if (atLeastOne) {
	            this.onRowHeightChanged();
	        }
	    };
	    __decorate$28([
	        Autowired('columnController')
	    ], ClientSideRowModel.prototype, "columnController", void 0);
	    __decorate$28([
	        Autowired('$scope')
	    ], ClientSideRowModel.prototype, "$scope", void 0);
	    __decorate$28([
	        Autowired('selectionController')
	    ], ClientSideRowModel.prototype, "selectionController", void 0);
	    __decorate$28([
	        Autowired('valueCache')
	    ], ClientSideRowModel.prototype, "valueCache", void 0);
	    __decorate$28([
	        Autowired('columnApi')
	    ], ClientSideRowModel.prototype, "columnApi", void 0);
	    __decorate$28([
	        Autowired('gridApi')
	    ], ClientSideRowModel.prototype, "gridApi", void 0);
	    __decorate$28([
	        Autowired('animationFrameService')
	    ], ClientSideRowModel.prototype, "animationFrameService", void 0);
	    __decorate$28([
	        Autowired('filterStage')
	    ], ClientSideRowModel.prototype, "filterStage", void 0);
	    __decorate$28([
	        Autowired('sortStage')
	    ], ClientSideRowModel.prototype, "sortStage", void 0);
	    __decorate$28([
	        Autowired('flattenStage')
	    ], ClientSideRowModel.prototype, "flattenStage", void 0);
	    __decorate$28([
	        Optional('groupStage')
	    ], ClientSideRowModel.prototype, "groupStage", void 0);
	    __decorate$28([
	        Optional('aggregationStage')
	    ], ClientSideRowModel.prototype, "aggregationStage", void 0);
	    __decorate$28([
	        Optional('pivotStage')
	    ], ClientSideRowModel.prototype, "pivotStage", void 0);
	    __decorate$28([
	        PostConstruct
	    ], ClientSideRowModel.prototype, "init", null);
	    ClientSideRowModel = __decorate$28([
	        Bean('rowModel')
	    ], ClientSideRowModel);
	    return ClientSideRowModel;
	}(BeanStub));

	var __extends$2l = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$29 = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var FilterStage = /** @class */ (function (_super) {
	    __extends$2l(FilterStage, _super);
	    function FilterStage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FilterStage.prototype.execute = function (params) {
	        var rowNode = params.rowNode, changedPath = params.changedPath;
	        this.filterService.filter(changedPath);
	        this.selectableService.updateSelectableAfterFiltering(rowNode);
	    };
	    __decorate$29([
	        Autowired('selectableService')
	    ], FilterStage.prototype, "selectableService", void 0);
	    __decorate$29([
	        Autowired('filterService')
	    ], FilterStage.prototype, "filterService", void 0);
	    FilterStage = __decorate$29([
	        Bean('filterStage')
	    ], FilterStage);
	    return FilterStage;
	}(BeanStub));

	var __extends$2m = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2a = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SortStage = /** @class */ (function (_super) {
	    __extends$2m(SortStage, _super);
	    function SortStage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SortStage.prototype.execute = function (params) {
	        var sortOptions = this.sortController.getSortOptions();
	        var sortActive = _.exists(sortOptions) && sortOptions.length > 0;
	        var deltaSort = sortActive
	            && _.exists(params.rowNodeTransactions)
	            // in time we can remove this check, so that delta sort is always
	            // on if transactions are present. it's off for now so that we can
	            // selectively turn it on and test it with some select users before
	            // rolling out to everyone.
	            && this.gridOptionsWrapper.isDeltaSort();
	        // we only need dirty nodes if doing delta sort
	        var dirtyLeafNodes = deltaSort ? this.calculateDirtyNodes(params.rowNodeTransactions) : null;
	        var valueColumns = this.columnController.getValueColumns();
	        var noAggregations = _.missingOrEmpty(valueColumns);
	        this.sortService.sort(sortOptions, sortActive, deltaSort, dirtyLeafNodes, params.changedPath, noAggregations);
	    };
	    SortStage.prototype.calculateDirtyNodes = function (rowNodeTransactions) {
	        var dirtyNodes = {};
	        var addNodesFunc = function (rowNodes) {
	            if (rowNodes) {
	                rowNodes.forEach(function (rowNode) { return dirtyNodes[rowNode.id] = true; });
	            }
	        };
	        // all leaf level nodes in the transaction were impacted
	        if (rowNodeTransactions) {
	            rowNodeTransactions.forEach(function (tran) {
	                addNodesFunc(tran.add);
	                addNodesFunc(tran.update);
	                addNodesFunc(tran.remove);
	            });
	        }
	        return dirtyNodes;
	    };
	    __decorate$2a([
	        Autowired('sortService')
	    ], SortStage.prototype, "sortService", void 0);
	    __decorate$2a([
	        Autowired('sortController')
	    ], SortStage.prototype, "sortController", void 0);
	    __decorate$2a([
	        Autowired('columnController')
	    ], SortStage.prototype, "columnController", void 0);
	    SortStage = __decorate$2a([
	        Bean('sortStage')
	    ], SortStage);
	    return SortStage;
	}(BeanStub));

	var __extends$2n = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2b = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var FlattenStage = /** @class */ (function (_super) {
	    __extends$2n(FlattenStage, _super);
	    function FlattenStage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FlattenStage.prototype.execute = function (params) {
	        var rootNode = params.rowNode;
	        // even if not doing grouping, we do the mapping, as the client might
	        // of passed in data that already has a grouping in it somewhere
	        var result = [];
	        // putting value into a wrapper so it's passed by reference
	        var nextRowTop = { value: 0 };
	        var skipLeafNodes = this.columnController.isPivotMode();
	        // if we are reducing, and not grouping, then we want to show the root node, as that
	        // is where the pivot values are
	        var showRootNode = skipLeafNodes && rootNode.leafGroup;
	        var topList = showRootNode ? [rootNode] : rootNode.childrenAfterSort;
	        this.recursivelyAddToRowsToDisplay(topList, result, nextRowTop, skipLeafNodes, 0);
	        // we do not want the footer total if the gris is empty
	        var atLeastOneRowPresent = result.length > 0;
	        var includeGroupTotalFooter = !showRootNode
	            // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
	            && atLeastOneRowPresent
	            && this.gridOptionsWrapper.isGroupIncludeTotalFooter();
	        if (includeGroupTotalFooter) {
	            this.ensureFooterNodeExists(rootNode);
	            this.addRowNodeToRowsToDisplay(rootNode.sibling, result, nextRowTop, 0);
	        }
	        return result;
	    };
	    FlattenStage.prototype.recursivelyAddToRowsToDisplay = function (rowsToFlatten, result, nextRowTop, skipLeafNodes, uiLevel) {
	        if (_.missingOrEmpty(rowsToFlatten)) {
	            return;
	        }
	        var hideOpenParents = this.gridOptionsWrapper.isGroupHideOpenParents();
	        // these two are mutually exclusive, so if first set, we don't set the second
	        var groupRemoveSingleChildren = this.gridOptionsWrapper.isGroupRemoveSingleChildren();
	        var groupRemoveLowestSingleChildren = !groupRemoveSingleChildren && this.gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
	        for (var i = 0; i < rowsToFlatten.length; i++) {
	            var rowNode = rowsToFlatten[i];
	            // check all these cases, for working out if this row should be included in the final mapped list
	            var isParent = rowNode.hasChildren();
	            var isSkippedLeafNode = skipLeafNodes && !isParent;
	            var isRemovedSingleChildrenGroup = groupRemoveSingleChildren &&
	                isParent &&
	                rowNode.childrenAfterGroup.length === 1;
	            var isRemovedLowestSingleChildrenGroup = groupRemoveLowestSingleChildren &&
	                isParent &&
	                rowNode.leafGroup &&
	                rowNode.childrenAfterGroup.length === 1;
	            // hide open parents means when group is open, we don't show it. we also need to make sure the
	            // group is expandable in the first place (as leaf groups are not expandable if pivot mode is on).
	            // the UI will never allow expanding leaf  groups, however the user might via the API (or menu option 'expand all')
	            var neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
	            var isHiddenOpenParent = hideOpenParents && rowNode.expanded && (!neverAllowToExpand);
	            var thisRowShouldBeRendered = !isSkippedLeafNode && !isHiddenOpenParent &&
	                !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
	            if (thisRowShouldBeRendered) {
	                this.addRowNodeToRowsToDisplay(rowNode, result, nextRowTop, uiLevel);
	            }
	            // if we are pivoting, we never map below the leaf group
	            if (skipLeafNodes && rowNode.leafGroup) {
	                continue;
	            }
	            if (isParent) {
	                var excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
	                // we traverse the group if it is expended, however we always traverse if the parent node
	                // was removed (as the group will never be opened if it is not displayed, we show the children instead)
	                if (rowNode.expanded || excludedParent) {
	                    // if the parent was excluded, then ui level is that of the parent
	                    var uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
	                    this.recursivelyAddToRowsToDisplay(rowNode.childrenAfterSort, result, nextRowTop, skipLeafNodes, uiLevelForChildren);
	                    // put a footer in if user is looking for it
	                    if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
	                        this.ensureFooterNodeExists(rowNode);
	                        this.addRowNodeToRowsToDisplay(rowNode.sibling, result, nextRowTop, uiLevel);
	                    }
	                }
	            }
	            else if (rowNode.master && rowNode.expanded) {
	                var detailNode = this.createDetailNode(rowNode);
	                this.addRowNodeToRowsToDisplay(detailNode, result, nextRowTop, uiLevel);
	            }
	        }
	    };
	    // duplicated method, it's also in floatingRowModel
	    FlattenStage.prototype.addRowNodeToRowsToDisplay = function (rowNode, result, nextRowTop, uiLevel) {
	        var isGroupMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
	        result.push(rowNode);
	        rowNode.setUiLevel(isGroupMultiAutoColumn ? 0 : uiLevel);
	    };
	    FlattenStage.prototype.ensureFooterNodeExists = function (groupNode) {
	        // only create footer node once, otherwise we have daemons and
	        // the animate screws up with the daemons hanging around
	        if (_.exists(groupNode.sibling)) {
	            return;
	        }
	        var footerNode = new RowNode();
	        this.context.createBean(footerNode);
	        Object.keys(groupNode).forEach(function (key) {
	            footerNode[key] = groupNode[key];
	        });
	        footerNode.footer = true;
	        footerNode.setRowTop(null);
	        footerNode.setRowIndex(null);
	        // manually set oldRowTop to null so we discard any
	        // previous information about its position.
	        footerNode.oldRowTop = null;
	        if (_.exists(footerNode.id)) {
	            footerNode.id = 'rowGroupFooter_' + footerNode.id;
	        }
	        // get both header and footer to reference each other as siblings. this is never undone,
	        // only overwritten. so if a group is expanded, then contracted, it will have a ghost
	        // sibling - but that's fine, as we can ignore this if the header is contracted.
	        footerNode.sibling = groupNode;
	        groupNode.sibling = footerNode;
	    };
	    FlattenStage.prototype.createDetailNode = function (masterNode) {
	        if (_.exists(masterNode.detailNode)) {
	            return masterNode.detailNode;
	        }
	        var detailNode = new RowNode();
	        this.context.createBean(detailNode);
	        detailNode.detail = true;
	        detailNode.selectable = false;
	        detailNode.parent = masterNode;
	        if (_.exists(masterNode.id)) {
	            detailNode.id = 'detail_' + masterNode.id;
	        }
	        detailNode.data = masterNode.data;
	        detailNode.level = masterNode.level + 1;
	        masterNode.detailNode = detailNode;
	        return detailNode;
	    };
	    __decorate$2b([
	        Autowired('columnController')
	    ], FlattenStage.prototype, "columnController", void 0);
	    FlattenStage = __decorate$2b([
	        Bean('flattenStage')
	    ], FlattenStage);
	    return FlattenStage;
	}(BeanStub));

	var __extends$2o = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2c = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var SortService = /** @class */ (function (_super) {
	    __extends$2o(SortService, _super);
	    function SortService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SortService.prototype.init = function () {
	        this.postSortFunc = this.gridOptionsWrapper.getPostSortFunc();
	    };
	    SortService.prototype.sort = function (sortOptions, sortActive, deltaSort, dirtyLeafNodes, changedPath, noAggregations) {
	        var _this = this;
	        var callback = function (rowNode) {
	            // we clear out the 'pull down open parents' first, as the values mix up the sorting
	            _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterFilter, true);
	            // Javascript sort is non deterministic when all the array items are equals, ie Comparator always returns 0,
	            // so to ensure the array keeps its order, add an additional sorting condition manually, in this case we
	            // are going to inspect the original array position. This is what sortedRowNodes is for.
	            if (sortActive) {
	                rowNode.childrenAfterSort = deltaSort ?
	                    _this.doDeltaSort(rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations)
	                    : _this.rowNodeSorter.doFullSort(rowNode.childrenAfterFilter, sortOptions);
	            }
	            else {
	                rowNode.childrenAfterSort = rowNode.childrenAfterFilter.slice(0);
	            }
	            _this.updateChildIndexes(rowNode);
	            if (_this.postSortFunc) {
	                _this.postSortFunc(rowNode.childrenAfterSort);
	            }
	        };
	        if (changedPath) {
	            changedPath.forEachChangedNodeDepthFirst(callback);
	        }
	        this.updateGroupDataForHiddenOpenParents(changedPath);
	    };
	    SortService.prototype.mapNodeToSortedNode = function (rowNode, pos) {
	        return { currentPos: pos, rowNode: rowNode };
	    };
	    SortService.prototype.doDeltaSort = function (rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations) {
	        // clean nodes will be a list of all row nodes that remain in the set
	        // and ordered. we start with the old sorted set and take out any nodes
	        // that were removed or changed (but not added, added doesn't make sense,
	        // if a node was added, there is no way it could be here from last time).
	        var cleanNodes = rowNode.childrenAfterSort
	            .filter(function (node) {
	            // take out all nodes that were changed as part of the current transaction.
	            // a changed node could a) be in a different sort position or b) may
	            // no longer be in this set as the changed node may not pass filtering,
	            // or be in a different group.
	            var passesDirtyNodesCheck = !dirtyLeafNodes[node.id];
	            // also remove group nodes in the changed path, as they can have different aggregate
	            // values which could impact the sort order.
	            // note: changed path is not active if a) no value columns or b) no transactions. it is never
	            // (b) in deltaSort as we only do deltaSort for transactions. for (a) if no value columns, then
	            // there is no value in the group that could of changed (ie no aggregate values)
	            var passesChangedPathCheck = noAggregations || (changedPath && changedPath.canSkip(node));
	            return passesDirtyNodesCheck && passesChangedPathCheck;
	        })
	            .map(this.mapNodeToSortedNode.bind(this));
	        // for fast access below, we map them
	        var cleanNodesMapped = {};
	        cleanNodes.forEach(function (sortedRowNode) { return cleanNodesMapped[sortedRowNode.rowNode.id] = sortedRowNode.rowNode; });
	        // these are all nodes that need to be placed
	        var changedNodes = rowNode.childrenAfterFilter
	            // ignore nodes in the clean list
	            .filter(function (node) { return !cleanNodesMapped[node.id]; })
	            .map(this.mapNodeToSortedNode.bind(this));
	        // sort changed nodes. note that we don't need to sort cleanNodes as they are
	        // already sorted from last time.
	        changedNodes.sort(this.rowNodeSorter.compareRowNodes.bind(this, sortOptions));
	        var result;
	        if (changedNodes.length === 0) {
	            result = cleanNodes;
	        }
	        else if (cleanNodes.length === 0) {
	            result = changedNodes;
	        }
	        else {
	            result = this.mergeSortedArrays(sortOptions, cleanNodes, changedNodes);
	        }
	        return result.map(function (item) { return item.rowNode; });
	    };
	    // Merge two sorted arrays into each other
	    SortService.prototype.mergeSortedArrays = function (sortOptions, arr1, arr2) {
	        var res = [];
	        var i = 0;
	        var j = 0;
	        // Traverse both array, adding them in order
	        while (i < arr1.length && j < arr2.length) {
	            // Check if current element of first
	            // array is smaller than current element
	            // of second array. If yes, store first
	            // array element and increment first array
	            // index. Otherwise do same with second array
	            var compareResult = this.rowNodeSorter.compareRowNodes(sortOptions, arr1[i], arr2[j]);
	            if (compareResult < 0) {
	                res.push(arr1[i++]);
	            }
	            else {
	                res.push(arr2[j++]);
	            }
	        }
	        // add remaining from arr1
	        while (i < arr1.length) {
	            res.push(arr1[i++]);
	        }
	        // add remaining from arr2
	        while (j < arr2.length) {
	            res.push(arr2[j++]);
	        }
	        return res;
	    };
	    SortService.prototype.updateChildIndexes = function (rowNode) {
	        if (_.missing(rowNode.childrenAfterSort)) {
	            return;
	        }
	        var listToSort = rowNode.childrenAfterSort;
	        for (var i = 0; i < listToSort.length; i++) {
	            var child = listToSort[i];
	            var firstChild = i === 0;
	            var lastChild = i === rowNode.childrenAfterSort.length - 1;
	            child.setFirstChild(firstChild);
	            child.setLastChild(lastChild);
	            child.setChildIndex(i);
	        }
	    };
	    SortService.prototype.updateGroupDataForHiddenOpenParents = function (changedPath) {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        // recurse breadth first over group nodes after sort to 'pull down' group data to child groups
	        var callback = function (rowNode) {
	            _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterSort, false);
	            rowNode.childrenAfterSort.forEach(function (child) {
	                if (child.hasChildren()) {
	                    callback(child);
	                }
	            });
	        };
	        if (changedPath) {
	            changedPath.executeFromRootNode(function (rowNode) { return callback(rowNode); });
	        }
	    };
	    SortService.prototype.pullDownGroupDataForHideOpenParents = function (rowNodes, clearOperation) {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents() || _.missing(rowNodes)) {
	            return;
	        }
	        rowNodes.forEach(function (childRowNode) {
	            var groupDisplayCols = _this.columnController.getGroupDisplayColumns();
	            groupDisplayCols.forEach(function (groupDisplayCol) {
	                var showRowGroup = groupDisplayCol.getColDef().showRowGroup;
	                if (typeof showRowGroup !== 'string') {
	                    console.error('AG Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup');
	                    return;
	                }
	                var displayingGroupKey = showRowGroup;
	                var rowGroupColumn = _this.columnController.getPrimaryColumn(displayingGroupKey);
	                var thisRowNodeMatches = rowGroupColumn === childRowNode.rowGroupColumn;
	                if (thisRowNodeMatches) {
	                    return;
	                }
	                if (clearOperation) {
	                    // if doing a clear operation, we clear down the value for every possible group column
	                    childRowNode.setGroupValue(groupDisplayCol.getId(), null);
	                }
	                else {
	                    // if doing a set operation, we set only where the pull down is to occur
	                    var parentToStealFrom = childRowNode.getFirstChildOfFirstChild(rowGroupColumn);
	                    if (parentToStealFrom) {
	                        childRowNode.setGroupValue(groupDisplayCol.getId(), parentToStealFrom.key);
	                    }
	                }
	            });
	        });
	    };
	    __decorate$2c([
	        Autowired('columnController')
	    ], SortService.prototype, "columnController", void 0);
	    __decorate$2c([
	        Autowired('rowNodeSorter')
	    ], SortService.prototype, "rowNodeSorter", void 0);
	    __decorate$2c([
	        PostConstruct
	    ], SortService.prototype, "init", null);
	    SortService = __decorate$2c([
	        Bean('sortService')
	    ], SortService);
	    return SortService;
	}(BeanStub));

	var __extends$2p = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2d = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var FilterService = /** @class */ (function (_super) {
	    __extends$2p(FilterService, _super);
	    function FilterService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FilterService.prototype.postConstruct = function () {
	        this.doingTreeData = this.gridOptionsWrapper.isTreeData();
	    };
	    FilterService.prototype.filter = function (changedPath) {
	        var filterActive = this.filterManager.isAnyFilterPresent();
	        this.filterNodes(filterActive, changedPath);
	    };
	    FilterService.prototype.filterNodes = function (filterActive, changedPath) {
	        var _this = this;
	        var filterCallback = function (rowNode, includeChildNodes) {
	            // recursively get all children that are groups to also filter
	            if (rowNode.hasChildren()) {
	                // result of filter for this node. when filtering tree data, includeChildNodes = true when parent passes
	                if (filterActive && !includeChildNodes) {
	                    rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter(function (childNode) {
	                        // a group is included in the result if it has any children of it's own.
	                        // by this stage, the child groups are already filtered
	                        var passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
	                        // both leaf level nodes and tree data nodes have data. these get added if
	                        // the data passes the filter
	                        var passBecauseDataPasses = childNode.data
	                            && _this.filterManager.doesRowPassFilter({ rowNode: childNode });
	                        // note - tree data nodes pass either if a) they pass themselves or b) any children of that node pass
	                        return passBecauseChildren || passBecauseDataPasses;
	                    });
	                }
	                else {
	                    // if not filtering, the result is the original list
	                    rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
	                }
	                _this.setAllChildrenCount(rowNode);
	            }
	            else {
	                rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
	                rowNode.setAllChildrenCount(null);
	            }
	        };
	        if (this.doingTreeDataFiltering()) {
	            var treeDataDepthFirstFilter_1 = function (rowNode, alreadyFoundInParent) {
	                // tree data filter traverses the hierarchy depth first and includes child nodes if parent passes
	                // filter, and parent nodes will be include if any children exist.
	                if (rowNode.childrenAfterGroup) {
	                    for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                        var childNode = rowNode.childrenAfterGroup[i];
	                        // first check if current node passes filter before invoking child nodes
	                        var foundInParent = alreadyFoundInParent
	                            || _this.filterManager.doesRowPassFilter({ rowNode: childNode });
	                        if (childNode.childrenAfterGroup) {
	                            treeDataDepthFirstFilter_1(rowNode.childrenAfterGroup[i], foundInParent);
	                        }
	                        else {
	                            filterCallback(childNode, foundInParent);
	                        }
	                    }
	                }
	                filterCallback(rowNode, alreadyFoundInParent);
	            };
	            var treeDataFilterCallback = function (rowNode) { return treeDataDepthFirstFilter_1(rowNode, false); };
	            changedPath.executeFromRootNode(treeDataFilterCallback);
	        }
	        else {
	            var defaultFilterCallback = function (rowNode) { return filterCallback(rowNode, false); };
	            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
	        }
	    };
	    FilterService.prototype.setAllChildrenCountTreeData = function (rowNode) {
	        // for tree data, we include all children, groups and leafs
	        var allChildrenCount = 0;
	        rowNode.childrenAfterFilter.forEach(function (child) {
	            // include child itself
	            allChildrenCount++;
	            // include children of children
	            allChildrenCount += child.allChildrenCount;
	        });
	        rowNode.setAllChildrenCount(allChildrenCount);
	    };
	    FilterService.prototype.setAllChildrenCountGridGrouping = function (rowNode) {
	        // for grid data, we only count the leafs
	        var allChildrenCount = 0;
	        rowNode.childrenAfterFilter.forEach(function (child) {
	            if (child.group) {
	                allChildrenCount += child.allChildrenCount;
	            }
	            else {
	                allChildrenCount++;
	            }
	        });
	        rowNode.setAllChildrenCount(allChildrenCount);
	    };
	    FilterService.prototype.setAllChildrenCount = function (rowNode) {
	        if (this.doingTreeData) {
	            this.setAllChildrenCountTreeData(rowNode);
	        }
	        else {
	            this.setAllChildrenCountGridGrouping(rowNode);
	        }
	    };
	    FilterService.prototype.doingTreeDataFiltering = function () {
	        return this.gridOptionsWrapper.isTreeData() && !this.gridOptionsWrapper.isExcludeChildrenWhenTreeDataFiltering();
	    };
	    __decorate$2d([
	        Autowired('filterManager')
	    ], FilterService.prototype, "filterManager", void 0);
	    __decorate$2d([
	        PostConstruct
	    ], FilterService.prototype, "postConstruct", null);
	    FilterService = __decorate$2d([
	        Bean("filterService")
	    ], FilterService);
	    return FilterService;
	}(BeanStub));

	var __extends$2q = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2e = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var ImmutableService = /** @class */ (function (_super) {
	    __extends$2q(ImmutableService, _super);
	    function ImmutableService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ImmutableService.prototype.postConstruct = function () {
	        if (this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = this.rowModel;
	        }
	    };
	    // converts the setRowData() command to a transaction
	    ImmutableService.prototype.createTransactionForRowData = function (data) {
	        if (_.missing(this.clientSideRowModel)) {
	            console.error('AG Grid: ImmutableService only works with ClientSideRowModel');
	            return;
	        }
	        var getRowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
	        if (!getRowNodeIdFunc || _.missing(getRowNodeIdFunc)) {
	            console.error('AG Grid: ImmutableService requires getRowNodeId() callback to be implemented, your row data need IDs!');
	            return;
	        }
	        // convert the data into a transaction object by working out adds, removes and updates
	        var transaction = {
	            remove: [],
	            update: [],
	            add: []
	        };
	        var existingNodesMap = this.clientSideRowModel.getCopyOfNodesMap();
	        var suppressSortOrder = this.gridOptionsWrapper.isSuppressMaintainUnsortedOrder();
	        var orderMap = suppressSortOrder ? null : {};
	        if (_.exists(data)) {
	            // split all the new data in the following:
	            // if new, push to 'add'
	            // if update, push to 'update'
	            // if not changed, do not include in the transaction
	            data.forEach(function (dataItem, index) {
	                var id = getRowNodeIdFunc(dataItem);
	                var existingNode = existingNodesMap[id];
	                if (orderMap) {
	                    orderMap[id] = index;
	                }
	                if (existingNode) {
	                    var dataHasChanged = existingNode.data !== dataItem;
	                    if (dataHasChanged) {
	                        transaction.update.push(dataItem);
	                    }
	                    // otherwise, if data not changed, we just don't include it anywhere, as it's not a delta
	                    // remove from list, so we know the item is not to be removed
	                    existingNodesMap[id] = undefined;
	                }
	                else {
	                    transaction.add.push(dataItem);
	                }
	            });
	        }
	        // at this point, all rows that are left, should be removed
	        _.iterateObject(existingNodesMap, function (id, rowNode) {
	            if (rowNode) {
	                transaction.remove.push(rowNode.data);
	            }
	        });
	        return [transaction, orderMap];
	    };
	    __decorate$2e([
	        Autowired('rowModel')
	    ], ImmutableService.prototype, "rowModel", void 0);
	    __decorate$2e([
	        PostConstruct
	    ], ImmutableService.prototype, "postConstruct", null);
	    ImmutableService = __decorate$2e([
	        Bean('immutableService')
	    ], ImmutableService);
	    return ImmutableService;
	}(BeanStub));

	var ClientSideRowModelModule = {
	    moduleName: exports.ModuleNames.ClientSideRowModelModule,
	    beans: [FilterStage, SortStage, FlattenStage, SortService, FilterService, ImmutableService],
	    rowModels: { clientSide: ClientSideRowModel }
	};

	var __extends$2r = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2f = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var InfiniteBlock = /** @class */ (function (_super) {
	    __extends$2r(InfiniteBlock, _super);
	    function InfiniteBlock(id, parentCache, params) {
	        var _this = _super.call(this, id) || this;
	        _this.parentCache = parentCache;
	        _this.params = params;
	        // we don't need to calculate these now, as the inputs don't change,
	        // however it makes the code easier to read if we work them out up front
	        _this.startRow = id * params.blockSize;
	        _this.endRow = _this.startRow + params.blockSize;
	        return _this;
	    }
	    InfiniteBlock.prototype.postConstruct = function () {
	        this.createRowNodes();
	    };
	    InfiniteBlock.prototype.getBlockStateJson = function () {
	        return {
	            id: '' + this.getId(),
	            state: {
	                blockNumber: this.getId(),
	                startRow: this.getStartRow(),
	                endRow: this.getEndRow(),
	                pageStatus: this.getState()
	            }
	        };
	    };
	    InfiniteBlock.prototype.setDataAndId = function (rowNode, data, index) {
	        if (_.exists(data)) {
	            // this means if the user is not providing id's we just use the
	            // index for the row. this will allow selection to work (that is based
	            // on index) as long user is not inserting or deleting rows,
	            // or wanting to keep selection between server side sorting or filtering
	            rowNode.setDataAndId(data, index.toString());
	        }
	        else {
	            rowNode.setDataAndId(undefined, undefined);
	        }
	    };
	    InfiniteBlock.prototype.loadFromDatasource = function () {
	        var _this = this;
	        var params = this.createLoadParams();
	        if (_.missing(this.params.datasource.getRows)) {
	            console.warn("AG Grid: datasource is missing getRows method");
	            return;
	        }
	        // put in timeout, to force result to be async
	        window.setTimeout(function () {
	            _this.params.datasource.getRows(params);
	        }, 0);
	    };
	    InfiniteBlock.prototype.processServerFail = function () {
	        // todo - this method has better handling in SSRM
	    };
	    InfiniteBlock.prototype.createLoadParams = function () {
	        // PROBLEM . . . . when the user sets sort via colDef.sort, then this code
	        // is executing before the sort is set up, so server is not getting the sort
	        // model. need to change with regards order - so the server side request is
	        // AFTER thus it gets the right sort model.
	        var params = {
	            startRow: this.getStartRow(),
	            endRow: this.getEndRow(),
	            successCallback: this.pageLoaded.bind(this, this.getVersion()),
	            failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
	            sortModel: this.params.sortModel,
	            filterModel: this.params.filterModel,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        return params;
	    };
	    InfiniteBlock.prototype.forEachNode = function (callback, sequence, rowCount) {
	        var _this = this;
	        this.rowNodes.forEach(function (rowNode, index) {
	            var rowIndex = _this.startRow + index;
	            if (rowIndex < rowCount) {
	                callback(rowNode, sequence.next());
	            }
	        });
	    };
	    InfiniteBlock.prototype.getLastAccessed = function () {
	        return this.lastAccessed;
	    };
	    InfiniteBlock.prototype.getRow = function (rowIndex, dontTouchLastAccessed) {
	        if (dontTouchLastAccessed === void 0) { dontTouchLastAccessed = false; }
	        if (!dontTouchLastAccessed) {
	            this.lastAccessed = this.params.lastAccessedSequence.next();
	        }
	        var localIndex = rowIndex - this.startRow;
	        return this.rowNodes[localIndex];
	    };
	    InfiniteBlock.prototype.getStartRow = function () {
	        return this.startRow;
	    };
	    InfiniteBlock.prototype.getEndRow = function () {
	        return this.endRow;
	    };
	    // creates empty row nodes, data is missing as not loaded yet
	    InfiniteBlock.prototype.createRowNodes = function () {
	        this.rowNodes = [];
	        for (var i = 0; i < this.params.blockSize; i++) {
	            var rowIndex = this.startRow + i;
	            var rowNode = this.getContext().createBean(new RowNode());
	            rowNode.setRowHeight(this.params.rowHeight);
	            rowNode.uiLevel = 0;
	            rowNode.setRowIndex(rowIndex);
	            rowNode.setRowTop(this.params.rowHeight * rowIndex);
	            this.rowNodes.push(rowNode);
	        }
	    };
	    InfiniteBlock.prototype.processServerResult = function (params) {
	        var _this = this;
	        this.rowNodes.forEach(function (rowNode, index) {
	            var data = params.rowData ? params.rowData[index] : undefined;
	            _this.setDataAndId(rowNode, data, _this.startRow + index);
	        });
	        var finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : undefined;
	        this.parentCache.pageLoaded(this, finalRowCount);
	    };
	    InfiniteBlock.prototype.destroyRowNodes = function () {
	        this.rowNodes.forEach(function (rowNode) {
	            // this is needed, so row render knows to fade out the row, otherwise it
	            // sees row top is present, and thinks the row should be shown.
	            rowNode.clearRowTopAndRowIndex();
	        });
	    };
	    __decorate$2f([
	        PostConstruct
	    ], InfiniteBlock.prototype, "postConstruct", null);
	    __decorate$2f([
	        PreDestroy
	    ], InfiniteBlock.prototype, "destroyRowNodes", null);
	    return InfiniteBlock;
	}(RowNodeBlock));

	var __extends$2s = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2g = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __param$b = function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var InfiniteCache = /** @class */ (function (_super) {
	    __extends$2s(InfiniteCache, _super);
	    function InfiniteCache(params) {
	        var _this = _super.call(this) || this;
	        _this.lastRowIndexKnown = false;
	        _this.blocks = {};
	        _this.blockCount = 0;
	        _this.rowCount = params.initialRowCount;
	        _this.params = params;
	        return _this;
	    }
	    InfiniteCache.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('InfiniteCache');
	    };
	    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
	    // it will want new pages in the cache as it asks for rows. only when we are inserting /
	    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
	    InfiniteCache.prototype.getRow = function (rowIndex, dontCreatePage) {
	        if (dontCreatePage === void 0) { dontCreatePage = false; }
	        var blockId = Math.floor(rowIndex / this.params.blockSize);
	        var block = this.blocks[blockId];
	        if (!block) {
	            if (dontCreatePage) {
	                return null;
	            }
	            block = this.createBlock(blockId);
	        }
	        return block.getRow(rowIndex);
	    };
	    InfiniteCache.prototype.createBlock = function (blockNumber) {
	        var newBlock = this.createBean(new InfiniteBlock(blockNumber, this, this.params));
	        this.blocks[newBlock.getId()] = newBlock;
	        this.blockCount++;
	        this.purgeBlocksIfNeeded(newBlock);
	        this.params.rowNodeBlockLoader.addBlock(newBlock);
	        return newBlock;
	    };
	    // we have this on infinite row model only, not server side row model,
	    // because for server side, it would leave the children in inconsistent
	    // state - eg if a node had children, but after the refresh it had data
	    // for a different row, then the children would be with the wrong row node.
	    InfiniteCache.prototype.refreshCache = function () {
	        var nothingToRefresh = this.blockCount == 0;
	        if (nothingToRefresh) {
	            this.purgeCache();
	            return;
	        }
	        this.getBlocksInOrder().forEach(function (block) { return block.setStateWaitingToLoad(); });
	        this.params.rowNodeBlockLoader.checkBlockToLoad();
	    };
	    InfiniteCache.prototype.destroyAllBlocks = function () {
	        var _this = this;
	        this.getBlocksInOrder().forEach(function (block) { return _this.destroyBlock(block); });
	    };
	    InfiniteCache.prototype.getRowCount = function () {
	        return this.rowCount;
	    };
	    InfiniteCache.prototype.isLastRowIndexKnown = function () {
	        return this.lastRowIndexKnown;
	    };
	    // block calls this, when page loaded
	    InfiniteCache.prototype.pageLoaded = function (block, lastRow) {
	        // if we are not active, then we ignore all events, otherwise we could end up getting the
	        // grid to refresh even though we are no longer the active cache
	        if (!this.isAlive()) {
	            return;
	        }
	        this.logger.log("onPageLoaded: page = " + block.getId() + ", lastRow = " + lastRow);
	        this.checkRowCount(block, lastRow);
	        // we fire cacheUpdated even if the row count has not changed, as some items need updating even
	        // if no new rows to render. for example the pagination panel has '?' as the total rows when loading
	        // is underway, which would need to get updated when loading finishes.
	        this.onCacheUpdated();
	    };
	    InfiniteCache.prototype.purgeBlocksIfNeeded = function (blockToExclude) {
	        var _this = this;
	        // we exclude checking for the page just created, as this has yet to be accessed and hence
	        // the lastAccessed stamp will not be updated for the first time yet
	        var blocksForPurging = this.getBlocksInOrder().filter(function (b) { return b != blockToExclude; });
	        var lastAccessedComparator = function (a, b) { return b.getLastAccessed() - a.getLastAccessed(); };
	        blocksForPurging.sort(lastAccessedComparator);
	        // we remove (maxBlocksInCache - 1) as we already excluded the 'just created' page.
	        // in other words, after the splice operation below, we have taken out the blocks
	        // we want to keep, which means we are left with blocks that we can potentially purge
	        var maxBlocksProvided = this.params.maxBlocksInCache > 0;
	        var blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
	        var emptyBlocksToKeep = InfiniteCache.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
	        blocksForPurging.forEach(function (block, index) {
	            var purgeBecauseBlockEmpty = block.getState() === InfiniteBlock.STATE_WAITING_TO_LOAD && index >= emptyBlocksToKeep;
	            var purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
	            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
	                // if the block currently has rows been displayed, then don't remove it either.
	                // this can happen if user has maxBlocks=2, and blockSize=5 (thus 10 max rows in cache)
	                // but the screen is showing 20 rows, so at least 4 blocks are needed.
	                if (_this.isBlockCurrentlyDisplayed(block)) {
	                    return;
	                }
	                // don't want to loose keyboard focus, so keyboard navigation can continue. so keep focused blocks.
	                if (_this.isBlockFocused(block)) {
	                    return;
	                }
	                // at this point, block is not needed, so burn baby burn
	                _this.removeBlockFromCache(block);
	            }
	        });
	    };
	    InfiniteCache.prototype.isBlockFocused = function (block) {
	        var focusedCell = this.focusController.getFocusCellToUseAfterRefresh();
	        if (!focusedCell) {
	            return false;
	        }
	        if (focusedCell.rowPinned != null) {
	            return false;
	        }
	        var blockIndexStart = block.getStartRow();
	        var blockIndexEnd = block.getEndRow();
	        var hasFocus = focusedCell.rowIndex >= blockIndexStart && focusedCell.rowIndex < blockIndexEnd;
	        return hasFocus;
	    };
	    InfiniteCache.prototype.isBlockCurrentlyDisplayed = function (block) {
	        var startIndex = block.getStartRow();
	        var endIndex = block.getEndRow() - 1;
	        return this.rowRenderer.isRangeInRenderedViewport(startIndex, endIndex);
	    };
	    InfiniteCache.prototype.removeBlockFromCache = function (blockToRemove) {
	        if (!blockToRemove) {
	            return;
	        }
	        this.destroyBlock(blockToRemove);
	        // we do not want to remove the 'loaded' event listener, as the
	        // concurrent loads count needs to be updated when the load is complete
	        // if the purged page is in loading state
	    };
	    InfiniteCache.prototype.checkRowCount = function (block, lastRow) {
	        // if client provided a last row, we always use it, as it could change between server calls
	        // if user deleted data and then called refresh on the grid.
	        if (typeof lastRow === 'number' && lastRow >= 0) {
	            this.rowCount = lastRow;
	            this.lastRowIndexKnown = true;
	        }
	        else if (!this.lastRowIndexKnown) {
	            // otherwise, see if we need to add some virtual rows
	            var lastRowIndex = (block.getId() + 1) * this.params.blockSize;
	            var lastRowIndexPlusOverflow = lastRowIndex + this.params.overflowSize;
	            if (this.rowCount < lastRowIndexPlusOverflow) {
	                this.rowCount = lastRowIndexPlusOverflow;
	            }
	        }
	    };
	    InfiniteCache.prototype.setRowCount = function (rowCount, lastRowIndexKnown) {
	        this.rowCount = rowCount;
	        // if undefined is passed, we do not set this value, if one of {true,false}
	        // is passed, we do set the value.
	        if (_.exists(lastRowIndexKnown)) {
	            this.lastRowIndexKnown = lastRowIndexKnown;
	        }
	        // if we are still searching, then the row count must not end at the end
	        // of a particular page, otherwise the searching will not pop into the
	        // next page
	        if (!this.lastRowIndexKnown) {
	            if (this.rowCount % this.params.blockSize === 0) {
	                this.rowCount++;
	            }
	        }
	        this.onCacheUpdated();
	    };
	    InfiniteCache.prototype.forEachNodeDeep = function (callback) {
	        var _this = this;
	        var sequence = new NumberSequence();
	        this.getBlocksInOrder().forEach(function (block) { return block.forEachNode(callback, sequence, _this.rowCount); });
	    };
	    InfiniteCache.prototype.getBlocksInOrder = function () {
	        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
	        var blockComparator = function (a, b) { return a.getId() - b.getId(); };
	        var blocks = _.getAllValuesInObject(this.blocks).sort(blockComparator);
	        return blocks;
	    };
	    InfiniteCache.prototype.destroyBlock = function (block) {
	        delete this.blocks[block.getId()];
	        this.destroyBean(block);
	        this.blockCount--;
	        this.params.rowNodeBlockLoader.removeBlock(block);
	    };
	    // gets called 1) row count changed 2) cache purged 3) items inserted
	    InfiniteCache.prototype.onCacheUpdated = function () {
	        if (this.isAlive()) {
	            // if the virtualRowCount is shortened, then it's possible blocks exist that are no longer
	            // in the valid range. so we must remove these. this can happen if user explicitly sets
	            // the virtual row count, or the datasource returns a result and sets lastRow to something
	            // less than virtualRowCount (can happen if user scrolls down, server reduces dataset size).
	            this.destroyAllBlocksPastVirtualRowCount();
	            // this results in both row models (infinite and server side) firing ModelUpdated,
	            // however server side row model also updates the row indexes first
	            var event_1 = {
	                type: Events.EVENT_STORE_UPDATED
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    InfiniteCache.prototype.destroyAllBlocksPastVirtualRowCount = function () {
	        var _this = this;
	        var blocksToDestroy = [];
	        this.getBlocksInOrder().forEach(function (block) {
	            var startRow = block.getId() * _this.params.blockSize;
	            if (startRow >= _this.rowCount) {
	                blocksToDestroy.push(block);
	            }
	        });
	        if (blocksToDestroy.length > 0) {
	            blocksToDestroy.forEach(function (block) { return _this.destroyBlock(block); });
	        }
	    };
	    InfiniteCache.prototype.purgeCache = function () {
	        var _this = this;
	        this.getBlocksInOrder().forEach(function (block) { return _this.removeBlockFromCache(block); });
	        this.lastRowIndexKnown = false;
	        // if zero rows in the cache, we need to get the SSRM to start asking for rows again.
	        // otherwise if set to zero rows last time, and we don't update the row count, then after
	        // the purge there will still be zero rows, meaning the SSRM won't request any rows.
	        // to kick things off, at least one row needs to be asked for.
	        if (this.rowCount === 0) {
	            this.rowCount = this.params.initialRowCount;
	        }
	        this.onCacheUpdated();
	    };
	    InfiniteCache.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
	        var _this = this;
	        var result = [];
	        var lastBlockId = -1;
	        var inActiveRange = false;
	        var numberSequence = new NumberSequence();
	        // if only one node passed, we start the selection at the top
	        if (_.missing(firstInRange)) {
	            inActiveRange = true;
	        }
	        var foundGapInSelection = false;
	        this.getBlocksInOrder().forEach(function (block) {
	            if (foundGapInSelection) {
	                return;
	            }
	            if (inActiveRange && (lastBlockId + 1 !== block.getId())) {
	                foundGapInSelection = true;
	                return;
	            }
	            lastBlockId = block.getId();
	            block.forEachNode(function (rowNode) {
	                var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
	                if (inActiveRange || hitFirstOrLast) {
	                    result.push(rowNode);
	                }
	                if (hitFirstOrLast) {
	                    inActiveRange = !inActiveRange;
	                }
	            }, numberSequence, _this.rowCount);
	        });
	        // inActiveRange will be still true if we never hit the second rowNode
	        var invalidRange = foundGapInSelection || inActiveRange;
	        return invalidRange ? [] : result;
	    };
	    // this property says how many empty blocks should be in a cache, eg if scrolls down fast and creates 10
	    // blocks all for loading, the grid will only load the last 2 - it will assume the blocks the user quickly
	    // scrolled over are not needed to be loaded.
	    InfiniteCache.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
	    __decorate$2g([
	        Autowired('rowRenderer')
	    ], InfiniteCache.prototype, "rowRenderer", void 0);
	    __decorate$2g([
	        Autowired("focusController")
	    ], InfiniteCache.prototype, "focusController", void 0);
	    __decorate$2g([
	        __param$b(0, Qualifier('loggerFactory'))
	    ], InfiniteCache.prototype, "setBeans", null);
	    __decorate$2g([
	        PreDestroy
	    ], InfiniteCache.prototype, "destroyAllBlocks", null);
	    return InfiniteCache;
	}(BeanStub));

	var __extends$2t = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2h = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var InfiniteRowModel = /** @class */ (function (_super) {
	    __extends$2t(InfiniteRowModel, _super);
	    function InfiniteRowModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InfiniteRowModel.prototype.getRowBounds = function (index) {
	        return {
	            rowHeight: this.rowHeight,
	            rowTop: this.rowHeight * index
	        };
	    };
	    // we don't implement as lazy row heights is not supported in this row model
	    InfiniteRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
	        return false;
	    };
	    InfiniteRowModel.prototype.init = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isRowModelInfinite()) {
	            return;
	        }
	        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        this.addEventListeners();
	        this.addDestroyFunc(function () { return _this.destroyCache(); });
	        this.verifyProps();
	    };
	    InfiniteRowModel.prototype.verifyProps = function () {
	        if (this.gridOptionsWrapper.getDefaultGroupSortComparator() != null) {
	            var message_1 = "AG Grid: defaultGroupSortComparator cannot be used with Infinite Row Model. If using Infinite Row Model, then sorting is done on the server side, nothing to do with the client.";
	            _.doOnce(function () { return console.warn(message_1); }, 'IRM.DefaultGroupSortComparator');
	        }
	    };
	    InfiniteRowModel.prototype.start = function () {
	        this.setDatasource(this.gridOptionsWrapper.getDatasource());
	    };
	    InfiniteRowModel.prototype.destroyDatasource = function () {
	        if (this.datasource) {
	            this.getContext().destroyBean(this.datasource);
	            this.rowRenderer.datasourceChanged();
	            this.datasource = null;
	        }
	    };
	    InfiniteRowModel.prototype.addEventListeners = function () {
	        this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this));
	        this.addManagedListener(this.eventService, Events.EVENT_STORE_UPDATED, this.onCacheUpdated.bind(this));
	    };
	    InfiniteRowModel.prototype.onFilterChanged = function () {
	        this.reset();
	    };
	    InfiniteRowModel.prototype.onSortChanged = function () {
	        this.reset();
	    };
	    InfiniteRowModel.prototype.onColumnEverything = function () {
	        var resetRequired;
	        // if cache params, we require reset only if sort model has changed. we don't need to check
	        // for filter model, as the filter manager will fire an event when columns change that result
	        // in the filter changing.
	        if (this.cacheParams) {
	            resetRequired = this.isSortModelDifferent();
	        }
	        else {
	            // if no cacheParams, means first time creating the cache, so always create one
	            resetRequired = true;
	        }
	        if (resetRequired) {
	            this.reset();
	        }
	    };
	    InfiniteRowModel.prototype.isSortModelDifferent = function () {
	        return !_.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
	    };
	    InfiniteRowModel.prototype.getType = function () {
	        return Constants.ROW_MODEL_TYPE_INFINITE;
	    };
	    InfiniteRowModel.prototype.setDatasource = function (datasource) {
	        this.destroyDatasource();
	        this.datasource = datasource;
	        // only reset if we have a valid datasource to working with
	        if (datasource) {
	            this.reset();
	        }
	    };
	    InfiniteRowModel.prototype.isEmpty = function () {
	        return !this.infiniteCache;
	    };
	    InfiniteRowModel.prototype.isRowsToRender = function () {
	        return !!this.infiniteCache;
	    };
	    InfiniteRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(firstInRange, lastInRange) : [];
	    };
	    InfiniteRowModel.prototype.reset = function () {
	        // important to return here, as the user could be setting filter or sort before
	        // data-source is set
	        if (!this.datasource) {
	            return;
	        }
	        // if user is providing id's, then this means we can keep the selection between datasource hits,
	        // as the rows will keep their unique id's even if, for example, server side sorting or filtering
	        // is done.
	        var userGeneratingIds = _.exists(this.gridOptionsWrapper.getRowNodeIdFunc());
	        if (!userGeneratingIds) {
	            this.selectionController.reset();
	        }
	        this.resetCache();
	        var event = this.createModelUpdatedEvent();
	        this.eventService.dispatchEvent(event);
	    };
	    InfiniteRowModel.prototype.createModelUpdatedEvent = function () {
	        return {
	            type: Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            // not sure if these should all be false - noticed if after implementing,
	            // maybe they should be true?
	            newPage: false,
	            newData: false,
	            keepRenderedRows: true,
	            animate: false
	        };
	    };
	    InfiniteRowModel.prototype.resetCache = function () {
	        // if not first time creating a cache, need to destroy the old one
	        this.destroyCache();
	        var maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
	        this.cacheParams = {
	            // the user provided datasource
	            datasource: this.datasource,
	            // sort and filter model
	            filterModel: this.filterManager.getFilterModel(),
	            sortModel: this.sortController.getSortModel(),
	            rowNodeBlockLoader: this.rowNodeBlockLoader,
	            // properties - this way we take a snapshot of them, so if user changes any, they will be
	            // used next time we create a new cache, which is generally after a filter or sort change,
	            // or a new datasource is set
	            maxConcurrentRequests: this.defaultIfInvalid(maxConcurrentRequests, 2),
	            initialRowCount: this.defaultIfInvalid(this.gridOptionsWrapper.getInfiniteInitialRowCount(), 1),
	            maxBlocksInCache: this.gridOptionsWrapper.getMaxBlocksInCache(),
	            rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
	            // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
	            // the current page and request first row of next page
	            overflowSize: this.defaultIfInvalid(this.gridOptionsWrapper.getCacheOverflowSize(), 1),
	            // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
	            // server for one page at a time. so the default if not specified is 100.
	            blockSize: this.defaultIfInvalid(this.gridOptionsWrapper.getCacheBlockSize(), 100),
	            // the cache could create this, however it is also used by the pages, so handy to create it
	            // here as the settings are also passed to the pages
	            lastAccessedSequence: new NumberSequence()
	        };
	        this.infiniteCache = this.createBean(new InfiniteCache(this.cacheParams));
	    };
	    InfiniteRowModel.prototype.defaultIfInvalid = function (value, defaultValue) {
	        return value > 0 ? value : defaultValue;
	    };
	    InfiniteRowModel.prototype.destroyCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache = this.destroyBean(this.infiniteCache);
	        }
	    };
	    InfiniteRowModel.prototype.onCacheUpdated = function () {
	        var event = this.createModelUpdatedEvent();
	        this.eventService.dispatchEvent(event);
	    };
	    InfiniteRowModel.prototype.getRow = function (rowIndex) {
	        return this.infiniteCache ? this.infiniteCache.getRow(rowIndex) : null;
	    };
	    InfiniteRowModel.prototype.getRowNode = function (id) {
	        var result = null;
	        this.forEachNode(function (rowNode) {
	            if (rowNode.id === id) {
	                result = rowNode;
	            }
	        });
	        return result;
	    };
	    InfiniteRowModel.prototype.forEachNode = function (callback) {
	        if (this.infiniteCache) {
	            this.infiniteCache.forEachNodeDeep(callback);
	        }
	    };
	    InfiniteRowModel.prototype.getTopLevelRowCount = function () {
	        return this.getRowCount();
	    };
	    InfiniteRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        return topLevelIndex;
	    };
	    InfiniteRowModel.prototype.getRowIndexAtPixel = function (pixel) {
	        if (this.rowHeight !== 0) { // avoid divide by zero error
	            var rowIndexForPixel = Math.floor(pixel / this.rowHeight);
	            var lastRowIndex = this.getRowCount() - 1;
	            if (rowIndexForPixel > lastRowIndex) {
	                return lastRowIndex;
	            }
	            else {
	                return rowIndexForPixel;
	            }
	        }
	        else {
	            return 0;
	        }
	    };
	    InfiniteRowModel.prototype.getRowCount = function () {
	        return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
	    };
	    InfiniteRowModel.prototype.isRowPresent = function (rowNode) {
	        var foundRowNode = this.getRowNode(rowNode.id);
	        return !!foundRowNode;
	    };
	    InfiniteRowModel.prototype.refreshCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.refreshCache();
	        }
	    };
	    InfiniteRowModel.prototype.purgeCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.purgeCache();
	        }
	    };
	    // for iRowModel
	    InfiniteRowModel.prototype.isLastRowIndexKnown = function () {
	        if (this.infiniteCache) {
	            return this.infiniteCache.isLastRowIndexKnown();
	        }
	        else {
	            return false;
	        }
	    };
	    InfiniteRowModel.prototype.setRowCount = function (rowCount, lastRowIndexKnown) {
	        if (this.infiniteCache) {
	            this.infiniteCache.setRowCount(rowCount, lastRowIndexKnown);
	        }
	    };
	    __decorate$2h([
	        Autowired('filterManager')
	    ], InfiniteRowModel.prototype, "filterManager", void 0);
	    __decorate$2h([
	        Autowired('sortController')
	    ], InfiniteRowModel.prototype, "sortController", void 0);
	    __decorate$2h([
	        Autowired('selectionController')
	    ], InfiniteRowModel.prototype, "selectionController", void 0);
	    __decorate$2h([
	        Autowired('gridApi')
	    ], InfiniteRowModel.prototype, "gridApi", void 0);
	    __decorate$2h([
	        Autowired('columnApi')
	    ], InfiniteRowModel.prototype, "columnApi", void 0);
	    __decorate$2h([
	        Autowired('rowRenderer')
	    ], InfiniteRowModel.prototype, "rowRenderer", void 0);
	    __decorate$2h([
	        Autowired('rowNodeBlockLoader')
	    ], InfiniteRowModel.prototype, "rowNodeBlockLoader", void 0);
	    __decorate$2h([
	        PostConstruct
	    ], InfiniteRowModel.prototype, "init", null);
	    __decorate$2h([
	        PreDestroy
	    ], InfiniteRowModel.prototype, "destroyDatasource", null);
	    InfiniteRowModel = __decorate$2h([
	        Bean('rowModel')
	    ], InfiniteRowModel);
	    return InfiniteRowModel;
	}(BeanStub));

	var InfiniteRowModelModule = {
	    moduleName: exports.ModuleNames.InfiniteRowModelModule,
	    rowModels: { infinite: InfiniteRowModel }
	};

	var BaseCreator = /** @class */ (function () {
	    function BaseCreator() {
	    }
	    BaseCreator.prototype.setBeans = function (beans) {
	        this.beans = beans;
	    };
	    BaseCreator.prototype.getFileName = function (fileName) {
	        var extension = this.getDefaultFileExtension();
	        if (fileName == null || !fileName.length) {
	            fileName = this.getDefaultFileName();
	        }
	        return fileName.indexOf('.') === -1 ? fileName + "." + extension : fileName;
	    };
	    BaseCreator.prototype.getMergedParamsAndData = function (userParams) {
	        var mergedParams = this.mergeDefaultParams(userParams);
	        var data = this.beans.gridSerializer.serialize(this.createSerializingSession(mergedParams), mergedParams);
	        return { mergedParams: mergedParams, data: data };
	    };
	    BaseCreator.prototype.mergeDefaultParams = function (userParams) {
	        var baseParams = this.getDefaultExportParams();
	        var params = {};
	        _.assign(params, baseParams);
	        _.assign(params, userParams);
	        return params;
	    };
	    return BaseCreator;
	}());

	var BaseGridSerializingSession = /** @class */ (function () {
	    function BaseGridSerializingSession(config) {
	        this.groupColumns = [];
	        var columnController = config.columnController, valueService = config.valueService, gridOptionsWrapper = config.gridOptionsWrapper, processCellCallback = config.processCellCallback, processHeaderCallback = config.processHeaderCallback, processGroupHeaderCallback = config.processGroupHeaderCallback, processRowGroupCallback = config.processRowGroupCallback;
	        this.columnController = columnController;
	        this.valueService = valueService;
	        this.gridOptionsWrapper = gridOptionsWrapper;
	        this.processCellCallback = processCellCallback;
	        this.processHeaderCallback = processHeaderCallback;
	        this.processGroupHeaderCallback = processGroupHeaderCallback;
	        this.processRowGroupCallback = processRowGroupCallback;
	    }
	    BaseGridSerializingSession.prototype.prepare = function (columnsToExport) {
	        this.groupColumns = _.filter(columnsToExport, function (col) { return !!col.getColDef().showRowGroup; });
	    };
	    BaseGridSerializingSession.prototype.extractHeaderValue = function (column) {
	        var value = this.getHeaderName(this.processHeaderCallback, column);
	        return value != null ? value : '';
	    };
	    BaseGridSerializingSession.prototype.extractRowCellValue = function (column, index, accumulatedRowIndex, type, node) {
	        // we render the group summary text e.g. "-> Parent -> Child"...
	        var groupIndex = this.gridOptionsWrapper.isGroupMultiAutoColumn() ? node.rowGroupIndex : 0;
	        var renderGroupSummaryCell = 
	        // on group rows
	        node && node.group
	            && (
	            // in the group column if groups appear in regular grid cells
	            index === groupIndex && this.groupColumns.indexOf(column) !== -1
	                // or the first cell in the row, if we're doing full width rows
	                || (index === 0 && this.gridOptionsWrapper.isGroupUseEntireRow(this.columnController.isPivotMode())));
	        var valueForCell;
	        if (renderGroupSummaryCell) {
	            valueForCell = this.createValueForGroupNode(node);
	        }
	        else {
	            valueForCell = this.valueService.getValue(column, node);
	        }
	        var value = this.processCell(accumulatedRowIndex, node, column, valueForCell, this.processCellCallback, type);
	        return value != null ? value : '';
	    };
	    BaseGridSerializingSession.prototype.getHeaderName = function (callback, column) {
	        if (callback) {
	            return callback({
	                column: column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            });
	        }
	        return this.columnController.getDisplayNameForColumn(column, 'csv', true);
	    };
	    BaseGridSerializingSession.prototype.createValueForGroupNode = function (node) {
	        if (this.processRowGroupCallback) {
	            return this.processRowGroupCallback({
	                node: node,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext(),
	            });
	        }
	        var keys = [node.key];
	        if (!this.gridOptionsWrapper.isGroupMultiAutoColumn()) {
	            while (node.parent) {
	                node = node.parent;
	                keys.push(node.key);
	            }
	        }
	        return keys.reverse().join(' -> ');
	    };
	    BaseGridSerializingSession.prototype.processCell = function (accumulatedRowIndex, rowNode, column, value, processCellCallback, type) {
	        if (processCellCallback) {
	            return processCellCallback({
	                accumulatedRowIndex: accumulatedRowIndex,
	                column: column,
	                node: rowNode,
	                value: value,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext(),
	                type: type
	            });
	        }
	        return value != null ? value : '';
	    };
	    return BaseGridSerializingSession;
	}());

	var Downloader = /** @class */ (function () {
	    function Downloader() {
	    }
	    Downloader.download = function (fileName, content) {
	        var win = document.defaultView || window;
	        if (!win) {
	            console.warn('AG Grid: There is no `window` associated with the current `document`');
	            return;
	        }
	        // Internet Explorer
	        if (win.navigator.msSaveOrOpenBlob) {
	            win.navigator.msSaveOrOpenBlob(content, fileName);
	        }
	        else {
	            // Other Browsers
	            var element = document.createElement('a');
	            // @ts-ignore
	            var url_1 = win.URL.createObjectURL(content);
	            element.setAttribute('href', url_1);
	            element.setAttribute('download', fileName);
	            element.style.display = 'none';
	            document.body.appendChild(element);
	            element.dispatchEvent(new MouseEvent('click', {
	                bubbles: false,
	                cancelable: true,
	                view: win
	            }));
	            document.body.removeChild(element);
	            win.setTimeout(function () {
	                // @ts-ignore
	                win.URL.revokeObjectURL(url_1);
	            }, 0);
	        }
	    };
	    return Downloader;
	}());

	var __extends$2u = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var LINE_SEPARATOR = '\r\n';
	var CsvSerializingSession = /** @class */ (function (_super) {
	    __extends$2u(CsvSerializingSession, _super);
	    function CsvSerializingSession(config) {
	        var _this = _super.call(this, config) || this;
	        _this.isFirstLine = true;
	        _this.result = '';
	        var suppressQuotes = config.suppressQuotes, columnSeparator = config.columnSeparator;
	        _this.suppressQuotes = suppressQuotes;
	        _this.columnSeparator = columnSeparator;
	        return _this;
	    }
	    CsvSerializingSession.prototype.addCustomContent = function (content) {
	        var _this = this;
	        if (!content) {
	            return;
	        }
	        if (typeof content === 'string') {
	            if (!/^\s*\n/.test(content)) {
	                this.beginNewLine();
	            }
	            // replace whatever newlines are supplied with the style we're using
	            content = content.replace(/\r?\n/g, LINE_SEPARATOR);
	            this.result += content;
	        }
	        else {
	            content.forEach(function (row) {
	                _this.beginNewLine();
	                row.forEach(function (cell, index) {
	                    if (index !== 0) {
	                        _this.result += _this.columnSeparator;
	                    }
	                    _this.result += _this.putInQuotes(cell.data.value || '');
	                    if (cell.mergeAcross) {
	                        _this.appendEmptyCells(cell.mergeAcross);
	                    }
	                });
	            });
	        }
	    };
	    CsvSerializingSession.prototype.onNewHeaderGroupingRow = function () {
	        this.beginNewLine();
	        return {
	            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewHeaderGroupingRowColumn = function (header, index, span) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(header);
	        this.appendEmptyCells(span);
	    };
	    CsvSerializingSession.prototype.appendEmptyCells = function (count) {
	        for (var i = 1; i <= count; i++) {
	            this.result += this.columnSeparator + this.putInQuotes("");
	        }
	    };
	    CsvSerializingSession.prototype.onNewHeaderRow = function () {
	        this.beginNewLine();
	        return {
	            onColumn: this.onNewHeaderRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewHeaderRowColumn = function (column, index) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(this.extractHeaderValue(column));
	    };
	    CsvSerializingSession.prototype.onNewBodyRow = function () {
	        this.beginNewLine();
	        return {
	            onColumn: this.onNewBodyRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewBodyRowColumn = function (column, index, node) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(this.extractRowCellValue(column, index, index, Constants.EXPORT_TYPE_CSV, node));
	    };
	    CsvSerializingSession.prototype.putInQuotes = function (value) {
	        if (this.suppressQuotes) {
	            return value;
	        }
	        if (value === null || value === undefined) {
	            return '""';
	        }
	        var stringValue;
	        if (typeof value === 'string') {
	            stringValue = value;
	        }
	        else if (typeof value.toString === 'function') {
	            stringValue = value.toString();
	        }
	        else {
	            console.warn('unknown value type during csv conversion');
	            stringValue = '';
	        }
	        // replace each " with "" (ie two sets of double quotes is how to do double quotes in csv)
	        var valueEscaped = stringValue.replace(/"/g, "\"\"");
	        return '"' + valueEscaped + '"';
	    };
	    CsvSerializingSession.prototype.parse = function () {
	        return this.result;
	    };
	    CsvSerializingSession.prototype.beginNewLine = function () {
	        if (!this.isFirstLine) {
	            this.result += LINE_SEPARATOR;
	        }
	        this.isFirstLine = false;
	    };
	    return CsvSerializingSession;
	}(BaseGridSerializingSession));

	var __extends$2v = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2i = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var CsvCreator = /** @class */ (function (_super) {
	    __extends$2v(CsvCreator, _super);
	    function CsvCreator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CsvCreator.prototype.postConstruct = function () {
	        this.setBeans({
	            gridSerializer: this.gridSerializer,
	            gridOptionsWrapper: this.gridOptionsWrapper
	        });
	    };
	    CsvCreator.prototype.getDefaultExportParams = function () {
	        return this.gridOptionsWrapper.getDefaultExportParams('csv');
	    };
	    CsvCreator.prototype.export = function (userParams) {
	        if (this.isExportSuppressed()) {
	            console.warn("ag-grid: Export cancelled. Export is not allowed as per your configuration.");
	            return '';
	        }
	        var _a = this.getMergedParamsAndData(userParams), mergedParams = _a.mergedParams, data = _a.data;
	        var packagedFile = new Blob(["\ufeff", data], {
	            // @ts-ignore
	            type: window.navigator.msSaveOrOpenBlob ? this.getMimeType() : 'octet/stream'
	        });
	        Downloader.download(this.getFileName(mergedParams.fileName), packagedFile);
	        return data;
	    };
	    CsvCreator.prototype.exportDataAsCsv = function (params) {
	        return this.export(params);
	    };
	    CsvCreator.prototype.getDataAsCsv = function (params) {
	        return this.getMergedParamsAndData(params).data;
	    };
	    CsvCreator.prototype.getMimeType = function () {
	        return 'text/csv;charset=utf-8;';
	    };
	    CsvCreator.prototype.getDefaultFileName = function () {
	        return 'export.csv';
	    };
	    CsvCreator.prototype.getDefaultFileExtension = function () {
	        return 'csv';
	    };
	    CsvCreator.prototype.createSerializingSession = function (params) {
	        var _a = this, columnController = _a.columnController, valueService = _a.valueService, gridOptionsWrapper = _a.gridOptionsWrapper;
	        var _b = params, processCellCallback = _b.processCellCallback, processHeaderCallback = _b.processHeaderCallback, processGroupHeaderCallback = _b.processGroupHeaderCallback, processRowGroupCallback = _b.processRowGroupCallback, suppressQuotes = _b.suppressQuotes, columnSeparator = _b.columnSeparator;
	        return new CsvSerializingSession({
	            columnController: columnController,
	            valueService: valueService,
	            gridOptionsWrapper: gridOptionsWrapper,
	            processCellCallback: processCellCallback || undefined,
	            processHeaderCallback: processHeaderCallback || undefined,
	            processGroupHeaderCallback: processGroupHeaderCallback || undefined,
	            processRowGroupCallback: processRowGroupCallback || undefined,
	            suppressQuotes: suppressQuotes || false,
	            columnSeparator: columnSeparator || ','
	        });
	    };
	    CsvCreator.prototype.isExportSuppressed = function () {
	        return this.gridOptionsWrapper.isSuppressCsvExport();
	    };
	    __decorate$2i([
	        Autowired('columnController')
	    ], CsvCreator.prototype, "columnController", void 0);
	    __decorate$2i([
	        Autowired('valueService')
	    ], CsvCreator.prototype, "valueService", void 0);
	    __decorate$2i([
	        Autowired('gridSerializer')
	    ], CsvCreator.prototype, "gridSerializer", void 0);
	    __decorate$2i([
	        Autowired('gridOptionsWrapper')
	    ], CsvCreator.prototype, "gridOptionsWrapper", void 0);
	    __decorate$2i([
	        PostConstruct
	    ], CsvCreator.prototype, "postConstruct", null);
	    CsvCreator = __decorate$2i([
	        Bean('csvCreator')
	    ], CsvCreator);
	    return CsvCreator;
	}(BaseCreator));

	var __extends$2w = (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$2j = function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	(function (RowType) {
	    RowType[RowType["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
	    RowType[RowType["HEADER"] = 1] = "HEADER";
	    RowType[RowType["BODY"] = 2] = "BODY";
	})(exports.RowType || (exports.RowType = {}));
	var GridSerializer = /** @class */ (function (_super) {
	    __extends$2w(GridSerializer, _super);
	    function GridSerializer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GridSerializer.prototype.serialize = function (gridSerializingSession, params) {
	        if (params === void 0) { params = {}; }
	        var columnsToExport = this.getColumnsToExport(params.allColumns, params.columnKeys);
	        var serializeChain = _.compose(
	        // first pass, put in the header names of the cols
	        this.prepareSession(columnsToExport), this.prependContent(params), this.exportColumnGroups(params, columnsToExport), this.exportHeaders(params, columnsToExport), this.processPinnedTopRows(params, columnsToExport), this.processRows(params, columnsToExport), this.processPinnedBottomRows(params, columnsToExport), this.appendContent(params));
	        return serializeChain(gridSerializingSession).parse();
	    };
	    GridSerializer.prototype.processRow = function (gridSerializingSession, params, columnsToExport, node) {
	        var rowSkipper = params.shouldRowBeSkipped || (function () { return false; });
	        var gridOptionsWrapper = this.gridOptionsWrapper;
	        var context = gridOptionsWrapper.getContext();
	        var api = gridOptionsWrapper.getApi();
	        var columnApi = gridOptionsWrapper.getColumnApi();
	        var skipSingleChildrenGroup = gridOptionsWrapper.isGroupRemoveSingleChildren();
	        var hideOpenParents = gridOptionsWrapper.isGroupHideOpenParents();
	        var skipLowestSingleChildrenGroup = gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
	        var isLeafNode = this.columnController.isPivotMode() ? node.leafGroup : !node.group;
	        var skipRowGroups = params.skipGroups || params.skipRowGroups;
	        var shouldSkipLowestGroup = skipLowestSingleChildrenGroup && node.leafGroup;
	        var shouldSkipCurrentGroup = node.allChildrenCount === 1 && (skipSingleChildrenGroup || shouldSkipLowestGroup);
	        if (skipRowGroups && params.skipGroups) {
	            _.doOnce(function () { return console.warn('AG Grid: Since v25.2 `skipGroups` has been renamed to `skipRowGroups`.'); }, 'gridSerializer-skipGroups');
	        }
	        if ((!isLeafNode && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents)) ||
	            (params.onlySelected && !node.isSelected()) ||
	            (params.skipPinnedTop && node.rowPinned === 'top') ||
	            (params.skipPinnedBottom && node.rowPinned === 'bottom')) {
	            return;
	        }
	        // if we are in pivotMode, then the grid will show the root node only
	        // if it's not a leaf group
	        var nodeIsRootNode = node.level === -1;
	        if (nodeIsRootNode && !node.leafGroup) {
	            return;
	        }
	        var shouldRowBeSkipped = rowSkipper({ node: node, api: api, context: context });
	        if (shouldRowBeSkipped) {
	            return;
	        }
	        var rowAccumulator = gridSerializingSession.onNewBodyRow();
	        columnsToExport.forEach(function (column, index) {
	            rowAccumulator.onColumn(column, index, node);
	        });
	        if (params.getCustomContentBelowRow) {
	            var content = params.getCustomContentBelowRow({ node: node, api: api, columnApi: columnApi, context: context });
	            if (content) {
	                gridSerializingSession.addCustomContent(content);
	            }
	        }
	    };
	    GridSerializer.prototype.appendContent = function (params) {
	        return function (gridSerializingSession) {
	            var appendContent = params.customFooter || params.appendContent;
	            if (appendContent) {
	                if (params.customFooter) {
	                    _.doOnce(function () { return console.warn('AG Grid: Since version 25.2.0 the `customFooter` param has been deprecated. Use `appendContent` instead.'); }, 'gridSerializer-customFooter');
	                }
	                gridSerializingSession.addCustomContent(appendContent);
	            }
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.prependContent = function (params) {
	        return function (gridSerializingSession) {
	            var prependContent = params.customHeader || params.prependContent;
	            if (prependContent) {
	                if (params.customHeader) {
	                    _.doOnce(function () { return console.warn('AG Grid: Since version 25.2.0 the `customHeader` param has been deprecated. Use `prependContent` instead.'); }, 'gridSerializer-customHeader');
	                }
	                gridSerializingSession.addCustomContent(prependContent);
	            }
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.prepareSession = function (columnsToExport) {
	        return function (gridSerializingSession) {
	            gridSerializingSession.prepare(columnsToExport);
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.exportColumnGroups = function (params, columnsToExport) {
	        var _this = this;
	        return function (gridSerializingSession) {
	            if (!params.skipColumnGroupHeaders) {
	                var groupInstanceIdCreator = new GroupInstanceIdCreator();
	                var displayedGroups = _this.displayedGroupCreator.createDisplayedGroups(columnsToExport, _this.columnController.getGridBalancedTree(), groupInstanceIdCreator, null);
	                _this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
	            }
	            else if (params.columnGroups) {
	                _.doOnce(function () { return console.warn('AG Grid: Since v25.2 the `columnGroups` param has deprecated, and groups are exported by default.'); }, 'gridSerializer-columnGroups');
	            }
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.exportHeaders = function (params, columnsToExport) {
	        return function (gridSerializingSession) {
	            if (!params.skipHeader && !params.skipColumnHeaders) {
	                var gridRowIterator_1 = gridSerializingSession.onNewHeaderRow();
	                columnsToExport.forEach(function (column, index) {
	                    gridRowIterator_1.onColumn(column, index, undefined);
	                });
	            }
	            else if (params.skipHeader) {
	                _.doOnce(function () { return console.warn('AG Grid: Since v25.2 the `skipHeader` param has been renamed to `skipColumnHeaders`.'); }, 'gridSerializer-skipHeader');
	            }
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.processPinnedTopRows = function (params, columnsToExport) {
	        var _this = this;
	        return function (gridSerializingSession) {
	            var processRow = _this.processRow.bind(_this, gridSerializingSession, params, columnsToExport);
	            _this.pinnedRowModel.forEachPinnedTopRow(processRow);
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.processRows = function (params, columnsToExport) {
	        var _this = this;
	        return function (gridSerializingSession) {
	            // when in pivot mode, we always render cols on screen, never 'all columns'
	            var rowModel = _this.rowModel;
	            var rowModelType = rowModel.getType();
	            var usingCsrm = rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	            var usingSsrm = rowModelType === Constants.ROW_MODEL_TYPE_SERVER_SIDE;
	            var onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
	            var processRow = _this.processRow.bind(_this, gridSerializingSession, params, columnsToExport);
	            if (_this.columnController.isPivotMode()) {
	                if (usingCsrm) {
	                    rowModel.forEachPivotNode(processRow);
	                }
	                else {
	                    // must be enterprise, so we can just loop through all the nodes
	                    rowModel.forEachNode(processRow);
	                }
	            }
	            else {
	                // onlySelectedAllPages: user doing pagination and wants selected items from
	                // other pages, so cannot use the standard row model as it won't have rows from
	                // other pages.
	                // onlySelectedNonStandardModel: if user wants selected in non standard row model
	                // (eg viewport) then again RowModel cannot be used, so need to use selected instead.
	                if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
	                    var selectedNodes = _this.selectionController.getSelectedNodes();
	                    selectedNodes.forEach(processRow);
	                }
	                else {
	                    // here is everything else - including standard row model and selected. we don't use
	                    // the selection model even when just using selected, so that the result is the order
	                    // of the rows appearing on the screen.
	                    if (usingCsrm) {
	                        rowModel.forEachNodeAfterFilterAndSort(processRow);
	                    }
	                    else if (usingSsrm) {
	                        rowModel.forEachNodeAfterFilterAndSort(processRow);
	                    }
	                    else {
	                        rowModel.forEachNode(processRow);
	                    }
	                }
	            }
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.processPinnedBottomRows = function (params, columnsToExport) {
	        var _this = this;
	        return function (gridSerializingSession) {
	            var processRow = _this.processRow.bind(_this, gridSerializingSession, params, columnsToExport);
	            _this.pinnedRowModel.forEachPinnedBottomRow(processRow);
	            return gridSerializingSession;
	        };
	    };
	    GridSerializer.prototype.getColumnsToExport = function (allColumns, columnKeys) {
	        if (allColumns === void 0) { allColumns = false; }
	        var isPivotMode = this.columnController.isPivotMode();
	        if (columnKeys && columnKeys.length) {
	            return this.columnController.getGridColumns(columnKeys);
	        }
	        if (allColumns && !isPivotMode) {
	            // add auto group column for tree data
	            var columns = this.gridOptionsWrapper.isTreeData()
	                ? this.columnController.getGridColumns([Constants.GROUP_AUTO_COLUMN_ID])
	                : [];
	            return columns.concat(this.columnController.getAllPrimaryColumns() || []);
	        }
	        return this.columnController.getAllDisplayedColumns();
	    };
	    GridSerializer.prototype.recursivelyAddHeaderGroups = function (displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
	        var directChildrenHeaderGroups = [];
	        displayedGroups.forEach(function (columnGroupChild) {
	            var columnGroup = columnGroupChild;
	            if (!columnGroup.getChildren) {
	                return;
	            }
	            columnGroup.getChildren().forEach(function (it) { return directChildrenHeaderGroups.push(it); });
	        });
	        if (displayedGroups.length > 0 && displayedGroups[0] instanceof ColumnGroup) {
	            this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
	        }
	        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) {
	            this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
	        }
	    };
	    GridSerializer.prototype.doAddHeaderHeader = function (gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
	        var _this = this;
	        var gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
	        var columnIndex = 0;
	        displayedGroups.forEach(function (columnGroupChild) {
	            var columnGroup = columnGroupChild;
	            var name;
	            if (processGroupHeaderCallback) {
	                name = processGroupHeaderCallback({
	                    columnGroup: columnGroup,
	                    api: _this.gridOptionsWrapper.getApi(),
	                    columnApi: _this.gridOptionsWrapper.getColumnApi(),
	                    context: _this.gridOptionsWrapper.getContext()
	                });
	            }
	            else {
	                name = _this.columnController.getDisplayNameForColumnGroup(columnGroup, 'header');
	            }
	            gridRowIterator.onColumn(name || '', columnIndex++, columnGroup.getLeafColumns().length - 1);
	        });
	    };
	    __decorate$2j([
	        Autowired('displayedGroupCreator')
	    ], GridSerializer.prototype, "displayedGroupCreator", void 0);
	    __decorate$2j([
	        Autowired('columnController')
	    ], GridSerializer.prototype, "columnController", void 0);
	    __decorate$2j([
	        Autowired('rowModel')
	    ], GridSerializer.prototype, "rowModel", void 0);
	    __decorate$2j([
	        Autowired('pinnedRowModel')
	    ], GridSerializer.prototype, "pinnedRowModel", void 0);
	    __decorate$2j([
	        Autowired('selectionController')
	    ], GridSerializer.prototype, "selectionController", void 0);
	    GridSerializer = __decorate$2j([
	        Bean("gridSerializer")
	    ], GridSerializer);
	    return GridSerializer;
	}(BeanStub));

	var CsvExportModule = {
	    moduleName: exports.ModuleNames.CsvExportModule,
	    beans: [CsvCreator, GridSerializer]
	};

	var LINE_SEPARATOR$1 = '\r\n';
	var XmlFactory = /** @class */ (function () {
	    function XmlFactory() {
	    }
	    XmlFactory.createHeader = function (headerElement) {
	        if (headerElement === void 0) { headerElement = {}; }
	        var headerStart = '<?';
	        var headerEnd = '?>';
	        var keys = ['version'];
	        if (!headerElement.version) {
	            headerElement.version = "1.0";
	        }
	        if (headerElement.encoding) {
	            keys.push('encoding');
	        }
	        if (headerElement.standalone) {
	            keys.push('standalone');
	        }
	        var att = keys.map(function (key) { return key + "=\"" + headerElement[key] + "\""; }).join(' ');
	        return headerStart + "xml " + att + " " + headerEnd;
	    };
	    XmlFactory.createXml = function (xmlElement, booleanTransformer) {
	        var _this = this;
	        var props = '';
	        if (xmlElement.properties) {
	            if (xmlElement.properties.prefixedAttributes) {
	                xmlElement.properties.prefixedAttributes.forEach(function (prefixedSet) {
	                    Object.keys(prefixedSet.map).forEach(function (key) {
	                        props += _this.returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
	                    });
	                });
	            }
	            if (xmlElement.properties.rawMap) {
	                Object.keys(xmlElement.properties.rawMap).forEach(function (key) {
	                    props += _this.returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
	                });
	            }
	        }
	        var result = '<' + xmlElement.name + props;
	        if (!xmlElement.children && xmlElement.textNode == null) {
	            return result + '/>' + LINE_SEPARATOR$1;
	        }
	        if (xmlElement.textNode != null) {
	            return result + '>' + xmlElement.textNode + '</' + xmlElement.name + '>' + LINE_SEPARATOR$1;
	        }
	        result += '>' + LINE_SEPARATOR$1;
	        if (xmlElement.children) {
	            xmlElement.children.forEach(function (it) {
	                result += _this.createXml(it, booleanTransformer);
	            });
	        }
	        return result + '</' + xmlElement.name + '>' + LINE_SEPARATOR$1;
	    };
	    XmlFactory.returnAttributeIfPopulated = function (key, value, booleanTransformer) {
	        if (!value && value !== '' && value !== 0) {
	            return '';
	        }
	        var xmlValue = value;
	        if ((typeof (value) === 'boolean')) {
	            if (booleanTransformer) {
	                xmlValue = booleanTransformer(value);
	            }
	        }
	        return " " + key + "=\"" + xmlValue + "\"";
	    };
	    return XmlFactory;
	}());

	// table for crc calculation
	// from: https://referencesource.microsoft.com/#System/sys/System/IO/compression/Crc32Helper.cs,3b31978c7d7f7246,references
	var crcTable = new Uint32Array([
	    0x00000000, 0x77073096, 0xee0e612c, 0x990951ba, 0x076dc419, 0x706af48f,
	    0xe963a535, 0x9e6495a3, 0x0edb8832, 0x79dcb8a4, 0xe0d5e91e, 0x97d2d988,
	    0x09b64c2b, 0x7eb17cbd, 0xe7b82d07, 0x90bf1d91, 0x1db71064, 0x6ab020f2,
	    0xf3b97148, 0x84be41de, 0x1adad47d, 0x6ddde4eb, 0xf4d4b551, 0x83d385c7,
	    0x136c9856, 0x646ba8c0, 0xfd62f97a, 0x8a65c9ec, 0x14015c4f, 0x63066cd9,
	    0xfa0f3d63, 0x8d080df5, 0x3b6e20c8, 0x4c69105e, 0xd56041e4, 0xa2677172,
	    0x3c03e4d1, 0x4b04d447, 0xd20d85fd, 0xa50ab56b, 0x35b5a8fa, 0x42b2986c,
	    0xdbbbc9d6, 0xacbcf940, 0x32d86ce3, 0x45df5c75, 0xdcd60dcf, 0xabd13d59,
	    0x26d930ac, 0x51de003a, 0xc8d75180, 0xbfd06116, 0x21b4f4b5, 0x56b3c423,
	    0xcfba9599, 0xb8bda50f, 0x2802b89e, 0x5f058808, 0xc60cd9b2, 0xb10be924,
	    0x2f6f7c87, 0x58684c11, 0xc1611dab, 0xb6662d3d, 0x76dc4190, 0x01db7106,
	    0x98d220bc, 0xefd5102a, 0x71b18589, 0x06b6b51f, 0x9fbfe4a5, 0xe8b8d433,
	    0x7807c9a2, 0x0f00f934, 0x9609a88e, 0xe10e9818, 0x7f6a0dbb, 0x086d3d2d,
	    0x91646c97, 0xe6635c01, 0x6b6b51f4, 0x1c6c6162, 0x856530d8, 0xf262004e,
	    0x6c0695ed, 0x1b01a57b, 0x8208f4c1, 0xf50fc457, 0x65b0d9c6, 0x12b7e950,
	    0x8bbeb8ea, 0xfcb9887c, 0x62dd1ddf, 0x15da2d49, 0x8cd37cf3, 0xfbd44c65,
	    0x4db26158, 0x3ab551ce, 0xa3bc0074, 0xd4bb30e2, 0x4adfa541, 0x3dd895d7,
	    0xa4d1c46d, 0xd3d6f4fb, 0x4369e96a, 0x346ed9fc, 0xad678846, 0xda60b8d0,
	    0x44042d73, 0x33031de5, 0xaa0a4c5f, 0xdd0d7cc9, 0x5005713c, 0x270241aa,
	    0xbe0b1010, 0xc90c2086, 0x5768b525, 0x206f85b3, 0xb966d409, 0xce61e49f,
	    0x5edef90e, 0x29d9c998, 0xb0d09822, 0xc7d7a8b4, 0x59b33d17, 0x2eb40d81,
	    0xb7bd5c3b, 0xc0ba6cad, 0xedb88320, 0x9abfb3b6, 0x03b6e20c, 0x74b1d29a,
	    0xead54739, 0x9dd277af, 0x04db2615, 0x73dc1683, 0xe3630b12, 0x94643b84,
	    0x0d6d6a3e, 0x7a6a5aa8, 0xe40ecf0b, 0x9309ff9d, 0x0a00ae27, 0x7d079eb1,
	    0xf00f9344, 0x8708a3d2, 0x1e01f268, 0x6906c2fe, 0xf762575d, 0x806567cb,
	    0x196c3671, 0x6e6b06e7, 0xfed41b76, 0x89d32be0, 0x10da7a5a, 0x67dd4acc,
	    0xf9b9df6f, 0x8ebeeff9, 0x17b7be43, 0x60b08ed5, 0xd6d6a3e8, 0xa1d1937e,
	    0x38d8c2c4, 0x4fdff252, 0xd1bb67f1, 0xa6bc5767, 0x3fb506dd, 0x48b2364b,
	    0xd80d2bda, 0xaf0a1b4c, 0x36034af6, 0x41047a60, 0xdf60efc3, 0xa867df55,
	    0x316e8eef, 0x4669be79, 0xcb61b38c, 0xbc66831a, 0x256fd2a0, 0x5268e236,
	    0xcc0c7795, 0xbb0b4703, 0x220216b9, 0x5505262f, 0xc5ba3bbe, 0xb2bd0b28,
	    0x2bb45a92, 0x5cb36a04, 0xc2d7ffa7, 0xb5d0cf31, 0x2cd99e8b, 0x5bdeae1d,
	    0x9b64c2b0, 0xec63f226, 0x756aa39c, 0x026d930a, 0x9c0906a9, 0xeb0e363f,
	    0x72076785, 0x05005713, 0x95bf4a82, 0xe2b87a14, 0x7bb12bae, 0x0cb61b38,
	    0x92d28e9b, 0xe5d5be0d, 0x7cdcefb7, 0x0bdbdf21, 0x86d3d2d4, 0xf1d4e242,
	    0x68ddb3f8, 0x1fda836e, 0x81be16cd, 0xf6b9265b, 0x6fb077e1, 0x18b74777,
	    0x88085ae6, 0xff0f6a70, 0x66063bca, 0x11010b5c, 0x8f659eff, 0xf862ae69,
	    0x616bffd3, 0x166ccf45, 0xa00ae278, 0xd70dd2ee, 0x4e048354, 0x3903b3c2,
	    0xa7672661, 0xd06016f7, 0x4969474d, 0x3e6e77db, 0xaed16a4a, 0xd9d65adc,
	    0x40df0b66, 0x37d83bf0, 0xa9bcae53, 0xdebb9ec5, 0x47b2cf7f, 0x30b5ffe9,
	    0xbdbdf21c, 0xcabac28a, 0x53b39330, 0x24b4a3a6, 0xbad03605, 0xcdd70693,
	    0x54de5729, 0x23d967bf, 0xb3667a2e, 0xc4614ab8, 0x5d681b02, 0x2a6f2b94,
	    0xb40bbe37, 0xc30c8ea1, 0x5a05df1b, 0x2d02ef8d
	]);
	var ZipContainer = /** @class */ (function () {
	    function ZipContainer() {
	    }
	    ZipContainer.addFolders = function (paths) {
	        paths.forEach(this.addFolder.bind(this));
	    };
	    ZipContainer.addFolder = function (path) {
	        this.folders.push({
	            path: path,
	            created: new Date(),
	            isBase64: false
	        });
	    };
	    ZipContainer.addFile = function (path, content, isBase64) {
	        if (isBase64 === void 0) { isBase64 = false; }
	        this.files.push({
	            path: path,
	            created: new Date(),
	            content: content,
	            isBase64: isBase64
	        });
	    };
	    ZipContainer.getContent = function (mimeType) {
	        if (mimeType === void 0) { mimeType = 'application/zip'; }
	        var textOutput = this.buildFileStream();
	        var uInt8Output = this.buildUint8Array(textOutput);
	        this.clearStream();
	        return new Blob([uInt8Output], { type: mimeType });
	    };
	    ZipContainer.clearStream = function () {
	        this.folders = [];
	        this.files = [];
	    };
	    ZipContainer.buildFileStream = function (fData) {
	        if (fData === void 0) { fData = ''; }
	        var totalFiles = this.folders.concat(this.files);
	        var len = totalFiles.length;
	        var foData = '';
	        var lL = 0;
	        var cL = 0;
	        for (var _i = 0, totalFiles_1 = totalFiles; _i < totalFiles_1.length; _i++) {
	            var currentFile = totalFiles_1[_i];
	            var _a = this.getHeader(currentFile, lL), fileHeader = _a.fileHeader, folderHeader = _a.folderHeader, content = _a.content;
	            lL += fileHeader.length + content.length;
	            cL += folderHeader.length;
	            fData += fileHeader + content;
	            foData += folderHeader;
	        }
	        var foEnd = this.buildFolderEnd(len, cL, lL);
	        return fData + foData + foEnd;
	    };
	    ZipContainer.getHeader = function (currentFile, offset) {
	        var content = currentFile.content, path = currentFile.path, created = currentFile.created, isBase64 = currentFile.isBase64;
	        var utf8_encode = _.utf8_encode, decToHex = _.decToHex;
	        var utfPath = utf8_encode(path);
	        var isUTF8 = utfPath !== path;
	        var time = this.convertTime(created);
	        var dt = this.convertDate(created);
	        var extraFields = '';
	        if (isUTF8) {
	            var uExtraFieldPath = decToHex(1, 1) + decToHex(this.getFromCrc32Table(utfPath), 4) + utfPath;
	            extraFields = "\x75\x70" + decToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
	        }
	        var _a = !content ? { size: 0, content: '' } : this.getConvertedContent(content, isBase64), size = _a.size, convertedContent = _a.content;
	        var header = '\x0A\x00' +
	            (isUTF8 ? '\x00\x08' : '\x00\x00') +
	            '\x00\x00' +
	            decToHex(time, 2) + // last modified time
	            decToHex(dt, 2) + // last modified date
	            decToHex(size ? this.getFromCrc32Table(convertedContent) : 0, 4) +
	            decToHex(size, 4) + // compressed size
	            decToHex(size, 4) + // uncompressed size
	            decToHex(utfPath.length, 2) + // file name length
	            decToHex(extraFields.length, 2); // extra field length
	        var fileHeader = 'PK\x03\x04' + header + utfPath + extraFields;
	        var folderHeader = 'PK\x01\x02' + // central header
	            '\x14\x00' +
	            header + // file header
	            '\x00\x00' +
	            '\x00\x00' +
	            '\x00\x00' +
	            (content ? '\x00\x00\x00\x00' : '\x10\x00\x00\x00') + // external file attributes
	            decToHex(offset, 4) + // relative offset of local header
	            utfPath + // file name
	            extraFields; // extra field
	        return { fileHeader: fileHeader, folderHeader: folderHeader, content: convertedContent || '' };
	    };
	    ZipContainer.getConvertedContent = function (content, isBase64) {
	        if (isBase64 === void 0) { isBase64 = false; }
	        if (isBase64) {
	            content = content.split(';base64,')[1];
	        }
	        content = isBase64 ? atob(content) : content;
	        return {
	            size: content.length,
	            content: content
	        };
	    };
	    ZipContainer.buildFolderEnd = function (tLen, cLen, lLen) {
	        var decToHex = _.decToHex;
	        return 'PK\x05\x06' + // central folder end
	            '\x00\x00' +
	            '\x00\x00' +
	            decToHex(tLen, 2) + // total number of entries in the central folder
	            decToHex(tLen, 2) + // total number of entries in the central folder
	            decToHex(cLen, 4) + // size of the central folder
	            decToHex(lLen, 4) + // central folder start offset
	            '\x00\x00';
	    };
	    ZipContainer.buildUint8Array = function (content) {
	        var uint8 = new Uint8Array(content.length);
	        for (var i = 0; i < uint8.length; i++) {
	            uint8[i] = content.charCodeAt(i);
	        }
	        return uint8;
	    };
	    ZipContainer.getFromCrc32Table = function (content) {
	        if (!content.length) {
	            return 0;
	        }
	        var size = content.length;
	        var iterable = new Uint8Array(size);
	        for (var i = 0; i < size; i++) {
	            iterable[i] = content.charCodeAt(i);
	        }
	        var crc = 0 ^ (-1);
	        var j = 0;
	        var k = 0;
	        var l = 0;
	        for (var i = 0; i < size; i++) {
	            j = iterable[i];
	            k = (crc ^ j) & 0xFF;
	            l = crcTable[k];
	            crc = (crc >>> 8) ^ l;
	        }
	        return crc ^ (-1);
	    };
	    ZipContainer.convertTime = function (date) {
	        var time = date.getHours();
	        time <<= 6;
	        time = time | date.getMinutes();
	        time <<= 5;
	        time = time | date.getSeconds() / 2;
	        return time;
	    };
	    ZipContainer.convertDate = function (date) {
	        var dt = date.getFullYear() - 1980;
	        dt <<= 4;
	        dt = dt | (date.getMonth() + 1);
	        dt <<= 5;
	        dt = dt | date.getDate();
	        return dt;
	    };
	    ZipContainer.folders = [];
	    ZipContainer.files = [];
	    return ZipContainer;
	}());

	ModuleRegistry.register(ClientSideRowModelModule, false);
	ModuleRegistry.register(InfiniteRowModelModule, false);
	ModuleRegistry.register(CsvExportModule, false);

	exports.AgAbstractField = AgAbstractField;
	exports.AgAngleSelect = AgAngleSelect;
	exports.AgCheckbox = AgCheckbox;
	exports.AgColorPicker = AgColorPicker;
	exports.AgDialog = AgDialog;
	exports.AgGroupComponent = AgGroupComponent;
	exports.AgInputNumberField = AgInputNumberField;
	exports.AgInputRange = AgInputRange;
	exports.AgInputTextArea = AgInputTextArea;
	exports.AgInputTextField = AgInputTextField;
	exports.AgPanel = AgPanel;
	exports.AgPromise = AgPromise;
	exports.AgRadioButton = AgRadioButton;
	exports.AgSelect = AgSelect;
	exports.AgSlider = AgSlider;
	exports.AgToggleButton = AgToggleButton;
	exports.AlignedGridsService = AlignedGridsService;
	exports.AnimateShowChangeCellRenderer = AnimateShowChangeCellRenderer;
	exports.AnimateSlideCellRenderer = AnimateSlideCellRenderer;
	exports.AnimationFrameService = AnimationFrameService;
	exports.AutoWidthCalculator = AutoWidthCalculator;
	exports.Autowired = Autowired;
	exports.BaseComponentWrapper = BaseComponentWrapper;
	exports.BaseCreator = BaseCreator;
	exports.BaseGridSerializingSession = BaseGridSerializingSession;
	exports.Bean = Bean;
	exports.BeanStub = BeanStub;
	exports.BodyDropPivotTarget = BodyDropPivotTarget;
	exports.BodyDropTarget = BodyDropTarget;
	exports.CellComp = CellComp;
	exports.CellNavigationService = CellNavigationService;
	exports.CellPositionUtils = CellPositionUtils;
	exports.ChangedPath = ChangedPath;
	exports.CheckboxSelectionComponent = CheckboxSelectionComponent;
	exports.ColDefUtil = ColDefUtil;
	exports.Color = Color;
	exports.Column = Column;
	exports.ColumnApi = ColumnApi;
	exports.ColumnController = ColumnController;
	exports.ColumnFactory = ColumnFactory;
	exports.ColumnGroup = ColumnGroup;
	exports.ColumnKeyCreator = ColumnKeyCreator;
	exports.ColumnUtils = ColumnUtils;
	exports.Component = Component;
	exports.ComponentUtil = ComponentUtil;
	exports.Constants = Constants;
	exports.Context = Context;
	exports.ControllersService = ControllersService;
	exports.CssClassApplier = CssClassApplier;
	exports.CsvCreator = CsvCreator;
	exports.CsvExportModule = CsvExportModule;
	exports.DateFilter = DateFilter;
	exports.DisplayedGroupCreator = DisplayedGroupCreator;
	exports.Downloader = Downloader;
	exports.DragAndDropService = DragAndDropService;
	exports.DragService = DragService;
	exports.Environment = Environment;
	exports.EventService = EventService;
	exports.Events = Events;
	exports.ExpressionService = ExpressionService;
	exports.FilterManager = FilterManager;
	exports.FloatingFilterMapper = FloatingFilterMapper;
	exports.FloatingFilterWrapper = FloatingFilterWrapper;
	exports.FocusController = FocusController;
	exports.Grid = Grid;
	exports.GridApi = GridApi;
	exports.GridBodyComp = GridBodyComp;
	exports.GridBodyController = GridBodyController;
	exports.GridComp = GridComp;
	exports.GridCompController = GridCompController;
	exports.GridCoreCreator = GridCoreCreator;
	exports.GridListener = GridListener;
	exports.GridOptionsWrapper = GridOptionsWrapper;
	exports.GridSerializer = GridSerializer;
	exports.GroupCellRenderer = GroupCellRenderer;
	exports.GroupInstanceIdCreator = GroupInstanceIdCreator;
	exports.GuiListener = GuiListener;
	exports.HeaderContainer = HeaderContainer;
	exports.HeaderNavigationService = HeaderNavigationService;
	exports.HeaderPositionUtils = HeaderPositionUtils;
	exports.HeaderRootComp = HeaderRootComp;
	exports.HeaderRowComp = HeaderRowComp;
	exports.HeadlessService = HeadlessService;
	exports.HorizontalResizeService = HorizontalResizeService;
	exports.KeyCode = KeyCode;
	exports.KeyName = KeyName;
	exports.LargeTextCellEditor = LargeTextCellEditor;
	exports.Logger = Logger;
	exports.LoggerFactory = LoggerFactory;
	exports.ManagedFocusComponent = ManagedFocusComponent;
	exports.ModuleRegistry = ModuleRegistry;
	exports.MouseEventService = MouseEventService;
	exports.MoveColumnController = MoveColumnController;
	exports.NumberFilter = NumberFilter;
	exports.NumberSequence = NumberSequence;
	exports.Optional = Optional;
	exports.OriginalColumnGroup = OriginalColumnGroup;
	exports.PaginationProxy = PaginationProxy;
	exports.PinnedRowModel = PinnedRowModel;
	exports.PopupComponent = PopupComponent;
	exports.PopupEditorWrapper = PopupEditorWrapper;
	exports.PopupSelectCellEditor = PopupSelectCellEditor;
	exports.PopupService = PopupService;
	exports.PopupTextCellEditor = PopupTextCellEditor;
	exports.PostConstruct = PostConstruct;
	exports.PreConstruct = PreConstruct;
	exports.PreDestroy = PreDestroy;
	exports.PropertyKeys = PropertyKeys;
	exports.ProvidedFilter = ProvidedFilter;
	exports.Qualifier = Qualifier;
	exports.QuerySelector = QuerySelector;
	exports.RefSelector = RefSelector;
	exports.ResizeObserverService = ResizeObserverService;
	exports.RowController = RowController;
	exports.RowNode = RowNode;
	exports.RowNodeBlock = RowNodeBlock;
	exports.RowNodeBlockLoader = RowNodeBlockLoader;
	exports.RowNodeSorter = RowNodeSorter;
	exports.RowPositionUtils = RowPositionUtils;
	exports.RowRenderer = RowRenderer;
	exports.ScalarFilter = ScalarFilter;
	exports.ScrollVisibleService = ScrollVisibleService;
	exports.SelectCellEditor = SelectCellEditor;
	exports.SelectableService = SelectableService;
	exports.SelectionController = SelectionController;
	exports.SetLeftFeature = SetLeftFeature;
	exports.SimpleFilter = SimpleFilter;
	exports.SortController = SortController;
	exports.StandardMenuFactory = StandardMenuFactory;
	exports.StylingService = StylingService;
	exports.TabbedLayout = TabbedLayout;
	exports.TemplateService = TemplateService;
	exports.TestHeadless = TestHeadless;
	exports.TextCellEditor = TextCellEditor;
	exports.TextFilter = TextFilter;
	exports.TextFloatingFilter = TextFloatingFilter;
	exports.Timer = Timer;
	exports.TooltipFeature = TooltipFeature;
	exports.TouchListener = TouchListener;
	exports.UserComponentFactory = UserComponentFactory;
	exports.UserComponentRegistry = UserComponentRegistry;
	exports.ValueCache = ValueCache;
	exports.ValueFormatterService = ValueFormatterService;
	exports.ValueService = ValueService;
	exports.VanillaFrameworkOverrides = VanillaFrameworkOverrides;
	exports.VirtualList = VirtualList;
	exports.XmlFactory = XmlFactory;
	exports.ZipContainer = ZipContainer;
	exports._ = _;
	exports.defaultGroupComparator = defaultGroupComparator;
	exports.initialiseAgGridWithAngular1 = initialiseAgGridWithAngular1;
	exports.initialiseAgGridWithWebComponents = initialiseAgGridWithWebComponents;
	exports.simpleHttpRequest = simpleHttpRequest;
	exports.stringToArray = stringToArray;
	});

	var grid = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
	    factory(exports, agGridCommunity_cjs) ;
	}(commonjsGlobal, (function (exports, agGridCommunity) {
	    function noop$1() { }
	    function run$1(fn) {
	        return fn();
	    }
	    function blank_object$1() {
	        return Object.create(null);
	    }
	    function run_all$1(fns) {
	        fns.forEach(run$1);
	    }
	    function is_function$1(thing) {
	        return typeof thing === 'function';
	    }
	    function safe_not_equal$1(a, b) {
	        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
	    }
	    function is_empty$1(obj) {
	        return Object.keys(obj).length === 0;
	    }
	    function subscribe$1(store, ...callbacks) {
	        if (store == null) {
	            return noop$1;
	        }
	        const unsub = store.subscribe(...callbacks);
	        return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
	    }
	    function component_subscribe$1(component, store, callback) {
	        component.$$.on_destroy.push(subscribe$1(store, callback));
	    }
	    function action_destroyer$1(action_result) {
	        return action_result && is_function$1(action_result.destroy) ? action_result.destroy : noop$1;
	    }

	    function append$1(target, node) {
	        target.appendChild(node);
	    }
	    function insert$1(target, node, anchor) {
	        target.insertBefore(node, anchor || null);
	    }
	    function detach$1(node) {
	        node.parentNode.removeChild(node);
	    }
	    function destroy_each$1(iterations, detaching) {
	        for (let i = 0; i < iterations.length; i += 1) {
	            if (iterations[i])
	                iterations[i].d(detaching);
	        }
	    }
	    function element$1(name) {
	        return document.createElement(name);
	    }
	    function svg_element$1(name) {
	        return document.createElementNS('http://www.w3.org/2000/svg', name);
	    }
	    function text$1(data) {
	        return document.createTextNode(data);
	    }
	    function space$1() {
	        return text$1(' ');
	    }
	    function empty$1() {
	        return text$1('');
	    }
	    function listen$1(node, event, handler, options) {
	        node.addEventListener(event, handler, options);
	        return () => node.removeEventListener(event, handler, options);
	    }
	    function attr$1(node, attribute, value) {
	        if (value == null)
	            node.removeAttribute(attribute);
	        else if (node.getAttribute(attribute) !== value)
	            node.setAttribute(attribute, value);
	    }
	    function children$1(element) {
	        return Array.from(element.childNodes);
	    }
	    function set_data$1(text, data) {
	        data = '' + data;
	        if (text.wholeText !== data)
	            text.data = data;
	    }
	    function set_style(node, key, value, important) {
	        node.style.setProperty(key, value, important ? 'important' : '');
	    }
	    function toggle_class$1(element, name, toggle) {
	        element.classList[toggle ? 'add' : 'remove'](name);
	    }
	    function custom_event$1(type, detail) {
	        const e = document.createEvent('CustomEvent');
	        e.initCustomEvent(type, false, false, detail);
	        return e;
	    }
	    class HtmlTag$1 {
	        constructor(anchor = null) {
	            this.a = anchor;
	            this.e = this.n = null;
	        }
	        m(html, target, anchor = null) {
	            if (!this.e) {
	                this.e = element$1(target.nodeName);
	                this.t = target;
	                this.h(html);
	            }
	            this.i(anchor);
	        }
	        h(html) {
	            this.e.innerHTML = html;
	            this.n = Array.from(this.e.childNodes);
	        }
	        i(anchor) {
	            for (let i = 0; i < this.n.length; i += 1) {
	                insert$1(this.t, this.n[i], anchor);
	            }
	        }
	        p(html) {
	            this.d();
	            this.h(html);
	            this.i(this.a);
	        }
	        d() {
	            this.n.forEach(detach$1);
	        }
	    }

	    let current_component$1;
	    function set_current_component$1(component) {
	        current_component$1 = component;
	    }
	    function get_current_component$1() {
	        if (!current_component$1)
	            throw new Error('Function called outside component initialization');
	        return current_component$1;
	    }
	    function beforeUpdate$1(fn) {
	        get_current_component$1().$$.before_update.push(fn);
	    }
	    function onMount$1(fn) {
	        get_current_component$1().$$.on_mount.push(fn);
	    }
	    function onDestroy$1(fn) {
	        get_current_component$1().$$.on_destroy.push(fn);
	    }
	    function createEventDispatcher$1() {
	        const component = get_current_component$1();
	        return (type, detail) => {
	            const callbacks = component.$$.callbacks[type];
	            if (callbacks) {
	                // TODO are there situations where events could be dispatched
	                // in a server (non-DOM) environment?
	                const event = custom_event$1(type, detail);
	                callbacks.slice().forEach(fn => {
	                    fn.call(component, event);
	                });
	            }
	        };
	    }

	    const dirty_components$1 = [];
	    const binding_callbacks$1 = [];
	    const render_callbacks$1 = [];
	    const flush_callbacks$1 = [];
	    const resolved_promise$1 = Promise.resolve();
	    let update_scheduled$1 = false;
	    function schedule_update$1() {
	        if (!update_scheduled$1) {
	            update_scheduled$1 = true;
	            resolved_promise$1.then(flush$1);
	        }
	    }
	    function add_render_callback$1(fn) {
	        render_callbacks$1.push(fn);
	    }
	    function add_flush_callback$1(fn) {
	        flush_callbacks$1.push(fn);
	    }
	    let flushing$1 = false;
	    const seen_callbacks$1 = new Set();
	    function flush$1() {
	        if (flushing$1)
	            return;
	        flushing$1 = true;
	        do {
	            // first, call beforeUpdate functions
	            // and update components
	            for (let i = 0; i < dirty_components$1.length; i += 1) {
	                const component = dirty_components$1[i];
	                set_current_component$1(component);
	                update$1(component.$$);
	            }
	            set_current_component$1(null);
	            dirty_components$1.length = 0;
	            while (binding_callbacks$1.length)
	                binding_callbacks$1.pop()();
	            // then, once components are updated, call
	            // afterUpdate functions. This may cause
	            // subsequent updates...
	            for (let i = 0; i < render_callbacks$1.length; i += 1) {
	                const callback = render_callbacks$1[i];
	                if (!seen_callbacks$1.has(callback)) {
	                    // ...so guard against infinite loops
	                    seen_callbacks$1.add(callback);
	                    callback();
	                }
	            }
	            render_callbacks$1.length = 0;
	        } while (dirty_components$1.length);
	        while (flush_callbacks$1.length) {
	            flush_callbacks$1.pop()();
	        }
	        update_scheduled$1 = false;
	        flushing$1 = false;
	        seen_callbacks$1.clear();
	    }
	    function update$1($$) {
	        if ($$.fragment !== null) {
	            $$.update();
	            run_all$1($$.before_update);
	            const dirty = $$.dirty;
	            $$.dirty = [-1];
	            $$.fragment && $$.fragment.p($$.ctx, dirty);
	            $$.after_update.forEach(add_render_callback$1);
	        }
	    }
	    const outroing$1 = new Set();
	    let outros$1;
	    function group_outros$1() {
	        outros$1 = {
	            r: 0,
	            c: [],
	            p: outros$1 // parent group
	        };
	    }
	    function check_outros$1() {
	        if (!outros$1.r) {
	            run_all$1(outros$1.c);
	        }
	        outros$1 = outros$1.p;
	    }
	    function transition_in$1(block, local) {
	        if (block && block.i) {
	            outroing$1.delete(block);
	            block.i(local);
	        }
	    }
	    function transition_out$1(block, local, detach, callback) {
	        if (block && block.o) {
	            if (outroing$1.has(block))
	                return;
	            outroing$1.add(block);
	            outros$1.c.push(() => {
	                outroing$1.delete(block);
	                if (callback) {
	                    if (detach)
	                        block.d(1);
	                    callback();
	                }
	            });
	            block.o(local);
	        }
	    }

	    const globals$1 = (typeof window !== 'undefined'
	        ? window
	        : typeof globalThis !== 'undefined'
	            ? globalThis
	            : commonjsGlobal);

	    function bind$1(component, name, callback) {
	        const index = component.$$.props[name];
	        if (index !== undefined) {
	            component.$$.bound[index] = callback;
	            callback(component.$$.ctx[index]);
	        }
	    }
	    function create_component$1(block) {
	        block && block.c();
	    }
	    function mount_component$1(component, target, anchor, customElement) {
	        const { fragment, on_mount, on_destroy, after_update } = component.$$;
	        fragment && fragment.m(target, anchor);
	        if (!customElement) {
	            // onMount happens before the initial afterUpdate
	            add_render_callback$1(() => {
	                const new_on_destroy = on_mount.map(run$1).filter(is_function$1);
	                if (on_destroy) {
	                    on_destroy.push(...new_on_destroy);
	                }
	                else {
	                    // Edge case - component was destroyed immediately,
	                    // most likely as a result of a binding initialising
	                    run_all$1(new_on_destroy);
	                }
	                component.$$.on_mount = [];
	            });
	        }
	        after_update.forEach(add_render_callback$1);
	    }
	    function destroy_component$1(component, detaching) {
	        const $$ = component.$$;
	        if ($$.fragment !== null) {
	            run_all$1($$.on_destroy);
	            $$.fragment && $$.fragment.d(detaching);
	            // TODO null out other refs, including component.$$ (but need to
	            // preserve final state?)
	            $$.on_destroy = $$.fragment = null;
	            $$.ctx = [];
	        }
	    }
	    function make_dirty$1(component, i) {
	        if (component.$$.dirty[0] === -1) {
	            dirty_components$1.push(component);
	            schedule_update$1();
	            component.$$.dirty.fill(0);
	        }
	        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
	    }
	    function init$1(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
	        const parent_component = current_component$1;
	        set_current_component$1(component);
	        const $$ = component.$$ = {
	            fragment: null,
	            ctx: null,
	            // state
	            props,
	            update: noop$1,
	            not_equal,
	            bound: blank_object$1(),
	            // lifecycle
	            on_mount: [],
	            on_destroy: [],
	            on_disconnect: [],
	            before_update: [],
	            after_update: [],
	            context: new Map(parent_component ? parent_component.$$.context : options.context || []),
	            // everything else
	            callbacks: blank_object$1(),
	            dirty,
	            skip_bound: false
	        };
	        let ready = false;
	        $$.ctx = instance
	            ? instance(component, options.props || {}, (i, ret, ...rest) => {
	                const value = rest.length ? rest[0] : ret;
	                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
	                    if (!$$.skip_bound && $$.bound[i])
	                        $$.bound[i](value);
	                    if (ready)
	                        make_dirty$1(component, i);
	                }
	                return ret;
	            })
	            : [];
	        $$.update();
	        ready = true;
	        run_all$1($$.before_update);
	        // `false` as a special case of no DOM component
	        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
	        if (options.target) {
	            if (options.hydrate) {
	                const nodes = children$1(options.target);
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.l(nodes);
	                nodes.forEach(detach$1);
	            }
	            else {
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.c();
	            }
	            if (options.intro)
	                transition_in$1(component.$$.fragment);
	            mount_component$1(component, options.target, options.anchor, options.customElement);
	            flush$1();
	        }
	        set_current_component$1(parent_component);
	    }
	    /**
	     * Base class for Svelte components. Used when dev=false.
	     */
	    class SvelteComponent$1 {
	        $destroy() {
	            destroy_component$1(this, 1);
	            this.$destroy = noop$1;
	        }
	        $on(type, callback) {
	            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
	            callbacks.push(callback);
	            return () => {
	                const index = callbacks.indexOf(callback);
	                if (index !== -1)
	                    callbacks.splice(index, 1);
	            };
	        }
	        $set($$props) {
	            if (this.$$set && !is_empty$1($$props)) {
	                this.$$.skip_bound = true;
	                this.$$set($$props);
	                this.$$.skip_bound = false;
	            }
	        }
	    }

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray$1 = Array.isArray;

	    var isArray$2 = isArray$1;

	    /** Detect free variable `global` from Node.js. */
	    var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	    var freeGlobal$2 = freeGlobal$1;

	    /** Detect free variable `self`. */
	    var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

	    /** Used as a reference to the global object. */
	    var root$1 = freeGlobal$2 || freeSelf$1 || Function('return this')();

	    var root$2 = root$1;

	    /** Built-in value references. */
	    var Symbol$2 = root$2.Symbol;

	    var Symbol$3 = Symbol$2;

	    /** Used for built-in method references. */
	    var objectProto$6 = Object.prototype;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString$1 = objectProto$6.toString;

	    /** Built-in value references. */
	    var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : undefined;

	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty$5.call(value, symToStringTag$1),
	          tag = value[symToStringTag$1];

	      try {
	        value[symToStringTag$1] = undefined;
	        var unmasked = true;
	      } catch (e) {}

	      var result = nativeObjectToString$1.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag$1] = tag;
	        } else {
	          delete value[symToStringTag$1];
	        }
	      }
	      return result;
	    }

	    /** Used for built-in method references. */
	    var objectProto$5 = Object.prototype;

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto$5.toString;

	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString$1(value) {
	      return nativeObjectToString.call(value);
	    }

	    /** `Object#toString` result references. */
	    var nullTag = '[object Null]',
	        undefinedTag = '[object Undefined]';

	    /** Built-in value references. */
	    var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString$1(value);
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike$1(value) {
	      return value != null && typeof value == 'object';
	    }

	    /** `Object#toString` result references. */
	    var symbolTag$1 = '[object Symbol]';

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol$1(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike$1(value) && baseGetTag(value) == symbolTag$1);
	    }

	    /** Used to match property names within property paths. */
	    var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	        reIsPlainProp$1 = /^\w*$/;

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey$1(value, object) {
	      if (isArray$2(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol$1(value)) {
	        return true;
	      }
	      return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject$1(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }

	    /** `Object#toString` result references. */
	    var asyncTag = '[object AsyncFunction]',
	        funcTag$1 = '[object Function]',
	        genTag$1 = '[object GeneratorFunction]',
	        proxyTag = '[object Proxy]';

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction$1(value) {
	      if (!isObject$1(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
	    }

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData$1 = root$2['__core-js_shared__'];

	    var coreJsData$2 = coreJsData$1;

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey$1 = (function() {
	      var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked$1(func) {
	      return !!maskSrcKey$1 && (maskSrcKey$1 in func);
	    }

	    /** Used for built-in method references. */
	    var funcProto$2 = Function.prototype;

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString$2 = funcProto$2.toString;

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource$1(func) {
	      if (func != null) {
	        try {
	          return funcToString$2.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Used to match `RegExp`
	     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	     */
	    var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

	    /** Used to detect host constructors (Safari). */
	    var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

	    /** Used for built-in method references. */
	    var funcProto$1 = Function.prototype,
	        objectProto$4 = Object.prototype;

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString$1 = funcProto$1.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

	    /** Used to detect if a method is native. */
	    var reIsNative$1 = RegExp('^' +
	      funcToString$1.call(hasOwnProperty$4).replace(reRegExpChar$1, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative$1(value) {
	      if (!isObject$1(value) || isMasked$1(value)) {
	        return false;
	      }
	      var pattern = isFunction$1(value) ? reIsNative$1 : reIsHostCtor$1;
	      return pattern.test(toSource$1(value));
	    }

	    /**
	     * Gets the value at `key` of `object`.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function getValue$2(object, key) {
	      return object == null ? undefined : object[key];
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative$1(object, key) {
	      var value = getValue$2(object, key);
	      return baseIsNative$1(value) ? value : undefined;
	    }

	    /* Built-in method references that are verified to be native. */
	    var nativeCreate$1 = getNative$1(Object, 'create');

	    var nativeCreate$2 = nativeCreate$1;

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear$1() {
	      this.__data__ = nativeCreate$2 ? nativeCreate$2(null) : {};
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete$1(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /** Used to stand-in for `undefined` hash values. */
	    var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

	    /** Used for built-in method references. */
	    var objectProto$3 = Object.prototype;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet$1(key) {
	      var data = this.__data__;
	      if (nativeCreate$2) {
	        var result = data[key];
	        return result === HASH_UNDEFINED$2 ? undefined : result;
	      }
	      return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
	    }

	    /** Used for built-in method references. */
	    var objectProto$2 = Object.prototype;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas$1(key) {
	      var data = this.__data__;
	      return nativeCreate$2 ? (data[key] !== undefined) : hasOwnProperty$2.call(data, key);
	    }

	    /** Used to stand-in for `undefined` hash values. */
	    var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet$1(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate$2 && value === undefined) ? HASH_UNDEFINED$1 : value;
	      return this;
	    }

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash$1(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    // Add methods to `Hash`.
	    Hash$1.prototype.clear = hashClear$1;
	    Hash$1.prototype['delete'] = hashDelete$1;
	    Hash$1.prototype.get = hashGet$1;
	    Hash$1.prototype.has = hashHas$1;
	    Hash$1.prototype.set = hashSet$1;

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear$1() {
	      this.__data__ = [];
	      this.size = 0;
	    }

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq$1(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf$1(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq$1(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /** Used for built-in method references. */
	    var arrayProto$1 = Array.prototype;

	    /** Built-in value references. */
	    var splice$1 = arrayProto$1.splice;

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete$1(key) {
	      var data = this.__data__,
	          index = assocIndexOf$1(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice$1.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet$1(key) {
	      var data = this.__data__,
	          index = assocIndexOf$1(data, key);

	      return index < 0 ? undefined : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas$1(key) {
	      return assocIndexOf$1(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet$1(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf$1(data, key);

	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache$1(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    // Add methods to `ListCache`.
	    ListCache$1.prototype.clear = listCacheClear$1;
	    ListCache$1.prototype['delete'] = listCacheDelete$1;
	    ListCache$1.prototype.get = listCacheGet$1;
	    ListCache$1.prototype.has = listCacheHas$1;
	    ListCache$1.prototype.set = listCacheSet$1;

	    /* Built-in method references that are verified to be native. */
	    var Map$2 = getNative$1(root$2, 'Map');

	    var Map$3 = Map$2;

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear$1() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash$1,
	        'map': new (Map$3 || ListCache$1),
	        'string': new Hash$1
	      };
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable$1(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData$1(map, key) {
	      var data = map.__data__;
	      return isKeyable$1(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete$1(key) {
	      var result = getMapData$1(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet$1(key) {
	      return getMapData$1(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas$1(key) {
	      return getMapData$1(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet$1(key, value) {
	      var data = getMapData$1(this, key),
	          size = data.size;

	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache$1(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    // Add methods to `MapCache`.
	    MapCache$1.prototype.clear = mapCacheClear$1;
	    MapCache$1.prototype['delete'] = mapCacheDelete$1;
	    MapCache$1.prototype.get = mapCacheGet$1;
	    MapCache$1.prototype.has = mapCacheHas$1;
	    MapCache$1.prototype.set = mapCacheSet$1;

	    /** Error message constants. */
	    var FUNC_ERROR_TEXT$2 = 'Expected a function';

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize$3(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT$2);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize$3.Cache || MapCache$1);
	      return memoized;
	    }

	    // Expose `MapCache`.
	    memoize$3.Cache = MapCache$1;

	    /** Used as the maximum memoize cache size. */
	    var MAX_MEMOIZE_SIZE = 500;

	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize$3(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });

	      var cache = result.cache;
	      return result;
	    }

	    /** Used to match property names within property paths. */
	    var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	    /** Used to match backslashes in property paths. */
	    var reEscapeChar$1 = /\\(\\)?/g;

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath$1 = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName$1, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
	      });
	      return result;
	    });

	    var stringToPath$2 = stringToPath$1;

	    /**
	     * A specialized version of `_.map` for arrays without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} [array] The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }

	    /** Used as references for various `Number` constants. */
	    var INFINITY$2 = 1 / 0;

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined,
	        symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString$1(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray$2(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString$1) + '';
	      }
	      if (isSymbol$1(value)) {
	        return symbolToString$1 ? symbolToString$1.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString$2(value) {
	      return value == null ? '' : baseToString$1(value);
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath$1(value, object) {
	      if (isArray$2(value)) {
	        return value;
	      }
	      return isKey$1(value, object) ? [value] : stringToPath$2(toString$2(value));
	    }

	    /** Used as references for various `Number` constants. */
	    var INFINITY$1 = 1 / 0;

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey$1(value) {
	      if (typeof value == 'string' || isSymbol$1(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet$1(object, path) {
	      path = castPath$1(path, object);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey$1(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get$1(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet$1(object, path);
	      return result === undefined ? defaultValue : result;
	    }

	    var defineProperty = (function() {
	      try {
	        var func = getNative$1(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());

	    var defineProperty$1 = defineProperty;

	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty$1) {
	        defineProperty$1(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }

	    /** Used for built-in method references. */
	    var objectProto$1 = Object.prototype;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty$1.call(object, key) && eq$1(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /** Used as references for various `Number` constants. */
	    var MAX_SAFE_INTEGER = 9007199254740991;

	    /** Used to detect unsigned integer values. */
	    var reIsUint = /^(?:0|[1-9]\d*)$/;

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;

	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }

	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject$1(object)) {
	        return object;
	      }
	      path = castPath$1(path, object);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = toKey$1(path[index]),
	            newValue = value;

	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }

	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject$1(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }

	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = function() {
	      return root$2.Date.now();
	    };

	    var now$1 = now;

	    /** Used to match a single whitespace character. */
	    var reWhitespace = /\s/;

	    /**
	     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	     * character of `string`.
	     *
	     * @private
	     * @param {string} string The string to inspect.
	     * @returns {number} Returns the index of the last non-whitespace character.
	     */
	    function trimmedEndIndex(string) {
	      var index = string.length;

	      while (index-- && reWhitespace.test(string.charAt(index))) {}
	      return index;
	    }

	    /** Used to match leading whitespace. */
	    var reTrimStart = /^\s+/;

	    /**
	     * The base implementation of `_.trim`.
	     *
	     * @private
	     * @param {string} string The string to trim.
	     * @returns {string} Returns the trimmed string.
	     */
	    function baseTrim(string) {
	      return string
	        ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	        : string;
	    }

	    /** Used as references for various `Number` constants. */
	    var NAN = 0 / 0;

	    /** Used to detect bad signed hexadecimal string values. */
	    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	    /** Used to detect binary string values. */
	    var reIsBinary = /^0b[01]+$/i;

	    /** Used to detect octal string values. */
	    var reIsOctal = /^0o[0-7]+$/i;

	    /** Built-in method references without a dependency on `root`. */
	    var freeParseInt = parseInt;

	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol$1(value)) {
	        return NAN;
	      }
	      if (isObject$1(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject$1(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }

	    /** Error message constants. */
	    var FUNC_ERROR_TEXT$1 = 'Expected a function';

	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeMax = Math.max,
	        nativeMin = Math.min;

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT$1);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject$1(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;

	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }

	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }

	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;

	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }

	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;

	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }

	      function timerExpired() {
	        var time = now$1();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }

	      function trailingEdge(time) {
	        timerId = undefined;

	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }

	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }

	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now$1());
	      }

	      function debounced() {
	        var time = now$1(),
	            isInvoking = shouldInvoke(time);

	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;

	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }

	    var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

	    function getDefaultExportFromCjs (x) {
	    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	    }

	    function createCommonjsModule(fn, basedir, module) {
	    	return module = {
	    		path: basedir,
	    		exports: {},
	    		require: function (path, base) {
	    			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
	    		}
	    	}, fn(module, module.exports), module.exports;
	    }

	    function getAugmentedNamespace(n) {
	    	if (n.__esModule) return n;
	    	var a = Object.defineProperty({}, '__esModule', {value: true});
	    	Object.keys(n).forEach(function (k) {
	    		var d = Object.getOwnPropertyDescriptor(n, k);
	    		Object.defineProperty(a, k, d.get ? d : {
	    			enumerable: true,
	    			get: function () {
	    				return n[k];
	    			}
	    		});
	    	});
	    	return a;
	    }

	    function commonjsRequire () {
	    	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	    }

	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise */

	    var extendStatics$2 = function(d, b) {
	        extendStatics$2 = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics$2(d, b);
	    };

	    function __extends$2(d, b) {
	        extendStatics$2(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }

	    var __assign$4 = function() {
	        __assign$4 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$4.apply(this, arguments);
	    };

	    function __rest(s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    }

	    function __decorate(decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    }

	    function __param(paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    }

	    function __metadata(metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    }

	    function __awaiter(thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    }

	    function __generator(thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    }

	    var __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });

	    function __exportStar(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    }

	    function __values(o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    }

	    function __read(o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    }

	    function __spread() {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    }

	    function __spreadArrays() {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    }
	    function __await(v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    }

	    function __asyncGenerator(thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    }

	    function __asyncDelegator(o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    }

	    function __asyncValues(o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    }

	    function __makeTemplateObject(cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    }
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };

	    function __importStar(mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    }

	    function __importDefault(mod) {
	        return (mod && mod.__esModule) ? mod : { default: mod };
	    }

	    function __classPrivateFieldGet(receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    }

	    function __classPrivateFieldSet(receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    }

	    var tslib_es6 = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        __extends: __extends$2,
	        get __assign () { return __assign$4; },
	        __rest: __rest,
	        __decorate: __decorate,
	        __param: __param,
	        __metadata: __metadata,
	        __awaiter: __awaiter,
	        __generator: __generator,
	        __createBinding: __createBinding,
	        __exportStar: __exportStar,
	        __values: __values,
	        __read: __read,
	        __spread: __spread,
	        __spreadArrays: __spreadArrays,
	        __await: __await,
	        __asyncGenerator: __asyncGenerator,
	        __asyncDelegator: __asyncDelegator,
	        __asyncValues: __asyncValues,
	        __makeTemplateObject: __makeTemplateObject,
	        __importStar: __importStar,
	        __importDefault: __importDefault,
	        __classPrivateFieldGet: __classPrivateFieldGet,
	        __classPrivateFieldSet: __classPrivateFieldSet
	    });

	    var Cache_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    /**
	     * Simple cache implementation
	     */
	    var Cache = /** @class */ (function () {
	        function Cache() {
	            this.data = {};
	            this.pending = {};
	        }
	        Cache.prototype.put = function (key, value) {
	            var previousValue = this.data[key];
	            this.data[key] = value;
	            return previousValue;
	        };
	        Cache.prototype.get = function (key) {
	            return this.data[key];
	        };
	        Cache.prototype.remove = function (key) {
	            var previousValue = this.data[key];
	            delete this.data[key];
	            return previousValue;
	        };
	        Cache.prototype.removeAll = function () {
	            this.data = {};
	        };
	        /**
	         * Gets a value from the cache or invokes the callback to populate the value
	         * with the result of a promise. If invoked multiple times, it will return the promise
	         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	         *
	         * @param key cache key
	         * @param callback returns a Promise to populate the cache with
	         * @returns Promise<*> a promise with the cached value
	         */
	        Cache.prototype.refreshIfAbsent = function (key, callback) {
	            if (this.data.hasOwnProperty(key)) {
	                return Promise.resolve(this.data[key]);
	            }
	            return this.refresh(key, callback);
	        };
	        /**
	         * Invokes the callback to populate the value with the result of a promise.
	         * If invoked multiple times, it will return the promise
	         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	         *
	         * @param key cache key
	         * @param callback returns a Promise to populate the cache with
	         * @returns Promise<*> a promise with the cached value
	         */
	        Cache.prototype.refresh = function (key, callback) {
	            var _this = this;
	            // Check if the callback is already pending for this key
	            var pending = this.pending[key];
	            if (pending) {
	                return pending;
	            }
	            pending = callback();
	            this.pending[key] = pending;
	            return pending.then(function (value) {
	                delete _this.pending[key];
	                _this.put(key, value);
	                return value;
	            }).catch(function (error) {
	                delete _this.pending[key];
	                throw error;
	            });
	        };
	        return Cache;
	    }());
	    exports.default = Cache;

	    });

	    var tslib_1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

	    var Registry_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    exports.SERVICE_REGISTRY_PATH = void 0;

	    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
	    exports.SERVICE_REGISTRY_PATH = '/api/portal/v2/client/config';
	    var PORTAL_SERVICE_NAME = 'portal_service';
	    var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
	    var DEFAULT_CONFIG = {
	        host: '',
	        cache: new Cache_1$1.default(),
	    };
	    var Registry = /** @class */ (function () {
	        function Registry(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	        }
	        // Get the underlying registry cache
	        Registry.prototype.getCache = function () {
	            return this.config.cache;
	        };
	        Registry.prototype.getRegistry = function () {
	            var _this = this;
	            return this.config.cache.refreshIfAbsent('registry', function () {
	                var serviceRegistryUrl = _this.getHost();
	                serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
	                var config = {
	                    method: 'GET',
	                    mode: 'cors',
	                    credentials: 'include',
	                    headers: {
	                        'Content-Type': 'application/json',
	                    },
	                };
	                return fetch(serviceRegistryUrl, config).then(function (resp) {
	                    if (!resp.ok) {
	                        return Promise.reject(resp);
	                    }
	                    return resp.json().then(function (data) {
	                        var dataResponse = tslib_1.__assign({ data: data }, resp);
	                        var registry = data.registry;
	                        // Optimization - also stuff the client config URL into the cache.
	                        // Sometimes, this URL can be different if it's requested from the same domain.
	                        var portalService = registry.services[PORTAL_SERVICE_NAME];
	                        if (portalService) {
	                            var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH, 2);
	                            _this.config.cache.put(clientConfigUrl, dataResponse);
	                        }
	                        return dataResponse;
	                    });
	                });
	            }).then(function (resp) {
	                return resp.data.registry;
	            });
	        };
	        Registry.prototype.getUrl = function (serviceName, path, version) {
	            var _this = this;
	            if (path === void 0) { path = ''; }
	            return this.getRegistry().then(function (data) {
	                var service = data.services[serviceName];
	                if (service === undefined) {
	                    throw new Error("Unable to find service '" + serviceName + "'");
	                }
	                return service;
	            }).then(function (service) {
	                return _this.createServiceUrl(service, path, version);
	            });
	        };
	        Registry.prototype.getServiceBaseUrl = function (service, version) {
	            var baseUrl = service.base_sv_url;
	            if (!baseUrl) {
	                // unversioned service - simply return regular service url
	                return service.sv_url;
	            }
	            if (version === undefined) {
	                // Use configured version if present
	                // if(apiVersions[serviceName]) {
	                //  version = apiVersions[serviceName];
	                // Fallback to version 1 (keeps backwards comparability and generally safe)
	                version = 1;
	            }
	            return this.joinUrlParts(baseUrl, 'v' + version);
	        };
	        Registry.prototype.getServiceHostUrl = function (service) {
	            // Inspired by https://gist.github.com/jlong/2428561
	            var parser = document.createElement('a');
	            parser.href = service.sv_url;
	            return parser.protocol + "//" + parser.host;
	        };
	        Registry.prototype.createServiceUrl = function (service, path, version) {
	            var base;
	            if (path.charAt(0) === '/') {
	                // Host absolute URL
	                base = this.getServiceHostUrl(service);
	            }
	            else {
	                // Service relative URL
	                base = this.getServiceBaseUrl(service, version);
	            }
	            return this.joinUrlParts(base, path);
	        };
	        /**
	         * Determines the registry host in the following order,
	         * 1. Uses the configured host if set
	         * 2. If a PrintOS subdomain is detected as the current hostname,
	         *    the base domain is returned.
	         *    For example, if location.hostname is 'app.www.printos.com',
	         *    then 'www.printos.com' is returned.
	         * 3. Return an empty string otherwise (resulting in a registry call relative
	         *    to the current host).
	         */
	        Registry.prototype.getHost = function () {
	            if (this.config.host) {
	                // Ensure https
	                if (this.config.host.indexOf('https://') !== 0) {
	                    this.config.host = 'https://' + this.config.host;
	                }
	                return this.config.host;
	            }
	            return '';
	        };
	        Registry.prototype.joinUrlParts = function (a, b) {
	            if (!b) {
	                return a;
	            }
	            if (b.charAt(0) === '/') {
	                // Prevent double slashes by ensuring part b doesn't have a slash
	                b = b.substr(1);
	            }
	            if (a.charAt(a.length - 1) === '/') {
	                return a + b;
	            }
	            return a + '/' + b;
	        };
	        return Registry;
	    }());
	    exports.default = Registry;

	    });

	    var Http_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });

	    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
	    var DEFAULT_CONFIG = {
	        registry: new Registry_1$1.default(),
	    };
	    var Http = /** @class */ (function () {
	        function Http(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	            // Use registry cache by default to cache the registry efficiently
	            // Use registry cache by default to cache the registry efficiently
	            this.config.cache = this.config.cache || this.config.registry.getCache();
	        }
	        Http.prototype.getCookie = function (name) {
	            var value = "; " + document.cookie;
	            var parts = value.split("; " + name + "=");
	            if (parts.length == 2) {
	                return decodeURIComponent(parts.pop().split(';').shift());
	            }
	        };
	        Http.prototype.fetchJsonResponse = function (config) {
	            var _this = this;
	            var url = Http.formatUrl(config);
	            var fetchConfig = {
	                method: config.method,
	                mode: config.mode ? config.mode : 'cors',
	                credentials: config.credentials ? config.credentials : 'include',
	                headers: {},
	            };
	            // if (fetchConfig.credentials === 'include') {
	            //   fetchConfig.headers['Access-Control-Allow-Origin'] = '*';
	            //   fetchConfig.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
	            //   fetchConfig.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
	            //   fetchConfig.headers['Access-Control-Allow-Credentials'] = true;
	            // }
	            if (config.data !== undefined && config.data !== null) {
	                if (config.data instanceof FormData) {
	                    fetchConfig.body = config.data;
	                    // fetchConfig.headers['Content-Type'] = undefined;
	                    fetchConfig.headers['Accept'] = '*/*';
	                }
	                else {
	                    fetchConfig.body = config.data instanceof Object ? JSON.stringify(config.data) : config.data;
	                    fetchConfig.headers['Accept'] = 'application/json, text/plain, */*';
	                    fetchConfig.headers['Content-Type'] = 'application/json';
	                    // XSRF-TOKEN handling
	                    var xsrfToken = this.getCookie('XSRF-TOKEN');
	                    if (xsrfToken) {
	                        fetchConfig.headers['X-XSRF-TOKEN'] = xsrfToken;
	                    }
	                }
	            }
	            // Add or overwrite any headers that were passed in
	            fetchConfig.headers = tslib_1.__assign(tslib_1.__assign({}, fetchConfig.headers), (config.headers ? config.headers : {}));
	            // Clean up any undefined or null values from the object if explicitly set
	            for (var _i = 0, _a = Object.entries(fetchConfig.headers); _i < _a.length; _i++) {
	                var _b = _a[_i], key = _b[0], value = _b[1];
	                if (value === undefined || value === null) {
	                    delete fetchConfig.headers[key];
	                }
	            }
	            return fetch(url, fetchConfig).then(function (resp) {
	                if (_this.responseInterceptor) {
	                    return _this.responseInterceptor(resp);
	                }
	                return resp;
	            }).then(function (resp) {
	                var _a, _b;
	                if (!resp.ok) {
	                    if ((_a = resp.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
	                        return resp.json().then(function (data) {
	                            // Extend response to include data
	                            return Promise.reject(Object.assign(resp, { data: data }));
	                        });
	                    }
	                    if ((_b = resp.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.includes('text/plain')) {
	                        return resp.text().then(function (data) {
	                            // Extend response to include data
	                            return Promise.reject(Object.assign(resp, { data: data }));
	                        });
	                    }
	                    return Promise.reject(Object.assign(resp, { data: null }));
	                }
	                if (resp.status === 204) {
	                    return Promise.resolve(Object.assign(resp, { data: null }));
	                }
	                if (fetchConfig.method === 'HEAD') {
	                    return Promise.resolve(Object.assign(resp, { data: null }));
	                }
	                var contentType = resp.headers.get('Content-Type');
	                if (contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')) {
	                    return resp.json().then(function (data) {
	                        // Extend response to include data
	                        return Object.assign(resp, { data: data });
	                    })
	                        .catch(function (e) {
	                        console.warn('HTTP: Failed to parse JSON response', e);
	                        return Object.assign(resp, { data: null });
	                    });
	                }
	                if ((contentType === null || contentType === void 0 ? void 0 : contentType.includes('text/plain')) || config.responseType === 'text') {
	                    return resp.text().then(function (data) {
	                        // Extend response to include data
	                        return Object.assign(resp, { data: data });
	                    });
	                }
	                return Promise.resolve(Object.assign(resp));
	            });
	        };
	        Http.formatUrl = function (config) {
	            var url = config.url;
	            if (config.params) {
	                if (url.includes('?')) {
	                    url += '&';
	                }
	                else {
	                    url += '?';
	                }
	                url += Http.getQueryString(config.params);
	            }
	            return url;
	        };
	        // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
	        Http.getQueryString = function (params) {
	            return Object.keys(params).map(function (k) {
	                var param = params[k];
	                if (Array.isArray(param)) {
	                    return param
	                        .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
	                        .join('&');
	                }
	                return encodeURIComponent(k) + "=" + encodeURIComponent(param);
	            }).join('&');
	        };
	        Http.prototype.request = function (config) {
	            var _this = this;
	            if (config === void 0) { config = {}; }
	            if (config.cache === true) {
	                return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
	                    return _this.fetchJsonResponse(config);
	                });
	            }
	            if (config.cache === 'refresh') {
	                return this.config.cache.refresh(Http.formatUrl(config), function () {
	                    return _this.fetchJsonResponse(config);
	                });
	            }
	            return this.fetchJsonResponse(config);
	        };
	        Http.prototype.serviceRequest = function (serviceName, path, config) {
	            var _this = this;
	            if (config === void 0) { config = {}; }
	            return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
	                config.url = url;
	                return _this.request(config);
	            });
	        };
	        //
	        // Shortcut methods
	        //
	        Http.prototype.get = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'GET';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.post = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'POST';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.put = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'PUT';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.patch = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'PATCH';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.delete = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'DELETE';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.head = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'HEAD';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.fetch = function (url, config) {
	            if (config === void 0) { config = {}; }
	            config.url = url;
	            return this.fetchJsonResponse(config);
	        };
	        return Http;
	    }());
	    exports.default = Http;

	    });

	    var Preferences_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });

	    var Http_1$1 = tslib_1.__importDefault(Http_1);
	    var DEFAULT_CONFIG = {
	        http: new Http_1$1.default(),
	    };
	    var Preferences = /** @class */ (function () {
	        function Preferences(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	        }
	        Preferences.prototype.get = function (path, cache) {
	            if (path === void 0) { path = null; }
	            if (cache === void 0) { cache = true; }
	            var reqPath = 'preferences';
	            if (path) {
	                reqPath += '/' + path;
	            }
	            return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.update = function (prefs) {
	            return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.patch = function (path, prefs) {
	            return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.delete = function (path) {
	            return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.deleteAll = function () {
	            return this.config.http.delete('portal_service', 'preferences', { version: 2 });
	        };
	        return Preferences;
	    }());
	    exports.default = Preferences;

	    });

	    var Locale_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var Locale = /** @class */ (function () {
	        function Locale() {
	            this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
	        }
	        Locale.prototype.getCookieValue = function (cookieName) {
	            var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
	            if (match) {
	                return decodeURIComponent(match[2]);
	            }
	            return null;
	        };
	        Locale.prototype.getBestFit = function () {
	            var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
	            if (cookie && cookie.locale) {
	                return cookie.locale.split('-')[0];
	            }
	            return window.navigator.language.split('-')[0];
	        };
	        return Locale;
	    }());
	    exports.default = Locale;

	    });

	    var dist = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    exports.locale = exports.preferences = exports.http = exports.registry = exports.cache = void 0;

	    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
	    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
	    var Http_1$1 = tslib_1.__importDefault(Http_1);
	    var Preferences_1$1 = tslib_1.__importDefault(Preferences_1);
	    var Locale_1$1 = tslib_1.__importDefault(Locale_1);
	    // TODO: move into Registry and have it listen for blue ready
	    function getRegistryHost() {
	        var host = '';
	        if (window.printos &&
	            window.printos.blue &&
	            window.printos.blue.ui &&
	            window.printos.blue.ui.registry) {
	            host = window.printos.blue.ui.registry.host;
	        }
	        return host;
	    }
	    exports.cache = new Cache_1$1.default();
	    exports.registry = new Registry_1$1.default({
	        cache: exports.cache,
	        host: getRegistryHost(),
	    });
	    exports.http = new Http_1$1.default({
	        cache: exports.cache,
	        registry: exports.registry
	    });
	    exports.preferences = new Preferences_1$1.default({ http: exports.http });
	    exports.locale = new Locale_1$1.default();
	    exports.default = {
	        cache: exports.cache,
	        registry: exports.registry,
	        http: exports.http,
	        preferences: exports.preferences,
	        locale: exports.locale,
	    };

	    });

	    var core = /*@__PURE__*/getDefaultExportFromCjs(dist);

	    /* node_modules/@printos/agnostic-icon/src/Icon.svelte generated by Svelte v3.38.2 */
	    function add_css$l() {
	      var style = element$1("style");
	      style.id = "svelte-1if0avd-style";
	      style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
	      append$1(document.head, style);
	    }

	    // (3:4) {#if _content}
	    function create_if_block$j(ctx) {
	      let html_tag;
	      let html_anchor;
	      return {
	        c() {
	          html_anchor = empty$1();
	          html_tag = new HtmlTag$1(html_anchor);
	        },
	        m(target, anchor) {
	          html_tag.m(/*_content*/ctx[1], target, anchor);
	          insert$1(target, html_anchor, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty & /*_content*/2) html_tag.p(/*_content*/ctx[1]);
	        },
	        d(detaching) {
	          if (detaching) detach$1(html_anchor);
	          if (detaching) html_tag.d();
	        }
	      };
	    }
	    function create_fragment$m(ctx) {
	      let div1;
	      let div0;
	      let div0_pros_tooltip_value;
	      let div1_class_value;
	      let if_block = /*_content*/ctx[1] && create_if_block$j(ctx);
	      return {
	        c() {
	          div1 = element$1("div");
	          div0 = element$1("div");
	          if (if_block) if_block.c();
	          attr$1(div0, "class", "pros-icon-content svelte-1if0avd");
	          attr$1(div0, "style", /*_style*/ctx[4]);
	          attr$1(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ctx[6] || null);
	          attr$1(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ctx[3] + " svelte-1if0avd");
	          attr$1(div1, "style", /*_style*/ctx[4]);
	          attr$1(div1, "pos--theme", /*_theme*/ctx[2]);
	          attr$1(div1, "pos--mode", /*mode*/ctx[0]);
	          toggle_class$1(div1, "disabled", /*disabled*/ctx[7]);
	        },
	        m(target, anchor) {
	          insert$1(target, div1, anchor);
	          append$1(div1, div0);
	          if (if_block) if_block.m(div0, null);
	          /*div1_binding*/
	          ctx[22](div1);
	        },
	        p(ctx, [dirty]) {
	          if (/*_content*/ctx[1]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	            } else {
	              if_block = create_if_block$j(ctx);
	              if_block.c();
	              if_block.m(div0, null);
	            }
	          } else if (if_block) {
	            if_block.d(1);
	            if_block = null;
	          }
	          if (dirty & /*_style*/16) {
	            attr$1(div0, "style", /*_style*/ctx[4]);
	          }
	          if (dirty & /*tooltip*/64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ctx[6] || null)) {
	            attr$1(div0, "pros-tooltip", div0_pros_tooltip_value);
	          }
	          if (dirty & /*_className*/8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ctx[3] + " svelte-1if0avd")) {
	            attr$1(div1, "class", div1_class_value);
	          }
	          if (dirty & /*_style*/16) {
	            attr$1(div1, "style", /*_style*/ctx[4]);
	          }
	          if (dirty & /*_theme*/4) {
	            attr$1(div1, "pos--theme", /*_theme*/ctx[2]);
	          }
	          if (dirty & /*mode*/1) {
	            attr$1(div1, "pos--mode", /*mode*/ctx[0]);
	          }
	          if (dirty & /*_className, disabled*/136) {
	            toggle_class$1(div1, "disabled", /*disabled*/ctx[7]);
	          }
	        },
	        i: noop$1,
	        o: noop$1,
	        d(detaching) {
	          if (detaching) detach$1(div1);
	          if (if_block) if_block.d();
	          /*div1_binding*/
	          ctx[22](null);
	        }
	      };
	    }
	    function hasValue$9(test) {
	      return test !== undefined && test !== null;
	    }
	    function instance$m($$self, $$props, $$invalidate) {
	      createEventDispatcher$1();
	      let {
	        name = null
	      } = $$props; // Name of veneer image (E.G. 'alarm')
	      let {
	        path = null
	      } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	      let {
	        url = null
	      } = $$props; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	      let {
	        theme = "auto"
	      } = $$props; // Color Theme (auto/dark/light)
	      let {
	        mode = "default"
	      } = $$props; // default/form
	      let {
	        className = ""
	      } = $$props; // Class name
	      let {
	        tooltip
	      } = $$props;
	      let {
	        disabled = false
	      } = $$props;
	      let {
	        size = "24px"
	      } = $$props;
	      let {
	        constraint = "h"
	      } = $$props;
	      let {
	        color
	      } = $$props;
	      let {
	        solid = false
	      } = $$props;
	      let {
	        _content = undefined
	      } = $$props;
	      let {
	        _theme
	      } = $$props;
	      let {
	        _lastTheme
	      } = $$props;
	      let {
	        _className
	      } = $$props;
	      let {
	        _style = ""
	      } = $$props;
	      let {
	        _iconElement = undefined
	      } = $$props;
	      let {
	        _lastName = null
	      } = $$props;
	      let {
	        _lastPath = null
	      } = $$props;
	      let {
	        _lastUrl = null
	      } = $$props;
	      onMount$1(() => {
	        $$invalidate(3, _className = hasValue$9(className) ? className : "");
	        updateContent();
	      }); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

	      beforeUpdate$1(() => {
	        $$invalidate(8, theme = hasValue$9(theme) ? theme : "light");
	        $$invalidate(0, mode = hasValue$9(mode) ? mode : "icon");
	        if (theme !== _lastTheme) {
	          $$invalidate(9, _lastTheme = theme);
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
	            window.removeEventListener("posh-theme-changed", handleThemeChanged);
	            window.addEventListener("posh-theme-changed", handleThemeChanged);
	          } else {
	            $$invalidate(2, _theme = theme);
	          }
	        }
	        if (name !== _lastName) {
	          $$invalidate(10, _lastName = name);
	          updateContent();
	        }
	        if (path !== _lastPath) {
	          $$invalidate(11, _lastPath = path);
	          updateContent();
	        }
	        if (url !== _lastUrl) {
	          $$invalidate(12, _lastUrl = url);
	          updateContent();
	        }
	      });
	      onDestroy$1(() => {
	        window.removeEventListener("posh-theme-changed", handleThemeChanged);
	      });
	      function updateContent() {
	        if (name) {
	          let myName = solid ? name : `${name}-o`;
	          loadContent.call(this, `https://cdn.printos.com/images/general/veneer/${myName}.svg`);
	        } else if (path) {
	          let myPath = path.endsWith(".svg") ? path : `${path}.svg`;
	          loadContent.call(this, `https://cdn.printos.com/images/${myPath}`);
	        } else if (url) {
	          loadContent.call(this, url);
	        }
	      }
	      function handleThemeChanged(event) {
	        if (theme === "auto") {
	          $$invalidate(2, _theme = event.detail.theme);
	        }
	      }

	      // Others
	      function loadContent(url) {
	        let config = {
	          url,
	          cache: true,
	          credentials: "omit",
	          responseType: "text"
	        };
	        return dist.http.request(config).then(resp => {
	          $$invalidate(1, _content = resp.data);
	        });
	      }
	      function div1_binding($$value) {
	        binding_callbacks$1[$$value ? "unshift" : "push"](() => {
	          _iconElement = $$value;
	          $$invalidate(5, _iconElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("name" in $$props) $$invalidate(13, name = $$props.name);
	        if ("path" in $$props) $$invalidate(14, path = $$props.path);
	        if ("url" in $$props) $$invalidate(15, url = $$props.url);
	        if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
	        if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
	        if ("className" in $$props) $$invalidate(16, className = $$props.className);
	        if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
	        if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
	        if ("size" in $$props) $$invalidate(17, size = $$props.size);
	        if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
	        if ("color" in $$props) $$invalidate(19, color = $$props.color);
	        if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
	        if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
	        if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	        if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
	        if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
	        if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
	        if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
	        if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
	        if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
	        if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty & /*size, constraint, color, _style*/917520) {
	          // onState
	          {
	            if (size) {
	              let h;
	              let w;
	              switch (constraint) {
	                case "b":
	                  h = isNaN(size) ? size : `${size}px`;
	                  w = isNaN(size) ? size : `${size}px`;
	                  break;
	                case "w":
	                  w = isNaN(size) ? size : `${size}px`;
	                  h = "fit-content";
	                  break;
	                case "h":
	                default:
	                  h = isNaN(size) ? size : `${size}px`;
	                  w = "fit-content";
	                  break;
	              }
	              $$invalidate(4, _style = `height:${h};width:${w};`);
	            }
	            if (color) {
	              if (hasValue$9(color)) {
	                $$invalidate(4, _style += `color:${color};fill:${color}`);
	              }
	            }
	          }
	        }
	      };
	      return [mode, _content, _theme, _className, _style, _iconElement, tooltip, disabled, theme, _lastTheme, _lastName, _lastPath, _lastUrl, name, path, url, className, size, constraint, color, solid, hasValue$9, div1_binding];
	    }
	    class Icon$1 extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-1if0avd-style")) add_css$l();
	        init$1(this, options, instance$m, create_fragment$m, safe_not_equal$1, {
	          name: 13,
	          path: 14,
	          url: 15,
	          theme: 8,
	          mode: 0,
	          className: 16,
	          tooltip: 6,
	          disabled: 7,
	          size: 17,
	          constraint: 18,
	          color: 19,
	          solid: 20,
	          _content: 1,
	          _theme: 2,
	          _lastTheme: 9,
	          _className: 3,
	          _style: 4,
	          _iconElement: 5,
	          _lastName: 10,
	          _lastPath: 11,
	          _lastUrl: 12,
	          hasValue: 21
	        });
	      }
	      get hasValue() {
	        return hasValue$9;
	      }
	    }

	    function styleInject(css, ref) {
	      if ( ref === void 0 ) ref = {};
	      var insertAt = ref.insertAt;

	      if (!css || typeof document === 'undefined') { return; }

	      var head = document.head || document.getElementsByTagName('head')[0];
	      var style = document.createElement('style');
	      style.type = 'text/css';

	      if (insertAt === 'top') {
	        if (head.firstChild) {
	          head.insertBefore(style, head.firstChild);
	        } else {
	          head.appendChild(style);
	        }
	      } else {
	        head.appendChild(style);
	      }

	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(document.createTextNode(css));
	      }
	    }

	    var css_248z = ".pros-dialog-position {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  min-height: 0;\n  flex: 1;\n  box-sizing: border-box;\n}\n.pros-dialog-position .pros-dialog-page {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 16px;\n  border-color: #ffffff;\n  box-shadow: 0 8px 20px rgba(33, 33, 33, 0.2);\n  max-width: 100%;\n  max-height: 90%;\n}\n.pros-dialog-position .pros-dialog-page .pros-dialog-scroll {\n  box-sizing: border-box;\n  width: 100%;\n  overflow: auto;\n  padding: 32px;\n}\n.pros-dialog-position .pros-dialog-page .pros-dialog-footer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  box-sizing: border-box;\n  border-top: 1px solid #F3F3F3;\n  padding: 8px 32px;\n  width: 100%;\n  flex-shrink: 0;\n}\n.pros-dialog-position .pros-dialog-page .pros-dialog-footer else {\n  flex-direction: row;\n}\n\n.pros-dialog-outer {\n  flex: 1;\n  max-height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n.pros-dialog-outer.start {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n.pros-dialog-outer.center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.pros-dialog-outer .pros-dialog-inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 16px;\n  border-color: #ffffff;\n  box-shadow: 0 8px 20px rgba(33, 33, 33, 0.2);\n  box-sizing: border-box;\n  max-width: 100%;\n  max-height: 100%;\n  padding: 32px;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-error-message {\n  width: 100%;\n  background-color: #ff5722;\n  color: #FFFFFF;\n  padding: 8px;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog-header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  flex-shrink: 0;\n  padding-bottom: 20px;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog-header else {\n  flex-direction: row;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog-header .pros-dialog-title {\n  flex: 1;\n  margin: 0;\n  font-size: 32px;\n  line-height: 36px;\n  font-weight: normal;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  box-sizing: border-box;\n  flex: 1;\n  max-width: 100%;\n  min-height: 0;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  flex: 1;\n  overflow: auto;\n  width: 100%;\n  font-size: 16px;\n  line-height: 24px;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog-content .pros-description {\n  font-weight: 400;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  box-sizing: border-box;\n  padding-top: 32px;\n  width: 100%;\n  flex-shrink: 0;\n}\n.pros-dialog-outer .pros-dialog-inner .pros-dialog-footer else {\n  flex-direction: row;\n}\n\n.pros-progress-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  padding: 32px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n}\n.pros-progress-overlay else {\n  flex-direction: row;\n}\n.pros-progress-overlay .progress-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n.pros-progress-overlay .progress-container .title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  padding: 4px;\n  text-align: center;\n}\n.pros-progress-overlay .progress-container .title else {\n  flex-direction: row;\n}\n.pros-progress-overlay .progress-container .details {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px;\n  text-align: center;\n}\n.pros-progress-overlay .progress-container .details else {\n  flex-direction: row;\n}\n.pros-progress-overlay .progress-container .spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px;\n}\n.pros-progress-overlay .progress-container .spinner else {\n  flex-direction: row;\n}\n\nbody[pos--theme=light] .pros-dialog-page, body[pos--theme=light] .pros-dialog-inner {\n  color: #212121;\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n\nbody[pos--theme=dark] .pros-dialog-page, body[pos--theme=dark] .pros-dialog-inner {\n  color: #ffffff;\n  background-color: #2b2b2b;\n  border-color: #2b2b2b;\n}\n\n.pros-dialog-outer[pos--theme=light] .pros-dialog-page, .pros-dialog-outer[pos--theme=light] .pros-dialog-inner {\n  color: #212121;\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n\n.pros-dialog-outer[pos--theme=dark] .pros-dialog-page, .pros-dialog-outer[pos--theme=dark] .pros-dialog-inner {\n  color: #ffffff;\n  background-color: #2b2b2b;\n  border-color: #2b2b2b;\n}\n\nprintos-backdrop {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  opacity: 0.48;\n  background-color: rgb(33, 33, 33);\n}\n\nprintos-dialog {\n  box-sizing: border-box;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1001;\n}";
	    styleInject(css_248z);

	    // Deferred helper
	    // From https://developer.mozilla.org/en-US/docs/Mozilla/JavaScript_code_modules/Promise.jsm/Deferred#backwards_forwards_compatible
	    function Deferred() {
	      // update 062115 for typeof
	      if (typeof(Promise) !== 'undefined' && Promise.defer) {
	        //need import of Promise.jsm for example: Cu.import('resource:/gree/modules/Promise.jsm');
	        return Promise.defer();
	      } else if (typeof(PromiseUtils) !== 'undefined'  && PromiseUtils.defer) {
	        //need import of PromiseUtils.jsm for example: Cu.import('resource:/gree/modules/PromiseUtils.jsm');
	        return PromiseUtils.defer();
	      } else {
	        /* A method to resolve the associated Promise with the value passed.
	         * If the promise is already settled it does nothing.
	         *
	         * @param {anything} value : This value is used to resolve the promise
	         * If the value is a Promise then the associated promise assumes the state
	         * of Promise passed as value.
	         */
	        this.resolve = null;

	        /* A method to reject the assocaited Promise with the value passed.
	         * If the promise is already settled it does nothing.
	         *
	         * @param {anything} reason: The reason for the rejection of the Promise.
	         * Generally its an Error object. If however a Promise is passed, then the Promise
	         * itself will be the reason for rejection no matter the state of the Promise.
	         */
	        this.reject = null;

	        /* A newly created Promise object.
	         * Initially in pending state.
	         */
	        this.promise = new Promise(function(resolve, reject) {
	          this.resolve = resolve;
	          this.reject = reject;
	        }.bind(this));
	        Object.freeze(this);
	      }
	    }

	    function noop() { }
	    function run(fn) {
	        return fn();
	    }
	    function blank_object() {
	        return Object.create(null);
	    }
	    function run_all(fns) {
	        fns.forEach(run);
	    }
	    function is_function(thing) {
	        return typeof thing === 'function';
	    }
	    function safe_not_equal(a, b) {
	        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
	    }
	    function is_empty(obj) {
	        return Object.keys(obj).length === 0;
	    }
	    function subscribe(store, ...callbacks) {
	        if (store == null) {
	            return noop;
	        }
	        const unsub = store.subscribe(...callbacks);
	        return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
	    }
	    function component_subscribe(component, store, callback) {
	        component.$$.on_destroy.push(subscribe(store, callback));
	    }
	    function action_destroyer(action_result) {
	        return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
	    }

	    function append(target, node) {
	        target.appendChild(node);
	    }
	    function insert(target, node, anchor) {
	        target.insertBefore(node, anchor || null);
	    }
	    function detach(node) {
	        node.parentNode.removeChild(node);
	    }
	    function destroy_each(iterations, detaching) {
	        for (let i = 0; i < iterations.length; i += 1) {
	            if (iterations[i])
	                iterations[i].d(detaching);
	        }
	    }
	    function element(name) {
	        return document.createElement(name);
	    }
	    function svg_element(name) {
	        return document.createElementNS('http://www.w3.org/2000/svg', name);
	    }
	    function text(data) {
	        return document.createTextNode(data);
	    }
	    function space() {
	        return text(' ');
	    }
	    function empty() {
	        return text('');
	    }
	    function listen(node, event, handler, options) {
	        node.addEventListener(event, handler, options);
	        return () => node.removeEventListener(event, handler, options);
	    }
	    function attr(node, attribute, value) {
	        if (value == null)
	            node.removeAttribute(attribute);
	        else if (node.getAttribute(attribute) !== value)
	            node.setAttribute(attribute, value);
	    }
	    function children(element) {
	        return Array.from(element.childNodes);
	    }
	    function set_data(text, data) {
	        data = '' + data;
	        if (text.wholeText !== data)
	            text.data = data;
	    }
	    function set_input_value(input, value) {
	        input.value = value == null ? '' : value;
	    }
	    function toggle_class(element, name, toggle) {
	        element.classList[toggle ? 'add' : 'remove'](name);
	    }
	    function custom_event(type, detail) {
	        const e = document.createEvent('CustomEvent');
	        e.initCustomEvent(type, false, false, detail);
	        return e;
	    }
	    class HtmlTag {
	        constructor(anchor = null) {
	            this.a = anchor;
	            this.e = this.n = null;
	        }
	        m(html, target, anchor = null) {
	            if (!this.e) {
	                this.e = element(target.nodeName);
	                this.t = target;
	                this.h(html);
	            }
	            this.i(anchor);
	        }
	        h(html) {
	            this.e.innerHTML = html;
	            this.n = Array.from(this.e.childNodes);
	        }
	        i(anchor) {
	            for (let i = 0; i < this.n.length; i += 1) {
	                insert(this.t, this.n[i], anchor);
	            }
	        }
	        p(html) {
	            this.d();
	            this.h(html);
	            this.i(this.a);
	        }
	        d() {
	            this.n.forEach(detach);
	        }
	    }

	    let current_component;
	    function set_current_component(component) {
	        current_component = component;
	    }
	    function get_current_component() {
	        if (!current_component)
	            throw new Error('Function called outside component initialization');
	        return current_component;
	    }
	    function beforeUpdate(fn) {
	        get_current_component().$$.before_update.push(fn);
	    }
	    function onMount(fn) {
	        get_current_component().$$.on_mount.push(fn);
	    }
	    function onDestroy(fn) {
	        get_current_component().$$.on_destroy.push(fn);
	    }
	    function createEventDispatcher() {
	        const component = get_current_component();
	        return (type, detail) => {
	            const callbacks = component.$$.callbacks[type];
	            if (callbacks) {
	                // TODO are there situations where events could be dispatched
	                // in a server (non-DOM) environment?
	                const event = custom_event(type, detail);
	                callbacks.slice().forEach(fn => {
	                    fn.call(component, event);
	                });
	            }
	        };
	    }

	    const dirty_components = [];
	    const binding_callbacks = [];
	    const render_callbacks = [];
	    const flush_callbacks = [];
	    const resolved_promise = Promise.resolve();
	    let update_scheduled = false;
	    function schedule_update() {
	        if (!update_scheduled) {
	            update_scheduled = true;
	            resolved_promise.then(flush);
	        }
	    }
	    function add_render_callback(fn) {
	        render_callbacks.push(fn);
	    }
	    function add_flush_callback(fn) {
	        flush_callbacks.push(fn);
	    }
	    let flushing = false;
	    const seen_callbacks = new Set();
	    function flush() {
	        if (flushing)
	            return;
	        flushing = true;
	        do {
	            // first, call beforeUpdate functions
	            // and update components
	            for (let i = 0; i < dirty_components.length; i += 1) {
	                const component = dirty_components[i];
	                set_current_component(component);
	                update(component.$$);
	            }
	            set_current_component(null);
	            dirty_components.length = 0;
	            while (binding_callbacks.length)
	                binding_callbacks.pop()();
	            // then, once components are updated, call
	            // afterUpdate functions. This may cause
	            // subsequent updates...
	            for (let i = 0; i < render_callbacks.length; i += 1) {
	                const callback = render_callbacks[i];
	                if (!seen_callbacks.has(callback)) {
	                    // ...so guard against infinite loops
	                    seen_callbacks.add(callback);
	                    callback();
	                }
	            }
	            render_callbacks.length = 0;
	        } while (dirty_components.length);
	        while (flush_callbacks.length) {
	            flush_callbacks.pop()();
	        }
	        update_scheduled = false;
	        flushing = false;
	        seen_callbacks.clear();
	    }
	    function update($$) {
	        if ($$.fragment !== null) {
	            $$.update();
	            run_all($$.before_update);
	            const dirty = $$.dirty;
	            $$.dirty = [-1];
	            $$.fragment && $$.fragment.p($$.ctx, dirty);
	            $$.after_update.forEach(add_render_callback);
	        }
	    }
	    const outroing = new Set();
	    let outros;
	    function group_outros() {
	        outros = {
	            r: 0,
	            c: [],
	            p: outros // parent group
	        };
	    }
	    function check_outros() {
	        if (!outros.r) {
	            run_all(outros.c);
	        }
	        outros = outros.p;
	    }
	    function transition_in(block, local) {
	        if (block && block.i) {
	            outroing.delete(block);
	            block.i(local);
	        }
	    }
	    function transition_out(block, local, detach, callback) {
	        if (block && block.o) {
	            if (outroing.has(block))
	                return;
	            outroing.add(block);
	            outros.c.push(() => {
	                outroing.delete(block);
	                if (callback) {
	                    if (detach)
	                        block.d(1);
	                    callback();
	                }
	            });
	            block.o(local);
	        }
	    }

	    const globals = (typeof window !== 'undefined'
	        ? window
	        : typeof globalThis !== 'undefined'
	            ? globalThis
	            : commonjsGlobal);

	    function bind(component, name, callback) {
	        const index = component.$$.props[name];
	        if (index !== undefined) {
	            component.$$.bound[index] = callback;
	            callback(component.$$.ctx[index]);
	        }
	    }
	    function create_component(block) {
	        block && block.c();
	    }
	    function mount_component(component, target, anchor, customElement) {
	        const { fragment, on_mount, on_destroy, after_update } = component.$$;
	        fragment && fragment.m(target, anchor);
	        if (!customElement) {
	            // onMount happens before the initial afterUpdate
	            add_render_callback(() => {
	                const new_on_destroy = on_mount.map(run).filter(is_function);
	                if (on_destroy) {
	                    on_destroy.push(...new_on_destroy);
	                }
	                else {
	                    // Edge case - component was destroyed immediately,
	                    // most likely as a result of a binding initialising
	                    run_all(new_on_destroy);
	                }
	                component.$$.on_mount = [];
	            });
	        }
	        after_update.forEach(add_render_callback);
	    }
	    function destroy_component(component, detaching) {
	        const $$ = component.$$;
	        if ($$.fragment !== null) {
	            run_all($$.on_destroy);
	            $$.fragment && $$.fragment.d(detaching);
	            // TODO null out other refs, including component.$$ (but need to
	            // preserve final state?)
	            $$.on_destroy = $$.fragment = null;
	            $$.ctx = [];
	        }
	    }
	    function make_dirty(component, i) {
	        if (component.$$.dirty[0] === -1) {
	            dirty_components.push(component);
	            schedule_update();
	            component.$$.dirty.fill(0);
	        }
	        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
	    }
	    function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
	        const parent_component = current_component;
	        set_current_component(component);
	        const $$ = component.$$ = {
	            fragment: null,
	            ctx: null,
	            // state
	            props,
	            update: noop,
	            not_equal,
	            bound: blank_object(),
	            // lifecycle
	            on_mount: [],
	            on_destroy: [],
	            on_disconnect: [],
	            before_update: [],
	            after_update: [],
	            context: new Map(parent_component ? parent_component.$$.context : options.context || []),
	            // everything else
	            callbacks: blank_object(),
	            dirty,
	            skip_bound: false
	        };
	        let ready = false;
	        $$.ctx = instance
	            ? instance(component, options.props || {}, (i, ret, ...rest) => {
	                const value = rest.length ? rest[0] : ret;
	                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
	                    if (!$$.skip_bound && $$.bound[i])
	                        $$.bound[i](value);
	                    if (ready)
	                        make_dirty(component, i);
	                }
	                return ret;
	            })
	            : [];
	        $$.update();
	        ready = true;
	        run_all($$.before_update);
	        // `false` as a special case of no DOM component
	        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
	        if (options.target) {
	            if (options.hydrate) {
	                const nodes = children(options.target);
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.l(nodes);
	                nodes.forEach(detach);
	            }
	            else {
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.c();
	            }
	            if (options.intro)
	                transition_in(component.$$.fragment);
	            mount_component(component, options.target, options.anchor, options.customElement);
	            flush();
	        }
	        set_current_component(parent_component);
	    }
	    /**
	     * Base class for Svelte components. Used when dev=false.
	     */
	    class SvelteComponent {
	        $destroy() {
	            destroy_component(this, 1);
	            this.$destroy = noop;
	        }
	        $on(type, callback) {
	            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
	            callbacks.push(callback);
	            return () => {
	                const index = callbacks.indexOf(callback);
	                if (index !== -1)
	                    callbacks.splice(index, 1);
	            };
	        }
	        $set($$props) {
	            if (this.$$set && !is_empty($$props)) {
	                this.$$.skip_bound = true;
	                this.$$set($$props);
	                this.$$.skip_bound = false;
	            }
	        }
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/icon/src/Icon.svelte generated by Svelte v3.38.2 */

	    function add_css$k() {
	    	var style = element("style");
	    	style.id = "svelte-1if0avd-style";
	    	style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
	    	append(document.head, style);
	    }

	    // (3:4) {#if _content}
	    function create_if_block$i(ctx) {
	    	let html_tag;
	    	let html_anchor;

	    	return {
	    		c() {
	    			html_anchor = empty();
	    			html_tag = new HtmlTag(html_anchor);
	    		},
	    		m(target, anchor) {
	    			html_tag.m(/*_content*/ ctx[1], target, anchor);
	    			insert(target, html_anchor, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_content*/ 2) html_tag.p(/*_content*/ ctx[1]);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(html_anchor);
	    			if (detaching) html_tag.d();
	    		}
	    	};
	    }

	    function create_fragment$l(ctx) {
	    	let div1;
	    	let div0;
	    	let div0_pros_tooltip_value;
	    	let div1_class_value;
	    	let if_block = /*_content*/ ctx[1] && create_if_block$i(ctx);

	    	return {
	    		c() {
	    			div1 = element("div");
	    			div0 = element("div");
	    			if (if_block) if_block.c();
	    			attr(div0, "class", "pros-icon-content svelte-1if0avd");
	    			attr(div0, "style", /*_style*/ ctx[4]);
	    			attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null);
	    			attr(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd");
	    			attr(div1, "style", /*_style*/ ctx[4]);
	    			attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div1, anchor);
	    			append(div1, div0);
	    			if (if_block) if_block.m(div0, null);
	    			/*div1_binding*/ ctx[22](div1);
	    		},
	    		p(ctx, [dirty]) {
	    			if (/*_content*/ ctx[1]) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);
	    				} else {
	    					if_block = create_if_block$i(ctx);
	    					if_block.c();
	    					if_block.m(div0, null);
	    				}
	    			} else if (if_block) {
	    				if_block.d(1);
	    				if_block = null;
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div0, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*tooltip*/ 64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null)) {
	    				attr(div0, "pros-tooltip", div0_pros_tooltip_value);
	    			}

	    			if (dirty & /*_className*/ 8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd")) {
	    				attr(div1, "class", div1_class_value);
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div1, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*_theme*/ 4) {
	    				attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			}

	    			if (dirty & /*mode*/ 1) {
	    				attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			}

	    			if (dirty & /*_className, disabled*/ 136) {
	    				toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div1);
	    			if (if_block) if_block.d();
	    			/*div1_binding*/ ctx[22](null);
	    		}
	    	};
	    }

	    function hasValue$8(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$l($$self, $$props, $$invalidate) {
	    	createEventDispatcher();
	    	let { name = null } = $$props; // Name of veneer image (E.G. 'alarm')
	    	let { path = null } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	    	let { url = null } = $$props; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
	    	let { mode = "default" } = $$props; // default/form
	    	let { className = "" } = $$props; // Class name
	    	let { tooltip } = $$props;
	    	let { disabled = false } = $$props;
	    	let { size = "24px" } = $$props;
	    	let { constraint = "h" } = $$props;
	    	let { color } = $$props;
	    	let { solid = false } = $$props;
	    	let { _content = undefined } = $$props;
	    	let { _theme } = $$props;
	    	let { _lastTheme } = $$props;
	    	let { _className } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _iconElement = undefined } = $$props;
	    	let { _lastName = null } = $$props;
	    	let { _lastPath = null } = $$props;
	    	let { _lastUrl = null } = $$props;

	    	onMount(() => {
	    		$$invalidate(3, _className = hasValue$8(className) ? className : "");
	    		updateContent();
	    	}); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

	    	beforeUpdate(() => {
	    		$$invalidate(8, theme = hasValue$8(theme) ? theme : "light");
	    		$$invalidate(0, mode = hasValue$8(mode) ? mode : "icon");

	    		if (theme !== _lastTheme) {
	    			$$invalidate(9, _lastTheme = theme);

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
	    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    				window.addEventListener("posh-theme-changed", handleThemeChanged);
	    			} else {
	    				$$invalidate(2, _theme = theme);
	    			}
	    		}

	    		if (name !== _lastName) {
	    			$$invalidate(10, _lastName = name);
	    			updateContent();
	    		}

	    		if (path !== _lastPath) {
	    			$$invalidate(11, _lastPath = path);
	    			updateContent();
	    		}

	    		if (url !== _lastUrl) {
	    			$$invalidate(12, _lastUrl = url);
	    			updateContent();
	    		}
	    	});

	    	onDestroy(() => {
	    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    	});

	    	function updateContent() {
	    		if (name) {
	    			let myName = solid ? name : `${name}-o`;
	    			loadContent.call(this, `https://cdn.printos.com/images/general/veneer/${myName}.svg`);
	    		} else if (path) {
	    			let myPath = path.endsWith(".svg") ? path : `${path}.svg`;
	    			loadContent.call(this, `https://cdn.printos.com/images/${myPath}`);
	    		} else if (url) {
	    			loadContent.call(this, url);
	    		}
	    	}

	    	function handleThemeChanged(event) {
	    		if (theme === "auto") {
	    			$$invalidate(2, _theme = event.detail.theme);
	    		}
	    	}

	    	// Others
	    	function loadContent(url) {
	    		let config = {
	    			url,
	    			cache: true,
	    			credentials: "omit",
	    			responseType: "text"
	    		};

	    		return dist.http.request(config).then(resp => {
	    			$$invalidate(1, _content = resp.data);
	    		});
	    	}

	    	function div1_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_iconElement = $$value;
	    			$$invalidate(5, _iconElement);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("name" in $$props) $$invalidate(13, name = $$props.name);
	    		if ("path" in $$props) $$invalidate(14, path = $$props.path);
	    		if ("url" in $$props) $$invalidate(15, url = $$props.url);
	    		if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
	    		if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
	    		if ("className" in $$props) $$invalidate(16, className = $$props.className);
	    		if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
	    		if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
	    		if ("size" in $$props) $$invalidate(17, size = $$props.size);
	    		if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
	    		if ("color" in $$props) $$invalidate(19, color = $$props.color);
	    		if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
	    		if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
	    		if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	    		if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
	    		if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
	    		if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
	    		if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
	    		if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
	    		if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
	    		if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*size, constraint, color, _style*/ 917520) {
	    			// onState
	    			{
	    				if (size) {
	    					let h;
	    					let w;

	    					switch (constraint) {
	    						case "b":
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = isNaN(size) ? size : `${size}px`;
	    							break;
	    						case "w":
	    							w = isNaN(size) ? size : `${size}px`;
	    							h = "fit-content";
	    							break;
	    						case "h":
	    						default:
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = "fit-content";
	    							break;
	    					}

	    					$$invalidate(4, _style = `height:${h};width:${w};`);
	    				}

	    				if (color) {
	    					if (hasValue$8(color)) {
	    						$$invalidate(4, _style += `color:${color};fill:${color}`);
	    					}
	    				}
	    			}
	    		}
	    	};

	    	return [
	    		mode,
	    		_content,
	    		_theme,
	    		_className,
	    		_style,
	    		_iconElement,
	    		tooltip,
	    		disabled,
	    		theme,
	    		_lastTheme,
	    		_lastName,
	    		_lastPath,
	    		_lastUrl,
	    		name,
	    		path,
	    		url,
	    		className,
	    		size,
	    		constraint,
	    		color,
	    		solid,
	    		hasValue$8,
	    		div1_binding
	    	];
	    }

	    class Icon extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-1if0avd-style")) add_css$k();

	    		init(this, options, instance$l, create_fragment$l, safe_not_equal, {
	    			name: 13,
	    			path: 14,
	    			url: 15,
	    			theme: 8,
	    			mode: 0,
	    			className: 16,
	    			tooltip: 6,
	    			disabled: 7,
	    			size: 17,
	    			constraint: 18,
	    			color: 19,
	    			solid: 20,
	    			_content: 1,
	    			_theme: 2,
	    			_lastTheme: 9,
	    			_className: 3,
	    			_style: 4,
	    			_iconElement: 5,
	    			_lastName: 10,
	    			_lastPath: 11,
	    			_lastUrl: 12,
	    			hasValue: 21
	    		});
	    	}

	    	get hasValue() {
	    		return hasValue$8;
	    	}
	    }

	    const DEFAULT_OPTIONS = {
	      clickOutsideToClose: false,
	      escapeToClose: true,
	    };

	    class Dialog {
	      show(options) {
	        let opts = {...DEFAULT_OPTIONS, ...options};

	        this._prependBackdropToBody();
	        this._appendDialogToBody(opts);

	        // TODO: disallow showing multiple dialogs
	        // Instead of using static data, consider adding a namespaced global variable.
	        Dialog._showing = new Deferred();
	        return Dialog._showing.promise;
	      }

	      hide(response) {
	        Dialog._showing.resolve(response);
	        Dialog._close();
	        return Promise.resolve();
	      }

	      cancel(response) {
	        Dialog._showing.reject(response);
	        Dialog._close();
	        return Promise.resolve();
	      }

	      static _close() {
	        let backdrop = document.getElementById('printos-backdrop');
	        if (backdrop) {
	          backdrop.remove();
	        }

	        let dialog = document.getElementById('printos-dialog');
	        if (dialog) {
	          dialog.remove();
	        }
	      }


	      _prependBackdropToBody() {
	        let backdrop = document.createElement('printos-backdrop');
	        backdrop.id = 'printos-backdrop';
	        document.body.prepend(backdrop);
	      }

	      _appendDialogToBody(opts) {
	        let _theme = opts.options && opts.options.theme ? opts.options.theme : 'auto';
	        let dialogContent = document.createElement('div');
	        dialogContent.classList.add('pros-dialog-inner');

	        let dialogContainer = document.createElement('div');
	        dialogContainer.classList.add('pros-dialog-outer');
	        dialogContainer.classList.add('center');
	        dialogContainer.setAttribute('pos--theme', _theme);
	        dialogContainer.append(dialogContent);

	        if (opts.title) {
	          let titleBar = this._createTitleBar(opts);
	          dialogContent.append(titleBar);
	        }

	        dialogContent.append(opts.content);

	        let dialog = document.createElement('printos-dialog');
	        dialog.id = 'printos-dialog';
	        dialog.append(dialogContainer);

	        if (opts.clickOutsideToClose) {
	          dialog.addEventListener('click', event => {
	            this.cancel(event);
	          });
	        }

	        if (opts.escapeToClose) {
	          dialog.setAttribute('tabIndex', '-1');

	          dialog.addEventListener('keydown', event => {
	            if (event.key === 'Escape') {
	              event.stopPropagation();
	              event.preventDefault();
	            }
	          });

	          dialog.addEventListener('keyup', event => {
	            if (event.key === 'Escape') {
	              event.stopPropagation();
	              event.preventDefault();

	              this.cancel(event);
	            }
	          });
	        }

	        document.body.append(dialog);
	        dialog.focus();
	      }

	      _createTitleBar(opts) {
	        let titleBar = document.createElement('div');
	        titleBar.classList.add('pros-dialog-header');

	        let title = document.createElement('h2');
	        title.classList.add('pros-dialog-title');
	        title.textContent = opts.title;

	        let closeBtn = document.createElement('div');
	        closeBtn.classList.add('pros-btn-close');
	        closeBtn.addEventListener('click', event => {
	          this.cancel(event);
	        });

	        new Icon({
	          target: closeBtn,
	          props: {
	            path: 'general/veneer/x-o',
	            theme: opts.options && opts.options.theme ? opts.options.theme : 'auto',
	            mode: 'clickable',
	          }
	        });

	        titleBar.append(title, closeBtn);

	        return titleBar;
	      }
	    }

	    const dialog = new Dialog();

	    const subscriber_queue$1 = [];
	    /**
	     * Creates a `Readable` store that allows reading by subscription.
	     * @param value initial value
	     * @param {StartStopNotifier}start start and stop notifications for subscriptions
	     */
	    function readable$1(value, start) {
	        return {
	            subscribe: writable$1(value, start).subscribe
	        };
	    }
	    /**
	     * Create a `Writable` store that allows both updating and reading by subscription.
	     * @param {*=}value initial value
	     * @param {StartStopNotifier=}start start and stop notifications for subscriptions
	     */
	    function writable$1(value, start = noop$1) {
	        let stop;
	        const subscribers = [];
	        function set(new_value) {
	            if (safe_not_equal$1(value, new_value)) {
	                value = new_value;
	                if (stop) { // store is ready
	                    const run_queue = !subscriber_queue$1.length;
	                    for (let i = 0; i < subscribers.length; i += 1) {
	                        const s = subscribers[i];
	                        s[1]();
	                        subscriber_queue$1.push(s, value);
	                    }
	                    if (run_queue) {
	                        for (let i = 0; i < subscriber_queue$1.length; i += 2) {
	                            subscriber_queue$1[i][0](subscriber_queue$1[i + 1]);
	                        }
	                        subscriber_queue$1.length = 0;
	                    }
	                }
	            }
	        }
	        function update(fn) {
	            set(fn(value));
	        }
	        function subscribe(run, invalidate = noop$1) {
	            const subscriber = [run, invalidate];
	            subscribers.push(subscriber);
	            if (subscribers.length === 1) {
	                stop = start(set) || noop$1;
	            }
	            run(value);
	            return () => {
	                const index = subscribers.indexOf(subscriber);
	                if (index !== -1) {
	                    subscribers.splice(index, 1);
	                }
	                if (subscribers.length === 0) {
	                    stop();
	                    stop = null;
	                }
	            };
	        }
	        return { set, update, subscribe };
	    }
	    function derived$1(stores, fn, initial_value) {
	        const single = !Array.isArray(stores);
	        const stores_array = single
	            ? [stores]
	            : stores;
	        const auto = fn.length < 2;
	        return readable$1(initial_value, (set) => {
	            let inited = false;
	            const values = [];
	            let pending = 0;
	            let cleanup = noop$1;
	            const sync = () => {
	                if (pending) {
	                    return;
	                }
	                cleanup();
	                const result = fn(single ? values[0] : values, set);
	                if (auto) {
	                    set(result);
	                }
	                else {
	                    cleanup = is_function$1(result) ? result : noop$1;
	                }
	            };
	            const unsubscribers = stores_array.map((store, i) => subscribe$1(store, (value) => {
	                values[i] = value;
	                pending &= ~(1 << i);
	                if (inited) {
	                    sync();
	                }
	            }, () => {
	                pending |= (1 << i);
	            }));
	            inited = true;
	            sync();
	            return function stop() {
	                run_all$1(unsubscribers);
	                cleanup();
	            };
	        });
	    }

	    var isMergeableObject$1 = function isMergeableObject(value) {
	    	return isNonNullObject$1(value)
	    		&& !isSpecial$1(value)
	    };

	    function isNonNullObject$1(value) {
	    	return !!value && typeof value === 'object'
	    }

	    function isSpecial$1(value) {
	    	var stringValue = Object.prototype.toString.call(value);

	    	return stringValue === '[object RegExp]'
	    		|| stringValue === '[object Date]'
	    		|| isReactElement$1(value)
	    }

	    // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	    var canUseSymbol$1 = typeof Symbol === 'function' && Symbol.for;
	    var REACT_ELEMENT_TYPE$1 = canUseSymbol$1 ? Symbol.for('react.element') : 0xeac7;

	    function isReactElement$1(value) {
	    	return value.$$typeof === REACT_ELEMENT_TYPE$1
	    }

	    function emptyTarget$1(val) {
	    	return Array.isArray(val) ? [] : {}
	    }

	    function cloneUnlessOtherwiseSpecified$1(value, options) {
	    	return (options.clone !== false && options.isMergeableObject(value))
	    		? deepmerge$1(emptyTarget$1(value), value, options)
	    		: value
	    }

	    function defaultArrayMerge$1(target, source, options) {
	    	return target.concat(source).map(function(element) {
	    		return cloneUnlessOtherwiseSpecified$1(element, options)
	    	})
	    }

	    function getMergeFunction$1(key, options) {
	    	if (!options.customMerge) {
	    		return deepmerge$1
	    	}
	    	var customMerge = options.customMerge(key);
	    	return typeof customMerge === 'function' ? customMerge : deepmerge$1
	    }

	    function getEnumerableOwnPropertySymbols$1(target) {
	    	return Object.getOwnPropertySymbols
	    		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
	    			return Object.propertyIsEnumerable.call(target, symbol)
	    		})
	    		: []
	    }

	    function getKeys$1(target) {
	    	return Object.keys(target).concat(getEnumerableOwnPropertySymbols$1(target))
	    }

	    function propertyIsOnObject$1(object, property) {
	    	try {
	    		return property in object
	    	} catch(_) {
	    		return false
	    	}
	    }

	    // Protects from prototype poisoning and unexpected merging up the prototype chain.
	    function propertyIsUnsafe$1(target, key) {
	    	return propertyIsOnObject$1(target, key) // Properties are safe to merge if they don't exist in the target yet,
	    		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
	    			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	    }

	    function mergeObject$1(target, source, options) {
	    	var destination = {};
	    	if (options.isMergeableObject(target)) {
	    		getKeys$1(target).forEach(function(key) {
	    			destination[key] = cloneUnlessOtherwiseSpecified$1(target[key], options);
	    		});
	    	}
	    	getKeys$1(source).forEach(function(key) {
	    		if (propertyIsUnsafe$1(target, key)) {
	    			return
	    		}

	    		if (propertyIsOnObject$1(target, key) && options.isMergeableObject(source[key])) {
	    			destination[key] = getMergeFunction$1(key, options)(target[key], source[key], options);
	    		} else {
	    			destination[key] = cloneUnlessOtherwiseSpecified$1(source[key], options);
	    		}
	    	});
	    	return destination
	    }

	    function deepmerge$1(target, source, options) {
	    	options = options || {};
	    	options.arrayMerge = options.arrayMerge || defaultArrayMerge$1;
	    	options.isMergeableObject = options.isMergeableObject || isMergeableObject$1;
	    	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	    	// implementations can use it. The caller may not replace it.
	    	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified$1;

	    	var sourceIsArray = Array.isArray(source);
	    	var targetIsArray = Array.isArray(target);
	    	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	    	if (!sourceAndTargetTypesMatch) {
	    		return cloneUnlessOtherwiseSpecified$1(source, options)
	    	} else if (sourceIsArray) {
	    		return options.arrayMerge(target, source, options)
	    	} else {
	    		return mergeObject$1(target, source, options)
	    	}
	    }

	    deepmerge$1.all = function deepmergeAll(array, options) {
	    	if (!Array.isArray(array)) {
	    		throw new Error('first argument should be an array')
	    	}

	    	return array.reduce(function(prev, next) {
	    		return deepmerge$1(prev, next, options)
	    	}, {})
	    };

	    var deepmerge_1$1 = deepmerge$1;

	    var cjs$1 = deepmerge_1$1;

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

	    var extendStatics$1 = function(d, b) {
	        extendStatics$1 = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics$1(d, b);
	    };

	    function __extends$1(d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics$1(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }

	    var __assign$3 = function() {
	        __assign$3 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$3.apply(this, arguments);
	    };

	    function __spreadArray$1(to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    }

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    var ErrorKind$1;
	    (function (ErrorKind) {
	        /** Argument is unclosed (e.g. `{0`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
	        /** Argument is empty (e.g. `{}`). */
	        ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
	        /** Argument is malformed (e.g. `{foo!}``) */
	        ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
	        /** Expect an argument type (e.g. `{foo,}`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
	        /** Unsupported argument type (e.g. `{foo,foo}`) */
	        ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
	        /** Expect an argument style (e.g. `{foo, number, }`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
	        /** The number skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
	        /** The date time skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
	        /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
	        /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
	        /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
	        ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
	        /** Missing select argument options (e.g. `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
	        /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
	        /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
	        /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
	        /**
	         * Expecting a message fragment after the `plural` or `selectordinal` selector
	         * (e.g. `{foo, plural, one}`)
	         */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
	        /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
	        /**
	         * Duplicate selectors in `plural` or `selectordinal` argument.
	         * (e.g. {foo, plural, one {#} one {#}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
	        /** Duplicate selectors in `select` argument.
	         * (e.g. {foo, select, apple {apple} apple {apple}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
	        /** Plural or select argument option must have `other` clause. */
	        ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
	        /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
	        ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
	        /** The tag name is invalid. (e.g. `<123>foo</123>`) */
	        ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
	        /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
	        ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
	        /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
	        ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
	    })(ErrorKind$1 || (ErrorKind$1 = {}));

	    var TYPE$1;
	    (function (TYPE) {
	        /**
	         * Raw text
	         */
	        TYPE[TYPE["literal"] = 0] = "literal";
	        /**
	         * Variable w/o any format, e.g `var` in `this is a {var}`
	         */
	        TYPE[TYPE["argument"] = 1] = "argument";
	        /**
	         * Variable w/ number format
	         */
	        TYPE[TYPE["number"] = 2] = "number";
	        /**
	         * Variable w/ date format
	         */
	        TYPE[TYPE["date"] = 3] = "date";
	        /**
	         * Variable w/ time format
	         */
	        TYPE[TYPE["time"] = 4] = "time";
	        /**
	         * Variable w/ select format
	         */
	        TYPE[TYPE["select"] = 5] = "select";
	        /**
	         * Variable w/ plural format
	         */
	        TYPE[TYPE["plural"] = 6] = "plural";
	        /**
	         * Only possible within plural argument.
	         * This is the `#` symbol that will be substituted with the count.
	         */
	        TYPE[TYPE["pound"] = 7] = "pound";
	        /**
	         * XML-like tag
	         */
	        TYPE[TYPE["tag"] = 8] = "tag";
	    })(TYPE$1 || (TYPE$1 = {}));
	    var SKELETON_TYPE$1;
	    (function (SKELETON_TYPE) {
	        SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
	        SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
	    })(SKELETON_TYPE$1 || (SKELETON_TYPE$1 = {}));
	    /**
	     * Type Guards
	     */
	    function isLiteralElement$1(el) {
	        return el.type === TYPE$1.literal;
	    }
	    function isArgumentElement$1(el) {
	        return el.type === TYPE$1.argument;
	    }
	    function isNumberElement$1(el) {
	        return el.type === TYPE$1.number;
	    }
	    function isDateElement$1(el) {
	        return el.type === TYPE$1.date;
	    }
	    function isTimeElement$1(el) {
	        return el.type === TYPE$1.time;
	    }
	    function isSelectElement$1(el) {
	        return el.type === TYPE$1.select;
	    }
	    function isPluralElement$1(el) {
	        return el.type === TYPE$1.plural;
	    }
	    function isPoundElement$1(el) {
	        return el.type === TYPE$1.pound;
	    }
	    function isTagElement$1(el) {
	        return el.type === TYPE$1.tag;
	    }
	    function isNumberSkeleton$1(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE$1.number);
	    }
	    function isDateTimeSkeleton$1(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE$1.dateTime);
	    }

	    // @generated from regex-gen.ts
	    var SPACE_SEPARATOR_REGEX$1 = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

	    /**
	     * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
	     * with some tweaks
	     */
	    var DATE_TIME_REGEX$1 = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	    /**
	     * Parse Date time skeleton into Intl.DateTimeFormatOptions
	     * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * @public
	     * @param skeleton skeleton string
	     */
	    function parseDateTimeSkeleton$1(skeleton) {
	        var result = {};
	        skeleton.replace(DATE_TIME_REGEX$1, function (match) {
	            var len = match.length;
	            switch (match[0]) {
	                // Era
	                case 'G':
	                    result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
	                    break;
	                // Year
	                case 'y':
	                    result.year = len === 2 ? '2-digit' : 'numeric';
	                    break;
	                case 'Y':
	                case 'u':
	                case 'U':
	                case 'r':
	                    throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
	                // Quarter
	                case 'q':
	                case 'Q':
	                    throw new RangeError('`q/Q` (quarter) patterns are not supported');
	                // Month
	                case 'M':
	                case 'L':
	                    result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
	                    break;
	                // Week
	                case 'w':
	                case 'W':
	                    throw new RangeError('`w/W` (week) patterns are not supported');
	                case 'd':
	                    result.day = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'D':
	                case 'F':
	                case 'g':
	                    throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
	                // Weekday
	                case 'E':
	                    result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
	                    break;
	                case 'e':
	                    if (len < 4) {
	                        throw new RangeError('`e..eee` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                case 'c':
	                    if (len < 4) {
	                        throw new RangeError('`c..ccc` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                // Period
	                case 'a': // AM, PM
	                    result.hour12 = true;
	                    break;
	                case 'b': // am, pm, noon, midnight
	                case 'B': // flexible day periods
	                    throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
	                // Hour
	                case 'h':
	                    result.hourCycle = 'h12';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'H':
	                    result.hourCycle = 'h23';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'K':
	                    result.hourCycle = 'h11';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'k':
	                    result.hourCycle = 'h24';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'j':
	                case 'J':
	                case 'C':
	                    throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
	                // Minute
	                case 'm':
	                    result.minute = ['numeric', '2-digit'][len - 1];
	                    break;
	                // Second
	                case 's':
	                    result.second = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'S':
	                case 'A':
	                    throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
	                // Zone
	                case 'z': // 1..3, 4: specific non-location format
	                    result.timeZoneName = len < 4 ? 'short' : 'long';
	                    break;
	                case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	                case 'O': // 1, 4: miliseconds in day short, long
	                case 'v': // 1, 4: generic non-location format
	                case 'V': // 1, 2, 3, 4: time zone ID or city
	                case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	                case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
	                    throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
	            }
	            return '';
	        });
	        return result;
	    }

	    // @generated from regex-gen.ts
	    var WHITE_SPACE_REGEX$1 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

	    function parseNumberSkeletonFromString$1(skeleton) {
	        if (skeleton.length === 0) {
	            throw new Error('Number skeleton cannot be empty');
	        }
	        // Parse the skeleton
	        var stringTokens = skeleton
	            .split(WHITE_SPACE_REGEX$1)
	            .filter(function (x) { return x.length > 0; });
	        var tokens = [];
	        for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
	            var stringToken = stringTokens_1[_i];
	            var stemAndOptions = stringToken.split('/');
	            if (stemAndOptions.length === 0) {
	                throw new Error('Invalid number skeleton');
	            }
	            var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
	            for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
	                var option = options_1[_a];
	                if (option.length === 0) {
	                    throw new Error('Invalid number skeleton');
	                }
	            }
	            tokens.push({ stem: stem, options: options });
	        }
	        return tokens;
	    }
	    function icuUnitToEcma$1(unit) {
	        return unit.replace(/^(.*?)-/, '');
	    }
	    var FRACTION_PRECISION_REGEX$1 = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
	    var SIGNIFICANT_PRECISION_REGEX$1 = /^(@+)?(\+|#+)?[rs]?$/g;
	    var INTEGER_WIDTH_REGEX$1 = /(\*)(0+)|(#+)(0+)|(0+)/g;
	    var CONCISE_INTEGER_WIDTH_REGEX$1 = /^(0+)$/;
	    function parseSignificantPrecision$1(str) {
	        var result = {};
	        if (str[str.length - 1] === 'r') {
	            result.roundingPriority = 'morePrecision';
	        }
	        else if (str[str.length - 1] === 's') {
	            result.roundingPriority = 'lessPrecision';
	        }
	        str.replace(SIGNIFICANT_PRECISION_REGEX$1, function (_, g1, g2) {
	            // @@@ case
	            if (typeof g2 !== 'string') {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits = g1.length;
	            }
	            // @@@+ case
	            else if (g2 === '+') {
	                result.minimumSignificantDigits = g1.length;
	            }
	            // .### case
	            else if (g1[0] === '#') {
	                result.maximumSignificantDigits = g1.length;
	            }
	            // .@@## or .@@@ case
	            else {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits =
	                    g1.length + (typeof g2 === 'string' ? g2.length : 0);
	            }
	            return '';
	        });
	        return result;
	    }
	    function parseSign$1(str) {
	        switch (str) {
	            case 'sign-auto':
	                return {
	                    signDisplay: 'auto',
	                };
	            case 'sign-accounting':
	            case '()':
	                return {
	                    currencySign: 'accounting',
	                };
	            case 'sign-always':
	            case '+!':
	                return {
	                    signDisplay: 'always',
	                };
	            case 'sign-accounting-always':
	            case '()!':
	                return {
	                    signDisplay: 'always',
	                    currencySign: 'accounting',
	                };
	            case 'sign-except-zero':
	            case '+?':
	                return {
	                    signDisplay: 'exceptZero',
	                };
	            case 'sign-accounting-except-zero':
	            case '()?':
	                return {
	                    signDisplay: 'exceptZero',
	                    currencySign: 'accounting',
	                };
	            case 'sign-never':
	            case '+_':
	                return {
	                    signDisplay: 'never',
	                };
	        }
	    }
	    function parseConciseScientificAndEngineeringStem$1(stem) {
	        // Engineering
	        var result;
	        if (stem[0] === 'E' && stem[1] === 'E') {
	            result = {
	                notation: 'engineering',
	            };
	            stem = stem.slice(2);
	        }
	        else if (stem[0] === 'E') {
	            result = {
	                notation: 'scientific',
	            };
	            stem = stem.slice(1);
	        }
	        if (result) {
	            var signDisplay = stem.slice(0, 2);
	            if (signDisplay === '+!') {
	                result.signDisplay = 'always';
	                stem = stem.slice(2);
	            }
	            else if (signDisplay === '+?') {
	                result.signDisplay = 'exceptZero';
	                stem = stem.slice(2);
	            }
	            if (!CONCISE_INTEGER_WIDTH_REGEX$1.test(stem)) {
	                throw new Error('Malformed concise eng/scientific notation');
	            }
	            result.minimumIntegerDigits = stem.length;
	        }
	        return result;
	    }
	    function parseNotationOptions$1(opt) {
	        var result = {};
	        var signOpts = parseSign$1(opt);
	        if (signOpts) {
	            return signOpts;
	        }
	        return result;
	    }
	    /**
	     * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
	     */
	    function parseNumberSkeleton$1(tokens) {
	        var result = {};
	        for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
	            var token = tokens_1[_i];
	            switch (token.stem) {
	                case 'percent':
	                case '%':
	                    result.style = 'percent';
	                    continue;
	                case '%x100':
	                    result.style = 'percent';
	                    result.scale = 100;
	                    continue;
	                case 'currency':
	                    result.style = 'currency';
	                    result.currency = token.options[0];
	                    continue;
	                case 'group-off':
	                case ',_':
	                    result.useGrouping = false;
	                    continue;
	                case 'precision-integer':
	                case '.':
	                    result.maximumFractionDigits = 0;
	                    continue;
	                case 'measure-unit':
	                case 'unit':
	                    result.style = 'unit';
	                    result.unit = icuUnitToEcma$1(token.options[0]);
	                    continue;
	                case 'compact-short':
	                case 'K':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'short';
	                    continue;
	                case 'compact-long':
	                case 'KK':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'long';
	                    continue;
	                case 'scientific':
	                    result = __assign$3(__assign$3(__assign$3({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign$3(__assign$3({}, all), parseNotationOptions$1(opt))); }, {}));
	                    continue;
	                case 'engineering':
	                    result = __assign$3(__assign$3(__assign$3({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign$3(__assign$3({}, all), parseNotationOptions$1(opt))); }, {}));
	                    continue;
	                case 'notation-simple':
	                    result.notation = 'standard';
	                    continue;
	                // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
	                case 'unit-width-narrow':
	                    result.currencyDisplay = 'narrowSymbol';
	                    result.unitDisplay = 'narrow';
	                    continue;
	                case 'unit-width-short':
	                    result.currencyDisplay = 'code';
	                    result.unitDisplay = 'short';
	                    continue;
	                case 'unit-width-full-name':
	                    result.currencyDisplay = 'name';
	                    result.unitDisplay = 'long';
	                    continue;
	                case 'unit-width-iso-code':
	                    result.currencyDisplay = 'symbol';
	                    continue;
	                case 'scale':
	                    result.scale = parseFloat(token.options[0]);
	                    continue;
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	                case 'integer-width':
	                    if (token.options.length > 1) {
	                        throw new RangeError('integer-width stems only accept a single optional option');
	                    }
	                    token.options[0].replace(INTEGER_WIDTH_REGEX$1, function (_, g1, g2, g3, g4, g5) {
	                        if (g1) {
	                            result.minimumIntegerDigits = g2.length;
	                        }
	                        else if (g3 && g4) {
	                            throw new Error('We currently do not support maximum integer digits');
	                        }
	                        else if (g5) {
	                            throw new Error('We currently do not support exact integer digits');
	                        }
	                        return '';
	                    });
	                    continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	            if (CONCISE_INTEGER_WIDTH_REGEX$1.test(token.stem)) {
	                result.minimumIntegerDigits = token.stem.length;
	                continue;
	            }
	            if (FRACTION_PRECISION_REGEX$1.test(token.stem)) {
	                // Precision
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
	                // precision-integer case
	                if (token.options.length > 1) {
	                    throw new RangeError('Fraction-precision stems only accept a single optional option');
	                }
	                token.stem.replace(FRACTION_PRECISION_REGEX$1, function (_, g1, g2, g3, g4, g5) {
	                    // .000* case (before ICU67 it was .000+)
	                    if (g2 === '*') {
	                        result.minimumFractionDigits = g1.length;
	                    }
	                    // .### case
	                    else if (g3 && g3[0] === '#') {
	                        result.maximumFractionDigits = g3.length;
	                    }
	                    // .00## case
	                    else if (g4 && g5) {
	                        result.minimumFractionDigits = g4.length;
	                        result.maximumFractionDigits = g4.length + g5.length;
	                    }
	                    else {
	                        result.minimumFractionDigits = g1.length;
	                        result.maximumFractionDigits = g1.length;
	                    }
	                    return '';
	                });
	                var opt = token.options[0];
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
	                if (opt === 'w') {
	                    result = __assign$3(__assign$3({}, result), { trailingZeroDisplay: 'stripIfInteger' });
	                }
	                else if (opt) {
	                    result = __assign$3(__assign$3({}, result), parseSignificantPrecision$1(opt));
	                }
	                continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
	            if (SIGNIFICANT_PRECISION_REGEX$1.test(token.stem)) {
	                result = __assign$3(__assign$3({}, result), parseSignificantPrecision$1(token.stem));
	                continue;
	            }
	            var signOpts = parseSign$1(token.stem);
	            if (signOpts) {
	                result = __assign$3(__assign$3({}, result), signOpts);
	            }
	            var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem$1(token.stem);
	            if (conciseScientificAndEngineeringOpts) {
	                result = __assign$3(__assign$3({}, result), conciseScientificAndEngineeringOpts);
	            }
	        }
	        return result;
	    }

	    // @generated from time-data-gen.ts
	    // prettier-ignore  
	    var timeData$1 = {
	        "AX": [
	            "H"
	        ],
	        "BQ": [
	            "H"
	        ],
	        "CP": [
	            "H"
	        ],
	        "CZ": [
	            "H"
	        ],
	        "DK": [
	            "H"
	        ],
	        "FI": [
	            "H"
	        ],
	        "ID": [
	            "H"
	        ],
	        "IS": [
	            "H"
	        ],
	        "ML": [
	            "H"
	        ],
	        "NE": [
	            "H"
	        ],
	        "RU": [
	            "H"
	        ],
	        "SE": [
	            "H"
	        ],
	        "SJ": [
	            "H"
	        ],
	        "SK": [
	            "H"
	        ],
	        "AS": [
	            "h",
	            "H"
	        ],
	        "BT": [
	            "h",
	            "H"
	        ],
	        "DJ": [
	            "h",
	            "H"
	        ],
	        "ER": [
	            "h",
	            "H"
	        ],
	        "GH": [
	            "h",
	            "H"
	        ],
	        "IN": [
	            "h",
	            "H"
	        ],
	        "LS": [
	            "h",
	            "H"
	        ],
	        "PG": [
	            "h",
	            "H"
	        ],
	        "PW": [
	            "h",
	            "H"
	        ],
	        "SO": [
	            "h",
	            "H"
	        ],
	        "TO": [
	            "h",
	            "H"
	        ],
	        "VU": [
	            "h",
	            "H"
	        ],
	        "WS": [
	            "h",
	            "H"
	        ],
	        "001": [
	            "H",
	            "h"
	        ],
	        "AL": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "TD": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "ca-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "fr-CA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "gl-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-CH": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-IT": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "LU": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "NP": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "PF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SC": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SN": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "TF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "VA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CY": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "GR": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "CO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "DO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KP": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "NA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "VE": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "AC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "AI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BW": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BZ": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "DG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "FK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GB": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IM": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IO": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "JE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "LT": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MS": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NF": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NR": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NU": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "PN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SH": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "TA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "ZA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "af-ZA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "AR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CL": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CU": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "EA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BO": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-EC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-ES": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-GQ": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-PE": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "GT": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "HN": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "IC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KG": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KM": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "LK": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MX": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "NI": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "PY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "SV": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "UY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "JP": [
	            "H",
	            "h",
	            "K"
	        ],
	        "AD": [
	            "H",
	            "hB"
	        ],
	        "AM": [
	            "H",
	            "hB"
	        ],
	        "AO": [
	            "H",
	            "hB"
	        ],
	        "AT": [
	            "H",
	            "hB"
	        ],
	        "AW": [
	            "H",
	            "hB"
	        ],
	        "BE": [
	            "H",
	            "hB"
	        ],
	        "BF": [
	            "H",
	            "hB"
	        ],
	        "BJ": [
	            "H",
	            "hB"
	        ],
	        "BL": [
	            "H",
	            "hB"
	        ],
	        "BR": [
	            "H",
	            "hB"
	        ],
	        "CG": [
	            "H",
	            "hB"
	        ],
	        "CI": [
	            "H",
	            "hB"
	        ],
	        "CV": [
	            "H",
	            "hB"
	        ],
	        "DE": [
	            "H",
	            "hB"
	        ],
	        "EE": [
	            "H",
	            "hB"
	        ],
	        "FR": [
	            "H",
	            "hB"
	        ],
	        "GA": [
	            "H",
	            "hB"
	        ],
	        "GF": [
	            "H",
	            "hB"
	        ],
	        "GN": [
	            "H",
	            "hB"
	        ],
	        "GP": [
	            "H",
	            "hB"
	        ],
	        "GW": [
	            "H",
	            "hB"
	        ],
	        "HR": [
	            "H",
	            "hB"
	        ],
	        "IL": [
	            "H",
	            "hB"
	        ],
	        "IT": [
	            "H",
	            "hB"
	        ],
	        "KZ": [
	            "H",
	            "hB"
	        ],
	        "MC": [
	            "H",
	            "hB"
	        ],
	        "MD": [
	            "H",
	            "hB"
	        ],
	        "MF": [
	            "H",
	            "hB"
	        ],
	        "MQ": [
	            "H",
	            "hB"
	        ],
	        "MZ": [
	            "H",
	            "hB"
	        ],
	        "NC": [
	            "H",
	            "hB"
	        ],
	        "NL": [
	            "H",
	            "hB"
	        ],
	        "PM": [
	            "H",
	            "hB"
	        ],
	        "PT": [
	            "H",
	            "hB"
	        ],
	        "RE": [
	            "H",
	            "hB"
	        ],
	        "RO": [
	            "H",
	            "hB"
	        ],
	        "SI": [
	            "H",
	            "hB"
	        ],
	        "SR": [
	            "H",
	            "hB"
	        ],
	        "ST": [
	            "H",
	            "hB"
	        ],
	        "TG": [
	            "H",
	            "hB"
	        ],
	        "TR": [
	            "H",
	            "hB"
	        ],
	        "WF": [
	            "H",
	            "hB"
	        ],
	        "YT": [
	            "H",
	            "hB"
	        ],
	        "BD": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "PK": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "AZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BG": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "CH": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "GE": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "LI": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "ME": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "RS": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "XK": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "AG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "AU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "CA": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "DM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "en-001": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FJ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GD": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "JM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KN": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LR": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MH": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MP": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MW": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "NZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SL": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TT": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "UM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "US": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "ZM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BO": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "EC": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "ES": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "GQ": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "PE": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "AE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "ar-001": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "BH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "DZ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EG": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "HK": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "IQ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "JO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "KW": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LB": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MR": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "OM": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PS": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "QA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SD": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "TN": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "YE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "AF": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "LA": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "CN": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "LV": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "TL": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "zu-ZA": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "CD": [
	            "hB",
	            "H"
	        ],
	        "IR": [
	            "hB",
	            "H"
	        ],
	        "hi-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "kn-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "ml-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "te-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "KH": [
	            "hB",
	            "h",
	            "H",
	            "hb"
	        ],
	        "ta-IN": [
	            "hB",
	            "h",
	            "hb",
	            "H"
	        ],
	        "BN": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "MY": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "ET": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "gu-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "mr-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "pa-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "TW": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "KE": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "MM": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "TZ": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "UG": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ]
	    };

	    /**
	     * Returns the best matching date time pattern if a date time skeleton
	     * pattern is provided with a locale. Follows the Unicode specification:
	     * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
	     * @param skeleton date time skeleton pattern that possibly includes j, J or C
	     * @param locale
	     */
	    function getBestPattern$1(skeleton, locale) {
	        var skeletonCopy = '';
	        for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
	            var patternChar = skeleton.charAt(patternPos);
	            if (patternChar === 'j') {
	                var extraLength = 0;
	                while (patternPos + 1 < skeleton.length &&
	                    skeleton.charAt(patternPos + 1) === patternChar) {
	                    extraLength++;
	                    patternPos++;
	                }
	                var hourLen = 1 + (extraLength & 1);
	                var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
	                var dayPeriodChar = 'a';
	                var hourChar = getDefaultHourSymbolFromLocale$1(locale);
	                if (hourChar == 'H' || hourChar == 'k') {
	                    dayPeriodLen = 0;
	                }
	                while (dayPeriodLen-- > 0) {
	                    skeletonCopy += dayPeriodChar;
	                }
	                while (hourLen-- > 0) {
	                    skeletonCopy = hourChar + skeletonCopy;
	                }
	            }
	            else if (patternChar === 'J') {
	                skeletonCopy += 'H';
	            }
	            else {
	                skeletonCopy += patternChar;
	            }
	        }
	        return skeletonCopy;
	    }
	    /**
	     * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
	     * of the given `locale` to the corresponding time pattern.
	     * @param locale
	     */
	    function getDefaultHourSymbolFromLocale$1(locale) {
	        var hourCycle = locale.hourCycle;
	        if (hourCycle === undefined &&
	            // @ts-ignore hourCycle(s) is not identified yet
	            locale.hourCycles &&
	            // @ts-ignore
	            locale.hourCycles.length) {
	            // @ts-ignore
	            hourCycle = locale.hourCycles[0];
	        }
	        if (hourCycle) {
	            switch (hourCycle) {
	                case 'h24':
	                    return 'k';
	                case 'h23':
	                    return 'H';
	                case 'h12':
	                    return 'h';
	                case 'h11':
	                    return 'K';
	                default:
	                    throw new Error('Invalid hourCycle');
	            }
	        }
	        // TODO: Once hourCycle is fully supported remove the following with data generation
	        var languageTag = locale.language;
	        var regionTag;
	        if (languageTag !== 'root') {
	            regionTag = locale.maximize().region;
	        }
	        var hourCycles = timeData$1[regionTag || ''] ||
	            timeData$1[languageTag || ''] ||
	            timeData$1["".concat(languageTag, "-001")] ||
	            timeData$1['001'];
	        return hourCycles[0];
	    }

	    var _a$1;
	    var SPACE_SEPARATOR_START_REGEX$1 = new RegExp("^".concat(SPACE_SEPARATOR_REGEX$1.source, "*"));
	    var SPACE_SEPARATOR_END_REGEX$1 = new RegExp("".concat(SPACE_SEPARATOR_REGEX$1.source, "*$"));
	    function createLocation$1(start, end) {
	        return { start: start, end: end };
	    }
	    // #region Ponyfills
	    // Consolidate these variables up top for easier toggling during debugging
	    var hasNativeStartsWith$1 = !!String.prototype.startsWith;
	    var hasNativeFromCodePoint$1 = !!String.fromCodePoint;
	    var hasNativeFromEntries$1 = !!Object.fromEntries;
	    var hasNativeCodePointAt$1 = !!String.prototype.codePointAt;
	    var hasTrimStart$1 = !!String.prototype.trimStart;
	    var hasTrimEnd$1 = !!String.prototype.trimEnd;
	    var hasNativeIsSafeInteger$1 = !!Number.isSafeInteger;
	    var isSafeInteger$1 = hasNativeIsSafeInteger$1
	        ? Number.isSafeInteger
	        : function (n) {
	            return (typeof n === 'number' &&
	                isFinite(n) &&
	                Math.floor(n) === n &&
	                Math.abs(n) <= 0x1fffffffffffff);
	        };
	    // IE11 does not support y and u.
	    var REGEX_SUPPORTS_U_AND_Y$1 = true;
	    try {
	        var re$1 = RE$1('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        /**
	         * legacy Edge or Xbox One browser
	         * Unicode flag support: supported
	         * Pattern_Syntax support: not supported
	         * See https://github.com/formatjs/formatjs/issues/2822
	         */
	        REGEX_SUPPORTS_U_AND_Y$1 = ((_a$1 = re$1.exec('a')) === null || _a$1 === void 0 ? void 0 : _a$1[0]) === 'a';
	    }
	    catch (_) {
	        REGEX_SUPPORTS_U_AND_Y$1 = false;
	    }
	    var startsWith$1 = hasNativeStartsWith$1
	        ? // Native
	            function startsWith(s, search, position) {
	                return s.startsWith(search, position);
	            }
	        : // For IE11
	            function startsWith(s, search, position) {
	                return s.slice(position, position + search.length) === search;
	            };
	    var fromCodePoint$1 = hasNativeFromCodePoint$1
	        ? String.fromCodePoint
	        : // IE11
	            function fromCodePoint() {
	                var codePoints = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    codePoints[_i] = arguments[_i];
	                }
	                var elements = '';
	                var length = codePoints.length;
	                var i = 0;
	                var code;
	                while (length > i) {
	                    code = codePoints[i++];
	                    if (code > 0x10ffff)
	                        throw RangeError(code + ' is not a valid code point');
	                    elements +=
	                        code < 0x10000
	                            ? String.fromCharCode(code)
	                            : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
	                }
	                return elements;
	            };
	    var fromEntries$1 = 
	    // native
	    hasNativeFromEntries$1
	        ? Object.fromEntries
	        : // Ponyfill
	            function fromEntries(entries) {
	                var obj = {};
	                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                    var _a = entries_1[_i], k = _a[0], v = _a[1];
	                    obj[k] = v;
	                }
	                return obj;
	            };
	    var codePointAt$1 = hasNativeCodePointAt$1
	        ? // Native
	            function codePointAt(s, index) {
	                return s.codePointAt(index);
	            }
	        : // IE 11
	            function codePointAt(s, index) {
	                var size = s.length;
	                if (index < 0 || index >= size) {
	                    return undefined;
	                }
	                var first = s.charCodeAt(index);
	                var second;
	                return first < 0xd800 ||
	                    first > 0xdbff ||
	                    index + 1 === size ||
	                    (second = s.charCodeAt(index + 1)) < 0xdc00 ||
	                    second > 0xdfff
	                    ? first
	                    : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
	            };
	    var trimStart$1 = hasTrimStart$1
	        ? // Native
	            function trimStart(s) {
	                return s.trimStart();
	            }
	        : // Ponyfill
	            function trimStart(s) {
	                return s.replace(SPACE_SEPARATOR_START_REGEX$1, '');
	            };
	    var trimEnd$1 = hasTrimEnd$1
	        ? // Native
	            function trimEnd(s) {
	                return s.trimEnd();
	            }
	        : // Ponyfill
	            function trimEnd(s) {
	                return s.replace(SPACE_SEPARATOR_END_REGEX$1, '');
	            };
	    // Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
	    function RE$1(s, flag) {
	        return new RegExp(s, flag);
	    }
	    // #endregion
	    var matchIdentifierAtIndex$1;
	    if (REGEX_SUPPORTS_U_AND_Y$1) {
	        // Native
	        var IDENTIFIER_PREFIX_RE_1$1 = RE$1('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        matchIdentifierAtIndex$1 = function matchIdentifierAtIndex(s, index) {
	            var _a;
	            IDENTIFIER_PREFIX_RE_1$1.lastIndex = index;
	            var match = IDENTIFIER_PREFIX_RE_1$1.exec(s);
	            return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
	        };
	    }
	    else {
	        // IE11
	        matchIdentifierAtIndex$1 = function matchIdentifierAtIndex(s, index) {
	            var match = [];
	            while (true) {
	                var c = codePointAt$1(s, index);
	                if (c === undefined || _isWhiteSpace$1(c) || _isPatternSyntax$1(c)) {
	                    break;
	                }
	                match.push(c);
	                index += c >= 0x10000 ? 2 : 1;
	            }
	            return fromCodePoint$1.apply(void 0, match);
	        };
	    }
	    var Parser$1 = /** @class */ (function () {
	        function Parser(message, options) {
	            if (options === void 0) { options = {}; }
	            this.message = message;
	            this.position = { offset: 0, line: 1, column: 1 };
	            this.ignoreTag = !!options.ignoreTag;
	            this.locale = options.locale;
	            this.requiresOtherClause = !!options.requiresOtherClause;
	            this.shouldParseSkeletons = !!options.shouldParseSkeletons;
	        }
	        Parser.prototype.parse = function () {
	            if (this.offset() !== 0) {
	                throw Error('parser can only be used once');
	            }
	            return this.parseMessage(0, '', false);
	        };
	        Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
	            var elements = [];
	            while (!this.isEOF()) {
	                var char = this.char();
	                if (char === 123 /* `{` */) {
	                    var result = this.parseArgument(nestingLevel, expectingCloseTag);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else if (char === 125 /* `}` */ && nestingLevel > 0) {
	                    break;
	                }
	                else if (char === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
	                    var position = this.clonePosition();
	                    this.bump();
	                    elements.push({
	                        type: TYPE$1.pound,
	                        location: createLocation$1(position, this.clonePosition()),
	                    });
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    this.peek() === 47 // char code for '/'
	                ) {
	                    if (expectingCloseTag) {
	                        break;
	                    }
	                    else {
	                        return this.error(ErrorKind$1.UNMATCHED_CLOSING_TAG, createLocation$1(this.clonePosition(), this.clonePosition()));
	                    }
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    _isAlpha$1(this.peek() || 0)) {
	                    var result = this.parseTag(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else {
	                    var result = this.parseLiteral(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	            }
	            return { val: elements, err: null };
	        };
	        /**
	         * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	         * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	         * are accepted:
	         *
	         * ```
	         * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	         * tagName ::= [a-z] (PENChar)*
	         * PENChar ::=
	         *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	         *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	         *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	         * ```
	         *
	         * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	         * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	         * since other tag-based engines like React allow it
	         */
	        Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
	            var startPosition = this.clonePosition();
	            this.bump(); // `<`
	            var tagName = this.parseTagName();
	            this.bumpSpace();
	            if (this.bumpIf('/>')) {
	                // Self closing tag
	                return {
	                    val: {
	                        type: TYPE$1.literal,
	                        value: "<".concat(tagName, "/>"),
	                        location: createLocation$1(startPosition, this.clonePosition()),
	                    },
	                    err: null,
	                };
	            }
	            else if (this.bumpIf('>')) {
	                var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
	                if (childrenResult.err) {
	                    return childrenResult;
	                }
	                var children = childrenResult.val;
	                // Expecting a close tag
	                var endTagStartPosition = this.clonePosition();
	                if (this.bumpIf('</')) {
	                    if (this.isEOF() || !_isAlpha$1(this.char())) {
	                        return this.error(ErrorKind$1.INVALID_TAG, createLocation$1(endTagStartPosition, this.clonePosition()));
	                    }
	                    var closingTagNameStartPosition = this.clonePosition();
	                    var closingTagName = this.parseTagName();
	                    if (tagName !== closingTagName) {
	                        return this.error(ErrorKind$1.UNMATCHED_CLOSING_TAG, createLocation$1(closingTagNameStartPosition, this.clonePosition()));
	                    }
	                    this.bumpSpace();
	                    if (!this.bumpIf('>')) {
	                        return this.error(ErrorKind$1.INVALID_TAG, createLocation$1(endTagStartPosition, this.clonePosition()));
	                    }
	                    return {
	                        val: {
	                            type: TYPE$1.tag,
	                            value: tagName,
	                            children: children,
	                            location: createLocation$1(startPosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                else {
	                    return this.error(ErrorKind$1.UNCLOSED_TAG, createLocation$1(startPosition, this.clonePosition()));
	                }
	            }
	            else {
	                return this.error(ErrorKind$1.INVALID_TAG, createLocation$1(startPosition, this.clonePosition()));
	            }
	        };
	        /**
	         * This method assumes that the caller has peeked ahead for the first tag character.
	         */
	        Parser.prototype.parseTagName = function () {
	            var startOffset = this.offset();
	            this.bump(); // the first tag name character
	            while (!this.isEOF() && _isPotentialElementNameChar$1(this.char())) {
	                this.bump();
	            }
	            return this.message.slice(startOffset, this.offset());
	        };
	        Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
	            var start = this.clonePosition();
	            var value = '';
	            while (true) {
	                var parseQuoteResult = this.tryParseQuote(parentArgType);
	                if (parseQuoteResult) {
	                    value += parseQuoteResult;
	                    continue;
	                }
	                var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
	                if (parseUnquotedResult) {
	                    value += parseUnquotedResult;
	                    continue;
	                }
	                var parseLeftAngleResult = this.tryParseLeftAngleBracket();
	                if (parseLeftAngleResult) {
	                    value += parseLeftAngleResult;
	                    continue;
	                }
	                break;
	            }
	            var location = createLocation$1(start, this.clonePosition());
	            return {
	                val: { type: TYPE$1.literal, value: value, location: location },
	                err: null,
	            };
	        };
	        Parser.prototype.tryParseLeftAngleBracket = function () {
	            if (!this.isEOF() &&
	                this.char() === 60 /* `<` */ &&
	                (this.ignoreTag ||
	                    // If at the opening tag or closing tag position, bail.
	                    !_isAlphaOrSlash$1(this.peek() || 0))) {
	                this.bump(); // `<`
	                return '<';
	            }
	            return null;
	        };
	        /**
	         * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	         * a character that requires quoting (that is, "only where needed"), and works the same in
	         * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	         */
	        Parser.prototype.tryParseQuote = function (parentArgType) {
	            if (this.isEOF() || this.char() !== 39 /* `'` */) {
	                return null;
	            }
	            // Parse escaped char following the apostrophe, or early return if there is no escaped char.
	            // Check if is valid escaped character
	            switch (this.peek()) {
	                case 39 /* `'` */:
	                    // double quote, should return as a single quote.
	                    this.bump();
	                    this.bump();
	                    return "'";
	                // '{', '<', '>', '}'
	                case 123:
	                case 60:
	                case 62:
	                case 125:
	                    break;
	                case 35: // '#'
	                    if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
	                        break;
	                    }
	                    return null;
	                default:
	                    return null;
	            }
	            this.bump(); // apostrophe
	            var codePoints = [this.char()]; // escaped char
	            this.bump();
	            // read chars until the optional closing apostrophe is found
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch === 39 /* `'` */) {
	                    if (this.peek() === 39 /* `'` */) {
	                        codePoints.push(39);
	                        // Bump one more time because we need to skip 2 characters.
	                        this.bump();
	                    }
	                    else {
	                        // Optional closing apostrophe.
	                        this.bump();
	                        break;
	                    }
	                }
	                else {
	                    codePoints.push(ch);
	                }
	                this.bump();
	            }
	            return fromCodePoint$1.apply(void 0, codePoints);
	        };
	        Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
	            if (this.isEOF()) {
	                return null;
	            }
	            var ch = this.char();
	            if (ch === 60 /* `<` */ ||
	                ch === 123 /* `{` */ ||
	                (ch === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
	                (ch === 125 /* `}` */ && nestingLevel > 0)) {
	                return null;
	            }
	            else {
	                this.bump();
	                return fromCodePoint$1(ch);
	            }
	        };
	        Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
	            var openingBracePosition = this.clonePosition();
	            this.bump(); // `{`
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind$1.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
	            }
	            if (this.char() === 125 /* `}` */) {
	                this.bump();
	                return this.error(ErrorKind$1.EMPTY_ARGUMENT, createLocation$1(openingBracePosition, this.clonePosition()));
	            }
	            // argument name
	            var value = this.parseIdentifierIfPossible().value;
	            if (!value) {
	                return this.error(ErrorKind$1.MALFORMED_ARGUMENT, createLocation$1(openingBracePosition, this.clonePosition()));
	            }
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind$1.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
	            }
	            switch (this.char()) {
	                // Simple argument: `{name}`
	                case 125 /* `}` */: {
	                    this.bump(); // `}`
	                    return {
	                        val: {
	                            type: TYPE$1.argument,
	                            // value does not include the opening and closing braces.
	                            value: value,
	                            location: createLocation$1(openingBracePosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                // Argument with options: `{name, format, ...}`
	                case 44 /* `,` */: {
	                    this.bump(); // `,`
	                    this.bumpSpace();
	                    if (this.isEOF()) {
	                        return this.error(ErrorKind$1.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
	                    }
	                    return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
	                }
	                default:
	                    return this.error(ErrorKind$1.MALFORMED_ARGUMENT, createLocation$1(openingBracePosition, this.clonePosition()));
	            }
	        };
	        /**
	         * Advance the parser until the end of the identifier, if it is currently on
	         * an identifier character. Return an empty string otherwise.
	         */
	        Parser.prototype.parseIdentifierIfPossible = function () {
	            var startingPosition = this.clonePosition();
	            var startOffset = this.offset();
	            var value = matchIdentifierAtIndex$1(this.message, startOffset);
	            var endOffset = startOffset + value.length;
	            this.bumpTo(endOffset);
	            var endPosition = this.clonePosition();
	            var location = createLocation$1(startingPosition, endPosition);
	            return { value: value, location: location };
	        };
	        Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
	            var _a;
	            // Parse this range:
	            // {name, type, style}
	            //        ^---^
	            var typeStartPosition = this.clonePosition();
	            var argType = this.parseIdentifierIfPossible().value;
	            var typeEndPosition = this.clonePosition();
	            switch (argType) {
	                case '':
	                    // Expecting a style string number, date, time, plural, selectordinal, or select.
	                    return this.error(ErrorKind$1.EXPECT_ARGUMENT_TYPE, createLocation$1(typeStartPosition, typeEndPosition));
	                case 'number':
	                case 'date':
	                case 'time': {
	                    // Parse this range:
	                    // {name, number, style}
	                    //              ^-------^
	                    this.bumpSpace();
	                    var styleAndLocation = null;
	                    if (this.bumpIf(',')) {
	                        this.bumpSpace();
	                        var styleStartPosition = this.clonePosition();
	                        var result = this.parseSimpleArgStyleIfPossible();
	                        if (result.err) {
	                            return result;
	                        }
	                        var style = trimEnd$1(result.val);
	                        if (style.length === 0) {
	                            return this.error(ErrorKind$1.EXPECT_ARGUMENT_STYLE, createLocation$1(this.clonePosition(), this.clonePosition()));
	                        }
	                        var styleLocation = createLocation$1(styleStartPosition, this.clonePosition());
	                        styleAndLocation = { style: style, styleLocation: styleLocation };
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_1 = createLocation$1(openingBracePosition, this.clonePosition());
	                    // Extract style or skeleton
	                    if (styleAndLocation && startsWith$1(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
	                        // Skeleton starts with `::`.
	                        var skeleton = trimStart$1(styleAndLocation.style.slice(2));
	                        if (argType === 'number') {
	                            var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
	                            if (result.err) {
	                                return result;
	                            }
	                            return {
	                                val: { type: TYPE$1.number, value: value, location: location_1, style: result.val },
	                                err: null,
	                            };
	                        }
	                        else {
	                            if (skeleton.length === 0) {
	                                return this.error(ErrorKind$1.EXPECT_DATE_TIME_SKELETON, location_1);
	                            }
	                            var dateTimePattern = skeleton;
	                            // Get "best match" pattern only if locale is passed, if not, let it
	                            // pass as-is where `parseDateTimeSkeleton()` will throw an error
	                            // for unsupported patterns.
	                            if (this.locale) {
	                                dateTimePattern = getBestPattern$1(skeleton, this.locale);
	                            }
	                            var style = {
	                                type: SKELETON_TYPE$1.dateTime,
	                                pattern: dateTimePattern,
	                                location: styleAndLocation.styleLocation,
	                                parsedOptions: this.shouldParseSkeletons
	                                    ? parseDateTimeSkeleton$1(dateTimePattern)
	                                    : {},
	                            };
	                            var type = argType === 'date' ? TYPE$1.date : TYPE$1.time;
	                            return {
	                                val: { type: type, value: value, location: location_1, style: style },
	                                err: null,
	                            };
	                        }
	                    }
	                    // Regular style or no style.
	                    return {
	                        val: {
	                            type: argType === 'number'
	                                ? TYPE$1.number
	                                : argType === 'date'
	                                    ? TYPE$1.date
	                                    : TYPE$1.time,
	                            value: value,
	                            location: location_1,
	                            style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
	                        },
	                        err: null,
	                    };
	                }
	                case 'plural':
	                case 'selectordinal':
	                case 'select': {
	                    // Parse this range:
	                    // {name, plural, options}
	                    //              ^---------^
	                    var typeEndPosition_1 = this.clonePosition();
	                    this.bumpSpace();
	                    if (!this.bumpIf(',')) {
	                        return this.error(ErrorKind$1.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation$1(typeEndPosition_1, __assign$3({}, typeEndPosition_1)));
	                    }
	                    this.bumpSpace();
	                    // Parse offset:
	                    // {name, plural, offset:1, options}
	                    //                ^-----^
	                    //
	                    // or the first option:
	                    //
	                    // {name, plural, one {...} other {...}}
	                    //                ^--^
	                    var identifierAndLocation = this.parseIdentifierIfPossible();
	                    var pluralOffset = 0;
	                    if (argType !== 'select' && identifierAndLocation.value === 'offset') {
	                        if (!this.bumpIf(':')) {
	                            return this.error(ErrorKind$1.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation$1(this.clonePosition(), this.clonePosition()));
	                        }
	                        this.bumpSpace();
	                        var result = this.tryParseDecimalInteger(ErrorKind$1.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind$1.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
	                        if (result.err) {
	                            return result;
	                        }
	                        // Parse another identifier for option parsing
	                        this.bumpSpace();
	                        identifierAndLocation = this.parseIdentifierIfPossible();
	                        pluralOffset = result.val;
	                    }
	                    var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
	                    if (optionsResult.err) {
	                        return optionsResult;
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_2 = createLocation$1(openingBracePosition, this.clonePosition());
	                    if (argType === 'select') {
	                        return {
	                            val: {
	                                type: TYPE$1.select,
	                                value: value,
	                                options: fromEntries$1(optionsResult.val),
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                    else {
	                        return {
	                            val: {
	                                type: TYPE$1.plural,
	                                value: value,
	                                options: fromEntries$1(optionsResult.val),
	                                offset: pluralOffset,
	                                pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                }
	                default:
	                    return this.error(ErrorKind$1.INVALID_ARGUMENT_TYPE, createLocation$1(typeStartPosition, typeEndPosition));
	            }
	        };
	        Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
	            // Parse: {value, number, ::currency/GBP }
	            //
	            if (this.isEOF() || this.char() !== 125 /* `}` */) {
	                return this.error(ErrorKind$1.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
	            }
	            this.bump(); // `}`
	            return { val: true, err: null };
	        };
	        /**
	         * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	         */
	        Parser.prototype.parseSimpleArgStyleIfPossible = function () {
	            var nestedBraces = 0;
	            var startPosition = this.clonePosition();
	            while (!this.isEOF()) {
	                var ch = this.char();
	                switch (ch) {
	                    case 39 /* `'` */: {
	                        // Treat apostrophe as quoting but include it in the style part.
	                        // Find the end of the quoted literal text.
	                        this.bump();
	                        var apostrophePosition = this.clonePosition();
	                        if (!this.bumpUntil("'")) {
	                            return this.error(ErrorKind$1.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation$1(apostrophePosition, this.clonePosition()));
	                        }
	                        this.bump();
	                        break;
	                    }
	                    case 123 /* `{` */: {
	                        nestedBraces += 1;
	                        this.bump();
	                        break;
	                    }
	                    case 125 /* `}` */: {
	                        if (nestedBraces > 0) {
	                            nestedBraces -= 1;
	                        }
	                        else {
	                            return {
	                                val: this.message.slice(startPosition.offset, this.offset()),
	                                err: null,
	                            };
	                        }
	                        break;
	                    }
	                    default:
	                        this.bump();
	                        break;
	                }
	            }
	            return {
	                val: this.message.slice(startPosition.offset, this.offset()),
	                err: null,
	            };
	        };
	        Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
	            var tokens = [];
	            try {
	                tokens = parseNumberSkeletonFromString$1(skeleton);
	            }
	            catch (e) {
	                return this.error(ErrorKind$1.INVALID_NUMBER_SKELETON, location);
	            }
	            return {
	                val: {
	                    type: SKELETON_TYPE$1.number,
	                    tokens: tokens,
	                    location: location,
	                    parsedOptions: this.shouldParseSkeletons
	                        ? parseNumberSkeleton$1(tokens)
	                        : {},
	                },
	                err: null,
	            };
	        };
	        /**
	         * @param nesting_level The current nesting level of messages.
	         *     This can be positive when parsing message fragment in select or plural argument options.
	         * @param parent_arg_type The parent argument's type.
	         * @param parsed_first_identifier If provided, this is the first identifier-like selector of
	         *     the argument. It is a by-product of a previous parsing attempt.
	         * @param expecting_close_tag If true, this message is directly or indirectly nested inside
	         *     between a pair of opening and closing tags. The nested message will not parse beyond
	         *     the closing tag boundary.
	         */
	        Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
	            var _a;
	            var hasOtherClause = false;
	            var options = [];
	            var parsedSelectors = new Set();
	            var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
	            // Parse:
	            // one {one apple}
	            // ^--^
	            while (true) {
	                if (selector.length === 0) {
	                    var startPosition = this.clonePosition();
	                    if (parentArgType !== 'select' && this.bumpIf('=')) {
	                        // Try parse `={number}` selector
	                        var result = this.tryParseDecimalInteger(ErrorKind$1.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind$1.INVALID_PLURAL_ARGUMENT_SELECTOR);
	                        if (result.err) {
	                            return result;
	                        }
	                        selectorLocation = createLocation$1(startPosition, this.clonePosition());
	                        selector = this.message.slice(startPosition.offset, this.offset());
	                    }
	                    else {
	                        break;
	                    }
	                }
	                // Duplicate selector clauses
	                if (parsedSelectors.has(selector)) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind$1.DUPLICATE_SELECT_ARGUMENT_SELECTOR
	                        : ErrorKind$1.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
	                }
	                if (selector === 'other') {
	                    hasOtherClause = true;
	                }
	                // Parse:
	                // one {one apple}
	                //     ^----------^
	                this.bumpSpace();
	                var openingBracePosition = this.clonePosition();
	                if (!this.bumpIf('{')) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind$1.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
	                        : ErrorKind$1.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation$1(this.clonePosition(), this.clonePosition()));
	                }
	                var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
	                if (fragmentResult.err) {
	                    return fragmentResult;
	                }
	                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                if (argCloseResult.err) {
	                    return argCloseResult;
	                }
	                options.push([
	                    selector,
	                    {
	                        value: fragmentResult.val,
	                        location: createLocation$1(openingBracePosition, this.clonePosition()),
	                    },
	                ]);
	                // Keep track of the existing selectors
	                parsedSelectors.add(selector);
	                // Prep next selector clause.
	                this.bumpSpace();
	                (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
	            }
	            if (options.length === 0) {
	                return this.error(parentArgType === 'select'
	                    ? ErrorKind$1.EXPECT_SELECT_ARGUMENT_SELECTOR
	                    : ErrorKind$1.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation$1(this.clonePosition(), this.clonePosition()));
	            }
	            if (this.requiresOtherClause && !hasOtherClause) {
	                return this.error(ErrorKind$1.MISSING_OTHER_CLAUSE, createLocation$1(this.clonePosition(), this.clonePosition()));
	            }
	            return { val: options, err: null };
	        };
	        Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
	            var sign = 1;
	            var startingPosition = this.clonePosition();
	            if (this.bumpIf('+')) ;
	            else if (this.bumpIf('-')) {
	                sign = -1;
	            }
	            var hasDigits = false;
	            var decimal = 0;
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
	                    hasDigits = true;
	                    decimal = decimal * 10 + (ch - 48);
	                    this.bump();
	                }
	                else {
	                    break;
	                }
	            }
	            var location = createLocation$1(startingPosition, this.clonePosition());
	            if (!hasDigits) {
	                return this.error(expectNumberError, location);
	            }
	            decimal *= sign;
	            if (!isSafeInteger$1(decimal)) {
	                return this.error(invalidNumberError, location);
	            }
	            return { val: decimal, err: null };
	        };
	        Parser.prototype.offset = function () {
	            return this.position.offset;
	        };
	        Parser.prototype.isEOF = function () {
	            return this.offset() === this.message.length;
	        };
	        Parser.prototype.clonePosition = function () {
	            // This is much faster than `Object.assign` or spread.
	            return {
	                offset: this.position.offset,
	                line: this.position.line,
	                column: this.position.column,
	            };
	        };
	        /**
	         * Return the code point at the current position of the parser.
	         * Throws if the index is out of bound.
	         */
	        Parser.prototype.char = function () {
	            var offset = this.position.offset;
	            if (offset >= this.message.length) {
	                throw Error('out of bound');
	            }
	            var code = codePointAt$1(this.message, offset);
	            if (code === undefined) {
	                throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
	            }
	            return code;
	        };
	        Parser.prototype.error = function (kind, location) {
	            return {
	                val: null,
	                err: {
	                    kind: kind,
	                    message: this.message,
	                    location: location,
	                },
	            };
	        };
	        /** Bump the parser to the next UTF-16 code unit. */
	        Parser.prototype.bump = function () {
	            if (this.isEOF()) {
	                return;
	            }
	            var code = this.char();
	            if (code === 10 /* '\n' */) {
	                this.position.line += 1;
	                this.position.column = 1;
	                this.position.offset += 1;
	            }
	            else {
	                this.position.column += 1;
	                // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
	                this.position.offset += code < 0x10000 ? 1 : 2;
	            }
	        };
	        /**
	         * If the substring starting at the current position of the parser has
	         * the given prefix, then bump the parser to the character immediately
	         * following the prefix and return true. Otherwise, don't bump the parser
	         * and return false.
	         */
	        Parser.prototype.bumpIf = function (prefix) {
	            if (startsWith$1(this.message, prefix, this.offset())) {
	                for (var i = 0; i < prefix.length; i++) {
	                    this.bump();
	                }
	                return true;
	            }
	            return false;
	        };
	        /**
	         * Bump the parser until the pattern character is found and return `true`.
	         * Otherwise bump to the end of the file and return `false`.
	         */
	        Parser.prototype.bumpUntil = function (pattern) {
	            var currentOffset = this.offset();
	            var index = this.message.indexOf(pattern, currentOffset);
	            if (index >= 0) {
	                this.bumpTo(index);
	                return true;
	            }
	            else {
	                this.bumpTo(this.message.length);
	                return false;
	            }
	        };
	        /**
	         * Bump the parser to the target offset.
	         * If target offset is beyond the end of the input, bump the parser to the end of the input.
	         */
	        Parser.prototype.bumpTo = function (targetOffset) {
	            if (this.offset() > targetOffset) {
	                throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
	            }
	            targetOffset = Math.min(targetOffset, this.message.length);
	            while (true) {
	                var offset = this.offset();
	                if (offset === targetOffset) {
	                    break;
	                }
	                if (offset > targetOffset) {
	                    throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
	                }
	                this.bump();
	                if (this.isEOF()) {
	                    break;
	                }
	            }
	        };
	        /** advance the parser through all whitespace to the next non-whitespace code unit. */
	        Parser.prototype.bumpSpace = function () {
	            while (!this.isEOF() && _isWhiteSpace$1(this.char())) {
	                this.bump();
	            }
	        };
	        /**
	         * Peek at the *next* Unicode codepoint in the input without advancing the parser.
	         * If the input has been exhausted, then this returns null.
	         */
	        Parser.prototype.peek = function () {
	            if (this.isEOF()) {
	                return null;
	            }
	            var code = this.char();
	            var offset = this.offset();
	            var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
	            return nextCode !== null && nextCode !== void 0 ? nextCode : null;
	        };
	        return Parser;
	    }());
	    /**
	     * This check if codepoint is alphabet (lower & uppercase)
	     * @param codepoint
	     * @returns
	     */
	    function _isAlpha$1(codepoint) {
	        return ((codepoint >= 97 && codepoint <= 122) ||
	            (codepoint >= 65 && codepoint <= 90));
	    }
	    function _isAlphaOrSlash$1(codepoint) {
	        return _isAlpha$1(codepoint) || codepoint === 47; /* '/' */
	    }
	    /** See `parseTag` function docs. */
	    function _isPotentialElementNameChar$1(c) {
	        return (c === 45 /* '-' */ ||
	            c === 46 /* '.' */ ||
	            (c >= 48 && c <= 57) /* 0..9 */ ||
	            c === 95 /* '_' */ ||
	            (c >= 97 && c <= 122) /** a..z */ ||
	            (c >= 65 && c <= 90) /* A..Z */ ||
	            c == 0xb7 ||
	            (c >= 0xc0 && c <= 0xd6) ||
	            (c >= 0xd8 && c <= 0xf6) ||
	            (c >= 0xf8 && c <= 0x37d) ||
	            (c >= 0x37f && c <= 0x1fff) ||
	            (c >= 0x200c && c <= 0x200d) ||
	            (c >= 0x203f && c <= 0x2040) ||
	            (c >= 0x2070 && c <= 0x218f) ||
	            (c >= 0x2c00 && c <= 0x2fef) ||
	            (c >= 0x3001 && c <= 0xd7ff) ||
	            (c >= 0xf900 && c <= 0xfdcf) ||
	            (c >= 0xfdf0 && c <= 0xfffd) ||
	            (c >= 0x10000 && c <= 0xeffff));
	    }
	    /**
	     * Code point equivalent of regex `\p{White_Space}`.
	     * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isWhiteSpace$1(c) {
	        return ((c >= 0x0009 && c <= 0x000d) ||
	            c === 0x0020 ||
	            c === 0x0085 ||
	            (c >= 0x200e && c <= 0x200f) ||
	            c === 0x2028 ||
	            c === 0x2029);
	    }
	    /**
	     * Code point equivalent of regex `\p{Pattern_Syntax}`.
	     * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isPatternSyntax$1(c) {
	        return ((c >= 0x0021 && c <= 0x0023) ||
	            c === 0x0024 ||
	            (c >= 0x0025 && c <= 0x0027) ||
	            c === 0x0028 ||
	            c === 0x0029 ||
	            c === 0x002a ||
	            c === 0x002b ||
	            c === 0x002c ||
	            c === 0x002d ||
	            (c >= 0x002e && c <= 0x002f) ||
	            (c >= 0x003a && c <= 0x003b) ||
	            (c >= 0x003c && c <= 0x003e) ||
	            (c >= 0x003f && c <= 0x0040) ||
	            c === 0x005b ||
	            c === 0x005c ||
	            c === 0x005d ||
	            c === 0x005e ||
	            c === 0x0060 ||
	            c === 0x007b ||
	            c === 0x007c ||
	            c === 0x007d ||
	            c === 0x007e ||
	            c === 0x00a1 ||
	            (c >= 0x00a2 && c <= 0x00a5) ||
	            c === 0x00a6 ||
	            c === 0x00a7 ||
	            c === 0x00a9 ||
	            c === 0x00ab ||
	            c === 0x00ac ||
	            c === 0x00ae ||
	            c === 0x00b0 ||
	            c === 0x00b1 ||
	            c === 0x00b6 ||
	            c === 0x00bb ||
	            c === 0x00bf ||
	            c === 0x00d7 ||
	            c === 0x00f7 ||
	            (c >= 0x2010 && c <= 0x2015) ||
	            (c >= 0x2016 && c <= 0x2017) ||
	            c === 0x2018 ||
	            c === 0x2019 ||
	            c === 0x201a ||
	            (c >= 0x201b && c <= 0x201c) ||
	            c === 0x201d ||
	            c === 0x201e ||
	            c === 0x201f ||
	            (c >= 0x2020 && c <= 0x2027) ||
	            (c >= 0x2030 && c <= 0x2038) ||
	            c === 0x2039 ||
	            c === 0x203a ||
	            (c >= 0x203b && c <= 0x203e) ||
	            (c >= 0x2041 && c <= 0x2043) ||
	            c === 0x2044 ||
	            c === 0x2045 ||
	            c === 0x2046 ||
	            (c >= 0x2047 && c <= 0x2051) ||
	            c === 0x2052 ||
	            c === 0x2053 ||
	            (c >= 0x2055 && c <= 0x205e) ||
	            (c >= 0x2190 && c <= 0x2194) ||
	            (c >= 0x2195 && c <= 0x2199) ||
	            (c >= 0x219a && c <= 0x219b) ||
	            (c >= 0x219c && c <= 0x219f) ||
	            c === 0x21a0 ||
	            (c >= 0x21a1 && c <= 0x21a2) ||
	            c === 0x21a3 ||
	            (c >= 0x21a4 && c <= 0x21a5) ||
	            c === 0x21a6 ||
	            (c >= 0x21a7 && c <= 0x21ad) ||
	            c === 0x21ae ||
	            (c >= 0x21af && c <= 0x21cd) ||
	            (c >= 0x21ce && c <= 0x21cf) ||
	            (c >= 0x21d0 && c <= 0x21d1) ||
	            c === 0x21d2 ||
	            c === 0x21d3 ||
	            c === 0x21d4 ||
	            (c >= 0x21d5 && c <= 0x21f3) ||
	            (c >= 0x21f4 && c <= 0x22ff) ||
	            (c >= 0x2300 && c <= 0x2307) ||
	            c === 0x2308 ||
	            c === 0x2309 ||
	            c === 0x230a ||
	            c === 0x230b ||
	            (c >= 0x230c && c <= 0x231f) ||
	            (c >= 0x2320 && c <= 0x2321) ||
	            (c >= 0x2322 && c <= 0x2328) ||
	            c === 0x2329 ||
	            c === 0x232a ||
	            (c >= 0x232b && c <= 0x237b) ||
	            c === 0x237c ||
	            (c >= 0x237d && c <= 0x239a) ||
	            (c >= 0x239b && c <= 0x23b3) ||
	            (c >= 0x23b4 && c <= 0x23db) ||
	            (c >= 0x23dc && c <= 0x23e1) ||
	            (c >= 0x23e2 && c <= 0x2426) ||
	            (c >= 0x2427 && c <= 0x243f) ||
	            (c >= 0x2440 && c <= 0x244a) ||
	            (c >= 0x244b && c <= 0x245f) ||
	            (c >= 0x2500 && c <= 0x25b6) ||
	            c === 0x25b7 ||
	            (c >= 0x25b8 && c <= 0x25c0) ||
	            c === 0x25c1 ||
	            (c >= 0x25c2 && c <= 0x25f7) ||
	            (c >= 0x25f8 && c <= 0x25ff) ||
	            (c >= 0x2600 && c <= 0x266e) ||
	            c === 0x266f ||
	            (c >= 0x2670 && c <= 0x2767) ||
	            c === 0x2768 ||
	            c === 0x2769 ||
	            c === 0x276a ||
	            c === 0x276b ||
	            c === 0x276c ||
	            c === 0x276d ||
	            c === 0x276e ||
	            c === 0x276f ||
	            c === 0x2770 ||
	            c === 0x2771 ||
	            c === 0x2772 ||
	            c === 0x2773 ||
	            c === 0x2774 ||
	            c === 0x2775 ||
	            (c >= 0x2794 && c <= 0x27bf) ||
	            (c >= 0x27c0 && c <= 0x27c4) ||
	            c === 0x27c5 ||
	            c === 0x27c6 ||
	            (c >= 0x27c7 && c <= 0x27e5) ||
	            c === 0x27e6 ||
	            c === 0x27e7 ||
	            c === 0x27e8 ||
	            c === 0x27e9 ||
	            c === 0x27ea ||
	            c === 0x27eb ||
	            c === 0x27ec ||
	            c === 0x27ed ||
	            c === 0x27ee ||
	            c === 0x27ef ||
	            (c >= 0x27f0 && c <= 0x27ff) ||
	            (c >= 0x2800 && c <= 0x28ff) ||
	            (c >= 0x2900 && c <= 0x2982) ||
	            c === 0x2983 ||
	            c === 0x2984 ||
	            c === 0x2985 ||
	            c === 0x2986 ||
	            c === 0x2987 ||
	            c === 0x2988 ||
	            c === 0x2989 ||
	            c === 0x298a ||
	            c === 0x298b ||
	            c === 0x298c ||
	            c === 0x298d ||
	            c === 0x298e ||
	            c === 0x298f ||
	            c === 0x2990 ||
	            c === 0x2991 ||
	            c === 0x2992 ||
	            c === 0x2993 ||
	            c === 0x2994 ||
	            c === 0x2995 ||
	            c === 0x2996 ||
	            c === 0x2997 ||
	            c === 0x2998 ||
	            (c >= 0x2999 && c <= 0x29d7) ||
	            c === 0x29d8 ||
	            c === 0x29d9 ||
	            c === 0x29da ||
	            c === 0x29db ||
	            (c >= 0x29dc && c <= 0x29fb) ||
	            c === 0x29fc ||
	            c === 0x29fd ||
	            (c >= 0x29fe && c <= 0x2aff) ||
	            (c >= 0x2b00 && c <= 0x2b2f) ||
	            (c >= 0x2b30 && c <= 0x2b44) ||
	            (c >= 0x2b45 && c <= 0x2b46) ||
	            (c >= 0x2b47 && c <= 0x2b4c) ||
	            (c >= 0x2b4d && c <= 0x2b73) ||
	            (c >= 0x2b74 && c <= 0x2b75) ||
	            (c >= 0x2b76 && c <= 0x2b95) ||
	            c === 0x2b96 ||
	            (c >= 0x2b97 && c <= 0x2bff) ||
	            (c >= 0x2e00 && c <= 0x2e01) ||
	            c === 0x2e02 ||
	            c === 0x2e03 ||
	            c === 0x2e04 ||
	            c === 0x2e05 ||
	            (c >= 0x2e06 && c <= 0x2e08) ||
	            c === 0x2e09 ||
	            c === 0x2e0a ||
	            c === 0x2e0b ||
	            c === 0x2e0c ||
	            c === 0x2e0d ||
	            (c >= 0x2e0e && c <= 0x2e16) ||
	            c === 0x2e17 ||
	            (c >= 0x2e18 && c <= 0x2e19) ||
	            c === 0x2e1a ||
	            c === 0x2e1b ||
	            c === 0x2e1c ||
	            c === 0x2e1d ||
	            (c >= 0x2e1e && c <= 0x2e1f) ||
	            c === 0x2e20 ||
	            c === 0x2e21 ||
	            c === 0x2e22 ||
	            c === 0x2e23 ||
	            c === 0x2e24 ||
	            c === 0x2e25 ||
	            c === 0x2e26 ||
	            c === 0x2e27 ||
	            c === 0x2e28 ||
	            c === 0x2e29 ||
	            (c >= 0x2e2a && c <= 0x2e2e) ||
	            c === 0x2e2f ||
	            (c >= 0x2e30 && c <= 0x2e39) ||
	            (c >= 0x2e3a && c <= 0x2e3b) ||
	            (c >= 0x2e3c && c <= 0x2e3f) ||
	            c === 0x2e40 ||
	            c === 0x2e41 ||
	            c === 0x2e42 ||
	            (c >= 0x2e43 && c <= 0x2e4f) ||
	            (c >= 0x2e50 && c <= 0x2e51) ||
	            c === 0x2e52 ||
	            (c >= 0x2e53 && c <= 0x2e7f) ||
	            (c >= 0x3001 && c <= 0x3003) ||
	            c === 0x3008 ||
	            c === 0x3009 ||
	            c === 0x300a ||
	            c === 0x300b ||
	            c === 0x300c ||
	            c === 0x300d ||
	            c === 0x300e ||
	            c === 0x300f ||
	            c === 0x3010 ||
	            c === 0x3011 ||
	            (c >= 0x3012 && c <= 0x3013) ||
	            c === 0x3014 ||
	            c === 0x3015 ||
	            c === 0x3016 ||
	            c === 0x3017 ||
	            c === 0x3018 ||
	            c === 0x3019 ||
	            c === 0x301a ||
	            c === 0x301b ||
	            c === 0x301c ||
	            c === 0x301d ||
	            (c >= 0x301e && c <= 0x301f) ||
	            c === 0x3020 ||
	            c === 0x3030 ||
	            c === 0xfd3e ||
	            c === 0xfd3f ||
	            (c >= 0xfe45 && c <= 0xfe46));
	    }

	    function pruneLocation$1(els) {
	        els.forEach(function (el) {
	            delete el.location;
	            if (isSelectElement$1(el) || isPluralElement$1(el)) {
	                for (var k in el.options) {
	                    delete el.options[k].location;
	                    pruneLocation$1(el.options[k].value);
	                }
	            }
	            else if (isNumberElement$1(el) && isNumberSkeleton$1(el.style)) {
	                delete el.style.location;
	            }
	            else if ((isDateElement$1(el) || isTimeElement$1(el)) &&
	                isDateTimeSkeleton$1(el.style)) {
	                delete el.style.location;
	            }
	            else if (isTagElement$1(el)) {
	                pruneLocation$1(el.children);
	            }
	        });
	    }
	    function parse$2(message, opts) {
	        if (opts === void 0) { opts = {}; }
	        opts = __assign$3({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
	        var result = new Parser$1(message, opts).parse();
	        if (result.err) {
	            var error = SyntaxError(ErrorKind$1[result.err.kind]);
	            // @ts-expect-error Assign to error object
	            error.location = result.err.location;
	            // @ts-expect-error Assign to error object
	            error.originalMessage = result.err.message;
	            throw error;
	        }
	        if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
	            pruneLocation$1(result.val);
	        }
	        return result.val;
	    }

	    //
	    // Main
	    //
	    function memoize$2(fn, options) {
	        var cache = options && options.cache ? options.cache : cacheDefault$1;
	        var serializer = options && options.serializer ? options.serializer : serializerDefault$1;
	        var strategy = options && options.strategy ? options.strategy : strategyDefault$1;
	        return strategy(fn, {
	            cache: cache,
	            serializer: serializer,
	        });
	    }
	    //
	    // Strategy
	    //
	    function isPrimitive$1(value) {
	        return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
	    }
	    function monadic$1(fn, cache, serializer, arg) {
	        var cacheKey = isPrimitive$1(arg) ? arg : serializer(arg);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.call(this, arg);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function variadic$1(fn, cache, serializer) {
	        var args = Array.prototype.slice.call(arguments, 3);
	        var cacheKey = serializer(args);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.apply(this, args);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function assemble$1(fn, context, strategy, cache, serialize) {
	        return strategy.bind(context, fn, cache, serialize);
	    }
	    function strategyDefault$1(fn, options) {
	        var strategy = fn.length === 1 ? monadic$1 : variadic$1;
	        return assemble$1(fn, this, strategy, options.cache.create(), options.serializer);
	    }
	    function strategyVariadic$1(fn, options) {
	        return assemble$1(fn, this, variadic$1, options.cache.create(), options.serializer);
	    }
	    function strategyMonadic$1(fn, options) {
	        return assemble$1(fn, this, monadic$1, options.cache.create(), options.serializer);
	    }
	    //
	    // Serializer
	    //
	    var serializerDefault$1 = function () {
	        return JSON.stringify(arguments);
	    };
	    //
	    // Cache
	    //
	    function ObjectWithoutPrototypeCache$1() {
	        this.cache = Object.create(null);
	    }
	    ObjectWithoutPrototypeCache$1.prototype.get = function (key) {
	        return this.cache[key];
	    };
	    ObjectWithoutPrototypeCache$1.prototype.set = function (key, value) {
	        this.cache[key] = value;
	    };
	    var cacheDefault$1 = {
	        create: function create() {
	            // @ts-ignore
	            return new ObjectWithoutPrototypeCache$1();
	        },
	    };
	    var strategies$1 = {
	        variadic: strategyVariadic$1,
	        monadic: strategyMonadic$1,
	    };

	    var ErrorCode$1;
	    (function (ErrorCode) {
	        // When we have a placeholder but no value to format
	        ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
	        // When value supplied is invalid
	        ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
	        // When we need specific Intl API but it's not available
	        ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
	    })(ErrorCode$1 || (ErrorCode$1 = {}));
	    var FormatError$1 = /** @class */ (function (_super) {
	        __extends$1(FormatError, _super);
	        function FormatError(msg, code, originalMessage) {
	            var _this = _super.call(this, msg) || this;
	            _this.code = code;
	            _this.originalMessage = originalMessage;
	            return _this;
	        }
	        FormatError.prototype.toString = function () {
	            return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
	        };
	        return FormatError;
	    }(Error));
	    var InvalidValueError$1 = /** @class */ (function (_super) {
	        __extends$1(InvalidValueError, _super);
	        function InvalidValueError(variableId, value, options, originalMessage) {
	            return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode$1.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueError;
	    }(FormatError$1));
	    var InvalidValueTypeError$1 = /** @class */ (function (_super) {
	        __extends$1(InvalidValueTypeError, _super);
	        function InvalidValueTypeError(value, type, originalMessage) {
	            return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode$1.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueTypeError;
	    }(FormatError$1));
	    var MissingValueError$1 = /** @class */ (function (_super) {
	        __extends$1(MissingValueError, _super);
	        function MissingValueError(variableId, originalMessage) {
	            return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode$1.MISSING_VALUE, originalMessage) || this;
	        }
	        return MissingValueError;
	    }(FormatError$1));

	    var PART_TYPE$1;
	    (function (PART_TYPE) {
	        PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
	        PART_TYPE[PART_TYPE["object"] = 1] = "object";
	    })(PART_TYPE$1 || (PART_TYPE$1 = {}));
	    function mergeLiteral$1(parts) {
	        if (parts.length < 2) {
	            return parts;
	        }
	        return parts.reduce(function (all, part) {
	            var lastPart = all[all.length - 1];
	            if (!lastPart ||
	                lastPart.type !== PART_TYPE$1.literal ||
	                part.type !== PART_TYPE$1.literal) {
	                all.push(part);
	            }
	            else {
	                lastPart.value += part.value;
	            }
	            return all;
	        }, []);
	    }
	    function isFormatXMLElementFn$1(el) {
	        return typeof el === 'function';
	    }
	    // TODO(skeleton): add skeleton support
	    function formatToParts$1(els, locales, formatters, formats, values, currentPluralValue, 
	    // For debugging
	    originalMessage) {
	        // Hot path for straight simple msg translations
	        if (els.length === 1 && isLiteralElement$1(els[0])) {
	            return [
	                {
	                    type: PART_TYPE$1.literal,
	                    value: els[0].value,
	                },
	            ];
	        }
	        var result = [];
	        for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	            var el = els_1[_i];
	            // Exit early for string parts.
	            if (isLiteralElement$1(el)) {
	                result.push({
	                    type: PART_TYPE$1.literal,
	                    value: el.value,
	                });
	                continue;
	            }
	            // TODO: should this part be literal type?
	            // Replace `#` in plural rules with the actual numeric value.
	            if (isPoundElement$1(el)) {
	                if (typeof currentPluralValue === 'number') {
	                    result.push({
	                        type: PART_TYPE$1.literal,
	                        value: formatters.getNumberFormat(locales).format(currentPluralValue),
	                    });
	                }
	                continue;
	            }
	            var varName = el.value;
	            // Enforce that all required values are provided by the caller.
	            if (!(values && varName in values)) {
	                throw new MissingValueError$1(varName, originalMessage);
	            }
	            var value = values[varName];
	            if (isArgumentElement$1(el)) {
	                if (!value || typeof value === 'string' || typeof value === 'number') {
	                    value =
	                        typeof value === 'string' || typeof value === 'number'
	                            ? String(value)
	                            : '';
	                }
	                result.push({
	                    type: typeof value === 'string' ? PART_TYPE$1.literal : PART_TYPE$1.object,
	                    value: value,
	                });
	                continue;
	            }
	            // Recursively format plural and select parts' option — which can be a
	            // nested pattern structure. The choosing of the option to use is
	            // abstracted-by and delegated-to the part helper object.
	            if (isDateElement$1(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.date[el.style]
	                    : isDateTimeSkeleton$1(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                result.push({
	                    type: PART_TYPE$1.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTimeElement$1(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.time[el.style]
	                    : isDateTimeSkeleton$1(el.style)
	                        ? el.style.parsedOptions
	                        : formats.time.medium;
	                result.push({
	                    type: PART_TYPE$1.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isNumberElement$1(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.number[el.style]
	                    : isNumberSkeleton$1(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                if (style && style.scale) {
	                    value =
	                        value *
	                            (style.scale || 1);
	                }
	                result.push({
	                    type: PART_TYPE$1.literal,
	                    value: formatters
	                        .getNumberFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTagElement$1(el)) {
	                var children = el.children, value_1 = el.value;
	                var formatFn = values[value_1];
	                if (!isFormatXMLElementFn$1(formatFn)) {
	                    throw new InvalidValueTypeError$1(value_1, 'function', originalMessage);
	                }
	                var parts = formatToParts$1(children, locales, formatters, formats, values, currentPluralValue);
	                var chunks = formatFn(parts.map(function (p) { return p.value; }));
	                if (!Array.isArray(chunks)) {
	                    chunks = [chunks];
	                }
	                result.push.apply(result, chunks.map(function (c) {
	                    return {
	                        type: typeof c === 'string' ? PART_TYPE$1.literal : PART_TYPE$1.object,
	                        value: c,
	                    };
	                }));
	            }
	            if (isSelectElement$1(el)) {
	                var opt = el.options[value] || el.options.other;
	                if (!opt) {
	                    throw new InvalidValueError$1(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts$1(opt.value, locales, formatters, formats, values));
	                continue;
	            }
	            if (isPluralElement$1(el)) {
	                var opt = el.options["=".concat(value)];
	                if (!opt) {
	                    if (!Intl.PluralRules) {
	                        throw new FormatError$1("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode$1.MISSING_INTL_API, originalMessage);
	                    }
	                    var rule = formatters
	                        .getPluralRules(locales, { type: el.pluralType })
	                        .select(value - (el.offset || 0));
	                    opt = el.options[rule] || el.options.other;
	                }
	                if (!opt) {
	                    throw new InvalidValueError$1(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts$1(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
	                continue;
	            }
	        }
	        return mergeLiteral$1(result);
	    }

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    // -- MessageFormat --------------------------------------------------------
	    function mergeConfig$1(c1, c2) {
	        if (!c2) {
	            return c1;
	        }
	        return __assign$3(__assign$3(__assign$3({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
	            all[k] = __assign$3(__assign$3({}, c1[k]), (c2[k] || {}));
	            return all;
	        }, {}));
	    }
	    function mergeConfigs$1(defaultConfig, configs) {
	        if (!configs) {
	            return defaultConfig;
	        }
	        return Object.keys(defaultConfig).reduce(function (all, k) {
	            all[k] = mergeConfig$1(defaultConfig[k], configs[k]);
	            return all;
	        }, __assign$3({}, defaultConfig));
	    }
	    function createFastMemoizeCache$1(store) {
	        return {
	            create: function () {
	                return {
	                    get: function (key) {
	                        return store[key];
	                    },
	                    set: function (key, value) {
	                        store[key] = value;
	                    },
	                };
	            },
	        };
	    }
	    function createDefaultFormatters$1(cache) {
	        if (cache === void 0) { cache = {
	            number: {},
	            dateTime: {},
	            pluralRules: {},
	        }; }
	        return {
	            getNumberFormat: memoize$2(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray$1([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache$1(cache.number),
	                strategy: strategies$1.variadic,
	            }),
	            getDateTimeFormat: memoize$2(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray$1([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache$1(cache.dateTime),
	                strategy: strategies$1.variadic,
	            }),
	            getPluralRules: memoize$2(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray$1([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache$1(cache.pluralRules),
	                strategy: strategies$1.variadic,
	            }),
	        };
	    }
	    var IntlMessageFormat$1 = /** @class */ (function () {
	        function IntlMessageFormat(message, locales, overrideFormats, opts) {
	            var _this = this;
	            if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
	            this.formatterCache = {
	                number: {},
	                dateTime: {},
	                pluralRules: {},
	            };
	            this.format = function (values) {
	                var parts = _this.formatToParts(values);
	                // Hot path for straight simple msg translations
	                if (parts.length === 1) {
	                    return parts[0].value;
	                }
	                var result = parts.reduce(function (all, part) {
	                    if (!all.length ||
	                        part.type !== PART_TYPE$1.literal ||
	                        typeof all[all.length - 1] !== 'string') {
	                        all.push(part.value);
	                    }
	                    else {
	                        all[all.length - 1] += part.value;
	                    }
	                    return all;
	                }, []);
	                if (result.length <= 1) {
	                    return result[0] || '';
	                }
	                return result;
	            };
	            this.formatToParts = function (values) {
	                return formatToParts$1(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
	            };
	            this.resolvedOptions = function () { return ({
	                locale: _this.resolvedLocale.toString(),
	            }); };
	            this.getAst = function () { return _this.ast; };
	            // Defined first because it's used to build the format pattern.
	            this.locales = locales;
	            this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
	            if (typeof message === 'string') {
	                this.message = message;
	                if (!IntlMessageFormat.__parse) {
	                    throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
	                }
	                // Parse string messages into an AST.
	                this.ast = IntlMessageFormat.__parse(message, {
	                    ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
	                    locale: this.resolvedLocale,
	                });
	            }
	            else {
	                this.ast = message;
	            }
	            if (!Array.isArray(this.ast)) {
	                throw new TypeError('A message must be provided as a String or AST.');
	            }
	            // Creates a new object with the specified `formats` merged with the default
	            // formats.
	            this.formats = mergeConfigs$1(IntlMessageFormat.formats, overrideFormats);
	            this.formatters =
	                (opts && opts.formatters) || createDefaultFormatters$1(this.formatterCache);
	        }
	        Object.defineProperty(IntlMessageFormat, "defaultLocale", {
	            get: function () {
	                if (!IntlMessageFormat.memoizedDefaultLocale) {
	                    IntlMessageFormat.memoizedDefaultLocale =
	                        new Intl.NumberFormat().resolvedOptions().locale;
	                }
	                return IntlMessageFormat.memoizedDefaultLocale;
	            },
	            enumerable: false,
	            configurable: true
	        });
	        IntlMessageFormat.memoizedDefaultLocale = null;
	        IntlMessageFormat.resolveLocale = function (locales) {
	            var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
	            if (supportedLocales.length > 0) {
	                return new Intl.Locale(supportedLocales[0]);
	            }
	            return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
	        };
	        IntlMessageFormat.__parse = parse$2;
	        // Default format options used as the prototype of the `formats` provided to the
	        // constructor. These are used when constructing the internal Intl.NumberFormat
	        // and Intl.DateTimeFormat instances.
	        IntlMessageFormat.formats = {
	            number: {
	                integer: {
	                    maximumFractionDigits: 0,
	                },
	                currency: {
	                    style: 'currency',
	                },
	                percent: {
	                    style: 'percent',
	                },
	            },
	            date: {
	                short: {
	                    month: 'numeric',
	                    day: 'numeric',
	                    year: '2-digit',
	                },
	                medium: {
	                    month: 'short',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                long: {
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                full: {
	                    weekday: 'long',
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	            },
	            time: {
	                short: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                },
	                medium: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                },
	                long: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	                full: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	            },
	        };
	        return IntlMessageFormat;
	    }());

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    var o$1 = IntlMessageFormat$1;

	    const r$1={},i$1=(e,n,t)=>t?(n in r$1||(r$1[n]={}),e in r$1[n]||(r$1[n][e]=t),t):t,a$1=(e,n)=>{if(null==n)return;if(n in r$1&&e in r$1[n])return r$1[n][e];const t=E$1(n);for(let o=0;o<t.length;o++){const r=c$1(t[o],e);if(r)return i$1(e,n,r)}};let l$1;const s$1=writable$1({});function u$1(e){return e in l$1}function c$1(e,n){if(!u$1(e))return null;return function(e,n){if(n in e)return e[n];const t=n.split(".");let o=e;for(let e=0;e<t.length;e++)if("object"==typeof o){if(e>0){const n=t.slice(e,t.length).join(".");if(n in o){o=o[n];break}}o=o[t[e]];}else o=void 0;return o}(function(e){return l$1[e]||null}(e),n)}function m$1(e,...n){delete r$1[e],s$1.update((o=>(o[e]=cjs$1.all([o[e]||{},...n]),o)));}derived$1([s$1],(([e])=>Object.keys(e)));s$1.subscribe((e=>l$1=e));const d$1={};function g$1(e){return d$1[e]}function w$1(e){return E$1(e).some((e=>{var n;return null===(n=g$1(e))||void 0===n?void 0:n.size}))}function h$1(e,n){return Promise.all(n.map((n=>(function(e,n){d$1[e].delete(n),0===d$1[e].size&&delete d$1[e];}(e,n),n().then((e=>e.default||e)))))).then((n=>m$1(e,...n)))}const p$1={};function b$1(e){if(!w$1(e))return e in p$1?p$1[e]:void 0;const n=function(e){return E$1(e).map((e=>{const n=g$1(e);return [e,n?[...n]:[]]})).filter((([,e])=>e.length>0))}(e);return p$1[e]=Promise.all(n.map((([e,n])=>h$1(e,n)))).then((()=>{if(w$1(e))return b$1(e);delete p$1[e];})),p$1[e]}/*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */function v$1(e,n){var t={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&n.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)n.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(t[o[r]]=e[o[r]]);}return t}const O$1={fallbackLocale:null,initialLocale:null,loadingDelay:200,formats:{number:{scientific:{notation:"scientific"},engineering:{notation:"engineering"},compactLong:{notation:"compact",compactDisplay:"long"},compactShort:{notation:"compact",compactDisplay:"short"}},date:{short:{month:"numeric",day:"numeric",year:"2-digit"},medium:{month:"short",day:"numeric",year:"numeric"},long:{month:"long",day:"numeric",year:"numeric"},full:{weekday:"long",month:"long",day:"numeric",year:"numeric"}},time:{short:{hour:"numeric",minute:"numeric"},medium:{hour:"numeric",minute:"numeric",second:"numeric"},long:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"},full:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"}}},warnOnMissingMessages:!0,ignoreTag:!0};function j$1(){return O$1}function $$1(e){const{formats:n}=e,t=v$1(e,["formats"]),o=e.initialLocale||e.fallbackLocale;return Object.assign(O$1,t,{initialLocale:o}),n&&("number"in n&&Object.assign(O$1.formats.number,n.number),"date"in n&&Object.assign(O$1.formats.date,n.date),"time"in n&&Object.assign(O$1.formats.time,n.time)),T$1.set(o)}const k$1=writable$1(!1);let L$1;const T$1=writable$1(null);function x$1(e){return e.split("-").map(((e,n,t)=>t.slice(0,n+1).join("-"))).reverse()}function E$1(e,n=j$1().fallbackLocale){const t=x$1(e);return n?[...new Set([...t,...x$1(n)])]:t}function D$1(){return L$1}T$1.subscribe((e=>{L$1=e,"undefined"!=typeof window&&null!==e&&document.documentElement.setAttribute("lang",e);}));const M$1=T$1.set;T$1.set=e=>{if(function(e){if(null==e)return;const n=E$1(e);for(let e=0;e<n.length;e++){const t=n[e];if(u$1(t))return t}}(e)&&w$1(e)){const{loadingDelay:n}=j$1();let t;return "undefined"!=typeof window&&null!=D$1()&&n?t=window.setTimeout((()=>k$1.set(!0)),n):k$1.set(!0),b$1(e).then((()=>{M$1(e);})).finally((()=>{clearTimeout(t),k$1.set(!1);}))}return M$1(e)},T$1.update=e=>M$1(e(L$1));const Z$1=e=>{const n=Object.create(null);return t=>{const o=JSON.stringify(t);return o in n?n[o]:n[o]=e(t)}},C$1=(e,n)=>{const{formats:t}=j$1();if(e in t&&n in t[e])return t[e][n];throw new Error(`[svelte-i18n] Unknown "${n}" ${e} format.`)},G$1=Z$1((e=>{var{locale:n,format:t}=e,o=v$1(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format numbers');return t&&(o=C$1("number",t)),new Intl.NumberFormat(n,o)})),J$1=Z$1((e=>{var{locale:n,format:t}=e,o=v$1(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format dates');return t?o=C$1("date",t):0===Object.keys(o).length&&(o=C$1("date","short")),new Intl.DateTimeFormat(n,o)})),U$1=Z$1((e=>{var{locale:n,format:t}=e,o=v$1(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format time values');return t?o=C$1("time",t):0===Object.keys(o).length&&(o=C$1("time","short")),new Intl.DateTimeFormat(n,o)})),_$1=(e={})=>{var{locale:n=D$1()}=e,t=v$1(e,["locale"]);return G$1(Object.assign({locale:n},t))},q$1=(e={})=>{var{locale:n=D$1()}=e,t=v$1(e,["locale"]);return J$1(Object.assign({locale:n},t))},B$1=(e={})=>{var{locale:n=D$1()}=e,t=v$1(e,["locale"]);return U$1(Object.assign({locale:n},t))},H$1=Z$1(((e,n=D$1())=>new o$1(e,n,j$1().formats,{ignoreTag:j$1().ignoreTag}))),K$1=(e,n={})=>{"object"==typeof e&&(e=(n=e).id);const{values:t,locale:o=D$1(),default:r}=n;if(null==o)throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");let i=a$1(e,o);if(i){if("string"!=typeof i)return console.warn(`[svelte-i18n] Message with id "${e}" must be of type "string", found: "${typeof i}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`),i}else j$1().warnOnMissingMessages&&console.warn(`[svelte-i18n] The message "${e}" was not found in "${E$1(o).join('", "')}".${w$1(D$1())?"\n\nNote: there are at least one loader still registered to this locale that wasn't executed.":""}`),i=r||e;if(!t)return i;let l=i;try{l=H$1(i,o).format(t);}catch(n){console.warn(`[svelte-i18n] Message "${e}" has syntax error:`,n.message);}return l},Q$1=(e,n)=>B$1(n).format(e),R$1=(e,n)=>q$1(n).format(e),V$1=(e,n)=>_$1(n).format(e),W$1=(e,n=D$1())=>a$1(e,n),X$1=derived$1([T$1,s$1],(()=>K$1));derived$1([T$1],(()=>Q$1));derived$1([T$1],(()=>R$1));derived$1([T$1],(()=>V$1));derived$1([T$1,s$1],(()=>W$1));

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var de$1 = {
	      quickFilter: "Schnellfilter...",
	      noItems: "Keine Elemente",
	      item: "Artikel",
	      items: "Artikel",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} von {1} {2}",
	      containsFilter: "Enthält {0}",
	      notContainsFilter: "Enthält nicht {0}",
	      equalsFilter: "Ist gleich {0}",
	      notEqualFilter: "Ist nicht gleich {0}",
	      startsWithFilter: "Beginnt mit {0}",
	      endsWithFilter: "Endet mit {0}",
	      lessThanFilter: "Kleiner als {0}",
	      lessThanOrEqualFilter: "Kleiner oder gleich {0}",
	      greaterThanFilter: "Größer als {0}",
	      greaterThanOrEqualFilter: "Größer als oder gleich {0}",
	      beforeFilter: "Vor {0}",
	      beforeOrSameFilter: "Vor oder gleich {0}",
	      afterFilter: "Nach {0}",
	      afterOrSameFilter: "Nach oder gleich {0}",
	      inRangeFilter: "m Bereich {0} - {1}",
	      isEmptyFilter: "Ist leer",
	      isNotEmptyFilter: "Ist nicht leer",
	      orFilter: "{0} ODER {1}",
	      andFilter: "{0} UND {1}",
	      Boolean_NoFilter: "Alle",
	      BooleanYes: "Ja",
	      BooleanNo: "Nein",
	      BooleanEnabled: "Aktiviert",
	      BooleanDisabled: "Deaktiviert",
	      BooleanTrue: "Wahr",
	      BooleanFalse: "Falsch",
	      BooleanLocked: "Gesperrt",
	      BooleanUnlocked: "Freigegeben",
	      BooleanActive: "Aktiv",
	      BooleanInactive: "Inaktiv",
	      BooleanOk: "OK",
	      BooleanError: "Fehler",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "Gleich",
	      Operator_NotEqual: "Ist nicht gleich",
	      Operator_LessThan: "Kleiner als",
	      Operator_LessOrEqual: "Kleiner als oder gleich",
	      Operator_GreaterThan: "Größer als",
	      Operator_GreaterOrEqual: "Größer als oder gleich",
	      Operator_Before: "Vor",
	      Operator_BeforeOrSame: "Vor oder gleich",
	      Operator_After: "Nach",
	      Operator_AfterOrSame: "Nach oder gleich",
	      Operator_BetweenExclusive: "Zwischen (exklusive)",
	      Operator_BetweenInclusive: "Zwischen (inklusive)",
	      Operator_Contains: "Enthält",
	      Operator_NotContains: "Enthält nicht",
	      Operator_StartsWith: "Beginnt mit",
	      Operator_EndsWith: "Endet mit",
	      Operator_IsEmpty: "Ist leer",
	      Operator_IsNotEmpty: "Ist nicht leer",
	      Operator_OR: "ODER",
	      Operator_AND: "UND",
	      Settings_Tooltip: "Einstellungen auflisten",
	      Menu_Columns: "Spalten...",
	      Menu_Reset: "Rücksetzen",
	      Menu_Export: "Exportieren",
	      Columns_Dialog_Title: "Anzuzeigende Spalten",
	      Duration_Years_Full: "Jahre",
	      Duration_Years_Medium: "J",
	      Duration_Years_Short: "J",
	      Duration_Days_Full: "Tage",
	      Duration_Days_Medium: "Tage",
	      Duration_Days_Short: "t",
	      Duration_Hours_Full: "Stunden",
	      Duration_Hours_Medium: "Std.",
	      Duration_Hours_Short: "h",
	      Duration_Minutes_Full: "Minuten",
	      Duration_Minutes_Medium: "Min",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "Sekunden",
	      Duration_Seconds_Medium: "Sek",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "Millisekunden",
	      Duration_Millis_Medium: "Millis",
	      Duration_Millis_Short: "ms",
	      SelectAll: "Alle auswählen",
	      SelectNone: "Alles löschen",
	      Action: "(Aktion) {0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var en$2 = {
	      quickFilter: "Quick filter...",
	      noItems: "No Items",
	      item: "Item",
	      items: "Items",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} of {1} {2}",
	      containsFilter: "Contains {0}",
	      notContainsFilter: "Does not contain {0}",
	      equalsFilter: "Equals {0}",
	      notEqualFilter: "Does not equal {0}",
	      startsWithFilter: "Starts with {0}",
	      endsWithFilter: "Ends with {0}",
	      lessThanFilter: "Less than {0}",
	      lessThanOrEqualFilter: "Less than or equal {0}",
	      greaterThanFilter: "Greater than {0}",
	      greaterThanOrEqualFilter: "Greater than or equal {0}",
	      beforeFilter: "Before {0}",
	      beforeOrSameFilter: "Before or same {0}",
	      afterFilter: "After {0}",
	      afterOrSameFilter: "After or same {0}",
	      inRangeFilter: "In range {0} - {1}",
	      isEmptyFilter: "Is empty",
	      isNotEmptyFilter: "Is not empty",
	      orFilter: "{0} OR {1}",
	      andFilter: "{0} AND {1}",
	      Boolean_NoFilter: "All",
	      BooleanYes: "Yes",
	      BooleanNo: "No",
	      BooleanEnabled: "Enabled",
	      BooleanDisabled: "Disabled",
	      BooleanTrue: "True",
	      BooleanFalse: "False",
	      BooleanLocked: "Locked",
	      BooleanUnlocked: "Unlocked",
	      BooleanActive: "Active",
	      BooleanInactive: "Inactive",
	      BooleanOk: "Ok",
	      BooleanError: "Error",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "Equals",
	      Operator_NotEqual: "Does not equal",
	      Operator_LessThan: "Less than",
	      Operator_LessOrEqual: "Less than or equal",
	      Operator_GreaterThan: "Greater than",
	      Operator_GreaterOrEqual: "Greater than or equal",
	      Operator_Before: "Before",
	      Operator_BeforeOrSame: "Before or same",
	      Operator_After: "After",
	      Operator_AfterOrSame: "After or same",
	      Operator_BetweenExclusive: "Between (exclusive)",
	      Operator_BetweenInclusive: "Between (inclusive)",
	      Operator_Contains: "Contains",
	      Operator_NotContains: "Does not contain",
	      Operator_StartsWith: "Starts with",
	      Operator_EndsWith: "Ends with",
	      Operator_IsEmpty: "Is empty",
	      Operator_IsNotEmpty: "Is not empty",
	      Operator_OR: "OR",
	      Operator_AND: "AND",
	      Settings_Tooltip: "List Settings",
	      Menu_Columns: "Columns...",
	      Menu_Reset: "Reset",
	      Menu_Export: "Export",
	      Columns_Dialog_Title: "Columns To Show",
	      Duration_Years_Full: "Years",
	      Duration_Years_Medium: "Yrs",
	      Duration_Years_Short: "y",
	      Duration_Days_Full: "Days",
	      Duration_Days_Medium: "Days",
	      Duration_Days_Short: "d",
	      Duration_Hours_Full: "Hours",
	      Duration_Hours_Medium: "Hrs",
	      Duration_Hours_Short: "h",
	      Duration_Minutes_Full: "Minutes",
	      Duration_Minutes_Medium: "Mins",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "Seconds",
	      Duration_Seconds_Medium: "Secs",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "Milliseconds",
	      Duration_Millis_Medium: "Millis",
	      Duration_Millis_Short: "ms",
	      SelectAll: "Select All",
	      SelectNone: "Clear All",
	      Action: "(Action) {0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var es$1 = {
	      quickFilter: "Filtro rápido...",
	      noItems: "Sin elementos",
	      item: "Artículo",
	      items: "Elementos",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} de {1} {2}",
	      containsFilter: "Contiene {0}",
	      notContainsFilter: "No contiene {0}",
	      equalsFilter: "Es igual a {0}",
	      notEqualFilter: "No es igual a {0}",
	      startsWithFilter: "Empieza con {0}",
	      endsWithFilter: "Termina en {0}",
	      lessThanFilter: "Menor de {0}",
	      lessThanOrEqualFilter: "Menor o igual a {0}",
	      greaterThanFilter: "Mayor de {0}",
	      greaterThanOrEqualFilter: "Mayor o igual de {0}",
	      beforeFilter: "Antes {0}",
	      beforeOrSameFilter: "Antes o el mismo {0}",
	      afterFilter: "Después {0}",
	      afterOrSameFilter: "Después o el mismo {0}",
	      inRangeFilter: "En el rango {0} - {1}",
	      isEmptyFilter: "Está vacío",
	      isNotEmptyFilter: "No está vacío",
	      orFilter: "{0} O {1}",
	      andFilter: "{0} Y {1}",
	      Boolean_NoFilter: "Todo",
	      BooleanYes: "Sí",
	      BooleanNo: "No",
	      BooleanEnabled: "Habilitado",
	      BooleanDisabled: "Deshabilitado",
	      BooleanTrue: "Verdadero",
	      BooleanFalse: "Falso",
	      BooleanLocked: "Bloqueado",
	      BooleanUnlocked: "Desbloqueado",
	      BooleanActive: "Activo",
	      BooleanInactive: "Inactivo",
	      BooleanOk: "Aceptar",
	      BooleanError: "Error",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "Es igual a",
	      Operator_NotEqual: "No es igual a",
	      Operator_LessThan: "Es menor que",
	      Operator_LessOrEqual: "Es menor o igual que",
	      Operator_GreaterThan: "Es mayor que",
	      Operator_GreaterOrEqual: "Es mayor o igual que",
	      Operator_Before: "Antes",
	      Operator_BeforeOrSame: "Antes o el mismo",
	      Operator_After: "Después",
	      Operator_AfterOrSame: "Después o el mismo",
	      Operator_BetweenExclusive: "Entre (exclusivo)",
	      Operator_BetweenInclusive: "Entre (inclusivo)",
	      Operator_Contains: "Contiene",
	      Operator_NotContains: "No contiene",
	      Operator_StartsWith: "Empieza con",
	      Operator_EndsWith: "Termina en",
	      Operator_IsEmpty: "Está vacío",
	      Operator_IsNotEmpty: "No está vacío",
	      Operator_OR: "O",
	      Operator_AND: "Y",
	      Settings_Tooltip: "Ajustes de lista",
	      Menu_Columns: "Columnas…",
	      Menu_Reset: "Restablecer",
	      Menu_Export: "Exportar",
	      Columns_Dialog_Title: "Columnas para mostrar",
	      Duration_Years_Full: "Años",
	      Duration_Years_Medium: "Añs",
	      Duration_Years_Short: "a",
	      Duration_Days_Full: "Días",
	      Duration_Days_Medium: "Días",
	      Duration_Days_Short: "d",
	      Duration_Hours_Full: "Horas",
	      Duration_Hours_Medium: "h",
	      Duration_Hours_Short: "h",
	      Duration_Minutes_Full: "Minutos",
	      Duration_Minutes_Medium: "Min",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "Segundos",
	      Duration_Seconds_Medium: "Seg",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "Milisegundos",
	      Duration_Millis_Medium: "milis",
	      Duration_Millis_Short: "ms",
	      SelectAll: "Seleccionar todos",
	      SelectNone: "Borrar todo",
	      Action: "(Acción) {0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var fr$1 = {
	      quickFilter: "Filtro rapido...",
	      noItems: "Nessun elemento",
	      item: "Elemento",
	      items: "Elementi",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} di {1} {2}",
	      containsFilter: "Contiene {0}",
	      notContainsFilter: "Non contiene {0}",
	      equalsFilter: "Uguale a {0}",
	      notEqualFilter: "Non uguale a {0}",
	      startsWithFilter: "Inizia con {0}",
	      endsWithFilter: "Finisce con {0}",
	      lessThanFilter: "Minore di {0}",
	      lessThanOrEqualFilter: "Minore o uguale a {0}",
	      greaterThanFilter: "Maggiore di  {0}",
	      greaterThanOrEqualFilter: "Maggiore o uguale a {0}",
	      beforeFilter: "Prima di {0}",
	      beforeOrSameFilter: "Prima di o uguale a {0}",
	      afterFilter: "Dopo {0}",
	      afterOrSameFilter: "Dopo o uguale a {0}",
	      inRangeFilter: "Nell'intervallo {0} - {1}",
	      isEmptyFilter: "È vuoto",
	      isNotEmptyFilter: "Non è vuoto",
	      orFilter: "{0} O {1}",
	      andFilter: "{0} E {1}",
	      Boolean_NoFilter: "Tutti",
	      BooleanYes: "Sì",
	      BooleanNo: "No",
	      BooleanEnabled: "Abilitato",
	      BooleanDisabled: "Disabilitato",
	      BooleanTrue: "Vero",
	      BooleanFalse: "Falso",
	      BooleanLocked: "Bloccato",
	      BooleanUnlocked: "Sbloccato",
	      BooleanActive: "Attivo",
	      BooleanInactive: "Inattivo",
	      BooleanOk: "OK",
	      BooleanError: "Errore",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "Uguale a",
	      Operator_NotEqual: "Non uguale a",
	      Operator_LessThan: "Minore di",
	      Operator_LessOrEqual: "Minore o uguale",
	      Operator_GreaterThan: "Maggiore di",
	      Operator_GreaterOrEqual: "Maggiore o uguale",
	      Operator_Before: "Prima",
	      Operator_BeforeOrSame: "Prima di o uguale a",
	      Operator_After: "Dopo",
	      Operator_AfterOrSame: "Dopo o uguale a",
	      Operator_BetweenExclusive: "Tra (non compreso)",
	      Operator_BetweenInclusive: "Tra (compreso)",
	      Operator_Contains: "Contiene",
	      Operator_NotContains: "Non contiene",
	      Operator_StartsWith: "Inizia con",
	      Operator_EndsWith: "Finisce con",
	      Operator_IsEmpty: "È vuoto",
	      Operator_IsNotEmpty: "Non è vuoto",
	      Operator_OR: "O",
	      Operator_AND: "E",
	      Settings_Tooltip: "Elenca impostazioni",
	      Menu_Columns: "Colonne...",
	      Menu_Reset: "Reimposta",
	      Menu_Export: "Esporta",
	      Columns_Dialog_Title: "Colonne da visualizzare",
	      Duration_Years_Full: "Anni",
	      Duration_Years_Medium: "Anni",
	      Duration_Years_Short: "a",
	      Duration_Days_Full: "Giorni",
	      Duration_Days_Medium: "Giorni",
	      Duration_Days_Short: "g",
	      Duration_Hours_Full: "Ore",
	      Duration_Hours_Medium: "Ore",
	      Duration_Hours_Short: "h",
	      Duration_Minutes_Full: "Minuti",
	      Duration_Minutes_Medium: "Min",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "Secondi",
	      Duration_Seconds_Medium: "Sec",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "Millisecondi",
	      Duration_Millis_Medium: "Millisec",
	      Duration_Millis_Short: "ms",
	      SelectAll: "Seleziona tutto",
	      SelectNone: "Cancella tutto",
	      Action: "(Azione) {0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var it$1 = {
	      noItems: "Nessun elemento",
	      item: "Elemento",
	      items: "Elementi",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} di {1} {2}",
	      containsFilter: "Contiene {0}",
	      notContainsFilter: "Non contiene {0}",
	      equalsFilter: "È uguale a {0}",
	      notEqualFilter: "Non è uguale a {0}",
	      startsWithFilter: "Inizia per {0}",
	      endsWithFilter: "Finisce per {0}",
	      lessThanFilter: "Inferiore di {0}",
	      lessThanOrEqualFilter: "Inferiore o pari a {0}",
	      greaterThanFilter: "Maggiore di {0}",
	      greaterThanOrEqualFilter: "Maggiore di o pari a {0}",
	      beforeFilter: "Precedente a {0}",
	      beforeOrSameFilter: "Precedente o uguale a {0}",
	      afterFilter: "Successivo a {0}",
	      afterOrSameFilter: "Successivo o uguale a {0}",
	      inRangeFilter: "Nell'intervallo da {0} a {1}",
	      orFilter: "{0} OR {1}",
	      andFilter: "{0} AND {1}",
	      Boolean_NoFilter: "Tutti",
	      BooleanYes: "Sì",
	      BooleanNo: "No",
	      BooleanEnabled: "Abilitato",
	      BooleanDisabled: "Disabilitato",
	      BooleanTrue: "Vero",
	      BooleanFalse: "Falso",
	      BooleanLocked: "Bloccato",
	      BooleanUnlocked: "Sbloccato",
	      BooleanActive: "Attivo",
	      BooleanInactive: "Inattivo",
	      BooleanOk: "OK",
	      BooleanError: "Errore",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "Uguale a",
	      Operator_NotEqual: "Non è uguale",
	      Operator_LessThan: "Minore di",
	      Operator_LessOrEqual: "Minore o uguale",
	      Operator_GreaterThan: "Maggiore di",
	      Operator_GreaterOrEqual: "Maggiore o uguale",
	      Operator_Before: "Precedente",
	      Operator_BeforeOrSame: "Precedente o uguale",
	      Operator_After: "Successivo o uguale",
	      Operator_AfterOrSame: "Successivo o uguale",
	      Operator_BetweenExclusive: "Tra  (esclusivo)",
	      Operator_BetweenInclusive: "Tra (inclusivo)",
	      Operator_Contains: "Contiene",
	      Operator_NotContains: "Non contiene",
	      Operator_StartsWith: "Inizia con",
	      Operator_EndsWith: "Finisce con",
	      Operator_OR: "OR",
	      Operator_AND: "AND",
	      Menu_Columns: "Colonne...",
	      Menu_Reset: "Reimposta",
	      Menu_Export: "Esporta",
	      Columns_Dialog_Title: "Colonne da mostrare",
	      Duration_Years_Full: "Anni",
	      Duration_Years_Medium: "A.",
	      Duration_Years_Short: "a",
	      Duration_Days_Full: "Giorni",
	      Duration_Days_Medium: "Giorni",
	      Duration_Days_Short: "g",
	      Duration_Hours_Full: "Ore",
	      Duration_Hours_Medium: "Ore",
	      Duration_Hours_Short: "h",
	      Duration_Minutes_Full: "Minuti",
	      Duration_Minutes_Medium: "Min",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "Secondi",
	      Duration_Seconds_Medium: "Sec",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "Millisecondi",
	      Duration_Millis_Medium: "Millis.",
	      Duration_Millis_Short: "ms"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var ja$1 = {
	      quickFilter: "クイックフィルター...",
	      noItems: "アイテムがありません",
	      item: "アイテム",
	      items: "アイテム",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} / {1} {2}",
	      containsFilter: "{0}を含む",
	      notContainsFilter: "{0}を含まない",
	      equalsFilter: "{0}に等しい",
	      notEqualFilter: "{0}に等しくない",
	      startsWithFilter: "{0}で始まる",
	      endsWithFilter: "{0}で終わる",
	      lessThanFilter: "{0}より小さい",
	      lessThanOrEqualFilter: "{0}以下である",
	      greaterThanFilter: "{0}より大きい",
	      greaterThanOrEqualFilter: "{0}以上である",
	      beforeFilter: "{0}の前",
	      beforeOrSameFilter: "{0}の前または同じ",
	      afterFilter: "{0}の後",
	      afterOrSameFilter: "{0}の後または同じ",
	      inRangeFilter: "{0}～{1}の範囲内",
	      isEmptyFilter: "空である",
	      isNotEmptyFilter: "空ではない",
	      orFilter: "{0}または{1}",
	      andFilter: "{0}および{1}",
	      Boolean_NoFilter: "すべて",
	      BooleanYes: "はい",
	      BooleanNo: "いいえ",
	      BooleanEnabled: "有効",
	      BooleanDisabled: "無効",
	      BooleanTrue: "True",
	      BooleanFalse: "False",
	      BooleanLocked: "ロック済み",
	      BooleanUnlocked: "ロック解除済み",
	      BooleanActive: "アクティブ",
	      BooleanInactive: "非アクティブ",
	      BooleanOk: "OK",
	      BooleanError: "エラー",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "次の値に等しい",
	      Operator_NotEqual: "次の値に等しくない",
	      Operator_LessThan: "次の値より小さい",
	      Operator_LessOrEqual: "次の値以下である",
	      Operator_GreaterThan: "次の値より大きい",
	      Operator_GreaterOrEqual: "次の値以上である",
	      Operator_Before: "次の値の前",
	      Operator_BeforeOrSame: "次の値の前または同じ",
	      Operator_After: "次の値の後",
	      Operator_AfterOrSame: "次の値の後または同じ",
	      Operator_BetweenExclusive: "間（除外）",
	      Operator_BetweenInclusive: "間（含む）",
	      Operator_Contains: "次の値を含む",
	      Operator_NotContains: "次の値を含まない",
	      Operator_StartsWith: "次の値で始まる",
	      Operator_EndsWith: "次の値で終わる",
	      Operator_IsEmpty: "空である",
	      Operator_IsNotEmpty: "空ではない",
	      Operator_OR: "または",
	      Operator_AND: "および",
	      Settings_Tooltip: "リストの設定",
	      Menu_Columns: "列...",
	      Menu_Reset: "リセット",
	      Menu_Export: "エクスポート",
	      Columns_Dialog_Title: "表示する列",
	      Duration_Years_Full: "年",
	      Duration_Years_Medium: "年",
	      Duration_Years_Short: "年",
	      Duration_Days_Full: "日",
	      Duration_Days_Medium: "日",
	      Duration_Days_Short: "日",
	      Duration_Hours_Full: "時間",
	      Duration_Hours_Medium: "時間",
	      Duration_Hours_Short: "時",
	      Duration_Minutes_Full: "分",
	      Duration_Minutes_Medium: "分",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "秒",
	      Duration_Seconds_Medium: "秒",
	      Duration_Seconds_Short: "秒",
	      Duration_Millis_Full: "ミリ秒",
	      Duration_Millis_Medium: "ミリ秒",
	      Duration_Millis_Short: "ミリ秒",
	      SelectAll: "すべて選択",
	      SelectNone: "すべてクリア",
	      Action: "（アクション）{0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var ko$1 = {
	      quickFilter: "빠른 필터...",
	      noItems: "항목 없음",
	      item: "항목",
	      items: "항목",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{1} {2} 중에서 {0}",
	      containsFilter: "{0} 포함",
	      notContainsFilter: "{0}을(를) 포함하지 않음",
	      equalsFilter: "{0}와(과) 같음",
	      notEqualFilter: "{0}와(과) 같지 않음",
	      startsWithFilter: "{0}(으)로 시작함",
	      endsWithFilter: "{0}(으)로 끝남",
	      lessThanFilter: "{0}보다 작음",
	      lessThanOrEqualFilter: "{0}보다 작거나 같음",
	      greaterThanFilter: "{0}보다 큼",
	      greaterThanOrEqualFilter: "{0}보다 크거나 같음",
	      beforeFilter: "{0} 이전",
	      beforeOrSameFilter: "{0} 이전이거나 동일함",
	      afterFilter: "{0} 이후",
	      afterOrSameFilter: "{0} 이후거나 동일함",
	      inRangeFilter: "{0} - {1} 범위 내",
	      isEmptyFilter: "비어 있음",
	      isNotEmptyFilter: "비어 있지 않음",
	      orFilter: "{0} 또는 {1}",
	      andFilter: "{0} 및 {1}",
	      Boolean_NoFilter: "모두",
	      BooleanYes: "예",
	      BooleanNo: "아니요",
	      BooleanEnabled: "활성화됨",
	      BooleanDisabled: "비활성화됨",
	      BooleanTrue: "참",
	      BooleanFalse: "거짓",
	      BooleanLocked: "잠김",
	      BooleanUnlocked: "잠금 해제됨",
	      BooleanActive: "활성",
	      BooleanInactive: "비활성",
	      BooleanOk: "확인",
	      BooleanError: "오류",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "같음",
	      Operator_NotEqual: "같지 않음",
	      Operator_LessThan: "보다 작은",
	      Operator_LessOrEqual: "보다 작거나 같은",
	      Operator_GreaterThan: "보다 큰",
	      Operator_GreaterOrEqual: "보다 크거나 같은",
	      Operator_Before: "이전",
	      Operator_BeforeOrSame: "이전이거나 동일함",
	      Operator_After: "이후",
	      Operator_AfterOrSame: "이후거나 동일함",
	      Operator_BetweenExclusive: "사이(제외)",
	      Operator_BetweenInclusive: "사이(포함)",
	      Operator_Contains: "포함",
	      Operator_NotContains: "포함하지 않음",
	      Operator_StartsWith: "다음으로 시작함",
	      Operator_EndsWith: "다음으로 끝남",
	      Operator_IsEmpty: "비어 있음",
	      Operator_IsNotEmpty: "비어 있지 않음",
	      Operator_OR: "또는",
	      Operator_AND: "및",
	      Settings_Tooltip: "목록 설정",
	      Menu_Columns: "열...",
	      Menu_Reset: "재설정",
	      Menu_Export: "내보내기",
	      Columns_Dialog_Title: "표시할 열",
	      Duration_Years_Full: "년",
	      Duration_Years_Medium: "년",
	      Duration_Years_Short: "y",
	      Duration_Days_Full: "일",
	      Duration_Days_Medium: "일",
	      Duration_Days_Short: "d",
	      Duration_Hours_Full: "시간",
	      Duration_Hours_Medium: "시간",
	      Duration_Hours_Short: "h",
	      Duration_Minutes_Full: "분",
	      Duration_Minutes_Medium: "분",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "초",
	      Duration_Seconds_Medium: "초",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "밀리초",
	      Duration_Millis_Medium: "밀리초",
	      Duration_Millis_Short: "ms",
	      SelectAll: "모두 선택",
	      SelectNone: "모두 지우기",
	      Action: "(작업) {0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var pt$1 = {
	      quickFilter: "Filtro rápido...",
	      noItems: "Nenhum item",
	      item: "Item",
	      items: "Itens",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} de {1} {2}",
	      containsFilter: "Contém {0}",
	      notContainsFilter: "Não contém {0}",
	      equalsFilter: "Igual a {0}",
	      notEqualFilter: "Não é igual a {0}",
	      startsWithFilter: "Começa com {0}",
	      endsWithFilter: "Termina com {0}",
	      lessThanFilter: "Menos de {0}",
	      lessThanOrEqualFilter: "Menor ou igual a {0}",
	      greaterThanFilter: "Maior que {0}",
	      greaterThanOrEqualFilter: "Maior ou igual a {0}",
	      beforeFilter: "Antes de {0}",
	      beforeOrSameFilter: "Antes de ou em {0}",
	      afterFilter: "Depois de {0}",
	      afterOrSameFilter: "Depois de ou em {0}",
	      inRangeFilter: "No intervalo {0} - {1}",
	      isEmptyFilter: "Está vazio",
	      isNotEmptyFilter: "Não está vazio",
	      orFilter: "{0} OU {1}",
	      andFilter: "{0} E {1}",
	      Boolean_NoFilter: "Todos",
	      BooleanYes: "Sim",
	      BooleanNo: "Não",
	      BooleanEnabled: "Ativado",
	      BooleanDisabled: "Desativado",
	      BooleanTrue: "Verdadeiro",
	      BooleanFalse: "Falso",
	      BooleanLocked: "Bloqueado",
	      BooleanUnlocked: "Desbloqueado",
	      BooleanActive: "Ativo",
	      BooleanInactive: "Inativo",
	      BooleanOk: "Ok",
	      BooleanError: "Erro",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "KB",
	      SizeUnit_MB: "MB",
	      SizeUnit_GB: "GB",
	      SizeUnit_TB: "TB",
	      Operator_Equals: "Igual a",
	      Operator_NotEqual: "Não é igual",
	      Operator_LessThan: "Menor que",
	      Operator_LessOrEqual: "Menor ou igual a",
	      Operator_GreaterThan: "Maior que",
	      Operator_GreaterOrEqual: "Maior ou igual a",
	      Operator_Before: "Antes",
	      Operator_BeforeOrSame: "Antes de ou em",
	      Operator_After: "Depois",
	      Operator_AfterOrSame: "Depois de ou em",
	      Operator_BetweenExclusive: "Entre (exclusivo)",
	      Operator_BetweenInclusive: "Entre (inclusive)",
	      Operator_Contains: "Contém",
	      Operator_NotContains: "Não contém",
	      Operator_StartsWith: "Começa com",
	      Operator_EndsWith: "Termina com",
	      Operator_IsEmpty: "Está vazio",
	      Operator_IsNotEmpty: "Não está vazio",
	      Operator_OR: "OU",
	      Operator_AND: "E",
	      Settings_Tooltip: "Listar configurações",
	      Menu_Columns: "Colunas...",
	      Menu_Reset: "Redefinir",
	      Menu_Export: "Exportar",
	      Columns_Dialog_Title: "Colunas a mostrar",
	      Duration_Years_Full: "Anos",
	      Duration_Years_Medium: "anos",
	      Duration_Years_Short: "a",
	      Duration_Days_Full: "Dias",
	      Duration_Days_Medium: "Dias",
	      Duration_Days_Short: "d",
	      Duration_Hours_Full: "Horas",
	      Duration_Hours_Medium: "Hrs",
	      Duration_Hours_Short: " h",
	      Duration_Minutes_Full: "Minutos",
	      Duration_Minutes_Medium: "min",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "Segundos",
	      Duration_Seconds_Medium: "seg",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "Milissegundos",
	      Duration_Millis_Medium: "Milis",
	      Duration_Millis_Short: "ms",
	      SelectAll: "Selecionar tudo",
	      SelectNone: "Limpar tudo",
	      Action: "(Ação) {0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var ru$1 = {
	      quickFilter: "Быстрый фильтр...",
	      noItems: "Нет элементов",
	      item: "Элемент",
	      items: "Элементы",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} из {1} {2}",
	      containsFilter: "Содержит {0}",
	      notContainsFilter: "Не содержит {0}",
	      equalsFilter: "Равно {0}",
	      notEqualFilter: "Не равно {0}",
	      startsWithFilter: "Начинается с {0}",
	      endsWithFilter: "Заканчивается на {0}",
	      lessThanFilter: "Меньше {0}",
	      lessThanOrEqualFilter: "Меньше или равно {0}",
	      greaterThanFilter: "Больше {0}",
	      greaterThanOrEqualFilter: "Больше или равно {0}",
	      beforeFilter: "До {0}",
	      beforeOrSameFilter: "До {0} или тогда же",
	      afterFilter: "После {0}",
	      afterOrSameFilter: "После {0} или тогда же",
	      inRangeFilter: "В диапазоне от {0} до {1}",
	      isEmptyFilter: "Пусто",
	      isNotEmptyFilter: "Не пусто",
	      orFilter: "{0} ИЛИ {1}",
	      andFilter: "{0} И {1}",
	      Boolean_NoFilter: "Все",
	      BooleanYes: "Да",
	      BooleanNo: "Нет",
	      BooleanEnabled: "Включено",
	      BooleanDisabled: "Отключено",
	      BooleanTrue: "Истина",
	      BooleanFalse: "Ложь",
	      BooleanLocked: "Заблокировано",
	      BooleanUnlocked: "Разблокировано",
	      BooleanActive: "Активно",
	      BooleanInactive: "Не активен",
	      BooleanOk: "OK",
	      BooleanError: "Ошибка",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "Кбайт",
	      SizeUnit_MB: "Мбайт",
	      SizeUnit_GB: "Гбайт",
	      SizeUnit_TB: "Тбайт",
	      Operator_Equals: "Равно",
	      Operator_NotEqual: "Не равно",
	      Operator_LessThan: "Меньше",
	      Operator_LessOrEqual: "Меньше или равно",
	      Operator_GreaterThan: "Больше",
	      Operator_GreaterOrEqual: "Больше или равно",
	      Operator_Before: "До",
	      Operator_BeforeOrSame: "До или тогда же",
	      Operator_After: "После",
	      Operator_AfterOrSame: "После или тогда же",
	      Operator_BetweenExclusive: "Между (не включая)",
	      Operator_BetweenInclusive: "Между (включительно)",
	      Operator_Contains: "Содержит",
	      Operator_NotContains: "Не содержит",
	      Operator_StartsWith: "Начинается с",
	      Operator_EndsWith: "Заканчивается на",
	      Operator_IsEmpty: "Пусто",
	      Operator_IsNotEmpty: "Не пусто",
	      Operator_OR: "ИЛИ",
	      Operator_AND: "И",
	      Settings_Tooltip: "Параметры списка",
	      Menu_Columns: "Столбцы...",
	      Menu_Reset: "Сброс",
	      Menu_Export: "Экспорт",
	      Columns_Dialog_Title: "Столбцы для отображения",
	      Duration_Years_Full: "Годы",
	      Duration_Years_Medium: "гг.",
	      Duration_Years_Short: "г.",
	      Duration_Days_Full: "Дн.",
	      Duration_Days_Medium: "Дн.",
	      Duration_Days_Short: "дн.",
	      Duration_Hours_Full: "Часы",
	      Duration_Hours_Medium: "час.",
	      Duration_Hours_Short: "ч.",
	      Duration_Minutes_Full: "Минуты",
	      Duration_Minutes_Medium: "Мин.",
	      Duration_Minutes_Short: "м",
	      Duration_Seconds_Full: "Секунды",
	      Duration_Seconds_Medium: "Сек.",
	      Duration_Seconds_Short: "с",
	      Duration_Millis_Full: "Миллисекунды",
	      Duration_Millis_Medium: "Миллисек.",
	      Duration_Millis_Short: "мс",
	      SelectAll: "Выбрать все",
	      SelectNone: "Очистить все",
	      Action: "(Действие) {0}"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var zh$1 = {
	      quickFilter: "Filtre rapide...",
	      noItems: "Aucun article",
	      item: "Élément",
	      items: "Éléments",
	      gridCount: "{0} {1}",
	      filteredGridCount: "{0} sur {1} {2}",
	      containsFilter: "Contient {0}",
	      notContainsFilter: "Ne contient pas {0}",
	      equalsFilter: "Est égal à {0}",
	      notEqualFilter: "N’est pas égal à {0}",
	      startsWithFilter: "Commence par {0}",
	      endsWithFilter: "Se termine par {0}",
	      lessThanFilter: "Inférieur à {0}",
	      lessThanOrEqualFilter: "Inférieur ou égal à {0}",
	      greaterThanFilter: "Supérieur à {0}",
	      greaterThanOrEqualFilter: "Supérieur ou égal à {0}",
	      beforeFilter: "Avant le {0}",
	      beforeOrSameFilter: "Avant le ou le {0}",
	      afterFilter: "Après le {0}",
	      afterOrSameFilter: "Après le ou le {0}",
	      inRangeFilter: "Dans la plage {0} - {1}",
	      isEmptyFilter: "Est vide",
	      isNotEmptyFilter: "N'est pas vide",
	      orFilter: "{0} OU {1}",
	      andFilter: "{0} ET {1}",
	      Boolean_NoFilter: "Tous",
	      BooleanYes: "Oui",
	      BooleanNo: "Non",
	      BooleanEnabled: "Activé",
	      BooleanDisabled: "Désactivé",
	      BooleanTrue: "Vrai",
	      BooleanFalse: "Faux",
	      BooleanLocked: "Verrouillé",
	      BooleanUnlocked: "Déverrouillé",
	      BooleanActive: "Actif",
	      BooleanInactive: "Inactif",
	      BooleanOk: "OK",
	      BooleanError: "Erreur",
	      SizeUnit_B: "B",
	      SizeUnit_KB: "Ko",
	      SizeUnit_MB: "Mo",
	      SizeUnit_GB: "Go",
	      SizeUnit_TB: "To",
	      Operator_Equals: "Est égal à",
	      Operator_NotEqual: "N’est pas égal à",
	      Operator_LessThan: "Inférieur à",
	      Operator_LessOrEqual: "Inférieur ou égal à",
	      Operator_GreaterThan: "Supérieur à",
	      Operator_GreaterOrEqual: "Supérieur ou égal à",
	      Operator_Before: "Avant le",
	      Operator_BeforeOrSame: "Avant le ou le",
	      Operator_After: "Après le",
	      Operator_AfterOrSame: "Après le ou le",
	      Operator_BetweenExclusive: "Entre (exclusif)",
	      Operator_BetweenInclusive: "Entre (inclusif)",
	      Operator_Contains: "Contient",
	      Operator_NotContains: "Ne contient pas",
	      Operator_StartsWith: "Commence par",
	      Operator_EndsWith: "Se termine par",
	      Operator_IsEmpty: "Est vide",
	      Operator_IsNotEmpty: "N'est pas vide",
	      Operator_OR: "OU",
	      Operator_AND: "ET",
	      Settings_Tooltip: "Paramètres de la liste",
	      Menu_Columns: "Colonnes...",
	      Menu_Reset: "Réinitialiser",
	      Menu_Export: "Exporter",
	      Columns_Dialog_Title: "Colonnes à afficher",
	      Duration_Years_Full: "Années",
	      Duration_Years_Medium: "Ans",
	      Duration_Years_Short: "a",
	      Duration_Days_Full: "Jours",
	      Duration_Days_Medium: "Jours",
	      Duration_Days_Short: "j",
	      Duration_Hours_Full: "Heures",
	      Duration_Hours_Medium: "Hr",
	      Duration_Hours_Short: "h",
	      Duration_Minutes_Full: "Minutes",
	      Duration_Minutes_Medium: "min.",
	      Duration_Minutes_Short: "m",
	      Duration_Seconds_Full: "Secondes",
	      Duration_Seconds_Medium: "sec.",
	      Duration_Seconds_Short: "s",
	      Duration_Millis_Full: "Millisecondes",
	      Duration_Millis_Medium: "Millisec",
	      Duration_Millis_Short: "ms",
	      SelectAll: "Tout sélectionner",
	      SelectNone: "Tout effacer",
	      Action: "(Action) {0}"
	    };

	    const {
	      locale: locale$1
	    } = core;
	    const dictionaryLocales$1 = {
	      de: de$1,
	      en: en$2,
	      es: es$1,
	      fr: fr$1,
	      it: it$1,
	      ja: ja$1,
	      ko: ko$1,
	      pt: pt$1,
	      ru: ru$1,
	      zh: zh$1
	    };
	    s$1.set(dictionaryLocales$1);

	    // Grid store
	    // Default to the browser locale, if present
	    let browserLang$1 = locale$1.getBestFit();
	    $$1({
	      fallbackLocale: 'en',
	      initialLocale: browserLang$1
	    });

	    const subscriber_queue = [];
	    /**
	     * Creates a `Readable` store that allows reading by subscription.
	     * @param value initial value
	     * @param {StartStopNotifier}start start and stop notifications for subscriptions
	     */
	    function readable(value, start) {
	        return {
	            subscribe: writable(value, start).subscribe
	        };
	    }
	    /**
	     * Create a `Writable` store that allows both updating and reading by subscription.
	     * @param {*=}value initial value
	     * @param {StartStopNotifier=}start start and stop notifications for subscriptions
	     */
	    function writable(value, start = noop) {
	        let stop;
	        const subscribers = [];
	        function set(new_value) {
	            if (safe_not_equal(value, new_value)) {
	                value = new_value;
	                if (stop) { // store is ready
	                    const run_queue = !subscriber_queue.length;
	                    for (let i = 0; i < subscribers.length; i += 1) {
	                        const s = subscribers[i];
	                        s[1]();
	                        subscriber_queue.push(s, value);
	                    }
	                    if (run_queue) {
	                        for (let i = 0; i < subscriber_queue.length; i += 2) {
	                            subscriber_queue[i][0](subscriber_queue[i + 1]);
	                        }
	                        subscriber_queue.length = 0;
	                    }
	                }
	            }
	        }
	        function update(fn) {
	            set(fn(value));
	        }
	        function subscribe(run, invalidate = noop) {
	            const subscriber = [run, invalidate];
	            subscribers.push(subscriber);
	            if (subscribers.length === 1) {
	                stop = start(set) || noop;
	            }
	            run(value);
	            return () => {
	                const index = subscribers.indexOf(subscriber);
	                if (index !== -1) {
	                    subscribers.splice(index, 1);
	                }
	                if (subscribers.length === 0) {
	                    stop();
	                    stop = null;
	                }
	            };
	        }
	        return { set, update, subscribe };
	    }
	    function derived(stores, fn, initial_value) {
	        const single = !Array.isArray(stores);
	        const stores_array = single
	            ? [stores]
	            : stores;
	        const auto = fn.length < 2;
	        return readable(initial_value, (set) => {
	            let inited = false;
	            const values = [];
	            let pending = 0;
	            let cleanup = noop;
	            const sync = () => {
	                if (pending) {
	                    return;
	                }
	                cleanup();
	                const result = fn(single ? values[0] : values, set);
	                if (auto) {
	                    set(result);
	                }
	                else {
	                    cleanup = is_function(result) ? result : noop;
	                }
	            };
	            const unsubscribers = stores_array.map((store, i) => subscribe(store, (value) => {
	                values[i] = value;
	                pending &= ~(1 << i);
	                if (inited) {
	                    sync();
	                }
	            }, () => {
	                pending |= (1 << i);
	            }));
	            inited = true;
	            sync();
	            return function stop() {
	                run_all(unsubscribers);
	                cleanup();
	            };
	        });
	    }

	    var isMergeableObject = function isMergeableObject(value) {
	    	return isNonNullObject(value)
	    		&& !isSpecial(value)
	    };

	    function isNonNullObject(value) {
	    	return !!value && typeof value === 'object'
	    }

	    function isSpecial(value) {
	    	var stringValue = Object.prototype.toString.call(value);

	    	return stringValue === '[object RegExp]'
	    		|| stringValue === '[object Date]'
	    		|| isReactElement(value)
	    }

	    // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	    var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	    function isReactElement(value) {
	    	return value.$$typeof === REACT_ELEMENT_TYPE
	    }

	    function emptyTarget(val) {
	    	return Array.isArray(val) ? [] : {}
	    }

	    function cloneUnlessOtherwiseSpecified(value, options) {
	    	return (options.clone !== false && options.isMergeableObject(value))
	    		? deepmerge(emptyTarget(value), value, options)
	    		: value
	    }

	    function defaultArrayMerge(target, source, options) {
	    	return target.concat(source).map(function(element) {
	    		return cloneUnlessOtherwiseSpecified(element, options)
	    	})
	    }

	    function getMergeFunction(key, options) {
	    	if (!options.customMerge) {
	    		return deepmerge
	    	}
	    	var customMerge = options.customMerge(key);
	    	return typeof customMerge === 'function' ? customMerge : deepmerge
	    }

	    function getEnumerableOwnPropertySymbols(target) {
	    	return Object.getOwnPropertySymbols
	    		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
	    			return Object.propertyIsEnumerable.call(target, symbol)
	    		})
	    		: []
	    }

	    function getKeys(target) {
	    	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	    }

	    function propertyIsOnObject(object, property) {
	    	try {
	    		return property in object
	    	} catch(_) {
	    		return false
	    	}
	    }

	    // Protects from prototype poisoning and unexpected merging up the prototype chain.
	    function propertyIsUnsafe(target, key) {
	    	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
	    		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
	    			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	    }

	    function mergeObject(target, source, options) {
	    	var destination = {};
	    	if (options.isMergeableObject(target)) {
	    		getKeys(target).forEach(function(key) {
	    			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
	    		});
	    	}
	    	getKeys(source).forEach(function(key) {
	    		if (propertyIsUnsafe(target, key)) {
	    			return
	    		}

	    		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
	    			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
	    		} else {
	    			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
	    		}
	    	});
	    	return destination
	    }

	    function deepmerge(target, source, options) {
	    	options = options || {};
	    	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	    	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	    	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	    	// implementations can use it. The caller may not replace it.
	    	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	    	var sourceIsArray = Array.isArray(source);
	    	var targetIsArray = Array.isArray(target);
	    	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	    	if (!sourceAndTargetTypesMatch) {
	    		return cloneUnlessOtherwiseSpecified(source, options)
	    	} else if (sourceIsArray) {
	    		return options.arrayMerge(target, source, options)
	    	} else {
	    		return mergeObject(target, source, options)
	    	}
	    }

	    deepmerge.all = function deepmergeAll(array, options) {
	    	if (!Array.isArray(array)) {
	    		throw new Error('first argument should be an array')
	    	}

	    	return array.reduce(function(prev, next) {
	    		return deepmerge(prev, next, options)
	    	}, {})
	    };

	    var deepmerge_1 = deepmerge;

	    var cjs = deepmerge_1;

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

	    var extendStatics = function(d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };

	    function __extends(d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }

	    var __assign$2 = function() {
	        __assign$2 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$2.apply(this, arguments);
	    };

	    function __spreadArray(to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    }

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */

	    var __assign$1 = function() {
	        __assign$1 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$1.apply(this, arguments);
	    };

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    var ErrorKind;
	    (function (ErrorKind) {
	        /** Argument is unclosed (e.g. `{0`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
	        /** Argument is empty (e.g. `{}`). */
	        ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
	        /** Argument is malformed (e.g. `{foo!}``) */
	        ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
	        /** Expect an argument type (e.g. `{foo,}`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
	        /** Unsupported argument type (e.g. `{foo,foo}`) */
	        ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
	        /** Expect an argument style (e.g. `{foo, number, }`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
	        /** The number skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
	        /** The date time skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
	        /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
	        /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
	        /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
	        ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
	        /** Missing select argument options (e.g. `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
	        /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
	        /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
	        /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
	        /**
	         * Expecting a message fragment after the `plural` or `selectordinal` selector
	         * (e.g. `{foo, plural, one}`)
	         */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
	        /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
	        /**
	         * Duplicate selectors in `plural` or `selectordinal` argument.
	         * (e.g. {foo, plural, one {#} one {#}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
	        /** Duplicate selectors in `select` argument.
	         * (e.g. {foo, select, apple {apple} apple {apple}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
	        /** Plural or select argument option must have `other` clause. */
	        ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
	        /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
	        ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
	        /** The tag name is invalid. (e.g. `<123>foo</123>`) */
	        ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
	        /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
	        ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
	        /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
	        ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
	    })(ErrorKind || (ErrorKind = {}));

	    var TYPE;
	    (function (TYPE) {
	        /**
	         * Raw text
	         */
	        TYPE[TYPE["literal"] = 0] = "literal";
	        /**
	         * Variable w/o any format, e.g `var` in `this is a {var}`
	         */
	        TYPE[TYPE["argument"] = 1] = "argument";
	        /**
	         * Variable w/ number format
	         */
	        TYPE[TYPE["number"] = 2] = "number";
	        /**
	         * Variable w/ date format
	         */
	        TYPE[TYPE["date"] = 3] = "date";
	        /**
	         * Variable w/ time format
	         */
	        TYPE[TYPE["time"] = 4] = "time";
	        /**
	         * Variable w/ select format
	         */
	        TYPE[TYPE["select"] = 5] = "select";
	        /**
	         * Variable w/ plural format
	         */
	        TYPE[TYPE["plural"] = 6] = "plural";
	        /**
	         * Only possible within plural argument.
	         * This is the `#` symbol that will be substituted with the count.
	         */
	        TYPE[TYPE["pound"] = 7] = "pound";
	        /**
	         * XML-like tag
	         */
	        TYPE[TYPE["tag"] = 8] = "tag";
	    })(TYPE || (TYPE = {}));
	    var SKELETON_TYPE;
	    (function (SKELETON_TYPE) {
	        SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
	        SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
	    })(SKELETON_TYPE || (SKELETON_TYPE = {}));
	    /**
	     * Type Guards
	     */
	    function isLiteralElement(el) {
	        return el.type === TYPE.literal;
	    }
	    function isArgumentElement(el) {
	        return el.type === TYPE.argument;
	    }
	    function isNumberElement(el) {
	        return el.type === TYPE.number;
	    }
	    function isDateElement(el) {
	        return el.type === TYPE.date;
	    }
	    function isTimeElement(el) {
	        return el.type === TYPE.time;
	    }
	    function isSelectElement(el) {
	        return el.type === TYPE.select;
	    }
	    function isPluralElement(el) {
	        return el.type === TYPE.plural;
	    }
	    function isPoundElement(el) {
	        return el.type === TYPE.pound;
	    }
	    function isTagElement(el) {
	        return el.type === TYPE.tag;
	    }
	    function isNumberSkeleton(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
	    }
	    function isDateTimeSkeleton(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
	    }

	    // @generated from regex-gen.ts
	    var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

	    /**
	     * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
	     * with some tweaks
	     */
	    var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	    /**
	     * Parse Date time skeleton into Intl.DateTimeFormatOptions
	     * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * @public
	     * @param skeleton skeleton string
	     */
	    function parseDateTimeSkeleton(skeleton) {
	        var result = {};
	        skeleton.replace(DATE_TIME_REGEX, function (match) {
	            var len = match.length;
	            switch (match[0]) {
	                // Era
	                case 'G':
	                    result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
	                    break;
	                // Year
	                case 'y':
	                    result.year = len === 2 ? '2-digit' : 'numeric';
	                    break;
	                case 'Y':
	                case 'u':
	                case 'U':
	                case 'r':
	                    throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
	                // Quarter
	                case 'q':
	                case 'Q':
	                    throw new RangeError('`q/Q` (quarter) patterns are not supported');
	                // Month
	                case 'M':
	                case 'L':
	                    result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
	                    break;
	                // Week
	                case 'w':
	                case 'W':
	                    throw new RangeError('`w/W` (week) patterns are not supported');
	                case 'd':
	                    result.day = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'D':
	                case 'F':
	                case 'g':
	                    throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
	                // Weekday
	                case 'E':
	                    result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
	                    break;
	                case 'e':
	                    if (len < 4) {
	                        throw new RangeError('`e..eee` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                case 'c':
	                    if (len < 4) {
	                        throw new RangeError('`c..ccc` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                // Period
	                case 'a': // AM, PM
	                    result.hour12 = true;
	                    break;
	                case 'b': // am, pm, noon, midnight
	                case 'B': // flexible day periods
	                    throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
	                // Hour
	                case 'h':
	                    result.hourCycle = 'h12';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'H':
	                    result.hourCycle = 'h23';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'K':
	                    result.hourCycle = 'h11';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'k':
	                    result.hourCycle = 'h24';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'j':
	                case 'J':
	                case 'C':
	                    throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
	                // Minute
	                case 'm':
	                    result.minute = ['numeric', '2-digit'][len - 1];
	                    break;
	                // Second
	                case 's':
	                    result.second = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'S':
	                case 'A':
	                    throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
	                // Zone
	                case 'z': // 1..3, 4: specific non-location format
	                    result.timeZoneName = len < 4 ? 'short' : 'long';
	                    break;
	                case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	                case 'O': // 1, 4: miliseconds in day short, long
	                case 'v': // 1, 4: generic non-location format
	                case 'V': // 1, 2, 3, 4: time zone ID or city
	                case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	                case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
	                    throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
	            }
	            return '';
	        });
	        return result;
	    }

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */

	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    // @generated from regex-gen.ts
	    var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

	    function parseNumberSkeletonFromString(skeleton) {
	        if (skeleton.length === 0) {
	            throw new Error('Number skeleton cannot be empty');
	        }
	        // Parse the skeleton
	        var stringTokens = skeleton
	            .split(WHITE_SPACE_REGEX)
	            .filter(function (x) { return x.length > 0; });
	        var tokens = [];
	        for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
	            var stringToken = stringTokens_1[_i];
	            var stemAndOptions = stringToken.split('/');
	            if (stemAndOptions.length === 0) {
	                throw new Error('Invalid number skeleton');
	            }
	            var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
	            for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
	                var option = options_1[_a];
	                if (option.length === 0) {
	                    throw new Error('Invalid number skeleton');
	                }
	            }
	            tokens.push({ stem: stem, options: options });
	        }
	        return tokens;
	    }
	    function icuUnitToEcma(unit) {
	        return unit.replace(/^(.*?)-/, '');
	    }
	    var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
	    var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
	    var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
	    var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
	    function parseSignificantPrecision(str) {
	        var result = {};
	        if (str[str.length - 1] === 'r') {
	            result.roundingPriority = 'morePrecision';
	        }
	        else if (str[str.length - 1] === 's') {
	            result.roundingPriority = 'lessPrecision';
	        }
	        str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
	            // @@@ case
	            if (typeof g2 !== 'string') {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits = g1.length;
	            }
	            // @@@+ case
	            else if (g2 === '+') {
	                result.minimumSignificantDigits = g1.length;
	            }
	            // .### case
	            else if (g1[0] === '#') {
	                result.maximumSignificantDigits = g1.length;
	            }
	            // .@@## or .@@@ case
	            else {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits =
	                    g1.length + (typeof g2 === 'string' ? g2.length : 0);
	            }
	            return '';
	        });
	        return result;
	    }
	    function parseSign(str) {
	        switch (str) {
	            case 'sign-auto':
	                return {
	                    signDisplay: 'auto',
	                };
	            case 'sign-accounting':
	            case '()':
	                return {
	                    currencySign: 'accounting',
	                };
	            case 'sign-always':
	            case '+!':
	                return {
	                    signDisplay: 'always',
	                };
	            case 'sign-accounting-always':
	            case '()!':
	                return {
	                    signDisplay: 'always',
	                    currencySign: 'accounting',
	                };
	            case 'sign-except-zero':
	            case '+?':
	                return {
	                    signDisplay: 'exceptZero',
	                };
	            case 'sign-accounting-except-zero':
	            case '()?':
	                return {
	                    signDisplay: 'exceptZero',
	                    currencySign: 'accounting',
	                };
	            case 'sign-never':
	            case '+_':
	                return {
	                    signDisplay: 'never',
	                };
	        }
	    }
	    function parseConciseScientificAndEngineeringStem(stem) {
	        // Engineering
	        var result;
	        if (stem[0] === 'E' && stem[1] === 'E') {
	            result = {
	                notation: 'engineering',
	            };
	            stem = stem.slice(2);
	        }
	        else if (stem[0] === 'E') {
	            result = {
	                notation: 'scientific',
	            };
	            stem = stem.slice(1);
	        }
	        if (result) {
	            var signDisplay = stem.slice(0, 2);
	            if (signDisplay === '+!') {
	                result.signDisplay = 'always';
	                stem = stem.slice(2);
	            }
	            else if (signDisplay === '+?') {
	                result.signDisplay = 'exceptZero';
	                stem = stem.slice(2);
	            }
	            if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
	                throw new Error('Malformed concise eng/scientific notation');
	            }
	            result.minimumIntegerDigits = stem.length;
	        }
	        return result;
	    }
	    function parseNotationOptions(opt) {
	        var result = {};
	        var signOpts = parseSign(opt);
	        if (signOpts) {
	            return signOpts;
	        }
	        return result;
	    }
	    /**
	     * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
	     */
	    function parseNumberSkeleton(tokens) {
	        var result = {};
	        for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
	            var token = tokens_1[_i];
	            switch (token.stem) {
	                case 'percent':
	                case '%':
	                    result.style = 'percent';
	                    continue;
	                case '%x100':
	                    result.style = 'percent';
	                    result.scale = 100;
	                    continue;
	                case 'currency':
	                    result.style = 'currency';
	                    result.currency = token.options[0];
	                    continue;
	                case 'group-off':
	                case ',_':
	                    result.useGrouping = false;
	                    continue;
	                case 'precision-integer':
	                case '.':
	                    result.maximumFractionDigits = 0;
	                    continue;
	                case 'measure-unit':
	                case 'unit':
	                    result.style = 'unit';
	                    result.unit = icuUnitToEcma(token.options[0]);
	                    continue;
	                case 'compact-short':
	                case 'K':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'short';
	                    continue;
	                case 'compact-long':
	                case 'KK':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'long';
	                    continue;
	                case 'scientific':
	                    result = __assign(__assign(__assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                    continue;
	                case 'engineering':
	                    result = __assign(__assign(__assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                    continue;
	                case 'notation-simple':
	                    result.notation = 'standard';
	                    continue;
	                // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
	                case 'unit-width-narrow':
	                    result.currencyDisplay = 'narrowSymbol';
	                    result.unitDisplay = 'narrow';
	                    continue;
	                case 'unit-width-short':
	                    result.currencyDisplay = 'code';
	                    result.unitDisplay = 'short';
	                    continue;
	                case 'unit-width-full-name':
	                    result.currencyDisplay = 'name';
	                    result.unitDisplay = 'long';
	                    continue;
	                case 'unit-width-iso-code':
	                    result.currencyDisplay = 'symbol';
	                    continue;
	                case 'scale':
	                    result.scale = parseFloat(token.options[0]);
	                    continue;
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	                case 'integer-width':
	                    if (token.options.length > 1) {
	                        throw new RangeError('integer-width stems only accept a single optional option');
	                    }
	                    token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
	                        if (g1) {
	                            result.minimumIntegerDigits = g2.length;
	                        }
	                        else if (g3 && g4) {
	                            throw new Error('We currently do not support maximum integer digits');
	                        }
	                        else if (g5) {
	                            throw new Error('We currently do not support exact integer digits');
	                        }
	                        return '';
	                    });
	                    continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	            if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
	                result.minimumIntegerDigits = token.stem.length;
	                continue;
	            }
	            if (FRACTION_PRECISION_REGEX.test(token.stem)) {
	                // Precision
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
	                // precision-integer case
	                if (token.options.length > 1) {
	                    throw new RangeError('Fraction-precision stems only accept a single optional option');
	                }
	                token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
	                    // .000* case (before ICU67 it was .000+)
	                    if (g2 === '*') {
	                        result.minimumFractionDigits = g1.length;
	                    }
	                    // .### case
	                    else if (g3 && g3[0] === '#') {
	                        result.maximumFractionDigits = g3.length;
	                    }
	                    // .00## case
	                    else if (g4 && g5) {
	                        result.minimumFractionDigits = g4.length;
	                        result.maximumFractionDigits = g4.length + g5.length;
	                    }
	                    else {
	                        result.minimumFractionDigits = g1.length;
	                        result.maximumFractionDigits = g1.length;
	                    }
	                    return '';
	                });
	                var opt = token.options[0];
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
	                if (opt === 'w') {
	                    result = __assign(__assign({}, result), { trailingZeroDisplay: 'stripIfInteger' });
	                }
	                else if (opt) {
	                    result = __assign(__assign({}, result), parseSignificantPrecision(opt));
	                }
	                continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
	            if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
	                result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
	                continue;
	            }
	            var signOpts = parseSign(token.stem);
	            if (signOpts) {
	                result = __assign(__assign({}, result), signOpts);
	            }
	            var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
	            if (conciseScientificAndEngineeringOpts) {
	                result = __assign(__assign({}, result), conciseScientificAndEngineeringOpts);
	            }
	        }
	        return result;
	    }

	    // @generated from time-data-gen.ts
	    // prettier-ignore  
	    var timeData = {
	        "AX": [
	            "H"
	        ],
	        "BQ": [
	            "H"
	        ],
	        "CP": [
	            "H"
	        ],
	        "CZ": [
	            "H"
	        ],
	        "DK": [
	            "H"
	        ],
	        "FI": [
	            "H"
	        ],
	        "ID": [
	            "H"
	        ],
	        "IS": [
	            "H"
	        ],
	        "ML": [
	            "H"
	        ],
	        "NE": [
	            "H"
	        ],
	        "RU": [
	            "H"
	        ],
	        "SE": [
	            "H"
	        ],
	        "SJ": [
	            "H"
	        ],
	        "SK": [
	            "H"
	        ],
	        "AS": [
	            "h",
	            "H"
	        ],
	        "BT": [
	            "h",
	            "H"
	        ],
	        "DJ": [
	            "h",
	            "H"
	        ],
	        "ER": [
	            "h",
	            "H"
	        ],
	        "GH": [
	            "h",
	            "H"
	        ],
	        "IN": [
	            "h",
	            "H"
	        ],
	        "LS": [
	            "h",
	            "H"
	        ],
	        "PG": [
	            "h",
	            "H"
	        ],
	        "PW": [
	            "h",
	            "H"
	        ],
	        "SO": [
	            "h",
	            "H"
	        ],
	        "TO": [
	            "h",
	            "H"
	        ],
	        "VU": [
	            "h",
	            "H"
	        ],
	        "WS": [
	            "h",
	            "H"
	        ],
	        "001": [
	            "H",
	            "h"
	        ],
	        "AL": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "TD": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "ca-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "fr-CA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "gl-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-CH": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-IT": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "LU": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "NP": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "PF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SC": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SN": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "TF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "VA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CY": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "GR": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "CO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "DO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KP": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "NA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "VE": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "AC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "AI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BW": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BZ": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "DG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "FK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GB": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IM": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IO": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "JE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "LT": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MS": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NF": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NR": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NU": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "PN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SH": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "TA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "ZA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "af-ZA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "AR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CL": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CU": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "EA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BO": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-EC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-ES": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-GQ": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-PE": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "GT": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "HN": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "IC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KG": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KM": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "LK": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MX": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "NI": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "PY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "SV": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "UY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "JP": [
	            "H",
	            "h",
	            "K"
	        ],
	        "AD": [
	            "H",
	            "hB"
	        ],
	        "AM": [
	            "H",
	            "hB"
	        ],
	        "AO": [
	            "H",
	            "hB"
	        ],
	        "AT": [
	            "H",
	            "hB"
	        ],
	        "AW": [
	            "H",
	            "hB"
	        ],
	        "BE": [
	            "H",
	            "hB"
	        ],
	        "BF": [
	            "H",
	            "hB"
	        ],
	        "BJ": [
	            "H",
	            "hB"
	        ],
	        "BL": [
	            "H",
	            "hB"
	        ],
	        "BR": [
	            "H",
	            "hB"
	        ],
	        "CG": [
	            "H",
	            "hB"
	        ],
	        "CI": [
	            "H",
	            "hB"
	        ],
	        "CV": [
	            "H",
	            "hB"
	        ],
	        "DE": [
	            "H",
	            "hB"
	        ],
	        "EE": [
	            "H",
	            "hB"
	        ],
	        "FR": [
	            "H",
	            "hB"
	        ],
	        "GA": [
	            "H",
	            "hB"
	        ],
	        "GF": [
	            "H",
	            "hB"
	        ],
	        "GN": [
	            "H",
	            "hB"
	        ],
	        "GP": [
	            "H",
	            "hB"
	        ],
	        "GW": [
	            "H",
	            "hB"
	        ],
	        "HR": [
	            "H",
	            "hB"
	        ],
	        "IL": [
	            "H",
	            "hB"
	        ],
	        "IT": [
	            "H",
	            "hB"
	        ],
	        "KZ": [
	            "H",
	            "hB"
	        ],
	        "MC": [
	            "H",
	            "hB"
	        ],
	        "MD": [
	            "H",
	            "hB"
	        ],
	        "MF": [
	            "H",
	            "hB"
	        ],
	        "MQ": [
	            "H",
	            "hB"
	        ],
	        "MZ": [
	            "H",
	            "hB"
	        ],
	        "NC": [
	            "H",
	            "hB"
	        ],
	        "NL": [
	            "H",
	            "hB"
	        ],
	        "PM": [
	            "H",
	            "hB"
	        ],
	        "PT": [
	            "H",
	            "hB"
	        ],
	        "RE": [
	            "H",
	            "hB"
	        ],
	        "RO": [
	            "H",
	            "hB"
	        ],
	        "SI": [
	            "H",
	            "hB"
	        ],
	        "SR": [
	            "H",
	            "hB"
	        ],
	        "ST": [
	            "H",
	            "hB"
	        ],
	        "TG": [
	            "H",
	            "hB"
	        ],
	        "TR": [
	            "H",
	            "hB"
	        ],
	        "WF": [
	            "H",
	            "hB"
	        ],
	        "YT": [
	            "H",
	            "hB"
	        ],
	        "BD": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "PK": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "AZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BG": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "CH": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "GE": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "LI": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "ME": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "RS": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "XK": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "AG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "AU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "CA": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "DM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "en-001": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FJ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GD": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "JM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KN": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LR": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MH": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MP": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MW": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "NZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SL": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TT": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "UM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "US": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "ZM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BO": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "EC": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "ES": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "GQ": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "PE": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "AE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "ar-001": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "BH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "DZ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EG": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "HK": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "IQ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "JO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "KW": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LB": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MR": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "OM": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PS": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "QA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SD": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "TN": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "YE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "AF": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "LA": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "CN": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "LV": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "TL": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "zu-ZA": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "CD": [
	            "hB",
	            "H"
	        ],
	        "IR": [
	            "hB",
	            "H"
	        ],
	        "hi-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "kn-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "ml-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "te-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "KH": [
	            "hB",
	            "h",
	            "H",
	            "hb"
	        ],
	        "ta-IN": [
	            "hB",
	            "h",
	            "hb",
	            "H"
	        ],
	        "BN": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "MY": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "ET": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "gu-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "mr-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "pa-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "TW": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "KE": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "MM": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "TZ": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "UG": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ]
	    };

	    /**
	     * Returns the best matching date time pattern if a date time skeleton
	     * pattern is provided with a locale. Follows the Unicode specification:
	     * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
	     * @param skeleton date time skeleton pattern that possibly includes j, J or C
	     * @param locale
	     */
	    function getBestPattern(skeleton, locale) {
	        var skeletonCopy = '';
	        for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
	            var patternChar = skeleton.charAt(patternPos);
	            if (patternChar === 'j') {
	                var extraLength = 0;
	                while (patternPos + 1 < skeleton.length &&
	                    skeleton.charAt(patternPos + 1) === patternChar) {
	                    extraLength++;
	                    patternPos++;
	                }
	                var hourLen = 1 + (extraLength & 1);
	                var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
	                var dayPeriodChar = 'a';
	                var hourChar = getDefaultHourSymbolFromLocale(locale);
	                if (hourChar == 'H' || hourChar == 'k') {
	                    dayPeriodLen = 0;
	                }
	                while (dayPeriodLen-- > 0) {
	                    skeletonCopy += dayPeriodChar;
	                }
	                while (hourLen-- > 0) {
	                    skeletonCopy = hourChar + skeletonCopy;
	                }
	            }
	            else if (patternChar === 'J') {
	                skeletonCopy += 'H';
	            }
	            else {
	                skeletonCopy += patternChar;
	            }
	        }
	        return skeletonCopy;
	    }
	    /**
	     * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
	     * of the given `locale` to the corresponding time pattern.
	     * @param locale
	     */
	    function getDefaultHourSymbolFromLocale(locale) {
	        var hourCycle = locale.hourCycle;
	        if (hourCycle === undefined &&
	            // @ts-ignore hourCycle(s) is not identified yet
	            locale.hourCycles &&
	            // @ts-ignore
	            locale.hourCycles.length) {
	            // @ts-ignore
	            hourCycle = locale.hourCycles[0];
	        }
	        if (hourCycle) {
	            switch (hourCycle) {
	                case 'h24':
	                    return 'k';
	                case 'h23':
	                    return 'H';
	                case 'h12':
	                    return 'h';
	                case 'h11':
	                    return 'K';
	                default:
	                    throw new Error('Invalid hourCycle');
	            }
	        }
	        // TODO: Once hourCycle is fully supported remove the following with data generation
	        var languageTag = locale.language;
	        var regionTag;
	        if (languageTag !== 'root') {
	            regionTag = locale.maximize().region;
	        }
	        var hourCycles = timeData[regionTag || ''] ||
	            timeData[languageTag || ''] ||
	            timeData["".concat(languageTag, "-001")] ||
	            timeData['001'];
	        return hourCycles[0];
	    }

	    var _a;
	    var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
	    var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
	    function createLocation(start, end) {
	        return { start: start, end: end };
	    }
	    // #region Ponyfills
	    // Consolidate these variables up top for easier toggling during debugging
	    var hasNativeStartsWith = !!String.prototype.startsWith;
	    var hasNativeFromCodePoint = !!String.fromCodePoint;
	    var hasNativeFromEntries = !!Object.fromEntries;
	    var hasNativeCodePointAt = !!String.prototype.codePointAt;
	    var hasTrimStart = !!String.prototype.trimStart;
	    var hasTrimEnd = !!String.prototype.trimEnd;
	    var hasNativeIsSafeInteger = !!Number.isSafeInteger;
	    var isSafeInteger = hasNativeIsSafeInteger
	        ? Number.isSafeInteger
	        : function (n) {
	            return (typeof n === 'number' &&
	                isFinite(n) &&
	                Math.floor(n) === n &&
	                Math.abs(n) <= 0x1fffffffffffff);
	        };
	    // IE11 does not support y and u.
	    var REGEX_SUPPORTS_U_AND_Y = true;
	    try {
	        var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        /**
	         * legacy Edge or Xbox One browser
	         * Unicode flag support: supported
	         * Pattern_Syntax support: not supported
	         * See https://github.com/formatjs/formatjs/issues/2822
	         */
	        REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
	    }
	    catch (_) {
	        REGEX_SUPPORTS_U_AND_Y = false;
	    }
	    var startsWith = hasNativeStartsWith
	        ? // Native
	            function startsWith(s, search, position) {
	                return s.startsWith(search, position);
	            }
	        : // For IE11
	            function startsWith(s, search, position) {
	                return s.slice(position, position + search.length) === search;
	            };
	    var fromCodePoint = hasNativeFromCodePoint
	        ? String.fromCodePoint
	        : // IE11
	            function fromCodePoint() {
	                var codePoints = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    codePoints[_i] = arguments[_i];
	                }
	                var elements = '';
	                var length = codePoints.length;
	                var i = 0;
	                var code;
	                while (length > i) {
	                    code = codePoints[i++];
	                    if (code > 0x10ffff)
	                        throw RangeError(code + ' is not a valid code point');
	                    elements +=
	                        code < 0x10000
	                            ? String.fromCharCode(code)
	                            : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
	                }
	                return elements;
	            };
	    var fromEntries = 
	    // native
	    hasNativeFromEntries
	        ? Object.fromEntries
	        : // Ponyfill
	            function fromEntries(entries) {
	                var obj = {};
	                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                    var _a = entries_1[_i], k = _a[0], v = _a[1];
	                    obj[k] = v;
	                }
	                return obj;
	            };
	    var codePointAt = hasNativeCodePointAt
	        ? // Native
	            function codePointAt(s, index) {
	                return s.codePointAt(index);
	            }
	        : // IE 11
	            function codePointAt(s, index) {
	                var size = s.length;
	                if (index < 0 || index >= size) {
	                    return undefined;
	                }
	                var first = s.charCodeAt(index);
	                var second;
	                return first < 0xd800 ||
	                    first > 0xdbff ||
	                    index + 1 === size ||
	                    (second = s.charCodeAt(index + 1)) < 0xdc00 ||
	                    second > 0xdfff
	                    ? first
	                    : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
	            };
	    var trimStart = hasTrimStart
	        ? // Native
	            function trimStart(s) {
	                return s.trimStart();
	            }
	        : // Ponyfill
	            function trimStart(s) {
	                return s.replace(SPACE_SEPARATOR_START_REGEX, '');
	            };
	    var trimEnd = hasTrimEnd
	        ? // Native
	            function trimEnd(s) {
	                return s.trimEnd();
	            }
	        : // Ponyfill
	            function trimEnd(s) {
	                return s.replace(SPACE_SEPARATOR_END_REGEX, '');
	            };
	    // Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
	    function RE(s, flag) {
	        return new RegExp(s, flag);
	    }
	    // #endregion
	    var matchIdentifierAtIndex;
	    if (REGEX_SUPPORTS_U_AND_Y) {
	        // Native
	        var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	            var _a;
	            IDENTIFIER_PREFIX_RE_1.lastIndex = index;
	            var match = IDENTIFIER_PREFIX_RE_1.exec(s);
	            return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
	        };
	    }
	    else {
	        // IE11
	        matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	            var match = [];
	            while (true) {
	                var c = codePointAt(s, index);
	                if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
	                    break;
	                }
	                match.push(c);
	                index += c >= 0x10000 ? 2 : 1;
	            }
	            return fromCodePoint.apply(void 0, match);
	        };
	    }
	    var Parser = /** @class */ (function () {
	        function Parser(message, options) {
	            if (options === void 0) { options = {}; }
	            this.message = message;
	            this.position = { offset: 0, line: 1, column: 1 };
	            this.ignoreTag = !!options.ignoreTag;
	            this.locale = options.locale;
	            this.requiresOtherClause = !!options.requiresOtherClause;
	            this.shouldParseSkeletons = !!options.shouldParseSkeletons;
	        }
	        Parser.prototype.parse = function () {
	            if (this.offset() !== 0) {
	                throw Error('parser can only be used once');
	            }
	            return this.parseMessage(0, '', false);
	        };
	        Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
	            var elements = [];
	            while (!this.isEOF()) {
	                var char = this.char();
	                if (char === 123 /* `{` */) {
	                    var result = this.parseArgument(nestingLevel, expectingCloseTag);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else if (char === 125 /* `}` */ && nestingLevel > 0) {
	                    break;
	                }
	                else if (char === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
	                    var position = this.clonePosition();
	                    this.bump();
	                    elements.push({
	                        type: TYPE.pound,
	                        location: createLocation(position, this.clonePosition()),
	                    });
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    this.peek() === 47 // char code for '/'
	                ) {
	                    if (expectingCloseTag) {
	                        break;
	                    }
	                    else {
	                        return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
	                    }
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    _isAlpha(this.peek() || 0)) {
	                    var result = this.parseTag(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else {
	                    var result = this.parseLiteral(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	            }
	            return { val: elements, err: null };
	        };
	        /**
	         * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	         * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	         * are accepted:
	         *
	         * ```
	         * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	         * tagName ::= [a-z] (PENChar)*
	         * PENChar ::=
	         *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	         *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	         *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	         * ```
	         *
	         * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	         * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	         * since other tag-based engines like React allow it
	         */
	        Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
	            var startPosition = this.clonePosition();
	            this.bump(); // `<`
	            var tagName = this.parseTagName();
	            this.bumpSpace();
	            if (this.bumpIf('/>')) {
	                // Self closing tag
	                return {
	                    val: {
	                        type: TYPE.literal,
	                        value: "<".concat(tagName, "/>"),
	                        location: createLocation(startPosition, this.clonePosition()),
	                    },
	                    err: null,
	                };
	            }
	            else if (this.bumpIf('>')) {
	                var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
	                if (childrenResult.err) {
	                    return childrenResult;
	                }
	                var children = childrenResult.val;
	                // Expecting a close tag
	                var endTagStartPosition = this.clonePosition();
	                if (this.bumpIf('</')) {
	                    if (this.isEOF() || !_isAlpha(this.char())) {
	                        return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                    }
	                    var closingTagNameStartPosition = this.clonePosition();
	                    var closingTagName = this.parseTagName();
	                    if (tagName !== closingTagName) {
	                        return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
	                    }
	                    this.bumpSpace();
	                    if (!this.bumpIf('>')) {
	                        return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                    }
	                    return {
	                        val: {
	                            type: TYPE.tag,
	                            value: tagName,
	                            children: children,
	                            location: createLocation(startPosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                else {
	                    return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
	                }
	            }
	            else {
	                return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
	            }
	        };
	        /**
	         * This method assumes that the caller has peeked ahead for the first tag character.
	         */
	        Parser.prototype.parseTagName = function () {
	            var startOffset = this.offset();
	            this.bump(); // the first tag name character
	            while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
	                this.bump();
	            }
	            return this.message.slice(startOffset, this.offset());
	        };
	        Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
	            var start = this.clonePosition();
	            var value = '';
	            while (true) {
	                var parseQuoteResult = this.tryParseQuote(parentArgType);
	                if (parseQuoteResult) {
	                    value += parseQuoteResult;
	                    continue;
	                }
	                var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
	                if (parseUnquotedResult) {
	                    value += parseUnquotedResult;
	                    continue;
	                }
	                var parseLeftAngleResult = this.tryParseLeftAngleBracket();
	                if (parseLeftAngleResult) {
	                    value += parseLeftAngleResult;
	                    continue;
	                }
	                break;
	            }
	            var location = createLocation(start, this.clonePosition());
	            return {
	                val: { type: TYPE.literal, value: value, location: location },
	                err: null,
	            };
	        };
	        Parser.prototype.tryParseLeftAngleBracket = function () {
	            if (!this.isEOF() &&
	                this.char() === 60 /* `<` */ &&
	                (this.ignoreTag ||
	                    // If at the opening tag or closing tag position, bail.
	                    !_isAlphaOrSlash(this.peek() || 0))) {
	                this.bump(); // `<`
	                return '<';
	            }
	            return null;
	        };
	        /**
	         * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	         * a character that requires quoting (that is, "only where needed"), and works the same in
	         * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	         */
	        Parser.prototype.tryParseQuote = function (parentArgType) {
	            if (this.isEOF() || this.char() !== 39 /* `'` */) {
	                return null;
	            }
	            // Parse escaped char following the apostrophe, or early return if there is no escaped char.
	            // Check if is valid escaped character
	            switch (this.peek()) {
	                case 39 /* `'` */:
	                    // double quote, should return as a single quote.
	                    this.bump();
	                    this.bump();
	                    return "'";
	                // '{', '<', '>', '}'
	                case 123:
	                case 60:
	                case 62:
	                case 125:
	                    break;
	                case 35: // '#'
	                    if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
	                        break;
	                    }
	                    return null;
	                default:
	                    return null;
	            }
	            this.bump(); // apostrophe
	            var codePoints = [this.char()]; // escaped char
	            this.bump();
	            // read chars until the optional closing apostrophe is found
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch === 39 /* `'` */) {
	                    if (this.peek() === 39 /* `'` */) {
	                        codePoints.push(39);
	                        // Bump one more time because we need to skip 2 characters.
	                        this.bump();
	                    }
	                    else {
	                        // Optional closing apostrophe.
	                        this.bump();
	                        break;
	                    }
	                }
	                else {
	                    codePoints.push(ch);
	                }
	                this.bump();
	            }
	            return fromCodePoint.apply(void 0, codePoints);
	        };
	        Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
	            if (this.isEOF()) {
	                return null;
	            }
	            var ch = this.char();
	            if (ch === 60 /* `<` */ ||
	                ch === 123 /* `{` */ ||
	                (ch === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
	                (ch === 125 /* `}` */ && nestingLevel > 0)) {
	                return null;
	            }
	            else {
	                this.bump();
	                return fromCodePoint(ch);
	            }
	        };
	        Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
	            var openingBracePosition = this.clonePosition();
	            this.bump(); // `{`
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            if (this.char() === 125 /* `}` */) {
	                this.bump();
	                return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            // argument name
	            var value = this.parseIdentifierIfPossible().value;
	            if (!value) {
	                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            switch (this.char()) {
	                // Simple argument: `{name}`
	                case 125 /* `}` */: {
	                    this.bump(); // `}`
	                    return {
	                        val: {
	                            type: TYPE.argument,
	                            // value does not include the opening and closing braces.
	                            value: value,
	                            location: createLocation(openingBracePosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                // Argument with options: `{name, format, ...}`
	                case 44 /* `,` */: {
	                    this.bump(); // `,`
	                    this.bumpSpace();
	                    if (this.isEOF()) {
	                        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	                    }
	                    return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
	                }
	                default:
	                    return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	        };
	        /**
	         * Advance the parser until the end of the identifier, if it is currently on
	         * an identifier character. Return an empty string otherwise.
	         */
	        Parser.prototype.parseIdentifierIfPossible = function () {
	            var startingPosition = this.clonePosition();
	            var startOffset = this.offset();
	            var value = matchIdentifierAtIndex(this.message, startOffset);
	            var endOffset = startOffset + value.length;
	            this.bumpTo(endOffset);
	            var endPosition = this.clonePosition();
	            var location = createLocation(startingPosition, endPosition);
	            return { value: value, location: location };
	        };
	        Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
	            var _a;
	            // Parse this range:
	            // {name, type, style}
	            //        ^---^
	            var typeStartPosition = this.clonePosition();
	            var argType = this.parseIdentifierIfPossible().value;
	            var typeEndPosition = this.clonePosition();
	            switch (argType) {
	                case '':
	                    // Expecting a style string number, date, time, plural, selectordinal, or select.
	                    return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	                case 'number':
	                case 'date':
	                case 'time': {
	                    // Parse this range:
	                    // {name, number, style}
	                    //              ^-------^
	                    this.bumpSpace();
	                    var styleAndLocation = null;
	                    if (this.bumpIf(',')) {
	                        this.bumpSpace();
	                        var styleStartPosition = this.clonePosition();
	                        var result = this.parseSimpleArgStyleIfPossible();
	                        if (result.err) {
	                            return result;
	                        }
	                        var style = trimEnd(result.val);
	                        if (style.length === 0) {
	                            return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
	                        }
	                        var styleLocation = createLocation(styleStartPosition, this.clonePosition());
	                        styleAndLocation = { style: style, styleLocation: styleLocation };
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_1 = createLocation(openingBracePosition, this.clonePosition());
	                    // Extract style or skeleton
	                    if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
	                        // Skeleton starts with `::`.
	                        var skeleton = trimStart(styleAndLocation.style.slice(2));
	                        if (argType === 'number') {
	                            var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
	                            if (result.err) {
	                                return result;
	                            }
	                            return {
	                                val: { type: TYPE.number, value: value, location: location_1, style: result.val },
	                                err: null,
	                            };
	                        }
	                        else {
	                            if (skeleton.length === 0) {
	                                return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
	                            }
	                            var dateTimePattern = skeleton;
	                            // Get "best match" pattern only if locale is passed, if not, let it
	                            // pass as-is where `parseDateTimeSkeleton()` will throw an error
	                            // for unsupported patterns.
	                            if (this.locale) {
	                                dateTimePattern = getBestPattern(skeleton, this.locale);
	                            }
	                            var style = {
	                                type: SKELETON_TYPE.dateTime,
	                                pattern: dateTimePattern,
	                                location: styleAndLocation.styleLocation,
	                                parsedOptions: this.shouldParseSkeletons
	                                    ? parseDateTimeSkeleton(dateTimePattern)
	                                    : {},
	                            };
	                            var type = argType === 'date' ? TYPE.date : TYPE.time;
	                            return {
	                                val: { type: type, value: value, location: location_1, style: style },
	                                err: null,
	                            };
	                        }
	                    }
	                    // Regular style or no style.
	                    return {
	                        val: {
	                            type: argType === 'number'
	                                ? TYPE.number
	                                : argType === 'date'
	                                    ? TYPE.date
	                                    : TYPE.time,
	                            value: value,
	                            location: location_1,
	                            style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
	                        },
	                        err: null,
	                    };
	                }
	                case 'plural':
	                case 'selectordinal':
	                case 'select': {
	                    // Parse this range:
	                    // {name, plural, options}
	                    //              ^---------^
	                    var typeEndPosition_1 = this.clonePosition();
	                    this.bumpSpace();
	                    if (!this.bumpIf(',')) {
	                        return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign$1({}, typeEndPosition_1)));
	                    }
	                    this.bumpSpace();
	                    // Parse offset:
	                    // {name, plural, offset:1, options}
	                    //                ^-----^
	                    //
	                    // or the first option:
	                    //
	                    // {name, plural, one {...} other {...}}
	                    //                ^--^
	                    var identifierAndLocation = this.parseIdentifierIfPossible();
	                    var pluralOffset = 0;
	                    if (argType !== 'select' && identifierAndLocation.value === 'offset') {
	                        if (!this.bumpIf(':')) {
	                            return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
	                        }
	                        this.bumpSpace();
	                        var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
	                        if (result.err) {
	                            return result;
	                        }
	                        // Parse another identifier for option parsing
	                        this.bumpSpace();
	                        identifierAndLocation = this.parseIdentifierIfPossible();
	                        pluralOffset = result.val;
	                    }
	                    var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
	                    if (optionsResult.err) {
	                        return optionsResult;
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_2 = createLocation(openingBracePosition, this.clonePosition());
	                    if (argType === 'select') {
	                        return {
	                            val: {
	                                type: TYPE.select,
	                                value: value,
	                                options: fromEntries(optionsResult.val),
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                    else {
	                        return {
	                            val: {
	                                type: TYPE.plural,
	                                value: value,
	                                options: fromEntries(optionsResult.val),
	                                offset: pluralOffset,
	                                pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                }
	                default:
	                    return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	            }
	        };
	        Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
	            // Parse: {value, number, ::currency/GBP }
	            //
	            if (this.isEOF() || this.char() !== 125 /* `}` */) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            this.bump(); // `}`
	            return { val: true, err: null };
	        };
	        /**
	         * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	         */
	        Parser.prototype.parseSimpleArgStyleIfPossible = function () {
	            var nestedBraces = 0;
	            var startPosition = this.clonePosition();
	            while (!this.isEOF()) {
	                var ch = this.char();
	                switch (ch) {
	                    case 39 /* `'` */: {
	                        // Treat apostrophe as quoting but include it in the style part.
	                        // Find the end of the quoted literal text.
	                        this.bump();
	                        var apostrophePosition = this.clonePosition();
	                        if (!this.bumpUntil("'")) {
	                            return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
	                        }
	                        this.bump();
	                        break;
	                    }
	                    case 123 /* `{` */: {
	                        nestedBraces += 1;
	                        this.bump();
	                        break;
	                    }
	                    case 125 /* `}` */: {
	                        if (nestedBraces > 0) {
	                            nestedBraces -= 1;
	                        }
	                        else {
	                            return {
	                                val: this.message.slice(startPosition.offset, this.offset()),
	                                err: null,
	                            };
	                        }
	                        break;
	                    }
	                    default:
	                        this.bump();
	                        break;
	                }
	            }
	            return {
	                val: this.message.slice(startPosition.offset, this.offset()),
	                err: null,
	            };
	        };
	        Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
	            var tokens = [];
	            try {
	                tokens = parseNumberSkeletonFromString(skeleton);
	            }
	            catch (e) {
	                return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
	            }
	            return {
	                val: {
	                    type: SKELETON_TYPE.number,
	                    tokens: tokens,
	                    location: location,
	                    parsedOptions: this.shouldParseSkeletons
	                        ? parseNumberSkeleton(tokens)
	                        : {},
	                },
	                err: null,
	            };
	        };
	        /**
	         * @param nesting_level The current nesting level of messages.
	         *     This can be positive when parsing message fragment in select or plural argument options.
	         * @param parent_arg_type The parent argument's type.
	         * @param parsed_first_identifier If provided, this is the first identifier-like selector of
	         *     the argument. It is a by-product of a previous parsing attempt.
	         * @param expecting_close_tag If true, this message is directly or indirectly nested inside
	         *     between a pair of opening and closing tags. The nested message will not parse beyond
	         *     the closing tag boundary.
	         */
	        Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
	            var _a;
	            var hasOtherClause = false;
	            var options = [];
	            var parsedSelectors = new Set();
	            var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
	            // Parse:
	            // one {one apple}
	            // ^--^
	            while (true) {
	                if (selector.length === 0) {
	                    var startPosition = this.clonePosition();
	                    if (parentArgType !== 'select' && this.bumpIf('=')) {
	                        // Try parse `={number}` selector
	                        var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
	                        if (result.err) {
	                            return result;
	                        }
	                        selectorLocation = createLocation(startPosition, this.clonePosition());
	                        selector = this.message.slice(startPosition.offset, this.offset());
	                    }
	                    else {
	                        break;
	                    }
	                }
	                // Duplicate selector clauses
	                if (parsedSelectors.has(selector)) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
	                        : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
	                }
	                if (selector === 'other') {
	                    hasOtherClause = true;
	                }
	                // Parse:
	                // one {one apple}
	                //     ^----------^
	                this.bumpSpace();
	                var openingBracePosition = this.clonePosition();
	                if (!this.bumpIf('{')) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
	                        : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
	                }
	                var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
	                if (fragmentResult.err) {
	                    return fragmentResult;
	                }
	                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                if (argCloseResult.err) {
	                    return argCloseResult;
	                }
	                options.push([
	                    selector,
	                    {
	                        value: fragmentResult.val,
	                        location: createLocation(openingBracePosition, this.clonePosition()),
	                    },
	                ]);
	                // Keep track of the existing selectors
	                parsedSelectors.add(selector);
	                // Prep next selector clause.
	                this.bumpSpace();
	                (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
	            }
	            if (options.length === 0) {
	                return this.error(parentArgType === 'select'
	                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
	                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
	            }
	            if (this.requiresOtherClause && !hasOtherClause) {
	                return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
	            }
	            return { val: options, err: null };
	        };
	        Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
	            var sign = 1;
	            var startingPosition = this.clonePosition();
	            if (this.bumpIf('+')) ;
	            else if (this.bumpIf('-')) {
	                sign = -1;
	            }
	            var hasDigits = false;
	            var decimal = 0;
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
	                    hasDigits = true;
	                    decimal = decimal * 10 + (ch - 48);
	                    this.bump();
	                }
	                else {
	                    break;
	                }
	            }
	            var location = createLocation(startingPosition, this.clonePosition());
	            if (!hasDigits) {
	                return this.error(expectNumberError, location);
	            }
	            decimal *= sign;
	            if (!isSafeInteger(decimal)) {
	                return this.error(invalidNumberError, location);
	            }
	            return { val: decimal, err: null };
	        };
	        Parser.prototype.offset = function () {
	            return this.position.offset;
	        };
	        Parser.prototype.isEOF = function () {
	            return this.offset() === this.message.length;
	        };
	        Parser.prototype.clonePosition = function () {
	            // This is much faster than `Object.assign` or spread.
	            return {
	                offset: this.position.offset,
	                line: this.position.line,
	                column: this.position.column,
	            };
	        };
	        /**
	         * Return the code point at the current position of the parser.
	         * Throws if the index is out of bound.
	         */
	        Parser.prototype.char = function () {
	            var offset = this.position.offset;
	            if (offset >= this.message.length) {
	                throw Error('out of bound');
	            }
	            var code = codePointAt(this.message, offset);
	            if (code === undefined) {
	                throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
	            }
	            return code;
	        };
	        Parser.prototype.error = function (kind, location) {
	            return {
	                val: null,
	                err: {
	                    kind: kind,
	                    message: this.message,
	                    location: location,
	                },
	            };
	        };
	        /** Bump the parser to the next UTF-16 code unit. */
	        Parser.prototype.bump = function () {
	            if (this.isEOF()) {
	                return;
	            }
	            var code = this.char();
	            if (code === 10 /* '\n' */) {
	                this.position.line += 1;
	                this.position.column = 1;
	                this.position.offset += 1;
	            }
	            else {
	                this.position.column += 1;
	                // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
	                this.position.offset += code < 0x10000 ? 1 : 2;
	            }
	        };
	        /**
	         * If the substring starting at the current position of the parser has
	         * the given prefix, then bump the parser to the character immediately
	         * following the prefix and return true. Otherwise, don't bump the parser
	         * and return false.
	         */
	        Parser.prototype.bumpIf = function (prefix) {
	            if (startsWith(this.message, prefix, this.offset())) {
	                for (var i = 0; i < prefix.length; i++) {
	                    this.bump();
	                }
	                return true;
	            }
	            return false;
	        };
	        /**
	         * Bump the parser until the pattern character is found and return `true`.
	         * Otherwise bump to the end of the file and return `false`.
	         */
	        Parser.prototype.bumpUntil = function (pattern) {
	            var currentOffset = this.offset();
	            var index = this.message.indexOf(pattern, currentOffset);
	            if (index >= 0) {
	                this.bumpTo(index);
	                return true;
	            }
	            else {
	                this.bumpTo(this.message.length);
	                return false;
	            }
	        };
	        /**
	         * Bump the parser to the target offset.
	         * If target offset is beyond the end of the input, bump the parser to the end of the input.
	         */
	        Parser.prototype.bumpTo = function (targetOffset) {
	            if (this.offset() > targetOffset) {
	                throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
	            }
	            targetOffset = Math.min(targetOffset, this.message.length);
	            while (true) {
	                var offset = this.offset();
	                if (offset === targetOffset) {
	                    break;
	                }
	                if (offset > targetOffset) {
	                    throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
	                }
	                this.bump();
	                if (this.isEOF()) {
	                    break;
	                }
	            }
	        };
	        /** advance the parser through all whitespace to the next non-whitespace code unit. */
	        Parser.prototype.bumpSpace = function () {
	            while (!this.isEOF() && _isWhiteSpace(this.char())) {
	                this.bump();
	            }
	        };
	        /**
	         * Peek at the *next* Unicode codepoint in the input without advancing the parser.
	         * If the input has been exhausted, then this returns null.
	         */
	        Parser.prototype.peek = function () {
	            if (this.isEOF()) {
	                return null;
	            }
	            var code = this.char();
	            var offset = this.offset();
	            var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
	            return nextCode !== null && nextCode !== void 0 ? nextCode : null;
	        };
	        return Parser;
	    }());
	    /**
	     * This check if codepoint is alphabet (lower & uppercase)
	     * @param codepoint
	     * @returns
	     */
	    function _isAlpha(codepoint) {
	        return ((codepoint >= 97 && codepoint <= 122) ||
	            (codepoint >= 65 && codepoint <= 90));
	    }
	    function _isAlphaOrSlash(codepoint) {
	        return _isAlpha(codepoint) || codepoint === 47; /* '/' */
	    }
	    /** See `parseTag` function docs. */
	    function _isPotentialElementNameChar(c) {
	        return (c === 45 /* '-' */ ||
	            c === 46 /* '.' */ ||
	            (c >= 48 && c <= 57) /* 0..9 */ ||
	            c === 95 /* '_' */ ||
	            (c >= 97 && c <= 122) /** a..z */ ||
	            (c >= 65 && c <= 90) /* A..Z */ ||
	            c == 0xb7 ||
	            (c >= 0xc0 && c <= 0xd6) ||
	            (c >= 0xd8 && c <= 0xf6) ||
	            (c >= 0xf8 && c <= 0x37d) ||
	            (c >= 0x37f && c <= 0x1fff) ||
	            (c >= 0x200c && c <= 0x200d) ||
	            (c >= 0x203f && c <= 0x2040) ||
	            (c >= 0x2070 && c <= 0x218f) ||
	            (c >= 0x2c00 && c <= 0x2fef) ||
	            (c >= 0x3001 && c <= 0xd7ff) ||
	            (c >= 0xf900 && c <= 0xfdcf) ||
	            (c >= 0xfdf0 && c <= 0xfffd) ||
	            (c >= 0x10000 && c <= 0xeffff));
	    }
	    /**
	     * Code point equivalent of regex `\p{White_Space}`.
	     * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isWhiteSpace(c) {
	        return ((c >= 0x0009 && c <= 0x000d) ||
	            c === 0x0020 ||
	            c === 0x0085 ||
	            (c >= 0x200e && c <= 0x200f) ||
	            c === 0x2028 ||
	            c === 0x2029);
	    }
	    /**
	     * Code point equivalent of regex `\p{Pattern_Syntax}`.
	     * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isPatternSyntax(c) {
	        return ((c >= 0x0021 && c <= 0x0023) ||
	            c === 0x0024 ||
	            (c >= 0x0025 && c <= 0x0027) ||
	            c === 0x0028 ||
	            c === 0x0029 ||
	            c === 0x002a ||
	            c === 0x002b ||
	            c === 0x002c ||
	            c === 0x002d ||
	            (c >= 0x002e && c <= 0x002f) ||
	            (c >= 0x003a && c <= 0x003b) ||
	            (c >= 0x003c && c <= 0x003e) ||
	            (c >= 0x003f && c <= 0x0040) ||
	            c === 0x005b ||
	            c === 0x005c ||
	            c === 0x005d ||
	            c === 0x005e ||
	            c === 0x0060 ||
	            c === 0x007b ||
	            c === 0x007c ||
	            c === 0x007d ||
	            c === 0x007e ||
	            c === 0x00a1 ||
	            (c >= 0x00a2 && c <= 0x00a5) ||
	            c === 0x00a6 ||
	            c === 0x00a7 ||
	            c === 0x00a9 ||
	            c === 0x00ab ||
	            c === 0x00ac ||
	            c === 0x00ae ||
	            c === 0x00b0 ||
	            c === 0x00b1 ||
	            c === 0x00b6 ||
	            c === 0x00bb ||
	            c === 0x00bf ||
	            c === 0x00d7 ||
	            c === 0x00f7 ||
	            (c >= 0x2010 && c <= 0x2015) ||
	            (c >= 0x2016 && c <= 0x2017) ||
	            c === 0x2018 ||
	            c === 0x2019 ||
	            c === 0x201a ||
	            (c >= 0x201b && c <= 0x201c) ||
	            c === 0x201d ||
	            c === 0x201e ||
	            c === 0x201f ||
	            (c >= 0x2020 && c <= 0x2027) ||
	            (c >= 0x2030 && c <= 0x2038) ||
	            c === 0x2039 ||
	            c === 0x203a ||
	            (c >= 0x203b && c <= 0x203e) ||
	            (c >= 0x2041 && c <= 0x2043) ||
	            c === 0x2044 ||
	            c === 0x2045 ||
	            c === 0x2046 ||
	            (c >= 0x2047 && c <= 0x2051) ||
	            c === 0x2052 ||
	            c === 0x2053 ||
	            (c >= 0x2055 && c <= 0x205e) ||
	            (c >= 0x2190 && c <= 0x2194) ||
	            (c >= 0x2195 && c <= 0x2199) ||
	            (c >= 0x219a && c <= 0x219b) ||
	            (c >= 0x219c && c <= 0x219f) ||
	            c === 0x21a0 ||
	            (c >= 0x21a1 && c <= 0x21a2) ||
	            c === 0x21a3 ||
	            (c >= 0x21a4 && c <= 0x21a5) ||
	            c === 0x21a6 ||
	            (c >= 0x21a7 && c <= 0x21ad) ||
	            c === 0x21ae ||
	            (c >= 0x21af && c <= 0x21cd) ||
	            (c >= 0x21ce && c <= 0x21cf) ||
	            (c >= 0x21d0 && c <= 0x21d1) ||
	            c === 0x21d2 ||
	            c === 0x21d3 ||
	            c === 0x21d4 ||
	            (c >= 0x21d5 && c <= 0x21f3) ||
	            (c >= 0x21f4 && c <= 0x22ff) ||
	            (c >= 0x2300 && c <= 0x2307) ||
	            c === 0x2308 ||
	            c === 0x2309 ||
	            c === 0x230a ||
	            c === 0x230b ||
	            (c >= 0x230c && c <= 0x231f) ||
	            (c >= 0x2320 && c <= 0x2321) ||
	            (c >= 0x2322 && c <= 0x2328) ||
	            c === 0x2329 ||
	            c === 0x232a ||
	            (c >= 0x232b && c <= 0x237b) ||
	            c === 0x237c ||
	            (c >= 0x237d && c <= 0x239a) ||
	            (c >= 0x239b && c <= 0x23b3) ||
	            (c >= 0x23b4 && c <= 0x23db) ||
	            (c >= 0x23dc && c <= 0x23e1) ||
	            (c >= 0x23e2 && c <= 0x2426) ||
	            (c >= 0x2427 && c <= 0x243f) ||
	            (c >= 0x2440 && c <= 0x244a) ||
	            (c >= 0x244b && c <= 0x245f) ||
	            (c >= 0x2500 && c <= 0x25b6) ||
	            c === 0x25b7 ||
	            (c >= 0x25b8 && c <= 0x25c0) ||
	            c === 0x25c1 ||
	            (c >= 0x25c2 && c <= 0x25f7) ||
	            (c >= 0x25f8 && c <= 0x25ff) ||
	            (c >= 0x2600 && c <= 0x266e) ||
	            c === 0x266f ||
	            (c >= 0x2670 && c <= 0x2767) ||
	            c === 0x2768 ||
	            c === 0x2769 ||
	            c === 0x276a ||
	            c === 0x276b ||
	            c === 0x276c ||
	            c === 0x276d ||
	            c === 0x276e ||
	            c === 0x276f ||
	            c === 0x2770 ||
	            c === 0x2771 ||
	            c === 0x2772 ||
	            c === 0x2773 ||
	            c === 0x2774 ||
	            c === 0x2775 ||
	            (c >= 0x2794 && c <= 0x27bf) ||
	            (c >= 0x27c0 && c <= 0x27c4) ||
	            c === 0x27c5 ||
	            c === 0x27c6 ||
	            (c >= 0x27c7 && c <= 0x27e5) ||
	            c === 0x27e6 ||
	            c === 0x27e7 ||
	            c === 0x27e8 ||
	            c === 0x27e9 ||
	            c === 0x27ea ||
	            c === 0x27eb ||
	            c === 0x27ec ||
	            c === 0x27ed ||
	            c === 0x27ee ||
	            c === 0x27ef ||
	            (c >= 0x27f0 && c <= 0x27ff) ||
	            (c >= 0x2800 && c <= 0x28ff) ||
	            (c >= 0x2900 && c <= 0x2982) ||
	            c === 0x2983 ||
	            c === 0x2984 ||
	            c === 0x2985 ||
	            c === 0x2986 ||
	            c === 0x2987 ||
	            c === 0x2988 ||
	            c === 0x2989 ||
	            c === 0x298a ||
	            c === 0x298b ||
	            c === 0x298c ||
	            c === 0x298d ||
	            c === 0x298e ||
	            c === 0x298f ||
	            c === 0x2990 ||
	            c === 0x2991 ||
	            c === 0x2992 ||
	            c === 0x2993 ||
	            c === 0x2994 ||
	            c === 0x2995 ||
	            c === 0x2996 ||
	            c === 0x2997 ||
	            c === 0x2998 ||
	            (c >= 0x2999 && c <= 0x29d7) ||
	            c === 0x29d8 ||
	            c === 0x29d9 ||
	            c === 0x29da ||
	            c === 0x29db ||
	            (c >= 0x29dc && c <= 0x29fb) ||
	            c === 0x29fc ||
	            c === 0x29fd ||
	            (c >= 0x29fe && c <= 0x2aff) ||
	            (c >= 0x2b00 && c <= 0x2b2f) ||
	            (c >= 0x2b30 && c <= 0x2b44) ||
	            (c >= 0x2b45 && c <= 0x2b46) ||
	            (c >= 0x2b47 && c <= 0x2b4c) ||
	            (c >= 0x2b4d && c <= 0x2b73) ||
	            (c >= 0x2b74 && c <= 0x2b75) ||
	            (c >= 0x2b76 && c <= 0x2b95) ||
	            c === 0x2b96 ||
	            (c >= 0x2b97 && c <= 0x2bff) ||
	            (c >= 0x2e00 && c <= 0x2e01) ||
	            c === 0x2e02 ||
	            c === 0x2e03 ||
	            c === 0x2e04 ||
	            c === 0x2e05 ||
	            (c >= 0x2e06 && c <= 0x2e08) ||
	            c === 0x2e09 ||
	            c === 0x2e0a ||
	            c === 0x2e0b ||
	            c === 0x2e0c ||
	            c === 0x2e0d ||
	            (c >= 0x2e0e && c <= 0x2e16) ||
	            c === 0x2e17 ||
	            (c >= 0x2e18 && c <= 0x2e19) ||
	            c === 0x2e1a ||
	            c === 0x2e1b ||
	            c === 0x2e1c ||
	            c === 0x2e1d ||
	            (c >= 0x2e1e && c <= 0x2e1f) ||
	            c === 0x2e20 ||
	            c === 0x2e21 ||
	            c === 0x2e22 ||
	            c === 0x2e23 ||
	            c === 0x2e24 ||
	            c === 0x2e25 ||
	            c === 0x2e26 ||
	            c === 0x2e27 ||
	            c === 0x2e28 ||
	            c === 0x2e29 ||
	            (c >= 0x2e2a && c <= 0x2e2e) ||
	            c === 0x2e2f ||
	            (c >= 0x2e30 && c <= 0x2e39) ||
	            (c >= 0x2e3a && c <= 0x2e3b) ||
	            (c >= 0x2e3c && c <= 0x2e3f) ||
	            c === 0x2e40 ||
	            c === 0x2e41 ||
	            c === 0x2e42 ||
	            (c >= 0x2e43 && c <= 0x2e4f) ||
	            (c >= 0x2e50 && c <= 0x2e51) ||
	            c === 0x2e52 ||
	            (c >= 0x2e53 && c <= 0x2e7f) ||
	            (c >= 0x3001 && c <= 0x3003) ||
	            c === 0x3008 ||
	            c === 0x3009 ||
	            c === 0x300a ||
	            c === 0x300b ||
	            c === 0x300c ||
	            c === 0x300d ||
	            c === 0x300e ||
	            c === 0x300f ||
	            c === 0x3010 ||
	            c === 0x3011 ||
	            (c >= 0x3012 && c <= 0x3013) ||
	            c === 0x3014 ||
	            c === 0x3015 ||
	            c === 0x3016 ||
	            c === 0x3017 ||
	            c === 0x3018 ||
	            c === 0x3019 ||
	            c === 0x301a ||
	            c === 0x301b ||
	            c === 0x301c ||
	            c === 0x301d ||
	            (c >= 0x301e && c <= 0x301f) ||
	            c === 0x3020 ||
	            c === 0x3030 ||
	            c === 0xfd3e ||
	            c === 0xfd3f ||
	            (c >= 0xfe45 && c <= 0xfe46));
	    }

	    function pruneLocation(els) {
	        els.forEach(function (el) {
	            delete el.location;
	            if (isSelectElement(el) || isPluralElement(el)) {
	                for (var k in el.options) {
	                    delete el.options[k].location;
	                    pruneLocation(el.options[k].value);
	                }
	            }
	            else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
	                delete el.style.location;
	            }
	            else if ((isDateElement(el) || isTimeElement(el)) &&
	                isDateTimeSkeleton(el.style)) {
	                delete el.style.location;
	            }
	            else if (isTagElement(el)) {
	                pruneLocation(el.children);
	            }
	        });
	    }
	    function parse$1(message, opts) {
	        if (opts === void 0) { opts = {}; }
	        opts = __assign$1({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
	        var result = new Parser(message, opts).parse();
	        if (result.err) {
	            var error = SyntaxError(ErrorKind[result.err.kind]);
	            // @ts-expect-error Assign to error object
	            error.location = result.err.location;
	            // @ts-expect-error Assign to error object
	            error.originalMessage = result.err.message;
	            throw error;
	        }
	        if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
	            pruneLocation(result.val);
	        }
	        return result.val;
	    }

	    //
	    // Main
	    //
	    function memoize$1(fn, options) {
	        var cache = options && options.cache ? options.cache : cacheDefault;
	        var serializer = options && options.serializer ? options.serializer : serializerDefault;
	        var strategy = options && options.strategy ? options.strategy : strategyDefault;
	        return strategy(fn, {
	            cache: cache,
	            serializer: serializer,
	        });
	    }
	    //
	    // Strategy
	    //
	    function isPrimitive(value) {
	        return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
	    }
	    function monadic(fn, cache, serializer, arg) {
	        var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.call(this, arg);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function variadic(fn, cache, serializer) {
	        var args = Array.prototype.slice.call(arguments, 3);
	        var cacheKey = serializer(args);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.apply(this, args);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function assemble(fn, context, strategy, cache, serialize) {
	        return strategy.bind(context, fn, cache, serialize);
	    }
	    function strategyDefault(fn, options) {
	        var strategy = fn.length === 1 ? monadic : variadic;
	        return assemble(fn, this, strategy, options.cache.create(), options.serializer);
	    }
	    function strategyVariadic(fn, options) {
	        return assemble(fn, this, variadic, options.cache.create(), options.serializer);
	    }
	    function strategyMonadic(fn, options) {
	        return assemble(fn, this, monadic, options.cache.create(), options.serializer);
	    }
	    //
	    // Serializer
	    //
	    var serializerDefault = function () {
	        return JSON.stringify(arguments);
	    };
	    //
	    // Cache
	    //
	    function ObjectWithoutPrototypeCache() {
	        this.cache = Object.create(null);
	    }
	    ObjectWithoutPrototypeCache.prototype.get = function (key) {
	        return this.cache[key];
	    };
	    ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	        this.cache[key] = value;
	    };
	    var cacheDefault = {
	        create: function create() {
	            // @ts-ignore
	            return new ObjectWithoutPrototypeCache();
	        },
	    };
	    var strategies = {
	        variadic: strategyVariadic,
	        monadic: strategyMonadic,
	    };

	    var ErrorCode;
	    (function (ErrorCode) {
	        // When we have a placeholder but no value to format
	        ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
	        // When value supplied is invalid
	        ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
	        // When we need specific Intl API but it's not available
	        ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
	    })(ErrorCode || (ErrorCode = {}));
	    var FormatError = /** @class */ (function (_super) {
	        __extends(FormatError, _super);
	        function FormatError(msg, code, originalMessage) {
	            var _this = _super.call(this, msg) || this;
	            _this.code = code;
	            _this.originalMessage = originalMessage;
	            return _this;
	        }
	        FormatError.prototype.toString = function () {
	            return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
	        };
	        return FormatError;
	    }(Error));
	    var InvalidValueError = /** @class */ (function (_super) {
	        __extends(InvalidValueError, _super);
	        function InvalidValueError(variableId, value, options, originalMessage) {
	            return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueError;
	    }(FormatError));
	    var InvalidValueTypeError = /** @class */ (function (_super) {
	        __extends(InvalidValueTypeError, _super);
	        function InvalidValueTypeError(value, type, originalMessage) {
	            return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueTypeError;
	    }(FormatError));
	    var MissingValueError = /** @class */ (function (_super) {
	        __extends(MissingValueError, _super);
	        function MissingValueError(variableId, originalMessage) {
	            return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
	        }
	        return MissingValueError;
	    }(FormatError));

	    var PART_TYPE;
	    (function (PART_TYPE) {
	        PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
	        PART_TYPE[PART_TYPE["object"] = 1] = "object";
	    })(PART_TYPE || (PART_TYPE = {}));
	    function mergeLiteral(parts) {
	        if (parts.length < 2) {
	            return parts;
	        }
	        return parts.reduce(function (all, part) {
	            var lastPart = all[all.length - 1];
	            if (!lastPart ||
	                lastPart.type !== PART_TYPE.literal ||
	                part.type !== PART_TYPE.literal) {
	                all.push(part);
	            }
	            else {
	                lastPart.value += part.value;
	            }
	            return all;
	        }, []);
	    }
	    function isFormatXMLElementFn(el) {
	        return typeof el === 'function';
	    }
	    // TODO(skeleton): add skeleton support
	    function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
	    // For debugging
	    originalMessage) {
	        // Hot path for straight simple msg translations
	        if (els.length === 1 && isLiteralElement(els[0])) {
	            return [
	                {
	                    type: PART_TYPE.literal,
	                    value: els[0].value,
	                },
	            ];
	        }
	        var result = [];
	        for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	            var el = els_1[_i];
	            // Exit early for string parts.
	            if (isLiteralElement(el)) {
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: el.value,
	                });
	                continue;
	            }
	            // TODO: should this part be literal type?
	            // Replace `#` in plural rules with the actual numeric value.
	            if (isPoundElement(el)) {
	                if (typeof currentPluralValue === 'number') {
	                    result.push({
	                        type: PART_TYPE.literal,
	                        value: formatters.getNumberFormat(locales).format(currentPluralValue),
	                    });
	                }
	                continue;
	            }
	            var varName = el.value;
	            // Enforce that all required values are provided by the caller.
	            if (!(values && varName in values)) {
	                throw new MissingValueError(varName, originalMessage);
	            }
	            var value = values[varName];
	            if (isArgumentElement(el)) {
	                if (!value || typeof value === 'string' || typeof value === 'number') {
	                    value =
	                        typeof value === 'string' || typeof value === 'number'
	                            ? String(value)
	                            : '';
	                }
	                result.push({
	                    type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                    value: value,
	                });
	                continue;
	            }
	            // Recursively format plural and select parts' option — which can be a
	            // nested pattern structure. The choosing of the option to use is
	            // abstracted-by and delegated-to the part helper object.
	            if (isDateElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.date[el.style]
	                    : isDateTimeSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTimeElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.time[el.style]
	                    : isDateTimeSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : formats.time.medium;
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isNumberElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.number[el.style]
	                    : isNumberSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                if (style && style.scale) {
	                    value =
	                        value *
	                            (style.scale || 1);
	                }
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getNumberFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTagElement(el)) {
	                var children = el.children, value_1 = el.value;
	                var formatFn = values[value_1];
	                if (!isFormatXMLElementFn(formatFn)) {
	                    throw new InvalidValueTypeError(value_1, 'function', originalMessage);
	                }
	                var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
	                var chunks = formatFn(parts.map(function (p) { return p.value; }));
	                if (!Array.isArray(chunks)) {
	                    chunks = [chunks];
	                }
	                result.push.apply(result, chunks.map(function (c) {
	                    return {
	                        type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                        value: c,
	                    };
	                }));
	            }
	            if (isSelectElement(el)) {
	                var opt = el.options[value] || el.options.other;
	                if (!opt) {
	                    throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
	                continue;
	            }
	            if (isPluralElement(el)) {
	                var opt = el.options["=".concat(value)];
	                if (!opt) {
	                    if (!Intl.PluralRules) {
	                        throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
	                    }
	                    var rule = formatters
	                        .getPluralRules(locales, { type: el.pluralType })
	                        .select(value - (el.offset || 0));
	                    opt = el.options[rule] || el.options.other;
	                }
	                if (!opt) {
	                    throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
	                continue;
	            }
	        }
	        return mergeLiteral(result);
	    }

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    // -- MessageFormat --------------------------------------------------------
	    function mergeConfig(c1, c2) {
	        if (!c2) {
	            return c1;
	        }
	        return __assign$2(__assign$2(__assign$2({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
	            all[k] = __assign$2(__assign$2({}, c1[k]), (c2[k] || {}));
	            return all;
	        }, {}));
	    }
	    function mergeConfigs(defaultConfig, configs) {
	        if (!configs) {
	            return defaultConfig;
	        }
	        return Object.keys(defaultConfig).reduce(function (all, k) {
	            all[k] = mergeConfig(defaultConfig[k], configs[k]);
	            return all;
	        }, __assign$2({}, defaultConfig));
	    }
	    function createFastMemoizeCache(store) {
	        return {
	            create: function () {
	                return {
	                    get: function (key) {
	                        return store[key];
	                    },
	                    set: function (key, value) {
	                        store[key] = value;
	                    },
	                };
	            },
	        };
	    }
	    function createDefaultFormatters(cache) {
	        if (cache === void 0) { cache = {
	            number: {},
	            dateTime: {},
	            pluralRules: {},
	        }; }
	        return {
	            getNumberFormat: memoize$1(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.number),
	                strategy: strategies.variadic,
	            }),
	            getDateTimeFormat: memoize$1(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.dateTime),
	                strategy: strategies.variadic,
	            }),
	            getPluralRules: memoize$1(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.pluralRules),
	                strategy: strategies.variadic,
	            }),
	        };
	    }
	    var IntlMessageFormat = /** @class */ (function () {
	        function IntlMessageFormat(message, locales, overrideFormats, opts) {
	            var _this = this;
	            if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
	            this.formatterCache = {
	                number: {},
	                dateTime: {},
	                pluralRules: {},
	            };
	            this.format = function (values) {
	                var parts = _this.formatToParts(values);
	                // Hot path for straight simple msg translations
	                if (parts.length === 1) {
	                    return parts[0].value;
	                }
	                var result = parts.reduce(function (all, part) {
	                    if (!all.length ||
	                        part.type !== PART_TYPE.literal ||
	                        typeof all[all.length - 1] !== 'string') {
	                        all.push(part.value);
	                    }
	                    else {
	                        all[all.length - 1] += part.value;
	                    }
	                    return all;
	                }, []);
	                if (result.length <= 1) {
	                    return result[0] || '';
	                }
	                return result;
	            };
	            this.formatToParts = function (values) {
	                return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
	            };
	            this.resolvedOptions = function () { return ({
	                locale: _this.resolvedLocale.toString(),
	            }); };
	            this.getAst = function () { return _this.ast; };
	            // Defined first because it's used to build the format pattern.
	            this.locales = locales;
	            this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
	            if (typeof message === 'string') {
	                this.message = message;
	                if (!IntlMessageFormat.__parse) {
	                    throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
	                }
	                // Parse string messages into an AST.
	                this.ast = IntlMessageFormat.__parse(message, {
	                    ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
	                    locale: this.resolvedLocale,
	                });
	            }
	            else {
	                this.ast = message;
	            }
	            if (!Array.isArray(this.ast)) {
	                throw new TypeError('A message must be provided as a String or AST.');
	            }
	            // Creates a new object with the specified `formats` merged with the default
	            // formats.
	            this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
	            this.formatters =
	                (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
	        }
	        Object.defineProperty(IntlMessageFormat, "defaultLocale", {
	            get: function () {
	                if (!IntlMessageFormat.memoizedDefaultLocale) {
	                    IntlMessageFormat.memoizedDefaultLocale =
	                        new Intl.NumberFormat().resolvedOptions().locale;
	                }
	                return IntlMessageFormat.memoizedDefaultLocale;
	            },
	            enumerable: false,
	            configurable: true
	        });
	        IntlMessageFormat.memoizedDefaultLocale = null;
	        IntlMessageFormat.resolveLocale = function (locales) {
	            var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
	            if (supportedLocales.length > 0) {
	                return new Intl.Locale(supportedLocales[0]);
	            }
	            return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
	        };
	        IntlMessageFormat.__parse = parse$1;
	        // Default format options used as the prototype of the `formats` provided to the
	        // constructor. These are used when constructing the internal Intl.NumberFormat
	        // and Intl.DateTimeFormat instances.
	        IntlMessageFormat.formats = {
	            number: {
	                integer: {
	                    maximumFractionDigits: 0,
	                },
	                currency: {
	                    style: 'currency',
	                },
	                percent: {
	                    style: 'percent',
	                },
	            },
	            date: {
	                short: {
	                    month: 'numeric',
	                    day: 'numeric',
	                    year: '2-digit',
	                },
	                medium: {
	                    month: 'short',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                long: {
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                full: {
	                    weekday: 'long',
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	            },
	            time: {
	                short: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                },
	                medium: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                },
	                long: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	                full: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	            },
	        };
	        return IntlMessageFormat;
	    }());

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    var o = IntlMessageFormat;

	    const r={},i=(e,n,t)=>t?(n in r||(r[n]={}),e in r[n]||(r[n][e]=t),t):t,a=(e,n)=>{if(null==n)return;if(n in r&&e in r[n])return r[n][e];const t=E(n);for(let o=0;o<t.length;o++){const r=c(t[o],e);if(r)return i(e,n,r)}};let l;const s=writable({});function u(e){return e in l}function c(e,n){if(!u(e))return null;return function(e,n){if(n in e)return e[n];const t=n.split(".");let o=e;for(let e=0;e<t.length;e++)if("object"==typeof o){if(e>0){const n=t.slice(e,t.length).join(".");if(n in o){o=o[n];break}}o=o[t[e]];}else o=void 0;return o}(function(e){return l[e]||null}(e),n)}function m(e,...n){delete r[e],s.update((o=>(o[e]=cjs.all([o[e]||{},...n]),o)));}derived([s],(([e])=>Object.keys(e)));s.subscribe((e=>l=e));const d={};function g(e){return d[e]}function w(e){return E(e).some((e=>{var n;return null===(n=g(e))||void 0===n?void 0:n.size}))}function h(e,n){return Promise.all(n.map((n=>(function(e,n){d[e].delete(n),0===d[e].size&&delete d[e];}(e,n),n().then((e=>e.default||e)))))).then((n=>m(e,...n)))}const p={};function b(e){if(!w(e))return e in p?p[e]:void 0;const n=function(e){return E(e).map((e=>{const n=g(e);return [e,n?[...n]:[]]})).filter((([,e])=>e.length>0))}(e);return p[e]=Promise.all(n.map((([e,n])=>h(e,n)))).then((()=>{if(w(e))return b(e);delete p[e];})),p[e]}/*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */function v(e,n){var t={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&n.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)n.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(t[o[r]]=e[o[r]]);}return t}const O={fallbackLocale:null,initialLocale:null,loadingDelay:200,formats:{number:{scientific:{notation:"scientific"},engineering:{notation:"engineering"},compactLong:{notation:"compact",compactDisplay:"long"},compactShort:{notation:"compact",compactDisplay:"short"}},date:{short:{month:"numeric",day:"numeric",year:"2-digit"},medium:{month:"short",day:"numeric",year:"numeric"},long:{month:"long",day:"numeric",year:"numeric"},full:{weekday:"long",month:"long",day:"numeric",year:"numeric"}},time:{short:{hour:"numeric",minute:"numeric"},medium:{hour:"numeric",minute:"numeric",second:"numeric"},long:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"},full:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"}}},warnOnMissingMessages:!0,ignoreTag:!0};function j(){return O}function $(e){const{formats:n}=e,t=v(e,["formats"]),o=e.initialLocale||e.fallbackLocale;return Object.assign(O,t,{initialLocale:o}),n&&("number"in n&&Object.assign(O.formats.number,n.number),"date"in n&&Object.assign(O.formats.date,n.date),"time"in n&&Object.assign(O.formats.time,n.time)),T.set(o)}const k=writable(!1);let L;const T=writable(null);function x(e){return e.split("-").map(((e,n,t)=>t.slice(0,n+1).join("-"))).reverse()}function E(e,n=j().fallbackLocale){const t=x(e);return n?[...new Set([...t,...x(n)])]:t}function D(){return L}T.subscribe((e=>{L=e,"undefined"!=typeof window&&null!==e&&document.documentElement.setAttribute("lang",e);}));const M=T.set;T.set=e=>{if(function(e){if(null==e)return;const n=E(e);for(let e=0;e<n.length;e++){const t=n[e];if(u(t))return t}}(e)&&w(e)){const{loadingDelay:n}=j();let t;return "undefined"!=typeof window&&null!=D()&&n?t=window.setTimeout((()=>k.set(!0)),n):k.set(!0),b(e).then((()=>{M(e);})).finally((()=>{clearTimeout(t),k.set(!1);}))}return M(e)},T.update=e=>M(e(L));const Z=e=>{const n=Object.create(null);return t=>{const o=JSON.stringify(t);return o in n?n[o]:n[o]=e(t)}},C=(e,n)=>{const{formats:t}=j();if(e in t&&n in t[e])return t[e][n];throw new Error(`[svelte-i18n] Unknown "${n}" ${e} format.`)},G=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format numbers');return t&&(o=C("number",t)),new Intl.NumberFormat(n,o)})),J=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format dates');return t?o=C("date",t):0===Object.keys(o).length&&(o=C("date","short")),new Intl.DateTimeFormat(n,o)})),U=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format time values');return t?o=C("time",t):0===Object.keys(o).length&&(o=C("time","short")),new Intl.DateTimeFormat(n,o)})),_=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return G(Object.assign({locale:n},t))},q=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return J(Object.assign({locale:n},t))},B=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return U(Object.assign({locale:n},t))},H=Z(((e,n=D())=>new o(e,n,j().formats,{ignoreTag:j().ignoreTag}))),K=(e,n={})=>{"object"==typeof e&&(e=(n=e).id);const{values:t,locale:o=D(),default:r}=n;if(null==o)throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");let i=a(e,o);if(i){if("string"!=typeof i)return console.warn(`[svelte-i18n] Message with id "${e}" must be of type "string", found: "${typeof i}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`),i}else j().warnOnMissingMessages&&console.warn(`[svelte-i18n] The message "${e}" was not found in "${E(o).join('", "')}".${w(D())?"\n\nNote: there are at least one loader still registered to this locale that wasn't executed.":""}`),i=r||e;if(!t)return i;let l=i;try{l=H(i,o).format(t);}catch(n){console.warn(`[svelte-i18n] Message "${e}" has syntax error:`,n.message);}return l},Q=(e,n)=>B(n).format(e),R=(e,n)=>q(n).format(e),V=(e,n)=>_(n).format(e),W=(e,n=D())=>a(e,n),X=derived([T,s],(()=>K));derived([T],(()=>Q));derived([T],(()=>R));derived([T],(()=>V));derived([T,s],(()=>W));

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var de = {
	      browser: "Durchsuchen",
	      random: "Zufällig",
	      invalidColor: "Ungültige Farbe",
	      today: "Heute",
	      nextMonth: 'Nächster Monat',
	      prevMonth: 'Vorheriger Monat',
	      nextYear: 'Nächstes Jahr',
	      prevYear: 'Vorheriges Jahr',
	      selectDate: "Datum auswählen",
	      validateTooManyFiles: "Zu viele Dateien (maximal {0} Dateien zulässig)",
	      validateTooLong: "Zu lang",
	      validateFileNameTooLong: "Dateiname zu lang (maximal {0} Zeichen zulässig)",
	      validateRequired: "Erforderliches Feld",
	      validateNotANumber: "Keine Zahl",
	      validateLessThanMin: "Die Zahl ist kleiner als das Minimum ({0})",
	      validateMoreThanMax: "Die Zahl ist größer als das Maximum ({0})",
	      validateNotAStepValue: "Kein gültiges Inkrement ({0})",
	      validateColor: "Nicht festgelegt",
	      validateRegex: "Ungültiges Format",
	      validateDate: "Ungültiges Datum (MM/TT/JJJJ)",
	      noSuggestions: "Keine Vorschläge",
	      noValues: "[Keine Werte]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var en$1 = {
	      browser: "Browse",
	      random: "Random",
	      invalidColor: "Invalid Color",
	      today: "Today",
	      nextMonth: 'Next Month',
	      prevMonth: 'Previous Month',
	      nextYear: 'Next Year',
	      prevYear: 'Previous Year',
	      selectDate: "Select Date",
	      validateTooManyFiles: "Too many files ({0} files maximum)",
	      validateTooLong: "Too long",
	      validateFileNameTooLong: "File name too long ({0} characters maximum)",
	      validateRequired: "Required field",
	      validateNotANumber: "Not a number",
	      validateLessThanMin: "Number is less than minimum ({0})",
	      validateMoreThanMax: "Number is more than maximum ({0})",
	      validateNotAStepValue: "Not a valid increment ({0})",
	      validateColor: "Not set",
	      validateRegex: "Invalid Format",
	      validateDate: "Invalid Date (MM/DD/YYYY)",
	      noSuggestions: "No Suggestions",
	      noValues: "[No Values]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var es = {
	      browser: "Examinar",
	      random: "Aleatoria",
	      invalidColor: "Color no válido",
	      today: "Hoy",
	      nextMonth: 'Siguiente mes',
	      prevMonth: 'Mes anterior',
	      nextYear: 'Siguiente año',
	      prevYear: 'Años anterior',
	      selectDate: "Seleccionar fecha",
	      validateTooManyFiles: "Demasiados archivos ({0} archivos máximo)",
	      validateTooLong: "Demasiado largo",
	      validateFileNameTooLong: "Nombre de archivo demasiado largo ({0} caracteres máximo)",
	      validateRequired: "Campo obligatorio",
	      validateNotANumber: "No un número",
	      validateLessThanMin: "El número es inferior al mínimo ({0})",
	      validateMoreThanMax: "El número es superior al máximo ({0})",
	      validateNotAStepValue: "Incremento no válido ({0})",
	      validateColor: "No establecido",
	      validateRegex: "Formato no válido",
	      validateDate: "Fecha no válida (MM/DD/YYYY)",
	      noSuggestions: "Sin sugerencias",
	      noValues: "[Sin valores]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var fr = {
	      browser: "Sfoglia",
	      random: "Casuale",
	      invalidColor: "Colore non valido",
	      today: "Oggi",
	      nextMonth: 'Mese successivo',
	      prevMonth: 'Mese precedente',
	      nextYear: 'Anno prossimo',
	      prevYear: 'Anno precedente',
	      selectDate: "Seleziona data",
	      validateTooManyFiles: "Troppi file (massimo {0} file)",
	      validateTooLong: "Troppo lungo",
	      validateFileNameTooLong: "Nome del file troppo lungo (massimo {0} caratteri)",
	      validateRequired: "Campo obbligatorio",
	      validateNotANumber: "Non un numero",
	      validateLessThanMin: "Numero inferiore al minimo ({0})",
	      validateMoreThanMax: "Number superiore al massimo ({0})",
	      validateNotAStepValue: "Incremento non valido ({0})",
	      validateColor: "Non definito",
	      validateRegex: "Formato non valido",
	      validateDate: "Data non valida (MM/GG/AAAA)",
	      noSuggestions: "Nessun suggerimento",
	      noValues: "[No Values]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var it = {
	      browser: "Sfoglia",
	      random: "Casuale",
	      invalidColor: "Colore non valido",
	      today: "Oggi",
	      selectDate: "Seleziona data",
	      validateTooManyFiles: "Troppi file ({0} file al massimo)",
	      validateTooLong: "Troppo lungo",
	      validateFileNameTooLong: "Nome file troppo lungo ({0} caratteri max)",
	      validateRequired: "Campo richiesto",
	      validateNotANumber: "Non è un numero",
	      validateLessThanMin: "Numero inferiore al minimo ({0})",
	      validateMoreThanMax: "Numero maggiore del massimo ({0})",
	      validateNotAStepValue: "Incremento non valido ({0})",
	      validateColor: "Non impostato",
	      validateRegex: "Formato non valido",
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ja = {
	      browser: "参照",
	      random: "ランダム",
	      invalidColor: "無効な色",
	      today: "本日",
	      nextMonth: '来月',
	      prevMonth: '先月',
	      nextYear: '来年',
	      prevYear: '前年',
	      selectDate: "日付を選択",
	      validateTooManyFiles: "ファイルが多すぎます（最大{0}ファイル）",
	      validateTooLong: "長すぎます",
	      validateFileNameTooLong: "ファイル名が長すぎます（最大{0}文字）",
	      validateRequired: "必須フィールド",
	      validateNotANumber: "数値ではありません",
	      validateLessThanMin: "数値は最小値（{0}）未満です",
	      validateMoreThanMax: "数値は最大値（{0}）以上です",
	      validateNotAStepValue: "増分が有効ではありません（{0}）",
	      validateColor: "未設定",
	      validateRegex: "無効なフォーマット",
	      validateDate: "無効な日付（YYYY/MM/DD）",
	      noSuggestions: "提案なし",
	      noValues: "[値なし]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ko = {
	      browser: "찾아보기",
	      random: "임의",
	      invalidColor: "잘못된 색상",
	      today: "오늘",
	      nextMonth: '다음 달',
	      prevMonth: '지난 달',
	      nextYear: '다음 해',
	      prevYear: '지난 해',
	      selectDate: "날짜 선택",
	      validateTooManyFiles: "파일이 너무 많음(최대 {0}개 파일)",
	      validateTooLong: "너무 김",
	      validateFileNameTooLong: "파일 이름이 너무 깁니다(최대 {0}자).",
	      validateRequired: "필수 필드",
	      validateNotANumber: "숫자가 아님",
	      validateLessThanMin: "숫자가 최소값({0})보다 작음",
	      validateMoreThanMax: "숫자가 최대값({0})보다 큼",
	      validateNotAStepValue: "유효한 증분({0})이 아님",
	      validateColor: "설정되지 않음",
	      validateRegex: "잘못된 형식",
	      validateDate: "잘못된 날짜(MM/DD/YYYY)",
	      noSuggestions: "제안 없음",
	      noValues: "[값 없음]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var pt = {
	      browser: "Navegar",
	      random: "Aleatório",
	      invalidColor: "Cor inválida",
	      today: "Hoje",
	      nextMonth: 'Próximo mês',
	      prevMonth: 'Mês anterior',
	      nextYear: 'Próximo ano',
	      prevYear: 'Ano anterior',
	      selectDate: "Selecione a data",
	      validateTooManyFiles: "Muitos arquivos (máximo de {0} arquivos)",
	      validateTooLong: "Muito longo",
	      validateFileNameTooLong: "Nome do arquivo muito longo (máximo de {0} caracteres)",
	      validateRequired: "Campo obrigatório",
	      validateNotANumber: "Não é um número",
	      validateLessThanMin: "O número é menor que o mínimo ({0})",
	      validateMoreThanMax: "O número é maior que o máximo ({0})",
	      validateNotAStepValue: "Não é um incremento válido ({0})",
	      validateColor: "Não configurado",
	      validateRegex: "Formato inválido",
	      validateDate: "Data inválida (MM/DD/AAAA)",
	      noSuggestions: "Nenhuma sugestão",
	      noValues: "[Sem valores]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ru = {
	      browser: "Обзор",
	      random: "Случайный",
	      invalidColor: "Недопустимый цвет",
	      today: "Сегодня",
	      nextMonth: 'Следующий месяц',
	      prevMonth: 'Предыдущий месяц',
	      nextYear: 'Следующий год',
	      prevYear: 'Предыдущий год',
	      selectDate: "Выбрать дату",
	      validateTooManyFiles: "Слишком много файлов (макс. число файлов - {0})",
	      validateTooLong: "Слишком длинное",
	      validateFileNameTooLong: "Слишком длинное имя файла (макс. число символов - {0})",
	      validateRequired: "Обязательно для заполнения",
	      validateNotANumber: "Не число",
	      validateLessThanMin: "Число меньше минимального ({0})",
	      validateMoreThanMax: "Число больше максимального ({0})",
	      validateNotAStepValue: "Недопустимое приращение ({0})",
	      validateColor: "Не задано",
	      validateRegex: "Недопустимый формат",
	      validateDate: "Недопустимая дата (ММ/ДД/ГГГГ)",
	      noSuggestions: "Нет предложений",
	      noValues: "[Нет значений]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var zh = {
	      browser: "Parcourir",
	      random: "Aléatoire",
	      invalidColor: "Couleur non valide",
	      today: "Aujourd'hui",
	      nextMonth: 'Mois suivant',
	      prevMonth: 'Mois précédent',
	      nextYear: 'Année suivante',
	      prevYear: 'Année précédente',
	      selectDate: "Sélectionner la date",
	      validateTooManyFiles: "Trop de fichiers ({0} fichiers maximum)",
	      validateTooLong: "Trop long",
	      validateFileNameTooLong: "Nom de fichier trop long ({0} caractères maximum)",
	      validateRequired: "Champ obligatoire",
	      validateNotANumber: "N’est pas un nombre",
	      validateLessThanMin: "Le nombre est inférieur au minimum ({0})",
	      validateMoreThanMax: "Le nombre est supérieur au maximum ({0})",
	      validateNotAStepValue: "N’est pas un incrément valide ({0})",
	      validateColor: "Non défini",
	      validateRegex: "Format non valide",
	      validateDate: "Date non valide (MM/JJ/AAAA)",
	      noSuggestions: "Aucune suggestion",
	      noValues: "[Aucune valeur]"
	    };

	    const {
	      locale
	    } = core;
	    const dictionaryLocales = {
	      de,
	      en: en$1,
	      es,
	      fr,
	      it,
	      ja,
	      ko,
	      pt,
	      ru,
	      zh
	    };
	    s.set(dictionaryLocales);

	    // Default to the browser locale, if present
	    let browserLang = locale.getBestFit();
	    $({
	      fallbackLocale: 'en',
	      initialLocale: browserLang
	    });

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/forms/src/CheckBox.svelte generated by Svelte v3.38.2 */

	    function add_css$j() {
	    	var style = element("style");
	    	style.id = "svelte-1iaa7pw-style";
	    	style.textContent = ".pros-message-container.svelte-1iaa7pw.svelte-1iaa7pw{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1iaa7pw .pros-status-icon.svelte-1iaa7pw{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1iaa7pw .pros-status-icon svg.svelte-1iaa7pw{height:100%;width:100%}.pros-message-container.svelte-1iaa7pw .pros-message.svelte-1iaa7pw{flex:1}.pros-global-wrapper.svelte-1iaa7pw.svelte-1iaa7pw{width:100%}.pros-control-container.svelte-1iaa7pw .pros-input-container.svelte-1iaa7pw{display:flex;justify-content:flex-start;align-items:center;height:34px;cursor:pointer}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-box.svelte-1iaa7pw{display:flex;flex-direction:column;justify-content:center;align-items:center;box-sizing:border-box;width:24px;height:24px;border-width:1px;border-style:solid;border-radius:4px;flex-shrink:0}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-box .pros-check.svelte-1iaa7pw{display:none;height:100%;width:100%}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-box.checked .pros-check.svelte-1iaa7pw{display:block}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-label.svelte-1iaa7pw{user-select:none;margin-left:8px}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-label.required.svelte-1iaa7pw::after{content:\" *\"}.pros-control-container.svelte-1iaa7pw .pros-message-container.svelte-1iaa7pw{padding-left:28px;width:unset;max-width:calc(100% - 28px)}.pros-control-container.custom-layout.svelte-1iaa7pw .pros-input-container.svelte-1iaa7pw{height:auto}.pros-global-wrapper[pos--shape=sharp].svelte-1iaa7pw .pros-box.svelte-1iaa7pw{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1iaa7pw .pros-control-container.has-focus .pros-input-container.svelte-1iaa7pw{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container.svelte-1iaa7pw{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container .pros-status-icon.svelte-1iaa7pw{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container.error.svelte-1iaa7pw{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1iaa7pw{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-message-container.svelte-1iaa7pw{color:#adadad !important}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container.svelte-1iaa7pw{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container .pros-status-icon.svelte-1iaa7pw{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container.error.svelte-1iaa7pw{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1iaa7pw{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-message-container.svelte-1iaa7pw{color:#585858 !important}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.svelte-1iaa7pw{background-color:transparent;border-color:#212121;color:white}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#027aae;border-color:#027aae}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.svelte-1iaa7pw{background-color:rgba(33, 33, 33, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.checked.svelte-1iaa7pw{background-color:#035b84;border-color:#035b84}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container.svelte-1iaa7pw{cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.svelte-1iaa7pw{border-color:#adadad;user-select:none}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box .pros-check.svelte-1iaa7pw{background-color:transparent;color:#ffffff}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-label.svelte-1iaa7pw{user-select:none}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.svelte-1iaa7pw{background-color:transparent;border-color:#ffffff;color:#212121}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#3ab4eb;border-color:#3ab4eb}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.svelte-1iaa7pw{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.checked.svelte-1iaa7pw{background-color:#6dd0fb;border-color:#6dd0fb}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container.svelte-1iaa7pw{cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.svelte-1iaa7pw{border-color:#585858;user-select:none}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box .pros-check.svelte-1iaa7pw{background-color:transparent;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-label.svelte-1iaa7pw{user-select:none}";
	    	append(document.head, style);
	    }

	    // (12:6) {#if label}
	    function create_if_block_3$8(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*label*/ ctx[2]);
	    			attr(div, "id", /*_labelId*/ ctx[12]);
	    			attr(div, "pros-tooltip", "");
	    			attr(div, "class", "pros-label svelte-1iaa7pw");
	    			toggle_class(div, "required", /*required*/ ctx[4]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*label*/ 4) set_data(t, /*label*/ ctx[2]);

	    			if (dirty[0] & /*_labelId*/ 4096) {
	    				attr(div, "id", /*_labelId*/ ctx[12]);
	    			}

	    			if (dirty[0] & /*required*/ 16) {
	    				toggle_class(div, "required", /*required*/ ctx[4]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (17:4) {#if display !== 'custom'}
	    function create_if_block$h(ctx) {
	    	let div;

	    	function select_block_type(ctx, dirty) {
	    		if (/*_dirty*/ ctx[7] && /*_errors*/ ctx[8].length > 0) return create_if_block_1$c;
	    		if (/*hint*/ ctx[3]) return create_if_block_2$b;
	    		return create_else_block$a;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-message-container svelte-1iaa7pw");
	    			toggle_class(div, "error", /*_dirty*/ ctx[7] && /*_errors*/ ctx[8].length > 0);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, dirty) {
	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 384) {
	    				toggle_class(div, "error", /*_dirty*/ ctx[7] && /*_errors*/ ctx[8].length > 0);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    // (33:6) {:else}
	    function create_else_block$a(ctx) {
	    	let div;

	    	return {
	    		c() {
	    			div = element("div");
	    			attr(div, "id", /*_messageId*/ ctx[14]);
	    			attr(div, "class", "pros-message svelte-1iaa7pw");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_messageId*/ 16384) {
	    				attr(div, "id", /*_messageId*/ ctx[14]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (26:21) 
	    function create_if_block_2$b(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(/*hint*/ ctx[3]);
	    			attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1iaa7pw");
	    			attr(div0, "id", /*_statusIconId*/ ctx[15]);
	    			attr(div0, "class", "pros-status-icon svelte-1iaa7pw");
	    			attr(div1, "id", /*_messageId*/ ctx[14]);
	    			attr(div1, "class", "pros-message svelte-1iaa7pw");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 32768) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[15]);
	    			}

	    			if (dirty[0] & /*hint*/ 8) set_data(t1, /*hint*/ ctx[3]);

	    			if (dirty[0] & /*_messageId*/ 16384) {
	    				attr(div1, "id", /*_messageId*/ ctx[14]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    // (19:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$c(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1_value = /*_errors*/ ctx[8][0] + "";
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(t1_value);
	    			attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1iaa7pw");
	    			attr(div0, "id", /*_statusIconId*/ ctx[15]);
	    			attr(div0, "class", "pros-status-icon error svelte-1iaa7pw");
	    			attr(div1, "id", /*_messageId*/ ctx[14]);
	    			attr(div1, "class", "pros-message error svelte-1iaa7pw");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 32768) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[15]);
	    			}

	    			if (dirty[0] & /*_errors*/ 256 && t1_value !== (t1_value = /*_errors*/ ctx[8][0] + "")) set_data(t1, t1_value);

	    			if (dirty[0] & /*_messageId*/ 16384) {
	    				attr(div1, "id", /*_messageId*/ ctx[14]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    function create_fragment$k(ctx) {
	    	let div4;
	    	let div3;
	    	let div2;
	    	let div1;
	    	let t0;
	    	let t1;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*label*/ ctx[2] && create_if_block_3$8(ctx);
	    	let if_block1 = /*display*/ ctx[0] !== "custom" && create_if_block$h(ctx);

	    	return {
	    		c() {
	    			div4 = element("div");
	    			div3 = element("div");
	    			div2 = element("div");
	    			div1 = element("div");
	    			div1.innerHTML = `<div class="pros-check svelte-1iaa7pw"><svg fill="currentColor" focusable="false" version="1.1" viewBox="0 0 32 32"><path d="M13.8,21.63,8.63,16.47l1.13-1.13,4,4,8.44-8.44,1.13,1.13Z"></path></svg></div>`;
	    			t0 = space();
	    			if (if_block0) if_block0.c();
	    			t1 = space();
	    			if (if_block1) if_block1.c();
	    			attr(div1, "class", "pros-box svelte-1iaa7pw");
	    			toggle_class(div1, "checked", /*value*/ ctx[1]);
	    			attr(div2, "id", /*_inputId*/ ctx[13]);
	    			attr(div2, "class", "pros-input-container svelte-1iaa7pw");
	    			attr(div3, "class", "pros-control-container svelte-1iaa7pw");
	    			toggle_class(div3, "custom-layout", /*display*/ ctx[0] === "custom");
	    			toggle_class(div3, "inline-layout", /*display*/ ctx[0] === "form-inline");
	    			toggle_class(div3, "error", /*_dirty*/ ctx[7] && /*_errors*/ ctx[8].length > 0);
	    			toggle_class(div3, "disabled", /*disabled*/ ctx[5]);
	    			toggle_class(div3, "allow-hover", !/*disabled*/ ctx[5]);
	    			attr(div4, "class", "pros-global-wrapper pros-form-control svelte-1iaa7pw");
	    			attr(div4, "pos--theme", /*_theme*/ ctx[9]);
	    			attr(div4, "pos--shape", /*_shape*/ ctx[10]);
	    			attr(div4, "pos--density", /*_density*/ ctx[11]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div4, anchor);
	    			append(div4, div3);
	    			append(div3, div2);
	    			append(div2, div1);
	    			append(div2, t0);
	    			if (if_block0) if_block0.m(div2, null);
	    			append(div3, t1);
	    			if (if_block1) if_block1.m(div3, null);

	    			if (!mounted) {
	    				dispose = listen(div2, "click", /*handleClick*/ ctx[6]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*value*/ 2) {
	    				toggle_class(div1, "checked", /*value*/ ctx[1]);
	    			}

	    			if (/*label*/ ctx[2]) {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);
	    				} else {
	    					if_block0 = create_if_block_3$8(ctx);
	    					if_block0.c();
	    					if_block0.m(div2, null);
	    				}
	    			} else if (if_block0) {
	    				if_block0.d(1);
	    				if_block0 = null;
	    			}

	    			if (dirty[0] & /*_inputId*/ 8192) {
	    				attr(div2, "id", /*_inputId*/ ctx[13]);
	    			}

	    			if (/*display*/ ctx[0] !== "custom") {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);
	    				} else {
	    					if_block1 = create_if_block$h(ctx);
	    					if_block1.c();
	    					if_block1.m(div3, null);
	    				}
	    			} else if (if_block1) {
	    				if_block1.d(1);
	    				if_block1 = null;
	    			}

	    			if (dirty[0] & /*display*/ 1) {
	    				toggle_class(div3, "custom-layout", /*display*/ ctx[0] === "custom");
	    			}

	    			if (dirty[0] & /*display*/ 1) {
	    				toggle_class(div3, "inline-layout", /*display*/ ctx[0] === "form-inline");
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 384) {
	    				toggle_class(div3, "error", /*_dirty*/ ctx[7] && /*_errors*/ ctx[8].length > 0);
	    			}

	    			if (dirty[0] & /*disabled*/ 32) {
	    				toggle_class(div3, "disabled", /*disabled*/ ctx[5]);
	    			}

	    			if (dirty[0] & /*disabled*/ 32) {
	    				toggle_class(div3, "allow-hover", !/*disabled*/ ctx[5]);
	    			}

	    			if (dirty[0] & /*_theme*/ 512) {
	    				attr(div4, "pos--theme", /*_theme*/ ctx[9]);
	    			}

	    			if (dirty[0] & /*_shape*/ 1024) {
	    				attr(div4, "pos--shape", /*_shape*/ ctx[10]);
	    			}

	    			if (dirty[0] & /*_density*/ 2048) {
	    				attr(div4, "pos--density", /*_density*/ ctx[11]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div4);
	    			if (if_block0) if_block0.d();
	    			if (if_block1) if_block1.d();
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    function hasValue$7(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$k($$self, $$props, $$invalidate) {
	    	let $_;
	    	component_subscribe($$self, X, $$value => $$invalidate(30, $_ = $$value));
	    	const dispatch = createEventDispatcher();
	    	let { display = "form" } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
	    	let { shape = "round" } = $$props; // Shape Style (round/sharp)
	    	let { density = "standard" } = $$props; // Density Style (standard/high)
	    	let { value = false } = $$props; // Current value of control
	    	let { label = "" } = $$props; // Control label
	    	let { hint = "" } = $$props; // Hint/Helper text to display when no validation errors to display
	    	let { required = false } = $$props; // Is value required to be valid?
	    	let { disabled = false } = $$props; // Is Control disabled?
	    	let { validation = true } = $$props; // Do we include built in validation?
	    	let { errors = [] } = $$props; // Custom external validation errors
	    	let { id = null } = $$props; // Custom external validation errors

	    	// Internal Data
	    	let _dirty = false; // Has the user changed the value (yes = dirty)

	    	let _errors = []; // Combined validation errors
	    	let _builtInErrors = []; // Built in validation errors
	    	let _lastValid;
	    	let _themeEventListener;
	    	let _shapeEventListener;
	    	let _densityEventListener;
	    	let _theme;
	    	let _shape;
	    	let _density;
	    	let _lastTheme;
	    	let _lastShape;
	    	let _lastDensity;
	    	let _labelId = null;
	    	let _inputId = null;
	    	let _messageId = null;
	    	let _statusIconId = null;

	    	// Computed values
	    	onMount(() => {
	    		doValidate();
	    	});

	    	onDestroy(() => {
	    		if (_themeEventListener) {
	    			window.removeEventListener("posh-theme-changed", _themeEventListener);
	    		}

	    		if (_shapeEventListener) {
	    			window.removeEventListener("posh-shape-changed", _shapeEventListener);
	    		}

	    		if (_densityEventListener) {
	    			window.removeEventListener("posh-density-changed", _densityEventListener);
	    		}
	    	});

	    	beforeUpdate(() => {
	    		// Normalize external changes
	    		$$invalidate(0, display = hasValue$7(display) ? display : "form");

	    		$$invalidate(16, theme = hasValue$7(theme) ? theme : "light");
	    		$$invalidate(17, shape = hasValue$7(shape) ? shape : "round");
	    		$$invalidate(18, density = hasValue$7(density) ? density : "standard");
	    		$$invalidate(2, label = hasValue$7(label) ? label : "");
	    		$$invalidate(3, hint = hasValue$7(hint) ? hint : "");
	    		$$invalidate(1, value = hasValue$7(value) ? value : false);
	    		$$invalidate(4, required = hasValue$7(required) ? required : false);
	    		$$invalidate(5, disabled = hasValue$7(disabled) ? disabled : false);
	    		$$invalidate(19, validation = hasValue$7(validation) ? validation : true);
	    		$$invalidate(12, _labelId = hasValue$7(id) ? `${id}-label` : undefined);
	    		$$invalidate(13, _inputId = hasValue$7(id) ? `${id}-input` : undefined);
	    		$$invalidate(14, _messageId = hasValue$7(id) ? `${id}-message` : undefined);
	    		$$invalidate(15, _statusIconId = hasValue$7(id) ? `${id}-status-icon` : undefined);

	    		if (theme !== _lastTheme) {
	    			_lastTheme = theme;

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(9, _theme = themeAttribute ? themeAttribute : "light");

	    				if (!_themeEventListener) {
	    					// Only start listening once
	    					_themeEventListener = window.addEventListener("posh-theme-changed", event => {
	    						if (theme === "auto") {
	    							$$invalidate(9, _theme = event.detail.theme);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(9, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			_lastShape = shape;

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(10, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					_shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(10, _shape = event.detail.shape);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(10, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			_lastDensity = density;

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(11, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					_densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(11, _density = event.detail.density);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(11, _density = density);
	    			}
	    		}

	    		doValidate.call(this);
	    	});

	    	function handleClick() {
	    		if (disabled) {
	    			return;
	    		}

	    		$$invalidate(7, _dirty = true);
	    		$$invalidate(1, value = !value);
	    		valueChanged.call(this);
	    	}

	    	function valueChanged() {
	    		doValidate.call(value);

	    		// Avoid short circuit handling if changed handler changes a state value
	    		window.setTimeout(() => {
	    			dispatch("changed", value);
	    		});
	    	}

	    	function doValidate() {
	    		_builtInErrors = [];
	    		$$invalidate(8, _errors = errors ? errors : []);

	    		if (required) {
	    			if (!value) {
	    				_builtInErrors.push($_("validateRequired"));
	    			}
	    		}

	    		// We do this here so that valid will be calculated based on built in errors before sending change event
	    		if (validation) {
	    			$$invalidate(8, _errors = _errors.concat(_builtInErrors));
	    		}

	    		window.setTimeout(() => {
	    			let valid = _errors.length === 0;

	    			if (_lastValid !== valid) {
	    				_lastValid = valid;
	    				dispatch("valid", valid);
	    			}
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("display" in $$props) $$invalidate(0, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(16, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(17, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(18, density = $$props.density);
	    		if ("value" in $$props) $$invalidate(1, value = $$props.value);
	    		if ("label" in $$props) $$invalidate(2, label = $$props.label);
	    		if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	    		if ("required" in $$props) $$invalidate(4, required = $$props.required);
	    		if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
	    		if ("validation" in $$props) $$invalidate(19, validation = $$props.validation);
	    		if ("errors" in $$props) $$invalidate(20, errors = $$props.errors);
	    		if ("id" in $$props) $$invalidate(21, id = $$props.id);
	    	};

	    	return [
	    		display,
	    		value,
	    		label,
	    		hint,
	    		required,
	    		disabled,
	    		handleClick,
	    		_dirty,
	    		_errors,
	    		_theme,
	    		_shape,
	    		_density,
	    		_labelId,
	    		_inputId,
	    		_messageId,
	    		_statusIconId,
	    		theme,
	    		shape,
	    		density,
	    		validation,
	    		errors,
	    		id
	    	];
	    }

	    class CheckBox extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-1iaa7pw-style")) add_css$j();

	    		init(
	    			this,
	    			options,
	    			instance$k,
	    			create_fragment$k,
	    			safe_not_equal,
	    			{
	    				display: 0,
	    				theme: 16,
	    				shape: 17,
	    				density: 18,
	    				value: 1,
	    				label: 2,
	    				hint: 3,
	    				required: 4,
	    				disabled: 5,
	    				validation: 19,
	    				errors: 20,
	    				id: 21,
	    				handleClick: 6
	    			},
	    			[-1, -1]
	    		);
	    	}

	    	get handleClick() {
	    		return this.$$.ctx[6];
	    	}
	    }

	    createCommonjsModule(function (module) {
	    module.exports=function(e){var r={};function n(t){if(r[t])return r[t].exports;var a=r[t]={i:t,l:!1,exports:{}};return e[t].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=e,n.c=r,n.d=function(e,r,t){n.o(e,r)||Object.defineProperty(e,r,{enumerable:!0,get:t});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,r){if(1&r&&(e=n(e)),8&r)return e;if(4&r&&"object"==typeof e&&e&&e.__esModule)return e;var t=Object.create(null);if(n.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:e}),2&r&&"string"!=typeof e)for(var a in e)n.d(t,a,function(r){return e[r]}.bind(null,a));return t},n.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(r,"a",r),r},n.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},n.p="",n(n.s=0)}([function(e,r,n){n.r(r),n.d(r,"validateHTMLColorName",(function(){return l})),n.d(r,"validateHTMLColorSpecialName",(function(){return i})),n.d(r,"validateHTMLColorHex",(function(){return u})),n.d(r,"validateHTMLColorRgb",(function(){return d})),n.d(r,"validateHTMLColorHsl",(function(){return f})),n.d(r,"validateHTMLColorHwb",(function(){return h})),n.d(r,"validateHTMLColorLab",(function(){return g})),n.d(r,"validateHTMLColor",(function(){return m}));const t=e=>e&&"string"==typeof e,a=["AliceBlue","AntiqueWhite","Aqua","Aquamarine","Azure","Beige","Bisque","Black","BlanchedAlmond","Blue","BlueViolet","Brown","BurlyWood","CadetBlue","Chartreuse","Chocolate","Coral","CornflowerBlue","Cornsilk","Crimson","Cyan","DarkBlue","DarkCyan","DarkGoldenrod","DarkGray","DarkGreen","DarkKhaki","DarkMagenta","DarkOliveGreen","DarkOrange","DarkOrchid","DarkRed","DarkSalmon","DarkSeaGreen","DarkSlateBlue","DarkSlateGray","DarkTurquoise","DarkViolet","DeepPink","DeepSkyBlue","DimGray","DodgerBlue","FireBrick","FloralWhite","ForestGreen","Fuchsia","Gainsboro","GhostWhite","Gold","Goldenrod","Gray","Green","GreenYellow","HoneyDew","HotPink","IndianRed","Indigo","Ivory","Khaki","Lavender","LavenderBlush","LawnGreen","LemonChiffon","LightBlue","LightCoral","LightCyan","LightGoldenrodYellow","LightGray","LightGreen","LightPink","LightSalmon","LightSalmon","LightSeaGreen","LightSkyBlue","LightSlateGray","LightSteelBlue","LightYellow","Lime","LimeGreen","Linen","Magenta","Maroon","MediumAquamarine","MediumBlue","MediumOrchid","MediumPurple","MediumSeaGreen","MediumSlateBlue","MediumSlateBlue","MediumSpringGreen","MediumTurquoise","MediumVioletRed","MidnightBlue","MintCream","MistyRose","Moccasin","NavajoWhite","Navy","OldLace","Olive","OliveDrab","Orange","OrangeRed","Orchid","PaleGoldenrod","PaleGreen","PaleTurquoise","PaleVioletRed","PapayaWhip","PeachPuff","Peru","Pink","Plum","PowderBlue","Purple","RebeccaPurple","Red","RosyBrown","RoyalBlue","SaddleBrown","Salmon","SandyBrown","SeaGreen","SeaShell","Sienna","Silver","SkyBlue","SlateBlue","SlateGray","Snow","SpringGreen","SteelBlue","Tan","Teal","Thistle","Tomato","Turquoise","Violet","Wheat","White","WhiteSmoke","Yellow","YellowGreen"],o=["currentColor","inherit","transparent"],l=e=>{let r=!1;return t(e)&&a.map(n=>(e.toLowerCase()===n.toLowerCase()&&(r=!0),null)),r},i=e=>{let r=!1;return t(e)&&o.map(n=>(e.toLowerCase()===n.toLowerCase()&&(r=!0),null)),r},u=e=>{if(t(e)){const r=/^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$/i;return e&&r.test(e)}},d=e=>{if(t(e)){const r=/(rgb)a?\((\s*\d+%?\s*?,?\s*){2}(\s*\d+%?\s*?,?\s*\)?)(\s*,?\s*\/?\s*(0?\.?\d+%?\s*)?|1|0)?\)$/i;return e&&r.test(e)}},s="(([0-9]|[1-9][0-9]|100)%)",c=`\\s*?\\)?)(\\s*?(\\/?)\\s+${`(((${s}))|(0?(\\.\\d+)?)|1))?`}\\s*?\\)$`,f=e=>{if(t(e)){const r=new RegExp(`(hsl)a?\\((\\s*?(${"(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)"}|${"(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|400)gra)"}|${"((([0-5])?\\.\\d+|6\\.([0-9]|1[0-9]|2[0-8])|[0-6])rad)"}|${"((0?(\\.\\d+)?|1)turn)"})((\\s*,\\s*)|(\\s+)))(\\s*?(0|${s})((\\s*,\\s*)|(\\s+)))(\\s*?(0|${s})\\s*?\\)?)(\\s*?(\\/?|,?)\\s*?(((${s}))|(0?(\\.\\d+)?)|1))?\\)$`);return e&&r.test(e)}},h=e=>{if(t(e)){const r=new RegExp(`(hwb\\(\\s*?${"(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)"}\\s+)((0|${s})\\s+)((0|${s})${c}`);return e&&r.test(e)}},g=e=>{if(t(e)){const r="(-?(([0-9]|[1-9][0-9]|1[0-5][0-9])(\\.\\d+)??|160))",n=new RegExp(`(lab\\(\\s*?((\\d*(\\.\\d+)?)%)\\s+${r}\\s+${r}${c}`);return e&&n.test(e)}},m=e=>!!(e&&u(e)||d(e)||f(e)||h(e)||g(e));r.default=e=>!!(e&&u(e)||l(e)||i(e)||d(e)||f(e)||h(e)||g(e));}]);
	    });

	    var MILLISECONDS_IN_MINUTE$3 = 60000;

	    /**
	     * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	     * They usually appear for dates that denote time before the timezones were introduced
	     * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	     * and GMT+01:00:00 after that date)
	     *
	     * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	     * which would lead to incorrect calculations.
	     *
	     * This function returns the timezone offset in milliseconds that takes seconds in account.
	     */
	    var getTimezoneOffsetInMilliseconds = function getTimezoneOffsetInMilliseconds (dirtyDate) {
	      var date = new Date(dirtyDate.getTime());
	      var baseTimezoneOffset = date.getTimezoneOffset();
	      date.setSeconds(0, 0);
	      var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE$3;

	      return baseTimezoneOffset * MILLISECONDS_IN_MINUTE$3 + millisecondsPartOfTimezoneOffset
	    };

	    /**
	     * @category Common Helpers
	     * @summary Is the given argument an instance of Date?
	     *
	     * @description
	     * Is the given argument an instance of Date?
	     *
	     * @param {*} argument - the argument to check
	     * @returns {Boolean} the given argument is an instance of Date
	     *
	     * @example
	     * // Is 'mayonnaise' a Date?
	     * var result = isDate('mayonnaise')
	     * //=> false
	     */
	    function isDate (argument) {
	      return argument instanceof Date
	    }

	    var is_date = isDate;

	    var MILLISECONDS_IN_HOUR = 3600000;
	    var MILLISECONDS_IN_MINUTE$2 = 60000;
	    var DEFAULT_ADDITIONAL_DIGITS = 2;

	    var parseTokenDateTimeDelimeter = /[T ]/;
	    var parseTokenPlainTime = /:/;

	    // year tokens
	    var parseTokenYY = /^(\d{2})$/;
	    var parseTokensYYY = [
	      /^([+-]\d{2})$/, // 0 additional digits
	      /^([+-]\d{3})$/, // 1 additional digit
	      /^([+-]\d{4})$/ // 2 additional digits
	    ];

	    var parseTokenYYYY = /^(\d{4})/;
	    var parseTokensYYYYY = [
	      /^([+-]\d{4})/, // 0 additional digits
	      /^([+-]\d{5})/, // 1 additional digit
	      /^([+-]\d{6})/ // 2 additional digits
	    ];

	    // date tokens
	    var parseTokenMM = /^-(\d{2})$/;
	    var parseTokenDDD = /^-?(\d{3})$/;
	    var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
	    var parseTokenWww = /^-?W(\d{2})$/;
	    var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;

	    // time tokens
	    var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
	    var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
	    var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;

	    // timezone tokens
	    var parseTokenTimezone = /([Z+-].*)$/;
	    var parseTokenTimezoneZ = /^(Z)$/;
	    var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
	    var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;

	    /**
	     * @category Common Helpers
	     * @summary Convert the given argument to an instance of Date.
	     *
	     * @description
	     * Convert the given argument to an instance of Date.
	     *
	     * If the argument is an instance of Date, the function returns its clone.
	     *
	     * If the argument is a number, it is treated as a timestamp.
	     *
	     * If an argument is a string, the function tries to parse it.
	     * Function accepts complete ISO 8601 formats as well as partial implementations.
	     * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	     *
	     * If all above fails, the function passes the given argument to Date constructor.
	     *
	     * @param {Date|String|Number} argument - the value to convert
	     * @param {Object} [options] - the object with options
	     * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	     * @returns {Date} the parsed date in the local time zone
	     *
	     * @example
	     * // Convert string '2014-02-11T11:30:30' to date:
	     * var result = parse('2014-02-11T11:30:30')
	     * //=> Tue Feb 11 2014 11:30:30
	     *
	     * @example
	     * // Parse string '+02014101',
	     * // if the additional number of digits in the extended year format is 1:
	     * var result = parse('+02014101', {additionalDigits: 1})
	     * //=> Fri Apr 11 2014 00:00:00
	     */
	    function parse (argument, dirtyOptions) {
	      if (is_date(argument)) {
	        // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	        return new Date(argument.getTime())
	      } else if (typeof argument !== 'string') {
	        return new Date(argument)
	      }

	      var options = dirtyOptions || {};
	      var additionalDigits = options.additionalDigits;
	      if (additionalDigits == null) {
	        additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
	      } else {
	        additionalDigits = Number(additionalDigits);
	      }

	      var dateStrings = splitDateString(argument);

	      var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	      var year = parseYearResult.year;
	      var restDateString = parseYearResult.restDateString;

	      var date = parseDate(restDateString, year);

	      if (date) {
	        var timestamp = date.getTime();
	        var time = 0;
	        var offset;

	        if (dateStrings.time) {
	          time = parseTime(dateStrings.time);
	        }

	        if (dateStrings.timezone) {
	          offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE$2;
	        } else {
	          var fullTime = timestamp + time;
	          var fullTimeDate = new Date(fullTime);

	          offset = getTimezoneOffsetInMilliseconds(fullTimeDate);

	          // Adjust time when it's coming from DST
	          var fullTimeDateNextDay = new Date(fullTime);
	          fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
	          var offsetDiff =
	            getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
	            getTimezoneOffsetInMilliseconds(fullTimeDate);
	          if (offsetDiff > 0) {
	            offset += offsetDiff;
	          }
	        }

	        return new Date(timestamp + time + offset)
	      } else {
	        return new Date(argument)
	      }
	    }

	    function splitDateString (dateString) {
	      var dateStrings = {};
	      var array = dateString.split(parseTokenDateTimeDelimeter);
	      var timeString;

	      if (parseTokenPlainTime.test(array[0])) {
	        dateStrings.date = null;
	        timeString = array[0];
	      } else {
	        dateStrings.date = array[0];
	        timeString = array[1];
	      }

	      if (timeString) {
	        var token = parseTokenTimezone.exec(timeString);
	        if (token) {
	          dateStrings.time = timeString.replace(token[1], '');
	          dateStrings.timezone = token[1];
	        } else {
	          dateStrings.time = timeString;
	        }
	      }

	      return dateStrings
	    }

	    function parseYear (dateString, additionalDigits) {
	      var parseTokenYYY = parseTokensYYY[additionalDigits];
	      var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];

	      var token;

	      // YYYY or ±YYYYY
	      token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
	      if (token) {
	        var yearString = token[1];
	        return {
	          year: parseInt(yearString, 10),
	          restDateString: dateString.slice(yearString.length)
	        }
	      }

	      // YY or ±YYY
	      token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
	      if (token) {
	        var centuryString = token[1];
	        return {
	          year: parseInt(centuryString, 10) * 100,
	          restDateString: dateString.slice(centuryString.length)
	        }
	      }

	      // Invalid ISO-formatted year
	      return {
	        year: null
	      }
	    }

	    function parseDate (dateString, year) {
	      // Invalid ISO-formatted year
	      if (year === null) {
	        return null
	      }

	      var token;
	      var date;
	      var month;
	      var week;

	      // YYYY
	      if (dateString.length === 0) {
	        date = new Date(0);
	        date.setUTCFullYear(year);
	        return date
	      }

	      // YYYY-MM
	      token = parseTokenMM.exec(dateString);
	      if (token) {
	        date = new Date(0);
	        month = parseInt(token[1], 10) - 1;
	        date.setUTCFullYear(year, month);
	        return date
	      }

	      // YYYY-DDD or YYYYDDD
	      token = parseTokenDDD.exec(dateString);
	      if (token) {
	        date = new Date(0);
	        var dayOfYear = parseInt(token[1], 10);
	        date.setUTCFullYear(year, 0, dayOfYear);
	        return date
	      }

	      // YYYY-MM-DD or YYYYMMDD
	      token = parseTokenMMDD.exec(dateString);
	      if (token) {
	        date = new Date(0);
	        month = parseInt(token[1], 10) - 1;
	        var day = parseInt(token[2], 10);
	        date.setUTCFullYear(year, month, day);
	        return date
	      }

	      // YYYY-Www or YYYYWww
	      token = parseTokenWww.exec(dateString);
	      if (token) {
	        week = parseInt(token[1], 10) - 1;
	        return dayOfISOYear(year, week)
	      }

	      // YYYY-Www-D or YYYYWwwD
	      token = parseTokenWwwD.exec(dateString);
	      if (token) {
	        week = parseInt(token[1], 10) - 1;
	        var dayOfWeek = parseInt(token[2], 10) - 1;
	        return dayOfISOYear(year, week, dayOfWeek)
	      }

	      // Invalid ISO-formatted date
	      return null
	    }

	    function parseTime (timeString) {
	      var token;
	      var hours;
	      var minutes;

	      // hh
	      token = parseTokenHH.exec(timeString);
	      if (token) {
	        hours = parseFloat(token[1].replace(',', '.'));
	        return (hours % 24) * MILLISECONDS_IN_HOUR
	      }

	      // hh:mm or hhmm
	      token = parseTokenHHMM.exec(timeString);
	      if (token) {
	        hours = parseInt(token[1], 10);
	        minutes = parseFloat(token[2].replace(',', '.'));
	        return (hours % 24) * MILLISECONDS_IN_HOUR +
	          minutes * MILLISECONDS_IN_MINUTE$2
	      }

	      // hh:mm:ss or hhmmss
	      token = parseTokenHHMMSS.exec(timeString);
	      if (token) {
	        hours = parseInt(token[1], 10);
	        minutes = parseInt(token[2], 10);
	        var seconds = parseFloat(token[3].replace(',', '.'));
	        return (hours % 24) * MILLISECONDS_IN_HOUR +
	          minutes * MILLISECONDS_IN_MINUTE$2 +
	          seconds * 1000
	      }

	      // Invalid ISO-formatted time
	      return null
	    }

	    function parseTimezone (timezoneString) {
	      var token;
	      var absoluteOffset;

	      // Z
	      token = parseTokenTimezoneZ.exec(timezoneString);
	      if (token) {
	        return 0
	      }

	      // ±hh
	      token = parseTokenTimezoneHH.exec(timezoneString);
	      if (token) {
	        absoluteOffset = parseInt(token[2], 10) * 60;
	        return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	      }

	      // ±hh:mm or ±hhmm
	      token = parseTokenTimezoneHHMM.exec(timezoneString);
	      if (token) {
	        absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
	        return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	      }

	      return 0
	    }

	    function dayOfISOYear (isoYear, week, day) {
	      week = week || 0;
	      day = day || 0;
	      var date = new Date(0);
	      date.setUTCFullYear(isoYear, 0, 4);
	      var fourthOfJanuaryDay = date.getUTCDay() || 7;
	      var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
	      date.setUTCDate(date.getUTCDate() + diff);
	      return date
	    }

	    var parse_1 = parse;

	    /**
	     * @category Year Helpers
	     * @summary Return the start of a year for the given date.
	     *
	     * @description
	     * Return the start of a year for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of a year
	     *
	     * @example
	     * // The start of a year for 2 September 2014 11:55:00:
	     * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	     * //=> Wed Jan 01 2014 00:00:00
	     */
	    function startOfYear (dirtyDate) {
	      var cleanDate = parse_1(dirtyDate);
	      var date = new Date(0);
	      date.setFullYear(cleanDate.getFullYear(), 0, 1);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_year = startOfYear;

	    /**
	     * @category Day Helpers
	     * @summary Return the start of a day for the given date.
	     *
	     * @description
	     * Return the start of a day for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of a day
	     *
	     * @example
	     * // The start of a day for 2 September 2014 11:55:00:
	     * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Tue Sep 02 2014 00:00:00
	     */
	    function startOfDay (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_day = startOfDay;

	    var MILLISECONDS_IN_MINUTE$1 = 60000;
	    var MILLISECONDS_IN_DAY = 86400000;

	    /**
	     * @category Day Helpers
	     * @summary Get the number of calendar days between the given dates.
	     *
	     * @description
	     * Get the number of calendar days between the given dates.
	     *
	     * @param {Date|String|Number} dateLeft - the later date
	     * @param {Date|String|Number} dateRight - the earlier date
	     * @returns {Number} the number of calendar days
	     *
	     * @example
	     * // How many calendar days are between
	     * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	     * var result = differenceInCalendarDays(
	     *   new Date(2012, 6, 2, 0, 0),
	     *   new Date(2011, 6, 2, 23, 0)
	     * )
	     * //=> 366
	     */
	    function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
	      var startOfDayLeft = start_of_day(dirtyDateLeft);
	      var startOfDayRight = start_of_day(dirtyDateRight);

	      var timestampLeft = startOfDayLeft.getTime() -
	        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1;
	      var timestampRight = startOfDayRight.getTime() -
	        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1;

	      // Round the number of days to the nearest integer
	      // because the number of milliseconds in a day is not constant
	      // (e.g. it's different in the day of the daylight saving time clock shift)
	      return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
	    }

	    var difference_in_calendar_days = differenceInCalendarDays;

	    /**
	     * @category Day Helpers
	     * @summary Get the day of the year of the given date.
	     *
	     * @description
	     * Get the day of the year of the given date.
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the day of year
	     *
	     * @example
	     * // Which day of the year is 2 July 2014?
	     * var result = getDayOfYear(new Date(2014, 6, 2))
	     * //=> 183
	     */
	    function getDayOfYear (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var diff = difference_in_calendar_days(date, start_of_year(date));
	      var dayOfYear = diff + 1;
	      return dayOfYear
	    }

	    var get_day_of_year = getDayOfYear;

	    /**
	     * @category Week Helpers
	     * @summary Return the start of a week for the given date.
	     *
	     * @description
	     * Return the start of a week for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @param {Object} [options] - the object with options
	     * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	     * @returns {Date} the start of a week
	     *
	     * @example
	     * // The start of a week for 2 September 2014 11:55:00:
	     * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Sun Aug 31 2014 00:00:00
	     *
	     * @example
	     * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	     * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function startOfWeek (dirtyDate, dirtyOptions) {
	      var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;

	      var date = parse_1(dirtyDate);
	      var day = date.getDay();
	      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

	      date.setDate(date.getDate() - diff);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_week = startOfWeek;

	    /**
	     * @category ISO Week Helpers
	     * @summary Return the start of an ISO week for the given date.
	     *
	     * @description
	     * Return the start of an ISO week for the given date.
	     * The result will be in the local timezone.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of an ISO week
	     *
	     * @example
	     * // The start of an ISO week for 2 September 2014 11:55:00:
	     * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function startOfISOWeek (dirtyDate) {
	      return start_of_week(dirtyDate, {weekStartsOn: 1})
	    }

	    var start_of_iso_week = startOfISOWeek;

	    /**
	     * @category ISO Week-Numbering Year Helpers
	     * @summary Get the ISO week-numbering year of the given date.
	     *
	     * @description
	     * Get the ISO week-numbering year of the given date,
	     * which always starts 3 days before the year's first Thursday.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the ISO week-numbering year
	     *
	     * @example
	     * // Which ISO-week numbering year is 2 January 2005?
	     * var result = getISOYear(new Date(2005, 0, 2))
	     * //=> 2004
	     */
	    function getISOYear (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var year = date.getFullYear();

	      var fourthOfJanuaryOfNextYear = new Date(0);
	      fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	      fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	      var startOfNextYear = start_of_iso_week(fourthOfJanuaryOfNextYear);

	      var fourthOfJanuaryOfThisYear = new Date(0);
	      fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	      fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	      var startOfThisYear = start_of_iso_week(fourthOfJanuaryOfThisYear);

	      if (date.getTime() >= startOfNextYear.getTime()) {
	        return year + 1
	      } else if (date.getTime() >= startOfThisYear.getTime()) {
	        return year
	      } else {
	        return year - 1
	      }
	    }

	    var get_iso_year = getISOYear;

	    /**
	     * @category ISO Week-Numbering Year Helpers
	     * @summary Return the start of an ISO week-numbering year for the given date.
	     *
	     * @description
	     * Return the start of an ISO week-numbering year,
	     * which always starts 3 days before the year's first Thursday.
	     * The result will be in the local timezone.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of an ISO year
	     *
	     * @example
	     * // The start of an ISO week-numbering year for 2 July 2005:
	     * var result = startOfISOYear(new Date(2005, 6, 2))
	     * //=> Mon Jan 03 2005 00:00:00
	     */
	    function startOfISOYear (dirtyDate) {
	      var year = get_iso_year(dirtyDate);
	      var fourthOfJanuary = new Date(0);
	      fourthOfJanuary.setFullYear(year, 0, 4);
	      fourthOfJanuary.setHours(0, 0, 0, 0);
	      var date = start_of_iso_week(fourthOfJanuary);
	      return date
	    }

	    var start_of_iso_year = startOfISOYear;

	    var MILLISECONDS_IN_WEEK$1 = 604800000;

	    /**
	     * @category ISO Week Helpers
	     * @summary Get the ISO week of the given date.
	     *
	     * @description
	     * Get the ISO week of the given date.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the ISO week
	     *
	     * @example
	     * // Which week of the ISO-week numbering year is 2 January 2005?
	     * var result = getISOWeek(new Date(2005, 0, 2))
	     * //=> 53
	     */
	    function getISOWeek (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var diff = start_of_iso_week(date).getTime() - start_of_iso_year(date).getTime();

	      // Round the number of days to the nearest integer
	      // because the number of milliseconds in a week is not constant
	      // (e.g. it's different in the week of the daylight saving time clock shift)
	      return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1
	    }

	    var get_iso_week = getISOWeek;

	    /**
	     * @category Common Helpers
	     * @summary Is the given date valid?
	     *
	     * @description
	     * Returns false if argument is Invalid Date and true otherwise.
	     * Invalid Date is a Date, whose time value is NaN.
	     *
	     * Time value of Date: http://es5.github.io/#x15.9.1.1
	     *
	     * @param {Date} date - the date to check
	     * @returns {Boolean} the date is valid
	     * @throws {TypeError} argument must be an instance of Date
	     *
	     * @example
	     * // For the valid date:
	     * var result = isValid(new Date(2014, 1, 31))
	     * //=> true
	     *
	     * @example
	     * // For the invalid date:
	     * var result = isValid(new Date(''))
	     * //=> false
	     */
	    function isValid (dirtyDate) {
	      if (is_date(dirtyDate)) {
	        return !isNaN(dirtyDate)
	      } else {
	        throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
	      }
	    }

	    var is_valid = isValid;

	    function buildDistanceInWordsLocale () {
	      var distanceInWordsLocale = {
	        lessThanXSeconds: {
	          one: 'less than a second',
	          other: 'less than {{count}} seconds'
	        },

	        xSeconds: {
	          one: '1 second',
	          other: '{{count}} seconds'
	        },

	        halfAMinute: 'half a minute',

	        lessThanXMinutes: {
	          one: 'less than a minute',
	          other: 'less than {{count}} minutes'
	        },

	        xMinutes: {
	          one: '1 minute',
	          other: '{{count}} minutes'
	        },

	        aboutXHours: {
	          one: 'about 1 hour',
	          other: 'about {{count}} hours'
	        },

	        xHours: {
	          one: '1 hour',
	          other: '{{count}} hours'
	        },

	        xDays: {
	          one: '1 day',
	          other: '{{count}} days'
	        },

	        aboutXMonths: {
	          one: 'about 1 month',
	          other: 'about {{count}} months'
	        },

	        xMonths: {
	          one: '1 month',
	          other: '{{count}} months'
	        },

	        aboutXYears: {
	          one: 'about 1 year',
	          other: 'about {{count}} years'
	        },

	        xYears: {
	          one: '1 year',
	          other: '{{count}} years'
	        },

	        overXYears: {
	          one: 'over 1 year',
	          other: 'over {{count}} years'
	        },

	        almostXYears: {
	          one: 'almost 1 year',
	          other: 'almost {{count}} years'
	        }
	      };

	      function localize (token, count, options) {
	        options = options || {};

	        var result;
	        if (typeof distanceInWordsLocale[token] === 'string') {
	          result = distanceInWordsLocale[token];
	        } else if (count === 1) {
	          result = distanceInWordsLocale[token].one;
	        } else {
	          result = distanceInWordsLocale[token].other.replace('{{count}}', count);
	        }

	        if (options.addSuffix) {
	          if (options.comparison > 0) {
	            return 'in ' + result
	          } else {
	            return result + ' ago'
	          }
	        }

	        return result
	      }

	      return {
	        localize: localize
	      }
	    }

	    var build_distance_in_words_locale = buildDistanceInWordsLocale;

	    var commonFormatterKeys = [
	      'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
	      'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
	      'H', 'HH', 'h', 'hh', 'm', 'mm',
	      's', 'ss', 'S', 'SS', 'SSS',
	      'Z', 'ZZ', 'X', 'x'
	    ];

	    function buildFormattingTokensRegExp (formatters) {
	      var formatterKeys = [];
	      for (var key in formatters) {
	        if (formatters.hasOwnProperty(key)) {
	          formatterKeys.push(key);
	        }
	      }

	      var formattingTokens = commonFormatterKeys
	        .concat(formatterKeys)
	        .sort()
	        .reverse();
	      var formattingTokensRegExp = new RegExp(
	        '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
	      );

	      return formattingTokensRegExp
	    }

	    var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;

	    function buildFormatLocale () {
	      // Note: in English, the names of days of the week and months are capitalized.
	      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	      // Generally, formatted dates should look like they are in the middle of a sentence,
	      // e.g. in Spanish language the weekdays and months should be in the lowercase.
	      var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	      var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	      var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	      var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	      var meridiemUppercase = ['AM', 'PM'];
	      var meridiemLowercase = ['am', 'pm'];
	      var meridiemFull = ['a.m.', 'p.m.'];

	      var formatters = {
	        // Month: Jan, Feb, ..., Dec
	        'MMM': function (date) {
	          return months3char[date.getMonth()]
	        },

	        // Month: January, February, ..., December
	        'MMMM': function (date) {
	          return monthsFull[date.getMonth()]
	        },

	        // Day of week: Su, Mo, ..., Sa
	        'dd': function (date) {
	          return weekdays2char[date.getDay()]
	        },

	        // Day of week: Sun, Mon, ..., Sat
	        'ddd': function (date) {
	          return weekdays3char[date.getDay()]
	        },

	        // Day of week: Sunday, Monday, ..., Saturday
	        'dddd': function (date) {
	          return weekdaysFull[date.getDay()]
	        },

	        // AM, PM
	        'A': function (date) {
	          return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
	        },

	        // am, pm
	        'a': function (date) {
	          return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
	        },

	        // a.m., p.m.
	        'aa': function (date) {
	          return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
	        }
	      };

	      // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
	      var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
	      ordinalFormatters.forEach(function (formatterToken) {
	        formatters[formatterToken + 'o'] = function (date, formatters) {
	          return ordinal(formatters[formatterToken](date))
	        };
	      });

	      return {
	        formatters: formatters,
	        formattingTokensRegExp: build_formatting_tokens_reg_exp(formatters)
	      }
	    }

	    function ordinal (number) {
	      var rem100 = number % 100;
	      if (rem100 > 20 || rem100 < 10) {
	        switch (rem100 % 10) {
	          case 1:
	            return number + 'st'
	          case 2:
	            return number + 'nd'
	          case 3:
	            return number + 'rd'
	        }
	      }
	      return number + 'th'
	    }

	    var build_format_locale = buildFormatLocale;

	    /**
	     * @category Locales
	     * @summary English locale.
	     */
	    var en = {
	      distanceInWords: build_distance_in_words_locale(),
	      format: build_format_locale()
	    };

	    /**
	     * @category Common Helpers
	     * @summary Format the date.
	     *
	     * @description
	     * Return the formatted date string in the given format.
	     *
	     * Accepted tokens:
	     * | Unit                    | Token | Result examples                  |
	     * |-------------------------|-------|----------------------------------|
	     * | Month                   | M     | 1, 2, ..., 12                    |
	     * |                         | Mo    | 1st, 2nd, ..., 12th              |
	     * |                         | MM    | 01, 02, ..., 12                  |
	     * |                         | MMM   | Jan, Feb, ..., Dec               |
	     * |                         | MMMM  | January, February, ..., December |
	     * | Quarter                 | Q     | 1, 2, 3, 4                       |
	     * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	     * | Day of month            | D     | 1, 2, ..., 31                    |
	     * |                         | Do    | 1st, 2nd, ..., 31st              |
	     * |                         | DD    | 01, 02, ..., 31                  |
	     * | Day of year             | DDD   | 1, 2, ..., 366                   |
	     * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	     * |                         | DDDD  | 001, 002, ..., 366               |
	     * | Day of week             | d     | 0, 1, ..., 6                     |
	     * |                         | do    | 0th, 1st, ..., 6th               |
	     * |                         | dd    | Su, Mo, ..., Sa                  |
	     * |                         | ddd   | Sun, Mon, ..., Sat               |
	     * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	     * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	     * | ISO week                | W     | 1, 2, ..., 53                    |
	     * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	     * |                         | WW    | 01, 02, ..., 53                  |
	     * | Year                    | YY    | 00, 01, ..., 99                  |
	     * |                         | YYYY  | 1900, 1901, ..., 2099            |
	     * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	     * |                         | GGGG  | 1900, 1901, ..., 2099            |
	     * | AM/PM                   | A     | AM, PM                           |
	     * |                         | a     | am, pm                           |
	     * |                         | aa    | a.m., p.m.                       |
	     * | Hour                    | H     | 0, 1, ... 23                     |
	     * |                         | HH    | 00, 01, ... 23                   |
	     * |                         | h     | 1, 2, ..., 12                    |
	     * |                         | hh    | 01, 02, ..., 12                  |
	     * | Minute                  | m     | 0, 1, ..., 59                    |
	     * |                         | mm    | 00, 01, ..., 59                  |
	     * | Second                  | s     | 0, 1, ..., 59                    |
	     * |                         | ss    | 00, 01, ..., 59                  |
	     * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	     * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	     * | Millisecond             | SSS   | 000, 001, ..., 999               |
	     * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	     * |                         | ZZ    | -0100, +0000, ..., +1200         |
	     * | Seconds timestamp       | X     | 512969520                        |
	     * | Milliseconds timestamp  | x     | 512969520900                     |
	     *
	     * The characters wrapped in square brackets are escaped.
	     *
	     * The result may vary by locale.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
	     * @param {Object} [options] - the object with options
	     * @param {Object} [options.locale=enLocale] - the locale object
	     * @returns {String} the formatted date string
	     *
	     * @example
	     * // Represent 11 February 2014 in middle-endian format:
	     * var result = format(
	     *   new Date(2014, 1, 11),
	     *   'MM/DD/YYYY'
	     * )
	     * //=> '02/11/2014'
	     *
	     * @example
	     * // Represent 2 July 2014 in Esperanto:
	     * var eoLocale = require('date-fns/locale/eo')
	     * var result = format(
	     *   new Date(2014, 6, 2),
	     *   'Do [de] MMMM YYYY',
	     *   {locale: eoLocale}
	     * )
	     * //=> '2-a de julio 2014'
	     */
	    function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
	      var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
	      var options = dirtyOptions || {};

	      var locale = options.locale;
	      var localeFormatters = en.format.formatters;
	      var formattingTokensRegExp = en.format.formattingTokensRegExp;
	      if (locale && locale.format && locale.format.formatters) {
	        localeFormatters = locale.format.formatters;

	        if (locale.format.formattingTokensRegExp) {
	          formattingTokensRegExp = locale.format.formattingTokensRegExp;
	        }
	      }

	      var date = parse_1(dirtyDate);

	      if (!is_valid(date)) {
	        return 'Invalid Date'
	      }

	      var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp);

	      return formatFn(date)
	    }

	    var formatters = {
	      // Month: 1, 2, ..., 12
	      'M': function (date) {
	        return date.getMonth() + 1
	      },

	      // Month: 01, 02, ..., 12
	      'MM': function (date) {
	        return addLeadingZeros(date.getMonth() + 1, 2)
	      },

	      // Quarter: 1, 2, 3, 4
	      'Q': function (date) {
	        return Math.ceil((date.getMonth() + 1) / 3)
	      },

	      // Day of month: 1, 2, ..., 31
	      'D': function (date) {
	        return date.getDate()
	      },

	      // Day of month: 01, 02, ..., 31
	      'DD': function (date) {
	        return addLeadingZeros(date.getDate(), 2)
	      },

	      // Day of year: 1, 2, ..., 366
	      'DDD': function (date) {
	        return get_day_of_year(date)
	      },

	      // Day of year: 001, 002, ..., 366
	      'DDDD': function (date) {
	        return addLeadingZeros(get_day_of_year(date), 3)
	      },

	      // Day of week: 0, 1, ..., 6
	      'd': function (date) {
	        return date.getDay()
	      },

	      // Day of ISO week: 1, 2, ..., 7
	      'E': function (date) {
	        return date.getDay() || 7
	      },

	      // ISO week: 1, 2, ..., 53
	      'W': function (date) {
	        return get_iso_week(date)
	      },

	      // ISO week: 01, 02, ..., 53
	      'WW': function (date) {
	        return addLeadingZeros(get_iso_week(date), 2)
	      },

	      // Year: 00, 01, ..., 99
	      'YY': function (date) {
	        return addLeadingZeros(date.getFullYear(), 4).substr(2)
	      },

	      // Year: 1900, 1901, ..., 2099
	      'YYYY': function (date) {
	        return addLeadingZeros(date.getFullYear(), 4)
	      },

	      // ISO week-numbering year: 00, 01, ..., 99
	      'GG': function (date) {
	        return String(get_iso_year(date)).substr(2)
	      },

	      // ISO week-numbering year: 1900, 1901, ..., 2099
	      'GGGG': function (date) {
	        return get_iso_year(date)
	      },

	      // Hour: 0, 1, ... 23
	      'H': function (date) {
	        return date.getHours()
	      },

	      // Hour: 00, 01, ..., 23
	      'HH': function (date) {
	        return addLeadingZeros(date.getHours(), 2)
	      },

	      // Hour: 1, 2, ..., 12
	      'h': function (date) {
	        var hours = date.getHours();
	        if (hours === 0) {
	          return 12
	        } else if (hours > 12) {
	          return hours % 12
	        } else {
	          return hours
	        }
	      },

	      // Hour: 01, 02, ..., 12
	      'hh': function (date) {
	        return addLeadingZeros(formatters['h'](date), 2)
	      },

	      // Minute: 0, 1, ..., 59
	      'm': function (date) {
	        return date.getMinutes()
	      },

	      // Minute: 00, 01, ..., 59
	      'mm': function (date) {
	        return addLeadingZeros(date.getMinutes(), 2)
	      },

	      // Second: 0, 1, ..., 59
	      's': function (date) {
	        return date.getSeconds()
	      },

	      // Second: 00, 01, ..., 59
	      'ss': function (date) {
	        return addLeadingZeros(date.getSeconds(), 2)
	      },

	      // 1/10 of second: 0, 1, ..., 9
	      'S': function (date) {
	        return Math.floor(date.getMilliseconds() / 100)
	      },

	      // 1/100 of second: 00, 01, ..., 99
	      'SS': function (date) {
	        return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
	      },

	      // Millisecond: 000, 001, ..., 999
	      'SSS': function (date) {
	        return addLeadingZeros(date.getMilliseconds(), 3)
	      },

	      // Timezone: -01:00, +00:00, ... +12:00
	      'Z': function (date) {
	        return formatTimezone(date.getTimezoneOffset(), ':')
	      },

	      // Timezone: -0100, +0000, ... +1200
	      'ZZ': function (date) {
	        return formatTimezone(date.getTimezoneOffset())
	      },

	      // Seconds timestamp: 512969520
	      'X': function (date) {
	        return Math.floor(date.getTime() / 1000)
	      },

	      // Milliseconds timestamp: 512969520900
	      'x': function (date) {
	        return date.getTime()
	      }
	    };

	    function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
	      var array = formatStr.match(formattingTokensRegExp);
	      var length = array.length;

	      var i;
	      var formatter;
	      for (i = 0; i < length; i++) {
	        formatter = localeFormatters[array[i]] || formatters[array[i]];
	        if (formatter) {
	          array[i] = formatter;
	        } else {
	          array[i] = removeFormattingTokens(array[i]);
	        }
	      }

	      return function (date) {
	        var output = '';
	        for (var i = 0; i < length; i++) {
	          if (array[i] instanceof Function) {
	            output += array[i](date, formatters);
	          } else {
	            output += array[i];
	          }
	        }
	        return output
	      }
	    }

	    function removeFormattingTokens (input) {
	      if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|]$/g, '')
	      }
	      return input.replace(/\\/g, '')
	    }

	    function formatTimezone (offset, delimeter) {
	      delimeter = delimeter || '';
	      var sign = offset > 0 ? '-' : '+';
	      var absOffset = Math.abs(offset);
	      var hours = Math.floor(absOffset / 60);
	      var minutes = absOffset % 60;
	      return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
	    }

	    function addLeadingZeros (number, targetLength) {
	      var output = Math.abs(number).toString();
	      while (output.length < targetLength) {
	        output = '0' + output;
	      }
	      return output
	    }

	    var format_1 = format;

	    /**
	     * @category Day Helpers
	     * @summary Return the array of dates within the specified range.
	     *
	     * @description
	     * Return the array of dates within the specified range.
	     *
	     * @param {Date|String|Number} startDate - the first date
	     * @param {Date|String|Number} endDate - the last date
	     * @param {Number} [step=1] - the step between each day
	     * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
	     * @throws {Error} startDate cannot be after endDate
	     *
	     * @example
	     * // Each day between 6 October 2014 and 10 October 2014:
	     * var result = eachDay(
	     *   new Date(2014, 9, 6),
	     *   new Date(2014, 9, 10)
	     * )
	     * //=> [
	     * //   Mon Oct 06 2014 00:00:00,
	     * //   Tue Oct 07 2014 00:00:00,
	     * //   Wed Oct 08 2014 00:00:00,
	     * //   Thu Oct 09 2014 00:00:00,
	     * //   Fri Oct 10 2014 00:00:00
	     * // ]
	     */
	    function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
	      var startDate = parse_1(dirtyStartDate);
	      var endDate = parse_1(dirtyEndDate);
	      var step = dirtyStep !== undefined ? dirtyStep : 1;

	      var endTime = endDate.getTime();

	      if (startDate.getTime() > endTime) {
	        throw new Error('The first date cannot be after the second date')
	      }

	      var dates = [];

	      var currentDate = startDate;
	      currentDate.setHours(0, 0, 0, 0);

	      while (currentDate.getTime() <= endTime) {
	        dates.push(parse_1(currentDate));
	        currentDate.setDate(currentDate.getDate() + step);
	      }

	      return dates
	    }

	    var each_day = eachDay;

	    /**
	     * @category Month Helpers
	     * @summary Return the start of a month for the given date.
	     *
	     * @description
	     * Return the start of a month for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of a month
	     *
	     * @example
	     * // The start of a month for 2 September 2014 11:55:00:
	     * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function startOfMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      date.setDate(1);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_month = startOfMonth;

	    /**
	     * @category Month Helpers
	     * @summary Return the end of a month for the given date.
	     *
	     * @description
	     * Return the end of a month for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the end of a month
	     *
	     * @example
	     * // The end of a month for 2 September 2014 11:55:00:
	     * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Tue Sep 30 2014 23:59:59.999
	     */
	    function endOfMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var month = date.getMonth();
	      date.setFullYear(date.getFullYear(), month + 1, 0);
	      date.setHours(23, 59, 59, 999);
	      return date
	    }

	    var end_of_month = endOfMonth;

	    /**
	     * @category Month Helpers
	     * @summary Return the last day of a month for the given date.
	     *
	     * @description
	     * Return the last day of a month for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the last day of a month
	     *
	     * @example
	     * // The last day of a month for 2 September 2014 11:55:00:
	     * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Tue Sep 30 2014 00:00:00
	     */
	    function lastDayOfMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var month = date.getMonth();
	      date.setFullYear(date.getFullYear(), month + 1, 0);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var last_day_of_month = lastDayOfMonth;

	    /**
	     * @category Weekday Helpers
	     * @summary Get the day of the week of the given date.
	     *
	     * @description
	     * Get the day of the week of the given date.
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the day of week
	     *
	     * @example
	     * // Which day of the week is 29 February 2012?
	     * var result = getDay(new Date(2012, 1, 29))
	     * //=> 3
	     */
	    function getDay (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var day = date.getDay();
	      return day
	    }

	    var get_day = getDay;

	    var MILLISECONDS_IN_MINUTE = 60000;
	    var MILLISECONDS_IN_WEEK = 604800000;

	    /**
	     * @category Week Helpers
	     * @summary Get the number of calendar weeks between the given dates.
	     *
	     * @description
	     * Get the number of calendar weeks between the given dates.
	     *
	     * @param {Date|String|Number} dateLeft - the later date
	     * @param {Date|String|Number} dateRight - the earlier date
	     * @param {Object} [options] - the object with options
	     * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	     * @returns {Number} the number of calendar weeks
	     *
	     * @example
	     * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	     * var result = differenceInCalendarWeeks(
	     *   new Date(2014, 6, 20),
	     *   new Date(2014, 6, 5)
	     * )
	     * //=> 3
	     *
	     * @example
	     * // If the week starts on Monday,
	     * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	     * var result = differenceInCalendarWeeks(
	     *   new Date(2014, 6, 20),
	     *   new Date(2014, 6, 5),
	     *   {weekStartsOn: 1}
	     * )
	     * //=> 2
	     */
	    function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	      var startOfWeekLeft = start_of_week(dirtyDateLeft, dirtyOptions);
	      var startOfWeekRight = start_of_week(dirtyDateRight, dirtyOptions);

	      var timestampLeft = startOfWeekLeft.getTime() -
	        startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	      var timestampRight = startOfWeekRight.getTime() -
	        startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;

	      // Round the number of days to the nearest integer
	      // because the number of milliseconds in a week is not constant
	      // (e.g. it's different in the week of the daylight saving time clock shift)
	      return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
	    }

	    var difference_in_calendar_weeks = differenceInCalendarWeeks;

	    /**
	     * @category Day Helpers
	     * @summary Is the given date today?
	     *
	     * @description
	     * Is the given date today?
	     *
	     * @param {Date|String|Number} date - the date to check
	     * @returns {Boolean} the date is today
	     *
	     * @example
	     * // If today is 6 October 2014, is 6 October 14:00:00 today?
	     * var result = isToday(new Date(2014, 9, 6, 14, 0))
	     * //=> true
	     */
	    function isToday (dirtyDate) {
	      return start_of_day(dirtyDate).getTime() === start_of_day(new Date()).getTime()
	    }

	    var is_today = isToday;

	    /**
	     * @category Day Helpers
	     * @summary Are the given dates in the same day?
	     *
	     * @description
	     * Are the given dates in the same day?
	     *
	     * @param {Date|String|Number} dateLeft - the first date to check
	     * @param {Date|String|Number} dateRight - the second date to check
	     * @returns {Boolean} the dates are in the same day
	     *
	     * @example
	     * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	     * var result = isSameDay(
	     *   new Date(2014, 8, 4, 6, 0),
	     *   new Date(2014, 8, 4, 18, 0)
	     * )
	     * //=> true
	     */
	    function isSameDay (dirtyDateLeft, dirtyDateRight) {
	      var dateLeftStartOfDay = start_of_day(dirtyDateLeft);
	      var dateRightStartOfDay = start_of_day(dirtyDateRight);

	      return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
	    }

	    var is_same_day = isSameDay;

	    /**
	     * @category Common Helpers
	     * @summary Is the first date before the second one?
	     *
	     * @description
	     * Is the first date before the second one?
	     *
	     * @param {Date|String|Number} date - the date that should be before the other one to return true
	     * @param {Date|String|Number} dateToCompare - the date to compare with
	     * @returns {Boolean} the first date is before the second date
	     *
	     * @example
	     * // Is 10 July 1989 before 11 February 1987?
	     * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	     * //=> false
	     */
	    function isBefore (dirtyDate, dirtyDateToCompare) {
	      var date = parse_1(dirtyDate);
	      var dateToCompare = parse_1(dirtyDateToCompare);
	      return date.getTime() < dateToCompare.getTime()
	    }

	    var is_before = isBefore;

	    /**
	     * @category Common Helpers
	     * @summary Is the first date after the second one?
	     *
	     * @description
	     * Is the first date after the second one?
	     *
	     * @param {Date|String|Number} date - the date that should be after the other one to return true
	     * @param {Date|String|Number} dateToCompare - the date to compare with
	     * @returns {Boolean} the first date is after the second date
	     *
	     * @example
	     * // Is 10 July 1989 after 11 February 1987?
	     * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	     * //=> true
	     */
	    function isAfter (dirtyDate, dirtyDateToCompare) {
	      var date = parse_1(dirtyDate);
	      var dateToCompare = parse_1(dirtyDateToCompare);
	      return date.getTime() > dateToCompare.getTime()
	    }

	    var is_after = isAfter;

	    /**
	     * @category Day Helpers
	     * @summary Add the specified number of days to the given date.
	     *
	     * @description
	     * Add the specified number of days to the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of days to be added
	     * @returns {Date} the new date with the days added
	     *
	     * @example
	     * // Add 10 days to 1 September 2014:
	     * var result = addDays(new Date(2014, 8, 1), 10)
	     * //=> Thu Sep 11 2014 00:00:00
	     */
	    function addDays (dirtyDate, dirtyAmount) {
	      var date = parse_1(dirtyDate);
	      var amount = Number(dirtyAmount);
	      date.setDate(date.getDate() + amount);
	      return date
	    }

	    var add_days = addDays;

	    /**
	     * @category Day Helpers
	     * @summary Subtract the specified number of days from the given date.
	     *
	     * @description
	     * Subtract the specified number of days from the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of days to be subtracted
	     * @returns {Date} the new date with the days subtracted
	     *
	     * @example
	     * // Subtract 10 days from 1 September 2014:
	     * var result = subDays(new Date(2014, 8, 1), 10)
	     * //=> Fri Aug 22 2014 00:00:00
	     */
	    function subDays (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_days(dirtyDate, -amount)
	    }

	    var sub_days = subDays;

	    /**
	     * @category Month Helpers
	     * @summary Get the number of days in a month of the given date.
	     *
	     * @description
	     * Get the number of days in a month of the given date.
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the number of days in a month
	     *
	     * @example
	     * // How many days are in February 2000?
	     * var result = getDaysInMonth(new Date(2000, 1))
	     * //=> 29
	     */
	    function getDaysInMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var year = date.getFullYear();
	      var monthIndex = date.getMonth();
	      var lastDayOfMonth = new Date(0);
	      lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	      lastDayOfMonth.setHours(0, 0, 0, 0);
	      return lastDayOfMonth.getDate()
	    }

	    var get_days_in_month = getDaysInMonth;

	    /**
	     * @category Month Helpers
	     * @summary Add the specified number of months to the given date.
	     *
	     * @description
	     * Add the specified number of months to the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of months to be added
	     * @returns {Date} the new date with the months added
	     *
	     * @example
	     * // Add 5 months to 1 September 2014:
	     * var result = addMonths(new Date(2014, 8, 1), 5)
	     * //=> Sun Feb 01 2015 00:00:00
	     */
	    function addMonths (dirtyDate, dirtyAmount) {
	      var date = parse_1(dirtyDate);
	      var amount = Number(dirtyAmount);
	      var desiredMonth = date.getMonth() + amount;
	      var dateWithDesiredMonth = new Date(0);
	      dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
	      dateWithDesiredMonth.setHours(0, 0, 0, 0);
	      var daysInMonth = get_days_in_month(dateWithDesiredMonth);
	      // Set the last day of the new month
	      // if the original date was the last day of the longer month
	      date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
	      return date
	    }

	    var add_months = addMonths;

	    /**
	     * @category Year Helpers
	     * @summary Add the specified number of years to the given date.
	     *
	     * @description
	     * Add the specified number of years to the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of years to be added
	     * @returns {Date} the new date with the years added
	     *
	     * @example
	     * // Add 5 years to 1 September 2014:
	     * var result = addYears(new Date(2014, 8, 1), 5)
	     * //=> Sun Sep 01 2019 00:00:00
	     */
	    function addYears (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_months(dirtyDate, amount * 12)
	    }

	    var add_years = addYears;

	    /**
	     * @category Year Helpers
	     * @summary Subtract the specified number of years from the given date.
	     *
	     * @description
	     * Subtract the specified number of years from the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of years to be subtracted
	     * @returns {Date} the new date with the years subtracted
	     *
	     * @example
	     * // Subtract 5 years from 1 September 2014:
	     * var result = subYears(new Date(2014, 8, 1), 5)
	     * //=> Tue Sep 01 2009 00:00:00
	     */
	    function subYears (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_years(dirtyDate, -amount)
	    }

	    var sub_years = subYears;

	    /**
	     * @category Month Helpers
	     * @summary Subtract the specified number of months from the given date.
	     *
	     * @description
	     * Subtract the specified number of months from the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of months to be subtracted
	     * @returns {Date} the new date with the months subtracted
	     *
	     * @example
	     * // Subtract 5 months from 1 February 2015:
	     * var result = subMonths(new Date(2015, 1, 1), 5)
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function subMonths (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_months(dirtyDate, -amount)
	    }

	    var sub_months = subMonths;

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/forms/src/DatePicker.svelte generated by Svelte v3.38.2 */

	    const { document: document_1$5 } = globals;

	    function add_css$i() {
	    	var style = element("style");
	    	style.id = "svelte-1ktvy4d-style";
	    	style.textContent = ".pros-highlight-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1ktvy4d .pros-input.svelte-1ktvy4d{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-1ktvy4d .pros-input.svelte-1ktvy4d{padding-top:18px}.pros-control-container.has-label.svelte-1ktvy4d input.svelte-1ktvy4d::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-1ktvy4d.svelte-1ktvy4d{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1ktvy4d.svelte-1ktvy4d::after{content:\" *\"}.pros-action-button.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-1ktvy4d svg.svelte-1ktvy4d{width:24px;height:24px}.pros-action-button.svelte-1ktvy4d.svelte-1ktvy4d:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-end-cap.svelte-1ktvy4d svg.svelte-1ktvy4d{width:auto;height:auto}.pros-control-container.svelte-1ktvy4d.svelte-1ktvy4d{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1ktvy4d .pros-control-label.svelte-1ktvy4d,.pros-control-container.has-focus.svelte-1ktvy4d .pros-control-label.svelte-1ktvy4d{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1ktvy4d .pros-highlight-container.svelte-1ktvy4d{cursor:default}.pros-control-container.has-focus.svelte-1ktvy4d .pros-input.svelte-1ktvy4d{cursor:text}.pros-control-container.has-focus.svelte-1ktvy4d .pros-highlight-container.svelte-1ktvy4d{border-width:2px}.pros-control-container.has-focus.svelte-1ktvy4d .pros-input-container.svelte-1ktvy4d{margin-left:11px}.pros-control-container.has-focus.svelte-1ktvy4d .pros-end-cap.svelte-1ktvy4d:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-1ktvy4d input.svelte-1ktvy4d::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1ktvy4d .pros-status-icon.svelte-1ktvy4d{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1ktvy4d .pros-status-icon svg.svelte-1ktvy4d{height:100%;width:100%}.pros-message-container.svelte-1ktvy4d .pros-message.svelte-1ktvy4d{flex:1}.pros-options-wrapper.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;position:fixed;z-index:1001;box-sizing:border-box;border-radius:12px;border-width:1px;border-style:solid}.pros-date-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:flex-start;align-items:center}.pros-date-container.svelte-1ktvy4d .pros-month-container.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;width:100%;padding:8px}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;width:36px;min-width:36px;height:36px;cursor:pointer;margin:0 4px}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector.first.svelte-1ktvy4d{margin-left:0}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector.last.svelte-1ktvy4d{margin-right:0}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector svg.svelte-1ktvy4d{width:24px;height:24px}.pros-date-container.svelte-1ktvy4d .pros-current-month.svelte-1ktvy4d{flex:1;text-align:center;font-size:16px;font-weight:400;line-height:20px;user-select:none;margin:0 16px;min-width:130px}.pros-date-container.svelte-1ktvy4d .pros-footer.svelte-1ktvy4d{width:100%;padding:8px 0;position:relative}.pros-date-container.svelte-1ktvy4d .pros-footer .pros-button.svelte-1ktvy4d{width:100%}.pros-date-container.svelte-1ktvy4d .pros-calendar-content.svelte-1ktvy4d{width:100%;padding:0 16px}.pros-date-container.svelte-1ktvy4d .pros-calendar.svelte-1ktvy4d{flex:1}.pros-date-container.svelte-1ktvy4d .pros-calendar .week.svelte-1ktvy4d,.pros-date-container.svelte-1ktvy4d .pros-calendar .header.svelte-1ktvy4d{display:grid;grid-template-columns:repeat(7, 1fr);grid-auto-flow:dense;grid-gap:0 0}.pros-date-container.svelte-1ktvy4d .pros-calendar .day.svelte-1ktvy4d{display:contents}.pros-date-container.svelte-1ktvy4d .pros-calendar .week-day.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;font-size:12px;font-weight:300;line-height:24px;user-select:none}.pros-date-container.svelte-1ktvy4d .pros-calendar .day-label.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;grid-row-start:5;cursor:pointer;border:1px solid transparent;border-radius:8px;height:32px;width:100%;line-height:24px;box-sizing:border-box;margin:2px;font-size:16px;font-weight:400;user-select:none}.pros-date-container.svelte-1ktvy4d .pros-calendar .day-label.disabled.svelte-1ktvy4d{cursor:default}.pros-global-wrapper[pos--shape=sharp].svelte-1ktvy4d .pros-highlight-container.svelte-1ktvy4d{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-control-label.svelte-1ktvy4d{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-highlight-container.svelte-1ktvy4d{height:36px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1ktvy4d{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-input-container .pros-input.svelte-1ktvy4d{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-label .pros-input.svelte-1ktvy4d{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-value .pros-control-label.svelte-1ktvy4d,.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-focus .pros-control-label.svelte-1ktvy4d{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1ktvy4d{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-focus .pros-input-container.svelte-1ktvy4d{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.svelte-1ktvy4d{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-highlight-container.svelte-1ktvy4d{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-input.svelte-1ktvy4d{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container input.svelte-1ktvy4d::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.allow-hover .pros-highlight-container.svelte-1ktvy4d:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.error .pros-highlight-container.svelte-1ktvy4d{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.has-focus .pros-highlight-container.svelte-1ktvy4d{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-end-cap.svelte-1ktvy4d{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container.svelte-1ktvy4d{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container .pros-status-icon.svelte-1ktvy4d{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container.error.svelte-1ktvy4d{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1ktvy4d{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled.svelte-1ktvy4d{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-highlight-container.svelte-1ktvy4d{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-input.svelte-1ktvy4d{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-message-container.svelte-1ktvy4d{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-end-cap.svelte-1ktvy4d{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-action-button.svelte-1ktvy4d:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.svelte-1ktvy4d{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-highlight-container.svelte-1ktvy4d{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-input.svelte-1ktvy4d{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container input.svelte-1ktvy4d::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.allow-hover .pros-highlight-container.svelte-1ktvy4d:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.error .pros-highlight-container.svelte-1ktvy4d{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.has-focus .pros-highlight-container.svelte-1ktvy4d{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container.svelte-1ktvy4d{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container .pros-status-icon.svelte-1ktvy4d{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container.error.svelte-1ktvy4d{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1ktvy4d{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled.svelte-1ktvy4d{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled .pros-highlight-container.svelte-1ktvy4d{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled .pros-input.svelte-1ktvy4d{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled .pros-message-container.svelte-1ktvy4d{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-action-button.svelte-1ktvy4d:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d.svelte-1ktvy4d{background-color:#FFFFFF;color:#212121;border-color:transparent;box-shadow:0 0 3px 0 rgba(33, 33, 33, 0.15)}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d{color:#212121}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.potential.svelte-1ktvy4d{background-color:#f1f1f1;border-color:#f1f1f1}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.today.svelte-1ktvy4d{border-color:#adadad}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.selected.svelte-1ktvy4d{background-color:#027aae;border-color:#027aae;color:#FFFFFF}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d:hover{background-color:#f1f1f1;border-color:#f1f1f1}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label:hover.selected.svelte-1ktvy4d{background-color:#035b84;border-color:#035b84}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.disabled.svelte-1ktvy4d{color:#adadad;border-color:transparent;background-color:#FFFFFF}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d.svelte-1ktvy4d{background-color:#2b2b2b;color:white;border-color:transparent;box-shadow:0 0 3px 0 rgba(33, 33, 33, 0.15)}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .week-day.svelte-1ktvy4d{color:#adadad}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d{color:white}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.potential.svelte-1ktvy4d{background-color:rgba(255, 255, 255, 0.05);border-color:rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.today.svelte-1ktvy4d{border-color:#585858}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.selected.svelte-1ktvy4d{background-color:#3ab4eb;border-color:#3ab4eb;color:#212121}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d:hover{background-color:rgba(255, 255, 255, 0.05);border-color:rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label:hover.selected.svelte-1ktvy4d{background-color:#6dd0fb;border-color:#6dd0fb}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.disabled.svelte-1ktvy4d{color:#585858;border-color:transparent;background-color:#2b2b2b}";
	    	append(document_1$5.head, style);
	    }

	    function get_each_context$7(ctx, list, i) {
	    	const child_ctx = ctx.slice();
	    	child_ctx[96] = list[i];
	    	return child_ctx;
	    }

	    function get_each_context_1(ctx, list, i) {
	    	const child_ctx = ctx.slice();
	    	child_ctx[99] = list[i];
	    	return child_ctx;
	    }

	    function get_each_context_2(ctx, list, i) {
	    	const child_ctx = ctx.slice();
	    	child_ctx[102] = list[i];
	    	return child_ctx;
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_5$3(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*label*/ ctx[0]);
	    			attr(div, "id", /*_labelId*/ ctx[21]);
	    			attr(div, "class", "pros-control-label svelte-1ktvy4d");
	    			attr(div, "pros-tooltip", "");
	    			toggle_class(div, "required", /*required*/ ctx[5]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*label*/ 1) set_data(t, /*label*/ ctx[0]);

	    			if (dirty[0] & /*_labelId*/ 2097152) {
	    				attr(div, "id", /*_labelId*/ ctx[21]);
	    			}

	    			if (dirty[0] & /*required*/ 32) {
	    				toggle_class(div, "required", /*required*/ ctx[5]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (28:8) {#if clear && (_hasValue || _untrimmedValue) && !disabled}
	    function create_if_block_4$6(ctx) {
	    	let div;
	    	let svg;
	    	let path;
	    	let mounted;
	    	let dispose;

	    	return {
	    		c() {
	    			div = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1ktvy4d");
	    			attr(div, "id", /*_clearId*/ ctx[23]);
	    			attr(div, "class", "pros-action-button svelte-1ktvy4d");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, svg);
	    			append(svg, path);

	    			if (!mounted) {
	    				dispose = listen(div, "mousedown", /*handleClear*/ ctx[49]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_clearId*/ 8388608) {
	    				attr(div, "id", /*_clearId*/ ctx[23]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (42:6) {#if _showOptions && !disabled}
	    function create_if_block_3$7(ctx) {
	    	let div11;
	    	let div10;
	    	let div5;
	    	let div0;
	    	let svg0;
	    	let path0;
	    	let div0_pros_tooltip_value;
	    	let t0;
	    	let div1;
	    	let svg1;
	    	let path1;
	    	let div1_pros_tooltip_value;
	    	let t1;
	    	let div2;
	    	let t2;
	    	let t3;
	    	let div3;
	    	let svg2;
	    	let path2;
	    	let div3_pros_tooltip_value;
	    	let t4;
	    	let div4;
	    	let svg3;
	    	let path3;
	    	let div4_pros_tooltip_value;
	    	let t5;
	    	let div9;
	    	let div7;
	    	let div6;
	    	let t6;
	    	let t7;
	    	let div8;
	    	let button;
	    	let t8_value = /*$_*/ ctx[35]("today") + "";
	    	let t8;
	    	let globalClicks_action;
	    	let positionOptions_action;
	    	let mounted;
	    	let dispose;
	    	let each_value_2 = /*_dayLabels*/ ctx[36];
	    	let each_blocks_1 = [];

	    	for (let i = 0; i < each_value_2.length; i += 1) {
	    		each_blocks_1[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	    	}

	    	let each_value = /*weeksOfTheMonth*/ ctx[40](/*_date*/ ctx[13]);
	    	let each_blocks = [];

	    	for (let i = 0; i < each_value.length; i += 1) {
	    		each_blocks[i] = create_each_block$7(get_each_context$7(ctx, each_value, i));
	    	}

	    	return {
	    		c() {
	    			div11 = element("div");
	    			div10 = element("div");
	    			div5 = element("div");
	    			div0 = element("div");
	    			svg0 = svg_element("svg");
	    			path0 = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			svg1 = svg_element("svg");
	    			path1 = svg_element("path");
	    			t1 = space();
	    			div2 = element("div");
	    			t2 = text(/*_monthYear*/ ctx[14]);
	    			t3 = space();
	    			div3 = element("div");
	    			svg2 = svg_element("svg");
	    			path2 = svg_element("path");
	    			t4 = space();
	    			div4 = element("div");
	    			svg3 = svg_element("svg");
	    			path3 = svg_element("path");
	    			t5 = space();
	    			div9 = element("div");
	    			div7 = element("div");
	    			div6 = element("div");

	    			for (let i = 0; i < each_blocks_1.length; i += 1) {
	    				each_blocks_1[i].c();
	    			}

	    			t6 = space();

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].c();
	    			}

	    			t7 = space();
	    			div8 = element("div");
	    			button = element("button");
	    			t8 = text(t8_value);
	    			attr(path0, "fill-rule", "evenodd");
	    			attr(path0, "clip-rule", "evenodd");
	    			attr(path0, "d", "M12.3536 4.85355C12.5488 4.65829 12.5488 4.34171 12.3536 4.14645C12.1583 3.95118 11.8417 3.95118 11.6464 4.14645L4.14645 11.6464C3.95118 11.8417 3.95118 12.1583 4.14645 12.3536L11.6464 19.8536C11.8417 20.0488 12.1583 20.0488 12.3536 19.8536C12.5488 19.6583 12.5488 19.3417 12.3536 19.1464L5.20711 12L12.3536 4.85355ZM19.3536 4.85355C19.5488 4.65829 19.5488 4.34171 19.3536 4.14645C19.1583 3.95118 18.8417 3.95118 18.6464 4.14645L11.1464 11.6464C10.9512 11.8417 10.9512 12.1583 11.1464 12.3536L18.6464 19.8536C18.8417 20.0488 19.1583 20.0488 19.3536 19.8536C19.5488 19.6583 19.5488 19.3417 19.3536 19.1464L12.2071 12L19.3536 4.85355Z");
	    			attr(svg0, "width", "24");
	    			attr(svg0, "height", "24");
	    			attr(svg0, "viewBox", "0 0 24 24");
	    			attr(svg0, "fill", "currentColor");
	    			attr(svg0, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg0, "class", "svelte-1ktvy4d");
	    			attr(div0, "id", /*_prevYearId*/ ctx[29]);
	    			attr(div0, "class", "pros-button pros-month-selector first svelte-1ktvy4d");
	    			attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*$_*/ ctx[35]("prevYear"));
	    			attr(path1, "d", "M15.4999 20.5C15.372 20.5 15.244 20.4512 15.1464 20.3535L7.14637 12.3535C6.95106 12.1582 6.95106 11.8418 7.14637 11.6465L15.1464 3.64648C15.3417 3.45117 15.6581 3.45117 15.8534 3.64648C16.0487 3.8418 16.0487 4.1582 15.8534 4.35352L8.20692 12L15.8534 19.6465C16.0487 19.8418 16.0487 20.1582 15.8534 20.3535C15.7557 20.4512 15.6278 20.5 15.4999 20.5Z");
	    			attr(svg1, "width", "24");
	    			attr(svg1, "height", "24");
	    			attr(svg1, "viewBox", "0 0 24 24");
	    			attr(svg1, "fill", "currentColor");
	    			attr(svg1, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg1, "class", "svelte-1ktvy4d");
	    			attr(div1, "id", /*_prevMonthId*/ ctx[30]);
	    			attr(div1, "class", "pros-button pros-month-selector svelte-1ktvy4d");
	    			attr(div1, "pros-tooltip", div1_pros_tooltip_value = /*$_*/ ctx[35]("prevMonth"));
	    			attr(div2, "class", "pros-current-month svelte-1ktvy4d");
	    			attr(path2, "d", "M8.49989 20.5C8.37196 20.5 8.24403 20.4512 8.14637 20.3535C7.95106 20.1582 7.95106 19.8418 8.14637 19.6465L15.7929 12L8.14637 4.35352C7.95106 4.1582 7.95106 3.8418 8.14637 3.64648C8.34168 3.45117 8.65809 3.45117 8.8534 3.64648L16.8534 11.6465C17.0487 11.8418 17.0487 12.1582 16.8534 12.3535L8.8534 20.3535C8.75574 20.4512 8.62782 20.5 8.49989 20.5Z");
	    			attr(svg2, "width", "24");
	    			attr(svg2, "height", "24");
	    			attr(svg2, "viewBox", "0 0 24 24");
	    			attr(svg2, "fill", "currentColor");
	    			attr(svg2, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg2, "class", "svelte-1ktvy4d");
	    			attr(div3, "id", /*_nextMonthId*/ ctx[27]);
	    			attr(div3, "class", "pros-button pros-month-selector svelte-1ktvy4d");
	    			attr(div3, "pros-tooltip", div3_pros_tooltip_value = /*$_*/ ctx[35]("nextMonth"));
	    			attr(path3, "fill-rule", "evenodd");
	    			attr(path3, "clip-rule", "evenodd");
	    			attr(path3, "d", "M11.6464 4.85355C11.4512 4.65829 11.4512 4.34171 11.6464 4.14645C11.8417 3.95118 12.1583 3.95118 12.3536 4.14645L19.8536 11.6464C20.0488 11.8417 20.0488 12.1583 19.8536 12.3536L12.3536 19.8536C12.1583 20.0488 11.8417 20.0488 11.6464 19.8536C11.4512 19.6583 11.4512 19.3417 11.6464 19.1464L18.7929 12L11.6464 4.85355ZM4.64645 4.85355C4.45118 4.65829 4.45118 4.34171 4.64645 4.14645C4.84171 3.95118 5.15829 3.95118 5.35355 4.14645L12.8536 11.6464C13.0488 11.8417 13.0488 12.1583 12.8536 12.3536L5.35355 19.8536C5.15829 20.0488 4.84171 20.0488 4.64645 19.8536C4.45119 19.6583 4.45119 19.3417 4.64645 19.1464L11.7929 12L4.64645 4.85355Z");
	    			attr(svg3, "width", "24");
	    			attr(svg3, "height", "24");
	    			attr(svg3, "viewBox", "0 0 24 24");
	    			attr(svg3, "fill", "currentColor");
	    			attr(svg3, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg3, "class", "svelte-1ktvy4d");
	    			attr(div4, "id", /*_nextYearId*/ ctx[28]);
	    			attr(div4, "class", "pros-button pros-month-selector last svelte-1ktvy4d");
	    			attr(div4, "pros-tooltip", div4_pros_tooltip_value = /*$_*/ ctx[35]("nextYear"));
	    			attr(div5, "class", "pros-month-container svelte-1ktvy4d");
	    			attr(div6, "class", "header svelte-1ktvy4d");
	    			attr(div7, "class", "pros-calendar svelte-1ktvy4d");
	    			attr(button, "id", /*_todayId*/ ctx[32]);
	    			attr(button, "class", "pros-button svelte-1ktvy4d");
	    			attr(button, "type", "button");
	    			attr(div8, "class", "pros-footer svelte-1ktvy4d");
	    			attr(div9, "class", "pros-calendar-content svelte-1ktvy4d");
	    			attr(div10, "id", /*_optionsId*/ ctx[31]);
	    			attr(div10, "class", "pros-date-container svelte-1ktvy4d");
	    			attr(div11, "class", "pros-options-wrapper svelte-1ktvy4d");
	    			attr(div11, "pos--theme", /*_theme*/ ctx[17]);
	    			attr(div11, "pos--shape", /*_shape*/ ctx[18]);
	    			attr(div11, "pos--density", /*_density*/ ctx[19]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div11, anchor);
	    			append(div11, div10);
	    			append(div10, div5);
	    			append(div5, div0);
	    			append(div0, svg0);
	    			append(svg0, path0);
	    			append(div5, t0);
	    			append(div5, div1);
	    			append(div1, svg1);
	    			append(svg1, path1);
	    			append(div5, t1);
	    			append(div5, div2);
	    			append(div2, t2);
	    			append(div5, t3);
	    			append(div5, div3);
	    			append(div3, svg2);
	    			append(svg2, path2);
	    			append(div5, t4);
	    			append(div5, div4);
	    			append(div4, svg3);
	    			append(svg3, path3);
	    			append(div10, t5);
	    			append(div10, div9);
	    			append(div9, div7);
	    			append(div7, div6);

	    			for (let i = 0; i < each_blocks_1.length; i += 1) {
	    				each_blocks_1[i].m(div6, null);
	    			}

	    			append(div7, t6);

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].m(div7, null);
	    			}

	    			append(div9, t7);
	    			append(div9, div8);
	    			append(div8, button);
	    			append(button, t8);

	    			if (!mounted) {
	    				dispose = [
	    					listen(div0, "click", /*previousYear*/ ctx[45]),
	    					listen(div0, "mousedown", preventClickPropagation$2),
	    					listen(div0, "mouseup", preventClickPropagation$2),
	    					listen(div1, "click", /*previousMonth*/ ctx[43]),
	    					listen(div1, "mousedown", preventClickPropagation$2),
	    					listen(div1, "mouseup", preventClickPropagation$2),
	    					listen(div3, "click", /*nextMonth*/ ctx[42]),
	    					listen(div3, "mousedown", preventClickPropagation$2),
	    					listen(div3, "mouseup", preventClickPropagation$2),
	    					listen(div4, "click", /*nextYear*/ ctx[44]),
	    					listen(div4, "mousedown", preventClickPropagation$2),
	    					listen(div4, "mouseup", preventClickPropagation$2),
	    					listen(button, "click", /*click_handler_1*/ ctx[68]),
	    					listen(button, "mousedown", preventClickPropagation$2),
	    					listen(button, "mouseup", preventClickPropagation$2),
	    					action_destroyer(globalClicks_action = /*globalClicks*/ ctx[37].call(null, div11)),
	    					action_destroyer(positionOptions_action = /*positionOptions*/ ctx[38].call(null, div11))
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_prevYearId*/ 536870912) {
	    				attr(div0, "id", /*_prevYearId*/ ctx[29]);
	    			}

	    			if (dirty[1] & /*$_*/ 16 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*$_*/ ctx[35]("prevYear"))) {
	    				attr(div0, "pros-tooltip", div0_pros_tooltip_value);
	    			}

	    			if (dirty[0] & /*_prevMonthId*/ 1073741824) {
	    				attr(div1, "id", /*_prevMonthId*/ ctx[30]);
	    			}

	    			if (dirty[1] & /*$_*/ 16 && div1_pros_tooltip_value !== (div1_pros_tooltip_value = /*$_*/ ctx[35]("prevMonth"))) {
	    				attr(div1, "pros-tooltip", div1_pros_tooltip_value);
	    			}

	    			if (dirty[0] & /*_monthYear*/ 16384) set_data(t2, /*_monthYear*/ ctx[14]);

	    			if (dirty[0] & /*_nextMonthId*/ 134217728) {
	    				attr(div3, "id", /*_nextMonthId*/ ctx[27]);
	    			}

	    			if (dirty[1] & /*$_*/ 16 && div3_pros_tooltip_value !== (div3_pros_tooltip_value = /*$_*/ ctx[35]("nextMonth"))) {
	    				attr(div3, "pros-tooltip", div3_pros_tooltip_value);
	    			}

	    			if (dirty[0] & /*_nextYearId*/ 268435456) {
	    				attr(div4, "id", /*_nextYearId*/ ctx[28]);
	    			}

	    			if (dirty[1] & /*$_*/ 16 && div4_pros_tooltip_value !== (div4_pros_tooltip_value = /*$_*/ ctx[35]("nextYear"))) {
	    				attr(div4, "pros-tooltip", div4_pros_tooltip_value);
	    			}

	    			if (dirty[1] & /*_dayLabels*/ 32) {
	    				each_value_2 = /*_dayLabels*/ ctx[36];
	    				let i;

	    				for (i = 0; i < each_value_2.length; i += 1) {
	    					const child_ctx = get_each_context_2(ctx, each_value_2, i);

	    					if (each_blocks_1[i]) {
	    						each_blocks_1[i].p(child_ctx, dirty);
	    					} else {
	    						each_blocks_1[i] = create_each_block_2(child_ctx);
	    						each_blocks_1[i].c();
	    						each_blocks_1[i].m(div6, null);
	    					}
	    				}

	    				for (; i < each_blocks_1.length; i += 1) {
	    					each_blocks_1[i].d(1);
	    				}

	    				each_blocks_1.length = each_value_2.length;
	    			}

	    			if (dirty[0] & /*_days, _date, preventClickPropagation*/ 41216 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth, handleDateChanged, dayOfTheMonth*/ 132864) {
	    				each_value = /*weeksOfTheMonth*/ ctx[40](/*_date*/ ctx[13]);
	    				let i;

	    				for (i = 0; i < each_value.length; i += 1) {
	    					const child_ctx = get_each_context$7(ctx, each_value, i);

	    					if (each_blocks[i]) {
	    						each_blocks[i].p(child_ctx, dirty);
	    					} else {
	    						each_blocks[i] = create_each_block$7(child_ctx);
	    						each_blocks[i].c();
	    						each_blocks[i].m(div7, null);
	    					}
	    				}

	    				for (; i < each_blocks.length; i += 1) {
	    					each_blocks[i].d(1);
	    				}

	    				each_blocks.length = each_value.length;
	    			}

	    			if (dirty[1] & /*$_*/ 16 && t8_value !== (t8_value = /*$_*/ ctx[35]("today") + "")) set_data(t8, t8_value);

	    			if (dirty[1] & /*_todayId*/ 2) {
	    				attr(button, "id", /*_todayId*/ ctx[32]);
	    			}

	    			if (dirty[1] & /*_optionsId*/ 1) {
	    				attr(div10, "id", /*_optionsId*/ ctx[31]);
	    			}

	    			if (dirty[0] & /*_theme*/ 131072) {
	    				attr(div11, "pos--theme", /*_theme*/ ctx[17]);
	    			}

	    			if (dirty[0] & /*_shape*/ 262144) {
	    				attr(div11, "pos--shape", /*_shape*/ ctx[18]);
	    			}

	    			if (dirty[0] & /*_density*/ 524288) {
	    				attr(div11, "pos--density", /*_density*/ ctx[19]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div11);
	    			destroy_each(each_blocks_1, detaching);
	    			destroy_each(each_blocks, detaching);
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (72:16) {#each _dayLabels as dayLabel}
	    function create_each_block_2(ctx) {
	    	let div;
	    	let t_value = /*dayLabel*/ ctx[102] + "";
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(t_value);
	    			attr(div, "class", "week-day svelte-1ktvy4d");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p: noop,
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (79:16) {#each daysOfCurrentWeek(_days, week) as day}
	    function create_each_block_1(ctx) {
	    	let div1;
	    	let div0;
	    	let t_value = /*dayOfTheMonth*/ ctx[39](/*day*/ ctx[99].value) + "";
	    	let t;
	    	let div1_id_value;
	    	let mounted;
	    	let dispose;

	    	function click_handler(...args) {
	    		return /*click_handler*/ ctx[67](/*day*/ ctx[99], ...args);
	    	}

	    	return {
	    		c() {
	    			div1 = element("div");
	    			div0 = element("div");
	    			t = text(t_value);
	    			attr(div0, "class", "day-label svelte-1ktvy4d");
	    			toggle_class(div0, "today", /*day*/ ctx[99].isToday);
	    			toggle_class(div0, "potential", /*day*/ ctx[99].isPotential);
	    			toggle_class(div0, "selected", /*day*/ ctx[99].isSelected);
	    			toggle_class(div0, "disabled", /*day*/ ctx[99].isDisabled);
	    			attr(div1, "id", div1_id_value = /*day*/ ctx[99].id);
	    			attr(div1, "class", "day svelte-1ktvy4d");
	    		},
	    		m(target, anchor) {
	    			insert(target, div1, anchor);
	    			append(div1, div0);
	    			append(div0, t);

	    			if (!mounted) {
	    				dispose = [
	    					listen(div0, "click", click_handler),
	    					listen(div0, "mousedown", preventClickPropagation$2),
	    					listen(div0, "mouseup", preventClickPropagation$2)
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(new_ctx, dirty) {
	    			ctx = new_ctx;
	    			if (dirty[0] & /*_days, _date*/ 40960 && t_value !== (t_value = /*dayOfTheMonth*/ ctx[39](/*day*/ ctx[99].value) + "")) set_data(t, t_value);

	    			if (dirty[0] & /*_days, _date*/ 40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/ 1536) {
	    				toggle_class(div0, "today", /*day*/ ctx[99].isToday);
	    			}

	    			if (dirty[0] & /*_days, _date*/ 40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/ 1536) {
	    				toggle_class(div0, "potential", /*day*/ ctx[99].isPotential);
	    			}

	    			if (dirty[0] & /*_days, _date*/ 40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/ 1536) {
	    				toggle_class(div0, "selected", /*day*/ ctx[99].isSelected);
	    			}

	    			if (dirty[0] & /*_days, _date*/ 40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/ 1536) {
	    				toggle_class(div0, "disabled", /*day*/ ctx[99].isDisabled);
	    			}

	    			if (dirty[0] & /*_days, _date*/ 40960 && div1_id_value !== (div1_id_value = /*day*/ ctx[99].id)) {
	    				attr(div1, "id", div1_id_value);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div1);
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (77:14) {#each weeksOfTheMonth(_date) as week}
	    function create_each_block$7(ctx) {
	    	let div;
	    	let t;
	    	let each_value_1 = /*daysOfCurrentWeek*/ ctx[41](/*_days*/ ctx[15], /*week*/ ctx[96]);
	    	let each_blocks = [];

	    	for (let i = 0; i < each_value_1.length; i += 1) {
	    		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	    	}

	    	return {
	    		c() {
	    			div = element("div");

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].c();
	    			}

	    			t = space();
	    			attr(div, "class", "week svelte-1ktvy4d");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].m(div, null);
	    			}

	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_days, _date, preventClickPropagation*/ 41216 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth, handleDateChanged, dayOfTheMonth*/ 132864) {
	    				each_value_1 = /*daysOfCurrentWeek*/ ctx[41](/*_days*/ ctx[15], /*week*/ ctx[96]);
	    				let i;

	    				for (i = 0; i < each_value_1.length; i += 1) {
	    					const child_ctx = get_each_context_1(ctx, each_value_1, i);

	    					if (each_blocks[i]) {
	    						each_blocks[i].p(child_ctx, dirty);
	    					} else {
	    						each_blocks[i] = create_each_block_1(child_ctx);
	    						each_blocks[i].c();
	    						each_blocks[i].m(div, t);
	    					}
	    				}

	    				for (; i < each_blocks.length; i += 1) {
	    					each_blocks[i].d(1);
	    				}

	    				each_blocks.length = each_value_1.length;
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_each(each_blocks, detaching);
	    		}
	    	};
	    }

	    // (97:4) {#if display !== 'custom'}
	    function create_if_block$g(ctx) {
	    	let div;

	    	function select_block_type(ctx, dirty) {
	    		if (/*_dirty*/ ctx[10] && /*_errors*/ ctx[9].length > 0) return create_if_block_1$b;
	    		if (/*hint*/ ctx[3] && /*_showOptions*/ ctx[12]) return create_if_block_2$a;
	    		return create_else_block$9;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-message-container svelte-1ktvy4d");
	    			toggle_class(div, "error", /*_dirty*/ ctx[10] && /*_errors*/ ctx[9].length > 0);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, dirty) {
	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 1536) {
	    				toggle_class(div, "error", /*_dirty*/ ctx[10] && /*_errors*/ ctx[9].length > 0);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    // (113:6) {:else}
	    function create_else_block$9(ctx) {
	    	let div;

	    	return {
	    		c() {
	    			div = element("div");
	    			attr(div, "id", /*_messageId*/ ctx[25]);
	    			attr(div, "class", "pros-message svelte-1ktvy4d");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_messageId*/ 33554432) {
	    				attr(div, "id", /*_messageId*/ ctx[25]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (106:37) 
	    function create_if_block_2$a(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(/*hint*/ ctx[3]);
	    			attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1ktvy4d");
	    			attr(div0, "id", /*_statusIconId*/ ctx[26]);
	    			attr(div0, "class", "pros-status-icon svelte-1ktvy4d");
	    			attr(div1, "id", /*_messageId*/ ctx[25]);
	    			attr(div1, "class", "pros-message svelte-1ktvy4d");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 67108864) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[26]);
	    			}

	    			if (dirty[0] & /*hint*/ 8) set_data(t1, /*hint*/ ctx[3]);

	    			if (dirty[0] & /*_messageId*/ 33554432) {
	    				attr(div1, "id", /*_messageId*/ ctx[25]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    // (99:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$b(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1_value = /*_errors*/ ctx[9][0] + "";
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(t1_value);
	    			attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1ktvy4d");
	    			attr(div0, "id", /*_statusIconId*/ ctx[26]);
	    			attr(div0, "class", "pros-status-icon error svelte-1ktvy4d");
	    			attr(div1, "id", /*_messageId*/ ctx[25]);
	    			attr(div1, "class", "pros-message error svelte-1ktvy4d");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 67108864) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[26]);
	    			}

	    			if (dirty[0] & /*_errors*/ 512 && t1_value !== (t1_value = /*_errors*/ ctx[9][0] + "")) set_data(t1, t1_value);

	    			if (dirty[0] & /*_messageId*/ 33554432) {
	    				attr(div1, "id", /*_messageId*/ ctx[25]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    function create_fragment$j(ctx) {
	    	let div5;
	    	let div4;
	    	let t0;
	    	let div3;
	    	let div2;
	    	let div0;
	    	let input;
	    	let t1;
	    	let t2;
	    	let div1;
	    	let svg;
	    	let path;
	    	let t3;
	    	let t4;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*_hasLabel*/ ctx[34] && create_if_block_5$3(ctx);
	    	let if_block1 = /*clear*/ ctx[4] && (/*_hasValue*/ ctx[33] || /*_untrimmedValue*/ ctx[11]) && !/*disabled*/ ctx[6] && create_if_block_4$6(ctx);
	    	let if_block2 = /*_showOptions*/ ctx[12] && !/*disabled*/ ctx[6] && create_if_block_3$7(ctx);
	    	let if_block3 = /*display*/ ctx[1] !== "custom" && create_if_block$g(ctx);

	    	return {
	    		c() {
	    			div5 = element("div");
	    			div4 = element("div");
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div3 = element("div");
	    			div2 = element("div");
	    			div0 = element("div");
	    			input = element("input");
	    			t1 = space();
	    			if (if_block1) if_block1.c();
	    			t2 = space();
	    			div1 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t3 = space();
	    			if (if_block2) if_block2.c();
	    			t4 = space();
	    			if (if_block3) if_block3.c();
	    			attr(input, "type", "text");
	    			attr(input, "id", /*_inputId*/ ctx[22]);
	    			attr(input, "class", "pros-input svelte-1ktvy4d");
	    			input.disabled = /*disabled*/ ctx[6];
	    			attr(input, "placeholder", /*placeholder*/ ctx[2]);
	    			attr(div0, "class", "pros-input-container svelte-1ktvy4d");
	    			attr(path, "d", "M19 5H17V4C17 3.72363 16.7764 3.5 16.5 3.5C16.2236 3.5 16 3.72363 16 4V7C16 7.27637 16.2236 7.5 16.5 7.5C16.7764 7.5 17 7.27637 17 7V6H19C19.5514 6 20 6.44861 20 7V9H4V7C4 6.44861 4.44861 6 5 6H5.5C5.77618 6 6 5.77612 6 5.5C6 5.22388 5.77618 5 5.5 5H5C3.89545 5 3 5.89545 3 7V19C3 20.1046 3.89545 21 5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89545 20.1046 5 19 5ZM19 20H5C4.44861 20 4 19.5514 4 19V10H20V19C20 19.5514 19.5514 20 19 20ZM7 7V4C7 3.72363 7.22363 3.5 7.5 3.5C7.77637 3.5 8 3.72363 8 4V5H14.5C14.7762 5 15 5.22388 15 5.5C15 5.77612 14.7762 6 14.5 6H8V7C8 7.27637 7.77637 7.5 7.5 7.5C7.22363 7.5 7 7.27637 7 7Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1ktvy4d");
	    			attr(div1, "id", /*_capId*/ ctx[24]);
	    			attr(div1, "class", "pros-end-cap svelte-1ktvy4d");
	    			attr(div1, "disabled", /*disabled*/ ctx[6]);
	    			attr(div2, "class", "pros-content-container svelte-1ktvy4d");
	    			attr(div3, "class", "pros-highlight-container svelte-1ktvy4d");
	    			attr(div4, "class", "pros-control-container svelte-1ktvy4d");
	    			toggle_class(div4, "has-value", /*_hasValue*/ ctx[33]);
	    			toggle_class(div4, "has-label", /*_hasLabel*/ ctx[34]);
	    			toggle_class(div4, "has-focus", /*_showOptions*/ ctx[12] || /*_hasFocus*/ ctx[20]);
	    			toggle_class(div4, "custom-layout", /*display*/ ctx[1] === "custom");
	    			toggle_class(div4, "error", /*_dirty*/ ctx[10] && /*_errors*/ ctx[9].length > 0);
	    			toggle_class(div4, "disabled", /*disabled*/ ctx[6]);
	    			toggle_class(div4, "allow-hover", !/*disabled*/ ctx[6]);
	    			attr(div5, "class", "pros-global-wrapper pros-form-control svelte-1ktvy4d");
	    			attr(div5, "pos--theme", /*_theme*/ ctx[17]);
	    			attr(div5, "pos--shape", /*_shape*/ ctx[18]);
	    			attr(div5, "pos--density", /*_density*/ ctx[19]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div5, anchor);
	    			append(div5, div4);
	    			if (if_block0) if_block0.m(div4, null);
	    			append(div4, t0);
	    			append(div4, div3);
	    			append(div3, div2);
	    			append(div2, div0);
	    			append(div0, input);
	    			set_input_value(input, /*_untrimmedValue*/ ctx[11]);
	    			/*input_binding*/ ctx[66](input);
	    			append(div2, t1);
	    			if (if_block1) if_block1.m(div2, null);
	    			append(div2, t2);
	    			append(div2, div1);
	    			append(div1, svg);
	    			append(svg, path);
	    			append(div3, t3);
	    			if (if_block2) if_block2.m(div3, null);
	    			append(div4, t4);
	    			if (if_block3) if_block3.m(div4, null);

	    			if (!mounted) {
	    				dispose = [
	    					listen(input, "input", /*input_input_handler*/ ctx[65]),
	    					listen(input, "focus", /*handleFocus*/ ctx[46]),
	    					listen(input, "blur", /*handleBlur*/ ctx[47]),
	    					listen(div3, "click", /*openIfClosed*/ ctx[7])
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasLabel*/ ctx[34]) {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);
	    				} else {
	    					if_block0 = create_if_block_5$3(ctx);
	    					if_block0.c();
	    					if_block0.m(div4, t0);
	    				}
	    			} else if (if_block0) {
	    				if_block0.d(1);
	    				if_block0 = null;
	    			}

	    			if (dirty[0] & /*_inputId*/ 4194304) {
	    				attr(input, "id", /*_inputId*/ ctx[22]);
	    			}

	    			if (dirty[0] & /*disabled*/ 64) {
	    				input.disabled = /*disabled*/ ctx[6];
	    			}

	    			if (dirty[0] & /*placeholder*/ 4) {
	    				attr(input, "placeholder", /*placeholder*/ ctx[2]);
	    			}

	    			if (dirty[0] & /*_untrimmedValue*/ 2048 && input.value !== /*_untrimmedValue*/ ctx[11]) {
	    				set_input_value(input, /*_untrimmedValue*/ ctx[11]);
	    			}

	    			if (/*clear*/ ctx[4] && (/*_hasValue*/ ctx[33] || /*_untrimmedValue*/ ctx[11]) && !/*disabled*/ ctx[6]) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);
	    				} else {
	    					if_block1 = create_if_block_4$6(ctx);
	    					if_block1.c();
	    					if_block1.m(div2, t2);
	    				}
	    			} else if (if_block1) {
	    				if_block1.d(1);
	    				if_block1 = null;
	    			}

	    			if (dirty[0] & /*_capId*/ 16777216) {
	    				attr(div1, "id", /*_capId*/ ctx[24]);
	    			}

	    			if (dirty[0] & /*disabled*/ 64) {
	    				attr(div1, "disabled", /*disabled*/ ctx[6]);
	    			}

	    			if (/*_showOptions*/ ctx[12] && !/*disabled*/ ctx[6]) {
	    				if (if_block2) {
	    					if_block2.p(ctx, dirty);
	    				} else {
	    					if_block2 = create_if_block_3$7(ctx);
	    					if_block2.c();
	    					if_block2.m(div3, null);
	    				}
	    			} else if (if_block2) {
	    				if_block2.d(1);
	    				if_block2 = null;
	    			}

	    			if (/*display*/ ctx[1] !== "custom") {
	    				if (if_block3) {
	    					if_block3.p(ctx, dirty);
	    				} else {
	    					if_block3 = create_if_block$g(ctx);
	    					if_block3.c();
	    					if_block3.m(div4, null);
	    				}
	    			} else if (if_block3) {
	    				if_block3.d(1);
	    				if_block3 = null;
	    			}

	    			if (dirty[1] & /*_hasValue*/ 4) {
	    				toggle_class(div4, "has-value", /*_hasValue*/ ctx[33]);
	    			}

	    			if (dirty[1] & /*_hasLabel*/ 8) {
	    				toggle_class(div4, "has-label", /*_hasLabel*/ ctx[34]);
	    			}

	    			if (dirty[0] & /*_showOptions, _hasFocus*/ 1052672) {
	    				toggle_class(div4, "has-focus", /*_showOptions*/ ctx[12] || /*_hasFocus*/ ctx[20]);
	    			}

	    			if (dirty[0] & /*display*/ 2) {
	    				toggle_class(div4, "custom-layout", /*display*/ ctx[1] === "custom");
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 1536) {
	    				toggle_class(div4, "error", /*_dirty*/ ctx[10] && /*_errors*/ ctx[9].length > 0);
	    			}

	    			if (dirty[0] & /*disabled*/ 64) {
	    				toggle_class(div4, "disabled", /*disabled*/ ctx[6]);
	    			}

	    			if (dirty[0] & /*disabled*/ 64) {
	    				toggle_class(div4, "allow-hover", !/*disabled*/ ctx[6]);
	    			}

	    			if (dirty[0] & /*_theme*/ 131072) {
	    				attr(div5, "pos--theme", /*_theme*/ ctx[17]);
	    			}

	    			if (dirty[0] & /*_shape*/ 262144) {
	    				attr(div5, "pos--shape", /*_shape*/ ctx[18]);
	    			}

	    			if (dirty[0] & /*_density*/ 524288) {
	    				attr(div5, "pos--density", /*_density*/ ctx[19]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div5);
	    			if (if_block0) if_block0.d();
	    			/*input_binding*/ ctx[66](null);
	    			if (if_block1) if_block1.d();
	    			if (if_block2) if_block2.d();
	    			if (if_block3) if_block3.d();
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    function keyIsNumber(key) {
	    	return (/^\d+$/).test(key);
	    }

	    function keyIsSlash(key) {
	    	return key === "/";
	    }

	    function preventClickPropagation$2(event) {
	    	event.stopPropagation();
	    	event.preventDefault();
	    }

	    function hasValue$6(test) {
	    	return test !== undefined && test !== null;
	    }

	    function notEmpty$4(test) {
	    	return test !== undefined && test !== null && test.trim() !== "";
	    }

	    function instance$j($$self, $$props, $$invalidate) {
	    	let _hasValue;
	    	let _hasLabel;
	    	let $_;
	    	component_subscribe($$self, X, $$value => $$invalidate(35, $_ = $$value));
	    	const dispatch = createEventDispatcher();
	    	const DAYS_IN_WEEK = 7;
	    	let { globalClickListener = null } = $$props;
	    	let { globalKeyListener = null } = $$props;
	    	let { display = "form" } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
	    	let { shape = "round" } = $$props; // Shape style (round/sharp)
	    	let { density = "standard" } = $$props; // Density style (standard/high)
	    	let { value = null } = $$props; // Current value of control
	    	let { label = "" } = $$props; // Control label
	    	let { placeholder = "" } = $$props; // Placeholder text to display in text box when no value
	    	let { hint = "" } = $$props; // Hint/Helper text to display when no validation errors to display
	    	let { clear = false } = $$props; // Allow value to be cleared
	    	let { required = false } = $$props; // Is value required to be valid?
	    	let { disabled = false } = $$props; // Is Control disabled?
	    	let { validation = true } = $$props; // Do we include built in validation?
	    	let { errors = [] } = $$props; // Custom external validation errors
	    	let { format = "MM/DD/YYYY" } = $$props;
	    	let { min = null } = $$props;
	    	let { max = null } = $$props;
	    	let { id = null } = $$props;

	    	// Internal Data
	    	let _dirty = false; // Has the user changed the value (yes = dirty)

	    	let _errors = []; // Combined validation errors
	    	let _builtInErrors = []; // Built in validation errors
	    	let _lastValid;
	    	let _untrimmedValue = ""; // Actual value bound to input box (may include extra whitespace)
	    	let _showOptions = false; // Is Selector visible?
	    	let _dayLabels = [];
	    	let _dateLocale = en;
	    	let _openNode = undefined;
	    	let _openParent = undefined;
	    	let _date = null;
	    	let _monthYear = undefined;
	    	let _days = undefined;
	    	let _lastValue = undefined;
	    	let _inputElement = undefined;
	    	let _potential = undefined;
	    	let _themeEventListener;
	    	let _shapeEventListener;
	    	let _densityEventListener;
	    	let _theme;
	    	let _shape;
	    	let _density;
	    	let _lastTheme;
	    	let _lastShape;
	    	let _lastDensity;
	    	let _hasFocus = false;
	    	let _labelId = null;
	    	let _inputId = null;
	    	let _clearId = null;
	    	let _capId = null;
	    	let _messageId = null;
	    	let _statusIconId = null;
	    	let _nextMonthId = null;
	    	let _nextYearId = null;
	    	let _prevYearId = null;
	    	let _prevMonthId = null;
	    	let _optionsId = null;
	    	let _todayId = null;

	    	onMount(() => {
	    		initDayLabels();
	    		doValidate();
	    	});

	    	onDestroy(() => {
	    		if (_showOptions) {
	    			toggleOpen();
	    		}

	    		if (_themeEventListener) {
	    			window.removeEventListener("posh-theme-changed", _themeEventListener);
	    		}

	    		if (_shapeEventListener) {
	    			window.removeEventListener("posh-shape-changed", _shapeEventListener);
	    		}

	    		if (_densityEventListener) {
	    			window.removeEventListener("posh-density-changed", _densityEventListener);
	    		}
	    	});

	    	beforeUpdate(() => {
	    		// Normalize external changes
	    		$$invalidate(1, display = hasValue$6(display) ? display : "form");

	    		$$invalidate(53, theme = hasValue$6(theme) ? theme : "light");
	    		$$invalidate(54, shape = hasValue$6(shape) ? shape : "round");
	    		$$invalidate(55, density = hasValue$6(density) ? density : "standard");
	    		$$invalidate(0, label = hasValue$6(label) ? label : "");
	    		$$invalidate(2, placeholder = hasValue$6(placeholder) ? placeholder : "MM/DD/YYYY");
	    		$$invalidate(3, hint = hasValue$6(hint) ? hint : "");

	    		// value = hasValue(value) ? value : null; // Removing this code due to the infinite loop problem that happens when this component is used in the Grid
	    		$$invalidate(5, required = hasValue$6(required) ? required : false);

	    		$$invalidate(6, disabled = hasValue$6(disabled) ? disabled : false);
	    		$$invalidate(56, validation = hasValue$6(validation) ? validation : true);
	    		$$invalidate(4, clear = hasValue$6(clear) ? clear : false);
	    		$$invalidate(57, format = "MM/DD/YYYY");
	    		$$invalidate(58, min = hasValue$6(min) ? new Date(min) : null);
	    		$$invalidate(59, max = hasValue$6(max) ? new Date(max) : null);
	    		$$invalidate(21, _labelId = hasValue$6(id) ? `${id}-label` : undefined);
	    		$$invalidate(22, _inputId = hasValue$6(id) ? `${id}-input` : undefined);
	    		$$invalidate(23, _clearId = hasValue$6(id) ? `${id}-clear` : undefined);
	    		$$invalidate(24, _capId = hasValue$6(id) ? `${id}-cap` : undefined);

	    		$$invalidate(31, _optionsId = hasValue$6(id)
	    		? `${id}-options`
	    		: "pros-options-container");

	    		$$invalidate(25, _messageId = hasValue$6(id) ? `${id}-message` : undefined);
	    		$$invalidate(26, _statusIconId = hasValue$6(id) ? `${id}-status-icon` : undefined);
	    		$$invalidate(27, _nextMonthId = hasValue$6(id) ? `${id}-next-month` : undefined);
	    		$$invalidate(28, _nextYearId = hasValue$6(id) ? `${id}-next-year` : undefined);
	    		$$invalidate(30, _prevMonthId = hasValue$6(id) ? `${id}-prev-month` : undefined);
	    		$$invalidate(29, _prevYearId = hasValue$6(id) ? `${id}-prev-year` : undefined);
	    		$$invalidate(32, _todayId = hasValue$6(id) ? `${id}-today` : undefined);

	    		if (value !== _lastValue) {
	    			$$invalidate(13, _date = value ? value : new Date());
	    			_potential = new Date(_date);

	    			$$invalidate(11, _untrimmedValue = value
	    			? format_1(value, format, { locale: _dateLocale })
	    			: null);

	    			_lastValue = value;
	    			initDays();
	    		}

	    		if (theme !== _lastTheme) {
	    			_lastTheme = theme;

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(17, _theme = themeAttribute ? themeAttribute : "light");

	    				if (!_themeEventListener) {
	    					// Only start listening once
	    					_themeEventListener = window.addEventListener("posh-theme-changed", event => {
	    						if (theme === "auto") {
	    							$$invalidate(17, _theme = event.detail.theme);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(17, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			_lastShape = shape;

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(18, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					_shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(18, _shape = event.detail.shape);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(18, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			_lastDensity = density;

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(19, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					_densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(19, _density = event.detail.density);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(19, _density = density);
	    			}
	    		}

	    		doValidate.call(this);
	    	});

	    	function initDayLabels() {
	    		let today = new Date();

	    		// Find nearest sunday and loop through to get day labels for all 7 days
	    		let sunday = sub_days(today, get_day(today));

	    		for (let i = 0; i < DAYS_IN_WEEK; i++) {
	    			_dayLabels.push(format_1(sunday, "dd", _dateLocale));
	    			sunday = add_days(sunday, 1);
	    		}
	    	}

	    	function initDays() {
	    		let blankCounter = 1;
	    		$$invalidate(14, _monthYear = format_1(_date, "MMMM YYYY", { locale: _dateLocale }));
	    		let days = each_day(start_of_month(_date), last_day_of_month(_date));
	    		let startOfWeek = get_day(start_of_month(_date));
	    		let endOfWeek = get_day(end_of_month(_date));

	    		for (let i = 0; i < startOfWeek; i++) {
	    			days.unshift(null);
	    		}

	    		for (let i = 1; i < endOfWeek - 1; i++) {
	    			days.push(null);
	    		}

	    		$$invalidate(15, _days = days.map(day => {
	    			if (day) {
	    				return {
	    					value: day,
	    					isToday: is_today(day),
	    					isPotential: is_same_day(day, _potential),
	    					isSelected: is_same_day(day, value),
	    					isDisabled: min && is_before(day, min) || max && is_after(day, max),
	    					id: `${id}-day${dayOfTheMonth(day)}`
	    				};
	    			} else {
	    				return {
	    					value: day,
	    					isToday: false,
	    					isPotential: false,
	    					isSelected: false,
	    					isDisabled: false,
	    					id: `${id}-day-blank${blankCounter++}`
	    				};
	    			}
	    		}));

	    		difference_in_calendar_weeks(last_day_of_month(_date), start_of_month(_date)) + 1;
	    	}

	    	function containsDay(test) {
	    		for (let i = 0; i < _days.length; i++) {
	    			if (is_same_day(_days[i].value, test)) {
	    				return true;
	    			}
	    		}

	    		return false;
	    	}

	    	function globalClicks(node) {

	    		$$invalidate(51, globalClickListener = event => {
	    			let elements = [node];

	    			// Change NodeList to Array to use some()
	    			elements = Array.prototype.slice.call(elements);

	    			let containsClick = elements.some(element => {
	    				return element.contains(event.target);
	    			});

	    			if (event.target !== _inputElement && !containsClick) {
	    				if (inputIsValid()) {
	    					handleDateChanged(new Date(_untrimmedValue.trim()));
	    					return;
	    				} else {
	    					$$invalidate(11, _untrimmedValue = value
	    					? format_1(value, format, { locale: _dateLocale })
	    					: null);

	    					toggleOpen();
	    				}
	    			}
	    		});

	    		$$invalidate(52, globalKeyListener = event => {
	    			myKeyDown.call(this, event);
	    		});

	    		// Necessary to prevent handling click that opens panel
	    		window.setTimeout(
	    			() => {
	    				document.addEventListener("click", globalClickListener);
	    				document.addEventListener("keydown", globalKeyListener);
	    			},
	    			0
	    		);
	    	}

	    	function positionOptions(node) {
	    		_openNode = node;
	    		_openParent = node.parentElement;
	    		document.body.appendChild(node);

	    		positionNode();
	    		document.addEventListener("wheel", positionNode);
	    		window.addEventListener("scroll", positionNode, true);
	    		window.addEventListener("resize", positionNode);

	    		return {
	    			destroy() {
	    				document.removeEventListener("wheel", positionNode);
	    				window.removeEventListener("scroll", positionNode);
	    				window.removeEventListener("resize", positionNode);
	    			}
	    		};
	    	}

	    	function positionNode(scrollEvent) {
	    		if (!_openParent) {
	    			document.removeEventListener("wheel", positionNode);
	    			window.removeEventListener("scroll", positionNode);
	    			window.removeEventListener("resize", positionNode);
	    			return;
	    		}

	    		if (scrollEvent) {
	    			let scrollTop = scrollEvent.target.scrollTop;
	    			let scrollBottom = scrollTop + scrollEvent.target.clientHeight;

	    			if (_openParent.offsetParent.offsetTop < scrollTop || _openParent.offsetParent.offsetTop > scrollBottom) {
	    				toggleOpen();
	    				return;
	    			}
	    		}

	    		let bodyRect = document.body.getBoundingClientRect();
	    		let rect = _openParent.getBoundingClientRect();
	    		_openNode.style.left = `${rect.right - _openNode.offsetWidth}px`;
	    		_openNode.style.top = `${rect.bottom + 16}px`;

	    		if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	    			_openNode.style.top = rect.top >= _openNode.offsetHeight
	    			? `${rect.top - _openNode.offsetHeight - 16}px`
	    			: `0`;
	    		}
	    	}

	    	function openIfClosed() {
	    		if (disabled) {
	    			return;
	    		}

	    		if (!_showOptions) {
	    			toggleOpen();
	    			_inputElement.focus();
	    		}
	    	}

	    	function toggleOpen() {
	    		if (disabled) {
	    			return;
	    		}

	    		let opening = !_showOptions;

	    		//Clean up if closing
	    		if (!opening) {
	    			// Re-parent options
	    			_openParent.appendChild(_openNode);

	    			_openNode = undefined;
	    			_openParent = undefined;

	    			if (globalClickListener) {
	    				document.removeEventListener("click", globalClickListener);
	    				$$invalidate(51, globalClickListener = null);
	    			}

	    			if (globalKeyListener) {
	    				document.removeEventListener("keydown", globalKeyListener);
	    				$$invalidate(52, globalKeyListener = null);
	    			}

	    			document.removeEventListener("wheel", positionNode);
	    			window.removeEventListener("scroll", positionNode);
	    			window.removeEventListener("resize", positionNode);
	    		}

	    		_inputElement.blur();
	    		$$invalidate(12, _showOptions = opening);
	    	}

	    	function myKeyDown(event) {
	    		if (event.target && event.target.id === "date-input") {
	    			//console.log('Input Code', event.code);
	    			switch (event.code) {
	    				case "Enter":
	    					if (inputIsValid()) {
	    						// Date is valid: Set Date and close
	    						handleDateChanged(new Date(_untrimmedValue.trim()));
	    					} else {
	    						// Date is valid: Ignore so user can fix
	    						$$invalidate(10, _dirty = true);

	    						event.stopPropagation();
	    						event.preventDefault();
	    					}
	    					return;
	    				case "ArrowDown":
	    				case "ArrowUp":
	    				case "ArrowLeft":
	    				case "ArrowRight":
	    					_inputElement.blur();
	    					initDays();
	    					event.stopPropagation();
	    					event.preventDefault();
	    					return;
	    				case "Paste":
	    				case "Undo":
	    				case "Redo":
	    				case "Delete":
	    				case "Cut":
	    				case "Copy":
	    				case "Backspace":
	    				case "ArrowLeft":
	    				case "ArrowRight":
	    				case "Home":
	    				case "End":
	    				case "Shift":
	    					// These are all ok
	    					break;
	    				default:
	    					let trimmed = hasValue$6(_untrimmedValue) ? _untrimmedValue.trim() : "";
	    					let parts = trimmed.split("/");
	    					if (parts.length === 3) {
	    						if (!keyIsNumber(event.key)) {
	    							// Already have enough slashes so ignore
	    							event.stopPropagation();

	    							event.preventDefault();
	    							return;
	    						}
	    					} else {
	    						if (!keyIsNumber(event.key) && !keyIsSlash(event.key)) {
	    							// Do not accept anything but numbers or slashes
	    							event.stopPropagation();

	    							event.preventDefault();
	    							return;
	    						}
	    					}
	    					return;
	    			}
	    		} else {
	    			switch (event.code) {
	    				case "Space":
	    				case "Enter":
	    					event.stopPropagation();
	    					if (_potential && !is_same_day(value, _potential)) {
	    						handleDateChanged(_potential);
	    					} else {
	    						toggleOpen();
	    					}
	    					break;
	    				case "Escape":
	    					toggleOpen();
	    					break;
	    				case "ArrowDown":
	    					event.stopPropagation();
	    					event.preventDefault();
	    					if (_showOptions) {
	    						let test = new Date(_potential);
	    						test.setDate(test.getDate() + 7);

	    						if (min && is_before(test, min) || max && is_after(test, max)) {
	    							return;
	    						}

	    						if (_potential) {
	    							_potential.setDate(_potential.getDate() + 7);
	    						}

	    						if (!containsDay(_potential)) {
	    							nextMonth(_potential);
	    						} else {
	    							initDays();
	    						}
	    					}
	    					break;
	    				case "ArrowUp":
	    					event.stopPropagation();
	    					event.preventDefault();
	    					if (_showOptions) {
	    						let test = new Date(_potential);
	    						test.setDate(test.getDate() - 7);

	    						if (min && is_before(test, min) || max && is_after(test, max)) {
	    							return;
	    						}

	    						_potential.setDate(_potential.getDate() - 7);

	    						if (!containsDay(_potential)) {
	    							previousMonth(_potential);
	    						} else {
	    							initDays();
	    						}
	    					}
	    					break;
	    				case "ArrowRight":
	    					event.stopPropagation();
	    					event.preventDefault();
	    					if (_showOptions) {
	    						let test = new Date(_potential);
	    						test.setDate(test.getDate() + 1);

	    						if (min && is_before(test, min) || max && is_after(test, max)) {
	    							return;
	    						}

	    						_potential.setDate(_potential.getDate() + 1);

	    						if (!containsDay(_potential)) {
	    							nextMonth(_potential);
	    						} else {
	    							initDays();
	    						}
	    					}
	    					break;
	    				case "ArrowLeft":
	    					event.stopPropagation();
	    					event.preventDefault();
	    					if (_showOptions) {
	    						let test = new Date(_potential);
	    						test.setDate(test.getDate() - 1);

	    						if (min && is_before(test, min) || max && is_after(test, max)) {
	    							return;
	    						}

	    						_potential.setDate(_potential.getDate() - 1);

	    						if (!containsDay(_potential)) {
	    							previousMonth(_potential);
	    						} else {
	    							initDays();
	    						}
	    					}
	    					break;
	    			}
	    		}
	    	}

	    	function dayOfTheMonth(date) {
	    		if (!date) {
	    			return "";
	    		}

	    		return format_1(date, "D");
	    	}

	    	function weeksOfTheMonth(date) {
	    		let week = [];
	    		let weeks = difference_in_calendar_weeks(last_day_of_month(date), start_of_month(date)) + 1;

	    		for (let i = 1; i <= weeks; i++) {
	    			week.push(i);
	    		}

	    		return week;
	    	}

	    	// Count the no. of days that can go in current week
	    	function daysOfCurrentWeek(days, week) {
	    		return _days.slice((week - 1) * DAYS_IN_WEEK, (week - 1) * DAYS_IN_WEEK + DAYS_IN_WEEK);
	    	}

	    	function nextMonth(date) {
	    		$$invalidate(13, _date = add_months(start_of_month(_date), 1));
	    		_potential = date ? date : new Date(_date);
	    		initDays();
	    	}

	    	function previousMonth(date) {
	    		$$invalidate(13, _date = sub_months(start_of_month(_date), 1));
	    		_potential = date ? date : new Date(_date);
	    		initDays();
	    	}

	    	function nextYear() {
	    		$$invalidate(13, _date = add_years(start_of_month(_date), 1));
	    		_potential = new Date(_date);
	    		initDays();
	    	}

	    	function previousYear() {
	    		$$invalidate(13, _date = sub_years(start_of_month(_date), 1));
	    		_potential = new Date(_date);
	    		initDays();
	    	}

	    	function handleFocus(event) {
	    		$$invalidate(20, _hasFocus = true);
	    	}

	    	function handleBlur(event) {
	    		$$invalidate(20, _hasFocus = false);
	    	}

	    	function handleDateChanged(day) {
	    		if (min && is_before(day, min) || max && is_after(day, max)) {
	    			return;
	    		}

	    		$$invalidate(50, value = day);
	    		toggleOpen();
	    		valueChanged.call(this);
	    	}

	    	function handleClear(event) {
	    		event.stopPropagation();
	    		event.preventDefault();
	    		$$invalidate(50, value = null);
	    		valueChanged.call(this);
	    	}

	    	function inputIsValid() {
	    		if (!notEmpty$4(_untrimmedValue)) {
	    			return false;
	    		}

	    		let test = _untrimmedValue.trim();
	    		let parts = test.split("/");

	    		if (parts.length !== 3) {
	    			// Incomplete
	    			return false;
	    		}

	    		let month = isNaN(parts[0]) ? 0 : Number(parts[0]);
	    		let day = isNaN(parts[1]) ? 0 : Number(parts[1]);
	    		let year = isNaN(parts[2]) ? 0 : Number(parts[2]);

	    		if (month < 1 || month > 12) {
	    			return false;
	    		}

	    		if (day < 1 || day > 31) {
	    			return false;
	    		}

	    		if (year < 1000 || year > 9999) {
	    			return false;
	    		}

	    		return true;
	    	}

	    	function valueChanged() {
	    		$$invalidate(10, _dirty = true);

	    		$$invalidate(11, _untrimmedValue = value
	    		? format_1(value, format, { locale: _dateLocale })
	    		: null);

	    		doValidate.call(this);

	    		// Avoid short circuit handling if changed handler changes a state value
	    		window.setTimeout(() => {
	    			dispatch("changed", value);
	    		});
	    	}

	    	function doValidate() {
	    		_builtInErrors = [];
	    		$$invalidate(9, _errors = errors ? errors : []);

	    		if (notEmpty$4(_untrimmedValue) && !inputIsValid()) {
	    			_builtInErrors.push($_("validateDate"));
	    		}

	    		if (required && !value) {
	    			_builtInErrors.push($_("validateRequired"));
	    		}

	    		if (validation) {
	    			$$invalidate(9, _errors = _errors.concat(_builtInErrors));
	    		}

	    		window.setTimeout(() => {
	    			let valid = _errors.length === 0;

	    			if (_lastValid !== valid) {
	    				_lastValid = valid;
	    				dispatch("valid", valid);

	    				if (hasValue$6(value) && !valid && !_dirty) {
	    					$$invalidate(10, _dirty = true);
	    				}
	    			}
	    		});
	    	}

	    	function input_input_handler() {
	    		_untrimmedValue = this.value;
	    		$$invalidate(11, _untrimmedValue);
	    	}

	    	function input_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_inputElement = $$value;
	    			$$invalidate(16, _inputElement);
	    		});
	    	}

	    	const click_handler = (day, event) => handleDateChanged(day.value);
	    	const click_handler_1 = event => handleDateChanged(new Date());

	    	$$self.$$set = $$props => {
	    		if ("globalClickListener" in $$props) $$invalidate(51, globalClickListener = $$props.globalClickListener);
	    		if ("globalKeyListener" in $$props) $$invalidate(52, globalKeyListener = $$props.globalKeyListener);
	    		if ("display" in $$props) $$invalidate(1, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(53, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(54, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(55, density = $$props.density);
	    		if ("value" in $$props) $$invalidate(50, value = $$props.value);
	    		if ("label" in $$props) $$invalidate(0, label = $$props.label);
	    		if ("placeholder" in $$props) $$invalidate(2, placeholder = $$props.placeholder);
	    		if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	    		if ("clear" in $$props) $$invalidate(4, clear = $$props.clear);
	    		if ("required" in $$props) $$invalidate(5, required = $$props.required);
	    		if ("disabled" in $$props) $$invalidate(6, disabled = $$props.disabled);
	    		if ("validation" in $$props) $$invalidate(56, validation = $$props.validation);
	    		if ("errors" in $$props) $$invalidate(61, errors = $$props.errors);
	    		if ("format" in $$props) $$invalidate(57, format = $$props.format);
	    		if ("min" in $$props) $$invalidate(58, min = $$props.min);
	    		if ("max" in $$props) $$invalidate(59, max = $$props.max);
	    		if ("id" in $$props) $$invalidate(62, id = $$props.id);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty[0] & /*_errors*/ 512) {
	    			// Computed values
	    			_errors.length === 0;
	    		}

	    		if ($$self.$$.dirty[1] & /*value*/ 524288) {
	    			$$invalidate(33, _hasValue = hasValue$6(value));
	    		}

	    		if ($$self.$$.dirty[0] & /*label*/ 1) {
	    			$$invalidate(34, _hasLabel = notEmpty$4(label));
	    		}
	    	};

	    	return [
	    		label,
	    		display,
	    		placeholder,
	    		hint,
	    		clear,
	    		required,
	    		disabled,
	    		openIfClosed,
	    		preventClickPropagation$2,
	    		_errors,
	    		_dirty,
	    		_untrimmedValue,
	    		_showOptions,
	    		_date,
	    		_monthYear,
	    		_days,
	    		_inputElement,
	    		_theme,
	    		_shape,
	    		_density,
	    		_hasFocus,
	    		_labelId,
	    		_inputId,
	    		_clearId,
	    		_capId,
	    		_messageId,
	    		_statusIconId,
	    		_nextMonthId,
	    		_nextYearId,
	    		_prevYearId,
	    		_prevMonthId,
	    		_optionsId,
	    		_todayId,
	    		_hasValue,
	    		_hasLabel,
	    		$_,
	    		_dayLabels,
	    		globalClicks,
	    		positionOptions,
	    		dayOfTheMonth,
	    		weeksOfTheMonth,
	    		daysOfCurrentWeek,
	    		nextMonth,
	    		previousMonth,
	    		nextYear,
	    		previousYear,
	    		handleFocus,
	    		handleBlur,
	    		handleDateChanged,
	    		handleClear,
	    		value,
	    		globalClickListener,
	    		globalKeyListener,
	    		theme,
	    		shape,
	    		density,
	    		validation,
	    		format,
	    		min,
	    		max,
	    		DAYS_IN_WEEK,
	    		errors,
	    		id,
	    		toggleOpen,
	    		myKeyDown,
	    		input_input_handler,
	    		input_binding,
	    		click_handler,
	    		click_handler_1
	    	];
	    }

	    class DatePicker extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document_1$5.getElementById("svelte-1ktvy4d-style")) add_css$i();

	    		init(
	    			this,
	    			options,
	    			instance$j,
	    			create_fragment$j,
	    			safe_not_equal,
	    			{
	    				DAYS_IN_WEEK: 60,
	    				globalClickListener: 51,
	    				globalKeyListener: 52,
	    				display: 1,
	    				theme: 53,
	    				shape: 54,
	    				density: 55,
	    				value: 50,
	    				label: 0,
	    				placeholder: 2,
	    				hint: 3,
	    				clear: 4,
	    				required: 5,
	    				disabled: 6,
	    				validation: 56,
	    				errors: 61,
	    				format: 57,
	    				min: 58,
	    				max: 59,
	    				id: 62,
	    				openIfClosed: 7,
	    				toggleOpen: 63,
	    				myKeyDown: 64,
	    				preventClickPropagation: 8
	    			},
	    			[-1, -1, -1, -1]
	    		);
	    	}

	    	get DAYS_IN_WEEK() {
	    		return this.$$.ctx[60];
	    	}

	    	get openIfClosed() {
	    		return this.$$.ctx[7];
	    	}

	    	get toggleOpen() {
	    		return this.$$.ctx[63];
	    	}

	    	get myKeyDown() {
	    		return this.$$.ctx[64];
	    	}

	    	get preventClickPropagation() {
	    		return preventClickPropagation$2;
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/forms/src/RadioButtonGroup.svelte generated by Svelte v3.38.2 */

	    function add_css$h() {
	    	var style = element("style");
	    	style.id = "svelte-6jjyvj-style";
	    	style.textContent = ".pros-message-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-6jjyvj .pros-status-icon.svelte-6jjyvj{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-6jjyvj .pros-status-icon svg.svelte-6jjyvj{height:100%;width:100%}.pros-message-container.svelte-6jjyvj .pros-message.svelte-6jjyvj{flex:1}.pros-control-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;box-sizing:border-box;width:100%;margin:0;font-size:16px}.pros-control-label.svelte-6jjyvj.svelte-6jjyvj{width:100%;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-bottom:8px}.pros-control-label.required.svelte-6jjyvj.svelte-6jjyvj::after{content:\" *\"}.pros-radio-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;width:100%}.pros-radio-container.horizontal.svelte-6jjyvj.svelte-6jjyvj{flex-direction:unset;display:flex;justify-content:start;align-items:center;width:100%;flex-wrap:wrap}.pros-radio-container.horizontal.svelte-6jjyvj .pros-input-container.svelte-6jjyvj{width:auto}.pros-input-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;justify-content:flex-start;align-items:center;width:100%;cursor:pointer;margin-bottom:12px;padding-left:8px}.pros-input-container.svelte-6jjyvj.svelte-6jjyvj:last-of-type{margin-bottom:0}.pros-input-container.svelte-6jjyvj input[type=radio].svelte-6jjyvj{position:absolute;display:none}.pros-input-container.svelte-6jjyvj .pros-radio-value.svelte-6jjyvj{margin-left:12px}.pros-input-container.svelte-6jjyvj .pros-radio-button.svelte-6jjyvj{display:flex;justify-content:center;align-items:center;position:relative;width:24px;height:24px;border-width:1px;border-style:solid;border-radius:100%;box-sizing:border-box}.pros-input-container.selected.svelte-6jjyvj .pros-radio-button.svelte-6jjyvj::before{position:absolute;border-radius:100%;content:\" \";height:12px;width:12px}.pros-global-wrapper[pos--density=high].svelte-6jjyvj .pros-control-label.svelte-6jjyvj{margin-bottom:4px;line-height:20px}.pros-global-wrapper[pos--density=high].svelte-6jjyvj .pros-radio-button.svelte-6jjyvj{width:20px;height:20px}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.svelte-6jjyvj{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#404040;background-color:transparent}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.allow-hover:hover .pros-radio-button.svelte-6jjyvj{background-color:rgba(33, 33, 33, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#027aae;border-color:#027aae}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj::before{background-color:white}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.allow-hover.selected:hover .pros-radio-button.svelte-6jjyvj{background-color:#035c84;border-color:#035c84}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled.svelte-6jjyvj{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.svelte-6jjyvj{cursor:default}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-value.svelte-6jjyvj{user-select:none}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-message-container.svelte-6jjyvj{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-message-container .pros-status-icon.error.svelte-6jjyvj{color:#F04B37}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-message-container .pros-message.error.svelte-6jjyvj{color:#F04B37}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.svelte-6jjyvj{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#ffffff;background-color:transparent}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-containerallow-hover:hover .pros-radio-button.svelte-6jjyvj{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#3ab4eb;border-color:#3ab4eb}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj::before{background-color:#212121}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-containerallow-hover.selected:hover .pros-radio-button.svelte-6jjyvj{background-color:#6dd0fb;border-color:#6dd0fb}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled.svelte-6jjyvj{color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.svelte-6jjyvj{cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-value.svelte-6jjyvj{user-select:none}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-message-container.svelte-6jjyvj{color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-message-container .pros-status-icon.error.svelte-6jjyvj{color:#F04B37}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-message-container .pros-message.error.svelte-6jjyvj{color:#F04B37}";
	    	append(document.head, style);
	    }

	    function get_each_context$6(ctx, list, i) {
	    	const child_ctx = ctx.slice();
	    	child_ctx[39] = list[i];
	    	child_ctx[41] = i;
	    	return child_ctx;
	    }

	    // (8:4) {#if _hasLabel}
	    function create_if_block_3$6(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*label*/ ctx[0]);
	    			attr(div, "class", "pros-control-label svelte-6jjyvj");
	    			attr(div, "pros-tooltip", "");
	    			toggle_class(div, "required", /*required*/ ctx[4]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*label*/ 1) set_data(t, /*label*/ ctx[0]);

	    			if (dirty[0] & /*required*/ 16) {
	    				toggle_class(div, "required", /*required*/ ctx[4]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (12:6) {#each options as option, index}
	    function create_each_block$6(ctx) {
	    	let div2;
	    	let input;
	    	let input_value_value;
	    	let input_checked_value;
	    	let t0;
	    	let div0;
	    	let t1;
	    	let div1;
	    	let t2_value = /*option*/ ctx[39].display + "";
	    	let t2;
	    	let t3;
	    	let div2_id_value;
	    	let mounted;
	    	let dispose;

	    	function click_handler(...args) {
	    		return /*click_handler*/ ctx[25](/*option*/ ctx[39], ...args);
	    	}

	    	return {
	    		c() {
	    			div2 = element("div");
	    			input = element("input");
	    			t0 = space();
	    			div0 = element("div");
	    			t1 = space();
	    			div1 = element("div");
	    			t2 = text(t2_value);
	    			t3 = space();
	    			attr(input, "type", "radio");
	    			attr(input, "name", /*name*/ ctx[7]);
	    			input.value = input_value_value = /*option*/ ctx[39].value;
	    			input.disabled = /*disabled*/ ctx[5];
	    			input.checked = input_checked_value = /*value*/ ctx[2] === /*option*/ ctx[39].value;
	    			attr(input, "class", "svelte-6jjyvj");
	    			attr(div0, "class", "pros-radio-button svelte-6jjyvj");
	    			attr(div1, "pros-tooltip", "");
	    			attr(div1, "class", "pros-radio-value svelte-6jjyvj");
	    			toggle_class(div1, "required", /*required*/ ctx[4]);
	    			attr(div2, "id", div2_id_value = /*getRadioId*/ ctx[18](/*index*/ ctx[41]));
	    			attr(div2, "class", "pros-input-container svelte-6jjyvj");
	    			toggle_class(div2, "allow-hover", !/*disabled*/ ctx[5]);
	    			toggle_class(div2, "selected", /*value*/ ctx[2] === /*option*/ ctx[39].value);
	    		},
	    		m(target, anchor) {
	    			insert(target, div2, anchor);
	    			append(div2, input);
	    			append(div2, t0);
	    			append(div2, div0);
	    			append(div2, t1);
	    			append(div2, div1);
	    			append(div1, t2);
	    			append(div2, t3);

	    			if (!mounted) {
	    				dispose = listen(div2, "click", click_handler);
	    				mounted = true;
	    			}
	    		},
	    		p(new_ctx, dirty) {
	    			ctx = new_ctx;

	    			if (dirty[0] & /*name*/ 128) {
	    				attr(input, "name", /*name*/ ctx[7]);
	    			}

	    			if (dirty[0] & /*options*/ 256 && input_value_value !== (input_value_value = /*option*/ ctx[39].value)) {
	    				input.value = input_value_value;
	    			}

	    			if (dirty[0] & /*disabled*/ 32) {
	    				input.disabled = /*disabled*/ ctx[5];
	    			}

	    			if (dirty[0] & /*value, options*/ 260 && input_checked_value !== (input_checked_value = /*value*/ ctx[2] === /*option*/ ctx[39].value)) {
	    				input.checked = input_checked_value;
	    			}

	    			if (dirty[0] & /*options*/ 256 && t2_value !== (t2_value = /*option*/ ctx[39].display + "")) set_data(t2, t2_value);

	    			if (dirty[0] & /*required*/ 16) {
	    				toggle_class(div1, "required", /*required*/ ctx[4]);
	    			}

	    			if (dirty[0] & /*disabled*/ 32) {
	    				toggle_class(div2, "allow-hover", !/*disabled*/ ctx[5]);
	    			}

	    			if (dirty[0] & /*value, options*/ 260) {
	    				toggle_class(div2, "selected", /*value*/ ctx[2] === /*option*/ ctx[39].value);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div2);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (29:4) {#if display !== 'custom'}
	    function create_if_block$f(ctx) {
	    	let div;

	    	function select_block_type(ctx, dirty) {
	    		if (/*_dirty*/ ctx[10] && /*_errors*/ ctx[11].length > 0) return create_if_block_1$a;
	    		if (/*hint*/ ctx[3]) return create_if_block_2$9;
	    		return create_else_block$8;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-message-container svelte-6jjyvj");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, dirty) {
	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    // (45:6) {:else}
	    function create_else_block$8(ctx) {
	    	let div;

	    	return {
	    		c() {
	    			div = element("div");
	    			attr(div, "id", /*_messageId*/ ctx[15]);
	    			attr(div, "class", "pros-message svelte-6jjyvj");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_messageId*/ 32768) {
	    				attr(div, "id", /*_messageId*/ ctx[15]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (38:21) 
	    function create_if_block_2$9(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(/*hint*/ ctx[3]);
	    			attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-6jjyvj");
	    			attr(div0, "id", /*_statusIconId*/ ctx[16]);
	    			attr(div0, "class", "pros-status-icon svelte-6jjyvj");
	    			attr(div1, "id", /*_messageId*/ ctx[15]);
	    			attr(div1, "class", "pros-message svelte-6jjyvj");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 65536) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[16]);
	    			}

	    			if (dirty[0] & /*hint*/ 8) set_data(t1, /*hint*/ ctx[3]);

	    			if (dirty[0] & /*_messageId*/ 32768) {
	    				attr(div1, "id", /*_messageId*/ ctx[15]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    // (31:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$a(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1_value = /*_errors*/ ctx[11][0] + "";
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(t1_value);
	    			attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-6jjyvj");
	    			attr(div0, "id", /*_statusIconId*/ ctx[16]);
	    			attr(div0, "class", "pros-status-icon error svelte-6jjyvj");
	    			attr(div1, "id", /*_messageId*/ ctx[15]);
	    			attr(div1, "class", "pros-message error svelte-6jjyvj");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 65536) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[16]);
	    			}

	    			if (dirty[0] & /*_errors*/ 2048 && t1_value !== (t1_value = /*_errors*/ ctx[11][0] + "")) set_data(t1, t1_value);

	    			if (dirty[0] & /*_messageId*/ 32768) {
	    				attr(div1, "id", /*_messageId*/ ctx[15]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    function create_fragment$i(ctx) {
	    	let div2;
	    	let div1;
	    	let t0;
	    	let div0;
	    	let t1;
	    	let if_block0 = /*_hasLabel*/ ctx[17] && create_if_block_3$6(ctx);
	    	let each_value = /*options*/ ctx[8];
	    	let each_blocks = [];

	    	for (let i = 0; i < each_value.length; i += 1) {
	    		each_blocks[i] = create_each_block$6(get_each_context$6(ctx, each_value, i));
	    	}

	    	let if_block1 = /*display*/ ctx[1] !== "custom" && create_if_block$f(ctx);

	    	return {
	    		c() {
	    			div2 = element("div");
	    			div1 = element("div");
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div0 = element("div");

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].c();
	    			}

	    			t1 = space();
	    			if (if_block1) if_block1.c();
	    			attr(div0, "class", "pros-radio-container svelte-6jjyvj");
	    			toggle_class(div0, "horizontal", /*orientation*/ ctx[6] === "horizontal");
	    			attr(div1, "class", "pros-control-container svelte-6jjyvj");
	    			toggle_class(div1, "custom-layout", /*display*/ ctx[1] === "custom");
	    			toggle_class(div1, "error", /*_dirty*/ ctx[10] && /*_errors*/ ctx[11].length > 0);
	    			toggle_class(div1, "disabled", /*disabled*/ ctx[5]);
	    			toggle_class(div1, "allow-hover", !/*disabled*/ ctx[5]);
	    			attr(div2, "class", "pros-global-wrapper pros-form-control svelte-6jjyvj");
	    			attr(div2, "pos--theme", /*_theme*/ ctx[12]);
	    			attr(div2, "pos--shape", /*_shape*/ ctx[13]);
	    			attr(div2, "pos--density", /*_density*/ ctx[14]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div2, anchor);
	    			append(div2, div1);
	    			if (if_block0) if_block0.m(div1, null);
	    			append(div1, t0);
	    			append(div1, div0);

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].m(div0, null);
	    			}

	    			append(div1, t1);
	    			if (if_block1) if_block1.m(div1, null);
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasLabel*/ ctx[17]) {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);
	    				} else {
	    					if_block0 = create_if_block_3$6(ctx);
	    					if_block0.c();
	    					if_block0.m(div1, t0);
	    				}
	    			} else if (if_block0) {
	    				if_block0.d(1);
	    				if_block0 = null;
	    			}

	    			if (dirty[0] & /*getRadioId, disabled, value, options, checkRadioButton, required, name*/ 263092) {
	    				each_value = /*options*/ ctx[8];
	    				let i;

	    				for (i = 0; i < each_value.length; i += 1) {
	    					const child_ctx = get_each_context$6(ctx, each_value, i);

	    					if (each_blocks[i]) {
	    						each_blocks[i].p(child_ctx, dirty);
	    					} else {
	    						each_blocks[i] = create_each_block$6(child_ctx);
	    						each_blocks[i].c();
	    						each_blocks[i].m(div0, null);
	    					}
	    				}

	    				for (; i < each_blocks.length; i += 1) {
	    					each_blocks[i].d(1);
	    				}

	    				each_blocks.length = each_value.length;
	    			}

	    			if (dirty[0] & /*orientation*/ 64) {
	    				toggle_class(div0, "horizontal", /*orientation*/ ctx[6] === "horizontal");
	    			}

	    			if (/*display*/ ctx[1] !== "custom") {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);
	    				} else {
	    					if_block1 = create_if_block$f(ctx);
	    					if_block1.c();
	    					if_block1.m(div1, null);
	    				}
	    			} else if (if_block1) {
	    				if_block1.d(1);
	    				if_block1 = null;
	    			}

	    			if (dirty[0] & /*display*/ 2) {
	    				toggle_class(div1, "custom-layout", /*display*/ ctx[1] === "custom");
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 3072) {
	    				toggle_class(div1, "error", /*_dirty*/ ctx[10] && /*_errors*/ ctx[11].length > 0);
	    			}

	    			if (dirty[0] & /*disabled*/ 32) {
	    				toggle_class(div1, "disabled", /*disabled*/ ctx[5]);
	    			}

	    			if (dirty[0] & /*disabled*/ 32) {
	    				toggle_class(div1, "allow-hover", !/*disabled*/ ctx[5]);
	    			}

	    			if (dirty[0] & /*_theme*/ 4096) {
	    				attr(div2, "pos--theme", /*_theme*/ ctx[12]);
	    			}

	    			if (dirty[0] & /*_shape*/ 8192) {
	    				attr(div2, "pos--shape", /*_shape*/ ctx[13]);
	    			}

	    			if (dirty[0] & /*_density*/ 16384) {
	    				attr(div2, "pos--density", /*_density*/ ctx[14]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div2);
	    			if (if_block0) if_block0.d();
	    			destroy_each(each_blocks, detaching);
	    			if (if_block1) if_block1.d();
	    		}
	    	};
	    }

	    function hasValue$5(test) {
	    	return test !== undefined && test !== null;
	    }

	    function notEmpty$3(test) {
	    	return test !== undefined && test !== null && test.trim() !== "";
	    }

	    function instance$i($$self, $$props, $$invalidate) {
	    	let _hasLabel;
	    	let $_;
	    	component_subscribe($$self, X, $$value => $$invalidate(35, $_ = $$value));
	    	const dispatch = createEventDispatcher();
	    	let { name = "prosRadio" } = $$props;
	    	let { display = "form" } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	    	let { theme = "auto" } = $$props; // Color theme (auto/dark/light)
	    	let { shape = "round" } = $$props; // Shape style (round/sharp)
	    	let { density = "standard" } = $$props; // Density style (standard/high)
	    	let { value = null } = $$props; // Current value of control
	    	let { label = null } = $$props; // Control label
	    	let { hint = "" } = $$props; // Hint/Helper text to display when no validation errors to display
	    	let { required = false } = $$props; // Is value required to be valid?
	    	let { disabled = false } = $$props; // Is Control disabled?
	    	let { validation = true } = $$props; // Do we include built in validation?
	    	let { errors = [] } = $$props; // Custom external validation errors
	    	let { options = [] } = $$props; // Radio Button Options to choose from
	    	let { orientation = "vertical" } = $$props; // Horizontal (wrap) or Vertical (stack)
	    	let { id = null } = $$props;

	    	// Internal Data
	    	let _dirty = false; // Has the user changed the value (yes = dirty)

	    	let _errors = []; // Combined validation errors
	    	let _builtInErrors = []; // Built in validation errors
	    	let _lastValid;
	    	let _themeEventListener;
	    	let _shapeEventListener;
	    	let _densityEventListener;
	    	let _theme;
	    	let _shape;
	    	let _density;
	    	let _lastTheme;
	    	let _lastShape;
	    	let _lastDensity;
	    	let _messageId = null;
	    	let _statusIconId = null;

	    	onMount(() => {
	    		doValidate();
	    	});

	    	onDestroy(() => {
	    		if (_themeEventListener) {
	    			window.removeEventListener("posh-theme-changed", _themeEventListener);
	    		}

	    		if (_shapeEventListener) {
	    			window.removeEventListener("posh-shape-changed", _shapeEventListener);
	    		}

	    		if (_densityEventListener) {
	    			window.removeEventListener("posh-density-changed", _densityEventListener);
	    		}
	    	});

	    	beforeUpdate(() => {
	    		// Normalize external changes
	    		$$invalidate(1, display = hasValue$5(display) ? display : "form");

	    		$$invalidate(19, theme = hasValue$5(theme) ? theme : "light");
	    		$$invalidate(20, shape = hasValue$5(shape) ? shape : "round");
	    		$$invalidate(21, density = hasValue$5(density) ? density : "standard");
	    		$$invalidate(0, label = hasValue$5(label) ? label : null);
	    		$$invalidate(3, hint = hasValue$5(hint) ? hint : "");
	    		$$invalidate(2, value = hasValue$5(value) ? value : null);
	    		$$invalidate(4, required = hasValue$5(required) ? required : false);
	    		$$invalidate(5, disabled = hasValue$5(disabled) ? disabled : false);
	    		$$invalidate(22, validation = hasValue$5(validation) ? validation : true);
	    		$$invalidate(6, orientation = hasValue$5(orientation) ? orientation : "vertical");
	    		$$invalidate(15, _messageId = hasValue$5(id) ? `${id}-message` : undefined);
	    		$$invalidate(16, _statusIconId = hasValue$5(id) ? `${id}-status-icon` : undefined);

	    		if (theme !== _lastTheme) {
	    			_lastTheme = theme;

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(12, _theme = themeAttribute ? themeAttribute : "light");

	    				if (!_themeEventListener) {
	    					// Only start listening once
	    					_themeEventListener = window.addEventListener("posh-theme-changed", event => {
	    						if (theme === "auto") {
	    							$$invalidate(12, _theme = event.detail.theme);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(12, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			_lastShape = shape;

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(13, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					_shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(13, _shape = event.detail.shape);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(13, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			_lastDensity = density;

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(14, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					_densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(14, _density = event.detail.density);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(14, _density = density);
	    			}
	    		}

	    		doValidate();
	    	});

	    	function checkRadioButton(option) {
	    		if (disabled) {
	    			return;
	    		}

	    		valueChanged.call(this, option.value);
	    	}

	    	function getRadioId(index) {
	    		if (!id) {
	    			return null;
	    		}

	    		return `${id}-input${index}`;
	    	}

	    	function valueChanged(currentValue) {
	    		$$invalidate(10, _dirty = true);
	    		$$invalidate(2, value = currentValue);
	    		doValidate.call(this);

	    		// Avoid short circuit handling if changed handler changes a state value
	    		window.setTimeout(() => {
	    			dispatch("changed", value);
	    		});
	    	}

	    	function doValidate() {
	    		_builtInErrors = [];
	    		$$invalidate(11, _errors = errors ? errors : []);

	    		if (required) {
	    			if (!hasValue$5(value)) {
	    				_builtInErrors.push($_("validateRequired"));
	    			}
	    		}

	    		if (validation) {
	    			$$invalidate(11, _errors = _errors.concat(_builtInErrors));
	    		}

	    		window.setTimeout(() => {
	    			let valid = _errors.length === 0;

	    			if (_lastValid !== valid) {
	    				_lastValid = valid;
	    				dispatch("valid", valid);

	    				if (hasValue$5(value) && !valid && !_dirty) {
	    					$$invalidate(10, _dirty = true);
	    				}
	    			}
	    		});
	    	}

	    	const click_handler = (option, event) => checkRadioButton(option);

	    	$$self.$$set = $$props => {
	    		if ("name" in $$props) $$invalidate(7, name = $$props.name);
	    		if ("display" in $$props) $$invalidate(1, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(19, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(20, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(21, density = $$props.density);
	    		if ("value" in $$props) $$invalidate(2, value = $$props.value);
	    		if ("label" in $$props) $$invalidate(0, label = $$props.label);
	    		if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	    		if ("required" in $$props) $$invalidate(4, required = $$props.required);
	    		if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
	    		if ("validation" in $$props) $$invalidate(22, validation = $$props.validation);
	    		if ("errors" in $$props) $$invalidate(23, errors = $$props.errors);
	    		if ("options" in $$props) $$invalidate(8, options = $$props.options);
	    		if ("orientation" in $$props) $$invalidate(6, orientation = $$props.orientation);
	    		if ("id" in $$props) $$invalidate(24, id = $$props.id);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty[0] & /*label*/ 1) {
	    			// Computed values
	    			$$invalidate(17, _hasLabel = notEmpty$3(label));
	    		}
	    	};

	    	return [
	    		label,
	    		display,
	    		value,
	    		hint,
	    		required,
	    		disabled,
	    		orientation,
	    		name,
	    		options,
	    		checkRadioButton,
	    		_dirty,
	    		_errors,
	    		_theme,
	    		_shape,
	    		_density,
	    		_messageId,
	    		_statusIconId,
	    		_hasLabel,
	    		getRadioId,
	    		theme,
	    		shape,
	    		density,
	    		validation,
	    		errors,
	    		id,
	    		click_handler
	    	];
	    }

	    class RadioButtonGroup extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-6jjyvj-style")) add_css$h();

	    		init(
	    			this,
	    			options,
	    			instance$i,
	    			create_fragment$i,
	    			safe_not_equal,
	    			{
	    				name: 7,
	    				display: 1,
	    				theme: 19,
	    				shape: 20,
	    				density: 21,
	    				value: 2,
	    				label: 0,
	    				hint: 3,
	    				required: 4,
	    				disabled: 5,
	    				validation: 22,
	    				errors: 23,
	    				options: 8,
	    				orientation: 6,
	    				id: 24,
	    				checkRadioButton: 9
	    			},
	    			[-1, -1]
	    		);
	    	}

	    	get checkRadioButton() {
	    		return this.$$.ctx[9];
	    	}
	    }

	    createCommonjsModule(function (module, exports) {
	    (function (global, factory) {
	      factory(exports) ;
	    }(commonjsGlobal$1, (function (exports) {
	      function _classCallCheck(a, n) {
	        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	      }
	      function _defineProperties(e, r) {
	        for (var t = 0; t < r.length; t++) {
	          var o = r[t];
	          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
	        }
	      }
	      function _createClass(e, r, t) {
	        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	          writable: !1
	        }), e;
	      }
	      function _toPrimitive(t, r) {
	        if ("object" != typeof t || !t) return t;
	        var e = t[Symbol.toPrimitive];
	        if (void 0 !== e) {
	          var i = e.call(t, r || "default");
	          if ("object" != typeof i) return i;
	          throw new TypeError("@@toPrimitive must return a primitive value.");
	        }
	        return ("string" === r ? String : Number)(t);
	      }
	      function _toPropertyKey(t) {
	        var i = _toPrimitive(t, "string");
	        return "symbol" == typeof i ? i : i + "";
	      }

	      function styleInject(css, ref) {
	        if ( ref === void 0 ) ref = {};
	        var insertAt = ref.insertAt;

	        if (!css || typeof document === 'undefined') { return; }

	        var head = document.head || document.getElementsByTagName('head')[0];
	        var style = document.createElement('style');
	        style.type = 'text/css';

	        if (insertAt === 'top') {
	          if (head.firstChild) {
	            head.insertBefore(style, head.firstChild);
	          } else {
	            head.appendChild(style);
	          }
	        } else {
	          head.appendChild(style);
	        }

	        if (style.styleSheet) {
	          style.styleSheet.cssText = css;
	        } else {
	          style.appendChild(document.createTextNode(css));
	        }
	      }

	      var css_248z = "[pros-tooltip]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}pros-tooltip-overlay{background-color:#5a5a5a;color:#fff;width:auto;border-radius:4px;padding:4px 8px;margin-top:4px;transform:translateX(-50%);z-index:1000001;font-family:FormaDJR,sans-serif;font-size:12px;font-weight:500;text-align:center;white-space:nowrap;pointer-events:none;user-select:none}pros-tooltip-overlay,pros-tooltip-overlay *,pros-tooltip-overlay :after,pros-tooltip-overlay :before{box-sizing:border-box}pros-tooltip-overlay.pros-custom-tooltip{padding:0;overflow:hidden}";
	      styleInject(css_248z);

	      var Tooltips = /*#__PURE__*/function () {
	        function Tooltips() {
	          _classCallCheck(this, Tooltips);
	          this._observers = new WeakMap();
	          this._listeners = {
	            mouseenter: new WeakMap(),
	            mouseleave: new WeakMap()
	          };
	        }
	        return _createClass(Tooltips, [{
	          key: "addObserver",
	          value: function addObserver() {
	            var _this = this;
	            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	            if (this._observers.get(target)) {
	              // Could also throw an error
	              return;
	            }
	            var observer = new MutationObserver(function (mutations) {
	              mutations.forEach(function (mutation) {
	                if (mutation.type !== 'childList') {
	                  return;
	                }
	                var addedNodes = mutation.addedNodes;
	                for (var i = 0; i < addedNodes.length; i++) {
	                  var node = addedNodes[i];
	                  if (!node.querySelectorAll) {
	                    continue;
	                  }

	                  //Check node itself and then children
	                  if (node.hasAttribute('pros-tooltip')) {
	                    _this._bind(node);
	                  }
	                  var elements = node.querySelectorAll('[pros-tooltip]');
	                  if (elements.length > 0) {
	                    for (var j = 0; j < elements.length; j++) {
	                      var element = elements[j];
	                      _this._bind(element);
	                    }
	                  }
	                }
	                var removedNodes = mutation.removedNodes;
	                for (var _i = 0; _i < removedNodes.length; _i++) {
	                  var _node = removedNodes[_i];
	                  if (!_node.querySelectorAll) {
	                    continue;
	                  }
	                  if (_node.hasAttribute('pros-tooltip')) {
	                    _this._unbind(_node);
	                  }
	                  var _elements = _node.querySelectorAll('[pros-tooltip]');
	                  if (_elements.length > 0) {
	                    for (var _j = 0; _j < _elements.length; _j++) {
	                      var _element = _elements[_j];
	                      _this._unbind(_element);
	                    }
	                  }
	                }
	              });
	            });
	            observer.observe(target, {
	              childList: true,
	              subtree: true,
	              attributes: false,
	              characterData: false
	            });
	            this._observers.set(target, observer);
	          }
	        }, {
	          key: "removeObserver",
	          value: function removeObserver() {
	            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	            var observer = this._observers.get(target);
	            if (observer) {
	              observer.disconnect();
	              this._observers["delete"](target);
	            }
	          }
	        }, {
	          key: "hasTooltipContent",
	          value: function hasTooltipContent(value, el) {
	            var attributeValue = el.getAttribute('pros-tooltip');
	            if (attributeValue) {
	              attributeValue = attributeValue.trim();
	            }
	            var elContent = el.textContent.trim();
	            return attributeValue !== '' || elContent !== '';
	          }
	        }, {
	          key: "_bind",
	          value: function _bind(el) {
	            var _this2 = this;
	            var listener = function listener() {
	              var attributeValue = el.getAttribute('pros-tooltip');
	              if (!_this2.hasTooltipContent(attributeValue, el) || !attributeValue && isFullContentVisible(el)) {
	                // not specified and text not truncated - don't show tooltip
	                return;
	              }
	              var tooltipEl = document.createElement('pros-tooltip-overlay');
	              setContent(tooltipEl, el);
	              setPosition(tooltipEl, el);

	              // Hide, then append to get width, then show once width corrected.
	              // Approach from http://stackoverflow.com/a/2930159/277307
	              hideElement(tooltipEl);
	              document.body.appendChild(tooltipEl);
	              ensureEvenWidth(tooltipEl);
	              ensureNotClipped(tooltipEl);
	              showElement(tooltipEl);
	              removeOnMouseLeave.call(_this2, tooltipEl, el);
	            };
	            var enterListener = this._listeners.mouseenter.get(el);
	            if (!enterListener) {
	              el.addEventListener('mouseenter', listener);
	              this._listeners.mouseenter.set(el, listener);
	            }
	          }
	        }, {
	          key: "_unbind",
	          value: function _unbind(el) {
	            var enterListener = this._listeners.mouseenter.get(el);
	            if (enterListener) {
	              el.removeEventListener('mouseenter', enterListener);
	              this._listeners.mouseenter["delete"](el);
	            }
	            var leaveListener = this._listeners.mouseleave.get(el);
	            if (leaveListener) {
	              leaveListener.call(this);
	            }
	          }
	        }]);
	      }(); // Adapted from http://stackoverflow.com/a/10017343/277307
	      function isFullContentVisible(el) {
	        return el.offsetWidth >= el.scrollWidth;
	      }
	      function setPosition(tooltipEl, el) {
	        tooltipEl.style.position = 'fixed';
	        var elRect = el.getBoundingClientRect();
	        tooltipEl.style.top = elRect.top + elRect.height + 'px';
	        // Center horizontally under element
	        tooltipEl.style.left = elRect.left + elRect.width / 2 + 'px';
	        return tooltipEl;
	      }
	      function setContent(tooltipEl, el) {
	        var attrValue = el.getAttribute('pros-tooltip');
	        if (attrValue) {
	          // Use value if provided
	          if (attrValue[0] === '<') {
	            tooltipEl.innerHTML = attrValue;
	            tooltipEl.style.whiteSpace = 'unset';
	            tooltipEl.classList.add('pros-custom-tooltip');
	          } else {
	            tooltipEl.textContent = attrValue;
	          }
	        } else {
	          // Element text by default
	          tooltipEl.textContent = el.textContent;
	        }
	        return tooltipEl;
	      }
	      function removeOnMouseLeave(tooltipEl, el) {
	        var _this3 = this;
	        var _leaveHandler = function leaveHandler() {
	          document.body.removeChild(tooltipEl);
	          el.removeEventListener('mouseleave', _leaveHandler);
	          _this3._listeners.mouseleave["delete"](el);
	        };
	        el.addEventListener('mouseleave', _leaveHandler);
	        this._listeners.mouseleave.set(el, _leaveHandler);
	      }
	      function hideElement(tooltipEl) {
	        tooltipEl.style.visibility = 'hidden';
	      }
	      function showElement(tooltipEl) {
	        tooltipEl.style.removeProperty('visibility');
	      }

	      // Necessary because of chrome font antialiasing with translations on odd widths
	      // will cause blurry text. See http://stackoverflow.com/a/41456864/277307
	      function ensureEvenWidth(tooltipEl) {
	        var width = Math.round(tooltipEl.getBoundingClientRect().width);
	        if (width % 2 !== 0) {
	          width++;
	          tooltipEl.style.width = width + 'px';
	        }
	      }
	      function ensureNotClipped(tooltipEl) {
	        // Ensure not clipped by window boundary,
	        // since we're transforming left 50% and width could exceed the window.
	        var rect = tooltipEl.getBoundingClientRect();
	        var halfWidth = rect.width / 2;
	        if (rect.left < 0) {
	          tooltipEl.style.left = halfWidth + 'px';
	        } else if (rect.right > window.innerWidth) {
	          tooltipEl.style.left = window.innerWidth - halfWidth + 'px';
	        }
	      }

	      exports.Tooltips = Tooltips;

	      Object.defineProperty(exports, '__esModule', { value: true });

	    })));
	    });

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/spinner/src/Spinner.svelte generated by Svelte v3.38.2 */

	    function create_else_block$7(ctx) {
	    	let svg;
	    	let rect;
	    	let circle;
	    	let animateTransform;

	    	return {
	    		c() {
	    			svg = svg_element("svg");
	    			rect = svg_element("rect");
	    			circle = svg_element("circle");
	    			animateTransform = svg_element("animateTransform");
	    			attr(rect, "x", "0");
	    			attr(rect, "y", "0");
	    			attr(rect, "width", "100");
	    			attr(rect, "height", "100");
	    			attr(rect, "fill", "none");
	    			attr(rect, "class", "bk");
	    			attr(animateTransform, "attributeName", "transform");
	    			attr(animateTransform, "type", "rotate");
	    			attr(animateTransform, "values", "0 50 50;180 50 50;360 50 50;");
	    			attr(animateTransform, "keyTimes", "0;0.5;1");
	    			attr(animateTransform, "dur", "1s");
	    			attr(animateTransform, "repeatCount", "indefinite");
	    			attr(animateTransform, "begin", "0s");
	    			attr(circle, "cx", "50");
	    			attr(circle, "cy", "50");
	    			attr(circle, "r", "42.5");
	    			attr(circle, "stroke-dasharray", "173.57299411083608 93.46238144429634");
	    			attr(circle, "stroke", "currentColor");
	    			attr(circle, "fill", "none");
	    			attr(circle, "stroke-width", "15");
	    			attr(svg, "style", /*_style*/ ctx[0]);
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "viewBox", "0 0 100 100");
	    			attr(svg, "preserveAspectRatio", "xMidYMid");
	    			attr(svg, "class", "uil-ring");
	    		},
	    		m(target, anchor) {
	    			insert(target, svg, anchor);
	    			append(svg, rect);
	    			append(svg, circle);
	    			append(circle, animateTransform);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_style*/ 1) {
	    				attr(svg, "style", /*_style*/ ctx[0]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(svg);
	    		}
	    	};
	    }

	    // (2:2) {#if mode === 'printos'}
	    function create_if_block$e(ctx) {
	    	let svg;
	    	let style;
	    	let t;
	    	let path0;
	    	let path1;
	    	let g;
	    	let circle;

	    	return {
	    		c() {
	    			svg = svg_element("svg");
	    			style = svg_element("style");
	    			t = text("@-webkit-keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}@keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}#el_ztyBp85wH *{-webkit-animation-duration: 3s;animation-duration: 3s;-webkit-animation-iteration-count: infinite;animation-iteration-count: infinite;-webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);animation-timing-function: cubic-bezier(0, 0, 1, 1);}#el_OK7WH8ppuY{fill: currentColor;}#el_pzIR5oVpeo{fill: currentColor;}#el_3R6WG92ED-{fill: none;stroke: currentColor;stroke-width: 5;}#el_3R6WG92ED-_9z4k3l2Lz{-webkit-animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;}");
	    			path0 = svg_element("path");
	    			path1 = svg_element("path");
	    			g = svg_element("g");
	    			circle = svg_element("circle");
	    			attr(path0, "d", "M67,70V64.67l-3.53-.91a14.62,14.62,0,0,0-1.41-3.41L64,57.25l-3.73-3.82-3.13,1.91a21,21,0,0,0-3.43-1.5l-.91-3.51H47.33l-.91,3.51A13,13,0,0,0,43,55.24l-3.13-1.91-3.73,3.82L38,60.25a17.89,17.89,0,0,0-1.51,3.41L33,64.57V70l3.53.91a14.62,14.62,0,0,0,1.41,3.41L36,77.4l3.73,3.82,3.13-1.91a21,21,0,0,0,3.43,1.5l.91,3.52h5.44l.91-3.52A13,13,0,0,0,57,79.41l3.13,1.91L64,77.61,62.06,74.5a17.89,17.89,0,0,0,1.51-3.41ZM49.85,76.7a9.48,9.48,0,1,1,9.58-9.43A9.47,9.47,0,0,1,49.85,76.7Z");
	    			attr(path0, "id", "el_OK7WH8ppuY");
	    			attr(path1, "d", "M92.5,39.38h0a14,14,0,0,0-3.3-.91A19.08,19.08,0,0,0,78,24.77a18.87,18.87,0,0,0-7.6-1.6,20.32,20.32,0,0,0-5.5.8A24.09,24.09,0,0,0,51.7,9.67a24.54,24.54,0,0,0-9.5-2,24.37,24.37,0,0,0-22,14.4A19.84,19.84,0,0,0,18.9,26h-.2A18.34,18.34,0,0,0,2.1,36.67a17.78,17.78,0,0,0,9.3,23.5,18.62,18.62,0,0,0,6.9,1.5h.2c.3-1.6.7-3.1,1.1-4.6H18.5A12.61,12.61,0,0,1,13.2,56a13.33,13.33,0,0,1-8-12.09,14,14,0,0,1,1.1-5.3,13.37,13.37,0,0,1,12.2-8,10.87,10.87,0,0,1,1.8.1l2.3.3.3-2.3a15.65,15.65,0,0,1,1.4-4.8,19.07,19.07,0,0,1,17.8-11.5A19.34,19.34,0,0,1,49.8,14,19.61,19.61,0,0,1,61,27.48l.6,2.8L64.1,29a14.24,14.24,0,0,1,6.1-1.3,15.07,15.07,0,0,1,5.8,1.2,14.62,14.62,0,0,1,8.8,12l.2,2.3L87.3,43h.6a8.87,8.87,0,0,1,2.7.5,7,7,0,0,1,4.2,6.41,7.43,7.43,0,0,1-6.2,7.2h-7a39,39,0,0,1,1.2,4.6h6.1a11.75,11.75,0,0,0,9.5-7.1,12.7,12.7,0,0,0,1-4.6A11.14,11.14,0,0,0,92.5,39.38Z");
	    			attr(path1, "id", "el_pzIR5oVpeo");
	    			attr(circle, "cx", "50");
	    			attr(circle, "cy", "67.33");
	    			attr(circle, "r", "25");
	    			attr(circle, "stroke-dasharray", "55");
	    			attr(circle, "id", "el_3R6WG92ED-");
	    			attr(g, "id", "el_3R6WG92ED-_9z4k3l2Lz");
	    			attr(g, "data-animator-group", "true");
	    			attr(g, "data-animator-type", "1");
	    			attr(svg, "style", /*_style*/ ctx[0]);
	    			attr(svg, "id", "el_ztyBp85wH");
	    			attr(svg, "data-name", "Layer 1");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "viewBox", "0 0 100 100");
	    		},
	    		m(target, anchor) {
	    			insert(target, svg, anchor);
	    			append(svg, style);
	    			append(style, t);
	    			append(svg, path0);
	    			append(svg, path1);
	    			append(svg, g);
	    			append(g, circle);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_style*/ 1) {
	    				attr(svg, "style", /*_style*/ ctx[0]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(svg);
	    		}
	    	};
	    }

	    function create_fragment$h(ctx) {
	    	let div;

	    	function select_block_type(ctx, dirty) {
	    		if (/*mode*/ ctx[1] === "printos") return create_if_block$e;
	    		return create_else_block$7;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-spinner");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, [dirty]) {
	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    function instance$h($$self, $$props, $$invalidate) {
	    	let { diameter = null } = $$props;
	    	let { mode = null } = $$props;
	    	let { color = null } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _diameter = null } = $$props;

	    	$$self.$$set = $$props => {
	    		if ("diameter" in $$props) $$invalidate(3, diameter = $$props.diameter);
	    		if ("mode" in $$props) $$invalidate(1, mode = $$props.mode);
	    		if ("color" in $$props) $$invalidate(4, color = $$props.color);
	    		if ("_style" in $$props) $$invalidate(0, _style = $$props._style);
	    		if ("_diameter" in $$props) $$invalidate(2, _diameter = $$props._diameter);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*diameter, _diameter, mode, _style, color*/ 31) {
	    			{
	    				$$invalidate(2, _diameter = diameter ? Number(diameter) : null);

	    				if (!_diameter) {
	    					$$invalidate(2, _diameter = mode === "printos" ? 200 : 50);
	    				}

	    				$$invalidate(0, _style = `height:${_diameter}px;width:${_diameter}px;`);
	    				$$invalidate(0, _style += color ? `color:${color};` : `color:#0096d6;`);
	    			}
	    		}
	    	};

	    	return [_style, mode, _diameter, diameter, color];
	    }

	    class Spinner extends SvelteComponent {
	    	constructor(options) {
	    		super();

	    		init(this, options, instance$h, create_fragment$h, safe_not_equal, {
	    			diameter: 3,
	    			mode: 1,
	    			color: 4,
	    			_style: 0,
	    			_diameter: 2
	    		});
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/forms/src/NumberBox.svelte generated by Svelte v3.38.2 */

	    function add_css$g() {
	    	var style = element("style");
	    	style.id = "svelte-a4lkko-style";
	    	style.textContent = ".pros-highlight-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-a4lkko .pros-input.svelte-a4lkko{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-a4lkko .pros-input.svelte-a4lkko{padding-top:18px}.pros-control-container.has-label.svelte-a4lkko input.svelte-a4lkko::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-a4lkko.svelte-a4lkko{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-a4lkko.svelte-a4lkko::after{content:\" *\"}.pros-action-button.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-a4lkko svg.svelte-a4lkko{width:24px;height:24px}.pros-action-button.svelte-a4lkko.svelte-a4lkko:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-a4lkko.svelte-a4lkko{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-end-cap.svelte-a4lkko svg.svelte-a4lkko{width:auto;height:auto}.pros-direction-button.svelte-a4lkko.svelte-a4lkko{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;padding:0;height:50%}.pros-direction-button.svelte-a4lkko svg.svelte-a4lkko{width:auto;height:auto}.pros-control-container.svelte-a4lkko.svelte-a4lkko{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-a4lkko .pros-control-label.svelte-a4lkko,.pros-control-container.has-focus.svelte-a4lkko .pros-control-label.svelte-a4lkko{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-a4lkko .pros-highlight-container.svelte-a4lkko{cursor:default}.pros-control-container.has-focus.svelte-a4lkko .pros-input.svelte-a4lkko{cursor:text}.pros-control-container.has-focus.svelte-a4lkko .pros-highlight-container.svelte-a4lkko{border-width:2px}.pros-control-container.has-focus.svelte-a4lkko .pros-input-container.svelte-a4lkko{margin-left:11px}.pros-control-container.has-focus.svelte-a4lkko .pros-end-cap.svelte-a4lkko:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-a4lkko input.svelte-a4lkko::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-a4lkko .pros-status-icon.svelte-a4lkko{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-a4lkko .pros-status-icon svg.svelte-a4lkko{height:100%;width:100%}.pros-message-container.svelte-a4lkko .pros-message.svelte-a4lkko{flex:1}.pros-global-wrapper[pos--shape=sharp].svelte-a4lkko .pros-highlight-container.svelte-a4lkko{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-control-label.svelte-a4lkko{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-highlight-container.svelte-a4lkko{height:36px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-a4lkko{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-input-container .pros-input.svelte-a4lkko{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-label .pros-input.svelte-a4lkko{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-value .pros-control-label.svelte-a4lkko,.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-focus .pros-control-label.svelte-a4lkko{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-a4lkko{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-focus .pros-input-container.svelte-a4lkko{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.svelte-a4lkko{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-highlight-container.svelte-a4lkko{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-input.svelte-a4lkko{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container input.svelte-a4lkko::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.allow-hover .pros-highlight-container.svelte-a4lkko:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.error .pros-highlight-container.svelte-a4lkko{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.has-focus .pros-highlight-container.svelte-a4lkko{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-end-cap.svelte-a4lkko{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container.svelte-a4lkko{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container .pros-status-icon.svelte-a4lkko{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container.error.svelte-a4lkko{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container.error .pros-status-icon.svelte-a4lkko{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled.svelte-a4lkko{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-highlight-container.svelte-a4lkko{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-input.svelte-a4lkko{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-message-container.svelte-a4lkko{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-end-cap.svelte-a4lkko{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-direction-button.allow-hover.svelte-a4lkko:hover{color:#027aae;background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-action-button.svelte-a4lkko:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.svelte-a4lkko{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-highlight-container.svelte-a4lkko{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-input.svelte-a4lkko{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container input.svelte-a4lkko::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.allow-hover .pros-highlight-container.svelte-a4lkko:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.error .pros-highlight-container.svelte-a4lkko{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.has-focus .pros-highlight-container.svelte-a4lkko{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container.svelte-a4lkko{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container .pros-status-icon.svelte-a4lkko{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container.error.svelte-a4lkko{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container.error .pros-status-icon.svelte-a4lkko{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled.svelte-a4lkko{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled .pros-highlight-container.svelte-a4lkko{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled .pros-input.svelte-a4lkko{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled .pros-message-container.svelte-a4lkko{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-direction-button.allow-hover.svelte-a4lkko:hover{color:#3ab4eb;background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-action-button.svelte-a4lkko:hover{background-color:rgba(0, 0, 0, 0.05)}";
	    	append(document.head, style);
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_4$5(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*label*/ ctx[0]);
	    			attr(div, "id", /*_labelId*/ ctx[24]);
	    			attr(div, "class", "pros-control-label svelte-a4lkko");
	    			attr(div, "pros-tooltip", "");
	    			toggle_class(div, "required", /*required*/ ctx[5]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*label*/ 1) set_data(t, /*label*/ ctx[0]);

	    			if (dirty[0] & /*_labelId*/ 16777216) {
	    				attr(div, "id", /*_labelId*/ ctx[24]);
	    			}

	    			if (dirty[0] & /*required*/ 32) {
	    				toggle_class(div, "required", /*required*/ ctx[5]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (27:8) {#if _showClear}
	    function create_if_block_3$5(ctx) {
	    	let div;
	    	let svg;
	    	let path;
	    	let mounted;
	    	let dispose;

	    	return {
	    		c() {
	    			div = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-a4lkko");
	    			attr(div, "id", /*_clearId*/ ctx[26]);
	    			attr(div, "class", "pros-action-button clear svelte-a4lkko");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, svg);
	    			append(svg, path);

	    			if (!mounted) {
	    				dispose = listen(div, "mousedown", /*handleClear*/ ctx[6]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_clearId*/ 67108864) {
	    				attr(div, "id", /*_clearId*/ ctx[26]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (49:4) {#if display !== 'custom'}
	    function create_if_block$d(ctx) {
	    	let div;

	    	function select_block_type(ctx, dirty) {
	    		if (/*_dirty*/ ctx[16] && /*_errors*/ ctx[17].length > 0) return create_if_block_1$9;
	    		if (/*hint*/ ctx[4] && /*_hasFocus*/ ctx[20]) return create_if_block_2$8;
	    		return create_else_block$6;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-message-container svelte-a4lkko");
	    			toggle_class(div, "error", /*_dirty*/ ctx[16] && /*_errors*/ ctx[17].length > 0);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, dirty) {
	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 196608) {
	    				toggle_class(div, "error", /*_dirty*/ ctx[16] && /*_errors*/ ctx[17].length > 0);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    // (65:6) {:else}
	    function create_else_block$6(ctx) {
	    	let div;

	    	return {
	    		c() {
	    			div = element("div");
	    			attr(div, "id", /*_messageId*/ ctx[29]);
	    			attr(div, "class", "pros-message svelte-a4lkko");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_messageId*/ 536870912) {
	    				attr(div, "id", /*_messageId*/ ctx[29]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (58:34) 
	    function create_if_block_2$8(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(/*hint*/ ctx[4]);
	    			attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-a4lkko");
	    			attr(div0, "id", /*_statusIconId*/ ctx[30]);
	    			attr(div0, "class", "pros-status-icon svelte-a4lkko");
	    			attr(div1, "id", /*_messageId*/ ctx[29]);
	    			attr(div1, "class", "pros-message svelte-a4lkko");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 1073741824) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[30]);
	    			}

	    			if (dirty[0] & /*hint*/ 16) set_data(t1, /*hint*/ ctx[4]);

	    			if (dirty[0] & /*_messageId*/ 536870912) {
	    				attr(div1, "id", /*_messageId*/ ctx[29]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    // (51:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$9(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1_value = /*_errors*/ ctx[17][0] + "";
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(t1_value);
	    			attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-a4lkko");
	    			attr(div0, "id", /*_statusIconId*/ ctx[30]);
	    			attr(div0, "class", "pros-status-icon error svelte-a4lkko");
	    			attr(div1, "id", /*_messageId*/ ctx[29]);
	    			attr(div1, "class", "pros-message error svelte-a4lkko");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_statusIconId*/ 1073741824) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[30]);
	    			}

	    			if (dirty[0] & /*_errors*/ 131072 && t1_value !== (t1_value = /*_errors*/ ctx[17][0] + "")) set_data(t1, t1_value);

	    			if (dirty[0] & /*_messageId*/ 536870912) {
	    				attr(div1, "id", /*_messageId*/ ctx[29]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    function create_fragment$g(ctx) {
	    	let div7;
	    	let div6;
	    	let t0;
	    	let div5;
	    	let div4;
	    	let div0;
	    	let input;
	    	let t1;
	    	let t2;
	    	let div3;
	    	let div1;
	    	let svg0;
	    	let path0;
	    	let t3;
	    	let div2;
	    	let svg1;
	    	let path1;
	    	let t4;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*_hasLabel*/ ctx[31] && create_if_block_4$5(ctx);
	    	let if_block1 = /*_showClear*/ ctx[32] && create_if_block_3$5(ctx);
	    	let if_block2 = /*display*/ ctx[2] !== "custom" && create_if_block$d(ctx);

	    	return {
	    		c() {
	    			div7 = element("div");
	    			div6 = element("div");
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div5 = element("div");
	    			div4 = element("div");
	    			div0 = element("div");
	    			input = element("input");
	    			t1 = space();
	    			if (if_block1) if_block1.c();
	    			t2 = space();
	    			div3 = element("div");
	    			div1 = element("div");
	    			svg0 = svg_element("svg");
	    			path0 = svg_element("path");
	    			t3 = space();
	    			div2 = element("div");
	    			svg1 = svg_element("svg");
	    			path1 = svg_element("path");
	    			t4 = space();
	    			if (if_block2) if_block2.c();
	    			attr(input, "id", /*_inputId*/ ctx[25]);
	    			attr(input, "class", "pros-input single-line buttons svelte-a4lkko");
	    			input.disabled = /*disabled*/ ctx[1];
	    			attr(input, "placeholder", /*placeholder*/ ctx[3]);
	    			attr(div0, "class", "pros-input-container svelte-a4lkko");
	    			attr(path0, "d", "M16.9999 9C16.872 9 16.744 8.95117 16.6464 8.85352L8.99989 1.20703L1.3534 8.85352C1.15809 9.04883 0.841682 9.04883 0.64637 8.85352C0.451057 8.6582 0.451057 8.3418 0.64637 8.14648L8.64637 0.146484C8.84168 -0.0488281 9.15809 -0.0488281 9.3534 0.146484L17.3534 8.14648C17.5487 8.3418 17.5487 8.6582 17.3534 8.85352C17.2557 8.95117 17.1278 9 16.9999 9Z");
	    			attr(svg0, "width", "18");
	    			attr(svg0, "height", "9");
	    			attr(svg0, "viewBox", "0 0 18 9");
	    			attr(svg0, "fill", "currentColor");
	    			attr(svg0, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg0, "class", "svelte-a4lkko");
	    			attr(div1, "id", /*_upId*/ ctx[27]);
	    			attr(div1, "class", "pros-direction-button svelte-a4lkko");
	    			toggle_class(div1, "allow-hover", !/*disabled*/ ctx[1]);
	    			attr(path1, "d", "M8.5 9C8.37207 9 8.24414 8.95117 8.14648 8.85352L0.146484 0.853516C-0.0488281 0.658203 -0.0488281 0.341797 0.146484 0.146484C0.341797 -0.048828 0.658203 -0.0488281 0.853516 0.146484L8.5 7.79297L16.1465 0.146484C16.3418 -0.0488281 16.6582 -0.0488281 16.8535 0.146484C17.0488 0.341797 17.0488 0.658203 16.8535 0.853516L8.85352 8.85352C8.75586 8.95117 8.62793 9 8.5 9Z");
	    			attr(svg1, "width", "18");
	    			attr(svg1, "height", "9");
	    			attr(svg1, "viewBox", "0 0 18 9");
	    			attr(svg1, "fill", "currentColor");
	    			attr(svg1, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg1, "class", "svelte-a4lkko");
	    			attr(div2, "id", /*_downId*/ ctx[28]);
	    			attr(div2, "class", "pros-direction-button svelte-a4lkko");
	    			toggle_class(div2, "allow-hover", !/*disabled*/ ctx[1]);
	    			attr(div3, "class", "pros-end-cap fill svelte-a4lkko");
	    			attr(div4, "class", "pros-content-container svelte-a4lkko");
	    			attr(div5, "class", "pros-highlight-container svelte-a4lkko");
	    			attr(div6, "class", "pros-control-container svelte-a4lkko");
	    			toggle_class(div6, "has-value", /*_hasValue*/ ctx[15]);
	    			toggle_class(div6, "has-label", /*_hasLabel*/ ctx[31]);
	    			toggle_class(div6, "has-focus", /*_hasFocus*/ ctx[20]);
	    			toggle_class(div6, "custom-layout", /*display*/ ctx[2] === "custom");
	    			toggle_class(div6, "error", /*_dirty*/ ctx[16] && /*_errors*/ ctx[17].length > 0);
	    			toggle_class(div6, "disabled", /*disabled*/ ctx[1]);
	    			toggle_class(div6, "allow-hover", !/*disabled*/ ctx[1]);
	    			attr(div7, "class", "pros-global-wrapper pros-form-control svelte-a4lkko");
	    			attr(div7, "pos--theme", /*_theme*/ ctx[21]);
	    			attr(div7, "pos--shape", /*_shape*/ ctx[22]);
	    			attr(div7, "pos--density", /*_density*/ ctx[23]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div7, anchor);
	    			append(div7, div6);
	    			if (if_block0) if_block0.m(div6, null);
	    			append(div6, t0);
	    			append(div6, div5);
	    			append(div5, div4);
	    			append(div4, div0);
	    			append(div0, input);
	    			set_input_value(input, /*_rawValue*/ ctx[18]);
	    			/*input_binding*/ ctx[56](input);
	    			append(div4, t1);
	    			if (if_block1) if_block1.m(div4, null);
	    			append(div4, t2);
	    			append(div4, div3);
	    			append(div3, div1);
	    			append(div1, svg0);
	    			append(svg0, path0);
	    			append(div3, t3);
	    			append(div3, div2);
	    			append(div2, svg1);
	    			append(svg1, path1);
	    			append(div6, t4);
	    			if (if_block2) if_block2.m(div6, null);

	    			if (!mounted) {
	    				dispose = [
	    					listen(input, "input", /*input_input_handler*/ ctx[55]),
	    					listen(input, "keydown", /*handleKeyDown*/ ctx[7]),
	    					listen(input, "blur", /*handleBlur*/ ctx[8]),
	    					listen(input, "focus", /*handleFocus*/ ctx[9]),
	    					listen(div1, "click", /*handleStepUp*/ ctx[11]),
	    					listen(div1, "mousedown", /*mousedown_handler*/ ctx[57]),
	    					listen(div1, "mouseup", /*mouseup_handler*/ ctx[58]),
	    					listen(div1, "mouseleave", /*endPressAndHold*/ ctx[14]),
	    					listen(div2, "click", /*handleStepDown*/ ctx[12]),
	    					listen(div2, "mousedown", /*mousedown_handler_1*/ ctx[59]),
	    					listen(div2, "mouseup", /*mouseup_handler_1*/ ctx[60]),
	    					listen(div2, "mouseleave", /*endPressAndHold*/ ctx[14]),
	    					listen(div5, "click", /*handleClick*/ ctx[10])
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasLabel*/ ctx[31]) {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);
	    				} else {
	    					if_block0 = create_if_block_4$5(ctx);
	    					if_block0.c();
	    					if_block0.m(div6, t0);
	    				}
	    			} else if (if_block0) {
	    				if_block0.d(1);
	    				if_block0 = null;
	    			}

	    			if (dirty[0] & /*_inputId*/ 33554432) {
	    				attr(input, "id", /*_inputId*/ ctx[25]);
	    			}

	    			if (dirty[0] & /*disabled*/ 2) {
	    				input.disabled = /*disabled*/ ctx[1];
	    			}

	    			if (dirty[0] & /*placeholder*/ 8) {
	    				attr(input, "placeholder", /*placeholder*/ ctx[3]);
	    			}

	    			if (dirty[0] & /*_rawValue*/ 262144 && input.value !== /*_rawValue*/ ctx[18]) {
	    				set_input_value(input, /*_rawValue*/ ctx[18]);
	    			}

	    			if (/*_showClear*/ ctx[32]) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);
	    				} else {
	    					if_block1 = create_if_block_3$5(ctx);
	    					if_block1.c();
	    					if_block1.m(div4, t2);
	    				}
	    			} else if (if_block1) {
	    				if_block1.d(1);
	    				if_block1 = null;
	    			}

	    			if (dirty[0] & /*_upId*/ 134217728) {
	    				attr(div1, "id", /*_upId*/ ctx[27]);
	    			}

	    			if (dirty[0] & /*disabled*/ 2) {
	    				toggle_class(div1, "allow-hover", !/*disabled*/ ctx[1]);
	    			}

	    			if (dirty[0] & /*_downId*/ 268435456) {
	    				attr(div2, "id", /*_downId*/ ctx[28]);
	    			}

	    			if (dirty[0] & /*disabled*/ 2) {
	    				toggle_class(div2, "allow-hover", !/*disabled*/ ctx[1]);
	    			}

	    			if (/*display*/ ctx[2] !== "custom") {
	    				if (if_block2) {
	    					if_block2.p(ctx, dirty);
	    				} else {
	    					if_block2 = create_if_block$d(ctx);
	    					if_block2.c();
	    					if_block2.m(div6, null);
	    				}
	    			} else if (if_block2) {
	    				if_block2.d(1);
	    				if_block2 = null;
	    			}

	    			if (dirty[0] & /*_hasValue*/ 32768) {
	    				toggle_class(div6, "has-value", /*_hasValue*/ ctx[15]);
	    			}

	    			if (dirty[1] & /*_hasLabel*/ 1) {
	    				toggle_class(div6, "has-label", /*_hasLabel*/ ctx[31]);
	    			}

	    			if (dirty[0] & /*_hasFocus*/ 1048576) {
	    				toggle_class(div6, "has-focus", /*_hasFocus*/ ctx[20]);
	    			}

	    			if (dirty[0] & /*display*/ 4) {
	    				toggle_class(div6, "custom-layout", /*display*/ ctx[2] === "custom");
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 196608) {
	    				toggle_class(div6, "error", /*_dirty*/ ctx[16] && /*_errors*/ ctx[17].length > 0);
	    			}

	    			if (dirty[0] & /*disabled*/ 2) {
	    				toggle_class(div6, "disabled", /*disabled*/ ctx[1]);
	    			}

	    			if (dirty[0] & /*disabled*/ 2) {
	    				toggle_class(div6, "allow-hover", !/*disabled*/ ctx[1]);
	    			}

	    			if (dirty[0] & /*_theme*/ 2097152) {
	    				attr(div7, "pos--theme", /*_theme*/ ctx[21]);
	    			}

	    			if (dirty[0] & /*_shape*/ 4194304) {
	    				attr(div7, "pos--shape", /*_shape*/ ctx[22]);
	    			}

	    			if (dirty[0] & /*_density*/ 8388608) {
	    				attr(div7, "pos--density", /*_density*/ ctx[23]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div7);
	    			if (if_block0) if_block0.d();
	    			/*input_binding*/ ctx[56](null);
	    			if (if_block1) if_block1.d();
	    			if (if_block2) if_block2.d();
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    function makeNumber(input) {
	    	if (!hasValue$4(input)) {
	    		return null;
	    	}

	    	return typeof input === "string" ? Number(input.trim()) : input;
	    }

	    function hasValue$4(test) {
	    	return test !== undefined && test !== null;
	    }

	    function notEmpty$2(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$g($$self, $$props, $$invalidate) {
	    	let _hasValue;
	    	let _hasLabel;
	    	let _showClear;
	    	let $_;
	    	component_subscribe($$self, X, $$value => $$invalidate(73, $_ = $$value));
	    	const dispatch = createEventDispatcher();
	    	let { display = "form" } = $$props; // Layout interaction (reserved space, alignment policies) (form, custom)
	    	let { theme = "auto" } = $$props; // Color theme (auto/dark/light)
	    	let { shape = "round" } = $$props; // Shape theme (round/sharp)
	    	let { density = "standard" } = $$props; // Density style (standard/high)
	    	let { value = null } = $$props; // Current value of control
	    	let { label = "" } = $$props; // Control label
	    	let { placeholder = "" } = $$props; // Placeholder text to display in text box when no value
	    	let { hint = "" } = $$props; // Hint/Helper text to display when no validation errors to display
	    	let { min = undefined } = $$props; // Minimum acceptable value
	    	let { max = undefined } = $$props; // maximum acceptable value
	    	let { step = 1 } = $$props; // Amount to increase/decrease each time
	    	let { clear = false } = $$props; // Allow value to be cleared
	    	let { disabled = false } = $$props; // Is Control disabled?
	    	let { validation = true } = $$props; // Do we include built in validation?
	    	let { required = false } = $$props; // Is value required to be valid?
	    	let { errors = [] } = $$props; // Custom external validation errors
	    	let { id = null } = $$props;

	    	// Internal Data
	    	let _dirty = false; // Has the user changed the value (yes = dirty)

	    	let _errors = []; // Combined validation errors
	    	let _builtInErrors = []; // Built in validation errors
	    	let _lastValid;
	    	let _speedUpTimer = undefined; //
	    	let _pressAndHoldInterval = undefined; //
	    	let _rawValue = null; // Current value of control
	    	let _lastValue = null;
	    	let _decimalLength = undefined;
	    	let _inputElement = undefined;
	    	let _hasFocus = false;
	    	let _themeEventListener;
	    	let _shapeEventListener;
	    	let _densityEventListener;
	    	let _theme;
	    	let _shape;
	    	let _density;
	    	let _lastTheme;
	    	let _lastShape;
	    	let _lastDensity;
	    	let _labelId = null;
	    	let _inputId = null;
	    	let _clearId = null;
	    	let _upId = null;
	    	let _downId = null;
	    	let _messageId = null;
	    	let _statusIconId = null;

	    	onMount(() => {
	    		$$invalidate(18, _rawValue = value);
	    		doValidate();
	    	});

	    	onDestroy(() => {
	    		if (_themeEventListener) {
	    			window.removeEventListener("posh-theme-changed", _themeEventListener);
	    		}

	    		if (_shapeEventListener) {
	    			window.removeEventListener("posh-shape-changed", _shapeEventListener);
	    		}

	    		if (_densityEventListener) {
	    			window.removeEventListener("posh-density-changed", _densityEventListener);
	    		}
	    	});

	    	beforeUpdate(() => {
	    		// Normalize external changes
	    		$$invalidate(2, display = hasValue$4(display) ? display : "form");

	    		$$invalidate(35, theme = hasValue$4(theme) ? theme : "light");
	    		$$invalidate(36, shape = hasValue$4(shape) ? shape : "round");
	    		$$invalidate(37, density = hasValue$4(density) ? density : "standard");
	    		$$invalidate(0, label = hasValue$4(label) ? label : "");
	    		$$invalidate(3, placeholder = hasValue$4(placeholder) ? placeholder : "");
	    		$$invalidate(4, hint = hasValue$4(hint) ? hint : "");
	    		$$invalidate(33, value = hasValue$4(value) && !isNaN(value) ? Number(value) : null);
	    		$$invalidate(5, required = hasValue$4(required) ? required : false);
	    		$$invalidate(1, disabled = hasValue$4(disabled) ? disabled : false);
	    		$$invalidate(34, clear = hasValue$4(clear) ? clear : false);
	    		$$invalidate(41, validation = hasValue$4(validation) ? validation : true);

	    		$$invalidate(40, step = hasValue$4(step) && !isNaN(step) && Number(step) > 0
	    		? Number(step)
	    		: 1);

	    		$$invalidate(38, min = hasValue$4(min) && !isNaN(min) ? Number(min) : undefined);
	    		$$invalidate(39, max = hasValue$4(max) && !isNaN(max) ? Number(max) : undefined);
	    		setDecimalLength();
	    		$$invalidate(24, _labelId = hasValue$4(id) ? `${id}-label` : undefined);
	    		$$invalidate(25, _inputId = hasValue$4(id) ? `${id}-input` : undefined);
	    		$$invalidate(26, _clearId = hasValue$4(id) ? `${id}-clear` : undefined);
	    		$$invalidate(27, _upId = hasValue$4(id) ? `${id}-up` : undefined);
	    		$$invalidate(28, _downId = hasValue$4(id) ? `${id}-down` : "pros-options-container");
	    		$$invalidate(29, _messageId = hasValue$4(id) ? `${id}-message` : undefined);
	    		$$invalidate(30, _statusIconId = hasValue$4(id) ? `${id}-status-icon` : undefined);

	    		// Check if this is a programmatic update
	    		if (value !== _lastValue) {
	    			$$invalidate(18, _rawValue = value);
	    			_lastValue = value;
	    		}

	    		if (theme !== _lastTheme) {
	    			_lastTheme = theme;

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(21, _theme = themeAttribute ? themeAttribute : "light");

	    				if (!_themeEventListener) {
	    					// Only start listening once
	    					_themeEventListener = window.addEventListener("posh-theme-changed", event => {
	    						if (theme === "auto") {
	    							$$invalidate(21, _theme = event.detail.theme);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(21, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			_lastShape = shape;

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(22, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					_shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(22, _shape = event.detail.shape);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(22, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			_lastDensity = density;

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(23, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					_densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(23, _density = event.detail.density);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(23, _density = density);
	    			}
	    		}

	    		doValidate.call(this);
	    	});

	    	function handleClear(event) {
	    		event.stopPropagation();
	    		event.preventDefault();
	    		$$invalidate(18, _rawValue = null);
	    		valueChanged.call(this);
	    	}

	    	function handleKeyDown(event) {
	    		checkControlValue.call(this);
	    	}

	    	function handleBlur(event) {
	    		$$invalidate(20, _hasFocus = false);
	    		checkControlValue.call(this);
	    	}

	    	function isValidInput() {
	    		if (_rawValue === null) {
	    			return true;
	    		}

	    		let testValue = typeof _rawValue === "string"
	    		? Number(_rawValue.trim())
	    		: _rawValue;

	    		if (isNaN(testValue)) {
	    			return false;
	    		}

	    		if (hasValue$4(min) && testValue < min) {
	    			return false;
	    		}

	    		if (hasValue$4(max) && testValue > max) {
	    			return false;
	    		}

	    		return true;
	    	}

	    	function isStep(testValue) {
	    		let base = min !== null && min !== undefined && min !== ""
	    		? min
	    		: 0;

	    		if (getDecimal((testValue - base) / step) !== 0) {
	    			return false;
	    		}

	    		return true;
	    	}

	    	function makeValid(input, isUp = true) {
	    		if (!hasValue$4(input)) {
	    			return input;
	    		}

	    		let myValue = input;

	    		if (hasValue$4(min) && input < min) {
	    			myValue = min;
	    		}

	    		if (hasValue$4(max) && input > max) {
	    			myValue = max;
	    		}

	    		if (!isStep(input)) {
	    			myValue = isUp ? roundUp(input) : roundDown(input);
	    		}

	    		return myValue;
	    	}

	    	function getDecimal(input) {
	    		let decimals = input.toFixed(_decimalLength).split(".");
	    		return decimals.length > 1 ? Number(decimals[1]) : 0;
	    	}

	    	function getValueString(input) {
	    		if (input === null) {
	    			return null;
	    		}

	    		if (input === 0) {
	    			return "0";
	    		}

	    		return hasValue$4(_decimalLength)
	    		? input.toFixed(_decimalLength)
	    		: `${input}`;
	    	}

	    	function handleFocus(event) {
	    		$$invalidate(20, _hasFocus = true);
	    	}

	    	function handleClick(event) {
	    		if (disabled) {
	    			return;
	    		}

	    		$$invalidate(20, _hasFocus = true);
	    		_inputElement.focus();
	    	}

	    	function handleStepUp() {
	    		if (disabled) {
	    			return;
	    		}

	    		stepUp.call(this);
	    		valueChanged();
	    	}

	    	function handleStepDown() {
	    		if (disabled) {
	    			return;
	    		}

	    		stepDown.call(this);
	    		valueChanged();
	    	}

	    	function stepUp() {
	    		let myValue = hasValue$4(min) ? min : 0;

	    		if (hasValue$4(_rawValue)) {
	    			myValue = makeNumber(_rawValue) + step;
	    			myValue = makeValid(myValue);
	    		}

	    		$$invalidate(18, _rawValue = getValueString(myValue));
	    	}

	    	function stepDown() {
	    		let myValue = hasValue$4(min) ? min : 0;

	    		if (hasValue$4(_rawValue)) {
	    			myValue = makeNumber(_rawValue) - step;
	    			myValue = makeValid(myValue, false);
	    		}

	    		$$invalidate(18, _rawValue = getValueString(myValue));
	    	}

	    	function startPressAndHold(event, isUp) {
	    		event.preventDefault();
	    		let directionFunction = isUp ? stepUp.bind(this) : stepDown.bind(this);
	    		_pressAndHoldInterval = window.setInterval(directionFunction, 300);

	    		_speedUpTimer = window.setTimeout(
	    			() => {
	    				window.clearInterval(_pressAndHoldInterval);
	    				_pressAndHoldInterval = window.setInterval(directionFunction, 50);
	    			},
	    			2000
	    		);
	    	}

	    	function endPressAndHold(isUp) {
	    		isUp ? stepUp.bind(this) : stepDown.bind(this);

	    		if (_speedUpTimer) {
	    			window.clearTimeout(_speedUpTimer);
	    		}

	    		if (_pressAndHoldInterval) {
	    			window.clearInterval(_pressAndHoldInterval);
	    		}

	    		_pressAndHoldInterval = null;
	    		_speedUpTimer = null;
	    		valueChanged.bind(this);
	    	}

	    	function roundUp(value) {
	    		if (value > 0) return Math.ceil(value / step) * step; else if (value < 0) return Math.floor(value / step) * step; else return step;
	    	}

	    	function roundDown(value) {
	    		if (value > 0) return Math.floor(value / step) * step; else if (value < 0) return Math.ceil(value / step) * step; else return step;
	    	}

	    	function setDecimalLength() {
	    		let test = `${step}`;
	    		let decimals = test.split(".");
	    		_decimalLength = decimals.length > 1 ? decimals[1].length : undefined;
	    	}

	    	function checkControlValue() {
	    		$$invalidate(16, _dirty = true);

	    		if (isValidInput()) {
	    			$$invalidate(18, _rawValue = getValueString(makeValid(makeNumber(_rawValue))));
	    		} else {
	    			$$invalidate(18, _rawValue = _rawValue.trim());
	    		}

	    		valueChanged.call(this);
	    	}

	    	function valueChanged() {
	    		$$invalidate(16, _dirty = true);
	    		$$invalidate(33, value = makeNumber(_rawValue));
	    		_lastValue = value;
	    		doValidate.call(this);

	    		window.setTimeout(() => {
	    			dispatch("changed", value);
	    		});
	    	}

	    	function doValidate() {
	    		_builtInErrors = [];
	    		$$invalidate(17, _errors = errors ? errors : []);

	    		if (required) {
	    			if (!hasValue$4(value)) {
	    				_builtInErrors.push($_("validateRequired"));
	    			}
	    		}

	    		if (!hasValue$4(value)) {
	    			if (required) {
	    				_builtInErrors.push($_("validateRequired"));
	    			}
	    		} else {
	    			if (isNaN(_rawValue)) {
	    				_builtInErrors.push($_("validateNotANumber"));
	    			} else {
	    				let testValue = Number(_rawValue);

	    				if (hasValue$4(min) && testValue < min) {
	    					_builtInErrors.push($_("validateLessThanMin", { values: { 0: min } }));
	    				}

	    				if (hasValue$4(max) && testValue > max) {
	    					_builtInErrors.push($_("validateMoreThanMax", { values: { 0: max } }));
	    				}

	    				if (!isStep(testValue)) {
	    					_builtInErrors.push($_("validateNotAStepValue", { values: { 0: step } }));
	    				}
	    			}
	    		}

	    		if (validation) {
	    			$$invalidate(17, _errors = _errors.concat(_builtInErrors));
	    		}

	    		window.setTimeout(() => {
	    			let valid = _errors.length === 0;

	    			if (_lastValid !== valid) {
	    				_lastValid = valid;
	    				dispatch("valid", valid);

	    				if (hasValue$4(value) && !valid && !_dirty) {
	    					$$invalidate(16, _dirty = true);
	    				}
	    			}
	    		});
	    	}

	    	function input_input_handler() {
	    		_rawValue = this.value;
	    		$$invalidate(18, _rawValue);
	    	}

	    	function input_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_inputElement = $$value;
	    			$$invalidate(19, _inputElement);
	    		});
	    	}

	    	const mousedown_handler = event => startPressAndHold(event, true);
	    	const mouseup_handler = () => endPressAndHold(true);
	    	const mousedown_handler_1 = event => startPressAndHold(event, false);
	    	const mouseup_handler_1 = () => endPressAndHold(false);

	    	$$self.$$set = $$props => {
	    		if ("display" in $$props) $$invalidate(2, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(35, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(36, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(37, density = $$props.density);
	    		if ("value" in $$props) $$invalidate(33, value = $$props.value);
	    		if ("label" in $$props) $$invalidate(0, label = $$props.label);
	    		if ("placeholder" in $$props) $$invalidate(3, placeholder = $$props.placeholder);
	    		if ("hint" in $$props) $$invalidate(4, hint = $$props.hint);
	    		if ("min" in $$props) $$invalidate(38, min = $$props.min);
	    		if ("max" in $$props) $$invalidate(39, max = $$props.max);
	    		if ("step" in $$props) $$invalidate(40, step = $$props.step);
	    		if ("clear" in $$props) $$invalidate(34, clear = $$props.clear);
	    		if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
	    		if ("validation" in $$props) $$invalidate(41, validation = $$props.validation);
	    		if ("required" in $$props) $$invalidate(5, required = $$props.required);
	    		if ("errors" in $$props) $$invalidate(42, errors = $$props.errors);
	    		if ("id" in $$props) $$invalidate(43, id = $$props.id);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty[1] & /*value*/ 4) {
	    			// Computed values
	    			$$invalidate(15, _hasValue = hasValue$4(value));
	    		}

	    		if ($$self.$$.dirty[0] & /*label*/ 1) {
	    			$$invalidate(31, _hasLabel = notEmpty$2(label));
	    		}

	    		if ($$self.$$.dirty[0] & /*disabled, _hasValue*/ 32770 | $$self.$$.dirty[1] & /*clear*/ 8) {
	    			$$invalidate(32, _showClear = clear && !disabled && _hasValue);
	    		}
	    	};

	    	return [
	    		label,
	    		disabled,
	    		display,
	    		placeholder,
	    		hint,
	    		required,
	    		handleClear,
	    		handleKeyDown,
	    		handleBlur,
	    		handleFocus,
	    		handleClick,
	    		handleStepUp,
	    		handleStepDown,
	    		startPressAndHold,
	    		endPressAndHold,
	    		_hasValue,
	    		_dirty,
	    		_errors,
	    		_rawValue,
	    		_inputElement,
	    		_hasFocus,
	    		_theme,
	    		_shape,
	    		_density,
	    		_labelId,
	    		_inputId,
	    		_clearId,
	    		_upId,
	    		_downId,
	    		_messageId,
	    		_statusIconId,
	    		_hasLabel,
	    		_showClear,
	    		value,
	    		clear,
	    		theme,
	    		shape,
	    		density,
	    		min,
	    		max,
	    		step,
	    		validation,
	    		errors,
	    		id,
	    		isValidInput,
	    		isStep,
	    		makeNumber,
	    		makeValid,
	    		getDecimal,
	    		getValueString,
	    		stepUp,
	    		stepDown,
	    		roundUp,
	    		roundDown,
	    		setDecimalLength,
	    		input_input_handler,
	    		input_binding,
	    		mousedown_handler,
	    		mouseup_handler,
	    		mousedown_handler_1,
	    		mouseup_handler_1
	    	];
	    }

	    class NumberBox extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-a4lkko-style")) add_css$g();

	    		init(
	    			this,
	    			options,
	    			instance$g,
	    			create_fragment$g,
	    			safe_not_equal,
	    			{
	    				display: 2,
	    				theme: 35,
	    				shape: 36,
	    				density: 37,
	    				value: 33,
	    				label: 0,
	    				placeholder: 3,
	    				hint: 4,
	    				min: 38,
	    				max: 39,
	    				step: 40,
	    				clear: 34,
	    				disabled: 1,
	    				validation: 41,
	    				required: 5,
	    				errors: 42,
	    				id: 43,
	    				handleClear: 6,
	    				handleKeyDown: 7,
	    				handleBlur: 8,
	    				isValidInput: 44,
	    				isStep: 45,
	    				makeNumber: 46,
	    				makeValid: 47,
	    				getDecimal: 48,
	    				getValueString: 49,
	    				handleFocus: 9,
	    				handleClick: 10,
	    				handleStepUp: 11,
	    				handleStepDown: 12,
	    				stepUp: 50,
	    				stepDown: 51,
	    				startPressAndHold: 13,
	    				endPressAndHold: 14,
	    				roundUp: 52,
	    				roundDown: 53,
	    				setDecimalLength: 54
	    			},
	    			[-1, -1, -1]
	    		);
	    	}

	    	get handleClear() {
	    		return this.$$.ctx[6];
	    	}

	    	get handleKeyDown() {
	    		return this.$$.ctx[7];
	    	}

	    	get handleBlur() {
	    		return this.$$.ctx[8];
	    	}

	    	get isValidInput() {
	    		return this.$$.ctx[44];
	    	}

	    	get isStep() {
	    		return this.$$.ctx[45];
	    	}

	    	get makeNumber() {
	    		return makeNumber;
	    	}

	    	get makeValid() {
	    		return this.$$.ctx[47];
	    	}

	    	get getDecimal() {
	    		return this.$$.ctx[48];
	    	}

	    	get getValueString() {
	    		return this.$$.ctx[49];
	    	}

	    	get handleFocus() {
	    		return this.$$.ctx[9];
	    	}

	    	get handleClick() {
	    		return this.$$.ctx[10];
	    	}

	    	get handleStepUp() {
	    		return this.$$.ctx[11];
	    	}

	    	get handleStepDown() {
	    		return this.$$.ctx[12];
	    	}

	    	get stepUp() {
	    		return this.$$.ctx[50];
	    	}

	    	get stepDown() {
	    		return this.$$.ctx[51];
	    	}

	    	get startPressAndHold() {
	    		return this.$$.ctx[13];
	    	}

	    	get endPressAndHold() {
	    		return this.$$.ctx[14];
	    	}

	    	get roundUp() {
	    		return this.$$.ctx[52];
	    	}

	    	get roundDown() {
	    		return this.$$.ctx[53];
	    	}

	    	get setDecimalLength() {
	    		return this.$$.ctx[54];
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/forms/src/SelectBox.svelte generated by Svelte v3.38.2 */

	    const { document: document_1$4 } = globals;

	    function add_css$f() {
	    	var style = element("style");
	    	style.id = "svelte-1c84wsf-style";
	    	style.textContent = ".pros-highlight-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1c84wsf .pros-input.svelte-1c84wsf{width:100%;outline:none !important;border:none;padding:0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer}.pros-control-container.has-label.svelte-1c84wsf .pros-input.svelte-1c84wsf{padding-top:18px}.pros-control-container.has-label.svelte-1c84wsf .pros-input.placeholder.svelte-1c84wsf{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-1c84wsf.svelte-1c84wsf{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1c84wsf.svelte-1c84wsf::after{content:\" *\"}.pros-action-button.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-1c84wsf svg.svelte-1c84wsf{width:24px;height:24px}.pros-action-button.svelte-1c84wsf.svelte-1c84wsf:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-1c84wsf.svelte-1c84wsf{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-end-cap.svelte-1c84wsf svg.svelte-1c84wsf{width:auto;height:auto}.pros-control-container.svelte-1c84wsf.svelte-1c84wsf{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1c84wsf .pros-control-label.svelte-1c84wsf,.pros-control-container.has-focus.svelte-1c84wsf .pros-control-label.svelte-1c84wsf{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1c84wsf .pros-highlight-container.svelte-1c84wsf{cursor:default}.pros-control-container.has-focus.svelte-1c84wsf .pros-input.svelte-1c84wsf{cursor:text}.pros-control-container.has-focus.svelte-1c84wsf .pros-highlight-container.svelte-1c84wsf{border-width:2px}.pros-control-container.has-focus.svelte-1c84wsf .pros-input-container.svelte-1c84wsf{margin-left:11px}.pros-control-container.has-focus.svelte-1c84wsf .pros-end-cap.svelte-1c84wsf:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-1c84wsf .pros-input.placeholder.svelte-1c84wsf{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1c84wsf .pros-status-icon.svelte-1c84wsf{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1c84wsf .pros-status-icon svg.svelte-1c84wsf{height:100%;width:100%}.pros-message-container.svelte-1c84wsf .pros-message.svelte-1c84wsf{flex:1}.pros-options-wrapper.svelte-1c84wsf.svelte-1c84wsf{position:fixed;display:none;max-width:100%;border-width:1px;border-style:solid;box-sizing:border-box;z-index:1001;overflow:hidden}.pros-options-wrapper.open.svelte-1c84wsf.svelte-1c84wsf{display:inherit}.pros-options-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%;box-sizing:border-box}.pros-options-container.svelte-1c84wsf .pros-options-search.svelte-1c84wsf{width:100%;padding:0 8px;box-sizing:border-box}.pros-options-container.svelte-1c84wsf .pros-options.svelte-1c84wsf{width:100%;overflow:auto;max-height:160px;margin:8px 0;padding:0 8px;box-sizing:border-box}.pros-options-container.svelte-1c84wsf .pros-options .pros-options-virtual-container.svelte-1c84wsf{position:relative;height:500px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list.svelte-1c84wsf{position:absolute;top:0;left:0;right:0}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;height:36px;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;padding:0 8px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row.svelte-1c84wsf:not(:last-of-type){margin-bottom:4px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row .pros-option.svelte-1c84wsf{flex:1}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row .pros-option-details.svelte-1c84wsf{font-size:12px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-empty-row.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;height:36px;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;padding:0 8px}.pros-options-container.svelte-1c84wsf .svelte-1c84wsf::-webkit-scrollbar{width:6px;height:6px}.pros-options-container.svelte-1c84wsf .svelte-1c84wsf::-webkit-scrollbar-track{background-color:transparent}.pros-options-container.svelte-1c84wsf .svelte-1c84wsf::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:6px}.pros-global-wrapper[pos--shape=sharp].svelte-1c84wsf .pros-highlight-container.svelte-1c84wsf{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-control-label.svelte-1c84wsf{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-highlight-container.svelte-1c84wsf{height:36px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1c84wsf{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-input-container .pros-input.svelte-1c84wsf{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-label .pros-input.svelte-1c84wsf{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-value .pros-control-label.svelte-1c84wsf,.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-focus .pros-control-label.svelte-1c84wsf{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1c84wsf{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-focus .pros-input-container.svelte-1c84wsf{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.svelte-1c84wsf{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-highlight-container.svelte-1c84wsf{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-input.svelte-1c84wsf{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-input.placeholder.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.allow-hover .pros-highlight-container.svelte-1c84wsf:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.error .pros-highlight-container.svelte-1c84wsf{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.has-focus .pros-highlight-container.svelte-1c84wsf{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-end-cap.svelte-1c84wsf{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container.svelte-1c84wsf{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container .pros-status-icon.svelte-1c84wsf{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container.error.svelte-1c84wsf{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1c84wsf{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled.svelte-1c84wsf{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-highlight-container.svelte-1c84wsf{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-input.svelte-1c84wsf{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-message-container.svelte-1c84wsf{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-end-cap.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-action-button.svelte-1c84wsf:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.svelte-1c84wsf{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-highlight-container.svelte-1c84wsf{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-input.svelte-1c84wsf{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-input.placeholder.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.allow-hover .pros-highlight-container.svelte-1c84wsf:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.error .pros-highlight-container.svelte-1c84wsf{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.has-focus .pros-highlight-container.svelte-1c84wsf{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container.svelte-1c84wsf{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container .pros-status-icon.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container.error.svelte-1c84wsf{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1c84wsf{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled.svelte-1c84wsf{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled .pros-highlight-container.svelte-1c84wsf{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled .pros-input.svelte-1c84wsf{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled .pros-message-container.svelte-1c84wsf{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-action-button.svelte-1c84wsf:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-highlight-container.open.svelte-1c84wsf{border-color:#ffffff;background-color:#ffffff}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-highlight-container.open.downward.svelte-1c84wsf{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-highlight-container.open.upward.svelte-1c84wsf{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-highlight-container.open.svelte-1c84wsf{border-color:#2b2b2b;background-color:#2b2b2b}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-highlight-container.open.downward.svelte-1c84wsf{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-highlight-container.open.upward.svelte-1c84wsf{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px}.pros-options-wrapper.svelte-1c84wsf.svelte-1c84wsf{display:none}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf.svelte-1c84wsf{background-color:#FFFFFF;color:#363636;border-color:transparent}.pros-options-wrapper[pos--theme=light].downward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0 16px 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px;border-top:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].upward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0 -16px 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row .pros-option-details.svelte-1c84wsf{color:#adadad}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.highlight.svelte-1c84wsf{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.svelte-1c84wsf:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected.svelte-1c84wsf{background-color:#027aae;color:white}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected .pros-option-details.svelte-1c84wsf{color:#dbdbdb}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf.svelte-1c84wsf{background-color:#2b2b2b;color:#ffffff;border-color:transparent}.pros-options-wrapper[pos--theme=dark].downward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px;border-top:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].upward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.svelte-1c84wsf{color:#ffffff}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row .pros-option-details.svelte-1c84wsf{color:#ebebeb}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.highlight.svelte-1c84wsf{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.svelte-1c84wsf:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected.svelte-1c84wsf{background-color:#3ab4eb;color:#212121}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected .pros-option-details.svelte-1c84wsf{color:#ebebeb}";
	    	append(document_1$4.head, style);
	    }

	    function get_each_context$5(ctx, list, i) {
	    	const child_ctx = ctx.slice();
	    	child_ctx[119] = list[i];
	    	child_ctx[120] = list;
	    	child_ctx[121] = i;
	    	return child_ctx;
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_14(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*label*/ ctx[0]);
	    			attr(div, "id", /*_labelId*/ ctx[41]);
	    			attr(div, "class", "pros-control-label svelte-1c84wsf");
	    			attr(div, "pros-tooltip", "");
	    			toggle_class(div, "required", /*required*/ ctx[7]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*label*/ 1) set_data(t, /*label*/ ctx[0]);

	    			if (dirty[1] & /*_labelId*/ 1024) {
	    				attr(div, "id", /*_labelId*/ ctx[41]);
	    			}

	    			if (dirty[0] & /*required*/ 128) {
	    				toggle_class(div, "required", /*required*/ ctx[7]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (34:10) {#if placeholder}
	    function create_if_block_13(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*placeholder*/ ctx[24]);
	    			attr(div, "class", "pros-input placeholder svelte-1c84wsf");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*placeholder*/ 16777216) set_data(t, /*placeholder*/ ctx[24]);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (31:29) 
	    function create_if_block_12(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*_display*/ ctx[3]);
	    			attr(div, "class", "pros-input svelte-1c84wsf");
	    			attr(div, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_display*/ 8) set_data(t, /*_display*/ ctx[3]);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (29:10) {#if _displayHtml}
	    function create_if_block_11(ctx) {
	    	let div;

	    	return {
	    		c() {
	    			div = element("div");
	    			attr(div, "class", "pros-input svelte-1c84wsf");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			div.innerHTML = /*_displayHtml*/ ctx[14];
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*_displayHtml*/ 16384) div.innerHTML = /*_displayHtml*/ ctx[14];		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (39:8) {#if _showClear}
	    function create_if_block_10$1(ctx) {
	    	let div;
	    	let svg;
	    	let path;
	    	let mounted;
	    	let dispose;

	    	return {
	    		c() {
	    			div = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1c84wsf");
	    			attr(div, "id", /*_clearId*/ ctx[43]);
	    			attr(div, "class", "pros-action-button clear-value svelte-1c84wsf");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, svg);
	    			append(svg, path);

	    			if (!mounted) {
	    				dispose = listen(div, "click", /*handleClear*/ ctx[34]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_clearId*/ 4096) {
	    				attr(div, "id", /*_clearId*/ ctx[43]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (53:6) {#if _showOptions && !disabled}
	    function create_if_block_3$4(ctx) {
	    	let div4;
	    	let div3;
	    	let t0;
	    	let div2;
	    	let div1;
	    	let div0;
	    	let t1;
	    	let positionOptions_action;
	    	let globalClicks_action;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*search*/ ctx[6] && create_if_block_9$1(ctx);
	    	let each_value = /*_virtualOptions*/ ctx[38];
	    	let each_blocks = [];

	    	for (let i = 0; i < each_value.length; i += 1) {
	    		each_blocks[i] = create_each_block$5(get_each_context$5(ctx, each_value, i));
	    	}

	    	const out = i => transition_out(each_blocks[i], 1, 1, () => {
	    		each_blocks[i] = null;
	    	});

	    	let if_block1 = /*_virtualOptions*/ ctx[38].length === 0 && create_if_block_4$4(ctx);

	    	return {
	    		c() {
	    			div4 = element("div");
	    			div3 = element("div");
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div2 = element("div");
	    			div1 = element("div");
	    			div0 = element("div");

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].c();
	    			}

	    			t1 = space();
	    			if (if_block1) if_block1.c();
	    			attr(div0, "class", "pros-option-list svelte-1c84wsf");
	    			attr(div1, "class", "pros-options-virtual-container svelte-1c84wsf");
	    			attr(div2, "id", /*_optionsId*/ ctx[45]);
	    			attr(div2, "class", "pros-options svelte-1c84wsf");
	    			attr(div3, "id", "pros-options-container");
	    			attr(div3, "class", "pros-options-container svelte-1c84wsf");
	    			attr(div4, "class", "pros-options-wrapper svelte-1c84wsf");
	    			attr(div4, "pos--theme", /*_theme*/ ctx[21]);
	    			attr(div4, "pos--shape", /*_shape*/ ctx[22]);
	    			attr(div4, "pos--density", /*_density*/ ctx[23]);
	    			toggle_class(div4, "open", /*_positioned*/ ctx[16]);
	    			toggle_class(div4, "upward", /*_upward*/ ctx[15]);
	    			toggle_class(div4, "downward", !/*_upward*/ ctx[15]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div4, anchor);
	    			append(div4, div3);
	    			if (if_block0) if_block0.m(div3, null);
	    			append(div3, t0);
	    			append(div3, div2);
	    			append(div2, div1);
	    			append(div1, div0);

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].m(div0, null);
	    			}

	    			append(div0, t1);
	    			if (if_block1) if_block1.m(div0, null);
	    			/*div0_binding*/ ctx[104](div0);
	    			/*div1_binding*/ ctx[105](div1);
	    			/*div2_binding*/ ctx[106](div2);
	    			/*div4_binding*/ ctx[107](div4);
	    			current = true;

	    			if (!mounted) {
	    				dispose = [
	    					listen(div2, "scroll", /*_handleOptionsScrollDebounce*/ ctx[52]),
	    					listen(div2, "mousedown", preventClickPropagation$1),
	    					listen(div2, "mouseup", preventClickPropagation$1),
	    					action_destroyer(positionOptions_action = /*positionOptions*/ ctx[26].call(null, div4)),
	    					action_destroyer(globalClicks_action = /*globalClicks*/ ctx[25].call(null, div4))
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*search*/ ctx[6]) {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);

	    					if (dirty[0] & /*search*/ 64) {
	    						transition_in(if_block0, 1);
	    					}
	    				} else {
	    					if_block0 = create_if_block_9$1(ctx);
	    					if_block0.c();
	    					transition_in(if_block0, 1);
	    					if_block0.m(div3, t0);
	    				}
	    			} else if (if_block0) {
	    				group_outros();

	    				transition_out(if_block0, 1, 1, () => {
	    					if_block0 = null;
	    				});

	    				check_outros();
	    			}

	    			if (dirty[0] & /*_searchOptions, _highlightIndex, handleMouseEnterOption, handleMouseLeaveOption, preventClickPropagation, _theme, multiple*/ 941633540 | dirty[1] & /*isOptionSelected, _virtualOptions, handleOptionClicked*/ 37748864) {
	    				each_value = /*_virtualOptions*/ ctx[38];
	    				let i;

	    				for (i = 0; i < each_value.length; i += 1) {
	    					const child_ctx = get_each_context$5(ctx, each_value, i);

	    					if (each_blocks[i]) {
	    						each_blocks[i].p(child_ctx, dirty);
	    						transition_in(each_blocks[i], 1);
	    					} else {
	    						each_blocks[i] = create_each_block$5(child_ctx);
	    						each_blocks[i].c();
	    						transition_in(each_blocks[i], 1);
	    						each_blocks[i].m(div0, t1);
	    					}
	    				}

	    				group_outros();

	    				for (i = each_value.length; i < each_blocks.length; i += 1) {
	    					out(i);
	    				}

	    				check_outros();
	    			}

	    			if (/*_virtualOptions*/ ctx[38].length === 0) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);
	    				} else {
	    					if_block1 = create_if_block_4$4(ctx);
	    					if_block1.c();
	    					if_block1.m(div0, null);
	    				}
	    			} else if (if_block1) {
	    				if_block1.d(1);
	    				if_block1 = null;
	    			}

	    			if (!current || dirty[1] & /*_optionsId*/ 16384) {
	    				attr(div2, "id", /*_optionsId*/ ctx[45]);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 2097152) {
	    				attr(div4, "pos--theme", /*_theme*/ ctx[21]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 4194304) {
	    				attr(div4, "pos--shape", /*_shape*/ ctx[22]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 8388608) {
	    				attr(div4, "pos--density", /*_density*/ ctx[23]);
	    			}

	    			if (dirty[0] & /*_positioned*/ 65536) {
	    				toggle_class(div4, "open", /*_positioned*/ ctx[16]);
	    			}

	    			if (dirty[0] & /*_upward*/ 32768) {
	    				toggle_class(div4, "upward", /*_upward*/ ctx[15]);
	    			}

	    			if (dirty[0] & /*_upward*/ 32768) {
	    				toggle_class(div4, "downward", !/*_upward*/ ctx[15]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block0);

	    			for (let i = 0; i < each_value.length; i += 1) {
	    				transition_in(each_blocks[i]);
	    			}

	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block0);
	    			each_blocks = each_blocks.filter(Boolean);

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				transition_out(each_blocks[i]);
	    			}

	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div4);
	    			if (if_block0) if_block0.d();
	    			destroy_each(each_blocks, detaching);
	    			if (if_block1) if_block1.d();
	    			/*div0_binding*/ ctx[104](null);
	    			/*div1_binding*/ ctx[105](null);
	    			/*div2_binding*/ ctx[106](null);
	    			/*div4_binding*/ ctx[107](null);
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (56:10) {#if search}
	    function create_if_block_9$1(ctx) {
	    	let div;
	    	let textbox;
	    	let updating_value;
	    	let updating_inputElement;
	    	let current;

	    	function textbox_value_binding(value) {
	    		/*textbox_value_binding*/ ctx[97](value);
	    	}

	    	function textbox_inputElement_binding(value) {
	    		/*textbox_inputElement_binding*/ ctx[98](value);
	    	}

	    	let textbox_props = {
	    		id: /*_optionsSearchId*/ ctx[46],
	    		placeholder: "Search",
	    		density: "high",
	    		display: "custom",
	    		icon: "general/veneer/search-o.svg",
	    		theme: /*_theme*/ ctx[21]
	    	};

	    	if (/*_searchText*/ ctx[11] !== void 0) {
	    		textbox_props.value = /*_searchText*/ ctx[11];
	    	}

	    	if (/*_searchElement*/ ctx[19] !== void 0) {
	    		textbox_props.inputElement = /*_searchElement*/ ctx[19];
	    	}

	    	textbox = new TextBox({ props: textbox_props });
	    	binding_callbacks.push(() => bind(textbox, "value", textbox_value_binding));
	    	binding_callbacks.push(() => bind(textbox, "inputElement", textbox_inputElement_binding));
	    	textbox.$on("changed", /*handleSearchChanged*/ ctx[35]);

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(textbox.$$.fragment);
	    			attr(div, "class", "pros-options-search svelte-1c84wsf");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(textbox, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const textbox_changes = {};
	    			if (dirty[1] & /*_optionsSearchId*/ 32768) textbox_changes.id = /*_optionsSearchId*/ ctx[46];
	    			if (dirty[0] & /*_theme*/ 2097152) textbox_changes.theme = /*_theme*/ ctx[21];

	    			if (!updating_value && dirty[0] & /*_searchText*/ 2048) {
	    				updating_value = true;
	    				textbox_changes.value = /*_searchText*/ ctx[11];
	    				add_flush_callback(() => updating_value = false);
	    			}

	    			if (!updating_inputElement && dirty[0] & /*_searchElement*/ 524288) {
	    				updating_inputElement = true;
	    				textbox_changes.inputElement = /*_searchElement*/ ctx[19];
	    				add_flush_callback(() => updating_inputElement = false);
	    			}

	    			textbox.$set(textbox_changes);
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(textbox.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(textbox.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(textbox);
	    		}
	    	};
	    }

	    // (83:18) {:else}
	    function create_else_block_1$1(ctx) {
	    	let div;
	    	let t;
	    	let if_block1_anchor;

	    	function select_block_type_2(ctx, dirty) {
	    		if (/*option*/ ctx[119].displayHtml) return create_if_block_8$1;
	    		return create_else_block_2$1;
	    	}

	    	let current_block_type = select_block_type_2(ctx);
	    	let if_block0 = current_block_type(ctx);
	    	let if_block1 = /*option*/ ctx[119].details && create_if_block_7$2(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block0.c();
	    			t = space();
	    			if (if_block1) if_block1.c();
	    			if_block1_anchor = empty();
	    			attr(div, "pros-tooltip", "");
	    			attr(div, "role", "option");
	    			attr(div, "class", "pros-option svelte-1c84wsf");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block0.m(div, null);
	    			insert(target, t, anchor);
	    			if (if_block1) if_block1.m(target, anchor);
	    			insert(target, if_block1_anchor, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (current_block_type === (current_block_type = select_block_type_2(ctx)) && if_block0) {
	    				if_block0.p(ctx, dirty);
	    			} else {
	    				if_block0.d(1);
	    				if_block0 = current_block_type(ctx);

	    				if (if_block0) {
	    					if_block0.c();
	    					if_block0.m(div, null);
	    				}
	    			}

	    			if (/*option*/ ctx[119].details) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);
	    				} else {
	    					if_block1 = create_if_block_7$2(ctx);
	    					if_block1.c();
	    					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
	    				}
	    			} else if (if_block1) {
	    				if_block1.d(1);
	    				if_block1 = null;
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block0.d();
	    			if (detaching) detach(t);
	    			if (if_block1) if_block1.d(detaching);
	    			if (detaching) detach(if_block1_anchor);
	    		}
	    	};
	    }

	    // (76:18) {#if multiple}
	    function create_if_block_5$2(ctx) {
	    	let checkbox;
	    	let updating_label;
	    	let updating_value;
	    	let t;
	    	let if_block_anchor;
	    	let current;

	    	function checkbox_label_binding(value) {
	    		/*checkbox_label_binding*/ ctx[99](value, /*option*/ ctx[119]);
	    	}

	    	function checkbox_value_binding(value) {
	    		/*checkbox_value_binding*/ ctx[100](value, /*option*/ ctx[119]);
	    	}

	    	let checkbox_props = {
	    		display: "custom",
	    		theme: /*_theme*/ ctx[21]
	    	};

	    	if (/*option*/ ctx[119].display !== void 0) {
	    		checkbox_props.label = /*option*/ ctx[119].display;
	    	}

	    	if (/*option*/ ctx[119].selected !== void 0) {
	    		checkbox_props.value = /*option*/ ctx[119].selected;
	    	}

	    	checkbox = new CheckBox({ props: checkbox_props });
	    	binding_callbacks.push(() => bind(checkbox, "label", checkbox_label_binding));
	    	binding_callbacks.push(() => bind(checkbox, "value", checkbox_value_binding));
	    	let if_block = /*option*/ ctx[119].details && create_if_block_6$2(ctx);

	    	return {
	    		c() {
	    			create_component(checkbox.$$.fragment);
	    			t = space();
	    			if (if_block) if_block.c();
	    			if_block_anchor = empty();
	    		},
	    		m(target, anchor) {
	    			mount_component(checkbox, target, anchor);
	    			insert(target, t, anchor);
	    			if (if_block) if_block.m(target, anchor);
	    			insert(target, if_block_anchor, anchor);
	    			current = true;
	    		},
	    		p(new_ctx, dirty) {
	    			ctx = new_ctx;
	    			const checkbox_changes = {};
	    			if (dirty[0] & /*_theme*/ 2097152) checkbox_changes.theme = /*_theme*/ ctx[21];

	    			if (!updating_label && dirty[1] & /*_virtualOptions*/ 128) {
	    				updating_label = true;
	    				checkbox_changes.label = /*option*/ ctx[119].display;
	    				add_flush_callback(() => updating_label = false);
	    			}

	    			if (!updating_value && dirty[1] & /*_virtualOptions*/ 128) {
	    				updating_value = true;
	    				checkbox_changes.value = /*option*/ ctx[119].selected;
	    				add_flush_callback(() => updating_value = false);
	    			}

	    			checkbox.$set(checkbox_changes);

	    			if (/*option*/ ctx[119].details) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);
	    				} else {
	    					if_block = create_if_block_6$2(ctx);
	    					if_block.c();
	    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
	    				}
	    			} else if (if_block) {
	    				if_block.d(1);
	    				if_block = null;
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(checkbox.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(checkbox.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			destroy_component(checkbox, detaching);
	    			if (detaching) detach(t);
	    			if (if_block) if_block.d(detaching);
	    			if (detaching) detach(if_block_anchor);
	    		}
	    	};
	    }

	    // (87:20) {:else}
	    function create_else_block_2$1(ctx) {
	    	let t_value = /*option*/ ctx[119].display + "";
	    	let t;

	    	return {
	    		c() {
	    			t = text(t_value);
	    		},
	    		m(target, anchor) {
	    			insert(target, t, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_virtualOptions*/ 128 && t_value !== (t_value = /*option*/ ctx[119].display + "")) set_data(t, t_value);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(t);
	    		}
	    	};
	    }

	    // (85:20) {#if option.displayHtml}
	    function create_if_block_8$1(ctx) {
	    	let html_tag;
	    	let raw_value = /*option*/ ctx[119].displayHtml + "";
	    	let html_anchor;

	    	return {
	    		c() {
	    			html_anchor = empty();
	    			html_tag = new HtmlTag(html_anchor);
	    		},
	    		m(target, anchor) {
	    			html_tag.m(raw_value, target, anchor);
	    			insert(target, html_anchor, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_virtualOptions*/ 128 && raw_value !== (raw_value = /*option*/ ctx[119].displayHtml + "")) html_tag.p(raw_value);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(html_anchor);
	    			if (detaching) html_tag.d();
	    		}
	    	};
	    }

	    // (91:18) {#if option.details}
	    function create_if_block_7$2(ctx) {
	    	let div;
	    	let t_value = /*option*/ ctx[119].details + "";
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(t_value);
	    			attr(div, "class", "pros-option-details svelte-1c84wsf");
	    			attr(div, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_virtualOptions*/ 128 && t_value !== (t_value = /*option*/ ctx[119].details + "")) set_data(t, t_value);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (78:20) {#if option.details}
	    function create_if_block_6$2(ctx) {
	    	let div;
	    	let t_value = /*option*/ ctx[119].details + "";
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(t_value);
	    			attr(div, "class", "pros-option-details svelte-1c84wsf");
	    			attr(div, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_virtualOptions*/ 128 && t_value !== (t_value = /*option*/ ctx[119].details + "")) set_data(t, t_value);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (74:16) {#each _virtualOptions as option}
	    function create_each_block$5(ctx) {
	    	let div;
	    	let current_block_type_index;
	    	let if_block;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	const if_block_creators = [create_if_block_5$2, create_else_block_1$1];
	    	const if_blocks = [];

	    	function select_block_type_1(ctx, dirty) {
	    		if (/*multiple*/ ctx[2]) return 0;
	    		return 1;
	    	}

	    	current_block_type_index = select_block_type_1(ctx);
	    	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	    	function click_handler(...args) {
	    		return /*click_handler*/ ctx[101](/*option*/ ctx[119], ...args);
	    	}

	    	function mouseenter_handler(...args) {
	    		return /*mouseenter_handler*/ ctx[102](/*option*/ ctx[119], ...args);
	    	}

	    	function mouseleave_handler(...args) {
	    		return /*mouseleave_handler*/ ctx[103](/*option*/ ctx[119], ...args);
	    	}

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-option-row svelte-1c84wsf");
	    			toggle_class(div, "selected", /*isOptionSelected*/ ctx[53](/*option*/ ctx[119]));
	    			toggle_class(div, "highlight", /*_searchOptions*/ ctx[12].indexOf(/*option*/ ctx[119]) === /*_highlightIndex*/ ctx[13]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_blocks[current_block_type_index].m(div, null);
	    			current = true;

	    			if (!mounted) {
	    				dispose = [
	    					listen(div, "click", click_handler),
	    					listen(div, "mouseenter", mouseenter_handler),
	    					listen(div, "mouseleave", mouseleave_handler),
	    					listen(div, "mouseleaveon:mousedown", preventClickPropagation$1),
	    					listen(div, "mouseup", preventClickPropagation$1)
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(new_ctx, dirty) {
	    			ctx = new_ctx;
	    			let previous_block_index = current_block_type_index;
	    			current_block_type_index = select_block_type_1(ctx);

	    			if (current_block_type_index === previous_block_index) {
	    				if_blocks[current_block_type_index].p(ctx, dirty);
	    			} else {
	    				group_outros();

	    				transition_out(if_blocks[previous_block_index], 1, 1, () => {
	    					if_blocks[previous_block_index] = null;
	    				});

	    				check_outros();
	    				if_block = if_blocks[current_block_type_index];

	    				if (!if_block) {
	    					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	    					if_block.c();
	    				} else {
	    					if_block.p(ctx, dirty);
	    				}

	    				transition_in(if_block, 1);
	    				if_block.m(div, null);
	    			}

	    			if (dirty[1] & /*isOptionSelected, _virtualOptions*/ 4194432) {
	    				toggle_class(div, "selected", /*isOptionSelected*/ ctx[53](/*option*/ ctx[119]));
	    			}

	    			if (dirty[0] & /*_searchOptions, _highlightIndex*/ 12288 | dirty[1] & /*_virtualOptions*/ 128) {
	    				toggle_class(div, "highlight", /*_searchOptions*/ ctx[12].indexOf(/*option*/ ctx[119]) === /*_highlightIndex*/ ctx[13]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_blocks[current_block_type_index].d();
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (99:16) {#if _virtualOptions.length === 0}
	    function create_if_block_4$4(ctx) {
	    	let div;
	    	let t_value = /*$_*/ ctx[51]("noValues") + "";
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(t_value);
	    			attr(div, "class", "pros-empty-row svelte-1c84wsf");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*$_*/ 1048576 && t_value !== (t_value = /*$_*/ ctx[51]("noValues") + "")) set_data(t, t_value);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (112:4) {#if display !== 'custom'}
	    function create_if_block$c(ctx) {
	    	let div;

	    	function select_block_type_3(ctx, dirty) {
	    		if (/*_dirty*/ ctx[8] && /*_errors*/ ctx[9].length > 0) return create_if_block_1$8;
	    		if (/*hint*/ ctx[5] && /*_showOptions*/ ctx[10]) return create_if_block_2$7;
	    		return create_else_block$5;
	    	}

	    	let current_block_type = select_block_type_3(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-message-container svelte-1c84wsf");
	    			toggle_class(div, "error", /*_dirty*/ ctx[8] && /*_errors*/ ctx[9].length > 0);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, dirty) {
	    			if (current_block_type === (current_block_type = select_block_type_3(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 768) {
	    				toggle_class(div, "error", /*_dirty*/ ctx[8] && /*_errors*/ ctx[9].length > 0);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    // (128:6) {:else}
	    function create_else_block$5(ctx) {
	    	let div;

	    	return {
	    		c() {
	    			div = element("div");
	    			attr(div, "id", /*_messageId*/ ctx[47]);
	    			attr(div, "class", "pros-message svelte-1c84wsf");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_messageId*/ 65536) {
	    				attr(div, "id", /*_messageId*/ ctx[47]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (121:37) 
	    function create_if_block_2$7(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(/*hint*/ ctx[5]);
	    			attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1c84wsf");
	    			attr(div0, "id", /*_statusIconId*/ ctx[48]);
	    			attr(div0, "class", "pros-status-icon svelte-1c84wsf");
	    			attr(div1, "id", /*_messageId*/ ctx[47]);
	    			attr(div1, "class", "pros-message svelte-1c84wsf");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_statusIconId*/ 131072) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[48]);
	    			}

	    			if (dirty[0] & /*hint*/ 32) set_data(t1, /*hint*/ ctx[5]);

	    			if (dirty[1] & /*_messageId*/ 65536) {
	    				attr(div1, "id", /*_messageId*/ ctx[47]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    // (114:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$8(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1_value = /*_errors*/ ctx[9][0] + "";
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(t1_value);
	    			attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1c84wsf");
	    			attr(div0, "id", /*_statusIconId*/ ctx[48]);
	    			attr(div0, "class", "pros-status-icon error svelte-1c84wsf");
	    			attr(div1, "id", /*_messageId*/ ctx[47]);
	    			attr(div1, "class", "pros-message error svelte-1c84wsf");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_statusIconId*/ 131072) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[48]);
	    			}

	    			if (dirty[0] & /*_errors*/ 512 && t1_value !== (t1_value = /*_errors*/ ctx[9][0] + "")) set_data(t1, t1_value);

	    			if (dirty[1] & /*_messageId*/ 65536) {
	    				attr(div1, "id", /*_messageId*/ ctx[47]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    function create_fragment$f(ctx) {
	    	let div5;
	    	let div4;
	    	let t0;
	    	let div3;
	    	let div2;
	    	let div0;
	    	let t1;
	    	let t2;
	    	let div1;
	    	let svg;
	    	let path;
	    	let t3;
	    	let t4;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*_hasLabel*/ ctx[50] && create_if_block_14(ctx);

	    	function select_block_type(ctx, dirty) {
	    		if (/*_displayHtml*/ ctx[14]) return create_if_block_11;
	    		if (/*_display*/ ctx[3]) return create_if_block_12;
	    		if (/*placeholder*/ ctx[24]) return create_if_block_13;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block1 = current_block_type && current_block_type(ctx);
	    	let if_block2 = /*_showClear*/ ctx[49] && create_if_block_10$1(ctx);
	    	let if_block3 = /*_showOptions*/ ctx[10] && !/*disabled*/ ctx[1] && create_if_block_3$4(ctx);
	    	let if_block4 = /*display*/ ctx[4] !== "custom" && create_if_block$c(ctx);

	    	return {
	    		c() {
	    			div5 = element("div");
	    			div4 = element("div");
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div3 = element("div");
	    			div2 = element("div");
	    			div0 = element("div");
	    			if (if_block1) if_block1.c();
	    			t1 = space();
	    			if (if_block2) if_block2.c();
	    			t2 = space();
	    			div1 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t3 = space();
	    			if (if_block3) if_block3.c();
	    			t4 = space();
	    			if (if_block4) if_block4.c();
	    			attr(div0, "class", "pros-input-container svelte-1c84wsf");
	    			attr(path, "d", "M12.5 17C12.3721 17 12.2441 16.9512 12.1465 16.8535L4.14648 8.85352C3.95117 8.6582 3.95117 8.3418 4.14648 8.14648C4.3418 7.95117 4.6582 7.95117 4.85352 8.14648L12.5 15.793L20.1465 8.14648C20.3418 7.95117 20.6582 7.95117 20.8535 8.14648C21.0488 8.3418 21.0488 8.6582 20.8535 8.85352L12.8535 16.8535C12.7559 16.9512 12.6279 17 12.5 17Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1c84wsf");
	    			attr(div1, "id", /*_capId*/ ctx[44]);
	    			attr(div1, "class", "pros-end-cap svelte-1c84wsf");
	    			attr(div1, "disabled", /*disabled*/ ctx[1]);
	    			attr(div2, "class", "pros-content-container svelte-1c84wsf");
	    			attr(div3, "id", /*_inputId*/ ctx[42]);
	    			attr(div3, "class", "pros-highlight-container svelte-1c84wsf");
	    			attr(div3, "tabindex", "0");
	    			toggle_class(div3, "open", /*_showOptions*/ ctx[10]);
	    			toggle_class(div3, "upward", /*_upward*/ ctx[15]);
	    			toggle_class(div3, "downward", !/*_upward*/ ctx[15]);
	    			attr(div4, "class", "pros-control-container svelte-1c84wsf");
	    			toggle_class(div4, "has-value", /*_hasValue*/ ctx[36]);
	    			toggle_class(div4, "has-label", /*_hasLabel*/ ctx[50]);
	    			toggle_class(div4, "has-focus", /*_hasFocus*/ ctx[17] && !/*_showOptions*/ ctx[10]);
	    			toggle_class(div4, "custom-layout", /*display*/ ctx[4] === "custom");
	    			toggle_class(div4, "error", /*_dirty*/ ctx[8] && /*_errors*/ ctx[9].length > 0);
	    			toggle_class(div4, "disabled", /*disabled*/ ctx[1]);
	    			toggle_class(div4, "allow-hover", !/*disabled*/ ctx[1] && !/*_showOptions*/ ctx[10]);
	    			attr(div5, "class", "pros-global-wrapper pros-form-control svelte-1c84wsf");
	    			attr(div5, "pos--theme", /*_theme*/ ctx[21]);
	    			attr(div5, "pos--shape", /*_shape*/ ctx[22]);
	    			attr(div5, "pos--density", /*_density*/ ctx[23]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div5, anchor);
	    			append(div5, div4);
	    			if (if_block0) if_block0.m(div4, null);
	    			append(div4, t0);
	    			append(div4, div3);
	    			append(div3, div2);
	    			append(div2, div0);
	    			if (if_block1) if_block1.m(div0, null);
	    			append(div2, t1);
	    			if (if_block2) if_block2.m(div2, null);
	    			append(div2, t2);
	    			append(div2, div1);
	    			append(div1, svg);
	    			append(svg, path);
	    			append(div3, t3);
	    			if (if_block3) if_block3.m(div3, null);
	    			/*div3_binding*/ ctx[108](div3);
	    			append(div4, t4);
	    			if (if_block4) if_block4.m(div4, null);
	    			current = true;

	    			if (!mounted) {
	    				dispose = [
	    					listen(div3, "mouseup", /*handleMouseUp*/ ctx[55]),
	    					listen(div3, "mousedown", /*handleMouseDown*/ ctx[54]),
	    					listen(div3, "click", /*handleClick*/ ctx[33]),
	    					listen(div3, "keydown", /*handleKeyDown*/ ctx[32]),
	    					listen(div3, "focus", /*handleFocus*/ ctx[30]),
	    					listen(div3, "focusout", /*handleBlur*/ ctx[31])
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasLabel*/ ctx[50]) {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);
	    				} else {
	    					if_block0 = create_if_block_14(ctx);
	    					if_block0.c();
	    					if_block0.m(div4, t0);
	    				}
	    			} else if (if_block0) {
	    				if_block0.d(1);
	    				if_block0 = null;
	    			}

	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) {
	    				if_block1.p(ctx, dirty);
	    			} else {
	    				if (if_block1) if_block1.d(1);
	    				if_block1 = current_block_type && current_block_type(ctx);

	    				if (if_block1) {
	    					if_block1.c();
	    					if_block1.m(div0, null);
	    				}
	    			}

	    			if (/*_showClear*/ ctx[49]) {
	    				if (if_block2) {
	    					if_block2.p(ctx, dirty);
	    				} else {
	    					if_block2 = create_if_block_10$1(ctx);
	    					if_block2.c();
	    					if_block2.m(div2, t2);
	    				}
	    			} else if (if_block2) {
	    				if_block2.d(1);
	    				if_block2 = null;
	    			}

	    			if (!current || dirty[1] & /*_capId*/ 8192) {
	    				attr(div1, "id", /*_capId*/ ctx[44]);
	    			}

	    			if (!current || dirty[0] & /*disabled*/ 2) {
	    				attr(div1, "disabled", /*disabled*/ ctx[1]);
	    			}

	    			if (/*_showOptions*/ ctx[10] && !/*disabled*/ ctx[1]) {
	    				if (if_block3) {
	    					if_block3.p(ctx, dirty);

	    					if (dirty[0] & /*_showOptions, disabled*/ 1026) {
	    						transition_in(if_block3, 1);
	    					}
	    				} else {
	    					if_block3 = create_if_block_3$4(ctx);
	    					if_block3.c();
	    					transition_in(if_block3, 1);
	    					if_block3.m(div3, null);
	    				}
	    			} else if (if_block3) {
	    				group_outros();

	    				transition_out(if_block3, 1, 1, () => {
	    					if_block3 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!current || dirty[1] & /*_inputId*/ 2048) {
	    				attr(div3, "id", /*_inputId*/ ctx[42]);
	    			}

	    			if (dirty[0] & /*_showOptions*/ 1024) {
	    				toggle_class(div3, "open", /*_showOptions*/ ctx[10]);
	    			}

	    			if (dirty[0] & /*_upward*/ 32768) {
	    				toggle_class(div3, "upward", /*_upward*/ ctx[15]);
	    			}

	    			if (dirty[0] & /*_upward*/ 32768) {
	    				toggle_class(div3, "downward", !/*_upward*/ ctx[15]);
	    			}

	    			if (/*display*/ ctx[4] !== "custom") {
	    				if (if_block4) {
	    					if_block4.p(ctx, dirty);
	    				} else {
	    					if_block4 = create_if_block$c(ctx);
	    					if_block4.c();
	    					if_block4.m(div4, null);
	    				}
	    			} else if (if_block4) {
	    				if_block4.d(1);
	    				if_block4 = null;
	    			}

	    			if (dirty[1] & /*_hasValue*/ 32) {
	    				toggle_class(div4, "has-value", /*_hasValue*/ ctx[36]);
	    			}

	    			if (dirty[1] & /*_hasLabel*/ 524288) {
	    				toggle_class(div4, "has-label", /*_hasLabel*/ ctx[50]);
	    			}

	    			if (dirty[0] & /*_hasFocus, _showOptions*/ 132096) {
	    				toggle_class(div4, "has-focus", /*_hasFocus*/ ctx[17] && !/*_showOptions*/ ctx[10]);
	    			}

	    			if (dirty[0] & /*display*/ 16) {
	    				toggle_class(div4, "custom-layout", /*display*/ ctx[4] === "custom");
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 768) {
	    				toggle_class(div4, "error", /*_dirty*/ ctx[8] && /*_errors*/ ctx[9].length > 0);
	    			}

	    			if (dirty[0] & /*disabled*/ 2) {
	    				toggle_class(div4, "disabled", /*disabled*/ ctx[1]);
	    			}

	    			if (dirty[0] & /*disabled, _showOptions*/ 1026) {
	    				toggle_class(div4, "allow-hover", !/*disabled*/ ctx[1] && !/*_showOptions*/ ctx[10]);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 2097152) {
	    				attr(div5, "pos--theme", /*_theme*/ ctx[21]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 4194304) {
	    				attr(div5, "pos--shape", /*_shape*/ ctx[22]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 8388608) {
	    				attr(div5, "pos--density", /*_density*/ ctx[23]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block3);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block3);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div5);
	    			if (if_block0) if_block0.d();

	    			if (if_block1) {
	    				if_block1.d();
	    			}

	    			if (if_block2) if_block2.d();
	    			if (if_block3) if_block3.d();
	    			/*div3_binding*/ ctx[108](null);
	    			if (if_block4) if_block4.d();
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    const OPTION_ROW_HEIGHT = 40;
	    const OPTION_SPACE_BETWEEN = 4;
	    const VIRTUAL_ITEM_COUNT = 20;

	    function preventClickPropagation$1(event) {
	    	event.stopPropagation();
	    	event.preventDefault();
	    }

	    function notEmpty$1(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$f($$self, $$props, $$invalidate) {
	    	let _showClear;
	    	let _hasValue;
	    	let _hasLabel;
	    	let $_;
	    	component_subscribe($$self, X, $$value => $$invalidate(51, $_ = $$value));
	    	const dispatch = createEventDispatcher();
	    	const _handleOptionsScrollDebounce = debounce(handleOptionScroll, 200, { maxWait: 500, trailing: true });
	    	let { globalClickListener = null } = $$props;
	    	let { globalKeyListener = null } = $$props;
	    	let { display = "form" } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	    	let { theme = "auto" } = $$props; // Color theme (auto/dark/light)
	    	let { shape = "round" } = $$props; // Shape style (round/sharp)
	    	let { density = "standard" } = $$props; // Density style (standard/high)
	    	let { value = undefined } = $$props; // Current value of control
	    	let { label = "" } = $$props; // Control label
	    	let { placeholder = "" } = $$props; // Placeholder text to display in text box when no value
	    	let { hint = "" } = $$props; // Hint/Helper text to display when no validation errors to display
	    	let { search = false } = $$props; // Allow options to be searched
	    	let { clear = false } = $$props; // Allow value to be cleared
	    	let { required = false } = $$props; // Is value required to be valid?
	    	let { disabled = false } = $$props; // Is Control disabled?
	    	let { validation = true } = $$props; // Do we include built in validation?
	    	let { errors = [] } = $$props; // Custom external validation errors
	    	let { options = [] } = $$props; // Options to choose from
	    	let { multiple = false } = $$props; // Allow multi-selection
	    	let { idKey = null } = $$props;
	    	let { valuePath } = $$props;
	    	let { id = null } = $$props;
	    	let { _dirty = false } = $$props; // Has the user changed the value (yes = dirty)
	    	let { _errors = [] } = $$props; // Combined validation errors
	    	let { _builtInErrors = [] } = $$props; // Built in validation errors
	    	let { _showOptions = false } = $$props; // Is Selector visible?
	    	let { _searchText = null } = $$props; // Current user search text
	    	let { _searchOptions = [] } = $$props; // Current set of options matching _searchText
	    	let { _highlightIndex = 0 } = $$props; // Index of option user currently has highlighted
	    	let { _globalClicksNode = null } = $$props; // Active Global clicks node for selecting in list
	    	let { _lastValue } = $$props; // Last control value so we can filter out extra change events and normalize programmatic changes
	    	let { _display } = $$props; // String to display based on selection
	    	let { _displayHtml } = $$props; // String to display based on selection
	    	let { _openNode = undefined } = $$props;
	    	let { _openParent = undefined } = $$props;
	    	let { _upward = false } = $$props;
	    	let { _positioned = false } = $$props;
	    	let { _hasFocus = false } = $$props;
	    	let { _highlightElement } = $$props;
	    	let { _searchElement } = $$props;
	    	let { _optionsWrapper } = $$props;
	    	let { _suppressFocus } = $$props;
	    	let { _lastValid } = $$props;
	    	let { _themeEventListener } = $$props;
	    	let { _shapeEventListener } = $$props;
	    	let { _densityEventListener } = $$props;
	    	let { _theme } = $$props;
	    	let { _shape } = $$props;
	    	let { _density } = $$props;
	    	let { _lastTheme } = $$props;
	    	let { _lastShape } = $$props;
	    	let { _lastDensity } = $$props;
	    	let { _lastSearchText } = $$props;
	    	let { _options = [] } = $$props;
	    	let { _lastOptions = [] } = $$props;
	    	let { _isNullValid = false } = $$props;
	    	let _virtualContainer;
	    	let _virtualOptions = [];
	    	let _optionListContainer;
	    	let _optionsScrollContainer;
	    	let _viewportTop = 0;
	    	let _mouseOverOption = false;
	    	let _labelId = null;
	    	let _inputId = null;
	    	let _clearId = null;
	    	let _capId = null;
	    	let _optionsId = null;
	    	let _optionsSearchId = null;
	    	let _messageId = null;
	    	let _statusIconId = null;

	    	// onCreate
	    	onMount(() => {
	    		doValidate();
	    	});

	    	onDestroy(() => {
	    		if (_showOptions) {
	    			closeOptions();
	    		}

	    		if (_themeEventListener) {
	    			window.removeEventListener("posh-theme-changed", _themeEventListener);
	    		}

	    		if (_shapeEventListener) {
	    			window.removeEventListener("posh-shape-changed", _shapeEventListener);
	    		}

	    		if (_densityEventListener) {
	    			window.removeEventListener("posh-density-changed", _densityEventListener);
	    			window.removeEventListener("posh-density-changed", _densityEventListener);
	    		}
	    	});

	    	beforeUpdate(() => {
	    		// Normalize external changes
	    		$$invalidate(2, multiple = notEmpty$1(multiple) ? multiple : false);

	    		$$invalidate(4, display = notEmpty$1(display) ? display : "form");
	    		$$invalidate(64, theme = notEmpty$1(theme) ? theme : "light");
	    		$$invalidate(65, shape = notEmpty$1(shape) ? shape : "round");
	    		$$invalidate(66, density = notEmpty$1(density) ? density : "standard");
	    		$$invalidate(0, label = notEmpty$1(label) ? label : "");
	    		$$invalidate(5, hint = notEmpty$1(hint) ? hint : "");
	    		$$invalidate(7, required = notEmpty$1(required) ? required : false);
	    		$$invalidate(1, disabled = notEmpty$1(disabled) ? disabled : false);
	    		$$invalidate(58, clear = notEmpty$1(clear) ? clear : false);
	    		$$invalidate(6, search = notEmpty$1(search) ? search : false);
	    		$$invalidate(67, validation = notEmpty$1(validation) ? validation : true);
	    		$$invalidate(41, _labelId = hasValue(id) ? `${id}-label` : undefined);
	    		$$invalidate(42, _inputId = hasValue(id) ? `${id}-input` : undefined);
	    		$$invalidate(43, _clearId = hasValue(id) ? `${id}-clear` : undefined);
	    		$$invalidate(44, _capId = hasValue(id) ? `${id}-cap` : undefined);
	    		$$invalidate(45, _optionsId = hasValue(id) ? `${id}-options` : undefined);
	    		$$invalidate(46, _optionsSearchId = hasValue(id) ? `${id}-options-search-input` : undefined);
	    		$$invalidate(47, _messageId = hasValue(id) ? `${id}-message` : undefined);
	    		$$invalidate(48, _statusIconId = hasValue(id) ? `${id}-status-icon` : undefined);

	    		if (multiple) {
	    			$$invalidate(57, value = hasValue(value) && Array.isArray(value) ? value : []);
	    		} else {
	    			$$invalidate(57, value = hasValue(value) ? value : undefined);
	    		}

	    		if (theme !== _lastTheme) {
	    			$$invalidate(77, _lastTheme = theme);

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(21, _theme = themeAttribute ? themeAttribute : "light");

	    				if (!_themeEventListener) {
	    					// Only start listening once
	    					$$invalidate(74, _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	    						if (theme === "auto") {
	    							$$invalidate(21, _theme = event.detail.theme);
	    						}
	    					}));
	    				}
	    			} else {
	    				$$invalidate(21, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			$$invalidate(78, _lastShape = shape);

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(22, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					$$invalidate(75, _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(22, _shape = event.detail.shape);
	    						}
	    					}));
	    				}
	    			} else {
	    				$$invalidate(22, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			$$invalidate(79, _lastDensity = density);

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(23, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					$$invalidate(76, _densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(23, _density = event.detail.density);
	    						}
	    					}));
	    				}
	    			} else {
	    				$$invalidate(23, _density = density);
	    			}
	    		}

	    		// handleSearchChanged();
	    		doValidate.call(this);
	    	});

	    	function updateDisplay() {
	    		$$invalidate(3, _display = "");

	    		if (multiple) {
	    			if (value && value.length > 0) {
	    				let _selectedOptions = _options.filter(o => {
	    					return o.selected;
	    				});

	    				$$invalidate(3, _display = _selectedOptions.map(o => {
	    					return o.display;
	    				}).join(", "));
	    			}
	    		} else {
	    			if (notEmpty$1(valuePath)) {
	    				let found = _options.find(o => {
	    					return get$1(o.value, valuePath) === get$1(value, valuePath);
	    				});

	    				$$invalidate(14, _displayHtml = found ? found.displayHtml : null);
	    				$$invalidate(3, _display = found ? found.display : null);
	    			} else {
	    				let found = _options.find(o => {
	    					if (idKey) {
	    						return value ? o.value[idKey] === value[idKey] : false;
	    					} else {
	    						return o.value === value;
	    					}
	    				});

	    				$$invalidate(14, _displayHtml = found ? found.displayHtml : null);
	    				$$invalidate(3, _display = found ? found.display : null);
	    			}
	    		}
	    	}

	    	function isOptionSelected(option) {
	    		if (multiple) {
	    			return;
	    		}

	    		if (valuePath) {
	    			return value && get$1(value, valuePath) === get$1(option.value, valuePath);
	    		} else {
	    			return value && value === option.value;
	    		}
	    	}

	    	function isSameValue(value1, value2) {
	    		if (!hasValue(value1) && !hasValue(value2)) {
	    			return true;
	    		}

	    		if (idKey) {
	    			return value1[idKey] === value2[idKey];
	    		}

	    		if (hasValue(value1) && !hasValue(value2) || !hasValue(value1) && hasValue(value2)) {
	    			return false;
	    		}

	    		if (multiple) {
	    			let array1 = Array.isArray(value1) ? value1 : [value1];
	    			let array2 = Array.isArray(value2) ? value2 : [value2];

	    			if (value1.length !== value2.length) {
	    				return false;
	    			}

	    			if (valuePath) {
	    				array1 = value1.map(v => {
	    					return v[valuePath];
	    				});

	    				array2 = value2.map(v => {
	    					return v[valuePath];
	    				});
	    			}

	    			let sameValues = true;

	    			array1.forEach(v => {
	    				if (!array2.includes(v)) {
	    					sameValues = false;
	    				}
	    			});

	    			return sameValues;
	    		} else {
	    			let test1 = valuePath ? value1[valuePath] : value1;
	    			let test2 = valuePath ? value2[valuePath] : value2;
	    			return test1 === test2;
	    		}
	    	}

	    	function isSameOptions(array1, array2) {
	    		if (array1.length !== array2.length) {
	    			// console.log('Detected difference - length', array1, array2);
	    			return false;
	    		}

	    		for (let i = 0; i < array1.length; i++) {
	    			const isObject1 = typeof array1[i].value === "object" && typeof array1[i] !== null;
	    			const isObject2 = typeof array2[i].value === "object" && typeof array2[i] !== null;

	    			if (isObject1 !== isObject2) {
	    				// console.log('Detected difference - type', isObject1, isObject2);
	    				return false;
	    			}

	    			if (array1[i].display !== array2[i].display) {
	    				// console.log('Detected difference - display', array1[i], array2[i]);
	    				return false;
	    			}

	    			if (array1[i].details !== array2[i].details) {
	    				// console.log('Detected difference - display', array1[i], array2[i]);
	    				return false;
	    			}

	    			if (isObject1 && valuePath && get$1(array1[i], valuePath) !== get$1(array2[i], valuePath)) {
	    				// console.log('Detected difference - valuePath', array1[i].value, array2[i].value);
	    				return false;
	    			}

	    			if (!isObject1 && array1[i].value !== array2[i].value) {
	    				// console.log('Detected difference - value', array1[i].value, array2[i].value);
	    				return false;
	    			}
	    		}

	    		return true;
	    	}

	    	function globalClicks(node) {
	    		// console.log('globalClicks');
	    		$$invalidate(69, _globalClicksNode = node);

	    		$$invalidate(62, globalClickListener = event => {
	    			// event.preventDefault();
	    			event.stopPropagation();

	    			let elements = [node];

	    			// Change NodeList to Array to use some()
	    			elements = Array.prototype.slice.call(elements);

	    			let containsClick = elements.some(element => {
	    				return element.contains(event.target);
	    			});

	    			if (!containsClick) {
	    				// console.log('SB: globalClicks: close Options');
	    				closeOptions(true);
	    			}
	    		});

	    		$$invalidate(63, globalKeyListener = event => {
	    			myKeyDown.call(this, event);
	    		});

	    		// Necessary to prevent handling click that opens panel
	    		setTimeout(() => {
	    			document.addEventListener("click", globalClickListener);
	    			document.addEventListener("keydown", globalKeyListener);
	    		}); // let searchBox = node.querySelector('.pros-search-input');
	    		//
	    		// if (searchBox) {
	    		//   searchBox.focus();
	    	} // }

	    	function positionOptions(node) {
	    		// console.log('positionOptions');
	    		$$invalidate(70, _openNode = node);

	    		$$invalidate(71, _openParent = node.parentElement);

	    		// console.log('positionOptions', _openNode, _openParent);
	    		// Reparent options to end of DOM so it is on top
	    		// We reparent options back when options are closed
	    		document.body.appendChild(node);

	    		setTimeout(positionNode);
	    		document.addEventListener("wheel", handleScroll);
	    		window.addEventListener("scroll", handleScroll, true);
	    		window.addEventListener("resize", handleScroll);

	    		return {
	    			destroy() {
	    				// console.log('Remove option listeners - positionOptions')
	    				document.removeEventListener("wheel", handleScroll);

	    				window.removeEventListener("scroll", handleScroll);
	    				window.removeEventListener("resize", handleScroll);
	    			}
	    		};
	    	}

	    	function positionNode(event) {
	    		// console.log('positionNode');
	    		if (!_openParent) {
	    			return;
	    		}

	    		let adjustedTop;
	    		let bodyRect = document.body.getBoundingClientRect();
	    		let rect = _openParent.getBoundingClientRect();
	    		$$invalidate(15, _upward = false);

	    		if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	    			$$invalidate(15, _upward = true);

	    			adjustedTop = rect.top >= _openNode.offsetHeight
	    			? `${rect.top - _openNode.offsetHeight}px`
	    			: `0px`;
	    		}

	    		if (event) {
	    			let scrollTop = event.target.scrollTop;
	    			let scrollBottom = scrollTop + event.target.clientHeight;

	    			if (_openParent.offsetParent.offsetTop < scrollTop) {
	    				adjustedTop = 0 + "px";
	    			}

	    			if (_openParent.offsetParent.offsetTop > scrollBottom) {
	    				adjustedTop = `${rect.top - _openNode.offsetHeight}px`;
	    			}
	    		}

	    		$$invalidate(70, _openNode.style.left = `${rect.left}px`, _openNode);
	    		$$invalidate(70, _openNode.style.top = adjustedTop ? adjustedTop : `${rect.bottom}px`, _openNode);
	    		$$invalidate(70, _openNode.style.width = `${rect.width}px`, _openNode);

	    		if (!_positioned) {
	    			// Let DOM update with new position before showing
	    			setTimeout(() => {
	    				// console.log('set options visible');
	    				$$invalidate(16, _positioned = true);

	    				// Let DOM update with visible options before doing work in options panel
	    				setTimeout(() => {
	    					// console.log('set focus - positionNode');
	    					handleSearchChanged();

	    					handleOptionScroll();
	    					scrollToSelected();

	    					if (search && _searchElement) {
	    						_searchElement.focus();
	    					}
	    				});
	    			});
	    		}
	    	} //setTimeout(positionNode, 10);

	    	function handleScroll(event) {
	    		// console.log('handleScroll');
	    		let isOptionScroll = false;

	    		let test = event.target;

	    		while (test) {
	    			if (test.id === "pros-options-container") {
	    				isOptionScroll = true;
	    				break;
	    			}

	    			test = test.parentElement;
	    		}

	    		if (!isOptionScroll) {
	    			// console.log('reposition Options due to scroll');
	    			positionNode(event);
	    		}
	    	}

	    	function closeOptions(keepFocus = false) {
	    		// console.log('closeOptions', keepFocus);
	    		// Re-parent options
	    		if (_openParent) {
	    			_openParent.appendChild(_openNode);
	    		}

	    		$$invalidate(70, _openNode = undefined);
	    		$$invalidate(71, _openParent = undefined);
	    		$$invalidate(12, _searchOptions = _options);
	    		$$invalidate(11, _searchText = null);
	    		$$invalidate(13, _highlightIndex = 0);

	    		if (globalClickListener) {
	    			document.removeEventListener("click", globalClickListener);
	    			$$invalidate(62, globalClickListener = null);
	    		}

	    		if (globalKeyListener) {
	    			document.removeEventListener("keydown", globalKeyListener);
	    			$$invalidate(63, globalKeyListener = null);
	    		}

	    		if (keepFocus) {
	    			// console.log('SB: closeOptions:focus Highlight')
	    			setTimeout(() => {
	    				_highlightElement.focus();
	    			});
	    		}

	    		$$invalidate(16, _positioned = false);
	    		$$invalidate(10, _showOptions = false);
	    	}

	    	function openOptions(event) {
	    		//console.log('openOptions');
	    		_highlightElement.focus();

	    		$$invalidate(10, _showOptions = true);
	    	}

	    	function myKeyDown(event) {
	    		// console.log('Key Down - Global', event);
	    		switch (event.key) {
	    			case "Enter":
	    				// console.log('SB: myKeyDown:Enter');
	    				event.stopPropagation();
	    				if (_showOptions) {
	    					let selectedOption = _searchOptions.find(option => {
	    						return option.value === value;
	    					});

	    					let selectedIndex = _searchOptions.indexOf(selectedOption);

	    					if (multiple) {
	    						toggleOption(_searchOptions[_highlightIndex]);
	    					} else {
	    						if (_highlightIndex !== selectedIndex) {
	    							toggleOption(_searchOptions[_highlightIndex]);
	    						}
	    					}
	    				} else {
	    					openOptions();
	    				}
	    				break;
	    			case "Escape":
	    				console.log("SB: myKeyDown:Escape");
	    				if (_showOptions) {
	    					event.stopPropagation();
	    					event.preventDefault();
	    					closeOptions(true);
	    				} else {
	    					_highlightElement.blur();
	    				}
	    				break;
	    			case "ArrowDown":
	    				// console.log('SB: myKeyDown:ArrowDown');
	    				event.stopPropagation();
	    				event.preventDefault();
	    				if (_showOptions && !_mouseOverOption) {
	    					if (_highlightIndex < _searchOptions.length - 1) {
	    						$$invalidate(13, _highlightIndex++, _highlightIndex);
	    					}

	    					scrollOptionIntoView.call(this, _highlightIndex);
	    				}
	    				break;
	    			case "ArrowUp":
	    				// console.log('SB: myKeyDown:ArrowUp');
	    				event.stopPropagation();
	    				event.preventDefault();
	    				if (_showOptions && !_mouseOverOption) {
	    					if (_highlightIndex > 0) {
	    						$$invalidate(13, _highlightIndex--, _highlightIndex);
	    					}

	    					scrollOptionIntoView.call(this, _highlightIndex);
	    				}
	    				break;
	    		}
	    	}

	    	function handleMouseEnterOption(option) {
	    		_mouseOverOption = true;
	    		$$invalidate(13, _highlightIndex = _searchOptions.indexOf(option));
	    	}

	    	function handleMouseLeaveOption() {
	    		_mouseOverOption = false;
	    	}

	    	function handleFocus(event) {
	    		if (!_suppressFocus) {
	    			$$invalidate(17, _hasFocus = true);
	    		} // console.log('SB: handleFocus');
	    	}

	    	function handleBlur(event) {
	    		if (!_showOptions) {
	    			// console.log('SB: handleBlur:SetFocus');
	    			$$invalidate(17, _hasFocus = false);
	    		} // console.log(`handleBlur`, event);
	    		// closeOptions(false)
	    	}

	    	function handleKeyDown(event) {
	    		// console.log('Key Down - Container', event);
	    		if (_showOptions || event.isComposing || event.keyCode === 229) {
	    			return;
	    		}

	    		switch (event.key) {
	    			case "Shift":
	    			case "Alt":
	    			case "Ctrl":
	    			case "Tab":
	    				return;
	    			case "Enter":
	    			case "ArrowDown":
	    			case " ":
	    				// console.log('SB: handleKeyDown:' + event.key);
	    				event.stopPropagation();
	    				event.preventDefault();
	    				openOptions();
	    				break;
	    			case "Escape":
	    				// console.log('SB: handleKeyDown:Escape');
	    				_highlightElement.blur();
	    				break;
	    			default:
	    				event.stopPropagation();
	    				event.preventDefault();
	    				if (search) {
	    					if ([...event.key].length === 1) {
	    						let char = String.fromCharCode(event.keyCode);

	    						if (!event.shiftKey) {
	    							char = char.toLocaleLowerCase();
	    						}

	    						$$invalidate(11, _searchText = "" + char);

	    						setTimeout(
	    							() => {
	    								handleSearchChanged();
	    							},
	    							10
	    						);

	    						openOptions();
	    					}
	    				}
	    		}
	    	}

	    	function handleClick(event) {
	    		if (disabled) {
	    			return;
	    		}

	    		if (_showOptions) {
	    			// console.log('SB: handleClick:Close');
	    			closeOptions(true);
	    		} else {
	    			// event.stopPropagation();
	    			// event.preventDefault();
	    			// console.log('SB: handleClick:Open');
	    			openOptions();
	    		}
	    	}

	    	function handleMouseDown(event) {
	    		$$invalidate(72, _suppressFocus = true);
	    	}

	    	function handleMouseUp(event) {
	    		$$invalidate(72, _suppressFocus = false);
	    	}

	    	function handleClear(event) {
	    		event.stopPropagation();
	    		event.preventDefault();
	    		$$invalidate(57, value = multiple ? [] : undefined);

	    		_options.forEach(o => {
	    			o.selected = false;
	    		});

	    		$$invalidate(12, _searchOptions = _options);
	    		valueChanged.call(this);
	    	}

	    	function handleOptionClicked(option, event) {
	    		// event.stopPropagation();
	    		// event.preventDefault();
	    		if (multiple) {
	    			handleSelectionChanged();
	    			return;
	    		}

	    		_options.forEach(o => {
	    			o.selected = false;
	    		});

	    		option.selected = !option.selected;
	    		handleSelectionChanged(option);
	    	}

	    	function toggleOption(option) {
	    		option.selected = !option.selected;
	    		handleSelectionChanged(option);
	    	}

	    	function handleSelectionChanged(option, event) {
	    		if (notEmpty$1(event)) {
	    			event.preventDefault();
	    			event.stopPropagation();
	    		}

	    		if (multiple) {
	    			let selectedOptions = _options.filter(o => {
	    				return o.selected;
	    			});

	    			$$invalidate(57, value = selectedOptions.map(o => {
	    				return o.value;
	    			}));
	    		} else {
	    			// console.log('SB: handleSelectionChanged: Close Options');
	    			$$invalidate(57, value = option.value);

	    			closeOptions(true);
	    		}

	    		valueChanged.call(this);
	    	}

	    	function scrollToSelected() {
	    		const found = _searchOptions.find(o => {
	    			return isOptionSelected(o);
	    		});

	    		if (found) {
	    			$$invalidate(13, _highlightIndex = _searchOptions.indexOf(found));
	    			const scrollTo = _highlightIndex * OPTION_ROW_HEIGHT;
	    			$$invalidate(40, _optionsScrollContainer.scrollTop = scrollTo, _optionsScrollContainer);
	    		}

	    		setTimeout(
	    			() => {
	    				handleOptionScroll();
	    			},
	    			10
	    		);
	    	}

	    	function scrollOptionIntoView(index) {
	    		if (!_globalClicksNode) {
	    			return;
	    		}

	    		const targetTop = index * OPTION_ROW_HEIGHT;
	    		const targetBottom = targetTop + OPTION_ROW_HEIGHT;
	    		const currentTop = _optionsScrollContainer.scrollTop;
	    		const currentBottom = currentTop + _optionsScrollContainer.offsetHeight;

	    		if (targetTop < currentTop) {
	    			_optionsScrollContainer.scrollTo({
	    				top: targetTop,
	    				left: 0,
	    				behavior: "smooth"
	    			});
	    		}

	    		if (targetBottom > currentBottom) {
	    			_optionsScrollContainer.scrollTo({
	    				top: targetBottom - _optionsScrollContainer.offsetHeight,
	    				left: 0,
	    				behavior: "smooth"
	    			});
	    		}
	    	}

	    	function handleOptionScroll(event) {
	    		if (!_optionsScrollContainer) {
	    			return;
	    		}

	    		const scrollTop = _optionsScrollContainer.scrollTop;

	    		// If we have no items account for 'No Items' message which takes space of 1 item
	    		const filteredCount = _searchOptions.length > 0 ? _searchOptions.length : 1;

	    		// Calculate the virtual container height
	    		const virtualHeight = filteredCount * OPTION_ROW_HEIGHT - OPTION_SPACE_BETWEEN;

	    		$$invalidate(37, _virtualContainer.style.height = `${virtualHeight}px`, _virtualContainer);

	    		// Height of the virtual view port that we absolute position
	    		const viewPortHeight = VIRTUAL_ITEM_COUNT * OPTION_ROW_HEIGHT;

	    		if (virtualHeight <= viewPortHeight) {
	    			$$invalidate(38, _virtualOptions = _searchOptions);
	    			return;
	    		}

	    		if (_virtualOptions.length === 0 || scrollTop < _viewportTop + viewPortHeight / 4 || scrollTop > _viewportTop + viewPortHeight - viewPortHeight / 4) {
	    			// Need to reset view port
	    			let itemIndex = Math.floor(scrollTop / OPTION_ROW_HEIGHT) - VIRTUAL_ITEM_COUNT / 2;

	    			if (itemIndex < 0) {
	    				itemIndex = 0;
	    			}

	    			if (itemIndex > _searchOptions.length - VIRTUAL_ITEM_COUNT) {
	    				itemIndex = _searchOptions.length - VIRTUAL_ITEM_COUNT;
	    			}

	    			$$invalidate(38, _virtualOptions = [..._searchOptions].splice(itemIndex, VIRTUAL_ITEM_COUNT));
	    			_viewportTop = itemIndex * OPTION_ROW_HEIGHT;
	    			$$invalidate(39, _optionListContainer.style.top = `${_viewportTop}px`, _optionListContainer);
	    		}
	    	}

	    	function handleSearchChanged(event) {
	    		$$invalidate(13, _highlightIndex = 0);

	    		if (_searchText === undefined || _searchText === null || _searchText === "") {
	    			$$invalidate(12, _searchOptions = _options);
	    			$$invalidate(80, _lastSearchText = null);
	    		} else {
	    			let myText = _searchText.toLocaleLowerCase();

	    			if (myText !== _lastSearchText) {
	    				$$invalidate(80, _lastSearchText = myText);

	    				$$invalidate(12, _searchOptions = _options.filter(option => {
	    					return option.display.toLocaleLowerCase().includes(myText) || option.details && option.details.toLocaleLowerCase().includes(myText);
	    				}));
	    			}
	    		}

	    		if (_optionsScrollContainer) {
	    			$$invalidate(40, _optionsScrollContainer.scrollTop = 0, _optionsScrollContainer);
	    		}

	    		setTimeout(
	    			() => {
	    				positionNode();
	    				handleOptionScroll();
	    			},
	    			10
	    		);
	    	}

	    	function handleClearSearch(event) {
	    		event.stopPropagation();
	    		_searchElement.focus();
	    		$$invalidate(12, _searchOptions = _options);
	    		$$invalidate(11, _searchText = null);
	    	}

	    	// Others
	    	function valueChanged() {
	    		$$invalidate(8, _dirty = true);
	    		$$invalidate(59, _lastValue = value);
	    		doValidate.call(this);

	    		window.setTimeout(() => {
	    			dispatch("changed", value);
	    		});
	    	}

	    	function doValidate() {
	    		$$invalidate(68, _builtInErrors = []);
	    		$$invalidate(9, _errors = errors ? errors : []);

	    		if (required) {
	    			if (multiple) {
	    				if (value.length === 0) {
	    					_builtInErrors.push($_("validateRequired"));
	    				}
	    			} else {
	    				if (!hasValue(value)) {
	    					_builtInErrors.push($_("validateRequired"));
	    				}
	    			}
	    		}

	    		if (validation) {
	    			$$invalidate(9, _errors = _errors.concat(_builtInErrors));
	    		}

	    		window.setTimeout(() => {
	    			let valid = _errors.length === 0;

	    			if (_lastValid !== valid) {
	    				$$invalidate(73, _lastValid = valid);
	    				dispatch("valid", valid);

	    				if (multiple) {
	    					if (value.length > 0 && !valid && !_dirty) {
	    						$$invalidate(8, _dirty = true);
	    					}
	    				} else {
	    					if (hasValue(value) && !valid && !_dirty) {
	    						$$invalidate(8, _dirty = true);
	    					}
	    				}
	    			}
	    		});
	    	}

	    	function hasValue(test) {
	    		if (test === undefined) {
	    			return false;
	    		}

	    		return _isNullValid ? true : test !== null;
	    	}

	    	function textbox_value_binding(value) {
	    		_searchText = value;
	    		$$invalidate(11, _searchText);
	    	}

	    	function textbox_inputElement_binding(value) {
	    		_searchElement = value;
	    		$$invalidate(19, _searchElement);
	    	}

	    	function checkbox_label_binding(value, option) {
	    		if ($$self.$$.not_equal(option.display, value)) {
	    			option.display = value;
	    			$$invalidate(38, _virtualOptions);
	    		}
	    	}

	    	function checkbox_value_binding(value, option) {
	    		if ($$self.$$.not_equal(option.selected, value)) {
	    			option.selected = value;
	    			$$invalidate(38, _virtualOptions);
	    		}
	    	}

	    	const click_handler = (option, event) => handleOptionClicked(option);
	    	const mouseenter_handler = (option, event) => handleMouseEnterOption(option);
	    	const mouseleave_handler = (option, event) => handleMouseLeaveOption();

	    	function div0_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_optionListContainer = $$value;
	    			$$invalidate(39, _optionListContainer);
	    		});
	    	}

	    	function div1_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_virtualContainer = $$value;
	    			$$invalidate(37, _virtualContainer);
	    		});
	    	}

	    	function div2_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_optionsScrollContainer = $$value;
	    			$$invalidate(40, _optionsScrollContainer);
	    		});
	    	}

	    	function div4_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_optionsWrapper = $$value;
	    			$$invalidate(20, _optionsWrapper);
	    		});
	    	}

	    	function div3_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_highlightElement = $$value;
	    			$$invalidate(18, _highlightElement);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("globalClickListener" in $$props) $$invalidate(62, globalClickListener = $$props.globalClickListener);
	    		if ("globalKeyListener" in $$props) $$invalidate(63, globalKeyListener = $$props.globalKeyListener);
	    		if ("display" in $$props) $$invalidate(4, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(64, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(65, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(66, density = $$props.density);
	    		if ("value" in $$props) $$invalidate(57, value = $$props.value);
	    		if ("label" in $$props) $$invalidate(0, label = $$props.label);
	    		if ("placeholder" in $$props) $$invalidate(24, placeholder = $$props.placeholder);
	    		if ("hint" in $$props) $$invalidate(5, hint = $$props.hint);
	    		if ("search" in $$props) $$invalidate(6, search = $$props.search);
	    		if ("clear" in $$props) $$invalidate(58, clear = $$props.clear);
	    		if ("required" in $$props) $$invalidate(7, required = $$props.required);
	    		if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
	    		if ("validation" in $$props) $$invalidate(67, validation = $$props.validation);
	    		if ("errors" in $$props) $$invalidate(82, errors = $$props.errors);
	    		if ("options" in $$props) $$invalidate(83, options = $$props.options);
	    		if ("multiple" in $$props) $$invalidate(2, multiple = $$props.multiple);
	    		if ("idKey" in $$props) $$invalidate(84, idKey = $$props.idKey);
	    		if ("valuePath" in $$props) $$invalidate(85, valuePath = $$props.valuePath);
	    		if ("id" in $$props) $$invalidate(86, id = $$props.id);
	    		if ("_dirty" in $$props) $$invalidate(8, _dirty = $$props._dirty);
	    		if ("_errors" in $$props) $$invalidate(9, _errors = $$props._errors);
	    		if ("_builtInErrors" in $$props) $$invalidate(68, _builtInErrors = $$props._builtInErrors);
	    		if ("_showOptions" in $$props) $$invalidate(10, _showOptions = $$props._showOptions);
	    		if ("_searchText" in $$props) $$invalidate(11, _searchText = $$props._searchText);
	    		if ("_searchOptions" in $$props) $$invalidate(12, _searchOptions = $$props._searchOptions);
	    		if ("_highlightIndex" in $$props) $$invalidate(13, _highlightIndex = $$props._highlightIndex);
	    		if ("_globalClicksNode" in $$props) $$invalidate(69, _globalClicksNode = $$props._globalClicksNode);
	    		if ("_lastValue" in $$props) $$invalidate(59, _lastValue = $$props._lastValue);
	    		if ("_display" in $$props) $$invalidate(3, _display = $$props._display);
	    		if ("_displayHtml" in $$props) $$invalidate(14, _displayHtml = $$props._displayHtml);
	    		if ("_openNode" in $$props) $$invalidate(70, _openNode = $$props._openNode);
	    		if ("_openParent" in $$props) $$invalidate(71, _openParent = $$props._openParent);
	    		if ("_upward" in $$props) $$invalidate(15, _upward = $$props._upward);
	    		if ("_positioned" in $$props) $$invalidate(16, _positioned = $$props._positioned);
	    		if ("_hasFocus" in $$props) $$invalidate(17, _hasFocus = $$props._hasFocus);
	    		if ("_highlightElement" in $$props) $$invalidate(18, _highlightElement = $$props._highlightElement);
	    		if ("_searchElement" in $$props) $$invalidate(19, _searchElement = $$props._searchElement);
	    		if ("_optionsWrapper" in $$props) $$invalidate(20, _optionsWrapper = $$props._optionsWrapper);
	    		if ("_suppressFocus" in $$props) $$invalidate(72, _suppressFocus = $$props._suppressFocus);
	    		if ("_lastValid" in $$props) $$invalidate(73, _lastValid = $$props._lastValid);
	    		if ("_themeEventListener" in $$props) $$invalidate(74, _themeEventListener = $$props._themeEventListener);
	    		if ("_shapeEventListener" in $$props) $$invalidate(75, _shapeEventListener = $$props._shapeEventListener);
	    		if ("_densityEventListener" in $$props) $$invalidate(76, _densityEventListener = $$props._densityEventListener);
	    		if ("_theme" in $$props) $$invalidate(21, _theme = $$props._theme);
	    		if ("_shape" in $$props) $$invalidate(22, _shape = $$props._shape);
	    		if ("_density" in $$props) $$invalidate(23, _density = $$props._density);
	    		if ("_lastTheme" in $$props) $$invalidate(77, _lastTheme = $$props._lastTheme);
	    		if ("_lastShape" in $$props) $$invalidate(78, _lastShape = $$props._lastShape);
	    		if ("_lastDensity" in $$props) $$invalidate(79, _lastDensity = $$props._lastDensity);
	    		if ("_lastSearchText" in $$props) $$invalidate(80, _lastSearchText = $$props._lastSearchText);
	    		if ("_options" in $$props) $$invalidate(60, _options = $$props._options);
	    		if ("_lastOptions" in $$props) $$invalidate(61, _lastOptions = $$props._lastOptions);
	    		if ("_isNullValid" in $$props) $$invalidate(81, _isNullValid = $$props._isNullValid);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty[0] & /*multiple*/ 4 | $$self.$$.dirty[1] & /*_lastOptions, _options, value, _lastValue*/ 1946157056 | $$self.$$.dirty[2] & /*options, valuePath*/ 10485760) {
	    			// Computed values
	    			{
	    				if (options) {
	    					// Detect changes to options from the outside
	    					if (!isSameOptions(options, _lastOptions)) {
	    						// console.log('SelectBox: Updating options', options);
	    						$$invalidate(61, _lastOptions = options);

	    						$$invalidate(60, _options = []);

	    						options.forEach(o => {
	    							_options.push(Object.assign({}, o));
	    						});

	    						$$invalidate(81, _isNullValid = !!options.find(o => {
	    							return o.value === null;
	    						}));
	    					}

	    					$$invalidate(12, _searchOptions = _options);

	    					setTimeout(
	    						() => {
	    							handleOptionScroll();
	    						},
	    						10
	    					);
	    				}

	    				if (!isSameValue(value, _lastValue)) {
	    					$$invalidate(59, _lastValue = value);

	    					if (multiple) {
	    						_options.forEach(o => {
	    							delete o.selected;
	    						});

	    						if (value && value.length > 0) {
	    							value.forEach(v => {
	    								let found = _options.find(o => {
	    									const value1 = valuePath ? o.value[valuePath] : o.value;
	    									const value2 = valuePath ? v[valuePath] : v;
	    									return value1 === value2;
	    								});

	    								if (found) {
	    									found.selected = true;
	    								}
	    							});
	    						}
	    					}
	    				}

	    				updateDisplay();
	    			}
	    		}

	    		if ($$self.$$.dirty[0] & /*multiple, _display*/ 12 | $$self.$$.dirty[1] & /*value*/ 67108864) {
	    			$$invalidate(36, _hasValue = multiple
	    			? hasValue(value) && value.length > 0
	    			: hasValue(value) || _display);
	    		}

	    		if ($$self.$$.dirty[0] & /*disabled*/ 2 | $$self.$$.dirty[1] & /*clear, _hasValue*/ 134217760) {
	    			$$invalidate(49, _showClear = clear && !disabled && _hasValue);
	    		}

	    		if ($$self.$$.dirty[0] & /*label*/ 1) {
	    			$$invalidate(50, _hasLabel = notEmpty$1(label) && label.trim() !== "");
	    		}
	    	};

	    	return [
	    		label,
	    		disabled,
	    		multiple,
	    		_display,
	    		display,
	    		hint,
	    		search,
	    		required,
	    		_dirty,
	    		_errors,
	    		_showOptions,
	    		_searchText,
	    		_searchOptions,
	    		_highlightIndex,
	    		_displayHtml,
	    		_upward,
	    		_positioned,
	    		_hasFocus,
	    		_highlightElement,
	    		_searchElement,
	    		_optionsWrapper,
	    		_theme,
	    		_shape,
	    		_density,
	    		placeholder,
	    		globalClicks,
	    		positionOptions,
	    		preventClickPropagation$1,
	    		handleMouseEnterOption,
	    		handleMouseLeaveOption,
	    		handleFocus,
	    		handleBlur,
	    		handleKeyDown,
	    		handleClick,
	    		handleClear,
	    		handleSearchChanged,
	    		_hasValue,
	    		_virtualContainer,
	    		_virtualOptions,
	    		_optionListContainer,
	    		_optionsScrollContainer,
	    		_labelId,
	    		_inputId,
	    		_clearId,
	    		_capId,
	    		_optionsId,
	    		_optionsSearchId,
	    		_messageId,
	    		_statusIconId,
	    		_showClear,
	    		_hasLabel,
	    		$_,
	    		_handleOptionsScrollDebounce,
	    		isOptionSelected,
	    		handleMouseDown,
	    		handleMouseUp,
	    		handleOptionClicked,
	    		value,
	    		clear,
	    		_lastValue,
	    		_options,
	    		_lastOptions,
	    		globalClickListener,
	    		globalKeyListener,
	    		theme,
	    		shape,
	    		density,
	    		validation,
	    		_builtInErrors,
	    		_globalClicksNode,
	    		_openNode,
	    		_openParent,
	    		_suppressFocus,
	    		_lastValid,
	    		_themeEventListener,
	    		_shapeEventListener,
	    		_densityEventListener,
	    		_lastTheme,
	    		_lastShape,
	    		_lastDensity,
	    		_lastSearchText,
	    		_isNullValid,
	    		errors,
	    		options,
	    		idKey,
	    		valuePath,
	    		id,
	    		positionNode,
	    		handleScroll,
	    		closeOptions,
	    		openOptions,
	    		myKeyDown,
	    		handleSelectionChanged,
	    		scrollToSelected,
	    		scrollOptionIntoView,
	    		handleOptionScroll,
	    		handleClearSearch,
	    		textbox_value_binding,
	    		textbox_inputElement_binding,
	    		checkbox_label_binding,
	    		checkbox_value_binding,
	    		click_handler,
	    		mouseenter_handler,
	    		mouseleave_handler,
	    		div0_binding,
	    		div1_binding,
	    		div2_binding,
	    		div4_binding,
	    		div3_binding
	    	];
	    }

	    class SelectBox extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document_1$4.getElementById("svelte-1c84wsf-style")) add_css$f();

	    		init(
	    			this,
	    			options,
	    			instance$f,
	    			create_fragment$f,
	    			safe_not_equal,
	    			{
	    				globalClickListener: 62,
	    				globalKeyListener: 63,
	    				display: 4,
	    				theme: 64,
	    				shape: 65,
	    				density: 66,
	    				value: 57,
	    				label: 0,
	    				placeholder: 24,
	    				hint: 5,
	    				search: 6,
	    				clear: 58,
	    				required: 7,
	    				disabled: 1,
	    				validation: 67,
	    				errors: 82,
	    				options: 83,
	    				multiple: 2,
	    				idKey: 84,
	    				valuePath: 85,
	    				id: 86,
	    				_dirty: 8,
	    				_errors: 9,
	    				_builtInErrors: 68,
	    				_showOptions: 10,
	    				_searchText: 11,
	    				_searchOptions: 12,
	    				_highlightIndex: 13,
	    				_globalClicksNode: 69,
	    				_lastValue: 59,
	    				_display: 3,
	    				_displayHtml: 14,
	    				_openNode: 70,
	    				_openParent: 71,
	    				_upward: 15,
	    				_positioned: 16,
	    				_hasFocus: 17,
	    				_highlightElement: 18,
	    				_searchElement: 19,
	    				_optionsWrapper: 20,
	    				_suppressFocus: 72,
	    				_lastValid: 73,
	    				_themeEventListener: 74,
	    				_shapeEventListener: 75,
	    				_densityEventListener: 76,
	    				_theme: 21,
	    				_shape: 22,
	    				_density: 23,
	    				_lastTheme: 77,
	    				_lastShape: 78,
	    				_lastDensity: 79,
	    				_lastSearchText: 80,
	    				_options: 60,
	    				_lastOptions: 61,
	    				_isNullValid: 81,
	    				globalClicks: 25,
	    				positionOptions: 26,
	    				positionNode: 87,
	    				handleScroll: 88,
	    				preventClickPropagation: 27,
	    				closeOptions: 89,
	    				openOptions: 90,
	    				myKeyDown: 91,
	    				handleMouseEnterOption: 28,
	    				handleMouseLeaveOption: 29,
	    				handleFocus: 30,
	    				handleBlur: 31,
	    				handleKeyDown: 32,
	    				handleClick: 33,
	    				handleClear: 34,
	    				handleSelectionChanged: 92,
	    				scrollToSelected: 93,
	    				scrollOptionIntoView: 94,
	    				handleOptionScroll: 95,
	    				handleSearchChanged: 35,
	    				handleClearSearch: 96
	    			},
	    			[-1, -1, -1, -1]
	    		);
	    	}

	    	get globalClicks() {
	    		return this.$$.ctx[25];
	    	}

	    	get positionOptions() {
	    		return this.$$.ctx[26];
	    	}

	    	get positionNode() {
	    		return this.$$.ctx[87];
	    	}

	    	get handleScroll() {
	    		return this.$$.ctx[88];
	    	}

	    	get preventClickPropagation() {
	    		return preventClickPropagation$1;
	    	}

	    	get closeOptions() {
	    		return this.$$.ctx[89];
	    	}

	    	get openOptions() {
	    		return this.$$.ctx[90];
	    	}

	    	get myKeyDown() {
	    		return this.$$.ctx[91];
	    	}

	    	get handleMouseEnterOption() {
	    		return this.$$.ctx[28];
	    	}

	    	get handleMouseLeaveOption() {
	    		return this.$$.ctx[29];
	    	}

	    	get handleFocus() {
	    		return this.$$.ctx[30];
	    	}

	    	get handleBlur() {
	    		return this.$$.ctx[31];
	    	}

	    	get handleKeyDown() {
	    		return this.$$.ctx[32];
	    	}

	    	get handleClick() {
	    		return this.$$.ctx[33];
	    	}

	    	get handleClear() {
	    		return this.$$.ctx[34];
	    	}

	    	get handleSelectionChanged() {
	    		return this.$$.ctx[92];
	    	}

	    	get scrollToSelected() {
	    		return this.$$.ctx[93];
	    	}

	    	get scrollOptionIntoView() {
	    		return this.$$.ctx[94];
	    	}

	    	get handleOptionScroll() {
	    		return this.$$.ctx[95];
	    	}

	    	get handleSearchChanged() {
	    		return this.$$.ctx[35];
	    	}

	    	get handleClearSearch() {
	    		return this.$$.ctx[96];
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/forms/src/TextBox.svelte generated by Svelte v3.38.2 */

	    const { document: document_1$3 } = globals;

	    function add_css$e() {
	    	var style = element("style");
	    	style.id = "svelte-1wnlerg-style";
	    	style.textContent = ".pros-highlight-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1wnlerg .pros-input.svelte-1wnlerg{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-1wnlerg .pros-input.svelte-1wnlerg{padding-top:18px}.pros-control-container.has-label.svelte-1wnlerg input.svelte-1wnlerg::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-1wnlerg.svelte-1wnlerg{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1wnlerg.svelte-1wnlerg::after{content:\" *\"}.pros-action-button.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-1wnlerg svg.svelte-1wnlerg{width:24px;height:24px}.pros-action-button.svelte-1wnlerg.svelte-1wnlerg:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-1wnlerg.svelte-1wnlerg{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-control-container.svelte-1wnlerg.svelte-1wnlerg{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1wnlerg .pros-control-label.svelte-1wnlerg,.pros-control-container.has-focus.svelte-1wnlerg .pros-control-label.svelte-1wnlerg{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1wnlerg .pros-highlight-container.svelte-1wnlerg{cursor:default}.pros-control-container.has-focus.svelte-1wnlerg .pros-input.svelte-1wnlerg{cursor:text}.pros-control-container.has-focus.svelte-1wnlerg .pros-highlight-container.svelte-1wnlerg{border-width:2px}.pros-control-container.has-focus.svelte-1wnlerg .pros-input-container.svelte-1wnlerg{margin-left:11px}.pros-control-container.has-focus.svelte-1wnlerg .pros-end-cap.svelte-1wnlerg:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-1wnlerg input.svelte-1wnlerg::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1wnlerg .pros-status-icon.svelte-1wnlerg{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1wnlerg .pros-status-icon svg.svelte-1wnlerg{height:100%;width:100%}.pros-message-container.svelte-1wnlerg .pros-message.svelte-1wnlerg{flex:1}.pros-spinner-container.svelte-1wnlerg.svelte-1wnlerg{padding:16px}.pros-options-wrapper.svelte-1wnlerg.svelte-1wnlerg{position:fixed;display:none;max-width:100%;border-width:1px;border-style:solid;box-sizing:border-box;z-index:1001;overflow:hidden}.pros-options-wrapper.open.svelte-1wnlerg.svelte-1wnlerg{display:inherit}.pros-options-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%}.pros-options-container.svelte-1wnlerg .pros-options.svelte-1wnlerg{width:100%;overflow:auto;max-height:160px;padding:8px;box-sizing:border-box}.pros-options-container.svelte-1wnlerg .pros-options .pros-option-list .pros-option-row.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;cursor:pointer;padding:6px 8px}.pros-options-container.svelte-1wnlerg .pros-options .pros-option-list .pros-option-row.svelte-1wnlerg:not(:last-of-type){margin-bottom:4px}.pros-options-container.svelte-1wnlerg .svelte-1wnlerg::-webkit-scrollbar{width:6px;height:6px}.pros-options-container.svelte-1wnlerg .svelte-1wnlerg::-webkit-scrollbar-track{background-color:transparent}.pros-options-container.svelte-1wnlerg .svelte-1wnlerg::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:6px}.pros-global-wrapper[pos--shape=sharp].svelte-1wnlerg .pros-highlight-container.svelte-1wnlerg{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-control-label.svelte-1wnlerg{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-highlight-container.svelte-1wnlerg{height:36px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1wnlerg{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-input-container .pros-input.svelte-1wnlerg{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-label .pros-input.svelte-1wnlerg{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-value .pros-control-label.svelte-1wnlerg,.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-focus .pros-control-label.svelte-1wnlerg{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1wnlerg{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-focus .pros-input-container.svelte-1wnlerg{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.svelte-1wnlerg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-highlight-container.svelte-1wnlerg{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-input.svelte-1wnlerg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container input.svelte-1wnlerg::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.allow-hover .pros-highlight-container.svelte-1wnlerg:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.error .pros-highlight-container.svelte-1wnlerg{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.svelte-1wnlerg{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-end-cap.svelte-1wnlerg{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container.svelte-1wnlerg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container .pros-status-icon.svelte-1wnlerg{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container.error.svelte-1wnlerg{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1wnlerg{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled.svelte-1wnlerg{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-highlight-container.svelte-1wnlerg{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-input.svelte-1wnlerg{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-message-container.svelte-1wnlerg{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-end-cap.svelte-1wnlerg{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-action-button.svelte-1wnlerg:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.svelte-1wnlerg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-highlight-container.svelte-1wnlerg{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-input.svelte-1wnlerg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container input.svelte-1wnlerg::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.allow-hover .pros-highlight-container.svelte-1wnlerg:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.error .pros-highlight-container.svelte-1wnlerg{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.svelte-1wnlerg{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container.svelte-1wnlerg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container .pros-status-icon.svelte-1wnlerg{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container.error.svelte-1wnlerg{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1wnlerg{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled.svelte-1wnlerg{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled .pros-highlight-container.svelte-1wnlerg{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled .pros-input.svelte-1wnlerg{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled .pros-message-container.svelte-1wnlerg{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-action-button.svelte-1wnlerg:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.svelte-1wnlerg{border-color:#ffffff !important;background-color:#ffffff !important}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.downward.svelte-1wnlerg{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.upward.svelte-1wnlerg{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.svelte-1wnlerg{border-color:#2b2b2b !important;background-color:#2b2b2b !important}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.downward.svelte-1wnlerg{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.upward.svelte-1wnlerg{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px}.pros-options-wrapper[pos--theme=light].svelte-1wnlerg.svelte-1wnlerg{background-color:#FFFFFF;color:#363636;border-color:transparent}.pros-options-wrapper[pos--theme=light].downward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0 16px 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px;border-top:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].upward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0 -16px 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1wnlerg .pros-options-container .pros-options .pros-option-row.svelte-1wnlerg:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1wnlerg.svelte-1wnlerg{background-color:#2b2b2b;color:#ffffff;border-color:transparent}.pros-options-wrapper[pos--theme=dark].downward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px;border-top:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].upward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1wnlerg .pros-options-container .pros-options .pros-option-row.svelte-1wnlerg{color:#ffffff}.pros-options-wrapper[pos--theme=dark].svelte-1wnlerg .pros-options-container .pros-options .pros-option-row.svelte-1wnlerg:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}";
	    	append(document_1$3.head, style);
	    }

	    function get_each_context$4(ctx, list, i) {
	    	const child_ctx = ctx.slice();
	    	child_ctx[91] = list[i];
	    	return child_ctx;
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_10(ctx) {
	    	let div;
	    	let t;

	    	return {
	    		c() {
	    			div = element("div");
	    			t = text(/*label*/ ctx[1]);
	    			attr(div, "id", /*_labelId*/ ctx[35]);
	    			attr(div, "class", "pros-control-label svelte-1wnlerg");
	    			attr(div, "pros-tooltip", "");
	    			toggle_class(div, "required", /*required*/ ctx[8]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*label*/ 2) set_data(t, /*label*/ ctx[1]);

	    			if (dirty[1] & /*_labelId*/ 16) {
	    				attr(div, "id", /*_labelId*/ ctx[35]);
	    			}

	    			if (dirty[0] & /*required*/ 256) {
	    				toggle_class(div, "required", /*required*/ ctx[8]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (42:10) {:else}
	    function create_else_block_2(ctx) {
	    	let input;
	    	let mounted;
	    	let dispose;

	    	return {
	    		c() {
	    			input = element("input");
	    			attr(input, "id", /*_inputId*/ ctx[36]);
	    			attr(input, "type", "text");
	    			attr(input, "class", "pros-input svelte-1wnlerg");
	    			input.disabled = /*disabled*/ ctx[9];
	    			attr(input, "placeholder", /*placeholder*/ ctx[11]);
	    			attr(input, "autocomplete", /*autocomplete*/ ctx[10]);
	    		},
	    		m(target, anchor) {
	    			insert(target, input, anchor);
	    			set_input_value(input, /*_untrimmedValue*/ ctx[23]);
	    			/*input_binding_1*/ ctx[69](input);

	    			if (!mounted) {
	    				dispose = [
	    					listen(input, "input", /*input_input_handler_1*/ ctx[68]),
	    					listen(input, "input", /*valueChanged*/ ctx[47]),
	    					listen(input, "focus", /*handleFocus*/ ctx[13]),
	    					listen(input, "blur", /*handleBlur*/ ctx[14])
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_inputId*/ 32) {
	    				attr(input, "id", /*_inputId*/ ctx[36]);
	    			}

	    			if (dirty[0] & /*disabled*/ 512) {
	    				input.disabled = /*disabled*/ ctx[9];
	    			}

	    			if (dirty[0] & /*placeholder*/ 2048) {
	    				attr(input, "placeholder", /*placeholder*/ ctx[11]);
	    			}

	    			if (dirty[0] & /*autocomplete*/ 1024) {
	    				attr(input, "autocomplete", /*autocomplete*/ ctx[10]);
	    			}

	    			if (dirty[0] & /*_untrimmedValue*/ 8388608 && input.value !== /*_untrimmedValue*/ ctx[23]) {
	    				set_input_value(input, /*_untrimmedValue*/ ctx[23]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(input);
	    			/*input_binding_1*/ ctx[69](null);
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (28:10) {#if password}
	    function create_if_block_9(ctx) {
	    	let input;
	    	let mounted;
	    	let dispose;

	    	return {
	    		c() {
	    			input = element("input");
	    			attr(input, "id", /*_inputId*/ ctx[36]);
	    			attr(input, "type", "password");
	    			attr(input, "class", "pros-input svelte-1wnlerg");
	    			input.disabled = /*disabled*/ ctx[9];
	    			attr(input, "placeholder", /*placeholder*/ ctx[11]);
	    			attr(input, "autocomplete", /*_autocomplete*/ ctx[34]);
	    		},
	    		m(target, anchor) {
	    			insert(target, input, anchor);
	    			set_input_value(input, /*_untrimmedValue*/ ctx[23]);
	    			/*input_binding*/ ctx[67](input);

	    			if (!mounted) {
	    				dispose = [
	    					listen(input, "input", /*input_input_handler*/ ctx[66]),
	    					listen(input, "input", /*valueChanged*/ ctx[47]),
	    					listen(input, "focus", /*handleFocus*/ ctx[13]),
	    					listen(input, "blur", /*handleBlur*/ ctx[14])
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_inputId*/ 32) {
	    				attr(input, "id", /*_inputId*/ ctx[36]);
	    			}

	    			if (dirty[0] & /*disabled*/ 512) {
	    				input.disabled = /*disabled*/ ctx[9];
	    			}

	    			if (dirty[0] & /*placeholder*/ 2048) {
	    				attr(input, "placeholder", /*placeholder*/ ctx[11]);
	    			}

	    			if (dirty[1] & /*_autocomplete*/ 8) {
	    				attr(input, "autocomplete", /*_autocomplete*/ ctx[34]);
	    			}

	    			if (dirty[0] & /*_untrimmedValue*/ 8388608 && input.value !== /*_untrimmedValue*/ ctx[23]) {
	    				set_input_value(input, /*_untrimmedValue*/ ctx[23]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(input);
	    			/*input_binding*/ ctx[67](null);
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (58:8) {#if _hasValue && !disabled && _hasFocus}
	    function create_if_block_8(ctx) {
	    	let div;
	    	let svg;
	    	let path;
	    	let mounted;
	    	let dispose;

	    	return {
	    		c() {
	    			div = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1wnlerg");
	    			attr(div, "id", /*_clearId*/ ctx[37]);
	    			attr(div, "class", "pros-action-button svelte-1wnlerg");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, svg);
	    			append(svg, path);

	    			if (!mounted) {
	    				dispose = listen(div, "mousedown", /*handleClear*/ ctx[17]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_clearId*/ 64) {
	    				attr(div, "id", /*_clearId*/ ctx[37]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (65:8) {#if iconName || iconPath || iconUrl}
	    function create_if_block_7$1(ctx) {
	    	let div;
	    	let icon;
	    	let updating_name;
	    	let updating_path;
	    	let updating_url;
	    	let current;

	    	function icon_name_binding(value) {
	    		/*icon_name_binding*/ ctx[70](value);
	    	}

	    	function icon_path_binding(value) {
	    		/*icon_path_binding*/ ctx[71](value);
	    	}

	    	function icon_url_binding(value) {
	    		/*icon_url_binding*/ ctx[72](value);
	    	}

	    	let icon_props = {
	    		id: /*_capId*/ ctx[38],
	    		theme: /*_theme*/ ctx[28]
	    	};

	    	if (/*iconName*/ ctx[5] !== void 0) {
	    		icon_props.name = /*iconName*/ ctx[5];
	    	}

	    	if (/*iconPath*/ ctx[6] !== void 0) {
	    		icon_props.path = /*iconPath*/ ctx[6];
	    	}

	    	if (/*iconUrl*/ ctx[7] !== void 0) {
	    		icon_props.url = /*iconUrl*/ ctx[7];
	    	}

	    	icon = new Icon({ props: icon_props });
	    	binding_callbacks.push(() => bind(icon, "name", icon_name_binding));
	    	binding_callbacks.push(() => bind(icon, "path", icon_path_binding));
	    	binding_callbacks.push(() => bind(icon, "url", icon_url_binding));

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(icon.$$.fragment);
	    			attr(div, "class", "pros-end-cap svelte-1wnlerg");
	    			attr(div, "disabled", /*disabled*/ ctx[9]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(icon, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const icon_changes = {};
	    			if (dirty[1] & /*_capId*/ 128) icon_changes.id = /*_capId*/ ctx[38];
	    			if (dirty[0] & /*_theme*/ 268435456) icon_changes.theme = /*_theme*/ ctx[28];

	    			if (!updating_name && dirty[0] & /*iconName*/ 32) {
	    				updating_name = true;
	    				icon_changes.name = /*iconName*/ ctx[5];
	    				add_flush_callback(() => updating_name = false);
	    			}

	    			if (!updating_path && dirty[0] & /*iconPath*/ 64) {
	    				updating_path = true;
	    				icon_changes.path = /*iconPath*/ ctx[6];
	    				add_flush_callback(() => updating_path = false);
	    			}

	    			if (!updating_url && dirty[0] & /*iconUrl*/ 128) {
	    				updating_url = true;
	    				icon_changes.url = /*iconUrl*/ ctx[7];
	    				add_flush_callback(() => updating_url = false);
	    			}

	    			icon.$set(icon_changes);

	    			if (!current || dirty[0] & /*disabled*/ 512) {
	    				attr(div, "disabled", /*disabled*/ ctx[9]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(icon.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(icon.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(icon);
	    		}
	    	};
	    }

	    // (72:6) {#if _showSuggestions && !disabled}
	    function create_if_block_4$3(ctx) {
	    	let div;
	    	let current_block_type_index;
	    	let if_block;
	    	let globalClicks_action;
	    	let positionOptions_action;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	const if_block_creators = [create_if_block_5$1, create_if_block_6$1, create_else_block_1];
	    	const if_blocks = [];

	    	function select_block_type_1(ctx, dirty) {
	    		if (/*_loadingSuggestions*/ ctx[31]) return 0;
	    		if (/*_suggestions*/ ctx[32].length > 0) return 1;
	    		return 2;
	    	}

	    	current_block_type_index = select_block_type_1(ctx);
	    	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-options-wrapper svelte-1wnlerg");
	    			attr(div, "pos--theme", /*_theme*/ ctx[28]);
	    			attr(div, "pos--shape", /*_shape*/ ctx[29]);
	    			attr(div, "pos--density", /*_density*/ ctx[30]);
	    			toggle_class(div, "open", /*_showSuggestions*/ ctx[33]);
	    			toggle_class(div, "upward", /*_upward*/ ctx[25]);
	    			toggle_class(div, "downward", !/*_upward*/ ctx[25]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_blocks[current_block_type_index].m(div, null);
	    			current = true;

	    			if (!mounted) {
	    				dispose = [
	    					action_destroyer(globalClicks_action = /*globalClicks*/ ctx[18].call(null, div)),
	    					action_destroyer(positionOptions_action = /*positionOptions*/ ctx[19].call(null, div))
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			let previous_block_index = current_block_type_index;
	    			current_block_type_index = select_block_type_1(ctx);

	    			if (current_block_type_index === previous_block_index) {
	    				if_blocks[current_block_type_index].p(ctx, dirty);
	    			} else {
	    				group_outros();

	    				transition_out(if_blocks[previous_block_index], 1, 1, () => {
	    					if_blocks[previous_block_index] = null;
	    				});

	    				check_outros();
	    				if_block = if_blocks[current_block_type_index];

	    				if (!if_block) {
	    					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	    					if_block.c();
	    				} else {
	    					if_block.p(ctx, dirty);
	    				}

	    				transition_in(if_block, 1);
	    				if_block.m(div, null);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 268435456) {
	    				attr(div, "pos--theme", /*_theme*/ ctx[28]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 536870912) {
	    				attr(div, "pos--shape", /*_shape*/ ctx[29]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 1073741824) {
	    				attr(div, "pos--density", /*_density*/ ctx[30]);
	    			}

	    			if (dirty[1] & /*_showSuggestions*/ 4) {
	    				toggle_class(div, "open", /*_showSuggestions*/ ctx[33]);
	    			}

	    			if (dirty[0] & /*_upward*/ 33554432) {
	    				toggle_class(div, "upward", /*_upward*/ ctx[25]);
	    			}

	    			if (dirty[0] & /*_upward*/ 33554432) {
	    				toggle_class(div, "downward", !/*_upward*/ ctx[25]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_blocks[current_block_type_index].d();
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (93:10) {:else}
	    function create_else_block_1(ctx) {
	    	let div4;
	    	let div3;
	    	let div2;
	    	let div1;
	    	let div0;
	    	let t_value = /*$_*/ ctx[45]("noSuggestions") + "";
	    	let t;
	    	let mounted;
	    	let dispose;

	    	return {
	    		c() {
	    			div4 = element("div");
	    			div3 = element("div");
	    			div2 = element("div");
	    			div1 = element("div");
	    			div0 = element("div");
	    			t = text(t_value);
	    			attr(div0, "pros-tooltip", "");
	    			attr(div0, "role", "option");
	    			attr(div0, "class", "pros-option svelte-1wnlerg");
	    			attr(div1, "class", "pros-option-row svelte-1wnlerg");
	    			attr(div2, "class", "pros-option-list svelte-1wnlerg");
	    			attr(div3, "class", "pros-options svelte-1wnlerg");
	    			attr(div4, "id", /*_optionsId*/ ctx[42]);
	    			attr(div4, "class", "pros-options-container svelte-1wnlerg");
	    		},
	    		m(target, anchor) {
	    			insert(target, div4, anchor);
	    			append(div4, div3);
	    			append(div3, div2);
	    			append(div2, div1);
	    			append(div1, div0);
	    			append(div0, t);

	    			if (!mounted) {
	    				dispose = [
	    					listen(div1, "mousedown", preventClickPropagation),
	    					listen(div1, "mouseup", preventClickPropagation)
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*$_*/ 16384 && t_value !== (t_value = /*$_*/ ctx[45]("noSuggestions") + "")) set_data(t, t_value);

	    			if (dirty[1] & /*_optionsId*/ 2048) {
	    				attr(div4, "id", /*_optionsId*/ ctx[42]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div4);
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (79:10) {#if _suggestions.length > 0}
	    function create_if_block_6$1(ctx) {
	    	let div2;
	    	let div1;
	    	let div0;
	    	let each_value = /*_suggestions*/ ctx[32];
	    	let each_blocks = [];

	    	for (let i = 0; i < each_value.length; i += 1) {
	    		each_blocks[i] = create_each_block$4(get_each_context$4(ctx, each_value, i));
	    	}

	    	return {
	    		c() {
	    			div2 = element("div");
	    			div1 = element("div");
	    			div0 = element("div");

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].c();
	    			}

	    			attr(div0, "class", "pros-option-list svelte-1wnlerg");
	    			attr(div1, "class", "pros-options svelte-1wnlerg");
	    			attr(div2, "id", /*_optionsId*/ ctx[42]);
	    			attr(div2, "class", "pros-options-container svelte-1wnlerg");
	    		},
	    		m(target, anchor) {
	    			insert(target, div2, anchor);
	    			append(div2, div1);
	    			append(div1, div0);

	    			for (let i = 0; i < each_blocks.length; i += 1) {
	    				each_blocks[i].m(div0, null);
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*preventClickPropagation*/ 1048576 | dirty[1] & /*handleSuggestionClicked, _suggestions*/ 32770) {
	    				each_value = /*_suggestions*/ ctx[32];
	    				let i;

	    				for (i = 0; i < each_value.length; i += 1) {
	    					const child_ctx = get_each_context$4(ctx, each_value, i);

	    					if (each_blocks[i]) {
	    						each_blocks[i].p(child_ctx, dirty);
	    					} else {
	    						each_blocks[i] = create_each_block$4(child_ctx);
	    						each_blocks[i].c();
	    						each_blocks[i].m(div0, null);
	    					}
	    				}

	    				for (; i < each_blocks.length; i += 1) {
	    					each_blocks[i].d(1);
	    				}

	    				each_blocks.length = each_value.length;
	    			}

	    			if (dirty[1] & /*_optionsId*/ 2048) {
	    				attr(div2, "id", /*_optionsId*/ ctx[42]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div2);
	    			destroy_each(each_blocks, detaching);
	    		}
	    	};
	    }

	    // (74:8) {#if _loadingSuggestions}
	    function create_if_block_5$1(ctx) {
	    	let div;
	    	let spinner;
	    	let current;
	    	spinner = new Spinner({ props: { diameter: "24" } });

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(spinner.$$.fragment);
	    			attr(div, "class", "pros-spinner-container svelte-1wnlerg");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(spinner, div, null);
	    			current = true;
	    		},
	    		p: noop,
	    		i(local) {
	    			if (current) return;
	    			transition_in(spinner.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(spinner.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(spinner);
	    		}
	    	};
	    }

	    // (83:16) {#each _suggestions as suggestion}
	    function create_each_block$4(ctx) {
	    	let div1;
	    	let div0;
	    	let raw_value = /*suggestion*/ ctx[91].modifiedDisplay + "";
	    	let t;
	    	let mounted;
	    	let dispose;

	    	function click_handler(...args) {
	    		return /*click_handler*/ ctx[73](/*suggestion*/ ctx[91], ...args);
	    	}

	    	return {
	    		c() {
	    			div1 = element("div");
	    			div0 = element("div");
	    			t = space();
	    			attr(div0, "pros-tooltip", "");
	    			attr(div0, "role", "option");
	    			attr(div0, "class", "pros-option svelte-1wnlerg");
	    			attr(div1, "class", "pros-option-row svelte-1wnlerg");
	    		},
	    		m(target, anchor) {
	    			insert(target, div1, anchor);
	    			append(div1, div0);
	    			div0.innerHTML = raw_value;
	    			append(div1, t);

	    			if (!mounted) {
	    				dispose = [
	    					listen(div1, "click", click_handler),
	    					listen(div1, "mousedown", preventClickPropagation),
	    					listen(div1, "mouseup", preventClickPropagation)
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(new_ctx, dirty) {
	    			ctx = new_ctx;
	    			if (dirty[1] & /*_suggestions*/ 2 && raw_value !== (raw_value = /*suggestion*/ ctx[91].modifiedDisplay + "")) div0.innerHTML = raw_value;		},
	    		d(detaching) {
	    			if (detaching) detach(div1);
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    // (111:4) {#if display !== 'custom'}
	    function create_if_block$b(ctx) {
	    	let div;
	    	let t;

	    	function select_block_type_2(ctx, dirty) {
	    		if (/*_dirty*/ ctx[21] && /*_errors*/ ctx[22].length > 0) return create_if_block_2$6;
	    		if (/*hint*/ ctx[3] && /*_hasFocus*/ ctx[27]) return create_if_block_3$3;
	    		return create_else_block$4;
	    	}

	    	let current_block_type = select_block_type_2(ctx);
	    	let if_block0 = current_block_type(ctx);
	    	let if_block1 = /*maxLength*/ ctx[4] && /*_hasFocus*/ ctx[27] && create_if_block_1$7(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block0.c();
	    			t = space();
	    			if (if_block1) if_block1.c();
	    			attr(div, "class", "pros-message-container svelte-1wnlerg");
	    			toggle_class(div, "error", /*_dirty*/ ctx[21] && /*_errors*/ ctx[22].length > 0);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block0.m(div, null);
	    			append(div, t);
	    			if (if_block1) if_block1.m(div, null);
	    		},
	    		p(ctx, dirty) {
	    			if (current_block_type === (current_block_type = select_block_type_2(ctx)) && if_block0) {
	    				if_block0.p(ctx, dirty);
	    			} else {
	    				if_block0.d(1);
	    				if_block0 = current_block_type(ctx);

	    				if (if_block0) {
	    					if_block0.c();
	    					if_block0.m(div, t);
	    				}
	    			}

	    			if (/*maxLength*/ ctx[4] && /*_hasFocus*/ ctx[27]) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);
	    				} else {
	    					if_block1 = create_if_block_1$7(ctx);
	    					if_block1.c();
	    					if_block1.m(div, null);
	    				}
	    			} else if (if_block1) {
	    				if_block1.d(1);
	    				if_block1 = null;
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 6291456) {
	    				toggle_class(div, "error", /*_dirty*/ ctx[21] && /*_errors*/ ctx[22].length > 0);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block0.d();
	    			if (if_block1) if_block1.d();
	    		}
	    	};
	    }

	    // (127:6) {:else}
	    function create_else_block$4(ctx) {
	    	let div;

	    	return {
	    		c() {
	    			div = element("div");
	    			attr(div, "id", /*_messageId*/ ctx[39]);
	    			attr(div, "class", "pros-message svelte-1wnlerg");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_messageId*/ 256) {
	    				attr(div, "id", /*_messageId*/ ctx[39]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    // (120:34) 
	    function create_if_block_3$3(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(/*hint*/ ctx[3]);
	    			attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1wnlerg");
	    			attr(div0, "id", /*_statusIconId*/ ctx[40]);
	    			attr(div0, "class", "pros-status-icon svelte-1wnlerg");
	    			attr(div1, "id", /*_messageId*/ ctx[39]);
	    			attr(div1, "class", "pros-message svelte-1wnlerg");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_statusIconId*/ 512) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[40]);
	    			}

	    			if (dirty[0] & /*hint*/ 8) set_data(t1, /*hint*/ ctx[3]);

	    			if (dirty[1] & /*_messageId*/ 256) {
	    				attr(div1, "id", /*_messageId*/ ctx[39]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    // (113:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_2$6(ctx) {
	    	let div0;
	    	let svg;
	    	let path;
	    	let t0;
	    	let div1;
	    	let t1_value = /*_errors*/ ctx[22][0] + "";
	    	let t1;

	    	return {
	    		c() {
	    			div0 = element("div");
	    			svg = svg_element("svg");
	    			path = svg_element("path");
	    			t0 = space();
	    			div1 = element("div");
	    			t1 = text(t1_value);
	    			attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	    			attr(svg, "width", "24");
	    			attr(svg, "height", "24");
	    			attr(svg, "viewBox", "0 0 24 24");
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "class", "svelte-1wnlerg");
	    			attr(div0, "id", /*_statusIconId*/ ctx[40]);
	    			attr(div0, "class", "pros-status-icon error svelte-1wnlerg");
	    			attr(div1, "id", /*_messageId*/ ctx[39]);
	    			attr(div1, "class", "pros-message error svelte-1wnlerg");
	    			attr(div1, "pros-tooltip", "");
	    		},
	    		m(target, anchor) {
	    			insert(target, div0, anchor);
	    			append(div0, svg);
	    			append(svg, path);
	    			insert(target, t0, anchor);
	    			insert(target, div1, anchor);
	    			append(div1, t1);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[1] & /*_statusIconId*/ 512) {
	    				attr(div0, "id", /*_statusIconId*/ ctx[40]);
	    			}

	    			if (dirty[0] & /*_errors*/ 4194304 && t1_value !== (t1_value = /*_errors*/ ctx[22][0] + "")) set_data(t1, t1_value);

	    			if (dirty[1] & /*_messageId*/ 256) {
	    				attr(div1, "id", /*_messageId*/ ctx[39]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div0);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div1);
	    		}
	    	};
	    }

	    // (130:6) {#if maxLength && _hasFocus}
	    function create_if_block_1$7(ctx) {
	    	let div;
	    	let t0_value = /*value*/ ctx[0].length + "";
	    	let t0;
	    	let t1;
	    	let t2;

	    	return {
	    		c() {
	    			div = element("div");
	    			t0 = text(t0_value);
	    			t1 = text("/");
	    			t2 = text(/*maxLength*/ ctx[4]);
	    			attr(div, "id", /*_constraintId*/ ctx[41]);
	    			attr(div, "class", "pros-constraint");
	    			toggle_class(div, "error", /*value*/ ctx[0].length > /*maxLength*/ ctx[4]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			append(div, t0);
	    			append(div, t1);
	    			append(div, t2);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty[0] & /*value*/ 1 && t0_value !== (t0_value = /*value*/ ctx[0].length + "")) set_data(t0, t0_value);
	    			if (dirty[0] & /*maxLength*/ 16) set_data(t2, /*maxLength*/ ctx[4]);

	    			if (dirty[1] & /*_constraintId*/ 1024) {
	    				attr(div, "id", /*_constraintId*/ ctx[41]);
	    			}

	    			if (dirty[0] & /*value, maxLength*/ 17) {
	    				toggle_class(div, "error", /*value*/ ctx[0].length > /*maxLength*/ ctx[4]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    		}
	    	};
	    }

	    function create_fragment$e(ctx) {
	    	let div4;
	    	let div3;
	    	let t0;
	    	let div2;
	    	let div1;
	    	let div0;
	    	let t1;
	    	let t2;
	    	let t3;
	    	let t4;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*_hasLabel*/ ctx[44] && create_if_block_10(ctx);

	    	function select_block_type(ctx, dirty) {
	    		if (/*password*/ ctx[12]) return create_if_block_9;
	    		return create_else_block_2;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block1 = current_block_type(ctx);
	    	let if_block2 = /*_hasValue*/ ctx[43] && !/*disabled*/ ctx[9] && /*_hasFocus*/ ctx[27] && create_if_block_8(ctx);
	    	let if_block3 = (/*iconName*/ ctx[5] || /*iconPath*/ ctx[6] || /*iconUrl*/ ctx[7]) && create_if_block_7$1(ctx);
	    	let if_block4 = /*_showSuggestions*/ ctx[33] && !/*disabled*/ ctx[9] && create_if_block_4$3(ctx);
	    	let if_block5 = /*display*/ ctx[2] !== "custom" && create_if_block$b(ctx);

	    	return {
	    		c() {
	    			div4 = element("div");
	    			div3 = element("div");
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div2 = element("div");
	    			div1 = element("div");
	    			div0 = element("div");
	    			if_block1.c();
	    			t1 = space();
	    			if (if_block2) if_block2.c();
	    			t2 = space();
	    			if (if_block3) if_block3.c();
	    			t3 = space();
	    			if (if_block4) if_block4.c();
	    			t4 = space();
	    			if (if_block5) if_block5.c();
	    			attr(div0, "class", "pros-input-container svelte-1wnlerg");
	    			attr(div1, "class", "pros-content-container svelte-1wnlerg");
	    			attr(div2, "class", "pros-highlight-container svelte-1wnlerg");
	    			toggle_class(div2, "open", /*_showSuggestions*/ ctx[33]);
	    			toggle_class(div2, "upward", /*_upward*/ ctx[25]);
	    			toggle_class(div2, "downward", /*_showSuggestions*/ ctx[33] && !/*_upward*/ ctx[25]);
	    			attr(div3, "class", "pros-control-container svelte-1wnlerg");
	    			toggle_class(div3, "has-value", /*_hasValue*/ ctx[43]);
	    			toggle_class(div3, "has-label", /*_hasLabel*/ ctx[44]);
	    			toggle_class(div3, "has-focus", /*_hasFocus*/ ctx[27]);
	    			toggle_class(div3, "custom-layout", /*display*/ ctx[2] === "custom");
	    			toggle_class(div3, "error", /*_dirty*/ ctx[21] && /*_errors*/ ctx[22].length > 0);
	    			toggle_class(div3, "disabled", /*disabled*/ ctx[9]);
	    			toggle_class(div3, "allow-hover", !/*disabled*/ ctx[9]);
	    			attr(div4, "class", "pros-global-wrapper pros-form-control svelte-1wnlerg");
	    			attr(div4, "pos--theme", /*_theme*/ ctx[28]);
	    			attr(div4, "pos--shape", /*_shape*/ ctx[29]);
	    			attr(div4, "pos--density", /*_density*/ ctx[30]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div4, anchor);
	    			append(div4, div3);
	    			if (if_block0) if_block0.m(div3, null);
	    			append(div3, t0);
	    			append(div3, div2);
	    			append(div2, div1);
	    			append(div1, div0);
	    			if_block1.m(div0, null);
	    			append(div1, t1);
	    			if (if_block2) if_block2.m(div1, null);
	    			append(div1, t2);
	    			if (if_block3) if_block3.m(div1, null);
	    			append(div2, t3);
	    			if (if_block4) if_block4.m(div2, null);
	    			/*div2_binding*/ ctx[74](div2);
	    			append(div3, t4);
	    			if (if_block5) if_block5.m(div3, null);
	    			current = true;

	    			if (!mounted) {
	    				dispose = [
	    					listen(div2, "mouseup", handleMouseUp),
	    					listen(div2, "mousedown", handleMouseDown),
	    					listen(div2, "keydown", /*handleKeyDown*/ ctx[15]),
	    					listen(div2, "focus", /*handleFocus*/ ctx[13]),
	    					listen(div2, "blur", /*handleBlur*/ ctx[14]),
	    					listen(div2, "click", /*handleClick*/ ctx[16])
	    				];

	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasLabel*/ ctx[44]) {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);
	    				} else {
	    					if_block0 = create_if_block_10(ctx);
	    					if_block0.c();
	    					if_block0.m(div3, t0);
	    				}
	    			} else if (if_block0) {
	    				if_block0.d(1);
	    				if_block0 = null;
	    			}

	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) {
	    				if_block1.p(ctx, dirty);
	    			} else {
	    				if_block1.d(1);
	    				if_block1 = current_block_type(ctx);

	    				if (if_block1) {
	    					if_block1.c();
	    					if_block1.m(div0, null);
	    				}
	    			}

	    			if (/*_hasValue*/ ctx[43] && !/*disabled*/ ctx[9] && /*_hasFocus*/ ctx[27]) {
	    				if (if_block2) {
	    					if_block2.p(ctx, dirty);
	    				} else {
	    					if_block2 = create_if_block_8(ctx);
	    					if_block2.c();
	    					if_block2.m(div1, t2);
	    				}
	    			} else if (if_block2) {
	    				if_block2.d(1);
	    				if_block2 = null;
	    			}

	    			if (/*iconName*/ ctx[5] || /*iconPath*/ ctx[6] || /*iconUrl*/ ctx[7]) {
	    				if (if_block3) {
	    					if_block3.p(ctx, dirty);

	    					if (dirty[0] & /*iconName, iconPath, iconUrl*/ 224) {
	    						transition_in(if_block3, 1);
	    					}
	    				} else {
	    					if_block3 = create_if_block_7$1(ctx);
	    					if_block3.c();
	    					transition_in(if_block3, 1);
	    					if_block3.m(div1, null);
	    				}
	    			} else if (if_block3) {
	    				group_outros();

	    				transition_out(if_block3, 1, 1, () => {
	    					if_block3 = null;
	    				});

	    				check_outros();
	    			}

	    			if (/*_showSuggestions*/ ctx[33] && !/*disabled*/ ctx[9]) {
	    				if (if_block4) {
	    					if_block4.p(ctx, dirty);

	    					if (dirty[0] & /*disabled*/ 512 | dirty[1] & /*_showSuggestions*/ 4) {
	    						transition_in(if_block4, 1);
	    					}
	    				} else {
	    					if_block4 = create_if_block_4$3(ctx);
	    					if_block4.c();
	    					transition_in(if_block4, 1);
	    					if_block4.m(div2, null);
	    				}
	    			} else if (if_block4) {
	    				group_outros();

	    				transition_out(if_block4, 1, 1, () => {
	    					if_block4 = null;
	    				});

	    				check_outros();
	    			}

	    			if (dirty[1] & /*_showSuggestions*/ 4) {
	    				toggle_class(div2, "open", /*_showSuggestions*/ ctx[33]);
	    			}

	    			if (dirty[0] & /*_upward*/ 33554432) {
	    				toggle_class(div2, "upward", /*_upward*/ ctx[25]);
	    			}

	    			if (dirty[0] & /*_upward*/ 33554432 | dirty[1] & /*_showSuggestions*/ 4) {
	    				toggle_class(div2, "downward", /*_showSuggestions*/ ctx[33] && !/*_upward*/ ctx[25]);
	    			}

	    			if (/*display*/ ctx[2] !== "custom") {
	    				if (if_block5) {
	    					if_block5.p(ctx, dirty);
	    				} else {
	    					if_block5 = create_if_block$b(ctx);
	    					if_block5.c();
	    					if_block5.m(div3, null);
	    				}
	    			} else if (if_block5) {
	    				if_block5.d(1);
	    				if_block5 = null;
	    			}

	    			if (dirty[1] & /*_hasValue*/ 4096) {
	    				toggle_class(div3, "has-value", /*_hasValue*/ ctx[43]);
	    			}

	    			if (dirty[1] & /*_hasLabel*/ 8192) {
	    				toggle_class(div3, "has-label", /*_hasLabel*/ ctx[44]);
	    			}

	    			if (dirty[0] & /*_hasFocus*/ 134217728) {
	    				toggle_class(div3, "has-focus", /*_hasFocus*/ ctx[27]);
	    			}

	    			if (dirty[0] & /*display*/ 4) {
	    				toggle_class(div3, "custom-layout", /*display*/ ctx[2] === "custom");
	    			}

	    			if (dirty[0] & /*_dirty, _errors*/ 6291456) {
	    				toggle_class(div3, "error", /*_dirty*/ ctx[21] && /*_errors*/ ctx[22].length > 0);
	    			}

	    			if (dirty[0] & /*disabled*/ 512) {
	    				toggle_class(div3, "disabled", /*disabled*/ ctx[9]);
	    			}

	    			if (dirty[0] & /*disabled*/ 512) {
	    				toggle_class(div3, "allow-hover", !/*disabled*/ ctx[9]);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 268435456) {
	    				attr(div4, "pos--theme", /*_theme*/ ctx[28]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 536870912) {
	    				attr(div4, "pos--shape", /*_shape*/ ctx[29]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 1073741824) {
	    				attr(div4, "pos--density", /*_density*/ ctx[30]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block3);
	    			transition_in(if_block4);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block3);
	    			transition_out(if_block4);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div4);
	    			if (if_block0) if_block0.d();
	    			if_block1.d();
	    			if (if_block2) if_block2.d();
	    			if (if_block3) if_block3.d();
	    			if (if_block4) if_block4.d();
	    			/*div2_binding*/ ctx[74](null);
	    			if (if_block5) if_block5.d();
	    			mounted = false;
	    			run_all(dispose);
	    		}
	    	};
	    }

	    function preventClickPropagation(event) {
	    	event.stopPropagation();
	    	event.preventDefault();
	    }

	    function handleMouseDown(event) {
	    	
	    } // _suppressFocus = true;

	    function handleMouseUp(event) {
	    	
	    } // _suppressFocus = false;

	    function hasValue$3(test) {
	    	return test !== undefined && test !== null;
	    }

	    function notEmpty(test) {
	    	return test !== undefined && test !== null && test.trim() !== "";
	    }

	    function instance$e($$self, $$props, $$invalidate) {
	    	let _hasValue;
	    	let _hasLabel;
	    	let $_;
	    	component_subscribe($$self, X, $$value => $$invalidate(45, $_ = $$value));
	    	const dispatch = createEventDispatcher();
	    	let { globalClickListener = null } = $$props;
	    	let { globalKeyListener = null } = $$props;
	    	let { display = "form" } = $$props; // Layout interaction (reserved space, alignment policies) (form, custom)
	    	let { theme = "auto" } = $$props; // Color theme (auto/dark/light)
	    	let { shape = "round" } = $$props; // Shape style (round/sharp)
	    	let { density = "standard" } = $$props; // Density style (standard/high)
	    	let { value = "" } = $$props; // Current value of control
	    	let { label = "" } = $$props; // Control label
	    	let { placeholder = "" } = $$props; // Placeholder text to display in text box when no value
	    	let { hint = "" } = $$props; // Hint/Helper text to display when no validation errors to display
	    	let { maxLength = undefined } = $$props; // Max length of value allowed
	    	let { iconName = undefined } = $$props;
	    	let { iconPath = undefined } = $$props;
	    	let { iconUrl = undefined } = $$props;
	    	let { required = false } = $$props; // Is value required to be valid?
	    	let { disabled = false } = $$props; // Is Control disabled?
	    	let { validation = true } = $$props; // Do we include built in validation?
	    	let { errors = [] } = $$props; // Custom external validation errors
	    	let { regex = undefined } = $$props; // Regex object to evaluate during built in validation
	    	let { regexkey = undefined } = $$props; // PrintOS validation id
	    	let { regexmessage = undefined } = $$props; // custom validation message for use with regexKey
	    	let { callbacks = {} } = $$props;
	    	let { _suggestionsDebounce = debounce(getSuggestions, 700, { maxWait: 5000, trailing: true }) } = $$props;
	    	let { inputElement } = $$props;
	    	let { password } = $$props;
	    	let { autocomplete = false } = $$props;
	    	let { id = null } = $$props;

	    	// Internal Data
	    	let _dirty = false; // Has the user changed the value (yes = dirty)

	    	let _errors = []; // Combined validation errors
	    	let _builtInErrors = []; // Built in validation errors
	    	let _lastValid;
	    	let _untrimmedValue = ""; // Actual value bound to input box (may include extra whitespace)
	    	let _lastValue = ""; // Last trimmed value so we can filter out extra change events based on trimmed value
	    	let _inputElement = undefined;
	    	let _openNode = undefined;
	    	let _openParent = undefined;
	    	let _upward = false;
	    	let _highlightElement;
	    	let _hasFocus = false;
	    	let _themeEventListener;
	    	let _shapeEventListener;
	    	let _densityEventListener;
	    	let _theme;
	    	let _shape;
	    	let _density;
	    	let _lastTheme;
	    	let _lastShape;
	    	let _lastDensity;
	    	let _loadingSuggestions = false;
	    	let _suggestions;
	    	let _showSuggestions = false; // Is Selector visible?
	    	let _printos = window.$printos;
	    	let _autocomplete = "off";
	    	let _labelId = null;
	    	let _inputId = null;
	    	let _clearId = null;
	    	let _capId = null;
	    	let _messageId = null;
	    	let _statusIconId = null;
	    	let _constraintId = null;
	    	let _optionsId = null;

	    	onMount(() => {
	    		$$invalidate(56, inputElement = _inputElement);
	    		doValidate();
	    	});

	    	onDestroy(() => {
	    		if (_themeEventListener) {
	    			window.removeEventListener("posh-theme-changed", _themeEventListener);
	    		}

	    		if (_shapeEventListener) {
	    			window.removeEventListener("posh-shape-changed", _shapeEventListener);
	    		}

	    		if (_densityEventListener) {
	    			window.removeEventListener("posh-density-changed", _densityEventListener);
	    		}
	    	});

	    	beforeUpdate(() => {
	    		// Normalize external changes
	    		$$invalidate(2, display = hasValue$3(display) ? display : "form");

	    		$$invalidate(50, theme = hasValue$3(theme) ? theme : "light");
	    		$$invalidate(51, shape = hasValue$3(shape) ? shape : "round");
	    		$$invalidate(52, density = hasValue$3(density) ? density : "standard");
	    		$$invalidate(1, label = hasValue$3(label) ? label : "");
	    		$$invalidate(3, hint = hasValue$3(hint) ? hint : "");
	    		$$invalidate(0, value = hasValue$3(value) ? value : "");

	    		$$invalidate(4, maxLength = hasValue$3(maxLength) && maxLength !== "" && !isNaN(maxLength) && Number(maxLength) >= 0
	    		? Number(maxLength)
	    		: undefined);

	    		$$invalidate(54, regex = hasValue$3(regex) ? regex : undefined);
	    		$$invalidate(55, regexkey = hasValue$3(regexkey) ? regexkey : undefined);
	    		$$invalidate(8, required = hasValue$3(required) ? required : false);
	    		$$invalidate(9, disabled = hasValue$3(disabled) ? disabled : false);
	    		$$invalidate(53, validation = hasValue$3(validation) ? validation : true);
	    		$$invalidate(10, autocomplete = hasValue$3(autocomplete) ? autocomplete : false);
	    		$$invalidate(34, _autocomplete = autocomplete ? "on" : "off");
	    		$$invalidate(35, _labelId = hasValue$3(id) ? `${id}-label` : undefined);
	    		$$invalidate(36, _inputId = hasValue$3(id) ? `${id}-input` : undefined);
	    		$$invalidate(37, _clearId = hasValue$3(id) ? `${id}-clear` : undefined);
	    		$$invalidate(38, _capId = hasValue$3(id) ? `${id}-cap` : undefined);

	    		$$invalidate(42, _optionsId = hasValue$3(id)
	    		? `${id}-options`
	    		: "pros-options-container");

	    		$$invalidate(39, _messageId = hasValue$3(id) ? `${id}-message` : undefined);
	    		$$invalidate(40, _statusIconId = hasValue$3(id) ? `${id}-status-icon` : undefined);
	    		$$invalidate(41, _constraintId = hasValue$3(id) ? `${id}-constraint` : undefined);

	    		// Check if this is a programmatic update
	    		if (value !== _lastValue) {
	    			$$invalidate(23, _untrimmedValue = value);
	    			_lastValue = value;
	    		}

	    		if (theme !== _lastTheme) {
	    			_lastTheme = theme;

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(28, _theme = themeAttribute ? themeAttribute : "light");

	    				if (!_themeEventListener) {
	    					// Only start listening once
	    					_themeEventListener = window.addEventListener("posh-theme-changed", event => {
	    						if (theme === "auto") {
	    							$$invalidate(28, _theme = event.detail.theme);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(28, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			_lastShape = shape;

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(29, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					_shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(29, _shape = event.detail.shape);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(29, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			_lastDensity = density;

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(30, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					_densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(30, _density = event.detail.density);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(30, _density = density);
	    			}
	    		}

	    		doValidate.call(this);
	    	});

	    	function handleFocus(event) {
	    		$$invalidate(27, _hasFocus = true);
	    	}

	    	function handleBlur(event) {
	    		if (!_showSuggestions) {
	    			$$invalidate(27, _hasFocus = false);
	    		}
	    	}

	    	function handleKeyDown(event) {
	    		if (!get$1(callbacks, "suggest")) {
	    			return;
	    		}

	    		if (_showSuggestions) {
	    			// Ignore this handler if option are open
	    			// console.log('SB: handleKeyDown:Ignore');
	    			return;
	    		}

	    		switch (event.key) {
	    			case "Enter":
	    			case "ArrowDown":
	    				// console.log('SB: handleKeyDown:' + event.key);
	    				event.stopPropagation();
	    				event.preventDefault();
	    				openOptions();
	    				break;
	    			case "Escape":
	    				// console.log('SB: handleKeyDown:Escape');
	    				event.stopPropagation();
	    				event.preventDefault();
	    				_highlightElement.blur();
	    				break;
	    		}
	    	}

	    	function handleClick(event) {
	    		if (disabled) {
	    			return;
	    		}

	    		if (_showSuggestions) {
	    			// console.log('SB: handleClick:Close');
	    			closeOptions(true);
	    		} else if (_suggestions && _suggestions.length > 0) {
	    			openOptions();
	    		} else if (notEmpty(value)) {
	    			_suggestionsDebounce();
	    		}
	    	}

	    	function handleClear(event) {
	    		event.preventDefault();

	    		if (event.which !== 1) {
	    			return;
	    		}

	    		// Clear the input value
	    		$$invalidate(23, _untrimmedValue = "");

	    		$$invalidate(27, _hasFocus = true);
	    		_inputElement.focus();
	    		valueChanged.call(this);
	    	}

	    	function getSuggestions(suppressOpen = false) {
	    		if (!get$1(callbacks, "suggest")) {
	    			return;
	    		}

	    		if (_loadingSuggestions) {
	    			_suggestionsDebounce();
	    			return;
	    		}

	    		if (!notEmpty(value)) {
	    			$$invalidate(32, _suggestions = []);
	    			closeOptions(true);
	    			return;
	    		}

	    		$$invalidate(31, _loadingSuggestions = true);

	    		if (!suppressOpen && !_showSuggestions && _hasFocus) {
	    			openOptions();
	    		}

	    		return callbacks.suggest(value).then(resp => {
	    			$$invalidate(32, _suggestions = []);

	    			if (!resp || !Array.isArray(resp)) {
	    				closeOptions(true);
	    				return;
	    			}

	    			$$invalidate(32, _suggestions = resp.map(suggestion => {
	    				let lc = suggestion.display.toLocaleLowerCase();
	    				let test = value.toLocaleLowerCase();
	    				let lastIndex = 0;
	    				let testIndex = lc.indexOf(test);
	    				let mySuggestion = "";

	    				while (testIndex !== -1) {
	    					mySuggestion += suggestion.display.substring(lastIndex, testIndex);
	    					mySuggestion += "<b>";
	    					mySuggestion += suggestion.display.substring(testIndex, testIndex + test.length);
	    					mySuggestion += "</b>";
	    					lastIndex = testIndex + test.length;
	    					testIndex = lc.indexOf(test, lastIndex);
	    				}

	    				mySuggestion += suggestion.display.substring(lastIndex);

	    				return {
	    					display: suggestion.display,
	    					modifiedDisplay: mySuggestion,
	    					value: suggestion.value
	    				};
	    			}));

	    			$$invalidate(31, _loadingSuggestions = false);
	    			_inputElement.focus();
	    		});
	    	}

	    	function handleSuggestionClicked(suggestion) {
	    		closeOptions();
	    		$$invalidate(23, _untrimmedValue = suggestion.display);
	    		valueChanged.call(this, null, true);
	    		getSuggestions(true);

	    		// Avoid short circuit handling if changed handler changes a state value
	    		window.setTimeout(() => {
	    			dispatch("suggested", suggestion.value);
	    		});
	    	}

	    	function globalClicks(node) {

	    		$$invalidate(48, globalClickListener = event => {
	    			let elements = [node];

	    			// Change NodeList to Array to use some()
	    			elements = Array.prototype.slice.call(elements);

	    			let containsClick = elements.some(element => {
	    				return element.contains(event.target);
	    			});

	    			if (!containsClick) {
	    				// console.log('SB: globalClicks: close Options');
	    				closeOptions();
	    			}
	    		});

	    		$$invalidate(49, globalKeyListener = event => {
	    			
	    		}); // myKeyDown.call(this, event); // myKeyDown function is not defined?

	    		// Necessary to prevent handling click that opens panel
	    		window.setTimeout(
	    			() => {
	    				document.addEventListener("click", globalClickListener);
	    				document.addEventListener("keydown", globalKeyListener);
	    			},
	    			0
	    		);
	    	}

	    	function positionOptions(node) {
	    		_openNode = node;
	    		_openParent = node.parentElement;

	    		// console.log('positionOptions', _openNode, _openParent);
	    		document.body.appendChild(node);

	    		positionNode();
	    		document.addEventListener("wheel", handleScroll);
	    		window.addEventListener("scroll", handleScroll, true);
	    		window.addEventListener("resize", handleScroll);

	    		return {
	    			destroy() {
	    				document.removeEventListener("wheel", handleScroll);
	    				window.removeEventListener("scroll", handleScroll);
	    				window.removeEventListener("resize", handleScroll);
	    			}
	    		};
	    	}

	    	function positionNode(event) {
	    		if (!_openParent) {
	    			document.removeEventListener("wheel", handleScroll);
	    			window.removeEventListener("scroll", handleScroll);
	    			window.removeEventListener("resize", handleScroll);
	    			return;
	    		}

	    		let adjustedTop;
	    		let bodyRect = document.body.getBoundingClientRect();
	    		let rect = _openParent.getBoundingClientRect();
	    		$$invalidate(25, _upward = false);

	    		if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	    			$$invalidate(25, _upward = true);

	    			adjustedTop = rect.top >= _openNode.offsetHeight
	    			? `${rect.top - _openNode.offsetHeight}px`
	    			: `0px`;
	    		}

	    		if (event) {
	    			let scrollTop = event.target.scrollTop;
	    			let scrollBottom = scrollTop + event.target.clientHeight;

	    			if (_openParent.offsetParent.offsetTop < scrollTop) {
	    				adjustedTop = 0 + "px";
	    			}

	    			if (_openParent.offsetParent.offsetTop > scrollBottom) {
	    				adjustedTop = `${rect.top - _openNode.offsetHeight}px`;
	    			}
	    		}

	    		_openNode.style.left = `${rect.left}px`;
	    		_openNode.style.top = adjustedTop ? adjustedTop : `${rect.bottom}px`;
	    		_openNode.style.width = `${rect.width}px`;
	    	}

	    	function handleScroll(event) {
	    		let isOptionScroll = false;
	    		let test = event.target;

	    		while (test) {
	    			if (test.id === _optionsId) {
	    				isOptionScroll = true;
	    				break;
	    			}

	    			test = test.parentElement;
	    		}

	    		if (!isOptionScroll) {
	    			// console.log('SB: scrollListener:Close Options');
	    			//closeOptions();
	    			positionNode(event);
	    		}
	    	}

	    	function closeOptions(keepFocus = false) {
	    		// console.log('SB: closeOptions: keepFocus=' + keepFocus);
	    		// Re-parent options
	    		if (_openParent) {
	    			_openParent.appendChild(_openNode);
	    		}

	    		_openNode = undefined;
	    		_openParent = undefined;

	    		if (globalClickListener) {
	    			document.removeEventListener("click", globalClickListener);
	    			$$invalidate(48, globalClickListener = null);
	    		}

	    		if (globalKeyListener) {
	    			document.removeEventListener("keydown", globalKeyListener);
	    			$$invalidate(49, globalKeyListener = null);
	    		}

	    		if (keepFocus) {
	    			// console.log('SB: closeOptions:focus Highlight')
	    			_inputElement.focus();

	    			$$invalidate(27, _hasFocus = true);
	    		}

	    		$$invalidate(33, _showSuggestions = false);
	    		document.removeEventListener("wheel", handleScroll);
	    		window.removeEventListener("scroll", handleScroll);
	    		window.removeEventListener("resize", handleScroll);
	    	}

	    	function openOptions(event) {
	    		$$invalidate(33, _showSuggestions = true);
	    		_inputElement.focus();
	    	}

	    	function valueChanged(event, suppressSuggest = false) {
	    		$$invalidate(21, _dirty = true);
	    		$$invalidate(0, value = _untrimmedValue.trim());

	    		if (value === _lastValue) {
	    			return;
	    		}

	    		// console.log('suppressSuggest', suppressSuggest);
	    		if (!suppressSuggest && get$1(callbacks, "suggest")) {
	    			_suggestionsDebounce();
	    		}

	    		_lastValue = value;
	    		doValidate.call(this);

	    		// Avoid short circuit handling if changed handler changes a state value
	    		window.setTimeout(() => {
	    			dispatch("changed", value);
	    		});
	    	}

	    	function doValidate() {
	    		_builtInErrors = [];
	    		$$invalidate(22, _errors = errors ? errors : []);

	    		if (required) {
	    			if (!value || value === "") {
	    				_builtInErrors.push($_("validateRequired"));
	    			}
	    		}

	    		if (hasValue$3(maxLength)) {
	    			if (value && value.trim().length > maxLength) {
	    				_builtInErrors.push($_("validateTooLong"));
	    			}
	    		}

	    		let myRegex;

	    		if (hasValue$3(regexkey) && _printos) {
	    			myRegex = _printos.client.v1.getValidator(regexkey);

	    			if (!myRegex) {
	    				console.log("Could not find PrintOS validator", regexkey);
	    			}
	    		} else {
	    			myRegex = regex;

	    			if (regexmessage) {
	    				myRegex.message = regexmessage;
	    			}
	    		}

	    		if (hasValue$3(myRegex) && notEmpty(value) && notEmpty(myRegex.expression)) {
	    			let exp = notEmpty(myRegex.flags)
	    			? new RegExp(myRegex.expression, myRegex.flags)
	    			: new RegExp(myRegex.expression);

	    			if (!exp.test(value)) {
	    				const myMessage = myRegex.message
	    				? unescape(myRegex.message)
	    				: $_("validateRegex");

	    				_builtInErrors.push(myMessage);
	    			}
	    		}

	    		if (validation) {
	    			$$invalidate(22, _errors = _errors.concat(_builtInErrors));
	    		}

	    		window.setTimeout(() => {
	    			let valid = _errors.length === 0;

	    			if (_lastValid !== valid) {
	    				_lastValid = valid;
	    				dispatch("valid", valid);

	    				if (notEmpty(value) && !valid && !_dirty) {
	    					$$invalidate(21, _dirty = true);
	    				}
	    			}
	    		});
	    	}

	    	function input_input_handler() {
	    		_untrimmedValue = this.value;
	    		$$invalidate(23, _untrimmedValue);
	    	}

	    	function input_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_inputElement = $$value;
	    			$$invalidate(24, _inputElement);
	    		});
	    	}

	    	function input_input_handler_1() {
	    		_untrimmedValue = this.value;
	    		$$invalidate(23, _untrimmedValue);
	    	}

	    	function input_binding_1($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_inputElement = $$value;
	    			$$invalidate(24, _inputElement);
	    		});
	    	}

	    	function icon_name_binding(value) {
	    		iconName = value;
	    		$$invalidate(5, iconName);
	    	}

	    	function icon_path_binding(value) {
	    		iconPath = value;
	    		$$invalidate(6, iconPath);
	    	}

	    	function icon_url_binding(value) {
	    		iconUrl = value;
	    		$$invalidate(7, iconUrl);
	    	}

	    	const click_handler = (suggestion, event) => handleSuggestionClicked(suggestion);

	    	function div2_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_highlightElement = $$value;
	    			$$invalidate(26, _highlightElement);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("globalClickListener" in $$props) $$invalidate(48, globalClickListener = $$props.globalClickListener);
	    		if ("globalKeyListener" in $$props) $$invalidate(49, globalKeyListener = $$props.globalKeyListener);
	    		if ("display" in $$props) $$invalidate(2, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(50, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(51, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(52, density = $$props.density);
	    		if ("value" in $$props) $$invalidate(0, value = $$props.value);
	    		if ("label" in $$props) $$invalidate(1, label = $$props.label);
	    		if ("placeholder" in $$props) $$invalidate(11, placeholder = $$props.placeholder);
	    		if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	    		if ("maxLength" in $$props) $$invalidate(4, maxLength = $$props.maxLength);
	    		if ("iconName" in $$props) $$invalidate(5, iconName = $$props.iconName);
	    		if ("iconPath" in $$props) $$invalidate(6, iconPath = $$props.iconPath);
	    		if ("iconUrl" in $$props) $$invalidate(7, iconUrl = $$props.iconUrl);
	    		if ("required" in $$props) $$invalidate(8, required = $$props.required);
	    		if ("disabled" in $$props) $$invalidate(9, disabled = $$props.disabled);
	    		if ("validation" in $$props) $$invalidate(53, validation = $$props.validation);
	    		if ("errors" in $$props) $$invalidate(57, errors = $$props.errors);
	    		if ("regex" in $$props) $$invalidate(54, regex = $$props.regex);
	    		if ("regexkey" in $$props) $$invalidate(55, regexkey = $$props.regexkey);
	    		if ("regexmessage" in $$props) $$invalidate(58, regexmessage = $$props.regexmessage);
	    		if ("callbacks" in $$props) $$invalidate(59, callbacks = $$props.callbacks);
	    		if ("_suggestionsDebounce" in $$props) $$invalidate(60, _suggestionsDebounce = $$props._suggestionsDebounce);
	    		if ("inputElement" in $$props) $$invalidate(56, inputElement = $$props.inputElement);
	    		if ("password" in $$props) $$invalidate(12, password = $$props.password);
	    		if ("autocomplete" in $$props) $$invalidate(10, autocomplete = $$props.autocomplete);
	    		if ("id" in $$props) $$invalidate(61, id = $$props.id);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty[0] & /*value*/ 1) {
	    			// Computed values
	    			$$invalidate(43, _hasValue = notEmpty(value));
	    		}

	    		if ($$self.$$.dirty[0] & /*label*/ 2) {
	    			$$invalidate(44, _hasLabel = notEmpty(label));
	    		}
	    	};

	    	return [
	    		value,
	    		label,
	    		display,
	    		hint,
	    		maxLength,
	    		iconName,
	    		iconPath,
	    		iconUrl,
	    		required,
	    		disabled,
	    		autocomplete,
	    		placeholder,
	    		password,
	    		handleFocus,
	    		handleBlur,
	    		handleKeyDown,
	    		handleClick,
	    		handleClear,
	    		globalClicks,
	    		positionOptions,
	    		preventClickPropagation,
	    		_dirty,
	    		_errors,
	    		_untrimmedValue,
	    		_inputElement,
	    		_upward,
	    		_highlightElement,
	    		_hasFocus,
	    		_theme,
	    		_shape,
	    		_density,
	    		_loadingSuggestions,
	    		_suggestions,
	    		_showSuggestions,
	    		_autocomplete,
	    		_labelId,
	    		_inputId,
	    		_clearId,
	    		_capId,
	    		_messageId,
	    		_statusIconId,
	    		_constraintId,
	    		_optionsId,
	    		_hasValue,
	    		_hasLabel,
	    		$_,
	    		handleSuggestionClicked,
	    		valueChanged,
	    		globalClickListener,
	    		globalKeyListener,
	    		theme,
	    		shape,
	    		density,
	    		validation,
	    		regex,
	    		regexkey,
	    		inputElement,
	    		errors,
	    		regexmessage,
	    		callbacks,
	    		_suggestionsDebounce,
	    		id,
	    		positionNode,
	    		handleScroll,
	    		closeOptions,
	    		openOptions,
	    		input_input_handler,
	    		input_binding,
	    		input_input_handler_1,
	    		input_binding_1,
	    		icon_name_binding,
	    		icon_path_binding,
	    		icon_url_binding,
	    		click_handler,
	    		div2_binding
	    	];
	    }

	    class TextBox extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document_1$3.getElementById("svelte-1wnlerg-style")) add_css$e();

	    		init(
	    			this,
	    			options,
	    			instance$e,
	    			create_fragment$e,
	    			safe_not_equal,
	    			{
	    				globalClickListener: 48,
	    				globalKeyListener: 49,
	    				display: 2,
	    				theme: 50,
	    				shape: 51,
	    				density: 52,
	    				value: 0,
	    				label: 1,
	    				placeholder: 11,
	    				hint: 3,
	    				maxLength: 4,
	    				iconName: 5,
	    				iconPath: 6,
	    				iconUrl: 7,
	    				required: 8,
	    				disabled: 9,
	    				validation: 53,
	    				errors: 57,
	    				regex: 54,
	    				regexkey: 55,
	    				regexmessage: 58,
	    				callbacks: 59,
	    				_suggestionsDebounce: 60,
	    				inputElement: 56,
	    				password: 12,
	    				autocomplete: 10,
	    				id: 61,
	    				handleFocus: 13,
	    				handleBlur: 14,
	    				handleKeyDown: 15,
	    				handleClick: 16,
	    				handleClear: 17,
	    				globalClicks: 18,
	    				positionOptions: 19,
	    				positionNode: 62,
	    				handleScroll: 63,
	    				preventClickPropagation: 20,
	    				closeOptions: 64,
	    				openOptions: 65
	    			},
	    			[-1, -1, -1, -1]
	    		);
	    	}

	    	get handleFocus() {
	    		return this.$$.ctx[13];
	    	}

	    	get handleBlur() {
	    		return this.$$.ctx[14];
	    	}

	    	get handleKeyDown() {
	    		return this.$$.ctx[15];
	    	}

	    	get handleClick() {
	    		return this.$$.ctx[16];
	    	}

	    	get handleClear() {
	    		return this.$$.ctx[17];
	    	}

	    	get globalClicks() {
	    		return this.$$.ctx[18];
	    	}

	    	get positionOptions() {
	    		return this.$$.ctx[19];
	    	}

	    	get positionNode() {
	    		return this.$$.ctx[62];
	    	}

	    	get handleScroll() {
	    		return this.$$.ctx[63];
	    	}

	    	get preventClickPropagation() {
	    		return preventClickPropagation;
	    	}

	    	get closeOptions() {
	    		return this.$$.ctx[64];
	    	}

	    	get openOptions() {
	    		return this.$$.ctx[65];
	    	}
	    }

	    var moment = createCommonjsModule(function (module, exports) {
	    (function (global, factory) {
	        module.exports = factory() ;
	    }(commonjsGlobal$1, (function () {
	        var hookCallback;

	        function hooks() {
	            return hookCallback.apply(null, arguments);
	        }

	        // This is done to register the method called with moment()
	        // without creating circular dependencies.
	        function setHookCallback(callback) {
	            hookCallback = callback;
	        }

	        function isArray(input) {
	            return (
	                input instanceof Array ||
	                Object.prototype.toString.call(input) === '[object Array]'
	            );
	        }

	        function isObject(input) {
	            // IE8 will treat undefined and null as object if it wasn't for
	            // input != null
	            return (
	                input != null &&
	                Object.prototype.toString.call(input) === '[object Object]'
	            );
	        }

	        function hasOwnProp(a, b) {
	            return Object.prototype.hasOwnProperty.call(a, b);
	        }

	        function isObjectEmpty(obj) {
	            if (Object.getOwnPropertyNames) {
	                return Object.getOwnPropertyNames(obj).length === 0;
	            } else {
	                var k;
	                for (k in obj) {
	                    if (hasOwnProp(obj, k)) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        }

	        function isUndefined(input) {
	            return input === void 0;
	        }

	        function isNumber(input) {
	            return (
	                typeof input === 'number' ||
	                Object.prototype.toString.call(input) === '[object Number]'
	            );
	        }

	        function isDate(input) {
	            return (
	                input instanceof Date ||
	                Object.prototype.toString.call(input) === '[object Date]'
	            );
	        }

	        function map(arr, fn) {
	            var res = [],
	                i,
	                arrLen = arr.length;
	            for (i = 0; i < arrLen; ++i) {
	                res.push(fn(arr[i], i));
	            }
	            return res;
	        }

	        function extend(a, b) {
	            for (var i in b) {
	                if (hasOwnProp(b, i)) {
	                    a[i] = b[i];
	                }
	            }

	            if (hasOwnProp(b, 'toString')) {
	                a.toString = b.toString;
	            }

	            if (hasOwnProp(b, 'valueOf')) {
	                a.valueOf = b.valueOf;
	            }

	            return a;
	        }

	        function createUTC(input, format, locale, strict) {
	            return createLocalOrUTC(input, format, locale, strict, true).utc();
	        }

	        function defaultParsingFlags() {
	            // We need to deep clone this object.
	            return {
	                empty: false,
	                unusedTokens: [],
	                unusedInput: [],
	                overflow: -2,
	                charsLeftOver: 0,
	                nullInput: false,
	                invalidEra: null,
	                invalidMonth: null,
	                invalidFormat: false,
	                userInvalidated: false,
	                iso: false,
	                parsedDateParts: [],
	                era: null,
	                meridiem: null,
	                rfc2822: false,
	                weekdayMismatch: false,
	            };
	        }

	        function getParsingFlags(m) {
	            if (m._pf == null) {
	                m._pf = defaultParsingFlags();
	            }
	            return m._pf;
	        }

	        var some;
	        if (Array.prototype.some) {
	            some = Array.prototype.some;
	        } else {
	            some = function (fun) {
	                var t = Object(this),
	                    len = t.length >>> 0,
	                    i;

	                for (i = 0; i < len; i++) {
	                    if (i in t && fun.call(this, t[i], i, t)) {
	                        return true;
	                    }
	                }

	                return false;
	            };
	        }

	        function isValid(m) {
	            var flags = null,
	                parsedParts = false,
	                isNowValid = m._d && !isNaN(m._d.getTime());
	            if (isNowValid) {
	                flags = getParsingFlags(m);
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                });
	                isNowValid =
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	                if (m._strict) {
	                    isNowValid =
	                        isNowValid &&
	                        flags.charsLeftOver === 0 &&
	                        flags.unusedTokens.length === 0 &&
	                        flags.bigHour === undefined;
	                }
	            }
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	            return m._isValid;
	        }

	        function createInvalid(flags) {
	            var m = createUTC(NaN);
	            if (flags != null) {
	                extend(getParsingFlags(m), flags);
	            } else {
	                getParsingFlags(m).userInvalidated = true;
	            }

	            return m;
	        }

	        // Plugins that add properties should also add the key here (null value),
	        // so we can properly clone ourselves.
	        var momentProperties = (hooks.momentProperties = []),
	            updateInProgress = false;

	        function copyConfig(to, from) {
	            var i,
	                prop,
	                val,
	                momentPropertiesLen = momentProperties.length;

	            if (!isUndefined(from._isAMomentObject)) {
	                to._isAMomentObject = from._isAMomentObject;
	            }
	            if (!isUndefined(from._i)) {
	                to._i = from._i;
	            }
	            if (!isUndefined(from._f)) {
	                to._f = from._f;
	            }
	            if (!isUndefined(from._l)) {
	                to._l = from._l;
	            }
	            if (!isUndefined(from._strict)) {
	                to._strict = from._strict;
	            }
	            if (!isUndefined(from._tzm)) {
	                to._tzm = from._tzm;
	            }
	            if (!isUndefined(from._isUTC)) {
	                to._isUTC = from._isUTC;
	            }
	            if (!isUndefined(from._offset)) {
	                to._offset = from._offset;
	            }
	            if (!isUndefined(from._pf)) {
	                to._pf = getParsingFlags(from);
	            }
	            if (!isUndefined(from._locale)) {
	                to._locale = from._locale;
	            }

	            if (momentPropertiesLen > 0) {
	                for (i = 0; i < momentPropertiesLen; i++) {
	                    prop = momentProperties[i];
	                    val = from[prop];
	                    if (!isUndefined(val)) {
	                        to[prop] = val;
	                    }
	                }
	            }

	            return to;
	        }

	        // Moment prototype object
	        function Moment(config) {
	            copyConfig(this, config);
	            this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	            if (!this.isValid()) {
	                this._d = new Date(NaN);
	            }
	            // Prevent infinite loop in case updateOffset creates new moment
	            // objects.
	            if (updateInProgress === false) {
	                updateInProgress = true;
	                hooks.updateOffset(this);
	                updateInProgress = false;
	            }
	        }

	        function isMoment(obj) {
	            return (
	                obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	            );
	        }

	        function warn(msg) {
	            if (
	                hooks.suppressDeprecationWarnings === false &&
	                typeof console !== 'undefined' &&
	                console.warn
	            ) {
	                console.warn('Deprecation warning: ' + msg);
	            }
	        }

	        function deprecate(msg, fn) {
	            var firstTime = true;

	            return extend(function () {
	                if (hooks.deprecationHandler != null) {
	                    hooks.deprecationHandler(null, msg);
	                }
	                if (firstTime) {
	                    var args = [],
	                        arg,
	                        i,
	                        key,
	                        argLen = arguments.length;
	                    for (i = 0; i < argLen; i++) {
	                        arg = '';
	                        if (typeof arguments[i] === 'object') {
	                            arg += '\n[' + i + '] ';
	                            for (key in arguments[0]) {
	                                if (hasOwnProp(arguments[0], key)) {
	                                    arg += key + ': ' + arguments[0][key] + ', ';
	                                }
	                            }
	                            arg = arg.slice(0, -2); // Remove trailing comma and space
	                        } else {
	                            arg = arguments[i];
	                        }
	                        args.push(arg);
	                    }
	                    warn(
	                        msg +
	                            '\nArguments: ' +
	                            Array.prototype.slice.call(args).join('') +
	                            '\n' +
	                            new Error().stack
	                    );
	                    firstTime = false;
	                }
	                return fn.apply(this, arguments);
	            }, fn);
	        }

	        var deprecations = {};

	        function deprecateSimple(name, msg) {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(name, msg);
	            }
	            if (!deprecations[name]) {
	                warn(msg);
	                deprecations[name] = true;
	            }
	        }

	        hooks.suppressDeprecationWarnings = false;
	        hooks.deprecationHandler = null;

	        function isFunction(input) {
	            return (
	                (typeof Function !== 'undefined' && input instanceof Function) ||
	                Object.prototype.toString.call(input) === '[object Function]'
	            );
	        }

	        function set(config) {
	            var prop, i;
	            for (i in config) {
	                if (hasOwnProp(config, i)) {
	                    prop = config[i];
	                    if (isFunction(prop)) {
	                        this[i] = prop;
	                    } else {
	                        this['_' + i] = prop;
	                    }
	                }
	            }
	            this._config = config;
	            // Lenient ordinal parsing accepts just a number in addition to
	            // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	            // TODO: Remove "ordinalParse" fallback in next major release.
	            this._dayOfMonthOrdinalParseLenient = new RegExp(
	                (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                    '|' +
	                    /\d{1,2}/.source
	            );
	        }

	        function mergeConfigs(parentConfig, childConfig) {
	            var res = extend({}, parentConfig),
	                prop;
	            for (prop in childConfig) {
	                if (hasOwnProp(childConfig, prop)) {
	                    if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                        res[prop] = {};
	                        extend(res[prop], parentConfig[prop]);
	                        extend(res[prop], childConfig[prop]);
	                    } else if (childConfig[prop] != null) {
	                        res[prop] = childConfig[prop];
	                    } else {
	                        delete res[prop];
	                    }
	                }
	            }
	            for (prop in parentConfig) {
	                if (
	                    hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])
	                ) {
	                    // make sure changes to properties don't modify parent config
	                    res[prop] = extend({}, res[prop]);
	                }
	            }
	            return res;
	        }

	        function Locale(config) {
	            if (config != null) {
	                this.set(config);
	            }
	        }

	        var keys;

	        if (Object.keys) {
	            keys = Object.keys;
	        } else {
	            keys = function (obj) {
	                var i,
	                    res = [];
	                for (i in obj) {
	                    if (hasOwnProp(obj, i)) {
	                        res.push(i);
	                    }
	                }
	                return res;
	            };
	        }

	        var defaultCalendar = {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        };

	        function calendar(key, mom, now) {
	            var output = this._calendar[key] || this._calendar['sameElse'];
	            return isFunction(output) ? output.call(mom, now) : output;
	        }

	        function zeroFill(number, targetLength, forceSign) {
	            var absNumber = '' + Math.abs(number),
	                zerosToFill = targetLength - absNumber.length,
	                sign = number >= 0;
	            return (
	                (sign ? (forceSign ? '+' : '') : '-') +
	                Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	                absNumber
	            );
	        }

	        var formattingTokens =
	                /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	            localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	            formatFunctions = {},
	            formatTokenFunctions = {};

	        // token:    'M'
	        // padded:   ['MM', 2]
	        // ordinal:  'Mo'
	        // callback: function () { this.month() + 1 }
	        function addFormatToken(token, padded, ordinal, callback) {
	            var func = callback;
	            if (typeof callback === 'string') {
	                func = function () {
	                    return this[callback]();
	                };
	            }
	            if (token) {
	                formatTokenFunctions[token] = func;
	            }
	            if (padded) {
	                formatTokenFunctions[padded[0]] = function () {
	                    return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	                };
	            }
	            if (ordinal) {
	                formatTokenFunctions[ordinal] = function () {
	                    return this.localeData().ordinal(
	                        func.apply(this, arguments),
	                        token
	                    );
	                };
	            }
	        }

	        function removeFormattingTokens(input) {
	            if (input.match(/\[[\s\S]/)) {
	                return input.replace(/^\[|\]$/g, '');
	            }
	            return input.replace(/\\/g, '');
	        }

	        function makeFormatFunction(format) {
	            var array = format.match(formattingTokens),
	                i,
	                length;

	            for (i = 0, length = array.length; i < length; i++) {
	                if (formatTokenFunctions[array[i]]) {
	                    array[i] = formatTokenFunctions[array[i]];
	                } else {
	                    array[i] = removeFormattingTokens(array[i]);
	                }
	            }

	            return function (mom) {
	                var output = '',
	                    i;
	                for (i = 0; i < length; i++) {
	                    output += isFunction(array[i])
	                        ? array[i].call(mom, format)
	                        : array[i];
	                }
	                return output;
	            };
	        }

	        // format date using native date object
	        function formatMoment(m, format) {
	            if (!m.isValid()) {
	                return m.localeData().invalidDate();
	            }

	            format = expandFormat(format, m.localeData());
	            formatFunctions[format] =
	                formatFunctions[format] || makeFormatFunction(format);

	            return formatFunctions[format](m);
	        }

	        function expandFormat(format, locale) {
	            var i = 5;

	            function replaceLongDateFormatTokens(input) {
	                return locale.longDateFormat(input) || input;
	            }

	            localFormattingTokens.lastIndex = 0;
	            while (i >= 0 && localFormattingTokens.test(format)) {
	                format = format.replace(
	                    localFormattingTokens,
	                    replaceLongDateFormatTokens
	                );
	                localFormattingTokens.lastIndex = 0;
	                i -= 1;
	            }

	            return format;
	        }

	        var defaultLongDateFormat = {
	            LTS: 'h:mm:ss A',
	            LT: 'h:mm A',
	            L: 'MM/DD/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        };

	        function longDateFormat(key) {
	            var format = this._longDateFormat[key],
	                formatUpper = this._longDateFormat[key.toUpperCase()];

	            if (format || !formatUpper) {
	                return format;
	            }

	            this._longDateFormat[key] = formatUpper
	                .match(formattingTokens)
	                .map(function (tok) {
	                    if (
	                        tok === 'MMMM' ||
	                        tok === 'MM' ||
	                        tok === 'DD' ||
	                        tok === 'dddd'
	                    ) {
	                        return tok.slice(1);
	                    }
	                    return tok;
	                })
	                .join('');

	            return this._longDateFormat[key];
	        }

	        var defaultInvalidDate = 'Invalid date';

	        function invalidDate() {
	            return this._invalidDate;
	        }

	        var defaultOrdinal = '%d',
	            defaultDayOfMonthOrdinalParse = /\d{1,2}/;

	        function ordinal(number) {
	            return this._ordinal.replace('%d', number);
	        }

	        var defaultRelativeTime = {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            w: 'a week',
	            ww: '%d weeks',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        };

	        function relativeTime(number, withoutSuffix, string, isFuture) {
	            var output = this._relativeTime[string];
	            return isFunction(output)
	                ? output(number, withoutSuffix, string, isFuture)
	                : output.replace(/%d/i, number);
	        }

	        function pastFuture(diff, output) {
	            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	            return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	        }

	        var aliases = {
	            D: 'date',
	            dates: 'date',
	            date: 'date',
	            d: 'day',
	            days: 'day',
	            day: 'day',
	            e: 'weekday',
	            weekdays: 'weekday',
	            weekday: 'weekday',
	            E: 'isoWeekday',
	            isoweekdays: 'isoWeekday',
	            isoweekday: 'isoWeekday',
	            DDD: 'dayOfYear',
	            dayofyears: 'dayOfYear',
	            dayofyear: 'dayOfYear',
	            h: 'hour',
	            hours: 'hour',
	            hour: 'hour',
	            ms: 'millisecond',
	            milliseconds: 'millisecond',
	            millisecond: 'millisecond',
	            m: 'minute',
	            minutes: 'minute',
	            minute: 'minute',
	            M: 'month',
	            months: 'month',
	            month: 'month',
	            Q: 'quarter',
	            quarters: 'quarter',
	            quarter: 'quarter',
	            s: 'second',
	            seconds: 'second',
	            second: 'second',
	            gg: 'weekYear',
	            weekyears: 'weekYear',
	            weekyear: 'weekYear',
	            GG: 'isoWeekYear',
	            isoweekyears: 'isoWeekYear',
	            isoweekyear: 'isoWeekYear',
	            w: 'week',
	            weeks: 'week',
	            week: 'week',
	            W: 'isoWeek',
	            isoweeks: 'isoWeek',
	            isoweek: 'isoWeek',
	            y: 'year',
	            years: 'year',
	            year: 'year',
	        };

	        function normalizeUnits(units) {
	            return typeof units === 'string'
	                ? aliases[units] || aliases[units.toLowerCase()]
	                : undefined;
	        }

	        function normalizeObjectUnits(inputObject) {
	            var normalizedInput = {},
	                normalizedProp,
	                prop;

	            for (prop in inputObject) {
	                if (hasOwnProp(inputObject, prop)) {
	                    normalizedProp = normalizeUnits(prop);
	                    if (normalizedProp) {
	                        normalizedInput[normalizedProp] = inputObject[prop];
	                    }
	                }
	            }

	            return normalizedInput;
	        }

	        var priorities = {
	            date: 9,
	            day: 11,
	            weekday: 11,
	            isoWeekday: 11,
	            dayOfYear: 4,
	            hour: 13,
	            millisecond: 16,
	            minute: 14,
	            month: 8,
	            quarter: 7,
	            second: 15,
	            weekYear: 1,
	            isoWeekYear: 1,
	            week: 5,
	            isoWeek: 5,
	            year: 1,
	        };

	        function getPrioritizedUnits(unitsObj) {
	            var units = [],
	                u;
	            for (u in unitsObj) {
	                if (hasOwnProp(unitsObj, u)) {
	                    units.push({ unit: u, priority: priorities[u] });
	                }
	            }
	            units.sort(function (a, b) {
	                return a.priority - b.priority;
	            });
	            return units;
	        }

	        var match1 = /\d/, //       0 - 9
	            match2 = /\d\d/, //      00 - 99
	            match3 = /\d{3}/, //     000 - 999
	            match4 = /\d{4}/, //    0000 - 9999
	            match6 = /[+-]?\d{6}/, // -999999 - 999999
	            match1to2 = /\d\d?/, //       0 - 99
	            match3to4 = /\d\d\d\d?/, //     999 - 9999
	            match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	            match1to3 = /\d{1,3}/, //       0 - 999
	            match1to4 = /\d{1,4}/, //       0 - 9999
	            match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	            matchUnsigned = /\d+/, //       0 - inf
	            matchSigned = /[+-]?\d+/, //    -inf - inf
	            matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	            matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	            matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	            // any word (or two) characters or numbers including two/three word month in arabic.
	            // includes scottish gaelic two word and hyphenated months
	            matchWord =
	                /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	            match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	            match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	            regexes;

	        regexes = {};

	        function addRegexToken(token, regex, strictRegex) {
	            regexes[token] = isFunction(regex)
	                ? regex
	                : function (isStrict, localeData) {
	                      return isStrict && strictRegex ? strictRegex : regex;
	                  };
	        }

	        function getParseRegexForToken(token, config) {
	            if (!hasOwnProp(regexes, token)) {
	                return new RegExp(unescapeFormat(token));
	            }

	            return regexes[token](config._strict, config._locale);
	        }

	        // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	        function unescapeFormat(s) {
	            return regexEscape(
	                s
	                    .replace('\\', '')
	                    .replace(
	                        /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                        function (matched, p1, p2, p3, p4) {
	                            return p1 || p2 || p3 || p4;
	                        }
	                    )
	            );
	        }

	        function regexEscape(s) {
	            return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	        }

	        function absFloor(number) {
	            if (number < 0) {
	                // -0 -> 0
	                return Math.ceil(number) || 0;
	            } else {
	                return Math.floor(number);
	            }
	        }

	        function toInt(argumentForCoercion) {
	            var coercedNumber = +argumentForCoercion,
	                value = 0;

	            if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	                value = absFloor(coercedNumber);
	            }

	            return value;
	        }

	        var tokens = {};

	        function addParseToken(token, callback) {
	            var i,
	                func = callback,
	                tokenLen;
	            if (typeof token === 'string') {
	                token = [token];
	            }
	            if (isNumber(callback)) {
	                func = function (input, array) {
	                    array[callback] = toInt(input);
	                };
	            }
	            tokenLen = token.length;
	            for (i = 0; i < tokenLen; i++) {
	                tokens[token[i]] = func;
	            }
	        }

	        function addWeekParseToken(token, callback) {
	            addParseToken(token, function (input, array, config, token) {
	                config._w = config._w || {};
	                callback(input, config._w, config, token);
	            });
	        }

	        function addTimeToArrayFromToken(token, input, config) {
	            if (input != null && hasOwnProp(tokens, token)) {
	                tokens[token](input, config._a, config, token);
	            }
	        }

	        function isLeapYear(year) {
	            return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	        }

	        var YEAR = 0,
	            MONTH = 1,
	            DATE = 2,
	            HOUR = 3,
	            MINUTE = 4,
	            SECOND = 5,
	            MILLISECOND = 6,
	            WEEK = 7,
	            WEEKDAY = 8;

	        // FORMATTING

	        addFormatToken('Y', 0, 0, function () {
	            var y = this.year();
	            return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	        });

	        addFormatToken(0, ['YY', 2], 0, function () {
	            return this.year() % 100;
	        });

	        addFormatToken(0, ['YYYY', 4], 0, 'year');
	        addFormatToken(0, ['YYYYY', 5], 0, 'year');
	        addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

	        // PARSING

	        addRegexToken('Y', matchSigned);
	        addRegexToken('YY', match1to2, match2);
	        addRegexToken('YYYY', match1to4, match4);
	        addRegexToken('YYYYY', match1to6, match6);
	        addRegexToken('YYYYYY', match1to6, match6);

	        addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	        addParseToken('YYYY', function (input, array) {
	            array[YEAR] =
	                input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	        });
	        addParseToken('YY', function (input, array) {
	            array[YEAR] = hooks.parseTwoDigitYear(input);
	        });
	        addParseToken('Y', function (input, array) {
	            array[YEAR] = parseInt(input, 10);
	        });

	        // HELPERS

	        function daysInYear(year) {
	            return isLeapYear(year) ? 366 : 365;
	        }

	        // HOOKS

	        hooks.parseTwoDigitYear = function (input) {
	            return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	        };

	        // MOMENTS

	        var getSetYear = makeGetSet('FullYear', true);

	        function getIsLeapYear() {
	            return isLeapYear(this.year());
	        }

	        function makeGetSet(unit, keepTime) {
	            return function (value) {
	                if (value != null) {
	                    set$1(this, unit, value);
	                    hooks.updateOffset(this, keepTime);
	                    return this;
	                } else {
	                    return get(this, unit);
	                }
	            };
	        }

	        function get(mom, unit) {
	            if (!mom.isValid()) {
	                return NaN;
	            }

	            var d = mom._d,
	                isUTC = mom._isUTC;

	            switch (unit) {
	                case 'Milliseconds':
	                    return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	                case 'Seconds':
	                    return isUTC ? d.getUTCSeconds() : d.getSeconds();
	                case 'Minutes':
	                    return isUTC ? d.getUTCMinutes() : d.getMinutes();
	                case 'Hours':
	                    return isUTC ? d.getUTCHours() : d.getHours();
	                case 'Date':
	                    return isUTC ? d.getUTCDate() : d.getDate();
	                case 'Day':
	                    return isUTC ? d.getUTCDay() : d.getDay();
	                case 'Month':
	                    return isUTC ? d.getUTCMonth() : d.getMonth();
	                case 'FullYear':
	                    return isUTC ? d.getUTCFullYear() : d.getFullYear();
	                default:
	                    return NaN; // Just in case
	            }
	        }

	        function set$1(mom, unit, value) {
	            var d, isUTC, year, month, date;

	            if (!mom.isValid() || isNaN(value)) {
	                return;
	            }

	            d = mom._d;
	            isUTC = mom._isUTC;

	            switch (unit) {
	                case 'Milliseconds':
	                    return void (isUTC
	                        ? d.setUTCMilliseconds(value)
	                        : d.setMilliseconds(value));
	                case 'Seconds':
	                    return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	                case 'Minutes':
	                    return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	                case 'Hours':
	                    return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	                case 'Date':
	                    return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	                // case 'Day': // Not real
	                //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	                // case 'Month': // Not used because we need to pass two variables
	                //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	                case 'FullYear':
	                    break; // See below ...
	                default:
	                    return; // Just in case
	            }

	            year = value;
	            month = mom.month();
	            date = mom.date();
	            date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	            void (isUTC
	                ? d.setUTCFullYear(year, month, date)
	                : d.setFullYear(year, month, date));
	        }

	        // MOMENTS

	        function stringGet(units) {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units]();
	            }
	            return this;
	        }

	        function stringSet(units, value) {
	            if (typeof units === 'object') {
	                units = normalizeObjectUnits(units);
	                var prioritized = getPrioritizedUnits(units),
	                    i,
	                    prioritizedLen = prioritized.length;
	                for (i = 0; i < prioritizedLen; i++) {
	                    this[prioritized[i].unit](units[prioritized[i].unit]);
	                }
	            } else {
	                units = normalizeUnits(units);
	                if (isFunction(this[units])) {
	                    return this[units](value);
	                }
	            }
	            return this;
	        }

	        function mod(n, x) {
	            return ((n % x) + x) % x;
	        }

	        var indexOf;

	        if (Array.prototype.indexOf) {
	            indexOf = Array.prototype.indexOf;
	        } else {
	            indexOf = function (o) {
	                // I know
	                var i;
	                for (i = 0; i < this.length; ++i) {
	                    if (this[i] === o) {
	                        return i;
	                    }
	                }
	                return -1;
	            };
	        }

	        function daysInMonth(year, month) {
	            if (isNaN(year) || isNaN(month)) {
	                return NaN;
	            }
	            var modMonth = mod(month, 12);
	            year += (month - modMonth) / 12;
	            return modMonth === 1
	                ? isLeapYear(year)
	                    ? 29
	                    : 28
	                : 31 - ((modMonth % 7) % 2);
	        }

	        // FORMATTING

	        addFormatToken('M', ['MM', 2], 'Mo', function () {
	            return this.month() + 1;
	        });

	        addFormatToken('MMM', 0, 0, function (format) {
	            return this.localeData().monthsShort(this, format);
	        });

	        addFormatToken('MMMM', 0, 0, function (format) {
	            return this.localeData().months(this, format);
	        });

	        // PARSING

	        addRegexToken('M', match1to2, match1to2NoLeadingZero);
	        addRegexToken('MM', match1to2, match2);
	        addRegexToken('MMM', function (isStrict, locale) {
	            return locale.monthsShortRegex(isStrict);
	        });
	        addRegexToken('MMMM', function (isStrict, locale) {
	            return locale.monthsRegex(isStrict);
	        });

	        addParseToken(['M', 'MM'], function (input, array) {
	            array[MONTH] = toInt(input) - 1;
	        });

	        addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	            var month = config._locale.monthsParse(input, token, config._strict);
	            // if we didn't find a month name, mark the date as invalid.
	            if (month != null) {
	                array[MONTH] = month;
	            } else {
	                getParsingFlags(config).invalidMonth = input;
	            }
	        });

	        // LOCALES

	        var defaultLocaleMonths =
	                'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                    '_'
	                ),
	            defaultLocaleMonthsShort =
	                'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	            MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	            defaultMonthsShortRegex = matchWord,
	            defaultMonthsRegex = matchWord;

	        function localeMonths(m, format) {
	            if (!m) {
	                return isArray(this._months)
	                    ? this._months
	                    : this._months['standalone'];
	            }
	            return isArray(this._months)
	                ? this._months[m.month()]
	                : this._months[
	                      (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                          ? 'format'
	                          : 'standalone'
	                  ][m.month()];
	        }

	        function localeMonthsShort(m, format) {
	            if (!m) {
	                return isArray(this._monthsShort)
	                    ? this._monthsShort
	                    : this._monthsShort['standalone'];
	            }
	            return isArray(this._monthsShort)
	                ? this._monthsShort[m.month()]
	                : this._monthsShort[
	                      MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	                  ][m.month()];
	        }

	        function handleStrictParse(monthName, format, strict) {
	            var i,
	                ii,
	                mom,
	                llc = monthName.toLocaleLowerCase();
	            if (!this._monthsParse) {
	                // this is not used
	                this._monthsParse = [];
	                this._longMonthsParse = [];
	                this._shortMonthsParse = [];
	                for (i = 0; i < 12; ++i) {
	                    mom = createUTC([2000, i]);
	                    this._shortMonthsParse[i] = this.monthsShort(
	                        mom,
	                        ''
	                    ).toLocaleLowerCase();
	                    this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	                }
	            }

	            if (strict) {
	                if (format === 'MMM') {
	                    ii = indexOf.call(this._shortMonthsParse, llc);
	                    return ii !== -1 ? ii : null;
	                } else {
	                    ii = indexOf.call(this._longMonthsParse, llc);
	                    return ii !== -1 ? ii : null;
	                }
	            } else {
	                if (format === 'MMM') {
	                    ii = indexOf.call(this._shortMonthsParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._longMonthsParse, llc);
	                    return ii !== -1 ? ii : null;
	                } else {
	                    ii = indexOf.call(this._longMonthsParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._shortMonthsParse, llc);
	                    return ii !== -1 ? ii : null;
	                }
	            }
	        }

	        function localeMonthsParse(monthName, format, strict) {
	            var i, mom, regex;

	            if (this._monthsParseExact) {
	                return handleStrictParse.call(this, monthName, format, strict);
	            }

	            if (!this._monthsParse) {
	                this._monthsParse = [];
	                this._longMonthsParse = [];
	                this._shortMonthsParse = [];
	            }

	            // TODO: add sorting
	            // Sorting makes sure if one month (or abbr) is a prefix of another
	            // see sorting in computeMonthsParse
	            for (i = 0; i < 12; i++) {
	                // make the regex if we don't have it already
	                mom = createUTC([2000, i]);
	                if (strict && !this._longMonthsParse[i]) {
	                    this._longMonthsParse[i] = new RegExp(
	                        '^' + this.months(mom, '').replace('.', '') + '$',
	                        'i'
	                    );
	                    this._shortMonthsParse[i] = new RegExp(
	                        '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                        'i'
	                    );
	                }
	                if (!strict && !this._monthsParse[i]) {
	                    regex =
	                        '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	                }
	                // test the regex
	                if (
	                    strict &&
	                    format === 'MMMM' &&
	                    this._longMonthsParse[i].test(monthName)
	                ) {
	                    return i;
	                } else if (
	                    strict &&
	                    format === 'MMM' &&
	                    this._shortMonthsParse[i].test(monthName)
	                ) {
	                    return i;
	                } else if (!strict && this._monthsParse[i].test(monthName)) {
	                    return i;
	                }
	            }
	        }

	        // MOMENTS

	        function setMonth(mom, value) {
	            if (!mom.isValid()) {
	                // No op
	                return mom;
	            }

	            if (typeof value === 'string') {
	                if (/^\d+$/.test(value)) {
	                    value = toInt(value);
	                } else {
	                    value = mom.localeData().monthsParse(value);
	                    // TODO: Another silent failure?
	                    if (!isNumber(value)) {
	                        return mom;
	                    }
	                }
	            }

	            var month = value,
	                date = mom.date();

	            date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	            void (mom._isUTC
	                ? mom._d.setUTCMonth(month, date)
	                : mom._d.setMonth(month, date));
	            return mom;
	        }

	        function getSetMonth(value) {
	            if (value != null) {
	                setMonth(this, value);
	                hooks.updateOffset(this, true);
	                return this;
	            } else {
	                return get(this, 'Month');
	            }
	        }

	        function getDaysInMonth() {
	            return daysInMonth(this.year(), this.month());
	        }

	        function monthsShortRegex(isStrict) {
	            if (this._monthsParseExact) {
	                if (!hasOwnProp(this, '_monthsRegex')) {
	                    computeMonthsParse.call(this);
	                }
	                if (isStrict) {
	                    return this._monthsShortStrictRegex;
	                } else {
	                    return this._monthsShortRegex;
	                }
	            } else {
	                if (!hasOwnProp(this, '_monthsShortRegex')) {
	                    this._monthsShortRegex = defaultMonthsShortRegex;
	                }
	                return this._monthsShortStrictRegex && isStrict
	                    ? this._monthsShortStrictRegex
	                    : this._monthsShortRegex;
	            }
	        }

	        function monthsRegex(isStrict) {
	            if (this._monthsParseExact) {
	                if (!hasOwnProp(this, '_monthsRegex')) {
	                    computeMonthsParse.call(this);
	                }
	                if (isStrict) {
	                    return this._monthsStrictRegex;
	                } else {
	                    return this._monthsRegex;
	                }
	            } else {
	                if (!hasOwnProp(this, '_monthsRegex')) {
	                    this._monthsRegex = defaultMonthsRegex;
	                }
	                return this._monthsStrictRegex && isStrict
	                    ? this._monthsStrictRegex
	                    : this._monthsRegex;
	            }
	        }

	        function computeMonthsParse() {
	            function cmpLenRev(a, b) {
	                return b.length - a.length;
	            }

	            var shortPieces = [],
	                longPieces = [],
	                mixedPieces = [],
	                i,
	                mom,
	                shortP,
	                longP;
	            for (i = 0; i < 12; i++) {
	                // make the regex if we don't have it already
	                mom = createUTC([2000, i]);
	                shortP = regexEscape(this.monthsShort(mom, ''));
	                longP = regexEscape(this.months(mom, ''));
	                shortPieces.push(shortP);
	                longPieces.push(longP);
	                mixedPieces.push(longP);
	                mixedPieces.push(shortP);
	            }
	            // Sorting makes sure if one month (or abbr) is a prefix of another it
	            // will match the longer piece.
	            shortPieces.sort(cmpLenRev);
	            longPieces.sort(cmpLenRev);
	            mixedPieces.sort(cmpLenRev);

	            this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	            this._monthsShortRegex = this._monthsRegex;
	            this._monthsStrictRegex = new RegExp(
	                '^(' + longPieces.join('|') + ')',
	                'i'
	            );
	            this._monthsShortStrictRegex = new RegExp(
	                '^(' + shortPieces.join('|') + ')',
	                'i'
	            );
	        }

	        function createDate(y, m, d, h, M, s, ms) {
	            // can't just apply() to create a date:
	            // https://stackoverflow.com/q/181348
	            var date;
	            // the date constructor remaps years 0-99 to 1900-1999
	            if (y < 100 && y >= 0) {
	                // preserve leap years using a full 400 year cycle, then reset
	                date = new Date(y + 400, m, d, h, M, s, ms);
	                if (isFinite(date.getFullYear())) {
	                    date.setFullYear(y);
	                }
	            } else {
	                date = new Date(y, m, d, h, M, s, ms);
	            }

	            return date;
	        }

	        function createUTCDate(y) {
	            var date, args;
	            // the Date.UTC function remaps years 0-99 to 1900-1999
	            if (y < 100 && y >= 0) {
	                args = Array.prototype.slice.call(arguments);
	                // preserve leap years using a full 400 year cycle, then reset
	                args[0] = y + 400;
	                date = new Date(Date.UTC.apply(null, args));
	                if (isFinite(date.getUTCFullYear())) {
	                    date.setUTCFullYear(y);
	                }
	            } else {
	                date = new Date(Date.UTC.apply(null, arguments));
	            }

	            return date;
	        }

	        // start-of-first-week - start-of-year
	        function firstWeekOffset(year, dow, doy) {
	            var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	                fwd = 7 + dow - doy,
	                // first-week day local weekday -- which local weekday is fwd
	                fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

	            return -fwdlw + fwd - 1;
	        }

	        // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	        function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	            var localWeekday = (7 + weekday - dow) % 7,
	                weekOffset = firstWeekOffset(year, dow, doy),
	                dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	                resYear,
	                resDayOfYear;

	            if (dayOfYear <= 0) {
	                resYear = year - 1;
	                resDayOfYear = daysInYear(resYear) + dayOfYear;
	            } else if (dayOfYear > daysInYear(year)) {
	                resYear = year + 1;
	                resDayOfYear = dayOfYear - daysInYear(year);
	            } else {
	                resYear = year;
	                resDayOfYear = dayOfYear;
	            }

	            return {
	                year: resYear,
	                dayOfYear: resDayOfYear,
	            };
	        }

	        function weekOfYear(mom, dow, doy) {
	            var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	                week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	                resWeek,
	                resYear;

	            if (week < 1) {
	                resYear = mom.year() - 1;
	                resWeek = week + weeksInYear(resYear, dow, doy);
	            } else if (week > weeksInYear(mom.year(), dow, doy)) {
	                resWeek = week - weeksInYear(mom.year(), dow, doy);
	                resYear = mom.year() + 1;
	            } else {
	                resYear = mom.year();
	                resWeek = week;
	            }

	            return {
	                week: resWeek,
	                year: resYear,
	            };
	        }

	        function weeksInYear(year, dow, doy) {
	            var weekOffset = firstWeekOffset(year, dow, doy),
	                weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	            return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	        }

	        // FORMATTING

	        addFormatToken('w', ['ww', 2], 'wo', 'week');
	        addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

	        // PARSING

	        addRegexToken('w', match1to2, match1to2NoLeadingZero);
	        addRegexToken('ww', match1to2, match2);
	        addRegexToken('W', match1to2, match1to2NoLeadingZero);
	        addRegexToken('WW', match1to2, match2);

	        addWeekParseToken(
	            ['w', 'ww', 'W', 'WW'],
	            function (input, week, config, token) {
	                week[token.substr(0, 1)] = toInt(input);
	            }
	        );

	        // HELPERS

	        // LOCALES

	        function localeWeek(mom) {
	            return weekOfYear(mom, this._week.dow, this._week.doy).week;
	        }

	        var defaultLocaleWeek = {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        };

	        function localeFirstDayOfWeek() {
	            return this._week.dow;
	        }

	        function localeFirstDayOfYear() {
	            return this._week.doy;
	        }

	        // MOMENTS

	        function getSetWeek(input) {
	            var week = this.localeData().week(this);
	            return input == null ? week : this.add((input - week) * 7, 'd');
	        }

	        function getSetISOWeek(input) {
	            var week = weekOfYear(this, 1, 4).week;
	            return input == null ? week : this.add((input - week) * 7, 'd');
	        }

	        // FORMATTING

	        addFormatToken('d', 0, 'do', 'day');

	        addFormatToken('dd', 0, 0, function (format) {
	            return this.localeData().weekdaysMin(this, format);
	        });

	        addFormatToken('ddd', 0, 0, function (format) {
	            return this.localeData().weekdaysShort(this, format);
	        });

	        addFormatToken('dddd', 0, 0, function (format) {
	            return this.localeData().weekdays(this, format);
	        });

	        addFormatToken('e', 0, 0, 'weekday');
	        addFormatToken('E', 0, 0, 'isoWeekday');

	        // PARSING

	        addRegexToken('d', match1to2);
	        addRegexToken('e', match1to2);
	        addRegexToken('E', match1to2);
	        addRegexToken('dd', function (isStrict, locale) {
	            return locale.weekdaysMinRegex(isStrict);
	        });
	        addRegexToken('ddd', function (isStrict, locale) {
	            return locale.weekdaysShortRegex(isStrict);
	        });
	        addRegexToken('dddd', function (isStrict, locale) {
	            return locale.weekdaysRegex(isStrict);
	        });

	        addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	            var weekday = config._locale.weekdaysParse(input, token, config._strict);
	            // if we didn't get a weekday name, mark the date as invalid
	            if (weekday != null) {
	                week.d = weekday;
	            } else {
	                getParsingFlags(config).invalidWeekday = input;
	            }
	        });

	        addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	            week[token] = toInt(input);
	        });

	        // HELPERS

	        function parseWeekday(input, locale) {
	            if (typeof input !== 'string') {
	                return input;
	            }

	            if (!isNaN(input)) {
	                return parseInt(input, 10);
	            }

	            input = locale.weekdaysParse(input);
	            if (typeof input === 'number') {
	                return input;
	            }

	            return null;
	        }

	        function parseIsoWeekday(input, locale) {
	            if (typeof input === 'string') {
	                return locale.weekdaysParse(input) % 7 || 7;
	            }
	            return isNaN(input) ? null : input;
	        }

	        // LOCALES
	        function shiftWeekdays(ws, n) {
	            return ws.slice(n, 7).concat(ws.slice(0, n));
	        }

	        var defaultLocaleWeekdays =
	                'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	            defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	            defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	            defaultWeekdaysRegex = matchWord,
	            defaultWeekdaysShortRegex = matchWord,
	            defaultWeekdaysMinRegex = matchWord;

	        function localeWeekdays(m, format) {
	            var weekdays = isArray(this._weekdays)
	                ? this._weekdays
	                : this._weekdays[
	                      m && m !== true && this._weekdays.isFormat.test(format)
	                          ? 'format'
	                          : 'standalone'
	                  ];
	            return m === true
	                ? shiftWeekdays(weekdays, this._week.dow)
	                : m
	                  ? weekdays[m.day()]
	                  : weekdays;
	        }

	        function localeWeekdaysShort(m) {
	            return m === true
	                ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	                : m
	                  ? this._weekdaysShort[m.day()]
	                  : this._weekdaysShort;
	        }

	        function localeWeekdaysMin(m) {
	            return m === true
	                ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	                : m
	                  ? this._weekdaysMin[m.day()]
	                  : this._weekdaysMin;
	        }

	        function handleStrictParse$1(weekdayName, format, strict) {
	            var i,
	                ii,
	                mom,
	                llc = weekdayName.toLocaleLowerCase();
	            if (!this._weekdaysParse) {
	                this._weekdaysParse = [];
	                this._shortWeekdaysParse = [];
	                this._minWeekdaysParse = [];

	                for (i = 0; i < 7; ++i) {
	                    mom = createUTC([2000, 1]).day(i);
	                    this._minWeekdaysParse[i] = this.weekdaysMin(
	                        mom,
	                        ''
	                    ).toLocaleLowerCase();
	                    this._shortWeekdaysParse[i] = this.weekdaysShort(
	                        mom,
	                        ''
	                    ).toLocaleLowerCase();
	                    this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	                }
	            }

	            if (strict) {
	                if (format === 'dddd') {
	                    ii = indexOf.call(this._weekdaysParse, llc);
	                    return ii !== -1 ? ii : null;
	                } else if (format === 'ddd') {
	                    ii = indexOf.call(this._shortWeekdaysParse, llc);
	                    return ii !== -1 ? ii : null;
	                } else {
	                    ii = indexOf.call(this._minWeekdaysParse, llc);
	                    return ii !== -1 ? ii : null;
	                }
	            } else {
	                if (format === 'dddd') {
	                    ii = indexOf.call(this._weekdaysParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._shortWeekdaysParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._minWeekdaysParse, llc);
	                    return ii !== -1 ? ii : null;
	                } else if (format === 'ddd') {
	                    ii = indexOf.call(this._shortWeekdaysParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._weekdaysParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._minWeekdaysParse, llc);
	                    return ii !== -1 ? ii : null;
	                } else {
	                    ii = indexOf.call(this._minWeekdaysParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._weekdaysParse, llc);
	                    if (ii !== -1) {
	                        return ii;
	                    }
	                    ii = indexOf.call(this._shortWeekdaysParse, llc);
	                    return ii !== -1 ? ii : null;
	                }
	            }
	        }

	        function localeWeekdaysParse(weekdayName, format, strict) {
	            var i, mom, regex;

	            if (this._weekdaysParseExact) {
	                return handleStrictParse$1.call(this, weekdayName, format, strict);
	            }

	            if (!this._weekdaysParse) {
	                this._weekdaysParse = [];
	                this._minWeekdaysParse = [];
	                this._shortWeekdaysParse = [];
	                this._fullWeekdaysParse = [];
	            }

	            for (i = 0; i < 7; i++) {
	                // make the regex if we don't have it already

	                mom = createUTC([2000, 1]).day(i);
	                if (strict && !this._fullWeekdaysParse[i]) {
	                    this._fullWeekdaysParse[i] = new RegExp(
	                        '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                        'i'
	                    );
	                    this._shortWeekdaysParse[i] = new RegExp(
	                        '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                        'i'
	                    );
	                    this._minWeekdaysParse[i] = new RegExp(
	                        '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                        'i'
	                    );
	                }
	                if (!this._weekdaysParse[i]) {
	                    regex =
	                        '^' +
	                        this.weekdays(mom, '') +
	                        '|^' +
	                        this.weekdaysShort(mom, '') +
	                        '|^' +
	                        this.weekdaysMin(mom, '');
	                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	                }
	                // test the regex
	                if (
	                    strict &&
	                    format === 'dddd' &&
	                    this._fullWeekdaysParse[i].test(weekdayName)
	                ) {
	                    return i;
	                } else if (
	                    strict &&
	                    format === 'ddd' &&
	                    this._shortWeekdaysParse[i].test(weekdayName)
	                ) {
	                    return i;
	                } else if (
	                    strict &&
	                    format === 'dd' &&
	                    this._minWeekdaysParse[i].test(weekdayName)
	                ) {
	                    return i;
	                } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                    return i;
	                }
	            }
	        }

	        // MOMENTS

	        function getSetDayOfWeek(input) {
	            if (!this.isValid()) {
	                return input != null ? this : NaN;
	            }

	            var day = get(this, 'Day');
	            if (input != null) {
	                input = parseWeekday(input, this.localeData());
	                return this.add(input - day, 'd');
	            } else {
	                return day;
	            }
	        }

	        function getSetLocaleDayOfWeek(input) {
	            if (!this.isValid()) {
	                return input != null ? this : NaN;
	            }
	            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	            return input == null ? weekday : this.add(input - weekday, 'd');
	        }

	        function getSetISODayOfWeek(input) {
	            if (!this.isValid()) {
	                return input != null ? this : NaN;
	            }

	            // behaves the same as moment#day except
	            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	            // as a setter, sunday should belong to the previous week.

	            if (input != null) {
	                var weekday = parseIsoWeekday(input, this.localeData());
	                return this.day(this.day() % 7 ? weekday : weekday - 7);
	            } else {
	                return this.day() || 7;
	            }
	        }

	        function weekdaysRegex(isStrict) {
	            if (this._weekdaysParseExact) {
	                if (!hasOwnProp(this, '_weekdaysRegex')) {
	                    computeWeekdaysParse.call(this);
	                }
	                if (isStrict) {
	                    return this._weekdaysStrictRegex;
	                } else {
	                    return this._weekdaysRegex;
	                }
	            } else {
	                if (!hasOwnProp(this, '_weekdaysRegex')) {
	                    this._weekdaysRegex = defaultWeekdaysRegex;
	                }
	                return this._weekdaysStrictRegex && isStrict
	                    ? this._weekdaysStrictRegex
	                    : this._weekdaysRegex;
	            }
	        }

	        function weekdaysShortRegex(isStrict) {
	            if (this._weekdaysParseExact) {
	                if (!hasOwnProp(this, '_weekdaysRegex')) {
	                    computeWeekdaysParse.call(this);
	                }
	                if (isStrict) {
	                    return this._weekdaysShortStrictRegex;
	                } else {
	                    return this._weekdaysShortRegex;
	                }
	            } else {
	                if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                    this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	                }
	                return this._weekdaysShortStrictRegex && isStrict
	                    ? this._weekdaysShortStrictRegex
	                    : this._weekdaysShortRegex;
	            }
	        }

	        function weekdaysMinRegex(isStrict) {
	            if (this._weekdaysParseExact) {
	                if (!hasOwnProp(this, '_weekdaysRegex')) {
	                    computeWeekdaysParse.call(this);
	                }
	                if (isStrict) {
	                    return this._weekdaysMinStrictRegex;
	                } else {
	                    return this._weekdaysMinRegex;
	                }
	            } else {
	                if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                    this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	                }
	                return this._weekdaysMinStrictRegex && isStrict
	                    ? this._weekdaysMinStrictRegex
	                    : this._weekdaysMinRegex;
	            }
	        }

	        function computeWeekdaysParse() {
	            function cmpLenRev(a, b) {
	                return b.length - a.length;
	            }

	            var minPieces = [],
	                shortPieces = [],
	                longPieces = [],
	                mixedPieces = [],
	                i,
	                mom,
	                minp,
	                shortp,
	                longp;
	            for (i = 0; i < 7; i++) {
	                // make the regex if we don't have it already
	                mom = createUTC([2000, 1]).day(i);
	                minp = regexEscape(this.weekdaysMin(mom, ''));
	                shortp = regexEscape(this.weekdaysShort(mom, ''));
	                longp = regexEscape(this.weekdays(mom, ''));
	                minPieces.push(minp);
	                shortPieces.push(shortp);
	                longPieces.push(longp);
	                mixedPieces.push(minp);
	                mixedPieces.push(shortp);
	                mixedPieces.push(longp);
	            }
	            // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	            // will match the longer piece.
	            minPieces.sort(cmpLenRev);
	            shortPieces.sort(cmpLenRev);
	            longPieces.sort(cmpLenRev);
	            mixedPieces.sort(cmpLenRev);

	            this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	            this._weekdaysShortRegex = this._weekdaysRegex;
	            this._weekdaysMinRegex = this._weekdaysRegex;

	            this._weekdaysStrictRegex = new RegExp(
	                '^(' + longPieces.join('|') + ')',
	                'i'
	            );
	            this._weekdaysShortStrictRegex = new RegExp(
	                '^(' + shortPieces.join('|') + ')',
	                'i'
	            );
	            this._weekdaysMinStrictRegex = new RegExp(
	                '^(' + minPieces.join('|') + ')',
	                'i'
	            );
	        }

	        // FORMATTING

	        function hFormat() {
	            return this.hours() % 12 || 12;
	        }

	        function kFormat() {
	            return this.hours() || 24;
	        }

	        addFormatToken('H', ['HH', 2], 0, 'hour');
	        addFormatToken('h', ['hh', 2], 0, hFormat);
	        addFormatToken('k', ['kk', 2], 0, kFormat);

	        addFormatToken('hmm', 0, 0, function () {
	            return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	        });

	        addFormatToken('hmmss', 0, 0, function () {
	            return (
	                '' +
	                hFormat.apply(this) +
	                zeroFill(this.minutes(), 2) +
	                zeroFill(this.seconds(), 2)
	            );
	        });

	        addFormatToken('Hmm', 0, 0, function () {
	            return '' + this.hours() + zeroFill(this.minutes(), 2);
	        });

	        addFormatToken('Hmmss', 0, 0, function () {
	            return (
	                '' +
	                this.hours() +
	                zeroFill(this.minutes(), 2) +
	                zeroFill(this.seconds(), 2)
	            );
	        });

	        function meridiem(token, lowercase) {
	            addFormatToken(token, 0, 0, function () {
	                return this.localeData().meridiem(
	                    this.hours(),
	                    this.minutes(),
	                    lowercase
	                );
	            });
	        }

	        meridiem('a', true);
	        meridiem('A', false);

	        // PARSING

	        function matchMeridiem(isStrict, locale) {
	            return locale._meridiemParse;
	        }

	        addRegexToken('a', matchMeridiem);
	        addRegexToken('A', matchMeridiem);
	        addRegexToken('H', match1to2, match1to2HasZero);
	        addRegexToken('h', match1to2, match1to2NoLeadingZero);
	        addRegexToken('k', match1to2, match1to2NoLeadingZero);
	        addRegexToken('HH', match1to2, match2);
	        addRegexToken('hh', match1to2, match2);
	        addRegexToken('kk', match1to2, match2);

	        addRegexToken('hmm', match3to4);
	        addRegexToken('hmmss', match5to6);
	        addRegexToken('Hmm', match3to4);
	        addRegexToken('Hmmss', match5to6);

	        addParseToken(['H', 'HH'], HOUR);
	        addParseToken(['k', 'kk'], function (input, array, config) {
	            var kInput = toInt(input);
	            array[HOUR] = kInput === 24 ? 0 : kInput;
	        });
	        addParseToken(['a', 'A'], function (input, array, config) {
	            config._isPm = config._locale.isPM(input);
	            config._meridiem = input;
	        });
	        addParseToken(['h', 'hh'], function (input, array, config) {
	            array[HOUR] = toInt(input);
	            getParsingFlags(config).bigHour = true;
	        });
	        addParseToken('hmm', function (input, array, config) {
	            var pos = input.length - 2;
	            array[HOUR] = toInt(input.substr(0, pos));
	            array[MINUTE] = toInt(input.substr(pos));
	            getParsingFlags(config).bigHour = true;
	        });
	        addParseToken('hmmss', function (input, array, config) {
	            var pos1 = input.length - 4,
	                pos2 = input.length - 2;
	            array[HOUR] = toInt(input.substr(0, pos1));
	            array[MINUTE] = toInt(input.substr(pos1, 2));
	            array[SECOND] = toInt(input.substr(pos2));
	            getParsingFlags(config).bigHour = true;
	        });
	        addParseToken('Hmm', function (input, array, config) {
	            var pos = input.length - 2;
	            array[HOUR] = toInt(input.substr(0, pos));
	            array[MINUTE] = toInt(input.substr(pos));
	        });
	        addParseToken('Hmmss', function (input, array, config) {
	            var pos1 = input.length - 4,
	                pos2 = input.length - 2;
	            array[HOUR] = toInt(input.substr(0, pos1));
	            array[MINUTE] = toInt(input.substr(pos1, 2));
	            array[SECOND] = toInt(input.substr(pos2));
	        });

	        // LOCALES

	        function localeIsPM(input) {
	            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	            // Using charAt should be more compatible.
	            return (input + '').toLowerCase().charAt(0) === 'p';
	        }

	        var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	            // Setting the hour should keep the time, because the user explicitly
	            // specified which hour they want. So trying to maintain the same hour (in
	            // a new timezone) makes sense. Adding/subtracting hours does not follow
	            // this rule.
	            getSetHour = makeGetSet('Hours', true);

	        function localeMeridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'pm' : 'PM';
	            } else {
	                return isLower ? 'am' : 'AM';
	            }
	        }

	        var baseConfig = {
	            calendar: defaultCalendar,
	            longDateFormat: defaultLongDateFormat,
	            invalidDate: defaultInvalidDate,
	            ordinal: defaultOrdinal,
	            dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	            relativeTime: defaultRelativeTime,

	            months: defaultLocaleMonths,
	            monthsShort: defaultLocaleMonthsShort,

	            week: defaultLocaleWeek,

	            weekdays: defaultLocaleWeekdays,
	            weekdaysMin: defaultLocaleWeekdaysMin,
	            weekdaysShort: defaultLocaleWeekdaysShort,

	            meridiemParse: defaultLocaleMeridiemParse,
	        };

	        // internal storage for locale config files
	        var locales = {},
	            localeFamilies = {},
	            globalLocale;

	        function commonPrefix(arr1, arr2) {
	            var i,
	                minl = Math.min(arr1.length, arr2.length);
	            for (i = 0; i < minl; i += 1) {
	                if (arr1[i] !== arr2[i]) {
	                    return i;
	                }
	            }
	            return minl;
	        }

	        function normalizeLocale(key) {
	            return key ? key.toLowerCase().replace('_', '-') : key;
	        }

	        // pick the locale from the array
	        // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	        // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	        function chooseLocale(names) {
	            var i = 0,
	                j,
	                next,
	                locale,
	                split;

	            while (i < names.length) {
	                split = normalizeLocale(names[i]).split('-');
	                j = split.length;
	                next = normalizeLocale(names[i + 1]);
	                next = next ? next.split('-') : null;
	                while (j > 0) {
	                    locale = loadLocale(split.slice(0, j).join('-'));
	                    if (locale) {
	                        return locale;
	                    }
	                    if (
	                        next &&
	                        next.length >= j &&
	                        commonPrefix(split, next) >= j - 1
	                    ) {
	                        //the next array item is better than a shallower substring of this one
	                        break;
	                    }
	                    j--;
	                }
	                i++;
	            }
	            return globalLocale;
	        }

	        function isLocaleNameSane(name) {
	            // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	            // Ensure name is available and function returns boolean
	            return !!(name && name.match('^[^/\\\\]*$'));
	        }

	        function loadLocale(name) {
	            var oldLocale = null,
	                aliasedRequire;
	            // TODO: Find a better way to register and load all the locales in Node
	            if (
	                locales[name] === undefined &&
	                'object' !== 'undefined' &&
	                module &&
	                module.exports &&
	                isLocaleNameSane(name)
	            ) {
	                try {
	                    oldLocale = globalLocale._abbr;
	                    aliasedRequire = commonjsRequire;
	                    aliasedRequire('./locale/' + name);
	                    getSetGlobalLocale(oldLocale);
	                } catch (e) {
	                    // mark as not found to avoid repeating expensive file require call causing high CPU
	                    // when trying to find en-US, en_US, en-us for every format call
	                    locales[name] = null; // null means not found
	                }
	            }
	            return locales[name];
	        }

	        // This function will load locale and then set the global locale.  If
	        // no arguments are passed in, it will simply return the current global
	        // locale key.
	        function getSetGlobalLocale(key, values) {
	            var data;
	            if (key) {
	                if (isUndefined(values)) {
	                    data = getLocale(key);
	                } else {
	                    data = defineLocale(key, values);
	                }

	                if (data) {
	                    // moment.duration._locale = moment._locale = data;
	                    globalLocale = data;
	                } else {
	                    if (typeof console !== 'undefined' && console.warn) {
	                        //warn user if arguments are passed but the locale could not be set
	                        console.warn(
	                            'Locale ' + key + ' not found. Did you forget to load it?'
	                        );
	                    }
	                }
	            }

	            return globalLocale._abbr;
	        }

	        function defineLocale(name, config) {
	            if (config !== null) {
	                var locale,
	                    parentConfig = baseConfig;
	                config.abbr = name;
	                if (locales[name] != null) {
	                    deprecateSimple(
	                        'defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                            'an existing locale. moment.defineLocale(localeName, ' +
	                            'config) should only be used for creating a new locale ' +
	                            'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                    );
	                    parentConfig = locales[name]._config;
	                } else if (config.parentLocale != null) {
	                    if (locales[config.parentLocale] != null) {
	                        parentConfig = locales[config.parentLocale]._config;
	                    } else {
	                        locale = loadLocale(config.parentLocale);
	                        if (locale != null) {
	                            parentConfig = locale._config;
	                        } else {
	                            if (!localeFamilies[config.parentLocale]) {
	                                localeFamilies[config.parentLocale] = [];
	                            }
	                            localeFamilies[config.parentLocale].push({
	                                name: name,
	                                config: config,
	                            });
	                            return null;
	                        }
	                    }
	                }
	                locales[name] = new Locale(mergeConfigs(parentConfig, config));

	                if (localeFamilies[name]) {
	                    localeFamilies[name].forEach(function (x) {
	                        defineLocale(x.name, x.config);
	                    });
	                }

	                // backwards compat for now: also set the locale
	                // make sure we set the locale AFTER all child locales have been
	                // created, so we won't end up with the child locale set.
	                getSetGlobalLocale(name);

	                return locales[name];
	            } else {
	                // useful for testing
	                delete locales[name];
	                return null;
	            }
	        }

	        function updateLocale(name, config) {
	            if (config != null) {
	                var locale,
	                    tmpLocale,
	                    parentConfig = baseConfig;

	                if (locales[name] != null && locales[name].parentLocale != null) {
	                    // Update existing child locale in-place to avoid memory-leaks
	                    locales[name].set(mergeConfigs(locales[name]._config, config));
	                } else {
	                    // MERGE
	                    tmpLocale = loadLocale(name);
	                    if (tmpLocale != null) {
	                        parentConfig = tmpLocale._config;
	                    }
	                    config = mergeConfigs(parentConfig, config);
	                    if (tmpLocale == null) {
	                        // updateLocale is called for creating a new locale
	                        // Set abbr so it will have a name (getters return
	                        // undefined otherwise).
	                        config.abbr = name;
	                    }
	                    locale = new Locale(config);
	                    locale.parentLocale = locales[name];
	                    locales[name] = locale;
	                }

	                // backwards compat for now: also set the locale
	                getSetGlobalLocale(name);
	            } else {
	                // pass null for config to unupdate, useful for tests
	                if (locales[name] != null) {
	                    if (locales[name].parentLocale != null) {
	                        locales[name] = locales[name].parentLocale;
	                        if (name === getSetGlobalLocale()) {
	                            getSetGlobalLocale(name);
	                        }
	                    } else if (locales[name] != null) {
	                        delete locales[name];
	                    }
	                }
	            }
	            return locales[name];
	        }

	        // returns locale data
	        function getLocale(key) {
	            var locale;

	            if (key && key._locale && key._locale._abbr) {
	                key = key._locale._abbr;
	            }

	            if (!key) {
	                return globalLocale;
	            }

	            if (!isArray(key)) {
	                //short-circuit everything else
	                locale = loadLocale(key);
	                if (locale) {
	                    return locale;
	                }
	                key = [key];
	            }

	            return chooseLocale(key);
	        }

	        function listLocales() {
	            return keys(locales);
	        }

	        function checkOverflow(m) {
	            var overflow,
	                a = m._a;

	            if (a && getParsingFlags(m).overflow === -2) {
	                overflow =
	                    a[MONTH] < 0 || a[MONTH] > 11
	                        ? MONTH
	                        : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                          ? DATE
	                          : a[HOUR] < 0 ||
	                              a[HOUR] > 24 ||
	                              (a[HOUR] === 24 &&
	                                  (a[MINUTE] !== 0 ||
	                                      a[SECOND] !== 0 ||
	                                      a[MILLISECOND] !== 0))
	                            ? HOUR
	                            : a[MINUTE] < 0 || a[MINUTE] > 59
	                              ? MINUTE
	                              : a[SECOND] < 0 || a[SECOND] > 59
	                                ? SECOND
	                                : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                                  ? MILLISECOND
	                                  : -1;

	                if (
	                    getParsingFlags(m)._overflowDayOfYear &&
	                    (overflow < YEAR || overflow > DATE)
	                ) {
	                    overflow = DATE;
	                }
	                if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                    overflow = WEEK;
	                }
	                if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                    overflow = WEEKDAY;
	                }

	                getParsingFlags(m).overflow = overflow;
	            }

	            return m;
	        }

	        // iso 8601 regex
	        // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	        var extendedIsoRegex =
	                /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	            basicIsoRegex =
	                /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	            tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	            isoDates = [
	                ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	                ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	                ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	                ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	                ['YYYY-DDD', /\d{4}-\d{3}/],
	                ['YYYY-MM', /\d{4}-\d\d/, false],
	                ['YYYYYYMMDD', /[+-]\d{10}/],
	                ['YYYYMMDD', /\d{8}/],
	                ['GGGG[W]WWE', /\d{4}W\d{3}/],
	                ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	                ['YYYYDDD', /\d{7}/],
	                ['YYYYMM', /\d{6}/, false],
	                ['YYYY', /\d{4}/, false],
	            ],
	            // iso time formats and regexes
	            isoTimes = [
	                ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	                ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	                ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	                ['HH:mm', /\d\d:\d\d/],
	                ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	                ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	                ['HHmmss', /\d\d\d\d\d\d/],
	                ['HHmm', /\d\d\d\d/],
	                ['HH', /\d\d/],
	            ],
	            aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	            // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	            rfc2822 =
	                /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	            obsOffsets = {
	                UT: 0,
	                GMT: 0,
	                EDT: -4 * 60,
	                EST: -5 * 60,
	                CDT: -5 * 60,
	                CST: -6 * 60,
	                MDT: -6 * 60,
	                MST: -7 * 60,
	                PDT: -7 * 60,
	                PST: -8 * 60,
	            };

	        // date from iso format
	        function configFromISO(config) {
	            var i,
	                l,
	                string = config._i,
	                match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	                allowTime,
	                dateFormat,
	                timeFormat,
	                tzFormat,
	                isoDatesLen = isoDates.length,
	                isoTimesLen = isoTimes.length;

	            if (match) {
	                getParsingFlags(config).iso = true;
	                for (i = 0, l = isoDatesLen; i < l; i++) {
	                    if (isoDates[i][1].exec(match[1])) {
	                        dateFormat = isoDates[i][0];
	                        allowTime = isoDates[i][2] !== false;
	                        break;
	                    }
	                }
	                if (dateFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	                if (match[3]) {
	                    for (i = 0, l = isoTimesLen; i < l; i++) {
	                        if (isoTimes[i][1].exec(match[3])) {
	                            // match[2] should be 'T' or space
	                            timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                            break;
	                        }
	                    }
	                    if (timeFormat == null) {
	                        config._isValid = false;
	                        return;
	                    }
	                }
	                if (!allowTime && timeFormat != null) {
	                    config._isValid = false;
	                    return;
	                }
	                if (match[4]) {
	                    if (tzRegex.exec(match[4])) {
	                        tzFormat = 'Z';
	                    } else {
	                        config._isValid = false;
	                        return;
	                    }
	                }
	                config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	                configFromStringAndFormat(config);
	            } else {
	                config._isValid = false;
	            }
	        }

	        function extractFromRFC2822Strings(
	            yearStr,
	            monthStr,
	            dayStr,
	            hourStr,
	            minuteStr,
	            secondStr
	        ) {
	            var result = [
	                untruncateYear(yearStr),
	                defaultLocaleMonthsShort.indexOf(monthStr),
	                parseInt(dayStr, 10),
	                parseInt(hourStr, 10),
	                parseInt(minuteStr, 10),
	            ];

	            if (secondStr) {
	                result.push(parseInt(secondStr, 10));
	            }

	            return result;
	        }

	        function untruncateYear(yearStr) {
	            var year = parseInt(yearStr, 10);
	            if (year <= 49) {
	                return 2000 + year;
	            } else if (year <= 999) {
	                return 1900 + year;
	            }
	            return year;
	        }

	        function preprocessRFC2822(s) {
	            // Remove comments and folding whitespace and replace multiple-spaces with a single space
	            return s
	                .replace(/\([^()]*\)|[\n\t]/g, ' ')
	                .replace(/(\s\s+)/g, ' ')
	                .replace(/^\s\s*/, '')
	                .replace(/\s\s*$/, '');
	        }

	        function checkWeekday(weekdayStr, parsedInput, config) {
	            if (weekdayStr) {
	                // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	                var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                    weekdayActual = new Date(
	                        parsedInput[0],
	                        parsedInput[1],
	                        parsedInput[2]
	                    ).getDay();
	                if (weekdayProvided !== weekdayActual) {
	                    getParsingFlags(config).weekdayMismatch = true;
	                    config._isValid = false;
	                    return false;
	                }
	            }
	            return true;
	        }

	        function calculateOffset(obsOffset, militaryOffset, numOffset) {
	            if (obsOffset) {
	                return obsOffsets[obsOffset];
	            } else if (militaryOffset) {
	                // the only allowed military tz is Z
	                return 0;
	            } else {
	                var hm = parseInt(numOffset, 10),
	                    m = hm % 100,
	                    h = (hm - m) / 100;
	                return h * 60 + m;
	            }
	        }

	        // date and time from ref 2822 format
	        function configFromRFC2822(config) {
	            var match = rfc2822.exec(preprocessRFC2822(config._i)),
	                parsedArray;
	            if (match) {
	                parsedArray = extractFromRFC2822Strings(
	                    match[4],
	                    match[3],
	                    match[2],
	                    match[5],
	                    match[6],
	                    match[7]
	                );
	                if (!checkWeekday(match[1], parsedArray, config)) {
	                    return;
	                }

	                config._a = parsedArray;
	                config._tzm = calculateOffset(match[8], match[9], match[10]);

	                config._d = createUTCDate.apply(null, config._a);
	                config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	                getParsingFlags(config).rfc2822 = true;
	            } else {
	                config._isValid = false;
	            }
	        }

	        // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	        function configFromString(config) {
	            var matched = aspNetJsonRegex.exec(config._i);
	            if (matched !== null) {
	                config._d = new Date(+matched[1]);
	                return;
	            }

	            configFromISO(config);
	            if (config._isValid === false) {
	                delete config._isValid;
	            } else {
	                return;
	            }

	            configFromRFC2822(config);
	            if (config._isValid === false) {
	                delete config._isValid;
	            } else {
	                return;
	            }

	            if (config._strict) {
	                config._isValid = false;
	            } else {
	                // Final attempt, use Input Fallback
	                hooks.createFromInputFallback(config);
	            }
	        }

	        hooks.createFromInputFallback = deprecate(
	            'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	                'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	                'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	            function (config) {
	                config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	            }
	        );

	        // Pick the first defined of two or three arguments.
	        function defaults(a, b, c) {
	            if (a != null) {
	                return a;
	            }
	            if (b != null) {
	                return b;
	            }
	            return c;
	        }

	        function currentDateArray(config) {
	            // hooks is actually the exported moment object
	            var nowValue = new Date(hooks.now());
	            if (config._useUTC) {
	                return [
	                    nowValue.getUTCFullYear(),
	                    nowValue.getUTCMonth(),
	                    nowValue.getUTCDate(),
	                ];
	            }
	            return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	        }

	        // convert an array to a date.
	        // the array should mirror the parameters below
	        // note: all values past the year are optional and will default to the lowest possible value.
	        // [year, month, day , hour, minute, second, millisecond]
	        function configFromArray(config) {
	            var i,
	                date,
	                input = [],
	                currentDate,
	                expectedWeekday,
	                yearToUse;

	            if (config._d) {
	                return;
	            }

	            currentDate = currentDateArray(config);

	            //compute day of the year from weeks and weekdays
	            if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	                dayOfYearFromWeekInfo(config);
	            }

	            //if the day of the year is set, figure out what it is
	            if (config._dayOfYear != null) {
	                yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

	                if (
	                    config._dayOfYear > daysInYear(yearToUse) ||
	                    config._dayOfYear === 0
	                ) {
	                    getParsingFlags(config)._overflowDayOfYear = true;
	                }

	                date = createUTCDate(yearToUse, 0, config._dayOfYear);
	                config._a[MONTH] = date.getUTCMonth();
	                config._a[DATE] = date.getUTCDate();
	            }

	            // Default to current date.
	            // * if no year, month, day of month are given, default to today
	            // * if day of month is given, default month and year
	            // * if month is given, default only year
	            // * if year is given, don't default anything
	            for (i = 0; i < 3 && config._a[i] == null; ++i) {
	                config._a[i] = input[i] = currentDate[i];
	            }

	            // Zero out whatever was not defaulted, including time
	            for (; i < 7; i++) {
	                config._a[i] = input[i] =
	                    config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	            }

	            // Check for 24:00:00.000
	            if (
	                config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0
	            ) {
	                config._nextDay = true;
	                config._a[HOUR] = 0;
	            }

	            config._d = (config._useUTC ? createUTCDate : createDate).apply(
	                null,
	                input
	            );
	            expectedWeekday = config._useUTC
	                ? config._d.getUTCDay()
	                : config._d.getDay();

	            // Apply timezone offset from input. The actual utcOffset can be changed
	            // with parseZone.
	            if (config._tzm != null) {
	                config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	            }

	            if (config._nextDay) {
	                config._a[HOUR] = 24;
	            }

	            // check for mismatching day of week
	            if (
	                config._w &&
	                typeof config._w.d !== 'undefined' &&
	                config._w.d !== expectedWeekday
	            ) {
	                getParsingFlags(config).weekdayMismatch = true;
	            }
	        }

	        function dayOfYearFromWeekInfo(config) {
	            var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

	            w = config._w;
	            if (w.GG != null || w.W != null || w.E != null) {
	                dow = 1;
	                doy = 4;

	                // TODO: We need to take the current isoWeekYear, but that depends on
	                // how we interpret now (local, utc, fixed offset). So create
	                // a now version of current config (take local/utc/offset flags, and
	                // create now).
	                weekYear = defaults(
	                    w.GG,
	                    config._a[YEAR],
	                    weekOfYear(createLocal(), 1, 4).year
	                );
	                week = defaults(w.W, 1);
	                weekday = defaults(w.E, 1);
	                if (weekday < 1 || weekday > 7) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                dow = config._locale._week.dow;
	                doy = config._locale._week.doy;

	                curWeek = weekOfYear(createLocal(), dow, doy);

	                weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

	                // Default to current week.
	                week = defaults(w.w, curWeek.week);

	                if (w.d != null) {
	                    // weekday -- low day numbers are considered next week
	                    weekday = w.d;
	                    if (weekday < 0 || weekday > 6) {
	                        weekdayOverflow = true;
	                    }
	                } else if (w.e != null) {
	                    // local weekday -- counting starts from beginning of week
	                    weekday = w.e + dow;
	                    if (w.e < 0 || w.e > 6) {
	                        weekdayOverflow = true;
	                    }
	                } else {
	                    // default to beginning of week
	                    weekday = dow;
	                }
	            }
	            if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	                getParsingFlags(config)._overflowWeeks = true;
	            } else if (weekdayOverflow != null) {
	                getParsingFlags(config)._overflowWeekday = true;
	            } else {
	                temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	                config._a[YEAR] = temp.year;
	                config._dayOfYear = temp.dayOfYear;
	            }
	        }

	        // constant that refers to the ISO standard
	        hooks.ISO_8601 = function () {};

	        // constant that refers to the RFC 2822 form
	        hooks.RFC_2822 = function () {};

	        // date from string and format string
	        function configFromStringAndFormat(config) {
	            // TODO: Move this to another part of the creation flow to prevent circular deps
	            if (config._f === hooks.ISO_8601) {
	                configFromISO(config);
	                return;
	            }
	            if (config._f === hooks.RFC_2822) {
	                configFromRFC2822(config);
	                return;
	            }
	            config._a = [];
	            getParsingFlags(config).empty = true;

	            // This array is used to make a Date, either with `new Date` or `Date.UTC`
	            var string = '' + config._i,
	                i,
	                parsedInput,
	                tokens,
	                token,
	                skipped,
	                stringLength = string.length,
	                totalParsedInputLength = 0,
	                era,
	                tokenLen;

	            tokens =
	                expandFormat(config._f, config._locale).match(formattingTokens) || [];
	            tokenLen = tokens.length;
	            for (i = 0; i < tokenLen; i++) {
	                token = tokens[i];
	                parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                    [])[0];
	                if (parsedInput) {
	                    skipped = string.substr(0, string.indexOf(parsedInput));
	                    if (skipped.length > 0) {
	                        getParsingFlags(config).unusedInput.push(skipped);
	                    }
	                    string = string.slice(
	                        string.indexOf(parsedInput) + parsedInput.length
	                    );
	                    totalParsedInputLength += parsedInput.length;
	                }
	                // don't parse if it's not a known token
	                if (formatTokenFunctions[token]) {
	                    if (parsedInput) {
	                        getParsingFlags(config).empty = false;
	                    } else {
	                        getParsingFlags(config).unusedTokens.push(token);
	                    }
	                    addTimeToArrayFromToken(token, parsedInput, config);
	                } else if (config._strict && !parsedInput) {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	            }

	            // add remaining unparsed input length to the string
	            getParsingFlags(config).charsLeftOver =
	                stringLength - totalParsedInputLength;
	            if (string.length > 0) {
	                getParsingFlags(config).unusedInput.push(string);
	            }

	            // clear _12h flag if hour is <= 12
	            if (
	                config._a[HOUR] <= 12 &&
	                getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] > 0
	            ) {
	                getParsingFlags(config).bigHour = undefined;
	            }

	            getParsingFlags(config).parsedDateParts = config._a.slice(0);
	            getParsingFlags(config).meridiem = config._meridiem;
	            // handle meridiem
	            config._a[HOUR] = meridiemFixWrap(
	                config._locale,
	                config._a[HOUR],
	                config._meridiem
	            );

	            // handle era
	            era = getParsingFlags(config).era;
	            if (era !== null) {
	                config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	            }

	            configFromArray(config);
	            checkOverflow(config);
	        }

	        function meridiemFixWrap(locale, hour, meridiem) {
	            var isPm;

	            if (meridiem == null) {
	                // nothing to do
	                return hour;
	            }
	            if (locale.meridiemHour != null) {
	                return locale.meridiemHour(hour, meridiem);
	            } else if (locale.isPM != null) {
	                // Fallback
	                isPm = locale.isPM(meridiem);
	                if (isPm && hour < 12) {
	                    hour += 12;
	                }
	                if (!isPm && hour === 12) {
	                    hour = 0;
	                }
	                return hour;
	            } else {
	                // this is not supposed to happen
	                return hour;
	            }
	        }

	        // date from string and array of format strings
	        function configFromStringAndArray(config) {
	            var tempConfig,
	                bestMoment,
	                scoreToBeat,
	                i,
	                currentScore,
	                validFormatFound,
	                bestFormatIsValid = false,
	                configfLen = config._f.length;

	            if (configfLen === 0) {
	                getParsingFlags(config).invalidFormat = true;
	                config._d = new Date(NaN);
	                return;
	            }

	            for (i = 0; i < configfLen; i++) {
	                currentScore = 0;
	                validFormatFound = false;
	                tempConfig = copyConfig({}, config);
	                if (config._useUTC != null) {
	                    tempConfig._useUTC = config._useUTC;
	                }
	                tempConfig._f = config._f[i];
	                configFromStringAndFormat(tempConfig);

	                if (isValid(tempConfig)) {
	                    validFormatFound = true;
	                }

	                // if there is any input that was not parsed add a penalty for that format
	                currentScore += getParsingFlags(tempConfig).charsLeftOver;

	                //or tokens
	                currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

	                getParsingFlags(tempConfig).score = currentScore;

	                if (!bestFormatIsValid) {
	                    if (
	                        scoreToBeat == null ||
	                        currentScore < scoreToBeat ||
	                        validFormatFound
	                    ) {
	                        scoreToBeat = currentScore;
	                        bestMoment = tempConfig;
	                        if (validFormatFound) {
	                            bestFormatIsValid = true;
	                        }
	                    }
	                } else {
	                    if (currentScore < scoreToBeat) {
	                        scoreToBeat = currentScore;
	                        bestMoment = tempConfig;
	                    }
	                }
	            }

	            extend(config, bestMoment || tempConfig);
	        }

	        function configFromObject(config) {
	            if (config._d) {
	                return;
	            }

	            var i = normalizeObjectUnits(config._i),
	                dayOrDate = i.day === undefined ? i.date : i.day;
	            config._a = map(
	                [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	                function (obj) {
	                    return obj && parseInt(obj, 10);
	                }
	            );

	            configFromArray(config);
	        }

	        function createFromConfig(config) {
	            var res = new Moment(checkOverflow(prepareConfig(config)));
	            if (res._nextDay) {
	                // Adding is smart enough around DST
	                res.add(1, 'd');
	                res._nextDay = undefined;
	            }

	            return res;
	        }

	        function prepareConfig(config) {
	            var input = config._i,
	                format = config._f;

	            config._locale = config._locale || getLocale(config._l);

	            if (input === null || (format === undefined && input === '')) {
	                return createInvalid({ nullInput: true });
	            }

	            if (typeof input === 'string') {
	                config._i = input = config._locale.preparse(input);
	            }

	            if (isMoment(input)) {
	                return new Moment(checkOverflow(input));
	            } else if (isDate(input)) {
	                config._d = input;
	            } else if (isArray(format)) {
	                configFromStringAndArray(config);
	            } else if (format) {
	                configFromStringAndFormat(config);
	            } else {
	                configFromInput(config);
	            }

	            if (!isValid(config)) {
	                config._d = null;
	            }

	            return config;
	        }

	        function configFromInput(config) {
	            var input = config._i;
	            if (isUndefined(input)) {
	                config._d = new Date(hooks.now());
	            } else if (isDate(input)) {
	                config._d = new Date(input.valueOf());
	            } else if (typeof input === 'string') {
	                configFromString(config);
	            } else if (isArray(input)) {
	                config._a = map(input.slice(0), function (obj) {
	                    return parseInt(obj, 10);
	                });
	                configFromArray(config);
	            } else if (isObject(input)) {
	                configFromObject(config);
	            } else if (isNumber(input)) {
	                // from milliseconds
	                config._d = new Date(input);
	            } else {
	                hooks.createFromInputFallback(config);
	            }
	        }

	        function createLocalOrUTC(input, format, locale, strict, isUTC) {
	            var c = {};

	            if (format === true || format === false) {
	                strict = format;
	                format = undefined;
	            }

	            if (locale === true || locale === false) {
	                strict = locale;
	                locale = undefined;
	            }

	            if (
	                (isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)
	            ) {
	                input = undefined;
	            }
	            // object construction must be done this way.
	            // https://github.com/moment/moment/issues/1423
	            c._isAMomentObject = true;
	            c._useUTC = c._isUTC = isUTC;
	            c._l = locale;
	            c._i = input;
	            c._f = format;
	            c._strict = strict;

	            return createFromConfig(c);
	        }

	        function createLocal(input, format, locale, strict) {
	            return createLocalOrUTC(input, format, locale, strict, false);
	        }

	        var prototypeMin = deprecate(
	                'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	                function () {
	                    var other = createLocal.apply(null, arguments);
	                    if (this.isValid() && other.isValid()) {
	                        return other < this ? this : other;
	                    } else {
	                        return createInvalid();
	                    }
	                }
	            ),
	            prototypeMax = deprecate(
	                'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	                function () {
	                    var other = createLocal.apply(null, arguments);
	                    if (this.isValid() && other.isValid()) {
	                        return other > this ? this : other;
	                    } else {
	                        return createInvalid();
	                    }
	                }
	            );

	        // Pick a moment m from moments so that m[fn](other) is true for all
	        // other. This relies on the function fn to be transitive.
	        //
	        // moments should either be an array of moment objects or an array, whose
	        // first element is an array of moment objects.
	        function pickBy(fn, moments) {
	            var res, i;
	            if (moments.length === 1 && isArray(moments[0])) {
	                moments = moments[0];
	            }
	            if (!moments.length) {
	                return createLocal();
	            }
	            res = moments[0];
	            for (i = 1; i < moments.length; ++i) {
	                if (!moments[i].isValid() || moments[i][fn](res)) {
	                    res = moments[i];
	                }
	            }
	            return res;
	        }

	        // TODO: Use [].sort instead?
	        function min() {
	            var args = [].slice.call(arguments, 0);

	            return pickBy('isBefore', args);
	        }

	        function max() {
	            var args = [].slice.call(arguments, 0);

	            return pickBy('isAfter', args);
	        }

	        var now = function () {
	            return Date.now ? Date.now() : +new Date();
	        };

	        var ordering = [
	            'year',
	            'quarter',
	            'month',
	            'week',
	            'day',
	            'hour',
	            'minute',
	            'second',
	            'millisecond',
	        ];

	        function isDurationValid(m) {
	            var key,
	                unitHasDecimal = false,
	                i,
	                orderLen = ordering.length;
	            for (key in m) {
	                if (
	                    hasOwnProp(m, key) &&
	                    !(
	                        indexOf.call(ordering, key) !== -1 &&
	                        (m[key] == null || !isNaN(m[key]))
	                    )
	                ) {
	                    return false;
	                }
	            }

	            for (i = 0; i < orderLen; ++i) {
	                if (m[ordering[i]]) {
	                    if (unitHasDecimal) {
	                        return false; // only allow non-integers for smallest unit
	                    }
	                    if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                        unitHasDecimal = true;
	                    }
	                }
	            }

	            return true;
	        }

	        function isValid$1() {
	            return this._isValid;
	        }

	        function createInvalid$1() {
	            return createDuration(NaN);
	        }

	        function Duration(duration) {
	            var normalizedInput = normalizeObjectUnits(duration),
	                years = normalizedInput.year || 0,
	                quarters = normalizedInput.quarter || 0,
	                months = normalizedInput.month || 0,
	                weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	                days = normalizedInput.day || 0,
	                hours = normalizedInput.hour || 0,
	                minutes = normalizedInput.minute || 0,
	                seconds = normalizedInput.second || 0,
	                milliseconds = normalizedInput.millisecond || 0;

	            this._isValid = isDurationValid(normalizedInput);

	            // representation for dateAddRemove
	            this._milliseconds =
	                +milliseconds +
	                seconds * 1e3 + // 1000
	                minutes * 6e4 + // 1000 * 60
	                hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	            // Because of dateAddRemove treats 24 hours as different from a
	            // day when working around DST, we need to store them separately
	            this._days = +days + weeks * 7;
	            // It is impossible to translate months into days without knowing
	            // which months you are are talking about, so we have to store
	            // it separately.
	            this._months = +months + quarters * 3 + years * 12;

	            this._data = {};

	            this._locale = getLocale();

	            this._bubble();
	        }

	        function isDuration(obj) {
	            return obj instanceof Duration;
	        }

	        function absRound(number) {
	            if (number < 0) {
	                return Math.round(-1 * number) * -1;
	            } else {
	                return Math.round(number);
	            }
	        }

	        // compare two arrays, return the number of differences
	        function compareArrays(array1, array2, dontConvert) {
	            var len = Math.min(array1.length, array2.length),
	                lengthDiff = Math.abs(array1.length - array2.length),
	                diffs = 0,
	                i;
	            for (i = 0; i < len; i++) {
	                if (
	                    (dontConvert && array1[i] !== array2[i]) ||
	                    (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	                ) {
	                    diffs++;
	                }
	            }
	            return diffs + lengthDiff;
	        }

	        // FORMATTING

	        function offset(token, separator) {
	            addFormatToken(token, 0, 0, function () {
	                var offset = this.utcOffset(),
	                    sign = '+';
	                if (offset < 0) {
	                    offset = -offset;
	                    sign = '-';
	                }
	                return (
	                    sign +
	                    zeroFill(~~(offset / 60), 2) +
	                    separator +
	                    zeroFill(~~offset % 60, 2)
	                );
	            });
	        }

	        offset('Z', ':');
	        offset('ZZ', '');

	        // PARSING

	        addRegexToken('Z', matchShortOffset);
	        addRegexToken('ZZ', matchShortOffset);
	        addParseToken(['Z', 'ZZ'], function (input, array, config) {
	            config._useUTC = true;
	            config._tzm = offsetFromString(matchShortOffset, input);
	        });

	        // HELPERS

	        // timezone chunker
	        // '+10:00' > ['10',  '00']
	        // '-1530'  > ['-15', '30']
	        var chunkOffset = /([\+\-]|\d\d)/gi;

	        function offsetFromString(matcher, string) {
	            var matches = (string || '').match(matcher),
	                chunk,
	                parts,
	                minutes;

	            if (matches === null) {
	                return null;
	            }

	            chunk = matches[matches.length - 1] || [];
	            parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	            minutes = +(parts[1] * 60) + toInt(parts[2]);

	            return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	        }

	        // Return a moment from input, that is local/utc/zone equivalent to model.
	        function cloneWithOffset(input, model) {
	            var res, diff;
	            if (model._isUTC) {
	                res = model.clone();
	                diff =
	                    (isMoment(input) || isDate(input)
	                        ? input.valueOf()
	                        : createLocal(input).valueOf()) - res.valueOf();
	                // Use low-level api, because this fn is low-level api.
	                res._d.setTime(res._d.valueOf() + diff);
	                hooks.updateOffset(res, false);
	                return res;
	            } else {
	                return createLocal(input).local();
	            }
	        }

	        function getDateOffset(m) {
	            // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	            // https://github.com/moment/moment/pull/1871
	            return -Math.round(m._d.getTimezoneOffset());
	        }

	        // HOOKS

	        // This function will be called whenever a moment is mutated.
	        // It is intended to keep the offset in sync with the timezone.
	        hooks.updateOffset = function () {};

	        // MOMENTS

	        // keepLocalTime = true means only change the timezone, without
	        // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	        // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	        // +0200, so we adjust the time as needed, to be valid.
	        //
	        // Keeping the time actually adds/subtracts (one hour)
	        // from the actual represented time. That is why we call updateOffset
	        // a second time. In case it wants us to change the offset again
	        // _changeInProgress == true case, then we have to adjust, because
	        // there is no such time in the given timezone.
	        function getSetOffset(input, keepLocalTime, keepMinutes) {
	            var offset = this._offset || 0,
	                localAdjust;
	            if (!this.isValid()) {
	                return input != null ? this : NaN;
	            }
	            if (input != null) {
	                if (typeof input === 'string') {
	                    input = offsetFromString(matchShortOffset, input);
	                    if (input === null) {
	                        return this;
	                    }
	                } else if (Math.abs(input) < 16 && !keepMinutes) {
	                    input = input * 60;
	                }
	                if (!this._isUTC && keepLocalTime) {
	                    localAdjust = getDateOffset(this);
	                }
	                this._offset = input;
	                this._isUTC = true;
	                if (localAdjust != null) {
	                    this.add(localAdjust, 'm');
	                }
	                if (offset !== input) {
	                    if (!keepLocalTime || this._changeInProgress) {
	                        addSubtract(
	                            this,
	                            createDuration(input - offset, 'm'),
	                            1,
	                            false
	                        );
	                    } else if (!this._changeInProgress) {
	                        this._changeInProgress = true;
	                        hooks.updateOffset(this, true);
	                        this._changeInProgress = null;
	                    }
	                }
	                return this;
	            } else {
	                return this._isUTC ? offset : getDateOffset(this);
	            }
	        }

	        function getSetZone(input, keepLocalTime) {
	            if (input != null) {
	                if (typeof input !== 'string') {
	                    input = -input;
	                }

	                this.utcOffset(input, keepLocalTime);

	                return this;
	            } else {
	                return -this.utcOffset();
	            }
	        }

	        function setOffsetToUTC(keepLocalTime) {
	            return this.utcOffset(0, keepLocalTime);
	        }

	        function setOffsetToLocal(keepLocalTime) {
	            if (this._isUTC) {
	                this.utcOffset(0, keepLocalTime);
	                this._isUTC = false;

	                if (keepLocalTime) {
	                    this.subtract(getDateOffset(this), 'm');
	                }
	            }
	            return this;
	        }

	        function setOffsetToParsedOffset() {
	            if (this._tzm != null) {
	                this.utcOffset(this._tzm, false, true);
	            } else if (typeof this._i === 'string') {
	                var tZone = offsetFromString(matchOffset, this._i);
	                if (tZone != null) {
	                    this.utcOffset(tZone);
	                } else {
	                    this.utcOffset(0, true);
	                }
	            }
	            return this;
	        }

	        function hasAlignedHourOffset(input) {
	            if (!this.isValid()) {
	                return false;
	            }
	            input = input ? createLocal(input).utcOffset() : 0;

	            return (this.utcOffset() - input) % 60 === 0;
	        }

	        function isDaylightSavingTime() {
	            return (
	                this.utcOffset() > this.clone().month(0).utcOffset() ||
	                this.utcOffset() > this.clone().month(5).utcOffset()
	            );
	        }

	        function isDaylightSavingTimeShifted() {
	            if (!isUndefined(this._isDSTShifted)) {
	                return this._isDSTShifted;
	            }

	            var c = {},
	                other;

	            copyConfig(c, this);
	            c = prepareConfig(c);

	            if (c._a) {
	                other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	                this._isDSTShifted =
	                    this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	            } else {
	                this._isDSTShifted = false;
	            }

	            return this._isDSTShifted;
	        }

	        function isLocal() {
	            return this.isValid() ? !this._isUTC : false;
	        }

	        function isUtcOffset() {
	            return this.isValid() ? this._isUTC : false;
	        }

	        function isUtc() {
	            return this.isValid() ? this._isUTC && this._offset === 0 : false;
	        }

	        // ASP.NET json date format regex
	        var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	            // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	            // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	            // and further modified to allow for strings containing both week and day
	            isoRegex =
	                /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	        function createDuration(input, key) {
	            var duration = input,
	                // matching against regexp is expensive, do it on demand
	                match = null,
	                sign,
	                ret,
	                diffRes;

	            if (isDuration(input)) {
	                duration = {
	                    ms: input._milliseconds,
	                    d: input._days,
	                    M: input._months,
	                };
	            } else if (isNumber(input) || !isNaN(+input)) {
	                duration = {};
	                if (key) {
	                    duration[key] = +input;
	                } else {
	                    duration.milliseconds = +input;
	                }
	            } else if ((match = aspNetRegex.exec(input))) {
	                sign = match[1] === '-' ? -1 : 1;
	                duration = {
	                    y: 0,
	                    d: toInt(match[DATE]) * sign,
	                    h: toInt(match[HOUR]) * sign,
	                    m: toInt(match[MINUTE]) * sign,
	                    s: toInt(match[SECOND]) * sign,
	                    ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	                };
	            } else if ((match = isoRegex.exec(input))) {
	                sign = match[1] === '-' ? -1 : 1;
	                duration = {
	                    y: parseIso(match[2], sign),
	                    M: parseIso(match[3], sign),
	                    w: parseIso(match[4], sign),
	                    d: parseIso(match[5], sign),
	                    h: parseIso(match[6], sign),
	                    m: parseIso(match[7], sign),
	                    s: parseIso(match[8], sign),
	                };
	            } else if (duration == null) {
	                // checks for null or undefined
	                duration = {};
	            } else if (
	                typeof duration === 'object' &&
	                ('from' in duration || 'to' in duration)
	            ) {
	                diffRes = momentsDifference(
	                    createLocal(duration.from),
	                    createLocal(duration.to)
	                );

	                duration = {};
	                duration.ms = diffRes.milliseconds;
	                duration.M = diffRes.months;
	            }

	            ret = new Duration(duration);

	            if (isDuration(input) && hasOwnProp(input, '_locale')) {
	                ret._locale = input._locale;
	            }

	            if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	                ret._isValid = input._isValid;
	            }

	            return ret;
	        }

	        createDuration.fn = Duration.prototype;
	        createDuration.invalid = createInvalid$1;

	        function parseIso(inp, sign) {
	            // We'd normally use ~~inp for this, but unfortunately it also
	            // converts floats to ints.
	            // inp may be undefined, so careful calling replace on it.
	            var res = inp && parseFloat(inp.replace(',', '.'));
	            // apply sign while we're at it
	            return (isNaN(res) ? 0 : res) * sign;
	        }

	        function positiveMomentsDifference(base, other) {
	            var res = {};

	            res.months =
	                other.month() - base.month() + (other.year() - base.year()) * 12;
	            if (base.clone().add(res.months, 'M').isAfter(other)) {
	                --res.months;
	            }

	            res.milliseconds = +other - +base.clone().add(res.months, 'M');

	            return res;
	        }

	        function momentsDifference(base, other) {
	            var res;
	            if (!(base.isValid() && other.isValid())) {
	                return { milliseconds: 0, months: 0 };
	            }

	            other = cloneWithOffset(other, base);
	            if (base.isBefore(other)) {
	                res = positiveMomentsDifference(base, other);
	            } else {
	                res = positiveMomentsDifference(other, base);
	                res.milliseconds = -res.milliseconds;
	                res.months = -res.months;
	            }

	            return res;
	        }

	        // TODO: remove 'name' arg after deprecation is removed
	        function createAdder(direction, name) {
	            return function (val, period) {
	                var dur, tmp;
	                //invert the arguments, but complain about it
	                if (period !== null && !isNaN(+period)) {
	                    deprecateSimple(
	                        name,
	                        'moment().' +
	                            name +
	                            '(period, number) is deprecated. Please use moment().' +
	                            name +
	                            '(number, period). ' +
	                            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                    );
	                    tmp = val;
	                    val = period;
	                    period = tmp;
	                }

	                dur = createDuration(val, period);
	                addSubtract(this, dur, direction);
	                return this;
	            };
	        }

	        function addSubtract(mom, duration, isAdding, updateOffset) {
	            var milliseconds = duration._milliseconds,
	                days = absRound(duration._days),
	                months = absRound(duration._months);

	            if (!mom.isValid()) {
	                // No op
	                return;
	            }

	            updateOffset = updateOffset == null ? true : updateOffset;

	            if (months) {
	                setMonth(mom, get(mom, 'Month') + months * isAdding);
	            }
	            if (days) {
	                set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	            }
	            if (milliseconds) {
	                mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	            }
	            if (updateOffset) {
	                hooks.updateOffset(mom, days || months);
	            }
	        }

	        var add = createAdder(1, 'add'),
	            subtract = createAdder(-1, 'subtract');

	        function isString(input) {
	            return typeof input === 'string' || input instanceof String;
	        }

	        // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	        function isMomentInput(input) {
	            return (
	                isMoment(input) ||
	                isDate(input) ||
	                isString(input) ||
	                isNumber(input) ||
	                isNumberOrStringArray(input) ||
	                isMomentInputObject(input) ||
	                input === null ||
	                input === undefined
	            );
	        }

	        function isMomentInputObject(input) {
	            var objectTest = isObject(input) && !isObjectEmpty(input),
	                propertyTest = false,
	                properties = [
	                    'years',
	                    'year',
	                    'y',
	                    'months',
	                    'month',
	                    'M',
	                    'days',
	                    'day',
	                    'd',
	                    'dates',
	                    'date',
	                    'D',
	                    'hours',
	                    'hour',
	                    'h',
	                    'minutes',
	                    'minute',
	                    'm',
	                    'seconds',
	                    'second',
	                    's',
	                    'milliseconds',
	                    'millisecond',
	                    'ms',
	                ],
	                i,
	                property,
	                propertyLen = properties.length;

	            for (i = 0; i < propertyLen; i += 1) {
	                property = properties[i];
	                propertyTest = propertyTest || hasOwnProp(input, property);
	            }

	            return objectTest && propertyTest;
	        }

	        function isNumberOrStringArray(input) {
	            var arrayTest = isArray(input),
	                dataTypeTest = false;
	            if (arrayTest) {
	                dataTypeTest =
	                    input.filter(function (item) {
	                        return !isNumber(item) && isString(input);
	                    }).length === 0;
	            }
	            return arrayTest && dataTypeTest;
	        }

	        function isCalendarSpec(input) {
	            var objectTest = isObject(input) && !isObjectEmpty(input),
	                propertyTest = false,
	                properties = [
	                    'sameDay',
	                    'nextDay',
	                    'lastDay',
	                    'nextWeek',
	                    'lastWeek',
	                    'sameElse',
	                ],
	                i,
	                property;

	            for (i = 0; i < properties.length; i += 1) {
	                property = properties[i];
	                propertyTest = propertyTest || hasOwnProp(input, property);
	            }

	            return objectTest && propertyTest;
	        }

	        function getCalendarFormat(myMoment, now) {
	            var diff = myMoment.diff(now, 'days', true);
	            return diff < -6
	                ? 'sameElse'
	                : diff < -1
	                  ? 'lastWeek'
	                  : diff < 0
	                    ? 'lastDay'
	                    : diff < 1
	                      ? 'sameDay'
	                      : diff < 2
	                        ? 'nextDay'
	                        : diff < 7
	                          ? 'nextWeek'
	                          : 'sameElse';
	        }

	        function calendar$1(time, formats) {
	            // Support for single parameter, formats only overload to the calendar function
	            if (arguments.length === 1) {
	                if (!arguments[0]) {
	                    time = undefined;
	                    formats = undefined;
	                } else if (isMomentInput(arguments[0])) {
	                    time = arguments[0];
	                    formats = undefined;
	                } else if (isCalendarSpec(arguments[0])) {
	                    formats = arguments[0];
	                    time = undefined;
	                }
	            }
	            // We want to compare the start of today, vs this.
	            // Getting start-of-today depends on whether we're local/utc/offset or not.
	            var now = time || createLocal(),
	                sod = cloneWithOffset(now, this).startOf('day'),
	                format = hooks.calendarFormat(this, sod) || 'sameElse',
	                output =
	                    formats &&
	                    (isFunction(formats[format])
	                        ? formats[format].call(this, now)
	                        : formats[format]);

	            return this.format(
	                output || this.localeData().calendar(format, this, createLocal(now))
	            );
	        }

	        function clone() {
	            return new Moment(this);
	        }

	        function isAfter(input, units) {
	            var localInput = isMoment(input) ? input : createLocal(input);
	            if (!(this.isValid() && localInput.isValid())) {
	                return false;
	            }
	            units = normalizeUnits(units) || 'millisecond';
	            if (units === 'millisecond') {
	                return this.valueOf() > localInput.valueOf();
	            } else {
	                return localInput.valueOf() < this.clone().startOf(units).valueOf();
	            }
	        }

	        function isBefore(input, units) {
	            var localInput = isMoment(input) ? input : createLocal(input);
	            if (!(this.isValid() && localInput.isValid())) {
	                return false;
	            }
	            units = normalizeUnits(units) || 'millisecond';
	            if (units === 'millisecond') {
	                return this.valueOf() < localInput.valueOf();
	            } else {
	                return this.clone().endOf(units).valueOf() < localInput.valueOf();
	            }
	        }

	        function isBetween(from, to, units, inclusivity) {
	            var localFrom = isMoment(from) ? from : createLocal(from),
	                localTo = isMoment(to) ? to : createLocal(to);
	            if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	                return false;
	            }
	            inclusivity = inclusivity || '()';
	            return (
	                (inclusivity[0] === '('
	                    ? this.isAfter(localFrom, units)
	                    : !this.isBefore(localFrom, units)) &&
	                (inclusivity[1] === ')'
	                    ? this.isBefore(localTo, units)
	                    : !this.isAfter(localTo, units))
	            );
	        }

	        function isSame(input, units) {
	            var localInput = isMoment(input) ? input : createLocal(input),
	                inputMs;
	            if (!(this.isValid() && localInput.isValid())) {
	                return false;
	            }
	            units = normalizeUnits(units) || 'millisecond';
	            if (units === 'millisecond') {
	                return this.valueOf() === localInput.valueOf();
	            } else {
	                inputMs = localInput.valueOf();
	                return (
	                    this.clone().startOf(units).valueOf() <= inputMs &&
	                    inputMs <= this.clone().endOf(units).valueOf()
	                );
	            }
	        }

	        function isSameOrAfter(input, units) {
	            return this.isSame(input, units) || this.isAfter(input, units);
	        }

	        function isSameOrBefore(input, units) {
	            return this.isSame(input, units) || this.isBefore(input, units);
	        }

	        function diff(input, units, asFloat) {
	            var that, zoneDelta, output;

	            if (!this.isValid()) {
	                return NaN;
	            }

	            that = cloneWithOffset(input, this);

	            if (!that.isValid()) {
	                return NaN;
	            }

	            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	            units = normalizeUnits(units);

	            switch (units) {
	                case 'year':
	                    output = monthDiff(this, that) / 12;
	                    break;
	                case 'month':
	                    output = monthDiff(this, that);
	                    break;
	                case 'quarter':
	                    output = monthDiff(this, that) / 3;
	                    break;
	                case 'second':
	                    output = (this - that) / 1e3;
	                    break; // 1000
	                case 'minute':
	                    output = (this - that) / 6e4;
	                    break; // 1000 * 60
	                case 'hour':
	                    output = (this - that) / 36e5;
	                    break; // 1000 * 60 * 60
	                case 'day':
	                    output = (this - that - zoneDelta) / 864e5;
	                    break; // 1000 * 60 * 60 * 24, negate dst
	                case 'week':
	                    output = (this - that - zoneDelta) / 6048e5;
	                    break; // 1000 * 60 * 60 * 24 * 7, negate dst
	                default:
	                    output = this - that;
	            }

	            return asFloat ? output : absFloor(output);
	        }

	        function monthDiff(a, b) {
	            if (a.date() < b.date()) {
	                // end-of-month calculations work correct when the start month has more
	                // days than the end month.
	                return -monthDiff(b, a);
	            }
	            // difference in months
	            var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	                // b is in (anchor - 1 month, anchor + 1 month)
	                anchor = a.clone().add(wholeMonthDiff, 'months'),
	                anchor2,
	                adjust;

	            if (b - anchor < 0) {
	                anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	                // linear across the month
	                adjust = (b - anchor) / (anchor - anchor2);
	            } else {
	                anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	                // linear across the month
	                adjust = (b - anchor) / (anchor2 - anchor);
	            }

	            //check for negative zero, return zero if negative zero
	            return -(wholeMonthDiff + adjust) || 0;
	        }

	        hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	        hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	        function toString() {
	            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	        }

	        function toISOString(keepOffset) {
	            if (!this.isValid()) {
	                return null;
	            }
	            var utc = keepOffset !== true,
	                m = utc ? this.clone().utc() : this;
	            if (m.year() < 0 || m.year() > 9999) {
	                return formatMoment(
	                    m,
	                    utc
	                        ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                        : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	                );
	            }
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                if (utc) {
	                    return this.toDate().toISOString();
	                } else {
	                    return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                        .toISOString()
	                        .replace('Z', formatMoment(m, 'Z'));
	                }
	            }
	            return formatMoment(
	                m,
	                utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }

	        /**
	         * Return a human readable representation of a moment that can
	         * also be evaluated to get a new moment which is the same
	         *
	         * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	         */
	        function inspect() {
	            if (!this.isValid()) {
	                return 'moment.invalid(/* ' + this._i + ' */)';
	            }
	            var func = 'moment',
	                zone = '',
	                prefix,
	                year,
	                datetime,
	                suffix;
	            if (!this.isLocal()) {
	                func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	                zone = 'Z';
	            }
	            prefix = '[' + func + '("]';
	            year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	            datetime = '-MM-DD[T]HH:mm:ss.SSS';
	            suffix = zone + '[")]';

	            return this.format(prefix + year + datetime + suffix);
	        }

	        function format(inputString) {
	            if (!inputString) {
	                inputString = this.isUtc()
	                    ? hooks.defaultFormatUtc
	                    : hooks.defaultFormat;
	            }
	            var output = formatMoment(this, inputString);
	            return this.localeData().postformat(output);
	        }

	        function from(time, withoutSuffix) {
	            if (
	                this.isValid() &&
	                ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	            ) {
	                return createDuration({ to: this, from: time })
	                    .locale(this.locale())
	                    .humanize(!withoutSuffix);
	            } else {
	                return this.localeData().invalidDate();
	            }
	        }

	        function fromNow(withoutSuffix) {
	            return this.from(createLocal(), withoutSuffix);
	        }

	        function to(time, withoutSuffix) {
	            if (
	                this.isValid() &&
	                ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	            ) {
	                return createDuration({ from: this, to: time })
	                    .locale(this.locale())
	                    .humanize(!withoutSuffix);
	            } else {
	                return this.localeData().invalidDate();
	            }
	        }

	        function toNow(withoutSuffix) {
	            return this.to(createLocal(), withoutSuffix);
	        }

	        // If passed a locale key, it will set the locale for this
	        // instance.  Otherwise, it will return the locale configuration
	        // variables for this instance.
	        function locale(key) {
	            var newLocaleData;

	            if (key === undefined) {
	                return this._locale._abbr;
	            } else {
	                newLocaleData = getLocale(key);
	                if (newLocaleData != null) {
	                    this._locale = newLocaleData;
	                }
	                return this;
	            }
	        }

	        var lang = deprecate(
	            'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	            function (key) {
	                if (key === undefined) {
	                    return this.localeData();
	                } else {
	                    return this.locale(key);
	                }
	            }
	        );

	        function localeData() {
	            return this._locale;
	        }

	        var MS_PER_SECOND = 1000,
	            MS_PER_MINUTE = 60 * MS_PER_SECOND,
	            MS_PER_HOUR = 60 * MS_PER_MINUTE,
	            MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

	        // actual modulo - handles negative numbers (for dates before 1970):
	        function mod$1(dividend, divisor) {
	            return ((dividend % divisor) + divisor) % divisor;
	        }

	        function localStartOfDate(y, m, d) {
	            // the date constructor remaps years 0-99 to 1900-1999
	            if (y < 100 && y >= 0) {
	                // preserve leap years using a full 400 year cycle, then reset
	                return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	            } else {
	                return new Date(y, m, d).valueOf();
	            }
	        }

	        function utcStartOfDate(y, m, d) {
	            // Date.UTC remaps years 0-99 to 1900-1999
	            if (y < 100 && y >= 0) {
	                // preserve leap years using a full 400 year cycle, then reset
	                return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	            } else {
	                return Date.UTC(y, m, d);
	            }
	        }

	        function startOf(units) {
	            var time, startOfDate;
	            units = normalizeUnits(units);
	            if (units === undefined || units === 'millisecond' || !this.isValid()) {
	                return this;
	            }

	            startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	            switch (units) {
	                case 'year':
	                    time = startOfDate(this.year(), 0, 1);
	                    break;
	                case 'quarter':
	                    time = startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3),
	                        1
	                    );
	                    break;
	                case 'month':
	                    time = startOfDate(this.year(), this.month(), 1);
	                    break;
	                case 'week':
	                    time = startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday()
	                    );
	                    break;
	                case 'isoWeek':
	                    time = startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1)
	                    );
	                    break;
	                case 'day':
	                case 'date':
	                    time = startOfDate(this.year(), this.month(), this.date());
	                    break;
	                case 'hour':
	                    time = this._d.valueOf();
	                    time -= mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    );
	                    break;
	                case 'minute':
	                    time = this._d.valueOf();
	                    time -= mod$1(time, MS_PER_MINUTE);
	                    break;
	                case 'second':
	                    time = this._d.valueOf();
	                    time -= mod$1(time, MS_PER_SECOND);
	                    break;
	            }

	            this._d.setTime(time);
	            hooks.updateOffset(this, true);
	            return this;
	        }

	        function endOf(units) {
	            var time, startOfDate;
	            units = normalizeUnits(units);
	            if (units === undefined || units === 'millisecond' || !this.isValid()) {
	                return this;
	            }

	            startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	            switch (units) {
	                case 'year':
	                    time = startOfDate(this.year() + 1, 0, 1) - 1;
	                    break;
	                case 'quarter':
	                    time =
	                        startOfDate(
	                            this.year(),
	                            this.month() - (this.month() % 3) + 3,
	                            1
	                        ) - 1;
	                    break;
	                case 'month':
	                    time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                    break;
	                case 'week':
	                    time =
	                        startOfDate(
	                            this.year(),
	                            this.month(),
	                            this.date() - this.weekday() + 7
	                        ) - 1;
	                    break;
	                case 'isoWeek':
	                    time =
	                        startOfDate(
	                            this.year(),
	                            this.month(),
	                            this.date() - (this.isoWeekday() - 1) + 7
	                        ) - 1;
	                    break;
	                case 'day':
	                case 'date':
	                    time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                    break;
	                case 'hour':
	                    time = this._d.valueOf();
	                    time +=
	                        MS_PER_HOUR -
	                        mod$1(
	                            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                            MS_PER_HOUR
	                        ) -
	                        1;
	                    break;
	                case 'minute':
	                    time = this._d.valueOf();
	                    time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                    break;
	                case 'second':
	                    time = this._d.valueOf();
	                    time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                    break;
	            }

	            this._d.setTime(time);
	            hooks.updateOffset(this, true);
	            return this;
	        }

	        function valueOf() {
	            return this._d.valueOf() - (this._offset || 0) * 60000;
	        }

	        function unix() {
	            return Math.floor(this.valueOf() / 1000);
	        }

	        function toDate() {
	            return new Date(this.valueOf());
	        }

	        function toArray() {
	            var m = this;
	            return [
	                m.year(),
	                m.month(),
	                m.date(),
	                m.hour(),
	                m.minute(),
	                m.second(),
	                m.millisecond(),
	            ];
	        }

	        function toObject() {
	            var m = this;
	            return {
	                years: m.year(),
	                months: m.month(),
	                date: m.date(),
	                hours: m.hours(),
	                minutes: m.minutes(),
	                seconds: m.seconds(),
	                milliseconds: m.milliseconds(),
	            };
	        }

	        function toJSON() {
	            // new Date(NaN).toJSON() === null
	            return this.isValid() ? this.toISOString() : null;
	        }

	        function isValid$2() {
	            return isValid(this);
	        }

	        function parsingFlags() {
	            return extend({}, getParsingFlags(this));
	        }

	        function invalidAt() {
	            return getParsingFlags(this).overflow;
	        }

	        function creationData() {
	            return {
	                input: this._i,
	                format: this._f,
	                locale: this._locale,
	                isUTC: this._isUTC,
	                strict: this._strict,
	            };
	        }

	        addFormatToken('N', 0, 0, 'eraAbbr');
	        addFormatToken('NN', 0, 0, 'eraAbbr');
	        addFormatToken('NNN', 0, 0, 'eraAbbr');
	        addFormatToken('NNNN', 0, 0, 'eraName');
	        addFormatToken('NNNNN', 0, 0, 'eraNarrow');

	        addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	        addFormatToken('y', ['yy', 2], 0, 'eraYear');
	        addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	        addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

	        addRegexToken('N', matchEraAbbr);
	        addRegexToken('NN', matchEraAbbr);
	        addRegexToken('NNN', matchEraAbbr);
	        addRegexToken('NNNN', matchEraName);
	        addRegexToken('NNNNN', matchEraNarrow);

	        addParseToken(
	            ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	            function (input, array, config, token) {
	                var era = config._locale.erasParse(input, token, config._strict);
	                if (era) {
	                    getParsingFlags(config).era = era;
	                } else {
	                    getParsingFlags(config).invalidEra = input;
	                }
	            }
	        );

	        addRegexToken('y', matchUnsigned);
	        addRegexToken('yy', matchUnsigned);
	        addRegexToken('yyy', matchUnsigned);
	        addRegexToken('yyyy', matchUnsigned);
	        addRegexToken('yo', matchEraYearOrdinal);

	        addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	        addParseToken(['yo'], function (input, array, config, token) {
	            var match;
	            if (config._locale._eraYearOrdinalRegex) {
	                match = input.match(config._locale._eraYearOrdinalRegex);
	            }

	            if (config._locale.eraYearOrdinalParse) {
	                array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	            } else {
	                array[YEAR] = parseInt(input, 10);
	            }
	        });

	        function localeEras(m, format) {
	            var i,
	                l,
	                date,
	                eras = this._eras || getLocale('en')._eras;
	            for (i = 0, l = eras.length; i < l; ++i) {
	                switch (typeof eras[i].since) {
	                    case 'string':
	                        // truncate time
	                        date = hooks(eras[i].since).startOf('day');
	                        eras[i].since = date.valueOf();
	                        break;
	                }

	                switch (typeof eras[i].until) {
	                    case 'undefined':
	                        eras[i].until = +Infinity;
	                        break;
	                    case 'string':
	                        // truncate time
	                        date = hooks(eras[i].until).startOf('day').valueOf();
	                        eras[i].until = date.valueOf();
	                        break;
	                }
	            }
	            return eras;
	        }

	        function localeErasParse(eraName, format, strict) {
	            var i,
	                l,
	                eras = this.eras(),
	                name,
	                abbr,
	                narrow;
	            eraName = eraName.toUpperCase();

	            for (i = 0, l = eras.length; i < l; ++i) {
	                name = eras[i].name.toUpperCase();
	                abbr = eras[i].abbr.toUpperCase();
	                narrow = eras[i].narrow.toUpperCase();

	                if (strict) {
	                    switch (format) {
	                        case 'N':
	                        case 'NN':
	                        case 'NNN':
	                            if (abbr === eraName) {
	                                return eras[i];
	                            }
	                            break;

	                        case 'NNNN':
	                            if (name === eraName) {
	                                return eras[i];
	                            }
	                            break;

	                        case 'NNNNN':
	                            if (narrow === eraName) {
	                                return eras[i];
	                            }
	                            break;
	                    }
	                } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                    return eras[i];
	                }
	            }
	        }

	        function localeErasConvertYear(era, year) {
	            var dir = era.since <= era.until ? +1 : -1;
	            if (year === undefined) {
	                return hooks(era.since).year();
	            } else {
	                return hooks(era.since).year() + (year - era.offset) * dir;
	            }
	        }

	        function getEraName() {
	            var i,
	                l,
	                val,
	                eras = this.localeData().eras();
	            for (i = 0, l = eras.length; i < l; ++i) {
	                // truncate time
	                val = this.clone().startOf('day').valueOf();

	                if (eras[i].since <= val && val <= eras[i].until) {
	                    return eras[i].name;
	                }
	                if (eras[i].until <= val && val <= eras[i].since) {
	                    return eras[i].name;
	                }
	            }

	            return '';
	        }

	        function getEraNarrow() {
	            var i,
	                l,
	                val,
	                eras = this.localeData().eras();
	            for (i = 0, l = eras.length; i < l; ++i) {
	                // truncate time
	                val = this.clone().startOf('day').valueOf();

	                if (eras[i].since <= val && val <= eras[i].until) {
	                    return eras[i].narrow;
	                }
	                if (eras[i].until <= val && val <= eras[i].since) {
	                    return eras[i].narrow;
	                }
	            }

	            return '';
	        }

	        function getEraAbbr() {
	            var i,
	                l,
	                val,
	                eras = this.localeData().eras();
	            for (i = 0, l = eras.length; i < l; ++i) {
	                // truncate time
	                val = this.clone().startOf('day').valueOf();

	                if (eras[i].since <= val && val <= eras[i].until) {
	                    return eras[i].abbr;
	                }
	                if (eras[i].until <= val && val <= eras[i].since) {
	                    return eras[i].abbr;
	                }
	            }

	            return '';
	        }

	        function getEraYear() {
	            var i,
	                l,
	                dir,
	                val,
	                eras = this.localeData().eras();
	            for (i = 0, l = eras.length; i < l; ++i) {
	                dir = eras[i].since <= eras[i].until ? +1 : -1;

	                // truncate time
	                val = this.clone().startOf('day').valueOf();

	                if (
	                    (eras[i].since <= val && val <= eras[i].until) ||
	                    (eras[i].until <= val && val <= eras[i].since)
	                ) {
	                    return (
	                        (this.year() - hooks(eras[i].since).year()) * dir +
	                        eras[i].offset
	                    );
	                }
	            }

	            return this.year();
	        }

	        function erasNameRegex(isStrict) {
	            if (!hasOwnProp(this, '_erasNameRegex')) {
	                computeErasParse.call(this);
	            }
	            return isStrict ? this._erasNameRegex : this._erasRegex;
	        }

	        function erasAbbrRegex(isStrict) {
	            if (!hasOwnProp(this, '_erasAbbrRegex')) {
	                computeErasParse.call(this);
	            }
	            return isStrict ? this._erasAbbrRegex : this._erasRegex;
	        }

	        function erasNarrowRegex(isStrict) {
	            if (!hasOwnProp(this, '_erasNarrowRegex')) {
	                computeErasParse.call(this);
	            }
	            return isStrict ? this._erasNarrowRegex : this._erasRegex;
	        }

	        function matchEraAbbr(isStrict, locale) {
	            return locale.erasAbbrRegex(isStrict);
	        }

	        function matchEraName(isStrict, locale) {
	            return locale.erasNameRegex(isStrict);
	        }

	        function matchEraNarrow(isStrict, locale) {
	            return locale.erasNarrowRegex(isStrict);
	        }

	        function matchEraYearOrdinal(isStrict, locale) {
	            return locale._eraYearOrdinalRegex || matchUnsigned;
	        }

	        function computeErasParse() {
	            var abbrPieces = [],
	                namePieces = [],
	                narrowPieces = [],
	                mixedPieces = [],
	                i,
	                l,
	                erasName,
	                erasAbbr,
	                erasNarrow,
	                eras = this.eras();

	            for (i = 0, l = eras.length; i < l; ++i) {
	                erasName = regexEscape(eras[i].name);
	                erasAbbr = regexEscape(eras[i].abbr);
	                erasNarrow = regexEscape(eras[i].narrow);

	                namePieces.push(erasName);
	                abbrPieces.push(erasAbbr);
	                narrowPieces.push(erasNarrow);
	                mixedPieces.push(erasName);
	                mixedPieces.push(erasAbbr);
	                mixedPieces.push(erasNarrow);
	            }

	            this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	            this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	            this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	            this._erasNarrowRegex = new RegExp(
	                '^(' + narrowPieces.join('|') + ')',
	                'i'
	            );
	        }

	        // FORMATTING

	        addFormatToken(0, ['gg', 2], 0, function () {
	            return this.weekYear() % 100;
	        });

	        addFormatToken(0, ['GG', 2], 0, function () {
	            return this.isoWeekYear() % 100;
	        });

	        function addWeekYearFormatToken(token, getter) {
	            addFormatToken(0, [token, token.length], 0, getter);
	        }

	        addWeekYearFormatToken('gggg', 'weekYear');
	        addWeekYearFormatToken('ggggg', 'weekYear');
	        addWeekYearFormatToken('GGGG', 'isoWeekYear');
	        addWeekYearFormatToken('GGGGG', 'isoWeekYear');

	        // ALIASES

	        // PARSING

	        addRegexToken('G', matchSigned);
	        addRegexToken('g', matchSigned);
	        addRegexToken('GG', match1to2, match2);
	        addRegexToken('gg', match1to2, match2);
	        addRegexToken('GGGG', match1to4, match4);
	        addRegexToken('gggg', match1to4, match4);
	        addRegexToken('GGGGG', match1to6, match6);
	        addRegexToken('ggggg', match1to6, match6);

	        addWeekParseToken(
	            ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	            function (input, week, config, token) {
	                week[token.substr(0, 2)] = toInt(input);
	            }
	        );

	        addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	            week[token] = hooks.parseTwoDigitYear(input);
	        });

	        // MOMENTS

	        function getSetWeekYear(input) {
	            return getSetWeekYearHelper.call(
	                this,
	                input,
	                this.week(),
	                this.weekday() + this.localeData()._week.dow,
	                this.localeData()._week.dow,
	                this.localeData()._week.doy
	            );
	        }

	        function getSetISOWeekYear(input) {
	            return getSetWeekYearHelper.call(
	                this,
	                input,
	                this.isoWeek(),
	                this.isoWeekday(),
	                1,
	                4
	            );
	        }

	        function getISOWeeksInYear() {
	            return weeksInYear(this.year(), 1, 4);
	        }

	        function getISOWeeksInISOWeekYear() {
	            return weeksInYear(this.isoWeekYear(), 1, 4);
	        }

	        function getWeeksInYear() {
	            var weekInfo = this.localeData()._week;
	            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	        }

	        function getWeeksInWeekYear() {
	            var weekInfo = this.localeData()._week;
	            return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	        }

	        function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	            var weeksTarget;
	            if (input == null) {
	                return weekOfYear(this, dow, doy).year;
	            } else {
	                weeksTarget = weeksInYear(input, dow, doy);
	                if (week > weeksTarget) {
	                    week = weeksTarget;
	                }
	                return setWeekAll.call(this, input, week, weekday, dow, doy);
	            }
	        }

	        function setWeekAll(weekYear, week, weekday, dow, doy) {
	            var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	                date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	            this.year(date.getUTCFullYear());
	            this.month(date.getUTCMonth());
	            this.date(date.getUTCDate());
	            return this;
	        }

	        // FORMATTING

	        addFormatToken('Q', 0, 'Qo', 'quarter');

	        // PARSING

	        addRegexToken('Q', match1);
	        addParseToken('Q', function (input, array) {
	            array[MONTH] = (toInt(input) - 1) * 3;
	        });

	        // MOMENTS

	        function getSetQuarter(input) {
	            return input == null
	                ? Math.ceil((this.month() + 1) / 3)
	                : this.month((input - 1) * 3 + (this.month() % 3));
	        }

	        // FORMATTING

	        addFormatToken('D', ['DD', 2], 'Do', 'date');

	        // PARSING

	        addRegexToken('D', match1to2, match1to2NoLeadingZero);
	        addRegexToken('DD', match1to2, match2);
	        addRegexToken('Do', function (isStrict, locale) {
	            // TODO: Remove "ordinalParse" fallback in next major release.
	            return isStrict
	                ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	                : locale._dayOfMonthOrdinalParseLenient;
	        });

	        addParseToken(['D', 'DD'], DATE);
	        addParseToken('Do', function (input, array) {
	            array[DATE] = toInt(input.match(match1to2)[0]);
	        });

	        // MOMENTS

	        var getSetDayOfMonth = makeGetSet('Date', true);

	        // FORMATTING

	        addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	        // PARSING

	        addRegexToken('DDD', match1to3);
	        addRegexToken('DDDD', match3);
	        addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	            config._dayOfYear = toInt(input);
	        });

	        // HELPERS

	        // MOMENTS

	        function getSetDayOfYear(input) {
	            var dayOfYear =
	                Math.round(
	                    (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	                ) + 1;
	            return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	        }

	        // FORMATTING

	        addFormatToken('m', ['mm', 2], 0, 'minute');

	        // PARSING

	        addRegexToken('m', match1to2, match1to2HasZero);
	        addRegexToken('mm', match1to2, match2);
	        addParseToken(['m', 'mm'], MINUTE);

	        // MOMENTS

	        var getSetMinute = makeGetSet('Minutes', false);

	        // FORMATTING

	        addFormatToken('s', ['ss', 2], 0, 'second');

	        // PARSING

	        addRegexToken('s', match1to2, match1to2HasZero);
	        addRegexToken('ss', match1to2, match2);
	        addParseToken(['s', 'ss'], SECOND);

	        // MOMENTS

	        var getSetSecond = makeGetSet('Seconds', false);

	        // FORMATTING

	        addFormatToken('S', 0, 0, function () {
	            return ~~(this.millisecond() / 100);
	        });

	        addFormatToken(0, ['SS', 2], 0, function () {
	            return ~~(this.millisecond() / 10);
	        });

	        addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	        addFormatToken(0, ['SSSS', 4], 0, function () {
	            return this.millisecond() * 10;
	        });
	        addFormatToken(0, ['SSSSS', 5], 0, function () {
	            return this.millisecond() * 100;
	        });
	        addFormatToken(0, ['SSSSSS', 6], 0, function () {
	            return this.millisecond() * 1000;
	        });
	        addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	            return this.millisecond() * 10000;
	        });
	        addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	            return this.millisecond() * 100000;
	        });
	        addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	            return this.millisecond() * 1000000;
	        });

	        // PARSING

	        addRegexToken('S', match1to3, match1);
	        addRegexToken('SS', match1to3, match2);
	        addRegexToken('SSS', match1to3, match3);

	        var token, getSetMillisecond;
	        for (token = 'SSSS'; token.length <= 9; token += 'S') {
	            addRegexToken(token, matchUnsigned);
	        }

	        function parseMs(input, array) {
	            array[MILLISECOND] = toInt(('0.' + input) * 1000);
	        }

	        for (token = 'S'; token.length <= 9; token += 'S') {
	            addParseToken(token, parseMs);
	        }

	        getSetMillisecond = makeGetSet('Milliseconds', false);

	        // FORMATTING

	        addFormatToken('z', 0, 0, 'zoneAbbr');
	        addFormatToken('zz', 0, 0, 'zoneName');

	        // MOMENTS

	        function getZoneAbbr() {
	            return this._isUTC ? 'UTC' : '';
	        }

	        function getZoneName() {
	            return this._isUTC ? 'Coordinated Universal Time' : '';
	        }

	        var proto = Moment.prototype;

	        proto.add = add;
	        proto.calendar = calendar$1;
	        proto.clone = clone;
	        proto.diff = diff;
	        proto.endOf = endOf;
	        proto.format = format;
	        proto.from = from;
	        proto.fromNow = fromNow;
	        proto.to = to;
	        proto.toNow = toNow;
	        proto.get = stringGet;
	        proto.invalidAt = invalidAt;
	        proto.isAfter = isAfter;
	        proto.isBefore = isBefore;
	        proto.isBetween = isBetween;
	        proto.isSame = isSame;
	        proto.isSameOrAfter = isSameOrAfter;
	        proto.isSameOrBefore = isSameOrBefore;
	        proto.isValid = isValid$2;
	        proto.lang = lang;
	        proto.locale = locale;
	        proto.localeData = localeData;
	        proto.max = prototypeMax;
	        proto.min = prototypeMin;
	        proto.parsingFlags = parsingFlags;
	        proto.set = stringSet;
	        proto.startOf = startOf;
	        proto.subtract = subtract;
	        proto.toArray = toArray;
	        proto.toObject = toObject;
	        proto.toDate = toDate;
	        proto.toISOString = toISOString;
	        proto.inspect = inspect;
	        if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	            proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	                return 'Moment<' + this.format() + '>';
	            };
	        }
	        proto.toJSON = toJSON;
	        proto.toString = toString;
	        proto.unix = unix;
	        proto.valueOf = valueOf;
	        proto.creationData = creationData;
	        proto.eraName = getEraName;
	        proto.eraNarrow = getEraNarrow;
	        proto.eraAbbr = getEraAbbr;
	        proto.eraYear = getEraYear;
	        proto.year = getSetYear;
	        proto.isLeapYear = getIsLeapYear;
	        proto.weekYear = getSetWeekYear;
	        proto.isoWeekYear = getSetISOWeekYear;
	        proto.quarter = proto.quarters = getSetQuarter;
	        proto.month = getSetMonth;
	        proto.daysInMonth = getDaysInMonth;
	        proto.week = proto.weeks = getSetWeek;
	        proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	        proto.weeksInYear = getWeeksInYear;
	        proto.weeksInWeekYear = getWeeksInWeekYear;
	        proto.isoWeeksInYear = getISOWeeksInYear;
	        proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	        proto.date = getSetDayOfMonth;
	        proto.day = proto.days = getSetDayOfWeek;
	        proto.weekday = getSetLocaleDayOfWeek;
	        proto.isoWeekday = getSetISODayOfWeek;
	        proto.dayOfYear = getSetDayOfYear;
	        proto.hour = proto.hours = getSetHour;
	        proto.minute = proto.minutes = getSetMinute;
	        proto.second = proto.seconds = getSetSecond;
	        proto.millisecond = proto.milliseconds = getSetMillisecond;
	        proto.utcOffset = getSetOffset;
	        proto.utc = setOffsetToUTC;
	        proto.local = setOffsetToLocal;
	        proto.parseZone = setOffsetToParsedOffset;
	        proto.hasAlignedHourOffset = hasAlignedHourOffset;
	        proto.isDST = isDaylightSavingTime;
	        proto.isLocal = isLocal;
	        proto.isUtcOffset = isUtcOffset;
	        proto.isUtc = isUtc;
	        proto.isUTC = isUtc;
	        proto.zoneAbbr = getZoneAbbr;
	        proto.zoneName = getZoneName;
	        proto.dates = deprecate(
	            'dates accessor is deprecated. Use date instead.',
	            getSetDayOfMonth
	        );
	        proto.months = deprecate(
	            'months accessor is deprecated. Use month instead',
	            getSetMonth
	        );
	        proto.years = deprecate(
	            'years accessor is deprecated. Use year instead',
	            getSetYear
	        );
	        proto.zone = deprecate(
	            'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	            getSetZone
	        );
	        proto.isDSTShifted = deprecate(
	            'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	            isDaylightSavingTimeShifted
	        );

	        function createUnix(input) {
	            return createLocal(input * 1000);
	        }

	        function createInZone() {
	            return createLocal.apply(null, arguments).parseZone();
	        }

	        function preParsePostFormat(string) {
	            return string;
	        }

	        var proto$1 = Locale.prototype;

	        proto$1.calendar = calendar;
	        proto$1.longDateFormat = longDateFormat;
	        proto$1.invalidDate = invalidDate;
	        proto$1.ordinal = ordinal;
	        proto$1.preparse = preParsePostFormat;
	        proto$1.postformat = preParsePostFormat;
	        proto$1.relativeTime = relativeTime;
	        proto$1.pastFuture = pastFuture;
	        proto$1.set = set;
	        proto$1.eras = localeEras;
	        proto$1.erasParse = localeErasParse;
	        proto$1.erasConvertYear = localeErasConvertYear;
	        proto$1.erasAbbrRegex = erasAbbrRegex;
	        proto$1.erasNameRegex = erasNameRegex;
	        proto$1.erasNarrowRegex = erasNarrowRegex;

	        proto$1.months = localeMonths;
	        proto$1.monthsShort = localeMonthsShort;
	        proto$1.monthsParse = localeMonthsParse;
	        proto$1.monthsRegex = monthsRegex;
	        proto$1.monthsShortRegex = monthsShortRegex;
	        proto$1.week = localeWeek;
	        proto$1.firstDayOfYear = localeFirstDayOfYear;
	        proto$1.firstDayOfWeek = localeFirstDayOfWeek;

	        proto$1.weekdays = localeWeekdays;
	        proto$1.weekdaysMin = localeWeekdaysMin;
	        proto$1.weekdaysShort = localeWeekdaysShort;
	        proto$1.weekdaysParse = localeWeekdaysParse;

	        proto$1.weekdaysRegex = weekdaysRegex;
	        proto$1.weekdaysShortRegex = weekdaysShortRegex;
	        proto$1.weekdaysMinRegex = weekdaysMinRegex;

	        proto$1.isPM = localeIsPM;
	        proto$1.meridiem = localeMeridiem;

	        function get$1(format, index, field, setter) {
	            var locale = getLocale(),
	                utc = createUTC().set(setter, index);
	            return locale[field](utc, format);
	        }

	        function listMonthsImpl(format, index, field) {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';

	            if (index != null) {
	                return get$1(format, index, field, 'month');
	            }

	            var i,
	                out = [];
	            for (i = 0; i < 12; i++) {
	                out[i] = get$1(format, i, field, 'month');
	            }
	            return out;
	        }

	        // ()
	        // (5)
	        // (fmt, 5)
	        // (fmt)
	        // (true)
	        // (true, 5)
	        // (true, fmt, 5)
	        // (true, fmt)
	        function listWeekdaysImpl(localeSorted, format, index, field) {
	            if (typeof localeSorted === 'boolean') {
	                if (isNumber(format)) {
	                    index = format;
	                    format = undefined;
	                }

	                format = format || '';
	            } else {
	                format = localeSorted;
	                index = format;
	                localeSorted = false;

	                if (isNumber(format)) {
	                    index = format;
	                    format = undefined;
	                }

	                format = format || '';
	            }

	            var locale = getLocale(),
	                shift = localeSorted ? locale._week.dow : 0,
	                i,
	                out = [];

	            if (index != null) {
	                return get$1(format, (index + shift) % 7, field, 'day');
	            }

	            for (i = 0; i < 7; i++) {
	                out[i] = get$1(format, (i + shift) % 7, field, 'day');
	            }
	            return out;
	        }

	        function listMonths(format, index) {
	            return listMonthsImpl(format, index, 'months');
	        }

	        function listMonthsShort(format, index) {
	            return listMonthsImpl(format, index, 'monthsShort');
	        }

	        function listWeekdays(localeSorted, format, index) {
	            return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	        }

	        function listWeekdaysShort(localeSorted, format, index) {
	            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	        }

	        function listWeekdaysMin(localeSorted, format, index) {
	            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	        }

	        getSetGlobalLocale('en', {
	            eras: [
	                {
	                    since: '0001-01-01',
	                    until: +Infinity,
	                    offset: 1,
	                    name: 'Anno Domini',
	                    narrow: 'AD',
	                    abbr: 'AD',
	                },
	                {
	                    since: '0000-12-31',
	                    until: -Infinity,
	                    offset: 1,
	                    name: 'Before Christ',
	                    narrow: 'BC',
	                    abbr: 'BC',
	                },
	            ],
	            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	            ordinal: function (number) {
	                var b = number % 10,
	                    output =
	                        toInt((number % 100) / 10) === 1
	                            ? 'th'
	                            : b === 1
	                              ? 'st'
	                              : b === 2
	                                ? 'nd'
	                                : b === 3
	                                  ? 'rd'
	                                  : 'th';
	                return number + output;
	            },
	        });

	        // Side effect imports

	        hooks.lang = deprecate(
	            'moment.lang is deprecated. Use moment.locale instead.',
	            getSetGlobalLocale
	        );
	        hooks.langData = deprecate(
	            'moment.langData is deprecated. Use moment.localeData instead.',
	            getLocale
	        );

	        var mathAbs = Math.abs;

	        function abs() {
	            var data = this._data;

	            this._milliseconds = mathAbs(this._milliseconds);
	            this._days = mathAbs(this._days);
	            this._months = mathAbs(this._months);

	            data.milliseconds = mathAbs(data.milliseconds);
	            data.seconds = mathAbs(data.seconds);
	            data.minutes = mathAbs(data.minutes);
	            data.hours = mathAbs(data.hours);
	            data.months = mathAbs(data.months);
	            data.years = mathAbs(data.years);

	            return this;
	        }

	        function addSubtract$1(duration, input, value, direction) {
	            var other = createDuration(input, value);

	            duration._milliseconds += direction * other._milliseconds;
	            duration._days += direction * other._days;
	            duration._months += direction * other._months;

	            return duration._bubble();
	        }

	        // supports only 2.0-style add(1, 's') or add(duration)
	        function add$1(input, value) {
	            return addSubtract$1(this, input, value, 1);
	        }

	        // supports only 2.0-style subtract(1, 's') or subtract(duration)
	        function subtract$1(input, value) {
	            return addSubtract$1(this, input, value, -1);
	        }

	        function absCeil(number) {
	            if (number < 0) {
	                return Math.floor(number);
	            } else {
	                return Math.ceil(number);
	            }
	        }

	        function bubble() {
	            var milliseconds = this._milliseconds,
	                days = this._days,
	                months = this._months,
	                data = this._data,
	                seconds,
	                minutes,
	                hours,
	                years,
	                monthsFromDays;

	            // if we have a mix of positive and negative values, bubble down first
	            // check: https://github.com/moment/moment/issues/2166
	            if (
	                !(
	                    (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                    (milliseconds <= 0 && days <= 0 && months <= 0)
	                )
	            ) {
	                milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	                days = 0;
	                months = 0;
	            }

	            // The following code bubbles up values, see the tests for
	            // examples of what that means.
	            data.milliseconds = milliseconds % 1000;

	            seconds = absFloor(milliseconds / 1000);
	            data.seconds = seconds % 60;

	            minutes = absFloor(seconds / 60);
	            data.minutes = minutes % 60;

	            hours = absFloor(minutes / 60);
	            data.hours = hours % 24;

	            days += absFloor(hours / 24);

	            // convert days to months
	            monthsFromDays = absFloor(daysToMonths(days));
	            months += monthsFromDays;
	            days -= absCeil(monthsToDays(monthsFromDays));

	            // 12 months -> 1 year
	            years = absFloor(months / 12);
	            months %= 12;

	            data.days = days;
	            data.months = months;
	            data.years = years;

	            return this;
	        }

	        function daysToMonths(days) {
	            // 400 years have 146097 days (taking into account leap year rules)
	            // 400 years have 12 months === 4800
	            return (days * 4800) / 146097;
	        }

	        function monthsToDays(months) {
	            // the reverse of daysToMonths
	            return (months * 146097) / 4800;
	        }

	        function as(units) {
	            if (!this.isValid()) {
	                return NaN;
	            }
	            var days,
	                months,
	                milliseconds = this._milliseconds;

	            units = normalizeUnits(units);

	            if (units === 'month' || units === 'quarter' || units === 'year') {
	                days = this._days + milliseconds / 864e5;
	                months = this._months + daysToMonths(days);
	                switch (units) {
	                    case 'month':
	                        return months;
	                    case 'quarter':
	                        return months / 3;
	                    case 'year':
	                        return months / 12;
	                }
	            } else {
	                // handle milliseconds separately because of floating point math errors (issue #1867)
	                days = this._days + Math.round(monthsToDays(this._months));
	                switch (units) {
	                    case 'week':
	                        return days / 7 + milliseconds / 6048e5;
	                    case 'day':
	                        return days + milliseconds / 864e5;
	                    case 'hour':
	                        return days * 24 + milliseconds / 36e5;
	                    case 'minute':
	                        return days * 1440 + milliseconds / 6e4;
	                    case 'second':
	                        return days * 86400 + milliseconds / 1000;
	                    // Math.floor prevents floating point math errors here
	                    case 'millisecond':
	                        return Math.floor(days * 864e5) + milliseconds;
	                    default:
	                        throw new Error('Unknown unit ' + units);
	                }
	            }
	        }

	        function makeAs(alias) {
	            return function () {
	                return this.as(alias);
	            };
	        }

	        var asMilliseconds = makeAs('ms'),
	            asSeconds = makeAs('s'),
	            asMinutes = makeAs('m'),
	            asHours = makeAs('h'),
	            asDays = makeAs('d'),
	            asWeeks = makeAs('w'),
	            asMonths = makeAs('M'),
	            asQuarters = makeAs('Q'),
	            asYears = makeAs('y'),
	            valueOf$1 = asMilliseconds;

	        function clone$1() {
	            return createDuration(this);
	        }

	        function get$2(units) {
	            units = normalizeUnits(units);
	            return this.isValid() ? this[units + 's']() : NaN;
	        }

	        function makeGetter(name) {
	            return function () {
	                return this.isValid() ? this._data[name] : NaN;
	            };
	        }

	        var milliseconds = makeGetter('milliseconds'),
	            seconds = makeGetter('seconds'),
	            minutes = makeGetter('minutes'),
	            hours = makeGetter('hours'),
	            days = makeGetter('days'),
	            months = makeGetter('months'),
	            years = makeGetter('years');

	        function weeks() {
	            return absFloor(this.days() / 7);
	        }

	        var round = Math.round,
	            thresholds = {
	                ss: 44, // a few seconds to seconds
	                s: 45, // seconds to minute
	                m: 45, // minutes to hour
	                h: 22, // hours to day
	                d: 26, // days to month/week
	                w: null, // weeks to month
	                M: 11, // months to year
	            };

	        // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	        function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	            return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	        }

	        function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	            var duration = createDuration(posNegDuration).abs(),
	                seconds = round(duration.as('s')),
	                minutes = round(duration.as('m')),
	                hours = round(duration.as('h')),
	                days = round(duration.as('d')),
	                months = round(duration.as('M')),
	                weeks = round(duration.as('w')),
	                years = round(duration.as('y')),
	                a =
	                    (seconds <= thresholds.ss && ['s', seconds]) ||
	                    (seconds < thresholds.s && ['ss', seconds]) ||
	                    (minutes <= 1 && ['m']) ||
	                    (minutes < thresholds.m && ['mm', minutes]) ||
	                    (hours <= 1 && ['h']) ||
	                    (hours < thresholds.h && ['hh', hours]) ||
	                    (days <= 1 && ['d']) ||
	                    (days < thresholds.d && ['dd', days]);

	            if (thresholds.w != null) {
	                a =
	                    a ||
	                    (weeks <= 1 && ['w']) ||
	                    (weeks < thresholds.w && ['ww', weeks]);
	            }
	            a = a ||
	                (months <= 1 && ['M']) ||
	                (months < thresholds.M && ['MM', months]) ||
	                (years <= 1 && ['y']) || ['yy', years];

	            a[2] = withoutSuffix;
	            a[3] = +posNegDuration > 0;
	            a[4] = locale;
	            return substituteTimeAgo.apply(null, a);
	        }

	        // This function allows you to set the rounding function for relative time strings
	        function getSetRelativeTimeRounding(roundingFunction) {
	            if (roundingFunction === undefined) {
	                return round;
	            }
	            if (typeof roundingFunction === 'function') {
	                round = roundingFunction;
	                return true;
	            }
	            return false;
	        }

	        // This function allows you to set a threshold for relative time strings
	        function getSetRelativeTimeThreshold(threshold, limit) {
	            if (thresholds[threshold] === undefined) {
	                return false;
	            }
	            if (limit === undefined) {
	                return thresholds[threshold];
	            }
	            thresholds[threshold] = limit;
	            if (threshold === 's') {
	                thresholds.ss = limit - 1;
	            }
	            return true;
	        }

	        function humanize(argWithSuffix, argThresholds) {
	            if (!this.isValid()) {
	                return this.localeData().invalidDate();
	            }

	            var withSuffix = false,
	                th = thresholds,
	                locale,
	                output;

	            if (typeof argWithSuffix === 'object') {
	                argThresholds = argWithSuffix;
	                argWithSuffix = false;
	            }
	            if (typeof argWithSuffix === 'boolean') {
	                withSuffix = argWithSuffix;
	            }
	            if (typeof argThresholds === 'object') {
	                th = Object.assign({}, thresholds, argThresholds);
	                if (argThresholds.s != null && argThresholds.ss == null) {
	                    th.ss = argThresholds.s - 1;
	                }
	            }

	            locale = this.localeData();
	            output = relativeTime$1(this, !withSuffix, th, locale);

	            if (withSuffix) {
	                output = locale.pastFuture(+this, output);
	            }

	            return locale.postformat(output);
	        }

	        var abs$1 = Math.abs;

	        function sign(x) {
	            return (x > 0) - (x < 0) || +x;
	        }

	        function toISOString$1() {
	            // for ISO strings we do not use the normal bubbling rules:
	            //  * milliseconds bubble up until they become hours
	            //  * days do not bubble at all
	            //  * months bubble up until they become years
	            // This is because there is no context-free conversion between hours and days
	            // (think of clock changes)
	            // and also not between days and months (28-31 days per month)
	            if (!this.isValid()) {
	                return this.localeData().invalidDate();
	            }

	            var seconds = abs$1(this._milliseconds) / 1000,
	                days = abs$1(this._days),
	                months = abs$1(this._months),
	                minutes,
	                hours,
	                years,
	                s,
	                total = this.asSeconds(),
	                totalSign,
	                ymSign,
	                daysSign,
	                hmsSign;

	            if (!total) {
	                // this is the same as C#'s (Noda) and python (isodate)...
	                // but not other JS (goog.date)
	                return 'P0D';
	            }

	            // 3600 seconds -> 60 minutes -> 1 hour
	            minutes = absFloor(seconds / 60);
	            hours = absFloor(minutes / 60);
	            seconds %= 60;
	            minutes %= 60;

	            // 12 months -> 1 year
	            years = absFloor(months / 12);
	            months %= 12;

	            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	            s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

	            totalSign = total < 0 ? '-' : '';
	            ymSign = sign(this._months) !== sign(total) ? '-' : '';
	            daysSign = sign(this._days) !== sign(total) ? '-' : '';
	            hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

	            return (
	                totalSign +
	                'P' +
	                (years ? ymSign + years + 'Y' : '') +
	                (months ? ymSign + months + 'M' : '') +
	                (days ? daysSign + days + 'D' : '') +
	                (hours || minutes || seconds ? 'T' : '') +
	                (hours ? hmsSign + hours + 'H' : '') +
	                (minutes ? hmsSign + minutes + 'M' : '') +
	                (seconds ? hmsSign + s + 'S' : '')
	            );
	        }

	        var proto$2 = Duration.prototype;

	        proto$2.isValid = isValid$1;
	        proto$2.abs = abs;
	        proto$2.add = add$1;
	        proto$2.subtract = subtract$1;
	        proto$2.as = as;
	        proto$2.asMilliseconds = asMilliseconds;
	        proto$2.asSeconds = asSeconds;
	        proto$2.asMinutes = asMinutes;
	        proto$2.asHours = asHours;
	        proto$2.asDays = asDays;
	        proto$2.asWeeks = asWeeks;
	        proto$2.asMonths = asMonths;
	        proto$2.asQuarters = asQuarters;
	        proto$2.asYears = asYears;
	        proto$2.valueOf = valueOf$1;
	        proto$2._bubble = bubble;
	        proto$2.clone = clone$1;
	        proto$2.get = get$2;
	        proto$2.milliseconds = milliseconds;
	        proto$2.seconds = seconds;
	        proto$2.minutes = minutes;
	        proto$2.hours = hours;
	        proto$2.days = days;
	        proto$2.weeks = weeks;
	        proto$2.months = months;
	        proto$2.years = years;
	        proto$2.humanize = humanize;
	        proto$2.toISOString = toISOString$1;
	        proto$2.toString = toISOString$1;
	        proto$2.toJSON = toISOString$1;
	        proto$2.locale = locale;
	        proto$2.localeData = localeData;

	        proto$2.toIsoString = deprecate(
	            'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	            toISOString$1
	        );
	        proto$2.lang = lang;

	        // FORMATTING

	        addFormatToken('X', 0, 0, 'unix');
	        addFormatToken('x', 0, 0, 'valueOf');

	        // PARSING

	        addRegexToken('x', matchSigned);
	        addRegexToken('X', matchTimestamp);
	        addParseToken('X', function (input, array, config) {
	            config._d = new Date(parseFloat(input) * 1000);
	        });
	        addParseToken('x', function (input, array, config) {
	            config._d = new Date(toInt(input));
	        });

	        //! moment.js

	        hooks.version = '2.30.1';

	        setHookCallback(createLocal);

	        hooks.fn = proto;
	        hooks.min = min;
	        hooks.max = max;
	        hooks.now = now;
	        hooks.utc = createUTC;
	        hooks.unix = createUnix;
	        hooks.months = listMonths;
	        hooks.isDate = isDate;
	        hooks.locale = getSetGlobalLocale;
	        hooks.invalid = createInvalid;
	        hooks.duration = createDuration;
	        hooks.isMoment = isMoment;
	        hooks.weekdays = listWeekdays;
	        hooks.parseZone = createInZone;
	        hooks.localeData = getLocale;
	        hooks.isDuration = isDuration;
	        hooks.monthsShort = listMonthsShort;
	        hooks.weekdaysMin = listWeekdaysMin;
	        hooks.defineLocale = defineLocale;
	        hooks.updateLocale = updateLocale;
	        hooks.locales = listLocales;
	        hooks.weekdaysShort = listWeekdaysShort;
	        hooks.normalizeUnits = normalizeUnits;
	        hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	        hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	        hooks.calendarFormat = getCalendarFormat;
	        hooks.prototype = proto;

	        // currently HTML5 input type only supports 24-hour formats
	        hooks.HTML5_FMT = {
	            DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	            DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	            DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	            DATE: 'YYYY-MM-DD', // <input type="date" />
	            TIME: 'HH:mm', // <input type="time" />
	            TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	            TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	            WEEK: 'GGGG-[W]WW', // <input type="week" />
	            MONTH: 'YYYY-MM', // <input type="month" />
	        };

	        return hooks;

	    })));
	    });

	    /* src/FilterBar.svelte generated by Svelte v3.38.2 */
	    function add_css$d() {
	      var style = element$1("style");
	      style.id = "svelte-ehy03-style";
	      style.textContent = ".pros-filter-bar{display:flex;justify-content:flex-start;align-items:center;flex-shrink:0;box-sizing:border-box;width:100%;margin-bottom:8px;padding:0 16px}.pros-filter-bar else{flex-direction:row}.pros-filter-bar .pros-search{width:250px}.pros-filter-bar .pros-icon-container{margin-right:16px}.pros-filter-bar .pros-filter-container{display:flex;justify-content:flex-start;align-items:center;flex:1;margin-left:8px}.pros-filter-bar .pros-filter-container else{flex-direction:row}.pros-filter-bar .pros-filter-container .pros-filter-display{display:flex;justify-content:flex-start;align-items:center;padding:4px 8px;border-radius:12px;font-size:12px;margin-right:8px;max-width:250px}.pros-filter-bar .pros-filter-container .pros-filter-display else{flex-direction:row}.pros-filter-bar .pros-filter-container .pros-filter-display .column-label{font-weight:bold;margin-right:4px}.pros-filter-bar .pros-filter-container .pros-filter-display .column-label:after{content:\": \"}.pros-filter-bar .pros-filter-container .pros-filter-display .filter-display{flex:1}.pros-filter-bar .pros-filter-container .pros-filter-display .close-icon-container{cursor:pointer;margin-left:8px;width:16px;height:16px}.pros-filter-bar .close-icon{width:16px;height:16px;line-height:16px}.pros-filter-bar .pros-counts{font-size:14px;font-weight:bold;text-align:right}.pros-filter-bar[pos--theme=light] .pros-filter-display{border:1px solid #adadad;color:#212121}.pros-filter-bar[pos--theme=dark] .pros-filter-display{border:1px solid #585858;color:#adadad}";
	      append$1(document.head, style);
	    }
	    function get_each_context$3(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[20] = list[i];
	      return child_ctx;
	    }

	    // (20:4) {#each myFilters as filter}
	    function create_each_block$3(ctx) {
	      let div3;
	      let div0;
	      let t0_value = /*filter*/ctx[20].columnName + "";
	      let t0;
	      let t1;
	      let div1;
	      let t2_value = /*filter*/ctx[20].display + "";
	      let t2;
	      let t3;
	      let div2;
	      let icon;
	      let t4;
	      let current;
	      let mounted;
	      let dispose;
	      icon = new Icon$1({
	        props: {
	          name: "x-circle",
	          class: "close-icon",
	          size: "16",
	          theme: /*theme*/ctx[3]
	        }
	      });
	      return {
	        c() {
	          div3 = element$1("div");
	          div0 = element$1("div");
	          t0 = text$1(t0_value);
	          t1 = space$1();
	          div1 = element$1("div");
	          t2 = text$1(t2_value);
	          t3 = space$1();
	          div2 = element$1("div");
	          create_component$1(icon.$$.fragment);
	          t4 = space$1();
	          attr$1(div0, "class", "column-label");
	          attr$1(div1, "class", "filter-display");
	          attr$1(div1, "pros-tooltip", "");
	          attr$1(div2, "class", "close-icon-container");
	          attr$1(div3, "class", "pros-filter-display");
	        },
	        m(target, anchor) {
	          insert$1(target, div3, anchor);
	          append$1(div3, div0);
	          append$1(div0, t0);
	          append$1(div3, t1);
	          append$1(div3, div1);
	          append$1(div1, t2);
	          append$1(div3, t3);
	          append$1(div3, div2);
	          mount_component$1(icon, div2, null);
	          append$1(div3, t4);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(div2, "click", function () {
	              if (is_function$1(/*deleteFilter*/ctx[8](/*filter*/ctx[20]))) /*deleteFilter*/ctx[8](/*filter*/ctx[20]).apply(this, arguments);
	            });
	            mounted = true;
	          }
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          if ((!current || dirty & /*myFilters*/1) && t0_value !== (t0_value = /*filter*/ctx[20].columnName + "")) set_data$1(t0, t0_value);
	          if ((!current || dirty & /*myFilters*/1) && t2_value !== (t2_value = /*filter*/ctx[20].display + "")) set_data$1(t2, t2_value);
	          const icon_changes = {};
	          if (dirty & /*theme*/8) icon_changes.theme = /*theme*/ctx[3];
	          icon.$set(icon_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(icon.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(icon.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div3);
	          destroy_component$1(icon);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (33:2) {#if counts.items > 0}
	    function create_if_block$a(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element$1("div");
	          t = text$1(/*countDisplay*/ctx[6]);
	          attr$1(div, "class", "pros-counts");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          append$1(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty & /*countDisplay*/64) set_data$1(t, /*countDisplay*/ctx[6]);
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	        }
	      };
	    }
	    function create_fragment$d(ctx) {
	      let div3;
	      let div0;
	      let icon;
	      let t0;
	      let div1;
	      let textbox;
	      let updating_value;
	      let t1;
	      let div2;
	      let t2;
	      let current;
	      icon = new Icon$1({
	        props: {
	          name: "funnel",
	          theme: /*theme*/ctx[3],
	          height: "24px"
	        }
	      });
	      function textbox_value_binding(value) {
	        /*textbox_value_binding*/ctx[13](value);
	      }
	      let textbox_props = {
	        id: /*_searchId*/ctx[5],
	        placeholder: /*$_*/ctx[4]("quickFilter"),
	        theme: /*theme*/ctx[3],
	        density: "high",
	        display: "custom",
	        "icon-path": "general/veneer/search-o.svg"
	      };
	      if (/*_untrimmedSearch*/ctx[1] !== void 0) {
	        textbox_props.value = /*_untrimmedSearch*/ctx[1];
	      }
	      textbox = new TextBox({
	        props: textbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(textbox, "value", textbox_value_binding));
	      textbox.$on("changed", /*quickFilterChanged*/ctx[7]);
	      let each_value = /*myFilters*/ctx[0];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block$3(get_each_context$3(ctx, each_value, i));
	      }
	      const out = i => transition_out$1(each_blocks[i], 1, 1, () => {
	        each_blocks[i] = null;
	      });
	      let if_block = /*counts*/ctx[2].items > 0 && create_if_block$a(ctx);
	      return {
	        c() {
	          div3 = element$1("div");
	          div0 = element$1("div");
	          create_component$1(icon.$$.fragment);
	          t0 = space$1();
	          div1 = element$1("div");
	          create_component$1(textbox.$$.fragment);
	          t1 = space$1();
	          div2 = element$1("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          t2 = space$1();
	          if (if_block) if_block.c();
	          attr$1(div0, "class", "pros-icon-container");
	          attr$1(div1, "class", "pros-search");
	          attr$1(div2, "class", "pros-filter-container");
	          attr$1(div3, "class", "pros-filter-bar");
	          attr$1(div3, "pos--theme", /*theme*/ctx[3]);
	        },
	        m(target, anchor) {
	          insert$1(target, div3, anchor);
	          append$1(div3, div0);
	          mount_component$1(icon, div0, null);
	          append$1(div3, t0);
	          append$1(div3, div1);
	          mount_component$1(textbox, div1, null);
	          append$1(div3, t1);
	          append$1(div3, div2);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div2, null);
	          }
	          append$1(div3, t2);
	          if (if_block) if_block.m(div3, null);
	          current = true;
	        },
	        p(ctx, [dirty]) {
	          const icon_changes = {};
	          if (dirty & /*theme*/8) icon_changes.theme = /*theme*/ctx[3];
	          icon.$set(icon_changes);
	          const textbox_changes = {};
	          if (dirty & /*_searchId*/32) textbox_changes.id = /*_searchId*/ctx[5];
	          if (dirty & /*$_*/16) textbox_changes.placeholder = /*$_*/ctx[4]("quickFilter");
	          if (dirty & /*theme*/8) textbox_changes.theme = /*theme*/ctx[3];
	          if (!updating_value && dirty & /*_untrimmedSearch*/2) {
	            updating_value = true;
	            textbox_changes.value = /*_untrimmedSearch*/ctx[1];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          textbox.$set(textbox_changes);
	          if (dirty & /*deleteFilter, myFilters, theme*/265) {
	            each_value = /*myFilters*/ctx[0];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context$3(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	                transition_in$1(each_blocks[i], 1);
	              } else {
	                each_blocks[i] = create_each_block$3(child_ctx);
	                each_blocks[i].c();
	                transition_in$1(each_blocks[i], 1);
	                each_blocks[i].m(div2, null);
	              }
	            }
	            group_outros$1();
	            for (i = each_value.length; i < each_blocks.length; i += 1) {
	              out(i);
	            }
	            check_outros$1();
	          }
	          if (/*counts*/ctx[2].items > 0) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	            } else {
	              if_block = create_if_block$a(ctx);
	              if_block.c();
	              if_block.m(div3, null);
	            }
	          } else if (if_block) {
	            if_block.d(1);
	            if_block = null;
	          }
	          if (!current || dirty & /*theme*/8) {
	            attr$1(div3, "pos--theme", /*theme*/ctx[3]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(icon.$$.fragment, local);
	          transition_in$1(textbox.$$.fragment, local);
	          for (let i = 0; i < each_value.length; i += 1) {
	            transition_in$1(each_blocks[i]);
	          }
	          current = true;
	        },
	        o(local) {
	          transition_out$1(icon.$$.fragment, local);
	          transition_out$1(textbox.$$.fragment, local);
	          each_blocks = each_blocks.filter(Boolean);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            transition_out$1(each_blocks[i]);
	          }
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div3);
	          destroy_component$1(icon);
	          destroy_component$1(textbox);
	          destroy_each$1(each_blocks, detaching);
	          if (if_block) if_block.d();
	        }
	      };
	    }
	    function instance$d($$self, $$props, $$invalidate) {
	      let $_;
	      component_subscribe$1($$self, X$1, $$value => $$invalidate(4, $_ = $$value));
	      const dispatch = createEventDispatcher$1();
	      let {
	        filters = []
	      } = $$props;
	      let {
	        myFilters = []
	      } = $$props;
	      let {
	        counts = []
	      } = $$props;
	      let {
	        columnDefs = undefined
	      } = $$props;
	      let {
	        _untrimmedSearch
	      } = $$props;
	      let {
	        theme = "light"
	      } = $$props;
	      let {
	        gridId = null
	      } = $$props;
	      let _searchId = null;

	      // Internal
	      let _filters = [];
	      let countDisplay = null;
	      beforeUpdate$1(() => {
	        $$invalidate(5, _searchId = gridId ? `${gridId}-search` : undefined);
	      });

	      // Methods
	      function quickFilterChanged(event) {
	        let value = _untrimmedSearch ? _untrimmedSearch.trim() : null;
	        dispatch("filterChanged", {
	          detail: value,
	          type: "quick"
	        });
	      }
	      function deleteFilter(filter) {
	        dispatch("deleteFilter", {
	          columnId: filter.columnId
	        });
	      }

	      // Others
	      function getFilterDisplay(filter) {
	        switch (filter.type) {
	          case "boolean":
	            return filter.display;
	          case "enum":
	            let displayList = [];
	            filter.selected.forEach(selected => {
	              displayList.push(selected.display);
	            });
	            let display;
	            if (displayList.length === 1) {
	              display = displayList[0];
	            } else {
	              display = displayList.join(", ");
	            }
	            return display;
	          default:
	            let display1 = getConditionDisplay(filter.type, filter.conditions[0]);
	            if (filter.conditions.length === 1) {
	              return display1;
	            }
	            let display2 = getConditionDisplay(filter.type, filter.conditions[1]);
	            switch (filter.operator) {
	              case "OR":
	                return $_("orFilter", {
	                  values: [display1, display2]
	                });
	              case "AND":
	                return $_("andFilter", {
	                  values: [display1, display2]
	                });
	            }
	        }
	      }
	      function getConditionDisplay(type, condition) {
	        switch (type) {
	          case "text":
	            return getTextConditionDisplay(condition);
	          case "number":
	            return getNumberConditionDisplay(condition);
	          case "date":
	            return getDateConditionDisplay(condition);
	        }
	      }
	      function getTextConditionDisplay(condition) {
	        switch (condition.type) {
	          case "contains":
	            return $_("containsFilter", {
	              values: [condition.filter]
	            });
	          case "notContains":
	            return $_("notContainsFilter", {
	              values: [condition.filter]
	            });
	          case "equals":
	            return $_("equalsFilter", {
	              values: [condition.filter]
	            });
	          case "notEqual":
	            return $_("notEqualFilter", {
	              values: [condition.filter]
	            });
	          case "startsWith":
	            return $_("startsWithFilter", {
	              values: [condition.filter]
	            });
	          case "endsWith":
	            return $_("endsWithFilter", {
	              values: [condition.filter]
	            });
	          case "isEmpty":
	            return $_("isEmptyFilter");
	          case "isNotEmpty":
	            return $_("isNotEmptyFilter");
	          default:
	            return condition.filter;
	        }
	      }
	      function getNumberConditionDisplay(condition) {
	        switch (condition.type) {
	          case "equals":
	            return $_("equalsFilter", {
	              values: [condition.filterA]
	            });
	          case "notEqual":
	            return $_("notEqualFilter", {
	              values: [condition.filterA]
	            });
	          case "lessThan":
	            return $_("lessThanFilter", {
	              values: [condition.filterA]
	            });
	          case "lessOrEqual":
	            return $_("lessThanOrEqualFilter", {
	              values: [condition.filterA]
	            });
	          case "greaterThan":
	            return $_("greaterThanFilter", {
	              values: [condition.filterA]
	            });
	          case "greaterOrEqual":
	            return $_("greaterThanOrEqualFilter", {
	              values: [condition.filterA]
	            });
	          case "betweenExclusive":
	            return $_("inRangeFilter", {
	              values: [condition.filterA, condition.filterB]
	            });
	          case "betweenInclusive":
	            return $_("inRangeFilter", {
	              values: [condition.filterA, condition.filterB]
	            });
	          case "isEmpty":
	            return $_("isEmptyFilter");
	          case "isNotEmpty":
	            return $_("isNotEmptyFilter");
	          default:
	            return value;
	        }
	      }
	      function getDateConditionDisplay(condition) {
	        let valueA = moment(condition.filterA).format("LL");
	        let valueB = condition.filterB ? moment(condition.filterB) : "";
	        switch (condition.type) {
	          case "equals":
	            return $_("equalsFilter", {
	              values: [valueA]
	            });
	          case "notEqual":
	            return $_("notEqualFilter", {
	              values: [valueA]
	            });
	          case "before":
	            return $_("beforeFilter", {
	              values: [valueA]
	            });
	          case "beforeOrSame":
	            return $_("beforeOrSameFilter", {
	              values: [valueA]
	            });
	          case "after":
	            return $_("afterFilter", {
	              values: [valueA]
	            });
	          case "afterOrSame":
	            return $_("afterOrSameFilter", {
	              values: [valueA]
	            });
	          case "betweenExclusive":
	            return $_("inRangeFilter", {
	              values: [valueA, valueB]
	            });
	          case "betweenInclusive":
	            return $_("inRangeFilter", {
	              values: [valueA, valueB]
	            });
	          case "isEmpty":
	            return $_("isEmptyFilter");
	          case "isNotEmpty":
	            return $_("isNotEmptyFilter");
	          default:
	            return value;
	        }
	      }
	      function textbox_value_binding(value) {
	        _untrimmedSearch = value;
	        $$invalidate(1, _untrimmedSearch);
	      }
	      $$self.$$set = $$props => {
	        if ("filters" in $$props) $$invalidate(9, filters = $$props.filters);
	        if ("myFilters" in $$props) $$invalidate(0, myFilters = $$props.myFilters);
	        if ("counts" in $$props) $$invalidate(2, counts = $$props.counts);
	        if ("columnDefs" in $$props) $$invalidate(10, columnDefs = $$props.columnDefs);
	        if ("_untrimmedSearch" in $$props) $$invalidate(1, _untrimmedSearch = $$props._untrimmedSearch);
	        if ("theme" in $$props) $$invalidate(3, theme = $$props.theme);
	        if ("gridId" in $$props) $$invalidate(11, gridId = $$props.gridId);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty & /*counts, $_*/20) {
	          // Computed
	          {
	            let itemLabel = counts.items > 1 ? counts.itemsLabel : counts.itemLabel;
	            if (counts.filterItems !== undefined) {
	              $$invalidate(6, countDisplay = $_("filteredGridCount", {
	                values: [counts.filterItems, counts.items, itemLabel]
	              }));
	            } else {
	              $$invalidate(6, countDisplay = $_("gridCount", {
	                values: [counts.items, itemLabel]
	              }));
	            }
	          }
	        }
	        if ($$self.$$.dirty & /*_filters, filters, columnDefs, myFilters*/5633) {
	          // onState
	          {
	            if (_filters != filters) {
	              $$invalidate(12, _filters = filters);
	              $$invalidate(0, myFilters = []);
	              if (filters) {
	                Object.keys(filters).forEach(columnId => {
	                  let filter = filters[columnId];
	                  let columnDef = columnDefs.find(c => {
	                    return c.colId === columnId;
	                  });
	                  let myFilter = {
	                    columnId,
	                    columnName: columnDef.headerName
	                  };
	                  myFilter.display = getFilterDisplay(filter);
	                  myFilters.push(myFilter);
	                });
	              }
	            }
	          }
	        }
	      };
	      return [myFilters, _untrimmedSearch, counts, theme, $_, _searchId, countDisplay, quickFilterChanged, deleteFilter, filters, columnDefs, gridId, _filters, textbox_value_binding];
	    }
	    class FilterBar extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-ehy03-style")) add_css$d();
	        init$1(this, options, instance$d, create_fragment$d, safe_not_equal$1, {
	          filters: 9,
	          myFilters: 0,
	          counts: 2,
	          columnDefs: 10,
	          _untrimmedSearch: 1,
	          theme: 3,
	          gridId: 11
	        });
	      }
	    }

	    /* src/ColumnsDialog.svelte generated by Svelte v3.38.2 */
	    function add_css$c() {
	      var style = element$1("style");
	      style.id = "svelte-xd57ap-style";
	      style.textContent = ".pros-button.svelte-xd57ap.svelte-xd57ap{display:flex;justify-content:center;align-items:center;border-radius:8px;box-sizing:border-box;background-color:#027aae;border:1px solid #027aae;color:#ffffff;fill:#ffffff;cursor:pointer;font-family:FormaDJR, sans-serif;font-size:16px;height:34px;line-height:30px;min-width:90px;padding:0 15px;position:relative;text-align:center;text-transform:uppercase;transition:all 0.3s ease 0s;vertical-align:middle;white-space:nowrap;user-select:none}.pros-button.svelte-xd57ap.svelte-xd57ap:focus{background-color:#027aae;border:1px solid #014562;text-decoration:none}@media(min-width: 480px){.pros-button.svelte-xd57ap.svelte-xd57ap:hover{background-color:#035c84;border:1px solid #035c84;text-decoration:none}}.pros-button.svelte-xd57ap.svelte-xd57ap:active{background-color:#012839;border:1px solid #012839}.pros-button.secondary.svelte-xd57ap.svelte-xd57ap{background-color:#ffffff;border:1px solid #027aae;color:#027aae}.pros-button.secondary.svelte-xd57ap.svelte-xd57ap:focus{background-color:#ffffff;border:1px solid #b5b5b5}@media(min-width: 480px){.pros-button.secondary.svelte-xd57ap.svelte-xd57ap:hover{background-color:rgba(2, 122, 174, 0.05)}}.pros-button.secondary.svelte-xd57ap.svelte-xd57ap:active{background-color:#014562;border:1px solid #014562}@media(min-width: 480px){}.pros-button.svelte-xd57ap.svelte-xd57ap:disabled{background-color:rgba(33, 33, 33, 0.05);border:1px solid rgba(33, 33, 33, 0.05);color:#adadad !important;cursor:default !important}.pros-button-group.horizontal.svelte-xd57ap.svelte-xd57ap{display:flex;justify-content:flex-start;align-items:center}.pros-button-group.horizontal.svelte-xd57ap>.pros-button.svelte-xd57ap:not(:last-child){margin-right:16px}.pros-button-group.horizontal.svelte-xd57ap>.pros-button.svelte-xd57ap{margin:1px 0}@media(min-width: 768px){}@media(max-width: 767px){}@keyframes svelte-xd57ap-fadein{from{opacity:0}to{opacity:1}}.pros-columns-dialog.svelte-xd57ap.svelte-xd57ap{min-width:300px}.pros-columns-dialog.svelte-xd57ap .pros-dialog-content.svelte-xd57ap{max-height:500px}.pros-columns-dialog.svelte-xd57ap .checkbox-container.svelte-xd57ap{width:100%;flex:1}.pros-columns-dialog.svelte-xd57ap .checkbox-wrapper.svelte-xd57ap:not(:last-of-type){margin-bottom:8px}";
	      append$1(document.head, style);
	    }
	    function get_each_context$2(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[8] = list[i];
	      child_ctx[9] = list;
	      child_ctx[10] = i;
	      return child_ctx;
	    }

	    // (4:8) {#each columnOptions as columnOption}
	    function create_each_block$2(ctx) {
	      let div;
	      let checkbox;
	      let updating_label;
	      let updating_value;
	      let t;
	      let current;
	      function checkbox_label_binding(value) {
	        /*checkbox_label_binding*/ctx[6](value, /*columnOption*/ctx[8]);
	      }
	      function checkbox_value_binding(value) {
	        /*checkbox_value_binding*/ctx[7](value, /*columnOption*/ctx[8]);
	      }
	      let checkbox_props = {
	        theme: /*_theme*/ctx[1],
	        display: "custom"
	      };
	      if (/*columnOption*/ctx[8].display !== void 0) {
	        checkbox_props.label = /*columnOption*/ctx[8].display;
	      }
	      if (/*columnOption*/ctx[8].show !== void 0) {
	        checkbox_props.value = /*columnOption*/ctx[8].show;
	      }
	      checkbox = new CheckBox({
	        props: checkbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(checkbox, "label", checkbox_label_binding));
	      binding_callbacks$1.push(() => bind$1(checkbox, "value", checkbox_value_binding));
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(checkbox.$$.fragment);
	          t = space$1();
	          attr$1(div, "class", "checkbox-wrapper svelte-xd57ap");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(checkbox, div, null);
	          append$1(div, t);
	          current = true;
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          const checkbox_changes = {};
	          if (dirty & /*_theme*/2) checkbox_changes.theme = /*_theme*/ctx[1];
	          if (!updating_label && dirty & /*columnOptions*/1) {
	            updating_label = true;
	            checkbox_changes.label = /*columnOption*/ctx[8].display;
	            add_flush_callback$1(() => updating_label = false);
	          }
	          if (!updating_value && dirty & /*columnOptions*/1) {
	            updating_value = true;
	            checkbox_changes.value = /*columnOption*/ctx[8].show;
	            add_flush_callback$1(() => updating_value = false);
	          }
	          checkbox.$set(checkbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(checkbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(checkbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(checkbox);
	        }
	      };
	    }
	    function create_fragment$c(ctx) {
	      let div7;
	      let div1;
	      let div0;
	      let t0;
	      let div6;
	      let div2;
	      let t1;
	      let div5;
	      let div3;
	      let t3;
	      let div4;
	      let current;
	      let mounted;
	      let dispose;
	      let each_value = /*columnOptions*/ctx[0];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
	      }
	      const out = i => transition_out$1(each_blocks[i], 1, 1, () => {
	        each_blocks[i] = null;
	      });
	      return {
	        c() {
	          div7 = element$1("div");
	          div1 = element$1("div");
	          div0 = element$1("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          t0 = space$1();
	          div6 = element$1("div");
	          div2 = element$1("div");
	          t1 = space$1();
	          div5 = element$1("div");
	          div3 = element$1("div");
	          div3.textContent = "Cancel";
	          t3 = space$1();
	          div4 = element$1("div");
	          div4.textContent = "Submit";
	          attr$1(div0, "class", "checkbox-container svelte-xd57ap");
	          attr$1(div1, "class", "pros-dialog-content svelte-xd57ap");
	          attr$1(div2, "class", "pros-flex");
	          attr$1(div3, "class", "pros-button secondary svelte-xd57ap");
	          attr$1(div4, "class", "pros-button svelte-xd57ap");
	          attr$1(div5, "class", "pros-button-group horizontal svelte-xd57ap");
	          attr$1(div6, "class", "pros-dialog-footer");
	          attr$1(div7, "class", "pros-columns-dialog svelte-xd57ap");
	        },
	        m(target, anchor) {
	          insert$1(target, div7, anchor);
	          append$1(div7, div1);
	          append$1(div1, div0);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div0, null);
	          }
	          append$1(div7, t0);
	          append$1(div7, div6);
	          append$1(div6, div2);
	          append$1(div6, t1);
	          append$1(div6, div5);
	          append$1(div5, div3);
	          append$1(div5, t3);
	          append$1(div5, div4);
	          current = true;
	          if (!mounted) {
	            dispose = [listen$1(div3, "click", /*cancel*/ctx[2]), listen$1(div4, "click", /*submit*/ctx[3])];
	            mounted = true;
	          }
	        },
	        p(ctx, [dirty]) {
	          if (dirty & /*_theme, columnOptions*/3) {
	            each_value = /*columnOptions*/ctx[0];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context$2(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	                transition_in$1(each_blocks[i], 1);
	              } else {
	                each_blocks[i] = create_each_block$2(child_ctx);
	                each_blocks[i].c();
	                transition_in$1(each_blocks[i], 1);
	                each_blocks[i].m(div0, null);
	              }
	            }
	            group_outros$1();
	            for (i = each_value.length; i < each_blocks.length; i += 1) {
	              out(i);
	            }
	            check_outros$1();
	          }
	        },
	        i(local) {
	          if (current) return;
	          for (let i = 0; i < each_value.length; i += 1) {
	            transition_in$1(each_blocks[i]);
	          }
	          current = true;
	        },
	        o(local) {
	          each_blocks = each_blocks.filter(Boolean);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            transition_out$1(each_blocks[i]);
	          }
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div7);
	          destroy_each$1(each_blocks, detaching);
	          mounted = false;
	          run_all$1(dispose);
	        }
	      };
	    }
	    function instance$c($$self, $$props, $$invalidate) {
	      let {
	        columnOptions = []
	      } = $$props;
	      let {
	        options
	      } = $$props;
	      let {
	        theme
	      } = $$props;
	      let {
	        _theme = undefined
	      } = $$props;

	      // onCreate
	      onMount$1(() => {
	        $$invalidate(1, _theme = options.theme ? options.theme : "auto");
	        $$invalidate(0, columnOptions = []);
	        options.columns.forEach(c => {
	          let found = options.columnState.find(cs => {
	            return cs.colId === c.id;
	          });
	          if (found) {
	            columnOptions.push({
	              id: c.id,
	              display: c.display,
	              show: !found.hide
	            });
	          }
	        });
	        let myActions = get$1(options, "callbacks.actions", []);
	        myActions.forEach(a => {
	          let actionId = `action-${a.id}`;
	          let found = options.columnState.find(cs => {
	            return cs.colId === actionId;
	          });
	          if (found) {
	            let allowAction = true;
	            if (a.allow) {
	              allowAction = a.allow();
	            }
	            if (allowAction) {
	              columnOptions.push({
	                id: actionId,
	                display: options.internalTranslate("Action", {
	                  values: [options.externalTranslate(a.key)]
	                }),
	                show: !found.hide
	              });
	            }
	          }
	        });
	      });

	      // Methods
	      function cancel() {
	        dialog.cancel();
	      }
	      function submit() {
	        columnOptions.map(co => {
	          let found = options.columnState.find(c => {
	            return c.colId === co.id;
	          });
	          if (found) {
	            found.hide = !co.show;
	          }
	        });
	        dialog.hide(options.columnState);
	      }
	      function checkbox_label_binding(value, columnOption) {
	        if ($$self.$$.not_equal(columnOption.display, value)) {
	          columnOption.display = value;
	          $$invalidate(0, columnOptions);
	        }
	      }
	      function checkbox_value_binding(value, columnOption) {
	        if ($$self.$$.not_equal(columnOption.show, value)) {
	          columnOption.show = value;
	          $$invalidate(0, columnOptions);
	        }
	      }
	      $$self.$$set = $$props => {
	        if ("columnOptions" in $$props) $$invalidate(0, columnOptions = $$props.columnOptions);
	        if ("options" in $$props) $$invalidate(4, options = $$props.options);
	        if ("theme" in $$props) $$invalidate(5, theme = $$props.theme);
	        if ("_theme" in $$props) $$invalidate(1, _theme = $$props._theme);
	      };
	      return [columnOptions, _theme, cancel, submit, options, theme, checkbox_label_binding, checkbox_value_binding];
	    }
	    class ColumnsDialog extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-xd57ap-style")) add_css$c();
	        init$1(this, options, instance$c, create_fragment$c, safe_not_equal$1, {
	          columnOptions: 0,
	          options: 4,
	          theme: 5,
	          _theme: 1
	        });
	      }
	    }

	    var columns = {
	      getValue: getValue$1,
	      // Base Value, Filter evaluation
	      getString,
	      // Quick search, Export
	      renderCell,
	      // Cell value
	      getTextFromDefinition,
	      sortColumn
	    };
	    const ENUM_TYPE = {
	      VALUES: 'values',
	      LOOKUP: 'lookup'
	    };
	    const IMAGE_TYPE = {
	      SVG: 'svg',
	      IMAGE: 'image'
	    };

	    // Preprocess/Transform/Normalize the value
	    // Does NOT include any markup
	    function getValue$1(column, rowData, params) {
	      let rawValue = getRawValue(column, rowData);
	      let valueRenderer = get$1(column, 'callbacks.renderValue');
	      if (valueRenderer) {
	        rawValue = valueRenderer(rawValue, rowData, column, params);
	      }

	      // Marshall certain types so they don't blow up later
	      switch (column.type) {
	        case 'boolean':
	          rawValue = getBooleanValue(rawValue);
	          break;
	        case 'date':
	          rawValue = getDateValue(rawValue);
	          break;
	      }
	      return rawValue;
	    }
	    function getRawValue(column, rowData) {
	      let path = get$1(column, 'path');
	      if (!path) {
	        return null;
	      }
	      let rawValue = get$1(rowData, path, null);
	      if (rawValue === null) {
	        return rawValue;
	      }
	      return rawValue;
	    }
	    function getBooleanValue(value) {
	      if (value === undefined || value == null) {
	        return null;
	      }
	      let myValue = false;
	      switch (typeof value) {
	        case 'boolean':
	          myValue = value;
	          break;
	        case 'number':
	          myValue = value === 0 ? false : true;
	          break;
	        case 'string':
	          let test = value.toLowerCase();
	          myValue = test === 'true' || test === 't' ? true : false;
	          break;
	      }
	      return myValue;
	    }
	    function getDateValue(rawValue) {
	      if (rawValue === null || rawValue === undefined) {
	        return null;
	      }
	      return moment(rawValue);
	    }
	    function getString(column, rowData, params) {
	      let rawValue = getValue$1(column, rowData, params);
	      let stringValue = rawValue;
	      let renderString = get$1(column, 'callbacks.renderString');
	      if (renderString) {
	        stringValue = renderString(rawValue, rowData, column, params);
	      } else {
	        switch (column.type) {
	          case 'text':
	            stringValue = getTextString(rawValue, rowData, column);
	            break;
	          case 'number':
	            stringValue = getNumberString(rawValue, rowData, column);
	            break;
	          case 'array':
	            stringValue = getArrayString(rawValue, rowData, column);
	            break;
	          case 'boolean':
	            stringValue = getBooleanString(rawValue, rowData, column);
	            break;
	          case 'date':
	            stringValue = getDateString(rawValue, rowData, column);
	            break;
	          case 'enum':
	            stringValue = '' + getEnumString(rawValue, rowData, column);
	            break;
	        }
	      }
	      return stringValue;
	    }
	    function getTextString(value, rowData, column) {
	      if (value === null || value === undefined) {
	        return null;
	      }
	      value = '' + value;
	      let textDefinition = get$1(column, 'text');
	      let myValue = getTextFromDefinition(value, textDefinition, column.translateExternal);
	      let display = get$1(column, 'text.display');
	      if (display) {
	        switch (display) {
	          case 'upper':
	            myValue = myValue.toLocaleUpperCase();
	            break;
	          case 'lower':
	            myValue = myValue.toLocaleLowerCase();
	            break;
	          case 'capitalize':
	            myValue = myValue.charAt(0).toLocaleUpperCase() + myValue.substr(1);
	            break;
	        }
	      }
	      return myValue === undefined ? null : myValue;
	    }
	    function getNumberString(value, rowData, column) {
	      if (value === null || value === undefined) {
	        return null;
	      }
	      let myValue = value;
	      let toFixed = get$1(column, 'number.toFixed');
	      let display = get$1(column, 'number.display');
	      switch (display) {
	        case 'currency':
	          let currency = get$1(column, 'number.currency.type');
	          if (!currency) {
	            currency = 'USD';
	          }
	          if (toFixed) {
	            myValue = myValue.toFixed(toFixed);
	          }
	          myValue = value.toLocaleString('en-US', {
	            style: 'currency',
	            currency: currency
	          });
	          break;
	        case 'size':
	          let unit = get$1(column, 'number.size.incomingUnit');
	          if (!unit) {
	            unit = 'B';
	          }
	          let bytes = getBytesFromValue(value, unit);
	          let displayUnit = get$1(column, 'number.size.displayUnit');
	          if (!displayUnit) {
	            displayUnit = getBestFitSizeUnit(bytes);
	          }
	          if (unit !== displayUnit) {
	            // Convert value
	            myValue = getValueFromBytes(bytes, displayUnit);
	          }
	          if (toFixed) {
	            myValue = myValue.toFixed(toFixed);
	          }
	          myValue += ' ' + column.translateInternal(`SizeUnit_${displayUnit}`);
	          break;
	        case 'duration':
	          let durationUnit = get$1(column, 'number.duration.unit');
	          if (!durationUnit) {
	            durationUnit = 'ms';
	          }
	          let smallestUnit = get$1(column, 'number.duration.smallestUnit');
	          if (!smallestUnit) {
	            smallestUnit = 's';
	          }
	          let duration = moment.duration(value, durationUnit);
	          let durationDisplays = [];
	          let years = duration.get('y');
	          let days = duration.get('d');
	          let hours = duration.get('h');
	          let minutes = duration.get('m');
	          let seconds = duration.get('s');
	          let millis = duration.get('ms');
	          if (includeUnit('y', smallestUnit)) {
	            if (!includeUnit('d', smallestUnit) && days > 182) {
	              years++;
	            }
	            if (years > 0) {
	              durationDisplays.push(getDurationDisplay(years, 'y', column));
	            }
	          }
	          if (includeUnit('d', smallestUnit)) {
	            if (!includeUnit('h', smallestUnit) && hours > 12) {
	              days++;
	            }
	            if (days > 0) {
	              durationDisplays.push(getDurationDisplay(days, 'd', column));
	            }
	          }
	          if (includeUnit('h', smallestUnit)) {
	            if (!includeUnit('m', smallestUnit) && minutes > 30) {
	              hours++;
	            }
	            if (hours > 0) {
	              durationDisplays.push(getDurationDisplay(hours, 'h', column));
	            }
	          }
	          if (includeUnit('m', smallestUnit)) {
	            if (!includeUnit('s', smallestUnit) && seconds > 30) {
	              minutes++;
	            }
	            if (minutes > 0) {
	              durationDisplays.push(getDurationDisplay(minutes, 'm', column));
	            }
	          }
	          if (includeUnit('s', smallestUnit)) {
	            if (!includeUnit('ms', smallestUnit) && millis > 500) {
	              seconds++;
	            }
	            if (seconds > 0) {
	              durationDisplays.push(getDurationDisplay(seconds, 's', column));
	            }
	          }
	          if (includeUnit('ms', smallestUnit)) {
	            if (millis > 0) {
	              durationDisplays.push(getDurationDisplay(millis, 'ms', column));
	            }
	          }
	          myValue = durationDisplays.slice(0, 3).join(', ');
	          break;
	        case 'percent':
	          if (toFixed) {
	            myValue = myValue.toFixed(toFixed);
	          }
	          myValue += '%';
	          break;
	        case 'units':
	          let unitDisplay;
	          let singleUnitKey = get$1(column, 'number.units.unitKey');
	          let pluralUnitKey = get$1(column, 'number.units.unitsKey');
	          if (singleUnitKey && pluralUnitKey) {
	            if (myValue === 1) {
	              unitDisplay = column.translateExternal(singleUnitKey);
	            } else {
	              unitDisplay = column.translateExternal(pluralUnitKey);
	            }
	          }
	          if (toFixed) {
	            myValue = myValue.toFixed(toFixed);
	          }
	          if (unitDisplay) {
	            myValue += ' ' + unitDisplay;
	          }
	          break;
	      }
	      return myValue === undefined ? null : myValue;
	    }
	    function getArrayString(value, rowData, column) {
	      if (!value || value.length === 0) {
	        return null;
	      }
	      let myValue = null;
	      let arrayType = get$1(column, 'array.type', 'simple'); //value | object
	      let displayType = get$1(column, 'array.display', 'list'); //lookup (obj only) | list | summary
	      if (arrayType === 'simple') {
	        if (value.constructor === {}.constructor) {
	          return null; // Invalid
	        }
	        switch (displayType) {
	          case 'list':
	            myValue = value.map(v => {
	              return `${v}`;
	            }).join(', ');
	            break;
	          case 'summary':
	            let itemKey = get$1(column, 'array.itemKey');
	            let itemsKey = get$1(column, 'array.itemsKey');
	            let itemLabel;
	            if (value.length === 1) {
	              itemLabel = itemKey ? column.translateExternal(itemKey) : column.translateInternal(`item`);
	            } else {
	              itemLabel = itemsKey ? column.translateExternal(itemsKey) : column.translateInternal(`items`);
	            }
	            myValue = column.translateInternal('gridCount', {
	              values: [value.length, itemLabel]
	            });
	            break;
	          case 'lookup':
	            return null;
	          // Invalid
	        }
	      } else {
	        let valuePath = get$1(column, 'array.valuePath');
	        let idPath = get$1(column, 'array.idPath');
	        switch (displayType) {
	          case 'list':
	            if (!valuePath) {
	              return null; //invalid
	            }
	            myValue = value.map(o => {
	              let definition = get$1(column, 'array.text');
	              let idPath = get$1(column, 'array.idPath');
	              if (idPath) {
	                let keyTitle = definition ? getTextFromDefinition(get$1(o, idPath), definition, column.translateExternal) : get$1(o, idPath);
	                return keyTitle ? `${keyTitle}:${o[valuePath]}` : `${o[valuePath]}`;
	              } else {
	                return get$1(o, valuePath);
	              }
	            }).join(', ');
	            break;
	          case 'summary':
	            let itemKey = get$1(column, 'array.itemKey');
	            let itemsKey = get$1(column, 'array.itemsKey');
	            let itemLabel;
	            if (value.length === 1) {
	              itemLabel = itemKey ? column.translateExternal(itemKey) : column.translateInternal(`item`);
	            } else {
	              itemLabel = itemsKey ? column.translateExternal(itemsKey) : column.translateInternal(`items`);
	            }
	            myValue = column.translateInternal('gridCount', {
	              values: [value.length, itemLabel]
	            });
	            break;
	          case 'lookup':
	            if (!valuePath) {
	              return null; //invalid
	            }
	            let searchKey = get$1(column, 'array.key');
	            if (!idPath || !searchKey) {
	              return null; // Invalid
	            }
	            let found = value.find(v => {
	              return v[idPath] === searchKey;
	            });
	            myValue = found ? found[valuePath] : null;
	            break;
	        }
	      }
	      return myValue === undefined ? null : myValue;
	    }
	    function includeUnit(unit, smallestUnit) {
	      switch (unit) {
	        case 'd':
	          switch (smallestUnit) {
	            case 'y':
	              return false;
	          }
	          break;
	        case 'h':
	          switch (smallestUnit) {
	            case 'y':
	            case 'd':
	              return false;
	          }
	          break;
	        case 'm':
	          switch (smallestUnit) {
	            case 'y':
	            case 'd':
	            case 'h':
	              return false;
	          }
	          break;
	        case 's':
	          switch (smallestUnit) {
	            case 'y':
	            case 'd':
	            case 'h':
	            case 'm':
	              return false;
	          }
	          break;
	        case 'ms':
	          switch (smallestUnit) {
	            case 'y':
	            case 'd':
	            case 'h':
	            case 'm':
	            case 's':
	              return false;
	          }
	          break;
	      }
	      return true;
	    }
	    function getDurationDisplay(time, unit, column) {
	      let format = get$1(column, 'number.duration.format');
	      if (!format) {
	        format = 'full';
	      }
	      let unitKey = 'Duration_';
	      switch (unit) {
	        case 'ms':
	          unitKey += 'Millis_';
	          break;
	        case 's':
	          unitKey += 'Seconds_';
	          break;
	        case 'm':
	          unitKey += 'Minutes_';
	          break;
	        case 'h':
	          unitKey += 'Hours_';
	          break;
	        case 'd':
	          unitKey += 'Days_';
	          break;
	        case 'y':
	          unitKey += 'Years_';
	          break;
	      }
	      switch (format) {
	        case 'full':
	          unitKey += 'Full';
	          break;
	        case 'medium':
	          unitKey += 'Medium';
	          break;
	        case 'short':
	          unitKey += 'Short';
	          break;
	      }
	      return time + ' ' + column.translateInternal(unitKey);
	    }
	    function getBestFitSizeUnit(value) {
	      if (value > 1024 * 1024 * 1024 * 1024) {
	        return 'TB';
	      }
	      if (value > 1024 * 1024 * 1024) {
	        return 'GB';
	      }
	      if (value > 1024 * 1024) {
	        return 'MB';
	      }
	      if (value > 1024) {
	        return 'KB';
	      }
	      return 'B';
	    }
	    function getBytesFromValue(value, unit) {
	      if (!unit) {
	        return value;
	      }
	      switch (unit) {
	        case 'B':
	          return value;
	        case 'KB':
	          return value * 1024;
	        case 'MB':
	          return value * 1024 * 1024;
	        case 'GB':
	          return value * 1024 * 1024 * 1024;
	        case 'TB':
	          return value * 1024 * 1024 * 1024 * 1024;
	      }
	    }
	    function getValueFromBytes(bytes, unit) {
	      switch (unit) {
	        case 'B':
	          return bytes;
	        case 'KB':
	          return bytes / 1024;
	        case 'MB':
	          return bytes / 1024 / 1024;
	        case 'GB':
	          return bytes / 1024 / 1024 / 1024;
	        case 'TB':
	          return bytes / 1024 / 1024 / 1024 / 1024;
	      }
	    }
	    function getBooleanString(value, rowData, column) {
	      if (value === undefined || value === null) {
	        return null;
	      }
	      let displayType = get$1(column, 'boolean.display', 'yes');
	      let myValue = value;
	      switch (displayType) {
	        case 'yes':
	          myValue = value ? column.translateInternal('BooleanYes') : column.translateInternal('BooleanNo');
	          break;
	        case 'enabled':
	          myValue = value ? column.translateInternal('BooleanEnabled') : column.translateInternal('BooleanDisabled');
	          break;
	        case 'true':
	          myValue = value ? column.translateInternal('BooleanTrue') : column.translateInternal('BooleanFalse');
	          break;
	        case 'locked':
	          myValue = value ? column.translateInternal('BooleanLocked') : column.translateInternal('BooleanUnlocked');
	          break;
	        case 'active':
	          myValue = value ? column.translateInternal('BooleanActive') : column.translateInternal('BooleanInactive');
	          break;
	        case 'ok':
	          myValue = value ? column.translateInternal('BooleanOk') : column.translateInternal('BooleanError');
	          break;
	        case 'custom':
	          let values = get$1(column, 'boolean.values', []);
	          let valueDefinition = values.find(vd => {
	            return vd.value === value;
	          });
	          if (!valueDefinition) {
	            myValue = null;
	            break;
	          }
	          myValue = getTextFromDefinition(myValue, valueDefinition.text, column.translateExternal);
	          break;
	      }
	      return myValue === undefined ? null : myValue;
	    }
	    function getDateString(value, rowData, column) {
	      if (value === null || value === undefined) {
	        return null;
	      }
	      let displayType = get$1(column, 'date.display', 'medium');
	      let show = get$1(column, 'date.show', 'date');
	      let myValue = value;
	      switch (displayType) {
	        case 'elapse':
	          myValue = myValue.fromNow();
	          break;
	        case 'full':
	          switch (show) {
	            case 'both':
	              myValue = myValue.format('LLLL');
	              break;
	            case 'date':
	              myValue = myValue.format('dddd, MMMM D, YYYY');
	              break;
	            case 'time':
	              myValue = myValue.format('LTS');
	              break;
	          }
	          break;
	        case 'medium':
	          switch (show) {
	            case 'both':
	              myValue = myValue.format('lll');
	              break;
	            case 'date':
	              myValue = myValue.format('ll');
	              break;
	            case 'time':
	              myValue = myValue.format('LT');
	              break;
	          }
	          break;
	        case 'short':
	          switch (show) {
	            case 'both':
	              myValue = myValue.format('L LT');
	              break;
	            case 'date':
	              myValue = myValue.format('L');
	              break;
	            case 'time':
	              myValue = myValue.format('LT');
	              break;
	          }
	          break;
	        case 'format':
	          let format = get$1(column, 'date.format');
	          if (!format || format === '') {
	            format = 'LL';
	          }
	          myValue = myValue.format(format);
	          break;
	      }
	      return myValue === undefined ? null : myValue;
	    }
	    function getEnumString(value, rowData, column) {
	      let returnValue = value;
	      let myValue = value;
	      let enumType = get$1(column, 'enum.type', 'values');
	      let isList = get$1(column, 'enum.list', false);
	      if (isList) {
	        return renderEnumListStringValue(value, rowData, column);
	      }
	      switch (enumType) {
	        case ENUM_TYPE.VALUES:
	          let valueDefinitions = get$1(column, 'enum.values');
	          if (valueDefinitions) {
	            let valueDefinition = valueDefinitions.find(vd => {
	              return vd.value === myValue;
	            });
	            if (valueDefinition) {
	              returnValue = getTextFromDefinition(myValue, valueDefinition.text, column.translateExternal);
	            }
	          }
	          break;
	        case ENUM_TYPE.LOOKUP:
	          let lookupDefinition = get$1(column, 'enum.lookup');
	          if (lookupDefinition) {
	            returnValue = getTextFromDefinition(myValue, lookupDefinition.text, column.translateExternal);
	          }
	          break;
	      }
	      return returnValue === undefined ? null : returnValue;
	    }
	    function renderEnumListStringValue(value, rowData, column) {
	      let returnValue = value;
	      let myValue = value;
	      let enumType = get$1(column, 'enum.type', 'values');
	      if (myValue && !Array.isArray(myValue)) {
	        myValue = [myValue];
	      }
	      if (!myValue) {
	        return null;
	      }
	      let separator = get$1(column, 'enum.separator', ', ');
	      switch (enumType) {
	        case ENUM_TYPE.VALUES:
	          let valueDefinitions = get$1(column, 'enum.values');
	          if (valueDefinitions) {
	            let values = [];
	            myValue.forEach(v => {
	              let valueDefinition = valueDefinitions.find(vd => {
	                return vd.value === v;
	              });
	              if (valueDefinition) {
	                values.push(getTextFromDefinition(myValue, valueDefinition.text, column.translateExternal));
	              } else {
	                values.push(v);
	              }
	            });
	            returnValue = values.join(separator);
	          }
	          break;
	        case ENUM_TYPE.LOOKUP:
	          let lookupDefinition = get$1(column, 'enum.lookup');
	          if (lookupDefinition) {
	            myValue.forEach(v => {
	              values.push(getTextFromDefinition(myValue, lookupDefinition.text, column.translateExternal));
	            });
	            returnValue = values.join(separator);
	          }
	          break;
	      }
	      return returnValue === undefined ? null : returnValue;
	    }
	    function renderCell(column, rowData, params) {
	      let rawValue = getValue$1(column, rowData, params);
	      let cellValue = rawValue;
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-wrapper');
	      let myClass = get$1(column, 'options.class');
	      if (myClass) {
	        if (Array.isArray(myClass)) {
	          myClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(myClass);
	        }
	      }
	      let tooltipCallback = get$1(column, 'callbacks.tooltip');
	      let isCustomTooltip = tooltipCallback ? true : false;
	      let linkCallbacks = get$1(column, 'callbacks.link');
	      let isLink = linkCallbacks ? true : false;
	      let isLinkCallback = get$1(column, 'callbacks.link.isLink');
	      if (isLinkCallback) {
	        isLink = isLinkCallback(rawValue, rowData, column);
	      }
	      let anchorElement;
	      if (isLink) {
	        element.classList.add('pros-link-wrapper');
	        let href = linkCallbacks.href;
	        let newTab = get$1(linkCallbacks, 'newTab', true);
	        if (href) {
	          anchorElement = document.createElement('a');
	          anchorElement.classList.add('pros-link');
	          anchorElement.setAttribute('href', href);
	          if (newTab) {
	            anchorElement.setAttribute('target', '_blank');
	          }
	        }
	      }
	      let cellRenderer = get$1(column, 'callbacks.renderCell');
	      if (cellRenderer) {
	        let testValue = cellRenderer(rawValue, rowData, column, params);
	        if (!testValue) {
	          cellValue = null;
	        } else if (testValue instanceof Element) {
	          cellValue = testValue;
	        } else {
	          cellValue = document.createElement('div');
	          if (testValue[0] === '<') {
	            cellValue.innerHTML = testValue;
	          } else {
	            cellValue.innerText = testValue;
	          }
	        }
	      } else {
	        switch (column.type) {
	          case 'text':
	            cellValue = renderTextCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'number':
	            cellValue = renderNumberCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'array':
	            cellValue = renderArrayCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'date':
	            cellValue = renderDateCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'enum':
	            cellValue = renderEnumCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'boolean':
	            cellValue = renderBooleanCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'image':
	            cellValue = renderImageCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'icon':
	            cellValue = renderIconCell(rawValue, rowData, column, params, isCustomTooltip);
	            break;
	          case 'action':
	            cellValue = renderActionCell(rawValue, rowData, column, params);
	            break;
	        }
	      }
	      if (!cellValue) {
	        return null;
	      }
	      if (anchorElement) {
	        let intermediate = document.createElement('div');
	        intermediate.classList.add('link-content-wrapper');
	        if (tooltipCallback) {
	          let tooltip = tooltipCallback(rawValue, rowData, column);
	          if (tooltip) {
	            if (tooltip instanceof Element) {
	              cellValue.setAttribute('pros-tooltip', tooltip.outerHTML);
	            } else {
	              cellValue.setAttribute('pros-tooltip', tooltip);
	            }
	          }
	        }
	        intermediate.appendChild(cellValue);
	        anchorElement.appendChild(intermediate);
	        element.appendChild(anchorElement);
	      } else {
	        if (tooltipCallback) {
	          let tooltip = tooltipCallback(rawValue, rowData, column);
	          if (tooltip) {
	            if (tooltip instanceof Element) {
	              cellValue.setAttribute('pros-tooltip', tooltip.outerHTML);
	            } else {
	              cellValue.setAttribute('pros-tooltip', tooltip);
	            }
	          }
	        }
	        if (cellValue instanceof Element) {
	          element.appendChild(cellValue);
	        } else {
	          element.innerText = cellValue;
	        }
	      }
	      return element;
	    }
	    function renderTextCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      if (!value) {
	        return value;
	      }
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('text-cell');
	      let myClass = get$1(column, 'text.class');
	      if (myClass) {
	        if (Array.isArray(myClass)) {
	          myClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(myClass);
	        }
	      }
	      if (!isCustomTooltip) {
	        element.setAttribute('pros-tooltip', '');
	      }
	      element.innerText = getTextString(value, rowData, column);
	      return element;
	    }
	    function renderNumberCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('number-cell');
	      let myClass = get$1(column, 'number.class');
	      if (myClass) {
	        if (Array.isArray(myClass)) {
	          myClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(myClass);
	        }
	      }
	      if (!isCustomTooltip) {
	        element.setAttribute('pros-tooltip', '');
	      }
	      element.innerText = getNumberString(value, rowData, column);
	      return element;
	    }
	    function getLoadingContent() {
	      let rowElement = document.createElement('div');
	      new Spinner({
	        target: rowElement,
	        props: {
	          diameter: 16
	        }
	      });

	      // element.setAttribute('src', value);
	      return rowElement;
	    }
	    function renderArrayCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      let displayValue = getArrayString(value, rowData, column);
	      if (displayValue === null) {
	        return null;
	      }
	      let definition = get$1(column, 'array.text');
	      // let arrayType = get(column, 'array.type', 'simple'); //value | object
	      let displayType = get$1(column, 'array.display', 'list'); //lookup (obj only) | list | summary

	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('array-cell');
	      let myClass = get$1(column, 'array.class');
	      if (myClass) {
	        if (Array.isArray(myClass)) {
	          myClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(myClass);
	        }
	      }
	      if (!isCustomTooltip) {
	        if (displayType === 'summary') {
	          let valuePath = get$1(column, 'array.valuePath');
	          let idPath = get$1(column, 'array.idPath');
	          let tooltip = `<div class='pros-array-tooltip'>`;
	          if (value.length > 20) {
	            tooltip += `<div class='pros-array-tooltip-wrapped'>`;
	            let tooltipArray = [];
	            value.forEach(item => {
	              let itemValue = valuePath ? get$1(item, valuePath) : `${item}`;
	              tooltipArray.push(itemValue);
	            });
	            tooltip += tooltipArray.join(', ');
	            tooltip += `</div>`;
	          } else {
	            value.forEach(item => {
	              tooltip += `<div class='pros-array-tooltip-row'>`;
	              let keyTitle = definition ? getTextFromDefinition(get$1(item, idPath), definition, column.translateExternal) : get$1(item, idPath);
	              let itemValue = valuePath ? get$1(item, valuePath) : `${item}`;
	              tooltip += keyTitle ? `<div class='pros-array-tooltip-title'>${keyTitle}: ${itemValue}</div>` : `<div class='pros-array-tooltip-title'>${itemValue}</div>`;
	              tooltip += `</div>`; //pros-array-tooltip-row
	            });
	          }
	          tooltip += '</div>'; //pros-array-tooltip
	          element.setAttribute('pros-tooltip', tooltip);
	        } else {
	          element.setAttribute('pros-tooltip', '');
	        }
	      }
	      element.innerText = getArrayString(value, rowData, column);
	      return element;
	    }
	    function renderBooleanCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      if (value === null || value === undefined) {
	        return null;
	      }
	      let valuesToHide = get$1(column, 'boolean.hideValues', []);
	      if (valuesToHide.includes(value)) {
	        return null;
	      }
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('boolean-cell');
	      let myClass = get$1(column, 'boolean.class');
	      if (myClass) {
	        if (Array.isArray(myClass)) {
	          myClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(myClass);
	        }
	      }
	      let display = get$1(column, 'boolean.display', 'yes');
	      let show = get$1(column, 'boolean.show', 'image');
	      let showText = show === 'text' || show === 'both';
	      let showImage = show === 'image' || show === 'both';
	      let definition = {};
	      let trueClass = get$1(column, 'boolean.classTrue');
	      let falseClass = get$1(column, 'boolean.classFalse');
	      if (value === true && trueClass) {
	        definition.class = trueClass;
	      }
	      if (value === false && falseClass) {
	        definition.class = falseClass;
	      }
	      // Set up text definition
	      switch (display) {
	        case 'yes':
	          set(definition, 'text.dev', value ? column.translateInternal('BooleanYes') : column.translateInternal('BooleanNo'));
	          break;
	        case 'enabled':
	          set(definition, 'text.dev', value ? column.translateInternal('BooleanEnabled') : column.translateInternal('BooleanDisabled'));
	          break;
	        case 'true':
	          set(definition, 'text.dev', value ? column.translateInternal('BooleanTrue') : column.translateInternal('BooleanFalse'));
	          break;
	        case 'locked':
	          set(definition, 'text.dev', value ? column.translateInternal('BooleanLocked') : column.translateInternal('BooleanUnlocked'));
	          break;
	        case 'active':
	          set(definition, 'text.dev', value ? column.translateInternal('BooleanActive') : column.translateInternal('BooleanInactive'));
	          break;
	        case 'ok':
	          set(definition, 'text.dev', value ? column.translateInternal('BooleanOk') : column.translateInternal('BooleanError'));
	          break;
	        case 'custom':
	          let valueDefinitions = get$1(column, 'boolean.values');
	          if (valueDefinitions) {
	            definition = valueDefinitions.find(vd => {
	              return vd.value === value;
	            });
	            if (!definition) {
	              console.warn(`WC-Grid: Missing value definition for colId: ${column.id} and value: ${value}`);
	              return null;
	            }
	          }
	          break;
	      }

	      // Setup image definition
	      switch (display) {
	        case 'yes':
	        case 'enabled':
	        case 'true':
	        case 'active':
	          if (value) {
	            set(definition, 'image', {
	              type: IMAGE_TYPE.SVG,
	              path: 'status/ok.svg',
	              color: '#509137',
	              size: '24'
	            });
	          } else {
	            set(definition, 'image', {
	              type: IMAGE_TYPE.SVG,
	              path: 'status/aborted.svg',
	              size: '24'
	              // color: '#F04B37'
	            });
	          }
	          break;
	        case 'ok':
	          if (value) {
	            set(definition, 'image', {
	              type: IMAGE_TYPE.SVG,
	              path: 'status/ok.svg',
	              color: '#509137',
	              size: '24'
	            });
	          } else {
	            set(definition, 'image', {
	              type: IMAGE_TYPE.SVG,
	              path: 'status/aborted.svg',
	              color: '#F04B37',
	              size: '24'
	            });
	          }
	          break;
	        case 'locked':
	          if (value) {
	            set(definition, 'image', {
	              type: IMAGE_TYPE.SVG,
	              path: 'general/veneer/lock-o.svg',
	              size: '24'
	              // color: '#509137'
	            });
	          } else {
	            set(definition, 'image', {
	              type: IMAGE_TYPE.SVG,
	              path: 'general/veneer/lock-open-o.svg',
	              // color: '#F04B37'
	              size: '24'
	            });
	          }
	          break;
	      }
	      let enumElement = renderEnumCellFromDefinition(value, definition, showImage, showText, column, params, isCustomTooltip);
	      element.appendChild(enumElement);
	      return element;
	    }
	    function renderImageCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('image-cell');
	      if (!isCustomTooltip) {
	        element.setAttribute('pros-tooltip', '');
	      }
	      let imageElement = document.createElement('img');
	      let imageClass = get$1(column, 'image.class');
	      if (imageClass) {
	        imageElement.classList.add(imageClass);
	      }
	      imageElement.setAttribute('src', value);
	      let h = get$1(column, 'image.height');
	      let w = get$1(column, 'image.width');
	      imageElement.style.padding = '4px';
	      if (h) {
	        imageElement.style.height = !isNaN(h) ? `${h}px` : h;
	      }
	      if (w) {
	        imageElement.style.width = !isNaN(w) ? `${w}px` : w;
	      }
	      element.appendChild(imageElement);
	      return element;
	    }
	    function renderActionCell(value, rowData, column, params) {
	      let allow = true;
	      let allowCallback = get$1(column, 'callbacks.allow');
	      if (allowCallback) {
	        allow = allowCallback(rowData);
	      }
	      if (!allow) {
	        return null;
	      }
	      return renderIconCell(value, rowData, column, params);
	    }
	    function renderIconCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      let theme = get$1(params, 'colDef.gridParams.theme', 'auto');
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('icon-cell');
	      if (!isCustomTooltip) {
	        element.setAttribute('pros-tooltip', '');
	      }
	      let imageElement = document.createElement('div');
	      let imageType = get$1(column, 'icon.type', 'name');
	      let imageColor = get$1(column, 'icon.color');
	      get$1(column, 'icon.height');
	      let imageSize = get$1(column, 'icon.size');
	      let imageConstraint = get$1(column, 'icon.constraint');
	      imageElement.classList.add('pros-cell-icon');
	      let imageClass = get$1(column, 'icon.class');
	      if (imageClass) {
	        if (Array.isArray(imageClass)) {
	          imageClass.forEach(c => {
	            imageElement.classList.add(c);
	          });
	        } else {
	          imageElement.classList.add(imageClass);
	        }
	      }
	      let data = {
	        color: imageColor,
	        theme: theme,
	        size: imageSize ? imageSize : 24,
	        constraint: imageConstraint ? imageConstraint : 'h'
	      };
	      switch (imageType) {
	        case 'path':
	          data.path = getImagePathFromDefinition(value, column.icon, column.translateExternal);
	          break;
	        case 'name':
	          data.name = getImagePathFromDefinition(value, column.icon, column.translateExternal);
	          break;
	        case 'url':
	          data.url = getImagePathFromDefinition(value, column.icon, column.translateExternal);
	          break;
	      }
	      new Icon$1({
	        target: imageElement,
	        props: data
	      });
	      element.appendChild(imageElement);

	      // element.setAttribute('src', value);
	      return element;
	    }
	    function renderDateCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('date-cell');
	      let myClass = get$1(column, 'date.class');
	      if (myClass) {
	        if (Array.isArray(myClass)) {
	          myClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(myClass);
	        }
	      }
	      if (!isCustomTooltip) {
	        element.setAttribute('pros-tooltip', '');
	      }
	      element.innerText = getDateString(value, rowData, column);
	      return element;
	    }
	    function renderEnumCell(value, rowData, column, params, isCustomTooltip) {
	      let loadingCallback = get$1(column, 'callbacks.loading');
	      if (loadingCallback && loadingCallback(rowData)) {
	        return getLoadingContent();
	      }
	      if (value === null || value === undefined) {
	        return null;
	      }
	      let valuesToHide = get$1(column, 'enum.hideValues', []);
	      if (valuesToHide.includes(value)) {
	        return null;
	      }
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-content');
	      element.classList.add('enum-cell');
	      let myClass = get$1(column, 'enum.class');
	      if (myClass) {
	        if (Array.isArray(myClass)) {
	          myClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(myClass);
	        }
	      }
	      let enumType = get$1(column, 'enum.type', 'values');
	      let show = get$1(column, 'enum.show', 'text');
	      let showText = show === 'text' || show === 'both';
	      let showImage = show === 'image' || show === 'both';

	      // List Handling
	      let isList = get$1(column, 'enum.list', false);
	      if (isList) {
	        element.innerText = getEnumString(value, rowData, column);
	        if (!isCustomTooltip) {
	          element.setAttribute('pros-tooltip', '');
	        } else {
	          element.style.overflow = 'hidden';
	          element.style.whiteSpace = 'nowrap';
	          element.style.textOverflow = 'ellipsis';
	        }
	        return element;
	      }
	      let valueDefinition;
	      switch (enumType) {
	        case ENUM_TYPE.VALUES:
	          let valueDefinitions = get$1(column, 'enum.values');
	          if (valueDefinitions) {
	            valueDefinition = valueDefinitions.find(vd => {
	              return vd.value === value;
	            });
	          }
	          break;
	        case ENUM_TYPE.LOOKUP:
	          valueDefinition = get$1(column, 'enum.lookup');
	          break;
	      }
	      let enumElement = renderEnumCellFromDefinition(value, valueDefinition, showImage, showText, column, params, isCustomTooltip);
	      element.appendChild(enumElement);
	      return element;
	    }
	    function renderEnumCellFromDefinition(value, definition, showImage, showText, column, params, isCustomTooltip) {
	      if (!definition) {
	        showImage = false;
	        showText = true;
	        definition = {};
	      }
	      let theme = get$1(params, 'colDef.gridParams.theme', 'auto');
	      let element = document.createElement('div');
	      element.classList.add('pros-cell-row');
	      let definitionClass = get$1(definition, 'class');
	      if (definitionClass) {
	        if (Array.isArray(definitionClass)) {
	          definitionClass.forEach(c => {
	            element.classList.add(c);
	          });
	        } else {
	          element.classList.add(definitionClass);
	        }
	      }
	      if (!isCustomTooltip) {
	        element.setAttribute('pros-tooltip', '');
	      }
	      if (showImage) {
	        let imageType = get$1(definition, 'image.type', IMAGE_TYPE.SVG);
	        let imageColor = get$1(definition, 'image.color');
	        let imageHeight = get$1(definition, 'image.height');
	        let imageClass = get$1(definition, 'image.class');
	        let imageSize = get$1(definition, 'image.size');
	        let imageConstraint = get$1(definition, 'image.constraint');
	        let imageElement = document.createElement('div');
	        imageElement.classList.add('pros-cell-icon');
	        if (imageClass) {
	          if (Array.isArray(imageClass)) {
	            imageClass.forEach(c => {
	              imageElement.classList.add(c);
	            });
	          } else {
	            imageElement.classList.add(imageClass);
	          }
	        }
	        if (!isCustomTooltip) {
	          let tooltip = getTextFromDefinition(value, definition.text, column.translateExternal);
	          if (tooltip) {
	            imageElement.setAttribute('pros-tooltip', tooltip);
	          }
	        }
	        let data = {
	          color: imageColor,
	          theme: theme,
	          height: imageHeight ? imageHeight : '24px',
	          size: imageSize ? imageSize : 24,
	          constraint: imageConstraint ? imageConstraint : 'h'
	        };
	        switch (imageType) {
	          case IMAGE_TYPE.SVG:
	            data.path = getImagePathFromDefinition(value, definition.image, column.translateExternal);
	            break;
	          case IMAGE_TYPE.IMAGE:
	            data.name = getImagePathFromDefinition(value, definition.image, column.translateExternal);
	            break;
	        }
	        new Icon$1({
	          target: imageElement,
	          props: data
	        });
	        element.appendChild(imageElement);
	      }
	      if (showText) {
	        let textElement = document.createElement('div');
	        textElement.classList.add('pros-cell-text');
	        let textClass = get$1(definition, 'text.class');
	        if (textClass) {
	          if (Array.isArray(textClass)) {
	            textClass.forEach(c => {
	              textElement.classList.add(c);
	            });
	          } else {
	            textElement.classList.add(textClass);
	          }
	        }
	        if (!isCustomTooltip) {
	          textElement.setAttribute('pros-tooltip', '');
	        } else {
	          textElement.style.overflow = 'hidden';
	          textElement.style.whiteSpace = 'nowrap';
	          textElement.style.textOverflow = 'ellipsis';
	        }
	        textElement.innerText = getTextFromDefinition(value, definition.text, column.translateExternal);
	        element.appendChild(textElement);
	      }
	      return element;
	    }
	    function getTextFromDefinition(rawValue, definition, translate) {
	      if (!definition) {
	        return rawValue;
	      }
	      if (definition.lookupBase) {
	        let key = definition.lookupBase ? `${definition.lookupBase}${rawValue}` : rawValue;
	        return translate(key);
	      }
	      if (definition.key) {
	        return translate(definition.key);
	      }
	      if (definition.dev) {
	        return definition.dev;
	      }
	      return rawValue;
	    }
	    function getImagePathFromDefinition(rawValue, definition, translate) {
	      if (!definition) {
	        return rawValue;
	      }
	      if (definition.lookup) {
	        let key = definition.lookupBase ? `${definition.lookupBase}${rawValue}` : rawValue;
	        return translate(key);
	      }
	      if (definition.key) {
	        return translate(definition.key);
	      }
	      if (definition.path) {
	        return definition.path;
	      }
	      return rawValue;
	    }
	    function sortColumn(valA, valB, dataA, dataB, isInverted, column) {
	      switch (column.type) {
	        case 'text':
	          return sortTextColumn(valA, valB, dataA, dataB, isInverted, column);
	        case 'number':
	          return sortNumberColumn(valA, valB, dataA, dataB, isInverted, column);
	        case 'boolean':
	          return sortBooleanColumn(valA, valB, dataA, dataB, isInverted, column);
	        case 'date':
	          return sortDateColumn(valA, valB, dataA, dataB, isInverted, column);
	        case 'enum':
	          return sortEnumColumn(valA, valB, dataA, dataB, isInverted, column);
	        case 'array':
	          return sortArrayColumn(valA, valB, dataA, dataB, isInverted, column);
	        default:
	          if (valA < valB) {
	            return -1;
	          }
	          if (valA > valB) {
	            return 1;
	          }
	          return 0;
	      }
	    }
	    function sortTextColumn(valA, valB, dataA, dataB, isInverted, column) {
	      let valueA = getTextString(valA, dataA, column);
	      let valueB = getTextString(valB, dataB, column);
	      if (valueA === null && valueB !== null) {
	        return -1;
	      }
	      if (valueA !== null && valueB === null) {
	        return 1;
	      }
	      if (valueA === null && valueB === null) {
	        return 0;
	      }
	      return valueA.toLocaleLowerCase().localeCompare(valueB.toLocaleLowerCase());
	    }
	    function sortNumberColumn(valA, valB, dataA, dataB, isInverted, column) {
	      let valueA = getValue$1(column, dataA);
	      let valueB = getValue$1(column, dataB);
	      if (valueA === null && valueB !== null) {
	        return -1;
	      }
	      if (valueA !== null && valueB === null) {
	        return 1;
	      }
	      if (valueA === null && valueB === null) {
	        return 0;
	      }
	      return valueA - valueB;
	    }
	    function sortBooleanColumn(valA, valB, dataA, dataB, isInverted, column) {
	      let valueA = getValue$1(column, dataA);
	      let valueB = getValue$1(column, dataB);
	      if (valueA === null && valueB !== null) {
	        return -1;
	      }
	      if (valueA !== null && valueB === null) {
	        return 1;
	      }
	      if (valueA === null && valueB === null) {
	        return 0;
	      }
	      if (valueA && !valueB) {
	        return -1;
	      }
	      if (!valueA && valueB) {
	        return 1;
	      }
	      return 0;
	    }
	    function sortDateColumn(valA, valB, dataA, dataB, isInverted, column) {
	      let valueA = getValue$1(column, dataA);
	      let valueB = getValue$1(column, dataB);
	      if (valueA === null && valueB !== null) {
	        return -1;
	      }
	      if (valueA !== null && valueB === null) {
	        return 1;
	      }
	      if (valueA === null && valueB === null) {
	        return 0;
	      }
	      return valueA.valueOf() - valueB.valueOf();
	    }
	    function sortEnumColumn(valA, valB, dataA, dataB, isInverted, column) {
	      let valueA = getEnumString(valA, dataA, column);
	      let valueB = getEnumString(valB, dataB, column);
	      if (valueA === null && valueB !== null) {
	        return -1;
	      }
	      if (valueA !== null && valueB === null) {
	        return 1;
	      }
	      if (valueA === null && valueB === null) {
	        return 0;
	      }
	      return valueA.toLocaleLowerCase().localeCompare(valueB.toLocaleLowerCase());
	    }
	    function sortArrayColumn(valA, valB, dataA, dataB, isInverted, column) {
	      let displayType = get$1(column, 'array.display', 'list'); //lookup (obj only) | list | summary
	      if (displayType === 'summary') {
	        if (valA === null && valB !== null) {
	          return -1;
	        }
	        if (valA !== null && valB === null) {
	          return 1;
	        }
	        if (valA === null && valB === null) {
	          return 0;
	        }
	        return valA.length - valB.length;
	      }
	      let valueA = getArrayString(valA, dataA, column);
	      let valueB = getArrayString(valB, dataB, column);
	      if (valueA === null && valueB !== null) {
	        return -1;
	      }
	      if (valueA !== null && valueB === null) {
	        return 1;
	      }
	      if (valueA === null && valueB === null) {
	        return 0;
	      }
	      return valueA.toLocaleLowerCase().localeCompare(valueB.toLocaleLowerCase());
	    }

	    /* src/headers/GridHeader.svelte generated by Svelte v3.38.2 */
	    function add_css$b() {
	      var style = element$1("style");
	      style.id = "svelte-19yobkb-style";
	      style.textContent = ".pros-grid-header-container{display:flex;justify-content:center;align-items:center;height:100%;width:100%}.pros-grid-header-container else{flex-direction:row}.header-icon{display:flex;flex-direction:column;justify-content:center;align-items:center;width:24px;height:24px;border-radius:4px}.header-icon svg{height:16px;width:16px}.filter{cursor:pointer}.sort.descending{transition:transform 0.5s ease 0s;transform:rotate(-180deg);transition:transform 0.5s ease 0s}.pros-grid-header{display:flex;justify-content:flex-start;align-items:center;line-height:30px;width:100%;height:100%}.pros-grid-header else{flex-direction:row}.pros-grid-header.sortable{cursor:pointer}.pros-grid-header .pros-header-title{flex:1;font-size:14px;font-weight:400;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 4px;user-select:none}.pros-grid-header .header-icon.filter{display:none}.pros-grid-header .header-icon.filter.filtered{display:flex}.pros-grid-header:hover .header-icon.filter{display:flex}.pros-grid-header .superscript{height:28px;vertical-align:baseline !important;position:relative;line-height:0 !important;top:0.5em !important}";
	      append$1(document.head, style);
	    }

	    // (6:2) {#if canFilter}
	    function create_if_block_2$5(ctx) {
	      let div;
	      let svg;
	      let path;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element$1("div");
	          svg = svg_element$1("svg");
	          path = svg_element$1("path");
	          attr$1(path, "d", "M20.4062 4L13.9135 12.0348C13.6468 12.3647 13.5 12.776 13.5 13.1927V20L11.5 19.9918V13.1927C11.5 12.776 11.3531 12.3647 11.0865 12.0348L4.59375 4H20.4062ZM20.5362 3H4.46376C3.64647 3 3.17432 3.83448 3.65502 4.42936L10.3087 12.6633C10.433 12.8171 10.5 13.0025 10.5 13.1927V20.1C10.5 20.5971 10.9477 21 11.5 21H13.5C14.0523 21 14.5 20.5971 14.5 20.1V13.1927C14.5 13.0025 14.5669 12.8171 14.6913 12.6633L21.345 4.42936C21.8257 3.83448 21.3535 3 20.5362 3Z");
	          attr$1(svg, "id", /*_filterIconId*/ctx[7]);
	          attr$1(svg, "width", "24");
	          attr$1(svg, "height", "24");
	          attr$1(svg, "viewBox", "0 0 24 24");
	          attr$1(svg, "fill", "currentColor");
	          attr$1(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr$1(div, "id", /*_filterClickId*/ctx[6]);
	          attr$1(div, "class", "header-icon filter");
	          toggle_class$1(div, "filtered", /*isFiltered*/ctx[2]);
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          append$1(div, svg);
	          append$1(svg, path);
	          if (!mounted) {
	            dispose = listen$1(div, "click", /*filterClicked*/ctx[10]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty & /*_filterIconId*/128) {
	            attr$1(svg, "id", /*_filterIconId*/ctx[7]);
	          }
	          if (dirty & /*_filterClickId*/64) {
	            attr$1(div, "id", /*_filterClickId*/ctx[6]);
	          }
	          if (dirty & /*isFiltered*/4) {
	            toggle_class$1(div, "filtered", /*isFiltered*/ctx[2]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (14:2) {#if sortDirection}
	    function create_if_block_1$6(ctx) {
	      let div;
	      return {
	        c() {
	          div = element$1("div");
	          div.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13 17C12.8721 17 12.7441 16.9512 12.6465 16.8535L4.64648 8.85352C4.45117 8.6582 4.45117 8.3418 4.64648 8.14648C4.8418 7.95117 5.1582 7.95117 5.35352 8.14648L13 15.793L20.6465 8.14648C20.8418 7.95117 21.1582 7.95117 21.3535 8.14648C21.5488 8.3418 21.5488 8.6582 21.3535 8.85352L13.3535 16.8535C13.2559 16.9512 13.1279 17 13 17Z"></path></svg>`;
	          attr$1(div, "class", "header-icon sort");
	          toggle_class$1(div, "descending", /*sortDirection*/ctx[4] === "desc");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty & /*sortDirection*/16) {
	            toggle_class$1(div, "descending", /*sortDirection*/ctx[4] === "desc");
	          }
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	        }
	      };
	    }

	    // (21:2) {#if sortIndex}
	    function create_if_block$9(ctx) {
	      let sup;
	      let t;
	      return {
	        c() {
	          sup = element$1("sup");
	          t = text$1(/*sortIndex*/ctx[5]);
	          attr$1(sup, "class", "superscript");
	        },
	        m(target, anchor) {
	          insert$1(target, sup, anchor);
	          append$1(sup, t);
	        },
	        p(ctx, dirty) {
	          if (dirty & /*sortIndex*/32) set_data$1(t, /*sortIndex*/ctx[5]);
	        },
	        d(detaching) {
	          if (detaching) detach$1(sup);
	        }
	      };
	    }
	    function create_fragment$b(ctx) {
	      let div1;
	      let div0;
	      let t0;
	      let t1;
	      let t2;
	      let t3;
	      let mounted;
	      let dispose;
	      let if_block0 = /*canFilter*/ctx[1] && create_if_block_2$5(ctx);
	      let if_block1 = /*sortDirection*/ctx[4] && create_if_block_1$6(ctx);
	      let if_block2 = /*sortIndex*/ctx[5] && create_if_block$9(ctx);
	      return {
	        c() {
	          div1 = element$1("div");
	          div0 = element$1("div");
	          t0 = text$1(/*headerName*/ctx[0]);
	          t1 = space$1();
	          if (if_block0) if_block0.c();
	          t2 = space$1();
	          if (if_block1) if_block1.c();
	          t3 = space$1();
	          if (if_block2) if_block2.c();
	          attr$1(div0, "pros-tooltip", "");
	          attr$1(div0, "class", "pros-header-title");
	          attr$1(div1, "id", /*_sortClickId*/ctx[8]);
	          attr$1(div1, "class", "pros-grid-header");
	          toggle_class$1(div1, "sortable", /*isSortable*/ctx[3]);
	        },
	        m(target, anchor) {
	          insert$1(target, div1, anchor);
	          append$1(div1, div0);
	          append$1(div0, t0);
	          append$1(div1, t1);
	          if (if_block0) if_block0.m(div1, null);
	          append$1(div1, t2);
	          if (if_block1) if_block1.m(div1, null);
	          append$1(div1, t3);
	          if (if_block2) if_block2.m(div1, null);
	          if (!mounted) {
	            dispose = listen$1(div1, "click", /*sortClicked*/ctx[9]);
	            mounted = true;
	          }
	        },
	        p(ctx, [dirty]) {
	          if (dirty & /*headerName*/1) set_data$1(t0, /*headerName*/ctx[0]);
	          if (/*canFilter*/ctx[1]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_2$5(ctx);
	              if_block0.c();
	              if_block0.m(div1, t2);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (/*sortDirection*/ctx[4]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_1$6(ctx);
	              if_block1.c();
	              if_block1.m(div1, t3);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (/*sortIndex*/ctx[5]) {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block$9(ctx);
	              if_block2.c();
	              if_block2.m(div1, null);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (dirty & /*_sortClickId*/256) {
	            attr$1(div1, "id", /*_sortClickId*/ctx[8]);
	          }
	          if (dirty & /*isSortable*/8) {
	            toggle_class$1(div1, "sortable", /*isSortable*/ctx[3]);
	          }
	        },
	        i: noop$1,
	        o: noop$1,
	        d(detaching) {
	          if (detaching) detach$1(div1);
	          if (if_block0) if_block0.d();
	          if (if_block1) if_block1.d();
	          if (if_block2) if_block2.d();
	          mounted = false;
	          dispose();
	        }
	      };
	    }
	    function instance$b($$self, $$props, $$invalidate) {
	      let {
	        params = null
	      } = $$props;
	      let {
	        headerName = null
	      } = $$props;
	      let {
	        canFilter = true
	      } = $$props;
	      let {
	        isFiltered = false
	      } = $$props;
	      let {
	        isSortable = false
	      } = $$props;
	      let {
	        sortDirection = null
	      } = $$props;
	      let {
	        sortIndex = null
	      } = $$props;
	      let _gridId = null;
	      let _colId = null;
	      let _filterClickId = null;
	      let _filterIconId = null;
	      let _sortClickId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        _colId = get$1(params, "column.colDef.colId");
	        $$invalidate(6, _filterClickId = _gridId ? `${_gridId}-${_colId}-filter` : `${_colId}-filter`);
	        $$invalidate(8, _sortClickId = _gridId ? `${_gridId}-${_colId}-sort` : `${_colId}-sort`);
	        $$invalidate(7, _filterIconId = `${_colId}-filter-icon`);
	      });
	      function sortClicked(event) {
	        if (!isSortable) {
	          return;
	        }

	        // console.log('Sort Clicked', event.target.id);
	        // We are doing this instead of stopPropagation because global click handlers need to receive event
	        if (event.target.id === _filterClickId || event.target.id === _filterIconId) {
	          return;
	        }
	        params.progressSort(event.shiftKey);
	      }
	      function filterClicked(event) {
	        params.showColumnMenu(event.currentTarget.parentElement.parentElement);
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(11, params = $$props.params);
	        if ("headerName" in $$props) $$invalidate(0, headerName = $$props.headerName);
	        if ("canFilter" in $$props) $$invalidate(1, canFilter = $$props.canFilter);
	        if ("isFiltered" in $$props) $$invalidate(2, isFiltered = $$props.isFiltered);
	        if ("isSortable" in $$props) $$invalidate(3, isSortable = $$props.isSortable);
	        if ("sortDirection" in $$props) $$invalidate(4, sortDirection = $$props.sortDirection);
	        if ("sortIndex" in $$props) $$invalidate(5, sortIndex = $$props.sortIndex);
	      };
	      return [headerName, canFilter, isFiltered, isSortable, sortDirection, sortIndex, _filterClickId, _filterIconId, _sortClickId, sortClicked, filterClicked, params];
	    }
	    class GridHeader extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-19yobkb-style")) add_css$b();
	        init$1(this, options, instance$b, create_fragment$b, safe_not_equal$1, {
	          params: 11,
	          headerName: 0,
	          canFilter: 1,
	          isFiltered: 2,
	          isSortable: 3,
	          sortDirection: 4,
	          sortIndex: 5
	        });
	      }
	    }

	    class GridHeaderComponent {
	      init(params) {
	        let colDef = params.column.colDef;
	        this.agParams = params;
	        this.headerContainer = document.createElement('div');
	        this.headerContainer.classList.add('pros-grid-header-container');
	        let allowGlobalFilters = get$1(colDef.printOSOptions, 'grid.allowFilters', true);
	        let allowColumnFilter = get$1(colDef, 'printOSColumn.options.allowFilter', true);
	        let canFilter = !allowGlobalFilters || !allowColumnFilter ? false : true;
	        let isSortable = get$1(params, 'column.colDef.printOSColumn.options.allowSort', true);
	        this.header = new GridHeader({
	          target: this.headerContainer,
	          props: {
	            params: params,
	            options: colDef.printOSOptions,
	            column: colDef,
	            canFilter: canFilter,
	            isSortable: isSortable,
	            headerName: params.displayName
	          }
	        });
	        this.handleSortChanged();
	        this.sortChangedHandler = this.handleSortChanged.bind(this);
	        this.agParams.api.addEventListener('sortChanged', this.sortChangedHandler);
	        // this.agParams.api.addEventListener('sortChanged', this.onSortChanged.bind(this));
	        this.filterChangedHandler = this.onFilterChanged.bind(this);
	        this.agParams.column.addEventListener('filterChanged', this.filterChangedHandler);
	      }
	      getGui() {
	        // Contrary to the docs, this method is called twice.
	        // So, the element must be created in init() to be initialized correctly.
	        return this.headerContainer;
	      }
	      destroy() {
	        // this.header.$destroy(); Is this really necessary? See: https://github.com/sveltejs/svelte/issues/3089
	        this.agParams.api.removeEventListener(this.sortChangedHandler);
	        this.agParams.api.removeEventListener(this.filterChangedHandler);
	      }
	      onSortChanged() {
	        let sortModel = this.agParams.api.getSortModel();
	        let found = sortModel.find(s => s.colId === this.agParams.column.colId);
	        let sortDirection = found ? found.sort : null;
	        let sortIndex = sortModel.length > 1 && found ? sortModel.indexOf(found) + 1 : null;
	        this.header.$set({
	          sortDirection,
	          sortIndex
	        });
	      }
	      onFilterChanged() {
	        this.header.$set({
	          isFiltered: this.agParams.column.isFilterActive()
	        });
	      }
	      handleSortChanged(event) {
	        let colState = this.agParams.columnApi.getColumnState();
	        let sortColumns = colState.filter(c => {
	          return c.sortIndex !== null;
	        });
	        let found = sortColumns.find(s => s.colId === this.agParams.column.colId);
	        let sortDirection = found ? found.sort : null;
	        let sortIndex = found && found.sort && found.sortIndex !== undefined && sortColumns.length > 1 ? found.sortIndex + 1 : null;
	        this.header.$set({
	          sortDirection,
	          sortIndex
	        });
	      }
	    }

	    /* src/headers/ActionsGridHeader.svelte generated by Svelte v3.38.2 */
	    const {
	      document: document_1$2
	    } = globals$1;
	    function add_css$a() {
	      var style = element$1("style");
	      style.id = "svelte-m120xm-style";
	      style.textContent = ".pros-actions-grid-header{display:flex;justify-content:center;align-items:center;padding:0;cursor:pointer}.pros-actions-grid-header else{flex-direction:row}.pros-actions-grid-header .pros-icon{width:16px !important;height:16px !important;line-height:16px !important;margin:auto}.pros-actions-grid-header .pros-icon svg{width:100%;height:100%}.pros-actions-grid-header .pros-options-container{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:fixed;display:none;max-width:100%;width:200px !important;border-width:1px;border-style:solid;transform:translate(-175px, 0);padding:8px;border-radius:12px;box-sizing:border-box;z-index:1}.pros-actions-grid-header .pros-options-container.open{display:inherit}.pros-actions-grid-header .pros-options-container .pros-menu-option{display:flex;justify-content:flex-start;align-items:center;width:100%;height:34px;line-height:34px;font-size:16px;border-radius:8px;font-size:16px;font-weight:400}.pros-actions-grid-header .pros-options-container .pros-menu-option else{flex-direction:row}.pros-actions-grid-header .pros-options-container .pros-menu-option .menu-icon{margin:0 4px;width:24px;height:24px}.pros-actions-grid-header .pros-options-container .pros-menu-option .menu-label{flex:1;margin:0 8px}.pros-options-wrapper{position:fixed;display:none;max-width:100%;border-width:1px;border-style:solid;box-sizing:border-box;border-radius:12px;z-index:1001;overflow:hidden}.pros-options-wrapper.open{display:inherit}.pros-options-container{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%}.pros-options-container .pros-options-border-container{padding:8px}.pros-options-container .pros-options{width:100%;overflow:auto;padding:8px;box-sizing:border-box}.pros-options-container .pros-options .pros-option-list .pros-option-row{display:flex;justify-content:flex-start;align-items:center;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;cursor:pointer;padding:6px 8px}.pros-options-container .pros-options .pros-option-list .pros-option-row else{flex-direction:row}.pros-options-container .pros-options .pros-option-list .pros-option-row:not(:last-of-type){margin-bottom:4px}.pros-options-container .pros-options .pros-option-list .pros-option-row .menu-label{margin-left:8px}.pros-options-container ::-webkit-scrollbar{width:6px;height:6px}.pros-options-container ::-webkit-scrollbar-track{background-color:transparent}.pros-options-container ::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:6px}.pros-options-wrapper[pos--theme=light]{background-color:#FFFFFF;color:#363636;border-color:transparent;box-shadow:0 8px 20px rgba(33, 33, 33, 0.2)}.pros-options-wrapper[pos--theme=light] .pros-options-container .pros-options .pros-option-row.highlight{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=light] .pros-options-container .pros-options .pros-option-row:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=light] .pros-options-container .pros-options .pros-option-row.selected{background-color:#027aae;color:white}.pros-options-wrapper[pos--theme=dark]{background-color:#2b2b2b;color:#ffffff;border-color:transparent;box-shadow:0 8px 20px rgba(33, 33, 33, 0.2)}.pros-options-wrapper[pos--theme=dark] .pros-options-container .pros-options .pros-option-row{color:#ffffff}.pros-options-wrapper[pos--theme=dark] .pros-options-container .pros-options .pros-option-row.highlight{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-options-wrapper[pos--theme=dark] .pros-options-container .pros-options .pros-option-row:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-options-wrapper[pos--theme=dark] .pros-options-container .pros-options .pros-option-row.selected{background-color:#3ab4eb;color:#212121}";
	      append$1(document_1$2.head, style);
	    }

	    // (2:2) {#if allow}
	    function create_if_block$8(ctx) {
	      let div1;
	      let div0;
	      let t;
	      let if_block = /*open*/ctx[0] && create_if_block_1$5(ctx);
	      return {
	        c() {
	          div1 = element$1("div");
	          div0 = element$1("div");
	          div0.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M21.9919 10.6386L20.26 9.65997L19.6418 8.16748L20.1745 6.25098C20.2711 5.9035 20.1731 5.53101 19.9181 5.276L19.2239 4.58185C19.0339 4.39178 18.7784 4.28894 18.5168 4.28894C18.4276 4.28894 18.3375 4.3009 18.2491 4.3255L16.3325 4.85822L14.84 4.23999L13.8614 2.50806C13.684 2.19409 13.3514 2 12.9908 2H12.0093C11.6487 2 11.316 2.19409 11.1386 2.50806L10.16 4.23999L8.66748 4.85822L6.75085 4.3255C6.66248 4.30096 6.57245 4.28894 6.48315 4.28894C6.22156 4.28894 5.96619 4.39172 5.77606 4.58185L5.08191 5.276C4.8269 5.53101 4.72894 5.9035 4.82556 6.25098L5.35822 8.16748L4.73999 9.65997L3.00806 10.6386C2.69415 10.816 2.5 11.1487 2.5 11.5092V12.4908C2.5 12.8513 2.69415 13.184 3.00806 13.3614L4.73999 14.34L5.35822 15.8325L4.8255 17.7491C4.72894 18.0965 4.8269 18.469 5.08185 18.7239L5.776 19.4181C5.96613 19.6082 6.22156 19.711 6.48322 19.711C6.57251 19.711 6.66254 19.699 6.75098 19.6745L8.66748 19.1418L10.16 19.76L11.1386 21.4919C11.316 21.8058 11.6487 22 12.0093 22H12.9908C13.3514 22 13.684 21.8059 13.8614 21.4919L14.84 19.76L16.3325 19.1418L18.2491 19.6745C18.3375 19.699 18.4276 19.7111 18.5168 19.7111C18.7785 19.7111 19.0338 19.6082 19.2239 19.4182L19.9181 18.724C20.1731 18.469 20.2711 18.0965 20.1745 17.749L19.6418 15.8325L20.26 14.34L21.9919 13.3614C22.3059 13.184 22.5 12.8513 22.5 12.4908V11.5092C22.5 11.1487 22.3059 10.816 21.9919 10.6386ZM21.5 12.4908L19.7681 13.4694L19.468 13.6389L19.3362 13.9573L18.7179 15.4498L18.586 15.7682L18.6783 16.1003L19.211 18.0169L18.517 18.711L16.6003 18.1783L16.2682 18.086L15.9498 18.2179L14.4573 18.8361L14.1389 18.968L13.9694 19.2681L12.9908 21H12.0093L11.0306 19.2681L10.8611 18.968L10.5427 18.8361L9.05017 18.2179L8.73175 18.086L8.39966 18.1783L6.48309 18.711L5.789 18.0169L6.32172 16.1003L6.414 15.7682L6.2821 15.4498L5.66382 13.9573L5.53198 13.6389L5.23193 13.4694L3.5 12.4908V11.5092L5.23193 10.5306L5.53198 10.3611L5.66382 10.0427L6.2821 8.55017L6.414 8.23175L6.32172 7.89966L5.789 5.98309L6.48309 5.289L8.39972 5.82172L8.73175 5.914L9.05017 5.7821L10.5427 5.16382L10.8611 5.03198L11.0306 4.73193L12.0093 3H12.9908L13.9694 4.73193L14.1389 5.03198L14.4573 5.16382L15.9498 5.7821L16.2682 5.914L16.6003 5.82172L18.5168 5.28894L19.211 5.98315L18.6783 7.89966L18.586 8.23175L18.7179 8.55017L19.3362 10.0427L19.468 10.3611L19.7681 10.5306L21.5 11.5092V12.4908ZM12.5002 7C9.74316 7 7.50018 9.24298 7.50018 12C7.50018 14.757 9.74316 17 12.5002 17C15.2572 17 17.5002 14.757 17.5002 12C17.5002 9.24298 15.2572 7 12.5002 7ZM12.5002 16C10.291 16 8.50018 14.2091 8.50018 12C8.50018 9.79083 10.291 8 12.5002 8C14.7094 8 16.5002 9.79083 16.5002 12C16.5002 14.2091 14.7094 16 12.5002 16Z"></path></svg>`;
	          t = space$1();
	          if (if_block) if_block.c();
	          attr$1(div0, "class", "pros-icon");
	          attr$1(div1, "pros-tooltip", /*settingsTooltip*/ctx[1]);
	          attr$1(div1, "class", "header-title");
	        },
	        m(target, anchor) {
	          insert$1(target, div1, anchor);
	          append$1(div1, div0);
	          append$1(div1, t);
	          if (if_block) if_block.m(div1, null);
	        },
	        p(ctx, dirty) {
	          if (/*open*/ctx[0]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	            } else {
	              if_block = create_if_block_1$5(ctx);
	              if_block.c();
	              if_block.m(div1, null);
	            }
	          } else if (if_block) {
	            if_block.d(1);
	            if_block = null;
	          }
	          if (dirty[0] & /*settingsTooltip*/2) {
	            attr$1(div1, "pros-tooltip", /*settingsTooltip*/ctx[1]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach$1(div1);
	          if (if_block) if_block.d();
	        }
	      };
	    }

	    // (10:4) {#if open}
	    function create_if_block_1$5(ctx) {
	      let div9;
	      let div8;
	      let div7;
	      let div6;
	      let div1;
	      let div0;
	      let t0;
	      let div1_id_value;
	      let t1;
	      let div3;
	      let div2;
	      let t2;
	      let div3_id_value;
	      let t3;
	      let div5;
	      let div4;
	      let t4;
	      let div5_id_value;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div9 = element$1("div");
	          div8 = element$1("div");
	          div7 = element$1("div");
	          div6 = element$1("div");
	          div1 = element$1("div");
	          div0 = element$1("div");
	          t0 = text$1(/*columnsLabel*/ctx[2]);
	          t1 = space$1();
	          div3 = element$1("div");
	          div2 = element$1("div");
	          t2 = text$1(/*exportLabel*/ctx[3]);
	          t3 = space$1();
	          div5 = element$1("div");
	          div4 = element$1("div");
	          t4 = text$1(/*resetLabel*/ctx[4]);
	          attr$1(div0, "class", "menu-label");
	          attr$1(div0, "pros-tooltip", "");
	          attr$1(div1, "id", div1_id_value = "" + (/*_optionsId*/ctx[7] + "-columns"));
	          attr$1(div1, "class", "pros-option-row");
	          attr$1(div2, "class", "menu-label");
	          attr$1(div2, "pros-tooltip", "");
	          attr$1(div3, "id", div3_id_value = "" + (/*_optionsId*/ctx[7] + "-export"));
	          attr$1(div3, "class", "pros-option-row");
	          attr$1(div4, "class", "menu-label");
	          attr$1(div4, "pros-tooltip", "");
	          attr$1(div5, "id", div5_id_value = "" + (/*_optionsId*/ctx[7] + "-reset"));
	          attr$1(div5, "class", "pros-option-row");
	          attr$1(div6, "class", "pros-option-list");
	          attr$1(div7, "class", "pros-options");
	          attr$1(div8, "id", "pros-my-container");
	          attr$1(div8, "class", "pros-options-container");
	          attr$1(div9, "class", "pros-options-wrapper");
	          attr$1(div9, "pos--theme", /*_theme*/ctx[5]);
	          toggle_class$1(div9, "open", /*open*/ctx[0]);
	        },
	        m(target, anchor) {
	          insert$1(target, div9, anchor);
	          append$1(div9, div8);
	          append$1(div8, div7);
	          append$1(div7, div6);
	          append$1(div6, div1);
	          append$1(div1, div0);
	          append$1(div0, t0);
	          append$1(div6, t1);
	          append$1(div6, div3);
	          append$1(div3, div2);
	          append$1(div2, t2);
	          append$1(div6, t3);
	          append$1(div6, div5);
	          append$1(div5, div4);
	          append$1(div4, t4);
	          if (!mounted) {
	            dispose = [listen$1(div1, "click", /*columnsClicked*/ctx[11]), listen$1(div3, "click", /*exportClicked*/ctx[12]), listen$1(div5, "click", /*resetClicked*/ctx[13]), action_destroyer$1(/*globalClicks*/ctx[8].call(null, div9)), action_destroyer$1(/*positionOptions*/ctx[9].call(null, div9))];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*columnsLabel*/4) set_data$1(t0, /*columnsLabel*/ctx[2]);
	          if (dirty[0] & /*_optionsId*/128 && div1_id_value !== (div1_id_value = "" + (/*_optionsId*/ctx[7] + "-columns"))) {
	            attr$1(div1, "id", div1_id_value);
	          }
	          if (dirty[0] & /*exportLabel*/8) set_data$1(t2, /*exportLabel*/ctx[3]);
	          if (dirty[0] & /*_optionsId*/128 && div3_id_value !== (div3_id_value = "" + (/*_optionsId*/ctx[7] + "-export"))) {
	            attr$1(div3, "id", div3_id_value);
	          }
	          if (dirty[0] & /*resetLabel*/16) set_data$1(t4, /*resetLabel*/ctx[4]);
	          if (dirty[0] & /*_optionsId*/128 && div5_id_value !== (div5_id_value = "" + (/*_optionsId*/ctx[7] + "-reset"))) {
	            attr$1(div5, "id", div5_id_value);
	          }
	          if (dirty[0] & /*_theme*/32) {
	            attr$1(div9, "pos--theme", /*_theme*/ctx[5]);
	          }
	          if (dirty[0] & /*open*/1) {
	            toggle_class$1(div9, "open", /*open*/ctx[0]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach$1(div9);
	          mounted = false;
	          run_all$1(dispose);
	        }
	      };
	    }
	    function create_fragment$a(ctx) {
	      let div;
	      let mounted;
	      let dispose;
	      let if_block = /*allow*/ctx[6] && create_if_block$8(ctx);
	      return {
	        c() {
	          div = element$1("div");
	          if (if_block) if_block.c();
	          attr$1(div, "id", /*_optionsId*/ctx[7]);
	          attr$1(div, "class", "pros-actions-grid-header");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          if (if_block) if_block.m(div, null);
	          if (!mounted) {
	            dispose = listen$1(div, "click", /*handleCellClick*/ctx[10]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*allow*/ctx[6]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	            } else {
	              if_block = create_if_block$8(ctx);
	              if_block.c();
	              if_block.m(div, null);
	            }
	          } else if (if_block) {
	            if_block.d(1);
	            if_block = null;
	          }
	          if (dirty[0] & /*_optionsId*/128) {
	            attr$1(div, "id", /*_optionsId*/ctx[7]);
	          }
	        },
	        i: noop$1,
	        o: noop$1,
	        d(detaching) {
	          if (detaching) detach$1(div);
	          if (if_block) if_block.d();
	          mounted = false;
	          dispose();
	        }
	      };
	    }
	    function instance$a($$self, $$props, $$invalidate) {
	      let $_;
	      component_subscribe$1($$self, X$1, $$value => $$invalidate(25, $_ = $$value));
	      let {
	        params = null
	      } = $$props;
	      let {
	        open = false
	      } = $$props;
	      let {
	        settingsTooltip = null
	      } = $$props;
	      let {
	        columnsLabel = null
	      } = $$props;
	      let {
	        exportLabel = null
	      } = $$props;
	      let {
	        resetLabel = null
	      } = $$props;
	      let {
	        globalClickListener = null
	      } = $$props;
	      let {
	        _globalClicksNode = null
	      } = $$props; // Active Global clicks node for selecting in list
	      let {
	        _openNode = undefined
	      } = $$props;
	      let {
	        _openParent = undefined
	      } = $$props;
	      let {
	        _theme = undefined
	      } = $$props;
	      let {
	        value = null
	      } = $$props;
	      let {
	        options = []
	      } = $$props;
	      let {
	        highlightIndex = null
	      } = $$props;
	      let {
	        _actionsOpenedEventListener = undefined
	      } = $$props;
	      let {
	        allow = false
	      } = $$props;
	      let _gridId = null;
	      let _optionsId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        $$invalidate(7, _optionsId = _gridId ? `${_gridId}-options` : undefined);
	      });

	      // onCreate
	      onMount$1(() => {
	        $$invalidate(5, _theme = params.column.colDef.printos.getTheme());
	        $$invalidate(1, settingsTooltip = $_("Settings_Tooltip"));
	        $$invalidate(2, columnsLabel = $_("Menu_Columns"));
	        $$invalidate(3, exportLabel = $_("Menu_Export"));
	        $$invalidate(4, resetLabel = $_("Menu_Reset"));
	        window.addEventListener("posh-theme-changed", handleThemeChanged);
	        $$invalidate(6, allow = get$1(params, "column.colDef.printos.options.grid.allowOptions", true));
	      }); // console.log('allowOptions',  allow);

	      onDestroy$1(() => {
	        window.removeEventListener("posh-theme-changed", handleThemeChanged);
	      });

	      // Actions
	      function globalClicks(node) {
	        $$invalidate(15, _globalClicksNode = node);
	        $$invalidate(14, globalClickListener = event => {
	          // console.log('ActionGridHeader: globalClickHandler');
	          let elements = [node];

	          // Change NodeList to Array to use some()
	          elements = Array.prototype.slice.call(elements);
	          let containsClick = elements.some(element => {
	            return element.contains(event.target);
	          });
	          if (!containsClick || _openNode) {
	            let ignoreClick = [_openNode].some(e => {
	              return e.contains(event.target);
	            });
	            if (!ignoreClick) {
	              // console.log('SB: globalClicks: close Options', ignoreClick);
	              closeOptions();
	            }
	          }
	        });

	        // Necessary to prevent handling click that opens panel
	        window.setTimeout(() => {
	          document.addEventListener("click", globalClickListener);
	        }, 0);
	      }
	      function handleThemeChanged() {
	        $$invalidate(5, _theme = params.column.colDef.printos.getTheme());
	      }

	      // Methods
	      function positionOptions(node) {
	        $$invalidate(16, _openNode = node);
	        $$invalidate(17, _openParent = node.parentElement);

	        // console.log('positionOptions', _openNode, _openParent);
	        document.body.appendChild(node);
	        positionNode();
	        document.addEventListener("wheel", handleScroll);
	        window.addEventListener("scroll", handleScroll, true);
	        window.addEventListener("resize", handleScroll);
	        return {
	          destroy() {
	            document.removeEventListener("wheel", handleScroll);
	            window.removeEventListener("scroll", handleScroll);
	            window.removeEventListener("resize", handleScroll);
	          }
	        };
	      } // let parent = node.parentElement;
	      // node.style.width = `${parent.offsetWidth}px`;

	      function handleCellClick(event) {
	        // console.log('ActionGridHeader: handleCellClick');
	        event.stopPropagation();
	        event.preventDefault();

	        // open = !open;
	        if (open) {
	          closeOptions();
	          window.removeEventListener("posgrid-actions-opened", _actionsOpenedEventListener);
	          $$invalidate(19, _actionsOpenedEventListener = undefined);
	        } else {
	          window.dispatchEvent(new Event("posgrid-actions-opened", {}));
	          $$invalidate(19, _actionsOpenedEventListener = window.addEventListener("posgrid-actions-opened", event => {
	            closeOptions();
	          }));
	          openOptions();
	        } // clearGlobalClickListener();
	      }
	      function openOptions() {
	        $$invalidate(0, open = true);
	      }
	      function closeOptions() {
	        // Re-parent options
	        if (_openParent) {
	          _openParent.appendChild(_openNode);
	        }
	        $$invalidate(16, _openNode = undefined);
	        $$invalidate(17, _openParent = undefined);
	        if (globalClickListener) {
	          document.removeEventListener("click", globalClickListener);
	          $$invalidate(14, globalClickListener = null);
	        }
	        $$invalidate(0, open = false);
	        document.removeEventListener("wheel", handleScroll);
	        window.removeEventListener("scroll", handleScroll);
	        window.removeEventListener("resize", handleScroll);
	      }
	      function positionNode(event) {
	        if (!_openParent) {
	          document.removeEventListener("wheel", handleScroll);
	          window.removeEventListener("scroll", handleScroll);
	          window.removeEventListener("resize", handleScroll);
	          return;
	        }
	        let adjustedTop;
	        let bodyRect = document.body.getBoundingClientRect();
	        let rect = _openParent.getBoundingClientRect();
	        if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	          adjustedTop = rect.top >= _openNode.offsetHeight ? `${rect.top - _openNode.offsetHeight}px` : `0px`;
	        }
	        if (event) {
	          let scrollTop = event.target.scrollTop;
	          let scrollBottom = scrollTop + event.target.clientHeight;
	          if (_openParent.offsetParent.offsetTop < scrollTop) {
	            adjustedTop = 0 + "px";
	          }
	          if (_openParent.offsetParent.offsetTop > scrollBottom) {
	            adjustedTop = `${rect.top - _openNode.offsetHeight}px`;
	          }
	        }
	        $$invalidate(16, _openNode.style.right = `${bodyRect.width - rect.right}px`, _openNode);
	        $$invalidate(16, _openNode.style.top = adjustedTop ? adjustedTop : `${rect.bottom}px`, _openNode);
	      } // _openNode.style.width = `${rect.width}px`;

	      function handleScroll(event) {
	        let isOptionScroll = false;
	        let test = event.target;
	        while (test) {
	          if (test.id === "pros-options-container") {
	            isOptionScroll = true;
	            break;
	          }
	          test = test.parentElement;
	        }
	        if (!isOptionScroll) {
	          // console.log('SB: scrollListener:Close Options');
	          closeOptions();
	        } // positionNode(event);
	      }
	      function columnsClicked(event) {
	        closeOptions();
	        params.column.colDef.printos.configureColumns();
	      }
	      function exportClicked(event) {
	        closeOptions();
	        params.column.colDef.printos.export();
	      }
	      function resetClicked(event) {
	        // console.log('ActionGridHeader: resetClicked');
	        closeOptions();
	        params.column.colDef.printos.resetPreferences();
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(20, params = $$props.params);
	        if ("open" in $$props) $$invalidate(0, open = $$props.open);
	        if ("settingsTooltip" in $$props) $$invalidate(1, settingsTooltip = $$props.settingsTooltip);
	        if ("columnsLabel" in $$props) $$invalidate(2, columnsLabel = $$props.columnsLabel);
	        if ("exportLabel" in $$props) $$invalidate(3, exportLabel = $$props.exportLabel);
	        if ("resetLabel" in $$props) $$invalidate(4, resetLabel = $$props.resetLabel);
	        if ("globalClickListener" in $$props) $$invalidate(14, globalClickListener = $$props.globalClickListener);
	        if ("_globalClicksNode" in $$props) $$invalidate(15, _globalClicksNode = $$props._globalClicksNode);
	        if ("_openNode" in $$props) $$invalidate(16, _openNode = $$props._openNode);
	        if ("_openParent" in $$props) $$invalidate(17, _openParent = $$props._openParent);
	        if ("_theme" in $$props) $$invalidate(5, _theme = $$props._theme);
	        if ("value" in $$props) $$invalidate(21, value = $$props.value);
	        if ("options" in $$props) $$invalidate(22, options = $$props.options);
	        if ("highlightIndex" in $$props) $$invalidate(18, highlightIndex = $$props.highlightIndex);
	        if ("_actionsOpenedEventListener" in $$props) $$invalidate(19, _actionsOpenedEventListener = $$props._actionsOpenedEventListener);
	        if ("allow" in $$props) $$invalidate(6, allow = $$props.allow);
	      };
	      return [open, settingsTooltip, columnsLabel, exportLabel, resetLabel, _theme, allow, _optionsId, globalClicks, positionOptions, handleCellClick, columnsClicked, exportClicked, resetClicked, globalClickListener, _globalClicksNode, _openNode, _openParent, highlightIndex, _actionsOpenedEventListener, params, value, options, handleScroll];
	    }
	    class ActionsGridHeader extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document_1$2.getElementById("svelte-m120xm-style")) add_css$a();
	        init$1(this, options, instance$a, create_fragment$a, safe_not_equal$1, {
	          params: 20,
	          open: 0,
	          settingsTooltip: 1,
	          columnsLabel: 2,
	          exportLabel: 3,
	          resetLabel: 4,
	          globalClickListener: 14,
	          _globalClicksNode: 15,
	          _openNode: 16,
	          _openParent: 17,
	          _theme: 5,
	          value: 21,
	          options: 22,
	          highlightIndex: 18,
	          _actionsOpenedEventListener: 19,
	          allow: 6,
	          handleScroll: 23
	        }, [-1, -1]);
	      }
	      get handleScroll() {
	        return this.$$.ctx[23];
	      }
	    }

	    class ActionsGridHeaderComponent {
	      init(params) {
	        params.column.colDef;
	        this.agParams = params;
	        this.headerContainer = document.createElement('div');
	        this.headerContainer.classList.add('pros-grid-header-container');
	        this.header = new ActionsGridHeader({
	          target: this.headerContainer,
	          props: {
	            params: params,
	            headerName: params.displayName
	          }
	        });
	      }
	      getGui() {
	        // Contrary to the docs, this method is called twice.
	        // So, the element must be created in init() to be initialized correctly.
	        return this.headerContainer;
	      }
	      destroy() {
	        // this.header.$destroy(); Is this really necessary? See: https://github.com/sveltejs/svelte/issues/3089
	      }
	    }

	    /* src/headers/ActionGridHeader.svelte generated by Svelte v3.38.2 */
	    function add_css$9() {
	      var style = element$1("style");
	      style.id = "svelte-rqabqc-style";
	      style.textContent = ".pros-action-grid-header{display:flex;justify-content:center;align-items:center;padding:0}.pros-action-grid-header else{flex-direction:row}";
	      append$1(document.head, style);
	    }

	    // (2:2) {#if !isLoading}
	    function create_if_block$7(ctx) {
	      let div;
	      let icon;
	      let updating_path;
	      let current;
	      function icon_path_binding(value) {
	        /*icon_path_binding*/ctx[5](value);
	      }
	      let icon_props = {
	        theme: /*_theme*/ctx[2],
	        height: "24px"
	      };
	      if (/*iconName*/ctx[1] !== void 0) {
	        icon_props.path = /*iconName*/ctx[1];
	      }
	      icon = new Icon$1({
	        props: icon_props
	      });
	      binding_callbacks$1.push(() => bind$1(icon, "path", icon_path_binding));
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(icon.$$.fragment);
	          attr$1(div, "pros-tooltip", /*display*/ctx[0]);
	          attr$1(div, "class", "header-title");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(icon, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const icon_changes = {};
	          if (dirty & /*_theme*/4) icon_changes.theme = /*_theme*/ctx[2];
	          if (!updating_path && dirty & /*iconName*/2) {
	            updating_path = true;
	            icon_changes.path = /*iconName*/ctx[1];
	            add_flush_callback$1(() => updating_path = false);
	          }
	          icon.$set(icon_changes);
	          if (!current || dirty & /*display*/1) {
	            attr$1(div, "pros-tooltip", /*display*/ctx[0]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(icon.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(icon.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(icon);
	        }
	      };
	    }
	    function create_fragment$9(ctx) {
	      let div;
	      let current;
	      let if_block = ! /*isLoading*/ctx[3] && create_if_block$7(ctx);
	      return {
	        c() {
	          div = element$1("div");
	          if (if_block) if_block.c();
	          attr$1(div, "class", "pros-action-grid-header");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          if (if_block) if_block.m(div, null);
	          current = true;
	        },
	        p(ctx, [dirty]) {
	          if (! /*isLoading*/ctx[3]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	              if (dirty & /*isLoading*/8) {
	                transition_in$1(if_block, 1);
	              }
	            } else {
	              if_block = create_if_block$7(ctx);
	              if_block.c();
	              transition_in$1(if_block, 1);
	              if_block.m(div, null);
	            }
	          } else if (if_block) {
	            group_outros$1();
	            transition_out$1(if_block, 1, 1, () => {
	              if_block = null;
	            });
	            check_outros$1();
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          if (if_block) if_block.d();
	        }
	      };
	    }
	    function instance$9($$self, $$props, $$invalidate) {
	      let {
	        params = null
	      } = $$props;
	      let {
	        display = null
	      } = $$props;
	      let {
	        iconName = null
	      } = $$props;
	      let {
	        _theme
	      } = $$props;
	      let {
	        isLoading = true
	      } = $$props;

	      // onCreate
	      onMount$1(() => {
	        $$invalidate(2, _theme = params.column.colDef.printos.getTheme());
	        let actions = get$1(params, "column.colDef.printos.callbacks.actions", []);
	        let colId = params.column.colDef.colId;
	        let actionId = colId.substring(colId.indexOf("-") + 1);
	        let action = actions.find(a => {
	          return a.id === actionId;
	        });
	        $$invalidate(0, display = action ? action.display : actionId);
	        $$invalidate(1, iconName = action ? action.iconName : "");
	        window.addEventListener("posh-theme-changed", handleThemeChanged);
	        $$invalidate(3, isLoading = false);
	      });
	      function handleThemeChanged(event) {
	        $$invalidate(2, _theme = event.detail.theme);
	      }
	      onDestroy$1(() => {
	        window.removeEventListener("posh-theme-changed", handleThemeChanged);
	      });
	      function icon_path_binding(value) {
	        iconName = value;
	        $$invalidate(1, iconName);
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(4, params = $$props.params);
	        if ("display" in $$props) $$invalidate(0, display = $$props.display);
	        if ("iconName" in $$props) $$invalidate(1, iconName = $$props.iconName);
	        if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	        if ("isLoading" in $$props) $$invalidate(3, isLoading = $$props.isLoading);
	      };
	      return [display, iconName, _theme, isLoading, params, icon_path_binding];
	    }
	    class ActionGridHeader extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-rqabqc-style")) add_css$9();
	        init$1(this, options, instance$9, create_fragment$9, safe_not_equal$1, {
	          params: 4,
	          display: 0,
	          iconName: 1,
	          _theme: 2,
	          isLoading: 3
	        });
	      }
	    }

	    class ActionGridHeaderComponent {
	      init(params) {
	        params.column.colDef;
	        this.agParams = params;
	        this.headerContainer = document.createElement('div');
	        this.headerContainer.classList.add('pros-grid-header-container');
	        this.header = new ActionGridHeader({
	          target: this.headerContainer,
	          props: {
	            params: params,
	            headerName: params.displayName
	          }
	        });
	      }
	      getGui() {
	        // Contrary to the docs, this method is called twice.
	        // So, the element must be created in init() to be initialized correctly.
	        return this.headerContainer;
	      }
	      destroy() {
	        // this.header.$destroy(); Is this really necessary? See: https://github.com/sveltejs/svelte/issues/3089
	      }
	    }

	    /* src/filters/TextGridFilter.svelte generated by Svelte v3.38.2 */
	    function add_css$8() {
	      var style = element$1("style");
	      style.id = "svelte-rmtefj-style";
	      style.textContent = ".pros-text-grid-filter.svelte-rmtefj.svelte-rmtefj{display:flex;flex-direction:column;padding:16px;width:300px}.pros-text-grid-filter.svelte-rmtefj .pros-toggle-container.svelte-rmtefj{margin:8px 0;height:48px;display:flex;justify-content:flex-start;align-items:center}.pros-text-grid-filter.svelte-rmtefj .pros-toggle-container.hide.svelte-rmtefj{display:none}.pros-text-grid-filter.svelte-rmtefj .pros-toggle-container .blank.svelte-rmtefj{flex:1;border-radius:12px;border:1px solid #F3F3F3}.pros-text-grid-filter.svelte-rmtefj .pros-toggle-container .pros-button.svelte-rmtefj{display:flex;flex-direction:column;justify-content:center;align-items:center;height:48px;width:48px;margin-right:8px;font-size:30px;border-radius:8px;border:1px solid #F3F3F3}.pros-text-grid-filter.svelte-rmtefj .pros-toggle-container .pros-button svg.svelte-rmtefj{transition:transform 0.5s ease 0s}.pros-text-grid-filter.svelte-rmtefj .pros-toggle-container .pros-button.open svg.svelte-rmtefj{transition:transform 0.5s ease 0s;transform:rotate(-180deg)}.pros-text-grid-filter.svelte-rmtefj .pros-toggle-container .pros-operator-container.svelte-rmtefj{flex:1}.pros-text-grid-filter.svelte-rmtefj .pros-control-container.svelte-rmtefj{margin-bottom:8px}.pros-text-grid-filter.svelte-rmtefj .pros-control-container.svelte-rmtefj:last-of-type{margin-bottom:0}.pros-text-grid-filter.svelte-rmtefj .pros-condition-container.svelte-rmtefj{display:flex;flex-direction:column}.pros-text-grid-filter.svelte-rmtefj .pros-condition-container.option2.svelte-rmtefj{display:none}.pros-text-grid-filter.svelte-rmtefj .pros-condition-container.option2.expanded.svelte-rmtefj{display:inherit}";
	      append$1(document.head, style);
	    }

	    // (15:4) {#if type1 !== 'isEmpty' && type1 !== 'isNotEmpty'}
	    function create_if_block_2$4(ctx) {
	      let div;
	      let textbox;
	      let updating_value;
	      let current;
	      function textbox_value_binding(value) {
	        /*textbox_value_binding*/ctx[20](value);
	      }
	      let textbox_props = {
	        id: /*_text1Id*/ctx[11],
	        theme: /*params*/ctx[8].colDef.gridParams.theme,
	        autofocus: true,
	        display: "custom"
	      };
	      if (/*filter1*/ctx[4] !== void 0) {
	        textbox_props.value = /*filter1*/ctx[4];
	      }
	      textbox = new TextBox({
	        props: textbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(textbox, "value", textbox_value_binding));
	      textbox.$on("changed", /*handleFilterChanged*/ctx[15]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(textbox.$$.fragment);
	          attr$1(div, "class", "pros-control-container svelte-rmtefj");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(textbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const textbox_changes = {};
	          if (dirty & /*_text1Id*/2048) textbox_changes.id = /*_text1Id*/ctx[11];
	          if (dirty & /*params*/256) textbox_changes.theme = /*params*/ctx[8].colDef.gridParams.theme;
	          if (!updating_value && dirty & /*filter1*/16) {
	            updating_value = true;
	            textbox_changes.value = /*filter1*/ctx[4];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          textbox.$set(textbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(textbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(textbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(textbox);
	        }
	      };
	    }

	    // (48:4) {:else}
	    function create_else_block$3(ctx) {
	      let div;
	      return {
	        c() {
	          div = element$1("div");
	          attr$1(div, "class", "blank svelte-rmtefj");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	        },
	        p: noop$1,
	        i: noop$1,
	        o: noop$1,
	        d(detaching) {
	          if (detaching) detach$1(div);
	        }
	      };
	    }

	    // (36:4) {#if showOperator === true}
	    function create_if_block_1$4(ctx) {
	      let div;
	      let selectbox;
	      let updating_options;
	      let updating_value;
	      let current;
	      function selectbox_options_binding(value) {
	        /*selectbox_options_binding*/ctx[21](value);
	      }
	      function selectbox_value_binding(value) {
	        /*selectbox_value_binding*/ctx[22](value);
	      }
	      let selectbox_props = {
	        id: /*_operatorId*/ctx[13],
	        class: "pros-operator-input",
	        theme: /*params*/ctx[8].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*operatorOptions*/ctx[1] !== void 0) {
	        selectbox_props.options = /*operatorOptions*/ctx[1];
	      }
	      if (/*operator*/ctx[2] !== void 0) {
	        selectbox_props.value = /*operator*/ctx[2];
	      }
	      selectbox = new SelectBox({
	        props: selectbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox, "options", selectbox_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox, "value", selectbox_value_binding));
	      selectbox.$on("changed", /*handleFilterChanged*/ctx[15]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(selectbox.$$.fragment);
	          attr$1(div, "class", "pros-operator-container svelte-rmtefj");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(selectbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const selectbox_changes = {};
	          if (dirty & /*_operatorId*/8192) selectbox_changes.id = /*_operatorId*/ctx[13];
	          if (dirty & /*params*/256) selectbox_changes.theme = /*params*/ctx[8].colDef.gridParams.theme;
	          if (!updating_options && dirty & /*operatorOptions*/2) {
	            updating_options = true;
	            selectbox_changes.options = /*operatorOptions*/ctx[1];
	            add_flush_callback$1(() => updating_options = false);
	          }
	          if (!updating_value && dirty & /*operator*/4) {
	            updating_value = true;
	            selectbox_changes.value = /*operator*/ctx[2];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          selectbox.$set(selectbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(selectbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(selectbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(selectbox);
	        }
	      };
	    }

	    // (66:4) {#if type2 !== 'isEmpty' && type2 !== 'isNotEmpty'}
	    function create_if_block$6(ctx) {
	      let div;
	      let textbox;
	      let updating_value;
	      let current;
	      function textbox_value_binding_1(value) {
	        /*textbox_value_binding_1*/ctx[25](value);
	      }
	      let textbox_props = {
	        id: /*_text2Id*/ctx[12],
	        theme: /*params*/ctx[8].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter2*/ctx[6] !== void 0) {
	        textbox_props.value = /*filter2*/ctx[6];
	      }
	      textbox = new TextBox({
	        props: textbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(textbox, "value", textbox_value_binding_1));
	      textbox.$on("changed", /*handleFilterChanged*/ctx[15]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(textbox.$$.fragment);
	          attr$1(div, "class", "pros-control-container svelte-rmtefj");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(textbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const textbox_changes = {};
	          if (dirty & /*_text2Id*/4096) textbox_changes.id = /*_text2Id*/ctx[12];
	          if (dirty & /*params*/256) textbox_changes.theme = /*params*/ctx[8].colDef.gridParams.theme;
	          if (!updating_value && dirty & /*filter2*/64) {
	            updating_value = true;
	            textbox_changes.value = /*filter2*/ctx[6];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          textbox.$set(textbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(textbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(textbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(textbox);
	        }
	      };
	    }
	    function create_fragment$8(ctx) {
	      let div6;
	      let div1;
	      let div0;
	      let selectbox0;
	      let updating_value;
	      let updating_options;
	      let t0;
	      let t1;
	      let div3;
	      let div2;
	      let svg;
	      let path;
	      let t2;
	      let current_block_type_index;
	      let if_block1;
	      let t3;
	      let div5;
	      let div4;
	      let selectbox1;
	      let updating_options_1;
	      let updating_value_1;
	      let t4;
	      let current;
	      let mounted;
	      let dispose;
	      function selectbox0_value_binding(value) {
	        /*selectbox0_value_binding*/ctx[18](value);
	      }
	      function selectbox0_options_binding(value) {
	        /*selectbox0_options_binding*/ctx[19](value);
	      }
	      let selectbox0_props = {
	        id: /*_select1Id*/ctx[9],
	        class: "pros-input-test",
	        theme: /*params*/ctx[8].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*type1*/ctx[3] !== void 0) {
	        selectbox0_props.value = /*type1*/ctx[3];
	      }
	      if (/*options*/ctx[0] !== void 0) {
	        selectbox0_props.options = /*options*/ctx[0];
	      }
	      selectbox0 = new SelectBox({
	        props: selectbox0_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox0, "value", selectbox0_value_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox0, "options", selectbox0_options_binding));
	      selectbox0.$on("changed", /*handleFilterChanged*/ctx[15]);
	      let if_block0 = /*type1*/ctx[3] !== "isEmpty" && /*type1*/ctx[3] !== "isNotEmpty" && create_if_block_2$4(ctx);
	      const if_block_creators = [create_if_block_1$4, create_else_block$3];
	      const if_blocks = [];
	      function select_block_type(ctx, dirty) {
	        if (/*showOperator*/ctx[7] === true) return 0;
	        return 1;
	      }
	      current_block_type_index = select_block_type(ctx);
	      if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      function selectbox1_options_binding(value) {
	        /*selectbox1_options_binding*/ctx[23](value);
	      }
	      function selectbox1_value_binding(value) {
	        /*selectbox1_value_binding*/ctx[24](value);
	      }
	      let selectbox1_props = {
	        id: /*_select2Id*/ctx[10],
	        class: "pros-filter-input",
	        theme: /*params*/ctx[8].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*options*/ctx[0] !== void 0) {
	        selectbox1_props.options = /*options*/ctx[0];
	      }
	      if (/*type2*/ctx[5] !== void 0) {
	        selectbox1_props.value = /*type2*/ctx[5];
	      }
	      selectbox1 = new SelectBox({
	        props: selectbox1_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox1, "options", selectbox1_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox1, "value", selectbox1_value_binding));
	      selectbox1.$on("changed", /*handleFilterChanged*/ctx[15]);
	      let if_block2 = /*type2*/ctx[5] !== "isEmpty" && /*type2*/ctx[5] !== "isNotEmpty" && create_if_block$6(ctx);
	      return {
	        c() {
	          div6 = element$1("div");
	          div1 = element$1("div");
	          div0 = element$1("div");
	          create_component$1(selectbox0.$$.fragment);
	          t0 = space$1();
	          if (if_block0) if_block0.c();
	          t1 = space$1();
	          div3 = element$1("div");
	          div2 = element$1("div");
	          svg = svg_element$1("svg");
	          path = svg_element$1("path");
	          t2 = space$1();
	          if_block1.c();
	          t3 = space$1();
	          div5 = element$1("div");
	          div4 = element$1("div");
	          create_component$1(selectbox1.$$.fragment);
	          t4 = space$1();
	          if (if_block2) if_block2.c();
	          attr$1(div0, "class", "pros-control-container svelte-rmtefj");
	          attr$1(div1, "class", "pros-condition-container svelte-rmtefj");
	          attr$1(path, "d", "M13 17C12.8721 17 12.7441 16.9512 12.6465 16.8535L4.64648 8.85352C4.45117 8.6582 4.45117 8.3418 4.64648 8.14648C4.8418 7.95117 5.1582 7.95117 5.35352 8.14648L13 15.793L20.6465 8.14648C20.8418 7.95117 21.1582 7.95117 21.3535 8.14648C21.5488 8.3418 21.5488 8.6582 21.3535 8.85352L13.3535 16.8535C13.2559 16.9512 13.1279 17 13 17Z");
	          attr$1(svg, "width", "24");
	          attr$1(svg, "height", "24");
	          attr$1(svg, "viewBox", "0 0 24 24");
	          attr$1(svg, "fill", "currentColor");
	          attr$1(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr$1(svg, "class", "svelte-rmtefj");
	          attr$1(div2, "id", /*_toggleId*/ctx[14]);
	          attr$1(div2, "class", "pros-button svelte-rmtefj");
	          attr$1(div2, "type", "button");
	          toggle_class$1(div2, "open", /*showOperator*/ctx[7]);
	          attr$1(div3, "class", "pros-toggle-container svelte-rmtefj");
	          toggle_class$1(div3, "hide", ! /*filter1*/ctx[4] || /*filter1*/ctx[4] === "");
	          attr$1(div4, "class", "pros-control-container svelte-rmtefj");
	          attr$1(div5, "class", "pros-condition-container option2 svelte-rmtefj");
	          toggle_class$1(div5, "expanded", /*showOperator*/ctx[7] && /*filter1*/ctx[4] && /*filter1*/ctx[4] !== "");
	          attr$1(div6, "class", "pros-text-grid-filter svelte-rmtefj");
	        },
	        m(target, anchor) {
	          insert$1(target, div6, anchor);
	          append$1(div6, div1);
	          append$1(div1, div0);
	          mount_component$1(selectbox0, div0, null);
	          append$1(div1, t0);
	          if (if_block0) if_block0.m(div1, null);
	          append$1(div6, t1);
	          append$1(div6, div3);
	          append$1(div3, div2);
	          append$1(div2, svg);
	          append$1(svg, path);
	          append$1(div3, t2);
	          if_blocks[current_block_type_index].m(div3, null);
	          append$1(div6, t3);
	          append$1(div6, div5);
	          append$1(div5, div4);
	          mount_component$1(selectbox1, div4, null);
	          append$1(div5, t4);
	          if (if_block2) if_block2.m(div5, null);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(div2, "click", /*toggleOperator*/ctx[16]);
	            mounted = true;
	          }
	        },
	        p(ctx, [dirty]) {
	          const selectbox0_changes = {};
	          if (dirty & /*_select1Id*/512) selectbox0_changes.id = /*_select1Id*/ctx[9];
	          if (dirty & /*params*/256) selectbox0_changes.theme = /*params*/ctx[8].colDef.gridParams.theme;
	          if (!updating_value && dirty & /*type1*/8) {
	            updating_value = true;
	            selectbox0_changes.value = /*type1*/ctx[3];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          if (!updating_options && dirty & /*options*/1) {
	            updating_options = true;
	            selectbox0_changes.options = /*options*/ctx[0];
	            add_flush_callback$1(() => updating_options = false);
	          }
	          selectbox0.$set(selectbox0_changes);
	          if (/*type1*/ctx[3] !== "isEmpty" && /*type1*/ctx[3] !== "isNotEmpty") {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	              if (dirty & /*type1*/8) {
	                transition_in$1(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_2$4(ctx);
	              if_block0.c();
	              transition_in$1(if_block0, 1);
	              if_block0.m(div1, null);
	            }
	          } else if (if_block0) {
	            group_outros$1();
	            transition_out$1(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros$1();
	          }
	          if (!current || dirty & /*_toggleId*/16384) {
	            attr$1(div2, "id", /*_toggleId*/ctx[14]);
	          }
	          if (dirty & /*showOperator*/128) {
	            toggle_class$1(div2, "open", /*showOperator*/ctx[7]);
	          }
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros$1();
	            transition_out$1(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros$1();
	            if_block1 = if_blocks[current_block_type_index];
	            if (!if_block1) {
	              if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block1.c();
	            } else {
	              if_block1.p(ctx, dirty);
	            }
	            transition_in$1(if_block1, 1);
	            if_block1.m(div3, null);
	          }
	          if (dirty & /*filter1*/16) {
	            toggle_class$1(div3, "hide", ! /*filter1*/ctx[4] || /*filter1*/ctx[4] === "");
	          }
	          const selectbox1_changes = {};
	          if (dirty & /*_select2Id*/1024) selectbox1_changes.id = /*_select2Id*/ctx[10];
	          if (dirty & /*params*/256) selectbox1_changes.theme = /*params*/ctx[8].colDef.gridParams.theme;
	          if (!updating_options_1 && dirty & /*options*/1) {
	            updating_options_1 = true;
	            selectbox1_changes.options = /*options*/ctx[0];
	            add_flush_callback$1(() => updating_options_1 = false);
	          }
	          if (!updating_value_1 && dirty & /*type2*/32) {
	            updating_value_1 = true;
	            selectbox1_changes.value = /*type2*/ctx[5];
	            add_flush_callback$1(() => updating_value_1 = false);
	          }
	          selectbox1.$set(selectbox1_changes);
	          if (/*type2*/ctx[5] !== "isEmpty" && /*type2*/ctx[5] !== "isNotEmpty") {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	              if (dirty & /*type2*/32) {
	                transition_in$1(if_block2, 1);
	              }
	            } else {
	              if_block2 = create_if_block$6(ctx);
	              if_block2.c();
	              transition_in$1(if_block2, 1);
	              if_block2.m(div5, null);
	            }
	          } else if (if_block2) {
	            group_outros$1();
	            transition_out$1(if_block2, 1, 1, () => {
	              if_block2 = null;
	            });
	            check_outros$1();
	          }
	          if (dirty & /*showOperator, filter1*/144) {
	            toggle_class$1(div5, "expanded", /*showOperator*/ctx[7] && /*filter1*/ctx[4] && /*filter1*/ctx[4] !== "");
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(selectbox0.$$.fragment, local);
	          transition_in$1(if_block0);
	          transition_in$1(if_block1);
	          transition_in$1(selectbox1.$$.fragment, local);
	          transition_in$1(if_block2);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(selectbox0.$$.fragment, local);
	          transition_out$1(if_block0);
	          transition_out$1(if_block1);
	          transition_out$1(selectbox1.$$.fragment, local);
	          transition_out$1(if_block2);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div6);
	          destroy_component$1(selectbox0);
	          if (if_block0) if_block0.d();
	          if_blocks[current_block_type_index].d();
	          destroy_component$1(selectbox1);
	          if (if_block2) if_block2.d();
	          mounted = false;
	          dispose();
	        }
	      };
	    }
	    function instance$8($$self, $$props, $$invalidate) {
	      let $_;
	      component_subscribe$1($$self, X$1, $$value => $$invalidate(28, $_ = $$value));
	      const dispatch = createEventDispatcher$1();
	      let {
	        params
	      } = $$props;
	      let {
	        options = [{
	          value: "contains",
	          display: $_("Operator_Contains")
	        }, {
	          value: "notContains",
	          display: $_("Operator_NotContains")
	        }, {
	          value: "equals",
	          display: $_("Operator_Equals")
	        }, {
	          value: "notEqual",
	          display: $_("Operator_NotEqual")
	        }, {
	          value: "startsWith",
	          display: $_("Operator_StartsWith")
	        }, {
	          value: "endsWith",
	          display: $_("Operator_EndsWith")
	        }, {
	          value: "isEmpty",
	          display: $_("Operator_IsEmpty")
	        }, {
	          value: "isNotEmpty",
	          display: $_("Operator_IsNotEmpty")
	        }]
	      } = $$props;
	      let {
	        operatorOptions = [{
	          value: "OR",
	          display: $_("Operator_OR")
	        }, {
	          value: "AND",
	          display: $_("Operator_AND")
	        }]
	      } = $$props;
	      let {
	        operator = "OR"
	      } = $$props;
	      let {
	        type1 = "contains"
	      } = $$props;
	      let {
	        filter1 = ""
	      } = $$props;
	      let {
	        type2 = "contains"
	      } = $$props;
	      let {
	        filter2 = ""
	      } = $$props;
	      let {
	        showOperator = false
	      } = $$props;
	      let _gridId = null;
	      let _colId = null;
	      let _select1Id = null;
	      let _select2Id = null;
	      let _text1Id = null;
	      let _text2Id = null;
	      let _operatorId = null;
	      let _toggleId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        _colId = get$1(params, "column.colDef.colId");
	        $$invalidate(9, _select1Id = _gridId ? `${_gridId}-${_colId}-select1` : undefined);
	        $$invalidate(10, _select2Id = _gridId ? `${_gridId}-${_colId}-select2` : undefined);
	        $$invalidate(11, _text1Id = _gridId ? `${_gridId}-${_colId}-text1` : undefined);
	        $$invalidate(12, _text2Id = _gridId ? `${_gridId}-${_colId}-text2` : undefined);
	        $$invalidate(13, _operatorId = _gridId ? `${_gridId}-${_colId}-operator` : undefined);
	        $$invalidate(14, _toggleId = _gridId ? `${_gridId}-${_colId}-toggle` : undefined);
	      });
	      function setFilter(filter) {
	        if (!filter) {
	          $$invalidate(3, type1 = "contains");
	          $$invalidate(4, filter1 = "");
	          $$invalidate(5, type2 = "contains");
	          $$invalidate(6, filter2 = "");
	          $$invalidate(7, showOperator = false);
	        } else {
	          $$invalidate(3, type1 = filter.conditions[0].type);
	          $$invalidate(4, filter1 = filter.conditions[0].filter);
	          if (filter.conditions.length > 1) {
	            $$invalidate(5, type2 = filter.conditions[1].type);
	            $$invalidate(6, filter2 = filter.conditions[1].filter);
	            $$invalidate(2, operator = filter.operator);
	            $$invalidate(7, showOperator = true);
	          }
	        }
	        handleFilterChanged();
	      }
	      function handleFilterChanged() {
	        let filter = null;
	        if (filter1 !== undefined && filter1 !== null && filter1 !== "") {
	          filter = {
	            conditions: [],
	            type: "text"
	          };
	          filter.conditions.push({
	            filter: filter1,
	            type: type1
	          });
	        } else if (type1 === "isEmpty" || type1 === "isNotEmpty") {
	          filter = {
	            conditions: [],
	            type: "text"
	          };
	          filter.conditions.push({
	            type: type1
	          });
	        }
	        if (filter) {
	          if (showOperator && filter2 !== undefined && filter2 !== null && filter2 !== "") {
	            filter.operator = operator;
	            filter.conditions.push({
	              filter: filter2,
	              type: type2
	            });
	          } else if (type2 === "isEmpty" || type2 === "isNotEmpty") {
	            filter.operator = operator;
	            filter.conditions.push({
	              type: type2
	            });
	          }
	        }
	        dispatch("changed", filter);
	      }
	      function toggleOperator() {
	        $$invalidate(7, showOperator = !showOperator);
	        handleFilterChanged();
	      }
	      function selectbox0_value_binding(value) {
	        type1 = value;
	        $$invalidate(3, type1);
	      }
	      function selectbox0_options_binding(value) {
	        options = value;
	        $$invalidate(0, options);
	      }
	      function textbox_value_binding(value) {
	        filter1 = value;
	        $$invalidate(4, filter1);
	      }
	      function selectbox_options_binding(value) {
	        operatorOptions = value;
	        $$invalidate(1, operatorOptions);
	      }
	      function selectbox_value_binding(value) {
	        operator = value;
	        $$invalidate(2, operator);
	      }
	      function selectbox1_options_binding(value) {
	        options = value;
	        $$invalidate(0, options);
	      }
	      function selectbox1_value_binding(value) {
	        type2 = value;
	        $$invalidate(5, type2);
	      }
	      function textbox_value_binding_1(value) {
	        filter2 = value;
	        $$invalidate(6, filter2);
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(8, params = $$props.params);
	        if ("options" in $$props) $$invalidate(0, options = $$props.options);
	        if ("operatorOptions" in $$props) $$invalidate(1, operatorOptions = $$props.operatorOptions);
	        if ("operator" in $$props) $$invalidate(2, operator = $$props.operator);
	        if ("type1" in $$props) $$invalidate(3, type1 = $$props.type1);
	        if ("filter1" in $$props) $$invalidate(4, filter1 = $$props.filter1);
	        if ("type2" in $$props) $$invalidate(5, type2 = $$props.type2);
	        if ("filter2" in $$props) $$invalidate(6, filter2 = $$props.filter2);
	        if ("showOperator" in $$props) $$invalidate(7, showOperator = $$props.showOperator);
	      };
	      return [options, operatorOptions, operator, type1, filter1, type2, filter2, showOperator, params, _select1Id, _select2Id, _text1Id, _text2Id, _operatorId, _toggleId, handleFilterChanged, toggleOperator, setFilter, selectbox0_value_binding, selectbox0_options_binding, textbox_value_binding, selectbox_options_binding, selectbox_value_binding, selectbox1_options_binding, selectbox1_value_binding, textbox_value_binding_1];
	    }
	    class TextGridFilter extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-rmtefj-style")) add_css$8();
	        init$1(this, options, instance$8, create_fragment$8, safe_not_equal$1, {
	          params: 8,
	          options: 0,
	          operatorOptions: 1,
	          operator: 2,
	          type1: 3,
	          filter1: 4,
	          type2: 5,
	          filter2: 6,
	          showOperator: 7,
	          setFilter: 17
	        });
	      }
	      get setFilter() {
	        return this.$$.ctx[17];
	      }
	    }

	    class TextGridFilterComponent {
	      init(params) {
	        this.column = params.column.colDef.printOSColumn;
	        this.agParams = params;
	        this.filterContainer = document.createElement('div');
	        this.filterContainer.classList.add('pros-grid-filter-container');
	        this.gridFilter = new TextGridFilter({
	          target: this.filterContainer,
	          props: {
	            params: params
	          }
	        });
	        this.filter = undefined;
	        this.gridFilter.$on('changed', event => {
	          this.agParams.api.showLoadingOverlay();
	          setTimeout(() => {
	            this.filter = event.detail;
	            this.agParams.filterChangedCallback();
	          }, 10);
	        });
	      }
	      getGui() {
	        return this.filterContainer;
	      }
	      isFilterActive() {
	        return this.filter && this.filter.conditions.length > 0;
	      }
	      getModel() {
	        if (!this.filter) {
	          return null;
	        }
	        return this.filter;
	      }
	      setModel(filter) {
	        this.gridFilter.setFilter(filter);
	      }
	      doesFilterPass(params) {
	        if (!this.filter) {
	          return true;
	        }
	        let value = columns.getString(this.column, params.data, params);
	        let result1 = this.checkCondition(this.filter.conditions[0], value);
	        if (this.filter.conditions.length === 1) {
	          return result1;
	        }
	        let result2 = this.checkCondition(this.filter.conditions[1], value);
	        switch (this.filter.operator) {
	          case 'OR':
	            return result1 || result2;
	          case 'AND':
	            return result1 && result2;
	          default:
	            // OR
	            return result1 || result2;
	        }
	      }
	      checkCondition(condition, value) {
	        let myValue = value ? value.toLocaleLowerCase() : null;
	        let test = condition.filter ? condition.filter.toLocaleLowerCase() : null;
	        switch (condition.type) {
	          case 'contains':
	            return myValue ? myValue.indexOf(test) >= 0 : false;
	          case 'notContains':
	            return myValue ? myValue.indexOf(test) === -1 : true;
	          case 'equals':
	            return myValue === test;
	          case 'notEqual':
	            return myValue !== test;
	          case 'startsWith':
	            return myValue ? myValue.startsWith(test) : false;
	          case 'endsWith':
	            return myValue ? myValue.endsWith(test) : false;
	          case 'isEmpty':
	            return !myValue;
	          case 'isNotEmpty':
	            return !!myValue;
	          default:
	            // contains
	            return myValue.indexOf(test) >= 0;
	        }
	      }
	      destroy() {
	        this.gridFilter.$destroy();
	      }
	    }

	    /* src/filters/NumberGridFilter.svelte generated by Svelte v3.38.2 */
	    function add_css$7() {
	      var style = element$1("style");
	      style.id = "svelte-1rf2o8r-style";
	      style.textContent = ".pros-number-grid-filter{display:flex;flex-direction:column;padding:16px;width:300px}.pros-number-grid-filter .pros-toggle-container{margin:8px 0;height:48px;display:flex;justify-content:flex-start;align-items:center}.pros-number-grid-filter .pros-toggle-container else{flex-direction:row}.pros-number-grid-filter .pros-toggle-container.hide{display:none}.pros-number-grid-filter .pros-toggle-container .blank{flex:1;border-radius:12px;border:1px solid #F3F3F3}.pros-number-grid-filter .pros-toggle-container .pros-button{display:flex;flex-direction:column;justify-content:center;align-items:center;height:48px;width:48px;margin-right:8px;font-size:30px;border-radius:8px;border:1px solid #F3F3F3}.pros-number-grid-filter .pros-toggle-container .pros-button svg{transition:transform 0.5s ease 0s}.pros-number-grid-filter .pros-toggle-container .pros-button.open svg{transition:transform 0.5s ease 0s;transform:rotate(-180deg)}.pros-number-grid-filter .pros-toggle-container .pros-operator-container{flex:1}.pros-number-grid-filter .pros-control-container{margin-bottom:8px}.pros-number-grid-filter .pros-control-container:last-of-type{margin-bottom:0}.pros-number-grid-filter .pros-condition-container{display:flex;flex-direction:column}.pros-number-grid-filter .pros-condition-container.option2{display:none}.pros-number-grid-filter .pros-condition-container.option2.expanded{display:inherit}";
	      append$1(document.head, style);
	    }

	    // (14:4) {#if type1 !== 'isEmpty' && type1 !== 'isNotEmpty'}
	    function create_if_block_4$2(ctx) {
	      let div;
	      let numberbox;
	      let updating_value;
	      let updating_step;
	      let updating_min;
	      let updating_max;
	      let current;
	      function numberbox_value_binding(value) {
	        /*numberbox_value_binding*/ctx[27](value);
	      }
	      function numberbox_step_binding(value) {
	        /*numberbox_step_binding*/ctx[28](value);
	      }
	      function numberbox_min_binding(value) {
	        /*numberbox_min_binding*/ctx[29](value);
	      }
	      function numberbox_max_binding(value) {
	        /*numberbox_max_binding*/ctx[30](value);
	      }
	      let numberbox_props = {
	        id: /*_num1aId*/ctx[16],
	        theme: /*params*/ctx[13].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter1a*/ctx[7] !== void 0) {
	        numberbox_props.value = /*filter1a*/ctx[7];
	      }
	      if (/*step*/ctx[3] !== void 0) {
	        numberbox_props.step = /*step*/ctx[3];
	      }
	      if (/*min*/ctx[4] !== void 0) {
	        numberbox_props.min = /*min*/ctx[4];
	      }
	      if (/*max*/ctx[5] !== void 0) {
	        numberbox_props.max = /*max*/ctx[5];
	      }
	      numberbox = new NumberBox({
	        props: numberbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(numberbox, "value", numberbox_value_binding));
	      binding_callbacks$1.push(() => bind$1(numberbox, "step", numberbox_step_binding));
	      binding_callbacks$1.push(() => bind$1(numberbox, "min", numberbox_min_binding));
	      binding_callbacks$1.push(() => bind$1(numberbox, "max", numberbox_max_binding));
	      numberbox.$on("changed", /*handleFilterChanged*/ctx[22]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(numberbox.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(numberbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const numberbox_changes = {};
	          if (dirty[0] & /*_num1aId*/65536) numberbox_changes.id = /*_num1aId*/ctx[16];
	          if (dirty[0] & /*params*/8192) numberbox_changes.theme = /*params*/ctx[13].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter1a*/128) {
	            updating_value = true;
	            numberbox_changes.value = /*filter1a*/ctx[7];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          if (!updating_step && dirty[0] & /*step*/8) {
	            updating_step = true;
	            numberbox_changes.step = /*step*/ctx[3];
	            add_flush_callback$1(() => updating_step = false);
	          }
	          if (!updating_min && dirty[0] & /*min*/16) {
	            updating_min = true;
	            numberbox_changes.min = /*min*/ctx[4];
	            add_flush_callback$1(() => updating_min = false);
	          }
	          if (!updating_max && dirty[0] & /*max*/32) {
	            updating_max = true;
	            numberbox_changes.max = /*max*/ctx[5];
	            add_flush_callback$1(() => updating_max = false);
	          }
	          numberbox.$set(numberbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(numberbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(numberbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(numberbox);
	        }
	      };
	    }

	    // (29:4) {#if type1 === 'betweenInclusive' || type1 === 'betweenExclusive'}
	    function create_if_block_3$2(ctx) {
	      let div;
	      let numberbox;
	      let updating_value;
	      let updating_step;
	      let updating_min;
	      let updating_max;
	      let current;
	      function numberbox_value_binding_1(value) {
	        /*numberbox_value_binding_1*/ctx[31](value);
	      }
	      function numberbox_step_binding_1(value) {
	        /*numberbox_step_binding_1*/ctx[32](value);
	      }
	      function numberbox_min_binding_1(value) {
	        /*numberbox_min_binding_1*/ctx[33](value);
	      }
	      function numberbox_max_binding_1(value) {
	        /*numberbox_max_binding_1*/ctx[34](value);
	      }
	      let numberbox_props = {
	        id: /*_num1bId*/ctx[17],
	        theme: /*params*/ctx[13].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter1b*/ctx[8] !== void 0) {
	        numberbox_props.value = /*filter1b*/ctx[8];
	      }
	      if (/*step*/ctx[3] !== void 0) {
	        numberbox_props.step = /*step*/ctx[3];
	      }
	      if (/*min*/ctx[4] !== void 0) {
	        numberbox_props.min = /*min*/ctx[4];
	      }
	      if (/*max*/ctx[5] !== void 0) {
	        numberbox_props.max = /*max*/ctx[5];
	      }
	      numberbox = new NumberBox({
	        props: numberbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(numberbox, "value", numberbox_value_binding_1));
	      binding_callbacks$1.push(() => bind$1(numberbox, "step", numberbox_step_binding_1));
	      binding_callbacks$1.push(() => bind$1(numberbox, "min", numberbox_min_binding_1));
	      binding_callbacks$1.push(() => bind$1(numberbox, "max", numberbox_max_binding_1));
	      numberbox.$on("changed", /*handleFilterChanged*/ctx[22]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(numberbox.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(numberbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const numberbox_changes = {};
	          if (dirty[0] & /*_num1bId*/131072) numberbox_changes.id = /*_num1bId*/ctx[17];
	          if (dirty[0] & /*params*/8192) numberbox_changes.theme = /*params*/ctx[13].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter1b*/256) {
	            updating_value = true;
	            numberbox_changes.value = /*filter1b*/ctx[8];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          if (!updating_step && dirty[0] & /*step*/8) {
	            updating_step = true;
	            numberbox_changes.step = /*step*/ctx[3];
	            add_flush_callback$1(() => updating_step = false);
	          }
	          if (!updating_min && dirty[0] & /*min*/16) {
	            updating_min = true;
	            numberbox_changes.min = /*min*/ctx[4];
	            add_flush_callback$1(() => updating_min = false);
	          }
	          if (!updating_max && dirty[0] & /*max*/32) {
	            updating_max = true;
	            numberbox_changes.max = /*max*/ctx[5];
	            add_flush_callback$1(() => updating_max = false);
	          }
	          numberbox.$set(numberbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(numberbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(numberbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(numberbox);
	        }
	      };
	    }

	    // (63:4) {:else}
	    function create_else_block$2(ctx) {
	      let div;
	      return {
	        c() {
	          div = element$1("div");
	          attr$1(div, "class", "blank");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	        },
	        p: noop$1,
	        i: noop$1,
	        o: noop$1,
	        d(detaching) {
	          if (detaching) detach$1(div);
	        }
	      };
	    }

	    // (52:4) {#if showOperator === true}
	    function create_if_block_2$3(ctx) {
	      let div;
	      let selectbox;
	      let updating_options;
	      let updating_value;
	      let current;
	      function selectbox_options_binding(value) {
	        /*selectbox_options_binding*/ctx[35](value);
	      }
	      function selectbox_value_binding(value) {
	        /*selectbox_value_binding*/ctx[36](value);
	      }
	      let selectbox_props = {
	        id: /*_operatorId*/ctx[20],
	        theme: /*params*/ctx[13].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*operatorOptions*/ctx[1] !== void 0) {
	        selectbox_props.options = /*operatorOptions*/ctx[1];
	      }
	      if (/*operator*/ctx[2] !== void 0) {
	        selectbox_props.value = /*operator*/ctx[2];
	      }
	      selectbox = new SelectBox({
	        props: selectbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox, "options", selectbox_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox, "value", selectbox_value_binding));
	      selectbox.$on("changed", /*handleFilterChanged*/ctx[22]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(selectbox.$$.fragment);
	          attr$1(div, "class", "pros-operator-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(selectbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const selectbox_changes = {};
	          if (dirty[0] & /*_operatorId*/1048576) selectbox_changes.id = /*_operatorId*/ctx[20];
	          if (dirty[0] & /*params*/8192) selectbox_changes.theme = /*params*/ctx[13].colDef.gridParams.theme;
	          if (!updating_options && dirty[0] & /*operatorOptions*/2) {
	            updating_options = true;
	            selectbox_changes.options = /*operatorOptions*/ctx[1];
	            add_flush_callback$1(() => updating_options = false);
	          }
	          if (!updating_value && dirty[0] & /*operator*/4) {
	            updating_value = true;
	            selectbox_changes.value = /*operator*/ctx[2];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          selectbox.$set(selectbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(selectbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(selectbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(selectbox);
	        }
	      };
	    }

	    // (80:4) {#if type2 !== 'isEmpty' && type2 !== 'isNotEmpty'}
	    function create_if_block_1$3(ctx) {
	      let div;
	      let numberbox;
	      let updating_value;
	      let updating_step;
	      let updating_min;
	      let updating_max;
	      let current;
	      function numberbox_value_binding_2(value) {
	        /*numberbox_value_binding_2*/ctx[39](value);
	      }
	      function numberbox_step_binding_2(value) {
	        /*numberbox_step_binding_2*/ctx[40](value);
	      }
	      function numberbox_min_binding_2(value) {
	        /*numberbox_min_binding_2*/ctx[41](value);
	      }
	      function numberbox_max_binding_2(value) {
	        /*numberbox_max_binding_2*/ctx[42](value);
	      }
	      let numberbox_props = {
	        id: /*_num2aId*/ctx[18],
	        theme: /*params*/ctx[13].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter2a*/ctx[10] !== void 0) {
	        numberbox_props.value = /*filter2a*/ctx[10];
	      }
	      if (/*step*/ctx[3] !== void 0) {
	        numberbox_props.step = /*step*/ctx[3];
	      }
	      if (/*min*/ctx[4] !== void 0) {
	        numberbox_props.min = /*min*/ctx[4];
	      }
	      if (/*max*/ctx[5] !== void 0) {
	        numberbox_props.max = /*max*/ctx[5];
	      }
	      numberbox = new NumberBox({
	        props: numberbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(numberbox, "value", numberbox_value_binding_2));
	      binding_callbacks$1.push(() => bind$1(numberbox, "step", numberbox_step_binding_2));
	      binding_callbacks$1.push(() => bind$1(numberbox, "min", numberbox_min_binding_2));
	      binding_callbacks$1.push(() => bind$1(numberbox, "max", numberbox_max_binding_2));
	      numberbox.$on("changed", /*handleFilterChanged*/ctx[22]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(numberbox.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(numberbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const numberbox_changes = {};
	          if (dirty[0] & /*_num2aId*/262144) numberbox_changes.id = /*_num2aId*/ctx[18];
	          if (dirty[0] & /*params*/8192) numberbox_changes.theme = /*params*/ctx[13].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter2a*/1024) {
	            updating_value = true;
	            numberbox_changes.value = /*filter2a*/ctx[10];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          if (!updating_step && dirty[0] & /*step*/8) {
	            updating_step = true;
	            numberbox_changes.step = /*step*/ctx[3];
	            add_flush_callback$1(() => updating_step = false);
	          }
	          if (!updating_min && dirty[0] & /*min*/16) {
	            updating_min = true;
	            numberbox_changes.min = /*min*/ctx[4];
	            add_flush_callback$1(() => updating_min = false);
	          }
	          if (!updating_max && dirty[0] & /*max*/32) {
	            updating_max = true;
	            numberbox_changes.max = /*max*/ctx[5];
	            add_flush_callback$1(() => updating_max = false);
	          }
	          numberbox.$set(numberbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(numberbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(numberbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(numberbox);
	        }
	      };
	    }

	    // (95:4) {#if type2 === 'betweenInclusive' || type2 === 'betweenExclusive'}
	    function create_if_block$5(ctx) {
	      let div;
	      let numberbox;
	      let updating_value;
	      let updating_step;
	      let updating_min;
	      let updating_max;
	      let current;
	      function numberbox_value_binding_3(value) {
	        /*numberbox_value_binding_3*/ctx[43](value);
	      }
	      function numberbox_step_binding_3(value) {
	        /*numberbox_step_binding_3*/ctx[44](value);
	      }
	      function numberbox_min_binding_3(value) {
	        /*numberbox_min_binding_3*/ctx[45](value);
	      }
	      function numberbox_max_binding_3(value) {
	        /*numberbox_max_binding_3*/ctx[46](value);
	      }
	      let numberbox_props = {
	        id: /*_num2bId*/ctx[19],
	        theme: /*params*/ctx[13].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter2b*/ctx[11] !== void 0) {
	        numberbox_props.value = /*filter2b*/ctx[11];
	      }
	      if (/*step*/ctx[3] !== void 0) {
	        numberbox_props.step = /*step*/ctx[3];
	      }
	      if (/*min*/ctx[4] !== void 0) {
	        numberbox_props.min = /*min*/ctx[4];
	      }
	      if (/*max*/ctx[5] !== void 0) {
	        numberbox_props.max = /*max*/ctx[5];
	      }
	      numberbox = new NumberBox({
	        props: numberbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(numberbox, "value", numberbox_value_binding_3));
	      binding_callbacks$1.push(() => bind$1(numberbox, "step", numberbox_step_binding_3));
	      binding_callbacks$1.push(() => bind$1(numberbox, "min", numberbox_min_binding_3));
	      binding_callbacks$1.push(() => bind$1(numberbox, "max", numberbox_max_binding_3));
	      numberbox.$on("changed", /*handleFilterChanged*/ctx[22]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(numberbox.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(numberbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const numberbox_changes = {};
	          if (dirty[0] & /*_num2bId*/524288) numberbox_changes.id = /*_num2bId*/ctx[19];
	          if (dirty[0] & /*params*/8192) numberbox_changes.theme = /*params*/ctx[13].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter2b*/2048) {
	            updating_value = true;
	            numberbox_changes.value = /*filter2b*/ctx[11];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          if (!updating_step && dirty[0] & /*step*/8) {
	            updating_step = true;
	            numberbox_changes.step = /*step*/ctx[3];
	            add_flush_callback$1(() => updating_step = false);
	          }
	          if (!updating_min && dirty[0] & /*min*/16) {
	            updating_min = true;
	            numberbox_changes.min = /*min*/ctx[4];
	            add_flush_callback$1(() => updating_min = false);
	          }
	          if (!updating_max && dirty[0] & /*max*/32) {
	            updating_max = true;
	            numberbox_changes.max = /*max*/ctx[5];
	            add_flush_callback$1(() => updating_max = false);
	          }
	          numberbox.$set(numberbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(numberbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(numberbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(numberbox);
	        }
	      };
	    }
	    function create_fragment$7(ctx) {
	      let div6;
	      let div1;
	      let div0;
	      let selectbox0;
	      let updating_options;
	      let updating_value;
	      let t0;
	      let t1;
	      let t2;
	      let div3;
	      let div2;
	      let svg;
	      let path;
	      let t3;
	      let current_block_type_index;
	      let if_block2;
	      let t4;
	      let div5;
	      let div4;
	      let selectbox1;
	      let updating_options_1;
	      let updating_value_1;
	      let t5;
	      let t6;
	      let current;
	      let mounted;
	      let dispose;
	      function selectbox0_options_binding(value) {
	        /*selectbox0_options_binding*/ctx[25](value);
	      }
	      function selectbox0_value_binding(value) {
	        /*selectbox0_value_binding*/ctx[26](value);
	      }
	      let selectbox0_props = {
	        id: /*_select1Id*/ctx[14],
	        theme: /*params*/ctx[13].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*options*/ctx[0] !== void 0) {
	        selectbox0_props.options = /*options*/ctx[0];
	      }
	      if (/*type1*/ctx[6] !== void 0) {
	        selectbox0_props.value = /*type1*/ctx[6];
	      }
	      selectbox0 = new SelectBox({
	        props: selectbox0_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox0, "options", selectbox0_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox0, "value", selectbox0_value_binding));
	      selectbox0.$on("changed", /*handleFilterChanged*/ctx[22]);
	      let if_block0 = /*type1*/ctx[6] !== "isEmpty" && /*type1*/ctx[6] !== "isNotEmpty" && create_if_block_4$2(ctx);
	      let if_block1 = (/*type1*/ctx[6] === "betweenInclusive" || /*type1*/ctx[6] === "betweenExclusive") && create_if_block_3$2(ctx);
	      const if_block_creators = [create_if_block_2$3, create_else_block$2];
	      const if_blocks = [];
	      function select_block_type(ctx, dirty) {
	        if (/*showOperator*/ctx[12] === true) return 0;
	        return 1;
	      }
	      current_block_type_index = select_block_type(ctx);
	      if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      function selectbox1_options_binding(value) {
	        /*selectbox1_options_binding*/ctx[37](value);
	      }
	      function selectbox1_value_binding(value) {
	        /*selectbox1_value_binding*/ctx[38](value);
	      }
	      let selectbox1_props = {
	        id: /*_select2Id*/ctx[15],
	        theme: /*params*/ctx[13].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*options*/ctx[0] !== void 0) {
	        selectbox1_props.options = /*options*/ctx[0];
	      }
	      if (/*type2*/ctx[9] !== void 0) {
	        selectbox1_props.value = /*type2*/ctx[9];
	      }
	      selectbox1 = new SelectBox({
	        props: selectbox1_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox1, "options", selectbox1_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox1, "value", selectbox1_value_binding));
	      selectbox1.$on("changed", /*handleFilterChanged*/ctx[22]);
	      let if_block3 = /*type2*/ctx[9] !== "isEmpty" && /*type2*/ctx[9] !== "isNotEmpty" && create_if_block_1$3(ctx);
	      let if_block4 = (/*type2*/ctx[9] === "betweenInclusive" || /*type2*/ctx[9] === "betweenExclusive") && create_if_block$5(ctx);
	      return {
	        c() {
	          div6 = element$1("div");
	          div1 = element$1("div");
	          div0 = element$1("div");
	          create_component$1(selectbox0.$$.fragment);
	          t0 = space$1();
	          if (if_block0) if_block0.c();
	          t1 = space$1();
	          if (if_block1) if_block1.c();
	          t2 = space$1();
	          div3 = element$1("div");
	          div2 = element$1("div");
	          svg = svg_element$1("svg");
	          path = svg_element$1("path");
	          t3 = space$1();
	          if_block2.c();
	          t4 = space$1();
	          div5 = element$1("div");
	          div4 = element$1("div");
	          create_component$1(selectbox1.$$.fragment);
	          t5 = space$1();
	          if (if_block3) if_block3.c();
	          t6 = space$1();
	          if (if_block4) if_block4.c();
	          attr$1(div0, "class", "pros-control-container");
	          attr$1(div1, "class", "pros-condition-container");
	          attr$1(path, "d", "M13 17C12.8721 17 12.7441 16.9512 12.6465 16.8535L4.64648 8.85352C4.45117 8.6582 4.45117 8.3418 4.64648 8.14648C4.8418 7.95117 5.1582 7.95117 5.35352 8.14648L13 15.793L20.6465 8.14648C20.8418 7.95117 21.1582 7.95117 21.3535 8.14648C21.5488 8.3418 21.5488 8.6582 21.3535 8.85352L13.3535 16.8535C13.2559 16.9512 13.1279 17 13 17Z");
	          attr$1(svg, "width", "24");
	          attr$1(svg, "height", "24");
	          attr$1(svg, "viewBox", "0 0 24 24");
	          attr$1(svg, "fill", "currentColor");
	          attr$1(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr$1(div2, "id", /*_toggleId*/ctx[21]);
	          attr$1(div2, "class", "pros-button");
	          attr$1(div2, "type", "button");
	          toggle_class$1(div2, "open", /*showOperator*/ctx[12]);
	          attr$1(div3, "class", "pros-toggle-container");
	          toggle_class$1(div3, "hide", ! /*filter1a*/ctx[7] || /*filter1a*/ctx[7] === "");
	          attr$1(div4, "class", "pros-control-container");
	          attr$1(div5, "class", "pros-condition-container option2");
	          toggle_class$1(div5, "expanded", /*showOperator*/ctx[12] && /*filter1a*/ctx[7] && /*filter1a*/ctx[7] !== "");
	          attr$1(div6, "class", "pros-number-grid-filter");
	        },
	        m(target, anchor) {
	          insert$1(target, div6, anchor);
	          append$1(div6, div1);
	          append$1(div1, div0);
	          mount_component$1(selectbox0, div0, null);
	          append$1(div1, t0);
	          if (if_block0) if_block0.m(div1, null);
	          append$1(div1, t1);
	          if (if_block1) if_block1.m(div1, null);
	          append$1(div6, t2);
	          append$1(div6, div3);
	          append$1(div3, div2);
	          append$1(div2, svg);
	          append$1(svg, path);
	          append$1(div3, t3);
	          if_blocks[current_block_type_index].m(div3, null);
	          append$1(div6, t4);
	          append$1(div6, div5);
	          append$1(div5, div4);
	          mount_component$1(selectbox1, div4, null);
	          append$1(div5, t5);
	          if (if_block3) if_block3.m(div5, null);
	          append$1(div5, t6);
	          if (if_block4) if_block4.m(div5, null);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(div2, "click", /*toggleOperator*/ctx[23]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          const selectbox0_changes = {};
	          if (dirty[0] & /*_select1Id*/16384) selectbox0_changes.id = /*_select1Id*/ctx[14];
	          if (dirty[0] & /*params*/8192) selectbox0_changes.theme = /*params*/ctx[13].colDef.gridParams.theme;
	          if (!updating_options && dirty[0] & /*options*/1) {
	            updating_options = true;
	            selectbox0_changes.options = /*options*/ctx[0];
	            add_flush_callback$1(() => updating_options = false);
	          }
	          if (!updating_value && dirty[0] & /*type1*/64) {
	            updating_value = true;
	            selectbox0_changes.value = /*type1*/ctx[6];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          selectbox0.$set(selectbox0_changes);
	          if (/*type1*/ctx[6] !== "isEmpty" && /*type1*/ctx[6] !== "isNotEmpty") {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	              if (dirty[0] & /*type1*/64) {
	                transition_in$1(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_4$2(ctx);
	              if_block0.c();
	              transition_in$1(if_block0, 1);
	              if_block0.m(div1, t1);
	            }
	          } else if (if_block0) {
	            group_outros$1();
	            transition_out$1(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros$1();
	          }
	          if (/*type1*/ctx[6] === "betweenInclusive" || /*type1*/ctx[6] === "betweenExclusive") {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty[0] & /*type1*/64) {
	                transition_in$1(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block_3$2(ctx);
	              if_block1.c();
	              transition_in$1(if_block1, 1);
	              if_block1.m(div1, null);
	            }
	          } else if (if_block1) {
	            group_outros$1();
	            transition_out$1(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros$1();
	          }
	          if (!current || dirty[0] & /*_toggleId*/2097152) {
	            attr$1(div2, "id", /*_toggleId*/ctx[21]);
	          }
	          if (dirty[0] & /*showOperator*/4096) {
	            toggle_class$1(div2, "open", /*showOperator*/ctx[12]);
	          }
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros$1();
	            transition_out$1(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros$1();
	            if_block2 = if_blocks[current_block_type_index];
	            if (!if_block2) {
	              if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block2.c();
	            } else {
	              if_block2.p(ctx, dirty);
	            }
	            transition_in$1(if_block2, 1);
	            if_block2.m(div3, null);
	          }
	          if (dirty[0] & /*filter1a*/128) {
	            toggle_class$1(div3, "hide", ! /*filter1a*/ctx[7] || /*filter1a*/ctx[7] === "");
	          }
	          const selectbox1_changes = {};
	          if (dirty[0] & /*_select2Id*/32768) selectbox1_changes.id = /*_select2Id*/ctx[15];
	          if (dirty[0] & /*params*/8192) selectbox1_changes.theme = /*params*/ctx[13].colDef.gridParams.theme;
	          if (!updating_options_1 && dirty[0] & /*options*/1) {
	            updating_options_1 = true;
	            selectbox1_changes.options = /*options*/ctx[0];
	            add_flush_callback$1(() => updating_options_1 = false);
	          }
	          if (!updating_value_1 && dirty[0] & /*type2*/512) {
	            updating_value_1 = true;
	            selectbox1_changes.value = /*type2*/ctx[9];
	            add_flush_callback$1(() => updating_value_1 = false);
	          }
	          selectbox1.$set(selectbox1_changes);
	          if (/*type2*/ctx[9] !== "isEmpty" && /*type2*/ctx[9] !== "isNotEmpty") {
	            if (if_block3) {
	              if_block3.p(ctx, dirty);
	              if (dirty[0] & /*type2*/512) {
	                transition_in$1(if_block3, 1);
	              }
	            } else {
	              if_block3 = create_if_block_1$3(ctx);
	              if_block3.c();
	              transition_in$1(if_block3, 1);
	              if_block3.m(div5, t6);
	            }
	          } else if (if_block3) {
	            group_outros$1();
	            transition_out$1(if_block3, 1, 1, () => {
	              if_block3 = null;
	            });
	            check_outros$1();
	          }
	          if (/*type2*/ctx[9] === "betweenInclusive" || /*type2*/ctx[9] === "betweenExclusive") {
	            if (if_block4) {
	              if_block4.p(ctx, dirty);
	              if (dirty[0] & /*type2*/512) {
	                transition_in$1(if_block4, 1);
	              }
	            } else {
	              if_block4 = create_if_block$5(ctx);
	              if_block4.c();
	              transition_in$1(if_block4, 1);
	              if_block4.m(div5, null);
	            }
	          } else if (if_block4) {
	            group_outros$1();
	            transition_out$1(if_block4, 1, 1, () => {
	              if_block4 = null;
	            });
	            check_outros$1();
	          }
	          if (dirty[0] & /*showOperator, filter1a*/4224) {
	            toggle_class$1(div5, "expanded", /*showOperator*/ctx[12] && /*filter1a*/ctx[7] && /*filter1a*/ctx[7] !== "");
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(selectbox0.$$.fragment, local);
	          transition_in$1(if_block0);
	          transition_in$1(if_block1);
	          transition_in$1(if_block2);
	          transition_in$1(selectbox1.$$.fragment, local);
	          transition_in$1(if_block3);
	          transition_in$1(if_block4);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(selectbox0.$$.fragment, local);
	          transition_out$1(if_block0);
	          transition_out$1(if_block1);
	          transition_out$1(if_block2);
	          transition_out$1(selectbox1.$$.fragment, local);
	          transition_out$1(if_block3);
	          transition_out$1(if_block4);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div6);
	          destroy_component$1(selectbox0);
	          if (if_block0) if_block0.d();
	          if (if_block1) if_block1.d();
	          if_blocks[current_block_type_index].d();
	          destroy_component$1(selectbox1);
	          if (if_block3) if_block3.d();
	          if (if_block4) if_block4.d();
	          mounted = false;
	          dispose();
	        }
	      };
	    }
	    function instance$7($$self, $$props, $$invalidate) {
	      let $_;
	      component_subscribe$1($$self, X$1, $$value => $$invalidate(49, $_ = $$value));
	      const dispatch = createEventDispatcher$1();
	      let {
	        params
	      } = $$props;
	      let {
	        options = [{
	          value: "equals",
	          display: $_("Operator_Equals")
	        }, {
	          value: "notEqual",
	          display: $_("Operator_NotEqual")
	        }, {
	          value: "lessThan",
	          display: $_("Operator_LessThan")
	        }, {
	          value: "lessOrEqual",
	          display: $_("Operator_LessOrEqual")
	        }, {
	          value: "greaterThan",
	          display: $_("Operator_GreaterThan")
	        }, {
	          value: "greaterOrEqual",
	          display: $_("Operator_GreaterOrEqual")
	        }, {
	          value: "betweenExclusive",
	          display: $_("Operator_BetweenExclusive")
	        }, {
	          value: "betweenInclusive",
	          display: $_("Operator_BetweenInclusive")
	        }, {
	          value: "isEmpty",
	          display: $_("Operator_IsEmpty")
	        }, {
	          value: "isNotEmpty",
	          display: $_("Operator_IsNotEmpty")
	        }]
	      } = $$props;
	      let {
	        operatorOptions = [{
	          value: "OR",
	          display: "OR"
	        }, {
	          value: "AND",
	          display: "AND"
	        }]
	      } = $$props;
	      let {
	        operator = "OR"
	      } = $$props;
	      let {
	        step = undefined
	      } = $$props;
	      let {
	        min = undefined
	      } = $$props;
	      let {
	        max = undefined
	      } = $$props;
	      let {
	        type1 = "equals"
	      } = $$props;
	      let {
	        filter1a = null
	      } = $$props;
	      let {
	        filter1b = null
	      } = $$props;
	      let {
	        type2 = "equals"
	      } = $$props;
	      let {
	        filter2a = null
	      } = $$props;
	      let {
	        filter2b = null
	      } = $$props;
	      let {
	        showOperator = false
	      } = $$props;
	      let _gridId = null;
	      let _colId = null;
	      let _select1Id = null;
	      let _select2Id = null;
	      let _num1aId = null;
	      let _num1bId = null;
	      let _num2aId = null;
	      let _num2bId = null;
	      let _operatorId = null;
	      let _toggleId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        _colId = get$1(params, "column.colDef.colId");
	        $$invalidate(14, _select1Id = _gridId ? `${_gridId}-${_colId}-select1` : undefined);
	        $$invalidate(15, _select2Id = _gridId ? `${_gridId}-${_colId}-select2` : undefined);
	        $$invalidate(16, _num1aId = _gridId ? `${_gridId}-${_colId}-num1a` : undefined);
	        $$invalidate(17, _num1bId = _gridId ? `${_gridId}-${_colId}-num1b` : undefined);
	        $$invalidate(18, _num2aId = _gridId ? `${_gridId}-${_colId}-num2a` : undefined);
	        $$invalidate(19, _num2bId = _gridId ? `${_gridId}-${_colId}-num2b` : undefined);
	        $$invalidate(20, _operatorId = _gridId ? `${_gridId}-${_colId}-operator` : undefined);
	        $$invalidate(21, _toggleId = _gridId ? `${_gridId}-${_colId}-toggle` : undefined);
	      });
	      function setFilter(filter) {
	        if (!filter) {
	          $$invalidate(6, type1 = "equals");
	          $$invalidate(7, filter1a = null);
	          $$invalidate(8, filter1b = null);
	          $$invalidate(9, type2 = "equals");
	          $$invalidate(10, filter2a = null);
	          $$invalidate(11, filter2b = null);
	          $$invalidate(12, showOperator = false);
	        } else {
	          $$invalidate(6, type1 = filter.conditions[0].type);
	          $$invalidate(7, filter1a = filter.conditions[0].filterA);
	          $$invalidate(8, filter1b = filter.conditions[0].filterB ? filter.conditions[0].filterB : null);
	          if (filter.conditions.length > 1) {
	            $$invalidate(2, operator = filter.operator);
	            $$invalidate(9, type2 = filter.conditions[1].type);
	            $$invalidate(10, filter2a = filter.conditions[1].filterA);
	            $$invalidate(11, filter2b = filter.conditions[1].filterB ? filter.conditions[1].filterB : null);
	            $$invalidate(12, showOperator = true);
	          }
	        }
	        handleFilterChanged();
	      }
	      function handleFilterChanged(event) {
	        let filter = null;
	        if (filter1a !== undefined && filter1a !== null && filter1a !== "") {
	          filter = {
	            conditions: [],
	            type: "number"
	          };
	          filter.conditions.push({
	            filterA: filter1a,
	            filterB: filter1b,
	            type: type1
	          });
	        } else if (type1 === "isEmpty" || type1 === "isNotEmpty") {
	          filter = {
	            conditions: [],
	            type: "number"
	          };
	          filter.conditions.push({
	            type: type1
	          });
	        }
	        if (filter) {
	          if (showOperator && filter2b !== undefined && filter2b !== null && filter2b !== "") {
	            filter.operator = operator;
	            filter.conditions.push({
	              filterA: filter2a,
	              filterB: filter2b,
	              type: type2
	            });
	          } else if (type2 === "isEmpty" || type2 === "isNotEmpty") {
	            filter.operator = operator;
	            filter.conditions.push({
	              type: type2
	            });
	          }
	        }
	        dispatch("changed", filter);
	      }
	      function toggleOperator() {
	        $$invalidate(12, showOperator = !showOperator);
	        handleFilterChanged();
	      }
	      function selectbox0_options_binding(value) {
	        options = value;
	        $$invalidate(0, options);
	      }
	      function selectbox0_value_binding(value) {
	        type1 = value;
	        $$invalidate(6, type1);
	      }
	      function numberbox_value_binding(value) {
	        filter1a = value;
	        $$invalidate(7, filter1a);
	      }
	      function numberbox_step_binding(value) {
	        step = value;
	        $$invalidate(3, step);
	      }
	      function numberbox_min_binding(value) {
	        min = value;
	        $$invalidate(4, min);
	      }
	      function numberbox_max_binding(value) {
	        max = value;
	        $$invalidate(5, max);
	      }
	      function numberbox_value_binding_1(value) {
	        filter1b = value;
	        $$invalidate(8, filter1b);
	      }
	      function numberbox_step_binding_1(value) {
	        step = value;
	        $$invalidate(3, step);
	      }
	      function numberbox_min_binding_1(value) {
	        min = value;
	        $$invalidate(4, min);
	      }
	      function numberbox_max_binding_1(value) {
	        max = value;
	        $$invalidate(5, max);
	      }
	      function selectbox_options_binding(value) {
	        operatorOptions = value;
	        $$invalidate(1, operatorOptions);
	      }
	      function selectbox_value_binding(value) {
	        operator = value;
	        $$invalidate(2, operator);
	      }
	      function selectbox1_options_binding(value) {
	        options = value;
	        $$invalidate(0, options);
	      }
	      function selectbox1_value_binding(value) {
	        type2 = value;
	        $$invalidate(9, type2);
	      }
	      function numberbox_value_binding_2(value) {
	        filter2a = value;
	        $$invalidate(10, filter2a);
	      }
	      function numberbox_step_binding_2(value) {
	        step = value;
	        $$invalidate(3, step);
	      }
	      function numberbox_min_binding_2(value) {
	        min = value;
	        $$invalidate(4, min);
	      }
	      function numberbox_max_binding_2(value) {
	        max = value;
	        $$invalidate(5, max);
	      }
	      function numberbox_value_binding_3(value) {
	        filter2b = value;
	        $$invalidate(11, filter2b);
	      }
	      function numberbox_step_binding_3(value) {
	        step = value;
	        $$invalidate(3, step);
	      }
	      function numberbox_min_binding_3(value) {
	        min = value;
	        $$invalidate(4, min);
	      }
	      function numberbox_max_binding_3(value) {
	        max = value;
	        $$invalidate(5, max);
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(13, params = $$props.params);
	        if ("options" in $$props) $$invalidate(0, options = $$props.options);
	        if ("operatorOptions" in $$props) $$invalidate(1, operatorOptions = $$props.operatorOptions);
	        if ("operator" in $$props) $$invalidate(2, operator = $$props.operator);
	        if ("step" in $$props) $$invalidate(3, step = $$props.step);
	        if ("min" in $$props) $$invalidate(4, min = $$props.min);
	        if ("max" in $$props) $$invalidate(5, max = $$props.max);
	        if ("type1" in $$props) $$invalidate(6, type1 = $$props.type1);
	        if ("filter1a" in $$props) $$invalidate(7, filter1a = $$props.filter1a);
	        if ("filter1b" in $$props) $$invalidate(8, filter1b = $$props.filter1b);
	        if ("type2" in $$props) $$invalidate(9, type2 = $$props.type2);
	        if ("filter2a" in $$props) $$invalidate(10, filter2a = $$props.filter2a);
	        if ("filter2b" in $$props) $$invalidate(11, filter2b = $$props.filter2b);
	        if ("showOperator" in $$props) $$invalidate(12, showOperator = $$props.showOperator);
	      };
	      return [options, operatorOptions, operator, step, min, max, type1, filter1a, filter1b, type2, filter2a, filter2b, showOperator, params, _select1Id, _select2Id, _num1aId, _num1bId, _num2aId, _num2bId, _operatorId, _toggleId, handleFilterChanged, toggleOperator, setFilter, selectbox0_options_binding, selectbox0_value_binding, numberbox_value_binding, numberbox_step_binding, numberbox_min_binding, numberbox_max_binding, numberbox_value_binding_1, numberbox_step_binding_1, numberbox_min_binding_1, numberbox_max_binding_1, selectbox_options_binding, selectbox_value_binding, selectbox1_options_binding, selectbox1_value_binding, numberbox_value_binding_2, numberbox_step_binding_2, numberbox_min_binding_2, numberbox_max_binding_2, numberbox_value_binding_3, numberbox_step_binding_3, numberbox_min_binding_3, numberbox_max_binding_3];
	    }
	    class NumberGridFilter extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-1rf2o8r-style")) add_css$7();
	        init$1(this, options, instance$7, create_fragment$7, safe_not_equal$1, {
	          params: 13,
	          options: 0,
	          operatorOptions: 1,
	          operator: 2,
	          step: 3,
	          min: 4,
	          max: 5,
	          type1: 6,
	          filter1a: 7,
	          filter1b: 8,
	          type2: 9,
	          filter2a: 10,
	          filter2b: 11,
	          showOperator: 12,
	          setFilter: 24
	        }, [-1, -1]);
	      }
	      get setFilter() {
	        return this.$$.ctx[24];
	      }
	    }

	    /**
	     * lodash (Custom Build) <https://lodash.com/>
	     * Build: `lodash modularize exports="npm" -o ./`
	     * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	     * Released under MIT license <https://lodash.com/license>
	     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	     */

	    /** Used as the `TypeError` message for "Functions" methods. */
	    var FUNC_ERROR_TEXT = 'Expected a function';

	    /** Used to stand-in for `undefined` hash values. */
	    var HASH_UNDEFINED = '__lodash_hash_undefined__';

	    /** Used as references for various `Number` constants. */
	    var INFINITY = 1 / 0;

	    /** `Object#toString` result references. */
	    var funcTag = '[object Function]',
	        genTag = '[object GeneratorFunction]',
	        symbolTag = '[object Symbol]';

	    /** Used to match property names within property paths. */
	    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	        reIsPlainProp = /^\w*$/,
	        reLeadingDot = /^\./,
	        rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	    /**
	     * Used to match `RegExp`
	     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	     */
	    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	    /** Used to match backslashes in property paths. */
	    var reEscapeChar = /\\(\\)?/g;

	    /** Used to detect host constructors (Safari). */
	    var reIsHostCtor = /^\[object .+?Constructor\]$/;

	    /** Detect free variable `global` from Node.js. */
	    var freeGlobal = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

	    /** Detect free variable `self`. */
	    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	    /** Used as a reference to the global object. */
	    var root = freeGlobal || freeSelf || Function('return this')();

	    /**
	     * Gets the value at `key` of `object`.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function getValue(object, key) {
	      return object == null ? undefined : object[key];
	    }

	    /**
	     * Checks if `value` is a host object in IE < 9.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	     */
	    function isHostObject(value) {
	      // Many host objects are `Object` objects that can coerce to strings
	      // despite having improperly defined `toString` methods.
	      var result = false;
	      if (value != null && typeof value.toString != 'function') {
	        try {
	          result = !!(value + '');
	        } catch (e) {}
	      }
	      return result;
	    }

	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = root['__core-js_shared__'];

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Built-in value references. */
	    var Symbol$1 = root.Symbol,
	        splice = arrayProto.splice;

	    /* Built-in method references that are verified to be native. */
	    var Map$1 = getNative(root, 'Map'),
	        nativeCreate = getNative(Object, 'create');

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }

	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	    }

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      return index < 0 ? undefined : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map$1 || ListCache),
	        'string': new Hash
	      };
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      return getMapData(this, key)['delete'](key);
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      getMapData(this, key).set(key, value);
	      return this;
	    }

	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      string = toString$1(string);

	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }

	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8-9 which returns 'object' for typed array and other constructors.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString$1(value) {
	      return value == null ? '' : baseToString(value);
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }

	    var lodash_get = get;

	    class NumberGridFilterComponent {
	      init(params) {
	        this.column = params.column.colDef.printOSColumn;
	        this.agParams = params;
	        this.filterContainer = document.createElement('div');
	        this.filterContainer.classList.add('pros-grid-filter-container');
	        this.gridFilter = new NumberGridFilter({
	          target: this.filterContainer,
	          props: {
	            params: params,
	            step: lodash_get(this.column, "number.step", 1),
	            min: lodash_get(this.column, "number.min", 0),
	            max: lodash_get(this.column, "number.max", undefined)
	          }
	        });
	        this.filter = undefined;
	        this.gridFilter.$on('changed', event => {
	          setTimeout(() => {
	            this.filter = event.detail;
	            this.agParams.filterChangedCallback();
	          }, 10);
	        });
	      }
	      getGui() {
	        return this.filterContainer;
	      }
	      isFilterActive() {
	        return this.filter && this.filter.conditions.length > 0;
	      }
	      getModel() {
	        if (!this.filter) {
	          return null;
	        }
	        return this.filter;
	      }
	      setModel(filter) {
	        this.gridFilter.setFilter(filter);
	      }
	      doesFilterPass(params) {
	        if (!this.filter) {
	          return true;
	        }
	        let value = columns.getValue(this.column, params.data, params);
	        let result1 = this.checkCondition(this.filter.conditions[0], value);
	        if (this.filter.conditions.length === 1) {
	          return result1;
	        }
	        let result2 = this.checkCondition(this.filter.conditions[1], value);
	        switch (this.filter.operator) {
	          case 'OR':
	            return result1 || result2;
	          case 'AND':
	            return result1 && result2;
	          default:
	            // OR
	            return result1 || result2;
	        }
	      }
	      checkCondition(condition, value) {
	        let testA = Number(condition.filterA);
	        let testB = Number(condition.filterB);
	        switch (condition.type) {
	          case 'equals':
	            return value === testA;
	          case 'notEqual':
	            return value !== testA;
	          case 'lessThan':
	            return value < testA;
	          case 'lessOrEqual':
	            return value <= testA;
	          case 'greaterThan':
	            return value > testA;
	          case 'greaterOrEqual':
	            return value >= testA;
	          case 'betweenExclusive':
	            if (testA < testB) return value > testA && value < testB;
	            if (testB < testA) return value > testB && value < testA;
	            return false;
	          case 'betweenInclusive':
	            if (testA < testB) return value >= testA && value <= testB;
	            if (testB < testA) return value >= testB && value <= testA;
	            return value === testA;
	          case 'isEmpty':
	            return value === null || value === undefined;
	          case 'isNotEmpty':
	            return value !== null && value !== undefined;
	          default:
	            // equal
	            return value === testA;
	        }
	      }
	      destroy() {
	        this.gridFilter.$destroy();
	      }
	    }

	    /* src/filters/BooleanGridFilter.svelte generated by Svelte v3.38.2 */
	    function add_css$6() {
	      var style = element$1("style");
	      style.id = "svelte-1uz0c9x-style";
	      style.textContent = ".pros-boolean-grid-filter{display:flex;flex-direction:column;padding:16px;width:300px}";
	      append$1(document.head, style);
	    }
	    function create_fragment$6(ctx) {
	      let div1;
	      let div0;
	      let radiobuttongroup;
	      let updating_value;
	      let updating_options;
	      let current;
	      function radiobuttongroup_value_binding(value) {
	        /*radiobuttongroup_value_binding*/ctx[7](value);
	      }
	      function radiobuttongroup_options_binding(value) {
	        /*radiobuttongroup_options_binding*/ctx[8](value);
	      }
	      let radiobuttongroup_props = {
	        id: /*_radioId*/ctx[3],
	        theme: /*params*/ctx[2].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filterValue*/ctx[1] !== void 0) {
	        radiobuttongroup_props.value = /*filterValue*/ctx[1];
	      }
	      if (/*options*/ctx[0] !== void 0) {
	        radiobuttongroup_props.options = /*options*/ctx[0];
	      }
	      radiobuttongroup = new RadioButtonGroup({
	        props: radiobuttongroup_props
	      });
	      binding_callbacks$1.push(() => bind$1(radiobuttongroup, "value", radiobuttongroup_value_binding));
	      binding_callbacks$1.push(() => bind$1(radiobuttongroup, "options", radiobuttongroup_options_binding));
	      radiobuttongroup.$on("changed", /*handleFilterChanged*/ctx[4]);
	      return {
	        c() {
	          div1 = element$1("div");
	          div0 = element$1("div");
	          create_component$1(radiobuttongroup.$$.fragment);
	          attr$1(div0, "class", "pros-condition-container");
	          attr$1(div1, "class", "pros-boolean-grid-filter");
	        },
	        m(target, anchor) {
	          insert$1(target, div1, anchor);
	          append$1(div1, div0);
	          mount_component$1(radiobuttongroup, div0, null);
	          current = true;
	        },
	        p(ctx, [dirty]) {
	          const radiobuttongroup_changes = {};
	          if (dirty & /*_radioId*/8) radiobuttongroup_changes.id = /*_radioId*/ctx[3];
	          if (dirty & /*params*/4) radiobuttongroup_changes.theme = /*params*/ctx[2].colDef.gridParams.theme;
	          if (!updating_value && dirty & /*filterValue*/2) {
	            updating_value = true;
	            radiobuttongroup_changes.value = /*filterValue*/ctx[1];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          if (!updating_options && dirty & /*options*/1) {
	            updating_options = true;
	            radiobuttongroup_changes.options = /*options*/ctx[0];
	            add_flush_callback$1(() => updating_options = false);
	          }
	          radiobuttongroup.$set(radiobuttongroup_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(radiobuttongroup.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(radiobuttongroup.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div1);
	          destroy_component$1(radiobuttongroup);
	        }
	      };
	    }
	    function instance$6($$self, $$props, $$invalidate) {
	      const dispatch = createEventDispatcher$1();
	      const NO_FILTER = "PROS_NO_FILTER";
	      let {
	        params
	      } = $$props;
	      let {
	        options = []
	      } = $$props;
	      let {
	        filterValue = NO_FILTER
	      } = $$props;
	      let _gridId = null;
	      let _colId = null;
	      let _radioId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        _colId = get$1(params, "column.colDef.colId");
	        $$invalidate(3, _radioId = _gridId ? `${_gridId}-${_colId}-boolean-filter-options` : undefined);
	      });

	      // onCreate
	      onMount$1(() => {
	        let column = get$1(params, "colDef.printOSColumn");
	        let display = get$1(column, "boolean.display", "yes");
	        let myOptions = [{
	          display: column.translateInternal("Boolean_NoFilter"),
	          value: NO_FILTER
	        }];
	        switch (display) {
	          case "yes":
	            myOptions.push({
	              display: column.translateInternal("BooleanYes"),
	              value: true
	            });
	            myOptions.push({
	              display: column.translateInternal("BooleanNo"),
	              value: false
	            });
	            break;
	          case "enabled":
	            myOptions.push({
	              display: column.translateInternal("BooleanEnabled"),
	              value: true
	            });
	            myOptions.push({
	              display: column.translateInternal("BooleanDisabled"),
	              value: false
	            });
	            break;
	          case "true":
	            myOptions.push({
	              display: column.translateInternal("BooleanTrue"),
	              value: true
	            });
	            myOptions.push({
	              display: column.translateInternal("BooleanFalse"),
	              value: false
	            });
	            break;
	          case "active":
	            myOptions.push({
	              display: column.translateInternal("BooleanActive"),
	              value: true
	            });
	            myOptions.push({
	              display: column.translateInternal("BooleanInactive"),
	              value: false
	            });
	            break;
	          case "ok":
	            myOptions.push({
	              display: column.translateInternal("BooleanOk"),
	              value: true
	            });
	            myOptions.push({
	              display: column.translateInternal("BooleanError"),
	              value: false
	            });
	            break;
	          case "locked":
	            myOptions.push({
	              display: column.translateInternal("BooleanLocked"),
	              value: true
	            });
	            myOptions.push({
	              display: column.translateInternal("BooleanUnlocked"),
	              value: false
	            });
	            break;
	          case "custom":
	            column.boolean.values.forEach(v => {
	              if (get$1(v, "text.key")) {
	                myOptions.push({
	                  display: column.translateExternal(v.text.key),
	                  value: v.value
	                });
	              }
	            });
	            break;
	        }
	        $$invalidate(0, options = myOptions);
	      });
	      function setFilter(filter) {
	        if (filter === null) {
	          $$invalidate(1, filterValue = NO_FILTER);
	        } else {
	          $$invalidate(1, filterValue = filter.value);
	        }
	        handleFilterChanged();
	      }
	      function handleFilterChanged() {
	        let filter = null;
	        if (filterValue !== NO_FILTER) {
	          let option = options.find(o => {
	            return o.value === filterValue;
	          });
	          filter = {
	            type: "boolean",
	            value: filterValue,
	            display: option.display
	          };
	        }
	        dispatch("changed", filter);
	      }
	      function radiobuttongroup_value_binding(value) {
	        filterValue = value;
	        $$invalidate(1, filterValue);
	      }
	      function radiobuttongroup_options_binding(value) {
	        options = value;
	        $$invalidate(0, options);
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(2, params = $$props.params);
	        if ("options" in $$props) $$invalidate(0, options = $$props.options);
	        if ("filterValue" in $$props) $$invalidate(1, filterValue = $$props.filterValue);
	      };
	      return [options, filterValue, params, _radioId, handleFilterChanged, NO_FILTER, setFilter, radiobuttongroup_value_binding, radiobuttongroup_options_binding];
	    }
	    class BooleanGridFilter extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-1uz0c9x-style")) add_css$6();
	        init$1(this, options, instance$6, create_fragment$6, safe_not_equal$1, {
	          NO_FILTER: 5,
	          params: 2,
	          options: 0,
	          filterValue: 1,
	          setFilter: 6
	        });
	      }
	      get NO_FILTER() {
	        return this.$$.ctx[5];
	      }
	      get setFilter() {
	        return this.$$.ctx[6];
	      }
	    }

	    class BooleanGridFilterComponent {
	      init(params) {
	        this.column = params.colDef.printOSColumn;
	        this.agParams = params;
	        this.filterContainer = document.createElement('div');
	        this.filterContainer.classList.add('pros-grid-filter-container');
	        this.filter = BooleanGridFilter.NO_FILTER;
	        this.gridFilter = new BooleanGridFilter({
	          target: this.filterContainer,
	          props: {
	            params: params,
	            filterValue: this.filter
	          }
	        });
	        this.gridFilter.$on('changed', event => {
	          setTimeout(() => {
	            this.filter = event.detail;
	            this.agParams.filterChangedCallback();
	          }, 10);
	        });
	      }
	      getGui() {
	        return this.filterContainer;
	      }
	      isFilterActive() {
	        return this.filter !== null;
	      }
	      getModel() {
	        return this.filter;
	      }
	      setModel(filter) {
	        if (!filter) {
	          this.filter = null;
	        } else {
	          this.filter = filter;
	        }
	        this.gridFilter.setFilter(this.filter);
	      }
	      doesFilterPass(params) {
	        if (this.filter === null) {
	          return true;
	        }
	        let value = columns.getValue(this.column, params.data, params);
	        return value === this.filter.value;
	      }
	      destroy() {
	        this.gridFilter.$destroy();
	      }
	    }

	    /* src/filters/EnumGridFilter.svelte generated by Svelte v3.38.2 */
	    function add_css$5() {
	      var style = element$1("style");
	      style.id = "svelte-yorq0y-style";
	      style.textContent = ".pros-enum-grid-filter{display:flex;flex-direction:column;padding:16px;width:300px;max-height:300px}.pros-enum-grid-filter .pros-options-container{flex:1;overflow:auto}.pros-enum-grid-filter .select-row{display:flex;justify-content:center;align-items:center;margin-top:16px}.pros-enum-grid-filter .select-row else{flex-direction:row}.pros-enum-grid-filter .select-row .spacer{flex:1}.pros-enum-grid-filter .select-row .select-item{font-size:10px;cursor:pointer}.pros-enum-grid-filter .select-row .select-item:hover{text-decoration:underline}.pros-enum-grid-filter .pros-control-container{margin-bottom:8px}.pros-enum-grid-filter .pros-control-container:last-of-type{margin-bottom:0}";
	      append$1(document.head, style);
	    }
	    function get_each_context$1(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[16] = list[i];
	      child_ctx[17] = list;
	      child_ctx[18] = i;
	      return child_ctx;
	    }

	    // (2:2) {#if !loading}
	    function create_if_block$4(ctx) {
	      let div0;
	      let t0;
	      let div4;
	      let div1;
	      let t1_value = /*_t*/ctx[1]("SelectAll") + "";
	      let t1;
	      let t2;
	      let div2;
	      let t3;
	      let div3;
	      let t4_value = /*_t*/ctx[1]("SelectNone") + "";
	      let t4;
	      let current;
	      let mounted;
	      let dispose;
	      let each_value = /*options*/ctx[0];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
	      }
	      const out = i => transition_out$1(each_blocks[i], 1, 1, () => {
	        each_blocks[i] = null;
	      });
	      return {
	        c() {
	          div0 = element$1("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          t0 = space$1();
	          div4 = element$1("div");
	          div1 = element$1("div");
	          t1 = text$1(t1_value);
	          t2 = space$1();
	          div2 = element$1("div");
	          t3 = space$1();
	          div3 = element$1("div");
	          t4 = text$1(t4_value);
	          attr$1(div0, "class", "pros-options-container");
	          attr$1(div1, "class", "select-item");
	          attr$1(div2, "class", "spacer");
	          attr$1(div3, "class", "select-item");
	          attr$1(div4, "class", "select-row");
	        },
	        m(target, anchor) {
	          insert$1(target, div0, anchor);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div0, null);
	          }
	          insert$1(target, t0, anchor);
	          insert$1(target, div4, anchor);
	          append$1(div4, div1);
	          append$1(div1, t1);
	          append$1(div4, t2);
	          append$1(div4, div2);
	          append$1(div4, t3);
	          append$1(div4, div3);
	          append$1(div3, t4);
	          current = true;
	          if (!mounted) {
	            dispose = [listen$1(div1, "click", /*handleSelectAll*/ctx[6]), listen$1(div3, "click", /*handleClearAll*/ctx[7])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty & /*_optionId, options, params, handleFilterChanged*/57) {
	            each_value = /*options*/ctx[0];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context$1(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	                transition_in$1(each_blocks[i], 1);
	              } else {
	                each_blocks[i] = create_each_block$1(child_ctx);
	                each_blocks[i].c();
	                transition_in$1(each_blocks[i], 1);
	                each_blocks[i].m(div0, null);
	              }
	            }
	            group_outros$1();
	            for (i = each_value.length; i < each_blocks.length; i += 1) {
	              out(i);
	            }
	            check_outros$1();
	          }
	          if ((!current || dirty & /*_t*/2) && t1_value !== (t1_value = /*_t*/ctx[1]("SelectAll") + "")) set_data$1(t1, t1_value);
	          if ((!current || dirty & /*_t*/2) && t4_value !== (t4_value = /*_t*/ctx[1]("SelectNone") + "")) set_data$1(t4, t4_value);
	        },
	        i(local) {
	          if (current) return;
	          for (let i = 0; i < each_value.length; i += 1) {
	            transition_in$1(each_blocks[i]);
	          }
	          current = true;
	        },
	        o(local) {
	          each_blocks = each_blocks.filter(Boolean);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            transition_out$1(each_blocks[i]);
	          }
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div0);
	          destroy_each$1(each_blocks, detaching);
	          if (detaching) detach$1(t0);
	          if (detaching) detach$1(div4);
	          mounted = false;
	          run_all$1(dispose);
	        }
	      };
	    }

	    // (4:4) {#each options as option}
	    function create_each_block$1(ctx) {
	      let div;
	      let checkbox;
	      let updating_label;
	      let updating_value;
	      let t;
	      let current;
	      function checkbox_label_binding(value) {
	        /*checkbox_label_binding*/ctx[9](value, /*option*/ctx[16]);
	      }
	      function checkbox_value_binding(value) {
	        /*checkbox_value_binding*/ctx[10](value, /*option*/ctx[16]);
	      }
	      let checkbox_props = {
	        id: "" + (/*_optionId*/ctx[4] + "-$" + /*option*/ctx[16].id),
	        theme: /*params*/ctx[3].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*option*/ctx[16].display !== void 0) {
	        checkbox_props.label = /*option*/ctx[16].display;
	      }
	      if (/*option*/ctx[16].selected !== void 0) {
	        checkbox_props.value = /*option*/ctx[16].selected;
	      }
	      checkbox = new CheckBox({
	        props: checkbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(checkbox, "label", checkbox_label_binding));
	      binding_callbacks$1.push(() => bind$1(checkbox, "value", checkbox_value_binding));
	      checkbox.$on("changed", /*handleFilterChanged*/ctx[5]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(checkbox.$$.fragment);
	          t = space$1();
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(checkbox, div, null);
	          append$1(div, t);
	          current = true;
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          const checkbox_changes = {};
	          if (dirty & /*_optionId, options*/17) checkbox_changes.id = "" + (/*_optionId*/ctx[4] + "-$" + /*option*/ctx[16].id);
	          if (dirty & /*params*/8) checkbox_changes.theme = /*params*/ctx[3].colDef.gridParams.theme;
	          if (!updating_label && dirty & /*options*/1) {
	            updating_label = true;
	            checkbox_changes.label = /*option*/ctx[16].display;
	            add_flush_callback$1(() => updating_label = false);
	          }
	          if (!updating_value && dirty & /*options*/1) {
	            updating_value = true;
	            checkbox_changes.value = /*option*/ctx[16].selected;
	            add_flush_callback$1(() => updating_value = false);
	          }
	          checkbox.$set(checkbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(checkbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(checkbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(checkbox);
	        }
	      };
	    }
	    function create_fragment$5(ctx) {
	      let div;
	      let current;
	      let if_block = ! /*loading*/ctx[2] && create_if_block$4(ctx);
	      return {
	        c() {
	          div = element$1("div");
	          if (if_block) if_block.c();
	          attr$1(div, "class", "pros-enum-grid-filter");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          if (if_block) if_block.m(div, null);
	          current = true;
	        },
	        p(ctx, [dirty]) {
	          if (! /*loading*/ctx[2]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	              if (dirty & /*loading*/4) {
	                transition_in$1(if_block, 1);
	              }
	            } else {
	              if_block = create_if_block$4(ctx);
	              if_block.c();
	              transition_in$1(if_block, 1);
	              if_block.m(div, null);
	            }
	          } else if (if_block) {
	            group_outros$1();
	            transition_out$1(if_block, 1, 1, () => {
	              if_block = null;
	            });
	            check_outros$1();
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          if (if_block) if_block.d();
	        }
	      };
	    }
	    function instance$5($$self, $$props, $$invalidate) {
	      const dispatch = createEventDispatcher$1();
	      let {
	        params
	      } = $$props;
	      let {
	        options = []
	      } = $$props;
	      let {
	        _t
	      } = $$props;
	      let {
	        loading = true
	      } = $$props;
	      let _gridId = null;
	      let _colId = null;
	      let _optionId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        _colId = get$1(params, "column.colDef.colId");
	        $$invalidate(4, _optionId = _gridId ? `${_gridId}-${_colId}-option` : undefined);
	      });

	      // onCreate
	      onMount$1(() => {
	        initOptions();
	        $$invalidate(2, loading = false);
	      });
	      function setFilter(filter) {
	        initOptions();
	        if (!filter) {
	          options.forEach(option => {
	            option.selected = false;
	          });
	        } else {
	          options.forEach(option => {
	            let found = filter.selected.find(s => {
	              return s.value === option.value;
	            });
	            option.selected = found ? true : false;
	          });
	        }
	        handleFilterChanged();
	      }
	      function initOptions() {
	        let column = get$1(params, "colDef.printOSColumn");
	        $$invalidate(1, _t = column.translateInternal);
	        let enumValues = get$1(column, "enum.values");
	        let columnCategory = get$1(params, "colDef.gridCallbacks.columns", {});
	        let columnCallbacks = columnCategory[column.id];
	        let valueCallback = get$1(columnCallbacks, "enum.values");
	        if (valueCallback) {
	          let test = valueCallback();
	          if (test && Array.isArray(test)) {
	            test = test.sort((a, b) => {
	              return a.value.toLocaleLowerCase().localeCompare(b.value.toLocaleLowerCase());
	            });
	            enumValues = test;
	          }
	        }
	        $$invalidate(0, options = []);
	        enumValues.forEach(ev => {
	          options.push({
	            value: ev.value,
	            display: columns.getTextFromDefinition(ev.value, ev.text, column.translateExternal),
	            selected: false
	          });
	        });
	      }
	      function handleFilterChanged() {
	        let selected = [];
	        options.forEach(option => {
	          if (option.selected) {
	            selected.push({
	              value: option.value,
	              display: option.display
	            });
	          }
	        });
	        let filter;
	        if (selected.length > 0) {
	          filter = {
	            type: "enum",
	            selected
	          };
	        }
	        dispatch("changed", filter);
	      }
	      function handleSelectAll() {
	        toggleAll(true);
	      }
	      function handleClearAll() {
	        toggleAll(false);
	      }
	      function toggleAll(selected) {
	        options.forEach(option => {
	          option.selected = selected;
	        });
	        $$invalidate(0, options = [...options]);
	        handleFilterChanged();
	      }
	      function checkbox_label_binding(value, option) {
	        if ($$self.$$.not_equal(option.display, value)) {
	          option.display = value;
	          $$invalidate(0, options);
	        }
	      }
	      function checkbox_value_binding(value, option) {
	        if ($$self.$$.not_equal(option.selected, value)) {
	          option.selected = value;
	          $$invalidate(0, options);
	        }
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(3, params = $$props.params);
	        if ("options" in $$props) $$invalidate(0, options = $$props.options);
	        if ("_t" in $$props) $$invalidate(1, _t = $$props._t);
	        if ("loading" in $$props) $$invalidate(2, loading = $$props.loading);
	      };
	      return [options, _t, loading, params, _optionId, handleFilterChanged, handleSelectAll, handleClearAll, setFilter, checkbox_label_binding, checkbox_value_binding];
	    }
	    class EnumGridFilter extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-yorq0y-style")) add_css$5();
	        init$1(this, options, instance$5, create_fragment$5, safe_not_equal$1, {
	          params: 3,
	          options: 0,
	          _t: 1,
	          loading: 2,
	          setFilter: 8
	        });
	      }
	      get setFilter() {
	        return this.$$.ctx[8];
	      }
	    }

	    class EnumGridFilterComponent {
	      init(params) {
	        this.column = params.column.colDef.printOSColumn;
	        this.agParams = params;
	        this.filterContainer = document.createElement('div');
	        this.filterContainer.classList.add('pros-grid-filter-container');
	        this.gridFilter = new EnumGridFilter({
	          target: this.filterContainer,
	          props: {
	            params: params
	          }
	        });
	        this.filter = undefined;
	        this.gridFilter.$on('changed', event => {
	          setTimeout(() => {
	            this.filter = event.detail;
	            this.agParams.filterChangedCallback();
	          }, 10);
	        });
	      }
	      getGui() {
	        return this.filterContainer;
	      }
	      isFilterActive() {
	        return this.filter && this.filter.selected.length > 0;
	      }
	      getModel() {
	        if (!this.filter) {
	          return null;
	        }
	        return this.filter;
	      }
	      setModel(filter) {
	        this.filter = filter;
	        this.gridFilter.setFilter(filter);
	      }
	      doesFilterPass(params) {
	        if (!this.filter) {
	          return true;
	        }
	        let value = columns.getValue(this.column, params.data, params);
	        // let isList = get(column, 'enum.list', false);
	        let isList = get$1(this.column, 'enum.list', false);
	        let result = false;
	        if (isList) {
	          if (value && !Array.isArray(value)) {
	            value = [value];
	          }
	          if (!value) {
	            result = false;
	          } else {
	            for (let i = 0; i < this.filter.selected.length; i++) {
	              if (value.includes(this.filter.selected[i].value)) {
	                result = true;
	                break;
	              }
	            }
	          }
	        } else {
	          for (let i = 0; i < this.filter.selected.length; i++) {
	            if (value === this.filter.selected[i].value) {
	              result = true;
	              break;
	            }
	          }
	        }
	        return result;
	      }
	      destroy() {
	        this.gridFilter.$destroy();
	      }
	    }

	    /* src/filters/DateGridFilter.svelte generated by Svelte v3.38.2 */
	    function add_css$4() {
	      var style = element$1("style");
	      style.id = "svelte-nzbi37-style";
	      style.textContent = ".pros-date-grid-filter{display:flex;flex-direction:column;padding:16px;width:300px}.pros-date-grid-filter .pros-toggle-container{margin:8px 0;height:48px;display:flex;justify-content:flex-start;align-items:center}.pros-date-grid-filter .pros-toggle-container else{flex-direction:row}.pros-date-grid-filter .pros-toggle-container.hide{display:none}.pros-date-grid-filter .pros-toggle-container .blank{flex:1;border-radius:12px;border:1px solid #F3F3F3}.pros-date-grid-filter .pros-toggle-container .pros-button{display:flex;flex-direction:column;justify-content:center;align-items:center;height:48px;width:48px;margin-right:8px;font-size:30px;border-radius:8px;border:1px solid #F3F3F3}.pros-date-grid-filter .pros-toggle-container .pros-button svg{transition:transform 0.5s ease 0s}.pros-date-grid-filter .pros-toggle-container .pros-button.open svg{transition:transform 0.5s ease 0s;transform:rotate(-180deg)}.pros-date-grid-filter .pros-toggle-container .pros-operator-container{flex:1}.pros-date-grid-filter .pros-control-container{margin-bottom:8px}.pros-date-grid-filter .pros-control-container:last-of-type{margin-bottom:0}.pros-date-grid-filter .pros-condition-container{display:flex;flex-direction:column}.pros-date-grid-filter .pros-condition-container.option2{display:none}.pros-date-grid-filter .pros-condition-container.option2.expanded{display:inherit}";
	      append$1(document.head, style);
	    }

	    // (14:4) {#if type1 !== 'isEmpty' && type1 !== 'isNotEmpty'}
	    function create_if_block_4$1(ctx) {
	      let div;
	      let datepicker;
	      let updating_value;
	      let current;
	      function datepicker_value_binding(value) {
	        /*datepicker_value_binding*/ctx[24](value);
	      }
	      let datepicker_props = {
	        id: /*_date1aId*/ctx[13],
	        theme: /*params*/ctx[10].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter1a*/ctx[1] !== void 0) {
	        datepicker_props.value = /*filter1a*/ctx[1];
	      }
	      datepicker = new DatePicker({
	        props: datepicker_props
	      });
	      binding_callbacks$1.push(() => bind$1(datepicker, "value", datepicker_value_binding));
	      datepicker.$on("changed", /*handleFilterChanged*/ctx[19]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(datepicker.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(datepicker, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const datepicker_changes = {};
	          if (dirty[0] & /*_date1aId*/8192) datepicker_changes.id = /*_date1aId*/ctx[13];
	          if (dirty[0] & /*params*/1024) datepicker_changes.theme = /*params*/ctx[10].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter1a*/2) {
	            updating_value = true;
	            datepicker_changes.value = /*filter1a*/ctx[1];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          datepicker.$set(datepicker_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(datepicker.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(datepicker.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(datepicker);
	        }
	      };
	    }

	    // (26:4) {#if type1 === 'betweenInclusive' || type1 === 'betweenExclusive'}
	    function create_if_block_3$1(ctx) {
	      let div;
	      let datepicker;
	      let updating_value;
	      let current;
	      function datepicker_value_binding_1(value) {
	        /*datepicker_value_binding_1*/ctx[25](value);
	      }
	      let datepicker_props = {
	        id: /*_date1bId*/ctx[14],
	        theme: /*params*/ctx[10].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter1b*/ctx[2] !== void 0) {
	        datepicker_props.value = /*filter1b*/ctx[2];
	      }
	      datepicker = new DatePicker({
	        props: datepicker_props
	      });
	      binding_callbacks$1.push(() => bind$1(datepicker, "value", datepicker_value_binding_1));
	      datepicker.$on("changed", /*handleFilterChanged*/ctx[19]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(datepicker.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(datepicker, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const datepicker_changes = {};
	          if (dirty[0] & /*_date1bId*/16384) datepicker_changes.id = /*_date1bId*/ctx[14];
	          if (dirty[0] & /*params*/1024) datepicker_changes.theme = /*params*/ctx[10].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter1b*/4) {
	            updating_value = true;
	            datepicker_changes.value = /*filter1b*/ctx[2];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          datepicker.$set(datepicker_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(datepicker.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(datepicker.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(datepicker);
	        }
	      };
	    }

	    // (57:4) {:else}
	    function create_else_block$1(ctx) {
	      let div;
	      return {
	        c() {
	          div = element$1("div");
	          attr$1(div, "class", "blank");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	        },
	        p: noop$1,
	        i: noop$1,
	        o: noop$1,
	        d(detaching) {
	          if (detaching) detach$1(div);
	        }
	      };
	    }

	    // (46:4) {#if showOperator}
	    function create_if_block_2$2(ctx) {
	      let div;
	      let selectbox;
	      let updating_options;
	      let updating_value;
	      let current;
	      function selectbox_options_binding(value) {
	        /*selectbox_options_binding*/ctx[26](value);
	      }
	      function selectbox_value_binding(value) {
	        /*selectbox_value_binding*/ctx[27](value);
	      }
	      let selectbox_props = {
	        id: /*_select2Id*/ctx[12],
	        theme: /*params*/ctx[10].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*operatorOptions*/ctx[8] !== void 0) {
	        selectbox_props.options = /*operatorOptions*/ctx[8];
	      }
	      if (/*operator*/ctx[9] !== void 0) {
	        selectbox_props.value = /*operator*/ctx[9];
	      }
	      selectbox = new SelectBox({
	        props: selectbox_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox, "options", selectbox_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox, "value", selectbox_value_binding));
	      selectbox.$on("changed", /*handleFilterChanged*/ctx[19]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(selectbox.$$.fragment);
	          attr$1(div, "class", "pros-operator-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(selectbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const selectbox_changes = {};
	          if (dirty[0] & /*_select2Id*/4096) selectbox_changes.id = /*_select2Id*/ctx[12];
	          if (dirty[0] & /*params*/1024) selectbox_changes.theme = /*params*/ctx[10].colDef.gridParams.theme;
	          if (!updating_options && dirty[0] & /*operatorOptions*/256) {
	            updating_options = true;
	            selectbox_changes.options = /*operatorOptions*/ctx[8];
	            add_flush_callback$1(() => updating_options = false);
	          }
	          if (!updating_value && dirty[0] & /*operator*/512) {
	            updating_value = true;
	            selectbox_changes.value = /*operator*/ctx[9];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          selectbox.$set(selectbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(selectbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(selectbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(selectbox);
	        }
	      };
	    }

	    // (74:4) {#if type2 !== 'isEmpty' && type2 !== 'isNotEmpty'}
	    function create_if_block_1$2(ctx) {
	      let div;
	      let datepicker;
	      let updating_value;
	      let current;
	      function datepicker_value_binding_2(value) {
	        /*datepicker_value_binding_2*/ctx[30](value);
	      }
	      let datepicker_props = {
	        id: /*_date2aId*/ctx[15],
	        theme: /*params*/ctx[10].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter2a*/ctx[4] !== void 0) {
	        datepicker_props.value = /*filter2a*/ctx[4];
	      }
	      datepicker = new DatePicker({
	        props: datepicker_props
	      });
	      binding_callbacks$1.push(() => bind$1(datepicker, "value", datepicker_value_binding_2));
	      datepicker.$on("changed", /*handleFilterChanged*/ctx[19]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(datepicker.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(datepicker, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const datepicker_changes = {};
	          if (dirty[0] & /*_date2aId*/32768) datepicker_changes.id = /*_date2aId*/ctx[15];
	          if (dirty[0] & /*params*/1024) datepicker_changes.theme = /*params*/ctx[10].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter2a*/16) {
	            updating_value = true;
	            datepicker_changes.value = /*filter2a*/ctx[4];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          datepicker.$set(datepicker_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(datepicker.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(datepicker.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(datepicker);
	        }
	      };
	    }

	    // (86:4) {#if type1 === 'betweenInclusive' || type1 === 'betweenExclusive'}
	    function create_if_block$3(ctx) {
	      let div;
	      let datepicker;
	      let updating_value;
	      let current;
	      function datepicker_value_binding_3(value) {
	        /*datepicker_value_binding_3*/ctx[31](value);
	      }
	      let datepicker_props = {
	        id: /*_date2bId*/ctx[16],
	        theme: /*params*/ctx[10].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*filter2b*/ctx[5] !== void 0) {
	        datepicker_props.value = /*filter2b*/ctx[5];
	      }
	      datepicker = new DatePicker({
	        props: datepicker_props
	      });
	      binding_callbacks$1.push(() => bind$1(datepicker, "value", datepicker_value_binding_3));
	      datepicker.$on("changed", /*handleFilterChanged*/ctx[19]);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(datepicker.$$.fragment);
	          attr$1(div, "class", "pros-control-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(datepicker, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const datepicker_changes = {};
	          if (dirty[0] & /*_date2bId*/65536) datepicker_changes.id = /*_date2bId*/ctx[16];
	          if (dirty[0] & /*params*/1024) datepicker_changes.theme = /*params*/ctx[10].colDef.gridParams.theme;
	          if (!updating_value && dirty[0] & /*filter2b*/32) {
	            updating_value = true;
	            datepicker_changes.value = /*filter2b*/ctx[5];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          datepicker.$set(datepicker_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(datepicker.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(datepicker.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(datepicker);
	        }
	      };
	    }
	    function create_fragment$4(ctx) {
	      let div6;
	      let div1;
	      let div0;
	      let selectbox0;
	      let updating_options;
	      let updating_value;
	      let t0;
	      let t1;
	      let t2;
	      let div3;
	      let div2;
	      let t3;
	      let current_block_type_index;
	      let if_block2;
	      let t4;
	      let div5;
	      let div4;
	      let selectbox1;
	      let updating_options_1;
	      let updating_value_1;
	      let t5;
	      let t6;
	      let current;
	      let mounted;
	      let dispose;
	      function selectbox0_options_binding(value) {
	        /*selectbox0_options_binding*/ctx[22](value);
	      }
	      function selectbox0_value_binding(value) {
	        /*selectbox0_value_binding*/ctx[23](value);
	      }
	      let selectbox0_props = {
	        id: /*_select1Id*/ctx[11],
	        theme: /*params*/ctx[10].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*options*/ctx[7] !== void 0) {
	        selectbox0_props.options = /*options*/ctx[7];
	      }
	      if (/*type1*/ctx[0] !== void 0) {
	        selectbox0_props.value = /*type1*/ctx[0];
	      }
	      selectbox0 = new SelectBox({
	        props: selectbox0_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox0, "options", selectbox0_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox0, "value", selectbox0_value_binding));
	      selectbox0.$on("changed", /*handleFilterChanged*/ctx[19]);
	      let if_block0 = /*type1*/ctx[0] !== "isEmpty" && /*type1*/ctx[0] !== "isNotEmpty" && create_if_block_4$1(ctx);
	      let if_block1 = (/*type1*/ctx[0] === "betweenInclusive" || /*type1*/ctx[0] === "betweenExclusive") && create_if_block_3$1(ctx);
	      const if_block_creators = [create_if_block_2$2, create_else_block$1];
	      const if_blocks = [];
	      function select_block_type(ctx, dirty) {
	        if (/*showOperator*/ctx[6]) return 0;
	        return 1;
	      }
	      current_block_type_index = select_block_type(ctx);
	      if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      function selectbox1_options_binding(value) {
	        /*selectbox1_options_binding*/ctx[28](value);
	      }
	      function selectbox1_value_binding(value) {
	        /*selectbox1_value_binding*/ctx[29](value);
	      }
	      let selectbox1_props = {
	        id: /*_operatorId*/ctx[17],
	        theme: /*params*/ctx[10].colDef.gridParams.theme,
	        display: "custom"
	      };
	      if (/*options*/ctx[7] !== void 0) {
	        selectbox1_props.options = /*options*/ctx[7];
	      }
	      if (/*type2*/ctx[3] !== void 0) {
	        selectbox1_props.value = /*type2*/ctx[3];
	      }
	      selectbox1 = new SelectBox({
	        props: selectbox1_props
	      });
	      binding_callbacks$1.push(() => bind$1(selectbox1, "options", selectbox1_options_binding));
	      binding_callbacks$1.push(() => bind$1(selectbox1, "value", selectbox1_value_binding));
	      selectbox1.$on("changed", /*handleFilterChanged*/ctx[19]);
	      let if_block3 = /*type2*/ctx[3] !== "isEmpty" && /*type2*/ctx[3] !== "isNotEmpty" && create_if_block_1$2(ctx);
	      let if_block4 = (/*type1*/ctx[0] === "betweenInclusive" || /*type1*/ctx[0] === "betweenExclusive") && create_if_block$3(ctx);
	      return {
	        c() {
	          div6 = element$1("div");
	          div1 = element$1("div");
	          div0 = element$1("div");
	          create_component$1(selectbox0.$$.fragment);
	          t0 = space$1();
	          if (if_block0) if_block0.c();
	          t1 = space$1();
	          if (if_block1) if_block1.c();
	          t2 = space$1();
	          div3 = element$1("div");
	          div2 = element$1("div");
	          div2.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13 17C12.8721 17 12.7441 16.9512 12.6465 16.8535L4.64648 8.85352C4.45117 8.6582 4.45117 8.3418 4.64648 8.14648C4.8418 7.95117 5.1582 7.95117 5.35352 8.14648L13 15.793L20.6465 8.14648C20.8418 7.95117 21.1582 7.95117 21.3535 8.14648C21.5488 8.3418 21.5488 8.6582 21.3535 8.85352L13.3535 16.8535C13.2559 16.9512 13.1279 17 13 17Z"></path></svg>`;
	          t3 = space$1();
	          if_block2.c();
	          t4 = space$1();
	          div5 = element$1("div");
	          div4 = element$1("div");
	          create_component$1(selectbox1.$$.fragment);
	          t5 = space$1();
	          if (if_block3) if_block3.c();
	          t6 = space$1();
	          if (if_block4) if_block4.c();
	          attr$1(div0, "class", "pros-control-container");
	          attr$1(div1, "class", "pros-condition-container");
	          attr$1(div2, "class", "pros-button");
	          attr$1(div2, "type", "button");
	          toggle_class$1(div2, "open", /*showOperator*/ctx[6]);
	          attr$1(div3, "class", "pros-toggle-container");
	          toggle_class$1(div3, "hide", ! /*isFilter1Valid*/ctx[18]);
	          attr$1(div4, "class", "pros-control-container");
	          attr$1(div5, "class", "pros-condition-container option2");
	          toggle_class$1(div5, "expanded", /*showOperator*/ctx[6] && /*isFilter1Valid*/ctx[18]);
	          attr$1(div6, "class", "pros-date-grid-filter");
	        },
	        m(target, anchor) {
	          insert$1(target, div6, anchor);
	          append$1(div6, div1);
	          append$1(div1, div0);
	          mount_component$1(selectbox0, div0, null);
	          append$1(div1, t0);
	          if (if_block0) if_block0.m(div1, null);
	          append$1(div1, t1);
	          if (if_block1) if_block1.m(div1, null);
	          append$1(div6, t2);
	          append$1(div6, div3);
	          append$1(div3, div2);
	          append$1(div3, t3);
	          if_blocks[current_block_type_index].m(div3, null);
	          append$1(div6, t4);
	          append$1(div6, div5);
	          append$1(div5, div4);
	          mount_component$1(selectbox1, div4, null);
	          append$1(div5, t5);
	          if (if_block3) if_block3.m(div5, null);
	          append$1(div5, t6);
	          if (if_block4) if_block4.m(div5, null);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(div2, "click", /*toggleOperator*/ctx[20]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          const selectbox0_changes = {};
	          if (dirty[0] & /*_select1Id*/2048) selectbox0_changes.id = /*_select1Id*/ctx[11];
	          if (dirty[0] & /*params*/1024) selectbox0_changes.theme = /*params*/ctx[10].colDef.gridParams.theme;
	          if (!updating_options && dirty[0] & /*options*/128) {
	            updating_options = true;
	            selectbox0_changes.options = /*options*/ctx[7];
	            add_flush_callback$1(() => updating_options = false);
	          }
	          if (!updating_value && dirty[0] & /*type1*/1) {
	            updating_value = true;
	            selectbox0_changes.value = /*type1*/ctx[0];
	            add_flush_callback$1(() => updating_value = false);
	          }
	          selectbox0.$set(selectbox0_changes);
	          if (/*type1*/ctx[0] !== "isEmpty" && /*type1*/ctx[0] !== "isNotEmpty") {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	              if (dirty[0] & /*type1*/1) {
	                transition_in$1(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_4$1(ctx);
	              if_block0.c();
	              transition_in$1(if_block0, 1);
	              if_block0.m(div1, t1);
	            }
	          } else if (if_block0) {
	            group_outros$1();
	            transition_out$1(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros$1();
	          }
	          if (/*type1*/ctx[0] === "betweenInclusive" || /*type1*/ctx[0] === "betweenExclusive") {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty[0] & /*type1*/1) {
	                transition_in$1(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block_3$1(ctx);
	              if_block1.c();
	              transition_in$1(if_block1, 1);
	              if_block1.m(div1, null);
	            }
	          } else if (if_block1) {
	            group_outros$1();
	            transition_out$1(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros$1();
	          }
	          if (dirty[0] & /*showOperator*/64) {
	            toggle_class$1(div2, "open", /*showOperator*/ctx[6]);
	          }
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros$1();
	            transition_out$1(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros$1();
	            if_block2 = if_blocks[current_block_type_index];
	            if (!if_block2) {
	              if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block2.c();
	            } else {
	              if_block2.p(ctx, dirty);
	            }
	            transition_in$1(if_block2, 1);
	            if_block2.m(div3, null);
	          }
	          if (dirty[0] & /*isFilter1Valid*/262144) {
	            toggle_class$1(div3, "hide", ! /*isFilter1Valid*/ctx[18]);
	          }
	          const selectbox1_changes = {};
	          if (dirty[0] & /*_operatorId*/131072) selectbox1_changes.id = /*_operatorId*/ctx[17];
	          if (dirty[0] & /*params*/1024) selectbox1_changes.theme = /*params*/ctx[10].colDef.gridParams.theme;
	          if (!updating_options_1 && dirty[0] & /*options*/128) {
	            updating_options_1 = true;
	            selectbox1_changes.options = /*options*/ctx[7];
	            add_flush_callback$1(() => updating_options_1 = false);
	          }
	          if (!updating_value_1 && dirty[0] & /*type2*/8) {
	            updating_value_1 = true;
	            selectbox1_changes.value = /*type2*/ctx[3];
	            add_flush_callback$1(() => updating_value_1 = false);
	          }
	          selectbox1.$set(selectbox1_changes);
	          if (/*type2*/ctx[3] !== "isEmpty" && /*type2*/ctx[3] !== "isNotEmpty") {
	            if (if_block3) {
	              if_block3.p(ctx, dirty);
	              if (dirty[0] & /*type2*/8) {
	                transition_in$1(if_block3, 1);
	              }
	            } else {
	              if_block3 = create_if_block_1$2(ctx);
	              if_block3.c();
	              transition_in$1(if_block3, 1);
	              if_block3.m(div5, t6);
	            }
	          } else if (if_block3) {
	            group_outros$1();
	            transition_out$1(if_block3, 1, 1, () => {
	              if_block3 = null;
	            });
	            check_outros$1();
	          }
	          if (/*type1*/ctx[0] === "betweenInclusive" || /*type1*/ctx[0] === "betweenExclusive") {
	            if (if_block4) {
	              if_block4.p(ctx, dirty);
	              if (dirty[0] & /*type1*/1) {
	                transition_in$1(if_block4, 1);
	              }
	            } else {
	              if_block4 = create_if_block$3(ctx);
	              if_block4.c();
	              transition_in$1(if_block4, 1);
	              if_block4.m(div5, null);
	            }
	          } else if (if_block4) {
	            group_outros$1();
	            transition_out$1(if_block4, 1, 1, () => {
	              if_block4 = null;
	            });
	            check_outros$1();
	          }
	          if (dirty[0] & /*showOperator, isFilter1Valid*/262208) {
	            toggle_class$1(div5, "expanded", /*showOperator*/ctx[6] && /*isFilter1Valid*/ctx[18]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(selectbox0.$$.fragment, local);
	          transition_in$1(if_block0);
	          transition_in$1(if_block1);
	          transition_in$1(if_block2);
	          transition_in$1(selectbox1.$$.fragment, local);
	          transition_in$1(if_block3);
	          transition_in$1(if_block4);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(selectbox0.$$.fragment, local);
	          transition_out$1(if_block0);
	          transition_out$1(if_block1);
	          transition_out$1(if_block2);
	          transition_out$1(selectbox1.$$.fragment, local);
	          transition_out$1(if_block3);
	          transition_out$1(if_block4);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div6);
	          destroy_component$1(selectbox0);
	          if (if_block0) if_block0.d();
	          if (if_block1) if_block1.d();
	          if_blocks[current_block_type_index].d();
	          destroy_component$1(selectbox1);
	          if (if_block3) if_block3.d();
	          if (if_block4) if_block4.d();
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // Others
	    function isFilterValid(type, filterA, filterB) {
	      if (type === "isEmpty" || type === "isNotEmpty") {
	        return true;
	      }
	      if (filterA === undefined || filterA === null || filterA === "") {
	        // Need at least one value
	        return false;
	      }
	      if ((type === "betweenExclusive" || type === "betweenInclusive") && (filterB === undefined || filterB === null || filterB === "")) {
	        // between requires 2 values
	        return false;
	      }
	      return true;
	    }
	    function instance$4($$self, $$props, $$invalidate) {
	      let isFilter1Valid;
	      let $_;
	      component_subscribe$1($$self, X$1, $$value => $$invalidate(34, $_ = $$value));
	      const dispatch = createEventDispatcher$1();
	      let {
	        params
	      } = $$props;
	      let {
	        options = [{
	          value: "equals",
	          display: $_("Operator_Equals")
	        }, {
	          value: "notEqual",
	          display: $_("Operator_NotEqual")
	        }, {
	          value: "before",
	          display: $_("Operator_Before")
	        }, {
	          value: "beforeOrSame",
	          display: $_("Operator_BeforeOrSame")
	        }, {
	          value: "after",
	          display: $_("Operator_After")
	        }, {
	          value: "afterOrSame",
	          display: $_("Operator_AfterOrSame")
	        }, {
	          value: "betweenExclusive",
	          display: $_("Operator_BetweenExclusive")
	        }, {
	          value: "betweenInclusive",
	          display: $_("Operator_BetweenInclusive")
	        }, {
	          value: "isEmpty",
	          display: $_("Operator_IsEmpty")
	        }, {
	          value: "isNotEmpty",
	          display: $_("Operator_IsNotEmpty")
	        }]
	      } = $$props;
	      let {
	        operatorOptions = [{
	          value: "OR",
	          display: "OR"
	        }, {
	          value: "AND",
	          display: "AND"
	        }]
	      } = $$props;
	      let {
	        operator = "OR"
	      } = $$props;
	      let {
	        type1 = "equals"
	      } = $$props;
	      let {
	        filter1a = null
	      } = $$props;
	      let {
	        filter1b = null
	      } = $$props;
	      let {
	        type2 = "equals"
	      } = $$props;
	      let {
	        filter2a = null
	      } = $$props;
	      let {
	        filter2b = null
	      } = $$props;
	      let {
	        showOperator = false
	      } = $$props;
	      let _gridId = null;
	      let _colId = null;
	      let _select1Id = null;
	      let _select2Id = null;
	      let _date1aId = null;
	      let _date1bId = null;
	      let _date2aId = null;
	      let _date2bId = null;
	      let _operatorId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        _colId = get$1(params, "column.colDef.colId");
	        $$invalidate(11, _select1Id = _gridId ? `${_gridId}-${_colId}-select1` : undefined);
	        $$invalidate(12, _select2Id = _gridId ? `${_gridId}-${_colId}-select2` : undefined);
	        $$invalidate(13, _date1aId = _gridId ? `${_gridId}-${_colId}-date1a` : undefined);
	        $$invalidate(14, _date1bId = _gridId ? `${_gridId}-${_colId}-date1b` : undefined);
	        $$invalidate(15, _date2aId = _gridId ? `${_gridId}-${_colId}-date2a` : undefined);
	        $$invalidate(16, _date2bId = _gridId ? `${_gridId}-${_colId}-date2b` : undefined);
	        $$invalidate(17, _operatorId = _gridId ? `${_gridId}-${_colId}-operator` : undefined);
	        $$invalidate(17, _operatorId = _gridId ? `${_gridId}-${_colId}-toggle` : undefined);
	      });
	      function setFilter(filter) {
	        if (!filter) {
	          $$invalidate(0, type1 = "equals");
	          $$invalidate(1, filter1a = null);
	          $$invalidate(2, filter1b = null);
	          $$invalidate(3, type2 = "equals");
	          $$invalidate(4, filter2a = null);
	          $$invalidate(5, filter2b = null);
	          $$invalidate(6, showOperator = false);
	        } else {
	          $$invalidate(0, type1 = filter.conditions[0].type);
	          $$invalidate(1, filter1a = filter.conditions[0].filterA);
	          $$invalidate(2, filter1b = filter.conditions[0].filterB ? filter.conditions[0].filterB : null);
	          if (filter.conditions.length > 1) {
	            $$invalidate(9, operator = filter.operator);
	            $$invalidate(3, type2 = filter.conditions[1].type);
	            $$invalidate(4, filter2a = filter.conditions[1].filterA);
	            $$invalidate(5, filter2b = filter.conditions[1].filterB ? filter.conditions[1].filterB : null);
	            $$invalidate(6, showOperator = true);
	          }
	        }
	        handleFilterChanged();
	      }
	      function handleFilterChanged() {
	        let filter = null;
	        if (isFilterValid(type1, filter1a, filter1b)) {
	          filter = {
	            conditions: [],
	            type: "date"
	          };
	          filter.conditions.push({
	            filterA: filter1a,
	            filterB: filter1b,
	            type: type1
	          });
	          if (showOperator && isFilterValid(type2, filter2a, filter2b)) {
	            filter.conditions.push({
	              filterA: filter2a,
	              filterB: filter2b,
	              type: type2
	            });
	            filter.operator = operator;
	          }
	        }
	        dispatch("changed", filter);
	      }
	      function toggleOperator() {
	        $$invalidate(6, showOperator = !showOperator);
	        handleFilterChanged();
	      }
	      function selectbox0_options_binding(value) {
	        options = value;
	        $$invalidate(7, options);
	      }
	      function selectbox0_value_binding(value) {
	        type1 = value;
	        $$invalidate(0, type1);
	      }
	      function datepicker_value_binding(value) {
	        filter1a = value;
	        $$invalidate(1, filter1a);
	      }
	      function datepicker_value_binding_1(value) {
	        filter1b = value;
	        $$invalidate(2, filter1b);
	      }
	      function selectbox_options_binding(value) {
	        operatorOptions = value;
	        $$invalidate(8, operatorOptions);
	      }
	      function selectbox_value_binding(value) {
	        operator = value;
	        $$invalidate(9, operator);
	      }
	      function selectbox1_options_binding(value) {
	        options = value;
	        $$invalidate(7, options);
	      }
	      function selectbox1_value_binding(value) {
	        type2 = value;
	        $$invalidate(3, type2);
	      }
	      function datepicker_value_binding_2(value) {
	        filter2a = value;
	        $$invalidate(4, filter2a);
	      }
	      function datepicker_value_binding_3(value) {
	        filter2b = value;
	        $$invalidate(5, filter2b);
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(10, params = $$props.params);
	        if ("options" in $$props) $$invalidate(7, options = $$props.options);
	        if ("operatorOptions" in $$props) $$invalidate(8, operatorOptions = $$props.operatorOptions);
	        if ("operator" in $$props) $$invalidate(9, operator = $$props.operator);
	        if ("type1" in $$props) $$invalidate(0, type1 = $$props.type1);
	        if ("filter1a" in $$props) $$invalidate(1, filter1a = $$props.filter1a);
	        if ("filter1b" in $$props) $$invalidate(2, filter1b = $$props.filter1b);
	        if ("type2" in $$props) $$invalidate(3, type2 = $$props.type2);
	        if ("filter2a" in $$props) $$invalidate(4, filter2a = $$props.filter2a);
	        if ("filter2b" in $$props) $$invalidate(5, filter2b = $$props.filter2b);
	        if ("showOperator" in $$props) $$invalidate(6, showOperator = $$props.showOperator);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*type1, filter1a, filter1b*/7) {
	          // Computed
	          $$invalidate(18, isFilter1Valid = isFilterValid(type1, filter1a, filter1b));
	        }
	        if ($$self.$$.dirty[0] & /*showOperator, type2, filter2a, filter2b*/120) ;
	      };
	      return [type1, filter1a, filter1b, type2, filter2a, filter2b, showOperator, options, operatorOptions, operator, params, _select1Id, _select2Id, _date1aId, _date1bId, _date2aId, _date2bId, _operatorId, isFilter1Valid, handleFilterChanged, toggleOperator, setFilter, selectbox0_options_binding, selectbox0_value_binding, datepicker_value_binding, datepicker_value_binding_1, selectbox_options_binding, selectbox_value_binding, selectbox1_options_binding, selectbox1_value_binding, datepicker_value_binding_2, datepicker_value_binding_3];
	    }
	    class DateGridFilter extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-nzbi37-style")) add_css$4();
	        init$1(this, options, instance$4, create_fragment$4, safe_not_equal$1, {
	          params: 10,
	          options: 7,
	          operatorOptions: 8,
	          operator: 9,
	          type1: 0,
	          filter1a: 1,
	          filter1b: 2,
	          type2: 3,
	          filter2a: 4,
	          filter2b: 5,
	          showOperator: 6,
	          setFilter: 21
	        }, [-1, -1]);
	      }
	      get setFilter() {
	        return this.$$.ctx[21];
	      }
	    }

	    class DateGridFilterComponent {
	      init(params) {
	        this.column = params.column.colDef.printOSColumn;
	        this.agParams = params;
	        this.filterContainer = document.createElement('div');
	        this.filterContainer.classList.add('pros-grid-filter-container');
	        this.gridFilter = new DateGridFilter({
	          target: this.filterContainer,
	          props: {
	            params: params
	          }
	        });
	        this.filter = undefined;
	        this.gridFilter.$on('changed', event => {
	          setTimeout(() => {
	            this.filter = event.detail;
	            this.agParams.filterChangedCallback();
	          }, 10);
	        });
	      }
	      getGui() {
	        return this.filterContainer;
	      }
	      isFilterActive() {
	        return this.filter && this.filter.conditions.length > 0;
	      }
	      getModel() {
	        if (!this.filter) {
	          return null;
	        }
	        return this.filter;
	      }
	      setModel(filter) {
	        this.filter = filter;
	        this.gridFilter.setFilter(filter);
	      }
	      doesFilterPass(params) {
	        if (!this.filter) {
	          return true;
	        }
	        let value = columns.getValue(this.column, params.data, params);
	        let result1 = this.checkCondition(this.filter.conditions[0], value);
	        if (this.filter.conditions.length === 1) {
	          return result1;
	        }
	        let result2 = this.checkCondition(this.filter.conditions[1], value);
	        switch (this.filter.operator) {
	          case 'OR':
	            return result1 || result2;
	          case 'AND':
	            return result1 && result2;
	          default:
	            // OR
	            return result1 || result2;
	        }
	      }
	      checkCondition(condition, value) {
	        let myDate = value ? moment(value) : null;
	        let testA = moment(condition.filterA);
	        let testB = moment(condition.filterB);
	        switch (condition.type) {
	          case 'equals':
	            return myDate ? myDate.isSame(testA, 'day') : false;
	          case 'notEqual':
	            return myDate ? !myDate.isSame(testA, 'day') : true;
	          case 'before':
	            return myDate ? myDate.isBefore(testA, 'day') : false;
	          case 'beforeOrSame':
	            return myDate ? myDate.isSameOrBefore(testA, 'day') : false;
	          case 'after':
	            return myDate ? myDate.isAfter(testA, 'day') : false;
	          case 'afterOrSame':
	            return myDate ? myDate.isSameOrAfter(testA, 'day') : false;
	          case 'betweenExclusive':
	            if (testA.isBefore(testB)) return myDate ? myDate.isAfter(testA) && myDate.isBefore(testB) : false;
	            if (testB.isBefore(testA)) return myDate ? myDate.isAfter(testB) && myDate.isBefore(testA) : false;
	            return false;
	          case 'betweenInclusive':
	            if (testA.isBefore(testB)) return myDate ? myDate.isSameOrAfter(testA) && myDate.isSameOrBefore(testB) : false;
	            if (testB.isBefore(testA)) return myDate ? myDate.isSameOrAfter(testB) && myDate.isSameOrBefore(testA) : false;
	            return myDate.isSame(testA);
	          case 'isEmpty':
	            return !myDate;
	          case 'isNotEmpty':
	            return !!myDate;
	          default:
	            // equal
	            return myDate.isSame(testA);
	        }
	      }
	      destroy() {
	        this.gridFilter.$destroy();
	      }
	    }

	    /* src/cells/ImageCell.svelte generated by Svelte v3.38.2 */
	    function add_css$3() {
	      var style = element$1("style");
	      style.id = "svelte-m8mllz-style";
	      style.textContent = ".pros-image-cell.svelte-m8mllz .pros-img.svelte-m8mllz{vertical-align:middle;border:0;height:100%;width:auto}";
	      append$1(document.head, style);
	    }
	    function create_fragment$3(ctx) {
	      let div;
	      let img;
	      let img_src_value;
	      return {
	        c() {
	          div = element$1("div");
	          img = element$1("img");
	          attr$1(img, "class", "pros-img svelte-m8mllz");
	          if (img.src !== (img_src_value = /*params*/ctx[2].value)) attr$1(img, "src", img_src_value);
	          attr$1(div, "class", "pros-image-cell svelte-m8mllz");
	          set_style(div, "height", /*_height*/ctx[0]);
	          set_style(div, "width", /*_width*/ctx[1]);
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          append$1(div, img);
	        },
	        p(ctx, [dirty]) {
	          if (dirty & /*params*/4 && img.src !== (img_src_value = /*params*/ctx[2].value)) {
	            attr$1(img, "src", img_src_value);
	          }
	          if (dirty & /*_height*/1) {
	            set_style(div, "height", /*_height*/ctx[0]);
	          }
	          if (dirty & /*_width*/2) {
	            set_style(div, "width", /*_width*/ctx[1]);
	          }
	        },
	        i: noop$1,
	        o: noop$1,
	        d(detaching) {
	          if (detaching) detach$1(div);
	        }
	      };
	    }
	    function hasValue$2(test) {
	      return test !== null && test !== undefined;
	    }
	    function instance$3($$self, $$props, $$invalidate) {
	      createEventDispatcher$1();
	      let {
	        params = undefined
	      } = $$props;
	      let {
	        _height = "100%"
	      } = $$props;
	      let {
	        _width = "auto"
	      } = $$props;
	      onMount$1(() => {
	        let h = get$1(params, "colDef.printOSColumn.image.height");
	        let w = get$1(params, "colDef.printOSColumn.image.width");
	        if (hasValue$2(h)) {
	          $$invalidate(0, _height = !isNaN(h) ? Number(h) + "px" : h);
	        }
	        if (hasValue$2(w)) {
	          $$invalidate(1, _width = !isNaN(w) ? Number(w) + "px" : w);
	        }
	      });
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(2, params = $$props.params);
	        if ("_height" in $$props) $$invalidate(0, _height = $$props._height);
	        if ("_width" in $$props) $$invalidate(1, _width = $$props._width);
	      };
	      return [_height, _width, params];
	    }
	    class ImageCell extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-m8mllz-style")) add_css$3();
	        init$1(this, options, instance$3, create_fragment$3, safe_not_equal$1, {
	          params: 2,
	          _height: 0,
	          _width: 1
	        });
	      }
	    }

	    class ImageCellRenderer {
	      init(params) {
	        this.eGui = document.createElement('div');
	        this.eGui.classList.add('pros-custom-cell-content');
	        this.imageCell = new ImageCell({
	          target: this.eGui,
	          props: {
	            params
	          }
	        });
	      }
	      getGui() {
	        return this.eGui;
	      }
	      refresh(params) {}
	      destroy() {
	        this.imageCell.$destroy();
	      }
	      getValueToDisplay(params) {
	        return params.valueFormatted ? params.valueFormatted : params.value;
	      }
	    }

	    /* node_modules/@printos/agnostic-button/src/Button.svelte generated by Svelte v3.38.2 */
	    function add_css$2() {
	      var style = element$1("style");
	      style.id = "svelte-192il0a-style";
	      style.textContent = ".pros-button-wrapper.svelte-192il0a.svelte-192il0a{display:flex;justify-content:center;align-items:center;height:48px;min-width:48px;padding:0 16px 0 16px;user-select:none;border-radius:12px;box-sizing:border-box;cursor:pointer;appearance:none;outline:none;border:0;margin:0;overflow:visible;text-decoration:none;text-transform:none;box-shadow:none;font-size:16px;position:relative;transition:background-color 0.3s ease}.pros-button-wrapper.icon-only.svelte-192il0a.svelte-192il0a{padding:0 16px;width:48px}.pros-button-wrapper.svelte-192il0a.svelte-192il0a:after{border-radius:14px;border-width:2px;border-style:solid;content:\" \";transition:all 50ms ease 0s;inset:0;position:absolute;opacity:0}.pros-button-wrapper.svelte-192il0a .pros-button-content.svelte-192il0a{display:flex;justify-content:flex-start;align-items:center}.pros-button-wrapper.svelte-192il0a.svelte-192il0a:focus:after{opacity:1;inset:-4px}.pros-button-wrapper.disabled.svelte-192il0a.svelte-192il0a:after{opacity:0;inset:0}.pros-button-wrapper.svelte-192il0a .pros-icon-container.svelte-192il0a{min-width:24px}.pros-button-wrapper.svelte-192il0a .pros-icon-container.left.svelte-192il0a{margin-right:8px}.pros-button-wrapper.svelte-192il0a .pros-icon-container.right.svelte-192il0a{margin-left:8px}.pros-button-wrapper.svelte-192il0a .pros-button-label.svelte-192il0a{flex:1;white-space:nowrap}.pros-button-wrapper[pos--density=high].svelte-192il0a.svelte-192il0a{height:36px;min-width:36px;border-radius:8px}.pros-button-wrapper[pos--density=high].icon-only.svelte-192il0a.svelte-192il0a{width:36px}.pros-button-wrapper[pos--shape=sharp].svelte-192il0a.svelte-192il0a{border-radius:unset}.pros-button-wrapper[pos--shape=sharp].svelte-192il0a.svelte-192il0a:after{border-radius:0}.pros-button-wrapper[pos--mode=form].svelte-192il0a.svelte-192il0a{margin-bottom:20px}.pros-button-wrapper[pos--mode=toolbar].svelte-192il0a.svelte-192il0a{height:auto;width:auto;min-width:unset;padding:0}.pros-button-wrapper[pos--mode=toolbar].svelte-192il0a.svelte-192il0a:after{border-radius:4px;border-width:1px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a{height:32px;min-width:32px;padding:0;border-radius:4px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a:after{border-radius:4px;border-width:1px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a:focus:after{opacity:0;inset:0}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a{padding:0;max-height:36px;width:36px;min-width:36px;border-radius:10px}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a:after{border-radius:12px;border-width:1px;border-style:solid;content:\" \";transition:all 50ms ease 0s;inset:0;position:absolute;opacity:0}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a:focus:after{opacity:1;inset:-2px}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#027aae}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a:hover{background-color:#035c84}.pros-button-wrapper[pos--theme=light].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].svelte-192il0a.svelte-192il0a{color:#212121;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].svelte-192il0a.svelte-192il0a:hover{background-color:unset}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--mode=action].svelte-192il0a.svelte-192il0a{color:#404040;background-color:#ffffff}.pros-button-wrapper[pos--theme=light][pos--mode=action].svelte-192il0a.svelte-192il0a:hover{color:#363636}.pros-button-wrapper[pos--theme=light][pos--mode=action].disabled.svelte-192il0a.svelte-192il0a{color:#737373;cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{background-color:#135b08}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{background-color:#a90b0a}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{background-color:#b55500}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a{border:1px solid #027aae;color:#027aae;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a:hover{color:#035c84;background-color:rgba(2, 122, 174, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a{border:1px solid #1c7a17;color:#1c7a17;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#135b08;background-color:rgba(28, 122, 23, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a{border:1px solid #be1313;color:#be1313;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#a90b0a;background-color:rgba(190, 19, 19, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a{border:1px solid #d06702;color:#d06702;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#b55500;background-color:rgba(208, 103, 2, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a{color:#027aae;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a:hover{color:#035c84;background-color:rgba(2, 122, 174, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#1c7a17;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#135b08;background-color:rgba(28, 122, 23, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#be1313;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#a90b0a;background-color:rgba(190, 19, 19, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#d06702;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#b55500;background-color:rgba(208, 103, 2, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a{color:#404040;background-color:unset}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a:after{border-color:#404040}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a:hover{background-color:#ebebeb}.pros-button-wrapper[pos--mode=header][pos--theme=light].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a:hover{background-color:#6dd0fb}.pros-button-wrapper[pos--theme=dark].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].svelte-192il0a.svelte-192il0a:hover{background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--mode=action].svelte-192il0a.svelte-192il0a{color:#ebebeb;background-color:#2b2b2b}.pros-button-wrapper[pos--theme=dark][pos--mode=action].svelte-192il0a.svelte-192il0a:hover{color:#f1f1f1}.pros-button-wrapper[pos--theme=dark][pos--mode=action].disabled.svelte-192il0a.svelte-192il0a{color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{background-color:#8ef291}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{background-color:#f48787}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{background-color:#fdd1a5}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a{border:1px solid #3ab4eb;color:#3ab4eb;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a:hover{color:#6dd0fb;background-color:rgba(58, 180, 235, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a{border:1px solid #67df6a;color:#67df6a;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#8ef291;background-color:rgba(103, 223, 106, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a{border:1px solid #eb5e5e;color:#eb5e5e;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#f48787;background-color:rgba(235, 94, 94, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a{border:1px solid #f9c086;color:#f9c086;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#fdd1a5;background-color:rgba(249, 192, 134, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a{color:#3ab4eb;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a:hover{color:#6dd0fb;background-color:rgba(58, 180, 235, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#67df6a;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#8ef291;background-color:rgba(103, 223, 106, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#eb5e5e;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#f48787;background-color:rgba(235, 94, 94, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#f9c086;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#fdd1a5;background-color:rgba(249, 192, 134, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a{color:#ebebeb;background-color:unset}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a:after{border-color:#ebebeb}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a:hover{background-color:#404040}.pros-button-wrapper[pos--mode=header][pos--theme=dark].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;cursor:default}";
	      append$1(document.head, style);
	    }

	    // (16:0) {:else}
	    function create_else_block(ctx) {
	      let button;
	      let div;
	      let t;
	      let button_class_value;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*loading*/ctx[11] && create_if_block_7();
	      let if_block1 = ! /*loading*/ctx[11] && create_if_block_4(ctx);
	      return {
	        c() {
	          button = element$1("button");
	          div = element$1("div");
	          if (if_block0) if_block0.c();
	          t = space$1();
	          if (if_block1) if_block1.c();
	          attr$1(div, "class", "pros-button-content svelte-192il0a");
	          attr$1(button, "id", /*_id*/ctx[21]);
	          attr$1(button, "type", "button");
	          attr$1(button, "class", button_class_value = "pros-button-wrapper " + /*_class*/ctx[17] + " svelte-192il0a");
	          attr$1(button, "style", /*_style*/ctx[18]);
	          attr$1(button, "pos--theme", /*_theme*/ctx[14]);
	          attr$1(button, "pos--shape", /*_shape*/ctx[15]);
	          attr$1(button, "pos--density", /*_density*/ctx[16]);
	          attr$1(button, "pos--mode", /*mode*/ctx[3]);
	          attr$1(button, "pos--scheme", /*scheme*/ctx[4]);
	          attr$1(button, "pos--display", /*display*/ctx[8]);
	          toggle_class$1(button, "disabled", /*disabled*/ctx[10]);
	        },
	        m(target, anchor) {
	          insert$1(target, button, anchor);
	          append$1(button, div);
	          if (if_block0) if_block0.m(div, null);
	          append$1(div, t);
	          if (if_block1) if_block1.m(div, null);
	          /*button_binding_1*/
	          ctx[57](button);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(button, "click", /*handleClick*/ctx[22]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*loading*/ctx[11]) {
	            if (if_block0) {
	              if (dirty[0] & /*loading*/2048) {
	                transition_in$1(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_7();
	              if_block0.c();
	              transition_in$1(if_block0, 1);
	              if_block0.m(div, t);
	            }
	          } else if (if_block0) {
	            group_outros$1();
	            transition_out$1(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros$1();
	          }
	          if (! /*loading*/ctx[11]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty[0] & /*loading*/2048) {
	                transition_in$1(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block_4(ctx);
	              if_block1.c();
	              transition_in$1(if_block1, 1);
	              if_block1.m(div, null);
	            }
	          } else if (if_block1) {
	            group_outros$1();
	            transition_out$1(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros$1();
	          }
	          if (!current || dirty[0] & /*_id*/2097152) {
	            attr$1(button, "id", /*_id*/ctx[21]);
	          }
	          if (!current || dirty[0] & /*_class*/131072 && button_class_value !== (button_class_value = "pros-button-wrapper " + /*_class*/ctx[17] + " svelte-192il0a")) {
	            attr$1(button, "class", button_class_value);
	          }
	          if (!current || dirty[0] & /*_style*/262144) {
	            attr$1(button, "style", /*_style*/ctx[18]);
	          }
	          if (!current || dirty[0] & /*_theme*/16384) {
	            attr$1(button, "pos--theme", /*_theme*/ctx[14]);
	          }
	          if (!current || dirty[0] & /*_shape*/32768) {
	            attr$1(button, "pos--shape", /*_shape*/ctx[15]);
	          }
	          if (!current || dirty[0] & /*_density*/65536) {
	            attr$1(button, "pos--density", /*_density*/ctx[16]);
	          }
	          if (!current || dirty[0] & /*mode*/8) {
	            attr$1(button, "pos--mode", /*mode*/ctx[3]);
	          }
	          if (!current || dirty[0] & /*scheme*/16) {
	            attr$1(button, "pos--scheme", /*scheme*/ctx[4]);
	          }
	          if (!current || dirty[0] & /*display*/256) {
	            attr$1(button, "pos--display", /*display*/ctx[8]);
	          }
	          if (dirty[0] & /*_class, disabled*/132096) {
	            toggle_class$1(button, "disabled", /*disabled*/ctx[10]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block0);
	          transition_in$1(if_block1);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block0);
	          transition_out$1(if_block1);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(button);
	          if (if_block0) if_block0.d();
	          if (if_block1) if_block1.d();
	          /*button_binding_1*/
	          ctx[57](null);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (1:0) {#if _iconOnly}
	    function create_if_block$2(ctx) {
	      let button;
	      let div;
	      let t;
	      let button_class_value;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*loading*/ctx[11] && create_if_block_3();
	      let if_block1 = ! /*loading*/ctx[11] && create_if_block_1$1(ctx);
	      return {
	        c() {
	          button = element$1("button");
	          div = element$1("div");
	          if (if_block0) if_block0.c();
	          t = space$1();
	          if (if_block1) if_block1.c();
	          attr$1(div, "class", "pros-button-content svelte-192il0a");
	          attr$1(button, "id", /*_id*/ctx[21]);
	          attr$1(button, "type", "button");
	          attr$1(button, "class", button_class_value = "pros-button-wrapper " + /*_class*/ctx[17] + " svelte-192il0a");
	          attr$1(button, "style", /*_style*/ctx[18]);
	          attr$1(button, "pos--theme", /*_theme*/ctx[14]);
	          attr$1(button, "pos--shape", /*_shape*/ctx[15]);
	          attr$1(button, "pos--density", /*_density*/ctx[16]);
	          attr$1(button, "pos--mode", /*mode*/ctx[3]);
	          attr$1(button, "pos--scheme", /*scheme*/ctx[4]);
	          attr$1(button, "pos--display", /*display*/ctx[8]);
	          attr$1(button, "pros-tooltip", /*label*/ctx[9]);
	          toggle_class$1(button, "disabled", /*disabled*/ctx[10]);
	          toggle_class$1(button, "icon-only", /*_iconOnly*/ctx[12]);
	        },
	        m(target, anchor) {
	          insert$1(target, button, anchor);
	          append$1(button, div);
	          if (if_block0) if_block0.m(div, null);
	          append$1(div, t);
	          if (if_block1) if_block1.m(div, null);
	          /*button_binding*/
	          ctx[42](button);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(button, "click", /*handleClick*/ctx[22]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*loading*/ctx[11]) {
	            if (if_block0) {
	              if (dirty[0] & /*loading*/2048) {
	                transition_in$1(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_3();
	              if_block0.c();
	              transition_in$1(if_block0, 1);
	              if_block0.m(div, t);
	            }
	          } else if (if_block0) {
	            group_outros$1();
	            transition_out$1(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros$1();
	          }
	          if (! /*loading*/ctx[11]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty[0] & /*loading*/2048) {
	                transition_in$1(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block_1$1(ctx);
	              if_block1.c();
	              transition_in$1(if_block1, 1);
	              if_block1.m(div, null);
	            }
	          } else if (if_block1) {
	            group_outros$1();
	            transition_out$1(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros$1();
	          }
	          if (!current || dirty[0] & /*_id*/2097152) {
	            attr$1(button, "id", /*_id*/ctx[21]);
	          }
	          if (!current || dirty[0] & /*_class*/131072 && button_class_value !== (button_class_value = "pros-button-wrapper " + /*_class*/ctx[17] + " svelte-192il0a")) {
	            attr$1(button, "class", button_class_value);
	          }
	          if (!current || dirty[0] & /*_style*/262144) {
	            attr$1(button, "style", /*_style*/ctx[18]);
	          }
	          if (!current || dirty[0] & /*_theme*/16384) {
	            attr$1(button, "pos--theme", /*_theme*/ctx[14]);
	          }
	          if (!current || dirty[0] & /*_shape*/32768) {
	            attr$1(button, "pos--shape", /*_shape*/ctx[15]);
	          }
	          if (!current || dirty[0] & /*_density*/65536) {
	            attr$1(button, "pos--density", /*_density*/ctx[16]);
	          }
	          if (!current || dirty[0] & /*mode*/8) {
	            attr$1(button, "pos--mode", /*mode*/ctx[3]);
	          }
	          if (!current || dirty[0] & /*scheme*/16) {
	            attr$1(button, "pos--scheme", /*scheme*/ctx[4]);
	          }
	          if (!current || dirty[0] & /*display*/256) {
	            attr$1(button, "pos--display", /*display*/ctx[8]);
	          }
	          if (!current || dirty[0] & /*label*/512) {
	            attr$1(button, "pros-tooltip", /*label*/ctx[9]);
	          }
	          if (dirty[0] & /*_class, disabled*/132096) {
	            toggle_class$1(button, "disabled", /*disabled*/ctx[10]);
	          }
	          if (dirty[0] & /*_class, _iconOnly*/135168) {
	            toggle_class$1(button, "icon-only", /*_iconOnly*/ctx[12]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block0);
	          transition_in$1(if_block1);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block0);
	          transition_out$1(if_block1);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(button);
	          if (if_block0) if_block0.d();
	          if (if_block1) if_block1.d();
	          /*button_binding*/
	          ctx[42](null);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (19:4) {#if loading}
	    function create_if_block_7(ctx) {
	      let spinner;
	      let current;
	      spinner = new Spinner({
	        props: {
	          diameter: "24"
	        }
	      });
	      return {
	        c() {
	          create_component$1(spinner.$$.fragment);
	        },
	        m(target, anchor) {
	          mount_component$1(spinner, target, anchor);
	          current = true;
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(spinner.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(spinner.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          destroy_component$1(spinner, detaching);
	        }
	      };
	    }

	    // (22:4) {#if !loading}
	    function create_if_block_4(ctx) {
	      let t0;
	      let div;
	      let t1;
	      let t2;
	      let if_block1_anchor;
	      let current;
	      let if_block0 = /*_hasIcon*/ctx[13] && /*iconPosition*/ctx[5] === "left" && create_if_block_6(ctx);
	      let if_block1 = /*_hasIcon*/ctx[13] && /*iconPosition*/ctx[5] === "right" && create_if_block_5(ctx);
	      return {
	        c() {
	          if (if_block0) if_block0.c();
	          t0 = space$1();
	          div = element$1("div");
	          t1 = text$1(/*label*/ctx[9]);
	          t2 = space$1();
	          if (if_block1) if_block1.c();
	          if_block1_anchor = empty$1();
	          attr$1(div, "class", "pros-button-label svelte-192il0a");
	          attr$1(div, "pros-tooltip", "");
	          toggle_class$1(div, "right", /*iconPosition*/ctx[5] === "right");
	        },
	        m(target, anchor) {
	          if (if_block0) if_block0.m(target, anchor);
	          insert$1(target, t0, anchor);
	          insert$1(target, div, anchor);
	          append$1(div, t1);
	          insert$1(target, t2, anchor);
	          if (if_block1) if_block1.m(target, anchor);
	          insert$1(target, if_block1_anchor, anchor);
	          current = true;
	        },
	        p(ctx, dirty) {
	          if (/*_hasIcon*/ctx[13] && /*iconPosition*/ctx[5] === "left") {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	              if (dirty[0] & /*_hasIcon, iconPosition*/8224) {
	                transition_in$1(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_6(ctx);
	              if_block0.c();
	              transition_in$1(if_block0, 1);
	              if_block0.m(t0.parentNode, t0);
	            }
	          } else if (if_block0) {
	            group_outros$1();
	            transition_out$1(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros$1();
	          }
	          if (!current || dirty[0] & /*label*/512) set_data$1(t1, /*label*/ctx[9]);
	          if (dirty[0] & /*iconPosition*/32) {
	            toggle_class$1(div, "right", /*iconPosition*/ctx[5] === "right");
	          }
	          if (/*_hasIcon*/ctx[13] && /*iconPosition*/ctx[5] === "right") {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty[0] & /*_hasIcon, iconPosition*/8224) {
	                transition_in$1(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block_5(ctx);
	              if_block1.c();
	              transition_in$1(if_block1, 1);
	              if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
	            }
	          } else if (if_block1) {
	            group_outros$1();
	            transition_out$1(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros$1();
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block0);
	          transition_in$1(if_block1);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block0);
	          transition_out$1(if_block1);
	          current = false;
	        },
	        d(detaching) {
	          if (if_block0) if_block0.d(detaching);
	          if (detaching) detach$1(t0);
	          if (detaching) detach$1(div);
	          if (detaching) detach$1(t2);
	          if (if_block1) if_block1.d(detaching);
	          if (detaching) detach$1(if_block1_anchor);
	        }
	      };
	    }

	    // (23:6) {#if _hasIcon && iconPosition === 'left'}
	    function create_if_block_6(ctx) {
	      let div;
	      let icon_1;
	      let updating_name;
	      let updating_path;
	      let updating_url;
	      let updating_solid;
	      let updating_size;
	      let updating_constraint;
	      let updating_theme;
	      let current;
	      function icon_1_name_binding_1(value) {
	        /*icon_1_name_binding_1*/ctx[43](value);
	      }
	      function icon_1_path_binding_1(value) {
	        /*icon_1_path_binding_1*/ctx[44](value);
	      }
	      function icon_1_url_binding_1(value) {
	        /*icon_1_url_binding_1*/ctx[45](value);
	      }
	      function icon_1_solid_binding_1(value) {
	        /*icon_1_solid_binding_1*/ctx[46](value);
	      }
	      function icon_1_size_binding_1(value) {
	        /*icon_1_size_binding_1*/ctx[47](value);
	      }
	      function icon_1_constraint_binding_1(value) {
	        /*icon_1_constraint_binding_1*/ctx[48](value);
	      }
	      function icon_1_theme_binding_1(value) {
	        /*icon_1_theme_binding_1*/ctx[49](value);
	      }
	      let icon_1_props = {
	        mode: "button"
	      };
	      if (/*iconName*/ctx[0] !== void 0) {
	        icon_1_props.name = /*iconName*/ctx[0];
	      }
	      if (/*iconPath*/ctx[1] !== void 0) {
	        icon_1_props.path = /*iconPath*/ctx[1];
	      }
	      if (/*iconUrl*/ctx[2] !== void 0) {
	        icon_1_props.url = /*iconUrl*/ctx[2];
	      }
	      if (/*_solid*/ctx[19] !== void 0) {
	        icon_1_props.solid = /*_solid*/ctx[19];
	      }
	      if (/*iconSize*/ctx[6] !== void 0) {
	        icon_1_props.size = /*iconSize*/ctx[6];
	      }
	      if (/*iconConstraint*/ctx[7] !== void 0) {
	        icon_1_props.constraint = /*iconConstraint*/ctx[7];
	      }
	      if (/*_theme*/ctx[14] !== void 0) {
	        icon_1_props.theme = /*_theme*/ctx[14];
	      }
	      icon_1 = new Icon$1({
	        props: icon_1_props
	      });
	      binding_callbacks$1.push(() => bind$1(icon_1, "name", icon_1_name_binding_1));
	      binding_callbacks$1.push(() => bind$1(icon_1, "path", icon_1_path_binding_1));
	      binding_callbacks$1.push(() => bind$1(icon_1, "url", icon_1_url_binding_1));
	      binding_callbacks$1.push(() => bind$1(icon_1, "solid", icon_1_solid_binding_1));
	      binding_callbacks$1.push(() => bind$1(icon_1, "size", icon_1_size_binding_1));
	      binding_callbacks$1.push(() => bind$1(icon_1, "constraint", icon_1_constraint_binding_1));
	      binding_callbacks$1.push(() => bind$1(icon_1, "theme", icon_1_theme_binding_1));
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(icon_1.$$.fragment);
	          attr$1(div, "class", "pros-icon-container left svelte-192il0a");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(icon_1, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const icon_1_changes = {};
	          if (!updating_name && dirty[0] & /*iconName*/1) {
	            updating_name = true;
	            icon_1_changes.name = /*iconName*/ctx[0];
	            add_flush_callback$1(() => updating_name = false);
	          }
	          if (!updating_path && dirty[0] & /*iconPath*/2) {
	            updating_path = true;
	            icon_1_changes.path = /*iconPath*/ctx[1];
	            add_flush_callback$1(() => updating_path = false);
	          }
	          if (!updating_url && dirty[0] & /*iconUrl*/4) {
	            updating_url = true;
	            icon_1_changes.url = /*iconUrl*/ctx[2];
	            add_flush_callback$1(() => updating_url = false);
	          }
	          if (!updating_solid && dirty[0] & /*_solid*/524288) {
	            updating_solid = true;
	            icon_1_changes.solid = /*_solid*/ctx[19];
	            add_flush_callback$1(() => updating_solid = false);
	          }
	          if (!updating_size && dirty[0] & /*iconSize*/64) {
	            updating_size = true;
	            icon_1_changes.size = /*iconSize*/ctx[6];
	            add_flush_callback$1(() => updating_size = false);
	          }
	          if (!updating_constraint && dirty[0] & /*iconConstraint*/128) {
	            updating_constraint = true;
	            icon_1_changes.constraint = /*iconConstraint*/ctx[7];
	            add_flush_callback$1(() => updating_constraint = false);
	          }
	          if (!updating_theme && dirty[0] & /*_theme*/16384) {
	            updating_theme = true;
	            icon_1_changes.theme = /*_theme*/ctx[14];
	            add_flush_callback$1(() => updating_theme = false);
	          }
	          icon_1.$set(icon_1_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(icon_1.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(icon_1.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(icon_1);
	        }
	      };
	    }

	    // (29:6) {#if _hasIcon && iconPosition === 'right'}
	    function create_if_block_5(ctx) {
	      let div;
	      let icon_1;
	      let updating_name;
	      let updating_path;
	      let updating_url;
	      let updating_solid;
	      let updating_size;
	      let updating_constraint;
	      let updating_theme;
	      let current;
	      function icon_1_name_binding_2(value) {
	        /*icon_1_name_binding_2*/ctx[50](value);
	      }
	      function icon_1_path_binding_2(value) {
	        /*icon_1_path_binding_2*/ctx[51](value);
	      }
	      function icon_1_url_binding_2(value) {
	        /*icon_1_url_binding_2*/ctx[52](value);
	      }
	      function icon_1_solid_binding_2(value) {
	        /*icon_1_solid_binding_2*/ctx[53](value);
	      }
	      function icon_1_size_binding_2(value) {
	        /*icon_1_size_binding_2*/ctx[54](value);
	      }
	      function icon_1_constraint_binding_2(value) {
	        /*icon_1_constraint_binding_2*/ctx[55](value);
	      }
	      function icon_1_theme_binding_2(value) {
	        /*icon_1_theme_binding_2*/ctx[56](value);
	      }
	      let icon_1_props = {
	        mode: "button"
	      };
	      if (/*iconName*/ctx[0] !== void 0) {
	        icon_1_props.name = /*iconName*/ctx[0];
	      }
	      if (/*iconPath*/ctx[1] !== void 0) {
	        icon_1_props.path = /*iconPath*/ctx[1];
	      }
	      if (/*iconUrl*/ctx[2] !== void 0) {
	        icon_1_props.url = /*iconUrl*/ctx[2];
	      }
	      if (/*_solid*/ctx[19] !== void 0) {
	        icon_1_props.solid = /*_solid*/ctx[19];
	      }
	      if (/*iconSize*/ctx[6] !== void 0) {
	        icon_1_props.size = /*iconSize*/ctx[6];
	      }
	      if (/*iconConstraint*/ctx[7] !== void 0) {
	        icon_1_props.constraint = /*iconConstraint*/ctx[7];
	      }
	      if (/*_theme*/ctx[14] !== void 0) {
	        icon_1_props.theme = /*_theme*/ctx[14];
	      }
	      icon_1 = new Icon$1({
	        props: icon_1_props
	      });
	      binding_callbacks$1.push(() => bind$1(icon_1, "name", icon_1_name_binding_2));
	      binding_callbacks$1.push(() => bind$1(icon_1, "path", icon_1_path_binding_2));
	      binding_callbacks$1.push(() => bind$1(icon_1, "url", icon_1_url_binding_2));
	      binding_callbacks$1.push(() => bind$1(icon_1, "solid", icon_1_solid_binding_2));
	      binding_callbacks$1.push(() => bind$1(icon_1, "size", icon_1_size_binding_2));
	      binding_callbacks$1.push(() => bind$1(icon_1, "constraint", icon_1_constraint_binding_2));
	      binding_callbacks$1.push(() => bind$1(icon_1, "theme", icon_1_theme_binding_2));
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(icon_1.$$.fragment);
	          attr$1(div, "class", "pros-icon-container right svelte-192il0a");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(icon_1, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const icon_1_changes = {};
	          if (!updating_name && dirty[0] & /*iconName*/1) {
	            updating_name = true;
	            icon_1_changes.name = /*iconName*/ctx[0];
	            add_flush_callback$1(() => updating_name = false);
	          }
	          if (!updating_path && dirty[0] & /*iconPath*/2) {
	            updating_path = true;
	            icon_1_changes.path = /*iconPath*/ctx[1];
	            add_flush_callback$1(() => updating_path = false);
	          }
	          if (!updating_url && dirty[0] & /*iconUrl*/4) {
	            updating_url = true;
	            icon_1_changes.url = /*iconUrl*/ctx[2];
	            add_flush_callback$1(() => updating_url = false);
	          }
	          if (!updating_solid && dirty[0] & /*_solid*/524288) {
	            updating_solid = true;
	            icon_1_changes.solid = /*_solid*/ctx[19];
	            add_flush_callback$1(() => updating_solid = false);
	          }
	          if (!updating_size && dirty[0] & /*iconSize*/64) {
	            updating_size = true;
	            icon_1_changes.size = /*iconSize*/ctx[6];
	            add_flush_callback$1(() => updating_size = false);
	          }
	          if (!updating_constraint && dirty[0] & /*iconConstraint*/128) {
	            updating_constraint = true;
	            icon_1_changes.constraint = /*iconConstraint*/ctx[7];
	            add_flush_callback$1(() => updating_constraint = false);
	          }
	          if (!updating_theme && dirty[0] & /*_theme*/16384) {
	            updating_theme = true;
	            icon_1_changes.theme = /*_theme*/ctx[14];
	            add_flush_callback$1(() => updating_theme = false);
	          }
	          icon_1.$set(icon_1_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(icon_1.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(icon_1.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(icon_1);
	        }
	      };
	    }

	    // (4:4) {#if loading}
	    function create_if_block_3(ctx) {
	      let spinner;
	      let current;
	      spinner = new Spinner({
	        props: {
	          diameter: "24"
	        }
	      });
	      return {
	        c() {
	          create_component$1(spinner.$$.fragment);
	        },
	        m(target, anchor) {
	          mount_component$1(spinner, target, anchor);
	          current = true;
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(spinner.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(spinner.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          destroy_component$1(spinner, detaching);
	        }
	      };
	    }

	    // (7:4) {#if !loading}
	    function create_if_block_1$1(ctx) {
	      let if_block_anchor;
	      let current;
	      let if_block = /*_hasIcon*/ctx[13] && create_if_block_2$1(ctx);
	      return {
	        c() {
	          if (if_block) if_block.c();
	          if_block_anchor = empty$1();
	        },
	        m(target, anchor) {
	          if (if_block) if_block.m(target, anchor);
	          insert$1(target, if_block_anchor, anchor);
	          current = true;
	        },
	        p(ctx, dirty) {
	          if (/*_hasIcon*/ctx[13]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	              if (dirty[0] & /*_hasIcon*/8192) {
	                transition_in$1(if_block, 1);
	              }
	            } else {
	              if_block = create_if_block_2$1(ctx);
	              if_block.c();
	              transition_in$1(if_block, 1);
	              if_block.m(if_block_anchor.parentNode, if_block_anchor);
	            }
	          } else if (if_block) {
	            group_outros$1();
	            transition_out$1(if_block, 1, 1, () => {
	              if_block = null;
	            });
	            check_outros$1();
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (if_block) if_block.d(detaching);
	          if (detaching) detach$1(if_block_anchor);
	        }
	      };
	    }

	    // (8:6) {#if _hasIcon}
	    function create_if_block_2$1(ctx) {
	      let div;
	      let icon_1;
	      let updating_name;
	      let updating_path;
	      let updating_url;
	      let updating_solid;
	      let updating_size;
	      let updating_constraint;
	      let updating_theme;
	      let current;
	      function icon_1_name_binding(value) {
	        /*icon_1_name_binding*/ctx[35](value);
	      }
	      function icon_1_path_binding(value) {
	        /*icon_1_path_binding*/ctx[36](value);
	      }
	      function icon_1_url_binding(value) {
	        /*icon_1_url_binding*/ctx[37](value);
	      }
	      function icon_1_solid_binding(value) {
	        /*icon_1_solid_binding*/ctx[38](value);
	      }
	      function icon_1_size_binding(value) {
	        /*icon_1_size_binding*/ctx[39](value);
	      }
	      function icon_1_constraint_binding(value) {
	        /*icon_1_constraint_binding*/ctx[40](value);
	      }
	      function icon_1_theme_binding(value) {
	        /*icon_1_theme_binding*/ctx[41](value);
	      }
	      let icon_1_props = {
	        mode: "button"
	      };
	      if (/*iconName*/ctx[0] !== void 0) {
	        icon_1_props.name = /*iconName*/ctx[0];
	      }
	      if (/*iconPath*/ctx[1] !== void 0) {
	        icon_1_props.path = /*iconPath*/ctx[1];
	      }
	      if (/*iconUrl*/ctx[2] !== void 0) {
	        icon_1_props.url = /*iconUrl*/ctx[2];
	      }
	      if (/*_solid*/ctx[19] !== void 0) {
	        icon_1_props.solid = /*_solid*/ctx[19];
	      }
	      if (/*iconSize*/ctx[6] !== void 0) {
	        icon_1_props.size = /*iconSize*/ctx[6];
	      }
	      if (/*iconConstraint*/ctx[7] !== void 0) {
	        icon_1_props.constraint = /*iconConstraint*/ctx[7];
	      }
	      if (/*_theme*/ctx[14] !== void 0) {
	        icon_1_props.theme = /*_theme*/ctx[14];
	      }
	      icon_1 = new Icon$1({
	        props: icon_1_props
	      });
	      binding_callbacks$1.push(() => bind$1(icon_1, "name", icon_1_name_binding));
	      binding_callbacks$1.push(() => bind$1(icon_1, "path", icon_1_path_binding));
	      binding_callbacks$1.push(() => bind$1(icon_1, "url", icon_1_url_binding));
	      binding_callbacks$1.push(() => bind$1(icon_1, "solid", icon_1_solid_binding));
	      binding_callbacks$1.push(() => bind$1(icon_1, "size", icon_1_size_binding));
	      binding_callbacks$1.push(() => bind$1(icon_1, "constraint", icon_1_constraint_binding));
	      binding_callbacks$1.push(() => bind$1(icon_1, "theme", icon_1_theme_binding));
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(icon_1.$$.fragment);
	          attr$1(div, "class", "pros-icon-container svelte-192il0a");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(icon_1, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const icon_1_changes = {};
	          if (!updating_name && dirty[0] & /*iconName*/1) {
	            updating_name = true;
	            icon_1_changes.name = /*iconName*/ctx[0];
	            add_flush_callback$1(() => updating_name = false);
	          }
	          if (!updating_path && dirty[0] & /*iconPath*/2) {
	            updating_path = true;
	            icon_1_changes.path = /*iconPath*/ctx[1];
	            add_flush_callback$1(() => updating_path = false);
	          }
	          if (!updating_url && dirty[0] & /*iconUrl*/4) {
	            updating_url = true;
	            icon_1_changes.url = /*iconUrl*/ctx[2];
	            add_flush_callback$1(() => updating_url = false);
	          }
	          if (!updating_solid && dirty[0] & /*_solid*/524288) {
	            updating_solid = true;
	            icon_1_changes.solid = /*_solid*/ctx[19];
	            add_flush_callback$1(() => updating_solid = false);
	          }
	          if (!updating_size && dirty[0] & /*iconSize*/64) {
	            updating_size = true;
	            icon_1_changes.size = /*iconSize*/ctx[6];
	            add_flush_callback$1(() => updating_size = false);
	          }
	          if (!updating_constraint && dirty[0] & /*iconConstraint*/128) {
	            updating_constraint = true;
	            icon_1_changes.constraint = /*iconConstraint*/ctx[7];
	            add_flush_callback$1(() => updating_constraint = false);
	          }
	          if (!updating_theme && dirty[0] & /*_theme*/16384) {
	            updating_theme = true;
	            icon_1_changes.theme = /*_theme*/ctx[14];
	            add_flush_callback$1(() => updating_theme = false);
	          }
	          icon_1.$set(icon_1_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(icon_1.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(icon_1.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(icon_1);
	        }
	      };
	    }
	    function create_fragment$2(ctx) {
	      let current_block_type_index;
	      let if_block;
	      let if_block_anchor;
	      let current;
	      const if_block_creators = [create_if_block$2, create_else_block];
	      const if_blocks = [];
	      function select_block_type(ctx, dirty) {
	        if (/*_iconOnly*/ctx[12]) return 0;
	        return 1;
	      }
	      current_block_type_index = select_block_type(ctx);
	      if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      return {
	        c() {
	          if_block.c();
	          if_block_anchor = empty$1();
	        },
	        m(target, anchor) {
	          if_blocks[current_block_type_index].m(target, anchor);
	          insert$1(target, if_block_anchor, anchor);
	          current = true;
	        },
	        p(ctx, dirty) {
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros$1();
	            transition_out$1(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros$1();
	            if_block = if_blocks[current_block_type_index];
	            if (!if_block) {
	              if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block.c();
	            } else {
	              if_block.p(ctx, dirty);
	            }
	            transition_in$1(if_block, 1);
	            if_block.m(if_block_anchor.parentNode, if_block_anchor);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if_blocks[current_block_type_index].d(detaching);
	          if (detaching) detach$1(if_block_anchor);
	        }
	      };
	    }
	    function hasValue$1(test) {
	      return test !== undefined && test !== null;
	    }
	    function instance$2($$self, $$props, $$invalidate) {
	      const dispatch = createEventDispatcher$1();
	      let {
	        mode = "default"
	      } = $$props; // Icon, Button, Toolbar_Icon, Toolbar_Button
	      let {
	        display = "primary"
	      } = $$props; // primary, secondary, ghost, panel
	      let {
	        theme = "light"
	      } = $$props; // auto, light, dark
	      let {
	        shape = "round"
	      } = $$props; // round/sharp
	      let {
	        density = "standard"
	      } = $$props; // standard/high
	      let {
	        scheme = "default"
	      } = $$props; // default/positive/negative/warning
	      let {
	        iconName = ""
	      } = $$props; // Name of veneer image (E.G. 'alarm')
	      let {
	        iconPath = ""
	      } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	      let {
	        iconUrl = ""
	      } = $$props; // Full path of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	      let {
	        iconPosition = "left"
	      } = $$props; // Icon to left or right of text
	      let {
	        iconSize = "24px"
	      } = $$props; // Icon to left or right of text
	      let {
	        iconConstraint = "h"
	      } = $$props; // Icon to left or right of text
	      let {
	        icon = false
	      } = $$props; // Icon to left or right of text
	      let {
	        label = ""
	      } = $$props; // Button name or Tooltip for Icon Button
	      let {
	        className = ""
	      } = $$props; // Class name
	      let {
	        disabled = false
	      } = $$props;
	      let {
	        solid = false
	      } = $$props;
	      let {
	        height
	      } = $$props;
	      let {
	        width
	      } = $$props;
	      let {
	        loading = false
	      } = $$props;
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _hasIcon = false;
	      let _iconOnly = false;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _class;
	      let _style = "";
	      let _solid = false;
	      let _buttonWrapper;
	      let _width;
	      let _height;
	      let _id;
	      onMount$1(() => {}); // _buttonWrapper.parentElement.style.height = _height;

	      beforeUpdate$1(() => {
	        $$invalidate(23, theme = hasValue$1(theme) ? theme : "light");
	        $$invalidate(3, mode = hasValue$1(mode) ? mode : "default");
	        $$invalidate(4, scheme = hasValue$1(scheme) ? scheme : "default");
	        $$invalidate(19, _solid = hasValue$1(solid) ? solid === true || solid === "true" : false);
	        $$invalidate(17, _class = hasValue$1(className) ? className : "");
	        $$invalidate(5, iconPosition = hasValue$1(iconPosition) ? iconPosition : "left");
	        $$invalidate(21, _id = hasValue$1(id) ? `${id}-click` : undefined);
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(14, _theme = themeAttribute ? themeAttribute : "light");
	            window.removeEventListener("posh-theme-changed", handleThemeChanged);
	            window.addEventListener("posh-theme-changed", handleThemeChanged);
	          } else {
	            $$invalidate(14, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(15, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(15, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(15, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(16, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(16, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(16, _density = density);
	          }
	        }
	      });
	      onDestroy$1(() => {
	        window.removeEventListener("posh-theme-changed", handleThemeChanged);
	      });
	      function handleThemeChanged(event) {
	        if (theme === "auto") {
	          $$invalidate(14, _theme = event.detail.theme);
	        }
	      }
	      function handleClick(event) {
	        if (disabled) {
	          event.stopPropagation();
	          return;
	        }
	        _buttonWrapper.blur();
	        window.setTimeout(() => {
	          dispatch("clicked", event);
	        });
	      }
	      function icon_1_name_binding(value) {
	        iconName = value;
	        $$invalidate(0, iconName);
	      }
	      function icon_1_path_binding(value) {
	        iconPath = value;
	        $$invalidate(1, iconPath);
	      }
	      function icon_1_url_binding(value) {
	        iconUrl = value;
	        $$invalidate(2, iconUrl);
	      }
	      function icon_1_solid_binding(value) {
	        _solid = value;
	        $$invalidate(19, _solid);
	      }
	      function icon_1_size_binding(value) {
	        iconSize = value;
	        $$invalidate(6, iconSize);
	      }
	      function icon_1_constraint_binding(value) {
	        iconConstraint = value;
	        $$invalidate(7, iconConstraint);
	      }
	      function icon_1_theme_binding(value) {
	        _theme = value;
	        $$invalidate(14, _theme);
	      }
	      function button_binding($$value) {
	        binding_callbacks$1[$$value ? "unshift" : "push"](() => {
	          _buttonWrapper = $$value;
	          $$invalidate(20, _buttonWrapper);
	        });
	      }
	      function icon_1_name_binding_1(value) {
	        iconName = value;
	        $$invalidate(0, iconName);
	      }
	      function icon_1_path_binding_1(value) {
	        iconPath = value;
	        $$invalidate(1, iconPath);
	      }
	      function icon_1_url_binding_1(value) {
	        iconUrl = value;
	        $$invalidate(2, iconUrl);
	      }
	      function icon_1_solid_binding_1(value) {
	        _solid = value;
	        $$invalidate(19, _solid);
	      }
	      function icon_1_size_binding_1(value) {
	        iconSize = value;
	        $$invalidate(6, iconSize);
	      }
	      function icon_1_constraint_binding_1(value) {
	        iconConstraint = value;
	        $$invalidate(7, iconConstraint);
	      }
	      function icon_1_theme_binding_1(value) {
	        _theme = value;
	        $$invalidate(14, _theme);
	      }
	      function icon_1_name_binding_2(value) {
	        iconName = value;
	        $$invalidate(0, iconName);
	      }
	      function icon_1_path_binding_2(value) {
	        iconPath = value;
	        $$invalidate(1, iconPath);
	      }
	      function icon_1_url_binding_2(value) {
	        iconUrl = value;
	        $$invalidate(2, iconUrl);
	      }
	      function icon_1_solid_binding_2(value) {
	        _solid = value;
	        $$invalidate(19, _solid);
	      }
	      function icon_1_size_binding_2(value) {
	        iconSize = value;
	        $$invalidate(6, iconSize);
	      }
	      function icon_1_constraint_binding_2(value) {
	        iconConstraint = value;
	        $$invalidate(7, iconConstraint);
	      }
	      function icon_1_theme_binding_2(value) {
	        _theme = value;
	        $$invalidate(14, _theme);
	      }
	      function button_binding_1($$value) {
	        binding_callbacks$1[$$value ? "unshift" : "push"](() => {
	          _buttonWrapper = $$value;
	          $$invalidate(20, _buttonWrapper);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("mode" in $$props) $$invalidate(3, mode = $$props.mode);
	        if ("display" in $$props) $$invalidate(8, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(23, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(24, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(25, density = $$props.density);
	        if ("scheme" in $$props) $$invalidate(4, scheme = $$props.scheme);
	        if ("iconName" in $$props) $$invalidate(0, iconName = $$props.iconName);
	        if ("iconPath" in $$props) $$invalidate(1, iconPath = $$props.iconPath);
	        if ("iconUrl" in $$props) $$invalidate(2, iconUrl = $$props.iconUrl);
	        if ("iconPosition" in $$props) $$invalidate(5, iconPosition = $$props.iconPosition);
	        if ("iconSize" in $$props) $$invalidate(6, iconSize = $$props.iconSize);
	        if ("iconConstraint" in $$props) $$invalidate(7, iconConstraint = $$props.iconConstraint);
	        if ("icon" in $$props) $$invalidate(26, icon = $$props.icon);
	        if ("label" in $$props) $$invalidate(9, label = $$props.label);
	        if ("className" in $$props) $$invalidate(27, className = $$props.className);
	        if ("disabled" in $$props) $$invalidate(10, disabled = $$props.disabled);
	        if ("solid" in $$props) $$invalidate(28, solid = $$props.solid);
	        if ("height" in $$props) $$invalidate(29, height = $$props.height);
	        if ("width" in $$props) $$invalidate(30, width = $$props.width);
	        if ("loading" in $$props) $$invalidate(11, loading = $$props.loading);
	        if ("id" in $$props) $$invalidate(31, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*iconName, iconPath, iconUrl, _iconOnly, width, height, _style, icon*/1677987847 | $$self.$$.dirty[1] & /*_width, _height*/12) {
	          // onState
	          {
	            if (iconName || iconPath || iconUrl) {
	              $$invalidate(13, _hasIcon = true);
	            }
	            $$invalidate(18, _style = "");
	            const dw = _iconOnly ? null : "auto";
	            $$invalidate(33, _width = hasValue$1(width) ? width : dw);
	            if (_width) {
	              $$invalidate(33, _width = isNaN(_width) ? _width : `${_width}px`);
	            } // _buttonWrapper.parentElement.style.minWidth = _width;

	            $$invalidate(34, _height = hasValue$1(height) ? height : null);
	            if (_height) {
	              $$invalidate(34, _height = isNaN(_height) ? _height : `${_height}px`);
	            }
	            if (_width) {
	              $$invalidate(18, _style += `min-width:${_width};`);
	            }
	            if (_height) {
	              $$invalidate(18, _style += `height:${_height};`);
	            }
	            $$invalidate(12, _iconOnly = hasValue$1(icon) ? icon : false);
	          }
	        }
	      };
	      return [iconName, iconPath, iconUrl, mode, scheme, iconPosition, iconSize, iconConstraint, display, label, disabled, loading, _iconOnly, _hasIcon, _theme, _shape, _density, _class, _style, _solid, _buttonWrapper, _id, handleClick, theme, shape, density, icon, className, solid, height, width, id, hasValue$1, _width, _height, icon_1_name_binding, icon_1_path_binding, icon_1_url_binding, icon_1_solid_binding, icon_1_size_binding, icon_1_constraint_binding, icon_1_theme_binding, button_binding, icon_1_name_binding_1, icon_1_path_binding_1, icon_1_url_binding_1, icon_1_solid_binding_1, icon_1_size_binding_1, icon_1_constraint_binding_1, icon_1_theme_binding_1, icon_1_name_binding_2, icon_1_path_binding_2, icon_1_url_binding_2, icon_1_solid_binding_2, icon_1_size_binding_2, icon_1_constraint_binding_2, icon_1_theme_binding_2, button_binding_1];
	    }
	    class Button extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-192il0a-style")) add_css$2();
	        init$1(this, options, instance$2, create_fragment$2, safe_not_equal$1, {
	          mode: 3,
	          display: 8,
	          theme: 23,
	          shape: 24,
	          density: 25,
	          scheme: 4,
	          iconName: 0,
	          iconPath: 1,
	          iconUrl: 2,
	          iconPosition: 5,
	          iconSize: 6,
	          iconConstraint: 7,
	          icon: 26,
	          label: 9,
	          className: 27,
	          disabled: 10,
	          solid: 28,
	          height: 29,
	          width: 30,
	          loading: 11,
	          id: 31,
	          hasValue: 32
	        }, [-1, -1, -1]);
	      }
	      get hasValue() {
	        return hasValue$1;
	      }
	    }

	    /* src/cells/ActionCell.svelte generated by Svelte v3.38.2 */
	    const {
	      document: document_1$1
	    } = globals$1;
	    function add_css$1() {
	      var style = element$1("style");
	      style.id = "svelte-12sytby-style";
	      style.textContent = ".pros-action-cell{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:100%}.pros-action-cell.has-actions{cursor:pointer}.pros-action-cell .pros-action-cell-container{display:flex;flex-direction:column;justify-content:center;align-items:center;display:none;cursor:default}.pros-action-cell .pros-action-cell-container.open{display:inherit}.pros-action-cell svg{height:100%;width:100%}.pros-actions-wrapper{position:fixed;display:none;max-width:100%;border-width:1px;border-style:solid;box-sizing:border-box;border-radius:12px;z-index:1001;overflow:hidden}.pros-actions-wrapper.open{display:inherit}.pros-actions-container{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%}.pros-actions-container .pros-options-border-container{padding:8px}.pros-actions-container .pros-actions{width:100%;overflow:auto;padding:8px;box-sizing:border-box}.pros-actions-container .pros-actions .pros-option-list .pros-option-row{display:flex;justify-content:flex-start;align-items:center;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;cursor:pointer;padding:6px 8px}.pros-actions-container .pros-actions .pros-option-list .pros-option-row else{flex-direction:row}.pros-actions-container .pros-actions .pros-option-list .pros-option-row:not(:last-of-type){margin-bottom:4px}.pros-actions-container .pros-actions .pros-option-list .pros-option-row .menu-label{margin-left:8px}.pros-actions-container ::-webkit-scrollbar{width:6px;height:6px}.pros-actions-container ::-webkit-scrollbar-track{background-color:transparent}.pros-actions-container ::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:6px}.pros-actions-wrapper[pos--theme=light]{background-color:#FFFFFF;color:#363636;border-color:transparent;box-shadow:0 8px 20px rgba(33, 33, 33, 0.2)}.pros-actions-wrapper[pos--theme=light] .pros-actions-container .pros-actions .pros-option-row.highlight{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-actions-wrapper[pos--theme=light] .pros-actions-container .pros-actions .pros-option-row:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-actions-wrapper[pos--theme=light] .pros-actions-container .pros-actions .pros-option-row.selected{background-color:#027aae;color:white}.pros-actions-wrapper[pos--theme=dark]{background-color:#2b2b2b;color:#ffffff;border-color:transparent;box-shadow:0 8px 20px rgba(33, 33, 33, 0.2)}.pros-actions-wrapper[pos--theme=dark] .pros-actions-container .pros-actions .pros-option-row{color:#ffffff}.pros-actions-wrapper[pos--theme=dark] .pros-actions-container .pros-actions .pros-option-row.highlight{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-actions-wrapper[pos--theme=dark] .pros-actions-container .pros-actions .pros-option-row:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-actions-wrapper[pos--theme=dark] .pros-actions-container .pros-actions .pros-option-row.selected{background-color:#3ab4eb;color:#212121}";
	      append$1(document_1$1.head, style);
	    }
	    function get_each_context(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[29] = list[i];
	      return child_ctx;
	    }

	    // (2:2) {#if _actions.length === 1 }
	    function create_if_block_2(ctx) {
	      let div;
	      let button;
	      let updating_theme;
	      let current;
	      function button_theme_binding(value) {
	        /*button_theme_binding*/ctx[16](value);
	      }
	      let button_props = {
	        iconPath: /*_actions*/ctx[0][0].iconName,
	        label: /*_actions*/ctx[0][0].display,
	        mode: "action",
	        icon: true
	      };
	      if (/*_theme*/ctx[2] !== void 0) {
	        button_props.theme = /*_theme*/ctx[2];
	      }
	      button = new Button({
	        props: button_props
	      });
	      binding_callbacks$1.push(() => bind$1(button, "theme", button_theme_binding));
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(button.$$.fragment);
	          attr$1(div, "class", "pros-action-cell-container");
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(button, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const button_changes = {};
	          if (dirty[0] & /*_actions*/1) button_changes.iconPath = /*_actions*/ctx[0][0].iconName;
	          if (dirty[0] & /*_actions*/1) button_changes.label = /*_actions*/ctx[0][0].display;
	          if (!updating_theme && dirty[0] & /*_theme*/4) {
	            updating_theme = true;
	            button_changes.theme = /*_theme*/ctx[2];
	            add_flush_callback$1(() => updating_theme = false);
	          }
	          button.$set(button_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(button.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(button.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(button);
	        }
	      };
	    }

	    // (7:2) {#if _actions.length > 1 }
	    function create_if_block$1(ctx) {
	      let div;
	      let button;
	      let updating_theme;
	      let t;
	      let if_block_anchor;
	      let current;
	      function button_theme_binding_1(value) {
	        /*button_theme_binding_1*/ctx[17](value);
	      }
	      let button_props = {
	        iconName: "ellipsis",
	        label: "Actions",
	        mode: "action",
	        icon: true
	      };
	      if (/*_theme*/ctx[2] !== void 0) {
	        button_props.theme = /*_theme*/ctx[2];
	      }
	      button = new Button({
	        props: button_props
	      });
	      binding_callbacks$1.push(() => bind$1(button, "theme", button_theme_binding_1));
	      let if_block = /*open*/ctx[1] && create_if_block_1(ctx);
	      return {
	        c() {
	          div = element$1("div");
	          create_component$1(button.$$.fragment);
	          t = space$1();
	          if (if_block) if_block.c();
	          if_block_anchor = empty$1();
	          attr$1(div, "class", "pros-action-cell-container");
	          toggle_class$1(div, "open", /*open*/ctx[1]);
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          mount_component$1(button, div, null);
	          insert$1(target, t, anchor);
	          if (if_block) if_block.m(target, anchor);
	          insert$1(target, if_block_anchor, anchor);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const button_changes = {};
	          if (!updating_theme && dirty[0] & /*_theme*/4) {
	            updating_theme = true;
	            button_changes.theme = /*_theme*/ctx[2];
	            add_flush_callback$1(() => updating_theme = false);
	          }
	          button.$set(button_changes);
	          if (dirty[0] & /*open*/2) {
	            toggle_class$1(div, "open", /*open*/ctx[1]);
	          }
	          if (/*open*/ctx[1]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	              if (dirty[0] & /*open*/2) {
	                transition_in$1(if_block, 1);
	              }
	            } else {
	              if_block = create_if_block_1(ctx);
	              if_block.c();
	              transition_in$1(if_block, 1);
	              if_block.m(if_block_anchor.parentNode, if_block_anchor);
	            }
	          } else if (if_block) {
	            group_outros$1();
	            transition_out$1(if_block, 1, 1, () => {
	              if_block = null;
	            });
	            check_outros$1();
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(button.$$.fragment, local);
	          transition_in$1(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(button.$$.fragment, local);
	          transition_out$1(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          destroy_component$1(button);
	          if (detaching) detach$1(t);
	          if (if_block) if_block.d(detaching);
	          if (detaching) detach$1(if_block_anchor);
	        }
	      };
	    }

	    // (11:4) {#if open}
	    function create_if_block_1(ctx) {
	      let div3;
	      let div2;
	      let div1;
	      let div0;
	      let current;
	      let mounted;
	      let dispose;
	      let each_value = /*_actions*/ctx[0];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	      }
	      const out = i => transition_out$1(each_blocks[i], 1, 1, () => {
	        each_blocks[i] = null;
	      });
	      return {
	        c() {
	          div3 = element$1("div");
	          div2 = element$1("div");
	          div1 = element$1("div");
	          div0 = element$1("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          attr$1(div0, "class", "pros-option-list");
	          attr$1(div1, "class", "pros-actions");
	          attr$1(div2, "id", "pros-actions-container");
	          attr$1(div2, "class", "pros-actions-container");
	          attr$1(div3, "class", "pros-actions-wrapper");
	          attr$1(div3, "pos--theme", /*_theme*/ctx[2]);
	          toggle_class$1(div3, "open", /*open*/ctx[1]);
	        },
	        m(target, anchor) {
	          insert$1(target, div3, anchor);
	          append$1(div3, div2);
	          append$1(div2, div1);
	          append$1(div1, div0);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div0, null);
	          }
	          current = true;
	          if (!mounted) {
	            dispose = [action_destroyer$1(/*globalClicks*/ctx[6].call(null, div3)), action_destroyer$1(/*positionOptions*/ctx[7].call(null, div3))];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_actionsId, _actions, handleActionClick, _theme*/45) {
	            each_value = /*_actions*/ctx[0];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	                transition_in$1(each_blocks[i], 1);
	              } else {
	                each_blocks[i] = create_each_block(child_ctx);
	                each_blocks[i].c();
	                transition_in$1(each_blocks[i], 1);
	                each_blocks[i].m(div0, null);
	              }
	            }
	            group_outros$1();
	            for (i = each_value.length; i < each_blocks.length; i += 1) {
	              out(i);
	            }
	            check_outros$1();
	          }
	          if (!current || dirty[0] & /*_theme*/4) {
	            attr$1(div3, "pos--theme", /*_theme*/ctx[2]);
	          }
	          if (dirty[0] & /*open*/2) {
	            toggle_class$1(div3, "open", /*open*/ctx[1]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          for (let i = 0; i < each_value.length; i += 1) {
	            transition_in$1(each_blocks[i]);
	          }
	          current = true;
	        },
	        o(local) {
	          each_blocks = each_blocks.filter(Boolean);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            transition_out$1(each_blocks[i]);
	          }
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div3);
	          destroy_each$1(each_blocks, detaching);
	          mounted = false;
	          run_all$1(dispose);
	        }
	      };
	    }

	    // (16:10) {#each _actions as action}
	    function create_each_block(ctx) {
	      let div1;
	      let icon;
	      let updating_theme;
	      let t0;
	      let div0;
	      let t1_value = /*action*/ctx[29].display + "";
	      let t1;
	      let t2;
	      let div1_id_value;
	      let current;
	      let mounted;
	      let dispose;
	      function icon_theme_binding(value) {
	        /*icon_theme_binding*/ctx[18](value);
	      }
	      let icon_props = {
	        path: /*action*/ctx[29].iconName,
	        height: "24px"
	      };
	      if (/*_theme*/ctx[2] !== void 0) {
	        icon_props.theme = /*_theme*/ctx[2];
	      }
	      icon = new Icon$1({
	        props: icon_props
	      });
	      binding_callbacks$1.push(() => bind$1(icon, "theme", icon_theme_binding));
	      return {
	        c() {
	          div1 = element$1("div");
	          create_component$1(icon.$$.fragment);
	          t0 = space$1();
	          div0 = element$1("div");
	          t1 = text$1(t1_value);
	          t2 = space$1();
	          attr$1(div0, "class", "menu-label");
	          attr$1(div0, "pros-tooltip", "");
	          attr$1(div1, "id", div1_id_value = "" + (/*_actionsId*/ctx[3] + "-" + /*action*/ctx[29].id));
	          attr$1(div1, "class", "pros-option-row");
	        },
	        m(target, anchor) {
	          insert$1(target, div1, anchor);
	          mount_component$1(icon, div1, null);
	          append$1(div1, t0);
	          append$1(div1, div0);
	          append$1(div0, t1);
	          append$1(div1, t2);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(div1, "click", function () {
	              if (is_function$1(/*handleActionClick*/ctx[5](/*action*/ctx[29]))) /*handleActionClick*/ctx[5](/*action*/ctx[29]).apply(this, arguments);
	            });
	            mounted = true;
	          }
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          const icon_changes = {};
	          if (dirty[0] & /*_actions*/1) icon_changes.path = /*action*/ctx[29].iconName;
	          if (!updating_theme && dirty[0] & /*_theme*/4) {
	            updating_theme = true;
	            icon_changes.theme = /*_theme*/ctx[2];
	            add_flush_callback$1(() => updating_theme = false);
	          }
	          icon.$set(icon_changes);
	          if ((!current || dirty[0] & /*_actions*/1) && t1_value !== (t1_value = /*action*/ctx[29].display + "")) set_data$1(t1, t1_value);
	          if (!current || dirty[0] & /*_actionsId, _actions*/9 && div1_id_value !== (div1_id_value = "" + (/*_actionsId*/ctx[3] + "-" + /*action*/ctx[29].id))) {
	            attr$1(div1, "id", div1_id_value);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(icon.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(icon.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div1);
	          destroy_component$1(icon);
	          mounted = false;
	          dispose();
	        }
	      };
	    }
	    function create_fragment$1(ctx) {
	      let div;
	      let t;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_actions*/ctx[0].length === 1 && create_if_block_2(ctx);
	      let if_block1 = /*_actions*/ctx[0].length > 1 && create_if_block$1(ctx);
	      return {
	        c() {
	          div = element$1("div");
	          if (if_block0) if_block0.c();
	          t = space$1();
	          if (if_block1) if_block1.c();
	          attr$1(div, "id", /*_actionsId*/ctx[3]);
	          attr$1(div, "class", "pros-action-cell");
	          toggle_class$1(div, "has-actions", /*_actions*/ctx[0].length > 0);
	        },
	        m(target, anchor) {
	          insert$1(target, div, anchor);
	          if (if_block0) if_block0.m(div, null);
	          append$1(div, t);
	          if (if_block1) if_block1.m(div, null);
	          current = true;
	          if (!mounted) {
	            dispose = listen$1(div, "click", /*handleCellClick*/ctx[4]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_actions*/ctx[0].length === 1) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	              if (dirty[0] & /*_actions*/1) {
	                transition_in$1(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_2(ctx);
	              if_block0.c();
	              transition_in$1(if_block0, 1);
	              if_block0.m(div, t);
	            }
	          } else if (if_block0) {
	            group_outros$1();
	            transition_out$1(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros$1();
	          }
	          if (/*_actions*/ctx[0].length > 1) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty[0] & /*_actions*/1) {
	                transition_in$1(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block$1(ctx);
	              if_block1.c();
	              transition_in$1(if_block1, 1);
	              if_block1.m(div, null);
	            }
	          } else if (if_block1) {
	            group_outros$1();
	            transition_out$1(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros$1();
	          }
	          if (!current || dirty[0] & /*_actionsId*/8) {
	            attr$1(div, "id", /*_actionsId*/ctx[3]);
	          }
	          if (dirty[0] & /*_actions*/1) {
	            toggle_class$1(div, "has-actions", /*_actions*/ctx[0].length > 0);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block0);
	          transition_in$1(if_block1);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block0);
	          transition_out$1(if_block1);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div);
	          if (if_block0) if_block0.d();
	          if (if_block1) if_block1.d();
	          mounted = false;
	          dispose();
	        }
	      };
	    }
	    function instance$1($$self, $$props, $$invalidate) {
	      createEventDispatcher$1();
	      let {
	        params = undefined
	      } = $$props;
	      let {
	        _rowSelected = false
	      } = $$props;
	      let {
	        _actions = []
	      } = $$props;
	      let {
	        open = false
	      } = $$props;
	      let {
	        globalClickListener = null
	      } = $$props;
	      let {
	        _globalClicksNode = null
	      } = $$props; // Active Global clicks node for selecting in list
	      let {
	        _openNode = undefined
	      } = $$props;
	      let {
	        _openParent = undefined
	      } = $$props;
	      let {
	        _theme = undefined
	      } = $$props;
	      let {
	        _actionsOpenedEventListener = undefined
	      } = $$props;
	      let _gridId = null;
	      let _colId = null;
	      let _actionsId = null;
	      beforeUpdate$1(() => {
	        _gridId = get$1(params, "column.colDef.printOSOptions.grid.id");
	        _colId = get$1(params, "column.colDef.colId");
	        $$invalidate(3, _actionsId = _gridId ? `${_gridId}-${_colId}-actions` : `${_colId}-actions`);
	      });
	      onMount$1(() => {
	        $$invalidate(2, _theme = params.column.colDef.printos.getTheme());
	        $$invalidate(0, _actions = []);
	        let actions = get$1(params, "colDef.printos.callbacks.actions", []);
	        actions.forEach(action => {
	          let allowAction = true;
	          if (action.allow) {
	            allowAction = action.allow();
	          }
	          let allowRow = true;
	          if (action.allowRow) {
	            allowRow = action.allowRow(params.data);
	          }
	          if (allowAction && allowRow) {
	            _actions.push(action);
	          }
	        });
	        window.addEventListener("posh-grid-selection-changed", handleSelectionChanged);
	        window.addEventListener("posh-theme-changed", handleThemeChanged);
	      });
	      onDestroy$1(() => {
	        window.removeEventListener("posh-grid-selection-changed", handleSelectionChanged);
	        window.removeEventListener("posh-theme-changed", handleThemeChanged);
	      });
	      function handleSelectionChanged() {
	        $$invalidate(8, _rowSelected = params.node.isSelected());
	      }
	      function handleThemeChanged() {
	        $$invalidate(2, _theme = params.column.colDef.printos.getTheme());
	      }
	      function handleCellClick(event) {
	        if (_actions.length === 0) {
	          return;
	        }
	        event.stopPropagation();
	        event.preventDefault();
	        if (_actions.length === 1) {
	          handleActionClick(_actions[0]);
	          return;
	        }
	        if (open) {
	          // console.log('SB: handleClick:Close');
	          closeOptions();
	          window.removeEventListener("posgrid-actions-opened", _actionsOpenedEventListener);
	          $$invalidate(13, _actionsOpenedEventListener = undefined);
	        } else {
	          // console.log('SB: handleClick:Open');
	          window.dispatchEvent(new Event("posgrid-actions-opened", {}));
	          $$invalidate(13, _actionsOpenedEventListener = window.addEventListener("posgrid-actions-opened", event => {
	            closeOptions();
	          }));
	          openOptions();
	        }
	      }
	      function openOptions() {
	        $$invalidate(1, open = true);
	      }
	      function closeOptions() {
	        // Re-parent options
	        if (_openParent) {
	          _openParent.appendChild(_openNode);
	        }
	        $$invalidate(11, _openNode = undefined);
	        $$invalidate(12, _openParent = undefined);
	        if (globalClickListener) {
	          document.removeEventListener("click", globalClickListener);
	          $$invalidate(9, globalClickListener = null);
	        }
	        $$invalidate(1, open = false);
	        document.removeEventListener("wheel", handleScroll);
	        window.removeEventListener("scroll", handleScroll);
	        window.removeEventListener("resize", handleScroll);
	      }
	      function handleActionClick(action) {
	        closeOptions();
	        if (!action.callback) {
	          console.warn(`Developer Hint: No callback defined for action: ${action.id}`);
	          return;
	        }
	        window.setTimeout(() => {
	          action.callback(params.data);
	        });
	      }

	      // Actions
	      function globalClicks(node) {
	        $$invalidate(10, _globalClicksNode = node);
	        $$invalidate(9, globalClickListener = event => {
	          let elements = [node];

	          // Change NodeList to Array to use some()
	          elements = Array.prototype.slice.call(elements);
	          let containsClick = elements.some(element => {
	            return element.contains(event.target);
	          });
	          if (!containsClick || _openNode) {
	            // console.log('SB: globalClicks: close Options');
	            closeOptions();
	          }
	        });

	        // Necessary to prevent handling click that opens panel
	        window.setTimeout(() => {
	          document.addEventListener("click", globalClickListener);
	        }, 0);
	      }
	      function positionOptions(node) {
	        $$invalidate(11, _openNode = node);
	        $$invalidate(12, _openParent = node.parentElement);

	        // console.log('positionOptions', _openNode, _openParent);
	        document.body.appendChild(node);
	        positionNode();
	        document.addEventListener("wheel", handleScroll);
	        window.addEventListener("scroll", handleScroll, true);
	        window.addEventListener("resize", handleScroll);
	        return {
	          destroy() {
	            document.removeEventListener("wheel", handleScroll);
	            window.removeEventListener("scroll", handleScroll);
	            window.removeEventListener("resize", handleScroll);
	          }
	        };
	      } // let parent = node.parentElement;
	      // node.style.width = `${parent.offsetWidth}px`;

	      function positionNode(event) {
	        if (!_openParent) {
	          document.removeEventListener("wheel", handleScroll);
	          window.removeEventListener("scroll", handleScroll);
	          window.removeEventListener("resize", handleScroll);
	          return;
	        }
	        let adjustedTop;
	        let bodyRect = document.body.getBoundingClientRect();
	        let rect = _openParent.getBoundingClientRect();
	        if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	          adjustedTop = rect.top >= _openNode.offsetHeight ? `${rect.top - _openNode.offsetHeight}px` : `0px`;
	        }
	        if (event) {
	          let scrollTop = event.target.scrollTop;
	          let scrollBottom = scrollTop + event.target.clientHeight;
	          if (_openParent.offsetParent.offsetTop < scrollTop) {
	            adjustedTop = 0 + "px";
	          }
	          if (_openParent.offsetParent.offsetTop > scrollBottom) {
	            adjustedTop = `${rect.top - _openNode.offsetHeight}px`;
	          }
	        }
	        $$invalidate(11, _openNode.style.right = `${bodyRect.width - rect.right}px`, _openNode);
	        $$invalidate(11, _openNode.style.top = adjustedTop ? adjustedTop : `${rect.bottom}px`, _openNode);
	      } // _openNode.style.width = `${rect.width}px`;

	      function handleScroll(event) {
	        let isOptionScroll = false;
	        let test = event.target;
	        while (test) {
	          if (test.id === "pros-actions-container") {
	            isOptionScroll = true;
	            break;
	          }
	          test = test.parentElement;
	        }
	        if (!isOptionScroll) {
	          // console.log('SB: scrollListener:Close Options');
	          closeOptions();
	        } // positionNode(event);
	      }
	      function button_theme_binding(value) {
	        _theme = value;
	        $$invalidate(2, _theme);
	      }
	      function button_theme_binding_1(value) {
	        _theme = value;
	        $$invalidate(2, _theme);
	      }
	      function icon_theme_binding(value) {
	        _theme = value;
	        $$invalidate(2, _theme);
	      }
	      $$self.$$set = $$props => {
	        if ("params" in $$props) $$invalidate(14, params = $$props.params);
	        if ("_rowSelected" in $$props) $$invalidate(8, _rowSelected = $$props._rowSelected);
	        if ("_actions" in $$props) $$invalidate(0, _actions = $$props._actions);
	        if ("open" in $$props) $$invalidate(1, open = $$props.open);
	        if ("globalClickListener" in $$props) $$invalidate(9, globalClickListener = $$props.globalClickListener);
	        if ("_globalClicksNode" in $$props) $$invalidate(10, _globalClicksNode = $$props._globalClicksNode);
	        if ("_openNode" in $$props) $$invalidate(11, _openNode = $$props._openNode);
	        if ("_openParent" in $$props) $$invalidate(12, _openParent = $$props._openParent);
	        if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	        if ("_actionsOpenedEventListener" in $$props) $$invalidate(13, _actionsOpenedEventListener = $$props._actionsOpenedEventListener);
	      };
	      return [_actions, open, _theme, _actionsId, handleCellClick, handleActionClick, globalClicks, positionOptions, _rowSelected, globalClickListener, _globalClicksNode, _openNode, _openParent, _actionsOpenedEventListener, params, handleScroll, button_theme_binding, button_theme_binding_1, icon_theme_binding];
	    }
	    class ActionCell extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document_1$1.getElementById("svelte-12sytby-style")) add_css$1();
	        init$1(this, options, instance$1, create_fragment$1, safe_not_equal$1, {
	          params: 14,
	          _rowSelected: 8,
	          _actions: 0,
	          open: 1,
	          globalClickListener: 9,
	          _globalClicksNode: 10,
	          _openNode: 11,
	          _openParent: 12,
	          _theme: 2,
	          _actionsOpenedEventListener: 13,
	          handleScroll: 15
	        }, [-1, -1]);
	      }
	      get handleScroll() {
	        return this.$$.ctx[15];
	      }
	    }

	    class ActionCellRenderer {
	      init(params) {
	        this.eGui = document.createElement('div');
	        this.eGui.classList.add('pros-custom-cell-content');
	        this.actionCell = new ActionCell({
	          target: this.eGui,
	          props: {
	            params
	          }
	        });
	      }
	      getGui() {
	        return this.eGui;
	      }
	      refresh(params) {}
	      destroy() {
	        this.actionCell.$destroy();
	      }
	      getValueToDisplay(params) {
	        return params.valueFormatted ? params.valueFormatted : params.value;
	      }
	    }

	    /* src/Grid.svelte generated by Svelte v3.38.2 */
	    const {
	      document: document_1
	    } = globals$1;
	    function add_css() {
	      var style = element$1("style");
	      style.id = "svelte-pthl21-style";
	      style.textContent = ".pros-grid-layout{font-family:FormaDJR, sans-serif;display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:absolute;top:0;bottom:0;left:0;right:0}.pros-grid-layout .pros-grid-container{flex:1;width:100%}.pros-cell-content{max-width:100%}.pros-cell-wrapper{width:100%;height:100%;display:flex;flex-direction:row;align-items:center}.pros-cell-wrapper.pros-link-wrapper{cursor:pointer}.pros-cell-wrapper.pros-link-wrapper .pros-link{display:flex;align-items:center;color:inherit;text-decoration:underline;max-width:100%;height:100%}.pros-cell-wrapper.pros-link-wrapper .link-content-wrapper{max-width:100%}.pros-cell-row{display:flex;align-items:center;min-width:0}.pros-cell-row .pros-cell-icon{margin-right:4px;flex-shrink:0}.pros-cell-row .pros-cell-icon:last-child{margin-right:0}.pros-array-tooltip-wrapped{width:500px;white-space:unset}.pros-array-tooltip-wrapped .pros-array-tootlip-wrappeed{width:100%}.pros-grid-layout ag-grid,.pros-grid-layout ag-grid-angular,.pros-grid-layout ag-grid-ng2,.pros-grid-layout ag-grid-polymer,.pros-grid-layout ag-grid-aurelia{display:block}.pros-grid-layout .ag-hidden{display:none !important}.pros-grid-layout .ag-invisible{visibility:hidden !important}.pros-grid-layout .ag-drag-handle{cursor:move;cursor:-webkit-grab;cursor:grab}.pros-grid-layout .ag-column-drop-wrapper{display:flex}.pros-grid-layout .ag-column-drop-horizontal-half-width{display:inline-block;width:50% !important}.pros-grid-layout .ag-unselectable{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.pros-grid-layout .ag-selectable{-moz-user-select:text;-webkit-user-select:text;-ms-user-select:text;user-select:text}.pros-grid-layout .ag-tab{position:relative}.pros-grid-layout .ag-tab-guard{position:absolute;width:0;height:0;display:block}.pros-grid-layout .ag-select-agg-func-popup{position:absolute}.pros-grid-layout .ag-input-wrapper,.pros-grid-layout .ag-picker-field-wrapper{display:flex;flex:1 1 auto;align-items:center;line-height:normal;position:relative}.pros-grid-layout .ag-shake-left-to-right{-webkit-animation-direction:alternate;animation-direction:alternate;-webkit-animation-duration:0.2s;animation-duration:0.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ag-shake-left-to-right;animation-name:ag-shake-left-to-right}@-webkit-keyframes ag-shake-left-to-right{from{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}@keyframes ag-shake-left-to-right{from{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.pros-grid-layout .ag-root-wrapper{cursor:default;position:relative;display:flex;flex-direction:column;overflow:hidden}.pros-grid-layout .ag-root-wrapper.ag-layout-normal{height:100%}.pros-grid-layout .ag-watermark{position:absolute;bottom:10px;right:25px;opacity:0.5;transition:opacity 1s ease-out 3s}.pros-grid-layout .ag-watermark:before{content:\"\";background-image:url(data:image/svg+xml;base64,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);-webkit-filter:invert(50%);filter:invert(50%);background-repeat:no-repeat;background-size:110px 60px;display:block;height:60px;width:110px}.pros-grid-layout .ag-watermark-text{opacity:0.5;font-weight:bold;font-size:19px}.pros-grid-layout .ag-root-wrapper-body{display:flex;flex-direction:row}.pros-grid-layout .ag-root-wrapper-body.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}.pros-grid-layout .ag-root{position:relative;display:flex;flex-direction:column}.pros-grid-layout .ag-root.ag-layout-normal,.pros-grid-layout .ag-root.ag-layout-auto-height{overflow:hidden;flex:1 1 auto;width:0}.pros-grid-layout .ag-root.ag-layout-normal{height:100%}.pros-grid-layout .ag-header-viewport,.pros-grid-layout .ag-floating-top-viewport,.pros-grid-layout .ag-body-viewport,.pros-grid-layout .ag-center-cols-viewport,.pros-grid-layout .ag-floating-bottom-viewport,.pros-grid-layout .ag-body-horizontal-scroll-viewport,.pros-grid-layout .ag-virtual-list-viewport{position:relative;height:100%;min-width:0;overflow:hidden;flex:1 1 auto}.pros-grid-layout .ag-body-viewport.ag-layout-print{flex:none}@media print{.pros-grid-layout .ag-root-wrapper.ag-layout-print,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-root-wrapper-body,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-root,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-body-viewport,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-center-cols-container,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-center-cols-viewport,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-center-cols-clipper,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-body-horizontal-scroll-viewport,.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-virtual-list-viewport{height:auto !important;overflow:hidden !important;display:block !important}.pros-grid-layout .ag-root-wrapper.ag-layout-print .ag-row{page-break-inside:avoid}}.pros-grid-layout .ag-body-viewport{display:flex}.pros-grid-layout .ag-body-viewport.ag-layout-normal{overflow-y:auto;-webkit-overflow-scrolling:touch}.pros-grid-layout .ag-center-cols-viewport{width:100%;overflow-x:auto}.pros-grid-layout .ag-body-horizontal-scroll-viewport{overflow-x:scroll}.pros-grid-layout .ag-virtual-list-viewport{overflow:auto;width:100%}.pros-grid-layout .ag-header-container,.pros-grid-layout .ag-floating-top-container,.pros-grid-layout .ag-body-container,.pros-grid-layout .ag-pinned-right-cols-container,.pros-grid-layout .ag-center-cols-container,.pros-grid-layout .ag-pinned-left-cols-container,.pros-grid-layout .ag-floating-bottom-container,.pros-grid-layout .ag-body-horizontal-scroll-container,.pros-grid-layout .ag-full-width-container,.pros-grid-layout .ag-floating-bottom-full-width-container,.pros-grid-layout .ag-virtual-list-container{position:relative}.pros-grid-layout .ag-header-container,.pros-grid-layout .ag-floating-top-container,.pros-grid-layout .ag-floating-bottom-container{height:100%;white-space:nowrap}.pros-grid-layout .ag-center-cols-container{display:block}.pros-grid-layout .ag-layout-print .ag-center-cols-clipper{min-width:100%}.pros-grid-layout .ag-pinned-right-cols-container{display:block}.pros-grid-layout .ag-body-horizontal-scroll-container{height:100%}.pros-grid-layout .ag-full-width-container,.pros-grid-layout .ag-floating-top-full-width-container,.pros-grid-layout .ag-floating-bottom-full-width-container{position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout .ag-full-width-container{width:100%}.pros-grid-layout .ag-floating-bottom-full-width-container,.pros-grid-layout .ag-floating-top-full-width-container{display:inline-block;overflow:hidden;height:100%;width:100%}.pros-grid-layout .ag-virtual-list-container{overflow:hidden}.pros-grid-layout .ag-center-cols-clipper{flex:1 1 auto;min-width:0;overflow:hidden;min-height:100%}.pros-grid-layout .ag-body-horizontal-scroll{min-height:0;min-width:0;width:100%;display:flex;position:relative}.pros-grid-layout .ag-layout-print .ag-body-horizontal-scroll{display:none}.pros-grid-layout .ag-force-vertical-scroll{overflow-y:scroll !important}.pros-grid-layout .ag-force-vertical-scroll.ag-layout-print{overflow-y:visible !important}.pros-grid-layout .ag-horizontal-left-spacer,.pros-grid-layout .ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll}.pros-grid-layout .ag-horizontal-left-spacer.ag-scroller-corner,.pros-grid-layout .ag-horizontal-right-spacer.ag-scroller-corner{overflow-x:hidden}.pros-grid-layout .ag-header,.pros-grid-layout .ag-pinned-left-header,.pros-grid-layout .ag-pinned-right-header{display:inline-block;overflow:hidden;position:relative}.pros-grid-layout .ag-header-cell-sortable{cursor:pointer}.pros-grid-layout .ag-header{display:flex;width:100%;white-space:nowrap}.pros-grid-layout .ag-pinned-left-header{height:100%}.pros-grid-layout .ag-pinned-right-header{height:100%}.pros-grid-layout .ag-header-row{position:absolute;overflow:hidden}.pros-grid-layout .ag-header-cell{display:inline-flex;align-items:center;position:absolute;height:100%;overflow:hidden}.pros-grid-layout .ag-header-cell.ag-header-active .ag-header-cell-menu-button{opacity:1}.pros-grid-layout .ag-header-cell-menu-button:not(.ag-header-menu-always-show){transition:opacity 0.2s;opacity:0}.pros-grid-layout .ag-header-group-cell-label,.pros-grid-layout .ag-header-cell-label{display:flex;flex:1 1 auto;overflow:hidden;align-items:center;text-overflow:ellipsis;align-self:stretch}.pros-grid-layout .ag-header-cell-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pros-grid-layout .ag-right-aligned-header .ag-header-cell-label{flex-direction:row-reverse}.pros-grid-layout .ag-header-group-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pros-grid-layout .ag-header-cell-resize{position:absolute;z-index:2;height:100%;width:8px;top:0;cursor:ew-resize}.pros-grid-layout .ag-ltr .ag-header-cell-resize{right:-4px}.pros-grid-layout .ag-rtl .ag-header-cell-resize{left:-4px}.pros-grid-layout .ag-pinned-left-header .ag-header-cell-resize{right:-4px}.pros-grid-layout .ag-pinned-right-header .ag-header-cell-resize{left:-4px}.pros-grid-layout .ag-header-select-all{display:flex}.pros-grid-layout .ag-column-moving .ag-cell{transition:left 0.2s}.pros-grid-layout .ag-column-moving .ag-header-cell{transition:left 0.2s}.pros-grid-layout .ag-column-moving .ag-header-group-cell{transition:left 0.2s, width 0.2s}.pros-grid-layout .ag-column-panel{display:flex;flex-direction:column;overflow:hidden;flex:1 1 auto}.pros-grid-layout .ag-column-select{display:flex;flex-direction:column;overflow:hidden;flex-grow:3;flex-shrink:1;flex-basis:0}.pros-grid-layout .ag-column-select-header{position:relative;display:flex;flex:none}.pros-grid-layout .ag-column-select-header-icon{position:relative}.pros-grid-layout .ag-column-select-header-filter-wrapper{flex:1 1 auto}.pros-grid-layout .ag-column-select-header-filter{width:100%}.pros-grid-layout .ag-column-select-list{flex:1 1 0;overflow:hidden}.pros-grid-layout .ag-column-drop{display:inline-flex;align-items:center;overflow:auto;width:100%}.pros-grid-layout .ag-column-drop-list{display:flex;align-items:center}.pros-grid-layout .ag-column-drop-cell{display:flex;align-items:center}.pros-grid-layout .ag-column-drop-cell-text{overflow:hidden;flex:1 1 auto;text-overflow:ellipsis;white-space:nowrap}.pros-grid-layout .ag-column-drop-vertical{display:flex;flex-direction:column;overflow:hidden;flex:1 1 0;align-items:stretch}.pros-grid-layout .ag-column-drop-vertical-title-bar{display:flex;align-items:center;flex:none}.pros-grid-layout .ag-column-drop-vertical-list{position:relative;align-items:stretch;flex-grow:1;flex-direction:column;overflow-x:auto}.pros-grid-layout .ag-column-drop-vertical-list>*{flex:none}.pros-grid-layout .ag-column-drop-empty .ag-column-drop-vertical-list{overflow:hidden}.pros-grid-layout .ag-column-drop-vertical-empty-message{display:block}.pros-grid-layout .ag-column-drop.ag-column-drop-horizontal{white-space:nowrap;overflow:hidden}.pros-grid-layout .ag-column-drop-cell-button{cursor:pointer}.pros-grid-layout .ag-filter-toolpanel{flex:1 1 0;min-width:0}.pros-grid-layout .ag-filter-toolpanel-header{position:relative}.pros-grid-layout .ag-filter-toolpanel-header,.pros-grid-layout .ag-filter-toolpanel-search{display:flex;align-items:center}.pros-grid-layout .ag-filter-toolpanel-header>*,.pros-grid-layout .ag-filter-toolpanel-search>*{display:flex;align-items:center}.pros-grid-layout .ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden}.pros-grid-layout .ag-row-animation .ag-row{transition:top 0.4s, height 0.4s, background-color 0.1s, opacity 0.2s, -webkit-transform 0.4s;transition:transform 0.4s, top 0.4s, height 0.4s, background-color 0.1s, opacity 0.2s;transition:transform 0.4s, top 0.4s, height 0.4s, background-color 0.1s, opacity 0.2s, -webkit-transform 0.4s}.pros-grid-layout .ag-row-no-animation .ag-row{transition:background-color 0.1s}.pros-grid-layout .ag-row{white-space:nowrap;width:100%}.pros-grid-layout .ag-row-loading{display:flex;align-items:center}.pros-grid-layout .ag-row-position-absolute{position:absolute}.pros-grid-layout .ag-row-position-relative{position:relative}.pros-grid-layout .ag-full-width-row{overflow:hidden;pointer-events:all}.pros-grid-layout .ag-row-inline-editing{z-index:1}.pros-grid-layout .ag-row-dragging{z-index:2}.pros-grid-layout .ag-stub-cell{display:flex;align-items:center}.pros-grid-layout .ag-cell{display:inline-block;position:absolute;white-space:nowrap}.pros-grid-layout .ag-cell-value,.pros-grid-layout .ag-group-value{display:flex;flex-direction:row;justify-content:left;align-items:center;width:100%;height:100%}.pros-grid-layout .ag-cell-wrap-text{white-space:normal;word-break:break-all}.pros-grid-layout .ag-cell-wrapper{display:flex;align-items:center;height:100%;width:100%}.pros-grid-layout .ag-cell-wrapper.ag-row-group{align-items:flex-start}.pros-grid-layout .ag-full-width-row .ag-cell-wrapper.ag-row-group{align-items:center}.pros-grid-layout .ag-cell-auto-height{height:100%}.pros-grid-layout .ag-cell-inline-editing{z-index:1}.pros-grid-layout .ag-cell-inline-editing .ag-cell-edit-wrapper,.pros-grid-layout .ag-cell-inline-editing .ag-cell-editor,.pros-grid-layout .ag-cell-inline-editing .ag-cell-editor .ag-wrapper,.pros-grid-layout .ag-cell-inline-editing .ag-cell-editor input{height:100%;width:100%;line-height:normal}.pros-grid-layout .ag-cell .ag-icon{display:inline-block;vertical-align:middle}.pros-grid-layout .ag-set-filter-item{display:flex;align-items:center;height:100%}.pros-grid-layout .ag-set-filter-item-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pros-grid-layout .ag-set-filter-item-checkbox{display:flex}.pros-grid-layout .ag-filter-body-wrapper{display:flex;flex-direction:column}.pros-grid-layout .ag-filter-filter{flex:1 1 0}.pros-grid-layout .ag-filter-condition{display:flex;justify-content:center}.pros-grid-layout .ag-floating-filter-body{position:relative;display:flex;flex:1 1 auto;height:100%}.pros-grid-layout .ag-floating-filter-full-body{display:flex;flex:1 1 auto;height:100%;width:100%;align-items:center;overflow:hidden}.pros-grid-layout .ag-floating-filter-full-body>div{flex:1 1 auto}.pros-grid-layout .ag-floating-filter{display:inline-block;position:absolute}.pros-grid-layout .ag-floating-filter-input{align-items:center;display:flex;width:100%}.pros-grid-layout .ag-floating-filter-input>*{flex:1 1 auto}.pros-grid-layout .ag-floating-filter-button{display:flex;flex:none}.pros-grid-layout .ag-dnd-ghost{position:absolute;display:inline-flex;align-items:center;cursor:move;white-space:nowrap}.pros-grid-layout .ag-overlay{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.pros-grid-layout .ag-overlay-panel{display:flex;height:100%;width:100%}.pros-grid-layout .ag-overlay-wrapper{display:flex;flex:none;width:100%;height:100%;align-items:center;justify-content:center;text-align:center}.pros-grid-layout .ag-overlay-loading-wrapper{pointer-events:all}.pros-grid-layout .ag-popup-child{z-index:5}.pros-grid-layout .ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1}.pros-grid-layout .ag-large-text-input{display:block}.pros-grid-layout .ag-virtual-list-item{position:absolute;width:100%}.pros-grid-layout .ag-floating-top{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:flex}.pros-grid-layout .ag-pinned-left-floating-top{display:inline-block;overflow:hidden;position:relative;min-width:0}.pros-grid-layout .ag-pinned-right-floating-top{display:inline-block;overflow:hidden;position:relative;min-width:0}.pros-grid-layout .ag-floating-bottom{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:flex}.pros-grid-layout .ag-pinned-left-floating-bottom{display:inline-block;overflow:hidden;position:relative;min-width:0}.pros-grid-layout .ag-pinned-right-floating-bottom{display:inline-block;overflow:hidden;position:relative;min-width:0}.pros-grid-layout .ag-dialog,.pros-grid-layout .ag-panel{display:flex;flex-direction:column;position:relative;overflow:hidden}.pros-grid-layout .ag-panel-title-bar{display:flex;flex:none;align-items:center;cursor:default}.pros-grid-layout .ag-panel-title-bar-title{flex:1 1 auto}.pros-grid-layout .ag-panel-title-bar-buttons{display:flex}.pros-grid-layout .ag-panel-title-bar-button{cursor:pointer}.pros-grid-layout .ag-panel-content-wrapper{display:flex;flex:1 1 auto;position:relative;overflow:hidden}.pros-grid-layout .ag-dialog{position:absolute}.pros-grid-layout .ag-resizer{position:absolute;pointer-events:none;z-index:1}.pros-grid-layout .ag-resizer.ag-resizer-topLeft{top:0;left:0;height:5px;width:5px;cursor:nwse-resize}.pros-grid-layout .ag-resizer.ag-resizer-top{top:0;left:5px;right:5px;height:5px;cursor:ns-resize}.pros-grid-layout .ag-resizer.ag-resizer-topRight{top:0;right:0;height:5px;width:5px;cursor:nesw-resize}.pros-grid-layout .ag-resizer.ag-resizer-right{top:5px;right:0;bottom:5px;width:5px;cursor:ew-resize}.pros-grid-layout .ag-resizer.ag-resizer-bottomRight{bottom:0;right:0;height:5px;width:5px;cursor:nwse-resize}.pros-grid-layout .ag-resizer.ag-resizer-bottom{bottom:0;left:5px;right:5px;height:5px;cursor:ns-resize}.pros-grid-layout .ag-resizer.ag-resizer-bottomLeft{bottom:0;left:0;height:5px;width:5px;cursor:nesw-resize}.pros-grid-layout .ag-resizer.ag-resizer-left{left:0;top:5px;bottom:5px;width:5px;cursor:ew-resize}.pros-grid-layout .ag-tooltip{position:absolute;pointer-events:none;z-index:99999}.pros-grid-layout .ag-value-slide-out{margin-right:5px;opacity:1;transition:opacity 3s, margin-right 3s;transition-timing-function:linear}.pros-grid-layout .ag-value-slide-out-end{margin-right:10px;opacity:0}.pros-grid-layout .ag-opacity-zero{opacity:0 !important}.pros-grid-layout .ag-menu{max-height:100%;overflow-y:auto;position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pros-grid-layout .ag-menu-column-select-wrapper{height:265px;overflow:auto}.pros-grid-layout .ag-menu-column-select-wrapper .ag-column-select{height:100%}.pros-grid-layout .ag-menu-list{display:table;width:100%}.pros-grid-layout .ag-menu-option,.pros-grid-layout .ag-menu-separator{display:table-row}.pros-grid-layout .ag-menu-option-part,.pros-grid-layout .ag-menu-separator-part{display:table-cell;vertical-align:middle}.pros-grid-layout .ag-menu-option-text{white-space:nowrap}.pros-grid-layout .ag-compact-menu-option{width:100%;display:flex;flex-wrap:nowrap}.pros-grid-layout .ag-compact-menu-option-text{white-space:nowrap;flex:1 1 auto}.pros-grid-layout .ag-rich-select{cursor:default;outline:none}.pros-grid-layout .ag-rich-select-value{display:flex;align-items:center}.pros-grid-layout .ag-rich-select-value-icon{flex:1 1 auto;order:1}.pros-grid-layout .ag-ltr .ag-rich-select-value-icon{text-align:right}.pros-grid-layout .ag-rtl .ag-rich-select-value-icon{text-align:left}.pros-grid-layout .ag-rich-select-list{position:relative}.pros-grid-layout .ag-rich-select-virtual-list-item{display:flex}.pros-grid-layout .ag-rich-select-row{display:flex;flex:1 1 auto;align-items:center;white-space:nowrap}.pros-grid-layout .ag-paging-panel{align-items:center;display:flex;justify-content:flex-end}.pros-grid-layout .ag-paging-page-summary-panel{display:flex;align-items:center}.pros-grid-layout .ag-paging-button{position:relative}.pros-grid-layout .ag-disabled .ag-paging-page-summary-panel{pointer-events:none}.pros-grid-layout .ag-tool-panel-wrapper{display:flex;overflow-y:auto;overflow-x:hidden;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:200px}.pros-grid-layout .ag-column-select-column,.pros-grid-layout .ag-column-select-column-group{position:relative;align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;text-overflow:ellipsis;white-space:nowrap;height:100%}.pros-grid-layout .ag-column-select-column>*,.pros-grid-layout .ag-column-select-column-group>*{flex:none}.pros-grid-layout .ag-column-select-checkbox{display:flex}.pros-grid-layout .ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.pros-grid-layout .ag-ltr .ag-side-bar-left .ag-tool-panel-horizontal-resize{right:-3px}.pros-grid-layout .ag-rtl .ag-side-bar-left .ag-tool-panel-horizontal-resize{left:-3px}.pros-grid-layout .ag-ltr .ag-side-bar-right .ag-tool-panel-horizontal-resize{left:-3px}.pros-grid-layout .ag-rtl .ag-side-bar-right .ag-tool-panel-horizontal-resize{right:-3px}.pros-grid-layout .ag-details-row{width:100%}.pros-grid-layout .ag-details-row-fixed-height{height:100%}.pros-grid-layout .ag-details-grid{width:100%}.pros-grid-layout .ag-details-grid-fixed-height{height:100%}.pros-grid-layout .ag-header-group-cell{display:flex;align-items:center;height:100%;position:absolute}.pros-grid-layout .ag-cell-label-container{display:flex;justify-content:space-between;flex-direction:row-reverse;align-items:center;width:100%;height:100%;overflow:hidden}.pros-grid-layout .ag-right-aligned-header .ag-cell-label-container{flex-direction:row}.pros-grid-layout .ag-side-bar{display:flex;flex-direction:row-reverse}.pros-grid-layout .ag-side-bar-left{order:-1;flex-direction:row}.pros-grid-layout .ag-side-button-button{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;flex-wrap:nowrap;white-space:nowrap;outline:none;cursor:pointer}.pros-grid-layout .ag-side-button-label{-webkit-writing-mode:vertical-lr;-ms-writing-mode:tb-lr;writing-mode:vertical-lr}.pros-grid-layout .ag-status-bar{display:flex;justify-content:space-between;overflow:hidden}.pros-grid-layout .ag-status-panel{display:inline-flex}.pros-grid-layout .ag-status-name-value{white-space:nowrap}.pros-grid-layout .ag-status-bar-left{display:inline-flex}.pros-grid-layout .ag-status-bar-center{display:inline-flex}.pros-grid-layout .ag-status-bar-right{display:inline-flex}.pros-grid-layout .ag-icon{display:block;speak:none}.pros-grid-layout .ag-group{position:relative;width:100%}.pros-grid-layout .ag-group-title-bar{display:flex;align-items:center}.pros-grid-layout .ag-group-title{display:block;flex:1 1 auto;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.pros-grid-layout .ag-group-title-bar .ag-group-title{cursor:default}.pros-grid-layout .ag-group-toolbar{display:flex;align-items:center}.pros-grid-layout .ag-group-container{display:flex}.pros-grid-layout .ag-disabled .ag-group-container{pointer-events:none}.pros-grid-layout .ag-group-container-horizontal{flex-direction:row;flex-wrap:wrap}.pros-grid-layout .ag-group-container-vertical{flex-direction:column}.pros-grid-layout .ag-charts-font-size-color{display:flex;align-self:stretch;justify-content:space-between}.pros-grid-layout .ag-column-group-icons{display:block}.pros-grid-layout .ag-column-group-icons>*{cursor:pointer}.pros-grid-layout .ag-group-item-alignment-stretch .ag-group-item{align-items:stretch}.pros-grid-layout .ag-group-item-alignment-start .ag-group-item{align-items:flex-start}.pros-grid-layout .ag-group-item-alignment-end .ag-group-item{align-items:flex-end}.pros-grid-layout .ag-toggle-button-icon{transition:right 0.3s;position:absolute;top:-1px}.pros-grid-layout .ag-input-field,.pros-grid-layout .ag-select{display:flex;flex-direction:row;align-items:center}.pros-grid-layout .ag-input-field-input{flex:1 1 auto;width:100%;min-width:0}.pros-grid-layout .ag-floating-filter-input .ag-input-field-input[type=date]{width:1px}.pros-grid-layout .ag-range-field{display:flex;align-items:center}.pros-grid-layout .ag-angle-select{display:flex;align-items:center}.pros-grid-layout .ag-angle-select-wrapper{display:flex}.pros-grid-layout .ag-angle-select-parent-circle{display:block;position:relative}.pros-grid-layout .ag-angle-select-child-circle{position:absolute}.pros-grid-layout .ag-slider-wrapper{display:flex}.pros-grid-layout .ag-slider-wrapper .ag-input-field{flex:1 1 auto}.pros-grid-layout .ag-picker-field-display{flex:1 1 auto}.pros-grid-layout .ag-picker-field{display:flex;align-items:center}.pros-grid-layout .ag-picker-field-icon{display:flex;border:0;padding:0;margin:0;cursor:pointer}.pros-grid-layout .ag-picker-field-wrapper{overflow:hidden}.pros-grid-layout .ag-label-align-right .ag-label{order:1}.pros-grid-layout .ag-label-align-right>*{flex:none}.pros-grid-layout .ag-label-align-top{flex-direction:column;align-items:flex-start}.pros-grid-layout .ag-label-align-top>*{align-self:stretch}.pros-grid-layout .ag-color-panel{width:100%;display:flex;flex-direction:column;text-align:center}.pros-grid-layout .ag-spectrum-color{flex:1 1 auto;position:relative;overflow:hidden;cursor:default}.pros-grid-layout .ag-spectrum-fill{position:absolute;top:0;left:0;right:0;bottom:0}.pros-grid-layout .ag-spectrum-val{cursor:pointer}.pros-grid-layout .ag-spectrum-dragger{position:absolute;pointer-events:none;cursor:pointer}.pros-grid-layout .ag-spectrum-hue{cursor:default;background:linear-gradient(to left, #ff0000 3%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%)}.pros-grid-layout .ag-spectrum-alpha{cursor:default}.pros-grid-layout .ag-spectrum-hue-background{width:100%;height:100%}.pros-grid-layout .ag-spectrum-alpha-background{background-image:linear-gradient(to right, rgba(0, 0, 0, 0), black);width:100%;height:100%}.pros-grid-layout .ag-spectrum-tool{cursor:pointer}.pros-grid-layout .ag-spectrum-slider{position:absolute;pointer-events:none}.pros-grid-layout .ag-recent-colors{display:flex}.pros-grid-layout .ag-recent-color{cursor:pointer}.pros-grid-layout .ag-ltr .ag-column-select-indent-1{padding-left:20px}.pros-grid-layout .ag-rtl .ag-column-select-indent-1{padding-right:20px}.pros-grid-layout .ag-ltr .ag-row-group-indent-1{padding-left:20px}.pros-grid-layout .ag-rtl .ag-row-group-indent-1{padding-right:20px}.pros-grid-layout .ag-ltr .ag-column-select-indent-2{padding-left:40px}.pros-grid-layout .ag-rtl .ag-column-select-indent-2{padding-right:40px}.pros-grid-layout .ag-ltr .ag-row-group-indent-2{padding-left:40px}.pros-grid-layout .ag-rtl .ag-row-group-indent-2{padding-right:40px}.pros-grid-layout .ag-ltr .ag-column-select-indent-3{padding-left:60px}.pros-grid-layout .ag-rtl .ag-column-select-indent-3{padding-right:60px}.pros-grid-layout .ag-ltr .ag-row-group-indent-3{padding-left:60px}.pros-grid-layout .ag-rtl .ag-row-group-indent-3{padding-right:60px}.pros-grid-layout .ag-ltr .ag-column-select-indent-4{padding-left:80px}.pros-grid-layout .ag-rtl .ag-column-select-indent-4{padding-right:80px}.pros-grid-layout .ag-ltr .ag-row-group-indent-4{padding-left:80px}.pros-grid-layout .ag-rtl .ag-row-group-indent-4{padding-right:80px}.pros-grid-layout .ag-ltr .ag-column-select-indent-5{padding-left:100px}.pros-grid-layout .ag-rtl .ag-column-select-indent-5{padding-right:100px}.pros-grid-layout .ag-ltr .ag-row-group-indent-5{padding-left:100px}.pros-grid-layout .ag-rtl .ag-row-group-indent-5{padding-right:100px}.pros-grid-layout .ag-ltr .ag-column-select-indent-6{padding-left:120px}.pros-grid-layout .ag-rtl .ag-column-select-indent-6{padding-right:120px}.pros-grid-layout .ag-ltr .ag-row-group-indent-6{padding-left:120px}.pros-grid-layout .ag-rtl .ag-row-group-indent-6{padding-right:120px}.pros-grid-layout .ag-ltr .ag-column-select-indent-7{padding-left:140px}.pros-grid-layout .ag-rtl .ag-column-select-indent-7{padding-right:140px}.pros-grid-layout .ag-ltr .ag-row-group-indent-7{padding-left:140px}.pros-grid-layout .ag-rtl .ag-row-group-indent-7{padding-right:140px}.pros-grid-layout .ag-ltr .ag-column-select-indent-8{padding-left:160px}.pros-grid-layout .ag-rtl .ag-column-select-indent-8{padding-right:160px}.pros-grid-layout .ag-ltr .ag-row-group-indent-8{padding-left:160px}.pros-grid-layout .ag-rtl .ag-row-group-indent-8{padding-right:160px}.pros-grid-layout .ag-ltr .ag-column-select-indent-9{padding-left:180px}.pros-grid-layout .ag-rtl .ag-column-select-indent-9{padding-right:180px}.pros-grid-layout .ag-ltr .ag-row-group-indent-9{padding-left:180px}.pros-grid-layout .ag-rtl .ag-row-group-indent-9{padding-right:180px}.pros-grid-layout .ag-ltr{direction:ltr}.pros-grid-layout .ag-ltr .ag-body,.pros-grid-layout .ag-ltr .ag-floating-top,.pros-grid-layout .ag-ltr .ag-floating-bottom,.pros-grid-layout .ag-ltr .ag-header,.pros-grid-layout .ag-ltr .ag-body-viewport,.pros-grid-layout .ag-ltr .ag-body-horizontal-scroll{flex-direction:row}.pros-grid-layout .ag-rtl{direction:rtl}.pros-grid-layout .ag-rtl .ag-body,.pros-grid-layout .ag-rtl .ag-floating-top,.pros-grid-layout .ag-rtl .ag-floating-bottom,.pros-grid-layout .ag-rtl .ag-header,.pros-grid-layout .ag-rtl .ag-body-viewport,.pros-grid-layout .ag-rtl .ag-body-horizontal-scroll{flex-direction:row-reverse}.pros-grid-layout .ag-rtl .ag-icon-contracted,.pros-grid-layout .ag-rtl .ag-icon-tree-closed{display:block;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.pros-grid-layout .ag-body .ag-body-viewport{-webkit-overflow-scrolling:touch}.pros-grid-layout .ag-chart{position:relative;display:flex;overflow:hidden;width:100%;height:100%}.pros-grid-layout .ag-chart-components-wrapper{position:relative;display:flex;flex:1 1 auto;overflow:hidden}.pros-grid-layout .ag-chart-title-edit{position:absolute;display:none;top:0;left:0;text-align:center}.pros-grid-layout .ag-chart-title-edit.currently-editing{display:inline-block}.pros-grid-layout .ag-chart-canvas-wrapper{position:relative;flex:1 1 auto;overflow:hidden}.pros-grid-layout .ag-charts-canvas{display:block}.pros-grid-layout .ag-chart-menu{position:absolute;top:10px;width:24px;overflow:hidden;display:flex;flex-direction:column}.pros-grid-layout .ag-ltr .ag-chart-menu{right:20px}.pros-grid-layout .ag-rtl .ag-chart-menu{left:20px}.pros-grid-layout .ag-chart-docked-container{position:relative;width:0;min-width:0;transition:min-width 0.4s}.pros-grid-layout .ag-chart-menu-hidden~.ag-chart-docked-container{max-width:0;overflow:hidden}.pros-grid-layout .ag-chart-tabbed-menu{width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden}.pros-grid-layout .ag-chart-tabbed-menu-header{flex:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.pros-grid-layout .ag-chart-tabbed-menu-body{display:flex;flex:1 1 auto;align-items:stretch;overflow:hidden}.pros-grid-layout .ag-chart-tab{width:100%;overflow:hidden;overflow-y:auto}.pros-grid-layout .ag-chart-settings{overflow-x:hidden}.pros-grid-layout .ag-chart-settings-wrapper{position:relative;flex-direction:column;width:100%;height:100%;display:flex;overflow:hidden}.pros-grid-layout .ag-chart-settings-nav-bar{display:flex;align-items:center;width:100%;height:30px;padding:0 10px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pros-grid-layout .ag-chart-settings-card-selector{display:flex;align-items:center;justify-content:space-around;flex:1 1 auto;height:100%;padding:0 10px}.pros-grid-layout .ag-chart-settings-card-item{cursor:pointer;width:10px;height:10px;background-color:#000;position:relative}.pros-grid-layout .ag-chart-settings-card-item.ag-not-selected{opacity:0.2}.pros-grid-layout .ag-chart-settings-card-item:before{content:\" \";display:block;position:absolute;background-color:transparent;left:50%;top:50%;margin-left:-10px;margin-top:-10px;width:20px;height:20px}.pros-grid-layout .ag-chart-settings-prev,.pros-grid-layout .ag-chart-settings-next{position:relative;flex:none}.pros-grid-layout .ag-chart-settings-prev-button,.pros-grid-layout .ag-chart-settings-next-button{position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;opacity:0}.pros-grid-layout .ag-chart-settings-mini-charts-container{position:relative;flex:1 1 auto;overflow-x:hidden;overflow-y:auto}.pros-grid-layout .ag-chart-settings-mini-wrapper{position:absolute;top:0;left:0;display:flex;flex-direction:column;width:100%;min-height:100%;overflow:hidden}.pros-grid-layout .ag-chart-settings-mini-wrapper.ag-animating{transition:left 0.3s;transition-timing-function:ease-in-out}.pros-grid-layout .ag-chart-mini-thumbnail{cursor:pointer}.pros-grid-layout .ag-chart-mini-thumbnail-canvas{display:block}.pros-grid-layout .ag-chart-data-wrapper,.pros-grid-layout .ag-chart-format-wrapper{display:flex;flex-direction:column;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pros-grid-layout .ag-chart-data-section,.pros-grid-layout .ag-chart-format-section{display:flex;margin:0}.pros-grid-layout .ag-charts-font-panel-controls{justify-content:space-between}.pros-grid-layout .ag-chart-empty-text{display:flex;top:0;width:100%;height:100%;align-items:center;justify-content:center}.pros-grid-layout .ag-chart .ag-chart-menu{opacity:0;pointer-events:none}.pros-grid-layout .ag-chart-menu-hidden:hover .ag-chart-menu{opacity:1;pointer-events:all}.pros-grid-layout .ag-date-time-list-page-title-bar{display:flex}.pros-grid-layout .ag-date-time-list-page-column-labels-row,.pros-grid-layout .ag-date-time-list-page-entries-row{display:flex}.pros-grid-layout .ag-date-time-list-page-column-label,.pros-grid-layout .ag-date-time-list-page-entry{flex-basis:0;flex-grow:1}.pros-grid-layout .ag-date-time-list-page-entry{cursor:pointer}.pros-grid-layout .pros-align-left .pros-cell-wrapper{justify-content:left}.pros-grid-layout .pros-align-center .pros-cell-wrapper{justify-content:center}.pros-grid-layout .pros-align-right .pros-cell-wrapper{justify-content:right}.pros-grid-layout .pros-custom-cell-content{display:flex;flex-direction:column;justify-content:center;align-items:center;position:absolute;top:0;bottom:0;left:0;right:0}.pros-grid-layout .pros-grid-container .ag-row-hover .pros-action-cell-container{display:inherit;cursor:pointer}.pros-grid-layout .pros-grid-container .ag-cell{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;height:100%;width:100%}.pros-grid-layout .pros-grid-container .ag-cell.pros-action-cell{padding-left:0;padding-right:0;height:100%;width:100%}.pros-grid-layout .pros-grid-container .ag-cell.pros-action-header{padding-left:0;padding-right:0;height:100%;width:100%}.pros-grid-layout .pros-grid-container .pros-action-header{padding-left:0;padding-right:0}.pros-grid-layout .pros-grid-container .ag-icon{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.pros-grid-layout .pros-grid-container .ag-icon-aggregation:before{content:\"\\f101\"}.pros-grid-layout .pros-grid-container .ag-icon-arrows:before{content:\"\\f102\"}.pros-grid-layout .pros-grid-container .ag-icon-asc:before{content:\"\\f103\"}.pros-grid-layout .pros-grid-container .ag-icon-cancel:before{content:\"\\f104\"}.pros-grid-layout .pros-grid-container .ag-icon-chart:before{content:\"\\f105\"}.pros-grid-layout .pros-grid-container .ag-icon-color-picker:before{content:\"\\f109\"}.pros-grid-layout .pros-grid-container .ag-icon-columns:before{content:\"\\f10a\"}.pros-grid-layout .pros-grid-container .ag-icon-contracted:before{content:\"\\f10b\"}.pros-grid-layout .pros-grid-container .ag-icon-copy:before{content:\"\\f10c\"}.pros-grid-layout .pros-grid-container .ag-icon-cross:before{content:\"\\f10d\"}.pros-grid-layout .pros-grid-container .ag-icon-desc:before{content:\"\\f10e\"}.pros-grid-layout .pros-grid-container .ag-icon-expanded:before{content:\"\\f10f\"}.pros-grid-layout .pros-grid-container .ag-icon-eye-slash:before{content:\"\\f110\"}.pros-grid-layout .pros-grid-container .ag-icon-eye:before{content:\"\\f111\"}.pros-grid-layout .pros-grid-container .ag-icon-filter:before{content:\"\\f112\"}.pros-grid-layout .pros-grid-container .ag-icon-first:before{content:\"\\f113\"}.pros-grid-layout .pros-grid-container .ag-icon-grip:before{content:\"\\f114\"}.pros-grid-layout .pros-grid-container .ag-icon-group:before{content:\"\\f115\"}.pros-grid-layout .pros-grid-container .ag-icon-last:before{content:\"\\f116\"}.pros-grid-layout .pros-grid-container .ag-icon-left:before{content:\"\\f117\"}.pros-grid-layout .pros-grid-container .ag-icon-linked:before{content:\"\\f118\"}.pros-grid-layout .pros-grid-container .ag-icon-loading:before{content:\"\\f119\"}.pros-grid-layout .pros-grid-container .ag-icon-maximize:before{content:\"\\f11a\"}.pros-grid-layout .pros-grid-container .ag-icon-menu:before{content:\"\\f11b\"}.pros-grid-layout .pros-grid-container .ag-icon-minimize:before{content:\"\\f11c\"}.pros-grid-layout .pros-grid-container .ag-icon-next:before{content:\"\\f11d\"}.pros-grid-layout .pros-grid-container .ag-icon-none:before{content:\"\\f11e\"}.pros-grid-layout .pros-grid-container .ag-icon-not-allowed:before{content:\"\\f11f\"}.pros-grid-layout .pros-grid-container .ag-icon-paste:before{content:\"\\f120\"}.pros-grid-layout .pros-grid-container .ag-icon-pin:before{content:\"\\f121\"}.pros-grid-layout .pros-grid-container .ag-icon-pivot:before{content:\"\\f122\"}.pros-grid-layout .pros-grid-container .ag-icon-previous:before{content:\"\\f123\"}.pros-grid-layout .pros-grid-container .ag-icon-right:before{content:\"\\f126\"}.pros-grid-layout .pros-grid-container .ag-icon-save:before{content:\"\\f127\"}.pros-grid-layout .pros-grid-container .ag-icon-small-down:before{content:\"\\f128\"}.pros-grid-layout .pros-grid-container .ag-icon-small-left:before{content:\"\\f129\"}.pros-grid-layout .pros-grid-container .ag-icon-small-right:before{content:\"\\f12a\"}.pros-grid-layout .pros-grid-container .ag-icon-small-up:before{content:\"\\f12b\"}.pros-grid-layout .pros-grid-container .ag-icon-tick:before{content:\"\\f12c\"}.pros-grid-layout .pros-grid-container .ag-icon-tree-closed:before{content:\"\\f12d\"}.pros-grid-layout .pros-grid-container .ag-icon-tree-indeterminate:before{content:\"\\f12e\"}.pros-grid-layout .pros-grid-container .ag-icon-tree-open:before{content:\"\\f12f\"}.pros-grid-layout .pros-grid-container .ag-icon-unlinked:before{content:\"\\f130\"}.pros-grid-layout .pros-grid-container .ag-icon-row-drag:before{content:\"\\f114\"}.pros-grid-layout .pros-grid-container .ag-left-arrow:before{content:\"\\f117\"}.pros-grid-layout .pros-grid-container .ag-right-arrow:before{content:\"\\f126\"}.pros-grid-layout .pros-grid-container [class^=ag-],.pros-grid-layout .pros-grid-container [class^=ag-]:focus,.pros-grid-layout .pros-grid-container [class^=ag-]:after,.pros-grid-layout .pros-grid-container [class^=ag-]:before{box-sizing:border-box;outline:none}.pros-grid-layout .pros-grid-container [class^=ag-]::-ms-clear{display:none}.pros-grid-layout .pros-grid-container .ag-checkbox .ag-input-wrapper,.pros-grid-layout .pros-grid-container .ag-radio-button .ag-input-wrapper{overflow:visible}.pros-grid-layout .pros-grid-container .ag-range-field .ag-input-wrapper{height:100%}.pros-grid-layout .pros-grid-container .ag-toggle-button{flex:none;width:unset;min-width:unset}.pros-grid-layout .pros-grid-container .ag-ltr .ag-label-align-right .ag-label{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-label-align-right .ag-label{margin-right:6px}.pros-grid-layout .pros-grid-container{-webkit-font-smoothing:antialiased;color:#212121;font-size:13px;line-height:normal}.pros-grid-layout .pros-grid-container::-webkit-scrollbar,.pros-grid-layout .pros-grid-container ::-webkit-scrollbar{width:6px;height:6px}.pros-grid-layout .pros-grid-container::-webkit-scrollbar-track,.pros-grid-layout .pros-grid-container ::-webkit-scrollbar-track{background-color:transparent}.pros-grid-layout .pros-grid-container::-webkit-scrollbar-thumb,.pros-grid-layout .pros-grid-container ::-webkit-scrollbar-thumb{background-color:#adadad;border-radius:10px}.pros-grid-layout .pros-grid-container .ag-root-wrapper{background-color:#ffffff}.pros-grid-layout .pros-grid-container input[class^=ag-]{margin:0;background-color:#ffffff}.pros-grid-layout .pros-grid-container textarea[class^=ag-],.pros-grid-layout .pros-grid-container select[class^=ag-]{background-color:#ffffff}.pros-grid-layout .pros-grid-container input[class^=ag-]:not([type]),.pros-grid-layout .pros-grid-container input[class^=ag-][type=text],.pros-grid-layout .pros-grid-container input[class^=ag-][type=number],.pros-grid-layout .pros-grid-container input[class^=ag-][type=tel],.pros-grid-layout .pros-grid-container input[class^=ag-][type=date],.pros-grid-layout .pros-grid-container input[class^=ag-][type=datetime-local],.pros-grid-layout .pros-grid-container textarea[class^=ag-]{font-size:inherit;line-height:inherit;color:inherit;border-width:1px;border-style:solid;border-color:#babfc7}.pros-grid-layout .pros-grid-container input[class^=ag-]:not([type]):disabled,.pros-grid-layout .pros-grid-container input[class^=ag-][type=text]:disabled,.pros-grid-layout .pros-grid-container input[class^=ag-][type=number]:disabled,.pros-grid-layout .pros-grid-container input[class^=ag-][type=tel]:disabled,.pros-grid-layout .pros-grid-container input[class^=ag-][type=date]:disabled,.pros-grid-layout .pros-grid-container input[class^=ag-][type=datetime-local]:disabled,.pros-grid-layout .pros-grid-container textarea[class^=ag-]:disabled{color:rgba(24, 29, 31, 0.5);background-color:#f1f2f4;border-color:rgba(186, 191, 199, 0.3)}.pros-grid-layout .pros-grid-container input[class^=ag-]:not([type]):focus,.pros-grid-layout .pros-grid-container input[class^=ag-][type=text]:focus,.pros-grid-layout .pros-grid-container input[class^=ag-][type=number]:focus,.pros-grid-layout .pros-grid-container input[class^=ag-][type=tel]:focus,.pros-grid-layout .pros-grid-container input[class^=ag-][type=date]:focus,.pros-grid-layout .pros-grid-container input[class^=ag-][type=datetime-local]:focus,.pros-grid-layout .pros-grid-container textarea[class^=ag-]:focus{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container input[class^=ag-][type=number]{-moz-appearance:textfield}.pros-grid-layout .pros-grid-container input[class^=ag-][type=number]::-webkit-outer-spin-button,.pros-grid-layout .pros-grid-container input[class^=ag-][type=number]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]{padding:0}.pros-grid-layout .pros-grid-container input[class^=ag-][type=button]:focus,.pros-grid-layout .pros-grid-container button[class^=ag-]:focus{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-drag-handle{color:#181d1f}.pros-grid-layout .pros-grid-container .ag-list-item,.pros-grid-layout .pros-grid-container .ag-virtual-list-item{height:24px}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-virtual-list-item:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-virtual-list-item:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-select-list{background-color:#fff;overflow-y:auto;overflow-x:hidden}.pros-grid-layout .pros-grid-container .ag-list-item{display:flex;align-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pros-grid-layout .pros-grid-container .ag-list-item.ag-active-item{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout .pros-grid-container .ag-select-list-item{padding-left:4px;padding-right:4px;cursor:default;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.pros-grid-layout .pros-grid-container .ag-select-list-item span{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.pros-grid-layout .pros-grid-container .ag-select .ag-picker-field-wrapper{background-color:#fff;min-height:24px;cursor:default}.pros-grid-layout .pros-grid-container .ag-select.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}.pros-grid-layout .pros-grid-container .ag-select:not(.ag-cell-editor){height:24px}.pros-grid-layout .pros-grid-container .ag-select .ag-picker-field-display{margin:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pros-grid-layout .pros-grid-container .ag-select .ag-picker-field-icon{display:flex;align-items:center}.pros-grid-layout .pros-grid-container .ag-select.ag-disabled{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-rich-select{background-color:#f8f8f8}.pros-grid-layout .pros-grid-container .ag-rich-select-list{width:100%;min-width:200px;height:273px}.pros-grid-layout .pros-grid-container .ag-rich-select-value{padding:0 6px 0 18px;height:42px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-rich-select-virtual-list-item{cursor:default;height:24px}.pros-grid-layout .pros-grid-container .ag-rich-select-virtual-list-item:hover{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout .pros-grid-container .ag-rich-select-row{padding-left:18px}.pros-grid-layout .pros-grid-container .ag-rich-select-row-selected{background-color:rgba(33, 150, 243, 0.3)}.pros-grid-layout .pros-grid-container .ag-row-drag,.pros-grid-layout .pros-grid-container .ag-selection-checkbox,.pros-grid-layout .pros-grid-container .ag-group-expanded,.pros-grid-layout .pros-grid-container .ag-group-contracted{color:#181d1f}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-drag,.pros-grid-layout .pros-grid-container .ag-ltr .ag-selection-checkbox,.pros-grid-layout .pros-grid-container .ag-ltr .ag-group-expanded,.pros-grid-layout .pros-grid-container .ag-ltr .ag-group-contracted{margin-right:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-drag,.pros-grid-layout .pros-grid-container .ag-rtl .ag-selection-checkbox,.pros-grid-layout .pros-grid-container .ag-rtl .ag-group-expanded,.pros-grid-layout .pros-grid-container .ag-rtl .ag-group-contracted{margin-left:12px}.pros-grid-layout .pros-grid-container .ag-cell-wrapper>*:not(.ag-cell-value):not(.ag-group-value){height:40px;display:flex;align-items:center;flex:none}.pros-grid-layout .pros-grid-container .ag-group-expanded,.pros-grid-layout .pros-grid-container .ag-group-contracted{cursor:pointer}.pros-grid-layout .pros-grid-container .ag-group-title-bar-icon{cursor:pointer;flex:none;color:#181d1f}.pros-grid-layout .pros-grid-container .ag-ltr .ag-group-child-count{margin-left:2px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-group-child-count{margin-right:2px}.pros-grid-layout .pros-grid-container .ag-group-title-bar{background-color:#fff;padding:6px}.pros-grid-layout .pros-grid-container .ag-group-toolbar{padding:6px}.pros-grid-layout .pros-grid-container .ag-disabled-group-title-bar,.pros-grid-layout .pros-grid-container .ag-disabled-group-container{opacity:0.5}.pros-grid-layout .pros-grid-container .group-item{margin:3px 0}.pros-grid-layout .pros-grid-container .ag-label{white-space:nowrap}.pros-grid-layout .pros-grid-container .ag-ltr .ag-label{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-label{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-label-align-top .ag-label{margin-bottom:3px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-slider-field,.pros-grid-layout .pros-grid-container .ag-ltr .ag-angle-select-field{margin-right:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-slider-field,.pros-grid-layout .pros-grid-container .ag-rtl .ag-angle-select-field{margin-left:12px}.pros-grid-layout .pros-grid-container .ag-angle-select-parent-circle{width:24px;height:24px;border-radius:12px;border:solid 1px;border-color:#babfc7;background-color:#fff}.pros-grid-layout .pros-grid-container .ag-angle-select-child-circle{top:4px;left:12px;width:6px;height:6px;margin-left:-3px;margin-top:-4px;border-radius:3px;background-color:#181d1f}.pros-grid-layout .pros-grid-container .ag-picker-field-wrapper{border:1px solid;border-color:#babfc7;border-radius:5px}.pros-grid-layout .pros-grid-container .ag-picker-field-wrapper:focus{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-picker-field-button{background-color:#fff;color:#181d1f}.pros-grid-layout .pros-grid-container .ag-dialog.ag-color-dialog{border-radius:5px}.pros-grid-layout .pros-grid-container .ag-color-picker .ag-picker-field-display{height:16px}.pros-grid-layout .pros-grid-container .ag-color-panel{padding:6px}.pros-grid-layout .pros-grid-container .ag-spectrum-color{background-color:red;border-radius:2px}.pros-grid-layout .pros-grid-container .ag-spectrum-tools{padding:10px}.pros-grid-layout .pros-grid-container .ag-spectrum-sat{background-image:linear-gradient(to right, white, rgba(204, 154, 129, 0))}.pros-grid-layout .pros-grid-container .ag-spectrum-val{background-image:linear-gradient(to top, black, rgba(204, 154, 129, 0))}.pros-grid-layout .pros-grid-container .ag-spectrum-dragger{border-radius:12px;height:12px;width:12px;border:1px solid white;background:black;box-shadow:0 0 2px 0 rgba(0, 0, 0, 0.24)}.pros-grid-layout .pros-grid-container .ag-spectrum-hue-background{border-radius:2px}.pros-grid-layout .pros-grid-container .ag-spectrum-alpha-background{border-radius:2px}.pros-grid-layout .pros-grid-container .ag-spectrum-tool{margin-bottom:10px;height:11px;border-radius:2px}.pros-grid-layout .pros-grid-container .ag-spectrum-slider{margin-top:-12px;width:13px;height:13px;border-radius:13px;background-color:#f8f8f8;box-shadow:0 1px 4px 0 rgba(0, 0, 0, 0.37)}.pros-grid-layout .pros-grid-container .ag-recent-color{margin:0 3px}.pros-grid-layout .pros-grid-container .ag-recent-color:first-child{margin-left:0}.pros-grid-layout .pros-grid-container .ag-recent-color:last-child{margin-right:0}.pros-grid-layout .pros-grid-container.ag-dnd-ghost{border:solid 1px;border-color:#babfc7;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);overflow:hidden;text-overflow:ellipsis;z-index:10;border:solid 1px;border-color:#dde2eb;color:#181d1f;height:48px !important;line-height:48px;margin:0;padding:0 12px;-webkit-transform:translateY(12px);transform:translateY(12px)}.pros-grid-layout .pros-grid-container .ag-dnd-ghost-icon{margin-right:6px;color:#181d1f}.pros-grid-layout .pros-grid-container .ag-popup-child:not(.ag-tooltip-custom){box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4)}.pros-grid-layout .ag-dragging-range-handle .pros-grid-container .ag-dialog,.pros-grid-layout .ag-dragging-fill-handle .pros-grid-container .ag-dialog{opacity:0.7;pointer-events:none}.pros-grid-layout .pros-grid-container .ag-dialog{border-radius:3px;border:solid 1px;border-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-panel{background-color:#fff}.pros-grid-layout .pros-grid-container .ag-panel-title-bar{background-color:#f8f8f8;color:#212121;height:48px;padding:6px 18px;border-bottom:solid 1px;border-bottom-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-ltr .ag-panel-title-bar-button{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-panel-title-bar-button{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-tooltip{background-color:#f8f8f8;color:#181d1f;padding:6px;border:solid 1px;border-color:#babfc7;border-radius:3px;transition:opacity 1s}.pros-grid-layout .pros-grid-container .ag-tooltip.ag-tooltip-hiding{opacity:0}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-1{padding-left:16px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-1{padding-right:16px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-2{padding-left:32px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-2{padding-right:32px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-3{padding-left:48px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-3{padding-right:48px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-4{padding-left:64px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-4{padding-right:64px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-5{padding-left:80px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-5{padding-right:80px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-6{padding-left:96px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-6{padding-right:96px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-7{padding-left:112px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-7{padding-right:112px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-8{padding-left:128px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-8{padding-right:128px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-indent-9{padding-left:144px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-indent-9{padding-right:144px}.pros-grid-layout .pros-grid-container .ag-column-select-header-icon{cursor:pointer}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-column-select-header-icon:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-column-select-header-icon:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:0;left:0;display:block;width:calc(100% - 0px);height:calc(100% - 0px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-group-icons:not(:last-child),.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-header-icon:not(:last-child),.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-header-checkbox:not(:last-child),.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child),.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-checkbox:not(:last-child),.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-column-drag-handle:not(:last-child),.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child),.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-column-label:not(:last-child){margin-right:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-group-icons:not(:last-child),.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-header-icon:not(:last-child),.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-header-checkbox:not(:last-child),.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child),.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-checkbox:not(:last-child),.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-column-drag-handle:not(:last-child),.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child),.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-column-label:not(:last-child){margin-left:12px}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-column-select-virtual-list-item:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-column-select-virtual-list-item:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-column-select-column-group:not(:last-child),.pros-grid-layout .pros-grid-container .ag-column-select-column:not(:last-child){margin-bottom:9px}.pros-grid-layout .pros-grid-container .ag-column-select-column-readonly,.pros-grid-layout .pros-grid-container .ag-column-select-column-group-readonly{color:rgba(24, 29, 31, 0.5);pointer-events:none}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-select-add-group-indent{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-select-add-group-indent{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-column-select-virtual-list-viewport{padding:6px 12px}.pros-grid-layout .pros-grid-container .ag-rtl{text-align:right}.pros-grid-layout .pros-grid-container .ag-root-wrapper{border:solid 1px;border-radius:16px;border-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-left:46px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-right:46px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-1{padding-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-1{padding-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-left:74px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-right:74px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-2{padding-left:56px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-2{padding-right:56px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-left:102px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-right:102px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-3{padding-left:84px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-3{padding-right:84px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-left:130px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-right:130px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-4{padding-left:112px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-4{padding-right:112px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-left:158px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-right:158px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-5{padding-left:140px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-5{padding-right:140px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-left:186px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-right:186px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-6{padding-left:168px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-6{padding-right:168px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-left:214px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-right:214px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-7{padding-left:196px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-7{padding-right:196px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-left:242px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-right:242px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-8{padding-left:224px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-8{padding-right:224px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-left:270px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-right:270px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-9{padding-left:252px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-9{padding-right:252px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-left:298px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-right:298px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-10{padding-left:280px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-10{padding-right:280px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-left:326px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-right:326px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-11{padding-left:308px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-11{padding-right:308px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-left:354px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-right:354px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-12{padding-left:336px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-12{padding-right:336px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-left:382px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-right:382px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-13{padding-left:364px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-13{padding-right:364px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-left:410px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-right:410px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-14{padding-left:392px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-14{padding-right:392px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-left:438px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-right:438px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-15{padding-left:420px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-15{padding-right:420px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-left:466px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-right:466px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-16{padding-left:448px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-16{padding-right:448px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-left:494px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-right:494px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-17{padding-left:476px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-17{padding-right:476px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-left:522px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-right:522px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-18{padding-left:504px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-18{padding-right:504px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-left:550px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-right:550px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-indent-19{padding-left:532px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-indent-19{padding-right:532px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-row-group-leaf-indent{margin-left:28px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-row-group-leaf-indent{margin-right:28px}.pros-grid-layout .pros-grid-container .ag-value-change-delta{padding-right:2px}.pros-grid-layout .pros-grid-container .ag-value-change-delta-up{color:#43a047}.pros-grid-layout .pros-grid-container .ag-value-change-delta-down{color:#e53935}.pros-grid-layout .pros-grid-container .ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.pros-grid-layout .pros-grid-container .ag-value-change-value-highlight{background-color:rgba(22, 160, 133, 0.5);transition:background-color 0.1s}.pros-grid-layout .pros-grid-container .ag-cell-data-changed{background-color:rgba(22, 160, 133, 0.5) !important}.pros-grid-layout .pros-grid-container .ag-cell-data-changed-animation{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-cell-highlight{background-color:#2196f3 !important}.pros-grid-layout .pros-grid-container .ag-row{height:42px;background-color:rgba(33, 33, 33, 0.05);color:#212121;border-width:1px;border-color:#ebebeb;border-bottom-style:solid}.pros-grid-layout .pros-grid-container .ag-row-highlight-above::after,.pros-grid-layout .pros-grid-container .ag-row-highlight-below::after{content:\"\";position:absolute;width:calc(100% - 1px);height:1px;background-color:#ffffff;left:1px}.pros-grid-layout .pros-grid-container .ag-row-highlight-above::after{top:-1px}.pros-grid-layout .pros-grid-container .ag-row-highlight-above.ag-row-first::after{top:0}.pros-grid-layout .pros-grid-container .ag-row-highlight-below::after{bottom:0}.pros-grid-layout .pros-grid-container .ag-row-odd{background-color:#ffffff}.pros-grid-layout .pros-grid-container .ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:solid 1px;border-right-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:none}.pros-grid-layout .pros-grid-container .ag-ltr .ag-right-aligned-cell{text-align:right}.pros-grid-layout .pros-grid-container .ag-rtl .ag-right-aligned-cell{text-align:left}.pros-grid-layout .pros-grid-container .ag-ltr .ag-right-aligned-cell .ag-cell-value{margin-left:auto}.pros-grid-layout .pros-grid-container .ag-rtl .ag-right-aligned-cell .ag-cell-value{margin-right:auto}.pros-grid-layout .pros-grid-container .ag-cell,.pros-grid-layout .pros-grid-container .ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;padding-left:16px;padding-right:16px;-webkit-font-smoothing:subpixel-antialiased}.pros-grid-layout .pros-grid-container .ag-row>.ag-cell-wrapper{padding-left:16px;padding-right:16px}.pros-grid-layout .pros-grid-container .ag-row-dragging{cursor:move;opacity:0.5}.pros-grid-layout .pros-grid-container .ag-cell-inline-editing{border:solid 1px;border-color:#babfc7;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:0;height:42px;background-color:#f8f8f8}.pros-grid-layout .pros-grid-container .ag-popup-editor{border:solid 1px;border-color:#babfc7;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);background-color:#f8f8f8;padding:0}.pros-grid-layout .pros-grid-container .ag-large-text-input{height:auto;padding:18px}.pros-grid-layout .pros-grid-container .ag-details-row{padding:30px;background-color:#fff}.pros-grid-layout .pros-grid-container .ag-layout-auto-height .ag-center-cols-clipper,.pros-grid-layout .pros-grid-container .ag-layout-auto-height .ag-center-cols-container,.pros-grid-layout .pros-grid-container .ag-layout-print .ag-center-cols-clipper,.pros-grid-layout .pros-grid-container .ag-layout-print .ag-center-cols-container{min-height:50px}.pros-grid-layout .pros-grid-container .ag-overlay-loading-wrapper{background-color:rgba(255, 255, 255, 0.66)}.pros-grid-layout .pros-grid-container .ag-overlay-loading-center{border:solid 1px;border-color:#babfc7;background:#fff;border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:6px}.pros-grid-layout .pros-grid-container .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:30px}.pros-grid-layout .pros-grid-container .ag-loading{padding-left:18px;display:flex;height:100%;align-items:center}.pros-grid-layout .pros-grid-container .ag-loading-icon{padding-right:12px}.pros-grid-layout .pros-grid-container .ag-icon-loading{-webkit-animation-name:spin;animation-name:spin;-webkit-animation-duration:1000ms;animation-duration:1000ms;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}@-webkit-keyframes spin{from{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{from{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.pros-grid-layout .pros-grid-container .ag-floating-top{border-bottom:solid 1px;border-bottom-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-floating-bottom{border-top:solid 1px;border-top-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell{border-right:solid transparent}.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell{border-left:solid transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell{border-right-width:1px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell{border-left-width:1px}.pros-grid-layout .pros-grid-container .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell){border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell){border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-row-selected{background-color:#027aae;color:#ffffff}.pros-grid-layout .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus),.pros-grid-layout .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing){background-color:rgba(33, 150, 243, 0.2)}.pros-grid-layout .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,.pros-grid-layout .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart{background-color:rgba(0, 88, 255, 0.1) !important}.pros-grid-layout .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,.pros-grid-layout .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category{background-color:rgba(0, 255, 132, 0.1) !important}.pros-grid-layout .pros-grid-container .ag-cell-range-selected-1:not(.ag-cell-focus),.pros-grid-layout .pros-grid-container .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:rgba(33, 150, 243, 0.2)}.pros-grid-layout .pros-grid-container .ag-cell-range-selected-2:not(.ag-cell-focus),.pros-grid-layout .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2{background-color:rgba(33, 150, 243, 0.36)}.pros-grid-layout .pros-grid-container .ag-cell-range-selected-3:not(.ag-cell-focus),.pros-grid-layout .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3{background-color:rgba(33, 150, 243, 0.488)}.pros-grid-layout .pros-grid-container .ag-cell-range-selected-4:not(.ag-cell-focus),.pros-grid-layout .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4{background-color:rgba(33, 150, 243, 0.5904)}.pros-grid-layout .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top{border-top-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right{border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom{border-bottom-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left{border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout .pros-grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout .pros-grid-container .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell-range-single-cell,.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,.pros-grid-layout .pros-grid-container .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout .pros-grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout .pros-grid-container .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell-range-single-cell,.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle{border:1px solid;border-color:#ebebeb;outline:initial}.pros-grid-layout .pros-grid-container .ag-cell.ag-selection-fill-top,.pros-grid-layout .pros-grid-container .ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-right,.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed;border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-right,.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed;border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-cell.ag-selection-fill-bottom,.pros-grid-layout .pros-grid-container .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-left,.pros-grid-layout .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed;border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-left,.pros-grid-layout .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed;border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-fill-handle,.pros-grid-layout .pros-grid-container .ag-range-handle{position:absolute;width:6px;height:6px;bottom:-1px;background-color:#2196f3}.pros-grid-layout .pros-grid-container .ag-ltr .ag-fill-handle,.pros-grid-layout .pros-grid-container .ag-ltr .ag-range-handle{right:-1px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-fill-handle,.pros-grid-layout .pros-grid-container .ag-rtl .ag-range-handle{left:-1px}.pros-grid-layout .pros-grid-container .ag-fill-handle{cursor:cell}.pros-grid-layout .pros-grid-container .ag-range-handle{cursor:nwse-resize}.pros-grid-layout .pros-grid-container .ag-cell-inline-editing{border-color:rgba(33, 150, 243, 0.4) !important}.pros-grid-layout .pros-grid-container .ag-menu{border:solid 1px;border-color:#adadad;border-radius:12px;background-color:#ffffff;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:0}.pros-grid-layout .pros-grid-container .ag-menu-list{cursor:default;padding:6px 0}.pros-grid-layout .pros-grid-container .ag-menu-separator{height:13px}.pros-grid-layout .pros-grid-container .ag-menu-separator-part:after{content:\"\";display:block;border-top:solid 1px;border-top-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-menu-option-active,.pros-grid-layout .pros-grid-container .ag-compact-menu-option-active{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout .pros-grid-container .ag-menu-option-part,.pros-grid-layout .pros-grid-container .ag-compact-menu-option-part{line-height:16px;padding:8px 0}.pros-grid-layout .pros-grid-container .ag-menu-option-disabled,.pros-grid-layout .pros-grid-container .ag-compact-menu-option-disabled{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-menu-option-icon,.pros-grid-layout .pros-grid-container .ag-compact-menu-option-icon{width:16px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-menu-option-icon,.pros-grid-layout .pros-grid-container .ag-ltr .ag-compact-menu-option-icon{padding-left:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-menu-option-icon,.pros-grid-layout .pros-grid-container .ag-rtl .ag-compact-menu-option-icon{padding-right:12px}.pros-grid-layout .pros-grid-container .ag-menu-option-text,.pros-grid-layout .pros-grid-container .ag-compact-menu-option-text{padding-left:12px;padding-right:12px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-menu-option-shortcut,.pros-grid-layout .pros-grid-container .ag-ltr .ag-compact-menu-option-shortcut{padding-right:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-menu-option-shortcut,.pros-grid-layout .pros-grid-container .ag-rtl .ag-compact-menu-option-shortcut{padding-left:6px}.pros-grid-layout .pros-grid-container .ag-menu-option-popup-pointer,.pros-grid-layout .pros-grid-container .ag-compact-menu-option-popup-pointer{padding-right:6px}.pros-grid-layout .pros-grid-container .ag-tabs-header{min-width:220px;width:100%;display:flex}.pros-grid-layout .pros-grid-container .ag-tab{border-bottom:2px solid transparent;display:flex;flex:none;align-items:center;justify-content:center;cursor:pointer;flex:1 1 auto;transition:border-bottom 0.3s}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-tab:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-tab:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-tab-selected{border-bottom-color:#2196f3}.pros-grid-layout .pros-grid-container .ag-menu-header{color:#181d1f}.pros-grid-layout .pros-grid-container .ag-filter-separator{border-top:solid 1px;border-top-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-filter-condition-operator{height:17px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-condition-operator-or{margin-left:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-condition-operator-or{margin-right:12px}.pros-grid-layout .pros-grid-container .ag-set-filter-select-all{padding-top:12px}.pros-grid-layout .pros-grid-container .ag-set-filter-list,.pros-grid-layout .pros-grid-container .ag-filter-no-matches{height:144px}.pros-grid-layout .pros-grid-container .ag-set-filter-filter{margin-top:12px;margin-left:12px;margin-right:12px}.pros-grid-layout .pros-grid-container .ag-filter-to{margin-top:9px}.pros-grid-layout .pros-grid-container .ag-mini-filter{margin:12px 12px}.pros-grid-layout .pros-grid-container .ag-set-filter-item{margin:0 12px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-set-filter-item-value{margin-left:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-set-filter-item-value{margin-right:12px}.pros-grid-layout .pros-grid-container .ag-filter-apply-panel{padding:12px 12px;border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-filter-apply-panel-button{line-height:1.5}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-apply-panel-button{margin-left:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-apply-panel-button{margin-right:12px}.pros-grid-layout .pros-grid-container .ag-simple-filter-body-wrapper{padding:12px 12px;padding-bottom:3px}.pros-grid-layout .pros-grid-container .ag-simple-filter-body-wrapper>*{margin-bottom:9px}.pros-grid-layout .pros-grid-container .ag-filter-no-matches{padding:12px 12px}.pros-grid-layout .pros-grid-container .ag-multi-filter-menu-item{margin:6px 0}.pros-grid-layout .pros-grid-container .ag-multi-filter-group-title-bar{padding:12px 6px;background-color:transparent}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-side-bar{position:relative}.pros-grid-layout .pros-grid-container .ag-tool-panel-wrapper{background-color:#f8f8f8}.pros-grid-layout .pros-grid-container .ag-side-buttons{padding-top:24px;width:20px;position:relative;color:#181d1f;overflow:hidden}.pros-grid-layout .pros-grid-container button.ag-side-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;background:transparent;padding:12px 0 12px 0;width:100%;margin:0;min-height:108px;background-position-y:center;background-position-x:center;background-repeat:no-repeat;border:none}.pros-grid-layout .pros-grid-container button.ag-side-button-button:focus{box-shadow:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-side-button-button:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-side-button-button:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-side-button-icon-wrapper{margin-bottom:3px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-left,.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-right{border-right:solid 1px;border-right-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper{border-left:solid 1px;border-left-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-left .ag-side-button-button,.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-right .ag-side-button-button{border-right:2px solid transparent;transition:border-right 0.3s}.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button{border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-left,.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-right{border-left:solid 1px;border-left-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper{border-right:solid 1px;border-right-color:#babfc7}.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-left .ag-side-button-button,.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-right .ag-side-button-button{border-left:2px solid transparent;transition:border-left 0.3s}.pros-grid-layout .pros-grid-container .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,.pros-grid-layout .pros-grid-container .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button{border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-header{height:36px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-header,.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-search{padding-left:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-header,.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-search{padding-right:6px}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-filter-toolpanel-header:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-filter-toolpanel-header:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\f112\";position:absolute}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{padding-left:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{padding-right:6px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-0-header{height:48px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-item{margin-top:3px;margin-bottom:3px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-search{height:48px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-search-input{flex-grow:1;height:24px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-search-input{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-search-input{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-0{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-expand,.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-title-bar-icon{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-expand,.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-title-bar-icon{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-left:22px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-right:22px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-left:38px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-right:38px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-left:54px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-right:54px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-left:70px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-right:70px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-left:86px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-right:86px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-left:102px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-right:102px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-left:118px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-right:118px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-left:134px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-right:134px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-left:150px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-right:150px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-left:166px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-right:166px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header{padding-left:6px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-instance-filter{border-top:solid 1px;border-top-color:#babfc7;border-bottom:solid 1px;border-bottom-color:#babfc7;margin-top:6px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-filter-toolpanel-instance-header-icon{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-filter-toolpanel-instance-header-icon{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-pivot-mode-panel{height:48px;display:flex}.pros-grid-layout .pros-grid-container .ag-pivot-mode-select{display:flex;align-items:center}.pros-grid-layout .pros-grid-container .ag-ltr .ag-pivot-mode-select{margin-left:12px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-pivot-mode-select{margin-right:12px}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-column-select-header:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-column-select-header:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-column-select-header{height:48px;align-items:center;padding:0 12px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-column-panel-column-select{border-bottom:solid 1px;border-bottom-color:#dde2eb;border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-column-group-icons,.pros-grid-layout .pros-grid-container .ag-column-select-header-icon{color:#181d1f}.pros-grid-layout .pros-grid-container .ag-header{background-color:transparent;border-bottom:solid 1px;border-bottom-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-header:hover{color:#212121}.pros-grid-layout .pros-grid-container .ag-header-row{height:48px}.pros-grid-layout .pros-grid-container .ag-pinned-right-header{border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-pinned-left-header{border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-header-cell,.pros-grid-layout .pros-grid-container .ag-header-group-cell{padding-left:16px;padding-right:16px}.pros-grid-layout .pros-grid-container .ag-header-cell.ag-header-cell-moving,.pros-grid-layout .pros-grid-container .ag-header-group-cell.ag-header-cell-moving{background-color:#fff}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-header-cell:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-header-cell:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-header-group-cell:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-header-group-cell:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-header-icon{color:#181d1f}.pros-grid-layout .pros-grid-container .ag-header-expand-icon{cursor:pointer}.pros-grid-layout .pros-grid-container .ag-ltr .ag-header-expand-icon{padding-left:4px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-header-expand-icon{padding-right:4px}.pros-grid-layout .pros-grid-container .ag-header-row:not(:first-child) .ag-header-cell,.pros-grid-layout .pros-grid-container .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group{border-top:solid 1px;border-top-color:#737373}.pros-grid-layout .pros-grid-container .ag-header-cell-resize{display:flex;align-items:center}.pros-grid-layout .pros-grid-container .ag-header-cell-resize::after{content:\"\";position:absolute;z-index:1;display:block;left:calc(50% - 1px);width:2px;height:30%;top:35%;background-color:rgba(186, 191, 199, 0.5)}.pros-grid-layout .pros-grid-container .ag-pinned-right-header .ag-header-cell-resize::after{left:calc(50% - 2px)}.pros-grid-layout .pros-grid-container .ag-ltr .ag-header-select-all{margin-right:18px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-header-select-all{margin-left:18px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-floating-filter-button{margin-left:18px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-floating-filter-button{margin-right:18px}.pros-grid-layout .pros-grid-container .ag-floating-filter-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:none;height:16px;padding:0;width:16px}.pros-grid-layout .pros-grid-container .ag-filter-loading{background-color:#f8f8f8;height:100%;padding:12px 12px;position:absolute;width:100%;z-index:1}.pros-grid-layout .pros-grid-container .ag-paging-panel{border-top:1px solid;border-top-color:#ebebeb;color:#181d1f;height:48px}.pros-grid-layout .pros-grid-container .ag-paging-panel>*{margin:0 18px}.pros-grid-layout .pros-grid-container .ag-paging-button{cursor:pointer}.pros-grid-layout .pros-grid-container .ag-paging-button.ag-disabled{cursor:default;color:rgba(24, 29, 31, 0.5)}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-paging-button:focus{outline:none}.pros-grid-layout .pros-grid-container .ag-keyboard-focus .ag-paging-button:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:0px;left:0px;display:block;width:calc(100% - 0px);height:calc(100% - 0px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-paging-button,.pros-grid-layout .pros-grid-container .ag-paging-description{margin:0 6px}.pros-grid-layout .pros-grid-container .ag-status-bar{border-top:solid 1px;border-top-color:#ebebeb;color:rgba(24, 29, 31, 0.5);padding-right:24px;padding-left:24px;line-height:1.5}.pros-grid-layout .pros-grid-container .ag-status-name-value-value{color:#181d1f}.pros-grid-layout .pros-grid-container .ag-status-bar-center{text-align:center}.pros-grid-layout .pros-grid-container .ag-status-name-value{margin-left:6px;margin-right:6px;padding-top:12px;padding-bottom:12px}.pros-grid-layout .pros-grid-container .ag-column-drop-cell{background:rgba(24, 29, 31, 0.07);background:var(--ag-chip-background-color, rgba(24, 29, 31, 0.07));border-radius:24px;height:24px;padding:0 3px}.pros-grid-layout .pros-grid-container .ag-column-drop-cell-text{margin:0 6px}.pros-grid-layout .pros-grid-container .ag-column-drop-cell-button{min-width:24px;margin:0 3px;color:#181d1f}.pros-grid-layout .pros-grid-container .ag-column-drop-cell-drag-handle{margin-left:12px}.pros-grid-layout .pros-grid-container .ag-column-drop-cell-ghost{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-column-drop-horizontal{background-color:#f8f8f8;color:#181d1f;height:42px;border-bottom:solid 1px;border-bottom-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-drop-horizontal{padding-left:18px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-drop-horizontal{padding-right:18px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child){border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child){border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-column-drop-horizontal-cell-separator{margin:0 6px;color:#181d1f}.pros-grid-layout .pros-grid-container .ag-column-drop-horizontal-empty-message{color:rgba(24, 29, 31, 0.5)}.pros-grid-layout .pros-grid-container .ag-ltr .ag-column-drop-horizontal-icon{margin-right:18px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-column-drop-horizontal-icon{margin-left:18px}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical-list{padding-bottom:6px;padding-right:6px;padding-left:6px}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical-cell{margin-top:6px}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical{min-height:50px;max-height:150px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical.ag-last-column-drop{border-bottom:none}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical-icon{margin-left:6px;margin-right:6px}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical-empty-message{position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden;color:rgba(24, 29, 31, 0.5);margin-top:6px}.pros-grid-layout .pros-grid-container .ag-select-agg-func-popup{border:solid 1px;border-color:#ebebeb;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);background:#fff;background:var(--ag-background-color, #fff);height:105px;padding:0}.pros-grid-layout .pros-grid-container .ag-select-agg-func-virtual-list-item{cursor:default;line-height:30px;padding-left:12px}.pros-grid-layout .pros-grid-container .ag-select-agg-func-virtual-list-item:hover{background-color:rgba(33, 150, 243, 0.3)}.pros-grid-layout .pros-grid-container .ag-chart-menu{border-radius:3px;background:#fff;background:var(--ag-background-color, #fff)}.pros-grid-layout .pros-grid-container .ag-chart-menu-icon{opacity:0.5;line-height:24px;font-size:24px;width:24px;height:24px;margin:2px 0;cursor:pointer;border-radius:3px;color:#181d1f}.pros-grid-layout .pros-grid-container .ag-chart-menu-icon:hover{opacity:1}.pros-grid-layout .pros-grid-container .ag-chart-mini-thumbnail{border:1px solid;border-color:#dde2eb;border-radius:5px;margin:5px}.pros-grid-layout .pros-grid-container .ag-chart-mini-thumbnail:nth-last-child(3),.pros-grid-layout .pros-grid-container .ag-chart-mini-thumbnail:nth-last-child(3)~.ag-chart-mini-thumbnail{margin-left:auto;margin-right:auto}.pros-grid-layout .pros-grid-container .ag-ltr .ag-chart-mini-thumbnail:first-child{margin-left:0}.pros-grid-layout .pros-grid-container .ag-rtl .ag-chart-mini-thumbnail:first-child{margin-right:0}.pros-grid-layout .pros-grid-container .ag-ltr .ag-chart-mini-thumbnail:last-child{margin-right:0}.pros-grid-layout .pros-grid-container .ag-rtl .ag-chart-mini-thumbnail:last-child{margin-left:0}.pros-grid-layout .pros-grid-container .ag-chart-mini-thumbnail.ag-selected{border-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-chart-settings-card-item{background:#181d1f;background:var(--ag-foreground-color, #181d1f);width:8px;height:8px;border-radius:4px}.pros-grid-layout .pros-grid-container .ag-chart-settings-card-item.ag-selected{background-color:#2196f3}.pros-grid-layout .pros-grid-container .ag-chart-data-column-drag-handle{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-charts-settings-group-title-bar,.pros-grid-layout .pros-grid-container .ag-charts-data-group-title-bar,.pros-grid-layout .pros-grid-container .ag-charts-format-top-level-group-title-bar{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-charts-settings-group-container{padding:6px}.pros-grid-layout .pros-grid-container .ag-charts-data-group-container{padding:12px 12px;padding-bottom:3px}.pros-grid-layout .pros-grid-container .ag-charts-data-group-container>*{margin-bottom:9px}.pros-grid-layout .pros-grid-container .ag-charts-format-top-level-group-container{margin-left:12px;padding:6px}.pros-grid-layout .pros-grid-container .ag-charts-format-top-level-group-item{margin:6px 0}.pros-grid-layout .pros-grid-container .ag-charts-format-sub-level-group-container{padding:12px 12px;padding-bottom:3px}.pros-grid-layout .pros-grid-container .ag-charts-format-sub-level-group-container>*{margin-bottom:9px}.pros-grid-layout .pros-grid-container .ag-charts-group-container.ag-group-container-horizontal{padding:6px}.pros-grid-layout .pros-grid-container .ag-chart-data-section,.pros-grid-layout .pros-grid-container .ag-chart-format-section{display:flex;margin:0}.pros-grid-layout .pros-grid-container .ag-chart-menu-panel{background-color:#f8f8f8}.pros-grid-layout .pros-grid-container .ag-ltr .ag-chart-menu-panel{border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-rtl .ag-chart-menu-panel{border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-date-time-list-page-title{flex-grow:1;text-align:center}.pros-grid-layout .pros-grid-container .ag-date-time-list-page-column-label{text-align:center}.pros-grid-layout .pros-grid-container .ag-date-time-list-page-entry{text-align:center}.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px;background-color:#fff;border-radius:3px;display:inline-block;vertical-align:middle;flex:none}.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper input,.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper:focus-within,.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper:active{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper::after{content:\"\\f108\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper.ag-checked::after{content:\"\\f106\";color:#2196f3;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout .pros-grid-container .ag-checkbox-input-wrapper.ag-indeterminate::after{content:\"\\f107\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout .pros-grid-container .ag-toggle-button-input-wrapper{box-sizing:border-box;width:28px;height:18px;background-color:#999;border-radius:9px;position:relative;flex:none;border:1px solid;border-color:#999}.pros-grid-layout .pros-grid-container .ag-toggle-button-input-wrapper input{opacity:0;height:100%;width:100%}.pros-grid-layout .pros-grid-container .ag-toggle-button-input-wrapper:focus-within{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-toggle-button-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-toggle-button-input-wrapper.ag-checked{background-color:#2196f3;border-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-toggle-button-input-wrapper::before{content:\" \";position:absolute;top:-1px;left:-1px;display:block;box-sizing:border-box;height:18px;width:18px;background-color:#fff;border-radius:9px;transition:left 100ms;border:1px solid;border-color:#999}.pros-grid-layout .pros-grid-container .ag-toggle-button-input-wrapper.ag-checked::before{left:calc(100% - 18px);border-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px;background-color:#fff;display:inline-block;vertical-align:middle;flex:none;border-radius:16px}.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper input,.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper:focus-within,.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper:active{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper::after{content:\"\\f124\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout .pros-grid-container .ag-radio-button-input-wrapper.ag-checked::after{content:\"\\f125\";color:#2196f3;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]{-webkit-appearance:none;width:100%;height:100%;background:none;overflow:visible}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]::-webkit-slider-runnable-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]::-moz-range-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]::-ms-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px;color:transparent;width:calc(100% - 2px)}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]::-webkit-slider-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px;-webkit-transform:translateY(-6.5px);transform:translateY(-6.5px)}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]::-ms-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]::-moz-ag-range-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:focus{outline:none}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:focus::-webkit-slider-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#ebebeb}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:focus::-ms-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#ebebeb}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:focus::-moz-ag-range-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#ebebeb}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:active::-webkit-slider-runnable-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:active::-moz-ag-range-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:active::-ms-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout .pros-grid-container input[class^=ag-][type=range]:disabled{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-header,.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-search,.pros-grid-layout .pros-grid-container .ag-status-bar,.pros-grid-layout .pros-grid-container .ag-header-row,.pros-grid-layout .pros-grid-container .ag-panel-title-bar-title,.pros-grid-layout .pros-grid-container .ag-multi-filter-group-title-bar{font-weight:700;color:#737373}.pros-grid-layout .pros-grid-container .ag-ltr .ag-pinned-right-header .ag-header-row:after,.pros-grid-layout .pros-grid-container .ag-rtl .ag-pinned-left-header .ag-header-row:before{content:\"\";position:absolute;height:calc(100% - 20px);top:10px;width:1px;background-color:#babfc7;display:none}.pros-grid-layout .pros-grid-container .ag-ltr .ag-pinned-right-header .ag-header-row:after{right:0}.pros-grid-layout .pros-grid-container .ag-rtl .ag-pinned-left-header .ag-header-row:before{left:0}.pros-grid-layout .pros-grid-container .ag-row{font-size:14px}.pros-grid-layout .pros-grid-container input[class^=ag-]:not([type]),.pros-grid-layout .pros-grid-container input[class^=ag-][type=text],.pros-grid-layout .pros-grid-container input[class^=ag-][type=number],.pros-grid-layout .pros-grid-container input[class^=ag-][type=tel],.pros-grid-layout .pros-grid-container input[class^=ag-][type=date],.pros-grid-layout .pros-grid-container input[class^=ag-][type=datetime-local],.pros-grid-layout .pros-grid-container textarea[class^=ag-]{min-height:24px;border-radius:3px}.pros-grid-layout .pros-grid-container .ag-ltr input[class^=ag-]:not([type]),.pros-grid-layout .pros-grid-container .ag-ltr input[class^=ag-][type=text],.pros-grid-layout .pros-grid-container .ag-ltr input[class^=ag-][type=number],.pros-grid-layout .pros-grid-container .ag-ltr input[class^=ag-][type=tel],.pros-grid-layout .pros-grid-container .ag-ltr input[class^=ag-][type=date],.pros-grid-layout .pros-grid-container .ag-ltr input[class^=ag-][type=datetime-local],.pros-grid-layout .pros-grid-container .ag-ltr textarea[class^=ag-]{padding-left:6px}.pros-grid-layout .pros-grid-container .ag-rtl input[class^=ag-]:not([type]),.pros-grid-layout .pros-grid-container .ag-rtl input[class^=ag-][type=text],.pros-grid-layout .pros-grid-container .ag-rtl input[class^=ag-][type=number],.pros-grid-layout .pros-grid-container .ag-rtl input[class^=ag-][type=tel],.pros-grid-layout .pros-grid-container .ag-rtl input[class^=ag-][type=date],.pros-grid-layout .pros-grid-container .ag-rtl input[class^=ag-][type=datetime-local],.pros-grid-layout .pros-grid-container .ag-rtl textarea[class^=ag-]{padding-right:6px}.pros-grid-layout .pros-grid-container .ag-tab{padding:9px;transition:color 0.4s}.pros-grid-layout .pros-grid-container .ag-tab-selected{color:#2196f3}.pros-grid-layout .pros-grid-container .ag-menu{background-color:white}.pros-grid-layout .pros-grid-container .ag-menu-header{background-color:#f8f8f8;padding-top:1px;min-width:240px}.pros-grid-layout .pros-grid-container .ag-tabs-header{border-bottom:solid 1px;border-bottom-color:#ebebeb}.pros-grid-layout .pros-grid-container .ag-charts-settings-group-title-bar,.pros-grid-layout .pros-grid-container .ag-charts-data-group-title-bar,.pros-grid-layout .pros-grid-container .ag-charts-format-top-level-group-title-bar{padding:6px 12px;line-height:20px}.pros-grid-layout .pros-grid-container .ag-chart-mini-thumbnail{background-color:#fff}.pros-grid-layout .pros-grid-container .ag-chart-settings-nav-bar{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout .pros-grid-container .ag-ltr .ag-group-title-bar-icon{margin-right:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-group-title-bar-icon{margin-left:6px}.pros-grid-layout .pros-grid-container .ag-charts-format-top-level-group-toolbar{margin-top:6px}.pros-grid-layout .pros-grid-container .ag-ltr .ag-charts-format-top-level-group-toolbar{padding-left:20px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-charts-format-top-level-group-toolbar{padding-right:20px}.pros-grid-layout .pros-grid-container .ag-charts-format-sub-level-group{border-left:dashed 1px;border-left-color:#ebebeb;padding-left:6px;margin-bottom:12px}.pros-grid-layout .pros-grid-container .ag-charts-format-sub-level-group-title-bar{padding-top:0;padding-bottom:0;background:none;font-weight:700}.pros-grid-layout .pros-grid-container .ag-charts-format-sub-level-group-container{padding-bottom:0}.pros-grid-layout .pros-grid-container .ag-charts-format-sub-level-group-item:last-child{margin-bottom:0}.pros-grid-layout .pros-grid-container .ag-dnd-ghost{font-size:12px;font-weight:700}.pros-grid-layout .pros-grid-container .ag-side-buttons{width:30px}.pros-grid-layout .pros-grid-container .ag-standard-button{-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:3px;border:1px solid;border-color:#ebebeb;color:#2196f3;background-color:#fff;font-weight:600;padding:6px 12px}.pros-grid-layout .pros-grid-container .ag-standard-button:hover{border-color:#ebebeb;background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout .pros-grid-container .ag-standard-button:active{border-color:#ebebeb;background-color:#2196f3;color:#fff}.pros-grid-layout .pros-grid-container .ag-standard-button:disabled{color:rgba(24, 29, 31, 0.5);background-color:#f1f2f4;border-color:rgba(186, 191, 199, 0.3)}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical{min-height:75px;max-height:175px}.pros-grid-layout .pros-grid-container .ag-tool-panel-wrapper{width:250px}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical-title-bar{padding:12px;padding-bottom:0}.pros-grid-layout .pros-grid-container .ag-column-drop-vertical-empty-message{display:flex;align-items:center;border:dashed 1px;border-color:#ebebeb;margin:12px;padding:12px}.pros-grid-layout .pros-grid-container .ag-column-drop-empty-message{color:#181d1f;opacity:0.75}.pros-grid-layout .pros-grid-container .ag-status-bar{font-weight:normal}.pros-grid-layout .pros-grid-container .ag-status-name-value-value{font-weight:700}.pros-grid-layout .pros-grid-container .ag-paging-number,.pros-grid-layout .pros-grid-container .ag-paging-row-summary-panel-number{font-weight:700}.pros-grid-layout .pros-grid-container .ag-column-drop-cell-button{opacity:0.5}.pros-grid-layout .pros-grid-container .ag-column-drop-cell-button:hover{opacity:0.75}.pros-grid-layout .pros-grid-container .ag-header-cell-menu-button:hover,.pros-grid-layout .pros-grid-container .ag-side-button-button:hover,.pros-grid-layout .pros-grid-container .ag-tab:hover,.pros-grid-layout .pros-grid-container .ag-panel-title-bar-button:hover,.pros-grid-layout .pros-grid-container .ag-header-expand-icon:hover,.pros-grid-layout .pros-grid-container .ag-column-group-icons:hover,.pros-grid-layout .pros-grid-container .ag-group-expanded .ag-icon:hover,.pros-grid-layout .pros-grid-container .ag-group-contracted .ag-icon:hover,.pros-grid-layout .pros-grid-container .ag-chart-settings-prev:hover,.pros-grid-layout .pros-grid-container .ag-chart-settings-next:hover,.pros-grid-layout .pros-grid-container .ag-group-title-bar-icon:hover,.pros-grid-layout .pros-grid-container .ag-column-select-header-icon:hover,.pros-grid-layout .pros-grid-container .ag-floating-filter-button-button:hover,.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-expand:hover,.pros-grid-layout .pros-grid-container .ag-chart-menu-icon:hover{color:#2196f3}.pros-grid-layout .pros-grid-container .ag-chart-settings-card-item.ag-not-selected:hover{opacity:0.35}.pros-grid-layout .pros-grid-container .ag-ltr .ag-panel-title-bar-button{margin-left:12px;margin-right:6px}.pros-grid-layout .pros-grid-container .ag-rtl .ag-panel-title-bar-button{margin-right:12px;margin-left:6px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-group-container{padding-left:6px}.pros-grid-layout .pros-grid-container .ag-filter-toolpanel-instance-filter{border:none;background-color:#f8f8f8;border-left:dashed 1px;border-left-color:#ebebeb;margin-left:8px;padding-left:8px;margin-right:12px}.pros-grid-layout .pros-grid-container .ag-set-filter-list{padding-top:3px;padding-bottom:3px}.pros-grid-layout .pros-grid-container .ag-layout-auto-height .ag-center-cols-clipper,.pros-grid-layout .pros-grid-container .ag-layout-auto-height .ag-center-cols-container,.pros-grid-layout .pros-grid-container .ag-layout-print .ag-center-cols-clipper,.pros-grid-layout .pros-grid-container .ag-layout-print .ag-center-cols-container{min-height:150px}.pros-grid-layout .pros-grid-container .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:60px}.pros-grid-layout .pros-grid-container .ag-date-time-list-page-entry-is-current{background-color:#2196f3}.pros-grid-layout .pros-grid-container .pros-action-header{border-right:1px solid #ebebeb}.pros-grid-layout .pros-grid-header-container .header-icon.filter:hover{background-color:#ebebeb}.pros-grid-layout .pros--action-grid-header{color:#737373}.pros-grid-layout .pros-filter-bar{color:#212121}.pros-grid-layout[pos--theme=light] .pros-grid-container{-webkit-font-smoothing:antialiased;color:#212121;font-size:13px;line-height:normal}.pros-grid-layout[pos--theme=light] .pros-grid-container::-webkit-scrollbar,.pros-grid-layout[pos--theme=light] .pros-grid-container ::-webkit-scrollbar{width:6px;height:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container::-webkit-scrollbar-track,.pros-grid-layout[pos--theme=light] .pros-grid-container ::-webkit-scrollbar-track{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container::-webkit-scrollbar-thumb,.pros-grid-layout[pos--theme=light] .pros-grid-container ::-webkit-scrollbar-thumb{background-color:#adadad;border-radius:10px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-root-wrapper{background-color:#ffffff}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-]{margin:0;background-color:#ffffff}.pros-grid-layout[pos--theme=light] .pros-grid-container textarea[class^=ag-],.pros-grid-layout[pos--theme=light] .pros-grid-container select[class^=ag-]{background-color:#ffffff}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=text],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=number],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=date],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=light] .pros-grid-container textarea[class^=ag-]{font-size:inherit;line-height:inherit;color:inherit;border-width:1px;border-style:solid;border-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-]:not([type]):disabled,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=text]:disabled,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=number]:disabled,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=tel]:disabled,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=date]:disabled,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=datetime-local]:disabled,.pros-grid-layout[pos--theme=light] .pros-grid-container textarea[class^=ag-]:disabled{color:rgba(24, 29, 31, 0.5);background-color:#f1f2f4;border-color:rgba(186, 191, 199, 0.3)}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-]:not([type]):focus,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=text]:focus,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=number]:focus,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=tel]:focus,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=date]:focus,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=datetime-local]:focus,.pros-grid-layout[pos--theme=light] .pros-grid-container textarea[class^=ag-]:focus{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=number]{-moz-appearance:textfield}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=number]::-webkit-outer-spin-button,.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=number]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]{padding:0}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=button]:focus,.pros-grid-layout[pos--theme=light] .pros-grid-container button[class^=ag-]:focus{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-drag-handle{color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-list-item,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-virtual-list-item{height:24px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-virtual-list-item:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-virtual-list-item:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select-list{background-color:#fff;overflow-y:auto;overflow-x:hidden}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-list-item{display:flex;align-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-list-item.ag-active-item{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select-list-item{padding-left:4px;padding-right:4px;cursor:default}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select-list-item span{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select .ag-picker-field-wrapper{background-color:#fff;min-height:24px;cursor:default}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select:not(.ag-cell-editor){height:24px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select .ag-picker-field-display{margin:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select .ag-picker-field-icon{display:flex;align-items:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rich-select{background-color:#f8f8f8}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rich-select-list{width:100%;min-width:200px;height:273px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rich-select-value{padding:0 6px 0 18px;height:42px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rich-select-virtual-list-item{cursor:default;height:24px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rich-select-virtual-list-item:hover{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rich-select-row{padding-left:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rich-select-row-selected{background-color:rgba(33, 150, 243, 0.3)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-drag,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-selection-checkbox,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-expanded,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-contracted{color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-drag,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-selection-checkbox,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-group-expanded,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-group-contracted{margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-drag,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-selection-checkbox,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-group-expanded,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-group-contracted{margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-wrapper>*:not(.ag-cell-value):not(.ag-group-value){height:40px;display:flex;align-items:center;flex:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-expanded,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-contracted{cursor:pointer}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-title-bar-icon{cursor:pointer;flex:none;color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-group-child-count{margin-left:2px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-group-child-count{margin-right:2px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-title-bar{background-color:#fff;padding:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-toolbar{padding:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-disabled-group-title-bar,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-disabled-group-container{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .group-item{margin:3px 0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-label{white-space:nowrap}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-label{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-label{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-label-align-top .ag-label{margin-bottom:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-slider-field,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-angle-select-field{margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-slider-field,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-angle-select-field{margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-angle-select-parent-circle{width:24px;height:24px;border-radius:12px;border:solid 1px;border-color:#babfc7;background-color:#fff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-angle-select-child-circle{top:4px;left:12px;width:6px;height:6px;margin-left:-3px;margin-top:-4px;border-radius:3px;background-color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-picker-field-wrapper{border:1px solid;border-color:#babfc7;border-radius:5px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-picker-field-wrapper:focus{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-picker-field-button{background-color:#fff;color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-dialog.ag-color-dialog{border-radius:5px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-color-picker .ag-picker-field-display{height:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-color-panel{padding:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-color{background-color:red;border-radius:2px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-tools{padding:10px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-sat{background-image:linear-gradient(to right, white, rgba(204, 154, 129, 0))}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-val{background-image:linear-gradient(to top, black, rgba(204, 154, 129, 0))}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-dragger{border-radius:12px;height:12px;width:12px;border:1px solid white;background:black;box-shadow:0 0 2px 0 rgba(0, 0, 0, 0.24)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-hue-background{border-radius:2px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-alpha-background{border-radius:2px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-tool{margin-bottom:10px;height:11px;border-radius:2px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-spectrum-slider{margin-top:-12px;width:13px;height:13px;border-radius:13px;background-color:#f8f8f8;box-shadow:0 1px 4px 0 rgba(0, 0, 0, 0.37)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-recent-color{margin:0 3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-recent-color:first-child{margin-left:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-recent-color:last-child{margin-right:0}.pros-grid-layout[pos--theme=light] .pros-grid-container.ag-dnd-ghost{border:solid 1px;border-color:#babfc7;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);overflow:hidden;text-overflow:ellipsis;z-index:10;border:solid 1px;border-color:#dde2eb;color:#181d1f;height:48px !important;line-height:48px;margin:0;padding:0 12px;-webkit-transform:translateY(12px);transform:translateY(12px)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-dnd-ghost-icon{margin-right:6px;color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-popup-child:not(.ag-tooltip-custom){box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4)}.pros-grid-layout[pos--theme=light] .ag-dragging-range-handle .pros-grid-container .ag-dialog,.pros-grid-layout[pos--theme=light] .ag-dragging-fill-handle .pros-grid-container .ag-dialog{opacity:0.7;pointer-events:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-dialog{border-radius:3px;border:solid 1px;border-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-panel{background-color:#fff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-panel-title-bar{background-color:#f8f8f8;color:#212121;height:48px;padding:6px 18px;border-bottom:solid 1px;border-bottom-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-panel-title-bar-button{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-panel-title-bar-button{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tooltip{background-color:#f8f8f8;color:#181d1f;padding:6px;border:solid 1px;border-color:#babfc7;border-radius:3px;transition:opacity 1s}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tooltip.ag-tooltip-hiding{opacity:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-1{padding-left:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-1{padding-right:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-2{padding-left:32px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-2{padding-right:32px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-3{padding-left:48px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-3{padding-right:48px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-4{padding-left:64px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-4{padding-right:64px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-5{padding-left:80px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-5{padding-right:80px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-6{padding-left:96px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-6{padding-right:96px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-7{padding-left:112px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-7{padding-right:112px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-8{padding-left:128px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-8{padding-right:128px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-indent-9{padding-left:144px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-indent-9{padding-right:144px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-header-icon{cursor:pointer}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-column-select-header-icon:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-column-select-header-icon:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:0;left:0;display:block;width:calc(100% - 0px);height:calc(100% - 0px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-group-icons:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-header-icon:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-header-checkbox:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-checkbox:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-column-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-column-label:not(:last-child){margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-group-icons:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-header-icon:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-header-checkbox:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-checkbox:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-column-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-column-label:not(:last-child){margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-column-select-virtual-list-item:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-column-select-virtual-list-item:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-column-group:not(:last-child),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-column:not(:last-child){margin-bottom:9px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-column-readonly,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-column-group-readonly{color:rgba(24, 29, 31, 0.5);pointer-events:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-select-add-group-indent{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-select-add-group-indent{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-virtual-list-viewport{padding:6px 12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl{text-align:right}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-root-wrapper{border:solid 1px;border-radius:16px;border-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-left:46px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-right:46px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-1{padding-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-1{padding-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-left:74px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-right:74px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-2{padding-left:56px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-2{padding-right:56px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-left:102px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-right:102px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-3{padding-left:84px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-3{padding-right:84px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-left:130px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-right:130px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-4{padding-left:112px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-4{padding-right:112px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-left:158px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-right:158px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-5{padding-left:140px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-5{padding-right:140px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-left:186px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-right:186px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-6{padding-left:168px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-6{padding-right:168px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-left:214px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-right:214px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-7{padding-left:196px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-7{padding-right:196px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-left:242px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-right:242px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-8{padding-left:224px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-8{padding-right:224px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-left:270px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-right:270px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-9{padding-left:252px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-9{padding-right:252px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-left:298px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-right:298px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-10{padding-left:280px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-10{padding-right:280px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-left:326px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-right:326px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-11{padding-left:308px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-11{padding-right:308px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-left:354px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-right:354px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-12{padding-left:336px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-12{padding-right:336px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-left:382px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-right:382px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-13{padding-left:364px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-13{padding-right:364px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-left:410px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-right:410px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-14{padding-left:392px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-14{padding-right:392px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-left:438px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-right:438px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-15{padding-left:420px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-15{padding-right:420px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-left:466px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-right:466px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-16{padding-left:448px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-16{padding-right:448px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-left:494px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-right:494px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-17{padding-left:476px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-17{padding-right:476px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-left:522px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-right:522px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-18{padding-left:504px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-18{padding-right:504px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-left:550px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-right:550px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-indent-19{padding-left:532px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-indent-19{padding-right:532px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-row-group-leaf-indent{margin-left:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-row-group-leaf-indent{margin-right:28px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-value-change-delta{padding-right:2px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-value-change-delta-up{color:#43a047}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-value-change-delta-down{color:#e53935}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-value-change-value-highlight{background-color:rgba(22, 160, 133, 0.5);transition:background-color 0.1s}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-data-changed{background-color:rgba(22, 160, 133, 0.5) !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-data-changed-animation{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-highlight{background-color:#2196f3 !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row{height:42px;background-color:rgba(33, 33, 33, 0.05);color:#212121;border-width:1px;border-color:#ebebeb;border-bottom-style:solid}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-highlight-above::after,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-highlight-below::after{content:\"\";position:absolute;width:calc(100% - 1px);height:1px;background-color:#ffffff;left:1px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-highlight-above::after{top:-1px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-highlight-above.ag-row-first::after{top:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-highlight-below::after{bottom:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-odd{background-color:#ffffff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:solid 1px;border-right-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-hover{background-color:#ebf9ff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-right-aligned-cell{text-align:right}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-right-aligned-cell{text-align:left}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-right-aligned-cell .ag-cell-value{margin-left:auto}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-right-aligned-cell .ag-cell-value{margin-right:auto}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;padding-left:16px;padding-right:16px;-webkit-font-smoothing:subpixel-antialiased}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row>.ag-cell-wrapper{padding-left:16px;padding-right:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-dragging{cursor:move;opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-inline-editing{border:solid 1px;border-color:#babfc7;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:0;height:42px;background-color:#f8f8f8}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-popup-editor{border:solid 1px;border-color:#babfc7;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);background-color:#f8f8f8;padding:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-large-text-input{height:auto;padding:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-details-row{padding:30px;background-color:#fff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-auto-height .ag-center-cols-clipper,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-auto-height .ag-center-cols-container,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-print .ag-center-cols-clipper,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-print .ag-center-cols-container{min-height:50px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-overlay-loading-wrapper{background-color:rgba(255, 255, 255, 0.66)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-overlay-loading-center{border:solid 1px;border-color:#babfc7;background:#fff;border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:30px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-loading{padding-left:18px;display:flex;height:100%;align-items:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-loading-icon{padding-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-icon-loading{-webkit-animation-name:spin;animation-name:spin;-webkit-animation-duration:1000ms;animation-duration:1000ms;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}@-webkit-keyframes spin{from{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{from{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-floating-top{border-bottom:solid 1px;border-bottom-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-floating-bottom{border-top:solid 1px;border-top-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell{border-right:solid transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell{border-left:solid transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell{border-right-width:1px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell{border-left-width:1px}.pros-grid-layout[pos--theme=light] .pros-grid-container .pros-action-cell{border-right:solid 1px !important;border-right-color:#ebebeb !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell){border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell){border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-selected{background-color:#027aae;color:#ffffff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-selected .pros-cell-icon .pros-icon-wrapper{color:white !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-selected .pros-cell-image .pros-icon-wrapper{color:white !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-selected .pros-link a{color:white !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row-selected .pros-link .pros-cell-text{color:white !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing){background-color:rgba(33, 150, 243, 0.2)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart{background-color:rgba(0, 88, 255, 0.1) !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category{background-color:rgba(0, 255, 132, 0.1) !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-range-selected-1:not(.ag-cell-focus),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:rgba(33, 150, 243, 0.2)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-range-selected-2:not(.ag-cell-focus),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2{background-color:rgba(33, 150, 243, 0.36)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-range-selected-3:not(.ag-cell-focus),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3{background-color:rgba(33, 150, 243, 0.488)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-range-selected-4:not(.ag-cell-focus),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4{background-color:rgba(33, 150, 243, 0.5904)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top{border-top-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right{border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom{border-bottom-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left{border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell-range-single-cell,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell-range-single-cell,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle{border:1px solid;border-color:#ebebeb;outline:initial}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-selection-fill-top,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-right,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed;border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-right,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed;border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-selection-fill-bottom,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-left,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed;border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-left,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed;border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-fill-handle,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-range-handle{position:absolute;width:6px;height:6px;bottom:-1px;background-color:#2196f3}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-fill-handle,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-range-handle{right:-1px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-fill-handle,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-range-handle{left:-1px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-fill-handle{cursor:cell}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-range-handle{cursor:nwse-resize}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-cell-inline-editing{border-color:rgba(33, 150, 243, 0.4) !important}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu{border:solid 1px;border-color:#adadad;border-radius:12px;background-color:#ffffff;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-list{cursor:default;padding:6px 0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-separator{height:13px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-separator-part:after{content:\"\";display:block;border-top:solid 1px;border-top-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-option-active,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-compact-menu-option-active{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-option-part,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-compact-menu-option-part{line-height:16px;padding:8px 0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-option-disabled,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-compact-menu-option-disabled{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-option-icon,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-compact-menu-option-icon{width:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-menu-option-icon,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-compact-menu-option-icon{padding-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-menu-option-icon,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-compact-menu-option-icon{padding-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-option-text,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-compact-menu-option-text{padding-left:12px;padding-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-menu-option-shortcut,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-compact-menu-option-shortcut{padding-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-menu-option-shortcut,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-compact-menu-option-shortcut{padding-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-option-popup-pointer,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-compact-menu-option-popup-pointer{padding-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tabs-header{min-width:220px;width:100%;display:flex}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tab{border-bottom:2px solid transparent;display:flex;flex:none;align-items:center;justify-content:center;cursor:pointer;flex:1 1 auto;transition:border-bottom 0.3s}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-tab:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-tab:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tab-selected{border-bottom-color:#2196f3}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-header{color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-separator{border-top:solid 1px;border-top-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-condition-operator{height:17px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-condition-operator-or{margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-condition-operator-or{margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-set-filter-select-all{padding-top:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-set-filter-list,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-no-matches{height:144px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-set-filter-filter{margin-top:12px;margin-left:12px;margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-to{margin-top:9px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-mini-filter{margin:12px 12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-set-filter-item{margin:0 12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-set-filter-item-value{margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-set-filter-item-value{margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-apply-panel{padding:12px 12px;border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-apply-panel-button{line-height:1.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-apply-panel-button{margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-apply-panel-button{margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-simple-filter-body-wrapper{padding:12px 12px;padding-bottom:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-simple-filter-body-wrapper>*{margin-bottom:9px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-no-matches{padding:12px 12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-multi-filter-menu-item{margin:6px 0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-multi-filter-group-title-bar{padding:12px 6px;background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-side-bar{position:relative}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tool-panel-wrapper{background-color:#f8f8f8}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-side-buttons{padding-top:24px;width:20px;position:relative;color:#181d1f;overflow:hidden}.pros-grid-layout[pos--theme=light] .pros-grid-container button.ag-side-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;background:transparent;padding:12px 0 12px 0;width:100%;margin:0;min-height:108px;background-position-y:center;background-position-x:center;background-repeat:no-repeat;border:none}.pros-grid-layout[pos--theme=light] .pros-grid-container button.ag-side-button-button:focus{box-shadow:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-side-button-button:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-side-button-button:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-side-button-icon-wrapper{margin-bottom:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-left,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-right{border-right:solid 1px;border-right-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper{border-left:solid 1px;border-left-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-left .ag-side-button-button,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-right .ag-side-button-button{border-right:2px solid transparent;transition:border-right 0.3s}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button{border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-left,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-right{border-left:solid 1px;border-left-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper{border-right:solid 1px;border-right-color:#babfc7}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-left .ag-side-button-button,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-right .ag-side-button-button{border-left:2px solid transparent;transition:border-left 0.3s}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button{border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-header{height:36px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-header,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-search{padding-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-header,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-search{padding-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-filter-toolpanel-header:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-filter-toolpanel-header:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\f112\";position:absolute}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{padding-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{padding-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-0-header{height:48px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-item{margin-top:3px;margin-bottom:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-search{height:48px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-search-input{flex-grow:1;height:24px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-search-input{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-search-input{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-0{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-expand,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-title-bar-icon{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-expand,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-title-bar-icon{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-left:22px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-right:22px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-left:38px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-right:38px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-left:54px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-right:54px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-left:70px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-right:70px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-left:86px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-right:86px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-left:102px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-right:102px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-left:118px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-right:118px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-left:134px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-right:134px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-left:150px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-right:150px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-left:166px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-right:166px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header{padding-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-instance-filter{border-top:solid 1px;border-top-color:#babfc7;border-bottom:solid 1px;border-bottom-color:#babfc7;margin-top:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-filter-toolpanel-instance-header-icon{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-filter-toolpanel-instance-header-icon{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-pivot-mode-panel{height:48px;display:flex}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-pivot-mode-select{display:flex;align-items:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-pivot-mode-select{margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-pivot-mode-select{margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-column-select-header:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-column-select-header:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-header{height:48px;align-items:center;padding:0 12px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-panel-column-select{border-bottom:solid 1px;border-bottom-color:#dde2eb;border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-group-icons,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-header-icon{color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header{background-color:transparent;border-bottom:solid 1px;border-bottom-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header:hover{color:#212121}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-row{height:48px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-pinned-right-header{border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-pinned-left-header{border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-cell,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-group-cell{padding-left:16px;padding-right:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-cell.ag-header-cell-moving,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-group-cell.ag-header-cell-moving{background-color:#fff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-header-cell:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-header-cell:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-header-group-cell:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-header-group-cell:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-icon{color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-expand-icon{cursor:pointer}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-header-expand-icon{padding-left:4px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-header-expand-icon{padding-right:4px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-row:not(:first-child) .ag-header-cell,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group{border-top:solid 1px;border-top-color:#737373}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-cell-resize{display:flex;align-items:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-cell-resize::after{content:\"\";position:absolute;z-index:1;display:block;left:calc(50% - 1px);width:2px;height:30%;top:35%;background-color:rgba(186, 191, 199, 0.5)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-pinned-right-header .ag-header-cell-resize::after{left:calc(50% - 2px)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-header-select-all{margin-right:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-header-select-all{margin-left:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-floating-filter-button{margin-left:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-floating-filter-button{margin-right:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-floating-filter-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:none;height:16px;padding:0;width:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-loading{background-color:#f8f8f8;height:100%;padding:12px 12px;position:absolute;width:100%;z-index:1}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-panel{border-top:1px solid;border-top-color:#ebebeb;color:#181d1f;height:48px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-panel>*{margin:0 18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-button{cursor:pointer}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-button.ag-disabled{cursor:default;color:rgba(24, 29, 31, 0.5)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-paging-button:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-keyboard-focus .ag-paging-button:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:0px;left:0px;display:block;width:calc(100% - 0px);height:calc(100% - 0px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-button,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-description{margin:0 6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-status-bar{border-top:solid 1px;border-top-color:#ebebeb;color:rgba(24, 29, 31, 0.5);padding-right:24px;padding-left:24px;line-height:1.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-status-name-value-value{color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-status-bar-center{text-align:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-status-name-value{margin-left:6px;margin-right:6px;padding-top:12px;padding-bottom:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-cell{background:rgba(24, 29, 31, 0.07);background:var(--ag-chip-background-color, rgba(24, 29, 31, 0.07));border-radius:24px;height:24px;padding:0 3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-cell-text{margin:0 6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-cell-button{min-width:24px;margin:0 3px;color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-cell-drag-handle{margin-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-cell-ghost{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-horizontal{background-color:#f8f8f8;color:#181d1f;height:42px;border-bottom:solid 1px;border-bottom-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-drop-horizontal{padding-left:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-drop-horizontal{padding-right:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child){border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child){border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-horizontal-cell-separator{margin:0 6px;color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-horizontal-empty-message{color:rgba(24, 29, 31, 0.5)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-column-drop-horizontal-icon{margin-right:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-column-drop-horizontal-icon{margin-left:18px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical-list{padding-bottom:6px;padding-right:6px;padding-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical-cell{margin-top:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical{min-height:50px;max-height:150px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical.ag-last-column-drop{border-bottom:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical-icon{margin-left:6px;margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical-empty-message{position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden;color:rgba(24, 29, 31, 0.5);margin-top:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select-agg-func-popup{border:solid 1px;border-color:#ebebeb;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);background:#fff;background:var(--ag-background-color, #fff);height:105px;padding:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select-agg-func-virtual-list-item{cursor:default;line-height:30px;padding-left:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-select-agg-func-virtual-list-item:hover{background-color:rgba(33, 150, 243, 0.3)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-menu{border-radius:3px;background:#fff;background:var(--ag-background-color, #fff)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-menu-icon{opacity:0.5;line-height:24px;font-size:24px;width:24px;height:24px;margin:2px 0;cursor:pointer;border-radius:3px;color:#181d1f}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-menu-icon:hover{opacity:1}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-mini-thumbnail{border:1px solid;border-color:#dde2eb;border-radius:5px;margin:5px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-mini-thumbnail:nth-last-child(3),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-mini-thumbnail:nth-last-child(3)~.ag-chart-mini-thumbnail{margin-left:auto;margin-right:auto}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-chart-mini-thumbnail:first-child{margin-left:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-chart-mini-thumbnail:first-child{margin-right:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-chart-mini-thumbnail:last-child{margin-right:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-chart-mini-thumbnail:last-child{margin-left:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-mini-thumbnail.ag-selected{border-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-settings-card-item{background:#181d1f;background:var(--ag-foreground-color, #181d1f);width:8px;height:8px;border-radius:4px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-settings-card-item.ag-selected{background-color:#2196f3}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-data-column-drag-handle{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-settings-group-title-bar,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-data-group-title-bar,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-top-level-group-title-bar{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-settings-group-container{padding:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-data-group-container{padding:12px 12px;padding-bottom:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-data-group-container>*{margin-bottom:9px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-top-level-group-container{margin-left:12px;padding:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-top-level-group-item{margin:6px 0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-sub-level-group-container{padding:12px 12px;padding-bottom:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-sub-level-group-container>*{margin-bottom:9px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-group-container.ag-group-container-horizontal{padding:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-data-section,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-format-section{display:flex;margin:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-menu-panel{background-color:#f8f8f8}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-chart-menu-panel{border-left:solid 1px;border-left-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-chart-menu-panel{border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-date-time-list-page-title{flex-grow:1;text-align:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-date-time-list-page-column-label{text-align:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-date-time-list-page-entry{text-align:center}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px;background-color:#fff;border-radius:3px;display:inline-block;vertical-align:middle;flex:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper input,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper:focus-within,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper:active{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper::after{content:\"\\f108\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper.ag-checked::after{content:\"\\f106\";color:#2196f3;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-checkbox-input-wrapper.ag-indeterminate::after{content:\"\\f107\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-toggle-button-input-wrapper{box-sizing:border-box;width:28px;height:18px;background-color:#999;border-radius:9px;position:relative;flex:none;border:1px solid;border-color:#999}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-toggle-button-input-wrapper input{opacity:0;height:100%;width:100%}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-toggle-button-input-wrapper:focus-within{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-toggle-button-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-toggle-button-input-wrapper.ag-checked{background-color:#2196f3;border-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-toggle-button-input-wrapper::before{content:\" \";position:absolute;top:-1px;left:-1px;display:block;box-sizing:border-box;height:18px;width:18px;background-color:#fff;border-radius:9px;transition:left 100ms;border:1px solid;border-color:#999}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-toggle-button-input-wrapper.ag-checked::before{left:calc(100% - 18px);border-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px;background-color:#fff;display:inline-block;vertical-align:middle;flex:none;border-radius:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper input,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper:focus-within,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper:active{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper::after{content:\"\\f124\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-radio-button-input-wrapper.ag-checked::after{content:\"\\f125\";color:#2196f3;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]{-webkit-appearance:none;width:100%;height:100%;background:none;overflow:visible}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]::-webkit-slider-runnable-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]::-moz-range-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]::-ms-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px;color:transparent;width:calc(100% - 2px)}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]::-webkit-slider-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px;-webkit-transform:translateY(-6.5px);transform:translateY(-6.5px)}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]::-ms-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]::-moz-ag-range-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:focus{outline:none}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:focus::-webkit-slider-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:focus::-ms-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:focus::-moz-ag-range-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:active::-webkit-slider-runnable-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:active::-moz-ag-range-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:active::-ms-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=range]:disabled{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-header,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-search,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-status-bar,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-row,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-panel-title-bar-title,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-multi-filter-group-title-bar{font-weight:700;color:#737373}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-pinned-right-header .ag-header-row:after,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-pinned-left-header .ag-header-row:before{content:\"\";position:absolute;height:calc(100% - 20px);top:10px;width:1px;background-color:#babfc7;display:none}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-pinned-right-header .ag-header-row:after{right:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-pinned-left-header .ag-header-row:before{left:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-row{font-size:14px}.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=text],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=number],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=date],.pros-grid-layout[pos--theme=light] .pros-grid-container input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=light] .pros-grid-container textarea[class^=ag-]{min-height:24px;border-radius:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr input[class^=ag-][type=text],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr input[class^=ag-][type=number],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr input[class^=ag-][type=date],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr textarea[class^=ag-]{padding-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl input[class^=ag-][type=text],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl input[class^=ag-][type=number],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl input[class^=ag-][type=date],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl textarea[class^=ag-]{padding-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tab{padding:9px;transition:color 0.4s}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tab-selected{color:#2196f3}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu{background-color:white}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-menu-header{background-color:#f8f8f8;padding-top:1px;min-width:240px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tabs-header{border-bottom:solid 1px;border-bottom-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-settings-group-title-bar,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-data-group-title-bar,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-top-level-group-title-bar{padding:6px 12px;line-height:20px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-mini-thumbnail{background-color:#fff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-settings-nav-bar{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-group-title-bar-icon{margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-group-title-bar-icon{margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-top-level-group-toolbar{margin-top:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-charts-format-top-level-group-toolbar{padding-left:20px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-charts-format-top-level-group-toolbar{padding-right:20px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-sub-level-group{border-left:dashed 1px;border-left-color:#ebebeb;padding-left:6px;margin-bottom:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-sub-level-group-title-bar{padding-top:0;padding-bottom:0;background:none;font-weight:700}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-sub-level-group-container{padding-bottom:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-charts-format-sub-level-group-item:last-child{margin-bottom:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-dnd-ghost{font-size:12px;font-weight:700}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-side-buttons{width:30px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-standard-button{-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:3px;border:1px solid;border-color:#ebebeb;color:#2196f3;background-color:#fff;font-weight:600;padding:6px 12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-standard-button:hover{border-color:#ebebeb;background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-standard-button:active{border-color:#ebebeb;background-color:#2196f3;color:#fff}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-standard-button:disabled{color:rgba(24, 29, 31, 0.5);background-color:#f1f2f4;border-color:rgba(186, 191, 199, 0.3)}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical{min-height:75px;max-height:175px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tool-panel-wrapper{width:250px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical-title-bar{padding:12px;padding-bottom:0}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-vertical-empty-message{display:flex;align-items:center;border:dashed 1px;border-color:#ebebeb;margin:12px;padding:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-empty-message{color:#181d1f;opacity:0.75}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-status-bar{font-weight:normal}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-status-name-value-value{font-weight:700}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-number,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-paging-row-summary-panel-number{font-weight:700}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-cell-button{opacity:0.5}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-drop-cell-button:hover{opacity:0.75}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-cell-menu-button:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-side-button-button:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-tab:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-panel-title-bar-button:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-header-expand-icon:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-group-icons:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-expanded .ag-icon:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-contracted .ag-icon:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-settings-prev:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-settings-next:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-group-title-bar-icon:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-column-select-header-icon:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-floating-filter-button-button:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-expand:hover,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-menu-icon:hover{color:#2196f3}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-chart-settings-card-item.ag-not-selected:hover{opacity:0.35}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-ltr .ag-panel-title-bar-button{margin-left:12px;margin-right:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-rtl .ag-panel-title-bar-button{margin-right:12px;margin-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-group-container{padding-left:6px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-filter-toolpanel-instance-filter{border:none;background-color:#f8f8f8;border-left:dashed 1px;border-left-color:#ebebeb;margin-left:8px;padding-left:8px;margin-right:12px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-set-filter-list{padding-top:3px;padding-bottom:3px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-auto-height .ag-center-cols-clipper,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-auto-height .ag-center-cols-container,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-print .ag-center-cols-clipper,.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-layout-print .ag-center-cols-container{min-height:150px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:60px}.pros-grid-layout[pos--theme=light] .pros-grid-container .ag-date-time-list-page-entry-is-current{background-color:#2196f3}.pros-grid-layout[pos--theme=light] .pros-grid-container .pros-action-header{border-right:1px solid #ebebeb}.pros-grid-layout[pos--theme=light] .pros-grid-header-container .header-icon.filter:hover{background-color:#ebebeb}.pros-grid-layout[pos--theme=light] .pros-option-container{background-color:#FFFFFF;color:#363636;border-color:transparent}.pros-grid-layout[pos--theme=light] .pros-option-container .pros-menu-option:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040;background-color:rgba(33, 33, 33, 0.05)}.pros-grid-layout[pos--theme=light] .pros-filter-bar{color:#212121}.pros-grid-layout[pos--theme=light] .pros-cell-row.pros-link a{cursor:pointer;color:#0096d6;text-decoration:underline}.pros-grid-layout[pos--theme=light] .pros-cell-row.pros-link .pros-cell-image{cursor:pointer}.pros-grid-layout[pos--theme=light] .pros-cell-row.pros-link .pros-cell-text{cursor:pointer;color:#0096d6;text-decoration:underline}.pros-grid-layout[pos--theme=dark] .pros-grid-container{-webkit-font-smoothing:antialiased;color:#ebebeb;font-size:13px;line-height:normal}.pros-grid-layout[pos--theme=dark] .pros-grid-container::-webkit-scrollbar,.pros-grid-layout[pos--theme=dark] .pros-grid-container ::-webkit-scrollbar{width:6px;height:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container::-webkit-scrollbar-track,.pros-grid-layout[pos--theme=dark] .pros-grid-container ::-webkit-scrollbar-track{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container::-webkit-scrollbar-thumb,.pros-grid-layout[pos--theme=dark] .pros-grid-container ::-webkit-scrollbar-thumb{background-color:#585858;border-radius:10px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-root-wrapper{background-color:#2b2b2b}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-]{margin:0;background-color:#2b2b2b}.pros-grid-layout[pos--theme=dark] .pros-grid-container textarea[class^=ag-],.pros-grid-layout[pos--theme=dark] .pros-grid-container select[class^=ag-]{background-color:#2b2b2b}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=text],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=number],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=date],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=dark] .pros-grid-container textarea[class^=ag-]{font-size:inherit;line-height:inherit;color:inherit;border-width:1px;border-style:solid;border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-]:not([type]):disabled,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=text]:disabled,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=number]:disabled,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=tel]:disabled,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=date]:disabled,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=datetime-local]:disabled,.pros-grid-layout[pos--theme=dark] .pros-grid-container textarea[class^=ag-]:disabled{color:rgba(24, 29, 31, 0.5);background-color:#f1f2f4;border-color:rgba(186, 191, 199, 0.3)}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-]:not([type]):focus,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=text]:focus,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=number]:focus,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=tel]:focus,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=date]:focus,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=datetime-local]:focus,.pros-grid-layout[pos--theme=dark] .pros-grid-container textarea[class^=ag-]:focus{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=number]{-moz-appearance:textfield}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=number]::-webkit-outer-spin-button,.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=number]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]{padding:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=button]:focus,.pros-grid-layout[pos--theme=dark] .pros-grid-container button[class^=ag-]:focus{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-drag-handle{color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-list-item,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-virtual-list-item{height:24px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-virtual-list-item:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-virtual-list-item:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select-list{background-color:#fff;overflow-y:auto;overflow-x:hidden}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-list-item{display:flex;align-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-list-item.ag-active-item{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select-list-item{padding-left:4px;padding-right:4px;cursor:default}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select-list-item span{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select .ag-picker-field-wrapper{background-color:#fff;min-height:24px;cursor:default}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select:not(.ag-cell-editor){height:24px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select .ag-picker-field-display{margin:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select .ag-picker-field-icon{display:flex;align-items:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rich-select{background-color:#f8f8f8}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rich-select-list{width:100%;min-width:200px;height:273px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rich-select-value{padding:0 6px 0 18px;height:42px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rich-select-virtual-list-item{cursor:default;height:24px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rich-select-virtual-list-item:hover{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rich-select-row{padding-left:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rich-select-row-selected{background-color:rgba(33, 150, 243, 0.3)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-drag,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-selection-checkbox,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-expanded,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-contracted{color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-drag,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-selection-checkbox,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-group-expanded,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-group-contracted{margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-drag,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-selection-checkbox,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-group-expanded,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-group-contracted{margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-wrapper>*:not(.ag-cell-value):not(.ag-group-value){height:40px;display:flex;align-items:center;flex:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-expanded,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-contracted{cursor:pointer}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-title-bar-icon{cursor:pointer;flex:none;color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-group-child-count{margin-left:2px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-group-child-count{margin-right:2px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-title-bar{background-color:#fff;padding:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-toolbar{padding:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-disabled-group-title-bar,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-disabled-group-container{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .group-item{margin:3px 0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-label{white-space:nowrap}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-label{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-label{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-label-align-top .ag-label{margin-bottom:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-slider-field,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-angle-select-field{margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-slider-field,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-angle-select-field{margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-angle-select-parent-circle{width:24px;height:24px;border-radius:12px;border:solid 1px;border-color:#404040;background-color:#fff}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-angle-select-child-circle{top:4px;left:12px;width:6px;height:6px;margin-left:-3px;margin-top:-4px;border-radius:3px;background-color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-picker-field-wrapper{border:1px solid;border-color:#404040;border-radius:5px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-picker-field-wrapper:focus{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-picker-field-button{background-color:#fff;color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-dialog.ag-color-dialog{border-radius:5px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-color-picker .ag-picker-field-display{height:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-color-panel{padding:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-color{background-color:red;border-radius:2px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-tools{padding:10px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-sat{background-image:linear-gradient(to right, white, rgba(204, 154, 129, 0))}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-val{background-image:linear-gradient(to top, black, rgba(204, 154, 129, 0))}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-dragger{border-radius:12px;height:12px;width:12px;border:1px solid white;background:black;box-shadow:0 0 2px 0 rgba(0, 0, 0, 0.24)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-hue-background{border-radius:2px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-alpha-background{border-radius:2px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-tool{margin-bottom:10px;height:11px;border-radius:2px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-spectrum-slider{margin-top:-12px;width:13px;height:13px;border-radius:13px;background-color:#f8f8f8;box-shadow:0 1px 4px 0 rgba(0, 0, 0, 0.37)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-recent-color{margin:0 3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-recent-color:first-child{margin-left:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-recent-color:last-child{margin-right:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container.ag-dnd-ghost{border:solid 1px;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);overflow:hidden;text-overflow:ellipsis;z-index:10;border-color:#dde2eb;color:#181d1f;height:48px !important;line-height:48px;margin:0;padding:0 12px;-webkit-transform:translateY(12px);transform:translateY(12px)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-dnd-ghost-icon{margin-right:6px;color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-popup-child:not(.ag-tooltip-custom){box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4)}.pros-grid-layout[pos--theme=dark] .ag-dragging-range-handle .pros-grid-container .ag-dialog,.pros-grid-layout[pos--theme=dark] .ag-dragging-fill-handle .pros-grid-container .ag-dialog{opacity:0.7;pointer-events:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-dialog{border-radius:3px;border:solid 1px;border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-panel{background-color:#fff}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-panel-title-bar{background-color:#f8f8f8;color:#212121;height:48px;padding:6px 18px;border-bottom:solid 1px;border-bottom-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-panel-title-bar-button{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-panel-title-bar-button{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tooltip{background-color:#f8f8f8;color:#181d1f;padding:6px;border:solid 1px;border-color:#404040;border-radius:3px;transition:opacity 1s}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tooltip.ag-tooltip-hiding{opacity:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-1{padding-left:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-1{padding-right:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-2{padding-left:32px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-2{padding-right:32px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-3{padding-left:48px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-3{padding-right:48px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-4{padding-left:64px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-4{padding-right:64px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-5{padding-left:80px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-5{padding-right:80px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-6{padding-left:96px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-6{padding-right:96px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-7{padding-left:112px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-7{padding-right:112px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-8{padding-left:128px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-8{padding-right:128px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-indent-9{padding-left:144px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-indent-9{padding-right:144px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-header-icon{cursor:pointer}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-column-select-header-icon:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-column-select-header-icon:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:0;left:0;display:block;width:calc(100% - 0px);height:calc(100% - 0px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-group-icons:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-header-icon:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-header-checkbox:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-checkbox:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-column-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-column-label:not(:last-child){margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-group-icons:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-header-icon:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-header-checkbox:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-checkbox:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-column-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-column-label:not(:last-child){margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-column-select-virtual-list-item:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-column-select-virtual-list-item:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-column-group:not(:last-child),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-column:not(:last-child){margin-bottom:9px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-column-readonly,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-column-group-readonly{color:rgba(24, 29, 31, 0.5);pointer-events:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-select-add-group-indent{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-select-add-group-indent{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-virtual-list-viewport{padding:6px 12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl{text-align:right}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-root-wrapper{border:solid 1px;border-radius:12px;border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-left:46px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-right:46px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-1{padding-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-1{padding-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-left:74px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-right:74px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-2{padding-left:56px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-2{padding-right:56px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-left:102px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-right:102px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-3{padding-left:84px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-3{padding-right:84px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-left:130px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-right:130px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-4{padding-left:112px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-4{padding-right:112px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-left:158px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-right:158px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-5{padding-left:140px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-5{padding-right:140px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-left:186px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-right:186px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-6{padding-left:168px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-6{padding-right:168px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-left:214px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-right:214px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-7{padding-left:196px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-7{padding-right:196px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-left:242px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-right:242px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-8{padding-left:224px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-8{padding-right:224px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-left:270px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-right:270px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-9{padding-left:252px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-9{padding-right:252px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-left:298px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-right:298px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-10{padding-left:280px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-10{padding-right:280px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-left:326px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-right:326px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-11{padding-left:308px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-11{padding-right:308px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-left:354px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-right:354px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-12{padding-left:336px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-12{padding-right:336px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-left:382px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-right:382px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-13{padding-left:364px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-13{padding-right:364px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-left:410px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-right:410px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-14{padding-left:392px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-14{padding-right:392px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-left:438px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-right:438px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-15{padding-left:420px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-15{padding-right:420px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-left:466px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-right:466px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-16{padding-left:448px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-16{padding-right:448px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-left:494px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-right:494px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-17{padding-left:476px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-17{padding-right:476px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-left:522px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-right:522px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-18{padding-left:504px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-18{padding-right:504px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-left:550px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-right:550px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-indent-19{padding-left:532px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-indent-19{padding-right:532px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-row-group-leaf-indent{margin-left:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-row-group-leaf-indent{margin-right:28px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-value-change-delta{padding-right:2px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-value-change-delta-up{color:#43a047}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-value-change-delta-down{color:#e53935}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-value-change-value-highlight{background-color:rgba(22, 160, 133, 0.5);transition:background-color 0.1s}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-data-changed{background-color:rgba(22, 160, 133, 0.5) !important}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-data-changed-animation{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-highlight{background-color:#2196f3 !important}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row{height:42px;background-color:#212121;color:#ffffff;border-width:1px;border-color:#404040;border-bottom-style:solid}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-highlight-above::after,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-highlight-below::after{content:\"\";position:absolute;width:calc(100% - 1px);height:1px;background-color:transparent;left:1px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-highlight-above::after{top:-1px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-highlight-above.ag-row-first::after{top:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-highlight-below::after{bottom:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-odd{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:solid 1px;border-right-color:#ebebeb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-hover{background-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-right-aligned-cell{text-align:right}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-right-aligned-cell{text-align:left}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-right-aligned-cell .ag-cell-value{margin-left:auto}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-right-aligned-cell .ag-cell-value{margin-right:auto}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;padding-left:16px;padding-right:16px;-webkit-font-smoothing:subpixel-antialiased}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row>.ag-cell-wrapper{padding-left:16px;padding-right:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-dragging{cursor:move;opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-inline-editing{border:solid 1px;border-color:#404040;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:0;height:42px;background-color:#f8f8f8}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-popup-editor{border:solid 1px;border-color:#404040;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);background-color:#f8f8f8;padding:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-large-text-input{height:auto;padding:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-details-row{padding:30px;background-color:#fff}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-auto-height .ag-center-cols-clipper,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-auto-height .ag-center-cols-container,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-print .ag-center-cols-clipper,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-print .ag-center-cols-container{min-height:50px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-overlay-loading-wrapper{background-color:#000000;margin-top:49px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-overlay-loading-center{border:solid 1px;border-color:#212121;background:#212121;border-radius:3px;box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);padding:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:30px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-loading{padding-left:18px;display:flex;height:100%;align-items:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-loading-icon{padding-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-icon-loading{-webkit-animation-name:spin;animation-name:spin;-webkit-animation-duration:1000ms;animation-duration:1000ms;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}@-webkit-keyframes spin{from{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{from{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-floating-top{border-bottom:solid 1px;border-bottom-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-floating-bottom{border-top:solid 1px;border-top-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell{border-right:solid transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell{border-left:solid transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell{border-right-width:1px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell{border-left-width:1px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell){border-left:solid 1px;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell){border-right:solid 1px;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row-selected{background-color:#3ab4eb;color:#212121}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing){background-color:rgba(33, 150, 243, 0.2)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart{background-color:rgba(0, 88, 255, 0.1) !important}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category{background-color:rgba(0, 255, 132, 0.1) !important}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-range-selected-1:not(.ag-cell-focus),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:rgba(33, 150, 243, 0.2)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-range-selected-2:not(.ag-cell-focus),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2{background-color:rgba(33, 150, 243, 0.36)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-range-selected-3:not(.ag-cell-focus),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3{background-color:rgba(33, 150, 243, 0.488)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-range-selected-4:not(.ag-cell-focus),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4{background-color:rgba(33, 150, 243, 0.5904)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top{border-top-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right{border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom{border-bottom-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left{border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell-range-single-cell,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell-range-single-cell,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle{border:1px solid;border-color:#404040;outline:initial}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-selection-fill-top,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-right,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-right,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-selection-fill-bottom,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-left,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-left,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-fill-handle,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-range-handle{position:absolute;width:6px;height:6px;bottom:-1px;background-color:#2196f3}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-fill-handle,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-range-handle{right:-1px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-fill-handle,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-range-handle{left:-1px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-fill-handle{cursor:cell}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-range-handle{cursor:nwse-resize}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-cell-inline-editing{border-color:rgba(33, 150, 243, 0.4) !important}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu{border:solid 1px;border-color:#404040;border-radius:12px;background-color:#737373;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);padding:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-list{cursor:default;padding:6px 0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-separator{height:13px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-separator-part:after{content:\"\";display:block;border-top:solid 1px;border-top-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-option-active,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-compact-menu-option-active{background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-option-part,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-compact-menu-option-part{line-height:16px;padding:8px 0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-option-disabled,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-compact-menu-option-disabled{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-option-icon,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-compact-menu-option-icon{width:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-menu-option-icon,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-compact-menu-option-icon{padding-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-menu-option-icon,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-compact-menu-option-icon{padding-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-option-text,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-compact-menu-option-text{padding-left:12px;padding-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-menu-option-shortcut,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-compact-menu-option-shortcut{padding-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-menu-option-shortcut,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-compact-menu-option-shortcut{padding-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-option-popup-pointer,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-compact-menu-option-popup-pointer{padding-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tabs-header{min-width:220px;width:100%;display:flex}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tab{border-bottom:2px solid transparent;display:flex;flex:none;align-items:center;justify-content:center;cursor:pointer;flex:1 1 auto;transition:border-bottom 0.3s}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-tab:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-tab:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tab-selected{border-bottom-color:#ebebeb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-header{color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-separator{border-top:solid 1px;border-top-color:#ebebeb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-condition-operator{height:17px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-condition-operator-or{margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-condition-operator-or{margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-set-filter-select-all{padding-top:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-set-filter-list,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-no-matches{height:144px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-set-filter-filter{margin-top:12px;margin-left:12px;margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-to{margin-top:9px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-mini-filter{margin:12px 12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-set-filter-item{margin:0 12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-set-filter-item-value{margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-set-filter-item-value{margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-apply-panel{padding:12px 12px;border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-apply-panel-button{line-height:1.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-apply-panel-button{margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-apply-panel-button{margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-simple-filter-body-wrapper{padding:12px 12px;padding-bottom:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-simple-filter-body-wrapper>*{margin-bottom:9px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-no-matches{padding:12px 12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-multi-filter-menu-item{margin:6px 0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-multi-filter-group-title-bar{padding:12px 6px;background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-side-bar{position:relative}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tool-panel-wrapper{background-color:#f8f8f8}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-side-buttons{padding-top:24px;width:20px;position:relative;color:#181d1f;overflow:hidden}.pros-grid-layout[pos--theme=dark] .pros-grid-container button.ag-side-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;background:transparent;padding:12px 0 12px 0;width:100%;margin:0;min-height:108px;background-position-y:center;background-position-x:center;background-repeat:no-repeat;border:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container button.ag-side-button-button:focus{box-shadow:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-side-button-button:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-side-button-button:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-side-button-icon-wrapper{margin-bottom:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-left,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-right{border-right:solid 1px;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper{border-left:solid 1px;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-left .ag-side-button-button,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-right .ag-side-button-button{border-right:2px solid transparent;transition:border-right 0.3s}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button{border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-left,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-right{border-left:solid 1px;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper{border-right:solid 1px;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-left .ag-side-button-button,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-right .ag-side-button-button{border-left:2px solid transparent;transition:border-left 0.3s}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button{border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-header{height:36px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-header,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-search{padding-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-header,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-search{padding-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-filter-toolpanel-header:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-filter-toolpanel-header:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\f112\";position:absolute}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{padding-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group.ag-has-filter>.ag-group-title-bar .ag-group-title:after{padding-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-0-header{height:48px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-item{margin-top:3px;margin-bottom:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-search{height:48px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-search-input{flex-grow:1;height:24px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-search-input{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-search-input{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-0{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-expand,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-title-bar-icon{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-expand,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-title-bar-icon{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-left:22px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-right:22px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-left:38px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-right:38px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-left:54px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-right:54px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-left:70px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-right:70px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-left:86px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-right:86px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-left:102px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-right:102px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-left:118px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-right:118px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-left:134px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-right:134px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-left:150px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-right:150px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-left:166px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-right:166px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header{padding-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-instance-filter{border-top:solid 1px;border-top-color:#404040;border-bottom:solid 1px;border-bottom-color:#404040;margin-top:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-filter-toolpanel-instance-header-icon{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-filter-toolpanel-instance-header-icon{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-pivot-mode-panel{height:48px;display:flex}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-pivot-mode-select{display:flex;align-items:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-pivot-mode-select{margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-pivot-mode-select{margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-column-select-header:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-column-select-header:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-header{height:48px;align-items:center;padding:0 12px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-panel-column-select{border-bottom:solid 1px;border-bottom-color:#dde2eb;border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-group-icons,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-header-icon{color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header{background-color:transparent;border-bottom:solid 1px;border-bottom-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header:hover{color:#ffffff}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-row{height:48px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-pinned-right-header{border-left:solid 1px;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-pinned-left-header{border-right:solid 1px;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-cell,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-group-cell{padding-left:16px;padding-right:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-cell.ag-header-cell-moving,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-group-cell.ag-header-cell-moving{background-color:#fff}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-header-cell:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-header-cell:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-header-group-cell:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-header-group-cell:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-icon{color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-expand-icon{cursor:pointer}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-header-expand-icon{padding-left:4px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-header-expand-icon{padding-right:4px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-row:not(:first-child) .ag-header-cell,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group{border-top:solid 1px;border-top-color:#737373}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-cell-resize{display:flex;align-items:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-cell-resize::after{content:\"\";position:absolute;z-index:1;display:block;left:calc(50% - 1px);width:2px;height:30%;top:35%;background-color:rgba(186, 191, 199, 0.5)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-pinned-right-header .ag-header-cell-resize::after{left:calc(50% - 2px)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-header-select-all{margin-right:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-header-select-all{margin-left:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-floating-filter-button{margin-left:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-floating-filter-button{margin-right:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-floating-filter-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:none;height:16px;padding:0;width:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-loading{background-color:#f8f8f8;height:100%;padding:12px 12px;position:absolute;width:100%;z-index:1}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-panel{border-top:1px solid;border-top-color:#404040;color:#181d1f;height:48px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-panel>*{margin:0 18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-button{cursor:pointer}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-button.ag-disabled{cursor:default;color:rgba(24, 29, 31, 0.5)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-paging-button:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-keyboard-focus .ag-paging-button:focus:after{content:\"\";position:absolute;background-color:transparent;pointer-events:none;top:0px;left:0px;display:block;width:calc(100% - 0px);height:calc(100% - 0px);border:1px solid;border-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-button,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-description{margin:0 6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-status-bar{border-top:solid 1px;border-top-color:#404040;color:rgba(24, 29, 31, 0.5);padding-right:24px;padding-left:24px;line-height:1.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-status-name-value-value{color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-status-bar-center{text-align:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-status-name-value{margin-left:6px;margin-right:6px;padding-top:12px;padding-bottom:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-cell{background:rgba(24, 29, 31, 0.07);background:var(--ag-chip-background-color, rgba(24, 29, 31, 0.07));border-radius:24px;height:24px;padding:0 3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-cell-text{margin:0 6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-cell-button{min-width:24px;margin:0 3px;color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-cell-drag-handle{margin-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-cell-ghost{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-horizontal{background-color:#f8f8f8;color:#181d1f;height:42px;border-bottom:solid 1px;border-bottom-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-drop-horizontal{padding-left:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-drop-horizontal{padding-right:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child){border-right:solid 1px;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child){border-left:solid 1px;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-horizontal-cell-separator{margin:0 6px;color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-horizontal-empty-message{color:rgba(24, 29, 31, 0.5)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-column-drop-horizontal-icon{margin-right:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-column-drop-horizontal-icon{margin-left:18px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical-list{padding-bottom:6px;padding-right:6px;padding-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical-cell{margin-top:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical{min-height:50px;max-height:150px;border-bottom:solid 1px;border-bottom-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical.ag-last-column-drop{border-bottom:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical-icon{margin-left:6px;margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical-empty-message{position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden;color:rgba(24, 29, 31, 0.5);margin-top:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select-agg-func-popup{border:solid 1px;border-color:#404040;background:#fff;background:var(--ag-background-color, #fff);border-radius:3px;box-shadow:0 1px 4px 1px rgba(186, 191, 199, 0.4);background:#fff;background:var(--ag-background-color, #fff);height:105px;padding:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select-agg-func-virtual-list-item{cursor:default;line-height:30px;padding-left:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-select-agg-func-virtual-list-item:hover{background-color:rgba(33, 150, 243, 0.3)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-menu{border-radius:3px;background:#fff;background:var(--ag-background-color, #fff)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-menu-icon{opacity:0.5;line-height:24px;font-size:24px;width:24px;height:24px;margin:2px 0;cursor:pointer;border-radius:3px;color:#181d1f}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-menu-icon:hover{opacity:1}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-mini-thumbnail{border:1px solid;border-color:#dde2eb;border-radius:5px;margin:5px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-mini-thumbnail:nth-last-child(3),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-mini-thumbnail:nth-last-child(3)~.ag-chart-mini-thumbnail{margin-left:auto;margin-right:auto}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-chart-mini-thumbnail:first-child{margin-left:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-chart-mini-thumbnail:first-child{margin-right:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-chart-mini-thumbnail:last-child{margin-right:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-chart-mini-thumbnail:last-child{margin-left:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-mini-thumbnail.ag-selected{border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-settings-card-item{background:#181d1f;background:var(--ag-foreground-color, #181d1f);width:8px;height:8px;border-radius:4px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-settings-card-item.ag-selected{background-color:#2196f3}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-data-column-drag-handle{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-settings-group-title-bar,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-data-group-title-bar,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-top-level-group-title-bar{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-settings-group-container{padding:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-data-group-container{padding:12px 12px;padding-bottom:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-data-group-container>*{margin-bottom:9px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-top-level-group-container{margin-left:12px;padding:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-top-level-group-item{margin:6px 0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-sub-level-group-container{padding:12px 12px;padding-bottom:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-sub-level-group-container>*{margin-bottom:9px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-group-container.ag-group-container-horizontal{padding:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-data-section,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-format-section{display:flex;margin:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-menu-panel{background-color:#f8f8f8}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-chart-menu-panel{border-left:solid 1px;border-left-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-chart-menu-panel{border-right:solid 1px;border-right-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-date-time-list-page-title{flex-grow:1;text-align:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-date-time-list-page-column-label{text-align:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-date-time-list-page-entry{text-align:center}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px;background-color:#fff;border-radius:3px;display:inline-block;vertical-align:middle;flex:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper input,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper:focus-within,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper:active{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper::after{content:\"\\f108\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper.ag-checked::after{content:\"\\f106\";color:#2196f3;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-checkbox-input-wrapper.ag-indeterminate::after{content:\"\\f107\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-toggle-button-input-wrapper{box-sizing:border-box;width:28px;height:18px;background-color:#999;border-radius:9px;position:relative;flex:none;border:1px solid;border-color:#999}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-toggle-button-input-wrapper input{opacity:0;height:100%;width:100%}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-toggle-button-input-wrapper:focus-within{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-toggle-button-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-toggle-button-input-wrapper.ag-checked{background-color:#2196f3;border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-toggle-button-input-wrapper::before{content:\" \";position:absolute;top:-1px;left:-1px;display:block;box-sizing:border-box;height:18px;width:18px;background-color:#fff;border-radius:9px;transition:left 100ms;border:1px solid;border-color:#999}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-toggle-button-input-wrapper.ag-checked::before{left:calc(100% - 18px);border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper{font-size:16px;line-height:16px;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px;background-color:#fff;display:inline-block;vertical-align:middle;flex:none;border-radius:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper input,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper:focus-within,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper:active{outline:none;box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper.ag-disabled{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper::after{content:\"\\f124\";color:#999;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-radio-button-input-wrapper.ag-checked::after{content:\"\\f125\";color:#2196f3;position:absolute;top:0;left:0;pointer-events:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]{-webkit-appearance:none;width:100%;height:100%;background:none;overflow:visible}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]::-webkit-slider-runnable-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]::-moz-range-track{margin:0;padding:0;width:100%;height:3px;background-color:#babfc7;border-radius:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]::-ms-track{margin:0;padding:0;height:3px;background-color:#babfc7;border-radius:3px;color:transparent;width:calc(100% - 2px)}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]::-webkit-slider-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px;-webkit-transform:translateY(-6.5px);transform:translateY(-6.5px)}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]::-ms-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]::-moz-ag-range-thumb{margin:0;padding:0;-webkit-appearance:none;width:16px;height:16px;background-color:#fff;border:1px solid;border-color:#999;border-radius:16px}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:focus{outline:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:focus::-webkit-slider-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:focus::-ms-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:focus::-moz-ag-range-thumb{box-shadow:0 0 2px 0.1rem rgba(33, 150, 243, 0.4);border-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:active::-webkit-slider-runnable-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:active::-moz-ag-range-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:active::-ms-track{background-color:rgba(33, 150, 243, 0.4)}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=range]:disabled{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-header,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-search,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-status-bar,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-row,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-panel-title-bar-title,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-multi-filter-group-title-bar{font-weight:700;color:#adadad}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-pinned-right-header .ag-header-row:after,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-pinned-left-header .ag-header-row:before{content:\"\";position:absolute;height:calc(100% - 20px);top:10px;width:1px;background-color:#babfc7;display:none}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-pinned-right-header .ag-header-row:after{right:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-pinned-left-header .ag-header-row:before{left:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-row{font-size:14px}.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=text],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=number],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=date],.pros-grid-layout[pos--theme=dark] .pros-grid-container input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=dark] .pros-grid-container textarea[class^=ag-]{min-height:24px;border-radius:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr input[class^=ag-][type=text],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr input[class^=ag-][type=number],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr input[class^=ag-][type=date],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr textarea[class^=ag-]{padding-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl input[class^=ag-]:not([type]),.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl input[class^=ag-][type=text],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl input[class^=ag-][type=number],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl input[class^=ag-][type=tel],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl input[class^=ag-][type=date],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl input[class^=ag-][type=datetime-local],.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl textarea[class^=ag-]{padding-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tab{padding:9px;transition:color 0.4s}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tab-selected{color:#2196f3}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu{background-color:#212121}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-menu-header{background-color:#f8f8f8;padding-top:1px;min-width:240px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tabs-header{border-bottom:solid 1px;border-bottom-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-settings-group-title-bar,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-data-group-title-bar,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-top-level-group-title-bar{padding:6px 12px;line-height:20px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-mini-thumbnail{background-color:#fff}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-settings-nav-bar{border-top:solid 1px;border-top-color:#dde2eb}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-group-title-bar-icon{margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-group-title-bar-icon{margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-top-level-group-toolbar{margin-top:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-charts-format-top-level-group-toolbar{padding-left:20px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-charts-format-top-level-group-toolbar{padding-right:20px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-sub-level-group{border-left:dashed 1px;border-left-color:#404040;padding-left:6px;margin-bottom:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-sub-level-group-title-bar{padding-top:0;padding-bottom:0;background:none;font-weight:700}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-sub-level-group-container{padding-bottom:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-charts-format-sub-level-group-item:last-child{margin-bottom:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-dnd-ghost{font-size:12px;font-weight:700}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-side-buttons{width:30px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-standard-button{-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:3px;border:1px solid;border-color:#404040;color:#2196f3;background-color:#fff;font-weight:600;padding:6px 12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-standard-button:hover{border-color:#404040;background-color:rgba(33, 150, 243, 0.1)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-standard-button:active{border-color:#404040;background-color:#2196f3;color:#fff}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-standard-button:disabled{color:rgba(24, 29, 31, 0.5);background-color:#f1f2f4;border-color:rgba(186, 191, 199, 0.3)}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical{min-height:75px;max-height:175px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tool-panel-wrapper{width:250px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical-title-bar{padding:12px;padding-bottom:0}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-vertical-empty-message{display:flex;align-items:center;border:dashed 1px;border-color:#404040;margin:12px;padding:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-empty-message{color:#181d1f;opacity:0.75}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-status-bar{font-weight:normal}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-status-name-value-value{font-weight:700}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-number,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-paging-row-summary-panel-number{font-weight:700}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-cell-button{opacity:0.5}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-drop-cell-button:hover{opacity:0.75}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-cell-menu-button:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-side-button-button:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-tab:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-panel-title-bar-button:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-header-expand-icon:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-group-icons:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-expanded .ag-icon:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-contracted .ag-icon:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-settings-prev:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-settings-next:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-group-title-bar-icon:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-column-select-header-icon:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-floating-filter-button-button:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-expand:hover,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-menu-icon:hover{color:#2196f3}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-chart-settings-card-item.ag-not-selected:hover{opacity:0.35}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-ltr .ag-panel-title-bar-button{margin-left:12px;margin-right:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-rtl .ag-panel-title-bar-button{margin-right:12px;margin-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-group-container{padding-left:6px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-filter-toolpanel-instance-filter{border:none;background-color:#f8f8f8;border-left:dashed 1px;border-left-color:#404040;margin-left:8px;padding-left:8px;margin-right:12px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-set-filter-list{padding-top:3px;padding-bottom:3px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-auto-height .ag-center-cols-clipper,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-auto-height .ag-center-cols-container,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-print .ag-center-cols-clipper,.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-layout-print .ag-center-cols-container{min-height:150px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:60px}.pros-grid-layout[pos--theme=dark] .pros-grid-container .ag-date-time-list-page-entry-is-current{background-color:#2196f3}.pros-grid-layout[pos--theme=dark] .pros-grid-container .pros-action-header{border-right:1px solid #404040}.pros-grid-layout[pos--theme=dark] .pros-grid-header-container .header-icon.filter:hover{background-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-option-container{background-color:#2b2b2b;color:#ffffff;border-color:transparent}.pros-grid-layout[pos--theme=dark] .pros-option-container .pros-menu-option:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-grid-layout[pos--theme=dark] .pros-filter-bar{color:#ebebeb}";
	      append$1(document_1.head, style);
	    }

	    // (2:2) {#if _allowFilterBar}
	    function create_if_block(ctx) {
	      let filterbar;
	      let updating_counts;
	      let updating_filters;
	      let updating_columnDefs;
	      let updating_theme;
	      let updating_gridId;
	      let current;
	      function filterbar_counts_binding(value) {
	        /*filterbar_counts_binding*/ctx[37](value);
	      }
	      function filterbar_filters_binding(value) {
	        /*filterbar_filters_binding*/ctx[38](value);
	      }
	      function filterbar_columnDefs_binding(value) {
	        /*filterbar_columnDefs_binding*/ctx[39](value);
	      }
	      function filterbar_theme_binding(value) {
	        /*filterbar_theme_binding*/ctx[40](value);
	      }
	      function filterbar_gridId_binding(value) {
	        /*filterbar_gridId_binding*/ctx[41](value);
	      }
	      let filterbar_props = {};
	      if (/*counts*/ctx[9] !== void 0) {
	        filterbar_props.counts = /*counts*/ctx[9];
	      }
	      if (/*filters*/ctx[0] !== void 0) {
	        filterbar_props.filters = /*filters*/ctx[0];
	      }
	      if (/*_columnDefs*/ctx[1] !== void 0) {
	        filterbar_props.columnDefs = /*_columnDefs*/ctx[1];
	      }
	      if (/*_theme*/ctx[3] !== void 0) {
	        filterbar_props.theme = /*_theme*/ctx[3];
	      }
	      if (/*_gridId*/ctx[6] !== void 0) {
	        filterbar_props.gridId = /*_gridId*/ctx[6];
	      }
	      filterbar = new FilterBar({
	        props: filterbar_props
	      });
	      binding_callbacks$1.push(() => bind$1(filterbar, "counts", filterbar_counts_binding));
	      binding_callbacks$1.push(() => bind$1(filterbar, "filters", filterbar_filters_binding));
	      binding_callbacks$1.push(() => bind$1(filterbar, "columnDefs", filterbar_columnDefs_binding));
	      binding_callbacks$1.push(() => bind$1(filterbar, "theme", filterbar_theme_binding));
	      binding_callbacks$1.push(() => bind$1(filterbar, "gridId", filterbar_gridId_binding));
	      filterbar.$on("deleteFilter", /*deleteFilter_handler*/ctx[42]);
	      filterbar.$on("filterChanged", /*filterChanged_handler*/ctx[43]);
	      return {
	        c() {
	          create_component$1(filterbar.$$.fragment);
	        },
	        m(target, anchor) {
	          mount_component$1(filterbar, target, anchor);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const filterbar_changes = {};
	          if (!updating_counts && dirty[0] & /*counts*/512) {
	            updating_counts = true;
	            filterbar_changes.counts = /*counts*/ctx[9];
	            add_flush_callback$1(() => updating_counts = false);
	          }
	          if (!updating_filters && dirty[0] & /*filters*/1) {
	            updating_filters = true;
	            filterbar_changes.filters = /*filters*/ctx[0];
	            add_flush_callback$1(() => updating_filters = false);
	          }
	          if (!updating_columnDefs && dirty[0] & /*_columnDefs*/2) {
	            updating_columnDefs = true;
	            filterbar_changes.columnDefs = /*_columnDefs*/ctx[1];
	            add_flush_callback$1(() => updating_columnDefs = false);
	          }
	          if (!updating_theme && dirty[0] & /*_theme*/8) {
	            updating_theme = true;
	            filterbar_changes.theme = /*_theme*/ctx[3];
	            add_flush_callback$1(() => updating_theme = false);
	          }
	          if (!updating_gridId && dirty[0] & /*_gridId*/64) {
	            updating_gridId = true;
	            filterbar_changes.gridId = /*_gridId*/ctx[6];
	            add_flush_callback$1(() => updating_gridId = false);
	          }
	          filterbar.$set(filterbar_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(filterbar.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(filterbar.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          destroy_component$1(filterbar, detaching);
	        }
	      };
	    }
	    function create_fragment(ctx) {
	      let div1;
	      let t;
	      let div0;
	      let current;
	      let if_block = /*_allowFilterBar*/ctx[7] && create_if_block(ctx);
	      return {
	        c() {
	          div1 = element$1("div");
	          if (if_block) if_block.c();
	          t = space$1();
	          div0 = element$1("div");
	          attr$1(div0, "class", "pros-grid-container");
	          attr$1(div1, "class", "pros-grid-layout");
	          attr$1(div1, "pos--theme", /*_theme*/ctx[3]);
	          attr$1(div1, "pos--shape", /*_shape*/ctx[4]);
	          attr$1(div1, "pos--density", /*_density*/ctx[5]);
	        },
	        m(target, anchor) {
	          insert$1(target, div1, anchor);
	          if (if_block) if_block.m(div1, null);
	          append$1(div1, t);
	          append$1(div1, div0);
	          /*div0_binding*/
	          ctx[44](div0);
	          /*div1_binding*/
	          ctx[45](div1);
	          current = true;
	        },
	        p(ctx, dirty) {
	          if (/*_allowFilterBar*/ctx[7]) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	              if (dirty[0] & /*_allowFilterBar*/128) {
	                transition_in$1(if_block, 1);
	              }
	            } else {
	              if_block = create_if_block(ctx);
	              if_block.c();
	              transition_in$1(if_block, 1);
	              if_block.m(div1, t);
	            }
	          } else if (if_block) {
	            group_outros$1();
	            transition_out$1(if_block, 1, 1, () => {
	              if_block = null;
	            });
	            check_outros$1();
	          }
	          if (!current || dirty[0] & /*_theme*/8) {
	            attr$1(div1, "pos--theme", /*_theme*/ctx[3]);
	          }
	          if (!current || dirty[0] & /*_shape*/16) {
	            attr$1(div1, "pos--shape", /*_shape*/ctx[4]);
	          }
	          if (!current || dirty[0] & /*_density*/32) {
	            attr$1(div1, "pos--density", /*_density*/ctx[5]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in$1(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out$1(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach$1(div1);
	          if (if_block) if_block.d();
	          /*div0_binding*/
	          ctx[44](null);
	          /*div1_binding*/
	          ctx[45](null);
	        }
	      };
	    }
	    const DUMMY_COLUMN_ID = "printOSDummy";
	    const ACTION_COLUMN_ID = "printOSAction";
	    const DEFAULT_HEADER_HEIGHT = 48;
	    const DEFAULT_ROW_HEIGHT = 52;
	    const DEFAULT_COL_WIDTH = 200;
	    function missingTranslate(key) {
	      console.warn("WC-Grid: Missing callbacks.grid.translate.  Returning key");
	      return key;
	    }
	    function handleSelectionChanged(event) {
	      window.dispatchEvent(new Event("posh-grid-selection-changed", {}));
	    }
	    function hasValue(test) {
	      return test !== undefined && test !== null;
	    }
	    function instance($$self, $$props, $$invalidate) {
	      let $_;
	      component_subscribe$1($$self, X$1, $$value => $$invalidate(46, $_ = $$value));
	      const dispatch = createEventDispatcher$1();
	      const columnsToIgnore = [DUMMY_COLUMN_ID, ACTION_COLUMN_ID];
	      let {
	        options = {}
	      } = $$props;
	      let {
	        agGridOptions = {}
	      } = $$props;
	      let {
	        callbacks = {}
	      } = $$props;
	      let {
	        filters = null
	      } = $$props;
	      let {
	        _columnDefs = []
	      } = $$props;
	      let {
	        _gridPreferences = null
	      } = $$props;
	      let {
	        gridContainer = undefined
	      } = $$props;
	      let {
	        _savePreferencesDebounce = debounce(savePreferences, 500, {
	          maxWait: 5000,
	          trailing: true
	        })
	      } = $$props;
	      let {
	        _quickFilterSendEventDebounce = debounce(quickFilterSendEvent, 500, {
	          maxWait: 5000,
	          trailing: true
	        })
	      } = $$props;
	      let {
	        _identityColumnId
	      } = $$props;
	      let {
	        _identityColumn
	      } = $$props;
	      let {
	        _identityPath
	      } = $$props;
	      let {
	        _autoSizeColumns = []
	      } = $$props;
	      let {
	        _defaultAutoSizeColumns = []
	      } = $$props;
	      let {
	        theme
	      } = $$props; // Color Theme (auto/dark/light)
	      let {
	        shape
	      } = $$props; // Shape Mode (round/sharp)
	      let {
	        density
	      } = $$props; // Density Mode (standard/high)
	      let {
	        _theme
	      } = $$props;
	      let {
	        _shape
	      } = $$props;
	      let {
	        _density
	      } = $$props;
	      let {
	        _lastTheme
	      } = $$props;
	      let {
	        _lastShape
	      } = $$props;
	      let {
	        _lastDensity
	      } = $$props;
	      let {
	        _lastSelectedRows
	      } = $$props;
	      let {
	        _gridId
	      } = $$props;
	      let {
	        _lastFilter
	      } = $$props;
	      let {
	        _allowFilterBar
	      } = $$props;
	      let {
	        _translate
	      } = $$props;
	      let {
	        _isInitialLoad = true
	      } = $$props;
	      let {
	        _gridLayoutElement
	      } = $$props;
	      let {
	        _defaultFilters
	      } = $$props;
	      let {
	        suppressColumnVirtualisation = false
	      } = $$props;
	      let {
	        counts = {
	          items: 0,
	          totalItems: 0,
	          totalFilterItems: 0,
	          limit: 0
	        }
	      } = $$props;
	      let {
	        _printos
	      } = $$props;

	      // onCreate
	      onMount$1(() => {
	        $$invalidate(28, _translate = get$1(callbacks, "grid.translate"));
	        if (!_translate) {
	          $$invalidate(28, _translate = missingTranslate);
	        }
	        $$invalidate(13, agGridOptions = {
	          // Only use mouse events on mobile devices and prevent the filter popup.
	          // See https://github.com/ag-grid/ag-grid/issues/1205
	          suppressTouch: true,
	          suppressCellSelection: true,
	          suppressColumnVirtualisation,
	          onGridReady: handleGridReady,
	          onFirstDataRendered: handleFirstDataRendered,
	          onColumnMoved: handleColumnMoved,
	          onColumnResized: handleColumnResized,
	          onColumnPinned: handleColumnPinned,
	          onColumnVisible: handleColumnVisible,
	          onSortChanged: handleAfterSortChanged,
	          onFilterChanged: handleAfterFilterChanged,
	          onCellClicked: handleCellClicked,
	          suppressRowDeselection: false,
	          cacheQuickFilter: true,
	          alwaysShowHorizontalScroll: false,
	          enableCellTextSelection: true,
	          components: {
	            imageCellRenderer: ImageCellRenderer,
	            actionCellRenderer: ActionCellRenderer
	          }
	        });
	        if (!callbacks) {
	          $$invalidate(14, callbacks = {});
	        }
	        setupGridAPI();
	        $$invalidate(6, _gridId = get$1(options, "grid.id"));
	        $$invalidate(27, _lastFilter = get$1(options, "grid.lastFilter", false));
	        if (window.document.body.getAttribute("printos-app") !== null) {
	          // are we in a PrintOS environment
	          $$invalidate(31, _printos = window.$printos);
	          $$invalidate(15, _gridPreferences = _printos.preferences.v1.getOrgPreference(_gridId, "grid-sdk"));
	        } else {
	          $$invalidate(15, _gridPreferences = JSON.parse(localStorage.getItem(`grid-sdk.local.${_gridId}`)));
	        }

	        // If grid preferences are stored in the old model (columnState)
	        // or do not contain columnPrefs we'll clear preferences
	        if (_gridPreferences && (_gridPreferences.columnState || !_gridPreferences.columnPrefs)) {
	          $$invalidate(15, _gridPreferences = null);
	          handleResetPreferences();
	        }
	        setupGridOptions();

	        // Parent must have position relative to ensure proper sizing with "absolute reset" sizing trick
	        $$invalidate(8, _gridLayoutElement.parentElement.style.position = "relative", _gridLayoutElement);
	        $$invalidate(8, _gridLayoutElement.parentElement.style.display = "block", _gridLayoutElement);
	        $$invalidate(8, _gridLayoutElement.parentElement.style.width = "100%", _gridLayoutElement);
	        $$invalidate(8, _gridLayoutElement.parentElement.style.height = "100%", _gridLayoutElement);
	        new agGridCommunity.Grid(gridContainer, agGridOptions);
	      });
	      beforeUpdate$1(() => {
	        $$invalidate(20, theme = hasValue(theme) ? theme : "light");
	        $$invalidate(21, shape = hasValue(shape) ? shape : "round");
	        $$invalidate(22, density = hasValue(density) ? density : "standard");
	        if (theme !== _lastTheme) {
	          $$invalidate(23, _lastTheme = theme);
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(3, _theme = themeAttribute ? themeAttribute : "light");
	            window.addEventListener("posh-theme-changed", handleThemeChanged);
	          } else {
	            $$invalidate(3, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          $$invalidate(24, _lastShape = shape);
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(4, _shape = themeAttribute ? themeAttribute : "round");
	            _shapeEventListener = window.addEventListener("posh-shape-changed", handleShapeChanged.bind(this));
	          } else {
	            $$invalidate(4, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          $$invalidate(25, _lastDensity = density);
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(5, _density = themeAttribute ? themeAttribute : "standard");
	            _densityEventListener = window.addEventListener("posh-density-changed", handleDensityChanged.bind(this));
	          } else {
	            $$invalidate(5, _density = density);
	          }
	        }
	      });
	      function handleThemeChanged(ev) {
	        if (theme === "auto") {
	          $$invalidate(3, _theme = ev.detail.theme);
	          let actionColDef = _columnDefs.find(cd => {
	            return cd.colId === ACTION_COLUMN_ID;
	          });
	          if (actionColDef) {
	            actionColDef.printos.theme = event.detail.theme;
	          }
	        }
	      }
	      function handleShapeChanged(ev) {
	        if (shape === "auto") {
	          $$invalidate(4, _shape = ev.detail.shape);
	        }
	      }
	      function handleDensityChanged(ev) {
	        if (density === "auto") {
	          $$invalidate(5, _density = ev.detail.density);
	        }
	      }

	      // onDestroy
	      onDestroy$1(() => {
	        if (get$1(agGridOptions, ".api.destroy")) {
	          agGridOptions.api.destroy();
	        }
	        window.removeEventListener("posh-theme-changed", handleThemeChanged);
	        window.removeEventListener("posh-shape-changed", handleShapeChanged);
	        window.removeEventListener("posh-density-changed", handleDensityChanged);
	      });
	      function handleDeleteFilter(columnId) {
	        let filterModel = agGridOptions.api.getFilterModel();
	        delete filterModel[columnId];
	        agGridOptions.api.setFilterModel(filterModel);
	      }
	      function handleFilterChanged(event) {
	        if (event.detail.type === "quick") {
	          handleQuickFilterChanged(event);
	        }
	      }
	      function setupGridAPI() {
	        $$invalidate(12, options.api = {
	          getData: apiGetData,
	          setData: apiSetData,
	          updateRow: apiUpdateRow,
	          updateRows: apiUpdateRows,
	          removeRow: apiRemoveRow,
	          removeRows: apiRemoveRows,
	          removeRowById: apiRemoveRowById,
	          removeRowsById: apiRemoveRowsById,
	          selectRow: apiSelectRow,
	          setFilters: apiSetFilters,
	          refresh: handleFirstDataRendered,
	          agGridOptions
	        }, options);
	        $$invalidate(16, _identityColumnId = get$1(options, "grid.idColumn"));
	        if (_identityColumnId) {
	          $$invalidate(17, _identityColumn = options.columns.find(c => {
	            return c.id === _identityColumnId;
	          }));
	          if (_identityColumn) {
	            $$invalidate(18, _identityPath = _identityColumn.path);
	            $$invalidate(13, agGridOptions.getRowNodeId = data => {
	              return get$1(data, _identityPath);
	            }, agGridOptions);
	          }
	        }
	      }
	      function setupGridOptions() {
	        $$invalidate(7, _allowFilterBar = get$1(options, "grid.allowFilterBar", true));

	        // Set empty list display
	        set(agGridOptions, "localeText.noRowsToShow", $_("noItems"));
	        let itemKey = get$1(options, "grid.itemKey");
	        let itemsKey = get$1(options, "grid.itemsKey");
	        $$invalidate(9, counts.itemLabel = itemKey ? _translate(itemKey) : $_("item"), counts);
	        $$invalidate(9, counts.itemsLabel = itemsKey ? _translate(itemsKey) : $_("items"), counts);

	        // Set grid heights
	        $$invalidate(13, agGridOptions.headerHeight = get$1(options, "grid.headerHeight", DEFAULT_HEADER_HEIGHT), agGridOptions);
	        $$invalidate(13, agGridOptions.rowHeight = get$1(options, "grid.rowHeight", DEFAULT_ROW_HEIGHT), agGridOptions);

	        // Set row select
	        let selectType = get$1(options, "grid.selectionMode", "single");
	        if (selectType !== "single" && selectType !== "multiple" && selectType !== "none") {
	          console.warn("WC-Grid: invalid selection type - defaulting to single selection");
	          selectType = "single";
	        }
	        if (selectType !== "none") {
	          set(agGridOptions, "rowSelection", selectType);
	          set(agGridOptions, "suppressRowDeselection", false);
	          set(agGridOptions, "onSelectionChanged", handleSelectionChanged);
	          set(agGridOptions, "onRowSelected", handleRowSelected);
	          set(agGridOptions, "onRowClicked", handleRowClicked);
	          set(agGridOptions, "onRowDoubleClicked", handleRowDoubleClicked);
	        }

	        // Drag to hide columsn (default allow = true)
	        let allowDragToHide = get$1(options, "grid.allowDragToHide", true);
	        if (!allowDragToHide) {
	          set(agGridOptions, "suppressDragLeaveHidesColumns", true);
	        }
	        $$invalidate(13, agGridOptions.accentedSort = true, agGridOptions);
	        let actions = get$1(callbacks, "actions", []);
	        actions.forEach(action => {
	          action.display = _translate(action.key);
	        });
	      }
	      function handleGridReady() {
	        initColumnDefs();
	        agGridOptions.api.setColumnDefs(_columnDefs);

	        // console.log('Grid Ready', _defaultFilters);
	        if (_defaultFilters) {
	          agGridOptions.api.setFilterModel(_defaultFilters);
	        }
	        if (_gridPreferences) {
	          if (_gridPreferences.columnPrefs) {
	            agGridOptions.columnApi.setColumnState(_gridPreferences.columnPrefs);
	          }
	          if (_lastFilter && _gridPreferences.filters) {
	            agGridOptions.api.setFilterModel(_gridPreferences.filters);
	          }
	        }
	        let gridReadyCallback = get$1(callbacks, "grid.gridReady");
	        if (gridReadyCallback) {
	          gridReadyCallback();
	        }
	        dispatch("ready");
	        initGridData();
	      }
	      function initGridData() {
	        if (!get$1(callbacks, "data.getData")) {
	          return;
	        }
	        let paged = get$1(callbacks, "data.paged", false);
	        if (paged) {
	          initPagedData();
	        } else {
	          initData();
	        }
	      }
	      function initData() {
	        let getDataCallback = get$1(callbacks, "data.getData");
	        if (!getDataCallback) {
	          return;
	        }
	        let dataPath = get$1(callbacks, "data.path");
	        getDataCallback().then(resp => {
	          let data = dataPath ? get$1(resp, dataPath, []) : resp;
	          if (!Array.isArray(data)) {
	            data = [];
	          }
	          setData(data);
	        });
	      }
	      function initPagedData() {
	        let getDataCallback = get$1(callbacks, "data.getData");
	        if (!getDataCallback) {
	          return;
	        }
	        let dataPath = get$1(callbacks, "data.path");
	        if (!dataPath) {
	          console.warn("WC-Grid: callbacks.data.path required to retrieve paged data");
	          return;
	        }
	        let totalPath = get$1(callbacks, "data.totalPath");
	        if (!totalPath) {
	          console.warn("WC-Grid: callbacks.data.totalPath required to retrieve paged data");
	          return;
	        }
	        let pageLimit = get$1(callbacks, "data.limit");
	        if (!pageLimit) {
	          console.warn("WC-Grid: callbacks.data.limit required to retrieve paged data");
	          return;
	        }
	        let data = [];
	        getDataCallback(1, pageLimit).then(resp => {
	          data = get$1(resp, dataPath);
	          let total = get$1(resp, totalPath);
	          if (data.length < total) {
	            let pages = Math.ceil(total / pageLimit);
	            let promises = [];
	            for (let p = 2; p <= pages; p++) {
	              promises.push(getDataCallback(p, pageLimit).then(resp => {
	                let pageData = get$1(resp, dataPath);
	                if (_identityPath) {
	                  pageData.forEach(row => {
	                    let test = get$1(row, _identityPath);
	                    let found = data.find(r => {
	                      let t = get$1(r, _identityPath);
	                      return test === t;
	                    });
	                    if (!found) {
	                      data.push(row);
	                    } else {
	                      console.warn("Grid: Skipping Duplicate Row,", row);
	                    }
	                  });
	                } else {
	                  data = data.concat(pageData);
	                }
	              }));
	            }
	            Promise.all(promises).then(() => {
	              setData(data);
	            });
	          } else {
	            setData(data);
	          }
	        });
	      }
	      function initColumnDefs() {
	        $$invalidate(1, _columnDefs = options.columns.filter(column => {
	          let columnCallbacks = get$1(callbacks, ["columns", column.id]);
	          if (!columnCallbacks || !columnCallbacks.include) {
	            return true;
	          }
	          return columnCallbacks.include(column.id, column);
	        }).map(column => {
	          let columnCallbacks = get$1(callbacks, ["columns", column.id]);
	          column.translateExternal = _translate;
	          column.translateInternal = $_;
	          column.callbacks = get$1(callbacks, `columns.${column.id}`);
	          let columnDef = {
	            ...columnCallbacks,
	            gridCallbacks: callbacks,
	            gridParams: {
	              theme
	            },
	            colId: column.id,
	            headerComponent: GridHeaderComponent,
	            headerName: resolveText(column.header, column.id),
	            resizable: true,
	            field: column.path,
	            printOSColumn: column,
	            printOSOptions: options,
	            valueGetter: handleValueGet,
	            cellRenderer: handleCellRender,
	            getQuickFilterText: handleQuickFilter
	          };
	          if (!columnDef.comparator) {
	            columnDef.comparator = handleColumnSort.bind(column);
	          }
	          switch (column.type) {
	            case "text":
	              columnDef.filter = TextGridFilterComponent;
	              break;
	            case "number":
	              columnDef.filter = NumberGridFilterComponent;
	              break;
	            case "boolean":
	              columnDef.filter = BooleanGridFilterComponent;
	              break;
	            case "enum":
	              let isValues = get$1(column, "enum.type") === "values";
	              if (isValues) {
	                columnDef.filter = EnumGridFilterComponent;
	              } else {
	                columnDef.filter = TextGridFilterComponent;
	              }
	              break;
	            case "date":
	              columnDef.filter = DateGridFilterComponent;
	              break;
	            case "image":
	            default:
	              // text
	              columnDef.filter = TextGridFilterComponent;
	              break;
	          }
	          configureColumnDef(columnDef);
	          return columnDef;
	        }));

	        // Configure default sort
	        let defaultSort = get$1(options, "grid.sort", []);
	        let sortIndex = 0;
	        defaultSort.forEach(s => {
	          let found = _columnDefs.find(cd => {
	            return cd.colId === s.colId;
	          });
	          if (found) {
	            found.sort = s.sort;
	            found.sortIndex = sortIndex++;
	          }
	        });
	        $$invalidate(30, _defaultFilters = get$1(options, "grid.filters", null));

	        // console.log('init Column Defs', _defaultFilters);
	        let allowActionColumns = get$1(options, "grid.allowActionColumns", true);
	        if (allowActionColumns) {
	          let actions = get$1(callbacks, "actions", []);
	          actions.forEach(action => {
	            let allowColumn = true;
	            let allowColumnCallback = get$1(action, "allow");
	            if (allowColumnCallback) {
	              allowColumn = allowColumnCallback();
	            }
	            let showColumnByDefault = get$1(action, "show", false);
	            if (allowColumn) {
	              _columnDefs.push({
	                colId: `action-${action.id}`,
	                cellRenderer: handleCellRender,
	                gridParams: {
	                  theme
	                },
	                headerName: "",
	                hide: !showColumnByDefault,
	                minWidth: 64,
	                maxWidth: 64,
	                width: 64,
	                pinned: "right",
	                lockPinned: true,
	                suppressSorting: true,
	                suppressMenu: true,
	                suppressFilter: true,
	                suppressResize: true,
	                suppressMovable: true,
	                suppressNavigable: true,
	                headerComponent: ActionGridHeaderComponent,
	                headerClass: "pros-align-center pros-action-header",
	                cellClass: "pros-align-center pros-action-cell",
	                printOSColumn: {
	                  id: `action-${action.id}`,
	                  type: "action",
	                  options: {
	                    justify: "center",
	                    allowSort: false,
	                    width: 64
	                  },
	                  icon: {
	                    type: "path",
	                    path: action.iconName,
	                    height: "24px"
	                  },
	                  callbacks: {
	                    tooltip: () => {
	                      return _translate(action.key);
	                    },
	                    link: {
	                      click: action.callback,
	                      // hack to re-use allowRow to prevent link click on non-allowed row
	                      // did not want to change parameter ordering on link functions
	                      isLink: (value, data, column) => {
	                        return action.allowRow ? action.allowRow(data) : true;
	                      }
	                    },
	                    allow: action.allowRow
	                  }
	                },
	                // cellClass: 'pros-action-cell',
	                printos: {
	                  configureColumns: handleConfigureColumns,
	                  export: handleExport,
	                  resetPreferences: handleResetPreferences,
	                  agGridOptions,
	                  options,
	                  callbacks,
	                  getTheme: () => {
	                    return _theme;
	                  }
	                }
	              });
	            }
	          });
	        }

	        // Add dummy column to extend rows to full width
	        _columnDefs.push({
	          colId: DUMMY_COLUMN_ID,
	          headerName: "",
	          headerClass: "pros-inactive-header",
	          suppressSorting: true,
	          suppressMenu: true,
	          suppressFilter: true,
	          suppressResize: true,
	          suppressMovable: true,
	          suppressNavigable: true,
	          minWidth: 5,
	          flex: 1,
	          cellClass: "no-focus"
	        });
	        let allowActionColumn = get$1(options, "grid.allowActionColumn", true);
	        if (allowActionColumn) {
	          _columnDefs.push({
	            colId: ACTION_COLUMN_ID,
	            headerComponent: ActionsGridHeaderComponent,
	            cellRenderer: "actionCellRenderer",
	            headerName: "",
	            headerClass: "pros-action-header",
	            minWidth: 48,
	            maxWidth: 48,
	            width: 48,
	            pinned: "right",
	            lockPinned: true,
	            suppressSorting: true,
	            suppressMenu: true,
	            suppressFilter: true,
	            suppressResize: true,
	            suppressMovable: true,
	            suppressNavigable: true,
	            cellClass: "pros-action-cell",
	            printos: {
	              configureColumns: handleConfigureColumns,
	              export: handleExport,
	              resetPreferences: handleResetPreferences,
	              agGridOptions,
	              options,
	              callbacks,
	              getTheme: () => {
	                return _theme;
	              }
	            }
	          });
	        }
	      }
	      function handleFirstDataRendered() {
	        // console.log('Applying Auto Columns', _autoSizeColumns);
	        agGridOptions.columnApi.autoSizeColumns(_autoSizeColumns);
	      }
	      function handleConfigureColumns() {
	        let columns = options.columns;
	        columns.forEach(column => {
	          column.display = resolveText(column.header, column.id);
	        });
	        if (_printos) {
	          _printos.ga.v1.eventTrack("grid-sdk", "Column Dialog Opened", _gridId);
	        }
	        let el = document.createElement("div");
	        new ColumnsDialog({
	          target: el,
	          props: {
	            options: {
	              columnState: agGridOptions.columnApi.getColumnState(),
	              columns,
	              callbacks,
	              internalTranslate: $_,
	              externalTranslate: _translate,
	              theme: _theme
	            }
	          }
	        });
	        dialog.show({
	          title: $_("Columns_Dialog_Title"),
	          content: el,
	          options: {
	            theme: _theme
	          }
	        }).then(columnState => {
	          agGridOptions.columnApi.setColumnState(columnState);
	          savePreferences();
	        }).catch(() => {}); // Ignore
	      }
	      function handleExport() {
	        let params = {
	          //processHeaderCallback: handleExportHeaderRender,
	          processCellCallback: handleExportCellRender
	        };
	        let displayedColumns = agGridOptions.columnApi.getAllDisplayedColumns();
	        let toggledColumns = [];
	        displayedColumns.forEach(dc => {
	          let isImageColumn = get$1(dc, "colDef.printOSColumn.type") === "image";
	          let isIconColumn = get$1(dc, "colDef.printOSColumn.type") === "icon";
	          if ((isImageColumn || isIconColumn) && dc.visible) {
	            toggledColumns.push(dc);
	            agGridOptions.columnApi.setColumnVisible(dc.colDef.colId, false);
	          }
	        });
	        agGridOptions.api.exportDataAsCsv(params);
	        if (toggledColumns.length > 0) {
	          toggledColumns.forEach(tc => {
	            agGridOptions.columnApi.setColumnVisible(tc.colDef.colId, true);
	          });
	        }
	        if (_printos) {
	          _printos.ga.v1.eventTrack("grid-sdk", "Export", _gridId);
	        }
	      }
	      function handleExportCellRender(params) {
	        let column = get$1(params, "column.colDef.printOSColumn");
	        if (!column) {
	          return "";
	        }
	        return columns.getString(column, params.node.data, params);
	      }
	      function handleResetPreferences() {
	        if (_printos) {
	          return _printos.preferences.v1deleteOrgPreferenceAsync(_gridId, "grid-sdk").then(resp => {
	            $$invalidate(15, _gridPreferences = _printos.preferences.v1.getOrgPreference(_gridId, "grid-sdk"));
	            resetColumns();
	          });
	        } else {
	          localStorage.removeItem(`grid-sdk.local.${_gridId}`);
	          resetColumns();
	        }
	      }
	      function resetColumns() {
	        $$invalidate(19, _autoSizeColumns = [..._defaultAutoSizeColumns]);
	        agGridOptions.columnApi.resetColumnState();

	        // console.log('Reset AutoSize Columns', _autoSizeColumns);
	        agGridOptions.columnApi.autoSizeColumns(_autoSizeColumns);
	      } // console.log('grid-sdk: Reset Columns', agGridOptions.columnApi.getColumnState());

	      function configureColumnDef(columnDef) {
	        let printOSColumn = columnDef.printOSColumn;
	        let columnState = null;
	        if (_gridPreferences) {
	          columnState = _gridPreferences.columnPrefs.find(cs => {
	            return cs.colId === columnDef.colId;
	          });
	        }

	        // Visible
	        columnDef.hide = !get$1(printOSColumn, "options.show", true);

	        // Width
	        let width = get$1(printOSColumn, "options.width", DEFAULT_COL_WIDTH);
	        if (width === "auto") {
	          _defaultAutoSizeColumns.push(columnDef.colId);
	          columnDef.width = DEFAULT_COL_WIDTH;
	        } else {
	          columnDef.width = width;
	        }

	        // If we are currently in an AUTO case we need to add to _autoSizeColumns
	        if (!columnState && width === "auto" || columnState && columnState.width === "auto") {
	          addAutoSizeColumn(columnDef.colId);
	        }

	        // Justify
	        let columnType = get$1(printOSColumn, "type", "text");
	        let defaultJustify = "left";
	        switch (columnType) {
	          case "number":
	            defaultJustify = "right";
	            break;
	          case "image":
	          case "icon":
	          case "boolean":
	            defaultJustify = "center";
	            break;
	          case "enum":
	            let showImage = get$1(printOSColumn, "enum.showImage", false);
	            let showText = get$1(printOSColumn, "enum.showText", !showImage);
	            if (showImage && !showText) {
	              defaultJustify = "center";
	            }
	            break;
	        }
	        let justify = get$1(printOSColumn, "options.justify", defaultJustify);
	        if (justify !== "left" && justify !== "center" && justify !== "right") {
	          console.warn("WC-Grid: invalid column justify, defaulting to left");
	          justify = "left";
	        }
	        switch (justify) {
	          case "right":
	            columnDef.headerClass = "pros-align-right";
	            columnDef.cellClass = "pros-align-right";
	            break;
	          case "center":
	            columnDef.headerClass = "pros-align-center";
	            columnDef.cellClass = "pros-align-center";
	            break;
	        }

	        // Filters
	        let allowGlobalFilters = get$1(options, "grid.allowFilters", true);
	        let allowColumnFilter = get$1(printOSColumn, "options.allowFilter", true);
	        if (!allowGlobalFilters || !allowColumnFilter) {
	          columnDef.floatingFilterComponentParams = {
	            suppressFilterButton: true
	          };
	        }

	        // Sort
	        columnDef.suppressSorting = !get$1(printOSColumn, "options.allowSort", true);
	      }
	      function addAutoSizeColumn(colId) {
	        if (_autoSizeColumns.includes(colId)) {
	          return;
	        }

	        // console.log(`Adding AutoSize Column: ${colId}`);
	        _autoSizeColumns.push(colId);
	      }
	      function removeAutoSizeColumn(colId) {
	        if (_autoSizeColumns.includes(colId)) {
	          _autoSizeColumns.splice(_autoSizeColumns.indexOf(colId), 1);
	        } // console.log(`Removing AutoSize Column: ${colId}`);
	      }
	      function resolveText(obj, value) {
	        if (obj && obj.lookupBase) {
	          let key = `${obj.lookupBase}${value}`;
	          return _translate(key);
	        }
	        if (obj && obj.key) {
	          return _translate(obj.key);
	        }
	        if (obj && obj.title) {
	          return obj.title;
	        }
	        console.error(`WC-Grid: unable to resolve text on object for column ${value}`, obj);
	        return value;
	      }
	      function savePreferences() {
	        // console.log('grid-sdk: Save Preferences', agGridOptions.columnApi.getColumnState());
	        if (!agGridOptions) {
	          return;
	        }
	        if (!agGridOptions.columnApi) {
	          return;
	        }
	        ensureColumnOrder();
	        let columnState = agGridOptions.columnApi.getColumnState();
	        _autoSizeColumns.forEach(colId => {
	          let found = columnState.find(c => {
	            return c.colId === colId;
	          });
	          if (found) {
	            found.width = "auto";
	          }
	        });

	        // console.log('Saving Auto Columns', _autoSizeColumns);
	        let gridPrefs = {
	          columnPrefs: columnState,
	          filters
	        };
	        if (_printos) {
	          return _printos.preferences.v1.setOrgPreferenceAsync(_gridId, gridPrefs, "grid-sdk").then(() => {
	            $$invalidate(15, _gridPreferences = _printos.preferences.v1.getOrgPreference(_gridId, "grid-sdk"));
	          });
	        } else {
	          localStorage.setItem(`grid-sdk.local.${_gridId}`, JSON.stringify(gridPrefs));
	        }
	      }
	      function ensureColumnOrder() {
	        let columnState = agGridOptions.columnApi.getColumnState();

	        // Because actions are pinned we should be able to move the dummy column to the end and then move the action column to the end
	        // To ensure that the dummy column is the last un-pinned column and that the action column is the last pinned column
	        agGridOptions.columnApi.moveColumn("printOSDummy", columnState.length - 1);
	        agGridOptions.columnApi.moveColumn("printOSAction", columnState.length - 1);
	        columnState.forEach(cs => {
	          if (cs.colId.startsWith("action-")) {
	            agGridOptions.columnApi.moveColumn(cs.colId, columnState.length - 3);
	          }
	        });
	      }
	      function handleValueGet(params) {
	        let column = get$1(params, "colDef.printOSColumn");
	        return columns.getValue(column, params.data, params);
	      }
	      function handleQuickFilter(params) {
	        let column = get$1(params, "colDef.printOSColumn");
	        let allowQuickFilter = get$1(column, "options.allowQuickFilter", true);
	        if (!allowQuickFilter) {
	          return null;
	        }
	        let quickFilterCallback = get$1(column, "callbacks.quickFilterText");
	        return quickFilterCallback ? quickFilterCallback(params.data, column, params) : columns.getString(column, params.data, params);
	      }
	      function handleColumnSort(valA, valB, dataA, dataB, isInverted) {
	        let column = this;
	        let customSorter = get$1(column, "callbacks.sort");
	        if (customSorter) {
	          return customSorter(valA, valB, dataA.data, dataB.data, isInverted, column);
	        }
	        return columns.sortColumn(valA, valB, dataA.data, dataB.data, isInverted, column);
	      }
	      function handleCellRender(params) {
	        let column = get$1(params, "colDef.printOSColumn");
	        return columns.renderCell(column, params.data, params);
	      }
	      function handleQuickFilterChanged(event) {
	        let rows = agGridOptions.api.getModel().rowsToDisplay.length;
	        $$invalidate(9, counts.filterItems = rows === counts.items ? undefined : rows, counts);
	        agGridOptions.api.setQuickFilter(event.detail.detail);
	        _quickFilterSendEventDebounce();
	      }
	      function quickFilterSendEvent() {
	        if (_printos) {
	          _printos.ga.v1.eventTrack("grid-sdk", "Quick Filter", _gridId);
	        }
	      }
	      function handleRowSelected(event) {
	        let selectedRows = agGridOptions.api.getSelectedRows();
	        if (_lastSelectedRows) {
	          _lastSelectedRows.forEach(row => {
	            let actionElement = get$1(row, "_internal.actionElement");
	            if (actionElement) {
	              actionElement.classList.remove("selected");
	            }
	          });
	          if (selectedRows.length === _lastSelectedRows.length) {
	            let isSame = true;
	            if (_identityPath) {
	              for (let i = 0; i < selectedRows.length; i++) {
	                if (get$1(selectedRows[i], _identityPath) !== get$1(_lastSelectedRows[i], _identityPath)) {
	                  isSame = false;
	                }
	              }
	            } else {
	              // If we don't have an identity column Id then we need to assume that this is a different selection
	              isSame = false;
	            }
	            if (isSame) {
	              return;
	            }
	          }
	        }
	        selectedRows.forEach(row => {
	          let actionElement = get$1(row, "_internal.actionElement");
	          if (actionElement) {
	            actionElement.classList.add("selected");
	          }
	        });
	        let selectionCallback = get$1(callbacks, "grid.select");
	        if (selectionCallback) {
	          // TODO: If we have an identity column defined we can also return added/removed rows
	          selectionCallback(selectedRows);
	        }
	        $$invalidate(26, _lastSelectedRows = selectedRows);
	      }
	      function handleRowClicked(event) {
	        let clickCallback = get$1(callbacks, "grid.click");
	        if (clickCallback) {
	          clickCallback(event.data);
	        }
	      }
	      function handleRowDoubleClicked(event) {
	        let doubleCallback = get$1(callbacks, "grid.doubleClick");
	        if (doubleCallback) {
	          doubleCallback(event.data);
	          if (_printos) {
	            _printos.ga.v1.eventTrack("grid-sdk", "Row Double Click", _gridId);
	          }
	        }
	      }
	      function handleColumnVisible(event) {
	        _savePreferencesDebounce();
	      }
	      function handleColumnPinned(event) {
	        _savePreferencesDebounce();
	        if (_printos) {
	          _printos.ga.v1.eventTrack("grid-sdk", "Column Pinned", _gridId);
	        }
	      }
	      function handleColumnMoved(event) {
	        if (event.source !== "api") {
	          _savePreferencesDebounce();
	          if (_printos) {
	            _printos.ga.v1.eventTrack("grid-sdk", "Column Moved", _gridId);
	          }
	        }
	      }
	      function handleColumnResized(event) {
	        if (event.columns.length === 1 && columnsToIgnore.includes(event.columns[0].colId)) {
	          return;
	        }
	        switch (event.source) {
	          case "autosizeColumns":
	            // User double clicked column edge
	            event.columns.forEach(column => {
	              addAutoSizeColumn(column.colId);
	            });
	            _savePreferencesDebounce();
	            if (_printos) {
	              _printos.ga.v1.eventTrack("grid-sdk", "Column Auto Sized", _gridId);
	            }
	            break;
	          case "uiColumnDragged":
	            // User manually resized column
	            event.columns.forEach(column => {
	              removeAutoSizeColumn(column.colId);
	            });
	            _savePreferencesDebounce();
	            if (_printos) {
	              _printos.ga.v1.eventTrack("grid-sdk", "Column Resized", _gridId);
	            }
	            break;
	        }
	      }
	      function handleAfterSortChanged(event) {
	        savePreferences();
	        if (_printos) {
	          _printos.ga.v1.eventTrack("grid-sdk", "Sort Changed", _gridId);
	        }
	      }
	      function handleAfterFilterChanged(event) {
	        if (!agGridOptions.api) {
	          return;
	        }
	        agGridOptions.api.hideOverlay();
	        let rows = agGridOptions.api.getModel().rowsToDisplay.length;
	        $$invalidate(9, counts.filterItems = rows === counts.items ? undefined : rows, counts);
	        $$invalidate(0, filters = agGridOptions.api.getFilterModel());
	        savePreferences();
	      }
	      function handleCellClicked(event) {
	        const link = get$1(event, "colDef.printOSColumn.callbacks.link");
	        if (!link || !link.click) {
	          return;
	        }
	        const isLink = get$1(event, "colDef.printOSColumn.callbacks.link.isLink");
	        let linkOk = isLink ? isLink(event.value, event.data) : true;
	        if (linkOk) {
	          link.click(event.data, event.value, event.colDef.printOSColumn);
	        }
	      }
	      function setData(rows) {
	        if (!agGridOptions.api) {
	          return;
	        }

	        // console.log('setData', rows)
	        setTimeout(() => {
	          let myRows = [];
	          rows.forEach(r => {
	            let row = Object.assign({}, r);
	            myRows.push(row);
	          });
	          agGridOptions.api.setRowData(myRows);
	          $$invalidate(9, counts.items = rows.length, counts);
	          let dataLoadedCallback = get$1(callbacks, "data.loaded");
	          if (_isInitialLoad && dataLoadedCallback) {
	            dataLoadedCallback();
	          }
	          handleAfterFilterChanged();
	          handleFirstDataRendered();
	          $$invalidate(29, _isInitialLoad = false);
	        }, 0);
	      }
	      function apiGetData() {
	        initGridData();
	      }
	      function apiSetData(data) {
	        if (!data) {
	          // For now, ignore this...
	          return;
	        }
	        if (Array.isArray(data)) {
	          setData(data);
	        } else {
	          let dataPath = get$1(callbacks, "data.path");
	          let rows = get$1(data, dataPath, []);
	          setData(rows);
	        }
	      }
	      function apiSetFilters(filters) {
	        agGridOptions.api.setFilterModel(filters);
	      }
	      function apiUpdateRow(row) {
	        apiUpdateRows([row]);
	      }
	      function apiUpdateRows(rows) {
	        if (!_identityPath) {
	          console.warn("apiUpdateRows: No identityPath");
	          return;
	        }
	        if (!get$1(agGridOptions, "api.getRowNode")) {
	          console.warn("apiUpdateRows: No getRowNode API");
	          return;
	        }
	        setTimeout(() => {
	          let addNodes = [];
	          rows.forEach(row => {
	            delete row.posGridCache;
	            let rowNode = agGridOptions.api.getRowNode(get$1(row, _identityPath));
	            if (rowNode) {
	              let myRow = Object.assign({}, row);
	              rowNode.setData(myRow);
	            } else {
	              addNodes.push(row);
	            }
	          });
	          if (addNodes.length > 0) {
	            agGridOptions.api.applyTransaction({
	              add: addNodes
	            });
	          }
	          agGridOptions.api.refreshCells({
	            force: true
	          });
	          agGridOptions.api.onSortChanged();
	          handleAfterFilterChanged();
	        }, 0);
	      }
	      function apiRemoveRow(row) {
	        apiRemoveRows([row]);
	      }
	      function apiRemoveRows(rows) {
	        if (!_identityPath) {
	          console.warn("WC-Grid: options.grid.idColumn required to remove data");
	          return;
	        }
	        let rowIds = [];
	        rows.forEach(row => {
	          if (get$1(row, _identityPath)) {
	            rowIds.push(get$1(row, _identityPath));
	          }
	        });
	        if (rowIds.length > 0) {
	          apiRemoveRowsById(rowIds);
	        }
	      }
	      function apiRemoveRowById(rowId) {
	        apiRemoveRowsById([rowId]);
	      }
	      function apiRemoveRowsById(rowIds) {
	        if (!_identityPath) {
	          console.warn("WC-Grid: options.grid.idColumn required to remove data");
	          return;
	        }
	        let rowNodes = agGridOptions.api.getModel().rowsToDisplay;
	        let removeNodes = [];
	        rowIds.forEach(rowId => {
	          let found = rowNodes.find(rn => {
	            return get$1(rn, _identityPath) === rowId;
	          });
	          if (found) {
	            removeNodes.push(found);
	          }
	        });
	        if (removeNodes.length > 0) {
	          agGridOptions.api.updateRowData({
	            remove: removeNodes
	          });
	          handleAfterFilterChanged();
	        }
	      }
	      function apiSelectRow(rowId) {
	        if (!_identityPath) {
	          console.warn("WC-Grid: options.grid.idColumn required to select row");
	          return;
	        }
	        window.setTimeout(() => {
	          let nodeToSelect;
	          agGridOptions.api.forEachNode(node => {
	            let id = get$1(node, `data.${_identityPath}`);
	            if (id === rowId) {
	              nodeToSelect = node;
	              return false;
	            }
	          });
	          if (nodeToSelect) {
	            nodeToSelect.setSelected(true, true);
	            agGridOptions.api.ensureIndexVisible(nodeToSelect.rowIndex);
	            $$invalidate(26, _lastSelectedRows = null);
	            handleRowSelected();
	          }
	        });
	      }
	      function filterbar_counts_binding(value) {
	        counts = value;
	        $$invalidate(9, counts);
	      }
	      function filterbar_filters_binding(value) {
	        filters = value;
	        $$invalidate(0, filters);
	      }
	      function filterbar_columnDefs_binding(value) {
	        _columnDefs = value;
	        $$invalidate(1, _columnDefs);
	      }
	      function filterbar_theme_binding(value) {
	        _theme = value;
	        $$invalidate(3, _theme);
	      }
	      function filterbar_gridId_binding(value) {
	        _gridId = value;
	        $$invalidate(6, _gridId);
	      }
	      const deleteFilter_handler = event => handleDeleteFilter(event.detail.columnId);
	      const filterChanged_handler = event => handleFilterChanged(event);
	      function div0_binding($$value) {
	        binding_callbacks$1[$$value ? "unshift" : "push"](() => {
	          gridContainer = $$value;
	          $$invalidate(2, gridContainer);
	        });
	      }
	      function div1_binding($$value) {
	        binding_callbacks$1[$$value ? "unshift" : "push"](() => {
	          _gridLayoutElement = $$value;
	          $$invalidate(8, _gridLayoutElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("options" in $$props) $$invalidate(12, options = $$props.options);
	        if ("agGridOptions" in $$props) $$invalidate(13, agGridOptions = $$props.agGridOptions);
	        if ("callbacks" in $$props) $$invalidate(14, callbacks = $$props.callbacks);
	        if ("filters" in $$props) $$invalidate(0, filters = $$props.filters);
	        if ("_columnDefs" in $$props) $$invalidate(1, _columnDefs = $$props._columnDefs);
	        if ("_gridPreferences" in $$props) $$invalidate(15, _gridPreferences = $$props._gridPreferences);
	        if ("gridContainer" in $$props) $$invalidate(2, gridContainer = $$props.gridContainer);
	        if ("_savePreferencesDebounce" in $$props) $$invalidate(32, _savePreferencesDebounce = $$props._savePreferencesDebounce);
	        if ("_quickFilterSendEventDebounce" in $$props) $$invalidate(33, _quickFilterSendEventDebounce = $$props._quickFilterSendEventDebounce);
	        if ("_identityColumnId" in $$props) $$invalidate(16, _identityColumnId = $$props._identityColumnId);
	        if ("_identityColumn" in $$props) $$invalidate(17, _identityColumn = $$props._identityColumn);
	        if ("_identityPath" in $$props) $$invalidate(18, _identityPath = $$props._identityPath);
	        if ("_autoSizeColumns" in $$props) $$invalidate(19, _autoSizeColumns = $$props._autoSizeColumns);
	        if ("_defaultAutoSizeColumns" in $$props) $$invalidate(34, _defaultAutoSizeColumns = $$props._defaultAutoSizeColumns);
	        if ("theme" in $$props) $$invalidate(20, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(21, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(22, density = $$props.density);
	        if ("_theme" in $$props) $$invalidate(3, _theme = $$props._theme);
	        if ("_shape" in $$props) $$invalidate(4, _shape = $$props._shape);
	        if ("_density" in $$props) $$invalidate(5, _density = $$props._density);
	        if ("_lastTheme" in $$props) $$invalidate(23, _lastTheme = $$props._lastTheme);
	        if ("_lastShape" in $$props) $$invalidate(24, _lastShape = $$props._lastShape);
	        if ("_lastDensity" in $$props) $$invalidate(25, _lastDensity = $$props._lastDensity);
	        if ("_lastSelectedRows" in $$props) $$invalidate(26, _lastSelectedRows = $$props._lastSelectedRows);
	        if ("_gridId" in $$props) $$invalidate(6, _gridId = $$props._gridId);
	        if ("_lastFilter" in $$props) $$invalidate(27, _lastFilter = $$props._lastFilter);
	        if ("_allowFilterBar" in $$props) $$invalidate(7, _allowFilterBar = $$props._allowFilterBar);
	        if ("_translate" in $$props) $$invalidate(28, _translate = $$props._translate);
	        if ("_isInitialLoad" in $$props) $$invalidate(29, _isInitialLoad = $$props._isInitialLoad);
	        if ("_gridLayoutElement" in $$props) $$invalidate(8, _gridLayoutElement = $$props._gridLayoutElement);
	        if ("_defaultFilters" in $$props) $$invalidate(30, _defaultFilters = $$props._defaultFilters);
	        if ("suppressColumnVirtualisation" in $$props) $$invalidate(35, suppressColumnVirtualisation = $$props.suppressColumnVirtualisation);
	        if ("counts" in $$props) $$invalidate(9, counts = $$props.counts);
	        if ("_printos" in $$props) $$invalidate(31, _printos = $$props._printos);
	      };
	      return [filters, _columnDefs, gridContainer, _theme, _shape, _density, _gridId, _allowFilterBar, _gridLayoutElement, counts, handleDeleteFilter, handleFilterChanged, options, agGridOptions, callbacks, _gridPreferences, _identityColumnId, _identityColumn, _identityPath, _autoSizeColumns, theme, shape, density, _lastTheme, _lastShape, _lastDensity, _lastSelectedRows, _lastFilter, _translate, _isInitialLoad, _defaultFilters, _printos, _savePreferencesDebounce, _quickFilterSendEventDebounce, _defaultAutoSizeColumns, suppressColumnVirtualisation, hasValue, filterbar_counts_binding, filterbar_filters_binding, filterbar_columnDefs_binding, filterbar_theme_binding, filterbar_gridId_binding, deleteFilter_handler, filterChanged_handler, div0_binding, div1_binding];
	    }
	    class Grid_1 extends SvelteComponent$1 {
	      constructor(options) {
	        super();
	        if (!document_1.getElementById("svelte-pthl21-style")) add_css();
	        init$1(this, options, instance, create_fragment, safe_not_equal$1, {
	          options: 12,
	          agGridOptions: 13,
	          callbacks: 14,
	          filters: 0,
	          _columnDefs: 1,
	          _gridPreferences: 15,
	          gridContainer: 2,
	          _savePreferencesDebounce: 32,
	          _quickFilterSendEventDebounce: 33,
	          _identityColumnId: 16,
	          _identityColumn: 17,
	          _identityPath: 18,
	          _autoSizeColumns: 19,
	          _defaultAutoSizeColumns: 34,
	          theme: 20,
	          shape: 21,
	          density: 22,
	          _theme: 3,
	          _shape: 4,
	          _density: 5,
	          _lastTheme: 23,
	          _lastShape: 24,
	          _lastDensity: 25,
	          _lastSelectedRows: 26,
	          _gridId: 6,
	          _lastFilter: 27,
	          _allowFilterBar: 7,
	          _translate: 28,
	          _isInitialLoad: 29,
	          _gridLayoutElement: 8,
	          _defaultFilters: 30,
	          suppressColumnVirtualisation: 35,
	          counts: 9,
	          _printos: 31,
	          handleDeleteFilter: 10,
	          handleFilterChanged: 11,
	          hasValue: 36
	        }, [-1, -1, -1, -1]);
	      }
	      get handleDeleteFilter() {
	        return this.$$.ctx[10];
	      }
	      get handleFilterChanged() {
	        return this.$$.ctx[11];
	      }
	      get hasValue() {
	        return hasValue;
	      }
	    }

	    exports.FilterBar = FilterBar;
	    exports.Grid = Grid_1;

	    Object.defineProperty(exports, '__esModule', { value: true });

	})));

	});

	var name = 'prosGrid';
	function prosGrid() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      theme: '@',
	      shape: '@',
	      density: '@',
	      options: '=?',
	      callbacks: '=?',
	      data: '=?',
	      ready: '=?'
	    },
	    link: gridLink,
	    controller: gridController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function gridLink(scope, element, attrs) {
	    scope.vm.grid = new grid.Grid({
	      target: element[0],
	      props: {
	        theme: scope.vm.theme,
	        shape: scope.vm.shape,
	        density: scope.vm.density,
	        options: scope.vm.options,
	        callbacks: scope.vm.callbacks
	      }
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.grid.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.grid.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.grid.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.options', function (options) {
	      scope.vm.grid.$set({
	        options: options
	      });
	    });
	    scope.$watch('vm.callbacks', function (callbacks) {
	      scope.vm.grid.$set({
	        callbacks: callbacks
	      });
	    });
	    scope.vm.grid.$on('ready', function (event) {
	      scope.$parent.$apply(function () {
	        scope.$emit('ready', event);
	        if (scope.vm.ready) {
	          scope.vm.ready();
	        }
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.grid.$destroy();
	    });
	  }

	  /** @ngInject */
	  function gridController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var grid_module = angular.module('printos.grid', []).directive(name, prosGrid).name;

	return grid_module;

})));
